import { a as e, c as t, i as n, l as r, o as i, s as a, t as o } from "./chunk-DWYKcMT_.js";
//#region \0rolldown/runtime.js
var s = Object.create, c = Object.defineProperty, l = Object.getOwnPropertyDescriptor, u = Object.getOwnPropertyNames, d = Object.getPrototypeOf, f = Object.prototype.hasOwnProperty, p = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), m = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = u(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !f.call(e, s) && s !== n && c(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = l(t, s)) || r.enumerable
	});
	return e;
}, h = (e, t, n) => (n = e == null ? {} : s(d(e)), m(t || !e || !e.__esModule ? c(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), g = /* @__PURE__ */ p(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.activity"), p = Symbol.iterator;
	function m(e) {
		return typeof e != "object" || !e ? null : (e = p && e[p] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var h = {
		isMounted: function() {
			return !1;
		},
		enqueueForceUpdate: function() {},
		enqueueReplaceState: function() {},
		enqueueSetState: function() {}
	}, g = Object.assign, _ = {};
	function v(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	v.prototype.isReactComponent = {}, v.prototype.setState = function(e, t) {
		if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
		this.updater.enqueueSetState(this, e, t, "setState");
	}, v.prototype.forceUpdate = function(e) {
		this.updater.enqueueForceUpdate(this, e, "forceUpdate");
	};
	function y() {}
	y.prototype = v.prototype;
	function b(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	var x = b.prototype = new y();
	x.constructor = b, g(x, v.prototype), x.isPureReactComponent = !0;
	var S = Array.isArray;
	function C() {}
	var w = {
		H: null,
		A: null,
		T: null,
		S: null
	}, T = Object.prototype.hasOwnProperty;
	function E(e, n, r) {
		var i = r.ref;
		return {
			$$typeof: t,
			type: e,
			key: n,
			ref: i === void 0 ? null : i,
			props: r
		};
	}
	function D(e, t) {
		return E(e.type, t, e.props);
	}
	function O(e) {
		return typeof e == "object" && !!e && e.$$typeof === t;
	}
	function k(e) {
		var t = {
			"=": "=0",
			":": "=2"
		};
		return "$" + e.replace(/[=:]/g, function(e) {
			return t[e];
		});
	}
	var A = /\/+/g;
	function j(e, t) {
		return typeof e == "object" && e && e.key != null ? k("" + e.key) : t.toString(36);
	}
	function M(e) {
		switch (e.status) {
			case "fulfilled": return e.value;
			case "rejected": throw e.reason;
			default: switch (typeof e.status == "string" ? e.then(C, C) : (e.status = "pending", e.then(function(t) {
				e.status === "pending" && (e.status = "fulfilled", e.value = t);
			}, function(t) {
				e.status === "pending" && (e.status = "rejected", e.reason = t);
			})), e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
			}
		}
		throw e;
	}
	function N(e, r, i, a, o) {
		var s = typeof e;
		(s === "undefined" || s === "boolean") && (e = null);
		var c = !1;
		if (e === null) c = !0;
		else switch (s) {
			case "bigint":
			case "string":
			case "number":
				c = !0;
				break;
			case "object": switch (e.$$typeof) {
				case t:
				case n:
					c = !0;
					break;
				case d: return c = e._init, N(c(e._payload), r, i, a, o);
			}
		}
		if (c) return o = o(e), c = a === "" ? "." + j(e, 0) : a, S(o) ? (i = "", c != null && (i = c.replace(A, "$&/") + "/"), N(o, r, i, "", function(e) {
			return e;
		})) : o != null && (O(o) && (o = D(o, i + (o.key == null || e && e.key === o.key ? "" : ("" + o.key).replace(A, "$&/") + "/") + c)), r.push(o)), 1;
		c = 0;
		var l = a === "" ? "." : a + ":";
		if (S(e)) for (var u = 0; u < e.length; u++) a = e[u], s = l + j(a, u), c += N(a, r, i, s, o);
		else if (u = m(e), typeof u == "function") for (e = u.call(e), u = 0; !(a = e.next()).done;) a = a.value, s = l + j(a, u++), c += N(a, r, i, s, o);
		else if (s === "object") {
			if (typeof e.then == "function") return N(M(e), r, i, a, o);
			throw r = String(e), Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
		}
		return c;
	}
	function P(e, t, n) {
		if (e == null) return e;
		var r = [], i = 0;
		return N(e, r, "", "", function(e) {
			return t.call(n, e, i++);
		}), r;
	}
	function F(e) {
		if (e._status === -1) {
			var t = e._result;
			t = t(), t.then(function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
			}, function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
			}), e._status === -1 && (e._status = 0, e._result = t);
		}
		if (e._status === 1) return e._result.default;
		throw e._result;
	}
	var I = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, R = {
		map: P,
		forEach: function(e, t, n) {
			P(e, function() {
				t.apply(this, arguments);
			}, n);
		},
		count: function(e) {
			var t = 0;
			return P(e, function() {
				t++;
			}), t;
		},
		toArray: function(e) {
			return P(e, function(e) {
				return e;
			}) || [];
		},
		only: function(e) {
			if (!O(e)) throw Error("React.Children.only expected to receive a single React element child.");
			return e;
		}
	};
	e.Activity = f, e.Children = R, e.Component = v, e.Fragment = r, e.Profiler = a, e.PureComponent = b, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = w, e.__COMPILER_RUNTIME = {
		__proto__: null,
		c: function(e) {
			return w.H.useMemoCache(e);
		}
	}, e.cache = function(e) {
		return function() {
			return e.apply(null, arguments);
		};
	}, e.cacheSignal = function() {
		return null;
	}, e.cloneElement = function(e, t, n) {
		if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
		var r = g({}, e.props), i = e.key;
		if (t != null) for (a in t.key !== void 0 && (i = "" + t.key), t) !T.call(t, a) || a === "key" || a === "__self" || a === "__source" || a === "ref" && t.ref === void 0 || (r[a] = t[a]);
		var a = arguments.length - 2;
		if (a === 1) r.children = n;
		else if (1 < a) {
			for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
			r.children = o;
		}
		return E(e.type, i, r);
	}, e.createContext = function(e) {
		return e = {
			$$typeof: s,
			_currentValue: e,
			_currentValue2: e,
			_threadCount: 0,
			Provider: null,
			Consumer: null
		}, e.Provider = e, e.Consumer = {
			$$typeof: o,
			_context: e
		}, e;
	}, e.createElement = function(e, t, n) {
		var r, i = {}, a = null;
		if (t != null) for (r in t.key !== void 0 && (a = "" + t.key), t) T.call(t, r) && r !== "key" && r !== "__self" && r !== "__source" && (i[r] = t[r]);
		var o = arguments.length - 2;
		if (o === 1) i.children = n;
		else if (1 < o) {
			for (var s = Array(o), c = 0; c < o; c++) s[c] = arguments[c + 2];
			i.children = s;
		}
		if (e && e.defaultProps) for (r in o = e.defaultProps, o) i[r] === void 0 && (i[r] = o[r]);
		return E(e, a, i);
	}, e.createRef = function() {
		return { current: null };
	}, e.forwardRef = function(e) {
		return {
			$$typeof: c,
			render: e
		};
	}, e.isValidElement = O, e.lazy = function(e) {
		return {
			$$typeof: d,
			_payload: {
				_status: -1,
				_result: e
			},
			_init: F
		};
	}, e.memo = function(e, t) {
		return {
			$$typeof: u,
			type: e,
			compare: t === void 0 ? null : t
		};
	}, e.startTransition = function(e) {
		var t = w.T, n = {};
		w.T = n;
		try {
			var r = e(), i = w.S;
			i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && r.then(C, I);
		} catch (e) {
			I(e);
		} finally {
			t !== null && n.types !== null && (t.types = n.types), w.T = t;
		}
	}, e.unstable_useCacheRefresh = function() {
		return w.H.useCacheRefresh();
	}, e.use = function(e) {
		return w.H.use(e);
	}, e.useActionState = function(e, t, n) {
		return w.H.useActionState(e, t, n);
	}, e.useCallback = function(e, t) {
		return w.H.useCallback(e, t);
	}, e.useContext = function(e) {
		return w.H.useContext(e);
	}, e.useDebugValue = function() {}, e.useDeferredValue = function(e, t) {
		return w.H.useDeferredValue(e, t);
	}, e.useEffect = function(e, t) {
		return w.H.useEffect(e, t);
	}, e.useEffectEvent = function(e) {
		return w.H.useEffectEvent(e);
	}, e.useId = function() {
		return w.H.useId();
	}, e.useImperativeHandle = function(e, t, n) {
		return w.H.useImperativeHandle(e, t, n);
	}, e.useInsertionEffect = function(e, t) {
		return w.H.useInsertionEffect(e, t);
	}, e.useLayoutEffect = function(e, t) {
		return w.H.useLayoutEffect(e, t);
	}, e.useMemo = function(e, t) {
		return w.H.useMemo(e, t);
	}, e.useOptimistic = function(e, t) {
		return w.H.useOptimistic(e, t);
	}, e.useReducer = function(e, t, n) {
		return w.H.useReducer(e, t, n);
	}, e.useRef = function(e) {
		return w.H.useRef(e);
	}, e.useState = function(e) {
		return w.H.useState(e);
	}, e.useSyncExternalStore = function(e, t, n) {
		return w.H.useSyncExternalStore(e, t, n);
	}, e.useTransition = function() {
		return w.H.useTransition();
	}, e.version = "19.2.6";
})), _ = /* @__PURE__ */ p(((e, t) => {
	t.exports = g();
})), v = /* @__PURE__ */ p(((e) => {
	function t(e, t) {
		var n = e.length;
		e.push(t);
		a: for (; 0 < n;) {
			var r = n - 1 >>> 1, a = e[r];
			if (0 < i(a, t)) e[r] = t, e[n] = a, n = r;
			else break a;
		}
	}
	function n(e) {
		return e.length === 0 ? null : e[0];
	}
	function r(e) {
		if (e.length === 0) return null;
		var t = e[0], n = e.pop();
		if (n !== t) {
			e[0] = n;
			a: for (var r = 0, a = e.length, o = a >>> 1; r < o;) {
				var s = 2 * (r + 1) - 1, c = e[s], l = s + 1, u = e[l];
				if (0 > i(c, n)) l < a && 0 > i(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s);
				else if (l < a && 0 > i(u, n)) e[r] = u, e[l] = n, r = l;
				else break a;
			}
		}
		return t;
	}
	function i(e, t) {
		var n = e.sortIndex - t.sortIndex;
		return n === 0 ? e.id - t.id : n;
	}
	if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
		var a = performance;
		e.unstable_now = function() {
			return a.now();
		};
	} else {
		var o = Date, s = o.now();
		e.unstable_now = function() {
			return o.now() - s;
		};
	}
	var c = [], l = [], u = 1, d = null, f = 3, p = !1, m = !1, h = !1, g = !1, _ = typeof setTimeout == "function" ? setTimeout : null, v = typeof clearTimeout == "function" ? clearTimeout : null, y = typeof setImmediate < "u" ? setImmediate : null;
	function b(e) {
		for (var i = n(l); i !== null;) {
			if (i.callback === null) r(l);
			else if (i.startTime <= e) r(l), i.sortIndex = i.expirationTime, t(c, i);
			else break;
			i = n(l);
		}
	}
	function x(e) {
		if (h = !1, b(e), !m) if (n(c) !== null) m = !0, S || (S = !0, O());
		else {
			var t = n(l);
			t !== null && j(x, t.startTime - e);
		}
	}
	var S = !1, C = -1, w = 5, T = -1;
	function E() {
		return g ? !0 : !(e.unstable_now() - T < w);
	}
	function D() {
		if (g = !1, S) {
			var t = e.unstable_now();
			T = t;
			var i = !0;
			try {
				a: {
					m = !1, h && (h = !1, v(C), C = -1), p = !0;
					var a = f;
					try {
						b: {
							for (b(t), d = n(c); d !== null && !(d.expirationTime > t && E());) {
								var o = d.callback;
								if (typeof o == "function") {
									d.callback = null, f = d.priorityLevel;
									var s = o(d.expirationTime <= t);
									if (t = e.unstable_now(), typeof s == "function") {
										d.callback = s, b(t), i = !0;
										break b;
									}
									d === n(c) && r(c), b(t);
								} else r(c);
								d = n(c);
							}
							if (d !== null) i = !0;
							else {
								var u = n(l);
								u !== null && j(x, u.startTime - t), i = !1;
							}
						}
						break a;
					} finally {
						d = null, f = a, p = !1;
					}
					i = void 0;
				}
			} finally {
				i ? O() : S = !1;
			}
		}
	}
	var O;
	if (typeof y == "function") O = function() {
		y(D);
	};
	else if (typeof MessageChannel < "u") {
		var k = new MessageChannel(), A = k.port2;
		k.port1.onmessage = D, O = function() {
			A.postMessage(null);
		};
	} else O = function() {
		_(D, 0);
	};
	function j(t, n) {
		C = _(function() {
			t(e.unstable_now());
		}, n);
	}
	e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(e) {
		e.callback = null;
	}, e.unstable_forceFrameRate = function(e) {
		0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : w = 0 < e ? Math.floor(1e3 / e) : 5;
	}, e.unstable_getCurrentPriorityLevel = function() {
		return f;
	}, e.unstable_next = function(e) {
		switch (f) {
			case 1:
			case 2:
			case 3:
				var t = 3;
				break;
			default: t = f;
		}
		var n = f;
		f = t;
		try {
			return e();
		} finally {
			f = n;
		}
	}, e.unstable_requestPaint = function() {
		g = !0;
	}, e.unstable_runWithPriority = function(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 3:
			case 4:
			case 5: break;
			default: e = 3;
		}
		var n = f;
		f = e;
		try {
			return t();
		} finally {
			f = n;
		}
	}, e.unstable_scheduleCallback = function(r, i, a) {
		var o = e.unstable_now();
		switch (typeof a == "object" && a ? (a = a.delay, a = typeof a == "number" && 0 < a ? o + a : o) : a = o, r) {
			case 1:
				var s = -1;
				break;
			case 2:
				s = 250;
				break;
			case 5:
				s = 1073741823;
				break;
			case 4:
				s = 1e4;
				break;
			default: s = 5e3;
		}
		return s = a + s, r = {
			id: u++,
			callback: i,
			priorityLevel: r,
			startTime: a,
			expirationTime: s,
			sortIndex: -1
		}, a > o ? (r.sortIndex = a, t(l, r), n(c) === null && r === n(l) && (h ? (v(C), C = -1) : h = !0, j(x, a - o))) : (r.sortIndex = s, t(c, r), m || p || (m = !0, S || (S = !0, O()))), r;
	}, e.unstable_shouldYield = E, e.unstable_wrapCallback = function(e) {
		var t = f;
		return function() {
			var n = f;
			f = t;
			try {
				return e.apply(this, arguments);
			} finally {
				f = n;
			}
		};
	};
})), y = /* @__PURE__ */ p(((e, t) => {
	t.exports = v();
})), b = /* @__PURE__ */ p(((e) => {
	var t = _();
	function n(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function r() {}
	var i = {
		d: {
			f: r,
			r: function() {
				throw Error(n(522));
			},
			D: r,
			C: r,
			L: r,
			m: r,
			X: r,
			S: r,
			M: r
		},
		p: 0,
		findDOMNode: null
	}, a = Symbol.for("react.portal");
	function o(e, t, n) {
		var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
		return {
			$$typeof: a,
			key: r == null ? null : "" + r,
			children: e,
			containerInfo: t,
			implementation: n
		};
	}
	var s = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
	function c(e, t) {
		if (e === "font") return "";
		if (typeof t == "string") return t === "use-credentials" ? t : "";
	}
	e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i, e.createPortal = function(e, t) {
		var r = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
		if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error(n(299));
		return o(e, t, null, r);
	}, e.flushSync = function(e) {
		var t = s.T, n = i.p;
		try {
			if (s.T = null, i.p = 2, e) return e();
		} finally {
			s.T = t, i.p = n, i.d.f();
		}
	}, e.preconnect = function(e, t) {
		typeof e == "string" && (t ? (t = t.crossOrigin, t = typeof t == "string" ? t === "use-credentials" ? t : "" : void 0) : t = null, i.d.C(e, t));
	}, e.prefetchDNS = function(e) {
		typeof e == "string" && i.d.D(e);
	}, e.preinit = function(e, t) {
		if (typeof e == "string" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin), a = typeof t.integrity == "string" ? t.integrity : void 0, o = typeof t.fetchPriority == "string" ? t.fetchPriority : void 0;
			n === "style" ? i.d.S(e, typeof t.precedence == "string" ? t.precedence : void 0, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o
			}) : n === "script" && i.d.X(e, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0
			});
		}
	}, e.preinitModule = function(e, t) {
		if (typeof e == "string") if (typeof t == "object" && t) {
			if (t.as == null || t.as === "script") {
				var n = c(t.as, t.crossOrigin);
				i.d.M(e, {
					crossOrigin: n,
					integrity: typeof t.integrity == "string" ? t.integrity : void 0,
					nonce: typeof t.nonce == "string" ? t.nonce : void 0
				});
			}
		} else t ?? i.d.M(e);
	}, e.preload = function(e, t) {
		if (typeof e == "string" && typeof t == "object" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin);
			i.d.L(e, n, {
				crossOrigin: r,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0,
				type: typeof t.type == "string" ? t.type : void 0,
				fetchPriority: typeof t.fetchPriority == "string" ? t.fetchPriority : void 0,
				referrerPolicy: typeof t.referrerPolicy == "string" ? t.referrerPolicy : void 0,
				imageSrcSet: typeof t.imageSrcSet == "string" ? t.imageSrcSet : void 0,
				imageSizes: typeof t.imageSizes == "string" ? t.imageSizes : void 0,
				media: typeof t.media == "string" ? t.media : void 0
			});
		}
	}, e.preloadModule = function(e, t) {
		if (typeof e == "string") if (t) {
			var n = c(t.as, t.crossOrigin);
			i.d.m(e, {
				as: typeof t.as == "string" && t.as !== "script" ? t.as : void 0,
				crossOrigin: n,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0
			});
		} else i.d.m(e);
	}, e.requestFormReset = function(e) {
		i.d.r(e);
	}, e.unstable_batchedUpdates = function(e, t) {
		return e(t);
	}, e.useFormState = function(e, t, n) {
		return s.H.useFormState(e, t, n);
	}, e.useFormStatus = function() {
		return s.H.useHostTransitionStatus();
	}, e.version = "19.2.6";
})), x = /* @__PURE__ */ p(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = b();
})), S = /* @__PURE__ */ p(((e) => {
	var t = y(), n = _(), r = x();
	function i(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function a(e) {
		return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
	}
	function o(e) {
		var t = e, n = e;
		if (e.alternate) for (; t.return;) t = t.return;
		else {
			e = t;
			do
				t = e, t.flags & 4098 && (n = t.return), e = t.return;
			while (e);
		}
		return t.tag === 3 ? n : null;
	}
	function s(e) {
		if (e.tag === 13) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function c(e) {
		if (e.tag === 31) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function l(e) {
		if (o(e) !== e) throw Error(i(188));
	}
	function u(e) {
		var t = e.alternate;
		if (!t) {
			if (t = o(e), t === null) throw Error(i(188));
			return t === e ? e : null;
		}
		for (var n = e, r = t;;) {
			var a = n.return;
			if (a === null) break;
			var s = a.alternate;
			if (s === null) {
				if (r = a.return, r !== null) {
					n = r;
					continue;
				}
				break;
			}
			if (a.child === s.child) {
				for (s = a.child; s;) {
					if (s === n) return l(a), e;
					if (s === r) return l(a), t;
					s = s.sibling;
				}
				throw Error(i(188));
			}
			if (n.return !== r.return) n = a, r = s;
			else {
				for (var c = !1, u = a.child; u;) {
					if (u === n) {
						c = !0, n = a, r = s;
						break;
					}
					if (u === r) {
						c = !0, r = a, n = s;
						break;
					}
					u = u.sibling;
				}
				if (!c) {
					for (u = s.child; u;) {
						if (u === n) {
							c = !0, n = s, r = a;
							break;
						}
						if (u === r) {
							c = !0, r = s, n = a;
							break;
						}
						u = u.sibling;
					}
					if (!c) throw Error(i(189));
				}
			}
			if (n.alternate !== r) throw Error(i(190));
		}
		if (n.tag !== 3) throw Error(i(188));
		return n.stateNode.current === n ? e : t;
	}
	function d(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e;
		for (e = e.child; e !== null;) {
			if (t = d(e), t !== null) return t;
			e = e.sibling;
		}
		return null;
	}
	var f = Object.assign, p = Symbol.for("react.element"), m = Symbol.for("react.transitional.element"), h = Symbol.for("react.portal"), g = Symbol.for("react.fragment"), v = Symbol.for("react.strict_mode"), b = Symbol.for("react.profiler"), S = Symbol.for("react.consumer"), C = Symbol.for("react.context"), w = Symbol.for("react.forward_ref"), T = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), D = Symbol.for("react.memo"), O = Symbol.for("react.lazy"), k = Symbol.for("react.activity"), A = Symbol.for("react.memo_cache_sentinel"), j = Symbol.iterator;
	function M(e) {
		return typeof e != "object" || !e ? null : (e = j && e[j] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var N = Symbol.for("react.client.reference");
	function P(e) {
		if (e == null) return null;
		if (typeof e == "function") return e.$$typeof === N ? null : e.displayName || e.name || null;
		if (typeof e == "string") return e;
		switch (e) {
			case g: return "Fragment";
			case b: return "Profiler";
			case v: return "StrictMode";
			case T: return "Suspense";
			case E: return "SuspenseList";
			case k: return "Activity";
		}
		if (typeof e == "object") switch (e.$$typeof) {
			case h: return "Portal";
			case C: return e.displayName || "Context";
			case S: return (e._context.displayName || "Context") + ".Consumer";
			case w:
				var t = e.render;
				return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
			case D: return t = e.displayName || null, t === null ? P(e.type) || "Memo" : t;
			case O:
				t = e._payload, e = e._init;
				try {
					return P(e(t));
				} catch {}
		}
		return null;
	}
	var F = Array.isArray, I = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, R = r.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ee = {
		pending: !1,
		data: null,
		method: null,
		action: null
	}, te = [], ne = -1;
	function z(e) {
		return { current: e };
	}
	function B(e) {
		0 > ne || (e.current = te[ne], te[ne] = null, ne--);
	}
	function V(e, t) {
		ne++, te[ne] = e.current, e.current = t;
	}
	var re = z(null), ie = z(null), ae = z(null), oe = z(null);
	function se(e, t) {
		switch (V(ae, t), V(ie, e), V(re, null), t.nodeType) {
			case 9:
			case 11:
				e = (e = t.documentElement) && (e = e.namespaceURI) ? Gd(e) : 0;
				break;
			default: if (e = t.tagName, t = t.namespaceURI) t = Gd(t), e = Kd(t, e);
			else switch (e) {
				case "svg":
					e = 1;
					break;
				case "math":
					e = 2;
					break;
				default: e = 0;
			}
		}
		B(re), V(re, e);
	}
	function ce() {
		B(re), B(ie), B(ae);
	}
	function le(e) {
		e.memoizedState !== null && V(oe, e);
		var t = re.current, n = Kd(t, e.type);
		t !== n && (V(ie, e), V(re, n));
	}
	function ue(e) {
		ie.current === e && (B(re), B(ie)), oe.current === e && (B(oe), np._currentValue = ee);
	}
	var de, fe;
	function pe(e) {
		if (de === void 0) try {
			throw Error();
		} catch (e) {
			var t = e.stack.trim().match(/\n( *(at )?)/);
			de = t && t[1] || "", fe = -1 < e.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
		}
		return "\n" + de + e + fe;
	}
	var me = !1;
	function he(e, t) {
		if (!e || me) return "";
		me = !0;
		var n = Error.prepareStackTrace;
		Error.prepareStackTrace = void 0;
		try {
			var r = { DetermineComponentFrameRoot: function() {
				try {
					if (t) {
						var n = function() {
							throw Error();
						};
						if (Object.defineProperty(n.prototype, "props", { set: function() {
							throw Error();
						} }), typeof Reflect == "object" && Reflect.construct) {
							try {
								Reflect.construct(n, []);
							} catch (e) {
								var r = e;
							}
							Reflect.construct(e, [], n);
						} else {
							try {
								n.call();
							} catch (e) {
								r = e;
							}
							e.call(n.prototype);
						}
					} else {
						try {
							throw Error();
						} catch (e) {
							r = e;
						}
						(n = e()) && typeof n.catch == "function" && n.catch(function() {});
					}
				} catch (e) {
					if (e && r && typeof e.stack == "string") return [e.stack, r.stack];
				}
				return [null, null];
			} };
			r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
			var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, "name");
			i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
			var a = r.DetermineComponentFrameRoot(), o = a[0], s = a[1];
			if (o && s) {
				var c = o.split("\n"), l = s.split("\n");
				for (i = r = 0; r < c.length && !c[r].includes("DetermineComponentFrameRoot");) r++;
				for (; i < l.length && !l[i].includes("DetermineComponentFrameRoot");) i++;
				if (r === c.length || i === l.length) for (r = c.length - 1, i = l.length - 1; 1 <= r && 0 <= i && c[r] !== l[i];) i--;
				for (; 1 <= r && 0 <= i; r--, i--) if (c[r] !== l[i]) {
					if (r !== 1 || i !== 1) do
						if (r--, i--, 0 > i || c[r] !== l[i]) {
							var u = "\n" + c[r].replace(" at new ", " at ");
							return e.displayName && u.includes("<anonymous>") && (u = u.replace("<anonymous>", e.displayName)), u;
						}
					while (1 <= r && 0 <= i);
					break;
				}
			}
		} finally {
			me = !1, Error.prepareStackTrace = n;
		}
		return (n = e ? e.displayName || e.name : "") ? pe(n) : "";
	}
	function ge(e, t) {
		switch (e.tag) {
			case 26:
			case 27:
			case 5: return pe(e.type);
			case 16: return pe("Lazy");
			case 13: return e.child !== t && t !== null ? pe("Suspense Fallback") : pe("Suspense");
			case 19: return pe("SuspenseList");
			case 0:
			case 15: return he(e.type, !1);
			case 11: return he(e.type.render, !1);
			case 1: return he(e.type, !0);
			case 31: return pe("Activity");
			default: return "";
		}
	}
	function H(e) {
		try {
			var t = "", n = null;
			do
				t += ge(e, n), n = e, e = e.return;
			while (e);
			return t;
		} catch (e) {
			return "\nError generating stack: " + e.message + "\n" + e.stack;
		}
	}
	var _e = Object.prototype.hasOwnProperty, ve = t.unstable_scheduleCallback, ye = t.unstable_cancelCallback, U = t.unstable_shouldYield, be = t.unstable_requestPaint, W = t.unstable_now, xe = t.unstable_getCurrentPriorityLevel, Se = t.unstable_ImmediatePriority, Ce = t.unstable_UserBlockingPriority, we = t.unstable_NormalPriority, Te = t.unstable_LowPriority, Ee = t.unstable_IdlePriority, De = t.log, Oe = t.unstable_setDisableYieldValue, ke = null, Ae = null;
	function je(e) {
		if (typeof De == "function" && Oe(e), Ae && typeof Ae.setStrictMode == "function") try {
			Ae.setStrictMode(ke, e);
		} catch {}
	}
	var Me = Math.clz32 ? Math.clz32 : Fe, Ne = Math.log, Pe = Math.LN2;
	function Fe(e) {
		return e >>>= 0, e === 0 ? 32 : 31 - (Ne(e) / Pe | 0) | 0;
	}
	var Ie = 256, Le = 262144, Re = 4194304;
	function ze(e) {
		var t = e & 42;
		if (t !== 0) return t;
		switch (e & -e) {
			case 1: return 1;
			case 2: return 2;
			case 4: return 4;
			case 8: return 8;
			case 16: return 16;
			case 32: return 32;
			case 64: return 64;
			case 128: return 128;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072: return e & 261888;
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return e & 3932160;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return e & 62914560;
			case 67108864: return 67108864;
			case 134217728: return 134217728;
			case 268435456: return 268435456;
			case 536870912: return 536870912;
			case 1073741824: return 0;
			default: return e;
		}
	}
	function Be(e, t, n) {
		var r = e.pendingLanes;
		if (r === 0) return 0;
		var i = 0, a = e.suspendedLanes, o = e.pingedLanes;
		e = e.warmLanes;
		var s = r & 134217727;
		return s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = ze(n))) : i = ze(o) : i = ze(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = ze(n))) : i = ze(o)) : i = ze(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i;
	}
	function Ve(e, t) {
		return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
	}
	function He(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 4:
			case 8:
			case 64: return t + 250;
			case 16:
			case 32:
			case 128:
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return t + 5e3;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return -1;
			case 67108864:
			case 134217728:
			case 268435456:
			case 536870912:
			case 1073741824: return -1;
			default: return -1;
		}
	}
	function Ue() {
		var e = Re;
		return Re <<= 1, !(Re & 62914560) && (Re = 4194304), e;
	}
	function We(e) {
		for (var t = [], n = 0; 31 > n; n++) t.push(e);
		return t;
	}
	function Ge(e, t) {
		e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
	}
	function Ke(e, t, n, r, i, a) {
		var o = e.pendingLanes;
		e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
		var s = e.entanglements, c = e.expirationTimes, l = e.hiddenUpdates;
		for (n = o & ~n; 0 < n;) {
			var u = 31 - Me(n), d = 1 << u;
			s[u] = 0, c[u] = -1;
			var f = l[u];
			if (f !== null) for (l[u] = null, u = 0; u < f.length; u++) {
				var p = f[u];
				p !== null && (p.lane &= -536870913);
			}
			n &= ~d;
		}
		r !== 0 && qe(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t));
	}
	function qe(e, t, n) {
		e.pendingLanes |= t, e.suspendedLanes &= ~t;
		var r = 31 - Me(t);
		e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930;
	}
	function Je(e, t) {
		var n = e.entangledLanes |= t;
		for (e = e.entanglements; n;) {
			var r = 31 - Me(n), i = 1 << r;
			i & t | e[r] & t && (e[r] |= t), n &= ~i;
		}
	}
	function Ye(e, t) {
		var n = t & -t;
		return n = n & 42 ? 1 : Xe(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0;
	}
	function Xe(e) {
		switch (e) {
			case 2:
				e = 1;
				break;
			case 8:
				e = 4;
				break;
			case 32:
				e = 16;
				break;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152:
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432:
				e = 128;
				break;
			case 268435456:
				e = 134217728;
				break;
			default: e = 0;
		}
		return e;
	}
	function Ze(e) {
		return e &= -e, 2 < e ? 8 < e ? e & 134217727 ? 32 : 268435456 : 8 : 2;
	}
	function Qe() {
		var e = R.p;
		return e === 0 ? (e = window.event, e === void 0 ? 32 : vp(e.type)) : e;
	}
	function $e(e, t) {
		var n = R.p;
		try {
			return R.p = e, t();
		} finally {
			R.p = n;
		}
	}
	var et = Math.random().toString(36).slice(2), tt = "__reactFiber$" + et, nt = "__reactProps$" + et, rt = "__reactContainer$" + et, it = "__reactEvents$" + et, at = "__reactListeners$" + et, ot = "__reactHandles$" + et, G = "__reactResources$" + et, st = "__reactMarker$" + et;
	function ct(e) {
		delete e[tt], delete e[nt], delete e[it], delete e[at], delete e[ot];
	}
	function lt(e) {
		var t = e[tt];
		if (t) return t;
		for (var n = e.parentNode; n;) {
			if (t = n[rt] || n[tt]) {
				if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = hf(e); e !== null;) {
					if (n = e[tt]) return n;
					e = hf(e);
				}
				return t;
			}
			e = n, n = e.parentNode;
		}
		return null;
	}
	function ut(e) {
		if (e = e[tt] || e[rt]) {
			var t = e.tag;
			if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e;
		}
		return null;
	}
	function dt(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
		throw Error(i(33));
	}
	function ft(e) {
		var t = e[G];
		return t ||= e[G] = {
			hoistableStyles: /* @__PURE__ */ new Map(),
			hoistableScripts: /* @__PURE__ */ new Map()
		}, t;
	}
	function pt(e) {
		e[st] = !0;
	}
	var mt = /* @__PURE__ */ new Set(), ht = {};
	function gt(e, t) {
		_t(e, t), _t(e + "Capture", t);
	}
	function _t(e, t) {
		for (ht[e] = t, e = 0; e < t.length; e++) mt.add(t[e]);
	}
	var vt = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), yt = {}, bt = {};
	function xt(e) {
		return _e.call(bt, e) ? !0 : _e.call(yt, e) ? !1 : vt.test(e) ? bt[e] = !0 : (yt[e] = !0, !1);
	}
	function St(e, t, n) {
		if (xt(t)) if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
					e.removeAttribute(t);
					return;
				case "boolean":
					var r = t.toLowerCase().slice(0, 5);
					if (r !== "data-" && r !== "aria-") {
						e.removeAttribute(t);
						return;
					}
			}
			e.setAttribute(t, "" + n);
		}
	}
	function Ct(e, t, n) {
		if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(t);
					return;
			}
			e.setAttribute(t, "" + n);
		}
	}
	function wt(e, t, n, r) {
		if (r === null) e.removeAttribute(n);
		else {
			switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(n);
					return;
			}
			e.setAttributeNS(t, n, "" + r);
		}
	}
	function Tt(e) {
		switch (typeof e) {
			case "bigint":
			case "boolean":
			case "number":
			case "string":
			case "undefined": return e;
			case "object": return e;
			default: return "";
		}
	}
	function Et(e) {
		var t = e.type;
		return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
	}
	function Dt(e, t, n) {
		var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
		if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == "function" && typeof r.set == "function") {
			var i = r.get, a = r.set;
			return Object.defineProperty(e, t, {
				configurable: !0,
				get: function() {
					return i.call(this);
				},
				set: function(e) {
					n = "" + e, a.call(this, e);
				}
			}), Object.defineProperty(e, t, { enumerable: r.enumerable }), {
				getValue: function() {
					return n;
				},
				setValue: function(e) {
					n = "" + e;
				},
				stopTracking: function() {
					e._valueTracker = null, delete e[t];
				}
			};
		}
	}
	function Ot(e) {
		if (!e._valueTracker) {
			var t = Et(e) ? "checked" : "value";
			e._valueTracker = Dt(e, t, "" + e[t]);
		}
	}
	function kt(e) {
		if (!e) return !1;
		var t = e._valueTracker;
		if (!t) return !0;
		var n = t.getValue(), r = "";
		return e && (r = Et(e) ? e.checked ? "true" : "false" : e.value), e = r, e === n ? !1 : (t.setValue(e), !0);
	}
	function At(e) {
		if (e ||= typeof document < "u" ? document : void 0, e === void 0) return null;
		try {
			return e.activeElement || e.body;
		} catch {
			return e.body;
		}
	}
	var jt = /[\n"\\]/g;
	function Mt(e) {
		return e.replace(jt, function(e) {
			return "\\" + e.charCodeAt(0).toString(16) + " ";
		});
	}
	function Nt(e, t, n, r, i, a, o, s) {
		e.name = "", o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" ? e.type = o : e.removeAttribute("type"), t == null ? o !== "submit" && o !== "reset" || e.removeAttribute("value") : o === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + Tt(t)) : e.value !== "" + Tt(t) && (e.value = "" + Tt(t)), t == null ? n == null ? r != null && e.removeAttribute("value") : Ft(e, o, Tt(n)) : Ft(e, o, Tt(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != "function" && typeof i != "symbol"), s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" ? e.name = "" + Tt(s) : e.removeAttribute("name");
	}
	function Pt(e, t, n, r, i, a, o, s) {
		if (a != null && typeof a != "function" && typeof a != "symbol" && typeof a != "boolean" && (e.type = a), t != null || n != null) {
			if (!(a !== "submit" && a !== "reset" || t != null)) {
				Ot(e);
				return;
			}
			n = n == null ? "" : "" + Tt(n), t = t == null ? n : "" + Tt(t), s || t === e.value || (e.value = t), e.defaultValue = t;
		}
		r ??= i, r = typeof r != "function" && typeof r != "symbol" && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" && (e.name = o), Ot(e);
	}
	function Ft(e, t, n) {
		t === "number" && At(e.ownerDocument) === e || e.defaultValue === "" + n || (e.defaultValue = "" + n);
	}
	function It(e, t, n, r) {
		if (e = e.options, t) {
			t = {};
			for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
			for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
		} else {
			for (n = "" + Tt(n), t = null, i = 0; i < e.length; i++) {
				if (e[i].value === n) {
					e[i].selected = !0, r && (e[i].defaultSelected = !0);
					return;
				}
				t !== null || e[i].disabled || (t = e[i]);
			}
			t !== null && (t.selected = !0);
		}
	}
	function Lt(e, t, n) {
		if (t != null && (t = "" + Tt(t), t !== e.value && (e.value = t), n == null)) {
			e.defaultValue !== t && (e.defaultValue = t);
			return;
		}
		e.defaultValue = n == null ? "" : "" + Tt(n);
	}
	function Rt(e, t, n, r) {
		if (t == null) {
			if (r != null) {
				if (n != null) throw Error(i(92));
				if (F(r)) {
					if (1 < r.length) throw Error(i(93));
					r = r[0];
				}
				n = r;
			}
			n ??= "", t = n;
		}
		n = Tt(t), e.defaultValue = n, r = e.textContent, r === n && r !== "" && r !== null && (e.value = r), Ot(e);
	}
	function zt(e, t) {
		if (t) {
			var n = e.firstChild;
			if (n && n === e.lastChild && n.nodeType === 3) {
				n.nodeValue = t;
				return;
			}
		}
		e.textContent = t;
	}
	var Bt = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
	function Vt(e, t, n) {
		var r = t.indexOf("--") === 0;
		n == null || typeof n == "boolean" || n === "" ? r ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, n) : typeof n != "number" || n === 0 || Bt.has(t) ? t === "float" ? e.cssFloat = n : e[t] = ("" + n).trim() : e[t] = n + "px";
	}
	function Ht(e, t, n) {
		if (t != null && typeof t != "object") throw Error(i(62));
		if (e = e.style, n != null) {
			for (var r in n) !n.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf("--") === 0 ? e.setProperty(r, "") : r === "float" ? e.cssFloat = "" : e[r] = "");
			for (var a in t) r = t[a], t.hasOwnProperty(a) && n[a] !== r && Vt(e, a, r);
		} else for (var o in t) t.hasOwnProperty(o) && Vt(e, o, t[o]);
	}
	function Ut(e) {
		if (e.indexOf("-") === -1) return !1;
		switch (e) {
			case "annotation-xml":
			case "color-profile":
			case "font-face":
			case "font-face-src":
			case "font-face-uri":
			case "font-face-format":
			case "font-face-name":
			case "missing-glyph": return !1;
			default: return !0;
		}
	}
	var Wt = new Map([
		["acceptCharset", "accept-charset"],
		["htmlFor", "for"],
		["httpEquiv", "http-equiv"],
		["crossOrigin", "crossorigin"],
		["accentHeight", "accent-height"],
		["alignmentBaseline", "alignment-baseline"],
		["arabicForm", "arabic-form"],
		["baselineShift", "baseline-shift"],
		["capHeight", "cap-height"],
		["clipPath", "clip-path"],
		["clipRule", "clip-rule"],
		["colorInterpolation", "color-interpolation"],
		["colorInterpolationFilters", "color-interpolation-filters"],
		["colorProfile", "color-profile"],
		["colorRendering", "color-rendering"],
		["dominantBaseline", "dominant-baseline"],
		["enableBackground", "enable-background"],
		["fillOpacity", "fill-opacity"],
		["fillRule", "fill-rule"],
		["floodColor", "flood-color"],
		["floodOpacity", "flood-opacity"],
		["fontFamily", "font-family"],
		["fontSize", "font-size"],
		["fontSizeAdjust", "font-size-adjust"],
		["fontStretch", "font-stretch"],
		["fontStyle", "font-style"],
		["fontVariant", "font-variant"],
		["fontWeight", "font-weight"],
		["glyphName", "glyph-name"],
		["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
		["glyphOrientationVertical", "glyph-orientation-vertical"],
		["horizAdvX", "horiz-adv-x"],
		["horizOriginX", "horiz-origin-x"],
		["imageRendering", "image-rendering"],
		["letterSpacing", "letter-spacing"],
		["lightingColor", "lighting-color"],
		["markerEnd", "marker-end"],
		["markerMid", "marker-mid"],
		["markerStart", "marker-start"],
		["overlinePosition", "overline-position"],
		["overlineThickness", "overline-thickness"],
		["paintOrder", "paint-order"],
		["panose-1", "panose-1"],
		["pointerEvents", "pointer-events"],
		["renderingIntent", "rendering-intent"],
		["shapeRendering", "shape-rendering"],
		["stopColor", "stop-color"],
		["stopOpacity", "stop-opacity"],
		["strikethroughPosition", "strikethrough-position"],
		["strikethroughThickness", "strikethrough-thickness"],
		["strokeDasharray", "stroke-dasharray"],
		["strokeDashoffset", "stroke-dashoffset"],
		["strokeLinecap", "stroke-linecap"],
		["strokeLinejoin", "stroke-linejoin"],
		["strokeMiterlimit", "stroke-miterlimit"],
		["strokeOpacity", "stroke-opacity"],
		["strokeWidth", "stroke-width"],
		["textAnchor", "text-anchor"],
		["textDecoration", "text-decoration"],
		["textRendering", "text-rendering"],
		["transformOrigin", "transform-origin"],
		["underlinePosition", "underline-position"],
		["underlineThickness", "underline-thickness"],
		["unicodeBidi", "unicode-bidi"],
		["unicodeRange", "unicode-range"],
		["unitsPerEm", "units-per-em"],
		["vAlphabetic", "v-alphabetic"],
		["vHanging", "v-hanging"],
		["vIdeographic", "v-ideographic"],
		["vMathematical", "v-mathematical"],
		["vectorEffect", "vector-effect"],
		["vertAdvY", "vert-adv-y"],
		["vertOriginX", "vert-origin-x"],
		["vertOriginY", "vert-origin-y"],
		["wordSpacing", "word-spacing"],
		["writingMode", "writing-mode"],
		["xmlnsXlink", "xmlns:xlink"],
		["xHeight", "x-height"]
	]), Gt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
	function Kt(e) {
		return Gt.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
	}
	function qt() {}
	var Jt = null;
	function Yt(e) {
		return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
	}
	var Xt = null, Zt = null;
	function Qt(e) {
		var t = ut(e);
		if (t && (e = t.stateNode)) {
			var n = e[nt] || null;
			a: switch (e = t.stateNode, t.type) {
				case "input":
					if (Nt(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === "radio" && t != null) {
						for (n = e; n.parentNode;) n = n.parentNode;
						for (n = n.querySelectorAll("input[name=\"" + Mt("" + t) + "\"][type=\"radio\"]"), t = 0; t < n.length; t++) {
							var r = n[t];
							if (r !== e && r.form === e.form) {
								var a = r[nt] || null;
								if (!a) throw Error(i(90));
								Nt(r, a.value, a.defaultValue, a.defaultValue, a.checked, a.defaultChecked, a.type, a.name);
							}
						}
						for (t = 0; t < n.length; t++) r = n[t], r.form === e.form && kt(r);
					}
					break a;
				case "textarea":
					Lt(e, n.value, n.defaultValue);
					break a;
				case "select": t = n.value, t != null && It(e, !!n.multiple, t, !1);
			}
		}
	}
	var $t = !1;
	function en(e, t, n) {
		if ($t) return e(t, n);
		$t = !0;
		try {
			return e(t);
		} finally {
			if ($t = !1, (Xt !== null || Zt !== null) && (Su(), Xt && (t = Xt, e = Zt, Zt = Xt = null, Qt(t), e))) for (t = 0; t < e.length; t++) Qt(e[t]);
		}
	}
	function tn(e, t) {
		var n = e.stateNode;
		if (n === null) return null;
		var r = n[nt] || null;
		if (r === null) return null;
		n = r[t];
		a: switch (t) {
			case "onClick":
			case "onClickCapture":
			case "onDoubleClick":
			case "onDoubleClickCapture":
			case "onMouseDown":
			case "onMouseDownCapture":
			case "onMouseMove":
			case "onMouseMoveCapture":
			case "onMouseUp":
			case "onMouseUpCapture":
			case "onMouseEnter":
				(r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
				break a;
			default: e = !1;
		}
		if (e) return null;
		if (n && typeof n != "function") throw Error(i(231, t, typeof n));
		return n;
	}
	var nn = !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0), rn = !1;
	if (nn) try {
		var an = {};
		Object.defineProperty(an, "passive", { get: function() {
			rn = !0;
		} }), window.addEventListener("test", an, an), window.removeEventListener("test", an, an);
	} catch {
		rn = !1;
	}
	var on = null, sn = null, cn = null;
	function ln() {
		if (cn) return cn;
		var e, t = sn, n = t.length, r, i = "value" in on ? on.value : on.textContent, a = i.length;
		for (e = 0; e < n && t[e] === i[e]; e++);
		var o = n - e;
		for (r = 1; r <= o && t[n - r] === i[a - r]; r++);
		return cn = i.slice(e, 1 < r ? 1 - r : void 0);
	}
	function un(e) {
		var t = e.keyCode;
		return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
	}
	function K() {
		return !0;
	}
	function dn() {
		return !1;
	}
	function fn(e) {
		function t(t, n, r, i, a) {
			for (var o in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
			return this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? K : dn, this.isPropagationStopped = dn, this;
		}
		return f(t.prototype, {
			preventDefault: function() {
				this.defaultPrevented = !0;
				var e = this.nativeEvent;
				e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = K);
			},
			stopPropagation: function() {
				var e = this.nativeEvent;
				e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = K);
			},
			persist: function() {},
			isPersistent: K
		}), t;
	}
	var pn = {
		eventPhase: 0,
		bubbles: 0,
		cancelable: 0,
		timeStamp: function(e) {
			return e.timeStamp || Date.now();
		},
		defaultPrevented: 0,
		isTrusted: 0
	}, mn = fn(pn), hn = f({}, pn, {
		view: 0,
		detail: 0
	}), gn = fn(hn), _n, vn, yn, bn = f({}, hn, {
		screenX: 0,
		screenY: 0,
		clientX: 0,
		clientY: 0,
		pageX: 0,
		pageY: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		getModifierState: jn,
		button: 0,
		buttons: 0,
		relatedTarget: function(e) {
			return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
		},
		movementX: function(e) {
			return "movementX" in e ? e.movementX : (e !== yn && (yn && e.type === "mousemove" ? (_n = e.screenX - yn.screenX, vn = e.screenY - yn.screenY) : vn = _n = 0, yn = e), _n);
		},
		movementY: function(e) {
			return "movementY" in e ? e.movementY : vn;
		}
	}), xn = fn(bn), Sn = fn(f({}, bn, { dataTransfer: 0 })), Cn = fn(f({}, hn, { relatedTarget: 0 })), wn = fn(f({}, pn, {
		animationName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), Tn = fn(f({}, pn, { clipboardData: function(e) {
		return "clipboardData" in e ? e.clipboardData : window.clipboardData;
	} })), En = fn(f({}, pn, { data: 0 })), Dn = {
		Esc: "Escape",
		Spacebar: " ",
		Left: "ArrowLeft",
		Up: "ArrowUp",
		Right: "ArrowRight",
		Down: "ArrowDown",
		Del: "Delete",
		Win: "OS",
		Menu: "ContextMenu",
		Apps: "ContextMenu",
		Scroll: "ScrollLock",
		MozPrintableKey: "Unidentified"
	}, On = {
		8: "Backspace",
		9: "Tab",
		12: "Clear",
		13: "Enter",
		16: "Shift",
		17: "Control",
		18: "Alt",
		19: "Pause",
		20: "CapsLock",
		27: "Escape",
		32: " ",
		33: "PageUp",
		34: "PageDown",
		35: "End",
		36: "Home",
		37: "ArrowLeft",
		38: "ArrowUp",
		39: "ArrowRight",
		40: "ArrowDown",
		45: "Insert",
		46: "Delete",
		112: "F1",
		113: "F2",
		114: "F3",
		115: "F4",
		116: "F5",
		117: "F6",
		118: "F7",
		119: "F8",
		120: "F9",
		121: "F10",
		122: "F11",
		123: "F12",
		144: "NumLock",
		145: "ScrollLock",
		224: "Meta"
	}, kn = {
		Alt: "altKey",
		Control: "ctrlKey",
		Meta: "metaKey",
		Shift: "shiftKey"
	};
	function An(e) {
		var t = this.nativeEvent;
		return t.getModifierState ? t.getModifierState(e) : (e = kn[e]) ? !!t[e] : !1;
	}
	function jn() {
		return An;
	}
	var Mn = fn(f({}, hn, {
		key: function(e) {
			if (e.key) {
				var t = Dn[e.key] || e.key;
				if (t !== "Unidentified") return t;
			}
			return e.type === "keypress" ? (e = un(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? On[e.keyCode] || "Unidentified" : "";
		},
		code: 0,
		location: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		repeat: 0,
		locale: 0,
		getModifierState: jn,
		charCode: function(e) {
			return e.type === "keypress" ? un(e) : 0;
		},
		keyCode: function(e) {
			return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		},
		which: function(e) {
			return e.type === "keypress" ? un(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		}
	})), Nn = fn(f({}, bn, {
		pointerId: 0,
		width: 0,
		height: 0,
		pressure: 0,
		tangentialPressure: 0,
		tiltX: 0,
		tiltY: 0,
		twist: 0,
		pointerType: 0,
		isPrimary: 0
	})), Pn = fn(f({}, hn, {
		touches: 0,
		targetTouches: 0,
		changedTouches: 0,
		altKey: 0,
		metaKey: 0,
		ctrlKey: 0,
		shiftKey: 0,
		getModifierState: jn
	})), Fn = fn(f({}, pn, {
		propertyName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), In = fn(f({}, bn, {
		deltaX: function(e) {
			return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
		},
		deltaY: function(e) {
			return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
		},
		deltaZ: 0,
		deltaMode: 0
	})), Ln = fn(f({}, pn, {
		newState: 0,
		oldState: 0
	})), Rn = [
		9,
		13,
		27,
		32
	], zn = nn && "CompositionEvent" in window, Bn = null;
	nn && "documentMode" in document && (Bn = document.documentMode);
	var Vn = nn && "TextEvent" in window && !Bn, Hn = nn && (!zn || Bn && 8 < Bn && 11 >= Bn), Un = " ", Wn = !1;
	function Gn(e, t) {
		switch (e) {
			case "keyup": return Rn.indexOf(t.keyCode) !== -1;
			case "keydown": return t.keyCode !== 229;
			case "keypress":
			case "mousedown":
			case "focusout": return !0;
			default: return !1;
		}
	}
	function Kn(e) {
		return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
	}
	var qn = !1;
	function Jn(e, t) {
		switch (e) {
			case "compositionend": return Kn(t);
			case "keypress": return t.which === 32 ? (Wn = !0, Un) : null;
			case "textInput": return e = t.data, e === Un && Wn ? null : e;
			default: return null;
		}
	}
	function Yn(e, t) {
		if (qn) return e === "compositionend" || !zn && Gn(e, t) ? (e = ln(), cn = sn = on = null, qn = !1, e) : null;
		switch (e) {
			case "paste": return null;
			case "keypress":
				if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
					if (t.char && 1 < t.char.length) return t.char;
					if (t.which) return String.fromCharCode(t.which);
				}
				return null;
			case "compositionend": return Hn && t.locale !== "ko" ? null : t.data;
			default: return null;
		}
	}
	var Xn = {
		color: !0,
		date: !0,
		datetime: !0,
		"datetime-local": !0,
		email: !0,
		month: !0,
		number: !0,
		password: !0,
		range: !0,
		search: !0,
		tel: !0,
		text: !0,
		time: !0,
		url: !0,
		week: !0
	};
	function Zn(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t === "input" ? !!Xn[e.type] : t === "textarea";
	}
	function Qn(e, t, n, r) {
		Xt ? Zt ? Zt.push(r) : Zt = [r] : Xt = r, t = kd(t, "onChange"), 0 < t.length && (n = new mn("onChange", "change", null, n, r), e.push({
			event: n,
			listeners: t
		}));
	}
	var $n = null, er = null;
	function tr(e) {
		xd(e, 0);
	}
	function nr(e) {
		if (kt(dt(e))) return e;
	}
	function rr(e, t) {
		if (e === "change") return t;
	}
	var ir = !1;
	if (nn) {
		var ar;
		if (nn) {
			var or = "oninput" in document;
			if (!or) {
				var sr = document.createElement("div");
				sr.setAttribute("oninput", "return;"), or = typeof sr.oninput == "function";
			}
			ar = or;
		} else ar = !1;
		ir = ar && (!document.documentMode || 9 < document.documentMode);
	}
	function cr() {
		$n && ($n.detachEvent("onpropertychange", lr), er = $n = null);
	}
	function lr(e) {
		if (e.propertyName === "value" && nr(er)) {
			var t = [];
			Qn(t, er, e, Yt(e)), en(tr, t);
		}
	}
	function ur(e, t, n) {
		e === "focusin" ? (cr(), $n = t, er = n, $n.attachEvent("onpropertychange", lr)) : e === "focusout" && cr();
	}
	function dr(e) {
		if (e === "selectionchange" || e === "keyup" || e === "keydown") return nr(er);
	}
	function fr(e, t) {
		if (e === "click") return nr(t);
	}
	function pr(e, t) {
		if (e === "input" || e === "change") return nr(t);
	}
	function mr(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var hr = typeof Object.is == "function" ? Object.is : mr;
	function gr(e, t) {
		if (hr(e, t)) return !0;
		if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
		var n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (r = 0; r < n.length; r++) {
			var i = n[r];
			if (!_e.call(t, i) || !hr(e[i], t[i])) return !1;
		}
		return !0;
	}
	function _r(e) {
		for (; e && e.firstChild;) e = e.firstChild;
		return e;
	}
	function vr(e, t) {
		var n = _r(e);
		e = 0;
		for (var r; n;) {
			if (n.nodeType === 3) {
				if (r = e + n.textContent.length, e <= t && r >= t) return {
					node: n,
					offset: t - e
				};
				e = r;
			}
			a: {
				for (; n;) {
					if (n.nextSibling) {
						n = n.nextSibling;
						break a;
					}
					n = n.parentNode;
				}
				n = void 0;
			}
			n = _r(n);
		}
	}
	function yr(e, t) {
		return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? yr(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
	}
	function br(e) {
		e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
		for (var t = At(e.document); t instanceof e.HTMLIFrameElement;) {
			try {
				var n = typeof t.contentWindow.location.href == "string";
			} catch {
				n = !1;
			}
			if (n) e = t.contentWindow;
			else break;
			t = At(e.document);
		}
		return t;
	}
	function xr(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
	}
	var Sr = nn && "documentMode" in document && 11 >= document.documentMode, Cr = null, wr = null, Tr = null, Er = !1;
	function Dr(e, t, n) {
		var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
		Er || Cr == null || Cr !== At(r) || (r = Cr, "selectionStart" in r && xr(r) ? r = {
			start: r.selectionStart,
			end: r.selectionEnd
		} : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
			anchorNode: r.anchorNode,
			anchorOffset: r.anchorOffset,
			focusNode: r.focusNode,
			focusOffset: r.focusOffset
		}), Tr && gr(Tr, r) || (Tr = r, r = kd(wr, "onSelect"), 0 < r.length && (t = new mn("onSelect", "select", null, t, n), e.push({
			event: t,
			listeners: r
		}), t.target = Cr)));
	}
	function Or(e, t) {
		var n = {};
		return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
	}
	var kr = {
		animationend: Or("Animation", "AnimationEnd"),
		animationiteration: Or("Animation", "AnimationIteration"),
		animationstart: Or("Animation", "AnimationStart"),
		transitionrun: Or("Transition", "TransitionRun"),
		transitionstart: Or("Transition", "TransitionStart"),
		transitioncancel: Or("Transition", "TransitionCancel"),
		transitionend: Or("Transition", "TransitionEnd")
	}, Ar = {}, jr = {};
	nn && (jr = document.createElement("div").style, "AnimationEvent" in window || (delete kr.animationend.animation, delete kr.animationiteration.animation, delete kr.animationstart.animation), "TransitionEvent" in window || delete kr.transitionend.transition);
	function Mr(e) {
		if (Ar[e]) return Ar[e];
		if (!kr[e]) return e;
		var t = kr[e], n;
		for (n in t) if (t.hasOwnProperty(n) && n in jr) return Ar[e] = t[n];
		return e;
	}
	var Nr = Mr("animationend"), Pr = Mr("animationiteration"), Fr = Mr("animationstart"), Ir = Mr("transitionrun"), Lr = Mr("transitionstart"), Rr = Mr("transitioncancel"), zr = Mr("transitionend"), Br = /* @__PURE__ */ new Map(), Vr = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
	Vr.push("scrollEnd");
	function Hr(e, t) {
		Br.set(e, t), gt(t, [e]);
	}
	var Ur = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, Wr = [], Gr = 0, Kr = 0;
	function qr() {
		for (var e = Gr, t = Kr = Gr = 0; t < e;) {
			var n = Wr[t];
			Wr[t++] = null;
			var r = Wr[t];
			Wr[t++] = null;
			var i = Wr[t];
			Wr[t++] = null;
			var a = Wr[t];
			if (Wr[t++] = null, r !== null && i !== null) {
				var o = r.pending;
				o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i;
			}
			a !== 0 && Zr(n, i, a);
		}
	}
	function Jr(e, t, n, r) {
		Wr[Gr++] = e, Wr[Gr++] = t, Wr[Gr++] = n, Wr[Gr++] = r, Kr |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
	}
	function Yr(e, t, n, r) {
		return Jr(e, t, n, r), Qr(e);
	}
	function Xr(e, t) {
		return Jr(e, null, null, t), Qr(e);
	}
	function Zr(e, t, n) {
		e.lanes |= n;
		var r = e.alternate;
		r !== null && (r.lanes |= n);
		for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & 1 || (i = !0)), e = a, a = a.return;
		return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - Me(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null;
	}
	function Qr(e) {
		if (50 < pu) throw pu = 0, mu = null, Error(i(185));
		for (var t = e.return; t !== null;) e = t, t = e.return;
		return e.tag === 3 ? e.stateNode : null;
	}
	var $r = {};
	function ei(e, t, n, r) {
		this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
	}
	function ti(e, t, n, r) {
		return new ei(e, t, n, r);
	}
	function ni(e) {
		return e = e.prototype, !(!e || !e.isReactComponent);
	}
	function ri(e, t) {
		var n = e.alternate;
		return n === null ? (n = ti(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
	}
	function ii(e, t) {
		e.flags &= 65011714;
		var n = e.alternate;
		return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}), e;
	}
	function ai(e, t, n, r, a, o) {
		var s = 0;
		if (r = e, typeof e == "function") ni(e) && (s = 1);
		else if (typeof e == "string") s = qf(e, n, re.current) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
		else a: switch (e) {
			case k: return e = ti(31, n, t, a), e.elementType = k, e.lanes = o, e;
			case g: return oi(n.children, a, o, t);
			case v:
				s = 8, a |= 24;
				break;
			case b: return e = ti(12, n, t, a | 2), e.elementType = b, e.lanes = o, e;
			case T: return e = ti(13, n, t, a), e.elementType = T, e.lanes = o, e;
			case E: return e = ti(19, n, t, a), e.elementType = E, e.lanes = o, e;
			default:
				if (typeof e == "object" && e) switch (e.$$typeof) {
					case C:
						s = 10;
						break a;
					case S:
						s = 9;
						break a;
					case w:
						s = 11;
						break a;
					case D:
						s = 14;
						break a;
					case O:
						s = 16, r = null;
						break a;
				}
				s = 29, n = Error(i(130, e === null ? "null" : typeof e, "")), r = null;
		}
		return t = ti(s, n, t, a), t.elementType = e, t.type = r, t.lanes = o, t;
	}
	function oi(e, t, n, r) {
		return e = ti(7, e, r, t), e.lanes = n, e;
	}
	function si(e, t, n) {
		return e = ti(6, e, null, t), e.lanes = n, e;
	}
	function ci(e) {
		var t = ti(18, null, null, 0);
		return t.stateNode = e, t;
	}
	function li(e, t, n) {
		return t = ti(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
			containerInfo: e.containerInfo,
			pendingChildren: null,
			implementation: e.implementation
		}, t;
	}
	var ui = /* @__PURE__ */ new WeakMap();
	function di(e, t) {
		if (typeof e == "object" && e) {
			var n = ui.get(e);
			return n === void 0 ? (t = {
				value: e,
				source: t,
				stack: H(t)
			}, ui.set(e, t), t) : n;
		}
		return {
			value: e,
			source: t,
			stack: H(t)
		};
	}
	var fi = [], pi = 0, mi = null, hi = 0, gi = [], _i = 0, vi = null, yi = 1, bi = "";
	function xi(e, t) {
		fi[pi++] = hi, fi[pi++] = mi, mi = e, hi = t;
	}
	function Si(e, t, n) {
		gi[_i++] = yi, gi[_i++] = bi, gi[_i++] = vi, vi = e;
		var r = yi;
		e = bi;
		var i = 32 - Me(r) - 1;
		r &= ~(1 << i), n += 1;
		var a = 32 - Me(t) + i;
		if (30 < a) {
			var o = i - i % 5;
			a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, yi = 1 << 32 - Me(t) + i | n << i | r, bi = a + e;
		} else yi = 1 << a | n << i | r, bi = e;
	}
	function Ci(e) {
		e.return !== null && (xi(e, 1), Si(e, 1, 0));
	}
	function wi(e) {
		for (; e === mi;) mi = fi[--pi], fi[pi] = null, hi = fi[--pi], fi[pi] = null;
		for (; e === vi;) vi = gi[--_i], gi[_i] = null, bi = gi[--_i], gi[_i] = null, yi = gi[--_i], gi[_i] = null;
	}
	function Ti(e, t) {
		gi[_i++] = yi, gi[_i++] = bi, gi[_i++] = vi, yi = t.id, bi = t.overflow, vi = e;
	}
	var Ei = null, Di = null, Oi = !1, ki = null, Ai = !1, ji = Error(i(519));
	function Mi(e) {
		throw Ri(di(Error(i(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML", "")), e)), ji;
	}
	function Ni(e) {
		var t = e.stateNode, n = e.type, r = e.memoizedProps;
		switch (t[tt] = e, t[nt] = r, n) {
			case "dialog":
				Sd("cancel", t), Sd("close", t);
				break;
			case "iframe":
			case "object":
			case "embed":
				Sd("load", t);
				break;
			case "video":
			case "audio":
				for (n = 0; n < yd.length; n++) Sd(yd[n], t);
				break;
			case "source":
				Sd("error", t);
				break;
			case "img":
			case "image":
			case "link":
				Sd("error", t), Sd("load", t);
				break;
			case "details":
				Sd("toggle", t);
				break;
			case "input":
				Sd("invalid", t), Pt(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0);
				break;
			case "select":
				Sd("invalid", t);
				break;
			case "textarea": Sd("invalid", t), Rt(t, r.value, r.defaultValue, r.children);
		}
		n = r.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || t.textContent === "" + n || !0 === r.suppressHydrationWarning || Fd(t.textContent, n) ? (r.popover != null && (Sd("beforetoggle", t), Sd("toggle", t)), r.onScroll != null && Sd("scroll", t), r.onScrollEnd != null && Sd("scrollend", t), r.onClick != null && (t.onclick = qt), t = !0) : t = !1, t || Mi(e, !0);
	}
	function Pi(e) {
		for (Ei = e.return; Ei;) switch (Ei.tag) {
			case 5:
			case 31:
			case 13:
				Ai = !1;
				return;
			case 27:
			case 3:
				Ai = !0;
				return;
			default: Ei = Ei.return;
		}
	}
	function Fi(e) {
		if (e !== Ei) return !1;
		if (!Oi) return Pi(e), Oi = !0, !1;
		var t = e.tag, n;
		if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = !(n !== "form" && n !== "button") || qd(e.type, e.memoizedProps)), n = !n), n && Di && Mi(e), Pi(e), t === 13) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			Di = mf(e);
		} else if (t === 31) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			Di = mf(e);
		} else t === 27 ? (t = Di, tf(e.type) ? (e = pf, pf = null, Di = e) : Di = t) : Di = Ei ? ff(e.stateNode.nextSibling) : null;
		return !0;
	}
	function Ii() {
		Di = Ei = null, Oi = !1;
	}
	function Li() {
		var e = ki;
		return e !== null && (eu === null ? eu = e : eu.push.apply(eu, e), ki = null), e;
	}
	function Ri(e) {
		ki === null ? ki = [e] : ki.push(e);
	}
	var zi = z(null), Bi = null, Vi = null;
	function Hi(e, t, n) {
		V(zi, t._currentValue), t._currentValue = n;
	}
	function Ui(e) {
		e._currentValue = zi.current, B(zi);
	}
	function Wi(e, t, n) {
		for (; e !== null;) {
			var r = e.alternate;
			if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
			e = e.return;
		}
	}
	function Gi(e, t, n, r) {
		var a = e.child;
		for (a !== null && (a.return = e); a !== null;) {
			var o = a.dependencies;
			if (o !== null) {
				var s = a.child;
				o = o.firstContext;
				a: for (; o !== null;) {
					var c = o;
					o = a;
					for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
						o.lanes |= n, c = o.alternate, c !== null && (c.lanes |= n), Wi(o.return, n, e), r || (s = null);
						break a;
					}
					o = c.next;
				}
			} else if (a.tag === 18) {
				if (s = a.return, s === null) throw Error(i(341));
				s.lanes |= n, o = s.alternate, o !== null && (o.lanes |= n), Wi(s, n, e), s = null;
			} else s = a.child;
			if (s !== null) s.return = a;
			else for (s = a; s !== null;) {
				if (s === e) {
					s = null;
					break;
				}
				if (a = s.sibling, a !== null) {
					a.return = s.return, s = a;
					break;
				}
				s = s.return;
			}
			a = s;
		}
	}
	function Ki(e, t, n, r) {
		e = null;
		for (var a = t, o = !1; a !== null;) {
			if (!o) {
				if (a.flags & 524288) o = !0;
				else if (a.flags & 262144) break;
			}
			if (a.tag === 10) {
				var s = a.alternate;
				if (s === null) throw Error(i(387));
				if (s = s.memoizedProps, s !== null) {
					var c = a.type;
					hr(a.pendingProps.value, s.value) || (e === null ? e = [c] : e.push(c));
				}
			} else if (a === oe.current) {
				if (s = a.alternate, s === null) throw Error(i(387));
				s.memoizedState.memoizedState !== a.memoizedState.memoizedState && (e === null ? e = [np] : e.push(np));
			}
			a = a.return;
		}
		e !== null && Gi(t, e, n, r), t.flags |= 262144;
	}
	function qi(e) {
		for (e = e.firstContext; e !== null;) {
			if (!hr(e.context._currentValue, e.memoizedValue)) return !0;
			e = e.next;
		}
		return !1;
	}
	function Ji(e) {
		Bi = e, Vi = null, e = e.dependencies, e !== null && (e.firstContext = null);
	}
	function Yi(e) {
		return Zi(Bi, e);
	}
	function Xi(e, t) {
		return Bi === null && Ji(e), Zi(e, t);
	}
	function Zi(e, t) {
		var n = t._currentValue;
		if (t = {
			context: t,
			memoizedValue: n,
			next: null
		}, Vi === null) {
			if (e === null) throw Error(i(308));
			Vi = t, e.dependencies = {
				lanes: 0,
				firstContext: t
			}, e.flags |= 524288;
		} else Vi = Vi.next = t;
		return n;
	}
	var Qi = typeof AbortController < "u" ? AbortController : function() {
		var e = [], t = this.signal = {
			aborted: !1,
			addEventListener: function(t, n) {
				e.push(n);
			}
		};
		this.abort = function() {
			t.aborted = !0, e.forEach(function(e) {
				return e();
			});
		};
	}, $i = t.unstable_scheduleCallback, ea = t.unstable_NormalPriority, ta = {
		$$typeof: C,
		Consumer: null,
		Provider: null,
		_currentValue: null,
		_currentValue2: null,
		_threadCount: 0
	};
	function na() {
		return {
			controller: new Qi(),
			data: /* @__PURE__ */ new Map(),
			refCount: 0
		};
	}
	function ra(e) {
		e.refCount--, e.refCount === 0 && $i(ea, function() {
			e.controller.abort();
		});
	}
	var ia = null, aa = 0, oa = 0, sa = null;
	function ca(e, t) {
		if (ia === null) {
			var n = ia = [];
			aa = 0, oa = pd(), sa = {
				status: "pending",
				value: void 0,
				then: function(e) {
					n.push(e);
				}
			};
		}
		return aa++, t.then(la, la), t;
	}
	function la() {
		if (--aa === 0 && ia !== null) {
			sa !== null && (sa.status = "fulfilled");
			var e = ia;
			ia = null, oa = 0, sa = null;
			for (var t = 0; t < e.length; t++) (0, e[t])();
		}
	}
	function ua(e, t) {
		var n = [], r = {
			status: "pending",
			value: null,
			reason: null,
			then: function(e) {
				n.push(e);
			}
		};
		return e.then(function() {
			r.status = "fulfilled", r.value = t;
			for (var e = 0; e < n.length; e++) (0, n[e])(t);
		}, function(e) {
			for (r.status = "rejected", r.reason = e, e = 0; e < n.length; e++) (0, n[e])(void 0);
		}), r;
	}
	var da = I.S;
	I.S = function(e, t) {
		ru = W(), typeof t == "object" && t && typeof t.then == "function" && ca(e, t), da !== null && da(e, t);
	};
	var fa = z(null);
	function pa() {
		var e = fa.current;
		return e === null ? zl.pooledCache : e;
	}
	function ma(e, t) {
		t === null ? V(fa, fa.current) : V(fa, t.pool);
	}
	function ha() {
		var e = pa();
		return e === null ? null : {
			parent: ta._currentValue,
			pool: e
		};
	}
	var ga = Error(i(460)), _a = Error(i(474)), va = Error(i(542)), ya = { then: function() {} };
	function ba(e) {
		return e = e.status, e === "fulfilled" || e === "rejected";
	}
	function xa(e, t, n) {
		switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(qt, qt), t = n), t.status) {
			case "fulfilled": return t.value;
			case "rejected": throw e = t.reason, Ta(e), e;
			default:
				if (typeof t.status == "string") t.then(qt, qt);
				else {
					if (e = zl, e !== null && 100 < e.shellSuspendCounter) throw Error(i(482));
					e = t, e.status = "pending", e.then(function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "fulfilled", n.value = e;
						}
					}, function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "rejected", n.reason = e;
						}
					});
				}
				switch (t.status) {
					case "fulfilled": return t.value;
					case "rejected": throw e = t.reason, Ta(e), e;
				}
				throw Ca = t, ga;
		}
	}
	function Sa(e) {
		try {
			var t = e._init;
			return t(e._payload);
		} catch (e) {
			throw typeof e == "object" && e && typeof e.then == "function" ? (Ca = e, ga) : e;
		}
	}
	var Ca = null;
	function wa() {
		if (Ca === null) throw Error(i(459));
		var e = Ca;
		return Ca = null, e;
	}
	function Ta(e) {
		if (e === ga || e === va) throw Error(i(483));
	}
	var Ea = null, Da = 0;
	function Oa(e) {
		var t = Da;
		return Da += 1, Ea === null && (Ea = []), xa(Ea, e, t);
	}
	function ka(e, t) {
		t = t.props.ref, e.ref = t === void 0 ? null : t;
	}
	function Aa(e, t) {
		throw t.$$typeof === p ? Error(i(525)) : (e = Object.prototype.toString.call(t), Error(i(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e)));
	}
	function ja(e) {
		function t(t, n) {
			if (e) {
				var r = t.deletions;
				r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
			}
		}
		function n(n, r) {
			if (!e) return null;
			for (; r !== null;) t(n, r), r = r.sibling;
			return null;
		}
		function r(e) {
			for (var t = /* @__PURE__ */ new Map(); e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
			return t;
		}
		function a(e, t) {
			return e = ri(e, t), e.index = 0, e.sibling = null, e;
		}
		function o(t, n, r) {
			return t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 67108866, n) : (r = r.index, r < n ? (t.flags |= 67108866, n) : r)) : (t.flags |= 1048576, n);
		}
		function s(t) {
			return e && t.alternate === null && (t.flags |= 67108866), t;
		}
		function c(e, t, n, r) {
			return t === null || t.tag !== 6 ? (t = si(n, e.mode, r), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function l(e, t, n, r) {
			var i = n.type;
			return i === g ? d(e, t, n.props.children, r, n.key) : t !== null && (t.elementType === i || typeof i == "object" && i && i.$$typeof === O && Sa(i) === t.type) ? (t = a(t, n.props), ka(t, n), t.return = e, t) : (t = ai(n.type, n.key, n.props, null, e.mode, r), ka(t, n), t.return = e, t);
		}
		function u(e, t, n, r) {
			return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = li(n, e.mode, r), t.return = e, t) : (t = a(t, n.children || []), t.return = e, t);
		}
		function d(e, t, n, r, i) {
			return t === null || t.tag !== 7 ? (t = oi(n, e.mode, r, i), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function f(e, t, n) {
			if (typeof t == "string" && t !== "" || typeof t == "number" || typeof t == "bigint") return t = si("" + t, e.mode, n), t.return = e, t;
			if (typeof t == "object" && t) {
				switch (t.$$typeof) {
					case m: return n = ai(t.type, t.key, t.props, null, e.mode, n), ka(n, t), n.return = e, n;
					case h: return t = li(t, e.mode, n), t.return = e, t;
					case O: return t = Sa(t), f(e, t, n);
				}
				if (F(t) || M(t)) return t = oi(t, e.mode, n, null), t.return = e, t;
				if (typeof t.then == "function") return f(e, Oa(t), n);
				if (t.$$typeof === C) return f(e, Xi(e, t), n);
				Aa(e, t);
			}
			return null;
		}
		function p(e, t, n, r) {
			var i = t === null ? null : t.key;
			if (typeof n == "string" && n !== "" || typeof n == "number" || typeof n == "bigint") return i === null ? c(e, t, "" + n, r) : null;
			if (typeof n == "object" && n) {
				switch (n.$$typeof) {
					case m: return n.key === i ? l(e, t, n, r) : null;
					case h: return n.key === i ? u(e, t, n, r) : null;
					case O: return n = Sa(n), p(e, t, n, r);
				}
				if (F(n) || M(n)) return i === null ? d(e, t, n, r, null) : null;
				if (typeof n.then == "function") return p(e, t, Oa(n), r);
				if (n.$$typeof === C) return p(e, t, Xi(e, n), r);
				Aa(e, n);
			}
			return null;
		}
		function _(e, t, n, r, i) {
			if (typeof r == "string" && r !== "" || typeof r == "number" || typeof r == "bigint") return e = e.get(n) || null, c(t, e, "" + r, i);
			if (typeof r == "object" && r) {
				switch (r.$$typeof) {
					case m: return e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i);
					case h: return e = e.get(r.key === null ? n : r.key) || null, u(t, e, r, i);
					case O: return r = Sa(r), _(e, t, n, r, i);
				}
				if (F(r) || M(r)) return e = e.get(n) || null, d(t, e, r, i, null);
				if (typeof r.then == "function") return _(e, t, n, Oa(r), i);
				if (r.$$typeof === C) return _(e, t, n, Xi(t, r), i);
				Aa(t, r);
			}
			return null;
		}
		function v(i, a, s, c) {
			for (var l = null, u = null, d = a, m = a = 0, h = null; d !== null && m < s.length; m++) {
				d.index > m ? (h = d, d = null) : h = d.sibling;
				var g = p(i, d, s[m], c);
				if (g === null) {
					d === null && (d = h);
					break;
				}
				e && d && g.alternate === null && t(i, d), a = o(g, a, m), u === null ? l = g : u.sibling = g, u = g, d = h;
			}
			if (m === s.length) return n(i, d), Oi && xi(i, m), l;
			if (d === null) {
				for (; m < s.length; m++) d = f(i, s[m], c), d !== null && (a = o(d, a, m), u === null ? l = d : u.sibling = d, u = d);
				return Oi && xi(i, m), l;
			}
			for (d = r(d); m < s.length; m++) h = _(d, i, m, s[m], c), h !== null && (e && h.alternate !== null && d.delete(h.key === null ? m : h.key), a = o(h, a, m), u === null ? l = h : u.sibling = h, u = h);
			return e && d.forEach(function(e) {
				return t(i, e);
			}), Oi && xi(i, m), l;
		}
		function y(a, s, c, l) {
			if (c == null) throw Error(i(151));
			for (var u = null, d = null, m = s, h = s = 0, g = null, v = c.next(); m !== null && !v.done; h++, v = c.next()) {
				m.index > h ? (g = m, m = null) : g = m.sibling;
				var y = p(a, m, v.value, l);
				if (y === null) {
					m === null && (m = g);
					break;
				}
				e && m && y.alternate === null && t(a, m), s = o(y, s, h), d === null ? u = y : d.sibling = y, d = y, m = g;
			}
			if (v.done) return n(a, m), Oi && xi(a, h), u;
			if (m === null) {
				for (; !v.done; h++, v = c.next()) v = f(a, v.value, l), v !== null && (s = o(v, s, h), d === null ? u = v : d.sibling = v, d = v);
				return Oi && xi(a, h), u;
			}
			for (m = r(m); !v.done; h++, v = c.next()) v = _(m, a, h, v.value, l), v !== null && (e && v.alternate !== null && m.delete(v.key === null ? h : v.key), s = o(v, s, h), d === null ? u = v : d.sibling = v, d = v);
			return e && m.forEach(function(e) {
				return t(a, e);
			}), Oi && xi(a, h), u;
		}
		function b(e, r, o, c) {
			if (typeof o == "object" && o && o.type === g && o.key === null && (o = o.props.children), typeof o == "object" && o) {
				switch (o.$$typeof) {
					case m:
						a: {
							for (var l = o.key; r !== null;) {
								if (r.key === l) {
									if (l = o.type, l === g) {
										if (r.tag === 7) {
											n(e, r.sibling), c = a(r, o.props.children), c.return = e, e = c;
											break a;
										}
									} else if (r.elementType === l || typeof l == "object" && l && l.$$typeof === O && Sa(l) === r.type) {
										n(e, r.sibling), c = a(r, o.props), ka(c, o), c.return = e, e = c;
										break a;
									}
									n(e, r);
									break;
								} else t(e, r);
								r = r.sibling;
							}
							o.type === g ? (c = oi(o.props.children, e.mode, c, o.key), c.return = e, e = c) : (c = ai(o.type, o.key, o.props, null, e.mode, c), ka(c, o), c.return = e, e = c);
						}
						return s(e);
					case h:
						a: {
							for (l = o.key; r !== null;) {
								if (r.key === l) if (r.tag === 4 && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
									n(e, r.sibling), c = a(r, o.children || []), c.return = e, e = c;
									break a;
								} else {
									n(e, r);
									break;
								}
								else t(e, r);
								r = r.sibling;
							}
							c = li(o, e.mode, c), c.return = e, e = c;
						}
						return s(e);
					case O: return o = Sa(o), b(e, r, o, c);
				}
				if (F(o)) return v(e, r, o, c);
				if (M(o)) {
					if (l = M(o), typeof l != "function") throw Error(i(150));
					return o = l.call(o), y(e, r, o, c);
				}
				if (typeof o.then == "function") return b(e, r, Oa(o), c);
				if (o.$$typeof === C) return b(e, r, Xi(e, o), c);
				Aa(e, o);
			}
			return typeof o == "string" && o !== "" || typeof o == "number" || typeof o == "bigint" ? (o = "" + o, r !== null && r.tag === 6 ? (n(e, r.sibling), c = a(r, o), c.return = e, e = c) : (n(e, r), c = si(o, e.mode, c), c.return = e, e = c), s(e)) : n(e, r);
		}
		return function(e, t, n, r) {
			try {
				Da = 0;
				var i = b(e, t, n, r);
				return Ea = null, i;
			} catch (t) {
				if (t === ga || t === va) throw t;
				var a = ti(29, t, null, e.mode);
				return a.lanes = r, a.return = e, a;
			}
		};
	}
	var Ma = ja(!0), Na = ja(!1), Pa = !1;
	function Fa(e) {
		e.updateQueue = {
			baseState: e.memoizedState,
			firstBaseUpdate: null,
			lastBaseUpdate: null,
			shared: {
				pending: null,
				lanes: 0,
				hiddenCallbacks: null
			},
			callbacks: null
		};
	}
	function Ia(e, t) {
		e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
			baseState: e.baseState,
			firstBaseUpdate: e.firstBaseUpdate,
			lastBaseUpdate: e.lastBaseUpdate,
			shared: e.shared,
			callbacks: null
		});
	}
	function La(e) {
		return {
			lane: e,
			tag: 0,
			payload: null,
			callback: null,
			next: null
		};
	}
	function Ra(e, t, n) {
		var r = e.updateQueue;
		if (r === null) return null;
		if (r = r.shared, Rl & 2) {
			var i = r.pending;
			return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = Qr(e), Zr(e, null, n), t;
		}
		return Jr(e, r, t, n), Qr(e);
	}
	function za(e, t, n) {
		if (t = t.updateQueue, t !== null && (t = t.shared, n & 4194048)) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, Je(e, n);
		}
	}
	function Ba(e, t) {
		var n = e.updateQueue, r = e.alternate;
		if (r !== null && (r = r.updateQueue, n === r)) {
			var i = null, a = null;
			if (n = n.firstBaseUpdate, n !== null) {
				do {
					var o = {
						lane: n.lane,
						tag: n.tag,
						payload: n.payload,
						callback: null,
						next: null
					};
					a === null ? i = a = o : a = a.next = o, n = n.next;
				} while (n !== null);
				a === null ? i = a = t : a = a.next = t;
			} else i = a = t;
			n = {
				baseState: r.baseState,
				firstBaseUpdate: i,
				lastBaseUpdate: a,
				shared: r.shared,
				callbacks: r.callbacks
			}, e.updateQueue = n;
			return;
		}
		e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
	}
	var Va = !1;
	function Ha() {
		if (Va) {
			var e = sa;
			if (e !== null) throw e;
		}
	}
	function Ua(e, t, n, r) {
		Va = !1;
		var i = e.updateQueue;
		Pa = !1;
		var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
		if (s !== null) {
			i.shared.pending = null;
			var c = s, l = c.next;
			c.next = null, o === null ? a = l : o.next = l, o = c;
			var u = e.alternate;
			u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c));
		}
		if (a !== null) {
			var d = i.baseState;
			o = 0, u = l = c = null, s = a;
			do {
				var p = s.lane & -536870913, m = p !== s.lane;
				if (m ? (Vl & p) === p : (r & p) === p) {
					p !== 0 && p === oa && (Va = !0), u !== null && (u = u.next = {
						lane: 0,
						tag: s.tag,
						payload: s.payload,
						callback: null,
						next: null
					});
					a: {
						var h = e, g = s;
						p = t;
						var _ = n;
						switch (g.tag) {
							case 1:
								if (h = g.payload, typeof h == "function") {
									d = h.call(_, d, p);
									break a;
								}
								d = h;
								break a;
							case 3: h.flags = h.flags & -65537 | 128;
							case 0:
								if (h = g.payload, p = typeof h == "function" ? h.call(_, d, p) : h, p == null) break a;
								d = f({}, d, p);
								break a;
							case 2: Pa = !0;
						}
					}
					p = s.callback, p !== null && (e.flags |= 64, m && (e.flags |= 8192), m = i.callbacks, m === null ? i.callbacks = [p] : m.push(p));
				} else m = {
					lane: p,
					tag: s.tag,
					payload: s.payload,
					callback: s.callback,
					next: null
				}, u === null ? (l = u = m, c = d) : u = u.next = m, o |= p;
				if (s = s.next, s === null) {
					if (s = i.shared.pending, s === null) break;
					m = s, s = m.next, m.next = null, i.lastBaseUpdate = m, i.shared.pending = null;
				}
			} while (1);
			u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), Yl |= o, e.lanes = o, e.memoizedState = d;
		}
	}
	function Wa(e, t) {
		if (typeof e != "function") throw Error(i(191, e));
		e.call(t);
	}
	function Ga(e, t) {
		var n = e.callbacks;
		if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) Wa(n[e], t);
	}
	var Ka = z(null), qa = z(0);
	function Ja(e, t) {
		e = ql, V(qa, e), V(Ka, t), ql = e | t.baseLanes;
	}
	function Ya() {
		V(qa, ql), V(Ka, Ka.current);
	}
	function Xa() {
		ql = qa.current, B(Ka), B(qa);
	}
	var Za = z(null), Qa = null;
	function $a(e) {
		var t = e.alternate;
		V(io, io.current & 1), V(Za, e), Qa === null && (t === null || Ka.current !== null || t.memoizedState !== null) && (Qa = e);
	}
	function eo(e) {
		V(io, io.current), V(Za, e), Qa === null && (Qa = e);
	}
	function to(e) {
		e.tag === 22 ? (V(io, io.current), V(Za, e), Qa === null && (Qa = e)) : no(e);
	}
	function no() {
		V(io, io.current), V(Za, Za.current);
	}
	function ro(e) {
		B(Za), Qa === e && (Qa = null), B(io);
	}
	var io = z(0);
	function ao(e) {
		for (var t = e; t !== null;) {
			if (t.tag === 13) {
				var n = t.memoizedState;
				if (n !== null && (n = n.dehydrated, n === null || lf(n) || uf(n))) return t;
			} else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
				if (t.flags & 128) return t;
			} else if (t.child !== null) {
				t.child.return = t, t = t.child;
				continue;
			}
			if (t === e) break;
			for (; t.sibling === null;) {
				if (t.return === null || t.return === e) return null;
				t = t.return;
			}
			t.sibling.return = t.return, t = t.sibling;
		}
		return null;
	}
	var oo = 0, so = null, co = null, lo = null, uo = !1, fo = !1, po = !1, mo = 0, ho = 0, go = null, _o = 0;
	function vo() {
		throw Error(i(321));
	}
	function yo(e, t) {
		if (t === null) return !1;
		for (var n = 0; n < t.length && n < e.length; n++) if (!hr(e[n], t[n])) return !1;
		return !0;
	}
	function bo(e, t, n, r, i, a) {
		return oo = a, so = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, I.H = e === null || e.memoizedState === null ? Ls : Rs, po = !1, a = n(r, i), po = !1, fo && (a = So(t, n, r, i)), xo(e), a;
	}
	function xo(e) {
		I.H = Is;
		var t = co !== null && co.next !== null;
		if (oo = 0, lo = co = so = null, uo = !1, ho = 0, go = null, t) throw Error(i(300));
		e === null || tc || (e = e.dependencies, e !== null && qi(e) && (tc = !0));
	}
	function So(e, t, n, r) {
		so = e;
		var a = 0;
		do {
			if (fo && (go = null), ho = 0, fo = !1, 25 <= a) throw Error(i(301));
			if (a += 1, lo = co = null, e.updateQueue != null) {
				var o = e.updateQueue;
				o.lastEffect = null, o.events = null, o.stores = null, o.memoCache != null && (o.memoCache.index = 0);
			}
			I.H = zs, o = t(n, r);
		} while (fo);
		return o;
	}
	function Co() {
		var e = I.H, t = e.useState()[0];
		return t = typeof t.then == "function" ? Ao(t) : t, e = e.useState()[0], (co === null ? null : co.memoizedState) !== e && (so.flags |= 1024), t;
	}
	function wo() {
		var e = mo !== 0;
		return mo = 0, e;
	}
	function To(e, t, n) {
		t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
	}
	function Eo(e) {
		if (uo) {
			for (e = e.memoizedState; e !== null;) {
				var t = e.queue;
				t !== null && (t.pending = null), e = e.next;
			}
			uo = !1;
		}
		oo = 0, lo = co = so = null, fo = !1, ho = mo = 0, go = null;
	}
	function Do() {
		var e = {
			memoizedState: null,
			baseState: null,
			baseQueue: null,
			queue: null,
			next: null
		};
		return lo === null ? so.memoizedState = lo = e : lo = lo.next = e, lo;
	}
	function Oo() {
		if (co === null) {
			var e = so.alternate;
			e = e === null ? null : e.memoizedState;
		} else e = co.next;
		var t = lo === null ? so.memoizedState : lo.next;
		if (t !== null) lo = t, co = e;
		else {
			if (e === null) throw so.alternate === null ? Error(i(467)) : Error(i(310));
			co = e, e = {
				memoizedState: co.memoizedState,
				baseState: co.baseState,
				baseQueue: co.baseQueue,
				queue: co.queue,
				next: null
			}, lo === null ? so.memoizedState = lo = e : lo = lo.next = e;
		}
		return lo;
	}
	function ko() {
		return {
			lastEffect: null,
			events: null,
			stores: null,
			memoCache: null
		};
	}
	function Ao(e) {
		var t = ho;
		return ho += 1, go === null && (go = []), e = xa(go, e, t), t = so, (lo === null ? t.memoizedState : lo.next) === null && (t = t.alternate, I.H = t === null || t.memoizedState === null ? Ls : Rs), e;
	}
	function jo(e) {
		if (typeof e == "object" && e) {
			if (typeof e.then == "function") return Ao(e);
			if (e.$$typeof === C) return Yi(e);
		}
		throw Error(i(438, String(e)));
	}
	function Mo(e) {
		var t = null, n = so.updateQueue;
		if (n !== null && (t = n.memoCache), t == null) {
			var r = so.alternate;
			r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
				data: r.data.map(function(e) {
					return e.slice();
				}),
				index: 0
			})));
		}
		if (t ??= {
			data: [],
			index: 0
		}, n === null && (n = ko(), so.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = A;
		return t.index++, n;
	}
	function No(e, t) {
		return typeof t == "function" ? t(e) : t;
	}
	function Po(e) {
		return Fo(Oo(), co, e);
	}
	function Fo(e, t, n) {
		var r = e.queue;
		if (r === null) throw Error(i(311));
		r.lastRenderedReducer = n;
		var a = e.baseQueue, o = r.pending;
		if (o !== null) {
			if (a !== null) {
				var s = a.next;
				a.next = o.next, o.next = s;
			}
			t.baseQueue = a = o, r.pending = null;
		}
		if (o = e.baseState, a === null) e.memoizedState = o;
		else {
			t = a.next;
			var c = s = null, l = null, u = t, d = !1;
			do {
				var f = u.lane & -536870913;
				if (f === u.lane ? (oo & f) === f : (Vl & f) === f) {
					var p = u.revertLane;
					if (p === 0) l !== null && (l = l.next = {
						lane: 0,
						revertLane: 0,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}), f === oa && (d = !0);
					else if ((oo & p) === p) {
						u = u.next, p === oa && (d = !0);
						continue;
					} else f = {
						lane: 0,
						revertLane: u.revertLane,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}, l === null ? (c = l = f, s = o) : l = l.next = f, so.lanes |= p, Yl |= p;
					f = u.action, po && n(o, f), o = u.hasEagerState ? u.eagerState : n(o, f);
				} else p = {
					lane: f,
					revertLane: u.revertLane,
					gesture: u.gesture,
					action: u.action,
					hasEagerState: u.hasEagerState,
					eagerState: u.eagerState,
					next: null
				}, l === null ? (c = l = p, s = o) : l = l.next = p, so.lanes |= f, Yl |= f;
				u = u.next;
			} while (u !== null && u !== t);
			if (l === null ? s = o : l.next = c, !hr(o, e.memoizedState) && (tc = !0, d && (n = sa, n !== null))) throw n;
			e.memoizedState = o, e.baseState = s, e.baseQueue = l, r.lastRenderedState = o;
		}
		return a === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
	}
	function Io(e) {
		var t = Oo(), n = t.queue;
		if (n === null) throw Error(i(311));
		n.lastRenderedReducer = e;
		var r = n.dispatch, a = n.pending, o = t.memoizedState;
		if (a !== null) {
			n.pending = null;
			var s = a = a.next;
			do
				o = e(o, s.action), s = s.next;
			while (s !== a);
			hr(o, t.memoizedState) || (tc = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
		}
		return [o, r];
	}
	function Lo(e, t, n) {
		var r = so, a = Oo(), o = Oi;
		if (o) {
			if (n === void 0) throw Error(i(407));
			n = n();
		} else n = t();
		var s = !hr((co || a).memoizedState, n);
		if (s && (a.memoizedState = n, tc = !0), a = a.queue, cs(Bo.bind(null, r, a, e), [e]), a.getSnapshot !== t || s || lo !== null && lo.memoizedState.tag & 1) {
			if (r.flags |= 2048, rs(9, { destroy: void 0 }, zo.bind(null, r, a, n, t), null), zl === null) throw Error(i(349));
			o || oo & 127 || Ro(r, t, n);
		}
		return n;
	}
	function Ro(e, t, n) {
		e.flags |= 16384, e = {
			getSnapshot: t,
			value: n
		}, t = so.updateQueue, t === null ? (t = ko(), so.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
	}
	function zo(e, t, n, r) {
		t.value = n, t.getSnapshot = r, Vo(t) && Ho(e);
	}
	function Bo(e, t, n) {
		return n(function() {
			Vo(t) && Ho(e);
		});
	}
	function Vo(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !hr(e, n);
		} catch {
			return !0;
		}
	}
	function Ho(e) {
		var t = Xr(e, 2);
		t !== null && _u(t, e, 2);
	}
	function Uo(e) {
		var t = Do();
		if (typeof e == "function") {
			var n = e;
			if (e = n(), po) {
				je(!0);
				try {
					n();
				} finally {
					je(!1);
				}
			}
		}
		return t.memoizedState = t.baseState = e, t.queue = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: No,
			lastRenderedState: e
		}, t;
	}
	function Wo(e, t, n, r) {
		return e.baseState = n, Fo(e, co, typeof r == "function" ? r : No);
	}
	function Go(e, t, n, r, a) {
		if (Ns(e)) throw Error(i(485));
		if (e = t.action, e !== null) {
			var o = {
				payload: a,
				action: e,
				next: null,
				isTransition: !0,
				status: "pending",
				value: null,
				reason: null,
				listeners: [],
				then: function(e) {
					o.listeners.push(e);
				}
			};
			I.T === null ? o.isTransition = !1 : n(!0), r(o), n = t.pending, n === null ? (o.next = t.pending = o, Ko(t, o)) : (o.next = n.next, t.pending = n.next = o);
		}
	}
	function Ko(e, t) {
		var n = t.action, r = t.payload, i = e.state;
		if (t.isTransition) {
			var a = I.T, o = {};
			I.T = o;
			try {
				var s = n(i, r), c = I.S;
				c !== null && c(o, s), qo(e, t, s);
			} catch (n) {
				Yo(e, t, n);
			} finally {
				a !== null && o.types !== null && (a.types = o.types), I.T = a;
			}
		} else try {
			a = n(i, r), qo(e, t, a);
		} catch (n) {
			Yo(e, t, n);
		}
	}
	function qo(e, t, n) {
		typeof n == "object" && n && typeof n.then == "function" ? n.then(function(n) {
			Jo(e, t, n);
		}, function(n) {
			return Yo(e, t, n);
		}) : Jo(e, t, n);
	}
	function Jo(e, t, n) {
		t.status = "fulfilled", t.value = n, Xo(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, Ko(e, n)));
	}
	function Yo(e, t, n) {
		var r = e.pending;
		if (e.pending = null, r !== null) {
			r = r.next;
			do
				t.status = "rejected", t.reason = n, Xo(t), t = t.next;
			while (t !== r);
		}
		e.action = null;
	}
	function Xo(e) {
		e = e.listeners;
		for (var t = 0; t < e.length; t++) (0, e[t])();
	}
	function Zo(e, t) {
		return t;
	}
	function Qo(e, t) {
		if (Oi) {
			var n = zl.formState;
			if (n !== null) {
				a: {
					var r = so;
					if (Oi) {
						if (Di) {
							b: {
								for (var i = Di, a = Ai; i.nodeType !== 8;) {
									if (!a) {
										i = null;
										break b;
									}
									if (i = ff(i.nextSibling), i === null) {
										i = null;
										break b;
									}
								}
								a = i.data, i = a === "F!" || a === "F" ? i : null;
							}
							if (i) {
								Di = ff(i.nextSibling), r = i.data === "F!";
								break a;
							}
						}
						Mi(r);
					}
					r = !1;
				}
				r && (t = n[0]);
			}
		}
		return n = Do(), n.memoizedState = n.baseState = t, r = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: Zo,
			lastRenderedState: t
		}, n.queue = r, n = As.bind(null, so, r), r.dispatch = n, r = Uo(!1), a = Ms.bind(null, so, !1, r.queue), r = Do(), i = {
			state: t,
			dispatch: null,
			action: e,
			pending: null
		}, r.queue = i, n = Go.bind(null, so, i, a, n), i.dispatch = n, r.memoizedState = e, [
			t,
			n,
			!1
		];
	}
	function $o(e) {
		return es(Oo(), co, e);
	}
	function es(e, t, n) {
		if (t = Fo(e, t, Zo)[0], e = Po(No)[0], typeof t == "object" && t && typeof t.then == "function") try {
			var r = Ao(t);
		} catch (e) {
			throw e === ga ? va : e;
		}
		else r = t;
		t = Oo();
		var i = t.queue, a = i.dispatch;
		return n !== t.memoizedState && (so.flags |= 2048, rs(9, { destroy: void 0 }, ts.bind(null, i, n), null)), [
			r,
			a,
			e
		];
	}
	function ts(e, t) {
		e.action = t;
	}
	function ns(e) {
		var t = Oo(), n = co;
		if (n !== null) return es(t, n, e);
		Oo(), t = t.memoizedState, n = Oo();
		var r = n.queue.dispatch;
		return n.memoizedState = e, [
			t,
			r,
			!1
		];
	}
	function rs(e, t, n, r) {
		return e = {
			tag: e,
			create: n,
			deps: r,
			inst: t,
			next: null
		}, t = so.updateQueue, t === null && (t = ko(), so.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
	}
	function is() {
		return Oo().memoizedState;
	}
	function as(e, t, n, r) {
		var i = Do();
		so.flags |= e, i.memoizedState = rs(1 | t, { destroy: void 0 }, n, r === void 0 ? null : r);
	}
	function os(e, t, n, r) {
		var i = Oo();
		r = r === void 0 ? null : r;
		var a = i.memoizedState.inst;
		co !== null && r !== null && yo(r, co.memoizedState.deps) ? i.memoizedState = rs(t, a, n, r) : (so.flags |= e, i.memoizedState = rs(1 | t, a, n, r));
	}
	function ss(e, t) {
		as(8390656, 8, e, t);
	}
	function cs(e, t) {
		os(2048, 8, e, t);
	}
	function ls(e) {
		so.flags |= 4;
		var t = so.updateQueue;
		if (t === null) t = ko(), so.updateQueue = t, t.events = [e];
		else {
			var n = t.events;
			n === null ? t.events = [e] : n.push(e);
		}
	}
	function us(e) {
		var t = Oo().memoizedState;
		return ls({
			ref: t,
			nextImpl: e
		}), function() {
			if (Rl & 2) throw Error(i(440));
			return t.impl.apply(void 0, arguments);
		};
	}
	function ds(e, t) {
		return os(4, 2, e, t);
	}
	function fs(e, t) {
		return os(4, 4, e, t);
	}
	function ps(e, t) {
		if (typeof t == "function") {
			e = e();
			var n = t(e);
			return function() {
				typeof n == "function" ? n() : t(null);
			};
		}
		if (t != null) return e = e(), t.current = e, function() {
			t.current = null;
		};
	}
	function ms(e, t, n) {
		n = n == null ? null : n.concat([e]), os(4, 4, ps.bind(null, t, e), n);
	}
	function hs() {}
	function gs(e, t) {
		var n = Oo();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		return t !== null && yo(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
	}
	function _s(e, t) {
		var n = Oo();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		if (t !== null && yo(t, r[1])) return r[0];
		if (r = e(), po) {
			je(!0);
			try {
				e();
			} finally {
				je(!1);
			}
		}
		return n.memoizedState = [r, t], r;
	}
	function vs(e, t, n) {
		return n === void 0 || oo & 1073741824 && !(Vl & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = gu(), so.lanes |= e, Yl |= e, n);
	}
	function ys(e, t, n, r) {
		return hr(n, t) ? n : Ka.current === null ? !(oo & 42) || oo & 1073741824 && !(Vl & 261930) ? (tc = !0, e.memoizedState = n) : (e = gu(), so.lanes |= e, Yl |= e, t) : (e = vs(e, n, r), hr(e, t) || (tc = !0), e);
	}
	function bs(e, t, n, r, i) {
		var a = R.p;
		R.p = a !== 0 && 8 > a ? a : 8;
		var o = I.T, s = {};
		I.T = s, Ms(e, !1, t, n);
		try {
			var c = i(), l = I.S;
			l !== null && l(s, c), typeof c == "object" && c && typeof c.then == "function" ? js(e, t, ua(c, r), hu(e)) : js(e, t, r, hu(e));
		} catch (n) {
			js(e, t, {
				then: function() {},
				status: "rejected",
				reason: n
			}, hu());
		} finally {
			R.p = a, o !== null && s.types !== null && (o.types = s.types), I.T = o;
		}
	}
	function xs() {}
	function Ss(e, t, n, r) {
		if (e.tag !== 5) throw Error(i(476));
		var a = Cs(e).queue;
		bs(e, a, t, ee, n === null ? xs : function() {
			return ws(e), n(r);
		});
	}
	function Cs(e) {
		var t = e.memoizedState;
		if (t !== null) return t;
		t = {
			memoizedState: ee,
			baseState: ee,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: No,
				lastRenderedState: ee
			},
			next: null
		};
		var n = {};
		return t.next = {
			memoizedState: n,
			baseState: n,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: No,
				lastRenderedState: n
			},
			next: null
		}, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
	}
	function ws(e) {
		var t = Cs(e);
		t.next === null && (t = e.alternate.memoizedState), js(e, t.next.queue, {}, hu());
	}
	function Ts() {
		return Yi(np);
	}
	function Es() {
		return Oo().memoizedState;
	}
	function Ds() {
		return Oo().memoizedState;
	}
	function Os(e) {
		for (var t = e.return; t !== null;) {
			switch (t.tag) {
				case 24:
				case 3:
					var n = hu();
					e = La(n);
					var r = Ra(t, e, n);
					r !== null && (_u(r, t, n), za(r, t, n)), t = { cache: na() }, e.payload = t;
					return;
			}
			t = t.return;
		}
	}
	function ks(e, t, n) {
		var r = hu();
		n = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Ns(e) ? Ps(t, n) : (n = Yr(e, t, n, r), n !== null && (_u(n, e, r), Fs(n, t, r)));
	}
	function As(e, t, n) {
		js(e, t, n, hu());
	}
	function js(e, t, n, r) {
		var i = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		};
		if (Ns(e)) Ps(t, i);
		else {
			var a = e.alternate;
			if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) try {
				var o = t.lastRenderedState, s = a(o, n);
				if (i.hasEagerState = !0, i.eagerState = s, hr(s, o)) return Jr(e, t, i, 0), zl === null && qr(), !1;
			} catch {}
			if (n = Yr(e, t, i, r), n !== null) return _u(n, e, r), Fs(n, t, r), !0;
		}
		return !1;
	}
	function Ms(e, t, n, r) {
		if (r = {
			lane: 2,
			revertLane: pd(),
			gesture: null,
			action: r,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Ns(e)) {
			if (t) throw Error(i(479));
		} else t = Yr(e, n, r, 2), t !== null && _u(t, e, 2);
	}
	function Ns(e) {
		var t = e.alternate;
		return e === so || t !== null && t === so;
	}
	function Ps(e, t) {
		fo = uo = !0;
		var n = e.pending;
		n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
	}
	function Fs(e, t, n) {
		if (n & 4194048) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, Je(e, n);
		}
	}
	var Is = {
		readContext: Yi,
		use: jo,
		useCallback: vo,
		useContext: vo,
		useEffect: vo,
		useImperativeHandle: vo,
		useLayoutEffect: vo,
		useInsertionEffect: vo,
		useMemo: vo,
		useReducer: vo,
		useRef: vo,
		useState: vo,
		useDebugValue: vo,
		useDeferredValue: vo,
		useTransition: vo,
		useSyncExternalStore: vo,
		useId: vo,
		useHostTransitionStatus: vo,
		useFormState: vo,
		useActionState: vo,
		useOptimistic: vo,
		useMemoCache: vo,
		useCacheRefresh: vo
	};
	Is.useEffectEvent = vo;
	var Ls = {
		readContext: Yi,
		use: jo,
		useCallback: function(e, t) {
			return Do().memoizedState = [e, t === void 0 ? null : t], e;
		},
		useContext: Yi,
		useEffect: ss,
		useImperativeHandle: function(e, t, n) {
			n = n == null ? null : n.concat([e]), as(4194308, 4, ps.bind(null, t, e), n);
		},
		useLayoutEffect: function(e, t) {
			return as(4194308, 4, e, t);
		},
		useInsertionEffect: function(e, t) {
			as(4, 2, e, t);
		},
		useMemo: function(e, t) {
			var n = Do();
			t = t === void 0 ? null : t;
			var r = e();
			if (po) {
				je(!0);
				try {
					e();
				} finally {
					je(!1);
				}
			}
			return n.memoizedState = [r, t], r;
		},
		useReducer: function(e, t, n) {
			var r = Do();
			if (n !== void 0) {
				var i = n(t);
				if (po) {
					je(!0);
					try {
						n(t);
					} finally {
						je(!1);
					}
				}
			} else i = t;
			return r.memoizedState = r.baseState = i, e = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: e,
				lastRenderedState: i
			}, r.queue = e, e = e.dispatch = ks.bind(null, so, e), [r.memoizedState, e];
		},
		useRef: function(e) {
			var t = Do();
			return e = { current: e }, t.memoizedState = e;
		},
		useState: function(e) {
			e = Uo(e);
			var t = e.queue, n = As.bind(null, so, t);
			return t.dispatch = n, [e.memoizedState, n];
		},
		useDebugValue: hs,
		useDeferredValue: function(e, t) {
			return vs(Do(), e, t);
		},
		useTransition: function() {
			var e = Uo(!1);
			return e = bs.bind(null, so, e.queue, !0, !1), Do().memoizedState = e, [!1, e];
		},
		useSyncExternalStore: function(e, t, n) {
			var r = so, a = Do();
			if (Oi) {
				if (n === void 0) throw Error(i(407));
				n = n();
			} else {
				if (n = t(), zl === null) throw Error(i(349));
				Vl & 127 || Ro(r, t, n);
			}
			a.memoizedState = n;
			var o = {
				value: n,
				getSnapshot: t
			};
			return a.queue = o, ss(Bo.bind(null, r, o, e), [e]), r.flags |= 2048, rs(9, { destroy: void 0 }, zo.bind(null, r, o, n, t), null), n;
		},
		useId: function() {
			var e = Do(), t = zl.identifierPrefix;
			if (Oi) {
				var n = bi, r = yi;
				n = (r & ~(1 << 32 - Me(r) - 1)).toString(32) + n, t = "_" + t + "R_" + n, n = mo++, 0 < n && (t += "H" + n.toString(32)), t += "_";
			} else n = _o++, t = "_" + t + "r_" + n.toString(32) + "_";
			return e.memoizedState = t;
		},
		useHostTransitionStatus: Ts,
		useFormState: Qo,
		useActionState: Qo,
		useOptimistic: function(e) {
			var t = Do();
			t.memoizedState = t.baseState = e;
			var n = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: null,
				lastRenderedState: null
			};
			return t.queue = n, t = Ms.bind(null, so, !0, n), n.dispatch = t, [e, t];
		},
		useMemoCache: Mo,
		useCacheRefresh: function() {
			return Do().memoizedState = Os.bind(null, so);
		},
		useEffectEvent: function(e) {
			var t = Do(), n = { impl: e };
			return t.memoizedState = n, function() {
				if (Rl & 2) throw Error(i(440));
				return n.impl.apply(void 0, arguments);
			};
		}
	}, Rs = {
		readContext: Yi,
		use: jo,
		useCallback: gs,
		useContext: Yi,
		useEffect: cs,
		useImperativeHandle: ms,
		useInsertionEffect: ds,
		useLayoutEffect: fs,
		useMemo: _s,
		useReducer: Po,
		useRef: is,
		useState: function() {
			return Po(No);
		},
		useDebugValue: hs,
		useDeferredValue: function(e, t) {
			return ys(Oo(), co.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Po(No)[0], t = Oo().memoizedState;
			return [typeof e == "boolean" ? e : Ao(e), t];
		},
		useSyncExternalStore: Lo,
		useId: Es,
		useHostTransitionStatus: Ts,
		useFormState: $o,
		useActionState: $o,
		useOptimistic: function(e, t) {
			return Wo(Oo(), co, e, t);
		},
		useMemoCache: Mo,
		useCacheRefresh: Ds
	};
	Rs.useEffectEvent = us;
	var zs = {
		readContext: Yi,
		use: jo,
		useCallback: gs,
		useContext: Yi,
		useEffect: cs,
		useImperativeHandle: ms,
		useInsertionEffect: ds,
		useLayoutEffect: fs,
		useMemo: _s,
		useReducer: Io,
		useRef: is,
		useState: function() {
			return Io(No);
		},
		useDebugValue: hs,
		useDeferredValue: function(e, t) {
			var n = Oo();
			return co === null ? vs(n, e, t) : ys(n, co.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Io(No)[0], t = Oo().memoizedState;
			return [typeof e == "boolean" ? e : Ao(e), t];
		},
		useSyncExternalStore: Lo,
		useId: Es,
		useHostTransitionStatus: Ts,
		useFormState: ns,
		useActionState: ns,
		useOptimistic: function(e, t) {
			var n = Oo();
			return co === null ? (n.baseState = e, [e, n.queue.dispatch]) : Wo(n, co, e, t);
		},
		useMemoCache: Mo,
		useCacheRefresh: Ds
	};
	zs.useEffectEvent = us;
	function Bs(e, t, n, r) {
		t = e.memoizedState, n = n(r, t), n = n == null ? t : f({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
	}
	var Vs = {
		enqueueSetState: function(e, t, n) {
			e = e._reactInternals;
			var r = hu(), i = La(r);
			i.payload = t, n != null && (i.callback = n), t = Ra(e, i, r), t !== null && (_u(t, e, r), za(t, e, r));
		},
		enqueueReplaceState: function(e, t, n) {
			e = e._reactInternals;
			var r = hu(), i = La(r);
			i.tag = 1, i.payload = t, n != null && (i.callback = n), t = Ra(e, i, r), t !== null && (_u(t, e, r), za(t, e, r));
		},
		enqueueForceUpdate: function(e, t) {
			e = e._reactInternals;
			var n = hu(), r = La(n);
			r.tag = 2, t != null && (r.callback = t), t = Ra(e, r, n), t !== null && (_u(t, e, n), za(t, e, n));
		}
	};
	function Hs(e, t, n, r, i, a, o) {
		return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, a, o) : t.prototype && t.prototype.isPureReactComponent ? !gr(n, r) || !gr(i, a) : !0;
	}
	function Us(e, t, n, r) {
		e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Vs.enqueueReplaceState(t, t.state, null);
	}
	function Ws(e, t) {
		var n = t;
		if ("ref" in t) for (var r in n = {}, t) r !== "ref" && (n[r] = t[r]);
		if (e = e.defaultProps) for (var i in n === t && (n = f({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
		return n;
	}
	function Gs(e) {
		Ur(e);
	}
	function Ks(e) {
		console.error(e);
	}
	function qs(e) {
		Ur(e);
	}
	function Js(e, t) {
		try {
			var n = e.onUncaughtError;
			n(t.value, { componentStack: t.stack });
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Ys(e, t, n) {
		try {
			var r = e.onCaughtError;
			r(n.value, {
				componentStack: n.stack,
				errorBoundary: t.tag === 1 ? t.stateNode : null
			});
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Xs(e, t, n) {
		return n = La(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
			Js(e, t);
		}, n;
	}
	function Zs(e) {
		return e = La(e), e.tag = 3, e;
	}
	function Qs(e, t, n, r) {
		var i = n.type.getDerivedStateFromError;
		if (typeof i == "function") {
			var a = r.value;
			e.payload = function() {
				return i(a);
			}, e.callback = function() {
				Ys(t, n, r);
			};
		}
		var o = n.stateNode;
		o !== null && typeof o.componentDidCatch == "function" && (e.callback = function() {
			Ys(t, n, r), typeof i != "function" && (ou === null ? ou = new Set([this]) : ou.add(this));
			var e = r.stack;
			this.componentDidCatch(r.value, { componentStack: e === null ? "" : e });
		});
	}
	function $s(e, t, n, r, a) {
		if (n.flags |= 32768, typeof r == "object" && r && typeof r.then == "function") {
			if (t = n.alternate, t !== null && Ki(t, n, a, !0), n = Za.current, n !== null) {
				switch (n.tag) {
					case 31:
					case 13: return Qa === null ? ku() : n.alternate === null && Jl === 0 && (Jl = 3), n.flags &= -257, n.flags |= 65536, n.lanes = a, r === ya ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = new Set([r]) : t.add(r), qu(e, r, a)), !1;
					case 22: return n.flags |= 65536, r === ya ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
						transitions: null,
						markerInstances: null,
						retryQueue: new Set([r])
					}, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = new Set([r]) : n.add(r)), qu(e, r, a)), !1;
				}
				throw Error(i(435, n.tag));
			}
			return qu(e, r, a), ku(), !1;
		}
		if (Oi) return t = Za.current, t === null ? (r !== ji && (t = Error(i(423), { cause: r }), Ri(di(t, n))), e = e.current.alternate, e.flags |= 65536, a &= -a, e.lanes |= a, r = di(r, n), a = Xs(e.stateNode, r, a), Ba(e, a), Jl !== 4 && (Jl = 2)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = a, r !== ji && (e = Error(i(422), { cause: r }), Ri(di(e, n)))), !1;
		var o = Error(i(520), { cause: r });
		if (o = di(o, n), $l === null ? $l = [o] : $l.push(o), Jl !== 4 && (Jl = 2), t === null) return !0;
		r = di(r, n), n = t;
		do {
			switch (n.tag) {
				case 3: return n.flags |= 65536, e = a & -a, n.lanes |= e, e = Xs(n.stateNode, r, e), Ba(n, e), !1;
				case 1: if (t = n.type, o = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == "function" || o !== null && typeof o.componentDidCatch == "function" && (ou === null || !ou.has(o)))) return n.flags |= 65536, a &= -a, n.lanes |= a, a = Zs(a), Qs(a, e, n, r), Ba(n, a), !1;
			}
			n = n.return;
		} while (n !== null);
		return !1;
	}
	var ec = Error(i(461)), tc = !1;
	function nc(e, t, n, r) {
		t.child = e === null ? Na(t, null, n, r) : Ma(t, e.child, n, r);
	}
	function rc(e, t, n, r, i) {
		n = n.render;
		var a = t.ref;
		if ("ref" in r) {
			var o = {};
			for (var s in r) s !== "ref" && (o[s] = r[s]);
		} else o = r;
		return Ji(t), r = bo(e, t, n, o, a, i), s = wo(), e !== null && !tc ? (To(e, t, i), Ec(e, t, i)) : (Oi && s && Ci(t), t.flags |= 1, nc(e, t, r, i), t.child);
	}
	function ic(e, t, n, r, i) {
		if (e === null) {
			var a = n.type;
			return typeof a == "function" && !ni(a) && a.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = a, q(e, t, a, r, i)) : (e = ai(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
		}
		if (a = e.child, !Dc(e, i)) {
			var o = a.memoizedProps;
			if (n = n.compare, n = n === null ? gr : n, n(o, r) && e.ref === t.ref) return Ec(e, t, i);
		}
		return t.flags |= 1, e = ri(a, r), e.ref = t.ref, e.return = t, t.child = e;
	}
	function q(e, t, n, r, i) {
		if (e !== null) {
			var a = e.memoizedProps;
			if (gr(a, r) && e.ref === t.ref) if (tc = !1, t.pendingProps = r = a, Dc(e, i)) e.flags & 131072 && (tc = !0);
			else return t.lanes = e.lanes, Ec(e, t, i);
		}
		return fc(e, t, n, r, i);
	}
	function ac(e, t, n, r) {
		var i = r.children, a = e === null ? null : e.memoizedState;
		if (e === null && t.stateNode === null && (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), r.mode === "hidden") {
			if (t.flags & 128) {
				if (a = a === null ? n : a.baseLanes | n, e !== null) {
					for (r = t.child = e.child, i = 0; r !== null;) i = i | r.lanes | r.childLanes, r = r.sibling;
					r = i & ~a;
				} else r = 0, t.child = null;
				return sc(e, t, a, n, r);
			}
			if (n & 536870912) t.memoizedState = {
				baseLanes: 0,
				cachePool: null
			}, e !== null && ma(t, a === null ? null : a.cachePool), a === null ? Ya() : Ja(t, a), to(t);
			else return r = t.lanes = 536870912, sc(e, t, a === null ? n : a.baseLanes | n, n, r);
		} else a === null ? (e !== null && ma(t, null), Ya(), no(t)) : (ma(t, a.cachePool), Ja(t, a), no(t), t.memoizedState = null);
		return nc(e, t, i, n), t.child;
	}
	function oc(e, t) {
		return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), t.sibling;
	}
	function sc(e, t, n, r, i) {
		var a = pa();
		return a = a === null ? null : {
			parent: ta._currentValue,
			pool: a
		}, t.memoizedState = {
			baseLanes: n,
			cachePool: a
		}, e !== null && ma(t, null), Ya(), to(t), e !== null && Ki(e, t, r, !0), t.childLanes = i, null;
	}
	function cc(e, t) {
		return t = xc({
			mode: t.mode,
			children: t.children
		}, e.mode), t.ref = e.ref, e.child = t, t.return = e, t;
	}
	function lc(e, t, n) {
		return Ma(t, e.child, null, n), e = cc(t, t.pendingProps), e.flags |= 2, ro(t), t.memoizedState = null, e;
	}
	function uc(e, t, n) {
		var r = t.pendingProps, a = (t.flags & 128) != 0;
		if (t.flags &= -129, e === null) {
			if (Oi) {
				if (r.mode === "hidden") return e = cc(t, r), t.lanes = 536870912, oc(null, e);
				if (eo(t), (e = Di) ? (e = cf(e, Ai), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: vi === null ? null : {
						id: yi,
						overflow: bi
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = ci(e), n.return = t, t.child = n, Ei = t, Di = null)) : e = null, e === null) throw Mi(t);
				return t.lanes = 536870912, null;
			}
			return cc(t, r);
		}
		var o = e.memoizedState;
		if (o !== null) {
			var s = o.dehydrated;
			if (eo(t), a) if (t.flags & 256) t.flags &= -257, t = lc(e, t, n);
			else if (t.memoizedState !== null) t.child = e.child, t.flags |= 128, t = null;
			else throw Error(i(558));
			else if (tc || Ki(e, t, n, !1), a = (n & e.childLanes) !== 0, tc || a) {
				if (r = zl, r !== null && (s = Ye(r, n), s !== 0 && s !== o.retryLane)) throw o.retryLane = s, Xr(e, s), _u(r, e, s), ec;
				ku(), t = lc(e, t, n);
			} else e = o.treeContext, Di = ff(s.nextSibling), Ei = t, Oi = !0, ki = null, Ai = !1, e !== null && Ti(t, e), t = cc(t, r), t.flags |= 4096;
			return t;
		}
		return e = ri(e.child, {
			mode: r.mode,
			children: r.children
		}), e.ref = t.ref, t.child = e, e.return = t, e;
	}
	function dc(e, t) {
		var n = t.ref;
		if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816);
		else {
			if (typeof n != "function" && typeof n != "object") throw Error(i(284));
			(e === null || e.ref !== n) && (t.flags |= 4194816);
		}
	}
	function fc(e, t, n, r, i) {
		return Ji(t), n = bo(e, t, n, r, void 0, i), r = wo(), e !== null && !tc ? (To(e, t, i), Ec(e, t, i)) : (Oi && r && Ci(t), t.flags |= 1, nc(e, t, n, i), t.child);
	}
	function pc(e, t, n, r, i, a) {
		return Ji(t), t.updateQueue = null, n = So(t, r, n, i), xo(e), r = wo(), e !== null && !tc ? (To(e, t, a), Ec(e, t, a)) : (Oi && r && Ci(t), t.flags |= 1, nc(e, t, n, a), t.child);
	}
	function mc(e, t, n, r, i) {
		if (Ji(t), t.stateNode === null) {
			var a = $r, o = n.contextType;
			typeof o == "object" && o && (a = Yi(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = Vs, t.stateNode = a, a._reactInternals = t, a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, Fa(t), o = n.contextType, a.context = typeof o == "object" && o ? Yi(o) : $r, a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == "function" && (Bs(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function" || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (o = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), o !== a.state && Vs.enqueueReplaceState(a, a.state, null), Ua(t, r, a, i), Ha(), a.state = t.memoizedState), typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !0;
		} else if (e === null) {
			a = t.stateNode;
			var s = t.memoizedProps, c = Ws(n, s);
			a.props = c;
			var l = a.context, u = n.contextType;
			o = $r, typeof u == "object" && u && (o = Yi(u));
			var d = n.getDerivedStateFromProps;
			u = typeof d == "function" || typeof a.getSnapshotBeforeUpdate == "function", s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s || l !== o) && Us(t, a, r, o), Pa = !1;
			var f = t.memoizedState;
			a.state = f, Ua(t, r, a, i), Ha(), l = t.memoizedState, s || f !== l || Pa ? (typeof d == "function" && (Bs(t, n, d, r), l = t.memoizedState), (c = Pa || Hs(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
		} else {
			a = t.stateNode, Ia(e, t), o = t.memoizedProps, u = Ws(n, o), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = $r, typeof l == "object" && l && (c = Yi(l)), s = n.getDerivedStateFromProps, (l = typeof s == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (o !== d || f !== c) && Us(t, a, r, c), Pa = !1, f = t.memoizedState, a.state = f, Ua(t, r, a, i), Ha();
			var p = t.memoizedState;
			o !== d || f !== p || Pa || e !== null && e.dependencies !== null && qi(e.dependencies) ? (typeof s == "function" && (Bs(t, n, s, r), p = t.memoizedState), (u = Pa || Hs(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && qi(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
		}
		return a = r, dc(e, t), r = (t.flags & 128) != 0, a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != "function" ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = Ma(t, e.child, null, i), t.child = Ma(t, null, n, i)) : nc(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = Ec(e, t, i), e;
	}
	function hc(e, t, n, r) {
		return Ii(), t.flags |= 256, nc(e, t, n, r), t.child;
	}
	var gc = {
		dehydrated: null,
		treeContext: null,
		retryLane: 0,
		hydrationErrors: null
	};
	function _c(e) {
		return {
			baseLanes: e,
			cachePool: ha()
		};
	}
	function vc(e, t, n) {
		return e = e === null ? 0 : e.childLanes & ~n, t && (e |= J), e;
	}
	function yc(e, t, n) {
		var r = t.pendingProps, a = !1, o = (t.flags & 128) != 0, s;
		if ((s = o) || (s = e !== null && e.memoizedState === null ? !1 : (io.current & 2) != 0), s && (a = !0, t.flags &= -129), s = (t.flags & 32) != 0, t.flags &= -33, e === null) {
			if (Oi) {
				if (a ? $a(t) : no(t), (e = Di) ? (e = cf(e, Ai), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: vi === null ? null : {
						id: yi,
						overflow: bi
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = ci(e), n.return = t, t.child = n, Ei = t, Di = null)) : e = null, e === null) throw Mi(t);
				return uf(e) ? t.lanes = 32 : t.lanes = 536870912, null;
			}
			var c = r.children;
			return r = r.fallback, a ? (no(t), a = t.mode, c = xc({
				mode: "hidden",
				children: c
			}, a), r = oi(r, a, n, null), c.return = t, r.return = t, c.sibling = r, t.child = c, r = t.child, r.memoizedState = _c(n), r.childLanes = vc(e, s, n), t.memoizedState = gc, oc(null, r)) : ($a(t), bc(t, c));
		}
		var l = e.memoizedState;
		if (l !== null && (c = l.dehydrated, c !== null)) {
			if (o) t.flags & 256 ? ($a(t), t.flags &= -257, t = Sc(e, t, n)) : t.memoizedState === null ? (no(t), c = r.fallback, a = t.mode, r = xc({
				mode: "visible",
				children: r.children
			}, a), c = oi(c, a, n, null), c.flags |= 2, r.return = t, c.return = t, r.sibling = c, t.child = r, Ma(t, e.child, null, n), r = t.child, r.memoizedState = _c(n), r.childLanes = vc(e, s, n), t.memoizedState = gc, t = oc(null, r)) : (no(t), t.child = e.child, t.flags |= 128, t = null);
			else if ($a(t), uf(c)) {
				if (s = c.nextSibling && c.nextSibling.dataset, s) var u = s.dgst;
				s = u, r = Error(i(419)), r.stack = "", r.digest = s, Ri({
					value: r,
					source: null,
					stack: null
				}), t = Sc(e, t, n);
			} else if (tc || Ki(e, t, n, !1), s = (n & e.childLanes) !== 0, tc || s) {
				if (s = zl, s !== null && (r = Ye(s, n), r !== 0 && r !== l.retryLane)) throw l.retryLane = r, Xr(e, r), _u(s, e, r), ec;
				lf(c) || ku(), t = Sc(e, t, n);
			} else lf(c) ? (t.flags |= 192, t.child = e.child, t = null) : (e = l.treeContext, Di = ff(c.nextSibling), Ei = t, Oi = !0, ki = null, Ai = !1, e !== null && Ti(t, e), t = bc(t, r.children), t.flags |= 4096);
			return t;
		}
		return a ? (no(t), c = r.fallback, a = t.mode, l = e.child, u = l.sibling, r = ri(l, {
			mode: "hidden",
			children: r.children
		}), r.subtreeFlags = l.subtreeFlags & 65011712, u === null ? (c = oi(c, a, n, null), c.flags |= 2) : c = ri(u, c), c.return = t, r.return = t, r.sibling = c, t.child = r, oc(null, r), r = t.child, c = e.child.memoizedState, c === null ? c = _c(n) : (a = c.cachePool, a === null ? a = ha() : (l = ta._currentValue, a = a.parent === l ? a : {
			parent: l,
			pool: l
		}), c = {
			baseLanes: c.baseLanes | n,
			cachePool: a
		}), r.memoizedState = c, r.childLanes = vc(e, s, n), t.memoizedState = gc, oc(e.child, r)) : ($a(t), n = e.child, e = n.sibling, n = ri(n, {
			mode: "visible",
			children: r.children
		}), n.return = t, n.sibling = null, e !== null && (s = t.deletions, s === null ? (t.deletions = [e], t.flags |= 16) : s.push(e)), t.child = n, t.memoizedState = null, n);
	}
	function bc(e, t) {
		return t = xc({
			mode: "visible",
			children: t
		}, e.mode), t.return = e, e.child = t;
	}
	function xc(e, t) {
		return e = ti(22, e, null, t), e.lanes = 0, e;
	}
	function Sc(e, t, n) {
		return Ma(t, e.child, null, n), e = bc(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
	}
	function Cc(e, t, n) {
		e.lanes |= t;
		var r = e.alternate;
		r !== null && (r.lanes |= t), Wi(e.return, t, n);
	}
	function wc(e, t, n, r, i, a) {
		var o = e.memoizedState;
		o === null ? e.memoizedState = {
			isBackwards: t,
			rendering: null,
			renderingStartTime: 0,
			last: r,
			tail: n,
			tailMode: i,
			treeForkCount: a
		} : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a);
	}
	function Tc(e, t, n) {
		var r = t.pendingProps, i = r.revealOrder, a = r.tail;
		r = r.children;
		var o = io.current, s = (o & 2) != 0;
		if (s ? (o = o & 1 | 2, t.flags |= 128) : o &= 1, V(io, o), nc(e, t, r, n), r = Oi ? hi : 0, !s && e !== null && e.flags & 128) a: for (e = t.child; e !== null;) {
			if (e.tag === 13) e.memoizedState !== null && Cc(e, n, t);
			else if (e.tag === 19) Cc(e, n, t);
			else if (e.child !== null) {
				e.child.return = e, e = e.child;
				continue;
			}
			if (e === t) break a;
			for (; e.sibling === null;) {
				if (e.return === null || e.return === t) break a;
				e = e.return;
			}
			e.sibling.return = e.return, e = e.sibling;
		}
		switch (i) {
			case "forwards":
				for (n = t.child, i = null; n !== null;) e = n.alternate, e !== null && ao(e) === null && (i = n), n = n.sibling;
				n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), wc(t, !1, i, n, a, r);
				break;
			case "backwards":
			case "unstable_legacy-backwards":
				for (n = null, i = t.child, t.child = null; i !== null;) {
					if (e = i.alternate, e !== null && ao(e) === null) {
						t.child = i;
						break;
					}
					e = i.sibling, i.sibling = n, n = i, i = e;
				}
				wc(t, !0, n, null, a, r);
				break;
			case "together":
				wc(t, !1, null, null, void 0, r);
				break;
			default: t.memoizedState = null;
		}
		return t.child;
	}
	function Ec(e, t, n) {
		if (e !== null && (t.dependencies = e.dependencies), Yl |= t.lanes, (n & t.childLanes) === 0) if (e !== null) {
			if (Ki(e, t, n, !1), (n & t.childLanes) === 0) return null;
		} else return null;
		if (e !== null && t.child !== e.child) throw Error(i(153));
		if (t.child !== null) {
			for (e = t.child, n = ri(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = ri(e, e.pendingProps), n.return = t;
			n.sibling = null;
		}
		return t.child;
	}
	function Dc(e, t) {
		return (e.lanes & t) === 0 ? (e = e.dependencies, !!(e !== null && qi(e))) : !0;
	}
	function Oc(e, t, n) {
		switch (t.tag) {
			case 3:
				se(t, t.stateNode.containerInfo), Hi(t, ta, e.memoizedState.cache), Ii();
				break;
			case 27:
			case 5:
				le(t);
				break;
			case 4:
				se(t, t.stateNode.containerInfo);
				break;
			case 10:
				Hi(t, t.type, t.memoizedProps.value);
				break;
			case 31:
				if (t.memoizedState !== null) return t.flags |= 128, eo(t), null;
				break;
			case 13:
				var r = t.memoizedState;
				if (r !== null) return r.dehydrated === null ? (n & t.child.childLanes) === 0 ? ($a(t), e = Ec(e, t, n), e === null ? null : e.sibling) : yc(e, t, n) : ($a(t), t.flags |= 128, null);
				$a(t);
				break;
			case 19:
				var i = (e.flags & 128) != 0;
				if (r = (n & t.childLanes) !== 0, r ||= (Ki(e, t, n, !1), (n & t.childLanes) !== 0), i) {
					if (r) return Tc(e, t, n);
					t.flags |= 128;
				}
				if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), V(io, io.current), r) break;
				return null;
			case 22: return t.lanes = 0, ac(e, t, n, t.pendingProps);
			case 24: Hi(t, ta, e.memoizedState.cache);
		}
		return Ec(e, t, n);
	}
	function kc(e, t, n) {
		if (e !== null) if (e.memoizedProps !== t.pendingProps) tc = !0;
		else {
			if (!Dc(e, n) && !(t.flags & 128)) return tc = !1, Oc(e, t, n);
			tc = !!(e.flags & 131072);
		}
		else tc = !1, Oi && t.flags & 1048576 && Si(t, hi, t.index);
		switch (t.lanes = 0, t.tag) {
			case 16:
				a: {
					var r = t.pendingProps;
					if (e = Sa(t.elementType), t.type = e, typeof e == "function") ni(e) ? (r = Ws(e, r), t.tag = 1, t = mc(null, t, e, r, n)) : (t.tag = 0, t = fc(null, t, e, r, n));
					else {
						if (e != null) {
							var a = e.$$typeof;
							if (a === w) {
								t.tag = 11, t = rc(null, t, e, r, n);
								break a;
							} else if (a === D) {
								t.tag = 14, t = ic(null, t, e, r, n);
								break a;
							}
						}
						throw t = P(e) || e, Error(i(306, t, ""));
					}
				}
				return t;
			case 0: return fc(e, t, t.type, t.pendingProps, n);
			case 1: return r = t.type, a = Ws(r, t.pendingProps), mc(e, t, r, a, n);
			case 3:
				a: {
					if (se(t, t.stateNode.containerInfo), e === null) throw Error(i(387));
					r = t.pendingProps;
					var o = t.memoizedState;
					a = o.element, Ia(e, t), Ua(t, r, null, n);
					var s = t.memoizedState;
					if (r = s.cache, Hi(t, ta, r), r !== o.cache && Gi(t, [ta], n, !0), Ha(), r = s.element, o.isDehydrated) if (o = {
						element: r,
						isDehydrated: !1,
						cache: s.cache
					}, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
						t = hc(e, t, r, n);
						break a;
					} else if (r !== a) {
						a = di(Error(i(424)), t), Ri(a), t = hc(e, t, r, n);
						break a;
					} else {
						switch (e = t.stateNode.containerInfo, e.nodeType) {
							case 9:
								e = e.body;
								break;
							default: e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
						}
						for (Di = ff(e.firstChild), Ei = t, Oi = !0, ki = null, Ai = !0, n = Na(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 4096, n = n.sibling;
					}
					else {
						if (Ii(), r === a) {
							t = Ec(e, t, n);
							break a;
						}
						nc(e, t, r, n);
					}
					t = t.child;
				}
				return t;
			case 26: return dc(e, t), e === null ? (n = Nf(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : Oi || (n = t.type, e = t.pendingProps, r = Wd(ae.current).createElement(n), r[tt] = t, r[nt] = e, Rd(r, n, e), pt(r), t.stateNode = r) : t.memoizedState = Nf(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
			case 27: return le(t), e === null && Oi && (r = t.stateNode = gf(t.type, t.pendingProps, ae.current), Ei = t, Ai = !0, a = Di, tf(t.type) ? (pf = a, Di = ff(r.firstChild)) : Di = a), nc(e, t, t.pendingProps.children, n), dc(e, t), e === null && (t.flags |= 4194304), t.child;
			case 5: return e === null && Oi && ((a = r = Di) && (r = of(r, t.type, t.pendingProps, Ai), r === null ? a = !1 : (t.stateNode = r, Ei = t, Di = ff(r.firstChild), Ai = !1, a = !0)), a || Mi(t)), le(t), a = t.type, o = t.pendingProps, s = e === null ? null : e.memoizedProps, r = o.children, qd(a, o) ? r = null : s !== null && qd(a, s) && (t.flags |= 32), t.memoizedState !== null && (a = bo(e, t, Co, null, null, n), np._currentValue = a), dc(e, t), nc(e, t, r, n), t.child;
			case 6: return e === null && Oi && ((e = n = Di) && (n = sf(n, t.pendingProps, Ai), n === null ? e = !1 : (t.stateNode = n, Ei = t, Di = null, e = !0)), e || Mi(t)), null;
			case 13: return yc(e, t, n);
			case 4: return se(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Ma(t, null, r, n) : nc(e, t, r, n), t.child;
			case 11: return rc(e, t, t.type, t.pendingProps, n);
			case 7: return nc(e, t, t.pendingProps, n), t.child;
			case 8: return nc(e, t, t.pendingProps.children, n), t.child;
			case 12: return nc(e, t, t.pendingProps.children, n), t.child;
			case 10: return r = t.pendingProps, Hi(t, t.type, r.value), nc(e, t, r.children, n), t.child;
			case 9: return a = t.type._context, r = t.pendingProps.children, Ji(t), a = Yi(a), r = r(a), t.flags |= 1, nc(e, t, r, n), t.child;
			case 14: return ic(e, t, t.type, t.pendingProps, n);
			case 15: return q(e, t, t.type, t.pendingProps, n);
			case 19: return Tc(e, t, n);
			case 31: return uc(e, t, n);
			case 22: return ac(e, t, n, t.pendingProps);
			case 24: return Ji(t), r = Yi(ta), e === null ? (a = pa(), a === null && (a = zl, o = na(), a.pooledCache = o, o.refCount++, o !== null && (a.pooledCacheLanes |= n), a = o), t.memoizedState = {
				parent: r,
				cache: a
			}, Fa(t), Hi(t, ta, a)) : ((e.lanes & n) !== 0 && (Ia(e, t), Ua(t, null, null, n), Ha()), a = e.memoizedState, o = t.memoizedState, a.parent === r ? (r = o.cache, Hi(t, ta, r), r !== a.cache && Gi(t, [ta], n, !0)) : (a = {
				parent: r,
				cache: r
			}, t.memoizedState = a, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = a), Hi(t, ta, r))), nc(e, t, t.pendingProps.children, n), t.child;
			case 29: throw t.pendingProps;
		}
		throw Error(i(156, t.tag));
	}
	function Ac(e) {
		e.flags |= 4;
	}
	function jc(e, t, n, r, i) {
		if ((t = (e.mode & 32) != 0) && (t = !1), t) {
			if (e.flags |= 16777216, (i & 335544128) === i) if (e.stateNode.complete) e.flags |= 8192;
			else if (Eu()) e.flags |= 8192;
			else throw Ca = ya, _a;
		} else e.flags &= -16777217;
	}
	function Mc(e, t) {
		if (t.type !== "stylesheet" || t.state.loading & 4) e.flags &= -16777217;
		else if (e.flags |= 16777216, !Jf(t)) if (Eu()) e.flags |= 8192;
		else throw Ca = ya, _a;
	}
	function Nc(e, t) {
		t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : Ue(), e.lanes |= t, Ql |= t);
	}
	function Pc(e, t) {
		if (!Oi) switch (e.tailMode) {
			case "hidden":
				t = e.tail;
				for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
				n === null ? e.tail = null : n.sibling = null;
				break;
			case "collapsed":
				n = e.tail;
				for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
				r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
		}
	}
	function Fc(e) {
		var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
		if (t) for (var i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 65011712, r |= i.flags & 65011712, i.return = e, i = i.sibling;
		else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
		return e.subtreeFlags |= r, e.childLanes = n, t;
	}
	function Ic(e, t, n) {
		var r = t.pendingProps;
		switch (wi(t), t.tag) {
			case 16:
			case 15:
			case 0:
			case 11:
			case 7:
			case 8:
			case 12:
			case 9:
			case 14: return Fc(t), null;
			case 1: return Fc(t), null;
			case 3: return n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), Ui(ta), ce(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Fi(t) ? Ac(t) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Li())), Fc(t), null;
			case 26:
				var a = t.type, o = t.memoizedState;
				return e === null ? (Ac(t), o === null ? (Fc(t), jc(t, a, null, r, n)) : (Fc(t), Mc(t, o))) : o ? o === e.memoizedState ? (Fc(t), t.flags &= -16777217) : (Ac(t), Fc(t), Mc(t, o)) : (e = e.memoizedProps, e !== r && Ac(t), Fc(t), jc(t, a, e, r, n)), null;
			case 27:
				if (ue(t), n = ae.current, a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Ac(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return Fc(t), null;
					}
					e = re.current, Fi(t) ? Ni(t, e) : (e = gf(a, r, n), t.stateNode = e, Ac(t));
				}
				return Fc(t), null;
			case 5:
				if (ue(t), a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Ac(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return Fc(t), null;
					}
					if (o = re.current, Fi(t)) Ni(t, o);
					else {
						var s = Wd(ae.current);
						switch (o) {
							case 1:
								o = s.createElementNS("http://www.w3.org/2000/svg", a);
								break;
							case 2:
								o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
								break;
							default: switch (a) {
								case "svg":
									o = s.createElementNS("http://www.w3.org/2000/svg", a);
									break;
								case "math":
									o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
									break;
								case "script":
									o = s.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild);
									break;
								case "select":
									o = typeof r.is == "string" ? s.createElement("select", { is: r.is }) : s.createElement("select"), r.multiple ? o.multiple = !0 : r.size && (o.size = r.size);
									break;
								default: o = typeof r.is == "string" ? s.createElement(a, { is: r.is }) : s.createElement(a);
							}
						}
						o[tt] = t, o[nt] = r;
						a: for (s = t.child; s !== null;) {
							if (s.tag === 5 || s.tag === 6) o.appendChild(s.stateNode);
							else if (s.tag !== 4 && s.tag !== 27 && s.child !== null) {
								s.child.return = s, s = s.child;
								continue;
							}
							if (s === t) break a;
							for (; s.sibling === null;) {
								if (s.return === null || s.return === t) break a;
								s = s.return;
							}
							s.sibling.return = s.return, s = s.sibling;
						}
						t.stateNode = o;
						a: switch (Rd(o, a, r), a) {
							case "button":
							case "input":
							case "select":
							case "textarea":
								r = !!r.autoFocus;
								break a;
							case "img":
								r = !0;
								break a;
							default: r = !1;
						}
						r && Ac(t);
					}
				}
				return Fc(t), jc(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null;
			case 6:
				if (e && t.stateNode != null) e.memoizedProps !== r && Ac(t);
				else {
					if (typeof r != "string" && t.stateNode === null) throw Error(i(166));
					if (e = ae.current, Fi(t)) {
						if (e = t.stateNode, n = t.memoizedProps, r = null, a = Ei, a !== null) switch (a.tag) {
							case 27:
							case 5: r = a.memoizedProps;
						}
						e[tt] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || Fd(e.nodeValue, n)), e || Mi(t, !0);
					} else e = Wd(e).createTextNode(r), e[tt] = t, t.stateNode = e;
				}
				return Fc(t), null;
			case 31:
				if (n = t.memoizedState, e === null || e.memoizedState !== null) {
					if (r = Fi(t), n !== null) {
						if (e === null) {
							if (!r) throw Error(i(318));
							if (e = t.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(557));
							e[tt] = t;
						} else Ii(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						Fc(t), e = !1;
					} else n = Li(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
					if (!e) return t.flags & 256 ? (ro(t), t) : (ro(t), null);
					if (t.flags & 128) throw Error(i(558));
				}
				return Fc(t), null;
			case 13:
				if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
					if (a = Fi(t), r !== null && r.dehydrated !== null) {
						if (e === null) {
							if (!a) throw Error(i(318));
							if (a = t.memoizedState, a = a === null ? null : a.dehydrated, !a) throw Error(i(317));
							a[tt] = t;
						} else Ii(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						Fc(t), a = !1;
					} else a = Li(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = a), a = !0;
					if (!a) return t.flags & 256 ? (ro(t), t) : (ro(t), null);
				}
				return ro(t), t.flags & 128 ? (t.lanes = n, t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, a = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (a = r.alternate.memoizedState.cachePool.pool), o = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (o = r.memoizedState.cachePool.pool), o !== a && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), Nc(t, t.updateQueue), Fc(t), null);
			case 4: return ce(), e === null && Td(t.stateNode.containerInfo), Fc(t), null;
			case 10: return Ui(t.type), Fc(t), null;
			case 19:
				if (B(io), r = t.memoizedState, r === null) return Fc(t), null;
				if (a = (t.flags & 128) != 0, o = r.rendering, o === null) if (a) Pc(r, !1);
				else {
					if (Jl !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
						if (o = ao(e), o !== null) {
							for (t.flags |= 128, Pc(r, !1), e = o.updateQueue, t.updateQueue = e, Nc(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) ii(n, e), n = n.sibling;
							return V(io, io.current & 1 | 2), Oi && xi(t, r.treeForkCount), t.child;
						}
						e = e.sibling;
					}
					r.tail !== null && W() > iu && (t.flags |= 128, a = !0, Pc(r, !1), t.lanes = 4194304);
				}
				else {
					if (!a) if (e = ao(o), e !== null) {
						if (t.flags |= 128, a = !0, e = e.updateQueue, t.updateQueue = e, Nc(t, e), Pc(r, !0), r.tail === null && r.tailMode === "hidden" && !o.alternate && !Oi) return Fc(t), null;
					} else 2 * W() - r.renderingStartTime > iu && n !== 536870912 && (t.flags |= 128, a = !0, Pc(r, !1), t.lanes = 4194304);
					r.isBackwards ? (o.sibling = t.child, t.child = o) : (e = r.last, e === null ? t.child = o : e.sibling = o, r.last = o);
				}
				return r.tail === null ? (Fc(t), null) : (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = W(), e.sibling = null, n = io.current, V(io, a ? n & 1 | 2 : n & 1), Oi && xi(t, r.treeForkCount), e);
			case 22:
			case 23: return ro(t), Xa(), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (Fc(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Fc(t), n = t.updateQueue, n !== null && Nc(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && B(fa), null;
			case 24: return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), Ui(ta), Fc(t), null;
			case 25: return null;
			case 30: return null;
		}
		throw Error(i(156, t.tag));
	}
	function Lc(e, t) {
		switch (wi(t), t.tag) {
			case 1: return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 3: return Ui(ta), ce(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
			case 26:
			case 27:
			case 5: return ue(t), null;
			case 31:
				if (t.memoizedState !== null) {
					if (ro(t), t.alternate === null) throw Error(i(340));
					Ii();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 13:
				if (ro(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
					if (t.alternate === null) throw Error(i(340));
					Ii();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 19: return B(io), null;
			case 4: return ce(), null;
			case 10: return Ui(t.type), null;
			case 22:
			case 23: return ro(t), Xa(), e !== null && B(fa), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 24: return Ui(ta), null;
			case 25: return null;
			default: return null;
		}
	}
	function Rc(e, t) {
		switch (wi(t), t.tag) {
			case 3:
				Ui(ta), ce();
				break;
			case 26:
			case 27:
			case 5:
				ue(t);
				break;
			case 4:
				ce();
				break;
			case 31:
				t.memoizedState !== null && ro(t);
				break;
			case 13:
				ro(t);
				break;
			case 19:
				B(io);
				break;
			case 10:
				Ui(t.type);
				break;
			case 22:
			case 23:
				ro(t), Xa(), e !== null && B(fa);
				break;
			case 24: Ui(ta);
		}
	}
	function zc(e, t) {
		try {
			var n = t.updateQueue, r = n === null ? null : n.lastEffect;
			if (r !== null) {
				var i = r.next;
				n = i;
				do {
					if ((n.tag & e) === e) {
						r = void 0;
						var a = n.create, o = n.inst;
						r = a(), o.destroy = r;
					}
					n = n.next;
				} while (n !== i);
			}
		} catch (e) {
			Ku(t, t.return, e);
		}
	}
	function Bc(e, t, n) {
		try {
			var r = t.updateQueue, i = r === null ? null : r.lastEffect;
			if (i !== null) {
				var a = i.next;
				r = a;
				do {
					if ((r.tag & e) === e) {
						var o = r.inst, s = o.destroy;
						if (s !== void 0) {
							o.destroy = void 0, i = t;
							var c = n, l = s;
							try {
								l();
							} catch (e) {
								Ku(i, c, e);
							}
						}
					}
					r = r.next;
				} while (r !== a);
			}
		} catch (e) {
			Ku(t, t.return, e);
		}
	}
	function Vc(e) {
		var t = e.updateQueue;
		if (t !== null) {
			var n = e.stateNode;
			try {
				Ga(t, n);
			} catch (t) {
				Ku(e, e.return, t);
			}
		}
	}
	function Hc(e, t, n) {
		n.props = Ws(e.type, e.memoizedProps), n.state = e.memoizedState;
		try {
			n.componentWillUnmount();
		} catch (n) {
			Ku(e, t, n);
		}
	}
	function Uc(e, t) {
		try {
			var n = e.ref;
			if (n !== null) {
				switch (e.tag) {
					case 26:
					case 27:
					case 5:
						var r = e.stateNode;
						break;
					case 30:
						r = e.stateNode;
						break;
					default: r = e.stateNode;
				}
				typeof n == "function" ? e.refCleanup = n(r) : n.current = r;
			}
		} catch (n) {
			Ku(e, t, n);
		}
	}
	function Wc(e, t) {
		var n = e.ref, r = e.refCleanup;
		if (n !== null) if (typeof r == "function") try {
			r();
		} catch (n) {
			Ku(e, t, n);
		} finally {
			e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
		}
		else if (typeof n == "function") try {
			n(null);
		} catch (n) {
			Ku(e, t, n);
		}
		else n.current = null;
	}
	function Gc(e) {
		var t = e.type, n = e.memoizedProps, r = e.stateNode;
		try {
			a: switch (t) {
				case "button":
				case "input":
				case "select":
				case "textarea":
					n.autoFocus && r.focus();
					break a;
				case "img": n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet);
			}
		} catch (t) {
			Ku(e, e.return, t);
		}
	}
	function Kc(e, t, n) {
		try {
			var r = e.stateNode;
			zd(r, e.type, n, t), r[nt] = t;
		} catch (t) {
			Ku(e, e.return, t);
		}
	}
	function qc(e) {
		return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && tf(e.type) || e.tag === 4;
	}
	function Jc(e) {
		a: for (;;) {
			for (; e.sibling === null;) {
				if (e.return === null || qc(e.return)) return null;
				e = e.return;
			}
			for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
				if (e.tag === 27 && tf(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
				e.child.return = e, e = e.child;
			}
			if (!(e.flags & 2)) return e.stateNode;
		}
	}
	function Yc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = qt));
		else if (r !== 4 && (r === 27 && tf(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null)) for (Yc(e, t, n), e = e.sibling; e !== null;) Yc(e, t, n), e = e.sibling;
	}
	function Xc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
		else if (r !== 4 && (r === 27 && tf(e.type) && (n = e.stateNode), e = e.child, e !== null)) for (Xc(e, t, n), e = e.sibling; e !== null;) Xc(e, t, n), e = e.sibling;
	}
	function Zc(e) {
		var t = e.stateNode, n = e.memoizedProps;
		try {
			for (var r = e.type, i = t.attributes; i.length;) t.removeAttributeNode(i[0]);
			Rd(t, r, n), t[tt] = e, t[nt] = n;
		} catch (t) {
			Ku(e, e.return, t);
		}
	}
	var Qc = !1, $c = !1, el = !1, tl = typeof WeakSet == "function" ? WeakSet : Set, nl = null;
	function rl(e, t) {
		if (e = e.containerInfo, Hd = dp, e = br(e), xr(e)) {
			if ("selectionStart" in e) var n = {
				start: e.selectionStart,
				end: e.selectionEnd
			};
			else a: {
				n = (n = e.ownerDocument) && n.defaultView || window;
				var r = n.getSelection && n.getSelection();
				if (r && r.rangeCount !== 0) {
					n = r.anchorNode;
					var a = r.anchorOffset, o = r.focusNode;
					r = r.focusOffset;
					try {
						n.nodeType, o.nodeType;
					} catch {
						n = null;
						break a;
					}
					var s = 0, c = -1, l = -1, u = 0, d = 0, f = e, p = null;
					b: for (;;) {
						for (var m; f !== n || a !== 0 && f.nodeType !== 3 || (c = s + a), f !== o || r !== 0 && f.nodeType !== 3 || (l = s + r), f.nodeType === 3 && (s += f.nodeValue.length), (m = f.firstChild) !== null;) p = f, f = m;
						for (;;) {
							if (f === e) break b;
							if (p === n && ++u === a && (c = s), p === o && ++d === r && (l = s), (m = f.nextSibling) !== null) break;
							f = p, p = f.parentNode;
						}
						f = m;
					}
					n = c === -1 || l === -1 ? null : {
						start: c,
						end: l
					};
				} else n = null;
			}
			n ||= {
				start: 0,
				end: 0
			};
		} else n = null;
		for (Ud = {
			focusedElem: e,
			selectionRange: n
		}, dp = !1, nl = t; nl !== null;) if (t = nl, e = t.child, t.subtreeFlags & 1028 && e !== null) e.return = t, nl = e;
		else for (; nl !== null;) {
			switch (t = nl, o = t.alternate, e = t.flags, t.tag) {
				case 0:
					if (e & 4 && (e = t.updateQueue, e = e === null ? null : e.events, e !== null)) for (n = 0; n < e.length; n++) a = e[n], a.ref.impl = a.nextImpl;
					break;
				case 11:
				case 15: break;
				case 1:
					if (e & 1024 && o !== null) {
						e = void 0, n = t, a = o.memoizedProps, o = o.memoizedState, r = n.stateNode;
						try {
							var h = Ws(n.type, a);
							e = r.getSnapshotBeforeUpdate(h, o), r.__reactInternalSnapshotBeforeUpdate = e;
						} catch (e) {
							Ku(n, n.return, e);
						}
					}
					break;
				case 3:
					if (e & 1024) {
						if (e = t.stateNode.containerInfo, n = e.nodeType, n === 9) af(e);
						else if (n === 1) switch (e.nodeName) {
							case "HEAD":
							case "HTML":
							case "BODY":
								af(e);
								break;
							default: e.textContent = "";
						}
					}
					break;
				case 5:
				case 26:
				case 27:
				case 6:
				case 4:
				case 17: break;
				default: if (e & 1024) throw Error(i(163));
			}
			if (e = t.sibling, e !== null) {
				e.return = t.return, nl = e;
				break;
			}
			nl = t.return;
		}
	}
	function il(e, t, n) {
		var r = n.flags;
		switch (n.tag) {
			case 0:
			case 11:
			case 15:
				yl(e, n), r & 4 && zc(5, n);
				break;
			case 1:
				if (yl(e, n), r & 4) if (e = n.stateNode, t === null) try {
					e.componentDidMount();
				} catch (e) {
					Ku(n, n.return, e);
				}
				else {
					var i = Ws(n.type, t.memoizedProps);
					t = t.memoizedState;
					try {
						e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
					} catch (e) {
						Ku(n, n.return, e);
					}
				}
				r & 64 && Vc(n), r & 512 && Uc(n, n.return);
				break;
			case 3:
				if (yl(e, n), r & 64 && (e = n.updateQueue, e !== null)) {
					if (t = null, n.child !== null) switch (n.child.tag) {
						case 27:
						case 5:
							t = n.child.stateNode;
							break;
						case 1: t = n.child.stateNode;
					}
					try {
						Ga(e, t);
					} catch (e) {
						Ku(n, n.return, e);
					}
				}
				break;
			case 27: t === null && r & 4 && Zc(n);
			case 26:
			case 5:
				yl(e, n), t === null && r & 4 && Gc(n), r & 512 && Uc(n, n.return);
				break;
			case 12:
				yl(e, n);
				break;
			case 31:
				yl(e, n), r & 4 && ul(e, n);
				break;
			case 13:
				yl(e, n), r & 4 && dl(e, n), r & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = Xu.bind(null, n), df(e, n))));
				break;
			case 22:
				if (r = n.memoizedState !== null || Qc, !r) {
					t = t !== null && t.memoizedState !== null || $c, i = Qc;
					var a = $c;
					Qc = r, ($c = t) && !a ? xl(e, n, (n.subtreeFlags & 8772) != 0) : yl(e, n), Qc = i, $c = a;
				}
				break;
			case 30: break;
			default: yl(e, n);
		}
	}
	function al(e) {
		var t = e.alternate;
		t !== null && (e.alternate = null, al(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && ct(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
	}
	var ol = null, sl = !1;
	function cl(e, t, n) {
		for (n = n.child; n !== null;) ll(e, t, n), n = n.sibling;
	}
	function ll(e, t, n) {
		if (Ae && typeof Ae.onCommitFiberUnmount == "function") try {
			Ae.onCommitFiberUnmount(ke, n);
		} catch {}
		switch (n.tag) {
			case 26:
				$c || Wc(n, t), cl(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
				break;
			case 27:
				$c || Wc(n, t);
				var r = ol, i = sl;
				tf(n.type) && (ol = n.stateNode, sl = !1), cl(e, t, n), _f(n.stateNode), ol = r, sl = i;
				break;
			case 5: $c || Wc(n, t);
			case 6:
				if (r = ol, i = sl, ol = null, cl(e, t, n), ol = r, sl = i, ol !== null) if (sl) try {
					(ol.nodeType === 9 ? ol.body : ol.nodeName === "HTML" ? ol.ownerDocument.body : ol).removeChild(n.stateNode);
				} catch (e) {
					Ku(n, t, e);
				}
				else try {
					ol.removeChild(n.stateNode);
				} catch (e) {
					Ku(n, t, e);
				}
				break;
			case 18:
				ol !== null && (sl ? (e = ol, nf(e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, n.stateNode), Lp(e)) : nf(ol, n.stateNode));
				break;
			case 4:
				r = ol, i = sl, ol = n.stateNode.containerInfo, sl = !0, cl(e, t, n), ol = r, sl = i;
				break;
			case 0:
			case 11:
			case 14:
			case 15:
				Bc(2, n, t), $c || Bc(4, n, t), cl(e, t, n);
				break;
			case 1:
				$c || (Wc(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function" && Hc(n, t, r)), cl(e, t, n);
				break;
			case 21:
				cl(e, t, n);
				break;
			case 22:
				$c = (r = $c) || n.memoizedState !== null, cl(e, t, n), $c = r;
				break;
			default: cl(e, t, n);
		}
	}
	function ul(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
			e = e.dehydrated;
			try {
				Lp(e);
			} catch (e) {
				Ku(t, t.return, e);
			}
		}
	}
	function dl(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
			Lp(e);
		} catch (e) {
			Ku(t, t.return, e);
		}
	}
	function fl(e) {
		switch (e.tag) {
			case 31:
			case 13:
			case 19:
				var t = e.stateNode;
				return t === null && (t = e.stateNode = new tl()), t;
			case 22: return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new tl()), t;
			default: throw Error(i(435, e.tag));
		}
	}
	function pl(e, t) {
		var n = fl(e);
		t.forEach(function(t) {
			if (!n.has(t)) {
				n.add(t);
				var r = Zu.bind(null, e, t);
				t.then(r, r);
			}
		});
	}
	function ml(e, t) {
		var n = t.deletions;
		if (n !== null) for (var r = 0; r < n.length; r++) {
			var a = n[r], o = e, s = t, c = s;
			a: for (; c !== null;) {
				switch (c.tag) {
					case 27:
						if (tf(c.type)) {
							ol = c.stateNode, sl = !1;
							break a;
						}
						break;
					case 5:
						ol = c.stateNode, sl = !1;
						break a;
					case 3:
					case 4:
						ol = c.stateNode.containerInfo, sl = !0;
						break a;
				}
				c = c.return;
			}
			if (ol === null) throw Error(i(160));
			ll(o, s, a), ol = null, sl = !1, o = a.alternate, o !== null && (o.return = null), a.return = null;
		}
		if (t.subtreeFlags & 13886) for (t = t.child; t !== null;) gl(t, e), t = t.sibling;
	}
	var hl = null;
	function gl(e, t) {
		var n = e.alternate, r = e.flags;
		switch (e.tag) {
			case 0:
			case 11:
			case 14:
			case 15:
				ml(t, e), _l(e), r & 4 && (Bc(3, e, e.return), zc(3, e), Bc(5, e, e.return));
				break;
			case 1:
				ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), r & 64 && Qc && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? r : n.concat(r))));
				break;
			case 26:
				var a = hl;
				if (ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), r & 4) {
					var o = n === null ? null : n.memoizedState;
					if (r = e.memoizedState, n === null) if (r === null) if (e.stateNode === null) {
						a: {
							r = e.type, n = e.memoizedProps, a = a.ownerDocument || a;
							b: switch (r) {
								case "title":
									o = a.getElementsByTagName("title")[0], (!o || o[st] || o[tt] || o.namespaceURI === "http://www.w3.org/2000/svg" || o.hasAttribute("itemprop")) && (o = a.createElement(r), a.head.insertBefore(o, a.querySelector("head > title"))), Rd(o, r, n), o[tt] = e, pt(o), r = o;
									break a;
								case "link":
									var s = Gf("link", "href", a).get(r + (n.href || ""));
									if (s) {
										for (var c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && o.getAttribute("rel") === (n.rel == null ? null : n.rel) && o.getAttribute("title") === (n.title == null ? null : n.title) && o.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
											s.splice(c, 1);
											break b;
										}
									}
									o = a.createElement(r), Rd(o, r, n), a.head.appendChild(o);
									break;
								case "meta":
									if (s = Gf("meta", "content", a).get(r + (n.content || ""))) {
										for (c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("content") === (n.content == null ? null : "" + n.content) && o.getAttribute("name") === (n.name == null ? null : n.name) && o.getAttribute("property") === (n.property == null ? null : n.property) && o.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && o.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
											s.splice(c, 1);
											break b;
										}
									}
									o = a.createElement(r), Rd(o, r, n), a.head.appendChild(o);
									break;
								default: throw Error(i(468, r));
							}
							o[tt] = e, pt(o), r = o;
						}
						e.stateNode = r;
					} else Kf(a, e.type, e.stateNode);
					else e.stateNode = Bf(a, r, e.memoizedProps);
					else o === r ? r === null && e.stateNode !== null && Kc(e, e.memoizedProps, n.memoizedProps) : (o === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : o.count--, r === null ? Kf(a, e.type, e.stateNode) : Bf(a, r, e.memoizedProps));
				}
				break;
			case 27:
				ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), n !== null && r & 4 && Kc(e, e.memoizedProps, n.memoizedProps);
				break;
			case 5:
				if (ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), e.flags & 32) {
					a = e.stateNode;
					try {
						zt(a, "");
					} catch (t) {
						Ku(e, e.return, t);
					}
				}
				r & 4 && e.stateNode != null && (a = e.memoizedProps, Kc(e, a, n === null ? a : n.memoizedProps)), r & 1024 && (el = !0);
				break;
			case 6:
				if (ml(t, e), _l(e), r & 4) {
					if (e.stateNode === null) throw Error(i(162));
					r = e.memoizedProps, n = e.stateNode;
					try {
						n.nodeValue = r;
					} catch (t) {
						Ku(e, e.return, t);
					}
				}
				break;
			case 3:
				if (Wf = null, a = hl, hl = bf(t.containerInfo), ml(t, e), hl = a, _l(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
					Lp(t.containerInfo);
				} catch (t) {
					Ku(e, e.return, t);
				}
				el && (el = !1, vl(e));
				break;
			case 4:
				r = hl, hl = bf(e.stateNode.containerInfo), ml(t, e), _l(e), hl = r;
				break;
			case 12:
				ml(t, e), _l(e);
				break;
			case 31:
				ml(t, e), _l(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, pl(e, r)));
				break;
			case 13:
				ml(t, e), _l(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && (nu = W()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, pl(e, r)));
				break;
			case 22:
				a = e.memoizedState !== null;
				var l = n !== null && n.memoizedState !== null, u = Qc, d = $c;
				if (Qc = u || a, $c = d || l, ml(t, e), $c = d, Qc = u, _l(e), r & 8192) a: for (t = e.stateNode, t._visibility = a ? t._visibility & -2 : t._visibility | 1, a && (n === null || l || Qc || $c || bl(e)), n = null, t = e;;) {
					if (t.tag === 5 || t.tag === 26) {
						if (n === null) {
							l = n = t;
							try {
								if (o = l.stateNode, a) s = o.style, typeof s.setProperty == "function" ? s.setProperty("display", "none", "important") : s.display = "none";
								else {
									c = l.stateNode;
									var f = l.memoizedProps.style, p = f != null && f.hasOwnProperty("display") ? f.display : null;
									c.style.display = p == null || typeof p == "boolean" ? "" : ("" + p).trim();
								}
							} catch (e) {
								Ku(l, l.return, e);
							}
						}
					} else if (t.tag === 6) {
						if (n === null) {
							l = t;
							try {
								l.stateNode.nodeValue = a ? "" : l.memoizedProps;
							} catch (e) {
								Ku(l, l.return, e);
							}
						}
					} else if (t.tag === 18) {
						if (n === null) {
							l = t;
							try {
								var m = l.stateNode;
								a ? rf(m, !0) : rf(l.stateNode, !1);
							} catch (e) {
								Ku(l, l.return, e);
							}
						}
					} else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
						t.child.return = t, t = t.child;
						continue;
					}
					if (t === e) break a;
					for (; t.sibling === null;) {
						if (t.return === null || t.return === e) break a;
						n === t && (n = null), t = t.return;
					}
					n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
				}
				r & 4 && (r = e.updateQueue, r !== null && (n = r.retryQueue, n !== null && (r.retryQueue = null, pl(e, n))));
				break;
			case 19:
				ml(t, e), _l(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, pl(e, r)));
				break;
			case 30: break;
			case 21: break;
			default: ml(t, e), _l(e);
		}
	}
	function _l(e) {
		var t = e.flags;
		if (t & 2) {
			try {
				for (var n, r = e.return; r !== null;) {
					if (qc(r)) {
						n = r;
						break;
					}
					r = r.return;
				}
				if (n == null) throw Error(i(160));
				switch (n.tag) {
					case 27:
						var a = n.stateNode;
						Xc(e, Jc(e), a);
						break;
					case 5:
						var o = n.stateNode;
						n.flags & 32 && (zt(o, ""), n.flags &= -33), Xc(e, Jc(e), o);
						break;
					case 3:
					case 4:
						var s = n.stateNode.containerInfo;
						Yc(e, Jc(e), s);
						break;
					default: throw Error(i(161));
				}
			} catch (t) {
				Ku(e, e.return, t);
			}
			e.flags &= -3;
		}
		t & 4096 && (e.flags &= -4097);
	}
	function vl(e) {
		if (e.subtreeFlags & 1024) for (e = e.child; e !== null;) {
			var t = e;
			vl(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
		}
	}
	function yl(e, t) {
		if (t.subtreeFlags & 8772) for (t = t.child; t !== null;) il(e, t.alternate, t), t = t.sibling;
	}
	function bl(e) {
		for (e = e.child; e !== null;) {
			var t = e;
			switch (t.tag) {
				case 0:
				case 11:
				case 14:
				case 15:
					Bc(4, t, t.return), bl(t);
					break;
				case 1:
					Wc(t, t.return);
					var n = t.stateNode;
					typeof n.componentWillUnmount == "function" && Hc(t, t.return, n), bl(t);
					break;
				case 27: _f(t.stateNode);
				case 26:
				case 5:
					Wc(t, t.return), bl(t);
					break;
				case 22:
					t.memoizedState === null && bl(t);
					break;
				case 30:
					bl(t);
					break;
				default: bl(t);
			}
			e = e.sibling;
		}
	}
	function xl(e, t, n) {
		for (n &&= (t.subtreeFlags & 8772) != 0, t = t.child; t !== null;) {
			var r = t.alternate, i = e, a = t, o = a.flags;
			switch (a.tag) {
				case 0:
				case 11:
				case 15:
					xl(i, a, n), zc(4, a);
					break;
				case 1:
					if (xl(i, a, n), r = a, i = r.stateNode, typeof i.componentDidMount == "function") try {
						i.componentDidMount();
					} catch (e) {
						Ku(r, r.return, e);
					}
					if (r = a, i = r.updateQueue, i !== null) {
						var s = r.stateNode;
						try {
							var c = i.shared.hiddenCallbacks;
							if (c !== null) for (i.shared.hiddenCallbacks = null, i = 0; i < c.length; i++) Wa(c[i], s);
						} catch (e) {
							Ku(r, r.return, e);
						}
					}
					n && o & 64 && Vc(a), Uc(a, a.return);
					break;
				case 27: Zc(a);
				case 26:
				case 5:
					xl(i, a, n), n && r === null && o & 4 && Gc(a), Uc(a, a.return);
					break;
				case 12:
					xl(i, a, n);
					break;
				case 31:
					xl(i, a, n), n && o & 4 && ul(i, a);
					break;
				case 13:
					xl(i, a, n), n && o & 4 && dl(i, a);
					break;
				case 22:
					a.memoizedState === null && xl(i, a, n), Uc(a, a.return);
					break;
				case 30: break;
				default: xl(i, a, n);
			}
			t = t.sibling;
		}
	}
	function Sl(e, t) {
		var n = null;
		e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && ra(n));
	}
	function Cl(e, t) {
		e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ra(e));
	}
	function wl(e, t, n, r) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) Tl(e, t, n, r), t = t.sibling;
	}
	function Tl(e, t, n, r) {
		var i = t.flags;
		switch (t.tag) {
			case 0:
			case 11:
			case 15:
				wl(e, t, n, r), i & 2048 && zc(9, t);
				break;
			case 1:
				wl(e, t, n, r);
				break;
			case 3:
				wl(e, t, n, r), i & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ra(e)));
				break;
			case 12:
				if (i & 2048) {
					wl(e, t, n, r), e = t.stateNode;
					try {
						var a = t.memoizedProps, o = a.id, s = a.onPostCommit;
						typeof s == "function" && s(o, t.alternate === null ? "mount" : "update", e.passiveEffectDuration, -0);
					} catch (e) {
						Ku(t, t.return, e);
					}
				} else wl(e, t, n, r);
				break;
			case 31:
				wl(e, t, n, r);
				break;
			case 13:
				wl(e, t, n, r);
				break;
			case 23: break;
			case 22:
				a = t.stateNode, o = t.alternate, t.memoizedState === null ? a._visibility & 2 ? wl(e, t, n, r) : (a._visibility |= 2, El(e, t, n, r, (t.subtreeFlags & 10256) != 0 || !1)) : a._visibility & 2 ? wl(e, t, n, r) : Dl(e, t), i & 2048 && Sl(o, t);
				break;
			case 24:
				wl(e, t, n, r), i & 2048 && Cl(t.alternate, t);
				break;
			default: wl(e, t, n, r);
		}
	}
	function El(e, t, n, r, i) {
		for (i &&= (t.subtreeFlags & 10256) != 0 || !1, t = t.child; t !== null;) {
			var a = e, o = t, s = n, c = r, l = o.flags;
			switch (o.tag) {
				case 0:
				case 11:
				case 15:
					El(a, o, s, c, i), zc(8, o);
					break;
				case 23: break;
				case 22:
					var u = o.stateNode;
					o.memoizedState === null ? (u._visibility |= 2, El(a, o, s, c, i)) : u._visibility & 2 ? El(a, o, s, c, i) : Dl(a, o), i && l & 2048 && Sl(o.alternate, o);
					break;
				case 24:
					El(a, o, s, c, i), i && l & 2048 && Cl(o.alternate, o);
					break;
				default: El(a, o, s, c, i);
			}
			t = t.sibling;
		}
	}
	function Dl(e, t) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) {
			var n = e, r = t, i = r.flags;
			switch (r.tag) {
				case 22:
					Dl(n, r), i & 2048 && Sl(r.alternate, r);
					break;
				case 24:
					Dl(n, r), i & 2048 && Cl(r.alternate, r);
					break;
				default: Dl(n, r);
			}
			t = t.sibling;
		}
	}
	var Ol = 8192;
	function kl(e, t, n) {
		if (e.subtreeFlags & Ol) for (e = e.child; e !== null;) Al(e, t, n), e = e.sibling;
	}
	function Al(e, t, n) {
		switch (e.tag) {
			case 26:
				kl(e, t, n), e.flags & Ol && e.memoizedState !== null && Yf(n, hl, e.memoizedState, e.memoizedProps);
				break;
			case 5:
				kl(e, t, n);
				break;
			case 3:
			case 4:
				var r = hl;
				hl = bf(e.stateNode.containerInfo), kl(e, t, n), hl = r;
				break;
			case 22:
				e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Ol, Ol = 16777216, kl(e, t, n), Ol = r) : kl(e, t, n));
				break;
			default: kl(e, t, n);
		}
	}
	function jl(e) {
		var t = e.alternate;
		if (t !== null && (e = t.child, e !== null)) {
			t.child = null;
			do
				t = e.sibling, e.sibling = null, e = t;
			while (e !== null);
		}
	}
	function Ml(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				nl = r, Fl(r, e);
			}
			jl(e);
		}
		if (e.subtreeFlags & 10256) for (e = e.child; e !== null;) Nl(e), e = e.sibling;
	}
	function Nl(e) {
		switch (e.tag) {
			case 0:
			case 11:
			case 15:
				Ml(e), e.flags & 2048 && Bc(9, e, e.return);
				break;
			case 3:
				Ml(e);
				break;
			case 12:
				Ml(e);
				break;
			case 22:
				var t = e.stateNode;
				e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, Pl(e)) : Ml(e);
				break;
			default: Ml(e);
		}
	}
	function Pl(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				nl = r, Fl(r, e);
			}
			jl(e);
		}
		for (e = e.child; e !== null;) {
			switch (t = e, t.tag) {
				case 0:
				case 11:
				case 15:
					Bc(8, t, t.return), Pl(t);
					break;
				case 22:
					n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, Pl(t));
					break;
				default: Pl(t);
			}
			e = e.sibling;
		}
	}
	function Fl(e, t) {
		for (; nl !== null;) {
			var n = nl;
			switch (n.tag) {
				case 0:
				case 11:
				case 15:
					Bc(8, n, t);
					break;
				case 23:
				case 22:
					if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
						var r = n.memoizedState.cachePool.pool;
						r != null && r.refCount++;
					}
					break;
				case 24: ra(n.memoizedState.cache);
			}
			if (r = n.child, r !== null) r.return = n, nl = r;
			else a: for (n = e; nl !== null;) {
				r = nl;
				var i = r.sibling, a = r.return;
				if (al(r), r === n) {
					nl = null;
					break a;
				}
				if (i !== null) {
					i.return = a, nl = i;
					break a;
				}
				nl = a;
			}
		}
	}
	var Il = {
		getCacheForType: function(e) {
			var t = Yi(ta), n = t.data.get(e);
			return n === void 0 && (n = e(), t.data.set(e, n)), n;
		},
		cacheSignal: function() {
			return Yi(ta).controller.signal;
		}
	}, Ll = typeof WeakMap == "function" ? WeakMap : Map, Rl = 0, zl = null, Bl = null, Vl = 0, Hl = 0, Ul = null, Wl = !1, Gl = !1, Kl = !1, ql = 0, Jl = 0, Yl = 0, Xl = 0, Zl = 0, J = 0, Ql = 0, $l = null, eu = null, tu = !1, nu = 0, ru = 0, iu = Infinity, au = null, ou = null, Y = 0, su = null, cu = null, lu = 0, uu = 0, du = null, fu = null, pu = 0, mu = null;
	function hu() {
		return Rl & 2 && Vl !== 0 ? Vl & -Vl : I.T === null ? Qe() : pd();
	}
	function gu() {
		if (J === 0) if (!(Vl & 536870912) || Oi) {
			var e = Le;
			Le <<= 1, !(Le & 3932160) && (Le = 262144), J = e;
		} else J = 536870912;
		return e = Za.current, e !== null && (e.flags |= 32), J;
	}
	function _u(e, t, n) {
		(e === zl && (Hl === 2 || Hl === 9) || e.cancelPendingCommit !== null) && (wu(e, 0), xu(e, Vl, J, !1)), Ge(e, n), (!(Rl & 2) || e !== zl) && (e === zl && (!(Rl & 2) && (Xl |= n), Jl === 4 && xu(e, Vl, J, !1)), ad(e));
	}
	function vu(e, t, n) {
		if (Rl & 6) throw Error(i(327));
		var r = !n && (t & 127) == 0 && (t & e.expiredLanes) === 0 || Ve(e, t), a = r ? ju(e, t) : X(e, t, !0), o = r;
		do {
			if (a === 0) {
				Gl && !r && xu(e, t, 0, !1);
				break;
			} else {
				if (n = e.current.alternate, o && !bu(n)) {
					a = X(e, t, !1), o = !1;
					continue;
				}
				if (a === 2) {
					if (o = t, e.errorRecoveryDisabledLanes & o) var s = 0;
					else s = e.pendingLanes & -536870913, s = s === 0 ? s & 536870912 ? 536870912 : 0 : s;
					if (s !== 0) {
						t = s;
						a: {
							var c = e;
							a = $l;
							var l = c.current.memoizedState.isDehydrated;
							if (l && (wu(c, s).flags |= 256), s = X(c, s, !1), s !== 2) {
								if (Kl && !l) {
									c.errorRecoveryDisabledLanes |= o, Xl |= o, a = 4;
									break a;
								}
								o = eu, eu = a, o !== null && (eu === null ? eu = o : eu.push.apply(eu, o));
							}
							a = s;
						}
						if (o = !1, a !== 2) continue;
					}
				}
				if (a === 1) {
					wu(e, 0), xu(e, t, 0, !0);
					break;
				}
				a: {
					switch (r = e, o = a, o) {
						case 0:
						case 1: throw Error(i(345));
						case 4: if ((t & 4194048) !== t) break;
						case 6:
							xu(r, t, J, !Wl);
							break a;
						case 2:
							eu = null;
							break;
						case 3:
						case 5: break;
						default: throw Error(i(329));
					}
					if ((t & 62914560) === t && (a = nu + 300 - W(), 10 < a)) {
						if (xu(r, t, J, !Wl), Be(r, 0, !0) !== 0) break a;
						lu = t, r.timeoutHandle = Xd(yu.bind(null, r, n, eu, au, tu, t, J, Xl, Ql, Wl, o, "Throttled", -0, 0), a);
						break a;
					}
					yu(r, n, eu, au, tu, t, J, Xl, Ql, Wl, o, null, -0, 0);
				}
			}
			break;
		} while (1);
		ad(e);
	}
	function yu(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
		if (e.timeoutHandle = -1, d = t.subtreeFlags, d & 8192 || (d & 16785408) == 16785408) {
			d = {
				stylesheets: null,
				count: 0,
				imgCount: 0,
				imgBytes: 0,
				suspenseyImages: [],
				waitingForImages: !0,
				waitingForViewTransition: !1,
				unsuspend: qt
			}, Al(t, a, d);
			var m = (a & 62914560) === a ? nu - W() : (a & 4194048) === a ? ru - W() : 0;
			if (m = Zf(d, m), m !== null) {
				lu = a, e.cancelPendingCommit = m(Ru.bind(null, e, t, a, n, r, i, o, s, c, u, d, null, f, p)), xu(e, a, o, !l);
				return;
			}
		}
		Ru(e, t, a, n, r, i, o, s, c);
	}
	function bu(e) {
		for (var t = e;;) {
			var n = t.tag;
			if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
				var i = n[r], a = i.getSnapshot;
				i = i.value;
				try {
					if (!hr(a(), i)) return !1;
				} catch {
					return !1;
				}
			}
			if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
			else {
				if (t === e) break;
				for (; t.sibling === null;) {
					if (t.return === null || t.return === e) return !0;
					t = t.return;
				}
				t.sibling.return = t.return, t = t.sibling;
			}
		}
		return !0;
	}
	function xu(e, t, n, r) {
		t &= ~Zl, t &= ~Xl, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
		for (var i = t; 0 < i;) {
			var a = 31 - Me(i), o = 1 << a;
			r[a] = -1, i &= ~o;
		}
		n !== 0 && qe(e, n, t);
	}
	function Su() {
		return Rl & 6 ? !0 : (od(0, !1), !1);
	}
	function Cu() {
		if (Bl !== null) {
			if (Hl === 0) var e = Bl.return;
			else e = Bl, Vi = Bi = null, Eo(e), Ea = null, Da = 0, e = Bl;
			for (; e !== null;) Rc(e.alternate, e), e = e.return;
			Bl = null;
		}
	}
	function wu(e, t) {
		var n = e.timeoutHandle;
		n !== -1 && (e.timeoutHandle = -1, Zd(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), lu = 0, Cu(), zl = e, Bl = n = ri(e.current, null), Vl = t, Hl = 0, Ul = null, Wl = !1, Gl = Ve(e, t), Kl = !1, Ql = J = Zl = Xl = Yl = Jl = 0, eu = $l = null, tu = !1, t & 8 && (t |= t & 32);
		var r = e.entangledLanes;
		if (r !== 0) for (e = e.entanglements, r &= t; 0 < r;) {
			var i = 31 - Me(r), a = 1 << i;
			t |= e[i], r &= ~a;
		}
		return ql = t, qr(), n;
	}
	function Tu(e, t) {
		so = null, I.H = Is, t === ga || t === va ? (t = wa(), Hl = 3) : t === _a ? (t = wa(), Hl = 4) : Hl = t === ec ? 8 : typeof t == "object" && t && typeof t.then == "function" ? 6 : 1, Ul = t, Bl === null && (Jl = 1, Js(e, di(t, e.current)));
	}
	function Eu() {
		var e = Za.current;
		return e === null ? !0 : (Vl & 4194048) === Vl ? Qa === null : (Vl & 62914560) === Vl || Vl & 536870912 ? e === Qa : !1;
	}
	function Du() {
		var e = I.H;
		return I.H = Is, e === null ? Is : e;
	}
	function Ou() {
		var e = I.A;
		return I.A = Il, e;
	}
	function ku() {
		Jl = 4, Wl || (Vl & 4194048) !== Vl && Za.current !== null || (Gl = !0), !(Yl & 134217727) && !(Xl & 134217727) || zl === null || xu(zl, Vl, J, !1);
	}
	function X(e, t, n) {
		var r = Rl;
		Rl |= 2;
		var i = Du(), a = Ou();
		(zl !== e || Vl !== t) && (au = null, wu(e, t)), t = !1;
		var o = Jl;
		a: do
			try {
				if (Hl !== 0 && Bl !== null) {
					var s = Bl, c = Ul;
					switch (Hl) {
						case 8:
							Cu(), o = 6;
							break a;
						case 3:
						case 2:
						case 9:
						case 6:
							Za.current === null && (t = !0);
							var l = Hl;
							if (Hl = 0, Ul = null, Fu(e, s, c, l), n && Gl) {
								o = 0;
								break a;
							}
							break;
						default: l = Hl, Hl = 0, Ul = null, Fu(e, s, c, l);
					}
				}
				Au(), o = Jl;
				break;
			} catch (t) {
				Tu(e, t);
			}
		while (1);
		return t && e.shellSuspendCounter++, Vi = Bi = null, Rl = r, I.H = i, I.A = a, Bl === null && (zl = null, Vl = 0, qr()), o;
	}
	function Au() {
		for (; Bl !== null;) Nu(Bl);
	}
	function ju(e, t) {
		var n = Rl;
		Rl |= 2;
		var r = Du(), a = Ou();
		zl !== e || Vl !== t ? (au = null, iu = W() + 500, wu(e, t)) : Gl = Ve(e, t);
		a: do
			try {
				if (Hl !== 0 && Bl !== null) {
					t = Bl;
					var o = Ul;
					b: switch (Hl) {
						case 1:
							Hl = 0, Ul = null, Fu(e, t, o, 1);
							break;
						case 2:
						case 9:
							if (ba(o)) {
								Hl = 0, Ul = null, Pu(t);
								break;
							}
							t = function() {
								Hl !== 2 && Hl !== 9 || zl !== e || (Hl = 7), ad(e);
							}, o.then(t, t);
							break a;
						case 3:
							Hl = 7;
							break a;
						case 4:
							Hl = 5;
							break a;
						case 7:
							ba(o) ? (Hl = 0, Ul = null, Pu(t)) : (Hl = 0, Ul = null, Fu(e, t, o, 7));
							break;
						case 5:
							var s = null;
							switch (Bl.tag) {
								case 26: s = Bl.memoizedState;
								case 5:
								case 27:
									var c = Bl;
									if (s ? Jf(s) : c.stateNode.complete) {
										Hl = 0, Ul = null;
										var l = c.sibling;
										if (l !== null) Bl = l;
										else {
											var u = c.return;
											u === null ? Bl = null : (Bl = u, Iu(u));
										}
										break b;
									}
							}
							Hl = 0, Ul = null, Fu(e, t, o, 5);
							break;
						case 6:
							Hl = 0, Ul = null, Fu(e, t, o, 6);
							break;
						case 8:
							Cu(), Jl = 6;
							break a;
						default: throw Error(i(462));
					}
				}
				Mu();
				break;
			} catch (t) {
				Tu(e, t);
			}
		while (1);
		return Vi = Bi = null, I.H = r, I.A = a, Rl = n, Bl === null ? (zl = null, Vl = 0, qr(), Jl) : 0;
	}
	function Mu() {
		for (; Bl !== null && !U();) Nu(Bl);
	}
	function Nu(e) {
		var t = kc(e.alternate, e, ql);
		e.memoizedProps = e.pendingProps, t === null ? Iu(e) : Bl = t;
	}
	function Pu(e) {
		var t = e, n = t.alternate;
		switch (t.tag) {
			case 15:
			case 0:
				t = pc(n, t, t.pendingProps, t.type, void 0, Vl);
				break;
			case 11:
				t = pc(n, t, t.pendingProps, t.type.render, t.ref, Vl);
				break;
			case 5: Eo(t);
			default: Rc(n, t), t = Bl = ii(t, ql), t = kc(n, t, ql);
		}
		e.memoizedProps = e.pendingProps, t === null ? Iu(e) : Bl = t;
	}
	function Fu(e, t, n, r) {
		Vi = Bi = null, Eo(t), Ea = null, Da = 0;
		var i = t.return;
		try {
			if ($s(e, i, t, n, Vl)) {
				Jl = 1, Js(e, di(n, e.current)), Bl = null;
				return;
			}
		} catch (t) {
			if (i !== null) throw Bl = i, t;
			Jl = 1, Js(e, di(n, e.current)), Bl = null;
			return;
		}
		t.flags & 32768 ? (Oi || r === 1 ? e = !0 : Gl || Vl & 536870912 ? e = !1 : (Wl = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = Za.current, r !== null && r.tag === 13 && (r.flags |= 16384))), Lu(t, e)) : Iu(t);
	}
	function Iu(e) {
		var t = e;
		do {
			if (t.flags & 32768) {
				Lu(t, Wl);
				return;
			}
			e = t.return;
			var n = Ic(t.alternate, t, ql);
			if (n !== null) {
				Bl = n;
				return;
			}
			if (t = t.sibling, t !== null) {
				Bl = t;
				return;
			}
			Bl = t = e;
		} while (t !== null);
		Jl === 0 && (Jl = 5);
	}
	function Lu(e, t) {
		do {
			var n = Lc(e.alternate, e);
			if (n !== null) {
				n.flags &= 32767, Bl = n;
				return;
			}
			if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
				Bl = e;
				return;
			}
			Bl = e = n;
		} while (e !== null);
		Jl = 6, Bl = null;
	}
	function Ru(e, t, n, r, a, o, s, c, l) {
		e.cancelPendingCommit = null;
		do
			Uu();
		while (Y !== 0);
		if (Rl & 6) throw Error(i(327));
		if (t !== null) {
			if (t === e.current) throw Error(i(177));
			if (o = t.lanes | t.childLanes, o |= Kr, Ke(e, n, o, s, c, l), e === zl && (Bl = zl = null, Vl = 0), cu = t, su = e, lu = n, uu = o, du = a, fu = r, t.subtreeFlags & 10256 || t.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, Qu(we, function() {
				return Wu(), null;
			})) : (e.callbackNode = null, e.callbackPriority = 0), r = (t.flags & 13878) != 0, t.subtreeFlags & 13878 || r) {
				r = I.T, I.T = null, a = R.p, R.p = 2, s = Rl, Rl |= 4;
				try {
					rl(e, t, n);
				} finally {
					Rl = s, R.p = a, I.T = r;
				}
			}
			Y = 1, zu(), Bu(), Vu();
		}
	}
	function zu() {
		if (Y === 1) {
			Y = 0;
			var e = su, t = cu, n = (t.flags & 13878) != 0;
			if (t.subtreeFlags & 13878 || n) {
				n = I.T, I.T = null;
				var r = R.p;
				R.p = 2;
				var i = Rl;
				Rl |= 4;
				try {
					gl(t, e);
					var a = Ud, o = br(e.containerInfo), s = a.focusedElem, c = a.selectionRange;
					if (o !== s && s && s.ownerDocument && yr(s.ownerDocument.documentElement, s)) {
						if (c !== null && xr(s)) {
							var l = c.start, u = c.end;
							if (u === void 0 && (u = l), "selectionStart" in s) s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length);
							else {
								var d = s.ownerDocument || document, f = d && d.defaultView || window;
								if (f.getSelection) {
									var p = f.getSelection(), m = s.textContent.length, h = Math.min(c.start, m), g = c.end === void 0 ? h : Math.min(c.end, m);
									!p.extend && h > g && (o = g, g = h, h = o);
									var _ = vr(s, h), v = vr(s, g);
									if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
										var y = d.createRange();
										y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y));
									}
								}
							}
						}
						for (d = [], p = s; p = p.parentNode;) p.nodeType === 1 && d.push({
							element: p,
							left: p.scrollLeft,
							top: p.scrollTop
						});
						for (typeof s.focus == "function" && s.focus(), s = 0; s < d.length; s++) {
							var b = d[s];
							b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
						}
					}
					dp = !!Hd, Ud = Hd = null;
				} finally {
					Rl = i, R.p = r, I.T = n;
				}
			}
			e.current = t, Y = 2;
		}
	}
	function Bu() {
		if (Y === 2) {
			Y = 0;
			var e = su, t = cu, n = (t.flags & 8772) != 0;
			if (t.subtreeFlags & 8772 || n) {
				n = I.T, I.T = null;
				var r = R.p;
				R.p = 2;
				var i = Rl;
				Rl |= 4;
				try {
					il(e, t.alternate, t);
				} finally {
					Rl = i, R.p = r, I.T = n;
				}
			}
			Y = 3;
		}
	}
	function Vu() {
		if (Y === 4 || Y === 3) {
			Y = 0, be();
			var e = su, t = cu, n = lu, r = fu;
			t.subtreeFlags & 10256 || t.flags & 10256 ? Y = 5 : (Y = 0, cu = su = null, Hu(e, e.pendingLanes));
			var i = e.pendingLanes;
			if (i === 0 && (ou = null), Ze(n), t = t.stateNode, Ae && typeof Ae.onCommitFiberRoot == "function") try {
				Ae.onCommitFiberRoot(ke, t, void 0, (t.current.flags & 128) == 128);
			} catch {}
			if (r !== null) {
				t = I.T, i = R.p, R.p = 2, I.T = null;
				try {
					for (var a = e.onRecoverableError, o = 0; o < r.length; o++) {
						var s = r[o];
						a(s.value, { componentStack: s.stack });
					}
				} finally {
					I.T = t, R.p = i;
				}
			}
			lu & 3 && Uu(), ad(e), i = e.pendingLanes, n & 261930 && i & 42 ? e === mu ? pu++ : (pu = 0, mu = e) : pu = 0, od(0, !1);
		}
	}
	function Hu(e, t) {
		(e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, ra(t)));
	}
	function Uu() {
		return zu(), Bu(), Vu(), Wu();
	}
	function Wu() {
		if (Y !== 5) return !1;
		var e = su, t = uu;
		uu = 0;
		var n = Ze(lu), r = I.T, a = R.p;
		try {
			R.p = 32 > n ? 32 : n, I.T = null, n = du, du = null;
			var o = su, s = lu;
			if (Y = 0, cu = su = null, lu = 0, Rl & 6) throw Error(i(331));
			var c = Rl;
			if (Rl |= 4, Nl(o.current), Tl(o, o.current, s, n), Rl = c, od(0, !1), Ae && typeof Ae.onPostCommitFiberRoot == "function") try {
				Ae.onPostCommitFiberRoot(ke, o);
			} catch {}
			return !0;
		} finally {
			R.p = a, I.T = r, Hu(e, t);
		}
	}
	function Gu(e, t, n) {
		t = di(n, t), t = Xs(e.stateNode, t, 2), e = Ra(e, t, 2), e !== null && (Ge(e, 2), ad(e));
	}
	function Ku(e, t, n) {
		if (e.tag === 3) Gu(e, e, n);
		else for (; t !== null;) {
			if (t.tag === 3) {
				Gu(t, e, n);
				break;
			} else if (t.tag === 1) {
				var r = t.stateNode;
				if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (ou === null || !ou.has(r))) {
					e = di(n, e), n = Zs(2), r = Ra(t, n, 2), r !== null && (Qs(n, r, t, e), Ge(r, 2), ad(r));
					break;
				}
			}
			t = t.return;
		}
	}
	function qu(e, t, n) {
		var r = e.pingCache;
		if (r === null) {
			r = e.pingCache = new Ll();
			var i = /* @__PURE__ */ new Set();
			r.set(t, i);
		} else i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
		i.has(n) || (Kl = !0, i.add(n), e = Ju.bind(null, e, t, n), t.then(e, e));
	}
	function Ju(e, t, n) {
		var r = e.pingCache;
		r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, zl === e && (Vl & n) === n && (Jl === 4 || Jl === 3 && (Vl & 62914560) === Vl && 300 > W() - nu ? !(Rl & 2) && wu(e, 0) : Zl |= n, Ql === Vl && (Ql = 0)), ad(e);
	}
	function Yu(e, t) {
		t === 0 && (t = Ue()), e = Xr(e, t), e !== null && (Ge(e, t), ad(e));
	}
	function Xu(e) {
		var t = e.memoizedState, n = 0;
		t !== null && (n = t.retryLane), Yu(e, n);
	}
	function Zu(e, t) {
		var n = 0;
		switch (e.tag) {
			case 31:
			case 13:
				var r = e.stateNode, a = e.memoizedState;
				a !== null && (n = a.retryLane);
				break;
			case 19:
				r = e.stateNode;
				break;
			case 22:
				r = e.stateNode._retryCache;
				break;
			default: throw Error(i(314));
		}
		r !== null && r.delete(t), Yu(e, n);
	}
	function Qu(e, t) {
		return ve(e, t);
	}
	var $u = null, ed = null, td = !1, nd = !1, rd = !1, id = 0;
	function ad(e) {
		e !== ed && e.next === null && (ed === null ? $u = ed = e : ed = ed.next = e), nd = !0, td || (td = !0, fd());
	}
	function od(e, t) {
		if (!rd && nd) {
			rd = !0;
			do
				for (var n = !1, r = $u; r !== null;) {
					if (!t) if (e !== 0) {
						var i = r.pendingLanes;
						if (i === 0) var a = 0;
						else {
							var o = r.suspendedLanes, s = r.pingedLanes;
							a = (1 << 31 - Me(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0;
						}
						a !== 0 && (n = !0, dd(r, a));
					} else a = Vl, a = Be(r, r === zl ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1), !(a & 3) || Ve(r, a) || (n = !0, dd(r, a));
					r = r.next;
				}
			while (n);
			rd = !1;
		}
	}
	function sd() {
		cd();
	}
	function cd() {
		nd = td = !1;
		var e = 0;
		id !== 0 && Yd() && (e = id);
		for (var t = W(), n = null, r = $u; r !== null;) {
			var i = r.next, a = ld(r, t);
			a === 0 ? (r.next = null, n === null ? $u = i : n.next = i, i === null && (ed = n)) : (n = r, (e !== 0 || a & 3) && (nd = !0)), r = i;
		}
		Y !== 0 && Y !== 5 || od(e, !1), id !== 0 && (id = 0);
	}
	function ld(e, t) {
		for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a;) {
			var o = 31 - Me(a), s = 1 << o, c = i[o];
			c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = He(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s;
		}
		if (t = zl, n = Vl, n = Be(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r = e.callbackNode, n === 0 || e === t && (Hl === 2 || Hl === 9) || e.cancelPendingCommit !== null) return r !== null && r !== null && ye(r), e.callbackNode = null, e.callbackPriority = 0;
		if (!(n & 3) || Ve(e, n)) {
			if (t = n & -n, t === e.callbackPriority) return t;
			switch (r !== null && ye(r), Ze(n)) {
				case 2:
				case 8:
					n = Ce;
					break;
				case 32:
					n = we;
					break;
				case 268435456:
					n = Ee;
					break;
				default: n = we;
			}
			return r = ud.bind(null, e), n = ve(n, r), e.callbackPriority = t, e.callbackNode = n, t;
		}
		return r !== null && r !== null && ye(r), e.callbackPriority = 2, e.callbackNode = null, 2;
	}
	function ud(e, t) {
		if (Y !== 0 && Y !== 5) return e.callbackNode = null, e.callbackPriority = 0, null;
		var n = e.callbackNode;
		if (Uu() && e.callbackNode !== n) return null;
		var r = Vl;
		return r = Be(e, e === zl ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r === 0 ? null : (vu(e, r, t), ld(e, W()), e.callbackNode != null && e.callbackNode === n ? ud.bind(null, e) : null);
	}
	function dd(e, t) {
		if (Uu()) return null;
		vu(e, t, !0);
	}
	function fd() {
		$d(function() {
			Rl & 6 ? ve(Se, sd) : cd();
		});
	}
	function pd() {
		if (id === 0) {
			var e = oa;
			e === 0 && (e = Ie, Ie <<= 1, !(Ie & 261888) && (Ie = 256)), id = e;
		}
		return id;
	}
	function md(e) {
		return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : Kt("" + e);
	}
	function hd(e, t) {
		var n = t.ownerDocument.createElement("input");
		return n.name = t.name, n.value = t.value, e.id && n.setAttribute("form", e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
	}
	function gd(e, t, n, r, i) {
		if (t === "submit" && n && n.stateNode === i) {
			var a = md((i[nt] || null).action), o = r.submitter;
			o && (t = (t = o[nt] || null) ? md(t.formAction) : o.getAttribute("formAction"), t !== null && (a = t, o = null));
			var s = new mn("action", "action", null, r, i);
			e.push({
				event: s,
				listeners: [{
					instance: null,
					listener: function() {
						if (r.defaultPrevented) {
							if (id !== 0) {
								var e = o ? hd(i, o) : new FormData(i);
								Ss(n, {
									pending: !0,
									data: e,
									method: i.method,
									action: a
								}, null, e);
							}
						} else typeof a == "function" && (s.preventDefault(), e = o ? hd(i, o) : new FormData(i), Ss(n, {
							pending: !0,
							data: e,
							method: i.method,
							action: a
						}, a, e));
					},
					currentTarget: i
				}]
			});
		}
	}
	for (var _d = 0; _d < Vr.length; _d++) {
		var vd = Vr[_d];
		Hr(vd.toLowerCase(), "on" + (vd[0].toUpperCase() + vd.slice(1)));
	}
	Hr(Nr, "onAnimationEnd"), Hr(Pr, "onAnimationIteration"), Hr(Fr, "onAnimationStart"), Hr("dblclick", "onDoubleClick"), Hr("focusin", "onFocus"), Hr("focusout", "onBlur"), Hr(Ir, "onTransitionRun"), Hr(Lr, "onTransitionStart"), Hr(Rr, "onTransitionCancel"), Hr(zr, "onTransitionEnd"), _t("onMouseEnter", ["mouseout", "mouseover"]), _t("onMouseLeave", ["mouseout", "mouseover"]), _t("onPointerEnter", ["pointerout", "pointerover"]), _t("onPointerLeave", ["pointerout", "pointerover"]), gt("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), gt("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), gt("onBeforeInput", [
		"compositionend",
		"keypress",
		"textInput",
		"paste"
	]), gt("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), gt("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), gt("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
	var yd = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bd = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(yd));
	function xd(e, t) {
		t = (t & 4) != 0;
		for (var n = 0; n < e.length; n++) {
			var r = e[n], i = r.event;
			r = r.listeners;
			a: {
				var a = void 0;
				if (t) for (var o = r.length - 1; 0 <= o; o--) {
					var s = r[o], c = s.instance, l = s.currentTarget;
					if (s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						Ur(e);
					}
					i.currentTarget = null, a = c;
				}
				else for (o = 0; o < r.length; o++) {
					if (s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						Ur(e);
					}
					i.currentTarget = null, a = c;
				}
			}
		}
	}
	function Sd(e, t) {
		var n = t[it];
		n === void 0 && (n = t[it] = /* @__PURE__ */ new Set());
		var r = e + "__bubble";
		n.has(r) || (Ed(t, e, 2, !1), n.add(r));
	}
	function Cd(e, t, n) {
		var r = 0;
		t && (r |= 4), Ed(n, e, r, t);
	}
	var wd = "_reactListening" + Math.random().toString(36).slice(2);
	function Td(e) {
		if (!e[wd]) {
			e[wd] = !0, mt.forEach(function(t) {
				t !== "selectionchange" && (bd.has(t) || Cd(t, !1, e), Cd(t, !0, e));
			});
			var t = e.nodeType === 9 ? e : e.ownerDocument;
			t === null || t[wd] || (t[wd] = !0, Cd("selectionchange", !1, t));
		}
	}
	function Ed(e, t, n, r) {
		switch (vp(t)) {
			case 2:
				var i = fp;
				break;
			case 8:
				i = pp;
				break;
			default: i = mp;
		}
		n = i.bind(null, t, n, e), i = void 0, !rn || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
			capture: !0,
			passive: i
		}) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, { passive: i });
	}
	function Dd(e, t, n, r, i) {
		var a = r;
		if (!(t & 1) && !(t & 2) && r !== null) a: for (;;) {
			if (r === null) return;
			var s = r.tag;
			if (s === 3 || s === 4) {
				var c = r.stateNode.containerInfo;
				if (c === i) break;
				if (s === 4) for (s = r.return; s !== null;) {
					var l = s.tag;
					if ((l === 3 || l === 4) && s.stateNode.containerInfo === i) return;
					s = s.return;
				}
				for (; c !== null;) {
					if (s = lt(c), s === null) return;
					if (l = s.tag, l === 5 || l === 6 || l === 26 || l === 27) {
						r = a = s;
						continue a;
					}
					c = c.parentNode;
				}
			}
			r = r.return;
		}
		en(function() {
			var r = a, i = Yt(n), s = [];
			a: {
				var c = Br.get(e);
				if (c !== void 0) {
					var l = mn, u = e;
					switch (e) {
						case "keypress": if (un(n) === 0) break a;
						case "keydown":
						case "keyup":
							l = Mn;
							break;
						case "focusin":
							u = "focus", l = Cn;
							break;
						case "focusout":
							u = "blur", l = Cn;
							break;
						case "beforeblur":
						case "afterblur":
							l = Cn;
							break;
						case "click": if (n.button === 2) break a;
						case "auxclick":
						case "dblclick":
						case "mousedown":
						case "mousemove":
						case "mouseup":
						case "mouseout":
						case "mouseover":
						case "contextmenu":
							l = xn;
							break;
						case "drag":
						case "dragend":
						case "dragenter":
						case "dragexit":
						case "dragleave":
						case "dragover":
						case "dragstart":
						case "drop":
							l = Sn;
							break;
						case "touchcancel":
						case "touchend":
						case "touchmove":
						case "touchstart":
							l = Pn;
							break;
						case Nr:
						case Pr:
						case Fr:
							l = wn;
							break;
						case zr:
							l = Fn;
							break;
						case "scroll":
						case "scrollend":
							l = gn;
							break;
						case "wheel":
							l = In;
							break;
						case "copy":
						case "cut":
						case "paste":
							l = Tn;
							break;
						case "gotpointercapture":
						case "lostpointercapture":
						case "pointercancel":
						case "pointerdown":
						case "pointermove":
						case "pointerout":
						case "pointerover":
						case "pointerup":
							l = Nn;
							break;
						case "toggle":
						case "beforetoggle": l = Ln;
					}
					var d = (t & 4) != 0, f = !d && (e === "scroll" || e === "scrollend"), p = d ? c === null ? null : c + "Capture" : c;
					d = [];
					for (var m = r, h; m !== null;) {
						var g = m;
						if (h = g.stateNode, g = g.tag, g !== 5 && g !== 26 && g !== 27 || h === null || p === null || (g = tn(m, p), g != null && d.push(Od(m, g, h))), f) break;
						m = m.return;
					}
					0 < d.length && (c = new l(c, u, null, n, i), s.push({
						event: c,
						listeners: d
					}));
				}
			}
			if (!(t & 7)) {
				a: {
					if (c = e === "mouseover" || e === "pointerover", l = e === "mouseout" || e === "pointerout", c && n !== Jt && (u = n.relatedTarget || n.fromElement) && (lt(u) || u[rt])) break a;
					if ((l || c) && (c = i.window === i ? i : (c = i.ownerDocument) ? c.defaultView || c.parentWindow : window, l ? (u = n.relatedTarget || n.toElement, l = r, u = u ? lt(u) : null, u !== null && (f = o(u), d = u.tag, u !== f || d !== 5 && d !== 27 && d !== 6) && (u = null)) : (l = null, u = r), l !== u)) {
						if (d = xn, g = "onMouseLeave", p = "onMouseEnter", m = "mouse", (e === "pointerout" || e === "pointerover") && (d = Nn, g = "onPointerLeave", p = "onPointerEnter", m = "pointer"), f = l == null ? c : dt(l), h = u == null ? c : dt(u), c = new d(g, m + "leave", l, n, i), c.target = f, c.relatedTarget = h, g = null, lt(i) === r && (d = new d(p, m + "enter", u, n, i), d.target = h, d.relatedTarget = f, g = d), f = g, l && u) b: {
							for (d = Ad, p = l, m = u, h = 0, g = p; g; g = d(g)) h++;
							g = 0;
							for (var _ = m; _; _ = d(_)) g++;
							for (; 0 < h - g;) p = d(p), h--;
							for (; 0 < g - h;) m = d(m), g--;
							for (; h--;) {
								if (p === m || m !== null && p === m.alternate) {
									d = p;
									break b;
								}
								p = d(p), m = d(m);
							}
							d = null;
						}
						else d = null;
						l !== null && jd(s, c, l, d, !1), u !== null && f !== null && jd(s, f, u, d, !0);
					}
				}
				a: {
					if (c = r ? dt(r) : window, l = c.nodeName && c.nodeName.toLowerCase(), l === "select" || l === "input" && c.type === "file") var v = rr;
					else if (Zn(c)) if (ir) v = pr;
					else {
						v = dr;
						var y = ur;
					}
					else l = c.nodeName, !l || l.toLowerCase() !== "input" || c.type !== "checkbox" && c.type !== "radio" ? r && Ut(r.elementType) && (v = rr) : v = fr;
					if (v &&= v(e, r)) {
						Qn(s, v, n, i);
						break a;
					}
					y && y(e, c, r), e === "focusout" && r && c.type === "number" && r.memoizedProps.value != null && Ft(c, "number", c.value);
				}
				switch (y = r ? dt(r) : window, e) {
					case "focusin":
						(Zn(y) || y.contentEditable === "true") && (Cr = y, wr = r, Tr = null);
						break;
					case "focusout":
						Tr = wr = Cr = null;
						break;
					case "mousedown":
						Er = !0;
						break;
					case "contextmenu":
					case "mouseup":
					case "dragend":
						Er = !1, Dr(s, n, i);
						break;
					case "selectionchange": if (Sr) break;
					case "keydown":
					case "keyup": Dr(s, n, i);
				}
				var b;
				if (zn) b: {
					switch (e) {
						case "compositionstart":
							var x = "onCompositionStart";
							break b;
						case "compositionend":
							x = "onCompositionEnd";
							break b;
						case "compositionupdate":
							x = "onCompositionUpdate";
							break b;
					}
					x = void 0;
				}
				else qn ? Gn(e, n) && (x = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (x = "onCompositionStart");
				x && (Hn && n.locale !== "ko" && (qn || x !== "onCompositionStart" ? x === "onCompositionEnd" && qn && (b = ln()) : (on = i, sn = "value" in on ? on.value : on.textContent, qn = !0)), y = kd(r, x), 0 < y.length && (x = new En(x, e, null, n, i), s.push({
					event: x,
					listeners: y
				}), b ? x.data = b : (b = Kn(n), b !== null && (x.data = b)))), (b = Vn ? Jn(e, n) : Yn(e, n)) && (x = kd(r, "onBeforeInput"), 0 < x.length && (y = new En("onBeforeInput", "beforeinput", null, n, i), s.push({
					event: y,
					listeners: x
				}), y.data = b)), gd(s, e, r, n, i);
			}
			xd(s, t);
		});
	}
	function Od(e, t, n) {
		return {
			instance: e,
			listener: t,
			currentTarget: n
		};
	}
	function kd(e, t) {
		for (var n = t + "Capture", r = []; e !== null;) {
			var i = e, a = i.stateNode;
			if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = tn(e, n), i != null && r.unshift(Od(e, i, a)), i = tn(e, t), i != null && r.push(Od(e, i, a))), e.tag === 3) return r;
			e = e.return;
		}
		return [];
	}
	function Ad(e) {
		if (e === null) return null;
		do
			e = e.return;
		while (e && e.tag !== 5 && e.tag !== 27);
		return e || null;
	}
	function jd(e, t, n, r, i) {
		for (var a = t._reactName, o = []; n !== null && n !== r;) {
			var s = n, c = s.alternate, l = s.stateNode;
			if (s = s.tag, c !== null && c === r) break;
			s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = tn(n, a), l != null && o.unshift(Od(n, l, c))) : i || (l = tn(n, a), l != null && o.push(Od(n, l, c)))), n = n.return;
		}
		o.length !== 0 && e.push({
			event: t,
			listeners: o
		});
	}
	var Md = /\r\n?/g, Nd = /\u0000|\uFFFD/g;
	function Pd(e) {
		return (typeof e == "string" ? e : "" + e).replace(Md, "\n").replace(Nd, "");
	}
	function Fd(e, t) {
		return t = Pd(t), Pd(e) === t;
	}
	function Id(e, t, n, r, a, o) {
		switch (n) {
			case "children":
				typeof r == "string" ? t === "body" || t === "textarea" && r === "" || zt(e, r) : (typeof r == "number" || typeof r == "bigint") && t !== "body" && zt(e, "" + r);
				break;
			case "className":
				Ct(e, "class", r);
				break;
			case "tabIndex":
				Ct(e, "tabindex", r);
				break;
			case "dir":
			case "role":
			case "viewBox":
			case "width":
			case "height":
				Ct(e, n, r);
				break;
			case "style":
				Ht(e, r, o);
				break;
			case "data": if (t !== "object") {
				Ct(e, "data", r);
				break;
			}
			case "src":
			case "href":
				if (r === "" && (t !== "a" || n !== "href")) {
					e.removeAttribute(n);
					break;
				}
				if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = Kt("" + r), e.setAttribute(n, r);
				break;
			case "action":
			case "formAction":
				if (typeof r == "function") {
					e.setAttribute(n, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
					break;
				} else typeof o == "function" && (n === "formAction" ? (t !== "input" && Id(e, t, "name", a.name, a, null), Id(e, t, "formEncType", a.formEncType, a, null), Id(e, t, "formMethod", a.formMethod, a, null), Id(e, t, "formTarget", a.formTarget, a, null)) : (Id(e, t, "encType", a.encType, a, null), Id(e, t, "method", a.method, a, null), Id(e, t, "target", a.target, a, null)));
				if (r == null || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = Kt("" + r), e.setAttribute(n, r);
				break;
			case "onClick":
				r != null && (e.onclick = qt);
				break;
			case "onScroll":
				r != null && Sd("scroll", e);
				break;
			case "onScrollEnd":
				r != null && Sd("scrollend", e);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "multiple":
				e.multiple = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "muted":
				e.muted = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "defaultValue":
			case "defaultChecked":
			case "innerHTML":
			case "ref": break;
			case "autoFocus": break;
			case "xlinkHref":
				if (r == null || typeof r == "function" || typeof r == "boolean" || typeof r == "symbol") {
					e.removeAttribute("xlink:href");
					break;
				}
				n = Kt("" + r), e.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n);
				break;
			case "contentEditable":
			case "spellCheck":
			case "draggable":
			case "value":
			case "autoReverse":
			case "externalResourcesRequired":
			case "focusable":
			case "preserveAlpha":
				r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "" + r) : e.removeAttribute(n);
				break;
			case "inert":
			case "allowFullScreen":
			case "async":
			case "autoPlay":
			case "controls":
			case "default":
			case "defer":
			case "disabled":
			case "disablePictureInPicture":
			case "disableRemotePlayback":
			case "formNoValidate":
			case "hidden":
			case "loop":
			case "noModule":
			case "noValidate":
			case "open":
			case "playsInline":
			case "readOnly":
			case "required":
			case "reversed":
			case "scoped":
			case "seamless":
			case "itemScope":
				r && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "") : e.removeAttribute(n);
				break;
			case "capture":
			case "download":
				!0 === r ? e.setAttribute(n, "") : !1 !== r && r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "cols":
			case "rows":
			case "size":
			case "span":
				r != null && typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "rowSpan":
			case "start":
				r == null || typeof r == "function" || typeof r == "symbol" || isNaN(r) ? e.removeAttribute(n) : e.setAttribute(n, r);
				break;
			case "popover":
				Sd("beforetoggle", e), Sd("toggle", e), St(e, "popover", r);
				break;
			case "xlinkActuate":
				wt(e, "http://www.w3.org/1999/xlink", "xlink:actuate", r);
				break;
			case "xlinkArcrole":
				wt(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", r);
				break;
			case "xlinkRole":
				wt(e, "http://www.w3.org/1999/xlink", "xlink:role", r);
				break;
			case "xlinkShow":
				wt(e, "http://www.w3.org/1999/xlink", "xlink:show", r);
				break;
			case "xlinkTitle":
				wt(e, "http://www.w3.org/1999/xlink", "xlink:title", r);
				break;
			case "xlinkType":
				wt(e, "http://www.w3.org/1999/xlink", "xlink:type", r);
				break;
			case "xmlBase":
				wt(e, "http://www.w3.org/XML/1998/namespace", "xml:base", r);
				break;
			case "xmlLang":
				wt(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", r);
				break;
			case "xmlSpace":
				wt(e, "http://www.w3.org/XML/1998/namespace", "xml:space", r);
				break;
			case "is":
				St(e, "is", r);
				break;
			case "innerText":
			case "textContent": break;
			default: (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = Wt.get(n) || n, St(e, n, r));
		}
	}
	function Ld(e, t, n, r, a, o) {
		switch (n) {
			case "style":
				Ht(e, r, o);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "children":
				typeof r == "string" ? zt(e, r) : (typeof r == "number" || typeof r == "bigint") && zt(e, "" + r);
				break;
			case "onScroll":
				r != null && Sd("scroll", e);
				break;
			case "onScrollEnd":
				r != null && Sd("scrollend", e);
				break;
			case "onClick":
				r != null && (e.onclick = qt);
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "innerHTML":
			case "ref": break;
			case "innerText":
			case "textContent": break;
			default: if (!ht.hasOwnProperty(n)) a: {
				if (n[0] === "o" && n[1] === "n" && (a = n.endsWith("Capture"), t = n.slice(2, a ? n.length - 7 : void 0), o = e[nt] || null, o = o == null ? null : o[n], typeof o == "function" && e.removeEventListener(t, o, a), typeof r == "function")) {
					typeof o != "function" && o !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, r, a);
					break a;
				}
				n in e ? e[n] = r : !0 === r ? e.setAttribute(n, "") : St(e, n, r);
			}
		}
	}
	function Rd(e, t, n) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "img":
				Sd("error", e), Sd("load", e);
				var r = !1, a = !1, o;
				for (o in n) if (n.hasOwnProperty(o)) {
					var s = n[o];
					if (s != null) switch (o) {
						case "src":
							r = !0;
							break;
						case "srcSet":
							a = !0;
							break;
						case "children":
						case "dangerouslySetInnerHTML": throw Error(i(137, t));
						default: Id(e, t, o, s, n, null);
					}
				}
				a && Id(e, t, "srcSet", n.srcSet, n, null), r && Id(e, t, "src", n.src, n, null);
				return;
			case "input":
				Sd("invalid", e);
				var c = o = s = a = null, l = null, u = null;
				for (r in n) if (n.hasOwnProperty(r)) {
					var d = n[r];
					if (d != null) switch (r) {
						case "name":
							a = d;
							break;
						case "type":
							s = d;
							break;
						case "checked":
							l = d;
							break;
						case "defaultChecked":
							u = d;
							break;
						case "value":
							o = d;
							break;
						case "defaultValue":
							c = d;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (d != null) throw Error(i(137, t));
							break;
						default: Id(e, t, r, d, n, null);
					}
				}
				Pt(e, o, c, l, u, s, a, !1);
				return;
			case "select":
				for (a in Sd("invalid", e), r = s = o = null, n) if (n.hasOwnProperty(a) && (c = n[a], c != null)) switch (a) {
					case "value":
						o = c;
						break;
					case "defaultValue":
						s = c;
						break;
					case "multiple": r = c;
					default: Id(e, t, a, c, n, null);
				}
				t = o, n = s, e.multiple = !!r, t == null ? n != null && It(e, !!r, n, !0) : It(e, !!r, t, !1);
				return;
			case "textarea":
				for (s in Sd("invalid", e), o = a = r = null, n) if (n.hasOwnProperty(s) && (c = n[s], c != null)) switch (s) {
					case "value":
						r = c;
						break;
					case "defaultValue":
						a = c;
						break;
					case "children":
						o = c;
						break;
					case "dangerouslySetInnerHTML":
						if (c != null) throw Error(i(91));
						break;
					default: Id(e, t, s, c, n, null);
				}
				Rt(e, r, a, o);
				return;
			case "option":
				for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
					case "selected":
						e.selected = r && typeof r != "function" && typeof r != "symbol";
						break;
					default: Id(e, t, l, r, n, null);
				}
				return;
			case "dialog":
				Sd("beforetoggle", e), Sd("toggle", e), Sd("cancel", e), Sd("close", e);
				break;
			case "iframe":
			case "object":
				Sd("load", e);
				break;
			case "video":
			case "audio":
				for (r = 0; r < yd.length; r++) Sd(yd[r], e);
				break;
			case "image":
				Sd("error", e), Sd("load", e);
				break;
			case "details":
				Sd("toggle", e);
				break;
			case "embed":
			case "source":
			case "link": Sd("error", e), Sd("load", e);
			case "area":
			case "base":
			case "br":
			case "col":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "track":
			case "wbr":
			case "menuitem":
				for (u in n) if (n.hasOwnProperty(u) && (r = n[u], r != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML": throw Error(i(137, t));
					default: Id(e, t, u, r, n, null);
				}
				return;
			default: if (Ut(t)) {
				for (d in n) n.hasOwnProperty(d) && (r = n[d], r !== void 0 && Ld(e, t, d, r, n, void 0));
				return;
			}
		}
		for (c in n) n.hasOwnProperty(c) && (r = n[c], r != null && Id(e, t, c, r, n, null));
	}
	function zd(e, t, n, r) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "input":
				var a = null, o = null, s = null, c = null, l = null, u = null, d = null;
				for (m in n) {
					var f = n[m];
					if (n.hasOwnProperty(m) && f != null) switch (m) {
						case "checked": break;
						case "value": break;
						case "defaultValue": l = f;
						default: r.hasOwnProperty(m) || Id(e, t, m, null, r, f);
					}
				}
				for (var p in r) {
					var m = r[p];
					if (f = n[p], r.hasOwnProperty(p) && (m != null || f != null)) switch (p) {
						case "type":
							o = m;
							break;
						case "name":
							a = m;
							break;
						case "checked":
							u = m;
							break;
						case "defaultChecked":
							d = m;
							break;
						case "value":
							s = m;
							break;
						case "defaultValue":
							c = m;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (m != null) throw Error(i(137, t));
							break;
						default: m !== f && Id(e, t, p, m, r, f);
					}
				}
				Nt(e, s, c, l, u, d, o, a);
				return;
			case "select":
				for (o in m = s = c = p = null, n) if (l = n[o], n.hasOwnProperty(o) && l != null) switch (o) {
					case "value": break;
					case "multiple": m = l;
					default: r.hasOwnProperty(o) || Id(e, t, o, null, r, l);
				}
				for (a in r) if (o = r[a], l = n[a], r.hasOwnProperty(a) && (o != null || l != null)) switch (a) {
					case "value":
						p = o;
						break;
					case "defaultValue":
						c = o;
						break;
					case "multiple": s = o;
					default: o !== l && Id(e, t, a, o, r, l);
				}
				t = c, n = s, r = m, p == null ? !!r != !!n && (t == null ? It(e, !!n, n ? [] : "", !1) : It(e, !!n, t, !0)) : It(e, !!n, p, !1);
				return;
			case "textarea":
				for (c in m = p = null, n) if (a = n[c], n.hasOwnProperty(c) && a != null && !r.hasOwnProperty(c)) switch (c) {
					case "value": break;
					case "children": break;
					default: Id(e, t, c, null, r, a);
				}
				for (s in r) if (a = r[s], o = n[s], r.hasOwnProperty(s) && (a != null || o != null)) switch (s) {
					case "value":
						p = a;
						break;
					case "defaultValue":
						m = a;
						break;
					case "children": break;
					case "dangerouslySetInnerHTML":
						if (a != null) throw Error(i(91));
						break;
					default: a !== o && Id(e, t, s, a, r, o);
				}
				Lt(e, p, m);
				return;
			case "option":
				for (var h in n) if (p = n[h], n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h)) switch (h) {
					case "selected":
						e.selected = !1;
						break;
					default: Id(e, t, h, null, r, p);
				}
				for (l in r) if (p = r[l], m = n[l], r.hasOwnProperty(l) && p !== m && (p != null || m != null)) switch (l) {
					case "selected":
						e.selected = p && typeof p != "function" && typeof p != "symbol";
						break;
					default: Id(e, t, l, p, r, m);
				}
				return;
			case "img":
			case "link":
			case "area":
			case "base":
			case "br":
			case "col":
			case "embed":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "source":
			case "track":
			case "wbr":
			case "menuitem":
				for (var g in n) p = n[g], n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g) && Id(e, t, g, null, r, p);
				for (u in r) if (p = r[u], m = n[u], r.hasOwnProperty(u) && p !== m && (p != null || m != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML":
						if (p != null) throw Error(i(137, t));
						break;
					default: Id(e, t, u, p, r, m);
				}
				return;
			default: if (Ut(t)) {
				for (var _ in n) p = n[_], n.hasOwnProperty(_) && p !== void 0 && !r.hasOwnProperty(_) && Ld(e, t, _, void 0, r, p);
				for (d in r) p = r[d], m = n[d], !r.hasOwnProperty(d) || p === m || p === void 0 && m === void 0 || Ld(e, t, d, p, r, m);
				return;
			}
		}
		for (var v in n) p = n[v], n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v) && Id(e, t, v, null, r, p);
		for (f in r) p = r[f], m = n[f], !r.hasOwnProperty(f) || p === m || p == null && m == null || Id(e, t, f, p, r, m);
	}
	function Bd(e) {
		switch (e) {
			case "css":
			case "script":
			case "font":
			case "img":
			case "image":
			case "input":
			case "link": return !0;
			default: return !1;
		}
	}
	function Vd() {
		if (typeof performance.getEntriesByType == "function") {
			for (var e = 0, t = 0, n = performance.getEntriesByType("resource"), r = 0; r < n.length; r++) {
				var i = n[r], a = i.transferSize, o = i.initiatorType, s = i.duration;
				if (a && s && Bd(o)) {
					for (o = 0, s = i.responseEnd, r += 1; r < n.length; r++) {
						var c = n[r], l = c.startTime;
						if (l > s) break;
						var u = c.transferSize, d = c.initiatorType;
						u && Bd(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)));
					}
					if (--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e) break;
				}
			}
			if (0 < e) return t / e / 1e6;
		}
		return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
	}
	var Hd = null, Ud = null;
	function Wd(e) {
		return e.nodeType === 9 ? e : e.ownerDocument;
	}
	function Gd(e) {
		switch (e) {
			case "http://www.w3.org/2000/svg": return 1;
			case "http://www.w3.org/1998/Math/MathML": return 2;
			default: return 0;
		}
	}
	function Kd(e, t) {
		if (e === 0) switch (t) {
			case "svg": return 1;
			case "math": return 2;
			default: return 0;
		}
		return e === 1 && t === "foreignObject" ? 0 : e;
	}
	function qd(e, t) {
		return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
	}
	var Jd = null;
	function Yd() {
		var e = window.event;
		return e && e.type === "popstate" ? e === Jd ? !1 : (Jd = e, !0) : (Jd = null, !1);
	}
	var Xd = typeof setTimeout == "function" ? setTimeout : void 0, Zd = typeof clearTimeout == "function" ? clearTimeout : void 0, Qd = typeof Promise == "function" ? Promise : void 0, $d = typeof queueMicrotask == "function" ? queueMicrotask : Qd === void 0 ? Xd : function(e) {
		return Qd.resolve(null).then(e).catch(ef);
	};
	function ef(e) {
		setTimeout(function() {
			throw e;
		});
	}
	function tf(e) {
		return e === "head";
	}
	function nf(e, t) {
		var n = t, r = 0;
		do {
			var i = n.nextSibling;
			if (e.removeChild(n), i && i.nodeType === 8) if (n = i.data, n === "/$" || n === "/&") {
				if (r === 0) {
					e.removeChild(i), Lp(t);
					return;
				}
				r--;
			} else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&") r++;
			else if (n === "html") _f(e.ownerDocument.documentElement);
			else if (n === "head") {
				n = e.ownerDocument.head, _f(n);
				for (var a = n.firstChild; a;) {
					var o = a.nextSibling, s = a.nodeName;
					a[st] || s === "SCRIPT" || s === "STYLE" || s === "LINK" && a.rel.toLowerCase() === "stylesheet" || n.removeChild(a), a = o;
				}
			} else n === "body" && _f(e.ownerDocument.body);
			n = i;
		} while (n);
		Lp(t);
	}
	function rf(e, t) {
		var n = e;
		e = 0;
		do {
			var r = n.nextSibling;
			if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), r && r.nodeType === 8) if (n = r.data, n === "/$") {
				if (e === 0) break;
				e--;
			} else n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || e++;
			n = r;
		} while (n);
	}
	function af(e) {
		var t = e.firstChild;
		for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
			var n = t;
			switch (t = t.nextSibling, n.nodeName) {
				case "HTML":
				case "HEAD":
				case "BODY":
					af(n), ct(n);
					continue;
				case "SCRIPT":
				case "STYLE": continue;
				case "LINK": if (n.rel.toLowerCase() === "stylesheet") continue;
			}
			e.removeChild(n);
		}
	}
	function of(e, t, n, r) {
		for (; e.nodeType === 1;) {
			var i = n;
			if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
				if (!r && (e.nodeName !== "INPUT" || e.type !== "hidden")) break;
			} else if (!r) if (t === "input" && e.type === "hidden") {
				var a = i.name == null ? null : "" + i.name;
				if (i.type === "hidden" && e.getAttribute("name") === a) return e;
			} else return e;
			else if (!e[st]) switch (t) {
				case "meta":
					if (!e.hasAttribute("itemprop")) break;
					return e;
				case "link":
					if (a = e.getAttribute("rel"), a === "stylesheet" && e.hasAttribute("data-precedence") || a !== i.rel || e.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute("title") !== (i.title == null ? null : i.title)) break;
					return e;
				case "style":
					if (e.hasAttribute("data-precedence")) break;
					return e;
				case "script":
					if (a = e.getAttribute("src"), (a !== (i.src == null ? null : i.src) || e.getAttribute("type") !== (i.type == null ? null : i.type) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute("async") && !e.hasAttribute("itemprop")) break;
					return e;
				default: return e;
			}
			if (e = ff(e.nextSibling), e === null) break;
		}
		return null;
	}
	function sf(e, t, n) {
		if (t === "") return null;
		for (; e.nodeType !== 3;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !n || (e = ff(e.nextSibling), e === null)) return null;
		return e;
	}
	function cf(e, t) {
		for (; e.nodeType !== 8;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = ff(e.nextSibling), e === null)) return null;
		return e;
	}
	function lf(e) {
		return e.data === "$?" || e.data === "$~";
	}
	function uf(e) {
		return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
	}
	function df(e, t) {
		var n = e.ownerDocument;
		if (e.data === "$~") e._reactRetry = t;
		else if (e.data !== "$?" || n.readyState !== "loading") t();
		else {
			var r = function() {
				t(), n.removeEventListener("DOMContentLoaded", r);
			};
			n.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
		}
	}
	function ff(e) {
		for (; e != null; e = e.nextSibling) {
			var t = e.nodeType;
			if (t === 1 || t === 3) break;
			if (t === 8) {
				if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F") break;
				if (t === "/$" || t === "/&") return null;
			}
		}
		return e;
	}
	var pf = null;
	function mf(e) {
		e = e.nextSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "/$" || n === "/&") {
					if (t === 0) return ff(e.nextSibling);
					t--;
				} else n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || t++;
			}
			e = e.nextSibling;
		}
		return null;
	}
	function hf(e) {
		e = e.previousSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
					if (t === 0) return e;
					t--;
				} else n !== "/$" && n !== "/&" || t++;
			}
			e = e.previousSibling;
		}
		return null;
	}
	function gf(e, t, n) {
		switch (t = Wd(n), e) {
			case "html":
				if (e = t.documentElement, !e) throw Error(i(452));
				return e;
			case "head":
				if (e = t.head, !e) throw Error(i(453));
				return e;
			case "body":
				if (e = t.body, !e) throw Error(i(454));
				return e;
			default: throw Error(i(451));
		}
	}
	function _f(e) {
		for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
		ct(e);
	}
	var vf = /* @__PURE__ */ new Map(), yf = /* @__PURE__ */ new Set();
	function bf(e) {
		return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
	}
	var xf = R.d;
	R.d = {
		f: Sf,
		r: Cf,
		D: Ef,
		C: Df,
		L: Of,
		m: kf,
		X: jf,
		S: Af,
		M: Mf
	};
	function Sf() {
		var e = xf.f(), t = Su();
		return e || t;
	}
	function Cf(e) {
		var t = ut(e);
		t !== null && t.tag === 5 && t.type === "form" ? ws(t) : xf.r(e);
	}
	var wf = typeof document > "u" ? null : document;
	function Tf(e, t, n) {
		var r = wf;
		if (r && typeof t == "string" && t) {
			var i = Mt(t);
			i = "link[rel=\"" + e + "\"][href=\"" + i + "\"]", typeof n == "string" && (i += "[crossorigin=\"" + n + "\"]"), yf.has(i) || (yf.add(i), e = {
				rel: e,
				crossOrigin: n,
				href: t
			}, r.querySelector(i) === null && (t = r.createElement("link"), Rd(t, "link", e), pt(t), r.head.appendChild(t)));
		}
	}
	function Ef(e) {
		xf.D(e), Tf("dns-prefetch", e, null);
	}
	function Df(e, t) {
		xf.C(e, t), Tf("preconnect", e, t);
	}
	function Of(e, t, n) {
		xf.L(e, t, n);
		var r = wf;
		if (r && e && t) {
			var i = "link[rel=\"preload\"][as=\"" + Mt(t) + "\"]";
			t === "image" && n && n.imageSrcSet ? (i += "[imagesrcset=\"" + Mt(n.imageSrcSet) + "\"]", typeof n.imageSizes == "string" && (i += "[imagesizes=\"" + Mt(n.imageSizes) + "\"]")) : i += "[href=\"" + Mt(e) + "\"]";
			var a = i;
			switch (t) {
				case "style":
					a = Pf(e);
					break;
				case "script": a = Rf(e);
			}
			vf.has(a) || (e = f({
				rel: "preload",
				href: t === "image" && n && n.imageSrcSet ? void 0 : e,
				as: t
			}, n), vf.set(a, e), r.querySelector(i) !== null || t === "style" && r.querySelector(Ff(a)) || t === "script" && r.querySelector(zf(a)) || (t = r.createElement("link"), Rd(t, "link", e), pt(t), r.head.appendChild(t)));
		}
	}
	function kf(e, t) {
		xf.m(e, t);
		var n = wf;
		if (n && e) {
			var r = t && typeof t.as == "string" ? t.as : "script", i = "link[rel=\"modulepreload\"][as=\"" + Mt(r) + "\"][href=\"" + Mt(e) + "\"]", a = i;
			switch (r) {
				case "audioworklet":
				case "paintworklet":
				case "serviceworker":
				case "sharedworker":
				case "worker":
				case "script": a = Rf(e);
			}
			if (!vf.has(a) && (e = f({
				rel: "modulepreload",
				href: e
			}, t), vf.set(a, e), n.querySelector(i) === null)) {
				switch (r) {
					case "audioworklet":
					case "paintworklet":
					case "serviceworker":
					case "sharedworker":
					case "worker":
					case "script": if (n.querySelector(zf(a))) return;
				}
				r = n.createElement("link"), Rd(r, "link", e), pt(r), n.head.appendChild(r);
			}
		}
	}
	function Af(e, t, n) {
		xf.S(e, t, n);
		var r = wf;
		if (r && e) {
			var i = ft(r).hoistableStyles, a = Pf(e);
			t ||= "default";
			var o = i.get(a);
			if (!o) {
				var s = {
					loading: 0,
					preload: null
				};
				if (o = r.querySelector(Ff(a))) s.loading = 5;
				else {
					e = f({
						rel: "stylesheet",
						href: e,
						"data-precedence": t
					}, n), (n = vf.get(a)) && Hf(e, n);
					var c = o = r.createElement("link");
					pt(c), Rd(c, "link", e), c._p = new Promise(function(e, t) {
						c.onload = e, c.onerror = t;
					}), c.addEventListener("load", function() {
						s.loading |= 1;
					}), c.addEventListener("error", function() {
						s.loading |= 2;
					}), s.loading |= 4, Vf(o, t, r);
				}
				o = {
					type: "stylesheet",
					instance: o,
					count: 1,
					state: s
				}, i.set(a, o);
			}
		}
	}
	function jf(e, t) {
		xf.X(e, t);
		var n = wf;
		if (n && e) {
			var r = ft(n).hoistableScripts, i = Rf(e), a = r.get(i);
			a || (a = n.querySelector(zf(i)), a || (e = f({
				src: e,
				async: !0
			}, t), (t = vf.get(i)) && Uf(e, t), a = n.createElement("script"), pt(a), Rd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function Mf(e, t) {
		xf.M(e, t);
		var n = wf;
		if (n && e) {
			var r = ft(n).hoistableScripts, i = Rf(e), a = r.get(i);
			a || (a = n.querySelector(zf(i)), a || (e = f({
				src: e,
				async: !0,
				type: "module"
			}, t), (t = vf.get(i)) && Uf(e, t), a = n.createElement("script"), pt(a), Rd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function Nf(e, t, n, r) {
		var a = (a = ae.current) ? bf(a) : null;
		if (!a) throw Error(i(446));
		switch (e) {
			case "meta":
			case "title": return null;
			case "style": return typeof n.precedence == "string" && typeof n.href == "string" ? (t = Pf(n.href), n = ft(a).hoistableStyles, r = n.get(t), r || (r = {
				type: "style",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			case "link":
				if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
					e = Pf(n.href);
					var o = ft(a).hoistableStyles, s = o.get(e);
					if (s || (a = a.ownerDocument || a, s = {
						type: "stylesheet",
						instance: null,
						count: 0,
						state: {
							loading: 0,
							preload: null
						}
					}, o.set(e, s), (o = a.querySelector(Ff(e))) && !o._p && (s.instance = o, s.state.loading = 5), vf.has(e) || (n = {
						rel: "preload",
						as: "style",
						href: n.href,
						crossOrigin: n.crossOrigin,
						integrity: n.integrity,
						media: n.media,
						hrefLang: n.hrefLang,
						referrerPolicy: n.referrerPolicy
					}, vf.set(e, n), o || Lf(a, e, n, s.state))), t && r === null) throw Error(i(528, ""));
					return s;
				}
				if (t && r !== null) throw Error(i(529, ""));
				return null;
			case "script": return t = n.async, n = n.src, typeof n == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = Rf(n), n = ft(a).hoistableScripts, r = n.get(t), r || (r = {
				type: "script",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			default: throw Error(i(444, e));
		}
	}
	function Pf(e) {
		return "href=\"" + Mt(e) + "\"";
	}
	function Ff(e) {
		return "link[rel=\"stylesheet\"][" + e + "]";
	}
	function If(e) {
		return f({}, e, {
			"data-precedence": e.precedence,
			precedence: null
		});
	}
	function Lf(e, t, n, r) {
		e.querySelector("link[rel=\"preload\"][as=\"style\"][" + t + "]") ? r.loading = 1 : (t = e.createElement("link"), r.preload = t, t.addEventListener("load", function() {
			return r.loading |= 1;
		}), t.addEventListener("error", function() {
			return r.loading |= 2;
		}), Rd(t, "link", n), pt(t), e.head.appendChild(t));
	}
	function Rf(e) {
		return "[src=\"" + Mt(e) + "\"]";
	}
	function zf(e) {
		return "script[async]" + e;
	}
	function Bf(e, t, n) {
		if (t.count++, t.instance === null) switch (t.type) {
			case "style":
				var r = e.querySelector("style[data-href~=\"" + Mt(n.href) + "\"]");
				if (r) return t.instance = r, pt(r), r;
				var a = f({}, n, {
					"data-href": n.href,
					"data-precedence": n.precedence,
					href: null,
					precedence: null
				});
				return r = (e.ownerDocument || e).createElement("style"), pt(r), Rd(r, "style", a), Vf(r, n.precedence, e), t.instance = r;
			case "stylesheet":
				a = Pf(n.href);
				var o = e.querySelector(Ff(a));
				if (o) return t.state.loading |= 4, t.instance = o, pt(o), o;
				r = If(n), (a = vf.get(a)) && Hf(r, a), o = (e.ownerDocument || e).createElement("link"), pt(o);
				var s = o;
				return s._p = new Promise(function(e, t) {
					s.onload = e, s.onerror = t;
				}), Rd(o, "link", r), t.state.loading |= 4, Vf(o, n.precedence, e), t.instance = o;
			case "script": return o = Rf(n.src), (a = e.querySelector(zf(o))) ? (t.instance = a, pt(a), a) : (r = n, (a = vf.get(o)) && (r = f({}, n), Uf(r, a)), e = e.ownerDocument || e, a = e.createElement("script"), pt(a), Rd(a, "link", r), e.head.appendChild(a), t.instance = a);
			case "void": return null;
			default: throw Error(i(443, t.type));
		}
		else t.type === "stylesheet" && !(t.state.loading & 4) && (r = t.instance, t.state.loading |= 4, Vf(r, n.precedence, e));
		return t.instance;
	}
	function Vf(e, t, n) {
		for (var r = n.querySelectorAll("link[rel=\"stylesheet\"][data-precedence],style[data-precedence]"), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
			var s = r[o];
			if (s.dataset.precedence === t) a = s;
			else if (a !== i) break;
		}
		a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
	}
	function Hf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title;
	}
	function Uf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity;
	}
	var Wf = null;
	function Gf(e, t, n) {
		if (Wf === null) {
			var r = /* @__PURE__ */ new Map(), i = Wf = /* @__PURE__ */ new Map();
			i.set(n, r);
		} else i = Wf, r = i.get(n), r || (r = /* @__PURE__ */ new Map(), i.set(n, r));
		if (r.has(e)) return r;
		for (r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++) {
			var a = n[i];
			if (!(a[st] || a[tt] || e === "link" && a.getAttribute("rel") === "stylesheet") && a.namespaceURI !== "http://www.w3.org/2000/svg") {
				var o = a.getAttribute(t) || "";
				o = e + o;
				var s = r.get(o);
				s ? s.push(a) : r.set(o, [a]);
			}
		}
		return r;
	}
	function Kf(e, t, n) {
		e = e.ownerDocument || e, e.head.insertBefore(n, t === "title" ? e.querySelector("head > title") : null);
	}
	function qf(e, t, n) {
		if (n === 1 || t.itemProp != null) return !1;
		switch (e) {
			case "meta":
			case "title": return !0;
			case "style":
				if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") break;
				return !0;
			case "link":
				if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) break;
				switch (t.rel) {
					case "stylesheet": return e = t.disabled, typeof t.precedence == "string" && e == null;
					default: return !0;
				}
			case "script": if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string") return !0;
		}
		return !1;
	}
	function Jf(e) {
		return !(e.type === "stylesheet" && !(e.state.loading & 3));
	}
	function Yf(e, t, n, r) {
		if (n.type === "stylesheet" && (typeof r.media != "string" || !1 !== matchMedia(r.media).matches) && !(n.state.loading & 4)) {
			if (n.instance === null) {
				var i = Pf(r.href), a = t.querySelector(Ff(i));
				if (a) {
					t = a._p, typeof t == "object" && t && typeof t.then == "function" && (e.count++, e = Qf.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = a, pt(a);
					return;
				}
				a = t.ownerDocument || t, r = If(r), (i = vf.get(i)) && Hf(r, i), a = a.createElement("link"), pt(a);
				var o = a;
				o._p = new Promise(function(e, t) {
					o.onload = e, o.onerror = t;
				}), Rd(a, "link", r), n.instance = a;
			}
			e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && !(n.state.loading & 3) && (e.count++, n = Qf.bind(e), t.addEventListener("load", n), t.addEventListener("error", n));
		}
	}
	var Xf = 0;
	function Zf(e, t) {
		return e.stylesheets && e.count === 0 && ep(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(n) {
			var r = setTimeout(function() {
				if (e.stylesheets && ep(e, e.stylesheets), e.unsuspend) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, 6e4 + t);
			0 < e.imgBytes && Xf === 0 && (Xf = 62500 * Vd());
			var i = setTimeout(function() {
				if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && ep(e, e.stylesheets), e.unsuspend)) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, (e.imgBytes > Xf ? 50 : 800) + t);
			return e.unsuspend = n, function() {
				e.unsuspend = null, clearTimeout(r), clearTimeout(i);
			};
		} : null;
	}
	function Qf() {
		if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
			if (this.stylesheets) ep(this, this.stylesheets);
			else if (this.unsuspend) {
				var e = this.unsuspend;
				this.unsuspend = null, e();
			}
		}
	}
	var $f = null;
	function ep(e, t) {
		e.stylesheets = null, e.unsuspend !== null && (e.count++, $f = /* @__PURE__ */ new Map(), t.forEach(tp, e), $f = null, Qf.call(e));
	}
	function tp(e, t) {
		if (!(t.state.loading & 4)) {
			var n = $f.get(e);
			if (n) var r = n.get(null);
			else {
				n = /* @__PURE__ */ new Map(), $f.set(e, n);
				for (var i = e.querySelectorAll("link[data-precedence],style[data-precedence]"), a = 0; a < i.length; a++) {
					var o = i[a];
					(o.nodeName === "LINK" || o.getAttribute("media") !== "not all") && (n.set(o.dataset.precedence, o), r = o);
				}
				r && n.set(null, r);
			}
			i = t.instance, o = i.getAttribute("data-precedence"), a = n.get(o) || r, a === r && n.set(null, i), n.set(o, i), this.count++, r = Qf.bind(this), i.addEventListener("load", r), i.addEventListener("error", r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= 4;
		}
	}
	var np = {
		$$typeof: C,
		Provider: null,
		Consumer: null,
		_currentValue: ee,
		_currentValue2: ee,
		_threadCount: 0
	};
	function rp(e, t, n, r, i, a, o, s, c) {
		this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = We(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = We(0), this.hiddenUpdates = We(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.incompleteTransitions = /* @__PURE__ */ new Map();
	}
	function ip(e, t, n, r, i, a, o, s, c, l, u, d) {
		return e = new rp(e, t, n, o, c, l, u, d, s), t = 1, !0 === a && (t |= 24), a = ti(3, null, null, t), e.current = a, a.stateNode = e, t = na(), t.refCount++, e.pooledCache = t, t.refCount++, a.memoizedState = {
			element: r,
			isDehydrated: n,
			cache: t
		}, Fa(a), e;
	}
	function ap(e) {
		return e ? (e = $r, e) : $r;
	}
	function op(e, t, n, r, i, a) {
		i = ap(i), r.context === null ? r.context = i : r.pendingContext = i, r = La(t), r.payload = { element: n }, a = a === void 0 ? null : a, a !== null && (r.callback = a), n = Ra(e, r, t), n !== null && (_u(n, e, t), za(n, e, t));
	}
	function sp(e, t) {
		if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
			var n = e.retryLane;
			e.retryLane = n !== 0 && n < t ? n : t;
		}
	}
	function cp(e, t) {
		sp(e, t), (e = e.alternate) && sp(e, t);
	}
	function lp(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = Xr(e, 67108864);
			t !== null && _u(t, e, 67108864), cp(e, 67108864);
		}
	}
	function up(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = hu();
			t = Xe(t);
			var n = Xr(e, t);
			n !== null && _u(n, e, t), cp(e, t);
		}
	}
	var dp = !0;
	function fp(e, t, n, r) {
		var i = I.T;
		I.T = null;
		var a = R.p;
		try {
			R.p = 2, mp(e, t, n, r);
		} finally {
			R.p = a, I.T = i;
		}
	}
	function pp(e, t, n, r) {
		var i = I.T;
		I.T = null;
		var a = R.p;
		try {
			R.p = 8, mp(e, t, n, r);
		} finally {
			R.p = a, I.T = i;
		}
	}
	function mp(e, t, n, r) {
		if (dp) {
			var i = hp(r);
			if (i === null) Dd(e, t, r, gp, n), Dp(e, r);
			else if (kp(i, e, t, n, r)) r.stopPropagation();
			else if (Dp(e, r), t & 4 && -1 < Ep.indexOf(e)) {
				for (; i !== null;) {
					var a = ut(i);
					if (a !== null) switch (a.tag) {
						case 3:
							if (a = a.stateNode, a.current.memoizedState.isDehydrated) {
								var o = ze(a.pendingLanes);
								if (o !== 0) {
									var s = a;
									for (s.pendingLanes |= 2, s.entangledLanes |= 2; o;) {
										var c = 1 << 31 - Me(o);
										s.entanglements[1] |= c, o &= ~c;
									}
									ad(a), !(Rl & 6) && (iu = W() + 500, od(0, !1));
								}
							}
							break;
						case 31:
						case 13: s = Xr(a, 2), s !== null && _u(s, a, 2), Su(), cp(a, 2);
					}
					if (a = hp(r), a === null && Dd(e, t, r, gp, n), a === i) break;
					i = a;
				}
				i !== null && r.stopPropagation();
			} else Dd(e, t, r, null, n);
		}
	}
	function hp(e) {
		return e = Yt(e), _p(e);
	}
	var gp = null;
	function _p(e) {
		if (gp = null, e = lt(e), e !== null) {
			var t = o(e);
			if (t === null) e = null;
			else {
				var n = t.tag;
				if (n === 13) {
					if (e = s(t), e !== null) return e;
					e = null;
				} else if (n === 31) {
					if (e = c(t), e !== null) return e;
					e = null;
				} else if (n === 3) {
					if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
					e = null;
				} else t !== e && (e = null);
			}
		}
		return gp = e, null;
	}
	function vp(e) {
		switch (e) {
			case "beforetoggle":
			case "cancel":
			case "click":
			case "close":
			case "contextmenu":
			case "copy":
			case "cut":
			case "auxclick":
			case "dblclick":
			case "dragend":
			case "dragstart":
			case "drop":
			case "focusin":
			case "focusout":
			case "input":
			case "invalid":
			case "keydown":
			case "keypress":
			case "keyup":
			case "mousedown":
			case "mouseup":
			case "paste":
			case "pause":
			case "play":
			case "pointercancel":
			case "pointerdown":
			case "pointerup":
			case "ratechange":
			case "reset":
			case "resize":
			case "seeked":
			case "submit":
			case "toggle":
			case "touchcancel":
			case "touchend":
			case "touchstart":
			case "volumechange":
			case "change":
			case "selectionchange":
			case "textInput":
			case "compositionstart":
			case "compositionend":
			case "compositionupdate":
			case "beforeblur":
			case "afterblur":
			case "beforeinput":
			case "blur":
			case "fullscreenchange":
			case "focus":
			case "hashchange":
			case "popstate":
			case "select":
			case "selectstart": return 2;
			case "drag":
			case "dragenter":
			case "dragexit":
			case "dragleave":
			case "dragover":
			case "mousemove":
			case "mouseout":
			case "mouseover":
			case "pointermove":
			case "pointerout":
			case "pointerover":
			case "scroll":
			case "touchmove":
			case "wheel":
			case "mouseenter":
			case "mouseleave":
			case "pointerenter":
			case "pointerleave": return 8;
			case "message": switch (xe()) {
				case Se: return 2;
				case Ce: return 8;
				case we:
				case Te: return 32;
				case Ee: return 268435456;
				default: return 32;
			}
			default: return 32;
		}
	}
	var yp = !1, bp = null, xp = null, Sp = null, Cp = /* @__PURE__ */ new Map(), wp = /* @__PURE__ */ new Map(), Tp = [], Ep = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
	function Dp(e, t) {
		switch (e) {
			case "focusin":
			case "focusout":
				bp = null;
				break;
			case "dragenter":
			case "dragleave":
				xp = null;
				break;
			case "mouseover":
			case "mouseout":
				Sp = null;
				break;
			case "pointerover":
			case "pointerout":
				Cp.delete(t.pointerId);
				break;
			case "gotpointercapture":
			case "lostpointercapture": wp.delete(t.pointerId);
		}
	}
	function Op(e, t, n, r, i, a) {
		return e === null || e.nativeEvent !== a ? (e = {
			blockedOn: t,
			domEventName: n,
			eventSystemFlags: r,
			nativeEvent: a,
			targetContainers: [i]
		}, t !== null && (t = ut(t), t !== null && lp(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
	}
	function kp(e, t, n, r, i) {
		switch (t) {
			case "focusin": return bp = Op(bp, e, t, n, r, i), !0;
			case "dragenter": return xp = Op(xp, e, t, n, r, i), !0;
			case "mouseover": return Sp = Op(Sp, e, t, n, r, i), !0;
			case "pointerover":
				var a = i.pointerId;
				return Cp.set(a, Op(Cp.get(a) || null, e, t, n, r, i)), !0;
			case "gotpointercapture": return a = i.pointerId, wp.set(a, Op(wp.get(a) || null, e, t, n, r, i)), !0;
		}
		return !1;
	}
	function Ap(e) {
		var t = lt(e.target);
		if (t !== null) {
			var n = o(t);
			if (n !== null) {
				if (t = n.tag, t === 13) {
					if (t = s(n), t !== null) {
						e.blockedOn = t, $e(e.priority, function() {
							up(n);
						});
						return;
					}
				} else if (t === 31) {
					if (t = c(n), t !== null) {
						e.blockedOn = t, $e(e.priority, function() {
							up(n);
						});
						return;
					}
				} else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
					e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
					return;
				}
			}
		}
		e.blockedOn = null;
	}
	function jp(e) {
		if (e.blockedOn !== null) return !1;
		for (var t = e.targetContainers; 0 < t.length;) {
			var n = hp(e.nativeEvent);
			if (n === null) {
				n = e.nativeEvent;
				var r = new n.constructor(n.type, n);
				Jt = r, n.target.dispatchEvent(r), Jt = null;
			} else return t = ut(n), t !== null && lp(t), e.blockedOn = n, !1;
			t.shift();
		}
		return !0;
	}
	function Mp(e, t, n) {
		jp(e) && n.delete(t);
	}
	function Np() {
		yp = !1, bp !== null && jp(bp) && (bp = null), xp !== null && jp(xp) && (xp = null), Sp !== null && jp(Sp) && (Sp = null), Cp.forEach(Mp), wp.forEach(Mp);
	}
	function Pp(e, n) {
		e.blockedOn === n && (e.blockedOn = null, yp || (yp = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, Np)));
	}
	var Fp = null;
	function Ip(e) {
		Fp !== e && (Fp = e, t.unstable_scheduleCallback(t.unstable_NormalPriority, function() {
			Fp === e && (Fp = null);
			for (var t = 0; t < e.length; t += 3) {
				var n = e[t], r = e[t + 1], i = e[t + 2];
				if (typeof r != "function") {
					if (_p(r || n) === null) continue;
					break;
				}
				var a = ut(n);
				a !== null && (e.splice(t, 3), t -= 3, Ss(a, {
					pending: !0,
					data: i,
					method: n.method,
					action: r
				}, r, i));
			}
		}));
	}
	function Lp(e) {
		function t(t) {
			return Pp(t, e);
		}
		bp !== null && Pp(bp, e), xp !== null && Pp(xp, e), Sp !== null && Pp(Sp, e), Cp.forEach(t), wp.forEach(t);
		for (var n = 0; n < Tp.length; n++) {
			var r = Tp[n];
			r.blockedOn === e && (r.blockedOn = null);
		}
		for (; 0 < Tp.length && (n = Tp[0], n.blockedOn === null);) Ap(n), n.blockedOn === null && Tp.shift();
		if (n = (e.ownerDocument || e).$$reactFormReplay, n != null) for (r = 0; r < n.length; r += 3) {
			var i = n[r], a = n[r + 1], o = i[nt] || null;
			if (typeof a == "function") o || Ip(n);
			else if (o) {
				var s = null;
				if (a && a.hasAttribute("formAction")) {
					if (i = a, o = a[nt] || null) s = o.formAction;
					else if (_p(i) !== null) continue;
				} else s = o.action;
				typeof s == "function" ? n[r + 1] = s : (n.splice(r, 3), r -= 3), Ip(n);
			}
		}
	}
	function Rp() {
		function e(e) {
			e.canIntercept && e.info === "react-transition" && e.intercept({
				handler: function() {
					return new Promise(function(e) {
						return i = e;
					});
				},
				focusReset: "manual",
				scroll: "manual"
			});
		}
		function t() {
			i !== null && (i(), i = null), r || setTimeout(n, 20);
		}
		function n() {
			if (!r && !navigation.transition) {
				var e = navigation.currentEntry;
				e && e.url != null && navigation.navigate(e.url, {
					state: e.getState(),
					info: "react-transition",
					history: "replace"
				});
			}
		}
		if (typeof navigation == "object") {
			var r = !1, i = null;
			return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(n, 100), function() {
				r = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), i !== null && (i(), i = null);
			};
		}
	}
	function zp(e) {
		this._internalRoot = e;
	}
	Bp.prototype.render = zp.prototype.render = function(e) {
		var t = this._internalRoot;
		if (t === null) throw Error(i(409));
		var n = t.current;
		op(n, hu(), e, t, null, null);
	}, Bp.prototype.unmount = zp.prototype.unmount = function() {
		var e = this._internalRoot;
		if (e !== null) {
			this._internalRoot = null;
			var t = e.containerInfo;
			op(e.current, 2, null, e, null, null), Su(), t[rt] = null;
		}
	};
	function Bp(e) {
		this._internalRoot = e;
	}
	Bp.prototype.unstable_scheduleHydration = function(e) {
		if (e) {
			var t = Qe();
			e = {
				blockedOn: null,
				target: e,
				priority: t
			};
			for (var n = 0; n < Tp.length && t !== 0 && t < Tp[n].priority; n++);
			Tp.splice(n, 0, e), n === 0 && Ap(e);
		}
	};
	var Vp = n.version;
	if (Vp !== "19.2.6") throw Error(i(527, Vp, "19.2.6"));
	R.findDOMNode = function(e) {
		var t = e._reactInternals;
		if (t === void 0) throw typeof e.render == "function" ? Error(i(188)) : (e = Object.keys(e).join(","), Error(i(268, e)));
		return e = u(t), e = e === null ? null : d(e), e = e === null ? null : e.stateNode, e;
	};
	var Hp = {
		bundleType: 0,
		version: "19.2.6",
		rendererPackageName: "react-dom",
		currentDispatcherRef: I,
		reconcilerVersion: "19.2.6"
	};
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
		var Up = __REACT_DEVTOOLS_GLOBAL_HOOK__;
		if (!Up.isDisabled && Up.supportsFiber) try {
			ke = Up.inject(Hp), Ae = Up;
		} catch {}
	}
	e.createRoot = function(e, t) {
		if (!a(e)) throw Error(i(299));
		var n = !1, r = "", o = Gs, s = Ks, c = qs;
		return t != null && (!0 === t.unstable_strictMode && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (o = t.onUncaughtError), t.onCaughtError !== void 0 && (s = t.onCaughtError), t.onRecoverableError !== void 0 && (c = t.onRecoverableError)), t = ip(e, 1, !1, null, null, n, r, null, o, s, c, Rp), e[rt] = t.current, Td(e), new zp(t);
	};
})), C = /* @__PURE__ */ p(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = S();
})), w = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), T = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), E = (e) => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()), D = (e) => {
	let t = E(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, O = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}, k = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
	return !1;
}, A = /* @__PURE__ */ h(_(), 1), j = (0, A.createContext)({}), M = () => (0, A.useContext)(j), N = (0, A.forwardRef)(({ color: e, size: t, strokeWidth: n, absoluteStrokeWidth: r, className: i = "", children: a, iconNode: o, ...s }, c) => {
	let { size: l = 24, strokeWidth: u = 2, absoluteStrokeWidth: d = !1, color: f = "currentColor", className: p = "" } = M() ?? {}, m = r ?? d ? Number(n ?? u) * 24 / Number(t ?? l) : n ?? u;
	return (0, A.createElement)("svg", {
		ref: c,
		...O,
		width: t ?? l ?? O.width,
		height: t ?? l ?? O.height,
		stroke: e ?? f,
		strokeWidth: m,
		className: w("lucide", p, i),
		...!a && !k(s) && { "aria-hidden": "true" },
		...s
	}, [...o.map(([e, t]) => (0, A.createElement)(e, t)), ...Array.isArray(a) ? a : [a]]);
}), P = (e, t) => {
	let n = (0, A.forwardRef)(({ className: n, ...r }, i) => (0, A.createElement)(N, {
		ref: i,
		iconNode: t,
		className: w(`lucide-${T(D(e))}`, `lucide-${e}`, n),
		...r
	}));
	return n.displayName = D(e), n;
}, F = P("box", [
	["path", {
		d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
		key: "hh9hay"
	}],
	["path", {
		d: "m3.3 7 8.7 5 8.7-5",
		key: "g66t2b"
	}],
	["path", {
		d: "M12 22V12",
		key: "d0xqtd"
	}]
]), I = P("building-2", [
	["path", {
		d: "M10 12h4",
		key: "a56b0p"
	}],
	["path", {
		d: "M10 8h4",
		key: "1sr2af"
	}],
	["path", {
		d: "M14 21v-3a2 2 0 0 0-4 0v3",
		key: "1rgiei"
	}],
	["path", {
		d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2",
		key: "secmi2"
	}],
	["path", {
		d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16",
		key: "16ra0t"
	}]
]), R = P("check", [["path", {
	d: "M20 6 9 17l-5-5",
	key: "1gmf2c"
}]]), ee = P("chevron-down", [["path", {
	d: "m6 9 6 6 6-6",
	key: "qrunsl"
}]]), te = P("chevron-up", [["path", {
	d: "m18 15-6-6-6 6",
	key: "153udz"
}]]), ne = P("circle-check", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), z = P("circle", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}]]), B = P("crosshair", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["line", {
		x1: "22",
		x2: "18",
		y1: "12",
		y2: "12",
		key: "l9bcsi"
	}],
	["line", {
		x1: "6",
		x2: "2",
		y1: "12",
		y2: "12",
		key: "13hhkx"
	}],
	["line", {
		x1: "12",
		x2: "12",
		y1: "6",
		y2: "2",
		key: "10w3f3"
	}],
	["line", {
		x1: "12",
		x2: "12",
		y1: "22",
		y2: "18",
		key: "15g9kq"
	}]
]), V = P("download", [
	["path", {
		d: "M12 15V3",
		key: "m9g1x1"
	}],
	["path", {
		d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
		key: "ih7n3h"
	}],
	["path", {
		d: "m7 10 5 5 5-5",
		key: "brsn70"
	}]
]), re = P("hexagon", [["path", {
	d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
	key: "yt0hxn"
}]]), ie = P("info", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["path", {
		d: "M12 16v-4",
		key: "1dtifu"
	}],
	["path", {
		d: "M12 8h.01",
		key: "e9boi3"
	}]
]), ae = P("layers", [
	["path", {
		d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
		key: "zw3jo"
	}],
	["path", {
		d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
		key: "1wduqc"
	}],
	["path", {
		d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
		key: "kqbvx6"
	}]
]), oe = P("loader-circle", [["path", {
	d: "M21 12a9 9 0 1 1-6.219-8.56",
	key: "13zald"
}]]), se = P("map-pin", [["path", {
	d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
	key: "1r0f0z"
}], ["circle", {
	cx: "12",
	cy: "10",
	r: "3",
	key: "ilqhr7"
}]]), ce = P("map", [
	["path", {
		d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
		key: "169xi5"
	}],
	["path", {
		d: "M15 5.764v15",
		key: "1pn4in"
	}],
	["path", {
		d: "M9 3.236v15",
		key: "1uimfh"
	}]
]), le = P("mountain", [["path", {
	d: "m8 3 4 8 5-5 5 15H2L8 3z",
	key: "otkl63"
}]]), ue = P("mouse-pointer-2", [["path", {
	d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
	key: "edeuup"
}]]), de = P("octagon-x", [
	["path", {
		d: "m15 9-6 6",
		key: "1uzhvr"
	}],
	["path", {
		d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
		key: "2d38gg"
	}],
	["path", {
		d: "m9 9 6 6",
		key: "z0biqf"
	}]
]), fe = P("palette", [
	["path", {
		d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
		key: "e79jfc"
	}],
	["circle", {
		cx: "13.5",
		cy: "6.5",
		r: ".5",
		fill: "currentColor",
		key: "1okk4w"
	}],
	["circle", {
		cx: "17.5",
		cy: "10.5",
		r: ".5",
		fill: "currentColor",
		key: "f64h9f"
	}],
	["circle", {
		cx: "6.5",
		cy: "12.5",
		r: ".5",
		fill: "currentColor",
		key: "qy21gx"
	}],
	["circle", {
		cx: "8.5",
		cy: "7.5",
		r: ".5",
		fill: "currentColor",
		key: "fotxhn"
	}]
]), pe = P("pen-tool", [
	["path", {
		d: "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z",
		key: "nt11vn"
	}],
	["path", {
		d: "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18",
		key: "15qc1e"
	}],
	["path", {
		d: "m2.3 2.3 7.286 7.286",
		key: "1wuzzi"
	}],
	["circle", {
		cx: "11",
		cy: "11",
		r: "2",
		key: "xmgehs"
	}]
]), me = P("printer", [
	["path", {
		d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
		key: "143wyd"
	}],
	["path", {
		d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6",
		key: "1itne7"
	}],
	["rect", {
		x: "6",
		y: "14",
		width: "12",
		height: "8",
		rx: "1",
		key: "1ue0tg"
	}]
]), he = P("rectangle-horizontal", [["rect", {
	width: "20",
	height: "12",
	x: "2",
	y: "6",
	rx: "2",
	key: "9lu3g6"
}]]), ge = P("route", [
	["circle", {
		cx: "6",
		cy: "19",
		r: "3",
		key: "1kj8tv"
	}],
	["path", {
		d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15",
		key: "1d8sl"
	}],
	["circle", {
		cx: "18",
		cy: "5",
		r: "3",
		key: "gq8acd"
	}]
]), H = P("ruler", [
	["path", {
		d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
		key: "icamh8"
	}],
	["path", {
		d: "m14.5 12.5 2-2",
		key: "inckbg"
	}],
	["path", {
		d: "m11.5 9.5 2-2",
		key: "fmmyf7"
	}],
	["path", {
		d: "m8.5 6.5 2-2",
		key: "vc6u1g"
	}],
	["path", {
		d: "m17.5 15.5 2-2",
		key: "wo5hmg"
	}]
]), _e = P("search", [["path", {
	d: "m21 21-4.34-4.34",
	key: "14j7rj"
}], ["circle", {
	cx: "11",
	cy: "11",
	r: "8",
	key: "4ej97u"
}]]), ve = P("shield-check", [["path", {
	d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
	key: "oel41y"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), ye = P("square", [["rect", {
	width: "18",
	height: "18",
	x: "3",
	y: "3",
	rx: "2",
	key: "afitv7"
}]]), U = P("trees", [
	["path", {
		d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z",
		key: "1l6gj6"
	}],
	["path", {
		d: "M7 16v6",
		key: "1a82de"
	}],
	["path", {
		d: "M13 19v3",
		key: "13sx9i"
	}],
	["path", {
		d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
		key: "1sj9kv"
	}]
]), be = P("triangle-alert", [
	["path", {
		d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
		key: "wmoenq"
	}],
	["path", {
		d: "M12 9v4",
		key: "juzpu7"
	}],
	["path", {
		d: "M12 17h.01",
		key: "p32p05"
	}]
]), W = P("waves-horizontal", [
	["path", {
		d: "M2 12q2.5 2 5 0t5 0 5 0 5 0",
		key: "8ddzzs"
	}],
	["path", {
		d: "M2 19q2.5 2 5 0t5 0 5 0 5 0",
		key: "1wj4st"
	}],
	["path", {
		d: "M2 5q2.5 2 5 0t5 0 5 0 5 0",
		key: "69x50u"
	}]
]), xe = P("x", [["path", {
	d: "M18 6 6 18",
	key: "1bl5f8"
}], ["path", {
	d: "m6 6 12 12",
	key: "d8bk6v"
}]]), Se = C(), Ce = /* @__PURE__ */ h(x(), 1);
function we(e) {
	if (!e || typeof document > "u") return;
	let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
	n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
var Te = (e) => {
	switch (e) {
		case "success": return Oe;
		case "info": return Ae;
		case "warning": return ke;
		case "error": return je;
		default: return null;
	}
}, Ee = Array(12).fill(0), De = ({ visible: e, className: t }) => /* @__PURE__ */ A.createElement("div", {
	className: ["sonner-loading-wrapper", t].filter(Boolean).join(" "),
	"data-visible": e
}, /* @__PURE__ */ A.createElement("div", { className: "sonner-spinner" }, Ee.map((e, t) => /* @__PURE__ */ A.createElement("div", {
	className: "sonner-loading-bar",
	key: `spinner-bar-${t}`
})))), Oe = /* @__PURE__ */ A.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	height: "20",
	width: "20",
	"aria-hidden": "true"
}, /* @__PURE__ */ A.createElement("path", {
	fillRule: "evenodd",
	d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
	clipRule: "evenodd"
})), ke = /* @__PURE__ */ A.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	height: "20",
	width: "20",
	"aria-hidden": "true"
}, /* @__PURE__ */ A.createElement("path", {
	fillRule: "evenodd",
	d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
	clipRule: "evenodd"
})), Ae = /* @__PURE__ */ A.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	height: "20",
	width: "20",
	"aria-hidden": "true"
}, /* @__PURE__ */ A.createElement("path", {
	fillRule: "evenodd",
	d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
	clipRule: "evenodd"
})), je = /* @__PURE__ */ A.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	height: "20",
	width: "20",
	"aria-hidden": "true"
}, /* @__PURE__ */ A.createElement("path", {
	fillRule: "evenodd",
	d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
	clipRule: "evenodd"
})), Me = /* @__PURE__ */ A.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "12",
	height: "12",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: "1.5",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": "true"
}, /* @__PURE__ */ A.createElement("line", {
	x1: "18",
	y1: "6",
	x2: "6",
	y2: "18"
}), /* @__PURE__ */ A.createElement("line", {
	x1: "6",
	y1: "6",
	x2: "18",
	y2: "18"
})), Ne = () => {
	let [e, t] = A.useState(document.hidden);
	return A.useEffect(() => {
		let e = () => {
			t(document.hidden);
		};
		return document.addEventListener("visibilitychange", e), () => document.removeEventListener("visibilitychange", e);
	}, []), e;
}, Pe = 1, Fe = 100, Ie = (e) => typeof e?.id == "number" || e?.id?.length > 0 ? e.id : Pe++, Le = new class {
	constructor() {
		this.subscribe = (e) => (this.subscribers.push(e), this.getActiveToasts().forEach((t) => e(t)), () => {
			let t = this.subscribers.indexOf(e);
			this.subscribers.splice(t, 1);
		}), this.publish = (e) => {
			this.subscribers.forEach((t) => t(e));
		}, this.addToast = (e) => {
			this.publish(e), this.toasts = [...this.toasts, e], this.trimHistory();
		}, this.trimHistory = () => {
			let e = this.toasts.length - Fe;
			e <= 0 || (this.toasts = this.toasts.filter((t) => e > 0 && this.dismissedToasts.has(t.id) ? (this.dismissedToasts.delete(t.id), e--, !1) : !0));
		}, this.create = (e) => {
			let { message: t, ...n } = e, r = Ie(e), i = this.pendingDismissals.get(r);
			i !== void 0 && (cancelAnimationFrame(i), this.pendingDismissals.delete(r), this.dismissedToasts.delete(r));
			let a = this.dismissedToasts.has(r), o = e.dismissible === void 0 ? !0 : e.dismissible;
			return a && (this.dismissedToasts.delete(r), this.toasts = this.toasts.filter((e) => e.id !== r)), !a && this.toasts.find((e) => e.id === r) ? this.toasts = this.toasts.map((n) => n.id === r ? (this.publish({
				...n,
				...e,
				id: r,
				title: t
			}), {
				...n,
				...e,
				id: r,
				dismissible: o,
				title: t
			}) : n) : this.addToast({
				title: t,
				...n,
				dismissible: o,
				id: r
			}), r;
		}, this.dismiss = (e) => {
			if (e == null) return this.getActiveToasts().forEach((e) => {
				this.dismissedToasts.add(e.id), this.subscribers.forEach((t) => t({
					id: e.id,
					dismiss: !0
				}));
			}), e;
			this.dismissedToasts.add(e);
			let t = this.pendingDismissals.get(e);
			return t !== void 0 && cancelAnimationFrame(t), this.pendingDismissals.set(e, requestAnimationFrame(() => {
				this.pendingDismissals.delete(e), this.subscribers.forEach((t) => t({
					id: e,
					dismiss: !0
				}));
			})), e;
		}, this.message = (e, t) => this.create({
			...t,
			message: e,
			type: void 0
		}), this.error = (e, t) => this.create({
			...t,
			message: e,
			type: "error"
		}), this.success = (e, t) => this.create({
			...t,
			type: "success",
			message: e
		}), this.info = (e, t) => this.create({
			...t,
			type: "info",
			message: e
		}), this.warning = (e, t) => this.create({
			...t,
			type: "warning",
			message: e
		}), this.loading = (e, t) => this.create({
			...t,
			type: "loading",
			message: e
		}), this.promise = (e, t) => {
			if (!t) return;
			let n;
			t.loading !== void 0 && (n = this.create({
				...t,
				promise: e,
				type: "loading",
				message: t.loading,
				description: typeof t.description == "function" ? void 0 : t.description
			}));
			let r = Promise.resolve(e instanceof Function ? e() : e), i = n !== void 0, a, o = r.then(async (e) => {
				if (a = ["resolve", e], A.isValidElement(e)) i = !1, this.create({
					id: n,
					type: "default",
					message: e
				});
				else if (ze(e) && !e.ok) {
					i = !1;
					let r = typeof t.error == "function" ? await t.error(`HTTP error! status: ${e.status}`) : t.error, a = typeof t.description == "function" ? await t.description(`HTTP error! status: ${e.status}`) : t.description, o = typeof r == "object" && !A.isValidElement(r) ? r : { message: r };
					this.create({
						id: n,
						type: "error",
						description: a,
						...o
					});
				} else if (e instanceof Error) {
					i = !1;
					let r = typeof t.error == "function" ? await t.error(e) : t.error, a = typeof t.description == "function" ? await t.description(e) : t.description, o = typeof r == "object" && !A.isValidElement(r) ? r : { message: r };
					this.create({
						id: n,
						type: "error",
						description: a,
						...o
					});
				} else if (t.success !== void 0) {
					i = !1;
					let r = typeof t.success == "function" ? await t.success(e) : t.success, a = typeof t.description == "function" ? await t.description(e) : t.description, o = typeof r == "object" && !A.isValidElement(r) ? r : { message: r };
					this.create({
						id: n,
						type: "success",
						description: a,
						...o
					});
				}
			}).catch(async (e) => {
				if (a = ["reject", e], t.error !== void 0) {
					i = !1;
					let r = typeof t.error == "function" ? await t.error(e) : t.error, a = typeof t.description == "function" ? await t.description(e) : t.description, o = typeof r == "object" && !A.isValidElement(r) ? r : { message: r };
					this.create({
						id: n,
						type: "error",
						description: a,
						...o
					});
				}
			}).finally(() => {
				i && (this.dismiss(n), n = void 0), t.finally == null || t.finally.call(t);
			}), s = () => new Promise((e, t) => o.then(() => a[0] === "reject" ? t(a[1]) : e(a[1])).catch(t));
			return typeof n != "string" && typeof n != "number" ? { unwrap: s } : Object.assign(n, { unwrap: s });
		}, this.custom = (e, t) => {
			let n = Ie(t);
			return this.create({
				...t,
				jsx: e(n),
				id: n,
				type: void 0
			}), n;
		}, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set(), this.pendingDismissals = /* @__PURE__ */ new Map();
	}
}(), Re = (e, t) => Le.message(e, t), ze = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", Be = Object.assign(Re, {
	success: Le.success,
	info: Le.info,
	warning: Le.warning,
	error: Le.error,
	custom: Le.custom,
	message: Le.message,
	promise: Le.promise,
	dismiss: Le.dismiss,
	loading: Le.loading
}, {
	getHistory: () => Le.toasts,
	getToasts: () => Le.getActiveToasts()
});
we("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px;flex:1;min-width:0}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--normal-text);background:var(--normal-bg);border:1px solid var(--normal-border);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{-webkit-user-select:none;user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function Ve(e) {
	return e.label !== void 0;
}
var He = 3, Ue = "24px", We = "16px", Ge = 4e3, Ke = 356, qe = 14, Je = 45, Ye = 200;
function Xe(...e) {
	return e.filter(Boolean).join(" ");
}
function Ze(e) {
	let [t, n] = e.split("-"), r = [];
	return t && r.push(t), n && r.push(n), r;
}
var Qe = (e) => {
	let { invert: t, toast: n, unstyled: r, interacting: i, setHeights: a, visibleToasts: o, heights: s, index: c, toasts: l, expanded: u, removeToast: d, defaultRichColors: f, closeButton: p, style: m, cancelButtonStyle: h, actionButtonStyle: g, className: _ = "", descriptionClassName: v = "", duration: y, position: b, gap: x, expandByDefault: S, classNames: C, icons: w, closeButtonAriaLabel: T = "Close toast" } = e, [E, D] = A.useState(null), [O, k] = A.useState(null), [j, M] = A.useState(!1), [N, P] = A.useState(!1), [F, I] = A.useState(!1), [R, ee] = A.useState(!1), [te, ne] = A.useState(!1), [z, B] = A.useState(0), [V, re] = A.useState(0), ie = A.useRef(n.duration || y || Ge), ae = A.useRef(null), oe = A.useRef(null), se = c === 0, ce = c + 1 <= o, le = n.type, ue = le ?? "default", de = n.dismissible !== !1, fe = n.className || "", pe = n.descriptionClassName || "", me = A.useMemo(() => s.findIndex((e) => e.toastId === n.id) || 0, [s, n.id]), he = A.useMemo(() => n.closeButton ?? p, [n.closeButton, p]), ge = A.useMemo(() => n.duration || y || Ge, [n.duration, y]), H = A.useRef(0), _e = A.useRef(0), ve = A.useRef(0), ye = A.useRef(null), [U, be] = b.split("-"), W = A.useMemo(() => s.reduce((e, t, n) => n >= me ? e : e + t.height, 0), [s, me]), xe = Ne(), Se = A.useMemo(() => e.swipeDirections ?? Ze(b), [e.swipeDirections, b]), Ce = n.invert || t, we = le === "loading";
	_e.current = A.useMemo(() => me * x + W, [me, W]), A.useEffect(() => {
		ie.current = ge;
	}, [ge]), A.useEffect(() => {
		M(!0);
	}, []), A.useEffect(() => {
		let e = oe.current;
		if (e) {
			let t = e.getBoundingClientRect().height;
			return re(t), a((e) => [{
				toastId: n.id,
				height: t,
				position: n.position
			}, ...e]), () => a((e) => e.filter((e) => e.toastId !== n.id));
		}
	}, [a, n.id]), A.useLayoutEffect(() => {
		if (!j) return;
		let e = oe.current, t = e.style.height;
		e.style.height = "auto";
		let r = e.getBoundingClientRect().height;
		e.style.height = t, re(r), a((e) => e.find((e) => e.toastId === n.id) ? e.map((e) => e.toastId === n.id ? {
			...e,
			height: r
		} : e) : [{
			toastId: n.id,
			height: r,
			position: n.position
		}, ...e]);
	}, [
		j,
		n.title,
		n.description,
		a,
		n.id,
		n.jsx,
		n.action,
		n.cancel
	]);
	let Ee = A.useCallback(() => {
		P(!0), B(_e.current), a((e) => e.filter((e) => e.toastId !== n.id)), setTimeout(() => {
			d(n);
		}, Ye);
	}, [
		n,
		d,
		a,
		_e
	]);
	A.useEffect(() => {
		if (n.promise && le === "loading" || n.duration === Infinity || n.type === "loading") return;
		let e;
		return u || i || xe ? (() => {
			if (ve.current < H.current) {
				let e = (/* @__PURE__ */ new Date()).getTime() - H.current;
				ie.current -= e;
			}
			ve.current = (/* @__PURE__ */ new Date()).getTime();
		})() : ie.current !== Infinity && (H.current = (/* @__PURE__ */ new Date()).getTime(), e = setTimeout(() => {
			n.onAutoClose == null || n.onAutoClose.call(n, n), Ee();
		}, ie.current)), () => clearTimeout(e);
	}, [
		u,
		i,
		n,
		le,
		xe,
		Ee
	]), A.useEffect(() => {
		n.delete && (Ee(), n.onDismiss == null || n.onDismiss.call(n, n));
	}, [Ee, n.delete]);
	function Oe() {
		return w?.loading ? /* @__PURE__ */ A.createElement("div", {
			className: Xe(C?.loader, n?.classNames?.loader, "sonner-loader"),
			"data-visible": le === "loading"
		}, w.loading) : /* @__PURE__ */ A.createElement(De, {
			className: Xe(C?.loader, n?.classNames?.loader),
			visible: le === "loading"
		});
	}
	let ke = n.icon || w?.[le] || Te(le);
	return /* @__PURE__ */ A.createElement("li", {
		tabIndex: 0,
		ref: oe,
		className: Xe(_, fe, C?.toast, n?.classNames?.toast, C?.[ue], n?.classNames?.[ue]),
		"data-sonner-toast": "",
		"data-rich-colors": n.richColors ?? f,
		"data-styled": !(n.jsx || n.unstyled || r),
		"data-mounted": j,
		"data-promise": !!n.promise,
		"data-swiped": te,
		"data-removed": N,
		"data-visible": ce,
		"data-y-position": U,
		"data-x-position": be,
		"data-index": c,
		"data-front": se,
		"data-swiping": F,
		"data-dismissible": de,
		"data-type": le,
		"data-invert": Ce,
		"data-swipe-out": R,
		"data-swipe-direction": O,
		"data-expanded": !!(u || S && j),
		"data-testid": n.testId,
		style: {
			"--index": c,
			"--toasts-before": c,
			"--z-index": l.length - c,
			"--offset": `${N ? z : _e.current}px`,
			"--initial-height": S ? "auto" : `${V}px`,
			...m,
			...n.style
		},
		onDragEnd: () => {
			I(!1), D(null), ye.current = null;
		},
		onPointerDown: (e) => {
			e.button !== 2 && (we || !de || (ae.current = /* @__PURE__ */ new Date(), B(_e.current), e.target.setPointerCapture(e.pointerId), e.target.tagName !== "BUTTON" && (I(!0), ye.current = {
				x: e.clientX,
				y: e.clientY
			})));
		},
		onPointerUp: () => {
			if (R || !de) return;
			ye.current = null;
			let e = Number(oe.current?.style.getPropertyValue("--swipe-amount-x").replace("px", "") || 0), t = Number(oe.current?.style.getPropertyValue("--swipe-amount-y").replace("px", "") || 0), r = (/* @__PURE__ */ new Date()).getTime() - ae.current?.getTime(), i = E === "x" ? e : t, a = Math.abs(i) / r;
			if ((E === "x" ? Se.includes(e > 0 ? "right" : "left") : Se.includes(t > 0 ? "bottom" : "top")) && (Math.abs(i) >= Je || a > .11)) {
				B(_e.current), n.onDismiss == null || n.onDismiss.call(n, n), k(E === "x" ? e > 0 ? "right" : "left" : t > 0 ? "down" : "up"), Ee(), ee(!0);
				return;
			} else {
				var o, s;
				(o = oe.current) == null || o.style.setProperty("--swipe-amount-x", "0px"), (s = oe.current) == null || s.style.setProperty("--swipe-amount-y", "0px");
			}
			ne(!1), I(!1), D(null);
		},
		onPointerMove: (e) => {
			var t, n;
			if (!ye.current || !de || window.getSelection()?.toString().length > 0) return;
			let r = e.clientY - ye.current.y, i = e.clientX - ye.current.x;
			!E && (Math.abs(i) > 1 || Math.abs(r) > 1) && D(Math.abs(i) > Math.abs(r) ? "x" : "y");
			let a = {
				x: 0,
				y: 0
			}, o = (e) => 1 / (1.5 + Math.abs(e) / 20);
			if (E === "y") {
				if (Se.includes("top") || Se.includes("bottom")) if (Se.includes("top") && r < 0 || Se.includes("bottom") && r > 0) a.y = r;
				else {
					let e = r * o(r);
					a.y = Math.abs(e) < Math.abs(r) ? e : r;
				}
			} else if (E === "x" && (Se.includes("left") || Se.includes("right"))) if (Se.includes("left") && i < 0 || Se.includes("right") && i > 0) a.x = i;
			else {
				let e = i * o(i);
				a.x = Math.abs(e) < Math.abs(i) ? e : i;
			}
			(Math.abs(a.x) > 0 || Math.abs(a.y) > 0) && ne(!0), (t = oe.current) == null || t.style.setProperty("--swipe-amount-x", `${a.x}px`), (n = oe.current) == null || n.style.setProperty("--swipe-amount-y", `${a.y}px`);
		}
	}, he && !n.jsx && le !== "loading" ? /* @__PURE__ */ A.createElement("button", {
		"aria-label": T,
		"data-disabled": we,
		"data-close-button": !0,
		onClick: we || !de ? () => {} : () => {
			Ee(), n.onDismiss == null || n.onDismiss.call(n, n);
		},
		className: Xe(C?.closeButton, n?.classNames?.closeButton)
	}, w?.close ?? Me) : null, (le || n.icon || n.promise) && n.icon !== null && (w?.[le] !== null || n.icon) ? /* @__PURE__ */ A.createElement("div", {
		"data-icon": "",
		className: Xe(C?.icon, n?.classNames?.icon)
	}, le === "loading" ? n.icon || Oe() : n.promise ? Oe() : null, le === "loading" ? null : ke) : null, /* @__PURE__ */ A.createElement("div", {
		"data-content": "",
		className: Xe(C?.content, n?.classNames?.content)
	}, /* @__PURE__ */ A.createElement("div", {
		"data-title": "",
		className: Xe(C?.title, n?.classNames?.title)
	}, n.jsx ? n.jsx : typeof n.title == "function" ? n.title() : n.title), n.description ? /* @__PURE__ */ A.createElement("div", {
		"data-description": "",
		className: Xe(v, pe, C?.description, n?.classNames?.description)
	}, typeof n.description == "function" ? n.description() : n.description) : null), /* @__PURE__ */ A.isValidElement(n.cancel) ? n.cancel : n.cancel && Ve(n.cancel) ? /* @__PURE__ */ A.createElement("button", {
		"data-button": !0,
		"data-cancel": !0,
		style: n.cancelButtonStyle || h,
		onClick: (e) => {
			Ve(n.cancel) && de && (n.cancel.onClick == null || n.cancel.onClick.call(n.cancel, e), Ee());
		},
		className: Xe(C?.cancelButton, n?.classNames?.cancelButton)
	}, n.cancel.label) : null, /* @__PURE__ */ A.isValidElement(n.action) ? n.action : n.action && Ve(n.action) ? /* @__PURE__ */ A.createElement("button", {
		"data-button": !0,
		"data-action": !0,
		style: n.actionButtonStyle || g,
		onClick: (e) => {
			Ve(n.action) && (n.action.onClick == null || n.action.onClick.call(n.action, e), !e.defaultPrevented && Ee());
		},
		className: Xe(C?.actionButton, n?.classNames?.actionButton)
	}, n.action.label) : null);
};
function $e() {
	if (typeof window > "u" || typeof document > "u") return "ltr";
	let e = document.documentElement.getAttribute("dir");
	return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function et(e, t) {
	let n = {};
	return [e, t].forEach((e, t) => {
		let r = t === 1, i = r ? "--mobile-offset" : "--offset", a = r ? We : Ue;
		function o(e) {
			[
				"top",
				"right",
				"bottom",
				"left"
			].forEach((t) => {
				n[`${i}-${t}`] = typeof e == "number" ? `${e}px` : e;
			});
		}
		typeof e == "number" || typeof e == "string" ? o(e) : typeof e == "object" ? [
			"top",
			"right",
			"bottom",
			"left"
		].forEach((t) => {
			e[t] === void 0 ? n[`${i}-${t}`] = a : n[`${i}-${t}`] = typeof e[t] == "number" ? `${e[t]}px` : e[t];
		}) : o(a);
	}), n;
}
var tt = /* @__PURE__ */ A.forwardRef(function(e, t) {
	let { id: n, invert: r, position: i = "bottom-right", hotkey: a = ["altKey", "KeyT"], expand: o, closeButton: s, className: c, offset: l, mobileOffset: u, theme: d = "light", richColors: f, duration: p, style: m, visibleToasts: h = He, toastOptions: g, dir: _ = $e(), gap: v = qe, icons: y, customAriaLabel: b, containerAriaLabel: x = "Notifications" } = e, [S, C] = A.useState([]), w = A.useMemo(() => n ? S.filter((e) => e.toasterId === n) : S.filter((e) => !e.toasterId), [S, n]), T = A.useMemo(() => Array.from(new Set([i].concat(w.filter((e) => e.position).map((e) => e.position)))), [w, i]), [E, D] = A.useState([]), [O, k] = A.useState(!1), [j, M] = A.useState(!1), [N, P] = A.useState(d === "system" ? typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : d), F = A.useRef(null), I = a.join("+").replace(/Key/g, "").replace(/Digit/g, ""), R = A.useRef(null), ee = A.useRef(!1), te = A.useCallback((e) => {
		C((t) => (t.find((t) => t.id === e.id)?.delete || Le.dismiss(e.id), t.filter(({ id: t }) => t !== e.id)));
	}, []);
	return A.useEffect(() => Le.subscribe((e) => {
		if (e.dismiss) {
			requestAnimationFrame(() => {
				C((t) => t.map((t) => t.id === e.id ? {
					...t,
					delete: !0
				} : t));
			});
			return;
		}
		setTimeout(() => {
			Ce.flushSync(() => {
				C((t) => {
					let n = t.findIndex((t) => t.id === e.id);
					return n === -1 ? [e, ...t] : [
						...t.slice(0, n),
						{
							...t[n],
							...e
						},
						...t.slice(n + 1)
					];
				});
			});
		});
	}), []), A.useEffect(() => {
		if (d !== "system") {
			P(d);
			return;
		}
		if (d === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? P("dark") : P("light")), typeof window > "u") return;
		let e = window.matchMedia("(prefers-color-scheme: dark)");
		try {
			e.addEventListener("change", ({ matches: e }) => {
				P(e ? "dark" : "light");
			});
		} catch {
			e.addListener(({ matches: e }) => {
				try {
					P(e ? "dark" : "light");
				} catch (e) {
					console.error(e);
				}
			});
		}
	}, [d]), A.useEffect(() => {
		S.length <= 1 && k(!1);
	}, [S]), A.useEffect(() => {
		let e = (e) => {
			if (a.length > 0 && a.every((t) => e[t] || e.code === t)) {
				var t;
				k(!0), (t = F.current) == null || t.focus();
			}
			e.code === "Escape" && (document.activeElement === F.current || F.current?.contains(document.activeElement)) && k(!1);
		};
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [a]), A.useEffect(() => {
		if (F.current) return () => {
			R.current && (R.current.focus({ preventScroll: !0 }), R.current = null, ee.current = !1);
		};
	}, [F.current]), /* @__PURE__ */ A.createElement("section", {
		ref: t,
		"aria-label": b ?? `${x} ${I}`,
		tabIndex: -1,
		"aria-live": "polite",
		"aria-relevant": "additions text",
		"aria-atomic": "false",
		suppressHydrationWarning: !0,
		"data-react-aria-top-layer": !0
	}, T.map((t, n) => {
		let [i, a] = t.split("-");
		return w.length ? /* @__PURE__ */ A.createElement("ol", {
			key: t,
			dir: _ === "auto" ? $e() : _,
			tabIndex: -1,
			ref: F,
			className: c,
			"data-sonner-toaster": !0,
			"data-sonner-theme": N,
			"data-y-position": i,
			"data-x-position": a,
			style: {
				"--front-toast-height": `${E[0]?.height || 0}px`,
				"--width": `${Ke}px`,
				"--gap": `${v}px`,
				...m,
				...et(l, u)
			},
			onBlur: (e) => {
				ee.current && !e.currentTarget.contains(e.relatedTarget) && (ee.current = !1, R.current &&= (R.current.focus({ preventScroll: !0 }), null));
			},
			onFocus: (e) => {
				e.target instanceof HTMLElement && e.target.dataset.dismissible === "false" || ee.current || (ee.current = !0, R.current = e.relatedTarget);
			},
			onMouseEnter: () => k(!0),
			onMouseMove: () => k(!0),
			onMouseLeave: () => {
				j || k(!1);
			},
			onDragEnd: () => k(!1),
			onPointerDown: (e) => {
				e.target instanceof HTMLElement && e.target.dataset.dismissible === "false" || M(!0);
			},
			onPointerUp: () => M(!1)
		}, w.filter((e) => !e.position && n === 0 || e.position === t).map((n, i) => /* @__PURE__ */ A.createElement(Qe, {
			key: n.id,
			icons: y,
			index: i,
			toast: n,
			defaultRichColors: f,
			duration: g?.duration ?? p,
			className: g?.className,
			descriptionClassName: g?.descriptionClassName,
			invert: r,
			visibleToasts: h,
			closeButton: g?.closeButton ?? s,
			interacting: j,
			position: t,
			style: g?.style,
			unstyled: g?.unstyled,
			classNames: g?.classNames,
			cancelButtonStyle: g?.cancelButtonStyle,
			actionButtonStyle: g?.actionButtonStyle,
			closeButtonAriaLabel: g?.closeButtonAriaLabel,
			removeToast: te,
			toasts: w.filter((e) => e.position == n.position),
			heights: E.filter((e) => e.position == n.position),
			setHeights: D,
			expandByDefault: o,
			gap: v,
			expanded: O,
			swipeDirections: e.swipeDirections
		}))) : null;
	}));
});
//#endregion
//#region node_modules/proj4/lib/global.js
function nt(e) {
	e("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"), e("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees"), e("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");
	for (var t = 1; t <= 60; ++t) e("EPSG:" + (32600 + t), "+proj=utm +zone=" + t + " +datum=WGS84 +units=m"), e("EPSG:" + (32700 + t), "+proj=utm +zone=" + t + " +south +datum=WGS84 +units=m");
	e("EPSG:5041", "+title=WGS 84 / UPS North (E,N) +proj=stere +lat_0=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m"), e("EPSG:5042", "+title=WGS 84 / UPS South (E,N) +proj=stere +lat_0=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m"), e.WGS84 = e["EPSG:4326"], e["EPSG:3785"] = e["EPSG:3857"], e.GOOGLE = e["EPSG:3857"], e["EPSG:900913"] = e["EPSG:3857"], e["EPSG:102113"] = e["EPSG:3857"];
}
//#endregion
//#region node_modules/proj4/lib/constants/values.js
var rt = 6378137, it = 6356752.314, at = .0066943799901413165, ot = 484813681109536e-20, G = Math.PI / 2, st = .16666666666666666, ct = .04722222222222222, lt = .022156084656084655, ut = 1e-10, dt = .017453292519943295, ft = 57.29577951308232, pt = Math.PI / 4, mt = Math.PI * 2, ht = 3.14159265359, gt = {};
gt.greenwich = 0, gt.lisbon = -9.131906111111, gt.paris = 2.337229166667, gt.bogota = -74.080916666667, gt.madrid = -3.687938888889, gt.rome = 12.452333333333, gt.bern = 7.439583333333, gt.jakarta = 106.807719444444, gt.ferro = -17.666666666667, gt.brussels = 4.367975, gt.stockholm = 18.058277777778, gt.athens = 23.7163375, gt.oslo = 10.722916666667;
//#endregion
//#region node_modules/proj4/lib/constants/units.js
var _t = {
	mm: { to_meter: .001 },
	cm: { to_meter: .01 },
	ft: { to_meter: .3048 },
	"us-ft": { to_meter: 1200 / 3937 },
	fath: { to_meter: 1.8288 },
	kmi: { to_meter: 1852 },
	"us-ch": { to_meter: 20.1168402336805 },
	"us-mi": { to_meter: 1609.34721869444 },
	km: { to_meter: 1e3 },
	"ind-ft": { to_meter: .30479841 },
	"ind-yd": { to_meter: .91439523 },
	mi: { to_meter: 1609.344 },
	yd: { to_meter: .9144 },
	ch: { to_meter: 20.1168 },
	link: { to_meter: .201168 },
	dm: { to_meter: .1 },
	in: { to_meter: .0254 },
	"ind-ch": { to_meter: 20.11669506 },
	"us-in": { to_meter: .025400050800101 },
	"us-yd": { to_meter: .914401828803658 }
}, vt = /[\s_\-\/\(\)]/g;
function yt(e, t) {
	if (e[t]) return e[t];
	for (var n = Object.keys(e), r = t.toLowerCase().replace(vt, ""), i = -1, a, o; ++i < n.length;) if (a = n[i], o = a.toLowerCase().replace(vt, ""), o === r) return e[a];
}
//#endregion
//#region node_modules/proj4/lib/projString.js
function bt(e) {
	var t = {}, n = e.split("+").map(function(e) {
		return e.trim();
	}).filter(function(e) {
		return e;
	}).reduce(function(e, t) {
		var n = t.split("=");
		return n.push(!0), e[n[0].toLowerCase()] = n[1], e;
	}, {}), r, i, a, o = {
		proj: "projName",
		datum: "datumCode",
		rf: function(e) {
			t.rf = parseFloat(e);
		},
		lat_0: function(e) {
			t.lat0 = e * dt;
		},
		lat_1: function(e) {
			t.lat1 = e * dt;
		},
		lat_2: function(e) {
			t.lat2 = e * dt;
		},
		lat_ts: function(e) {
			t.lat_ts = e * dt;
		},
		lon_0: function(e) {
			t.long0 = e * dt;
		},
		lon_wrap: function(e) {
			t.long_wrap = parseFloat(e) * dt;
		},
		lon_1: function(e) {
			t.long1 = e * dt;
		},
		lon_2: function(e) {
			t.long2 = e * dt;
		},
		alpha: function(e) {
			t.alpha = parseFloat(e) * dt;
		},
		gamma: function(e) {
			t.rectified_grid_angle = parseFloat(e) * dt;
		},
		lonc: function(e) {
			t.longc = e * dt;
		},
		x_0: function(e) {
			t.x0 = parseFloat(e);
		},
		y_0: function(e) {
			t.y0 = parseFloat(e);
		},
		k_0: function(e) {
			t.k0 = parseFloat(e);
		},
		k: function(e) {
			t.k0 = parseFloat(e);
		},
		a: function(e) {
			t.a = parseFloat(e);
		},
		b: function(e) {
			t.b = parseFloat(e);
		},
		r: function(e) {
			t.a = t.b = parseFloat(e);
		},
		r_a: function() {
			t.R_A = !0;
		},
		zone: function(e) {
			t.zone = parseInt(e, 10);
		},
		south: function() {
			t.utmSouth = !0;
		},
		towgs84: function(e) {
			t.datum_params = e.split(",").map(function(e) {
				return parseFloat(e);
			});
		},
		to_meter: function(e) {
			t.to_meter = parseFloat(e);
		},
		units: function(e) {
			t.units = e;
			var n = yt(_t, e);
			n && (t.to_meter = n.to_meter);
		},
		from_greenwich: function(e) {
			t.from_greenwich = e * dt;
		},
		pm: function(e) {
			t.from_greenwich = (yt(gt, e) || parseFloat(e)) * dt;
		},
		nadgrids: function(e) {
			e === "@null" ? t.datumCode = "none" : t.nadgrids = e;
		},
		axis: function(e) {
			var n = "ewnsud";
			e.length === 3 && n.indexOf(e.substr(0, 1)) !== -1 && n.indexOf(e.substr(1, 1)) !== -1 && n.indexOf(e.substr(2, 1)) !== -1 && (t.axis = e);
		},
		approx: function() {
			t.approx = !0;
		},
		over: function() {
			t.over = !0;
		}
	};
	for (r in n) i = n[r], r in o ? (a = o[r], typeof a == "function" ? a(i) : t[a] = i) : t[r] = i;
	return typeof t.datumCode == "string" && t.datumCode !== "WGS84" && (t.datumCode = t.datumCode.toLowerCase()), t.projStr = e, t;
}
//#endregion
//#region node_modules/wkt-parser/PROJJSONBuilder.js
var xt = class {
	static getId(e) {
		let t = e.find((e) => Array.isArray(e) && e[0] === "ID");
		return t && t.length >= 3 ? {
			authority: t[1],
			code: parseInt(t[2], 10)
		} : null;
	}
	static convertUnit(e, t = "unit") {
		if (!e || e.length < 3) return {
			type: t,
			name: "unknown",
			conversion_factor: null
		};
		let n = e[1], r = parseFloat(e[2]) || null, i = e.find((e) => Array.isArray(e) && e[0] === "ID");
		return {
			type: t,
			name: n,
			conversion_factor: r,
			id: i ? {
				authority: i[1],
				code: parseInt(i[2], 10)
			} : null
		};
	}
	static convertAxis(e) {
		let t = e[1] || "Unknown", n, r = t.match(/^\((.)\)$/);
		if (r) {
			let t = r[1].toUpperCase();
			if (t === "E") n = "east";
			else if (t === "N") n = "north";
			else if (t === "U") n = "up";
			else if (e[2]) n = e[2];
			else throw Error(`Unknown axis abbreviation: ${t}`);
		} else n = e[2] || "unknown";
		let i = e.find((e) => Array.isArray(e) && e[0] === "ORDER"), a = i ? parseInt(i[1], 10) : null, o = e.find((e) => Array.isArray(e) && (e[0] === "LENGTHUNIT" || e[0] === "ANGLEUNIT" || e[0] === "SCALEUNIT")), s = this.convertUnit(o);
		return {
			name: t,
			direction: n,
			unit: s,
			order: a
		};
	}
	static extractAxes(e) {
		return e.filter((e) => Array.isArray(e) && e[0] === "AXIS").map((e) => this.convertAxis(e)).sort((e, t) => (e.order || 0) - (t.order || 0));
	}
	static convert(e, t = {}) {
		switch (e[0]) {
			case "PROJCRS":
				t.type = "ProjectedCRS", t.name = e[1], t.base_crs = e.find((e) => Array.isArray(e) && e[0] === "BASEGEOGCRS") ? this.convert(e.find((e) => Array.isArray(e) && e[0] === "BASEGEOGCRS")) : null, t.conversion = e.find((e) => Array.isArray(e) && e[0] === "CONVERSION") ? this.convert(e.find((e) => Array.isArray(e) && e[0] === "CONVERSION")) : null;
				let n = e.find((e) => Array.isArray(e) && e[0] === "CS");
				n && (t.coordinate_system = {
					subtype: n[1],
					axis: this.extractAxes(e)
				});
				let r = e.find((e) => Array.isArray(e) && e[0] === "LENGTHUNIT");
				if (r) {
					let e = this.convertUnit(r);
					t.coordinate_system.unit = e;
				}
				t.id = this.getId(e);
				break;
			case "BASEGEOGCRS":
			case "GEOGCRS":
			case "GEODCRS":
				t.type = e[0] === "GEODCRS" ? "GeodeticCRS" : "GeographicCRS", t.name = e[1];
				let i = e.find((e) => Array.isArray(e) && (e[0] === "DATUM" || e[0] === "ENSEMBLE"));
				if (i) {
					let n = this.convert(i);
					i[0] === "ENSEMBLE" ? t.datum_ensemble = n : t.datum = n;
					let r = e.find((e) => Array.isArray(e) && e[0] === "PRIMEM");
					r && r[1] !== "Greenwich" && (n.prime_meridian = {
						name: r[1],
						longitude: parseFloat(r[2])
					});
				}
				let a = e.find((e) => Array.isArray(e) && e[0] === "CS");
				t.coordinate_system = {
					subtype: a ? a[1] : "ellipsoidal",
					axis: this.extractAxes(e)
				}, t.id = this.getId(e);
				break;
			case "DATUM":
				t.type = "GeodeticReferenceFrame", t.name = e[1], t.ellipsoid = e.find((e) => Array.isArray(e) && e[0] === "ELLIPSOID") ? this.convert(e.find((e) => Array.isArray(e) && e[0] === "ELLIPSOID")) : null;
				break;
			case "ENSEMBLE":
				t.type = "DatumEnsemble", t.name = e[1], t.members = e.filter((e) => Array.isArray(e) && e[0] === "MEMBER").map((e) => ({
					type: "DatumEnsembleMember",
					name: e[1],
					id: this.getId(e)
				}));
				let o = e.find((e) => Array.isArray(e) && e[0] === "ENSEMBLEACCURACY");
				o && (t.accuracy = parseFloat(o[1]));
				let s = e.find((e) => Array.isArray(e) && e[0] === "ELLIPSOID");
				s && (t.ellipsoid = this.convert(s)), t.id = this.getId(e);
				break;
			case "ELLIPSOID":
				t.type = "Ellipsoid", t.name = e[1], t.semi_major_axis = parseFloat(e[2]), t.inverse_flattening = parseFloat(e[3]), e.find((e) => Array.isArray(e) && e[0] === "LENGTHUNIT") && this.convert(e.find((e) => Array.isArray(e) && e[0] === "LENGTHUNIT"), t);
				break;
			case "CONVERSION":
				t.type = "Conversion", t.name = e[1], t.method = e.find((e) => Array.isArray(e) && e[0] === "METHOD") ? this.convert(e.find((e) => Array.isArray(e) && e[0] === "METHOD")) : null, t.parameters = e.filter((e) => Array.isArray(e) && e[0] === "PARAMETER").map((e) => this.convert(e));
				break;
			case "METHOD":
				t.type = "Method", t.name = e[1], t.id = this.getId(e);
				break;
			case "PARAMETER":
				t.type = "Parameter", t.name = e[1], t.value = parseFloat(e[2]), t.unit = this.convertUnit(e.find((e) => Array.isArray(e) && (e[0] === "LENGTHUNIT" || e[0] === "ANGLEUNIT" || e[0] === "SCALEUNIT"))), t.id = this.getId(e);
				break;
			case "BOUNDCRS":
				t.type = "BoundCRS";
				let c = e.find((e) => Array.isArray(e) && e[0] === "SOURCECRS");
				if (c) {
					let e = c.find((e) => Array.isArray(e));
					t.source_crs = e ? this.convert(e) : null;
				}
				let l = e.find((e) => Array.isArray(e) && e[0] === "TARGETCRS");
				if (l) {
					let e = l.find((e) => Array.isArray(e));
					t.target_crs = e ? this.convert(e) : null;
				}
				let u = e.find((e) => Array.isArray(e) && e[0] === "ABRIDGEDTRANSFORMATION");
				u ? t.transformation = this.convert(u) : t.transformation = null;
				break;
			case "ABRIDGEDTRANSFORMATION":
				if (t.type = "Transformation", t.name = e[1], t.method = e.find((e) => Array.isArray(e) && e[0] === "METHOD") ? this.convert(e.find((e) => Array.isArray(e) && e[0] === "METHOD")) : null, t.parameters = e.filter((e) => Array.isArray(e) && (e[0] === "PARAMETER" || e[0] === "PARAMETERFILE")).map((e) => {
					if (e[0] === "PARAMETER") return this.convert(e);
					if (e[0] === "PARAMETERFILE") return {
						name: e[1],
						value: e[2],
						id: {
							authority: "EPSG",
							code: 8656
						}
					};
				}), t.parameters.length === 7) {
					let e = t.parameters[6];
					e.name === "Scale difference" && (e.value = Math.round((e.value - 1) * 0xe8d4a51000) / 1e6);
				}
				t.id = this.getId(e);
				break;
			case "AXIS":
				t.coordinate_system ||= {
					type: "unspecified",
					axis: []
				}, t.coordinate_system.axis.push(this.convertAxis(e));
				break;
			case "LENGTHUNIT":
				let d = this.convertUnit(e, "LinearUnit");
				t.coordinate_system && t.coordinate_system.axis && t.coordinate_system.axis.forEach((e) => {
					e.unit ||= d;
				}), d.conversion_factor && d.conversion_factor !== 1 && (t.semi_major_axis &&= {
					value: t.semi_major_axis,
					unit: d
				});
				break;
			default:
				t.keyword = e[0];
				break;
		}
		return t;
	}
};
//#endregion
//#region node_modules/wkt-parser/buildPROJJSON.js
function St(e) {
	return xt.convert(e);
}
//#endregion
//#region node_modules/wkt-parser/detectWKTVersion.js
function Ct(e) {
	let t = e.toUpperCase();
	return t.includes("PROJCRS") || t.includes("GEOGCRS") || t.includes("BOUNDCRS") || t.includes("VERTCRS") || t.includes("LENGTHUNIT") || t.includes("ANGLEUNIT") || t.includes("SCALEUNIT") ? "WKT2" : (t.includes("PROJCS") || t.includes("GEOGCS") || t.includes("LOCAL_CS") || t.includes("VERT_CS") || t.includes("UNIT"), "WKT1");
}
//#endregion
//#region node_modules/wkt-parser/parser.js
var wt = Lt, Tt = 1, Et = 2, Dt = 3, Ot = 4, kt = 5, At = -1, jt = /\s/, Mt = /[A-Za-z]/, Nt = /[A-Za-z84_]/, Pt = /[,\]]/, Ft = /[\d\.E\-\+]/;
function It(e) {
	if (typeof e != "string") throw Error("not a string");
	this.text = e.trim(), this.level = 0, this.place = 0, this.root = null, this.stack = [], this.currentObject = null, this.state = Tt;
}
It.prototype.readCharicter = function() {
	var e = this.text[this.place++];
	if (this.state !== Ot) for (; jt.test(e);) {
		if (this.place >= this.text.length) return;
		e = this.text[this.place++];
	}
	switch (this.state) {
		case Tt: return this.neutral(e);
		case Et: return this.keyword(e);
		case Ot: return this.quoted(e);
		case kt: return this.afterquote(e);
		case Dt: return this.number(e);
		case At: return;
	}
}, It.prototype.afterquote = function(e) {
	if (e === "\"") {
		this.word += "\"", this.state = Ot;
		return;
	}
	if (Pt.test(e)) {
		this.word = this.word.trim(), this.afterItem(e);
		return;
	}
	throw Error("havn't handled \"" + e + "\" in afterquote yet, index " + this.place);
}, It.prototype.afterItem = function(e) {
	if (e === ",") {
		this.word !== null && this.currentObject.push(this.word), this.word = null, this.state = Tt;
		return;
	}
	if (e === "]") {
		this.level--, this.word !== null && (this.currentObject.push(this.word), this.word = null), this.state = Tt, this.currentObject = this.stack.pop(), this.currentObject || (this.state = At);
		return;
	}
}, It.prototype.number = function(e) {
	if (Ft.test(e)) {
		this.word += e;
		return;
	}
	if (Pt.test(e)) {
		this.word = parseFloat(this.word), this.afterItem(e);
		return;
	}
	throw Error("havn't handled \"" + e + "\" in number yet, index " + this.place);
}, It.prototype.quoted = function(e) {
	if (e === "\"") {
		this.state = kt;
		return;
	}
	this.word += e;
}, It.prototype.keyword = function(e) {
	if (Nt.test(e)) {
		this.word += e;
		return;
	}
	if (e === "[") {
		var t = [];
		t.push(this.word), this.level++, this.root === null ? this.root = t : this.currentObject.push(t), this.stack.push(this.currentObject), this.currentObject = t, this.state = Tt;
		return;
	}
	if (Pt.test(e)) {
		this.afterItem(e);
		return;
	}
	throw Error("havn't handled \"" + e + "\" in keyword yet, index " + this.place);
}, It.prototype.neutral = function(e) {
	if (Mt.test(e)) {
		this.word = e, this.state = Et;
		return;
	}
	if (e === "\"") {
		this.word = "", this.state = Ot;
		return;
	}
	if (Ft.test(e)) {
		this.word = e, this.state = Dt;
		return;
	}
	if (Pt.test(e)) {
		this.afterItem(e);
		return;
	}
	throw Error("havn't handled \"" + e + "\" in neutral yet, index " + this.place);
}, It.prototype.output = function() {
	for (; this.place < this.text.length;) this.readCharicter();
	if (this.state === At) return this.root;
	throw Error("unable to parse string \"" + this.text + "\". State is " + this.state);
};
function Lt(e) {
	return new It(e).output();
}
//#endregion
//#region node_modules/wkt-parser/process.js
function Rt(e, t, n) {
	Array.isArray(t) && (n.unshift(t), t = null);
	var r = t ? {} : e, i = n.reduce(function(e, t) {
		return zt(t, e), e;
	}, r);
	t && (e[t] = i);
}
function zt(e, t) {
	if (!Array.isArray(e)) {
		t[e] = !0;
		return;
	}
	var n = e.shift();
	if (n === "PARAMETER" && (n = e.shift()), e.length === 1) {
		if (Array.isArray(e[0])) {
			t[n] = {}, zt(e[0], t[n]);
			return;
		}
		t[n] = e[0];
		return;
	}
	if (!e.length) {
		t[n] = !0;
		return;
	}
	if (n === "TOWGS84") {
		t[n] = e;
		return;
	}
	if (n === "AXIS") {
		n in t || (t[n] = []), t[n].push(e);
		return;
	}
	Array.isArray(n) || (t[n] = {});
	var r;
	switch (n) {
		case "UNIT":
		case "PRIMEM":
		case "VERT_DATUM":
			t[n] = {
				name: e[0].toLowerCase(),
				convert: e[1]
			}, e.length === 3 && zt(e[2], t[n]);
			return;
		case "SPHEROID":
		case "ELLIPSOID":
			t[n] = {
				name: e[0],
				a: e[1],
				rf: e[2]
			}, e.length === 4 && zt(e[3], t[n]);
			return;
		case "EDATUM":
		case "ENGINEERINGDATUM":
		case "LOCAL_DATUM":
		case "DATUM":
		case "VERT_CS":
		case "VERTCRS":
		case "VERTICALCRS":
			e[0] = ["name", e[0]], Rt(t, n, e);
			return;
		case "COMPD_CS":
		case "COMPOUNDCRS":
		case "FITTED_CS":
		case "PROJECTEDCRS":
		case "PROJCRS":
		case "GEOGCS":
		case "GEOCCS":
		case "PROJCS":
		case "LOCAL_CS":
		case "GEODCRS":
		case "GEODETICCRS":
		case "GEODETICDATUM":
		case "ENGCRS":
		case "ENGINEERINGCRS":
			e[0] = ["name", e[0]], Rt(t, n, e), t[n].type = n;
			return;
		default:
			for (r = -1; ++r < e.length;) if (!Array.isArray(e[r])) return zt(e, t[n]);
			return Rt(t, n, e);
	}
}
//#endregion
//#region node_modules/wkt-parser/util.js
var Bt = .017453292519943295;
function Vt(e) {
	return e * Bt;
}
function Ht(e) {
	let t = (e.projName || "").toLowerCase().replace(/_/g, " ");
	e.long0 === void 0 && e.longc !== void 0 && (e.long0 = e.longc), !e.lat_ts && e.lat1 && (t === "stereographic south pole" || t === "polar stereographic (variant b)") ? (e.lat0 = Vt(e.lat1 > 0 ? 90 : -90), e.lat_ts = e.lat1, delete e.lat1) : !e.lat_ts && e.lat0 && (t === "polar stereographic" || t === "polar stereographic (variant a)") && (e.lat_ts = e.lat0, e.lat0 = Vt(e.lat0 > 0 ? 90 : -90), delete e.lat1);
}
//#endregion
//#region node_modules/wkt-parser/transformPROJJSON.js
function Ut(e) {
	let t = {
		units: null,
		to_meter: void 0
	};
	return typeof e == "string" ? (t.units = e.toLowerCase(), t.units === "metre" && (t.units = "meter"), t.units === "meter" && (t.to_meter = 1)) : e && e.name && (t.units = e.name.toLowerCase(), t.units === "metre" && (t.units = "meter"), t.to_meter = e.conversion_factor), t;
}
function Wt(e) {
	return typeof e == "object" ? e.value * e.unit.conversion_factor : e;
}
function Gt(e, t) {
	e.ellipsoid.radius ? (t.a = e.ellipsoid.radius, t.rf = 0) : (t.a = Wt(e.ellipsoid.semi_major_axis), e.ellipsoid.inverse_flattening === void 0 ? e.ellipsoid.semi_major_axis !== void 0 && e.ellipsoid.semi_minor_axis !== void 0 && (t.rf = t.a / (t.a - Wt(e.ellipsoid.semi_minor_axis))) : t.rf = e.ellipsoid.inverse_flattening);
}
function Kt(e, t = {}) {
	return !e || typeof e != "object" ? e : e.type === "BoundCRS" ? (Kt(e.source_crs, t), e.transformation && (e.transformation.method && e.transformation.method.name === "NTv2" ? t.nadgrids = e.transformation.parameters[0].value : t.datum_params = e.transformation.parameters.map((e) => e.value)), t) : (Object.keys(e).forEach((n) => {
		let r = e[n];
		if (r !== null) switch (n) {
			case "name":
				if (t.srsCode) break;
				t.name = r, t.srsCode = r;
				break;
			case "type":
				r === "GeographicCRS" ? t.projName = "longlat" : r === "GeodeticCRS" ? e.coordinate_system && e.coordinate_system.subtype === "Cartesian" ? t.projName = "geocent" : t.projName = "longlat" : r === "ProjectedCRS" && e.conversion && e.conversion.method && (t.projName = e.conversion.method.name);
				break;
			case "datum":
			case "datum_ensemble":
				r.ellipsoid && (t.ellps = r.ellipsoid.name, Gt(r, t)), r.prime_meridian && (t.from_greenwich = r.prime_meridian.longitude * Math.PI / 180);
				break;
			case "ellipsoid":
				t.ellps = r.name, Gt(r, t);
				break;
			case "prime_meridian":
				t.long0 = (r.longitude || 0) * Math.PI / 180;
				break;
			case "coordinate_system":
				if (r.axis) {
					let e = {
						east: "e",
						north: "n",
						west: "w",
						south: "s",
						up: "u",
						down: "d",
						geocentricx: "e",
						geocentricy: "n",
						geocentricz: "u"
					}, n = r.axis.map((t) => e[t.direction.toLowerCase()]);
					if (n.every(Boolean) && (t.axis = n.join(""), t.axis.length === 2 && (t.axis += "u")), r.unit) {
						let { units: e, to_meter: n } = Ut(r.unit);
						t.units = e, t.to_meter = n;
					} else if (r.axis[0] && r.axis[0].unit) {
						let { units: e, to_meter: n } = Ut(r.axis[0].unit);
						t.units = e, t.to_meter = n;
					}
				}
				break;
			case "id":
				r.authority && r.code && (t.title = r.authority + ":" + r.code);
				break;
			case "conversion":
				r.method && r.method.name && (t.projName = r.method.name), r.parameters && r.parameters.forEach((e) => {
					let n = e.name.toLowerCase().replace(/\s+/g, "_"), r = e.value;
					e.unit && e.unit.conversion_factor ? t[n] = r * e.unit.conversion_factor : e.unit === "degree" ? t[n] = r * Math.PI / 180 : t[n] = r;
				});
				break;
			case "unit":
				r.name && (t.units = r.name.toLowerCase(), t.units === "metre" && (t.units = "meter")), r.conversion_factor && (t.to_meter = r.conversion_factor);
				break;
			case "base_crs":
				Kt(r, t), t.datumCode = r.id ? r.id.authority + "_" + r.id.code : r.name;
				break;
			default: break;
		}
	}), t.latitude_of_false_origin !== void 0 && (t.lat0 = t.latitude_of_false_origin), t.longitude_of_false_origin !== void 0 && (t.long0 = t.longitude_of_false_origin), t.latitude_of_standard_parallel !== void 0 && (t.lat0 = t.latitude_of_standard_parallel, t.lat1 = t.latitude_of_standard_parallel), t.latitude_of_1st_standard_parallel !== void 0 && (t.lat1 = t.latitude_of_1st_standard_parallel), t.latitude_of_2nd_standard_parallel !== void 0 && (t.lat2 = t.latitude_of_2nd_standard_parallel), t.latitude_of_projection_centre !== void 0 && (t.lat0 = t.latitude_of_projection_centre), t.longitude_of_projection_centre !== void 0 && (t.longc = t.longitude_of_projection_centre), t.easting_at_false_origin !== void 0 && (t.x0 = t.easting_at_false_origin), t.northing_at_false_origin !== void 0 && (t.y0 = t.northing_at_false_origin), t.latitude_of_natural_origin !== void 0 && (t.lat0 = t.latitude_of_natural_origin), t.longitude_of_natural_origin !== void 0 && (t.long0 = t.longitude_of_natural_origin), t.longitude_of_origin !== void 0 && (t.long0 = t.longitude_of_origin), t.false_easting !== void 0 && (t.x0 = t.false_easting), t.easting_at_projection_centre && (t.x0 = t.easting_at_projection_centre), t.false_northing !== void 0 && (t.y0 = t.false_northing), t.northing_at_projection_centre && (t.y0 = t.northing_at_projection_centre), t.standard_parallel_1 !== void 0 && (t.lat1 = t.standard_parallel_1), t.standard_parallel_2 !== void 0 && (t.lat2 = t.standard_parallel_2), t.scale_factor_at_natural_origin !== void 0 && (t.k0 = t.scale_factor_at_natural_origin), t.scale_factor_at_projection_centre !== void 0 && (t.k0 = t.scale_factor_at_projection_centre), t.scale_factor_on_pseudo_standard_parallel !== void 0 && (t.k0 = t.scale_factor_on_pseudo_standard_parallel), t.azimuth !== void 0 && (t.alpha = t.azimuth), t.azimuth_at_projection_centre !== void 0 && (t.alpha = t.azimuth_at_projection_centre), t.angle_from_rectified_to_skew_grid && (t.rectified_grid_angle = t.angle_from_rectified_to_skew_grid), Ht(t), t);
}
//#endregion
//#region node_modules/wkt-parser/index.js
var qt = [
	"PROJECTEDCRS",
	"PROJCRS",
	"GEOGCS",
	"GEOCCS",
	"PROJCS",
	"LOCAL_CS",
	"GEODCRS",
	"GEODETICCRS",
	"GEODETICDATUM",
	"ENGCRS",
	"ENGINEERINGCRS"
];
function Jt(e, t) {
	var n = t[0], r = t[1];
	!(n in e) && r in e && (e[n] = e[r], t.length === 3 && (e[n] = t[2](e[n])));
}
function Yt(e) {
	for (var t = Object.keys(e), n = 0, r = t.length; n < r; ++n) {
		var i = t[n];
		qt.indexOf(i) !== -1 && Xt(e[i]), typeof e[i] == "object" && Yt(e[i]);
	}
}
function Xt(e) {
	if (e.AUTHORITY) {
		var t = Object.keys(e.AUTHORITY)[0];
		t && t in e.AUTHORITY && (e.title = t + ":" + e.AUTHORITY[t]);
	}
	if (e.type === "GEOGCS" ? e.projName = "longlat" : e.type === "LOCAL_CS" ? (e.projName = "identity", e.local = !0) : typeof e.PROJECTION == "object" ? e.projName = Object.keys(e.PROJECTION)[0] : e.projName = e.PROJECTION, e.AXIS) {
		for (var n = "", r = 0, i = e.AXIS.length; r < i; ++r) {
			var a = [e.AXIS[r][0].toLowerCase(), e.AXIS[r][1].toLowerCase()];
			a[0].indexOf("north") !== -1 || (a[0] === "y" || a[0] === "lat") && a[1] === "north" ? n += "n" : a[0].indexOf("south") !== -1 || (a[0] === "y" || a[0] === "lat") && a[1] === "south" ? n += "s" : a[0].indexOf("east") !== -1 || (a[0] === "x" || a[0] === "lon") && a[1] === "east" ? n += "e" : (a[0].indexOf("west") !== -1 || (a[0] === "x" || a[0] === "lon") && a[1] === "west") && (n += "w");
		}
		n.length === 2 && (n += "u"), n.length === 3 && (e.axis = n);
	}
	e.UNIT && (e.units = e.UNIT.name.toLowerCase(), e.units === "metre" && (e.units = "meter"), e.UNIT.convert && (e.type === "GEOGCS" ? e.DATUM && e.DATUM.SPHEROID && (e.to_meter = e.UNIT.convert * e.DATUM.SPHEROID.a) : e.to_meter = e.UNIT.convert));
	var o = e.GEOGCS;
	e.type === "GEOGCS" && (o = e), o && (o.PRIMEM && o.PRIMEM.convert && (e.from_greenwich = Vt(o.PRIMEM.convert)), o.DATUM ? e.datumCode = o.DATUM.name.toLowerCase() : e.datumCode = o.name.toLowerCase(), e.datumCode.slice(0, 2) === "d_" && (e.datumCode = e.datumCode.slice(2)), e.datumCode === "new_zealand_1949" && (e.datumCode = "nzgd49"), (e.datumCode === "wgs_1984" || e.datumCode === "world_geodetic_system_1984") && (e.PROJECTION === "Mercator_Auxiliary_Sphere" && (e.sphere = !0), e.datumCode = "wgs84"), e.datumCode === "belge_1972" && (e.datumCode = "rnb72"), o.DATUM && o.DATUM.SPHEROID && (e.ellps = o.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk"), e.ellps.toLowerCase().slice(0, 13) === "international" && (e.ellps = "intl"), e.a = o.DATUM.SPHEROID.a, e.rf = parseFloat(o.DATUM.SPHEROID.rf)), o.DATUM && o.DATUM.TOWGS84 && (e.datum_params = o.DATUM.TOWGS84), ~e.datumCode.indexOf("osgb_1936") && (e.datumCode = "osgb36"), ~e.datumCode.indexOf("osni_1952") && (e.datumCode = "osni52"), (~e.datumCode.indexOf("tm65") || ~e.datumCode.indexOf("geodetic_datum_of_1965")) && (e.datumCode = "ire65"), e.datumCode === "ch1903+" && (e.datumCode = "ch1903"), ~e.datumCode.indexOf("israel") && (e.datumCode = "isr93")), e.b && !isFinite(e.b) && (e.b = e.a), e.rectified_grid_angle &&= Vt(e.rectified_grid_angle);
	function s(t) {
		return t * (e.to_meter || 1);
	}
	[
		["standard_parallel_1", "Standard_Parallel_1"],
		["standard_parallel_1", "Latitude of 1st standard parallel"],
		["standard_parallel_2", "Standard_Parallel_2"],
		["standard_parallel_2", "Latitude of 2nd standard parallel"],
		["false_easting", "False_Easting"],
		["false_easting", "False easting"],
		["false-easting", "Easting at false origin"],
		["false_northing", "False_Northing"],
		["false_northing", "False northing"],
		["false_northing", "Northing at false origin"],
		["central_meridian", "Central_Meridian"],
		["central_meridian", "Longitude of natural origin"],
		["central_meridian", "Longitude of false origin"],
		["latitude_of_origin", "Latitude_Of_Origin"],
		["latitude_of_origin", "Central_Parallel"],
		["latitude_of_origin", "Latitude of natural origin"],
		["latitude_of_origin", "Latitude of false origin"],
		["scale_factor", "Scale_Factor"],
		["k0", "scale_factor"],
		["latitude_of_center", "Latitude_Of_Center"],
		["latitude_of_center", "Latitude_of_center"],
		[
			"lat0",
			"latitude_of_center",
			Vt
		],
		["longitude_of_center", "Longitude_Of_Center"],
		["longitude_of_center", "Longitude_of_center"],
		[
			"longc",
			"longitude_of_center",
			Vt
		],
		[
			"x0",
			"false_easting",
			s
		],
		[
			"y0",
			"false_northing",
			s
		],
		[
			"long0",
			"central_meridian",
			Vt
		],
		[
			"lat0",
			"latitude_of_origin",
			Vt
		],
		[
			"lat0",
			"standard_parallel_1",
			Vt
		],
		[
			"lat1",
			"standard_parallel_1",
			Vt
		],
		[
			"lat2",
			"standard_parallel_2",
			Vt
		],
		["azimuth", "Azimuth"],
		[
			"alpha",
			"azimuth",
			Vt
		],
		["srsCode", "name"]
	].forEach(function(t) {
		return Jt(e, t);
	}), Ht(e);
}
function Zt(e) {
	if (typeof e == "object") return Kt(e);
	let t = Ct(e);
	var n = wt(e);
	if (t === "WKT2") return Kt(St(n));
	var r = n[0], i = {};
	return zt(n, i), Yt(i), i[r];
}
//#endregion
//#region node_modules/proj4/lib/defs.js
function Qt(e) {
	var t = this;
	if (arguments.length === 2) {
		var n = arguments[1];
		typeof n == "string" ? n.charAt(0) === "+" ? Qt[e] = bt(arguments[1]) : Qt[e] = Zt(arguments[1]) : n && typeof n == "object" && !("projName" in n) ? Qt[e] = Zt(arguments[1]) : (Qt[e] = n, n || delete Qt[e]);
	} else if (arguments.length === 1) {
		if (Array.isArray(e)) return e.map(function(e) {
			return Array.isArray(e) ? Qt.apply(t, e) : Qt(e);
		});
		if (typeof e == "string") {
			if (e in Qt) return Qt[e];
		} else "EPSG" in e ? Qt["EPSG:" + e.EPSG] = e : "ESRI" in e ? Qt["ESRI:" + e.ESRI] = e : "IAU2000" in e ? Qt["IAU2000:" + e.IAU2000] = e : console.log(e);
		return;
	}
}
nt(Qt);
//#endregion
//#region node_modules/proj4/lib/parseCode.js
function $t(e) {
	return typeof e == "string";
}
function en(e) {
	return e in Qt;
}
function tn(e) {
	return e.indexOf("+") !== 0 && e.indexOf("[") !== -1 || typeof e == "object" && !("srsCode" in e);
}
var nn = [
	"3857",
	"900913",
	"3785",
	"102113"
];
function rn(e) {
	if (e.title) return e.title.toLowerCase().indexOf("epsg:") === 0 && nn.indexOf(e.title.substr(5)) > -1;
	var t = yt(e, "authority");
	if (t) {
		var n = yt(t, "epsg");
		return n && nn.indexOf(n) > -1;
	}
}
function an(e) {
	var t = yt(e, "extension");
	if (t) return yt(t, "proj4");
}
function on(e) {
	return e[0] === "+";
}
function sn(e) {
	let t;
	if ($t(e)) if (en(e)) t = Qt[e];
	else if (tn(e)) {
		t = Zt(e);
		var n = an(t);
		n && (t = bt(n));
	} else on(e) && (t = bt(e));
	else t = "projName" in e ? e : Zt(e);
	return t && rn(t) ? Qt["EPSG:3857"] : t;
}
//#endregion
//#region node_modules/proj4/lib/extend.js
function cn(e, t) {
	e ||= {};
	var n, r;
	if (!t) return e;
	for (r in t) n = t[r], n !== void 0 && (e[r] = n);
	return e;
}
//#endregion
//#region node_modules/proj4/lib/common/msfnz.js
function ln(e, t, n) {
	var r = e * t;
	return n / Math.sqrt(1 - r * r);
}
//#endregion
//#region node_modules/proj4/lib/common/sign.js
function un(e) {
	return e < 0 ? -1 : 1;
}
//#endregion
//#region node_modules/proj4/lib/common/adjust_lon.js
function K(e, t) {
	return t || Math.abs(e) <= 3.14159265359 ? e : e - un(e) * mt;
}
//#endregion
//#region node_modules/proj4/lib/common/tsfnz.js
function dn(e, t, n) {
	var r = e * n, i = .5 * e;
	return r = ((1 - r) / (1 + r)) ** i, Math.tan(.5 * (G - t)) / r;
}
//#endregion
//#region node_modules/proj4/lib/common/phi2z.js
function fn(e, t) {
	for (var n = .5 * e, r, i, a = G - 2 * Math.atan(t), o = 0; o <= 15; o++) if (r = e * Math.sin(a), i = G - 2 * Math.atan(t * ((1 - r) / (1 + r)) ** n) - a, a += i, Math.abs(i) <= 1e-10) return a;
	return -9999;
}
//#endregion
//#region node_modules/proj4/lib/projections/merc.js
function pn() {
	var e = this.b / this.a;
	this.es = 1 - e * e, "x0" in this || (this.x0 = 0), "y0" in this || (this.y0 = 0), this.long0 = this.long0 || 0, this.e = Math.sqrt(this.es), this.lat_ts ? this.sphere ? this.k0 = Math.cos(this.lat_ts) : this.k0 = ln(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) : this.k0 || (this.k ? this.k0 = this.k : this.k0 = 1);
}
function mn(e) {
	var t = e.x, n = e.y;
	if (n * 57.29577951308232 > 90 && n * 57.29577951308232 < -90 && t * 57.29577951308232 > 180 && t * 57.29577951308232 < -180) return null;
	var r, i;
	if (Math.abs(Math.abs(n) - G) <= 1e-10) return null;
	if (this.sphere) r = this.x0 + this.a * this.k0 * K(t - this.long0, this.over), i = this.y0 + this.a * this.k0 * Math.log(Math.tan(pt + .5 * n));
	else {
		var a = Math.sin(n), o = dn(this.e, n, a);
		r = this.x0 + this.a * this.k0 * K(t - this.long0, this.over), i = this.y0 - this.a * this.k0 * Math.log(o);
	}
	return e.x = r, e.y = i, e;
}
function hn(e) {
	var t = e.x - this.x0, n = e.y - this.y0, r, i;
	if (this.sphere) i = G - 2 * Math.atan(Math.exp(-n / (this.a * this.k0)));
	else {
		var a = Math.exp(-n / (this.a * this.k0));
		if (i = fn(this.e, a), i === -9999) return null;
	}
	return r = K(this.long0 + t / (this.a * this.k0), this.over), e.x = r, e.y = i, e;
}
var gn = {
	init: pn,
	forward: mn,
	inverse: hn,
	names: [
		"Mercator",
		"Popular Visualisation Pseudo Mercator",
		"Mercator_1SP",
		"Mercator_Auxiliary_Sphere",
		"Mercator_Variant_A",
		"merc"
	]
};
//#endregion
//#region node_modules/proj4/lib/projections/longlat.js
function _n() {}
function vn(e) {
	return e;
}
var yn = ["longlat", "identity"], bn = [gn, {
	init: _n,
	forward: vn,
	inverse: vn,
	names: yn
}], xn = {}, Sn = [];
function Cn(e, t) {
	var n = Sn.length;
	return e.names ? (Sn[n] = e, e.names.forEach(function(e) {
		xn[e.toLowerCase()] = n;
	}), this) : (console.log(t), !0);
}
function wn(e) {
	return e.replace(/[-\(\)\s]+/g, " ").trim().replace(/ /g, "_");
}
function Tn(e) {
	if (!e) return !1;
	var t = e.toLowerCase();
	if (xn[t] !== void 0 && Sn[xn[t]] || (t = wn(t), t in xn && Sn[xn[t]])) return Sn[xn[t]];
}
function En() {
	bn.forEach(Cn);
}
var Dn = {
	start: En,
	add: Cn,
	get: Tn
}, On = {
	MERIT: {
		a: 6378137,
		rf: 298.257,
		ellipseName: "MERIT 1983"
	},
	SGS85: {
		a: 6378136,
		rf: 298.257,
		ellipseName: "Soviet Geodetic System 85"
	},
	GRS80: {
		a: 6378137,
		rf: 298.257222101,
		ellipseName: "GRS 1980(IUGG, 1980)"
	},
	IAU76: {
		a: 6378140,
		rf: 298.257,
		ellipseName: "IAU 1976"
	},
	airy: {
		a: 6377563.396,
		b: 6356256.91,
		ellipseName: "Airy 1830"
	},
	APL4: {
		a: 6378137,
		rf: 298.25,
		ellipseName: "Appl. Physics. 1965"
	},
	NWL9D: {
		a: 6378145,
		rf: 298.25,
		ellipseName: "Naval Weapons Lab., 1965"
	},
	mod_airy: {
		a: 6377340.189,
		b: 6356034.446,
		ellipseName: "Modified Airy"
	},
	andrae: {
		a: 6377104.43,
		rf: 300,
		ellipseName: "Andrae 1876 (Den., Iclnd.)"
	},
	aust_SA: {
		a: 6378160,
		rf: 298.25,
		ellipseName: "Australian Natl & S. Amer. 1969"
	},
	GRS67: {
		a: 6378160,
		rf: 298.247167427,
		ellipseName: "GRS 67(IUGG 1967)"
	},
	bessel: {
		a: 6377397.155,
		rf: 299.1528128,
		ellipseName: "Bessel 1841"
	},
	bess_nam: {
		a: 6377483.865,
		rf: 299.1528128,
		ellipseName: "Bessel 1841 (Namibia)"
	},
	clrk66: {
		a: 6378206.4,
		b: 6356583.8,
		ellipseName: "Clarke 1866"
	},
	clrk80: {
		a: 6378249.145,
		rf: 293.4663,
		ellipseName: "Clarke 1880 mod."
	},
	clrk80ign: {
		a: 6378249.2,
		b: 6356515,
		rf: 293.4660213,
		ellipseName: "Clarke 1880 (IGN)"
	},
	clrk58: {
		a: 6378293.645208759,
		rf: 294.2606763692654,
		ellipseName: "Clarke 1858"
	},
	CPM: {
		a: 6375738.7,
		rf: 334.29,
		ellipseName: "Comm. des Poids et Mesures 1799"
	},
	delmbr: {
		a: 6376428,
		rf: 311.5,
		ellipseName: "Delambre 1810 (Belgium)"
	},
	engelis: {
		a: 6378136.05,
		rf: 298.2566,
		ellipseName: "Engelis 1985"
	},
	evrst30: {
		a: 6377276.345,
		rf: 300.8017,
		ellipseName: "Everest 1830"
	},
	evrst48: {
		a: 6377304.063,
		rf: 300.8017,
		ellipseName: "Everest 1948"
	},
	evrst56: {
		a: 6377301.243,
		rf: 300.8017,
		ellipseName: "Everest 1956"
	},
	evrst69: {
		a: 6377295.664,
		rf: 300.8017,
		ellipseName: "Everest 1969"
	},
	evrstSS: {
		a: 6377298.556,
		rf: 300.8017,
		ellipseName: "Everest (Sabah & Sarawak)"
	},
	fschr60: {
		a: 6378166,
		rf: 298.3,
		ellipseName: "Fischer (Mercury Datum) 1960"
	},
	fschr60m: {
		a: 6378155,
		rf: 298.3,
		ellipseName: "Fischer 1960"
	},
	fschr68: {
		a: 6378150,
		rf: 298.3,
		ellipseName: "Fischer 1968"
	},
	helmert: {
		a: 6378200,
		rf: 298.3,
		ellipseName: "Helmert 1906"
	},
	hough: {
		a: 6378270,
		rf: 297,
		ellipseName: "Hough"
	},
	intl: {
		a: 6378388,
		rf: 297,
		ellipseName: "International 1909 (Hayford)"
	},
	kaula: {
		a: 6378163,
		rf: 298.24,
		ellipseName: "Kaula 1961"
	},
	lerch: {
		a: 6378139,
		rf: 298.257,
		ellipseName: "Lerch 1979"
	},
	mprts: {
		a: 6397300,
		rf: 191,
		ellipseName: "Maupertius 1738"
	},
	new_intl: {
		a: 6378157.5,
		b: 6356772.2,
		ellipseName: "New International 1967"
	},
	plessis: {
		a: 6376523,
		b: 6355863,
		ellipseName: "Plessis 1817 (France)"
	},
	krass: {
		a: 6378245,
		rf: 298.3,
		ellipseName: "Krassovsky, 1942"
	},
	SEasia: {
		a: 6378155,
		b: 6356773.3205,
		ellipseName: "Southeast Asia"
	},
	walbeck: {
		a: 6376896,
		b: 6355834.8467,
		ellipseName: "Walbeck"
	},
	WGS60: {
		a: 6378165,
		rf: 298.3,
		ellipseName: "WGS 60"
	},
	WGS66: {
		a: 6378145,
		rf: 298.25,
		ellipseName: "WGS 66"
	},
	WGS7: {
		a: 6378135,
		rf: 298.26,
		ellipseName: "WGS 72"
	},
	WGS84: {
		a: 6378137,
		rf: 298.257223563,
		ellipseName: "WGS 84"
	},
	sphere: {
		a: 6370997,
		b: 6370997,
		ellipseName: "Normal Sphere (r=6370997)"
	}
}, kn = On.WGS84;
function An(e, t, n, r) {
	var i = e * e, a = t * t, o = (i - a) / i, s = 0;
	r ? (e *= 1 - o * (st + o * (ct + o * lt)), i = e * e, o = 0) : s = Math.sqrt(o);
	var c = (i - a) / a;
	return {
		es: o,
		e: s,
		ep2: c
	};
}
function jn(e, t, n, r, i) {
	if (!e) {
		var a = yt(On, r);
		a ||= kn, e = a.a, t = a.b, n = a.rf;
	}
	return n && !t && (t = (1 - 1 / n) * e), (n === 0 || Math.abs(e - t) < 1e-10) && (i = !0, t = e), {
		a: e,
		b: t,
		rf: n,
		sphere: i
	};
}
//#endregion
//#region node_modules/proj4/lib/constants/Datum.js
var Mn = {
	wgs84: {
		towgs84: "0,0,0",
		ellipse: "WGS84",
		datumName: "WGS84"
	},
	ch1903: {
		towgs84: "674.374,15.056,405.346",
		ellipse: "bessel",
		datumName: "swiss"
	},
	ggrs87: {
		towgs84: "-199.87,74.79,246.62",
		ellipse: "GRS80",
		datumName: "Greek_Geodetic_Reference_System_1987"
	},
	nad83: {
		towgs84: "0,0,0",
		ellipse: "GRS80",
		datumName: "North_American_Datum_1983"
	},
	nad27: {
		nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
		ellipse: "clrk66",
		datumName: "North_American_Datum_1927"
	},
	potsdam: {
		towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
		ellipse: "bessel",
		datumName: "Potsdam Rauenberg 1950 DHDN"
	},
	carthage: {
		towgs84: "-263.0,6.0,431.0",
		ellipse: "clrk80ign",
		datumName: "Carthage 1934 Tunisia"
	},
	hermannskogel: {
		towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
		ellipse: "bessel",
		datumName: "Hermannskogel"
	},
	mgi: {
		towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
		ellipse: "bessel",
		datumName: "Militar-Geographische Institut"
	},
	osni52: {
		towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
		ellipse: "airy",
		datumName: "Irish National"
	},
	ire65: {
		towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
		ellipse: "mod_airy",
		datumName: "Ireland 1965"
	},
	rassadiran: {
		towgs84: "-133.63,-157.5,-158.62",
		ellipse: "intl",
		datumName: "Rassadiran"
	},
	nzgd49: {
		towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
		ellipse: "intl",
		datumName: "New Zealand Geodetic Datum 1949"
	},
	osgb36: {
		towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
		ellipse: "airy",
		datumName: "Ordnance Survey of Great Britain 1936"
	},
	s_jtsk: {
		towgs84: "589,76,480",
		ellipse: "bessel",
		datumName: "S-JTSK (Ferro)"
	},
	beduaram: {
		towgs84: "-106,-87,188",
		ellipse: "clrk80",
		datumName: "Beduaram"
	},
	gunung_segara: {
		towgs84: "-403,684,41",
		ellipse: "bessel",
		datumName: "Gunung Segara Jakarta"
	},
	rnb72: {
		towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
		ellipse: "intl",
		datumName: "Reseau National Belge 1972"
	},
	EPSG_5451: { towgs84: "6.41,-49.05,-11.28,1.5657,0.5242,6.9718,-5.7649" },
	IGNF_LURESG: { towgs84: "-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43" },
	EPSG_4614: { towgs84: "-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065" },
	EPSG_4615: { towgs84: "-494.088,-312.129,279.877,-1.423,-1.013,1.59,-0.748" },
	ESRI_37241: { towgs84: "-76.822,257.457,-12.817,2.136,-0.033,-2.392,-0.031" },
	ESRI_37249: { towgs84: "-440.296,58.548,296.265,1.128,10.202,4.559,-0.438" },
	ESRI_37245: { towgs84: "-511.151,-181.269,139.609,1.05,2.703,1.798,3.071" },
	EPSG_4178: { towgs84: "24.9,-126.4,-93.2,-0.063,-0.247,-0.041,1.01" },
	EPSG_4622: { towgs84: "-472.29,-5.63,-304.12,0.4362,-0.8374,0.2563,1.8984" },
	EPSG_4625: { towgs84: "126.93,547.94,130.41,-2.7867,5.1612,-0.8584,13.8227" },
	EPSG_5252: { towgs84: "0.023,0.036,-0.068,0.00176,0.00912,-0.01136,0.00439" },
	EPSG_4314: { towgs84: "597.1,71.4,412.1,0.894,0.068,-1.563,7.58" },
	EPSG_4282: { towgs84: "-178.3,-316.7,-131.5,5.278,6.077,10.979,19.166" },
	EPSG_4231: { towgs84: "-83.11,-97.38,-117.22,0.005693,-0.044698,0.044285,0.1218" },
	EPSG_4274: { towgs84: "-230.994,102.591,25.199,0.633,-0.239,0.9,1.95" },
	EPSG_4134: { towgs84: "-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006" },
	EPSG_4254: { towgs84: "18.38,192.45,96.82,0.056,-0.142,-0.2,-0.0013" },
	EPSG_4159: { towgs84: "-194.513,-63.978,-25.759,-3.4027,3.756,-3.352,-0.9175" },
	EPSG_4687: { towgs84: "0.072,-0.507,-0.245,0.0183,-0.0003,0.007,-0.0093" },
	EPSG_4227: { towgs84: "-83.58,-397.54,458.78,-17.595,-2.847,4.256,3.225" },
	EPSG_4746: { towgs84: "599.4,72.4,419.2,-0.062,-0.022,-2.723,6.46" },
	EPSG_4745: { towgs84: "612.4,77,440.2,-0.054,0.057,-2.797,2.55" },
	EPSG_6311: { towgs84: "8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926" },
	EPSG_4289: { towgs84: "565.7381,50.4018,465.2904,-0.395026,0.330772,-1.876073,4.07244" },
	EPSG_4230: { towgs84: "-68.863,-134.888,-111.49,-0.53,-0.14,0.57,-3.4" },
	EPSG_4154: { towgs84: "-123.02,-158.95,-168.47" },
	EPSG_4156: { towgs84: "570.8,85.7,462.8,4.998,1.587,5.261,3.56" },
	EPSG_4299: { towgs84: "482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15" },
	EPSG_4179: { towgs84: "33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84" },
	EPSG_4313: { towgs84: "-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747" },
	EPSG_4194: { towgs84: "163.511,127.533,-159.789" },
	EPSG_4195: { towgs84: "105,326,-102.5" },
	EPSG_4196: { towgs84: "-45,417,-3.5" },
	EPSG_4611: { towgs84: "-162.619,-276.959,-161.764,0.067753,-2.243648,-1.158828,-1.094246" },
	EPSG_4633: { towgs84: "137.092,131.66,91.475,-1.9436,-11.5993,-4.3321,-7.4824" },
	EPSG_4641: { towgs84: "-408.809,366.856,-412.987,1.8842,-0.5308,2.1655,-121.0993" },
	EPSG_4643: { towgs84: "-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002" },
	EPSG_4300: { towgs84: "482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15" },
	EPSG_4188: { towgs84: "482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15" },
	EPSG_4660: { towgs84: "982.6087,552.753,-540.873,6.681627,-31.611492,-19.848161,16.805" },
	EPSG_4662: { towgs84: "97.295,-263.247,310.882,-1.5999,0.8386,3.1409,13.3259" },
	EPSG_3906: { towgs84: "577.88891,165.22205,391.18289,4.9145,-0.94729,-13.05098,7.78664" },
	EPSG_4307: { towgs84: "-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547" },
	EPSG_6892: { towgs84: "-76.269,-16.683,68.562,-6.275,10.536,-4.286,-13.686" },
	EPSG_4690: { towgs84: "221.597,152.441,176.523,2.403,1.3893,0.884,11.4648" },
	EPSG_4691: { towgs84: "218.769,150.75,176.75,3.5231,2.0037,1.288,10.9817" },
	EPSG_4629: { towgs84: "72.51,345.411,79.241,-1.5862,-0.8826,-0.5495,1.3653" },
	EPSG_4630: { towgs84: "165.804,216.213,180.26,-0.6251,-0.4515,-0.0721,7.4111" },
	EPSG_4692: { towgs84: "217.109,86.452,23.711,0.0183,-0.0003,0.007,-0.0093" },
	EPSG_9333: { towgs84: "0,0,0,-0.008393,0.000749,-0.010276,0" },
	EPSG_9059: { towgs84: "0,0,0" },
	EPSG_4312: { towgs84: "601.705,84.263,485.227,4.7354,1.3145,5.393,-2.3887" },
	EPSG_4123: { towgs84: "-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496" },
	EPSG_4309: { towgs84: "-124.45,183.74,44.64,-0.4384,0.5446,-0.9706,-2.1365" },
	ESRI_104106: { towgs84: "-283.088,-70.693,117.445,-1.157,0.059,-0.652,-4.058" },
	EPSG_4281: { towgs84: "-219.247,-73.802,269.529" },
	EPSG_4322: { towgs84: "0,0,4.5" },
	EPSG_4324: { towgs84: "0,0,1.9" },
	EPSG_4284: { towgs84: "43.822,-108.842,-119.585,1.455,-0.761,0.737,0.549" },
	EPSG_4277: { towgs84: "446.448,-125.157,542.06,0.15,0.247,0.842,-20.489" },
	EPSG_4207: { towgs84: "-282.1,-72.2,120,-1.529,0.145,-0.89,-4.46" },
	EPSG_4688: { towgs84: "347.175,1077.618,2623.677,33.9058,-70.6776,9.4013,186.0647" },
	EPSG_4689: { towgs84: "410.793,54.542,80.501,-2.5596,-2.3517,-0.6594,17.3218" },
	EPSG_4720: { towgs84: "0,0,4.5" },
	EPSG_4273: { towgs84: "278.3,93,474.5,7.889,0.05,-6.61,6.21" },
	EPSG_4240: { towgs84: "204.64,834.74,293.8" },
	EPSG_4817: { towgs84: "278.3,93,474.5,7.889,0.05,-6.61,6.21" },
	ESRI_104131: { towgs84: "426.62,142.62,460.09,4.98,4.49,-12.42,-17.1" },
	EPSG_4265: { towgs84: "-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68" },
	EPSG_4263: { towgs84: "-111.92,-87.85,114.5,1.875,0.202,0.219,0.032" },
	EPSG_4298: { towgs84: "-689.5937,623.84046,-65.93566,-0.02331,1.17094,-0.80054,5.88536" },
	EPSG_4270: { towgs84: "-253.4392,-148.452,386.5267,0.15605,0.43,-0.1013,-0.0424" },
	EPSG_4229: { towgs84: "-121.8,98.1,-10.7" },
	EPSG_4220: { towgs84: "-55.5,-348,-229.2" },
	EPSG_4214: { towgs84: "12.646,-155.176,-80.863" },
	EPSG_4232: { towgs84: "-345,3,223" },
	EPSG_4238: { towgs84: "-1.977,-13.06,-9.993,0.364,0.254,0.689,-1.037" },
	EPSG_4168: { towgs84: "-170,33,326" },
	EPSG_4131: { towgs84: "199,931,318.9" },
	EPSG_4152: { towgs84: "-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0" },
	EPSG_5228: { towgs84: "572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378" },
	EPSG_8351: { towgs84: "485.021,169.465,483.839,7.786342,4.397554,4.102655,0" },
	EPSG_4683: { towgs84: "-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06" },
	EPSG_4133: { towgs84: "0,0,0" },
	EPSG_7373: { towgs84: "0.819,-0.5762,-1.6446,-0.00378,-0.03317,0.00318,0.0693" },
	EPSG_9075: { towgs84: "-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0" },
	EPSG_9072: { towgs84: "-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0" },
	EPSG_9294: { towgs84: "1.16835,-1.42001,-2.24431,-0.00822,-0.05508,0.01818,0.23388" },
	EPSG_4212: { towgs84: "-267.434,173.496,181.814,-13.4704,8.7154,7.3926,14.7492" },
	EPSG_4191: { towgs84: "-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703" },
	EPSG_4237: { towgs84: "52.684,-71.194,-13.975,-0.312,-0.1063,-0.3729,1.0191" },
	EPSG_4740: { towgs84: "-1.08,-0.27,-0.9" },
	EPSG_4124: { towgs84: "419.3836,99.3335,591.3451,0.850389,1.817277,-7.862238,-0.99496" },
	EPSG_5681: { towgs84: "584.9636,107.7175,413.8067,1.1155,0.2824,-3.1384,7.9922" },
	EPSG_4141: { towgs84: "23.772,17.49,17.859,-0.3132,-1.85274,1.67299,-5.4262" },
	EPSG_4204: { towgs84: "-85.645,-273.077,-79.708,2.289,-1.421,2.532,3.194" },
	EPSG_4319: { towgs84: "226.702,-193.337,-35.371,-2.229,-4.391,9.238,0.9798" },
	EPSG_4200: { towgs84: "24.82,-131.21,-82.66" },
	EPSG_4130: { towgs84: "0,0,0" },
	EPSG_4127: { towgs84: "-82.875,-57.097,-156.768,-2.158,1.524,-0.982,-0.359" },
	EPSG_4149: { towgs84: "674.374,15.056,405.346" },
	EPSG_4617: { towgs84: "-0.991,1.9072,0.5129,0.02579,0.00965,0.01166,0" },
	EPSG_4663: { towgs84: "-210.502,-66.902,-48.476,2.094,-15.067,-5.817,0.485" },
	EPSG_4664: { towgs84: "-211.939,137.626,58.3,-0.089,0.251,0.079,0.384" },
	EPSG_4665: { towgs84: "-105.854,165.589,-38.312,-0.003,-0.026,0.024,-0.048" },
	EPSG_4666: { towgs84: "631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43" },
	EPSG_4756: { towgs84: "-192.873,-39.382,-111.202,-0.00205,-0.0005,0.00335,0.0188" },
	EPSG_4723: { towgs84: "-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925" },
	EPSG_4726: { towgs84: "8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081" },
	EPSG_4267: { towgs84: "-8.0,160.0,176.0" },
	EPSG_5365: { towgs84: "-0.16959,0.35312,0.51846,0.03385,-0.16325,0.03446,0.03693" },
	EPSG_4218: { towgs84: "304.5,306.5,-318.1" },
	EPSG_4242: { towgs84: "-33.722,153.789,94.959,-8.581,-4.478,4.54,8.95" },
	EPSG_4216: { towgs84: "-292.295,248.758,429.447,4.9971,2.99,6.6906,1.0289" },
	ESRI_104105: { towgs84: "631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43" },
	ESRI_104129: { towgs84: "0,0,0" },
	EPSG_4673: { towgs84: "174.05,-25.49,112.57" },
	EPSG_4202: { towgs84: "-124,-60,154" },
	EPSG_4203: { towgs84: "-117.763,-51.51,139.061,0.292,0.443,0.277,-0.191" },
	EPSG_3819: { towgs84: "595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408" },
	EPSG_8694: { towgs84: "-93.799,-132.737,-219.073,-1.844,0.648,-6.37,-0.169" },
	EPSG_4145: { towgs84: "275.57,676.78,229.6" },
	EPSG_4283: { towgs84: "0.06155,-0.01087,-0.04019,0.039492,0.032722,0.032898,-0.009994" },
	EPSG_4317: { towgs84: "2.3287,-147.0425,-92.0802,-0.309248,0.324822,0.497299,5.689063" },
	EPSG_4272: { towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993" },
	EPSG_4248: { towgs84: "-307.7,265.3,-363.5" },
	EPSG_5561: { towgs84: "24,-121,-76" },
	EPSG_5233: { towgs84: "-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338" },
	ESRI_104130: { towgs84: "-86,-98,-119" },
	ESRI_104102: { towgs84: "682,-203,480" },
	ESRI_37207: { towgs84: "7,-10,-26" },
	EPSG_4675: { towgs84: "59.935,118.4,-10.871" },
	ESRI_104109: { towgs84: "-89.121,-348.182,260.871" },
	ESRI_104112: { towgs84: "-185.583,-230.096,281.361" },
	ESRI_104113: { towgs84: "25.1,-275.6,222.6" },
	IGNF_WGS72G: { towgs84: "0,12,6" },
	IGNF_NTFG: { towgs84: "-168,-60,320" },
	IGNF_EFATE57G: { towgs84: "-127,-769,472" },
	IGNF_PGP50G: { towgs84: "324.8,153.6,172.1" },
	IGNF_REUN47G: { towgs84: "94,-948,-1262" },
	IGNF_CSG67G: { towgs84: "-186,230,110" },
	IGNF_GUAD48G: { towgs84: "-467,-16,-300" },
	IGNF_TAHI51G: { towgs84: "162,117,154" },
	IGNF_TAHAAG: { towgs84: "65,342,77" },
	IGNF_NUKU72G: { towgs84: "84,274,65" },
	IGNF_PETRELS72G: { towgs84: "365,194,166" },
	IGNF_WALL78G: { towgs84: "253,-133,-127" },
	IGNF_MAYO50G: { towgs84: "-382,-59,-262" },
	IGNF_TANNAG: { towgs84: "-139,-967,436" },
	IGNF_IGN72G: { towgs84: "-13,-348,292" },
	IGNF_ATIGG: { towgs84: "1118,23,66" },
	IGNF_FANGA84G: { towgs84: "150.57,158.33,118.32" },
	IGNF_RUSAT84G: { towgs84: "202.13,174.6,-15.74" },
	IGNF_KAUE70G: { towgs84: "126.74,300.1,-75.49" },
	IGNF_MOP90G: { towgs84: "-10.8,-1.8,12.77" },
	IGNF_MHPF67G: { towgs84: "338.08,212.58,-296.17" },
	IGNF_TAHI79G: { towgs84: "160.61,116.05,153.69" },
	IGNF_ANAA92G: { towgs84: "1.5,3.84,4.81" },
	IGNF_MARQUI72G: { towgs84: "330.91,-13.92,58.56" },
	IGNF_APAT86G: { towgs84: "143.6,197.82,74.05" },
	IGNF_TUBU69G: { towgs84: "237.17,171.61,-77.84" },
	IGNF_STPM50G: { towgs84: "11.363,424.148,373.13" },
	EPSG_4150: { towgs84: "674.374,15.056,405.346" },
	EPSG_4754: { towgs84: "-208.4058,-109.8777,-2.5764" },
	ESRI_104101: { towgs84: "372.87,149.23,585.29" },
	EPSG_4693: { towgs84: "0,-0.15,0.68" },
	EPSG_6207: { towgs84: "293.17,726.18,245.36" },
	EPSG_4153: { towgs84: "-133.63,-157.5,-158.62" },
	EPSG_4132: { towgs84: "-241.54,-163.64,396.06" },
	EPSG_4221: { towgs84: "-154.5,150.7,100.4" },
	EPSG_4266: { towgs84: "-80.7,-132.5,41.1" },
	EPSG_4193: { towgs84: "-70.9,-151.8,-41.4" },
	EPSG_5340: { towgs84: "-0.41,0.46,-0.35" },
	EPSG_4246: { towgs84: "-294.7,-200.1,525.5" },
	EPSG_4318: { towgs84: "-3.2,-5.7,2.8" },
	EPSG_4121: { towgs84: "-199.87,74.79,246.62" },
	EPSG_4223: { towgs84: "-260.1,5.5,432.2" },
	EPSG_4158: { towgs84: "-0.465,372.095,171.736" },
	EPSG_4285: { towgs84: "-128.16,-282.42,21.93" },
	EPSG_4613: { towgs84: "-404.78,685.68,45.47" },
	EPSG_4607: { towgs84: "195.671,332.517,274.607" },
	EPSG_4475: { towgs84: "-381.788,-57.501,-256.673" },
	EPSG_4208: { towgs84: "-157.84,308.54,-146.6" },
	EPSG_4743: { towgs84: "70.995,-335.916,262.898" },
	EPSG_4710: { towgs84: "-323.65,551.39,-491.22" },
	EPSG_7881: { towgs84: "-0.077,0.079,0.086" },
	EPSG_4682: { towgs84: "283.729,735.942,261.143" },
	EPSG_4739: { towgs84: "-156,-271,-189" },
	EPSG_4679: { towgs84: "-80.01,253.26,291.19" },
	EPSG_4750: { towgs84: "-56.263,16.136,-22.856" },
	EPSG_4644: { towgs84: "-10.18,-350.43,291.37" },
	EPSG_4695: { towgs84: "-103.746,-9.614,-255.95" },
	EPSG_4292: { towgs84: "-355,21,72" },
	EPSG_4302: { towgs84: "-61.702,284.488,472.052" },
	EPSG_4143: { towgs84: "-124.76,53,466.79" },
	EPSG_4606: { towgs84: "-153,153,307" },
	EPSG_4699: { towgs84: "-770.1,158.4,-498.2" },
	EPSG_4247: { towgs84: "-273.5,110.6,-357.9" },
	EPSG_4160: { towgs84: "8.88,184.86,106.69" },
	EPSG_4161: { towgs84: "-233.43,6.65,173.64" },
	EPSG_9251: { towgs84: "-9.5,122.9,138.2" },
	EPSG_9253: { towgs84: "-78.1,101.6,133.3" },
	EPSG_4297: { towgs84: "-198.383,-240.517,-107.909" },
	EPSG_4269: { towgs84: "0,0,0" },
	EPSG_4301: { towgs84: "-147,506,687" },
	EPSG_4618: { towgs84: "-59,-11,-52" },
	EPSG_4612: { towgs84: "0,0,0" },
	EPSG_4678: { towgs84: "44.585,-131.212,-39.544" },
	EPSG_4250: { towgs84: "-130,29,364" },
	EPSG_4144: { towgs84: "214,804,268" },
	EPSG_4147: { towgs84: "-17.51,-108.32,-62.39" },
	EPSG_4259: { towgs84: "-254.1,-5.36,-100.29" },
	EPSG_4164: { towgs84: "-76,-138,67" },
	EPSG_4211: { towgs84: "-378.873,676.002,-46.255" },
	EPSG_4182: { towgs84: "-422.651,-172.995,84.02" },
	EPSG_4224: { towgs84: "-143.87,243.37,-33.52" },
	EPSG_4225: { towgs84: "-205.57,168.77,-4.12" },
	EPSG_5527: { towgs84: "-67.35,3.88,-38.22" },
	EPSG_4752: { towgs84: "98,390,-22" },
	EPSG_4310: { towgs84: "-30,190,89" },
	EPSG_9248: { towgs84: "-192.26,65.72,132.08" },
	EPSG_4680: { towgs84: "124.5,-63.5,-281" },
	EPSG_4701: { towgs84: "-79.9,-158,-168.9" },
	EPSG_4706: { towgs84: "-146.21,112.63,4.05" },
	EPSG_4805: { towgs84: "682,-203,480" },
	EPSG_4201: { towgs84: "-165,-11,206" },
	EPSG_4210: { towgs84: "-157,-2,-299" },
	EPSG_4183: { towgs84: "-104,167,-38" },
	EPSG_4139: { towgs84: "11,72,-101" },
	EPSG_4668: { towgs84: "-86,-98,-119" },
	EPSG_4717: { towgs84: "-2,151,181" },
	EPSG_4732: { towgs84: "102,52,-38" },
	EPSG_4280: { towgs84: "-377,681,-50" },
	EPSG_4209: { towgs84: "-138,-105,-289" },
	EPSG_4261: { towgs84: "31,146,47" },
	EPSG_4658: { towgs84: "-73,46,-86" },
	EPSG_4721: { towgs84: "265.025,384.929,-194.046" },
	EPSG_4222: { towgs84: "-136,-108,-292" },
	EPSG_4601: { towgs84: "-255,-15,71" },
	EPSG_4602: { towgs84: "725,685,536" },
	EPSG_4603: { towgs84: "72,213.7,93" },
	EPSG_4605: { towgs84: "9,183,236" },
	EPSG_4621: { towgs84: "137,248,-430" },
	EPSG_4657: { towgs84: "-28,199,5" },
	EPSG_4316: { towgs84: "103.25,-100.4,-307.19" },
	EPSG_4642: { towgs84: "-13,-348,292" },
	EPSG_4698: { towgs84: "145,-187,103" },
	EPSG_4192: { towgs84: "-206.1,-174.7,-87.7" },
	EPSG_4311: { towgs84: "-265,120,-358" },
	EPSG_4135: { towgs84: "58,-283,-182" },
	ESRI_104138: { towgs84: "198,-226,-347" },
	EPSG_4245: { towgs84: "-11,851,5" },
	EPSG_4142: { towgs84: "-125,53,467" },
	EPSG_4213: { towgs84: "-106,-87,188" },
	EPSG_4253: { towgs84: "-133,-77,-51" },
	EPSG_4129: { towgs84: "-132,-110,-335" },
	EPSG_4713: { towgs84: "-77,-128,142" },
	EPSG_4239: { towgs84: "217,823,299" },
	EPSG_4146: { towgs84: "295,736,257" },
	EPSG_4155: { towgs84: "-83,37,124" },
	EPSG_4165: { towgs84: "-173,253,27" },
	EPSG_4672: { towgs84: "175,-38,113" },
	EPSG_4236: { towgs84: "-637,-549,-203" },
	EPSG_4251: { towgs84: "-90,40,88" },
	EPSG_4271: { towgs84: "-2,374,172" },
	EPSG_4175: { towgs84: "-88,4,101" },
	EPSG_4716: { towgs84: "298,-304,-375" },
	EPSG_4315: { towgs84: "-23,259,-9" },
	EPSG_4744: { towgs84: "-242.2,-144.9,370.3" },
	EPSG_4244: { towgs84: "-97,787,86" },
	EPSG_4293: { towgs84: "616,97,-251" },
	EPSG_4714: { towgs84: "-127,-769,472" },
	EPSG_4736: { towgs84: "260,12,-147" },
	EPSG_6883: { towgs84: "-235,-110,393" },
	EPSG_6894: { towgs84: "-63,176,185" },
	EPSG_4205: { towgs84: "-43,-163,45" },
	EPSG_4256: { towgs84: "41,-220,-134" },
	EPSG_4262: { towgs84: "639,405,60" },
	EPSG_4604: { towgs84: "174,359,365" },
	EPSG_4169: { towgs84: "-115,118,426" },
	EPSG_4620: { towgs84: "-106,-129,165" },
	EPSG_4184: { towgs84: "-203,141,53" },
	EPSG_4616: { towgs84: "-289,-124,60" },
	EPSG_9403: { towgs84: "-307,-92,127" },
	EPSG_4684: { towgs84: "-133,-321,50" },
	EPSG_4708: { towgs84: "-491,-22,435" },
	EPSG_4707: { towgs84: "114,-116,-333" },
	EPSG_4709: { towgs84: "145,75,-272" },
	EPSG_4712: { towgs84: "-205,107,53" },
	EPSG_4711: { towgs84: "124,-234,-25" },
	EPSG_4718: { towgs84: "230,-199,-752" },
	EPSG_4719: { towgs84: "211,147,111" },
	EPSG_4724: { towgs84: "208,-435,-229" },
	EPSG_4725: { towgs84: "189,-79,-202" },
	EPSG_4735: { towgs84: "647,1777,-1124" },
	EPSG_4722: { towgs84: "-794,119,-298" },
	EPSG_4728: { towgs84: "-307,-92,127" },
	EPSG_4734: { towgs84: "-632,438,-609" },
	EPSG_4727: { towgs84: "912,-58,1227" },
	EPSG_4729: { towgs84: "185,165,42" },
	EPSG_4730: { towgs84: "170,42,84" },
	EPSG_4733: { towgs84: "276,-57,149" },
	ESRI_37218: { towgs84: "230,-199,-752" },
	ESRI_37240: { towgs84: "-7,215,225" },
	ESRI_37221: { towgs84: "252,-209,-751" },
	ESRI_4305: { towgs84: "-123,-206,219" },
	ESRI_104139: { towgs84: "-73,-247,227" },
	EPSG_4748: { towgs84: "51,391,-36" },
	EPSG_4219: { towgs84: "-384,664,-48" },
	EPSG_4255: { towgs84: "-333,-222,114" },
	EPSG_4257: { towgs84: "-587.8,519.75,145.76" },
	EPSG_4646: { towgs84: "-963,510,-359" },
	EPSG_6881: { towgs84: "-24,-203,268" },
	EPSG_6882: { towgs84: "-183,-15,273" },
	EPSG_4715: { towgs84: "-104,-129,239" },
	IGNF_RGF93GDD: { towgs84: "0,0,0" },
	IGNF_RGM04GDD: { towgs84: "0,0,0" },
	IGNF_RGSPM06GDD: { towgs84: "0,0,0" },
	IGNF_RGTAAF07GDD: { towgs84: "0,0,0" },
	IGNF_RGFG95GDD: { towgs84: "0,0,0" },
	IGNF_RGNCG: { towgs84: "0,0,0" },
	IGNF_RGPFGDD: { towgs84: "0,0,0" },
	IGNF_ETRS89G: { towgs84: "0,0,0" },
	IGNF_RGR92GDD: { towgs84: "0,0,0" },
	EPSG_4173: { towgs84: "0,0,0" },
	EPSG_4180: { towgs84: "0,0,0" },
	EPSG_4619: { towgs84: "0,0,0" },
	EPSG_4667: { towgs84: "0,0,0" },
	EPSG_4075: { towgs84: "0,0,0" },
	EPSG_6706: { towgs84: "0,0,0" },
	EPSG_7798: { towgs84: "0,0,0" },
	EPSG_4661: { towgs84: "0,0,0" },
	EPSG_4669: { towgs84: "0,0,0" },
	EPSG_8685: { towgs84: "0,0,0" },
	EPSG_4151: { towgs84: "0,0,0" },
	EPSG_9702: { towgs84: "0,0,0" },
	EPSG_4758: { towgs84: "0,0,0" },
	EPSG_4761: { towgs84: "0,0,0" },
	EPSG_4765: { towgs84: "0,0,0" },
	EPSG_8997: { towgs84: "0,0,0" },
	EPSG_4023: { towgs84: "0,0,0" },
	EPSG_4670: { towgs84: "0,0,0" },
	EPSG_4694: { towgs84: "0,0,0" },
	EPSG_4148: { towgs84: "0,0,0" },
	EPSG_4163: { towgs84: "0,0,0" },
	EPSG_4167: { towgs84: "0,0,0" },
	EPSG_4189: { towgs84: "0,0,0" },
	EPSG_4190: { towgs84: "0,0,0" },
	EPSG_4176: { towgs84: "0,0,0" },
	EPSG_4659: { towgs84: "0,0,0" },
	EPSG_3824: { towgs84: "0,0,0" },
	EPSG_3889: { towgs84: "0,0,0" },
	EPSG_4046: { towgs84: "0,0,0" },
	EPSG_4081: { towgs84: "0,0,0" },
	EPSG_4558: { towgs84: "0,0,0" },
	EPSG_4483: { towgs84: "0,0,0" },
	EPSG_5013: { towgs84: "0,0,0" },
	EPSG_5264: { towgs84: "0,0,0" },
	EPSG_5324: { towgs84: "0,0,0" },
	EPSG_5354: { towgs84: "0,0,0" },
	EPSG_5371: { towgs84: "0,0,0" },
	EPSG_5373: { towgs84: "0,0,0" },
	EPSG_5381: { towgs84: "0,0,0" },
	EPSG_5393: { towgs84: "0,0,0" },
	EPSG_5489: { towgs84: "0,0,0" },
	EPSG_5593: { towgs84: "0,0,0" },
	EPSG_6135: { towgs84: "0,0,0" },
	EPSG_6365: { towgs84: "0,0,0" },
	EPSG_5246: { towgs84: "0,0,0" },
	EPSG_7886: { towgs84: "0,0,0" },
	EPSG_8431: { towgs84: "0,0,0" },
	EPSG_8427: { towgs84: "0,0,0" },
	EPSG_8699: { towgs84: "0,0,0" },
	EPSG_8818: { towgs84: "0,0,0" },
	EPSG_4757: { towgs84: "0,0,0" },
	EPSG_9140: { towgs84: "0,0,0" },
	EPSG_8086: { towgs84: "0,0,0" },
	EPSG_4686: { towgs84: "0,0,0" },
	EPSG_4737: { towgs84: "0,0,0" },
	EPSG_4702: { towgs84: "0,0,0" },
	EPSG_4747: { towgs84: "0,0,0" },
	EPSG_4749: { towgs84: "0,0,0" },
	EPSG_4674: { towgs84: "0,0,0" },
	EPSG_4755: { towgs84: "0,0,0" },
	EPSG_4759: { towgs84: "0,0,0" },
	EPSG_4762: { towgs84: "0,0,0" },
	EPSG_4763: { towgs84: "0,0,0" },
	EPSG_4764: { towgs84: "0,0,0" },
	EPSG_4166: { towgs84: "0,0,0" },
	EPSG_4170: { towgs84: "0,0,0" },
	EPSG_5546: { towgs84: "0,0,0" },
	EPSG_7844: { towgs84: "0,0,0" },
	EPSG_4818: { towgs84: "589,76,480" },
	EPSG_10328: { towgs84: "0,0,0" },
	EPSG_9782: { towgs84: "0,0,0" },
	EPSG_9777: { towgs84: "0,0,0" },
	EPSG_10690: { towgs84: "0,0,0" },
	EPSG_10639: { towgs84: "0,0,0" },
	EPSG_10739: { towgs84: "0,0,0" },
	EPSG_7686: { towgs84: "0,0,0" },
	EPSG_8900: { towgs84: "0,0,0" },
	EPSG_5886: { towgs84: "0,0,0" },
	EPSG_7683: { towgs84: "0,0,0" },
	EPSG_6668: { towgs84: "0,0,0" },
	EPSG_20046: { towgs84: "0,0,0" },
	EPSG_10299: { towgs84: "0,0,0" },
	EPSG_10310: { towgs84: "0,0,0" },
	EPSG_10475: { towgs84: "0,0,0" },
	EPSG_4742: { towgs84: "0,0,0" },
	EPSG_10671: { towgs84: "0,0,0" },
	EPSG_10762: { towgs84: "0,0,0" },
	EPSG_10725: { towgs84: "0,0,0" },
	EPSG_10791: { towgs84: "0,0,0" },
	EPSG_10800: { towgs84: "0,0,0" },
	EPSG_10305: { towgs84: "0,0,0" },
	EPSG_10941: { towgs84: "0,0,0" },
	EPSG_10968: { towgs84: "0,0,0" },
	EPSG_10875: { towgs84: "0,0,0" },
	EPSG_6318: { towgs84: "0,0,0" },
	EPSG_10910: { towgs84: "0,0,0" }
};
for (var Nn in Mn) {
	var Pn = Mn[Nn];
	Pn.datumName && (Mn[Pn.datumName] = Pn);
}
//#endregion
//#region node_modules/proj4/lib/datum.js
function Fn(e, t, n, r, i, a, o) {
	var s = {};
	return s.datum_type = 5, t && (s.datum_type = 4, s.datum_params = t.map(parseFloat), (s.datum_params[0] !== 0 || s.datum_params[1] !== 0 || s.datum_params[2] !== 0) && (s.datum_type = 1), s.datum_params.length > 3 && (s.datum_params[3] !== 0 || s.datum_params[4] !== 0 || s.datum_params[5] !== 0 || s.datum_params[6] !== 0) && (s.datum_type = 2, s.datum_params[3] *= ot, s.datum_params[4] *= ot, s.datum_params[5] *= ot, s.datum_params[6] = s.datum_params[6] / 1e6 + 1)), o && (s.datum_type = 3, s.grids = o), s.a = n, s.b = r, s.es = i, s.ep2 = a, s;
}
//#endregion
//#region node_modules/proj4/lib/nadgrid.js
var In = {};
function Ln(e, t, n) {
	return t instanceof ArrayBuffer ? Rn(e, t, n) : { ready: zn(e, t) };
}
function Rn(e, t, n) {
	var r = !0;
	n !== void 0 && n.includeErrorFields === !1 && (r = !1);
	var i = new DataView(t), a = Wn(i), o = Gn(i, a), s = {
		header: o,
		subgrids: qn(i, o, a, r)
	};
	return In[e] = s, s;
}
async function zn(e, t) {
	for (var n = [], r = await t.getImageCount(), i = r - 1; i >= 0; i--) {
		var a = await t.getImage(i), o = await a.readRasters(), s = [a.getWidth(), a.getHeight()], c = a.getBoundingBox().map(Hn), l = typeof a.fileDirectory.getValue == "function" ? a.fileDirectory.getValue("ModelPixelScale") : a.fileDirectory.ModelPixelScale, u = [l[0], l[1]].map(Hn), d = c[0] + (s[0] - 1) * u[0], f = c[3] - (s[1] - 1) * u[1], p = o[0], m = o[1], h = [];
		for (let e = s[1] - 1; e >= 0; e--) for (let t = s[0] - 1; t >= 0; t--) {
			var g = e * s[0] + t;
			h.push([-Un(m[g]), Un(p[g])]);
		}
		n.push({
			del: u,
			lim: s,
			ll: [-d, f],
			cvs: h
		});
	}
	var _ = {
		header: { nSubgrids: r },
		subgrids: n
	};
	return In[e] = _, _;
}
function Bn(e) {
	return e === void 0 ? null : e.split(",").map(Vn);
}
function Vn(e) {
	if (e.length === 0) return null;
	var t = e[0] === "@";
	return t && (e = e.slice(1)), e === "null" ? {
		name: "null",
		mandatory: !t,
		grid: null,
		isNull: !0
	} : {
		name: e,
		mandatory: !t,
		grid: In[e] || null,
		isNull: !1
	};
}
function Hn(e) {
	return e * Math.PI / 180;
}
function Un(e) {
	return e / 3600 * Math.PI / 180;
}
function Wn(e) {
	var t = e.getInt32(8, !1);
	return t === 11 ? !1 : (t = e.getInt32(8, !0), t !== 11 && console.warn("Failed to detect nadgrid endian-ness, defaulting to little-endian"), !0);
}
function Gn(e, t) {
	return {
		nFields: e.getInt32(8, t),
		nSubgridFields: e.getInt32(24, t),
		nSubgrids: e.getInt32(40, t),
		shiftType: Kn(e, 56, 64).trim(),
		fromSemiMajorAxis: e.getFloat64(120, t),
		fromSemiMinorAxis: e.getFloat64(136, t),
		toSemiMajorAxis: e.getFloat64(152, t),
		toSemiMinorAxis: e.getFloat64(168, t)
	};
}
function Kn(e, t, n) {
	return String.fromCharCode.apply(null, new Uint8Array(e.buffer.slice(t, n)));
}
function qn(e, t, n, r) {
	for (var i = 176, a = [], o = 0; o < t.nSubgrids; o++) {
		var s = Yn(e, i, n), c = Xn(e, i, s, n, r), l = Math.round(1 + (s.upperLongitude - s.lowerLongitude) / s.longitudeInterval), u = Math.round(1 + (s.upperLatitude - s.lowerLatitude) / s.latitudeInterval);
		a.push({
			ll: [Un(s.lowerLongitude), Un(s.lowerLatitude)],
			del: [Un(s.longitudeInterval), Un(s.latitudeInterval)],
			lim: [l, u],
			count: s.gridNodeCount,
			cvs: Jn(c)
		});
		var d = 16;
		r === !1 && (d = 8), i += 176 + s.gridNodeCount * d;
	}
	return a;
}
function Jn(e) {
	return e.map(function(e) {
		return [Un(e.longitudeShift), Un(e.latitudeShift)];
	});
}
function Yn(e, t, n) {
	return {
		name: Kn(e, t + 8, t + 16).trim(),
		parent: Kn(e, t + 24, t + 24 + 8).trim(),
		lowerLatitude: e.getFloat64(t + 72, n),
		upperLatitude: e.getFloat64(t + 88, n),
		lowerLongitude: e.getFloat64(t + 104, n),
		upperLongitude: e.getFloat64(t + 120, n),
		latitudeInterval: e.getFloat64(t + 136, n),
		longitudeInterval: e.getFloat64(t + 152, n),
		gridNodeCount: e.getInt32(t + 168, n)
	};
}
function Xn(e, t, n, r, i) {
	var a = t + 176, o = 16;
	i === !1 && (o = 8);
	for (var s = [], c = 0; c < n.gridNodeCount; c++) {
		var l = {
			latitudeShift: e.getFloat32(a + c * o, r),
			longitudeShift: e.getFloat32(a + c * o + 4, r)
		};
		i !== !1 && (l.latitudeAccuracy = e.getFloat32(a + c * o + 8, r), l.longitudeAccuracy = e.getFloat32(a + c * o + 12, r)), s.push(l);
	}
	return s;
}
//#endregion
//#region node_modules/proj4/lib/Proj.js
function Zn(e, t) {
	if (!(this instanceof Zn)) return new Zn(e);
	this.forward = null, this.inverse = null, this.init = null, this.name, this.axis, this.names = null, this.title, t ||= function(e) {
		if (e) throw e;
	};
	var n = sn(e);
	if (typeof n != "object") {
		t("Could not parse to valid json: " + e);
		return;
	}
	var r = Zn.projections.get(n.projName);
	if (!r) {
		t("Could not get projection name from: " + e);
		return;
	}
	if (n.datumCode && n.datumCode !== "none") {
		var i = yt(Mn, n.datumCode);
		i && (n.datum_params = n.datum_params || (i.towgs84 ? i.towgs84.split(",") : null), n.ellps = i.ellipse, n.datumName = i.datumName ? i.datumName : n.datumCode);
	}
	n.axis = n.axis || "enu", n.ellps = n.ellps || "wgs84", n.lat1 = n.lat1 || n.lat0;
	var a = jn(n.a, n.b, n.rf, n.ellps, n.sphere), o = An(a.a, a.b, a.rf, n.R_A), s = Bn(n.nadgrids), c = n.datum || Fn(n.datumCode, n.datum_params, a.a, a.b, o.es, o.ep2, s);
	cn(this, n), cn(this, r), this.a = a.a, this.b = a.b, this.rf = a.rf, this.sphere = a.sphere, this.es = o.es, this.e = o.e, this.ep2 = o.ep2, this.datum = c, "init" in this && typeof this.init == "function" && this.init(), this.k0 ||= 1, t(null, this);
}
Zn.projections = Dn, Zn.projections.start();
//#endregion
//#region node_modules/proj4/lib/datumUtils.js
function Qn(e, t) {
	return e.datum_type === t.datum_type ? e.a !== t.a || Math.abs(e.es - t.es) > 5e-11 ? !1 : e.datum_type === 1 ? e.datum_params[0] === t.datum_params[0] && e.datum_params[1] === t.datum_params[1] && e.datum_params[2] === t.datum_params[2] : e.datum_type === 2 ? e.datum_params[0] === t.datum_params[0] && e.datum_params[1] === t.datum_params[1] && e.datum_params[2] === t.datum_params[2] && e.datum_params[3] === t.datum_params[3] && e.datum_params[4] === t.datum_params[4] && e.datum_params[5] === t.datum_params[5] && e.datum_params[6] === t.datum_params[6] : !0 : !1;
}
function $n(e, t, n) {
	var r = e.x, i = e.y, a = e.z ? e.z : 0, o, s, c, l;
	if (i < -G && i > -1.001 * G) i = -G;
	else if (i > G && i < 1.001 * G) i = G;
	else if (i < -G) return {
		x: -Infinity,
		y: -Infinity,
		z: e.z
	};
	else if (i > G) return {
		x: Infinity,
		y: Infinity,
		z: e.z
	};
	return r > Math.PI && (r -= 2 * Math.PI), s = Math.sin(i), l = Math.cos(i), c = s * s, o = n / Math.sqrt(1 - t * c), {
		x: (o + a) * l * Math.cos(r),
		y: (o + a) * l * Math.sin(r),
		z: (o * (1 - t) + a) * s
	};
}
function er(e, t, n, r) {
	var i = 1e-12, a = i * i, o = 30, s, c, l, u, d, f, p, m, h, g, _, v, y, b = e.x, x = e.y, S = e.z ? e.z : 0, C, w, T;
	if (s = Math.sqrt(b * b + x * x), c = Math.sqrt(b * b + x * x + S * S), s / n < i) {
		if (C = 0, c / n < i) return w = G, T = -r, {
			x: e.x,
			y: e.y,
			z: e.z
		};
	} else C = Math.atan2(x, b);
	l = S / c, u = s / c, d = 1 / Math.sqrt(1 - t * (2 - t) * u * u), m = u * (1 - t) * d, h = l * d, y = 0;
	do
		y++, p = n / Math.sqrt(1 - t * h * h), T = s * m + S * h - p * (1 - t * h * h), f = t * p / (p + T), d = 1 / Math.sqrt(1 - f * (2 - f) * u * u), g = u * (1 - f) * d, _ = l * d, v = _ * m - g * h, m = g, h = _;
	while (v * v > a && y < o);
	return w = Math.atan(_ / Math.abs(g)), {
		x: C,
		y: w,
		z: T
	};
}
function tr(e, t, n) {
	if (t === 1) return {
		x: e.x + n[0],
		y: e.y + n[1],
		z: e.z + n[2]
	};
	if (t === 2) {
		var r = n[0], i = n[1], a = n[2], o = n[3], s = n[4], c = n[5], l = n[6];
		return {
			x: l * (e.x - c * e.y + s * e.z) + r,
			y: l * (c * e.x + e.y - o * e.z) + i,
			z: l * (-s * e.x + o * e.y + e.z) + a
		};
	}
}
function nr(e, t, n) {
	if (t === 1) return {
		x: e.x - n[0],
		y: e.y - n[1],
		z: e.z - n[2]
	};
	if (t === 2) {
		var r = n[0], i = n[1], a = n[2], o = n[3], s = n[4], c = n[5], l = n[6], u = (e.x - r) / l, d = (e.y - i) / l, f = (e.z - a) / l;
		return {
			x: u + c * d - s * f,
			y: -c * u + d + o * f,
			z: s * u - o * d + f
		};
	}
}
//#endregion
//#region node_modules/proj4/lib/datum_transform.js
function rr(e) {
	return e === 1 || e === 2;
}
function ir(e, t, n) {
	if (Qn(e, t) || e.datum_type === 5 || t.datum_type === 5) return n;
	var r = e.a, i = e.es;
	if (e.datum_type === 3) {
		if (ar(e, !1, n) !== 0) return;
		r = rt, i = at;
	}
	var a = t.a, o = t.b, s = t.es;
	if (t.datum_type === 3 && (a = rt, o = it, s = at), i === s && r === a && !rr(e.datum_type) && !rr(t.datum_type) || (n = $n(n, i, r), rr(e.datum_type) && (n = tr(n, e.datum_type, e.datum_params)), rr(t.datum_type) && (n = nr(n, t.datum_type, t.datum_params)), n = er(n, s, a, o), !(t.datum_type === 3 && ar(t, !0, n) !== 0))) return n;
}
function ar(e, t, n) {
	if (e.grids === null || e.grids.length === 0) return console.log("Grid shift grids not found"), -1;
	var r = {
		x: -n.x,
		y: n.y
	}, i = {
		x: NaN,
		y: NaN
	}, a = [];
	outer: for (var o = 0; o < e.grids.length; o++) {
		var s = e.grids[o];
		if (a.push(s.name), s.isNull) {
			i = r;
			break;
		}
		if (s.grid === null) {
			if (s.mandatory) return console.log("Unable to find mandatory grid '" + s.name + "'"), -1;
			continue;
		}
		for (var c = s.grid.subgrids, l = 0, u = c.length; l < u; l++) {
			var d = c[l], f = (Math.abs(d.del[1]) + Math.abs(d.del[0])) / 1e4, p = d.ll[0] - f, m = d.ll[1] - f, h = d.ll[0] + (d.lim[0] - 1) * d.del[0] + f, g = d.ll[1] + (d.lim[1] - 1) * d.del[1] + f;
			if (!(m > r.y || p > r.x || g < r.y || h < r.x) && (i = or(r, t, d), !isNaN(i.x))) break outer;
		}
	}
	return isNaN(i.x) ? (console.log("Failed to find a grid shift table for location '" + -r.x * ft + " " + r.y * ft + " tried: '" + a + "'"), -1) : (n.x = -i.x, n.y = i.y, 0);
}
function or(e, t, n) {
	var r = {
		x: NaN,
		y: NaN
	};
	if (isNaN(e.x)) return r;
	var i = {
		x: e.x,
		y: e.y
	};
	i.x -= n.ll[0], i.y -= n.ll[1], i.x = K(i.x - Math.PI) + Math.PI;
	var a = sr(i, n);
	if (t) {
		if (isNaN(a.x)) return r;
		a.x = i.x - a.x, a.y = i.y - a.y;
		var o = 9, s = 1e-12, c, l;
		do {
			if (l = sr(a, n), isNaN(l.x)) {
				console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
				break;
			}
			c = {
				x: i.x - (l.x + a.x),
				y: i.y - (l.y + a.y)
			}, a.x += c.x, a.y += c.y;
		} while (o-- && Math.abs(c.x) > s && Math.abs(c.y) > s);
		if (o < 0) return console.log("Inverse grid shift iterator failed to converge."), r;
		r.x = K(a.x + n.ll[0]), r.y = a.y + n.ll[1];
	} else isNaN(a.x) || (r.x = e.x + a.x, r.y = e.y + a.y);
	return r;
}
function sr(e, t) {
	var n = {
		x: e.x / t.del[0],
		y: e.y / t.del[1]
	}, r = {
		x: Math.floor(n.x),
		y: Math.floor(n.y)
	}, i = {
		x: n.x - 1 * r.x,
		y: n.y - 1 * r.y
	}, a = {
		x: NaN,
		y: NaN
	}, o;
	if (r.x < 0 || r.x >= t.lim[0] || r.y < 0 || r.y >= t.lim[1]) return a;
	o = r.y * t.lim[0] + r.x;
	var s = {
		x: t.cvs[o][0],
		y: t.cvs[o][1]
	};
	o++;
	var c = {
		x: t.cvs[o][0],
		y: t.cvs[o][1]
	};
	o += t.lim[0];
	var l = {
		x: t.cvs[o][0],
		y: t.cvs[o][1]
	};
	o--;
	var u = {
		x: t.cvs[o][0],
		y: t.cvs[o][1]
	}, d = i.x * i.y, f = i.x * (1 - i.y), p = (1 - i.x) * (1 - i.y), m = (1 - i.x) * i.y;
	return a.x = p * s.x + f * c.x + m * u.x + d * l.x, a.y = p * s.y + f * c.y + m * u.y + d * l.y, a;
}
//#endregion
//#region node_modules/proj4/lib/adjust_axis.js
var cr = [
	"x",
	"y",
	"z"
];
function lr(e, t) {
	let n = {};
	for (let r = 0, i = e.axis.length; r < i; r++) {
		if (r === 2 && t.z === void 0) continue;
		let i = t[cr[r]];
		switch (e.axis[r]) {
			case "e":
				n.x = i;
				break;
			case "w":
				n.x = -i;
				break;
			case "n":
				n.y = i;
				break;
			case "s":
				n.y = -i;
				break;
			case "u":
				n.z = i;
				break;
			case "d":
				n.z = -i;
				break;
			default: return null;
		}
	}
	return n;
}
function ur(e, t) {
	let n = {};
	for (let r = 0, i = e.axis.length; r < i; r++) if (!(r === 2 && t.z === void 0)) switch (e.axis[r]) {
		case "e":
			n[cr[r]] = t.x;
			break;
		case "w":
			n[cr[r]] = -t.x;
			break;
		case "n":
			n[cr[r]] = t.y;
			break;
		case "s":
			n[cr[r]] = -t.y;
			break;
		case "u":
			n[cr[r]] = t.z;
			break;
		case "d":
			n[cr[r]] = -t.z;
			break;
		default: return null;
	}
	return n;
}
//#endregion
//#region node_modules/proj4/lib/common/toPoint.js
function dr(e) {
	var t = {
		x: e[0],
		y: e[1]
	};
	return e.length > 2 && (t.z = e[2]), e.length > 3 && (t.m = e[3]), t;
}
//#endregion
//#region node_modules/proj4/lib/checkSanity.js
function fr(e) {
	pr(e.x), pr(e.y);
}
function pr(e) {
	if (typeof Number.isFinite == "function") {
		if (Number.isFinite(e)) return;
		throw TypeError("coordinates must be finite numbers");
	}
	if (typeof e != "number" || e !== e || !isFinite(e)) throw TypeError("coordinates must be finite numbers");
}
//#endregion
//#region node_modules/proj4/lib/transform.js
function mr(e, t) {
	return (e.datum.datum_type === 1 || e.datum.datum_type === 2 || e.datum.datum_type === 3) && t.datumCode !== "WGS84" || (t.datum.datum_type === 1 || t.datum.datum_type === 2 || t.datum.datum_type === 3) && e.datumCode !== "WGS84";
}
function hr(e, t, n, r) {
	var i, a = n.z !== void 0;
	if (fr(n), e.datum && t.datum && mr(e, t) && (i = new Zn("WGS84"), n = hr(e, i, n, r), e = i), r && e.axis !== "enu" && (n = lr(e, n)), e.projName === "longlat") n = {
		x: n.x * dt,
		y: n.y * dt,
		z: n.z || 0
	};
	else if (e.to_meter && (n = {
		x: n.x * e.to_meter,
		y: n.y * e.to_meter,
		z: n.z || 0
	}), n = e.inverse(n), !n) return;
	if (e.from_greenwich && (n.x += e.from_greenwich), n = ir(e.datum, t.datum, n), n) return n = n, t.from_greenwich && (n = {
		x: n.x - t.from_greenwich,
		y: n.y,
		z: n.z || 0
	}), t.projName === "longlat" ? (t.long_wrap !== void 0 && (n.x = t.long_wrap + K(n.x - t.long_wrap)), n = {
		x: n.x * ft,
		y: n.y * ft,
		z: n.z || 0
	}) : (n = t.forward(n), t.to_meter && (n = {
		x: n.x / t.to_meter,
		y: n.y / t.to_meter,
		z: n.z || 0
	})), r && t.axis !== "enu" ? ur(t, n) : (n && !a && t.projName !== "geocent" && delete n.z, n);
}
function gr(e, t, n, r) {
	return hr(e, t, Array.isArray(n) ? dr(n) : {
		x: n.x,
		y: n.y,
		z: n.z,
		m: n.m
	}, r);
}
//#endregion
//#region node_modules/proj4/lib/core.js
var _r = Zn("WGS84");
function vr(e, t, n, r) {
	var i, a, o;
	return Array.isArray(n) ? (i = hr(e, t, dr(n), r) || {
		x: NaN,
		y: NaN
	}, n.length > 2 ? (a = e.name !== void 0 && e.name === "geocent" || t.name !== void 0 && t.name === "geocent", a ? typeof i.z == "number" ? [
		i.x,
		i.y,
		i.z
	].concat(n.slice(3)) : [
		i.x,
		i.y,
		n[2]
	].concat(n.slice(3)) : r && typeof i.z == "number" ? [
		i.x,
		i.y,
		i.z
	].concat(n.slice(3)) : [i.x, i.y].concat(n.slice(2))) : [i.x, i.y]) : (i = hr(e, t, {
		x: n.x,
		y: n.y,
		z: n.z,
		m: n.m
	}, r) || {
		x: NaN,
		y: NaN
	}, o = Object.keys(n), o.length === 2 ? i : (a = e.name !== void 0 && e.name === "geocent" || t.name !== void 0 && t.name === "geocent", o.forEach(function(e) {
		e === "x" || e === "y" || e === "z" && (a || r) || (i[e] = n[e]);
	}), i));
}
function yr(e) {
	return e instanceof Zn ? e : typeof e == "object" && "oProj" in e ? e.oProj : Zn(e);
}
function br(e, t, n) {
	var r, i, a = !1, o;
	return t === void 0 ? (i = yr(e), r = _r, a = !0) : (t.x !== void 0 || Array.isArray(t)) && (n = t, i = yr(e), r = _r, a = !0), r ||= yr(e), i ||= yr(t), n ? vr(r, i, n) : (o = {
		forward: function(e, t) {
			return vr(r, i, e, t);
		},
		inverse: function(e, t) {
			return vr(i, r, e, t);
		}
	}, a && (o.oProj = i), o);
}
//#endregion
//#region node_modules/mgrs/mgrs.js
var xr = 6, Sr = "AJSAJS", Cr = "AFAFAF", wr = 65, Tr = 73, Er = 79, Dr = 86, Or = 90, kr = {
	forward: Ar,
	inverse: jr,
	toPoint: Mr
};
function Ar(e, t) {
	return t ||= 5, Rr(Fr({
		lat: e[1],
		lon: e[0]
	}), t);
}
function jr(e) {
	var t = Ir(Hr(e.toUpperCase()));
	return t.lat && t.lon ? [
		t.lon,
		t.lat,
		t.lon,
		t.lat
	] : [
		t.left,
		t.bottom,
		t.right,
		t.top
	];
}
function Mr(e) {
	var t = Ir(Hr(e.toUpperCase()));
	return t.lat && t.lon ? [t.lon, t.lat] : [(t.left + t.right) / 2, (t.top + t.bottom) / 2];
}
function Nr(e) {
	return Math.PI / 180 * e;
}
function Pr(e) {
	return e / Math.PI * 180;
}
function Fr(e) {
	var t = e.lat, n = e.lon, r = 6378137, i = .00669438, a = .9996, o, s, c, l, u, d, f, p = Nr(t), m = Nr(n), h, g = Math.floor((n + 180) / 6) + 1;
	n === 180 && (g = 60), t >= 56 && t < 64 && n >= 3 && n < 12 && (g = 32), t >= 72 && t < 84 && (n >= 0 && n < 9 ? g = 31 : n >= 9 && n < 21 ? g = 33 : n >= 21 && n < 33 ? g = 35 : n >= 33 && n < 42 && (g = 37)), o = (g - 1) * 6 - 180 + 3, h = Nr(o), s = i / (1 - i), c = r / Math.sqrt(1 - i * Math.sin(p) * Math.sin(p)), l = Math.tan(p) * Math.tan(p), u = s * Math.cos(p) * Math.cos(p), d = Math.cos(p) * (m - h), f = r * ((1 - i / 4 - 3 * i * i / 64 - 5 * i * i * i / 256) * p - (3 * i / 8 + 3 * i * i / 32 + 45 * i * i * i / 1024) * Math.sin(2 * p) + (15 * i * i / 256 + 45 * i * i * i / 1024) * Math.sin(4 * p) - 35 * i * i * i / 3072 * Math.sin(6 * p));
	var _ = a * c * (d + (1 - l + u) * d * d * d / 6 + (5 - 18 * l + l * l + 72 * u - 58 * s) * d * d * d * d * d / 120) + 5e5, v = a * (f + c * Math.tan(p) * (d * d / 2 + (5 - l + 9 * u + 4 * u * u) * d * d * d * d / 24 + (61 - 58 * l + l * l + 600 * u - 330 * s) * d * d * d * d * d * d / 720));
	return t < 0 && (v += 1e7), {
		northing: Math.round(v),
		easting: Math.round(_),
		zoneNumber: g,
		zoneLetter: Lr(t)
	};
}
function Ir(e) {
	var t = e.northing, n = e.easting, r = e.zoneLetter, i = e.zoneNumber;
	if (i < 0 || i > 60) return null;
	var a = .9996, o = 6378137, s = .00669438, c, l = (1 - Math.sqrt(1 - s)) / (1 + Math.sqrt(1 - s)), u, d, f, p, m, h, g, _, v, y = n - 5e5, b = t;
	r < "N" && (b -= 1e7), g = (i - 1) * 6 - 180 + 3, c = s / (1 - s), h = b / a, _ = h / (o * (1 - s / 4 - 3 * s * s / 64 - 5 * s * s * s / 256)), v = _ + (3 * l / 2 - 27 * l * l * l / 32) * Math.sin(2 * _) + (21 * l * l / 16 - 55 * l * l * l * l / 32) * Math.sin(4 * _) + 151 * l * l * l / 96 * Math.sin(6 * _), u = o / Math.sqrt(1 - s * Math.sin(v) * Math.sin(v)), d = Math.tan(v) * Math.tan(v), f = c * Math.cos(v) * Math.cos(v), p = o * (1 - s) / (1 - s * Math.sin(v) * Math.sin(v)) ** 1.5, m = y / (u * a);
	var x = v - u * Math.tan(v) / p * (m * m / 2 - (5 + 3 * d + 10 * f - 4 * f * f - 9 * c) * m * m * m * m / 24 + (61 + 90 * d + 298 * f + 45 * d * d - 252 * c - 3 * f * f) * m * m * m * m * m * m / 720);
	x = Pr(x);
	var S = (m - (1 + 2 * d + f) * m * m * m / 6 + (5 - 2 * f + 28 * d - 3 * f * f + 8 * c + 24 * d * d) * m * m * m * m * m / 120) / Math.cos(v);
	S = g + Pr(S);
	var C;
	if (e.accuracy) {
		var w = Ir({
			northing: e.northing + e.accuracy,
			easting: e.easting + e.accuracy,
			zoneLetter: e.zoneLetter,
			zoneNumber: e.zoneNumber
		});
		C = {
			top: w.lat,
			right: w.lon,
			bottom: x,
			left: S
		};
	} else C = {
		lat: x,
		lon: S
	};
	return C;
}
function Lr(e) {
	var t = "Z";
	return 84 >= e && e >= 72 ? t = "X" : 72 > e && e >= 64 ? t = "W" : 64 > e && e >= 56 ? t = "V" : 56 > e && e >= 48 ? t = "U" : 48 > e && e >= 40 ? t = "T" : 40 > e && e >= 32 ? t = "S" : 32 > e && e >= 24 ? t = "R" : 24 > e && e >= 16 ? t = "Q" : 16 > e && e >= 8 ? t = "P" : 8 > e && e >= 0 ? t = "N" : 0 > e && e >= -8 ? t = "M" : -8 > e && e >= -16 ? t = "L" : -16 > e && e >= -24 ? t = "K" : -24 > e && e >= -32 ? t = "J" : -32 > e && e >= -40 ? t = "H" : -40 > e && e >= -48 ? t = "G" : -48 > e && e >= -56 ? t = "F" : -56 > e && e >= -64 ? t = "E" : -64 > e && e >= -72 ? t = "D" : -72 > e && e >= -80 && (t = "C"), t;
}
function Rr(e, t) {
	var n = "00000" + e.easting, r = "00000" + e.northing;
	return e.zoneNumber + e.zoneLetter + zr(e.easting, e.northing, e.zoneNumber) + n.substr(n.length - 5, t) + r.substr(r.length - 5, t);
}
function zr(e, t, n) {
	var r = Br(n);
	return Vr(Math.floor(e / 1e5), Math.floor(t / 1e5) % 20, r);
}
function Br(e) {
	var t = e % xr;
	return t === 0 && (t = xr), t;
}
function Vr(e, t, n) {
	var r = n - 1, i = Sr.charCodeAt(r), a = Cr.charCodeAt(r), o = i + e - 1, s = a + t, c = !1;
	return o > Or && (o = o - Or + wr - 1, c = !0), (o === Tr || i < Tr && o > Tr || (o > Tr || i < Tr) && c) && o++, (o === Er || i < Er && o > Er || (o > Er || i < Er) && c) && (o++, o === Tr && o++), o > Or && (o = o - Or + wr - 1), s > Dr ? (s = s - Dr + wr - 1, c = !0) : c = !1, (s === Tr || a < Tr && s > Tr || (s > Tr || a < Tr) && c) && s++, (s === Er || a < Er && s > Er || (s > Er || a < Er) && c) && (s++, s === Tr && s++), s > Dr && (s = s - Dr + wr - 1), String.fromCharCode(o) + String.fromCharCode(s);
}
function Hr(e) {
	if (e && e.length === 0) throw "MGRSPoint coverting from nothing";
	for (var t = e.length, n = null, r = "", i, a = 0; !/[A-Z]/.test(i = e.charAt(a));) {
		if (a >= 2) throw "MGRSPoint bad conversion from: " + e;
		r += i, a++;
	}
	var o = parseInt(r, 10);
	if (a === 0 || a + 3 > t) throw "MGRSPoint bad conversion from: " + e;
	var s = e.charAt(a++);
	if (s <= "A" || s === "B" || s === "Y" || s >= "Z" || s === "I" || s === "O") throw "MGRSPoint zone letter " + s + " not handled: " + e;
	n = e.substring(a, a += 2);
	for (var c = Br(o), l = Ur(n.charAt(0), c), u = Wr(n.charAt(1), c); u < Gr(s);) u += 2e6;
	var d = t - a;
	if (d % 2 != 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + e;
	var f = d / 2, p = 0, m = 0, h, g, _, v, y;
	return f > 0 && (h = 1e5 / 10 ** f, g = e.substring(a, a + f), p = parseFloat(g) * h, _ = e.substring(a + f), m = parseFloat(_) * h), v = p + l, y = m + u, {
		easting: v,
		northing: y,
		zoneLetter: s,
		zoneNumber: o,
		accuracy: h
	};
}
function Ur(e, t) {
	for (var n = Sr.charCodeAt(t - 1), r = 1e5, i = !1; n !== e.charCodeAt(0);) {
		if (n++, n === Tr && n++, n === Er && n++, n > Or) {
			if (i) throw "Bad character: " + e;
			n = wr, i = !0;
		}
		r += 1e5;
	}
	return r;
}
function Wr(e, t) {
	if (e > "V") throw "MGRSPoint given invalid Northing " + e;
	for (var n = Cr.charCodeAt(t - 1), r = 0, i = !1; n !== e.charCodeAt(0);) {
		if (n++, n === Tr && n++, n === Er && n++, n > Dr) {
			if (i) throw "Bad character: " + e;
			n = wr, i = !0;
		}
		r += 1e5;
	}
	return r;
}
function Gr(e) {
	var t;
	switch (e) {
		case "C":
			t = 11e5;
			break;
		case "D":
			t = 2e6;
			break;
		case "E":
			t = 28e5;
			break;
		case "F":
			t = 37e5;
			break;
		case "G":
			t = 46e5;
			break;
		case "H":
			t = 55e5;
			break;
		case "J":
			t = 64e5;
			break;
		case "K":
			t = 73e5;
			break;
		case "L":
			t = 82e5;
			break;
		case "M":
			t = 91e5;
			break;
		case "N":
			t = 0;
			break;
		case "P":
			t = 8e5;
			break;
		case "Q":
			t = 17e5;
			break;
		case "R":
			t = 26e5;
			break;
		case "S":
			t = 35e5;
			break;
		case "T":
			t = 44e5;
			break;
		case "U":
			t = 53e5;
			break;
		case "V":
			t = 62e5;
			break;
		case "W":
			t = 7e6;
			break;
		case "X":
			t = 79e5;
			break;
		default: t = -1;
	}
	if (t >= 0) return t;
	throw "Invalid zone letter: " + e;
}
//#endregion
//#region node_modules/proj4/lib/Point.js
function Kr(e, t, n) {
	if (!(this instanceof Kr)) return new Kr(e, t, n);
	if (Array.isArray(e)) this.x = e[0], this.y = e[1], this.z = e[2] || 0;
	else if (typeof e == "object") this.x = e.x, this.y = e.y, this.z = e.z || 0;
	else if (typeof e == "string" && t === void 0) {
		var r = e.split(",");
		this.x = parseFloat(r[0]), this.y = parseFloat(r[1]), this.z = parseFloat(r[2]) || 0;
	} else this.x = e, this.y = t, this.z = n || 0;
	console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
}
Kr.fromMGRS = function(e) {
	return new Kr(Mr(e));
}, Kr.prototype.toMGRS = function(e) {
	return Ar([this.x, this.y], e);
};
//#endregion
//#region node_modules/proj4/lib/common/pj_enfn.js
var qr = 1, Jr = .25, Yr = .046875, Xr = .01953125, Zr = .01068115234375, Qr = .75, $r = .46875, ei = .013020833333333334, ti = .007120768229166667, ni = .3645833333333333, ri = .005696614583333333, ii = .3076171875;
function ai(e) {
	var t = [];
	t[0] = qr - e * (Jr + e * (Yr + e * (Xr + e * Zr))), t[1] = e * (Qr - e * (Yr + e * (Xr + e * Zr)));
	var n = e * e;
	return t[2] = n * ($r - e * (ei + e * ti)), n *= e, t[3] = n * (ni - e * ri), t[4] = n * e * ii, t;
}
//#endregion
//#region node_modules/proj4/lib/common/pj_mlfn.js
function oi(e, t, n, r) {
	return n *= t, t *= t, r[0] * e - n * (r[1] + t * (r[2] + t * (r[3] + t * r[4])));
}
//#endregion
//#region node_modules/proj4/lib/common/pj_inv_mlfn.js
var si = 20;
function ci(e, t, n) {
	for (var r = 1 / (1 - t), i = e, a = si; a; --a) {
		var o = Math.sin(i), s = 1 - t * o * o;
		if (s = (oi(i, o, Math.cos(i), n) - e) * (s * Math.sqrt(s)) * r, i -= s, Math.abs(s) < 1e-10) return i;
	}
	return i;
}
//#endregion
//#region node_modules/proj4/lib/projections/tmerc.js
function li() {
	this.x0 = this.x0 === void 0 ? 0 : this.x0, this.y0 = this.y0 === void 0 ? 0 : this.y0, this.long0 = this.long0 === void 0 ? 0 : this.long0, this.lat0 = this.lat0 === void 0 ? 0 : this.lat0, this.es && (this.en = ai(this.es), this.ml0 = oi(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en));
}
function ui(e) {
	var t = e.x, n = e.y, r = K(t - this.long0, this.over), i, a, o, s = Math.sin(n), c = Math.cos(n);
	if (this.es) {
		var l = c * r, u = l ** 2, d = this.ep2 * c ** 2, f = d ** 2, p = (Math.abs(c) > 1e-10 ? Math.tan(n) : 0) ** 2, m = p ** 2;
		i = 1 - this.es * s ** 2, l /= Math.sqrt(i);
		var h = oi(n, s, c, this.en);
		a = this.a * (this.k0 * l * (1 + u / 6 * (1 - p + d + u / 20 * (5 - 18 * p + m + 14 * d - 58 * p * d + u / 42 * (61 + 179 * m - m * p - 479 * p))))) + this.x0, o = this.a * (this.k0 * (h - this.ml0 + s * r * l / 2 * (1 + u / 12 * (5 - p + 9 * d + 4 * f + u / 30 * (61 + m - 58 * p + 270 * d - 330 * p * d + u / 56 * (1385 + 543 * m - m * p - 3111 * p)))))) + this.y0;
	} else {
		var g = c * Math.sin(r);
		if (Math.abs(Math.abs(g) - 1) < 1e-10) return 93;
		if (a = .5 * this.a * this.k0 * Math.log((1 + g) / (1 - g)) + this.x0, o = c * Math.cos(r) / Math.sqrt(1 - g ** 2), g = Math.abs(o), g >= 1) {
			if (g - 1 > 1e-10) return 93;
			o = 0;
		} else o = Math.acos(o);
		n < 0 && (o = -o), o = this.a * this.k0 * (o - this.lat0) + this.y0;
	}
	return e.x = a, e.y = o, e;
}
function di(e) {
	var t, n, r, i, a = (e.x - this.x0) * (1 / this.a), o = (e.y - this.y0) * (1 / this.a);
	if (!this.es) {
		var s = Math.exp(a / this.k0), c = .5 * (s - 1 / s), l = this.lat0 + o / this.k0, u = Math.cos(l);
		t = Math.sqrt((1 - u ** 2) / (1 + c ** 2)), r = Math.asin(t), o < 0 && (r = -r), i = c === 0 && u === 0 ? 0 : K(Math.atan2(c, u) + this.long0, this.over);
	} else if (t = this.ml0 + o / this.k0, n = ci(t, this.es, this.en), Math.abs(n) < G) {
		var d = Math.sin(n), f = Math.cos(n), p = Math.abs(f) > 1e-10 ? Math.tan(n) : 0, m = this.ep2 * f ** 2, h = m ** 2, g = p ** 2, _ = g ** 2;
		t = 1 - this.es * d ** 2;
		var v = a * Math.sqrt(t) / this.k0, y = v ** 2;
		t *= p, r = n - t * y / (1 - this.es) * .5 * (1 - y / 12 * (5 + 3 * g - 9 * m * g + m - 4 * h - y / 30 * (61 + 90 * g - 252 * m * g + 45 * _ + 46 * m - y / 56 * (1385 + 3633 * g + 4095 * _ + 1574 * _ * g)))), i = K(this.long0 + v * (1 - y / 6 * (1 + 2 * g + m - y / 20 * (5 + 28 * g + 24 * _ + 8 * m * g + 6 * m - y / 42 * (61 + 662 * g + 1320 * _ + 720 * _ * g)))) / f, this.over);
	} else r = G * un(o), i = 0;
	return e.x = i, e.y = r, e;
}
var fi = {
	init: li,
	forward: ui,
	inverse: di,
	names: ["Fast_Transverse_Mercator", "Fast Transverse Mercator"]
};
//#endregion
//#region node_modules/proj4/lib/common/sinh.js
function pi(e) {
	var t = Math.exp(e);
	return t = (t - 1 / t) / 2, t;
}
//#endregion
//#region node_modules/proj4/lib/common/hypot.js
function mi(e, t) {
	e = Math.abs(e), t = Math.abs(t);
	var n = Math.max(e, t), r = Math.min(e, t) / (n || 1);
	return n * Math.sqrt(1 + r ** 2);
}
//#endregion
//#region node_modules/proj4/lib/common/log1py.js
function hi(e) {
	var t = 1 + e, n = t - 1;
	return n === 0 ? e : e * Math.log(t) / n;
}
//#endregion
//#region node_modules/proj4/lib/common/asinhy.js
function gi(e) {
	var t = Math.abs(e);
	return t = hi(t * (1 + t / (mi(1, t) + 1))), e < 0 ? -t : t;
}
//#endregion
//#region node_modules/proj4/lib/common/gatg.js
function _i(e, t) {
	for (var n = 2 * Math.cos(2 * t), r = e.length - 1, i = e[r], a = 0, o; --r >= 0;) o = -a + n * i + e[r], a = i, i = o;
	return t + o * Math.sin(2 * t);
}
//#endregion
//#region node_modules/proj4/lib/common/clens.js
function vi(e, t) {
	for (var n = 2 * Math.cos(t), r = e.length - 1, i = e[r], a = 0, o; --r >= 0;) o = -a + n * i + e[r], a = i, i = o;
	return Math.sin(t) * o;
}
//#endregion
//#region node_modules/proj4/lib/common/cosh.js
function yi(e) {
	var t = Math.exp(e);
	return t = (t + 1 / t) / 2, t;
}
//#endregion
//#region node_modules/proj4/lib/common/clens_cmplx.js
function bi(e, t, n) {
	for (var r = Math.sin(t), i = Math.cos(t), a = pi(n), o = yi(n), s = 2 * i * o, c = -2 * r * a, l = e.length - 1, u = e[l], d = 0, f = 0, p = 0, m, h; --l >= 0;) m = f, h = d, f = u, d = p, u = -m + s * f - c * d + e[l], p = -h + c * f + s * d;
	return s = r * o, c = i * a, [s * u - c * p, s * p + c * u];
}
//#endregion
//#region node_modules/proj4/lib/projections/etmerc.js
function xi() {
	if (!this.approx && (isNaN(this.es) || this.es <= 0)) throw Error("Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION[\"Fast_Transverse_Mercator\"] in the WKT.");
	this.approx && (fi.init.apply(this), this.forward = fi.forward, this.inverse = fi.inverse), this.x0 = this.x0 === void 0 ? 0 : this.x0, this.y0 = this.y0 === void 0 ? 0 : this.y0, this.long0 = this.long0 === void 0 ? 0 : this.long0, this.lat0 = this.lat0 === void 0 ? 0 : this.lat0, this.k0 = this.k0 === void 0 ? 1 : this.k0, this.cgb = [], this.cbg = [], this.utg = [], this.gtu = [];
	var e = this.es / (1 + Math.sqrt(1 - this.es)), t = e / (2 - e), n = t;
	this.cgb[0] = t * (2 + t * (-2 / 3 + t * (-2 + t * (116 / 45 + t * (26 / 45 + -2854 / 675 * t))))), this.cbg[0] = t * (-2 + t * (2 / 3 + t * (4 / 3 + t * (-82 / 45 + t * (32 / 45 + 4642 / 4725 * t))))), n *= t, this.cgb[1] = n * (7 / 3 + t * (-8 / 5 + t * (-227 / 45 + t * (2704 / 315 + 2323 / 945 * t)))), this.cbg[1] = n * (5 / 3 + t * (-16 / 15 + t * (-13 / 9 + t * (904 / 315 + -1522 / 945 * t)))), n *= t, this.cgb[2] = n * (56 / 15 + t * (-136 / 35 + t * (-1262 / 105 + 73814 / 2835 * t))), this.cbg[2] = n * (-26 / 15 + t * (34 / 21 + t * (8 / 5 + -12686 / 2835 * t))), n *= t, this.cgb[3] = n * (4279 / 630 + t * (-332 / 35 + -399572 / 14175 * t)), this.cbg[3] = n * (1237 / 630 + t * (-12 / 5 + -24832 / 14175 * t)), n *= t, this.cgb[4] = n * (4174 / 315 + -144838 / 6237 * t), this.cbg[4] = n * (-734 / 315 + 109598 / 31185 * t), n *= t, this.cgb[5] = 601676 / 22275 * n, this.cbg[5] = 444337 / 155925 * n, n = t ** 2, this.Qn = this.k0 / (1 + t) * (1 + n * (1 / 4 + n * (1 / 64 + n / 256))), this.utg[0] = t * (-.5 + t * (2 / 3 + t * (-37 / 96 + t * (1 / 360 + t * (81 / 512 + -96199 / 604800 * t))))), this.gtu[0] = t * (.5 + t * (-2 / 3 + t * (5 / 16 + t * (41 / 180 + t * (-127 / 288 + 7891 / 37800 * t))))), this.utg[1] = n * (-1 / 48 + t * (-1 / 15 + t * (437 / 1440 + t * (-46 / 105 + 1118711 / 3870720 * t)))), this.gtu[1] = n * (13 / 48 + t * (-3 / 5 + t * (557 / 1440 + t * (281 / 630 + -1983433 / 1935360 * t)))), n *= t, this.utg[2] = n * (-17 / 480 + t * (37 / 840 + t * (209 / 4480 + -5569 / 90720 * t))), this.gtu[2] = n * (61 / 240 + t * (-103 / 140 + t * (15061 / 26880 + 167603 / 181440 * t))), n *= t, this.utg[3] = n * (-4397 / 161280 + t * (11 / 504 + 830251 / 7257600 * t)), this.gtu[3] = n * (49561 / 161280 + t * (-179 / 168 + 6601661 / 7257600 * t)), n *= t, this.utg[4] = n * (-4583 / 161280 + 108847 / 3991680 * t), this.gtu[4] = n * (34729 / 80640 + -3418889 / 1995840 * t), n *= t, this.utg[5] = -20648693 / 638668800 * n, this.gtu[5] = 212378941 / 319334400 * n;
	var r = _i(this.cbg, this.lat0);
	this.Zb = -this.Qn * (r + vi(this.gtu, 2 * r));
}
function Si(e) {
	var t = K(e.x - this.long0, this.over), n = e.y;
	n = _i(this.cbg, n);
	var r = Math.sin(n), i = Math.cos(n), a = Math.sin(t), o = Math.cos(t);
	n = Math.atan2(r, o * i), t = Math.atan2(a * i, mi(r, i * o)), t = gi(Math.tan(t));
	var s = bi(this.gtu, 2 * n, 2 * t);
	n += s[0], t += s[1];
	var c, l;
	return Math.abs(t) <= 2.623395162778 ? (c = this.a * (this.Qn * t) + this.x0, l = this.a * (this.Qn * n + this.Zb) + this.y0) : (c = Infinity, l = Infinity), e.x = c, e.y = l, e;
}
function Ci(e) {
	var t = (e.x - this.x0) * (1 / this.a), n = (e.y - this.y0) * (1 / this.a);
	n = (n - this.Zb) / this.Qn, t /= this.Qn;
	var r, i;
	if (Math.abs(t) <= 2.623395162778) {
		var a = bi(this.utg, 2 * n, 2 * t);
		n += a[0], t += a[1], t = Math.atan(pi(t));
		var o = Math.sin(n), s = Math.cos(n), c = Math.sin(t), l = Math.cos(t);
		n = Math.atan2(o * l, mi(c, l * s)), t = Math.atan2(c, l * s), r = K(t + this.long0, this.over), i = _i(this.cgb, n);
	} else r = Infinity, i = Infinity;
	return e.x = r, e.y = i, e;
}
var wi = {
	init: xi,
	forward: Si,
	inverse: Ci,
	names: [
		"Extended_Transverse_Mercator",
		"Extended Transverse Mercator",
		"etmerc",
		"Transverse_Mercator",
		"Transverse Mercator",
		"Gauss Kruger",
		"Gauss_Kruger",
		"tmerc"
	]
};
//#endregion
//#region node_modules/proj4/lib/common/adjust_zone.js
function Ti(e, t) {
	if (e === void 0) {
		if (e = Math.floor((K(t) + Math.PI) * 30 / Math.PI) + 1, e < 0) return 0;
		if (e > 60) return 60;
	}
	return e;
}
//#endregion
//#region node_modules/proj4/lib/projections/utm.js
var Ei = "etmerc";
function Di() {
	var e = Ti(this.zone, this.long0);
	if (e === void 0) throw Error("unknown utm zone");
	this.lat0 = 0, this.long0 = (6 * Math.abs(e) - 183) * dt, this.x0 = 5e5, this.y0 = this.utmSouth ? 1e7 : 0, this.k0 = .9996, wi.init.apply(this), this.forward = wi.forward, this.inverse = wi.inverse;
}
var Oi = {
	init: Di,
	names: ["Universal Transverse Mercator System", "utm"],
	dependsOn: Ei
};
//#endregion
//#region node_modules/proj4/lib/common/srat.js
function ki(e, t) {
	return ((1 - e) / (1 + e)) ** t;
}
//#endregion
//#region node_modules/proj4/lib/projections/gauss.js
var Ai = 20;
function ji() {
	var e = Math.sin(this.lat0), t = Math.cos(this.lat0);
	t *= t, this.rc = Math.sqrt(1 - this.es) / (1 - this.es * e * e), this.C = Math.sqrt(1 + this.es * t * t / (1 - this.es)), this.phic0 = Math.asin(e / this.C), this.ratexp = .5 * this.C * this.e, this.K = Math.tan(.5 * this.phic0 + pt) / (Math.tan(.5 * this.lat0 + pt) ** +this.C * ki(this.e * e, this.ratexp));
}
function Mi(e) {
	var t = e.x, n = e.y;
	return e.y = 2 * Math.atan(this.K * Math.tan(.5 * n + pt) ** +this.C * ki(this.e * Math.sin(n), this.ratexp)) - G, e.x = this.C * t, e;
}
function Ni(e) {
	for (var t = 1e-14, n = e.x / this.C, r = e.y, i = (Math.tan(.5 * r + pt) / this.K) ** (1 / this.C), a = Ai; a > 0 && (r = 2 * Math.atan(i * ki(this.e * Math.sin(e.y), -.5 * this.e)) - G, !(Math.abs(r - e.y) < t)); --a) e.y = r;
	return a ? (e.x = n, e.y = r, e) : null;
}
var Pi = {
	init: ji,
	forward: Mi,
	inverse: Ni,
	names: ["gauss"]
};
//#endregion
//#region node_modules/proj4/lib/projections/sterea.js
function Fi() {
	Pi.init.apply(this), this.rc && (this.sinc0 = Math.sin(this.phic0), this.cosc0 = Math.cos(this.phic0), this.R2 = 2 * this.rc, this.title ||= "Oblique Stereographic Alternative");
}
function Ii(e) {
	var t, n, r, i;
	return e.x = K(e.x - this.long0, this.over), Pi.forward.apply(this, [e]), t = Math.sin(e.y), n = Math.cos(e.y), r = Math.cos(e.x), i = this.k0 * this.R2 / (1 + this.sinc0 * t + this.cosc0 * n * r), e.x = i * n * Math.sin(e.x), e.y = i * (this.cosc0 * t - this.sinc0 * n * r), e.x = this.a * e.x + this.x0, e.y = this.a * e.y + this.y0, e;
}
function Li(e) {
	var t, n, r, i, a;
	if (e.x = (e.x - this.x0) / this.a, e.y = (e.y - this.y0) / this.a, e.x /= this.k0, e.y /= this.k0, a = mi(e.x, e.y)) {
		var o = 2 * Math.atan2(a, this.R2);
		t = Math.sin(o), n = Math.cos(o), i = Math.asin(n * this.sinc0 + e.y * t * this.cosc0 / a), r = Math.atan2(e.x * t, a * this.cosc0 * n - e.y * this.sinc0 * t);
	} else i = this.phic0, r = 0;
	return e.x = r, e.y = i, Pi.inverse.apply(this, [e]), e.x = K(e.x + this.long0, this.over), e;
}
var Ri = {
	init: Fi,
	forward: Ii,
	inverse: Li,
	names: [
		"Stereographic_North_Pole",
		"Oblique_Stereographic",
		"sterea",
		"Oblique Stereographic Alternative",
		"Double_Stereographic"
	]
};
//#endregion
//#region node_modules/proj4/lib/projections/stere.js
function zi(e, t, n) {
	return t *= n, Math.tan(.5 * (G + e)) * ((1 - t) / (1 + t)) ** (.5 * n);
}
function Bi() {
	this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.coslat0 = Math.cos(this.lat0), this.sinlat0 = Math.sin(this.lat0), this.sphere ? !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= 1e-10 && (this.k0 = .5 * (1 + un(this.lat0) * Math.sin(this.lat_ts))) : (Math.abs(this.coslat0) <= 1e-10 && (this.lat0 > 0 ? this.con = 1 : this.con = -1), this.cons = Math.sqrt((1 + this.e) ** +(1 + this.e) * (1 - this.e) ** (1 - this.e)), !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= 1e-10 && Math.abs(Math.cos(this.lat_ts)) > 1e-10 && (this.k0 = .5 * this.cons * ln(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / dn(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts))), this.ms1 = ln(this.e, this.sinlat0, this.coslat0), this.X0 = 2 * Math.atan(zi(this.lat0, this.sinlat0, this.e)) - G, this.cosX0 = Math.cos(this.X0), this.sinX0 = Math.sin(this.X0));
}
function Vi(e) {
	var t = e.x, n = e.y, r = Math.sin(n), i = Math.cos(n), a, o, s, c, l, u, d = K(t - this.long0, this.over);
	return Math.abs(Math.abs(t - this.long0) - Math.PI) <= 1e-10 && Math.abs(n + this.lat0) <= 1e-10 ? (e.x = NaN, e.y = NaN, e) : this.sphere ? (a = 2 * this.k0 / (1 + this.sinlat0 * r + this.coslat0 * i * Math.cos(d)), e.x = this.a * a * i * Math.sin(d) + this.x0, e.y = this.a * a * (this.coslat0 * r - this.sinlat0 * i * Math.cos(d)) + this.y0, e) : (o = 2 * Math.atan(zi(n, r, this.e)) - G, c = Math.cos(o), s = Math.sin(o), Math.abs(this.coslat0) <= 1e-10 ? (l = dn(this.e, n * this.con, this.con * r), u = 2 * this.a * this.k0 * l / this.cons, e.x = this.x0 + u * Math.sin(t - this.long0), e.y = this.y0 - this.con * u * Math.cos(t - this.long0), e) : (Math.abs(this.sinlat0) < 1e-10 ? (a = 2 * this.a * this.k0 / (1 + c * Math.cos(d)), e.y = a * s) : (a = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * s + this.cosX0 * c * Math.cos(d))), e.y = a * (this.cosX0 * s - this.sinX0 * c * Math.cos(d)) + this.y0), e.x = a * c * Math.sin(d) + this.x0, e));
}
function Hi(e) {
	e.x -= this.x0, e.y -= this.y0;
	var t, n, r, i, a, o = Math.sqrt(e.x * e.x + e.y * e.y);
	if (this.sphere) {
		var s = 2 * Math.atan(o / (2 * this.a * this.k0));
		return t = this.long0, n = this.lat0, o <= 1e-10 ? (e.x = t, e.y = n, e) : (n = Math.asin(Math.cos(s) * this.sinlat0 + e.y * Math.sin(s) * this.coslat0 / o), t = Math.abs(this.coslat0) < 1e-10 ? this.lat0 > 0 ? K(this.long0 + Math.atan2(e.x, -1 * e.y), this.over) : K(this.long0 + Math.atan2(e.x, e.y), this.over) : K(this.long0 + Math.atan2(e.x * Math.sin(s), o * this.coslat0 * Math.cos(s) - e.y * this.sinlat0 * Math.sin(s)), this.over), e.x = t, e.y = n, e);
	} else if (Math.abs(this.coslat0) <= 1e-10) {
		if (o <= 1e-10) return n = this.lat0, t = this.long0, e.x = t, e.y = n, e;
		e.x *= this.con, e.y *= this.con, r = o * this.cons / (2 * this.a * this.k0), n = this.con * fn(this.e, r), t = this.con * K(this.con * this.long0 + Math.atan2(e.x, -1 * e.y), this.over);
	} else i = 2 * Math.atan(o * this.cosX0 / (2 * this.a * this.k0 * this.ms1)), t = this.long0, o <= 1e-10 ? a = this.X0 : (a = Math.asin(Math.cos(i) * this.sinX0 + e.y * Math.sin(i) * this.cosX0 / o), t = K(this.long0 + Math.atan2(e.x * Math.sin(i), o * this.cosX0 * Math.cos(i) - e.y * this.sinX0 * Math.sin(i)), this.over)), n = -1 * fn(this.e, Math.tan(.5 * (G + a)));
	return e.x = t, e.y = n, e;
}
var Ui = {
	init: Bi,
	forward: Vi,
	inverse: Hi,
	names: [
		"stere",
		"Stereographic_South_Pole",
		"Polar_Stereographic_variant_A",
		"Polar_Stereographic_variant_B",
		"Polar_Stereographic"
	],
	ssfn_: zi
};
//#endregion
//#region node_modules/proj4/lib/projections/somerc.js
function Wi() {
	this.k0 ||= 1;
	var e = this.lat0;
	this.lambda0 = this.long0;
	var t = Math.sin(e), n = this.a, r = 1 / this.rf, i = 2 * r - r ** 2, a = this.e = Math.sqrt(i);
	this.R = this.k0 * n * Math.sqrt(1 - i) / (1 - i * t ** 2), this.alpha = Math.sqrt(1 + i / (1 - i) * Math.cos(e) ** 4), this.b0 = Math.asin(t / this.alpha);
	var o = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2)), s = Math.log(Math.tan(Math.PI / 4 + e / 2)), c = Math.log((1 + a * t) / (1 - a * t));
	this.K = o - this.alpha * s + this.alpha * a / 2 * c;
}
function Gi(e) {
	var t = Math.log(Math.tan(Math.PI / 4 - e.y / 2)), n = this.e / 2 * Math.log((1 + this.e * Math.sin(e.y)) / (1 - this.e * Math.sin(e.y))), r = -this.alpha * (t + n) + this.K, i = 2 * (Math.atan(Math.exp(r)) - Math.PI / 4), a = this.alpha * (e.x - this.lambda0), o = Math.atan(Math.sin(a) / (Math.sin(this.b0) * Math.tan(i) + Math.cos(this.b0) * Math.cos(a))), s = Math.asin(Math.cos(this.b0) * Math.sin(i) - Math.sin(this.b0) * Math.cos(i) * Math.cos(a));
	return e.y = this.R / 2 * Math.log((1 + Math.sin(s)) / (1 - Math.sin(s))) + this.y0, e.x = this.R * o + this.x0, e;
}
function Ki(e) {
	for (var t = e.x - this.x0, n = e.y - this.y0, r = t / this.R, i = 2 * (Math.atan(Math.exp(n / this.R)) - Math.PI / 4), a = Math.asin(Math.cos(this.b0) * Math.sin(i) + Math.sin(this.b0) * Math.cos(i) * Math.cos(r)), o = Math.atan(Math.sin(r) / (Math.cos(this.b0) * Math.cos(r) - Math.sin(this.b0) * Math.tan(i))), s = this.lambda0 + o / this.alpha, c = 0, l = a, u = -1e3, d = 0; Math.abs(l - u) > 1e-7;) {
		if (++d > 20) return;
		c = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + a / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(l)) / 2)), u = l, l = 2 * Math.atan(Math.exp(c)) - Math.PI / 2;
	}
	return e.x = s, e.y = l, e;
}
var qi = {
	init: Wi,
	forward: Gi,
	inverse: Ki,
	names: ["somerc"]
}, Ji = 1e-7;
function Yi(e) {
	var t = [
		"Hotine_Oblique_Mercator",
		"Hotine_Oblique_Mercator_variant_A",
		"Hotine_Oblique_Mercator_Azimuth_Natural_Origin"
	], n = typeof e.projName == "object" ? Object.keys(e.projName)[0] : e.projName;
	return "no_uoff" in e || "no_off" in e || t.indexOf(n) !== -1 || t.indexOf(wn(n)) !== -1;
}
function Xi() {
	var e, t, n, r, i, a, o, s, c, l, u = 0, d, f = 0, p = 0, m = 0, h = 0, g = 0, _ = 0;
	this.k0 ||= 1, this.no_off = Yi(this), this.no_rot = "no_rot" in this;
	var v = !1;
	"alpha" in this && (v = !0);
	var y = !1;
	if ("rectified_grid_angle" in this && (y = !0), v && (_ = this.alpha), y && (u = this.rectified_grid_angle, v ||= (_ = 0, !0)), v || y) f = this.longc;
	else if (p = this.long1, h = this.lat1, m = this.long2, g = this.lat2, Math.abs(h - g) <= Ji || (e = Math.abs(h)) <= Ji || Math.abs(e - G) <= Ji || Math.abs(Math.abs(this.lat0) - G) <= Ji || Math.abs(Math.abs(g) - G) <= Ji) throw Error();
	var b = 1 - this.es;
	t = Math.sqrt(b), Math.abs(this.lat0) > 1e-10 ? (s = Math.sin(this.lat0), n = Math.cos(this.lat0), e = 1 - this.es * s * s, this.B = n * n, this.B = Math.sqrt(1 + this.es * this.B * this.B / b), this.A = this.B * this.k0 * t / e, r = this.B * t / (n * Math.sqrt(e)), i = r * r - 1, i <= 0 ? i = 0 : (i = Math.sqrt(i), this.lat0 < 0 && (i = -i)), this.E = i += r, this.E *= dn(this.e, this.lat0, s) ** +this.B) : (this.B = 1 / t, this.A = this.k0, this.E = r = i = 1), v || y ? (v ? (d = Math.asin(Math.sin(_) / r), y || (u = _)) : (d = u, _ = Math.asin(r * Math.sin(d))), this.lam0 = f - Math.asin(.5 * (i - 1 / i) * Math.tan(d)) / this.B) : (a = dn(this.e, h, Math.sin(h)) ** +this.B, o = dn(this.e, g, Math.sin(g)) ** +this.B, i = this.E / a, c = (o - a) / (o + a), l = this.E * this.E, l = (l - o * a) / (l + o * a), e = p - m, e < -Math.PI ? m -= mt : e > Math.PI && (m += mt), this.lam0 = K(.5 * (p + m) - Math.atan(l * Math.tan(.5 * this.B * (p - m)) / c) / this.B, this.over), d = Math.atan(2 * Math.sin(this.B * K(p - this.lam0, this.over)) / (i - 1 / i)), u = _ = Math.asin(r * Math.sin(d))), this.singam = Math.sin(d), this.cosgam = Math.cos(d), this.sinrot = Math.sin(u), this.cosrot = Math.cos(u), this.rB = 1 / this.B, this.ArB = this.A * this.rB, this.BrA = 1 / this.ArB, this.no_off ? this.u_0 = 0 : (this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(r * r - 1) / Math.cos(_))), this.lat0 < 0 && (this.u_0 = -this.u_0)), i = .5 * d, this.v_pole_n = this.ArB * Math.log(Math.tan(pt - i)), this.v_pole_s = this.ArB * Math.log(Math.tan(pt + i));
}
function Zi(e) {
	var t = {}, n, r, i, a, o, s, c, l;
	if (e.x -= this.lam0, Math.abs(Math.abs(e.y) - G) > 1e-10) {
		if (o = this.E / dn(this.e, e.y, Math.sin(e.y)) ** +this.B, s = 1 / o, n = .5 * (o - s), r = .5 * (o + s), a = Math.sin(this.B * e.x), i = (n * this.singam - a * this.cosgam) / r, Math.abs(Math.abs(i) - 1) < 1e-10) throw Error();
		l = .5 * this.ArB * Math.log((1 - i) / (1 + i)), s = Math.cos(this.B * e.x), c = Math.abs(s) < Ji ? this.A * e.x : this.ArB * Math.atan2(n * this.cosgam + a * this.singam, s);
	} else l = e.y > 0 ? this.v_pole_n : this.v_pole_s, c = this.ArB * e.y;
	return this.no_rot ? (t.x = c, t.y = l) : (c -= this.u_0, t.x = l * this.cosrot + c * this.sinrot, t.y = c * this.cosrot - l * this.sinrot), t.x = this.a * t.x + this.x0, t.y = this.a * t.y + this.y0, t;
}
function Qi(e) {
	var t, n, r, i, a, o, s, c = {};
	if (e.x = (e.x - this.x0) * (1 / this.a), e.y = (e.y - this.y0) * (1 / this.a), this.no_rot ? (n = e.y, t = e.x) : (n = e.x * this.cosrot - e.y * this.sinrot, t = e.y * this.cosrot + e.x * this.sinrot + this.u_0), r = Math.exp(-this.BrA * n), i = .5 * (r - 1 / r), a = .5 * (r + 1 / r), o = Math.sin(this.BrA * t), s = (o * this.cosgam + i * this.singam) / a, Math.abs(Math.abs(s) - 1) < 1e-10) c.x = 0, c.y = s < 0 ? -G : G;
	else {
		if (c.y = this.E / Math.sqrt((1 + s) / (1 - s)), c.y = fn(this.e, c.y ** (1 / this.B)), c.y === Infinity) throw Error();
		c.x = -this.rB * Math.atan2(i * this.cosgam - o * this.singam, Math.cos(this.BrA * t));
	}
	return c.x += this.lam0, c;
}
var $i = {
	init: Xi,
	forward: Zi,
	inverse: Qi,
	names: [
		"Hotine_Oblique_Mercator",
		"Hotine Oblique Mercator",
		"Hotine_Oblique_Mercator_variant_A",
		"Hotine_Oblique_Mercator_Variant_B",
		"Hotine_Oblique_Mercator_Azimuth_Natural_Origin",
		"Hotine_Oblique_Mercator_Two_Point_Natural_Origin",
		"Hotine_Oblique_Mercator_Azimuth_Center",
		"Oblique_Mercator",
		"omerc"
	]
};
//#endregion
//#region node_modules/proj4/lib/projections/lcc.js
function ea() {
	if (this.lat2 ||= this.lat1, this.k0 ||= 1, this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.long0 = this.long0 || 0, !(Math.abs(this.lat1 + this.lat2) < 1e-10)) {
		var e = this.b / this.a;
		this.e = Math.sqrt(1 - e * e);
		var t = Math.sin(this.lat1), n = Math.cos(this.lat1), r = ln(this.e, t, n), i = dn(this.e, this.lat1, t), a = Math.sin(this.lat2), o = Math.cos(this.lat2), s = ln(this.e, a, o), c = dn(this.e, this.lat2, a), l = dn(this.e, this.lat0, Math.sin(this.lat0));
		Math.abs(this.lat1 - this.lat2) > 1e-10 ? this.ns = Math.log(r / s) / Math.log(i / c) : this.ns = t, isNaN(this.ns) && (this.ns = t), this.f0 = r / (this.ns * i ** +this.ns), this.rh = Math.abs(Math.abs(this.lat0) - G) < 1e-10 ? 0 : this.a * this.f0 * l ** +this.ns, this.title ||= "Lambert Conformal Conic";
	}
}
function ta(e) {
	var t = e.x, n = e.y;
	Math.abs(2 * Math.abs(n) - Math.PI) <= 1e-10 && (n = un(n) * (G - 2 * ut));
	var r = Math.abs(Math.abs(n) - G), i, a;
	if (r > 1e-10) i = dn(this.e, n, Math.sin(n)), a = this.a * this.f0 * i ** +this.ns;
	else {
		if (r = n * this.ns, r <= 0) return null;
		a = 0;
	}
	var o = this.ns * K(t - this.long0, this.over);
	return e.x = this.k0 * (a * Math.sin(o)) + this.x0, e.y = this.k0 * (this.rh - a * Math.cos(o)) + this.y0, e;
}
function na(e) {
	var t, n, r, i, a, o = (e.x - this.x0) / this.k0, s = this.rh - (e.y - this.y0) / this.k0;
	this.ns > 0 ? (t = Math.sqrt(o * o + s * s), n = 1) : (t = -Math.sqrt(o * o + s * s), n = -1);
	var c = 0;
	if (t !== 0 && (c = Math.atan2(n * o, n * s)), t !== 0 || this.ns > 0) {
		if (n = 1 / this.ns, r = (t / (this.a * this.f0)) ** +n, i = fn(this.e, r), i === -9999) return null;
	} else i = -G;
	return a = K(c / this.ns + this.long0, this.over), e.x = a, e.y = i, e;
}
var ra = {
	init: ea,
	forward: ta,
	inverse: na,
	names: [
		"Lambert Tangential Conformal Conic Projection",
		"Lambert_Conformal_Conic",
		"Lambert_Conformal_Conic_1SP",
		"Lambert_Conformal_Conic_2SP",
		"lcc",
		"Lambert Conic Conformal (1SP)",
		"Lambert Conic Conformal (2SP)"
	]
};
//#endregion
//#region node_modules/proj4/lib/projections/krovak.js
function ia() {
	this.a = 6377397.155, this.es = .006674372230614, this.e = Math.sqrt(this.es), this.lat0 ||= .863937979737193, this.long0 ||= .4334234309119251, this.k0 ||= .9999, this.s45 = .785398163397448, this.s90 = 2 * this.s45, this.fi0 = this.lat0, this.e2 = this.es, this.e = Math.sqrt(this.e2), this.alfa = Math.sqrt(1 + this.e2 * Math.cos(this.fi0) ** 4 / (1 - this.e2)), this.uq = 1.04216856380474, this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa), this.g = ((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0))) ** (this.alfa * this.e / 2), this.k = Math.tan(this.u0 / 2 + this.s45) / Math.tan(this.fi0 / 2 + this.s45) ** +this.alfa * this.g, this.k1 = this.k0, this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.sin(this.fi0) ** 2), this.s0 = 1.37008346281555, this.n = Math.sin(this.s0), this.ro0 = this.k1 * this.n0 / Math.tan(this.s0), this.ad = this.s90 - this.uq;
}
function aa(e) {
	var t, n, r, i, a, o, s, c = e.x, l = e.y, u = K(c - this.long0, this.over);
	return t = ((1 + this.e * Math.sin(l)) / (1 - this.e * Math.sin(l))) ** (this.alfa * this.e / 2), n = 2 * (Math.atan(this.k * Math.tan(l / 2 + this.s45) ** +this.alfa / t) - this.s45), r = -u * this.alfa, i = Math.asin(Math.cos(this.ad) * Math.sin(n) + Math.sin(this.ad) * Math.cos(n) * Math.cos(r)), a = Math.asin(Math.cos(n) * Math.sin(r) / Math.cos(i)), o = this.n * a, s = this.ro0 * Math.tan(this.s0 / 2 + this.s45) ** +this.n / Math.tan(i / 2 + this.s45) ** +this.n, e.y = s * Math.cos(o) / 1, e.x = s * Math.sin(o) / 1, this.czech || (e.y *= -1, e.x *= -1), e;
}
function oa(e) {
	var t, n, r, i, a, o, s, c, l = e.x;
	e.x = e.y, e.y = l, this.czech || (e.y *= -1, e.x *= -1), o = Math.sqrt(e.x * e.x + e.y * e.y), a = Math.atan2(e.y, e.x), i = a / Math.sin(this.s0), r = 2 * (Math.atan((this.ro0 / o) ** (1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45), t = Math.asin(Math.cos(this.ad) * Math.sin(r) - Math.sin(this.ad) * Math.cos(r) * Math.cos(i)), n = Math.asin(Math.cos(r) * Math.sin(i) / Math.cos(t)), e.x = this.long0 - n / this.alfa, s = t, c = 0;
	var u = 0;
	do
		e.y = 2 * (Math.atan(this.k ** (-1 / this.alfa) * Math.tan(t / 2 + this.s45) ** (1 / this.alfa) * ((1 + this.e * Math.sin(s)) / (1 - this.e * Math.sin(s))) ** (this.e / 2)) - this.s45), Math.abs(s - e.y) < 1e-10 && (c = 1), s = e.y, u += 1;
	while (c === 0 && u < 15);
	return u >= 15 ? null : e;
}
var sa = {
	init: ia,
	forward: aa,
	inverse: oa,
	names: [
		"Krovak",
		"Krovak Modified",
		"Krovak (North Orientated)",
		"Krovak Modified (North Orientated)",
		"krovak"
	]
};
//#endregion
//#region node_modules/proj4/lib/common/mlfn.js
function ca(e, t, n, r, i) {
	return e * i - t * Math.sin(2 * i) + n * Math.sin(4 * i) - r * Math.sin(6 * i);
}
//#endregion
//#region node_modules/proj4/lib/common/e0fn.js
function la(e) {
	return 1 - .25 * e * (1 + e / 16 * (3 + 1.25 * e));
}
//#endregion
//#region node_modules/proj4/lib/common/e1fn.js
function ua(e) {
	return .375 * e * (1 + .25 * e * (1 + .46875 * e));
}
//#endregion
//#region node_modules/proj4/lib/common/e2fn.js
function da(e) {
	return .05859375 * e * e * (1 + .75 * e);
}
//#endregion
//#region node_modules/proj4/lib/common/e3fn.js
function fa(e) {
	return e * e * e * (35 / 3072);
}
//#endregion
//#region node_modules/proj4/lib/common/gN.js
function pa(e, t, n) {
	var r = t * n;
	return e / Math.sqrt(1 - r * r);
}
//#endregion
//#region node_modules/proj4/lib/common/adjust_lat.js
function ma(e) {
	return Math.abs(e) < G ? e : e - un(e) * Math.PI;
}
//#endregion
//#region node_modules/proj4/lib/common/imlfn.js
function ha(e, t, n, r, i) {
	for (var a = e / t, o, s = 0; s < 15; s++) if (o = (e - (t * a - n * Math.sin(2 * a) + r * Math.sin(4 * a) - i * Math.sin(6 * a))) / (t - 2 * n * Math.cos(2 * a) + 4 * r * Math.cos(4 * a) - 6 * i * Math.cos(6 * a)), a += o, Math.abs(o) <= 1e-10) return a;
	return NaN;
}
//#endregion
//#region node_modules/proj4/lib/projections/cass.js
function ga() {
	this.sphere || (this.e0 = la(this.es), this.e1 = ua(this.es), this.e2 = da(this.es), this.e3 = fa(this.es), this.ml0 = this.a * ca(this.e0, this.e1, this.e2, this.e3, this.lat0));
}
function _a(e) {
	var t, n, r = e.x, i = e.y;
	if (r = K(r - this.long0, this.over), this.sphere) t = this.a * Math.asin(Math.cos(i) * Math.sin(r)), n = this.a * (Math.atan2(Math.tan(i), Math.cos(r)) - this.lat0);
	else {
		var a = Math.sin(i), o = Math.cos(i), s = pa(this.a, this.e, a), c = Math.tan(i) * Math.tan(i), l = r * Math.cos(i), u = l * l, d = this.es * o * o / (1 - this.es), f = this.a * ca(this.e0, this.e1, this.e2, this.e3, i);
		t = s * l * (1 - u * c * (1 / 6 - (8 - c + 8 * d) * u / 120)), n = f - this.ml0 + s * a / o * u * (.5 + (5 - c + 6 * d) * u / 24);
	}
	return e.x = t + this.x0, e.y = n + this.y0, e;
}
function va(e) {
	e.x -= this.x0, e.y -= this.y0;
	var t = e.x / this.a, n = e.y / this.a, r, i;
	if (this.sphere) {
		var a = n + this.lat0;
		r = Math.asin(Math.sin(a) * Math.cos(t)), i = Math.atan2(Math.tan(t), Math.cos(a));
	} else {
		var o = ha(this.ml0 / this.a + n, this.e0, this.e1, this.e2, this.e3);
		if (Math.abs(Math.abs(o) - G) <= 1e-10) return e.x = this.long0, e.y = G, n < 0 && (e.y *= -1), e;
		var s = pa(this.a, this.e, Math.sin(o)), c = s * s * s / this.a / this.a * (1 - this.es), l = Math.tan(o) ** 2, u = t * this.a / s, d = u * u;
		r = o - s * Math.tan(o) / c * u * u * (.5 - (1 + 3 * l) * u * u / 24), i = u * (1 - d * (l / 3 + (1 + 3 * l) * l * d / 15)) / Math.cos(o);
	}
	return e.x = K(i + this.long0, this.over), e.y = ma(r), e;
}
var ya = {
	init: ga,
	forward: _a,
	inverse: va,
	names: [
		"Cassini",
		"Cassini_Soldner",
		"cass"
	]
};
//#endregion
//#region node_modules/proj4/lib/common/qsfnz.js
function ba(e, t) {
	var n;
	return e > 1e-7 ? (n = e * t, (1 - e * e) * (t / (1 - n * n) - .5 / e * Math.log((1 - n) / (1 + n)))) : 2 * t;
}
//#endregion
//#region node_modules/proj4/lib/common/authset.js
var xa = .3333333333333333, Sa = .17222222222222222, Ca = .10257936507936508, wa = .06388888888888888, Ta = .0664021164021164, Ea = .016415012942191543;
function Da(e) {
	var t, n = [];
	return n[0] = e * xa, t = e * e, n[0] += t * Sa, n[1] = t * wa, t *= e, n[0] += t * Ca, n[1] += t * Ta, n[2] = t * Ea, n;
}
//#endregion
//#region node_modules/proj4/lib/common/authlat.js
function Oa(e, t) {
	var n = e + e;
	return e + t[0] * Math.sin(n) + t[1] * Math.sin(n + n) + t[2] * Math.sin(n + n + n);
}
function ka() {
	var e = Math.abs(this.lat0);
	if (Math.abs(e - G) < 1e-10 ? this.mode = this.lat0 < 0 ? 1 : 2 : Math.abs(e) < 1e-10 ? this.mode = 3 : this.mode = 4, this.es > 0) {
		var t;
		switch (this.qp = ba(this.e, 1), this.mmf = .5 / (1 - this.es), this.apa = Da(this.es), this.mode) {
			case 2:
				this.dd = 1;
				break;
			case 1:
				this.dd = 1;
				break;
			case 3:
				this.rq = Math.sqrt(.5 * this.qp), this.dd = 1 / this.rq, this.xmf = 1, this.ymf = .5 * this.qp;
				break;
			case 4:
				this.rq = Math.sqrt(.5 * this.qp), t = Math.sin(this.lat0), this.sinb1 = ba(this.e, t) / this.qp, this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1), this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * t * t) * this.rq * this.cosb1), this.ymf = (this.xmf = this.rq) / this.dd, this.xmf *= this.dd;
				break;
		}
	} else this.mode === 4 && (this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0));
}
function Aa(e) {
	var t, n, r, i, a, o, s, c, l, u, d = e.x, f = e.y;
	if (d = K(d - this.long0, this.over), this.sphere) {
		if (a = Math.sin(f), u = Math.cos(f), r = Math.cos(d), this.mode === this.OBLIQ || this.mode === this.EQUIT) {
			if (n = this.mode === this.EQUIT ? 1 + u * r : 1 + this.sinph0 * a + this.cosph0 * u * r, n <= 1e-10) return null;
			n = Math.sqrt(2 / n), t = n * u * Math.sin(d), n *= this.mode === this.EQUIT ? a : this.cosph0 * a - this.sinph0 * u * r;
		} else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
			if (this.mode === this.N_POLE && (r = -r), Math.abs(f + this.lat0) < 1e-10) return null;
			n = pt - f * .5, n = 2 * (this.mode === this.S_POLE ? Math.cos(n) : Math.sin(n)), t = n * Math.sin(d), n *= r;
		}
	} else {
		switch (s = 0, c = 0, l = 0, r = Math.cos(d), i = Math.sin(d), a = Math.sin(f), o = ba(this.e, a), (this.mode === this.OBLIQ || this.mode === this.EQUIT) && (s = o / this.qp, c = Math.sqrt(1 - s * s)), this.mode) {
			case this.OBLIQ:
				l = 1 + this.sinb1 * s + this.cosb1 * c * r;
				break;
			case this.EQUIT:
				l = 1 + c * r;
				break;
			case this.N_POLE:
				l = G + f, o = this.qp - o;
				break;
			case this.S_POLE:
				l = f - G, o = this.qp + o;
				break;
		}
		if (Math.abs(l) < 1e-10) return null;
		switch (this.mode) {
			case this.OBLIQ:
			case this.EQUIT:
				l = Math.sqrt(2 / l), n = this.mode === this.OBLIQ ? this.ymf * l * (this.cosb1 * s - this.sinb1 * c * r) : (l = Math.sqrt(2 / (1 + c * r))) * s * this.ymf, t = this.xmf * l * c * i;
				break;
			case this.N_POLE:
			case this.S_POLE:
				o >= 0 ? (t = (l = Math.sqrt(o)) * i, n = r * (this.mode === this.S_POLE ? l : -l)) : t = n = 0;
				break;
		}
	}
	return e.x = this.a * t + this.x0, e.y = this.a * n + this.y0, e;
}
function ja(e) {
	e.x -= this.x0, e.y -= this.y0;
	var t = e.x / this.a, n = e.y / this.a, r, i, a, o, s, c, l;
	if (this.sphere) {
		var u = 0, d, f = 0;
		if (d = Math.sqrt(t * t + n * n), i = d * .5, i > 1) return null;
		switch (i = 2 * Math.asin(i), (this.mode === this.OBLIQ || this.mode === this.EQUIT) && (f = Math.sin(i), u = Math.cos(i)), this.mode) {
			case this.EQUIT:
				i = Math.abs(d) <= 1e-10 ? 0 : Math.asin(n * f / d), t *= f, n = u * d;
				break;
			case this.OBLIQ:
				i = Math.abs(d) <= 1e-10 ? this.lat0 : Math.asin(u * this.sinph0 + n * f * this.cosph0 / d), t *= f * this.cosph0, n = (u - Math.sin(i) * this.sinph0) * d;
				break;
			case this.N_POLE:
				n = -n, i = G - i;
				break;
			case this.S_POLE:
				i -= G;
				break;
		}
		r = n === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(t, n);
	} else {
		if (l = 0, this.mode === this.OBLIQ || this.mode === this.EQUIT) {
			if (t /= this.dd, n *= this.dd, c = Math.sqrt(t * t + n * n), c < 1e-10) return e.x = this.long0, e.y = this.lat0, e;
			o = 2 * Math.asin(.5 * c / this.rq), a = Math.cos(o), t *= o = Math.sin(o), this.mode === this.OBLIQ ? (l = a * this.sinb1 + n * o * this.cosb1 / c, s = this.qp * l, n = c * this.cosb1 * a - n * this.sinb1 * o) : (l = n * o / c, s = this.qp * l, n = c * a);
		} else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
			if (this.mode === this.N_POLE && (n = -n), s = t * t + n * n, !s) return e.x = this.long0, e.y = this.lat0, e;
			l = 1 - s / this.qp, this.mode === this.S_POLE && (l = -l);
		}
		r = Math.atan2(t, n), i = Oa(Math.asin(l), this.apa);
	}
	return e.x = K(this.long0 + r, this.over), e.y = i, e;
}
var Ma = {
	init: ka,
	forward: Aa,
	inverse: ja,
	names: [
		"Lambert Azimuthal Equal Area",
		"Lambert_Azimuthal_Equal_Area",
		"laea"
	],
	S_POLE: 1,
	N_POLE: 2,
	EQUIT: 3,
	OBLIQ: 4
};
//#endregion
//#region node_modules/proj4/lib/common/asinz.js
function Na(e) {
	return Math.abs(e) > 1 && (e = e > 1 ? 1 : -1), Math.asin(e);
}
//#endregion
//#region node_modules/proj4/lib/projections/aea.js
function Pa() {
	Math.abs(this.lat1 + this.lat2) < 1e-10 || (this.temp = this.b / this.a, this.es = 1 - this.temp ** 2, this.e3 = Math.sqrt(this.es), this.sin_po = Math.sin(this.lat1), this.cos_po = Math.cos(this.lat1), this.t1 = this.sin_po, this.con = this.sin_po, this.ms1 = ln(this.e3, this.sin_po, this.cos_po), this.qs1 = ba(this.e3, this.sin_po), this.sin_po = Math.sin(this.lat2), this.cos_po = Math.cos(this.lat2), this.t2 = this.sin_po, this.ms2 = ln(this.e3, this.sin_po, this.cos_po), this.qs2 = ba(this.e3, this.sin_po), this.sin_po = Math.sin(this.lat0), this.cos_po = Math.cos(this.lat0), this.t3 = this.sin_po, this.qs0 = ba(this.e3, this.sin_po), Math.abs(this.lat1 - this.lat2) > 1e-10 ? this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1) : this.ns0 = this.con, this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1, this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0);
}
function Fa(e) {
	var t = e.x, n = e.y;
	this.sin_phi = Math.sin(n), this.cos_phi = Math.cos(n);
	var r = ba(this.e3, this.sin_phi), i = this.a * Math.sqrt(this.c - this.ns0 * r) / this.ns0, a = this.ns0 * K(t - this.long0, this.over), o = i * Math.sin(a) + this.x0, s = this.rh - i * Math.cos(a) + this.y0;
	return e.x = o, e.y = s, e;
}
function Ia(e) {
	var t, n, r, i, a, o;
	return e.x -= this.x0, e.y = this.rh - e.y + this.y0, this.ns0 >= 0 ? (t = Math.sqrt(e.x * e.x + e.y * e.y), r = 1) : (t = -Math.sqrt(e.x * e.x + e.y * e.y), r = -1), i = 0, t !== 0 && (i = Math.atan2(r * e.x, r * e.y)), r = t * this.ns0 / this.a, this.sphere ? o = Math.asin((this.c - r * r) / (2 * this.ns0)) : (n = (this.c - r * r) / this.ns0, o = this.phi1z(this.e3, n)), a = K(i / this.ns0 + this.long0, this.over), e.x = a, e.y = o, e;
}
function La(e, t) {
	var n, r, i, a, o, s = Na(.5 * t);
	if (e < 1e-10) return s;
	for (var c = e * e, l = 1; l <= 25; l++) if (n = Math.sin(s), r = Math.cos(s), i = e * n, a = 1 - i * i, o = .5 * a * a / r * (t / (1 - c) - n / a + .5 / e * Math.log((1 - i) / (1 + i))), s += o, Math.abs(o) <= 1e-7) return s;
	return null;
}
var Ra = {
	init: Pa,
	forward: Fa,
	inverse: Ia,
	names: [
		"Albers_Conic_Equal_Area",
		"Albers_Equal_Area",
		"Albers",
		"aea"
	],
	phi1z: La
};
//#endregion
//#region node_modules/proj4/lib/projections/gnom.js
function za() {
	this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0), this.infinity_dist = 1e3 * this.a, this.rc = 1;
}
function Ba(e) {
	var t, n, r, i, a, o, s, c, l = e.x, u = e.y;
	return r = K(l - this.long0, this.over), t = Math.sin(u), n = Math.cos(u), i = Math.cos(r), o = this.sin_p14 * t + this.cos_p14 * n * i, a = 1, o > 0 || Math.abs(o) <= 1e-10 ? (s = this.x0 + this.a * a * n * Math.sin(r) / o, c = this.y0 + this.a * a * (this.cos_p14 * t - this.sin_p14 * n * i) / o) : (s = this.x0 + this.infinity_dist * n * Math.sin(r), c = this.y0 + this.infinity_dist * (this.cos_p14 * t - this.sin_p14 * n * i)), e.x = s, e.y = c, e;
}
function Va(e) {
	var t, n, r, i, a, o;
	return e.x = (e.x - this.x0) / this.a, e.y = (e.y - this.y0) / this.a, e.x /= this.k0, e.y /= this.k0, (t = Math.sqrt(e.x * e.x + e.y * e.y)) ? (i = Math.atan2(t, this.rc), n = Math.sin(i), r = Math.cos(i), o = Na(r * this.sin_p14 + e.y * n * this.cos_p14 / t), a = Math.atan2(e.x * n, t * this.cos_p14 * r - e.y * this.sin_p14 * n), a = K(this.long0 + a, this.over)) : (o = this.phic0, a = 0), e.x = a, e.y = o, e;
}
var Ha = {
	init: za,
	forward: Ba,
	inverse: Va,
	names: ["gnom"]
};
//#endregion
//#region node_modules/proj4/lib/common/iqsfnz.js
function Ua(e, t) {
	var n = 1 - (1 - e * e) / (2 * e) * Math.log((1 - e) / (1 + e));
	if (Math.abs(Math.abs(t) - n) < 1e-6) return t < 0 ? -1 * G : G;
	for (var r = Math.asin(.5 * t), i, a, o, s, c = 0; c < 30; c++) if (a = Math.sin(r), o = Math.cos(r), s = e * a, i = (1 - s * s) ** 2 / (2 * o) * (t / (1 - e * e) - a / (1 - s * s) + .5 / e * Math.log((1 - s) / (1 + s))), r += i, Math.abs(i) <= 1e-10) return r;
	return NaN;
}
//#endregion
//#region node_modules/proj4/lib/projections/cea.js
function Wa() {
	this.sphere || (this.k0 = ln(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)));
}
function Ga(e) {
	var t = e.x, n = e.y, r, i, a = K(t - this.long0, this.over);
	if (this.sphere) r = this.x0 + this.a * a * Math.cos(this.lat_ts), i = this.y0 + this.a * Math.sin(n) / Math.cos(this.lat_ts);
	else {
		var o = ba(this.e, Math.sin(n));
		r = this.x0 + this.a * this.k0 * a, i = this.y0 + this.a * o * .5 / this.k0;
	}
	return e.x = r, e.y = i, e;
}
function Ka(e) {
	e.x -= this.x0, e.y -= this.y0;
	var t, n;
	return this.sphere ? (t = K(this.long0 + e.x / this.a / Math.cos(this.lat_ts), this.over), n = Math.asin(e.y / this.a * Math.cos(this.lat_ts))) : (n = Ua(this.e, 2 * e.y * this.k0 / this.a), t = K(this.long0 + e.x / (this.a * this.k0), this.over)), e.x = t, e.y = n, e;
}
var qa = {
	init: Wa,
	forward: Ga,
	inverse: Ka,
	names: ["cea"]
};
//#endregion
//#region node_modules/proj4/lib/projections/eqc.js
function Ja() {
	this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Equidistant Cylindrical (Plate Carre)", this.rc = Math.cos(this.lat_ts);
}
function Ya(e) {
	var t = e.x, n = e.y, r = K(t - this.long0, this.over), i = ma(n - this.lat0);
	return e.x = this.x0 + this.a * r * this.rc, e.y = this.y0 + this.a * i, e;
}
function Xa(e) {
	var t = e.x, n = e.y;
	return e.x = K(this.long0 + (t - this.x0) / (this.a * this.rc), this.over), e.y = ma(this.lat0 + (n - this.y0) / this.a), e;
}
var Za = {
	init: Ja,
	forward: Ya,
	inverse: Xa,
	names: [
		"Equirectangular",
		"Equidistant_Cylindrical",
		"Equidistant_Cylindrical_Spherical",
		"eqc"
	]
}, Qa = 20;
function $a() {
	this.temp = this.b / this.a, this.es = 1 - this.temp ** 2, this.e = Math.sqrt(this.es), this.e0 = la(this.es), this.e1 = ua(this.es), this.e2 = da(this.es), this.e3 = fa(this.es), this.ml0 = this.a * ca(this.e0, this.e1, this.e2, this.e3, this.lat0);
}
function eo(e) {
	var t = e.x, n = e.y, r, i, a, o = K(t - this.long0, this.over);
	if (a = o * Math.sin(n), this.sphere) Math.abs(n) <= 1e-10 ? (r = this.a * o, i = -1 * this.a * this.lat0) : (r = this.a * Math.sin(a) / Math.tan(n), i = this.a * (ma(n - this.lat0) + (1 - Math.cos(a)) / Math.tan(n)));
	else if (Math.abs(n) <= 1e-10) r = this.a * o, i = -1 * this.ml0;
	else {
		var s = pa(this.a, this.e, Math.sin(n)) / Math.tan(n);
		r = s * Math.sin(a), i = this.a * ca(this.e0, this.e1, this.e2, this.e3, n) - this.ml0 + s * (1 - Math.cos(a));
	}
	return e.x = r + this.x0, e.y = i + this.y0, e;
}
function to(e) {
	var t, n, r = e.x - this.x0, i = e.y - this.y0, a, o, s, c, l;
	if (this.sphere) if (Math.abs(i + this.a * this.lat0) <= 1e-10) t = K(r / this.a + this.long0, this.over), n = 0;
	else {
		o = this.lat0 + i / this.a, s = r * r / this.a / this.a + o * o, c = o;
		var u;
		for (a = Qa; a; --a) if (u = Math.tan(c), l = -1 * (o * (c * u + 1) - c - .5 * (c * c + s) * u) / ((c - o) / u - 1), c += l, Math.abs(l) <= 1e-10) {
			n = c;
			break;
		}
		t = K(this.long0 + Math.asin(r * Math.tan(c) / this.a) / Math.sin(n), this.over);
	}
	else if (Math.abs(i + this.ml0) <= 1e-10) n = 0, t = K(this.long0 + r / this.a, this.over);
	else {
		o = (this.ml0 + i) / this.a, s = r * r / this.a / this.a + o * o, c = o;
		var d, f, p, m, h;
		for (a = Qa; a; --a) if (h = this.e * Math.sin(c), d = Math.sqrt(1 - h * h) * Math.tan(c), f = this.a * ca(this.e0, this.e1, this.e2, this.e3, c), p = this.e0 - 2 * this.e1 * Math.cos(2 * c) + 4 * this.e2 * Math.cos(4 * c) - 6 * this.e3 * Math.cos(6 * c), m = f / this.a, l = (o * (d * m + 1) - m - .5 * d * (m * m + s)) / (this.es * Math.sin(2 * c) * (m * m + s - 2 * o * m) / (4 * d) + (o - m) * (d * p - 2 / Math.sin(2 * c)) - p), c -= l, Math.abs(l) <= 1e-10) {
			n = c;
			break;
		}
		d = Math.sqrt(1 - this.es * Math.sin(n) ** 2) * Math.tan(n), t = K(this.long0 + Math.asin(r * d / this.a) / Math.sin(n), this.over);
	}
	return e.x = t, e.y = n, e;
}
var no = {
	init: $a,
	forward: eo,
	inverse: to,
	names: [
		"Polyconic",
		"American_Polyconic",
		"poly"
	]
};
function ro() {
	this.A = [], this.A[1] = .6399175073, this.A[2] = -.1358797613, this.A[3] = .063294409, this.A[4] = -.02526853, this.A[5] = .0117879, this.A[6] = -.0055161, this.A[7] = .0026906, this.A[8] = -.001333, this.A[9] = 67e-5, this.A[10] = -34e-5, this.B_re = [], this.B_im = [], this.B_re[1] = .7557853228, this.B_im[1] = 0, this.B_re[2] = .249204646, this.B_im[2] = .003371507, this.B_re[3] = -.001541739, this.B_im[3] = .04105856, this.B_re[4] = -.10162907, this.B_im[4] = .01727609, this.B_re[5] = -.26623489, this.B_im[5] = -.36249218, this.B_re[6] = -.6870983, this.B_im[6] = -1.1651967, this.C_re = [], this.C_im = [], this.C_re[1] = 1.3231270439, this.C_im[1] = 0, this.C_re[2] = -.577245789, this.C_im[2] = -.007809598, this.C_re[3] = .508307513, this.C_im[3] = -.112208952, this.C_re[4] = -.15094762, this.C_im[4] = .18200602, this.C_re[5] = 1.01418179, this.C_im[5] = 1.64497696, this.C_re[6] = 1.9660549, this.C_im[6] = 2.5127645, this.D = [], this.D[1] = 1.5627014243, this.D[2] = .5185406398, this.D[3] = -.03333098, this.D[4] = -.1052906, this.D[5] = -.0368594, this.D[6] = .007317, this.D[7] = .0122, this.D[8] = .00394, this.D[9] = -.0013;
}
function io(e) {
	var t, n = e.x, r = e.y - this.lat0, i = n - this.long0, a = r / ot * 1e-5, o = i, s = 1, c = 0;
	for (t = 1; t <= 10; t++) s *= a, c += this.A[t] * s;
	var l = c, u = o, d = 1, f = 0, p, m, h = 0, g = 0;
	for (t = 1; t <= 6; t++) p = d * l - f * u, m = f * l + d * u, d = p, f = m, h = h + this.B_re[t] * d - this.B_im[t] * f, g = g + this.B_im[t] * d + this.B_re[t] * f;
	return e.x = g * this.a + this.x0, e.y = h * this.a + this.y0, e;
}
function ao(e) {
	var t, n = e.x, r = e.y, i = n - this.x0, a = (r - this.y0) / this.a, o = i / this.a, s = 1, c = 0, l, u, d = 0, f = 0;
	for (t = 1; t <= 6; t++) l = s * a - c * o, u = c * a + s * o, s = l, c = u, d = d + this.C_re[t] * s - this.C_im[t] * c, f = f + this.C_im[t] * s + this.C_re[t] * c;
	for (var p = 0; p < this.iterations; p++) {
		var m = d, h = f, g, _, v = a, y = o;
		for (t = 2; t <= 6; t++) g = m * d - h * f, _ = h * d + m * f, m = g, h = _, v += (t - 1) * (this.B_re[t] * m - this.B_im[t] * h), y += (t - 1) * (this.B_im[t] * m + this.B_re[t] * h);
		m = 1, h = 0;
		var b = this.B_re[1], x = this.B_im[1];
		for (t = 2; t <= 6; t++) g = m * d - h * f, _ = h * d + m * f, m = g, h = _, b += t * (this.B_re[t] * m - this.B_im[t] * h), x += t * (this.B_im[t] * m + this.B_re[t] * h);
		var S = b * b + x * x;
		d = (v * b + y * x) / S, f = (y * b - v * x) / S;
	}
	var C = d, w = f, T = 1, E = 0;
	for (t = 1; t <= 9; t++) T *= C, E += this.D[t] * T;
	var D = this.lat0 + E * ot * 1e5;
	return e.x = this.long0 + w, e.y = D, e;
}
var oo = {
	init: ro,
	forward: io,
	inverse: ao,
	names: ["New_Zealand_Map_Grid", "nzmg"],
	iterations: 1
};
//#endregion
//#region node_modules/proj4/lib/projections/mill.js
function so() {}
function co(e) {
	var t = e.x, n = e.y, r = K(t - this.long0, this.over), i = this.x0 + this.a * r, a = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + n / 2.5)) * 1.25;
	return e.x = i, e.y = a, e;
}
function lo(e) {
	e.x -= this.x0, e.y -= this.y0;
	var t = K(this.long0 + e.x / this.a, this.over), n = 2.5 * (Math.atan(Math.exp(.8 * e.y / this.a)) - Math.PI / 4);
	return e.x = t, e.y = n, e;
}
var uo = {
	init: so,
	forward: co,
	inverse: lo,
	names: ["Miller_Cylindrical", "mill"]
}, fo = 20;
function po() {
	this.long0 = this.long0 || 0, this.sphere ? (this.n = 1, this.m = 0, this.es = 0, this.C_y = Math.sqrt((this.m + 1) / this.n), this.C_x = this.C_y / (this.m + 1)) : this.en = ai(this.es);
}
function mo(e) {
	var t, n, r = e.x, i = e.y;
	if (r = K(r - this.long0, this.over), this.sphere) {
		if (!this.m) i = this.n === 1 ? i : Math.asin(this.n * Math.sin(i));
		else for (var a = this.n * Math.sin(i), o = fo; o; --o) {
			var s = (this.m * i + Math.sin(i) - a) / (this.m + Math.cos(i));
			if (i -= s, Math.abs(s) < 1e-10) break;
		}
		t = this.a * this.C_x * r * (this.m + Math.cos(i)), n = this.a * this.C_y * i;
	} else {
		var c = Math.sin(i), l = Math.cos(i);
		n = this.a * oi(i, c, l, this.en), t = this.a * r * l / Math.sqrt(1 - this.es * c * c);
	}
	return e.x = t, e.y = n, e;
}
function ho(e) {
	var t, n, r, i;
	return e.x -= this.x0, r = e.x / this.a, e.y -= this.y0, t = e.y / this.a, this.sphere ? (t /= this.C_y, r /= this.C_x * (this.m + Math.cos(t)), this.m ? t = Na((this.m * t + Math.sin(t)) / this.n) : this.n !== 1 && (t = Na(Math.sin(t) / this.n)), r = K(r + this.long0, this.over), t = ma(t)) : (t = ci(e.y / this.a, this.es, this.en), i = Math.abs(t), i < G ? (i = Math.sin(t), n = this.long0 + e.x * Math.sqrt(1 - this.es * i * i) / (this.a * Math.cos(t)), r = K(n, this.over)) : i - 1e-10 < G && (r = this.long0)), e.x = r, e.y = t, e;
}
var go = {
	init: po,
	forward: mo,
	inverse: ho,
	names: ["Sinusoidal", "sinu"]
};
//#endregion
//#region node_modules/proj4/lib/projections/eck6.js
function _o() {
	this.sphere = !0, this.b = this.a, this.m = 1, this.n = 2.5707963267948966, this.es = 0, this.C_y = Math.sqrt((this.m + 1) / this.n), this.C_x = this.C_y / (this.m + 1);
}
var vo = {
	init: _o,
	forward: mo,
	inverse: ho,
	names: ["Eckert_VI", "eck6"]
};
//#endregion
//#region node_modules/proj4/lib/projections/moll.js
function yo() {
	this.x0 = this.x0 === void 0 ? 0 : this.x0, this.y0 = this.y0 === void 0 ? 0 : this.y0, this.long0 = this.long0 === void 0 ? 0 : this.long0;
}
function bo(e) {
	for (var t = e.x, n = e.y, r = K(t - this.long0, this.over), i = n, a = Math.PI * Math.sin(n);;) {
		var o = -(i + Math.sin(i) - a) / (1 + Math.cos(i));
		if (i += o, Math.abs(o) < 1e-10) break;
	}
	i /= 2, Math.PI / 2 - Math.abs(n) < 1e-10 && (r = 0);
	var s = .900316316158 * this.a * r * Math.cos(i) + this.x0, c = 1.4142135623731 * this.a * Math.sin(i) + this.y0;
	return e.x = s, e.y = c, e;
}
function xo(e) {
	var t, n;
	e.x -= this.x0, e.y -= this.y0, n = e.y / (1.4142135623731 * this.a), Math.abs(n) > .999999999999 && (n = .999999999999), t = Math.asin(n);
	var r = K(this.long0 + e.x / (.900316316158 * this.a * Math.cos(t)), this.over);
	r < -Math.PI && (r = -Math.PI), r > Math.PI && (r = Math.PI), n = (2 * t + Math.sin(2 * t)) / Math.PI, Math.abs(n) > 1 && (n = 1);
	var i = Math.asin(n);
	return e.x = r, e.y = i, e;
}
var So = {
	init: yo,
	forward: bo,
	inverse: xo,
	names: ["Mollweide", "moll"]
};
//#endregion
//#region node_modules/proj4/lib/projections/eqdc.js
function Co() {
	Math.abs(this.lat1 + this.lat2) < 1e-10 || (this.lat2 = this.lat2 || this.lat1, this.temp = this.b / this.a, this.es = 1 - this.temp ** 2, this.e = Math.sqrt(this.es), this.e0 = la(this.es), this.e1 = ua(this.es), this.e2 = da(this.es), this.e3 = fa(this.es), this.sin_phi = Math.sin(this.lat1), this.cos_phi = Math.cos(this.lat1), this.ms1 = ln(this.e, this.sin_phi, this.cos_phi), this.ml1 = ca(this.e0, this.e1, this.e2, this.e3, this.lat1), Math.abs(this.lat1 - this.lat2) < 1e-10 ? this.ns = this.sin_phi : (this.sin_phi = Math.sin(this.lat2), this.cos_phi = Math.cos(this.lat2), this.ms2 = ln(this.e, this.sin_phi, this.cos_phi), this.ml2 = ca(this.e0, this.e1, this.e2, this.e3, this.lat2), this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1)), this.g = this.ml1 + this.ms1 / this.ns, this.ml0 = ca(this.e0, this.e1, this.e2, this.e3, this.lat0), this.rh = this.a * (this.g - this.ml0));
}
function wo(e) {
	var t = e.x, n = e.y, r;
	if (this.sphere) r = this.a * (this.g - n);
	else {
		var i = ca(this.e0, this.e1, this.e2, this.e3, n);
		r = this.a * (this.g - i);
	}
	var a = this.ns * K(t - this.long0, this.over), o = this.x0 + r * Math.sin(a), s = this.y0 + this.rh - r * Math.cos(a);
	return e.x = o, e.y = s, e;
}
function To(e) {
	e.x -= this.x0, e.y = this.rh - e.y + this.y0;
	var t, n, r, i;
	this.ns >= 0 ? (n = Math.sqrt(e.x * e.x + e.y * e.y), t = 1) : (n = -Math.sqrt(e.x * e.x + e.y * e.y), t = -1);
	var a = 0;
	return n !== 0 && (a = Math.atan2(t * e.x, t * e.y)), this.sphere ? (i = K(this.long0 + a / this.ns, this.over), r = ma(this.g - n / this.a), e.x = i, e.y = r, e) : (r = ha(this.g - n / this.a, this.e0, this.e1, this.e2, this.e3), i = K(this.long0 + a / this.ns, this.over), e.x = i, e.y = r, e);
}
var Eo = {
	init: Co,
	forward: wo,
	inverse: To,
	names: ["Equidistant_Conic", "eqdc"]
};
//#endregion
//#region node_modules/proj4/lib/projections/vandg.js
function Do() {
	this.R = this.a;
}
function Oo(e) {
	var t = e.x, n = e.y, r = K(t - this.long0, this.over), i, a;
	if (Math.abs(n) <= 1e-10) return i = this.x0 + this.R * r, a = this.y0, e.x = i, e.y = a, e;
	var o = Na(2 * Math.abs(n / Math.PI));
	if (Math.abs(r) <= 1e-10 || Math.abs(Math.abs(n) - G) <= 1e-10) return i = this.x0, a = n >= 0 ? this.y0 + Math.PI * this.R * Math.tan(.5 * o) : this.y0 + Math.PI * this.R * -Math.tan(.5 * o), e.x = i, e.y = a, e;
	var s = .5 * Math.abs(Math.PI / r - r / Math.PI), c = s * s, l = Math.sin(o), u = Math.cos(o), d = u / (l + u - 1), f = d * d, p = d * (2 / l - 1), m = p * p, h = Math.PI * this.R * (s * (d - m) + Math.sqrt(c * (d - m) * (d - m) - (m + c) * (f - m))) / (m + c);
	r < 0 && (h = -h), i = this.x0 + h;
	var g = c + d;
	return h = Math.PI * this.R * (p * g - s * Math.sqrt((m + c) * (c + 1) - g * g)) / (m + c), a = n >= 0 ? this.y0 + h : this.y0 - h, e.x = i, e.y = a, e;
}
function ko(e) {
	var t, n, r, i, a, o, s, c, l, u, d, f, p;
	return e.x -= this.x0, e.y -= this.y0, d = Math.PI * this.R, r = e.x / d, i = e.y / d, a = r * r + i * i, o = -Math.abs(i) * (1 + a), s = o - 2 * i * i + r * r, c = -2 * o + 1 + 2 * i * i + a * a, p = i * i / c + (2 * s * s * s / c / c / c - 9 * o * s / c / c) / 27, l = (o - s * s / 3 / c) / c, u = 2 * Math.sqrt(-l / 3), d = 3 * p / l / u, Math.abs(d) > 1 && (d = d >= 0 ? 1 : -1), f = Math.acos(d) / 3, n = e.y >= 0 ? (-u * Math.cos(f + Math.PI / 3) - s / 3 / c) * Math.PI : -(-u * Math.cos(f + Math.PI / 3) - s / 3 / c) * Math.PI, t = Math.abs(r) < 1e-10 ? this.long0 : K(this.long0 + Math.PI * (a - 1 + Math.sqrt(1 + 2 * (r * r - i * i) + a * a)) / 2 / r, this.over), e.x = t, e.y = n, e;
}
var Ao = {
	init: Do,
	forward: Oo,
	inverse: ko,
	names: [
		"Van_der_Grinten_I",
		"VanDerGrinten",
		"Van_der_Grinten",
		"vandg"
	]
};
//#endregion
//#region node_modules/proj4/lib/common/vincenty.js
function jo(e, t, n, r, i, a) {
	let o = r - t, s = Math.atan((1 - a) * Math.tan(e)), c = Math.atan((1 - a) * Math.tan(n)), l = Math.sin(s), u = Math.cos(s), d = Math.sin(c), f = Math.cos(c), p = o, m, h = 100, g, _, v, y, b, x, S, C, w, T, E, D, O, k;
	do {
		if (g = Math.sin(p), _ = Math.cos(p), v = Math.sqrt(f * g * (f * g) + (u * d - l * f * _) * (u * d - l * f * _)), v === 0) return {
			azi1: 0,
			s12: 0
		};
		y = l * d + u * f * _, b = Math.atan2(v, y), x = u * f * g / v, S = 1 - x * x, C = S === 0 ? 0 : y - 2 * l * d / S, w = a / 16 * S * (4 + a * (4 - 3 * S)), m = p, p = o + (1 - w) * a * x * (b + w * v * (C + w * y * (-1 + 2 * C * C)));
	} while (Math.abs(p - m) > 1e-12 && --h > 0);
	return h === 0 ? {
		azi1: NaN,
		s12: NaN
	} : (T = S * (i * i - i * (1 - a) * (i * (1 - a))) / (i * (1 - a) * (i * (1 - a))), E = 1 + T / 16384 * (4096 + T * (-768 + T * (320 - 175 * T))), D = T / 1024 * (256 + T * (-128 + T * (74 - 47 * T))), O = D * v * (C + D / 4 * (y * (-1 + 2 * C * C) - D / 6 * C * (-3 + 4 * v * v) * (-3 + 4 * C * C))), k = i * (1 - a) * E * (b - O), {
		azi1: Math.atan2(f * g, u * d - l * f * _),
		s12: k
	});
}
function Mo(e, t, n, r, i, a) {
	let o = Math.atan((1 - a) * Math.tan(e)), s = Math.sin(o), c = Math.cos(o), l = Math.sin(n), u = Math.cos(n), d = Math.atan2(s, c * u), f = c * l, p = 1 - f * f, m = p * (i * i - i * (1 - a) * (i * (1 - a))) / (i * (1 - a) * (i * (1 - a))), h = 1 + m / 16384 * (4096 + m * (-768 + m * (320 - 175 * m))), g = m / 1024 * (256 + m * (-128 + m * (74 - 47 * m))), _ = r / (i * (1 - a) * h), v, y = 100, b, x, S, C;
	do
		b = Math.cos(2 * d + _), x = Math.sin(_), S = Math.cos(_), C = g * x * (b + g / 4 * (S * (-1 + 2 * b * b) - g / 6 * b * (-3 + 4 * x * x) * (-3 + 4 * b * b))), v = _, _ = r / (i * (1 - a) * h) + C;
	while (Math.abs(_ - v) > 1e-12 && --y > 0);
	if (y === 0) return {
		lat2: NaN,
		lon2: NaN
	};
	let w = s * x - c * S * u, T = Math.atan2(s * S + c * x * u, (1 - a) * Math.sqrt(f * f + w * w)), E = Math.atan2(x * l, c * S - s * x * u), D = a / 16 * p * (4 + a * (4 - 3 * p));
	return {
		lat2: T,
		lon2: t + (E - (1 - D) * a * f * (_ + D * x * (b + D * S * (-1 + 2 * b * b))))
	};
}
//#endregion
//#region node_modules/proj4/lib/projections/aeqd.js
function No() {
	this.sin_p12 = Math.sin(this.lat0), this.cos_p12 = Math.cos(this.lat0), this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.long0 = this.long0 || 0, this.f = this.es / (1 + Math.sqrt(1 - this.es));
}
function Po(e) {
	var t = e.x, n = e.y, r = Math.sin(e.y), i = Math.cos(e.y), a = K(t - this.long0, this.over), o, s, c, l, u, d, f, p, m, h, g;
	return this.sphere ? Math.abs(this.sin_p12 - 1) <= 1e-10 ? (e.x = this.x0 + this.a * (G - n) * Math.sin(a), e.y = this.y0 - this.a * (G - n) * Math.cos(a), e) : Math.abs(this.sin_p12 + 1) <= 1e-10 ? (e.x = this.x0 + this.a * (G + n) * Math.sin(a), e.y = this.y0 + this.a * (G + n) * Math.cos(a), e) : (m = this.sin_p12 * r + this.cos_p12 * i * Math.cos(a), f = Math.acos(m), p = f ? f / Math.sin(f) : 1, e.x = this.x0 + this.a * p * i * Math.sin(a), e.y = this.y0 + this.a * p * (this.cos_p12 * r - this.sin_p12 * i * Math.cos(a)), e) : (o = la(this.es), s = ua(this.es), c = da(this.es), l = fa(this.es), Math.abs(this.sin_p12 - 1) <= 1e-10 ? (u = this.a * ca(o, s, c, l, G), d = this.a * ca(o, s, c, l, n), e.x = this.x0 + (u - d) * Math.sin(a), e.y = this.y0 - (u - d) * Math.cos(a), e) : Math.abs(this.sin_p12 + 1) <= 1e-10 ? (u = this.a * ca(o, s, c, l, G), d = this.a * ca(o, s, c, l, n), e.x = this.x0 + (u + d) * Math.sin(a), e.y = this.y0 + (u + d) * Math.cos(a), e) : Math.abs(t) < 1e-10 && Math.abs(n - this.lat0) < 1e-10 ? (e.x = this.x0, e.y = this.y0, e) : (h = jo(this.lat0, this.long0, n, t, this.a, this.f), g = h.azi1, e.x = this.x0 + h.s12 * Math.sin(g), e.y = this.y0 + h.s12 * Math.cos(g), e));
}
function Fo(e) {
	e.x -= this.x0, e.y -= this.y0;
	var t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g;
	return this.sphere ? (t = Math.sqrt(e.x * e.x + e.y * e.y), t > 2 * G * this.a ? void 0 : (n = t / this.a, r = Math.sin(n), i = Math.cos(n), a = this.long0, Math.abs(t) <= 1e-10 ? o = this.lat0 : (o = Na(i * this.sin_p12 + e.y * r * this.cos_p12 / t), s = Math.abs(this.lat0) - G, a = Math.abs(s) <= 1e-10 ? this.lat0 >= 0 ? K(this.long0 + Math.atan2(e.x, -e.y), this.over) : K(this.long0 - Math.atan2(-e.x, e.y), this.over) : K(this.long0 + Math.atan2(e.x * r, t * this.cos_p12 * i - e.y * this.sin_p12 * r), this.over)), e.x = a, e.y = o, e)) : (c = la(this.es), l = ua(this.es), u = da(this.es), d = fa(this.es), Math.abs(this.sin_p12 - 1) <= 1e-10 ? (f = this.a * ca(c, l, u, d, G), t = Math.sqrt(e.x * e.x + e.y * e.y), p = f - t, o = ha(p / this.a, c, l, u, d), a = K(this.long0 + Math.atan2(e.x, -1 * e.y), this.over), e.x = a, e.y = o, e) : Math.abs(this.sin_p12 + 1) <= 1e-10 ? (f = this.a * ca(c, l, u, d, G), t = Math.sqrt(e.x * e.x + e.y * e.y), p = t - f, o = ha(p / this.a, c, l, u, d), a = K(this.long0 + Math.atan2(e.x, e.y), this.over), e.x = a, e.y = o, e) : (m = Math.atan2(e.x, e.y), h = Math.sqrt(e.x * e.x + e.y * e.y), g = Mo(this.lat0, this.long0, m, h, this.a, this.f), e.x = g.lon2, e.y = g.lat2, e));
}
var Io = {
	init: No,
	forward: Po,
	inverse: Fo,
	names: ["Azimuthal_Equidistant", "aeqd"]
};
//#endregion
//#region node_modules/proj4/lib/projections/ortho.js
function Lo() {
	this.sin_p14 = Math.sin(this.lat0 || 0), this.cos_p14 = Math.cos(this.lat0 || 0);
}
function Ro(e) {
	var t, n, r, i, a, o, s, c, l = e.x, u = e.y;
	return r = K(l - (this.long0 || 0), this.over), t = Math.sin(u), n = Math.cos(u), i = Math.cos(r), o = this.sin_p14 * t + this.cos_p14 * n * i, a = 1, (o > 0 || Math.abs(o) <= 1e-10) && (s = this.a * a * n * Math.sin(r), c = (this.y0 || 0) + this.a * a * (this.cos_p14 * t - this.sin_p14 * n * i)), e.x = s, e.y = c, e;
}
function zo(e) {
	var t, n, r, i, a, o, s, c, l;
	return e.x -= this.x0 || 0, e.y -= this.y0 || 0, t = Math.sqrt(e.x * e.x + e.y * e.y), n = Na(t / this.a), r = Math.sin(n), i = Math.cos(n), c = this.long0 || 0, l = this.lat0 || 0, o = c, Math.abs(t) <= 1e-10 ? (s = l, e.x = o, e.y = s, e) : (s = Na(i * this.sin_p14 + e.y * r * this.cos_p14 / t), a = Math.abs(l) - G, Math.abs(a) <= 1e-10 ? (o = K(l >= 0 ? c + Math.atan2(e.x, -e.y) : c - Math.atan2(-e.x, e.y), this.over), e.x = o, e.y = s, e) : (o = K(c + Math.atan2(e.x * r, t * this.cos_p14 * i - e.y * this.sin_p14 * r), this.over), e.x = o, e.y = s, e));
}
var Bo = {
	init: Lo,
	forward: Ro,
	inverse: zo,
	names: ["ortho"]
}, Vo = {
	FRONT: 1,
	RIGHT: 2,
	BACK: 3,
	LEFT: 4,
	TOP: 5,
	BOTTOM: 6
}, Ho = {
	AREA_0: 1,
	AREA_1: 2,
	AREA_2: 3,
	AREA_3: 4
};
function Uo() {
	this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Quadrilateralized Spherical Cube", this.lat0 >= G - pt / 2 ? this.face = Vo.TOP : this.lat0 <= -(G - pt / 2) ? this.face = Vo.BOTTOM : Math.abs(this.long0) <= pt ? this.face = Vo.FRONT : Math.abs(this.long0) <= G + pt ? this.face = this.long0 > 0 ? Vo.RIGHT : Vo.LEFT : this.face = Vo.BACK, this.es !== 0 && (this.one_minus_f = 1 - (this.a - this.b) / this.a, this.one_minus_f_squared = this.one_minus_f * this.one_minus_f);
}
function Wo(e) {
	var t = {
		x: 0,
		y: 0
	}, n, r, i, a, o, s, c = { value: 0 };
	if (e.x -= this.long0, n = this.es === 0 ? e.y : Math.atan(this.one_minus_f_squared * Math.tan(e.y)), r = e.x, this.face === Vo.TOP) a = G - n, r >= pt && r <= G + pt ? (c.value = Ho.AREA_0, i = r - G) : r > G + pt || r <= -(G + pt) ? (c.value = Ho.AREA_1, i = r > 0 ? r - ht : r + ht) : r > -(G + pt) && r <= -pt ? (c.value = Ho.AREA_2, i = r + G) : (c.value = Ho.AREA_3, i = r);
	else if (this.face === Vo.BOTTOM) a = G + n, r >= pt && r <= G + pt ? (c.value = Ho.AREA_0, i = -r + G) : r < pt && r >= -pt ? (c.value = Ho.AREA_1, i = -r) : r < -pt && r >= -(G + pt) ? (c.value = Ho.AREA_2, i = -r - G) : (c.value = Ho.AREA_3, i = r > 0 ? -r + ht : -r - ht);
	else {
		var l, u, d, f, p, m, h;
		this.face === Vo.RIGHT ? r = qo(r, +G) : this.face === Vo.BACK ? r = qo(r, +ht) : this.face === Vo.LEFT && (r = qo(r, -G)), f = Math.sin(n), p = Math.cos(n), m = Math.sin(r), h = Math.cos(r), l = p * h, u = p * m, d = f, this.face === Vo.FRONT ? (a = Math.acos(l), i = Ko(a, d, u, c)) : this.face === Vo.RIGHT ? (a = Math.acos(u), i = Ko(a, d, -l, c)) : this.face === Vo.BACK ? (a = Math.acos(-l), i = Ko(a, d, -u, c)) : this.face === Vo.LEFT ? (a = Math.acos(-u), i = Ko(a, d, l, c)) : (a = i = 0, c.value = Ho.AREA_0);
	}
	return s = Math.atan(12 / ht * (i + Math.acos(Math.sin(i) * Math.cos(pt)) - G)), o = Math.sqrt((1 - Math.cos(a)) / (Math.cos(s) * Math.cos(s)) / (1 - Math.cos(Math.atan(1 / Math.cos(i))))), c.value === Ho.AREA_1 ? s += G : c.value === Ho.AREA_2 ? s += ht : c.value === Ho.AREA_3 && (s += 1.5 * ht), t.x = o * Math.cos(s), t.y = o * Math.sin(s), t.x = t.x * this.a + this.x0, t.y = t.y * this.a + this.y0, e.x = t.x, e.y = t.y, e;
}
function Go(e) {
	var t = {
		lam: 0,
		phi: 0
	}, n, r, i, a, o, s, c, l, u, d = { value: 0 };
	if (e.x = (e.x - this.x0) / this.a, e.y = (e.y - this.y0) / this.a, r = Math.atan(Math.sqrt(e.x * e.x + e.y * e.y)), n = Math.atan2(e.y, e.x), e.x >= 0 && e.x >= Math.abs(e.y) ? d.value = Ho.AREA_0 : e.y >= 0 && e.y >= Math.abs(e.x) ? (d.value = Ho.AREA_1, n -= G) : e.x < 0 && -e.x >= Math.abs(e.y) ? (d.value = Ho.AREA_2, n = n < 0 ? n + ht : n - ht) : (d.value = Ho.AREA_3, n += G), u = ht / 12 * Math.tan(n), o = Math.sin(u) / (Math.cos(u) - 1 / Math.sqrt(2)), s = Math.atan(o), i = Math.cos(n), a = Math.tan(r), c = 1 - i * i * a * a * (1 - Math.cos(Math.atan(1 / Math.cos(s)))), c < -1 ? c = -1 : c > 1 && (c = 1), this.face === Vo.TOP) l = Math.acos(c), t.phi = G - l, d.value === Ho.AREA_0 ? t.lam = s + G : d.value === Ho.AREA_1 ? t.lam = s < 0 ? s + ht : s - ht : d.value === Ho.AREA_2 ? t.lam = s - G : t.lam = s;
	else if (this.face === Vo.BOTTOM) l = Math.acos(c), t.phi = l - G, d.value === Ho.AREA_0 ? t.lam = -s + G : d.value === Ho.AREA_1 ? t.lam = -s : d.value === Ho.AREA_2 ? t.lam = -s - G : t.lam = s < 0 ? -s - ht : -s + ht;
	else {
		var f = c, p, m;
		u = f * f, m = u >= 1 ? 0 : Math.sqrt(1 - u) * Math.sin(s), u += m * m, p = u >= 1 ? 0 : Math.sqrt(1 - u), d.value === Ho.AREA_1 ? (u = p, p = -m, m = u) : d.value === Ho.AREA_2 ? (p = -p, m = -m) : d.value === Ho.AREA_3 && (u = p, p = m, m = -u), this.face === Vo.RIGHT ? (u = f, f = -p, p = u) : this.face === Vo.BACK ? (f = -f, p = -p) : this.face === Vo.LEFT && (u = f, f = p, p = -u), t.phi = Math.acos(-m) - G, t.lam = Math.atan2(p, f), this.face === Vo.RIGHT ? t.lam = qo(t.lam, -G) : this.face === Vo.BACK ? t.lam = qo(t.lam, -ht) : this.face === Vo.LEFT && (t.lam = qo(t.lam, +G));
	}
	if (this.es !== 0) {
		var h = +(t.phi < 0), g = Math.tan(t.phi), _ = this.b / Math.sqrt(g * g + this.one_minus_f_squared);
		t.phi = Math.atan(Math.sqrt(this.a * this.a - _ * _) / (this.one_minus_f * _)), h && (t.phi = -t.phi);
	}
	return t.lam += this.long0, e.x = t.lam, e.y = t.phi, e;
}
function Ko(e, t, n, r) {
	var i;
	return e < 1e-10 ? (r.value = Ho.AREA_0, i = 0) : (i = Math.atan2(t, n), Math.abs(i) <= pt ? r.value = Ho.AREA_0 : i > pt && i <= G + pt ? (r.value = Ho.AREA_1, i -= G) : i > G + pt || i <= -(G + pt) ? (r.value = Ho.AREA_2, i = i >= 0 ? i - ht : i + ht) : (r.value = Ho.AREA_3, i += G)), i;
}
function qo(e, t) {
	var n = e + t;
	return n < -3.14159265359 ? n += mt : n > 3.14159265359 && (n -= mt), n;
}
var Jo = {
	init: Uo,
	forward: Wo,
	inverse: Go,
	names: [
		"Quadrilateralized Spherical Cube",
		"Quadrilateralized_Spherical_Cube",
		"qsc"
	]
}, Yo = [
	[
		1,
		22199e-21,
		-715515e-10,
		31103e-10
	],
	[
		.9986,
		-482243e-9,
		-24897e-9,
		-13309e-10
	],
	[
		.9954,
		-83103e-8,
		-448605e-10,
		-9.86701e-7
	],
	[
		.99,
		-.00135364,
		-59661e-9,
		36777e-10
	],
	[
		.9822,
		-.00167442,
		-449547e-11,
		-572411e-11
	],
	[
		.973,
		-.00214868,
		-903571e-10,
		1.8736e-8
	],
	[
		.96,
		-.00305085,
		-900761e-10,
		164917e-11
	],
	[
		.9427,
		-.00382792,
		-653386e-10,
		-26154e-10
	],
	[
		.9216,
		-.00467746,
		-10457e-8,
		481243e-11
	],
	[
		.8962,
		-.00536223,
		-323831e-10,
		-543432e-11
	],
	[
		.8679,
		-.00609363,
		-113898e-9,
		332484e-11
	],
	[
		.835,
		-.00698325,
		-640253e-10,
		9.34959e-7
	],
	[
		.7986,
		-.00755338,
		-500009e-10,
		9.35324e-7
	],
	[
		.7597,
		-.00798324,
		-35971e-9,
		-227626e-11
	],
	[
		.7186,
		-.00851367,
		-701149e-10,
		-86303e-10
	],
	[
		.6732,
		-.00986209,
		-199569e-9,
		191974e-10
	],
	[
		.6213,
		-.010418,
		883923e-10,
		624051e-11
	],
	[
		.5722,
		-.00906601,
		182e-6,
		624051e-11
	],
	[
		.5322,
		-.00677797,
		275608e-9,
		624051e-11
	]
], Xo = [
	[
		-520417e-23,
		.0124,
		121431e-23,
		-845284e-16
	],
	[
		.062,
		.0124,
		-1.26793e-9,
		422642e-15
	],
	[
		.124,
		.0124,
		5.07171e-9,
		-1.60604e-9
	],
	[
		.186,
		.0123999,
		-1.90189e-8,
		6.00152e-9
	],
	[
		.248,
		.0124002,
		7.10039e-8,
		-2.24e-8
	],
	[
		.31,
		.0123992,
		-2.64997e-7,
		8.35986e-8
	],
	[
		.372,
		.0124029,
		9.88983e-7,
		-3.11994e-7
	],
	[
		.434,
		.0123893,
		-369093e-11,
		-4.35621e-7
	],
	[
		.4958,
		.0123198,
		-102252e-10,
		-3.45523e-7
	],
	[
		.5571,
		.0121916,
		-154081e-10,
		-5.82288e-7
	],
	[
		.6176,
		.0119938,
		-241424e-10,
		-5.25327e-7
	],
	[
		.6769,
		.011713,
		-320223e-10,
		-5.16405e-7
	],
	[
		.7346,
		.0113541,
		-397684e-10,
		-6.09052e-7
	],
	[
		.7903,
		.0109107,
		-489042e-10,
		-104739e-11
	],
	[
		.8435,
		.0103431,
		-64615e-9,
		-1.40374e-9
	],
	[
		.8936,
		.00969686,
		-64636e-9,
		-8547e-9
	],
	[
		.9394,
		.00840947,
		-192841e-9,
		-42106e-10
	],
	[
		.9761,
		.00616527,
		-256e-6,
		-42106e-10
	],
	[
		1,
		.00328947,
		-319159e-9,
		-42106e-10
	]
], Zo = .8487, Qo = 1.3523, $o = ft / 5, es = 1 / $o, ts = 18, ns = function(e, t) {
	return e[0] + t * (e[1] + t * (e[2] + t * e[3]));
}, rs = function(e, t) {
	return e[1] + t * (2 * e[2] + t * 3 * e[3]);
};
function is(e, t, n, r) {
	for (var i = t; r; --r) {
		var a = e(i);
		if (i -= a, Math.abs(a) < n) break;
	}
	return i;
}
function as() {
	this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.long0 = this.long0 || 0, this.es = 0, this.title = this.title || "Robinson";
}
function os(e) {
	var t = K(e.x - this.long0, this.over), n = Math.abs(e.y), r = Math.floor(n * $o);
	r < 0 ? r = 0 : r >= ts && (r = ts - 1), n = ft * (n - es * r);
	var i = {
		x: ns(Yo[r], n) * t,
		y: ns(Xo[r], n)
	};
	return e.y < 0 && (i.y = -i.y), i.x = i.x * this.a * Zo + this.x0, i.y = i.y * this.a * Qo + this.y0, i;
}
function ss(e) {
	var t = {
		x: (e.x - this.x0) / (this.a * Zo),
		y: Math.abs(e.y - this.y0) / (this.a * Qo)
	};
	if (t.y >= 1) t.x /= Yo[ts][0], t.y = e.y < 0 ? -G : G;
	else {
		var n = Math.floor(t.y * ts);
		for (n < 0 ? n = 0 : n >= ts && (n = ts - 1);;) if (Xo[n][0] > t.y) --n;
		else if (Xo[n + 1][0] <= t.y) ++n;
		else break;
		var r = Xo[n], i = 5 * (t.y - r[0]) / (Xo[n + 1][0] - r[0]);
		i = is(function(e) {
			return (ns(r, e) - t.y) / rs(r, e);
		}, i, ut, 100), t.x /= ns(Yo[n], i), t.y = (5 * n + i) * dt, e.y < 0 && (t.y = -t.y);
	}
	return t.x = K(t.x + this.long0, this.over), t;
}
var cs = {
	init: as,
	forward: os,
	inverse: ss,
	names: ["Robinson", "robin"]
};
//#endregion
//#region node_modules/proj4/lib/projections/geocent.js
function ls() {
	this.name = "geocent";
}
function us(e) {
	return $n(e, this.es, this.a);
}
function ds(e) {
	return er(e, this.es, this.a, this.b);
}
var fs = {
	init: ls,
	forward: us,
	inverse: ds,
	names: [
		"Geocentric",
		"geocentric",
		"geocent",
		"Geocent"
	]
}, ps = {
	N_POLE: 0,
	S_POLE: 1,
	EQUIT: 2,
	OBLIQ: 3
}, ms = {
	h: {
		def: 1e5,
		num: !0
	},
	azi: {
		def: 0,
		num: !0,
		degrees: !0
	},
	tilt: {
		def: 0,
		num: !0,
		degrees: !0
	},
	long0: {
		def: 0,
		num: !0
	},
	lat0: {
		def: 0,
		num: !0
	}
};
function hs() {
	if (Object.keys(ms).forEach(function(e) {
		if (this[e] === void 0) this[e] = ms[e].def;
		else if (ms[e].num && isNaN(this[e])) throw Error("Invalid parameter value, must be numeric " + e + " = " + this[e]);
		else ms[e].num && (this[e] = parseFloat(this[e]));
		ms[e].degrees && (this[e] = this[e] * dt);
	}.bind(this)), Math.abs(Math.abs(this.lat0) - G) < 1e-10 ? this.mode = this.lat0 < 0 ? ps.S_POLE : ps.N_POLE : Math.abs(this.lat0) < 1e-10 ? this.mode = ps.EQUIT : (this.mode = ps.OBLIQ, this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0)), this.pn1 = this.h / this.a, this.pn1 <= 0 || this.pn1 > 1e10) throw Error("Invalid height");
	this.p = 1 + this.pn1, this.rp = 1 / this.p, this.h1 = 1 / this.pn1, this.pfact = (this.p + 1) * this.h1, this.es = 0;
	var e = this.tilt, t = this.azi;
	this.cg = Math.cos(t), this.sg = Math.sin(t), this.cw = Math.cos(e), this.sw = Math.sin(e);
}
function gs(e) {
	e.x -= this.long0;
	var t = Math.sin(e.y), n = Math.cos(e.y), r = Math.cos(e.x), i, a;
	switch (this.mode) {
		case ps.OBLIQ:
			a = this.sinph0 * t + this.cosph0 * n * r;
			break;
		case ps.EQUIT:
			a = n * r;
			break;
		case ps.S_POLE:
			a = -t;
			break;
		case ps.N_POLE:
			a = t;
			break;
	}
	switch (a = this.pn1 / (this.p - a), i = a * n * Math.sin(e.x), this.mode) {
		case ps.OBLIQ:
			a *= this.cosph0 * t - this.sinph0 * n * r;
			break;
		case ps.EQUIT:
			a *= t;
			break;
		case ps.N_POLE:
			a *= -(n * r);
			break;
		case ps.S_POLE:
			a *= n * r;
			break;
	}
	var o = a * this.cg + i * this.sg, s = 1 / (o * this.sw * this.h1 + this.cw);
	return i = (i * this.cg - a * this.sg) * this.cw * s, a = o * s, e.x = i * this.a, e.y = a * this.a, e;
}
function _s(e) {
	e.x /= this.a, e.y /= this.a;
	var t = {
		x: e.x,
		y: e.y
	}, n, r, i = 1 / (this.pn1 - e.y * this.sw);
	n = this.pn1 * e.x * i, r = this.pn1 * e.y * this.cw * i, e.x = n * this.cg + r * this.sg, e.y = r * this.cg - n * this.sg;
	var a = mi(e.x, e.y);
	if (Math.abs(a) < 1e-10) t.x = 0, t.y = e.y;
	else {
		var o, s = 1 - a * a * this.pfact;
		switch (s = (this.p - Math.sqrt(s)) / (this.pn1 / a + a / this.pn1), o = Math.sqrt(1 - s * s), this.mode) {
			case ps.OBLIQ:
				t.y = Math.asin(o * this.sinph0 + e.y * s * this.cosph0 / a), e.y = (o - this.sinph0 * Math.sin(t.y)) * a, e.x *= s * this.cosph0;
				break;
			case ps.EQUIT:
				t.y = Math.asin(e.y * s / a), e.y = o * a, e.x *= s;
				break;
			case ps.N_POLE:
				t.y = Math.asin(o), e.y = -e.y;
				break;
			case ps.S_POLE:
				t.y = -Math.asin(o);
				break;
		}
		t.x = Math.atan2(e.x, e.y);
	}
	return e.x = t.x + this.long0, e.y = t.y, e;
}
var vs = {
	init: hs,
	forward: gs,
	inverse: _s,
	names: ["Tilted_Perspective", "tpers"]
};
//#endregion
//#region node_modules/proj4/lib/projections/geos.js
function ys() {
	if (this.flip_axis = +(this.sweep === "x"), this.h = Number(this.h), this.radius_g_1 = this.h / this.a, this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) throw Error();
	if (this.radius_g = 1 + this.radius_g_1, this.C = this.radius_g * this.radius_g - 1, this.es !== 0) {
		var e = 1 - this.es, t = 1 / e;
		this.radius_p = Math.sqrt(e), this.radius_p2 = e, this.radius_p_inv2 = t, this.shape = "ellipse";
	} else this.radius_p = 1, this.radius_p2 = 1, this.radius_p_inv2 = 1, this.shape = "sphere";
	this.title ||= "Geostationary Satellite View";
}
function bs(e) {
	var t = e.x, n = e.y, r, i, a, o;
	if (t -= this.long0, this.shape === "ellipse") {
		n = Math.atan(this.radius_p2 * Math.tan(n));
		var s = this.radius_p / mi(this.radius_p * Math.cos(n), Math.sin(n));
		if (i = s * Math.cos(t) * Math.cos(n), a = s * Math.sin(t) * Math.cos(n), o = s * Math.sin(n), (this.radius_g - i) * i - a * a - o * o * this.radius_p_inv2 < 0) return e.x = NaN, e.y = NaN, e;
		r = this.radius_g - i, this.flip_axis ? (e.x = this.radius_g_1 * Math.atan(a / mi(o, r)), e.y = this.radius_g_1 * Math.atan(o / r)) : (e.x = this.radius_g_1 * Math.atan(a / r), e.y = this.radius_g_1 * Math.atan(o / mi(a, r)));
	} else this.shape === "sphere" && (r = Math.cos(n), i = Math.cos(t) * r, a = Math.sin(t) * r, o = Math.sin(n), r = this.radius_g - i, this.flip_axis ? (e.x = this.radius_g_1 * Math.atan(a / mi(o, r)), e.y = this.radius_g_1 * Math.atan(o / r)) : (e.x = this.radius_g_1 * Math.atan(a / r), e.y = this.radius_g_1 * Math.atan(o / mi(a, r))));
	return e.x *= this.a, e.y *= this.a, e;
}
function xs(e) {
	var t = -1, n = 0, r = 0, i, a, o, s;
	if (e.x /= this.a, e.y /= this.a, this.shape === "ellipse") {
		this.flip_axis ? (r = Math.tan(e.y / this.radius_g_1), n = Math.tan(e.x / this.radius_g_1) * mi(1, r)) : (n = Math.tan(e.x / this.radius_g_1), r = Math.tan(e.y / this.radius_g_1) * mi(1, n));
		var c = r / this.radius_p;
		if (i = n * n + c * c + t * t, a = 2 * this.radius_g * t, o = a * a - 4 * i * this.C, o < 0) return e.x = NaN, e.y = NaN, e;
		s = (-a - Math.sqrt(o)) / (2 * i), t = this.radius_g + s * t, n *= s, r *= s, e.x = Math.atan2(n, t), e.y = Math.atan(r * Math.cos(e.x) / t), e.y = Math.atan(this.radius_p_inv2 * Math.tan(e.y));
	} else if (this.shape === "sphere") {
		if (this.flip_axis ? (r = Math.tan(e.y / this.radius_g_1), n = Math.tan(e.x / this.radius_g_1) * Math.sqrt(1 + r * r)) : (n = Math.tan(e.x / this.radius_g_1), r = Math.tan(e.y / this.radius_g_1) * Math.sqrt(1 + n * n)), i = n * n + r * r + t * t, a = 2 * this.radius_g * t, o = a * a - 4 * i * this.C, o < 0) return e.x = NaN, e.y = NaN, e;
		s = (-a - Math.sqrt(o)) / (2 * i), t = this.radius_g + s * t, n *= s, r *= s, e.x = Math.atan2(n, t), e.y = Math.atan(r * Math.cos(e.x) / t);
	}
	return e.x += this.long0, e;
}
var Ss = {
	init: ys,
	forward: bs,
	inverse: xs,
	names: [
		"Geostationary Satellite View",
		"Geostationary_Satellite",
		"geos"
	]
}, Cs = 1.340264, ws = -.081106, Ts = 893e-6, Es = .003796, Ds = Math.sqrt(3) / 2;
function Os() {
	this.long0 = this.long0 === void 0 ? 0 : this.long0, this.x0 = this.x0 === void 0 ? 0 : this.x0, this.y0 = this.y0 === void 0 ? 0 : this.y0, this.es !== 0 && (this.apa = Da(this.es), this.qp = ba(this.e, 1), this.rqda = Math.sqrt(.5 * this.qp));
}
function ks(e) {
	var t = K(e.x - this.long0, this.over), n = e.y, r = Math.sin(n);
	this.es !== 0 && (r = ba(this.e, r) / this.qp);
	var i = Math.asin(Ds * r), a = i * i, o = a * a * a;
	return e.x = t * Math.cos(i) / (Ds * (Cs + 3 * ws * a + o * (7 * Ts + 9 * Es * a))), e.y = i * (Cs + ws * a + o * (Ts + Es * a)), this.es !== 0 && (e.x *= this.rqda, e.y *= this.rqda), e.x = this.a * e.x + this.x0, e.y = this.a * e.y + this.y0, e;
}
function As(e) {
	e.x = (e.x - this.x0) / this.a, e.y = (e.y - this.y0) / this.a, this.es !== 0 && (e.x /= this.rqda, e.y /= this.rqda);
	var t = 1e-9, n = 12, r = e.y, i, a, o, s, c, l;
	for (l = 0; l < n && (i = r * r, a = i * i * i, o = r * (Cs + ws * i + a * (Ts + Es * i)) - e.y, s = Cs + 3 * ws * i + a * (7 * Ts + 9 * Es * i), r -= c = o / s, !(Math.abs(c) < t)); ++l);
	return i = r * r, a = i * i * i, e.x = Ds * e.x * (Cs + 3 * ws * i + a * (7 * Ts + 9 * Es * i)) / Math.cos(r), e.y = Math.asin(Math.sin(r) / Ds), this.es !== 0 && (e.y = Oa(e.y, this.apa)), e.x = K(e.x + this.long0, this.over), e;
}
var js = {
	init: Os,
	forward: ks,
	inverse: As,
	names: [
		"eqearth",
		"Equal Earth",
		"Equal_Earth"
	]
}, Ms = 1e-10;
function Ns() {
	var e;
	if (this.phi1 = this.lat1, Math.abs(this.phi1) < Ms) throw Error();
	this.es ? (this.en = ai(this.es), this.m1 = oi(this.phi1, this.am1 = Math.sin(this.phi1), e = Math.cos(this.phi1), this.en), this.am1 = e / (Math.sqrt(1 - this.es * this.am1 * this.am1) * this.am1), this.inverse = Fs, this.forward = Ps) : (Math.abs(this.phi1) + Ms >= G ? this.cphi1 = 0 : this.cphi1 = 1 / Math.tan(this.phi1), this.inverse = Ls, this.forward = Is);
}
function Ps(e) {
	var t = K(e.x - (this.long0 || 0), this.over), n = e.y, r = this.am1 + this.m1 - oi(n, i = Math.sin(n), a = Math.cos(n), this.en), i = a * t / (r * Math.sqrt(1 - this.es * i * i)), a;
	return e.x = r * Math.sin(i), e.y = this.am1 - r * Math.cos(i), e.x = this.a * e.x + (this.x0 || 0), e.y = this.a * e.y + (this.y0 || 0), e;
}
function Fs(e) {
	e.x = (e.x - (this.x0 || 0)) / this.a, e.y = (e.y - (this.y0 || 0)) / this.a;
	var t, n = mi(e.x, e.y = this.am1 - e.y), r, i = ci(this.am1 + this.m1 - n, this.es, this.en);
	if ((t = Math.abs(i)) < G) t = Math.sin(i), r = n * Math.atan2(e.x, e.y) * Math.sqrt(1 - this.es * t * t) / Math.cos(i);
	else if (Math.abs(t - G) <= Ms) r = 0;
	else throw Error();
	return e.x = K(r + (this.long0 || 0), this.over), e.y = ma(i), e;
}
function Is(e) {
	var t = K(e.x - (this.long0 || 0), this.over), n = e.y, r, i = this.cphi1 + this.phi1 - n;
	return Math.abs(i) > Ms ? (e.x = i * Math.sin(r = t * Math.cos(n) / i), e.y = this.cphi1 - i * Math.cos(r)) : e.x = e.y = 0, e.x = this.a * e.x + (this.x0 || 0), e.y = this.a * e.y + (this.y0 || 0), e;
}
function Ls(e) {
	e.x = (e.x - (this.x0 || 0)) / this.a, e.y = (e.y - (this.y0 || 0)) / this.a;
	var t, n, r = mi(e.x, e.y = this.cphi1 - e.y);
	if (n = this.cphi1 + this.phi1 - r, Math.abs(n) > G) throw Error();
	return t = Math.abs(Math.abs(n) - G) <= Ms ? 0 : r * Math.atan2(e.x, e.y) / Math.cos(n), e.x = K(t + (this.long0 || 0), this.over), e.y = ma(n), e;
}
var Rs = {
	init: Ns,
	names: ["bonne", "Bonne (Werner lat_1=90)"]
}, zs = {
	OBLIQUE: {
		forward: Gs,
		inverse: qs
	},
	TRANSVERSE: {
		forward: Ks,
		inverse: Js
	}
}, Bs = {
	ROTATE: {
		o_alpha: "oAlpha",
		o_lon_c: "oLongC",
		o_lat_c: "oLatC"
	},
	NEW_POLE: {
		o_lat_p: "oLatP",
		o_lon_p: "oLongP"
	},
	NEW_EQUATOR: {
		o_lon_1: "oLong1",
		o_lat_1: "oLat1",
		o_lon_2: "oLong2",
		o_lat_2: "oLat2"
	}
};
function Vs() {
	if (this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.long0 = this.long0 || 0, this.title = this.title || "General Oblique Transformation", this.isIdentity = yn.includes(this.o_proj), !this.o_proj) throw Error("Missing parameter: o_proj");
	if (this.o_proj === "ob_tran") throw Error("Invalid value for o_proj: " + this.o_proj);
	let e = Zn(this.projStr.replace("+proj=ob_tran", "").replace("+o_proj=", "+proj=").trim());
	if (!e) throw Error("Invalid parameter: o_proj. Unknown projection " + this.o_proj);
	e.long0 = 0, this.obliqueProjection = e;
	let t, n = Object.keys(Bs), r = (e) => {
		if (this[e] === void 0) return;
		let t = parseFloat(this[e]) * dt;
		if (isNaN(t)) throw Error("Invalid value for " + e + ": " + this[e]);
		return t;
	};
	for (let e = 0; e < n.length; e++) {
		let i = Bs[n[e]], a = Object.entries(i);
		if (a.some(([e]) => this[e] !== void 0)) {
			t = i;
			for (let e = 0; e < a.length; e++) {
				let [t, n] = a[e], i = r(t);
				if (i === void 0) throw Error("Missing parameter: " + t + ".");
				this[n] = i;
			}
			break;
		}
	}
	if (!t) throw Error("No valid parameters provided for ob_tran projection.");
	let { lamp: i, phip: a } = Ws(this, t);
	this.lamp = i, Math.abs(a) > 1e-10 ? (this.cphip = Math.cos(a), this.sphip = Math.sin(a), this.projectionType = zs.OBLIQUE) : this.projectionType = zs.TRANSVERSE;
}
function Hs(e) {
	return this.projectionType.forward(this, e);
}
function Us(e) {
	return this.projectionType.inverse(this, e);
}
function Ws(e, t) {
	let n, r;
	if (t === Bs.ROTATE) {
		let t = e.oLongC, i = e.oLatC, a = e.oAlpha;
		if (Math.abs(Math.abs(i) - G) <= 1e-10) throw Error("Invalid value for o_lat_c: " + e.o_lat_c + " should be < 90°");
		r = t + Math.atan2(-1 * Math.cos(a), -1 * Math.sin(a) * Math.sin(i)), n = Math.asin(Math.cos(i) * Math.sin(a));
	} else if (t === Bs.NEW_POLE) r = e.oLongP, n = e.oLatP;
	else {
		let t = e.oLong1, i = e.oLat1, a = e.oLong2, o = e.oLat2, s = Math.abs(i);
		if (Math.abs(i) > G - 1e-10) throw Error("Invalid value for o_lat_1: " + e.o_lat_1 + " should be < 90°");
		if (Math.abs(o) > G - 1e-10) throw Error("Invalid value for o_lat_2: " + e.o_lat_2 + " should be < 90°");
		if (Math.abs(i - o) < 1e-10) throw Error("Invalid value for o_lat_1 and o_lat_2: o_lat_1 should be different from o_lat_2");
		if (s < 1e-10) throw Error("Invalid value for o_lat_1: o_lat_1 should be different from zero");
		r = Math.atan2(Math.cos(i) * Math.sin(o) * Math.cos(t) - Math.sin(i) * Math.cos(o) * Math.cos(a), Math.sin(i) * Math.cos(o) * Math.sin(a) - Math.cos(i) * Math.sin(o) * Math.sin(t)), n = Math.atan(-1 * Math.cos(r - t) / Math.tan(i));
	}
	return {
		lamp: r,
		phip: n
	};
}
function Gs(e, t) {
	let { x: n, y: r } = t;
	n = K(n - e.long0, e.over);
	let i = Math.cos(n), a = Math.sin(r), o = Math.cos(r);
	t.x = K(Math.atan2(o * Math.sin(n), e.sphip * o * i + e.cphip * a) + e.lamp), t.y = Math.asin(e.sphip * a - e.cphip * o * i);
	let s = e.obliqueProjection.forward(t);
	return e.isIdentity && (s.x *= ft, s.y *= ft), s;
}
function Ks(e, t) {
	let { x: n, y: r } = t;
	n = K(n - e.long0, e.over);
	let i = Math.cos(r), a = Math.cos(n);
	t.x = K(Math.atan2(i * Math.sin(n), Math.sin(r)) + e.lamp), t.y = Math.asin(-1 * i * a);
	let o = e.obliqueProjection.forward(t);
	return e.isIdentity && (o.x *= ft, o.y *= ft), o;
}
function qs(e, t) {
	e.isIdentity && (t.x *= dt, t.y *= dt);
	let { x: n, y: r } = e.obliqueProjection.inverse(t);
	if (n < Number.MAX_VALUE) {
		n -= e.lamp;
		let i = Math.cos(n), a = Math.sin(r), o = Math.cos(r);
		t.x = Math.atan2(o * Math.sin(n), e.sphip * o * i - e.cphip * a), t.y = Math.asin(e.sphip * a + e.cphip * o * i);
	}
	return t.x = K(t.x + e.long0), t;
}
function Js(e, t) {
	e.isIdentity && (t.x *= dt, t.y *= dt);
	let { x: n, y: r } = e.obliqueProjection.inverse(t);
	if (n < Number.MAX_VALUE) {
		let i = Math.cos(r);
		n -= e.lamp, t.x = Math.atan2(i * Math.sin(n), -1 * Math.sin(r)), t.y = Math.asin(i * Math.cos(n));
	}
	return t.x = K(t.x + e.long0), t;
}
var Ys = {
	init: Vs,
	forward: Hs,
	inverse: Us,
	names: [
		"General Oblique Transformation",
		"General_Oblique_Transformation",
		"ob_tran"
	]
};
//#endregion
//#region node_modules/proj4/projs.js
function Xs(e) {
	e.Proj.projections.add(fi), e.Proj.projections.add(wi), e.Proj.projections.add(Oi), e.Proj.projections.add(Ri), e.Proj.projections.add(Ui), e.Proj.projections.add(qi), e.Proj.projections.add($i), e.Proj.projections.add(ra), e.Proj.projections.add(sa), e.Proj.projections.add(ya), e.Proj.projections.add(Ma), e.Proj.projections.add(Ra), e.Proj.projections.add(Ha), e.Proj.projections.add(qa), e.Proj.projections.add(Za), e.Proj.projections.add(no), e.Proj.projections.add(oo), e.Proj.projections.add(uo), e.Proj.projections.add(go), e.Proj.projections.add(vo), e.Proj.projections.add(So), e.Proj.projections.add(Eo), e.Proj.projections.add(Ao), e.Proj.projections.add(Io), e.Proj.projections.add(Bo), e.Proj.projections.add(Jo), e.Proj.projections.add(cs), e.Proj.projections.add(fs), e.Proj.projections.add(vs), e.Proj.projections.add(Ss), e.Proj.projections.add(js), e.Proj.projections.add(Rs), e.Proj.projections.add(Ys);
}
//#endregion
//#region node_modules/proj4/lib/index.js
var Zs = Object.assign(br, {
	defaultDatum: "WGS84",
	Proj: Zn,
	WGS84: new Zn("WGS84"),
	Point: Kr,
	toPoint: dr,
	defs: Qt,
	nadgrid: Ln,
	transform: gr,
	mgrs: kr,
	version: "__VERSION__"
});
Xs(Zs);
//#endregion
//#region lib/projection.ts
var Qs = "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.4171,50.3319,465.5524,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs";
function $s(e) {
	let [t, n] = Zs(Qs, "EPSG:4326", e);
	return [t, n];
}
function ec(e) {
	let [t, n] = Zs("EPSG:4326", Qs, e);
	return [t, n];
}
var tc = 20037508.342789244;
function nc([e, t]) {
	let n = Math.max(-85.05112878, Math.min(85.05112878, t));
	return [e / 180 * tc, Math.log(Math.tan(Math.PI / 4 + n * Math.PI / 360)) * (tc / Math.PI)];
}
function rc([e, t]) {
	return [e / tc * 180, Math.atan(Math.exp(t / tc * Math.PI)) * 360 / Math.PI - 90];
}
//#endregion
//#region node_modules/react/cjs/react-jsx-runtime.production.js
var ic = /* @__PURE__ */ p(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
	function r(e, n, r) {
		var i = null;
		if (r !== void 0 && (i = "" + r), n.key !== void 0 && (i = "" + n.key), "key" in n) for (var a in r = {}, n) a !== "key" && (r[a] = n[a]);
		else r = n;
		return n = r.ref, {
			$$typeof: t,
			type: e,
			key: i,
			ref: n === void 0 ? null : n,
			props: r
		};
	}
	e.Fragment = n, e.jsx = r, e.jsxs = r;
})), q = (/* @__PURE__ */ p(((e, t) => {
	t.exports = ic();
})))(), ac = "https://service.pdok.nl/kadaster/brt-achtergrondkaart/wmts/v2_0/standaard/EPSG:3857/{z}/{x}/{y}.png", oc = "https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/Actueel_ortho25/EPSG:3857/{z}/{x}/{y}.jpeg", sc = "https://tile.openstreetmap.org/{z}/{x}/{y}.png", cc = "https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless_3857/default/g/{z}/{y}/{x}.jpg", lc = "https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&STYLE=normal&TILEMATRIXSET=PM&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=image/jpeg";
function uc(e, t) {
	let [n, r] = t === "web-mercator" ? rc(e) : $s(e);
	return [r, n];
}
function dc({ center: e, polygon: t, shape: n, focusKey: r, backgroundMode: i = "map", coordinateSystem: a = "rd", onCenterChange: o, onPolygonChange: s }) {
	let c = (0, A.useRef)(null), l = (0, A.useRef)(void 0), u = (0, A.useRef)(void 0), d = (0, A.useRef)(void 0), f = (0, A.useRef)(void 0), p = (0, A.useRef)(void 0), m = (0, A.useRef)({
		onCenterChange: o,
		onPolygonChange: s
	}), g = (0, A.useRef)(e), _ = (0, A.useRef)(e), v = (0, A.useRef)(t), y = (0, A.useRef)(n), b = (0, A.useRef)(a), [x, S] = (0, A.useState)(!1), [C, w] = (0, A.useState)(!1);
	return (0, A.useEffect)(() => {
		m.current = {
			onCenterChange: o,
			onPolygonChange: s
		}, _.current = e, v.current = t, y.current = n, b.current = a;
	}, [
		e,
		a,
		o,
		s,
		t,
		n
	]), (0, A.useEffect)(() => {
		if (!c.current || l.current) return;
		let e = !1;
		return (async () => {
			let t = await import("./chunk-Br546XJ8.js").then((e) => /* @__PURE__ */ h(e.default, 1));
			if (e || !c.current) return;
			p.current = t;
			let [n, r] = uc(g.current, b.current), i = t.map(c.current, {
				center: [n, r],
				zoom: b.current === "web-mercator" ? 13 : 16,
				minZoom: b.current === "web-mercator" ? 2 : 7,
				maxZoom: 19,
				zoomControl: !0,
				attributionControl: !0
			});
			l.current = i;
			let a = b.current === "web-mercator", o = t.tileLayer(a ? sc : ac, {
				minZoom: a ? 2 : 7,
				maxZoom: 19,
				tileSize: 256,
				crossOrigin: !0,
				attribution: a ? "© OpenStreetMap-bijdragers" : "Kaart © PDOK / Kadaster"
			}).addTo(i);
			f.current = o, o.on("tileerror", () => w(!0)), d.current = t.layerGroup().addTo(i), i.on("click", (e) => {
				let t = b.current === "web-mercator" ? nc([e.latlng.lng, e.latlng.lat]) : ec([e.latlng.lng, e.latlng.lat]);
				y.current === "polygon" ? v.current.length < 64 && m.current.onPolygonChange([...v.current, t]) : m.current.onCenterChange(t);
			}), S(!0), window.setTimeout(() => i.invalidateSize(), 0);
		})(), () => {
			e = !0, u.current?.remove(), u.current = void 0, l.current?.remove(), l.current = void 0, d.current = void 0, f.current = void 0, p.current = void 0;
		};
	}, []), (0, A.useEffect)(() => {
		let t = l.current, n = p.current;
		if (!t || !n || !x) return;
		f.current?.remove(), w(!1);
		let r = a === "web-mercator", [o, s] = r ? rc(e) : $s(e), c = r && o >= -5.6 && o <= 10 && s >= 41 && s <= 51.6, u = r ? i === "imagery" ? c ? lc : cc : sc : i === "imagery" ? oc : ac, d = n.tileLayer(u, {
			minZoom: r ? 2 : 7,
			maxZoom: 19,
			maxNativeZoom: r && i === "imagery" && !c ? 14 : 19,
			tileSize: 256,
			crossOrigin: !0,
			attribution: r ? i === "imagery" ? c ? "Orthophoto © IGN France, Licence Ouverte 2.0" : "Sentinel-2 cloudless © EOX, CC BY 4.0" : "© OpenStreetMap-bijdragers" : i === "imagery" ? "Luchtfoto © PDOK / Beeldmateriaal" : "Kaart © PDOK / Kadaster"
		}).addTo(t);
		f.current = d, d.bringToBack(), d.on("tileerror", () => w(!0));
	}, [
		i,
		e,
		a,
		x
	]), (0, A.useEffect)(() => {
		let e = p.current, t = d.current;
		if (!e || !t || !x) return;
		t.clearLayers();
		let n = v.current.map((e) => uc(e, a));
		n.length >= 3 ? e.polygon(n, {
			color: "#d76043",
			weight: 3,
			dashArray: "8 5",
			fillColor: "#d76043",
			fillOpacity: .2,
			interactive: !1
		}).addTo(t) : n.length >= 2 && e.polyline(n, {
			color: "#d76043",
			weight: 3,
			dashArray: "8 5",
			interactive: !1
		}).addTo(t);
		for (let r of n) e.circleMarker(r, {
			radius: 4,
			color: "#d76043",
			weight: 2,
			fillColor: "#fff8e9",
			fillOpacity: 1,
			interactive: !1
		}).addTo(t);
	}, [
		a,
		t,
		x
	]), (0, A.useEffect)(() => {
		let t = p.current, r = l.current;
		if (!(!t || !r || !x) && (u.current?.remove(), u.current = void 0, n !== "polygon")) {
			let n = t.marker(uc(e, a), {
				draggable: !0,
				icon: t.divIcon({
					className: "selection-marker",
					html: "<span></span>",
					iconSize: [24, 24],
					iconAnchor: [12, 12]
				})
			}).addTo(r);
			n.on("dragend", () => {
				let e = n.getLatLng();
				m.current.onCenterChange(a === "web-mercator" ? nc([e.lng, e.lat]) : ec([e.lng, e.lat]));
			}), u.current = n;
		}
	}, [
		e,
		a,
		x,
		n
	]), (0, A.useEffect)(() => {
		let e = p.current, t = l.current;
		if (!e || !t || !x) return;
		let n = v.current.map((e) => uc(e, a));
		n.length > 0 ? t.fitBounds(e.latLngBounds(n), {
			padding: [72, 72],
			maxZoom: 17,
			animate: !0
		}) : t.flyTo(uc(_.current, a), a === "web-mercator" ? 13 : 16, {
			animate: !0,
			duration: .45
		});
	}, [
		a,
		r,
		x
	]), /* @__PURE__ */ (0, q.jsxs)("div", {
		className: "area-map-shell",
		children: [
			/* @__PURE__ */ (0, q.jsx)("div", {
				ref: c,
				className: "area-map",
				"aria-label": "2D-kaart om het printgebied te kiezen"
			}),
			/* @__PURE__ */ (0, q.jsxs)("div", {
				className: "map-instruction",
				children: [n === "polygon" ? /* @__PURE__ */ (0, q.jsx)(ue, {}) : /* @__PURE__ */ (0, q.jsx)(B, {}), /* @__PURE__ */ (0, q.jsx)("span", { children: n === "polygon" ? t.length < 3 ? `Klik minimaal drie hoekpunten · ${t.length}/3` : `${t.length} punten · klik verder of bouw de preview` : "Klik op de kaart of versleep de pin om de selectie te verplaatsen" })]
			}),
			C ? /* @__PURE__ */ (0, q.jsx)("div", {
				className: "map-warning",
				children: "De PDOK-achtergrond laadt langzaam; de oranje printcontour blijft bruikbaar."
			}) : null
		]
	});
}
var fc = {
	LEFT: 0,
	MIDDLE: 1,
	RIGHT: 2,
	ROTATE: 0,
	DOLLY: 1,
	PAN: 2
}, pc = {
	ROTATE: 0,
	PAN: 1,
	DOLLY_PAN: 2,
	DOLLY_ROTATE: 3
}, mc = 1e3, hc = 1001, gc = 1002, _c = 1003, vc = 1004, yc = 1005, bc = 1006, xc = 1007, Sc = 1008, Cc = 1009, wc = 1010, Tc = 1011, Ec = 1012, Dc = 1013, Oc = 1014, kc = 1015, Ac = 1016, jc = 1017, Mc = 1018, Nc = 1020, Pc = 35902, Fc = 35899, Ic = 1021, Lc = 1022, Rc = 1023, zc = 1026, Bc = 1027, Vc = 1028, Hc = 1029, Uc = 1030, Wc = 1031, Gc = 1033, Kc = 33776, qc = 33777, Jc = 33778, Yc = 33779, Xc = 35840, Zc = 35841, Qc = 35842, $c = 35843, el = 36196, tl = 37492, nl = 37496, rl = 37488, il = 37489, al = 37490, ol = 37491, sl = 37808, cl = 37809, ll = 37810, ul = 37811, dl = 37812, fl = 37813, pl = 37814, ml = 37815, hl = 37816, gl = 37817, _l = 37818, vl = 37819, yl = 37820, bl = 37821, xl = 36492, Sl = 36494, Cl = 36495, wl = 36283, Tl = 36284, El = 36285, Dl = 36286, Ol = 2300, kl = 2301, Al = 2302, jl = 2303, Ml = 2400, Nl = 2401, Pl = 2402, Fl = 3200, Il = "srgb", Ll = "srgb-linear", Rl = "linear", zl = "srgb", Bl = 7680, Vl = 35044, Hl = 2e3;
function Ul(e) {
	for (let t = e.length - 1; t >= 0; --t) if (e[t] >= 65535) return !0;
	return !1;
}
function Wl(e) {
	return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Gl(e) {
	return document.createElementNS("http://www.w3.org/1999/xhtml", e);
}
function Kl() {
	let e = Gl("canvas");
	return e.style.display = "block", e;
}
var ql = {}, Jl = null;
function Yl(...e) {
	let t = "THREE." + e.shift();
	Jl ? Jl("log", t, ...e) : console.log(t, ...e);
}
function Xl(e) {
	let t = e[0];
	if (typeof t == "string" && t.startsWith("TSL:")) {
		let t = e[1];
		t && t.isStackTrace ? e[0] += " " + t.getLocation() : e[1] = "Stack trace not available. Enable \"THREE.Node.captureStackTrace\" to capture stack traces.";
	}
	return e;
}
function Zl(...e) {
	e = Xl(e);
	let t = "THREE." + e.shift();
	if (Jl) Jl("warn", t, ...e);
	else {
		let n = e[0];
		n && n.isStackTrace ? console.warn(n.getError(t)) : console.warn(t, ...e);
	}
}
function J(...e) {
	e = Xl(e);
	let t = "THREE." + e.shift();
	if (Jl) Jl("error", t, ...e);
	else {
		let n = e[0];
		n && n.isStackTrace ? console.error(n.getError(t)) : console.error(t, ...e);
	}
}
function Ql(...e) {
	let t = e.join(" ");
	t in ql || (ql[t] = !0, Zl(...e));
}
function $l(e, t, n) {
	return new Promise(function(r, i) {
		function a() {
			switch (e.clientWaitSync(t, e.SYNC_FLUSH_COMMANDS_BIT, 0)) {
				case e.WAIT_FAILED:
					i();
					break;
				case e.TIMEOUT_EXPIRED:
					setTimeout(a, n);
					break;
				default: r();
			}
		}
		setTimeout(a, n);
	});
}
var eu = {
	0: 1,
	2: 6,
	4: 7,
	3: 5,
	1: 0,
	6: 2,
	7: 4,
	5: 3
}, tu = class {
	addEventListener(e, t) {
		this._listeners === void 0 && (this._listeners = {});
		let n = this._listeners;
		n[e] === void 0 && (n[e] = []), n[e].indexOf(t) === -1 && n[e].push(t);
	}
	hasEventListener(e, t) {
		let n = this._listeners;
		return n === void 0 ? !1 : n[e] !== void 0 && n[e].indexOf(t) !== -1;
	}
	removeEventListener(e, t) {
		let n = this._listeners;
		if (n === void 0) return;
		let r = n[e];
		if (r !== void 0) {
			let e = r.indexOf(t);
			e !== -1 && r.splice(e, 1);
		}
	}
	dispatchEvent(e) {
		let t = this._listeners;
		if (t === void 0) return;
		let n = t[e.type];
		if (n !== void 0) {
			e.target = this;
			let t = n.slice(0);
			for (let n = 0, r = t.length; n < r; n++) t[n].call(this, e);
			e.target = null;
		}
	}
}, nu = /* @__PURE__ */ "00.01.02.03.04.05.06.07.08.09.0a.0b.0c.0d.0e.0f.10.11.12.13.14.15.16.17.18.19.1a.1b.1c.1d.1e.1f.20.21.22.23.24.25.26.27.28.29.2a.2b.2c.2d.2e.2f.30.31.32.33.34.35.36.37.38.39.3a.3b.3c.3d.3e.3f.40.41.42.43.44.45.46.47.48.49.4a.4b.4c.4d.4e.4f.50.51.52.53.54.55.56.57.58.59.5a.5b.5c.5d.5e.5f.60.61.62.63.64.65.66.67.68.69.6a.6b.6c.6d.6e.6f.70.71.72.73.74.75.76.77.78.79.7a.7b.7c.7d.7e.7f.80.81.82.83.84.85.86.87.88.89.8a.8b.8c.8d.8e.8f.90.91.92.93.94.95.96.97.98.99.9a.9b.9c.9d.9e.9f.a0.a1.a2.a3.a4.a5.a6.a7.a8.a9.aa.ab.ac.ad.ae.af.b0.b1.b2.b3.b4.b5.b6.b7.b8.b9.ba.bb.bc.bd.be.bf.c0.c1.c2.c3.c4.c5.c6.c7.c8.c9.ca.cb.cc.cd.ce.cf.d0.d1.d2.d3.d4.d5.d6.d7.d8.d9.da.db.dc.dd.de.df.e0.e1.e2.e3.e4.e5.e6.e7.e8.e9.ea.eb.ec.ed.ee.ef.f0.f1.f2.f3.f4.f5.f6.f7.f8.f9.fa.fb.fc.fd.fe.ff".split("."), ru = 1234567, iu = Math.PI / 180, au = 180 / Math.PI;
function ou() {
	let e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0, r = Math.random() * 4294967295 | 0;
	return (nu[e & 255] + nu[e >> 8 & 255] + nu[e >> 16 & 255] + nu[e >> 24 & 255] + "-" + nu[t & 255] + nu[t >> 8 & 255] + "-" + nu[t >> 16 & 15 | 64] + nu[t >> 24 & 255] + "-" + nu[n & 63 | 128] + nu[n >> 8 & 255] + "-" + nu[n >> 16 & 255] + nu[n >> 24 & 255] + nu[r & 255] + nu[r >> 8 & 255] + nu[r >> 16 & 255] + nu[r >> 24 & 255]).toLowerCase();
}
function Y(e, t, n) {
	return Math.max(t, Math.min(n, e));
}
function su(e, t) {
	return (e % t + t) % t;
}
function cu(e, t, n, r, i) {
	return r + (e - t) * (i - r) / (n - t);
}
function lu(e, t, n) {
	return e === t ? 0 : (n - e) / (t - e);
}
function uu(e, t, n) {
	return (1 - n) * e + n * t;
}
function du(e, t, n, r) {
	return uu(e, t, 1 - Math.exp(-n * r));
}
function fu(e, t = 1) {
	return t - Math.abs(su(e, t * 2) - t);
}
function pu(e, t, n) {
	return e <= t ? 0 : e >= n ? 1 : (e = (e - t) / (n - t), e * e * (3 - 2 * e));
}
function mu(e, t, n) {
	return e <= t ? 0 : e >= n ? 1 : (e = (e - t) / (n - t), e * e * e * (e * (e * 6 - 15) + 10));
}
function hu(e, t) {
	return e + Math.floor(Math.random() * (t - e + 1));
}
function gu(e, t) {
	return e + Math.random() * (t - e);
}
function _u(e) {
	return e * (.5 - Math.random());
}
function vu(e) {
	e !== void 0 && (ru = e);
	let t = ru += 1831565813;
	return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function yu(e) {
	return e * iu;
}
function bu(e) {
	return e * au;
}
function xu(e) {
	return (e & e - 1) == 0 && e !== 0;
}
function Su(e) {
	return 2 ** Math.ceil(Math.log(e) / Math.LN2);
}
function Cu(e) {
	return 2 ** Math.floor(Math.log(e) / Math.LN2);
}
function wu(e, t, n, r, i) {
	let a = Math.cos, o = Math.sin, s = a(n / 2), c = o(n / 2), l = a((t + r) / 2), u = o((t + r) / 2), d = a((t - r) / 2), f = o((t - r) / 2), p = a((r - t) / 2), m = o((r - t) / 2);
	switch (i) {
		case "XYX":
			e.set(s * u, c * d, c * f, s * l);
			break;
		case "YZY":
			e.set(c * f, s * u, c * d, s * l);
			break;
		case "ZXZ":
			e.set(c * d, c * f, s * u, s * l);
			break;
		case "XZX":
			e.set(s * u, c * m, c * p, s * l);
			break;
		case "YXY":
			e.set(c * p, s * u, c * m, s * l);
			break;
		case "ZYZ":
			e.set(c * m, c * p, s * u, s * l);
			break;
		default: Zl("MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
	}
}
function Tu(e, t) {
	switch (t.constructor) {
		case Float32Array: return e;
		case Uint32Array: return e / 4294967295;
		case Uint16Array: return e / 65535;
		case Uint8Array: return e / 255;
		case Int32Array: return Math.max(e / 2147483647, -1);
		case Int16Array: return Math.max(e / 32767, -1);
		case Int8Array: return Math.max(e / 127, -1);
		default: throw Error("THREE.MathUtils: Invalid component type.");
	}
}
function Eu(e, t) {
	switch (t.constructor) {
		case Float32Array: return e;
		case Uint32Array: return Math.round(e * 4294967295);
		case Uint16Array: return Math.round(e * 65535);
		case Uint8Array: return Math.round(e * 255);
		case Int32Array: return Math.round(e * 2147483647);
		case Int16Array: return Math.round(e * 32767);
		case Int8Array: return Math.round(e * 127);
		default: throw Error("THREE.MathUtils: Invalid component type.");
	}
}
var Du = {
	DEG2RAD: iu,
	RAD2DEG: au,
	generateUUID: ou,
	clamp: Y,
	euclideanModulo: su,
	mapLinear: cu,
	inverseLerp: lu,
	lerp: uu,
	damp: du,
	pingpong: fu,
	smoothstep: pu,
	smootherstep: mu,
	randInt: hu,
	randFloat: gu,
	randFloatSpread: _u,
	seededRandom: vu,
	degToRad: yu,
	radToDeg: bu,
	isPowerOfTwo: xu,
	ceilPowerOfTwo: Su,
	floorPowerOfTwo: Cu,
	setQuaternionFromProperEuler: wu,
	normalize: Eu,
	denormalize: Tu
}, Ou = class e {
	static {
		e.prototype.isVector2 = !0;
	}
	constructor(e = 0, t = 0) {
		this.x = e, this.y = t;
	}
	get width() {
		return this.x;
	}
	set width(e) {
		this.x = e;
	}
	get height() {
		return this.y;
	}
	set height(e) {
		this.y = e;
	}
	set(e, t) {
		return this.x = e, this.y = t, this;
	}
	setScalar(e) {
		return this.x = e, this.y = e, this;
	}
	setX(e) {
		return this.x = e, this;
	}
	setY(e) {
		return this.y = e, this;
	}
	setComponent(e, t) {
		switch (e) {
			case 0:
				this.x = t;
				break;
			case 1:
				this.y = t;
				break;
			default: throw Error("THREE.Vector2: index is out of range: " + e);
		}
		return this;
	}
	getComponent(e) {
		switch (e) {
			case 0: return this.x;
			case 1: return this.y;
			default: throw Error("THREE.Vector2: index is out of range: " + e);
		}
	}
	clone() {
		return new this.constructor(this.x, this.y);
	}
	copy(e) {
		return this.x = e.x, this.y = e.y, this;
	}
	add(e) {
		return this.x += e.x, this.y += e.y, this;
	}
	addScalar(e) {
		return this.x += e, this.y += e, this;
	}
	addVectors(e, t) {
		return this.x = e.x + t.x, this.y = e.y + t.y, this;
	}
	addScaledVector(e, t) {
		return this.x += e.x * t, this.y += e.y * t, this;
	}
	sub(e) {
		return this.x -= e.x, this.y -= e.y, this;
	}
	subScalar(e) {
		return this.x -= e, this.y -= e, this;
	}
	subVectors(e, t) {
		return this.x = e.x - t.x, this.y = e.y - t.y, this;
	}
	multiply(e) {
		return this.x *= e.x, this.y *= e.y, this;
	}
	multiplyScalar(e) {
		return this.x *= e, this.y *= e, this;
	}
	divide(e) {
		return this.x /= e.x, this.y /= e.y, this;
	}
	divideScalar(e) {
		return this.multiplyScalar(1 / e);
	}
	applyMatrix3(e) {
		let t = this.x, n = this.y, r = e.elements;
		return this.x = r[0] * t + r[3] * n + r[6], this.y = r[1] * t + r[4] * n + r[7], this;
	}
	min(e) {
		return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
	}
	max(e) {
		return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
	}
	clamp(e, t) {
		return this.x = Y(this.x, e.x, t.x), this.y = Y(this.y, e.y, t.y), this;
	}
	clampScalar(e, t) {
		return this.x = Y(this.x, e, t), this.y = Y(this.y, e, t), this;
	}
	clampLength(e, t) {
		let n = this.length();
		return this.divideScalar(n || 1).multiplyScalar(Y(n, e, t));
	}
	floor() {
		return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
	}
	ceil() {
		return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
	}
	round() {
		return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
	}
	roundToZero() {
		return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
	}
	negate() {
		return this.x = -this.x, this.y = -this.y, this;
	}
	dot(e) {
		return this.x * e.x + this.y * e.y;
	}
	cross(e) {
		return this.x * e.y - this.y * e.x;
	}
	lengthSq() {
		return this.x * this.x + this.y * this.y;
	}
	length() {
		return Math.sqrt(this.x * this.x + this.y * this.y);
	}
	manhattanLength() {
		return Math.abs(this.x) + Math.abs(this.y);
	}
	normalize() {
		return this.divideScalar(this.length() || 1);
	}
	angle() {
		return Math.atan2(-this.y, -this.x) + Math.PI;
	}
	angleTo(e) {
		let t = Math.sqrt(this.lengthSq() * e.lengthSq());
		if (t === 0) return Math.PI / 2;
		let n = this.dot(e) / t;
		return Math.acos(Y(n, -1, 1));
	}
	distanceTo(e) {
		return Math.sqrt(this.distanceToSquared(e));
	}
	distanceToSquared(e) {
		let t = this.x - e.x, n = this.y - e.y;
		return t * t + n * n;
	}
	manhattanDistanceTo(e) {
		return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
	}
	setLength(e) {
		return this.normalize().multiplyScalar(e);
	}
	lerp(e, t) {
		return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
	}
	lerpVectors(e, t, n) {
		return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this;
	}
	equals(e) {
		return e.x === this.x && e.y === this.y;
	}
	fromArray(e, t = 0) {
		return this.x = e[t], this.y = e[t + 1], this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this.x, e[t + 1] = this.y, e;
	}
	fromBufferAttribute(e, t) {
		return this.x = e.getX(t), this.y = e.getY(t), this;
	}
	rotateAround(e, t) {
		let n = Math.cos(t), r = Math.sin(t), i = this.x - e.x, a = this.y - e.y;
		return this.x = i * n - a * r + e.x, this.y = i * r + a * n + e.y, this;
	}
	random() {
		return this.x = Math.random(), this.y = Math.random(), this;
	}
	*[Symbol.iterator]() {
		yield this.x, yield this.y;
	}
}, ku = class {
	constructor(e = 0, t = 0, n = 0, r = 1) {
		this.isQuaternion = !0, this._x = e, this._y = t, this._z = n, this._w = r;
	}
	static slerpFlat(e, t, n, r, i, a, o) {
		let s = n[r + 0], c = n[r + 1], l = n[r + 2], u = n[r + 3], d = i[a + 0], f = i[a + 1], p = i[a + 2], m = i[a + 3];
		if (u !== m || s !== d || c !== f || l !== p) {
			let e = s * d + c * f + l * p + u * m;
			e < 0 && (d = -d, f = -f, p = -p, m = -m, e = -e);
			let t = 1 - o;
			if (e < .9995) {
				let n = Math.acos(e), r = Math.sin(n);
				t = Math.sin(t * n) / r, o = Math.sin(o * n) / r, s = s * t + d * o, c = c * t + f * o, l = l * t + p * o, u = u * t + m * o;
			} else {
				s = s * t + d * o, c = c * t + f * o, l = l * t + p * o, u = u * t + m * o;
				let e = 1 / Math.sqrt(s * s + c * c + l * l + u * u);
				s *= e, c *= e, l *= e, u *= e;
			}
		}
		e[t] = s, e[t + 1] = c, e[t + 2] = l, e[t + 3] = u;
	}
	static multiplyQuaternionsFlat(e, t, n, r, i, a) {
		let o = n[r], s = n[r + 1], c = n[r + 2], l = n[r + 3], u = i[a], d = i[a + 1], f = i[a + 2], p = i[a + 3];
		return e[t] = o * p + l * u + s * f - c * d, e[t + 1] = s * p + l * d + c * u - o * f, e[t + 2] = c * p + l * f + o * d - s * u, e[t + 3] = l * p - o * u - s * d - c * f, e;
	}
	get x() {
		return this._x;
	}
	set x(e) {
		this._x = e, this._onChangeCallback();
	}
	get y() {
		return this._y;
	}
	set y(e) {
		this._y = e, this._onChangeCallback();
	}
	get z() {
		return this._z;
	}
	set z(e) {
		this._z = e, this._onChangeCallback();
	}
	get w() {
		return this._w;
	}
	set w(e) {
		this._w = e, this._onChangeCallback();
	}
	set(e, t, n, r) {
		return this._x = e, this._y = t, this._z = n, this._w = r, this._onChangeCallback(), this;
	}
	clone() {
		return new this.constructor(this._x, this._y, this._z, this._w);
	}
	copy(e) {
		return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
	}
	setFromEuler(e, t = !0) {
		let n = e._x, r = e._y, i = e._z, a = e._order, o = Math.cos, s = Math.sin, c = o(n / 2), l = o(r / 2), u = o(i / 2), d = s(n / 2), f = s(r / 2), p = s(i / 2);
		switch (a) {
			case "XYZ":
				this._x = d * l * u + c * f * p, this._y = c * f * u - d * l * p, this._z = c * l * p + d * f * u, this._w = c * l * u - d * f * p;
				break;
			case "YXZ":
				this._x = d * l * u + c * f * p, this._y = c * f * u - d * l * p, this._z = c * l * p - d * f * u, this._w = c * l * u + d * f * p;
				break;
			case "ZXY":
				this._x = d * l * u - c * f * p, this._y = c * f * u + d * l * p, this._z = c * l * p + d * f * u, this._w = c * l * u - d * f * p;
				break;
			case "ZYX":
				this._x = d * l * u - c * f * p, this._y = c * f * u + d * l * p, this._z = c * l * p - d * f * u, this._w = c * l * u + d * f * p;
				break;
			case "YZX":
				this._x = d * l * u + c * f * p, this._y = c * f * u + d * l * p, this._z = c * l * p - d * f * u, this._w = c * l * u - d * f * p;
				break;
			case "XZY":
				this._x = d * l * u - c * f * p, this._y = c * f * u - d * l * p, this._z = c * l * p + d * f * u, this._w = c * l * u + d * f * p;
				break;
			default: Zl("Quaternion: .setFromEuler() encountered an unknown order: " + a);
		}
		return t === !0 && this._onChangeCallback(), this;
	}
	setFromAxisAngle(e, t) {
		let n = t / 2, r = Math.sin(n);
		return this._x = e.x * r, this._y = e.y * r, this._z = e.z * r, this._w = Math.cos(n), this._onChangeCallback(), this;
	}
	setFromRotationMatrix(e) {
		let t = e.elements, n = t[0], r = t[4], i = t[8], a = t[1], o = t[5], s = t[9], c = t[2], l = t[6], u = t[10], d = n + o + u;
		if (d > 0) {
			let e = .5 / Math.sqrt(d + 1);
			this._w = .25 / e, this._x = (l - s) * e, this._y = (i - c) * e, this._z = (a - r) * e;
		} else if (n > o && n > u) {
			let e = 2 * Math.sqrt(1 + n - o - u);
			this._w = (l - s) / e, this._x = .25 * e, this._y = (r + a) / e, this._z = (i + c) / e;
		} else if (o > u) {
			let e = 2 * Math.sqrt(1 + o - n - u);
			this._w = (i - c) / e, this._x = (r + a) / e, this._y = .25 * e, this._z = (s + l) / e;
		} else {
			let e = 2 * Math.sqrt(1 + u - n - o);
			this._w = (a - r) / e, this._x = (i + c) / e, this._y = (s + l) / e, this._z = .25 * e;
		}
		return this._onChangeCallback(), this;
	}
	setFromUnitVectors(e, t) {
		let n = e.dot(t) + 1;
		return n < 1e-8 ? (n = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = n)) : (this._x = e.y * t.z - e.z * t.y, this._y = e.z * t.x - e.x * t.z, this._z = e.x * t.y - e.y * t.x, this._w = n), this.normalize();
	}
	angleTo(e) {
		return 2 * Math.acos(Math.abs(Y(this.dot(e), -1, 1)));
	}
	rotateTowards(e, t) {
		let n = this.angleTo(e);
		if (n === 0) return this;
		let r = Math.min(1, t / n);
		return this.slerp(e, r), this;
	}
	identity() {
		return this.set(0, 0, 0, 1);
	}
	invert() {
		return this.conjugate();
	}
	conjugate() {
		return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
	}
	dot(e) {
		return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
	}
	lengthSq() {
		return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
	}
	length() {
		return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
	}
	normalize() {
		let e = this.length();
		return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x *= e, this._y *= e, this._z *= e, this._w *= e), this._onChangeCallback(), this;
	}
	multiply(e) {
		return this.multiplyQuaternions(this, e);
	}
	premultiply(e) {
		return this.multiplyQuaternions(e, this);
	}
	multiplyQuaternions(e, t) {
		let n = e._x, r = e._y, i = e._z, a = e._w, o = t._x, s = t._y, c = t._z, l = t._w;
		return this._x = n * l + a * o + r * c - i * s, this._y = r * l + a * s + i * o - n * c, this._z = i * l + a * c + n * s - r * o, this._w = a * l - n * o - r * s - i * c, this._onChangeCallback(), this;
	}
	slerp(e, t) {
		let n = e._x, r = e._y, i = e._z, a = e._w, o = this.dot(e);
		o < 0 && (n = -n, r = -r, i = -i, a = -a, o = -o);
		let s = 1 - t;
		if (o < .9995) {
			let e = Math.acos(o), c = Math.sin(e);
			s = Math.sin(s * e) / c, t = Math.sin(t * e) / c, this._x = this._x * s + n * t, this._y = this._y * s + r * t, this._z = this._z * s + i * t, this._w = this._w * s + a * t, this._onChangeCallback();
		} else this._x = this._x * s + n * t, this._y = this._y * s + r * t, this._z = this._z * s + i * t, this._w = this._w * s + a * t, this.normalize();
		return this;
	}
	slerpQuaternions(e, t, n) {
		return this.copy(e).slerp(t, n);
	}
	random() {
		let e = 2 * Math.PI * Math.random(), t = 2 * Math.PI * Math.random(), n = Math.random(), r = Math.sqrt(1 - n), i = Math.sqrt(n);
		return this.set(r * Math.sin(e), r * Math.cos(e), i * Math.sin(t), i * Math.cos(t));
	}
	equals(e) {
		return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
	}
	fromArray(e, t = 0) {
		return this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this._onChangeCallback(), this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
	}
	fromBufferAttribute(e, t) {
		return this._x = e.getX(t), this._y = e.getY(t), this._z = e.getZ(t), this._w = e.getW(t), this._onChangeCallback(), this;
	}
	toJSON() {
		return this.toArray();
	}
	_onChange(e) {
		return this._onChangeCallback = e, this;
	}
	_onChangeCallback() {}
	*[Symbol.iterator]() {
		yield this._x, yield this._y, yield this._z, yield this._w;
	}
}, X = class e {
	static {
		e.prototype.isVector3 = !0;
	}
	constructor(e = 0, t = 0, n = 0) {
		this.x = e, this.y = t, this.z = n;
	}
	set(e, t, n) {
		return n === void 0 && (n = this.z), this.x = e, this.y = t, this.z = n, this;
	}
	setScalar(e) {
		return this.x = e, this.y = e, this.z = e, this;
	}
	setX(e) {
		return this.x = e, this;
	}
	setY(e) {
		return this.y = e, this;
	}
	setZ(e) {
		return this.z = e, this;
	}
	setComponent(e, t) {
		switch (e) {
			case 0:
				this.x = t;
				break;
			case 1:
				this.y = t;
				break;
			case 2:
				this.z = t;
				break;
			default: throw Error("THREE.Vector3: index is out of range: " + e);
		}
		return this;
	}
	getComponent(e) {
		switch (e) {
			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			default: throw Error("THREE.Vector3: index is out of range: " + e);
		}
	}
	clone() {
		return new this.constructor(this.x, this.y, this.z);
	}
	copy(e) {
		return this.x = e.x, this.y = e.y, this.z = e.z, this;
	}
	add(e) {
		return this.x += e.x, this.y += e.y, this.z += e.z, this;
	}
	addScalar(e) {
		return this.x += e, this.y += e, this.z += e, this;
	}
	addVectors(e, t) {
		return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
	}
	addScaledVector(e, t) {
		return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
	}
	sub(e) {
		return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
	}
	subScalar(e) {
		return this.x -= e, this.y -= e, this.z -= e, this;
	}
	subVectors(e, t) {
		return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
	}
	multiply(e) {
		return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
	}
	multiplyScalar(e) {
		return this.x *= e, this.y *= e, this.z *= e, this;
	}
	multiplyVectors(e, t) {
		return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
	}
	applyEuler(e) {
		return this.applyQuaternion(ju.setFromEuler(e));
	}
	applyAxisAngle(e, t) {
		return this.applyQuaternion(ju.setFromAxisAngle(e, t));
	}
	applyMatrix3(e) {
		let t = this.x, n = this.y, r = this.z, i = e.elements;
		return this.x = i[0] * t + i[3] * n + i[6] * r, this.y = i[1] * t + i[4] * n + i[7] * r, this.z = i[2] * t + i[5] * n + i[8] * r, this;
	}
	applyNormalMatrix(e) {
		return this.applyMatrix3(e).normalize();
	}
	applyMatrix4(e) {
		let t = this.x, n = this.y, r = this.z, i = e.elements, a = 1 / (i[3] * t + i[7] * n + i[11] * r + i[15]);
		return this.x = (i[0] * t + i[4] * n + i[8] * r + i[12]) * a, this.y = (i[1] * t + i[5] * n + i[9] * r + i[13]) * a, this.z = (i[2] * t + i[6] * n + i[10] * r + i[14]) * a, this;
	}
	applyQuaternion(e) {
		let t = this.x, n = this.y, r = this.z, i = e.x, a = e.y, o = e.z, s = e.w, c = 2 * (a * r - o * n), l = 2 * (o * t - i * r), u = 2 * (i * n - a * t);
		return this.x = t + s * c + a * u - o * l, this.y = n + s * l + o * c - i * u, this.z = r + s * u + i * l - a * c, this;
	}
	project(e) {
		return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
	}
	unproject(e) {
		return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
	}
	transformDirection(e) {
		let t = this.x, n = this.y, r = this.z, i = e.elements;
		return this.x = i[0] * t + i[4] * n + i[8] * r, this.y = i[1] * t + i[5] * n + i[9] * r, this.z = i[2] * t + i[6] * n + i[10] * r, this.normalize();
	}
	divide(e) {
		return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
	}
	divideScalar(e) {
		return this.multiplyScalar(1 / e);
	}
	min(e) {
		return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
	}
	max(e) {
		return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
	}
	clamp(e, t) {
		return this.x = Y(this.x, e.x, t.x), this.y = Y(this.y, e.y, t.y), this.z = Y(this.z, e.z, t.z), this;
	}
	clampScalar(e, t) {
		return this.x = Y(this.x, e, t), this.y = Y(this.y, e, t), this.z = Y(this.z, e, t), this;
	}
	clampLength(e, t) {
		let n = this.length();
		return this.divideScalar(n || 1).multiplyScalar(Y(n, e, t));
	}
	floor() {
		return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
	}
	ceil() {
		return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
	}
	round() {
		return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
	}
	roundToZero() {
		return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
	}
	negate() {
		return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
	}
	dot(e) {
		return this.x * e.x + this.y * e.y + this.z * e.z;
	}
	lengthSq() {
		return this.x * this.x + this.y * this.y + this.z * this.z;
	}
	length() {
		return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
	}
	manhattanLength() {
		return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
	}
	normalize() {
		return this.divideScalar(this.length() || 1);
	}
	setLength(e) {
		return this.normalize().multiplyScalar(e);
	}
	lerp(e, t) {
		return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
	}
	lerpVectors(e, t, n) {
		return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this;
	}
	cross(e) {
		return this.crossVectors(this, e);
	}
	crossVectors(e, t) {
		let n = e.x, r = e.y, i = e.z, a = t.x, o = t.y, s = t.z;
		return this.x = r * s - i * o, this.y = i * a - n * s, this.z = n * o - r * a, this;
	}
	projectOnVector(e) {
		let t = e.lengthSq();
		if (t === 0) return this.set(0, 0, 0);
		let n = e.dot(this) / t;
		return this.copy(e).multiplyScalar(n);
	}
	projectOnPlane(e) {
		return Au.copy(this).projectOnVector(e), this.sub(Au);
	}
	reflect(e) {
		return this.sub(Au.copy(e).multiplyScalar(2 * this.dot(e)));
	}
	angleTo(e) {
		let t = Math.sqrt(this.lengthSq() * e.lengthSq());
		if (t === 0) return Math.PI / 2;
		let n = this.dot(e) / t;
		return Math.acos(Y(n, -1, 1));
	}
	distanceTo(e) {
		return Math.sqrt(this.distanceToSquared(e));
	}
	distanceToSquared(e) {
		let t = this.x - e.x, n = this.y - e.y, r = this.z - e.z;
		return t * t + n * n + r * r;
	}
	manhattanDistanceTo(e) {
		return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
	}
	setFromSpherical(e) {
		return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
	}
	setFromSphericalCoords(e, t, n) {
		let r = Math.sin(t) * e;
		return this.x = r * Math.sin(n), this.y = Math.cos(t) * e, this.z = r * Math.cos(n), this;
	}
	setFromCylindrical(e) {
		return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
	}
	setFromCylindricalCoords(e, t, n) {
		return this.x = e * Math.sin(t), this.y = n, this.z = e * Math.cos(t), this;
	}
	setFromMatrixPosition(e) {
		let t = e.elements;
		return this.x = t[12], this.y = t[13], this.z = t[14], this;
	}
	setFromMatrixScale(e) {
		let t = this.setFromMatrixColumn(e, 0).length(), n = this.setFromMatrixColumn(e, 1).length(), r = this.setFromMatrixColumn(e, 2).length();
		return this.x = t, this.y = n, this.z = r, this;
	}
	setFromMatrixColumn(e, t) {
		return this.fromArray(e.elements, t * 4);
	}
	setFromMatrix3Column(e, t) {
		return this.fromArray(e.elements, t * 3);
	}
	setFromEuler(e) {
		return this.x = e._x, this.y = e._y, this.z = e._z, this;
	}
	setFromColor(e) {
		return this.x = e.r, this.y = e.g, this.z = e.b, this;
	}
	equals(e) {
		return e.x === this.x && e.y === this.y && e.z === this.z;
	}
	fromArray(e, t = 0) {
		return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
	}
	fromBufferAttribute(e, t) {
		return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
	}
	random() {
		return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
	}
	randomDirection() {
		let e = Math.random() * Math.PI * 2, t = Math.random() * 2 - 1, n = Math.sqrt(1 - t * t);
		return this.x = n * Math.cos(e), this.y = t, this.z = n * Math.sin(e), this;
	}
	*[Symbol.iterator]() {
		yield this.x, yield this.y, yield this.z;
	}
}, Au = /* @__PURE__ */ new X(), ju = /* @__PURE__ */ new ku(), Mu = class e {
	static {
		e.prototype.isMatrix3 = !0;
	}
	constructor(e, t, n, r, i, a, o, s, c) {
		this.elements = [
			1,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			1
		], e !== void 0 && this.set(e, t, n, r, i, a, o, s, c);
	}
	set(e, t, n, r, i, a, o, s, c) {
		let l = this.elements;
		return l[0] = e, l[1] = r, l[2] = o, l[3] = t, l[4] = i, l[5] = s, l[6] = n, l[7] = a, l[8] = c, this;
	}
	identity() {
		return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
	}
	copy(e) {
		let t = this.elements, n = e.elements;
		return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], this;
	}
	extractBasis(e, t, n) {
		return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
	}
	setFromMatrix4(e) {
		let t = e.elements;
		return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
	}
	multiply(e) {
		return this.multiplyMatrices(this, e);
	}
	premultiply(e) {
		return this.multiplyMatrices(e, this);
	}
	multiplyMatrices(e, t) {
		let n = e.elements, r = t.elements, i = this.elements, a = n[0], o = n[3], s = n[6], c = n[1], l = n[4], u = n[7], d = n[2], f = n[5], p = n[8], m = r[0], h = r[3], g = r[6], _ = r[1], v = r[4], y = r[7], b = r[2], x = r[5], S = r[8];
		return i[0] = a * m + o * _ + s * b, i[3] = a * h + o * v + s * x, i[6] = a * g + o * y + s * S, i[1] = c * m + l * _ + u * b, i[4] = c * h + l * v + u * x, i[7] = c * g + l * y + u * S, i[2] = d * m + f * _ + p * b, i[5] = d * h + f * v + p * x, i[8] = d * g + f * y + p * S, this;
	}
	multiplyScalar(e) {
		let t = this.elements;
		return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
	}
	determinant() {
		let e = this.elements, t = e[0], n = e[1], r = e[2], i = e[3], a = e[4], o = e[5], s = e[6], c = e[7], l = e[8];
		return t * a * l - t * o * c - n * i * l + n * o * s + r * i * c - r * a * s;
	}
	invert() {
		let e = this.elements, t = e[0], n = e[1], r = e[2], i = e[3], a = e[4], o = e[5], s = e[6], c = e[7], l = e[8], u = l * a - o * c, d = o * s - l * i, f = c * i - a * s, p = t * u + n * d + r * f;
		if (p === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
		let m = 1 / p;
		return e[0] = u * m, e[1] = (r * c - l * n) * m, e[2] = (o * n - r * a) * m, e[3] = d * m, e[4] = (l * t - r * s) * m, e[5] = (r * i - o * t) * m, e[6] = f * m, e[7] = (n * s - c * t) * m, e[8] = (a * t - n * i) * m, this;
	}
	transpose() {
		let e, t = this.elements;
		return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
	}
	getNormalMatrix(e) {
		return this.setFromMatrix4(e).invert().transpose();
	}
	transposeIntoArray(e) {
		let t = this.elements;
		return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
	}
	setUvTransform(e, t, n, r, i, a, o) {
		let s = Math.cos(i), c = Math.sin(i);
		return this.set(n * s, n * c, -n * (s * a + c * o) + a + e, -r * c, r * s, -r * (-c * a + s * o) + o + t, 0, 0, 1), this;
	}
	scale(e, t) {
		return Ql("Matrix3: .scale() is deprecated. Use .makeScale() instead."), this.premultiply(Nu.makeScale(e, t)), this;
	}
	rotate(e) {
		return Ql("Matrix3: .rotate() is deprecated. Use .makeRotation() instead."), this.premultiply(Nu.makeRotation(-e)), this;
	}
	translate(e, t) {
		return Ql("Matrix3: .translate() is deprecated. Use .makeTranslation() instead."), this.premultiply(Nu.makeTranslation(e, t)), this;
	}
	makeTranslation(e, t) {
		return e.isVector2 ? this.set(1, 0, e.x, 0, 1, e.y, 0, 0, 1) : this.set(1, 0, e, 0, 1, t, 0, 0, 1), this;
	}
	makeRotation(e) {
		let t = Math.cos(e), n = Math.sin(e);
		return this.set(t, -n, 0, n, t, 0, 0, 0, 1), this;
	}
	makeScale(e, t) {
		return this.set(e, 0, 0, 0, t, 0, 0, 0, 1), this;
	}
	equals(e) {
		let t = this.elements, n = e.elements;
		for (let e = 0; e < 9; e++) if (t[e] !== n[e]) return !1;
		return !0;
	}
	fromArray(e, t = 0) {
		for (let n = 0; n < 9; n++) this.elements[n] = e[n + t];
		return this;
	}
	toArray(e = [], t = 0) {
		let n = this.elements;
		return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e;
	}
	clone() {
		return new this.constructor().fromArray(this.elements);
	}
}, Nu = /* @__PURE__ */ new Mu(), Pu = /* @__PURE__ */ new Mu().set(.4123908, .3575843, .1804808, .212639, .7151687, .0721923, .0193308, .1191948, .9505322), Fu = /* @__PURE__ */ new Mu().set(3.2409699, -1.5373832, -.4986108, -.9692436, 1.8759675, .0415551, .0556301, -.203977, 1.0569715);
function Iu() {
	let e = {
		enabled: !0,
		workingColorSpace: Ll,
		spaces: {},
		convert: function(e, t, n) {
			return this.enabled === !1 || t === n || !t || !n ? e : (this.spaces[t].transfer === "srgb" && (e.r = Ru(e.r), e.g = Ru(e.g), e.b = Ru(e.b)), this.spaces[t].primaries !== this.spaces[n].primaries && (e.applyMatrix3(this.spaces[t].toXYZ), e.applyMatrix3(this.spaces[n].fromXYZ)), this.spaces[n].transfer === "srgb" && (e.r = zu(e.r), e.g = zu(e.g), e.b = zu(e.b)), e);
		},
		workingToColorSpace: function(e, t) {
			return this.convert(e, this.workingColorSpace, t);
		},
		colorSpaceToWorking: function(e, t) {
			return this.convert(e, t, this.workingColorSpace);
		},
		getPrimaries: function(e) {
			return this.spaces[e].primaries;
		},
		getTransfer: function(e) {
			return e === "" ? Rl : this.spaces[e].transfer;
		},
		getToneMappingMode: function(e) {
			return this.spaces[e].outputColorSpaceConfig.toneMappingMode || "standard";
		},
		getLuminanceCoefficients: function(e, t = this.workingColorSpace) {
			return e.fromArray(this.spaces[t].luminanceCoefficients);
		},
		define: function(e) {
			Object.assign(this.spaces, e);
		},
		_getMatrix: function(e, t, n) {
			return e.copy(this.spaces[t].toXYZ).multiply(this.spaces[n].fromXYZ);
		},
		_getDrawingBufferColorSpace: function(e) {
			return this.spaces[e].outputColorSpaceConfig.drawingBufferColorSpace;
		},
		_getUnpackColorSpace: function(e = this.workingColorSpace) {
			return this.spaces[e].workingColorSpaceConfig.unpackColorSpace;
		},
		fromWorkingColorSpace: function(t, n) {
			return Ql("ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), e.workingToColorSpace(t, n);
		},
		toWorkingColorSpace: function(t, n) {
			return Ql("ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), e.colorSpaceToWorking(t, n);
		}
	}, t = [
		.64,
		.33,
		.3,
		.6,
		.15,
		.06
	], n = [
		.2126,
		.7152,
		.0722
	], r = [.3127, .329];
	return e.define({
		[Ll]: {
			primaries: t,
			whitePoint: r,
			transfer: Rl,
			toXYZ: Pu,
			fromXYZ: Fu,
			luminanceCoefficients: n,
			workingColorSpaceConfig: { unpackColorSpace: Il },
			outputColorSpaceConfig: { drawingBufferColorSpace: Il }
		},
		[Il]: {
			primaries: t,
			whitePoint: r,
			transfer: zl,
			toXYZ: Pu,
			fromXYZ: Fu,
			luminanceCoefficients: n,
			outputColorSpaceConfig: { drawingBufferColorSpace: Il }
		}
	}), e;
}
var Lu = /* @__PURE__ */ Iu();
function Ru(e) {
	return e < .04045 ? e * .0773993808 : (e * .9478672986 + .0521327014) ** 2.4;
}
function zu(e) {
	return e < .0031308 ? e * 12.92 : 1.055 * e ** .41666 - .055;
}
var Bu, Vu = class {
	static getDataURL(e, t = "image/png") {
		if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u") return e.src;
		let n;
		if (e instanceof HTMLCanvasElement) n = e;
		else {
			Bu === void 0 && (Bu = Gl("canvas")), Bu.width = e.width, Bu.height = e.height;
			let t = Bu.getContext("2d");
			e instanceof ImageData ? t.putImageData(e, 0, 0) : t.drawImage(e, 0, 0, e.width, e.height), n = Bu;
		}
		return n.toDataURL(t);
	}
	static sRGBToLinear(e) {
		if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
			let t = Gl("canvas");
			t.width = e.width, t.height = e.height;
			let n = t.getContext("2d");
			n.drawImage(e, 0, 0, e.width, e.height);
			let r = n.getImageData(0, 0, e.width, e.height), i = r.data;
			for (let e = 0; e < i.length; e++) i[e] = Ru(i[e] / 255) * 255;
			return n.putImageData(r, 0, 0), t;
		} else if (e.data) {
			let t = e.data.slice(0);
			for (let e = 0; e < t.length; e++) t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[e] = Math.floor(Ru(t[e] / 255) * 255) : t[e] = Ru(t[e]);
			return {
				data: t,
				width: e.width,
				height: e.height
			};
		} else return Zl("ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
	}
}, Hu = 0, Uu = class {
	constructor(e = null) {
		this.isSource = !0, Object.defineProperty(this, "id", { value: Hu++ }), this.uuid = ou(), this.data = e, this.dataReady = !0, this.version = 0;
	}
	getSize(e) {
		let t = this.data;
		return typeof HTMLVideoElement < "u" && t instanceof HTMLVideoElement ? e.set(t.videoWidth, t.videoHeight, 0) : typeof VideoFrame < "u" && t instanceof VideoFrame ? e.set(t.displayWidth, t.displayHeight, 0) : t === null ? e.set(0, 0, 0) : e.set(t.width, t.height, t.depth || 0), e;
	}
	set needsUpdate(e) {
		e === !0 && this.version++;
	}
	toJSON(e) {
		let t = e === void 0 || typeof e == "string";
		if (!t && e.images[this.uuid] !== void 0) return e.images[this.uuid];
		let n = {
			uuid: this.uuid,
			url: ""
		}, r = this.data;
		if (r !== null) {
			let e;
			if (Array.isArray(r)) {
				e = [];
				for (let t = 0, n = r.length; t < n; t++) r[t].isDataTexture ? e.push(Wu(r[t].image)) : e.push(Wu(r[t]));
			} else e = Wu(r);
			n.url = e;
		}
		return t || (e.images[this.uuid] = n), n;
	}
};
function Wu(e) {
	return typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap ? Vu.getDataURL(e) : e.data ? {
		data: Array.from(e.data),
		width: e.width,
		height: e.height,
		type: e.data.constructor.name
	} : (Zl("Texture: Unable to serialize Texture."), {});
}
var Gu = 0, Ku = /* @__PURE__ */ new X(), qu = class e extends tu {
	constructor(t = e.DEFAULT_IMAGE, n = e.DEFAULT_MAPPING, r = hc, i = hc, a = bc, o = Sc, s = Rc, c = Cc, l = e.DEFAULT_ANISOTROPY, u = "") {
		super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: Gu++ }), this.uuid = ou(), this.name = "", this.source = new Uu(t), this.mipmaps = [], this.mapping = n, this.channel = 0, this.wrapS = r, this.wrapT = i, this.magFilter = a, this.minFilter = o, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = c, this.offset = new Ou(0, 0), this.repeat = new Ou(1, 1), this.center = new Ou(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Mu(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = u, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(t && t.depth && t.depth > 1), this.pmremVersion = 0, this.normalized = !1;
	}
	get width() {
		return this.source.getSize(Ku).x;
	}
	get height() {
		return this.source.getSize(Ku).y;
	}
	get depth() {
		return this.source.getSize(Ku).z;
	}
	get image() {
		return this.source.data;
	}
	set image(e) {
		this.source.data = e;
	}
	updateMatrix() {
		this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
	}
	addUpdateRange(e, t) {
		this.updateRanges.push({
			start: e,
			count: t
		});
	}
	clearUpdateRanges() {
		this.updateRanges.length = 0;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.normalized = e.normalized, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.renderTarget = e.renderTarget, this.isRenderTargetTexture = e.isRenderTargetTexture, this.isArrayTexture = e.isArrayTexture, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
	}
	setValues(e) {
		for (let t in e) {
			let n = e[t];
			if (n === void 0) {
				Zl(`Texture.setValues(): parameter '${t}' has value of undefined.`);
				continue;
			}
			let r = this[t];
			if (r === void 0) {
				Zl(`Texture.setValues(): property '${t}' does not exist.`);
				continue;
			}
			r && n && r.isVector2 && n.isVector2 || r && n && r.isVector3 && n.isVector3 || r && n && r.isMatrix3 && n.isMatrix3 ? r.copy(n) : this[t] = n;
		}
	}
	toJSON(e) {
		let t = e === void 0 || typeof e == "string";
		if (!t && e.textures[this.uuid] !== void 0) return e.textures[this.uuid];
		let n = {
			metadata: {
				version: 4.7,
				type: "Texture",
				generator: "Texture.toJSON"
			},
			uuid: this.uuid,
			name: this.name,
			image: this.source.toJSON(e).uuid,
			mapping: this.mapping,
			channel: this.channel,
			repeat: [this.repeat.x, this.repeat.y],
			offset: [this.offset.x, this.offset.y],
			center: [this.center.x, this.center.y],
			rotation: this.rotation,
			wrap: [this.wrapS, this.wrapT],
			format: this.format,
			internalFormat: this.internalFormat,
			type: this.type,
			normalized: this.normalized,
			colorSpace: this.colorSpace,
			minFilter: this.minFilter,
			magFilter: this.magFilter,
			anisotropy: this.anisotropy,
			flipY: this.flipY,
			generateMipmaps: this.generateMipmaps,
			premultiplyAlpha: this.premultiplyAlpha,
			unpackAlignment: this.unpackAlignment
		};
		return Object.keys(this.userData).length > 0 && (n.userData = this.userData), t || (e.textures[this.uuid] = n), n;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
	transformUv(e) {
		if (this.mapping !== 300) return e;
		if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1) switch (this.wrapS) {
			case mc:
				e.x -= Math.floor(e.x);
				break;
			case hc:
				e.x = e.x < 0 ? 0 : 1;
				break;
			case gc:
				Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x -= Math.floor(e.x);
				break;
		}
		if (e.y < 0 || e.y > 1) switch (this.wrapT) {
			case mc:
				e.y -= Math.floor(e.y);
				break;
			case hc:
				e.y = e.y < 0 ? 0 : 1;
				break;
			case gc:
				Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y -= Math.floor(e.y);
				break;
		}
		return this.flipY && (e.y = 1 - e.y), e;
	}
	set needsUpdate(e) {
		e === !0 && (this.version++, this.source.needsUpdate = !0);
	}
	set needsPMREMUpdate(e) {
		e === !0 && this.pmremVersion++;
	}
};
qu.DEFAULT_IMAGE = null, qu.DEFAULT_MAPPING = 300, qu.DEFAULT_ANISOTROPY = 1;
var Ju = class e {
	static {
		e.prototype.isVector4 = !0;
	}
	constructor(e = 0, t = 0, n = 0, r = 1) {
		this.x = e, this.y = t, this.z = n, this.w = r;
	}
	get width() {
		return this.z;
	}
	set width(e) {
		this.z = e;
	}
	get height() {
		return this.w;
	}
	set height(e) {
		this.w = e;
	}
	set(e, t, n, r) {
		return this.x = e, this.y = t, this.z = n, this.w = r, this;
	}
	setScalar(e) {
		return this.x = e, this.y = e, this.z = e, this.w = e, this;
	}
	setX(e) {
		return this.x = e, this;
	}
	setY(e) {
		return this.y = e, this;
	}
	setZ(e) {
		return this.z = e, this;
	}
	setW(e) {
		return this.w = e, this;
	}
	setComponent(e, t) {
		switch (e) {
			case 0:
				this.x = t;
				break;
			case 1:
				this.y = t;
				break;
			case 2:
				this.z = t;
				break;
			case 3:
				this.w = t;
				break;
			default: throw Error("THREE.Vector4: index is out of range: " + e);
		}
		return this;
	}
	getComponent(e) {
		switch (e) {
			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			case 3: return this.w;
			default: throw Error("THREE.Vector4: index is out of range: " + e);
		}
	}
	clone() {
		return new this.constructor(this.x, this.y, this.z, this.w);
	}
	copy(e) {
		return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w === void 0 ? 1 : e.w, this;
	}
	add(e) {
		return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
	}
	addScalar(e) {
		return this.x += e, this.y += e, this.z += e, this.w += e, this;
	}
	addVectors(e, t) {
		return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
	}
	addScaledVector(e, t) {
		return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
	}
	sub(e) {
		return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
	}
	subScalar(e) {
		return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
	}
	subVectors(e, t) {
		return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
	}
	multiply(e) {
		return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
	}
	multiplyScalar(e) {
		return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
	}
	applyMatrix4(e) {
		let t = this.x, n = this.y, r = this.z, i = this.w, a = e.elements;
		return this.x = a[0] * t + a[4] * n + a[8] * r + a[12] * i, this.y = a[1] * t + a[5] * n + a[9] * r + a[13] * i, this.z = a[2] * t + a[6] * n + a[10] * r + a[14] * i, this.w = a[3] * t + a[7] * n + a[11] * r + a[15] * i, this;
	}
	divide(e) {
		return this.x /= e.x, this.y /= e.y, this.z /= e.z, this.w /= e.w, this;
	}
	divideScalar(e) {
		return this.multiplyScalar(1 / e);
	}
	setAxisAngleFromQuaternion(e) {
		this.w = 2 * Math.acos(e.w);
		let t = Math.sqrt(1 - e.w * e.w);
		return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
	}
	setAxisAngleFromRotationMatrix(e) {
		let t, n, r, i, a = .01, o = .1, s = e.elements, c = s[0], l = s[4], u = s[8], d = s[1], f = s[5], p = s[9], m = s[2], h = s[6], g = s[10];
		if (Math.abs(l - d) < a && Math.abs(u - m) < a && Math.abs(p - h) < a) {
			if (Math.abs(l + d) < o && Math.abs(u + m) < o && Math.abs(p + h) < o && Math.abs(c + f + g - 3) < o) return this.set(1, 0, 0, 0), this;
			t = Math.PI;
			let e = (c + 1) / 2, s = (f + 1) / 2, _ = (g + 1) / 2, v = (l + d) / 4, y = (u + m) / 4, b = (p + h) / 4;
			return e > s && e > _ ? e < a ? (n = 0, r = .707106781, i = .707106781) : (n = Math.sqrt(e), r = v / n, i = y / n) : s > _ ? s < a ? (n = .707106781, r = 0, i = .707106781) : (r = Math.sqrt(s), n = v / r, i = b / r) : _ < a ? (n = .707106781, r = .707106781, i = 0) : (i = Math.sqrt(_), n = y / i, r = b / i), this.set(n, r, i, t), this;
		}
		let _ = Math.sqrt((h - p) * (h - p) + (u - m) * (u - m) + (d - l) * (d - l));
		return Math.abs(_) < .001 && (_ = 1), this.x = (h - p) / _, this.y = (u - m) / _, this.z = (d - l) / _, this.w = Math.acos((c + f + g - 1) / 2), this;
	}
	setFromMatrixPosition(e) {
		let t = e.elements;
		return this.x = t[12], this.y = t[13], this.z = t[14], this.w = t[15], this;
	}
	min(e) {
		return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
	}
	max(e) {
		return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
	}
	clamp(e, t) {
		return this.x = Y(this.x, e.x, t.x), this.y = Y(this.y, e.y, t.y), this.z = Y(this.z, e.z, t.z), this.w = Y(this.w, e.w, t.w), this;
	}
	clampScalar(e, t) {
		return this.x = Y(this.x, e, t), this.y = Y(this.y, e, t), this.z = Y(this.z, e, t), this.w = Y(this.w, e, t), this;
	}
	clampLength(e, t) {
		let n = this.length();
		return this.divideScalar(n || 1).multiplyScalar(Y(n, e, t));
	}
	floor() {
		return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
	}
	ceil() {
		return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
	}
	round() {
		return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
	}
	roundToZero() {
		return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
	}
	negate() {
		return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
	}
	dot(e) {
		return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
	}
	lengthSq() {
		return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
	}
	length() {
		return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
	}
	manhattanLength() {
		return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
	}
	normalize() {
		return this.divideScalar(this.length() || 1);
	}
	setLength(e) {
		return this.normalize().multiplyScalar(e);
	}
	lerp(e, t) {
		return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
	}
	lerpVectors(e, t, n) {
		return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this.w = e.w + (t.w - e.w) * n, this;
	}
	equals(e) {
		return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
	}
	fromArray(e, t = 0) {
		return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
	}
	fromBufferAttribute(e, t) {
		return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
	}
	random() {
		return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
	}
	*[Symbol.iterator]() {
		yield this.x, yield this.y, yield this.z, yield this.w;
	}
}, Yu = class extends tu {
	constructor(e = 1, t = 1, n = {}) {
		super(), n = Object.assign({
			generateMipmaps: !1,
			internalFormat: null,
			minFilter: bc,
			depthBuffer: !0,
			stencilBuffer: !1,
			resolveDepthBuffer: !0,
			resolveStencilBuffer: !0,
			depthTexture: null,
			samples: 0,
			count: 1,
			depth: 1,
			multiview: !1,
			useArrayDepthTexture: !1
		}, n), this.isRenderTarget = !0, this.width = e, this.height = t, this.depth = n.depth, this.scissor = new Ju(0, 0, e, t), this.scissorTest = !1, this.viewport = new Ju(0, 0, e, t), this.textures = [];
		let r = new qu({
			width: e,
			height: t,
			depth: n.depth
		}), i = n.count;
		for (let e = 0; e < i; e++) this.textures[e] = r.clone(), this.textures[e].isRenderTargetTexture = !0, this.textures[e].renderTarget = this;
		this._setTextureOptions(n), this.depthBuffer = n.depthBuffer, this.stencilBuffer = n.stencilBuffer, this.resolveDepthBuffer = n.resolveDepthBuffer, this.resolveStencilBuffer = n.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = n.depthTexture, this.samples = n.samples, this.multiview = n.multiview, this.useArrayDepthTexture = n.useArrayDepthTexture;
	}
	_setTextureOptions(e = {}) {
		let t = {
			minFilter: bc,
			generateMipmaps: !1,
			flipY: !1,
			internalFormat: null
		};
		e.mapping !== void 0 && (t.mapping = e.mapping), e.wrapS !== void 0 && (t.wrapS = e.wrapS), e.wrapT !== void 0 && (t.wrapT = e.wrapT), e.wrapR !== void 0 && (t.wrapR = e.wrapR), e.magFilter !== void 0 && (t.magFilter = e.magFilter), e.minFilter !== void 0 && (t.minFilter = e.minFilter), e.format !== void 0 && (t.format = e.format), e.type !== void 0 && (t.type = e.type), e.anisotropy !== void 0 && (t.anisotropy = e.anisotropy), e.colorSpace !== void 0 && (t.colorSpace = e.colorSpace), e.flipY !== void 0 && (t.flipY = e.flipY), e.generateMipmaps !== void 0 && (t.generateMipmaps = e.generateMipmaps), e.internalFormat !== void 0 && (t.internalFormat = e.internalFormat);
		for (let e = 0; e < this.textures.length; e++) this.textures[e].setValues(t);
	}
	get texture() {
		return this.textures[0];
	}
	set texture(e) {
		this.textures[0] = e;
	}
	set depthTexture(e) {
		this._depthTexture !== null && (this._depthTexture.renderTarget = null), e !== null && (e.renderTarget = this), this._depthTexture = e;
	}
	get depthTexture() {
		return this._depthTexture;
	}
	setSize(e, t, n = 1) {
		if (this.width !== e || this.height !== t || this.depth !== n) {
			this.width = e, this.height = t, this.depth = n;
			for (let r = 0, i = this.textures.length; r < i; r++) this.textures[r].image.width = e, this.textures[r].image.height = t, this.textures[r].image.depth = n, this.textures[r].isData3DTexture !== !0 && (this.textures[r].isArrayTexture = this.textures[r].image.depth > 1);
			this.dispose();
		}
		this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.textures.length = 0;
		for (let t = 0, n = e.textures.length; t < n; t++) {
			this.textures[t] = e.textures[t].clone(), this.textures[t].isRenderTargetTexture = !0, this.textures[t].renderTarget = this;
			let n = Object.assign({}, e.textures[t].image);
			this.textures[t].source = new Uu(n);
		}
		return this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.resolveDepthBuffer = e.resolveDepthBuffer, this.resolveStencilBuffer = e.resolveStencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this.multiview = e.multiview, this.useArrayDepthTexture = e.useArrayDepthTexture, this;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
}, Xu = class extends Yu {
	constructor(e = 1, t = 1, n = {}) {
		super(e, t, n), this.isWebGLRenderTarget = !0;
	}
}, Zu = class extends qu {
	constructor(e = null, t = 1, n = 1, r = 1) {
		super(null), this.isDataArrayTexture = !0, this.image = {
			data: e,
			width: t,
			height: n,
			depth: r
		}, this.magFilter = _c, this.minFilter = _c, this.wrapR = hc, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = /* @__PURE__ */ new Set();
	}
	addLayerUpdate(e) {
		this.layerUpdates.add(e);
	}
	clearLayerUpdates() {
		this.layerUpdates.clear();
	}
}, Qu = class extends qu {
	constructor(e = null, t = 1, n = 1, r = 1) {
		super(null), this.isData3DTexture = !0, this.image = {
			data: e,
			width: t,
			height: n,
			depth: r
		}, this.magFilter = _c, this.minFilter = _c, this.wrapR = hc, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
	}
}, $u = class e {
	static {
		e.prototype.isMatrix4 = !0;
	}
	constructor(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h) {
		this.elements = [
			1,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			1
		], e !== void 0 && this.set(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h);
	}
	set(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h) {
		let g = this.elements;
		return g[0] = e, g[4] = t, g[8] = n, g[12] = r, g[1] = i, g[5] = a, g[9] = o, g[13] = s, g[2] = c, g[6] = l, g[10] = u, g[14] = d, g[3] = f, g[7] = p, g[11] = m, g[15] = h, this;
	}
	identity() {
		return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
	}
	clone() {
		return new e().fromArray(this.elements);
	}
	copy(e) {
		let t = this.elements, n = e.elements;
		return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], t[9] = n[9], t[10] = n[10], t[11] = n[11], t[12] = n[12], t[13] = n[13], t[14] = n[14], t[15] = n[15], this;
	}
	copyPosition(e) {
		let t = this.elements, n = e.elements;
		return t[12] = n[12], t[13] = n[13], t[14] = n[14], this;
	}
	setFromMatrix3(e) {
		let t = e.elements;
		return this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1), this;
	}
	extractBasis(e, t, n) {
		return this.determinantAffine() === 0 ? (e.set(1, 0, 0), t.set(0, 1, 0), n.set(0, 0, 1), this) : (e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this);
	}
	makeBasis(e, t, n) {
		return this.set(e.x, t.x, n.x, 0, e.y, t.y, n.y, 0, e.z, t.z, n.z, 0, 0, 0, 0, 1), this;
	}
	extractRotation(e) {
		if (e.determinantAffine() === 0) return this.identity();
		let t = this.elements, n = e.elements, r = 1 / ed.setFromMatrixColumn(e, 0).length(), i = 1 / ed.setFromMatrixColumn(e, 1).length(), a = 1 / ed.setFromMatrixColumn(e, 2).length();
		return t[0] = n[0] * r, t[1] = n[1] * r, t[2] = n[2] * r, t[3] = 0, t[4] = n[4] * i, t[5] = n[5] * i, t[6] = n[6] * i, t[7] = 0, t[8] = n[8] * a, t[9] = n[9] * a, t[10] = n[10] * a, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
	}
	makeRotationFromEuler(e) {
		let t = this.elements, n = e.x, r = e.y, i = e.z, a = Math.cos(n), o = Math.sin(n), s = Math.cos(r), c = Math.sin(r), l = Math.cos(i), u = Math.sin(i);
		if (e.order === "XYZ") {
			let e = a * l, n = a * u, r = o * l, i = o * u;
			t[0] = s * l, t[4] = -s * u, t[8] = c, t[1] = n + r * c, t[5] = e - i * c, t[9] = -o * s, t[2] = i - e * c, t[6] = r + n * c, t[10] = a * s;
		} else if (e.order === "YXZ") {
			let e = s * l, n = s * u, r = c * l, i = c * u;
			t[0] = e + i * o, t[4] = r * o - n, t[8] = a * c, t[1] = a * u, t[5] = a * l, t[9] = -o, t[2] = n * o - r, t[6] = i + e * o, t[10] = a * s;
		} else if (e.order === "ZXY") {
			let e = s * l, n = s * u, r = c * l, i = c * u;
			t[0] = e - i * o, t[4] = -a * u, t[8] = r + n * o, t[1] = n + r * o, t[5] = a * l, t[9] = i - e * o, t[2] = -a * c, t[6] = o, t[10] = a * s;
		} else if (e.order === "ZYX") {
			let e = a * l, n = a * u, r = o * l, i = o * u;
			t[0] = s * l, t[4] = r * c - n, t[8] = e * c + i, t[1] = s * u, t[5] = i * c + e, t[9] = n * c - r, t[2] = -c, t[6] = o * s, t[10] = a * s;
		} else if (e.order === "YZX") {
			let e = a * s, n = a * c, r = o * s, i = o * c;
			t[0] = s * l, t[4] = i - e * u, t[8] = r * u + n, t[1] = u, t[5] = a * l, t[9] = -o * l, t[2] = -c * l, t[6] = n * u + r, t[10] = e - i * u;
		} else if (e.order === "XZY") {
			let e = a * s, n = a * c, r = o * s, i = o * c;
			t[0] = s * l, t[4] = -u, t[8] = c * l, t[1] = e * u + i, t[5] = a * l, t[9] = n * u - r, t[2] = r * u - n, t[6] = o * l, t[10] = i * u + e;
		}
		return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
	}
	makeRotationFromQuaternion(e) {
		return this.compose(nd, e, rd);
	}
	lookAt(e, t, n) {
		let r = this.elements;
		return od.subVectors(e, t), od.lengthSq() === 0 && (od.z = 1), od.normalize(), id.crossVectors(n, od), id.lengthSq() === 0 && (Math.abs(n.z) === 1 ? od.x += 1e-4 : od.z += 1e-4, od.normalize(), id.crossVectors(n, od)), id.normalize(), ad.crossVectors(od, id), r[0] = id.x, r[4] = ad.x, r[8] = od.x, r[1] = id.y, r[5] = ad.y, r[9] = od.y, r[2] = id.z, r[6] = ad.z, r[10] = od.z, this;
	}
	multiply(e) {
		return this.multiplyMatrices(this, e);
	}
	premultiply(e) {
		return this.multiplyMatrices(e, this);
	}
	multiplyMatrices(e, t) {
		let n = e.elements, r = t.elements, i = this.elements, a = n[0], o = n[4], s = n[8], c = n[12], l = n[1], u = n[5], d = n[9], f = n[13], p = n[2], m = n[6], h = n[10], g = n[14], _ = n[3], v = n[7], y = n[11], b = n[15], x = r[0], S = r[4], C = r[8], w = r[12], T = r[1], E = r[5], D = r[9], O = r[13], k = r[2], A = r[6], j = r[10], M = r[14], N = r[3], P = r[7], F = r[11], I = r[15];
		return i[0] = a * x + o * T + s * k + c * N, i[4] = a * S + o * E + s * A + c * P, i[8] = a * C + o * D + s * j + c * F, i[12] = a * w + o * O + s * M + c * I, i[1] = l * x + u * T + d * k + f * N, i[5] = l * S + u * E + d * A + f * P, i[9] = l * C + u * D + d * j + f * F, i[13] = l * w + u * O + d * M + f * I, i[2] = p * x + m * T + h * k + g * N, i[6] = p * S + m * E + h * A + g * P, i[10] = p * C + m * D + h * j + g * F, i[14] = p * w + m * O + h * M + g * I, i[3] = _ * x + v * T + y * k + b * N, i[7] = _ * S + v * E + y * A + b * P, i[11] = _ * C + v * D + y * j + b * F, i[15] = _ * w + v * O + y * M + b * I, this;
	}
	multiplyScalar(e) {
		let t = this.elements;
		return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
	}
	determinant() {
		let e = this.elements, t = e[0], n = e[4], r = e[8], i = e[12], a = e[1], o = e[5], s = e[9], c = e[13], l = e[2], u = e[6], d = e[10], f = e[14], p = e[3], m = e[7], h = e[11], g = e[15], _ = s * f - c * d, v = o * f - c * u, y = o * d - s * u, b = a * f - c * l, x = a * d - s * l, S = a * u - o * l;
		return t * (m * _ - h * v + g * y) - n * (p * _ - h * b + g * x) + r * (p * v - m * b + g * S) - i * (p * y - m * x + h * S);
	}
	determinantAffine() {
		let e = this.elements, t = e[0], n = e[4], r = e[8], i = e[1], a = e[5], o = e[9], s = e[2], c = e[6], l = e[10];
		return t * (a * l - o * c) - n * (i * l - o * s) + r * (i * c - a * s);
	}
	transpose() {
		let e = this.elements, t;
		return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
	}
	setPosition(e, t, n) {
		let r = this.elements;
		return e.isVector3 ? (r[12] = e.x, r[13] = e.y, r[14] = e.z) : (r[12] = e, r[13] = t, r[14] = n), this;
	}
	invert() {
		let e = this.elements, t = e[0], n = e[1], r = e[2], i = e[3], a = e[4], o = e[5], s = e[6], c = e[7], l = e[8], u = e[9], d = e[10], f = e[11], p = e[12], m = e[13], h = e[14], g = e[15], _ = t * o - n * a, v = t * s - r * a, y = t * c - i * a, b = n * s - r * o, x = n * c - i * o, S = r * c - i * s, C = l * m - u * p, w = l * h - d * p, T = l * g - f * p, E = u * h - d * m, D = u * g - f * m, O = d * g - f * h, k = _ * O - v * D + y * E + b * T - x * w + S * C;
		if (k === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
		let A = 1 / k;
		return e[0] = (o * O - s * D + c * E) * A, e[1] = (r * D - n * O - i * E) * A, e[2] = (m * S - h * x + g * b) * A, e[3] = (d * x - u * S - f * b) * A, e[4] = (s * T - a * O - c * w) * A, e[5] = (t * O - r * T + i * w) * A, e[6] = (h * y - p * S - g * v) * A, e[7] = (l * S - d * y + f * v) * A, e[8] = (a * D - o * T + c * C) * A, e[9] = (n * T - t * D - i * C) * A, e[10] = (p * x - m * y + g * _) * A, e[11] = (u * y - l * x - f * _) * A, e[12] = (o * w - a * E - s * C) * A, e[13] = (t * E - n * w + r * C) * A, e[14] = (m * v - p * b - h * _) * A, e[15] = (l * b - u * v + d * _) * A, this;
	}
	scale(e) {
		let t = this.elements, n = e.x, r = e.y, i = e.z;
		return t[0] *= n, t[4] *= r, t[8] *= i, t[1] *= n, t[5] *= r, t[9] *= i, t[2] *= n, t[6] *= r, t[10] *= i, t[3] *= n, t[7] *= r, t[11] *= i, this;
	}
	getMaxScaleOnAxis() {
		let e = this.elements, t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], n = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], r = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
		return Math.sqrt(Math.max(t, n, r));
	}
	makeTranslation(e, t, n) {
		return e.isVector3 ? this.set(1, 0, 0, e.x, 0, 1, 0, e.y, 0, 0, 1, e.z, 0, 0, 0, 1) : this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1), this;
	}
	makeRotationX(e) {
		let t = Math.cos(e), n = Math.sin(e);
		return this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1), this;
	}
	makeRotationY(e) {
		let t = Math.cos(e), n = Math.sin(e);
		return this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1), this;
	}
	makeRotationZ(e) {
		let t = Math.cos(e), n = Math.sin(e);
		return this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
	}
	makeRotationAxis(e, t) {
		let n = Math.cos(t), r = Math.sin(t), i = 1 - n, a = e.x, o = e.y, s = e.z, c = i * a, l = i * o;
		return this.set(c * a + n, c * o - r * s, c * s + r * o, 0, c * o + r * s, l * o + n, l * s - r * a, 0, c * s - r * o, l * s + r * a, i * s * s + n, 0, 0, 0, 0, 1), this;
	}
	makeScale(e, t, n) {
		return this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
	}
	makeShear(e, t, n, r, i, a) {
		return this.set(1, n, i, 0, e, 1, a, 0, t, r, 1, 0, 0, 0, 0, 1), this;
	}
	compose(e, t, n) {
		let r = this.elements, i = t._x, a = t._y, o = t._z, s = t._w, c = i + i, l = a + a, u = o + o, d = i * c, f = i * l, p = i * u, m = a * l, h = a * u, g = o * u, _ = s * c, v = s * l, y = s * u, b = n.x, x = n.y, S = n.z;
		return r[0] = (1 - (m + g)) * b, r[1] = (f + y) * b, r[2] = (p - v) * b, r[3] = 0, r[4] = (f - y) * x, r[5] = (1 - (d + g)) * x, r[6] = (h + _) * x, r[7] = 0, r[8] = (p + v) * S, r[9] = (h - _) * S, r[10] = (1 - (d + m)) * S, r[11] = 0, r[12] = e.x, r[13] = e.y, r[14] = e.z, r[15] = 1, this;
	}
	decompose(e, t, n) {
		let r = this.elements;
		e.x = r[12], e.y = r[13], e.z = r[14];
		let i = this.determinantAffine();
		if (i === 0) return n.set(1, 1, 1), t.identity(), this;
		let a = ed.set(r[0], r[1], r[2]).length(), o = ed.set(r[4], r[5], r[6]).length(), s = ed.set(r[8], r[9], r[10]).length();
		i < 0 && (a = -a), td.copy(this);
		let c = 1 / a, l = 1 / o, u = 1 / s;
		return td.elements[0] *= c, td.elements[1] *= c, td.elements[2] *= c, td.elements[4] *= l, td.elements[5] *= l, td.elements[6] *= l, td.elements[8] *= u, td.elements[9] *= u, td.elements[10] *= u, t.setFromRotationMatrix(td), n.x = a, n.y = o, n.z = s, this;
	}
	makePerspective(e, t, n, r, i, a, o = Hl, s = !1) {
		let c = this.elements, l = 2 * i / (t - e), u = 2 * i / (n - r), d = (t + e) / (t - e), f = (n + r) / (n - r), p, m;
		if (s) p = i / (a - i), m = a * i / (a - i);
		else if (o === 2e3) p = -(a + i) / (a - i), m = -2 * a * i / (a - i);
		else if (o === 2001) p = -a / (a - i), m = -a * i / (a - i);
		else throw Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + o);
		return c[0] = l, c[4] = 0, c[8] = d, c[12] = 0, c[1] = 0, c[5] = u, c[9] = f, c[13] = 0, c[2] = 0, c[6] = 0, c[10] = p, c[14] = m, c[3] = 0, c[7] = 0, c[11] = -1, c[15] = 0, this;
	}
	makeOrthographic(e, t, n, r, i, a, o = Hl, s = !1) {
		let c = this.elements, l = 2 / (t - e), u = 2 / (n - r), d = -(t + e) / (t - e), f = -(n + r) / (n - r), p, m;
		if (s) p = 1 / (a - i), m = a / (a - i);
		else if (o === 2e3) p = -2 / (a - i), m = -(a + i) / (a - i);
		else if (o === 2001) p = -1 / (a - i), m = -i / (a - i);
		else throw Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + o);
		return c[0] = l, c[4] = 0, c[8] = 0, c[12] = d, c[1] = 0, c[5] = u, c[9] = 0, c[13] = f, c[2] = 0, c[6] = 0, c[10] = p, c[14] = m, c[3] = 0, c[7] = 0, c[11] = 0, c[15] = 1, this;
	}
	equals(e) {
		let t = this.elements, n = e.elements;
		for (let e = 0; e < 16; e++) if (t[e] !== n[e]) return !1;
		return !0;
	}
	fromArray(e, t = 0) {
		for (let n = 0; n < 16; n++) this.elements[n] = e[n + t];
		return this;
	}
	toArray(e = [], t = 0) {
		let n = this.elements;
		return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e[t + 9] = n[9], e[t + 10] = n[10], e[t + 11] = n[11], e[t + 12] = n[12], e[t + 13] = n[13], e[t + 14] = n[14], e[t + 15] = n[15], e;
	}
}, ed = /* @__PURE__ */ new X(), td = /* @__PURE__ */ new $u(), nd = /* @__PURE__ */ new X(0, 0, 0), rd = /* @__PURE__ */ new X(1, 1, 1), id = /* @__PURE__ */ new X(), ad = /* @__PURE__ */ new X(), od = /* @__PURE__ */ new X(), sd = /* @__PURE__ */ new $u(), cd = /* @__PURE__ */ new ku(), ld = class e {
	constructor(t = 0, n = 0, r = 0, i = e.DEFAULT_ORDER) {
		this.isEuler = !0, this._x = t, this._y = n, this._z = r, this._order = i;
	}
	get x() {
		return this._x;
	}
	set x(e) {
		this._x = e, this._onChangeCallback();
	}
	get y() {
		return this._y;
	}
	set y(e) {
		this._y = e, this._onChangeCallback();
	}
	get z() {
		return this._z;
	}
	set z(e) {
		this._z = e, this._onChangeCallback();
	}
	get order() {
		return this._order;
	}
	set order(e) {
		this._order = e, this._onChangeCallback();
	}
	set(e, t, n, r = this._order) {
		return this._x = e, this._y = t, this._z = n, this._order = r, this._onChangeCallback(), this;
	}
	clone() {
		return new this.constructor(this._x, this._y, this._z, this._order);
	}
	copy(e) {
		return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
	}
	setFromRotationMatrix(e, t = this._order, n = !0) {
		let r = e.elements, i = r[0], a = r[4], o = r[8], s = r[1], c = r[5], l = r[9], u = r[2], d = r[6], f = r[10];
		switch (t) {
			case "XYZ":
				this._y = Math.asin(Y(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-l, f), this._z = Math.atan2(-a, i)) : (this._x = Math.atan2(d, c), this._z = 0);
				break;
			case "YXZ":
				this._x = Math.asin(-Y(l, -1, 1)), Math.abs(l) < .9999999 ? (this._y = Math.atan2(o, f), this._z = Math.atan2(s, c)) : (this._y = Math.atan2(-u, i), this._z = 0);
				break;
			case "ZXY":
				this._x = Math.asin(Y(d, -1, 1)), Math.abs(d) < .9999999 ? (this._y = Math.atan2(-u, f), this._z = Math.atan2(-a, c)) : (this._y = 0, this._z = Math.atan2(s, i));
				break;
			case "ZYX":
				this._y = Math.asin(-Y(u, -1, 1)), Math.abs(u) < .9999999 ? (this._x = Math.atan2(d, f), this._z = Math.atan2(s, i)) : (this._x = 0, this._z = Math.atan2(-a, c));
				break;
			case "YZX":
				this._z = Math.asin(Y(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(-l, c), this._y = Math.atan2(-u, i)) : (this._x = 0, this._y = Math.atan2(o, f));
				break;
			case "XZY":
				this._z = Math.asin(-Y(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(d, c), this._y = Math.atan2(o, i)) : (this._x = Math.atan2(-l, f), this._y = 0);
				break;
			default: Zl("Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
		}
		return this._order = t, n === !0 && this._onChangeCallback(), this;
	}
	setFromQuaternion(e, t, n) {
		return sd.makeRotationFromQuaternion(e), this.setFromRotationMatrix(sd, t, n);
	}
	setFromVector3(e, t = this._order) {
		return this.set(e.x, e.y, e.z, t);
	}
	reorder(e) {
		return cd.setFromEuler(this), this.setFromQuaternion(cd, e);
	}
	equals(e) {
		return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
	}
	fromArray(e) {
		return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
	}
	_onChange(e) {
		return this._onChangeCallback = e, this;
	}
	_onChangeCallback() {}
	*[Symbol.iterator]() {
		yield this._x, yield this._y, yield this._z, yield this._order;
	}
};
ld.DEFAULT_ORDER = "XYZ";
var ud = class {
	constructor() {
		this.mask = 1;
	}
	set(e) {
		this.mask = (1 << e | 0) >>> 0;
	}
	enable(e) {
		this.mask |= 1 << e | 0;
	}
	enableAll() {
		this.mask = -1;
	}
	toggle(e) {
		this.mask ^= 1 << e | 0;
	}
	disable(e) {
		this.mask &= ~(1 << e | 0);
	}
	disableAll() {
		this.mask = 0;
	}
	test(e) {
		return (this.mask & e.mask) !== 0;
	}
	isEnabled(e) {
		return (this.mask & (1 << e | 0)) != 0;
	}
}, dd = 0, fd = /* @__PURE__ */ new X(), pd = /* @__PURE__ */ new ku(), md = /* @__PURE__ */ new $u(), hd = /* @__PURE__ */ new X(), gd = /* @__PURE__ */ new X(), _d = /* @__PURE__ */ new X(), vd = /* @__PURE__ */ new ku(), yd = /* @__PURE__ */ new X(1, 0, 0), bd = /* @__PURE__ */ new X(0, 1, 0), xd = /* @__PURE__ */ new X(0, 0, 1), Sd = { type: "added" }, Cd = { type: "removed" }, wd = {
	type: "childadded",
	child: null
}, Td = {
	type: "childremoved",
	child: null
}, Ed = class e extends tu {
	constructor() {
		super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: dd++ }), this.uuid = ou(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = e.DEFAULT_UP.clone();
		let t = new X(), n = new ld(), r = new ku(), i = new X(1, 1, 1);
		function a() {
			r.setFromEuler(n, !1);
		}
		function o() {
			n.setFromQuaternion(r, void 0, !1);
		}
		n._onChange(a), r._onChange(o), Object.defineProperties(this, {
			position: {
				configurable: !0,
				enumerable: !0,
				value: t
			},
			rotation: {
				configurable: !0,
				enumerable: !0,
				value: n
			},
			quaternion: {
				configurable: !0,
				enumerable: !0,
				value: r
			},
			scale: {
				configurable: !0,
				enumerable: !0,
				value: i
			},
			modelViewMatrix: { value: new $u() },
			normalMatrix: { value: new Mu() }
		}), this.matrix = new $u(), this.matrixWorld = new $u(), this.matrixAutoUpdate = e.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = e.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new ud(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.static = !1, this.userData = {}, this.pivot = null;
	}
	onBeforeShadow() {}
	onAfterShadow() {}
	onBeforeRender() {}
	onAfterRender() {}
	applyMatrix4(e) {
		this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
	}
	applyQuaternion(e) {
		return this.quaternion.premultiply(e), this;
	}
	setRotationFromAxisAngle(e, t) {
		this.quaternion.setFromAxisAngle(e, t);
	}
	setRotationFromEuler(e) {
		this.quaternion.setFromEuler(e, !0);
	}
	setRotationFromMatrix(e) {
		this.quaternion.setFromRotationMatrix(e);
	}
	setRotationFromQuaternion(e) {
		this.quaternion.copy(e);
	}
	rotateOnAxis(e, t) {
		return pd.setFromAxisAngle(e, t), this.quaternion.multiply(pd), this;
	}
	rotateOnWorldAxis(e, t) {
		return pd.setFromAxisAngle(e, t), this.quaternion.premultiply(pd), this;
	}
	rotateX(e) {
		return this.rotateOnAxis(yd, e);
	}
	rotateY(e) {
		return this.rotateOnAxis(bd, e);
	}
	rotateZ(e) {
		return this.rotateOnAxis(xd, e);
	}
	translateOnAxis(e, t) {
		return fd.copy(e).applyQuaternion(this.quaternion), this.position.add(fd.multiplyScalar(t)), this;
	}
	translateX(e) {
		return this.translateOnAxis(yd, e);
	}
	translateY(e) {
		return this.translateOnAxis(bd, e);
	}
	translateZ(e) {
		return this.translateOnAxis(xd, e);
	}
	localToWorld(e) {
		return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
	}
	worldToLocal(e) {
		return this.updateWorldMatrix(!0, !1), e.applyMatrix4(md.copy(this.matrixWorld).invert());
	}
	lookAt(e, t, n) {
		e.isVector3 ? hd.copy(e) : hd.set(e, t, n);
		let r = this.parent;
		this.updateWorldMatrix(!0, !1), gd.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? md.lookAt(gd, hd, this.up) : md.lookAt(hd, gd, this.up), this.quaternion.setFromRotationMatrix(md), r && (md.extractRotation(r.matrixWorld), pd.setFromRotationMatrix(md), this.quaternion.premultiply(pd.invert()));
	}
	add(e) {
		if (arguments.length > 1) {
			for (let e = 0; e < arguments.length; e++) this.add(arguments[e]);
			return this;
		}
		return e === this ? (J("Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.removeFromParent(), e.parent = this, this.children.push(e), e.dispatchEvent(Sd), wd.child = e, this.dispatchEvent(wd), wd.child = null) : J("Object3D.add: object not an instance of THREE.Object3D.", e), this);
	}
	remove(e) {
		if (arguments.length > 1) {
			for (let e = 0; e < arguments.length; e++) this.remove(arguments[e]);
			return this;
		}
		let t = this.children.indexOf(e);
		return t !== -1 && (e.parent = null, this.children.splice(t, 1), e.dispatchEvent(Cd), Td.child = e, this.dispatchEvent(Td), Td.child = null), this;
	}
	removeFromParent() {
		let e = this.parent;
		return e !== null && e.remove(this), this;
	}
	clear() {
		return this.remove(...this.children);
	}
	attach(e) {
		return this.updateWorldMatrix(!0, !1), md.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), md.multiply(e.parent.matrixWorld)), e.applyMatrix4(md), e.removeFromParent(), e.parent = this, this.children.push(e), e.updateWorldMatrix(!1, !0), e.dispatchEvent(Sd), wd.child = e, this.dispatchEvent(wd), wd.child = null, this;
	}
	getObjectById(e) {
		return this.getObjectByProperty("id", e);
	}
	getObjectByName(e) {
		return this.getObjectByProperty("name", e);
	}
	getObjectByProperty(e, t) {
		if (this[e] === t) return this;
		for (let n = 0, r = this.children.length; n < r; n++) {
			let r = this.children[n].getObjectByProperty(e, t);
			if (r !== void 0) return r;
		}
	}
	getObjectsByProperty(e, t, n = []) {
		this[e] === t && n.push(this);
		let r = this.children;
		for (let i = 0, a = r.length; i < a; i++) r[i].getObjectsByProperty(e, t, n);
		return n;
	}
	getWorldPosition(e) {
		return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
	}
	getWorldQuaternion(e) {
		return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(gd, e, _d), e;
	}
	getWorldScale(e) {
		return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(gd, vd, e), e;
	}
	getWorldDirection(e) {
		this.updateWorldMatrix(!0, !1);
		let t = this.matrixWorld.elements;
		return e.set(t[8], t[9], t[10]).normalize();
	}
	raycast() {}
	traverse(e) {
		e(this);
		let t = this.children;
		for (let n = 0, r = t.length; n < r; n++) t[n].traverse(e);
	}
	traverseVisible(e) {
		if (this.visible === !1) return;
		e(this);
		let t = this.children;
		for (let n = 0, r = t.length; n < r; n++) t[n].traverseVisible(e);
	}
	traverseAncestors(e) {
		let t = this.parent;
		t !== null && (e(t), t.traverseAncestors(e));
	}
	updateMatrix() {
		this.matrix.compose(this.position, this.quaternion, this.scale);
		let e = this.pivot;
		if (e !== null) {
			let t = e.x, n = e.y, r = e.z, i = this.matrix.elements;
			i[12] += t - i[0] * t - i[4] * n - i[8] * r, i[13] += n - i[1] * t - i[5] * n - i[9] * r, i[14] += r - i[2] * t - i[6] * n - i[10] * r;
		}
		this.matrixWorldNeedsUpdate = !0;
	}
	updateMatrixWorld(e) {
		this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, e = !0);
		let t = this.children;
		for (let n = 0, r = t.length; n < r; n++) t[n].updateMatrixWorld(e);
	}
	updateWorldMatrix(e, t, n = !1) {
		let r = this.parent;
		if (e === !0 && r !== null && r.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || n) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, n = !0), t === !0) {
			let e = this.children;
			for (let t = 0, r = e.length; t < r; t++) e[t].updateWorldMatrix(!1, !0, n);
		}
	}
	toJSON(e) {
		let t = e === void 0 || typeof e == "string", n = {};
		t && (e = {
			geometries: {},
			materials: {},
			textures: {},
			images: {},
			shapes: {},
			skeletons: {},
			animations: {},
			nodes: {}
		}, n.metadata = {
			version: 4.7,
			type: "Object",
			generator: "Object3D.toJSON"
		});
		let r = {};
		r.uuid = this.uuid, r.type = this.type, this.name !== "" && (r.name = this.name), this.castShadow === !0 && (r.castShadow = !0), this.receiveShadow === !0 && (r.receiveShadow = !0), this.visible === !1 && (r.visible = !1), this.frustumCulled === !1 && (r.frustumCulled = !1), this.renderOrder !== 0 && (r.renderOrder = this.renderOrder), this.static !== !1 && (r.static = this.static), Object.keys(this.userData).length > 0 && (r.userData = this.userData), r.layers = this.layers.mask, r.matrix = this.matrix.toArray(), r.up = this.up.toArray(), this.pivot !== null && (r.pivot = this.pivot.toArray()), this.matrixAutoUpdate === !1 && (r.matrixAutoUpdate = !1), this.morphTargetDictionary !== void 0 && (r.morphTargetDictionary = Object.assign({}, this.morphTargetDictionary)), this.morphTargetInfluences !== void 0 && (r.morphTargetInfluences = this.morphTargetInfluences.slice()), this.isInstancedMesh && (r.type = "InstancedMesh", r.count = this.count, r.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (r.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (r.type = "BatchedMesh", r.perObjectFrustumCulled = this.perObjectFrustumCulled, r.sortObjects = this.sortObjects, r.drawRanges = this._drawRanges, r.reservedRanges = this._reservedRanges, r.geometryInfo = this._geometryInfo.map((e) => ({
			...e,
			boundingBox: e.boundingBox ? e.boundingBox.toJSON() : void 0,
			boundingSphere: e.boundingSphere ? e.boundingSphere.toJSON() : void 0
		})), r.instanceInfo = this._instanceInfo.map((e) => ({ ...e })), r.availableInstanceIds = this._availableInstanceIds.slice(), r.availableGeometryIds = this._availableGeometryIds.slice(), r.nextIndexStart = this._nextIndexStart, r.nextVertexStart = this._nextVertexStart, r.geometryCount = this._geometryCount, r.maxInstanceCount = this._maxInstanceCount, r.maxVertexCount = this._maxVertexCount, r.maxIndexCount = this._maxIndexCount, r.geometryInitialized = this._geometryInitialized, r.matricesTexture = this._matricesTexture.toJSON(e), r.indirectTexture = this._indirectTexture.toJSON(e), this._colorsTexture !== null && (r.colorsTexture = this._colorsTexture.toJSON(e)), this.boundingSphere !== null && (r.boundingSphere = this.boundingSphere.toJSON()), this.boundingBox !== null && (r.boundingBox = this.boundingBox.toJSON()));
		function i(t, n) {
			return t[n.uuid] === void 0 && (t[n.uuid] = n.toJSON(e)), n.uuid;
		}
		if (this.isScene) this.background && (this.background.isColor ? r.background = this.background.toJSON() : this.background.isTexture && (r.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (r.environment = this.environment.toJSON(e).uuid);
		else if (this.isMesh || this.isLine || this.isPoints) {
			r.geometry = i(e.geometries, this.geometry);
			let t = this.geometry.parameters;
			if (t !== void 0 && t.shapes !== void 0) {
				let n = t.shapes;
				if (Array.isArray(n)) for (let t = 0, r = n.length; t < r; t++) {
					let r = n[t];
					i(e.shapes, r);
				}
				else i(e.shapes, n);
			}
		}
		if (this.isSkinnedMesh && (r.bindMode = this.bindMode, r.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (i(e.skeletons, this.skeleton), r.skeleton = this.skeleton.uuid)), this.material !== void 0) if (Array.isArray(this.material)) {
			let t = [];
			for (let n = 0, r = this.material.length; n < r; n++) t.push(i(e.materials, this.material[n]));
			r.material = t;
		} else r.material = i(e.materials, this.material);
		if (this.children.length > 0) {
			r.children = [];
			for (let t = 0; t < this.children.length; t++) r.children.push(this.children[t].toJSON(e).object);
		}
		if (this.animations.length > 0) {
			r.animations = [];
			for (let t = 0; t < this.animations.length; t++) {
				let n = this.animations[t];
				r.animations.push(i(e.animations, n));
			}
		}
		if (t) {
			let t = a(e.geometries), r = a(e.materials), i = a(e.textures), o = a(e.images), s = a(e.shapes), c = a(e.skeletons), l = a(e.animations), u = a(e.nodes);
			t.length > 0 && (n.geometries = t), r.length > 0 && (n.materials = r), i.length > 0 && (n.textures = i), o.length > 0 && (n.images = o), s.length > 0 && (n.shapes = s), c.length > 0 && (n.skeletons = c), l.length > 0 && (n.animations = l), u.length > 0 && (n.nodes = u);
		}
		return n.object = r, n;
		function a(e) {
			let t = [];
			for (let n in e) {
				let r = e[n];
				delete r.metadata, t.push(r);
			}
			return t;
		}
	}
	clone(e) {
		return new this.constructor().copy(this, e);
	}
	copy(e, t = !0) {
		if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.pivot = e.pivot === null ? null : e.pivot.clone(), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.static = e.static, this.animations = e.animations.slice(), this.userData = JSON.parse(JSON.stringify(e.userData)), t === !0) for (let t = 0; t < e.children.length; t++) {
			let n = e.children[t];
			this.add(n.clone());
		}
		return this;
	}
};
Ed.DEFAULT_UP = /* @__PURE__ */ new X(0, 1, 0), Ed.DEFAULT_MATRIX_AUTO_UPDATE = !0, Ed.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
var Dd = class extends Ed {
	constructor() {
		super(), this.isGroup = !0, this.type = "Group";
	}
}, Od = { type: "move" }, kd = class {
	constructor() {
		this._targetRay = null, this._grip = null, this._hand = null;
	}
	getHandSpace() {
		return this._hand === null && (this._hand = new Dd(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = { pinching: !1 }), this._hand;
	}
	getTargetRaySpace() {
		return this._targetRay === null && (this._targetRay = new Dd(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new X(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new X()), this._targetRay;
	}
	getGripSpace() {
		return this._grip === null && (this._grip = new Dd(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new X(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new X(), this._grip.eventsEnabled = !1), this._grip;
	}
	dispatchEvent(e) {
		return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
	}
	connect(e) {
		if (e && e.hand) {
			let t = this._hand;
			if (t) for (let n of e.hand.values()) this._getHandJoint(t, n);
		}
		return this.dispatchEvent({
			type: "connected",
			data: e
		}), this;
	}
	disconnect(e) {
		return this.dispatchEvent({
			type: "disconnected",
			data: e
		}), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
	}
	update(e, t, n) {
		let r = null, i = null, a = null, o = this._targetRay, s = this._grip, c = this._hand;
		if (e && t.session.visibilityState !== "visible-blurred") {
			if (c && e.hand) {
				a = !0;
				for (let r of e.hand.values()) {
					let e = t.getJointPose(r, n), i = this._getHandJoint(c, r);
					e !== null && (i.matrix.fromArray(e.transform.matrix), i.matrix.decompose(i.position, i.rotation, i.scale), i.matrixWorldNeedsUpdate = !0, i.jointRadius = e.radius), i.visible = e !== null;
				}
				let r = c.joints["index-finger-tip"], i = c.joints["thumb-tip"], o = r.position.distanceTo(i.position), s = .02, l = .005;
				c.inputState.pinching && o > s + l ? (c.inputState.pinching = !1, this.dispatchEvent({
					type: "pinchend",
					handedness: e.handedness,
					target: this
				})) : !c.inputState.pinching && o <= s - l && (c.inputState.pinching = !0, this.dispatchEvent({
					type: "pinchstart",
					handedness: e.handedness,
					target: this
				}));
			} else s !== null && e.gripSpace && (i = t.getPose(e.gripSpace, n), i !== null && (s.matrix.fromArray(i.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), s.matrixWorldNeedsUpdate = !0, i.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(i.linearVelocity)) : s.hasLinearVelocity = !1, i.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(i.angularVelocity)) : s.hasAngularVelocity = !1, s.eventsEnabled && s.dispatchEvent({
				type: "gripUpdated",
				data: e,
				target: this
			})));
			o !== null && (r = t.getPose(e.targetRaySpace, n), r === null && i !== null && (r = i), r !== null && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1, this.dispatchEvent(Od)));
		}
		return o !== null && (o.visible = r !== null), s !== null && (s.visible = i !== null), c !== null && (c.visible = a !== null), this;
	}
	_getHandJoint(e, t) {
		if (e.joints[t.jointName] === void 0) {
			let n = new Dd();
			n.matrixAutoUpdate = !1, n.visible = !1, e.joints[t.jointName] = n, e.add(n);
		}
		return e.joints[t.jointName];
	}
}, Ad = {
	aliceblue: 15792383,
	antiquewhite: 16444375,
	aqua: 65535,
	aquamarine: 8388564,
	azure: 15794175,
	beige: 16119260,
	bisque: 16770244,
	black: 0,
	blanchedalmond: 16772045,
	blue: 255,
	blueviolet: 9055202,
	brown: 10824234,
	burlywood: 14596231,
	cadetblue: 6266528,
	chartreuse: 8388352,
	chocolate: 13789470,
	coral: 16744272,
	cornflowerblue: 6591981,
	cornsilk: 16775388,
	crimson: 14423100,
	cyan: 65535,
	darkblue: 139,
	darkcyan: 35723,
	darkgoldenrod: 12092939,
	darkgray: 11119017,
	darkgreen: 25600,
	darkgrey: 11119017,
	darkkhaki: 12433259,
	darkmagenta: 9109643,
	darkolivegreen: 5597999,
	darkorange: 16747520,
	darkorchid: 10040012,
	darkred: 9109504,
	darksalmon: 15308410,
	darkseagreen: 9419919,
	darkslateblue: 4734347,
	darkslategray: 3100495,
	darkslategrey: 3100495,
	darkturquoise: 52945,
	darkviolet: 9699539,
	deeppink: 16716947,
	deepskyblue: 49151,
	dimgray: 6908265,
	dimgrey: 6908265,
	dodgerblue: 2003199,
	firebrick: 11674146,
	floralwhite: 16775920,
	forestgreen: 2263842,
	fuchsia: 16711935,
	gainsboro: 14474460,
	ghostwhite: 16316671,
	gold: 16766720,
	goldenrod: 14329120,
	gray: 8421504,
	green: 32768,
	greenyellow: 11403055,
	grey: 8421504,
	honeydew: 15794160,
	hotpink: 16738740,
	indianred: 13458524,
	indigo: 4915330,
	ivory: 16777200,
	khaki: 15787660,
	lavender: 15132410,
	lavenderblush: 16773365,
	lawngreen: 8190976,
	lemonchiffon: 16775885,
	lightblue: 11393254,
	lightcoral: 15761536,
	lightcyan: 14745599,
	lightgoldenrodyellow: 16448210,
	lightgray: 13882323,
	lightgreen: 9498256,
	lightgrey: 13882323,
	lightpink: 16758465,
	lightsalmon: 16752762,
	lightseagreen: 2142890,
	lightskyblue: 8900346,
	lightslategray: 7833753,
	lightslategrey: 7833753,
	lightsteelblue: 11584734,
	lightyellow: 16777184,
	lime: 65280,
	limegreen: 3329330,
	linen: 16445670,
	magenta: 16711935,
	maroon: 8388608,
	mediumaquamarine: 6737322,
	mediumblue: 205,
	mediumorchid: 12211667,
	mediumpurple: 9662683,
	mediumseagreen: 3978097,
	mediumslateblue: 8087790,
	mediumspringgreen: 64154,
	mediumturquoise: 4772300,
	mediumvioletred: 13047173,
	midnightblue: 1644912,
	mintcream: 16121850,
	mistyrose: 16770273,
	moccasin: 16770229,
	navajowhite: 16768685,
	navy: 128,
	oldlace: 16643558,
	olive: 8421376,
	olivedrab: 7048739,
	orange: 16753920,
	orangered: 16729344,
	orchid: 14315734,
	palegoldenrod: 15657130,
	palegreen: 10025880,
	paleturquoise: 11529966,
	palevioletred: 14381203,
	papayawhip: 16773077,
	peachpuff: 16767673,
	peru: 13468991,
	pink: 16761035,
	plum: 14524637,
	powderblue: 11591910,
	purple: 8388736,
	rebeccapurple: 6697881,
	red: 16711680,
	rosybrown: 12357519,
	royalblue: 4286945,
	saddlebrown: 9127187,
	salmon: 16416882,
	sandybrown: 16032864,
	seagreen: 3050327,
	seashell: 16774638,
	sienna: 10506797,
	silver: 12632256,
	skyblue: 8900331,
	slateblue: 6970061,
	slategray: 7372944,
	slategrey: 7372944,
	snow: 16775930,
	springgreen: 65407,
	steelblue: 4620980,
	tan: 13808780,
	teal: 32896,
	thistle: 14204888,
	tomato: 16737095,
	turquoise: 4251856,
	violet: 15631086,
	wheat: 16113331,
	white: 16777215,
	whitesmoke: 16119285,
	yellow: 16776960,
	yellowgreen: 10145074
}, jd = {
	h: 0,
	s: 0,
	l: 0
}, Md = {
	h: 0,
	s: 0,
	l: 0
};
function Nd(e, t, n) {
	return n < 0 && (n += 1), n > 1 && --n, n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * 6 * (2 / 3 - n) : e;
}
var Pd = class {
	constructor(e, t, n) {
		return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, t, n);
	}
	set(e, t, n) {
		if (t === void 0 && n === void 0) {
			let t = e;
			t && t.isColor ? this.copy(t) : typeof t == "number" ? this.setHex(t) : typeof t == "string" && this.setStyle(t);
		} else this.setRGB(e, t, n);
		return this;
	}
	setScalar(e) {
		return this.r = e, this.g = e, this.b = e, this;
	}
	setHex(e, t = Il) {
		return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, Lu.colorSpaceToWorking(this, t), this;
	}
	setRGB(e, t, n, r = Lu.workingColorSpace) {
		return this.r = e, this.g = t, this.b = n, Lu.colorSpaceToWorking(this, r), this;
	}
	setHSL(e, t, n, r = Lu.workingColorSpace) {
		if (e = su(e, 1), t = Y(t, 0, 1), n = Y(n, 0, 1), t === 0) this.r = this.g = this.b = n;
		else {
			let r = n <= .5 ? n * (1 + t) : n + t - n * t, i = 2 * n - r;
			this.r = Nd(i, r, e + 1 / 3), this.g = Nd(i, r, e), this.b = Nd(i, r, e - 1 / 3);
		}
		return Lu.colorSpaceToWorking(this, r), this;
	}
	setStyle(e, t = Il) {
		function n(t) {
			t !== void 0 && parseFloat(t) < 1 && Zl("Color: Alpha component of " + e + " will be ignored.");
		}
		let r;
		if (r = /^(\w+)\(([^\)]*)\)/.exec(e)) {
			let i, a = r[1], o = r[2];
			switch (a) {
				case "rgb":
				case "rgba":
					if (i = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) return n(i[4]), this.setRGB(Math.min(255, parseInt(i[1], 10)) / 255, Math.min(255, parseInt(i[2], 10)) / 255, Math.min(255, parseInt(i[3], 10)) / 255, t);
					if (i = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) return n(i[4]), this.setRGB(Math.min(100, parseInt(i[1], 10)) / 100, Math.min(100, parseInt(i[2], 10)) / 100, Math.min(100, parseInt(i[3], 10)) / 100, t);
					break;
				case "hsl":
				case "hsla":
					if (i = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) return n(i[4]), this.setHSL(parseFloat(i[1]) / 360, parseFloat(i[2]) / 100, parseFloat(i[3]) / 100, t);
					break;
				default: Zl("Color: Unknown color model " + e);
			}
		} else if (r = /^\#([A-Fa-f\d]+)$/.exec(e)) {
			let n = r[1], i = n.length;
			if (i === 3) return this.setRGB(parseInt(n.charAt(0), 16) / 15, parseInt(n.charAt(1), 16) / 15, parseInt(n.charAt(2), 16) / 15, t);
			if (i === 6) return this.setHex(parseInt(n, 16), t);
			Zl("Color: Invalid hex color " + e);
		} else if (e && e.length > 0) return this.setColorName(e, t);
		return this;
	}
	setColorName(e, t = Il) {
		let n = Ad[e.toLowerCase()];
		return n === void 0 ? Zl("Color: Unknown color " + e) : this.setHex(n, t), this;
	}
	clone() {
		return new this.constructor(this.r, this.g, this.b);
	}
	copy(e) {
		return this.r = e.r, this.g = e.g, this.b = e.b, this;
	}
	copySRGBToLinear(e) {
		return this.r = Ru(e.r), this.g = Ru(e.g), this.b = Ru(e.b), this;
	}
	copyLinearToSRGB(e) {
		return this.r = zu(e.r), this.g = zu(e.g), this.b = zu(e.b), this;
	}
	convertSRGBToLinear() {
		return this.copySRGBToLinear(this), this;
	}
	convertLinearToSRGB() {
		return this.copyLinearToSRGB(this), this;
	}
	getHex(e = Il) {
		return Lu.workingToColorSpace(Fd.copy(this), e), Math.round(Y(Fd.r * 255, 0, 255)) * 65536 + Math.round(Y(Fd.g * 255, 0, 255)) * 256 + Math.round(Y(Fd.b * 255, 0, 255));
	}
	getHexString(e = Il) {
		return ("000000" + this.getHex(e).toString(16)).slice(-6);
	}
	getHSL(e, t = Lu.workingColorSpace) {
		Lu.workingToColorSpace(Fd.copy(this), t);
		let n = Fd.r, r = Fd.g, i = Fd.b, a = Math.max(n, r, i), o = Math.min(n, r, i), s, c, l = (o + a) / 2;
		if (o === a) s = 0, c = 0;
		else {
			let e = a - o;
			switch (c = l <= .5 ? e / (a + o) : e / (2 - a - o), a) {
				case n:
					s = (r - i) / e + (r < i ? 6 : 0);
					break;
				case r:
					s = (i - n) / e + 2;
					break;
				case i:
					s = (n - r) / e + 4;
					break;
			}
			s /= 6;
		}
		return e.h = s, e.s = c, e.l = l, e;
	}
	getRGB(e, t = Lu.workingColorSpace) {
		return Lu.workingToColorSpace(Fd.copy(this), t), e.r = Fd.r, e.g = Fd.g, e.b = Fd.b, e;
	}
	getStyle(e = Il) {
		Lu.workingToColorSpace(Fd.copy(this), e);
		let t = Fd.r, n = Fd.g, r = Fd.b;
		return e === "srgb" ? `rgb(${Math.round(t * 255)},${Math.round(n * 255)},${Math.round(r * 255)})` : `color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${r.toFixed(3)})`;
	}
	offsetHSL(e, t, n) {
		return this.getHSL(jd), this.setHSL(jd.h + e, jd.s + t, jd.l + n);
	}
	add(e) {
		return this.r += e.r, this.g += e.g, this.b += e.b, this;
	}
	addColors(e, t) {
		return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
	}
	addScalar(e) {
		return this.r += e, this.g += e, this.b += e, this;
	}
	sub(e) {
		return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
	}
	multiply(e) {
		return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
	}
	multiplyScalar(e) {
		return this.r *= e, this.g *= e, this.b *= e, this;
	}
	lerp(e, t) {
		return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
	}
	lerpColors(e, t, n) {
		return this.r = e.r + (t.r - e.r) * n, this.g = e.g + (t.g - e.g) * n, this.b = e.b + (t.b - e.b) * n, this;
	}
	lerpHSL(e, t) {
		this.getHSL(jd), e.getHSL(Md);
		let n = uu(jd.h, Md.h, t), r = uu(jd.s, Md.s, t), i = uu(jd.l, Md.l, t);
		return this.setHSL(n, r, i), this;
	}
	setFromVector3(e) {
		return this.r = e.x, this.g = e.y, this.b = e.z, this;
	}
	applyMatrix3(e) {
		let t = this.r, n = this.g, r = this.b, i = e.elements;
		return this.r = i[0] * t + i[3] * n + i[6] * r, this.g = i[1] * t + i[4] * n + i[7] * r, this.b = i[2] * t + i[5] * n + i[8] * r, this;
	}
	equals(e) {
		return e.r === this.r && e.g === this.g && e.b === this.b;
	}
	fromArray(e, t = 0) {
		return this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
	}
	toArray(e = [], t = 0) {
		return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
	}
	fromBufferAttribute(e, t) {
		return this.r = e.getX(t), this.g = e.getY(t), this.b = e.getZ(t), this;
	}
	toJSON() {
		return this.getHex();
	}
	*[Symbol.iterator]() {
		yield this.r, yield this.g, yield this.b;
	}
}, Fd = /* @__PURE__ */ new Pd();
Pd.NAMES = Ad;
var Id = class extends Ed {
	constructor() {
		super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new ld(), this.environmentIntensity = 1, this.environmentRotation = new ld(), this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
	}
	copy(e, t) {
		return super.copy(e, t), e.background !== null && (this.background = e.background.clone()), e.environment !== null && (this.environment = e.environment.clone()), e.fog !== null && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, this.backgroundRotation.copy(e.backgroundRotation), this.environmentIntensity = e.environmentIntensity, this.environmentRotation.copy(e.environmentRotation), e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return this.fog !== null && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (t.object.backgroundIntensity = this.backgroundIntensity), t.object.backgroundRotation = this.backgroundRotation.toArray(), this.environmentIntensity !== 1 && (t.object.environmentIntensity = this.environmentIntensity), t.object.environmentRotation = this.environmentRotation.toArray(), t;
	}
}, Ld = /* @__PURE__ */ new X(), Rd = /* @__PURE__ */ new X(), zd = /* @__PURE__ */ new X(), Bd = /* @__PURE__ */ new X(), Vd = /* @__PURE__ */ new X(), Hd = /* @__PURE__ */ new X(), Ud = /* @__PURE__ */ new X(), Wd = /* @__PURE__ */ new X(), Gd = /* @__PURE__ */ new X(), Kd = /* @__PURE__ */ new X(), qd = /* @__PURE__ */ new Ju(), Jd = /* @__PURE__ */ new Ju(), Yd = /* @__PURE__ */ new Ju(), Xd = class e {
	constructor(e = new X(), t = new X(), n = new X()) {
		this.a = e, this.b = t, this.c = n;
	}
	static getNormal(e, t, n, r) {
		r.subVectors(n, t), Ld.subVectors(e, t), r.cross(Ld);
		let i = r.lengthSq();
		return i > 0 ? r.multiplyScalar(1 / Math.sqrt(i)) : r.set(0, 0, 0);
	}
	static getBarycoord(e, t, n, r, i) {
		Ld.subVectors(r, t), Rd.subVectors(n, t), zd.subVectors(e, t);
		let a = Ld.dot(Ld), o = Ld.dot(Rd), s = Ld.dot(zd), c = Rd.dot(Rd), l = Rd.dot(zd), u = a * c - o * o;
		if (u === 0) return i.set(0, 0, 0), null;
		let d = 1 / u, f = (c * s - o * l) * d, p = (a * l - o * s) * d;
		return i.set(1 - f - p, p, f);
	}
	static containsPoint(e, t, n, r) {
		return this.getBarycoord(e, t, n, r, Bd) === null ? !1 : Bd.x >= 0 && Bd.y >= 0 && Bd.x + Bd.y <= 1;
	}
	static getInterpolation(e, t, n, r, i, a, o, s) {
		return this.getBarycoord(e, t, n, r, Bd) === null ? (s.x = 0, s.y = 0, "z" in s && (s.z = 0), "w" in s && (s.w = 0), null) : (s.setScalar(0), s.addScaledVector(i, Bd.x), s.addScaledVector(a, Bd.y), s.addScaledVector(o, Bd.z), s);
	}
	static getInterpolatedAttribute(e, t, n, r, i, a) {
		return qd.setScalar(0), Jd.setScalar(0), Yd.setScalar(0), qd.fromBufferAttribute(e, t), Jd.fromBufferAttribute(e, n), Yd.fromBufferAttribute(e, r), a.setScalar(0), a.addScaledVector(qd, i.x), a.addScaledVector(Jd, i.y), a.addScaledVector(Yd, i.z), a;
	}
	static isFrontFacing(e, t, n, r) {
		return Ld.subVectors(n, t), Rd.subVectors(e, t), Ld.cross(Rd).dot(r) < 0;
	}
	set(e, t, n) {
		return this.a.copy(e), this.b.copy(t), this.c.copy(n), this;
	}
	setFromPointsAndIndices(e, t, n, r) {
		return this.a.copy(e[t]), this.b.copy(e[n]), this.c.copy(e[r]), this;
	}
	setFromAttributeAndIndices(e, t, n, r) {
		return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, n), this.c.fromBufferAttribute(e, r), this;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
	}
	getArea() {
		return Ld.subVectors(this.c, this.b), Rd.subVectors(this.a, this.b), Ld.cross(Rd).length() * .5;
	}
	getMidpoint(e) {
		return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
	}
	getNormal(t) {
		return e.getNormal(this.a, this.b, this.c, t);
	}
	getPlane(e) {
		return e.setFromCoplanarPoints(this.a, this.b, this.c);
	}
	getBarycoord(t, n) {
		return e.getBarycoord(t, this.a, this.b, this.c, n);
	}
	getInterpolation(t, n, r, i, a) {
		return e.getInterpolation(t, this.a, this.b, this.c, n, r, i, a);
	}
	containsPoint(t) {
		return e.containsPoint(t, this.a, this.b, this.c);
	}
	isFrontFacing(t) {
		return e.isFrontFacing(this.a, this.b, this.c, t);
	}
	intersectsBox(e) {
		return e.intersectsTriangle(this);
	}
	closestPointToPoint(e, t) {
		let n = this.a, r = this.b, i = this.c, a, o;
		Vd.subVectors(r, n), Hd.subVectors(i, n), Wd.subVectors(e, n);
		let s = Vd.dot(Wd), c = Hd.dot(Wd);
		if (s <= 0 && c <= 0) return t.copy(n);
		Gd.subVectors(e, r);
		let l = Vd.dot(Gd), u = Hd.dot(Gd);
		if (l >= 0 && u <= l) return t.copy(r);
		let d = s * u - l * c;
		if (d <= 0 && s >= 0 && l <= 0) return a = s / (s - l), t.copy(n).addScaledVector(Vd, a);
		Kd.subVectors(e, i);
		let f = Vd.dot(Kd), p = Hd.dot(Kd);
		if (p >= 0 && f <= p) return t.copy(i);
		let m = f * c - s * p;
		if (m <= 0 && c >= 0 && p <= 0) return o = c / (c - p), t.copy(n).addScaledVector(Hd, o);
		let h = l * p - f * u;
		if (h <= 0 && u - l >= 0 && f - p >= 0) return Ud.subVectors(i, r), o = (u - l) / (u - l + (f - p)), t.copy(r).addScaledVector(Ud, o);
		let g = 1 / (h + m + d);
		return a = m * g, o = d * g, t.copy(n).addScaledVector(Vd, a).addScaledVector(Hd, o);
	}
	equals(e) {
		return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
	}
}, Zd = class {
	constructor(e = new X(Infinity, Infinity, Infinity), t = new X(-Infinity, -Infinity, -Infinity)) {
		this.isBox3 = !0, this.min = e, this.max = t;
	}
	set(e, t) {
		return this.min.copy(e), this.max.copy(t), this;
	}
	setFromArray(e) {
		this.makeEmpty();
		for (let t = 0, n = e.length; t < n; t += 3) this.expandByPoint($d.fromArray(e, t));
		return this;
	}
	setFromBufferAttribute(e) {
		this.makeEmpty();
		for (let t = 0, n = e.count; t < n; t++) this.expandByPoint($d.fromBufferAttribute(e, t));
		return this;
	}
	setFromPoints(e) {
		this.makeEmpty();
		for (let t = 0, n = e.length; t < n; t++) this.expandByPoint(e[t]);
		return this;
	}
	setFromCenterAndSize(e, t) {
		let n = $d.copy(t).multiplyScalar(.5);
		return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
	}
	setFromObject(e, t = !1) {
		return this.makeEmpty(), this.expandByObject(e, t);
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		return this.min.copy(e.min), this.max.copy(e.max), this;
	}
	makeEmpty() {
		return this.min.x = this.min.y = this.min.z = Infinity, this.max.x = this.max.y = this.max.z = -Infinity, this;
	}
	isEmpty() {
		return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
	}
	getCenter(e) {
		return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(.5);
	}
	getSize(e) {
		return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
	}
	expandByPoint(e) {
		return this.min.min(e), this.max.max(e), this;
	}
	expandByVector(e) {
		return this.min.sub(e), this.max.add(e), this;
	}
	expandByScalar(e) {
		return this.min.addScalar(-e), this.max.addScalar(e), this;
	}
	expandByObject(e, t = !1) {
		e.updateWorldMatrix(!1, !1);
		let n = e.geometry;
		if (n !== void 0) {
			let r = n.getAttribute("position");
			if (t === !0 && r !== void 0 && e.isInstancedMesh !== !0) for (let t = 0, n = r.count; t < n; t++) e.isMesh === !0 ? e.getVertexPosition(t, $d) : $d.fromBufferAttribute(r, t), $d.applyMatrix4(e.matrixWorld), this.expandByPoint($d);
			else e.boundingBox === void 0 ? (n.boundingBox === null && n.computeBoundingBox(), ef.copy(n.boundingBox)) : (e.boundingBox === null && e.computeBoundingBox(), ef.copy(e.boundingBox)), ef.applyMatrix4(e.matrixWorld), this.union(ef);
		}
		let r = e.children;
		for (let e = 0, n = r.length; e < n; e++) this.expandByObject(r[e], t);
		return this;
	}
	containsPoint(e) {
		return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y && e.z >= this.min.z && e.z <= this.max.z;
	}
	containsBox(e) {
		return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
	}
	getParameter(e, t) {
		return t.set((e.x - this.min.x) / (this.max.x - this.min.x), (e.y - this.min.y) / (this.max.y - this.min.y), (e.z - this.min.z) / (this.max.z - this.min.z));
	}
	intersectsBox(e) {
		return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y && e.max.z >= this.min.z && e.min.z <= this.max.z;
	}
	intersectsSphere(e) {
		return this.clampPoint(e.center, $d), $d.distanceToSquared(e.center) <= e.radius * e.radius;
	}
	intersectsPlane(e) {
		let t, n;
		return e.normal.x > 0 ? (t = e.normal.x * this.min.x, n = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, n = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, n += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, n += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, n += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, n += e.normal.z * this.min.z), t <= -e.constant && n >= -e.constant;
	}
	intersectsTriangle(e) {
		if (this.isEmpty()) return !1;
		this.getCenter(cf), lf.subVectors(this.max, cf), tf.subVectors(e.a, cf), nf.subVectors(e.b, cf), rf.subVectors(e.c, cf), af.subVectors(nf, tf), of.subVectors(rf, nf), sf.subVectors(tf, rf);
		let t = [
			0,
			-af.z,
			af.y,
			0,
			-of.z,
			of.y,
			0,
			-sf.z,
			sf.y,
			af.z,
			0,
			-af.x,
			of.z,
			0,
			-of.x,
			sf.z,
			0,
			-sf.x,
			-af.y,
			af.x,
			0,
			-of.y,
			of.x,
			0,
			-sf.y,
			sf.x,
			0
		];
		return !ff(t, tf, nf, rf, lf) || (t = [
			1,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			1
		], !ff(t, tf, nf, rf, lf)) ? !1 : (uf.crossVectors(af, of), t = [
			uf.x,
			uf.y,
			uf.z
		], ff(t, tf, nf, rf, lf));
	}
	clampPoint(e, t) {
		return t.copy(e).clamp(this.min, this.max);
	}
	distanceToPoint(e) {
		return this.clampPoint(e, $d).distanceTo(e);
	}
	getBoundingSphere(e) {
		return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize($d).length() * .5), e;
	}
	intersect(e) {
		return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
	}
	union(e) {
		return this.min.min(e.min), this.max.max(e.max), this;
	}
	applyMatrix4(e) {
		return this.isEmpty() ? this : (Qd[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), Qd[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), Qd[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), Qd[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), Qd[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), Qd[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), Qd[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), Qd[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(Qd), this);
	}
	translate(e) {
		return this.min.add(e), this.max.add(e), this;
	}
	equals(e) {
		return e.min.equals(this.min) && e.max.equals(this.max);
	}
	toJSON() {
		return {
			min: this.min.toArray(),
			max: this.max.toArray()
		};
	}
	fromJSON(e) {
		return this.min.fromArray(e.min), this.max.fromArray(e.max), this;
	}
}, Qd = [
	/* @__PURE__ */ new X(),
	/* @__PURE__ */ new X(),
	/* @__PURE__ */ new X(),
	/* @__PURE__ */ new X(),
	/* @__PURE__ */ new X(),
	/* @__PURE__ */ new X(),
	/* @__PURE__ */ new X(),
	/* @__PURE__ */ new X()
], $d = /* @__PURE__ */ new X(), ef = /* @__PURE__ */ new Zd(), tf = /* @__PURE__ */ new X(), nf = /* @__PURE__ */ new X(), rf = /* @__PURE__ */ new X(), af = /* @__PURE__ */ new X(), of = /* @__PURE__ */ new X(), sf = /* @__PURE__ */ new X(), cf = /* @__PURE__ */ new X(), lf = /* @__PURE__ */ new X(), uf = /* @__PURE__ */ new X(), df = /* @__PURE__ */ new X();
function ff(e, t, n, r, i) {
	for (let a = 0, o = e.length - 3; a <= o; a += 3) {
		df.fromArray(e, a);
		let o = i.x * Math.abs(df.x) + i.y * Math.abs(df.y) + i.z * Math.abs(df.z), s = t.dot(df), c = n.dot(df), l = r.dot(df);
		if (Math.max(-Math.max(s, c, l), Math.min(s, c, l)) > o) return !1;
	}
	return !0;
}
var pf = /* @__PURE__ */ new X(), mf = /* @__PURE__ */ new Ou(), hf = 0, gf = class extends tu {
	constructor(e, t, n = !1) {
		if (super(), Array.isArray(e)) throw TypeError("THREE.BufferAttribute: array should be a Typed Array.");
		this.isBufferAttribute = !0, Object.defineProperty(this, "id", { value: hf++ }), this.name = "", this.array = e, this.itemSize = t, this.count = e === void 0 ? 0 : e.length / t, this.normalized = n, this.usage = Vl, this.updateRanges = [], this.gpuType = kc, this.version = 0;
	}
	onUploadCallback() {}
	set needsUpdate(e) {
		e === !0 && this.version++;
	}
	setUsage(e) {
		return this.usage = e, this;
	}
	addUpdateRange(e, t) {
		this.updateRanges.push({
			start: e,
			count: t
		});
	}
	clearUpdateRanges() {
		this.updateRanges.length = 0;
	}
	copy(e) {
		return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
	}
	copyAt(e, t, n) {
		e *= this.itemSize, n *= t.itemSize;
		for (let r = 0, i = this.itemSize; r < i; r++) this.array[e + r] = t.array[n + r];
		return this;
	}
	copyArray(e) {
		return this.array.set(e), this;
	}
	applyMatrix3(e) {
		if (this.itemSize === 2) for (let t = 0, n = this.count; t < n; t++) mf.fromBufferAttribute(this, t), mf.applyMatrix3(e), this.setXY(t, mf.x, mf.y);
		else if (this.itemSize === 3) for (let t = 0, n = this.count; t < n; t++) pf.fromBufferAttribute(this, t), pf.applyMatrix3(e), this.setXYZ(t, pf.x, pf.y, pf.z);
		return this;
	}
	applyMatrix4(e) {
		for (let t = 0, n = this.count; t < n; t++) pf.fromBufferAttribute(this, t), pf.applyMatrix4(e), this.setXYZ(t, pf.x, pf.y, pf.z);
		return this;
	}
	applyNormalMatrix(e) {
		for (let t = 0, n = this.count; t < n; t++) pf.fromBufferAttribute(this, t), pf.applyNormalMatrix(e), this.setXYZ(t, pf.x, pf.y, pf.z);
		return this;
	}
	transformDirection(e) {
		for (let t = 0, n = this.count; t < n; t++) pf.fromBufferAttribute(this, t), pf.transformDirection(e), this.setXYZ(t, pf.x, pf.y, pf.z);
		return this;
	}
	set(e, t = 0) {
		return this.array.set(e, t), this;
	}
	getComponent(e, t) {
		let n = this.array[e * this.itemSize + t];
		return this.normalized && (n = Tu(n, this.array)), n;
	}
	setComponent(e, t, n) {
		return this.normalized && (n = Eu(n, this.array)), this.array[e * this.itemSize + t] = n, this;
	}
	getX(e) {
		let t = this.array[e * this.itemSize];
		return this.normalized && (t = Tu(t, this.array)), t;
	}
	setX(e, t) {
		return this.normalized && (t = Eu(t, this.array)), this.array[e * this.itemSize] = t, this;
	}
	getY(e) {
		let t = this.array[e * this.itemSize + 1];
		return this.normalized && (t = Tu(t, this.array)), t;
	}
	setY(e, t) {
		return this.normalized && (t = Eu(t, this.array)), this.array[e * this.itemSize + 1] = t, this;
	}
	getZ(e) {
		let t = this.array[e * this.itemSize + 2];
		return this.normalized && (t = Tu(t, this.array)), t;
	}
	setZ(e, t) {
		return this.normalized && (t = Eu(t, this.array)), this.array[e * this.itemSize + 2] = t, this;
	}
	getW(e) {
		let t = this.array[e * this.itemSize + 3];
		return this.normalized && (t = Tu(t, this.array)), t;
	}
	setW(e, t) {
		return this.normalized && (t = Eu(t, this.array)), this.array[e * this.itemSize + 3] = t, this;
	}
	setXY(e, t, n) {
		return e *= this.itemSize, this.normalized && (t = Eu(t, this.array), n = Eu(n, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this;
	}
	setXYZ(e, t, n, r) {
		return e *= this.itemSize, this.normalized && (t = Eu(t, this.array), n = Eu(n, this.array), r = Eu(r, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = r, this;
	}
	setXYZW(e, t, n, r, i) {
		return e *= this.itemSize, this.normalized && (t = Eu(t, this.array), n = Eu(n, this.array), r = Eu(r, this.array), i = Eu(i, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = r, this.array[e + 3] = i, this;
	}
	onUpload(e) {
		return this.onUploadCallback = e, this;
	}
	clone() {
		return new this.constructor(this.array, this.itemSize).copy(this);
	}
	toJSON() {
		let e = {
			itemSize: this.itemSize,
			type: this.array.constructor.name,
			array: Array.from(this.array),
			normalized: this.normalized
		};
		return this.name !== "" && (e.name = this.name), this.usage !== 35044 && (e.usage = this.usage), e;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
}, _f = class extends gf {
	constructor(e, t, n) {
		super(new Uint16Array(e), t, n);
	}
}, vf = class extends gf {
	constructor(e, t, n) {
		super(new Uint32Array(e), t, n);
	}
}, yf = class extends gf {
	constructor(e, t, n) {
		super(new Float32Array(e), t, n);
	}
}, bf = /* @__PURE__ */ new Zd(), xf = /* @__PURE__ */ new X(), Sf = /* @__PURE__ */ new X(), Cf = class {
	constructor(e = new X(), t = -1) {
		this.isSphere = !0, this.center = e, this.radius = t;
	}
	set(e, t) {
		return this.center.copy(e), this.radius = t, this;
	}
	setFromPoints(e, t) {
		let n = this.center;
		t === void 0 ? bf.setFromPoints(e).getCenter(n) : n.copy(t);
		let r = 0;
		for (let t = 0, i = e.length; t < i; t++) r = Math.max(r, n.distanceToSquared(e[t]));
		return this.radius = Math.sqrt(r), this;
	}
	copy(e) {
		return this.center.copy(e.center), this.radius = e.radius, this;
	}
	isEmpty() {
		return this.radius < 0;
	}
	makeEmpty() {
		return this.center.set(0, 0, 0), this.radius = -1, this;
	}
	containsPoint(e) {
		return e.distanceToSquared(this.center) <= this.radius * this.radius;
	}
	distanceToPoint(e) {
		return e.distanceTo(this.center) - this.radius;
	}
	intersectsSphere(e) {
		let t = this.radius + e.radius;
		return e.center.distanceToSquared(this.center) <= t * t;
	}
	intersectsBox(e) {
		return e.intersectsSphere(this);
	}
	intersectsPlane(e) {
		return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
	}
	clampPoint(e, t) {
		let n = this.center.distanceToSquared(e);
		return t.copy(e), n > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
	}
	getBoundingBox(e) {
		return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
	}
	applyMatrix4(e) {
		return this.center.applyMatrix4(e), this.radius *= e.getMaxScaleOnAxis(), this;
	}
	translate(e) {
		return this.center.add(e), this;
	}
	expandByPoint(e) {
		if (this.isEmpty()) return this.center.copy(e), this.radius = 0, this;
		xf.subVectors(e, this.center);
		let t = xf.lengthSq();
		if (t > this.radius * this.radius) {
			let e = Math.sqrt(t), n = (e - this.radius) * .5;
			this.center.addScaledVector(xf, n / e), this.radius += n;
		}
		return this;
	}
	union(e) {
		return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : (Sf.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint(xf.copy(e.center).add(Sf)), this.expandByPoint(xf.copy(e.center).sub(Sf))), this);
	}
	equals(e) {
		return e.center.equals(this.center) && e.radius === this.radius;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	toJSON() {
		return {
			radius: this.radius,
			center: this.center.toArray()
		};
	}
	fromJSON(e) {
		return this.radius = e.radius, this.center.fromArray(e.center), this;
	}
}, wf = 0, Tf = /* @__PURE__ */ new $u(), Ef = /* @__PURE__ */ new Ed(), Df = /* @__PURE__ */ new X(), Of = /* @__PURE__ */ new Zd(), kf = /* @__PURE__ */ new Zd(), Af = /* @__PURE__ */ new X(), jf = class e extends tu {
	constructor() {
		super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: wf++ }), this.uuid = ou(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.indirectOffset = 0, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
			start: 0,
			count: Infinity
		}, this.userData = {}, this._transformed = !1;
	}
	getIndex() {
		return this.index;
	}
	setIndex(e) {
		return Array.isArray(e) ? this.index = new (Ul(e) ? vf : _f)(e, 1) : this.index = e, this;
	}
	setIndirect(e, t = 0) {
		return this.indirect = e, this.indirectOffset = t, this;
	}
	getIndirect() {
		return this.indirect;
	}
	getAttribute(e) {
		return this.attributes[e];
	}
	setAttribute(e, t) {
		return this.attributes[e] = t, this;
	}
	deleteAttribute(e) {
		return delete this.attributes[e], this;
	}
	hasAttribute(e) {
		return this.attributes[e] !== void 0;
	}
	addGroup(e, t, n = 0) {
		this.groups.push({
			start: e,
			count: t,
			materialIndex: n
		});
	}
	clearGroups() {
		this.groups = [];
	}
	setDrawRange(e, t) {
		this.drawRange.start = e, this.drawRange.count = t;
	}
	applyMatrix4(e) {
		let t = this.attributes.position;
		t !== void 0 && (t.applyMatrix4(e), t.needsUpdate = !0);
		let n = this.attributes.normal;
		if (n !== void 0) {
			let t = new Mu().getNormalMatrix(e);
			n.applyNormalMatrix(t), n.needsUpdate = !0;
		}
		let r = this.attributes.tangent;
		return r !== void 0 && (r.transformDirection(e), r.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this._transformed = !0, this;
	}
	applyQuaternion(e) {
		return Tf.makeRotationFromQuaternion(e), this.applyMatrix4(Tf), this;
	}
	rotateX(e) {
		return Tf.makeRotationX(e), this.applyMatrix4(Tf), this;
	}
	rotateY(e) {
		return Tf.makeRotationY(e), this.applyMatrix4(Tf), this;
	}
	rotateZ(e) {
		return Tf.makeRotationZ(e), this.applyMatrix4(Tf), this;
	}
	translate(e, t, n) {
		return Tf.makeTranslation(e, t, n), this.applyMatrix4(Tf), this;
	}
	scale(e, t, n) {
		return Tf.makeScale(e, t, n), this.applyMatrix4(Tf), this;
	}
	lookAt(e) {
		return Ef.lookAt(e), Ef.updateMatrix(), this.applyMatrix4(Ef.matrix), this;
	}
	center() {
		return this.computeBoundingBox(), this.boundingBox.getCenter(Df).negate(), this.translate(Df.x, Df.y, Df.z), this;
	}
	setFromPoints(e) {
		let t = this.getAttribute("position");
		if (t === void 0) {
			let t = [];
			for (let n = 0, r = e.length; n < r; n++) {
				let r = e[n];
				t.push(r.x, r.y, r.z || 0);
			}
			this.setAttribute("position", new yf(t, 3));
		} else {
			let n = Math.min(e.length, t.count);
			for (let r = 0; r < n; r++) {
				let n = e[r];
				t.setXYZ(r, n.x, n.y, n.z || 0);
			}
			e.length > t.count && Zl("BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), t.needsUpdate = !0;
		}
		return this;
	}
	computeBoundingBox() {
		this.boundingBox === null && (this.boundingBox = new Zd());
		let e = this.attributes.position, t = this.morphAttributes.position;
		if (e && e.isGLBufferAttribute) {
			J("BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(new X(-Infinity, -Infinity, -Infinity), new X(Infinity, Infinity, Infinity));
			return;
		}
		if (e !== void 0) {
			if (this.boundingBox.setFromBufferAttribute(e), t) for (let e = 0, n = t.length; e < n; e++) {
				let n = t[e];
				Of.setFromBufferAttribute(n), this.morphTargetsRelative ? (Af.addVectors(this.boundingBox.min, Of.min), this.boundingBox.expandByPoint(Af), Af.addVectors(this.boundingBox.max, Of.max), this.boundingBox.expandByPoint(Af)) : (this.boundingBox.expandByPoint(Of.min), this.boundingBox.expandByPoint(Of.max));
			}
		} else this.boundingBox.makeEmpty();
		(isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && J("BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The \"position\" attribute is likely to have NaN values.", this);
	}
	computeBoundingSphere() {
		this.boundingSphere === null && (this.boundingSphere = new Cf());
		let e = this.attributes.position, t = this.morphAttributes.position;
		if (e && e.isGLBufferAttribute) {
			J("BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new X(), Infinity);
			return;
		}
		if (e) {
			let n = this.boundingSphere.center;
			if (Of.setFromBufferAttribute(e), t) for (let e = 0, n = t.length; e < n; e++) {
				let n = t[e];
				kf.setFromBufferAttribute(n), this.morphTargetsRelative ? (Af.addVectors(Of.min, kf.min), Of.expandByPoint(Af), Af.addVectors(Of.max, kf.max), Of.expandByPoint(Af)) : (Of.expandByPoint(kf.min), Of.expandByPoint(kf.max));
			}
			Of.getCenter(n);
			let r = 0;
			for (let t = 0, i = e.count; t < i; t++) Af.fromBufferAttribute(e, t), r = Math.max(r, n.distanceToSquared(Af));
			if (t) for (let i = 0, a = t.length; i < a; i++) {
				let a = t[i], o = this.morphTargetsRelative;
				for (let t = 0, i = a.count; t < i; t++) Af.fromBufferAttribute(a, t), o && (Df.fromBufferAttribute(e, t), Af.add(Df)), r = Math.max(r, n.distanceToSquared(Af));
			}
			this.boundingSphere.radius = Math.sqrt(r), isNaN(this.boundingSphere.radius) && J("BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The \"position\" attribute is likely to have NaN values.", this);
		}
	}
	computeTangents() {
		let e = this.index, t = this.attributes;
		if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
			J("BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
			return;
		}
		let n = t.position, r = t.normal, i = t.uv, a = this.getAttribute("tangent");
		(a === void 0 || a.count !== n.count) && (a = new gf(new Float32Array(4 * n.count), 4), this.setAttribute("tangent", a));
		let o = [], s = [];
		for (let e = 0; e < n.count; e++) o[e] = new X(), s[e] = new X();
		let c = new X(), l = new X(), u = new X(), d = new Ou(), f = new Ou(), p = new Ou(), m = new X(), h = new X();
		function g(e, t, r) {
			c.fromBufferAttribute(n, e), l.fromBufferAttribute(n, t), u.fromBufferAttribute(n, r), d.fromBufferAttribute(i, e), f.fromBufferAttribute(i, t), p.fromBufferAttribute(i, r), l.sub(c), u.sub(c), f.sub(d), p.sub(d);
			let a = 1 / (f.x * p.y - p.x * f.y);
			isFinite(a) && (m.copy(l).multiplyScalar(p.y).addScaledVector(u, -f.y).multiplyScalar(a), h.copy(u).multiplyScalar(f.x).addScaledVector(l, -p.x).multiplyScalar(a), o[e].add(m), o[t].add(m), o[r].add(m), s[e].add(h), s[t].add(h), s[r].add(h));
		}
		let _ = this.groups;
		_.length === 0 && (_ = [{
			start: 0,
			count: e.count
		}]);
		for (let t = 0, n = _.length; t < n; ++t) {
			let n = _[t], r = n.start, i = n.count;
			for (let t = r, n = r + i; t < n; t += 3) g(e.getX(t + 0), e.getX(t + 1), e.getX(t + 2));
		}
		let v = new X(), y = new X(), b = new X(), x = new X();
		function S(e) {
			b.fromBufferAttribute(r, e), x.copy(b);
			let t = o[e];
			v.copy(t), v.sub(b.multiplyScalar(b.dot(t))).normalize(), y.crossVectors(x, t);
			let n = y.dot(s[e]) < 0 ? -1 : 1;
			a.setXYZW(e, v.x, v.y, v.z, n);
		}
		for (let t = 0, n = _.length; t < n; ++t) {
			let n = _[t], r = n.start, i = n.count;
			for (let t = r, n = r + i; t < n; t += 3) S(e.getX(t + 0)), S(e.getX(t + 1)), S(e.getX(t + 2));
		}
		this._transformed = !0;
	}
	computeVertexNormals() {
		let e = this.index, t = this.getAttribute("position");
		if (t !== void 0) {
			let n = this.getAttribute("normal");
			if (n === void 0 || n.count !== t.count) n = new gf(new Float32Array(t.count * 3), 3), this.setAttribute("normal", n);
			else for (let e = 0, t = n.count; e < t; e++) n.setXYZ(e, 0, 0, 0);
			let r = new X(), i = new X(), a = new X(), o = new X(), s = new X(), c = new X(), l = new X(), u = new X();
			if (e) for (let d = 0, f = e.count; d < f; d += 3) {
				let f = e.getX(d + 0), p = e.getX(d + 1), m = e.getX(d + 2);
				r.fromBufferAttribute(t, f), i.fromBufferAttribute(t, p), a.fromBufferAttribute(t, m), l.subVectors(a, i), u.subVectors(r, i), l.cross(u), o.fromBufferAttribute(n, f), s.fromBufferAttribute(n, p), c.fromBufferAttribute(n, m), o.add(l), s.add(l), c.add(l), n.setXYZ(f, o.x, o.y, o.z), n.setXYZ(p, s.x, s.y, s.z), n.setXYZ(m, c.x, c.y, c.z);
			}
			else for (let e = 0, o = t.count; e < o; e += 3) r.fromBufferAttribute(t, e + 0), i.fromBufferAttribute(t, e + 1), a.fromBufferAttribute(t, e + 2), l.subVectors(a, i), u.subVectors(r, i), l.cross(u), n.setXYZ(e + 0, l.x, l.y, l.z), n.setXYZ(e + 1, l.x, l.y, l.z), n.setXYZ(e + 2, l.x, l.y, l.z);
			this.normalizeNormals(), n.needsUpdate = !0;
		}
	}
	normalizeNormals() {
		let e = this.attributes.normal;
		for (let t = 0, n = e.count; t < n; t++) Af.fromBufferAttribute(e, t), Af.normalize(), e.setXYZ(t, Af.x, Af.y, Af.z);
	}
	toNonIndexed() {
		function t(e, t) {
			let n = e.array, r = e.itemSize, i = e.normalized, a = new n.constructor(t.length * r), o = 0, s = 0;
			for (let i = 0, c = t.length; i < c; i++) {
				o = e.isInterleavedBufferAttribute ? t[i] * e.data.stride + e.offset : t[i] * r;
				for (let e = 0; e < r; e++) a[s++] = n[o++];
			}
			return new gf(a, r, i);
		}
		if (this.index === null) return Zl("BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
		let n = new e(), r = this.index.array, i = this.attributes;
		for (let e in i) {
			let a = i[e], o = t(a, r);
			n.setAttribute(e, o);
		}
		let a = this.morphAttributes;
		for (let e in a) {
			let i = [], o = a[e];
			for (let e = 0, n = o.length; e < n; e++) {
				let n = o[e], a = t(n, r);
				i.push(a);
			}
			n.morphAttributes[e] = i;
		}
		n.morphTargetsRelative = this.morphTargetsRelative;
		let o = this.groups;
		for (let e = 0, t = o.length; e < t; e++) {
			let t = o[e];
			n.addGroup(t.start, t.count, t.materialIndex);
		}
		return n;
	}
	toJSON() {
		let e = { metadata: {
			version: 4.7,
			type: "BufferGeometry",
			generator: "BufferGeometry.toJSON"
		} };
		if (e.uuid = this.uuid, e.type = this.parameters !== void 0 && this._transformed === !0 ? "BufferGeometry" : this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0 && this._transformed !== !0) {
			let t = this.parameters;
			for (let n in t) t[n] !== void 0 && (e[n] = t[n]);
			return e;
		}
		e.data = { attributes: {} };
		let t = this.index;
		t !== null && (e.data.index = {
			type: t.array.constructor.name,
			array: Array.prototype.slice.call(t.array)
		});
		let n = this.attributes;
		for (let t in n) {
			let r = n[t];
			e.data.attributes[t] = r.toJSON(e.data);
		}
		let r = {}, i = !1;
		for (let t in this.morphAttributes) {
			let n = this.morphAttributes[t], a = [];
			for (let t = 0, r = n.length; t < r; t++) {
				let r = n[t];
				a.push(r.toJSON(e.data));
			}
			a.length > 0 && (r[t] = a, i = !0);
		}
		i && (e.data.morphAttributes = r, e.data.morphTargetsRelative = this.morphTargetsRelative);
		let a = this.groups;
		a.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(a)));
		let o = this.boundingSphere;
		return o !== null && (e.data.boundingSphere = o.toJSON()), e;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
		let t = {};
		this.name = e.name;
		let n = e.index;
		n !== null && this.setIndex(n.clone());
		let r = e.attributes;
		for (let e in r) {
			let n = r[e];
			this.setAttribute(e, n.clone(t));
		}
		let i = e.morphAttributes;
		for (let e in i) {
			let n = [], r = i[e];
			for (let e = 0, i = r.length; e < i; e++) n.push(r[e].clone(t));
			this.morphAttributes[e] = n;
		}
		this.morphTargetsRelative = e.morphTargetsRelative;
		let a = e.groups;
		for (let e = 0, t = a.length; e < t; e++) {
			let t = a[e];
			this.addGroup(t.start, t.count, t.materialIndex);
		}
		let o = e.boundingBox;
		o !== null && (this.boundingBox = o.clone());
		let s = e.boundingSphere;
		return s !== null && (this.boundingSphere = s.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this._transformed = e._transformed, this;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
}, Mf = 0, Nf = class extends tu {
	constructor() {
		super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: Mf++ }), this.uuid = ou(), this.name = "", this.type = "Material", this.blending = 1, this.side = 0, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = 204, this.blendDst = 205, this.blendEquation = 100, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Pd(0, 0, 0), this.blendAlpha = 0, this.depthFunc = 3, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = 519, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = Bl, this.stencilZFail = Bl, this.stencilZPass = Bl, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
	}
	get alphaTest() {
		return this._alphaTest;
	}
	set alphaTest(e) {
		this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
	}
	onBeforeRender() {}
	onBeforeCompile() {}
	customProgramCacheKey() {
		return this.onBeforeCompile.toString();
	}
	setValues(e) {
		if (e !== void 0) for (let t in e) {
			let n = e[t];
			if (n === void 0) {
				Zl(`Material: parameter '${t}' has value of undefined.`);
				continue;
			}
			let r = this[t];
			if (r === void 0) {
				Zl(`Material: '${t}' is not a property of THREE.${this.type}.`);
				continue;
			}
			r && r.isColor ? r.set(n) : r && r.isVector2 && n && n.isVector2 || r && r.isEuler && n && n.isEuler || r && r.isVector3 && n && n.isVector3 ? r.copy(n) : this[t] = n;
		}
	}
	toJSON(e) {
		let t = e === void 0 || typeof e == "string";
		t && (e = {
			textures: {},
			images: {}
		});
		let n = { metadata: {
			version: 4.7,
			type: "Material",
			generator: "Material.toJSON"
		} };
		n.uuid = this.uuid, n.type = this.type, this.name !== "" && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), this.roughness !== void 0 && (n.roughness = this.roughness), this.metalness !== void 0 && (n.metalness = this.metalness), this.sheen !== void 0 && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (n.shininess = this.shininess), this.clearcoat !== void 0 && (n.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.sheenColorMap && this.sheenColorMap.isTexture && (n.sheenColorMap = this.sheenColorMap.toJSON(e).uuid), this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture && (n.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(e).uuid), this.dispersion !== void 0 && (n.dispersion = this.dispersion), this.iridescence !== void 0 && (n.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (n.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.anisotropy !== void 0 && (n.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (n.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (n.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(e).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(e).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(e).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(e).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(e).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (n.combine = this.combine)), this.envMapRotation !== void 0 && (n.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (n.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (n.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== Infinity && (n.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (n.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (n.size = this.size), this.shadowSide !== null && (n.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== 1 && (n.blending = this.blending), this.side !== 0 && (n.side = this.side), this.vertexColors === !0 && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), this.transparent === !0 && (n.transparent = !0), this.blendSrc !== 204 && (n.blendSrc = this.blendSrc), this.blendDst !== 205 && (n.blendDst = this.blendDst), this.blendEquation !== 100 && (n.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (n.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (n.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (n.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (n.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (n.blendAlpha = this.blendAlpha), this.depthFunc !== 3 && (n.depthFunc = this.depthFunc), this.depthTest === !1 && (n.depthTest = this.depthTest), this.depthWrite === !1 && (n.depthWrite = this.depthWrite), this.colorWrite === !1 && (n.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (n.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== 519 && (n.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (n.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (n.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== 7680 && (n.stencilFail = this.stencilFail), this.stencilZFail !== 7680 && (n.stencilZFail = this.stencilZFail), this.stencilZPass !== 7680 && (n.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (n.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (n.rotation = this.rotation), this.polygonOffset === !0 && (n.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (n.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (n.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (n.linewidth = this.linewidth), this.dashSize !== void 0 && (n.dashSize = this.dashSize), this.gapSize !== void 0 && (n.gapSize = this.gapSize), this.scale !== void 0 && (n.scale = this.scale), this.dithering === !0 && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), this.alphaHash === !0 && (n.alphaHash = !0), this.alphaToCoverage === !0 && (n.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (n.premultipliedAlpha = !0), this.forceSinglePass === !0 && (n.forceSinglePass = !0), this.allowOverride === !1 && (n.allowOverride = !1), this.wireframe === !0 && (n.wireframe = !0), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (n.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (n.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (n.flatShading = !0), this.visible === !1 && (n.visible = !1), this.toneMapped === !1 && (n.toneMapped = !1), this.fog === !1 && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData);
		function r(e) {
			let t = [];
			for (let n in e) {
				let r = e[n];
				delete r.metadata, t.push(r);
			}
			return t;
		}
		if (t) {
			let t = r(e.textures), i = r(e.images);
			t.length > 0 && (n.textures = t), i.length > 0 && (n.images = i);
		}
		return n;
	}
	fromJSON(e, t) {
		if (e.uuid !== void 0 && (this.uuid = e.uuid), e.name !== void 0 && (this.name = e.name), e.color !== void 0 && this.color !== void 0 && this.color.setHex(e.color), e.roughness !== void 0 && (this.roughness = e.roughness), e.metalness !== void 0 && (this.metalness = e.metalness), e.sheen !== void 0 && (this.sheen = e.sheen), e.sheenColor !== void 0 && (this.sheenColor = new Pd().setHex(e.sheenColor)), e.sheenRoughness !== void 0 && (this.sheenRoughness = e.sheenRoughness), e.emissive !== void 0 && this.emissive !== void 0 && this.emissive.setHex(e.emissive), e.specular !== void 0 && this.specular !== void 0 && this.specular.setHex(e.specular), e.specularIntensity !== void 0 && (this.specularIntensity = e.specularIntensity), e.specularColor !== void 0 && this.specularColor !== void 0 && this.specularColor.setHex(e.specularColor), e.shininess !== void 0 && (this.shininess = e.shininess), e.clearcoat !== void 0 && (this.clearcoat = e.clearcoat), e.clearcoatRoughness !== void 0 && (this.clearcoatRoughness = e.clearcoatRoughness), e.dispersion !== void 0 && (this.dispersion = e.dispersion), e.iridescence !== void 0 && (this.iridescence = e.iridescence), e.iridescenceIOR !== void 0 && (this.iridescenceIOR = e.iridescenceIOR), e.iridescenceThicknessRange !== void 0 && (this.iridescenceThicknessRange = e.iridescenceThicknessRange), e.transmission !== void 0 && (this.transmission = e.transmission), e.thickness !== void 0 && (this.thickness = e.thickness), e.attenuationDistance !== void 0 && (this.attenuationDistance = e.attenuationDistance), e.attenuationColor !== void 0 && this.attenuationColor !== void 0 && this.attenuationColor.setHex(e.attenuationColor), e.anisotropy !== void 0 && (this.anisotropy = e.anisotropy), e.anisotropyRotation !== void 0 && (this.anisotropyRotation = e.anisotropyRotation), e.fog !== void 0 && (this.fog = e.fog), e.flatShading !== void 0 && (this.flatShading = e.flatShading), e.blending !== void 0 && (this.blending = e.blending), e.combine !== void 0 && (this.combine = e.combine), e.side !== void 0 && (this.side = e.side), e.shadowSide !== void 0 && (this.shadowSide = e.shadowSide), e.opacity !== void 0 && (this.opacity = e.opacity), e.transparent !== void 0 && (this.transparent = e.transparent), e.alphaTest !== void 0 && (this.alphaTest = e.alphaTest), e.alphaHash !== void 0 && (this.alphaHash = e.alphaHash), e.depthFunc !== void 0 && (this.depthFunc = e.depthFunc), e.depthTest !== void 0 && (this.depthTest = e.depthTest), e.depthWrite !== void 0 && (this.depthWrite = e.depthWrite), e.colorWrite !== void 0 && (this.colorWrite = e.colorWrite), e.blendSrc !== void 0 && (this.blendSrc = e.blendSrc), e.blendDst !== void 0 && (this.blendDst = e.blendDst), e.blendEquation !== void 0 && (this.blendEquation = e.blendEquation), e.blendSrcAlpha !== void 0 && (this.blendSrcAlpha = e.blendSrcAlpha), e.blendDstAlpha !== void 0 && (this.blendDstAlpha = e.blendDstAlpha), e.blendEquationAlpha !== void 0 && (this.blendEquationAlpha = e.blendEquationAlpha), e.blendColor !== void 0 && this.blendColor !== void 0 && this.blendColor.setHex(e.blendColor), e.blendAlpha !== void 0 && (this.blendAlpha = e.blendAlpha), e.stencilWriteMask !== void 0 && (this.stencilWriteMask = e.stencilWriteMask), e.stencilFunc !== void 0 && (this.stencilFunc = e.stencilFunc), e.stencilRef !== void 0 && (this.stencilRef = e.stencilRef), e.stencilFuncMask !== void 0 && (this.stencilFuncMask = e.stencilFuncMask), e.stencilFail !== void 0 && (this.stencilFail = e.stencilFail), e.stencilZFail !== void 0 && (this.stencilZFail = e.stencilZFail), e.stencilZPass !== void 0 && (this.stencilZPass = e.stencilZPass), e.stencilWrite !== void 0 && (this.stencilWrite = e.stencilWrite), e.wireframe !== void 0 && (this.wireframe = e.wireframe), e.wireframeLinewidth !== void 0 && (this.wireframeLinewidth = e.wireframeLinewidth), e.wireframeLinecap !== void 0 && (this.wireframeLinecap = e.wireframeLinecap), e.wireframeLinejoin !== void 0 && (this.wireframeLinejoin = e.wireframeLinejoin), e.rotation !== void 0 && (this.rotation = e.rotation), e.linewidth !== void 0 && (this.linewidth = e.linewidth), e.dashSize !== void 0 && (this.dashSize = e.dashSize), e.gapSize !== void 0 && (this.gapSize = e.gapSize), e.scale !== void 0 && (this.scale = e.scale), e.polygonOffset !== void 0 && (this.polygonOffset = e.polygonOffset), e.polygonOffsetFactor !== void 0 && (this.polygonOffsetFactor = e.polygonOffsetFactor), e.polygonOffsetUnits !== void 0 && (this.polygonOffsetUnits = e.polygonOffsetUnits), e.dithering !== void 0 && (this.dithering = e.dithering), e.alphaToCoverage !== void 0 && (this.alphaToCoverage = e.alphaToCoverage), e.premultipliedAlpha !== void 0 && (this.premultipliedAlpha = e.premultipliedAlpha), e.forceSinglePass !== void 0 && (this.forceSinglePass = e.forceSinglePass), e.allowOverride !== void 0 && (this.allowOverride = e.allowOverride), e.visible !== void 0 && (this.visible = e.visible), e.toneMapped !== void 0 && (this.toneMapped = e.toneMapped), e.userData !== void 0 && (this.userData = e.userData), e.vertexColors !== void 0 && (typeof e.vertexColors == "number" ? this.vertexColors = e.vertexColors > 0 : this.vertexColors = e.vertexColors), e.size !== void 0 && (this.size = e.size), e.sizeAttenuation !== void 0 && (this.sizeAttenuation = e.sizeAttenuation), e.map !== void 0 && (this.map = t[e.map] || null), e.matcap !== void 0 && (this.matcap = t[e.matcap] || null), e.alphaMap !== void 0 && (this.alphaMap = t[e.alphaMap] || null), e.bumpMap !== void 0 && (this.bumpMap = t[e.bumpMap] || null), e.bumpScale !== void 0 && (this.bumpScale = e.bumpScale), e.normalMap !== void 0 && (this.normalMap = t[e.normalMap] || null), e.normalMapType !== void 0 && (this.normalMapType = e.normalMapType), e.normalScale !== void 0) {
			let t = e.normalScale;
			Array.isArray(t) === !1 && (t = [t, t]), this.normalScale = new Ou().fromArray(t);
		}
		return e.displacementMap !== void 0 && (this.displacementMap = t[e.displacementMap] || null), e.displacementScale !== void 0 && (this.displacementScale = e.displacementScale), e.displacementBias !== void 0 && (this.displacementBias = e.displacementBias), e.roughnessMap !== void 0 && (this.roughnessMap = t[e.roughnessMap] || null), e.metalnessMap !== void 0 && (this.metalnessMap = t[e.metalnessMap] || null), e.emissiveMap !== void 0 && (this.emissiveMap = t[e.emissiveMap] || null), e.emissiveIntensity !== void 0 && (this.emissiveIntensity = e.emissiveIntensity), e.specularMap !== void 0 && (this.specularMap = t[e.specularMap] || null), e.specularIntensityMap !== void 0 && (this.specularIntensityMap = t[e.specularIntensityMap] || null), e.specularColorMap !== void 0 && (this.specularColorMap = t[e.specularColorMap] || null), e.envMap !== void 0 && (this.envMap = t[e.envMap] || null), e.envMapRotation !== void 0 && this.envMapRotation.fromArray(e.envMapRotation), e.envMapIntensity !== void 0 && (this.envMapIntensity = e.envMapIntensity), e.reflectivity !== void 0 && (this.reflectivity = e.reflectivity), e.refractionRatio !== void 0 && (this.refractionRatio = e.refractionRatio), e.lightMap !== void 0 && (this.lightMap = t[e.lightMap] || null), e.lightMapIntensity !== void 0 && (this.lightMapIntensity = e.lightMapIntensity), e.aoMap !== void 0 && (this.aoMap = t[e.aoMap] || null), e.aoMapIntensity !== void 0 && (this.aoMapIntensity = e.aoMapIntensity), e.gradientMap !== void 0 && (this.gradientMap = t[e.gradientMap] || null), e.clearcoatMap !== void 0 && (this.clearcoatMap = t[e.clearcoatMap] || null), e.clearcoatRoughnessMap !== void 0 && (this.clearcoatRoughnessMap = t[e.clearcoatRoughnessMap] || null), e.clearcoatNormalMap !== void 0 && (this.clearcoatNormalMap = t[e.clearcoatNormalMap] || null), e.clearcoatNormalScale !== void 0 && (this.clearcoatNormalScale = new Ou().fromArray(e.clearcoatNormalScale)), e.iridescenceMap !== void 0 && (this.iridescenceMap = t[e.iridescenceMap] || null), e.iridescenceThicknessMap !== void 0 && (this.iridescenceThicknessMap = t[e.iridescenceThicknessMap] || null), e.transmissionMap !== void 0 && (this.transmissionMap = t[e.transmissionMap] || null), e.thicknessMap !== void 0 && (this.thicknessMap = t[e.thicknessMap] || null), e.anisotropyMap !== void 0 && (this.anisotropyMap = t[e.anisotropyMap] || null), e.sheenColorMap !== void 0 && (this.sheenColorMap = t[e.sheenColorMap] || null), e.sheenRoughnessMap !== void 0 && (this.sheenRoughnessMap = t[e.sheenRoughnessMap] || null), this;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	copy(e) {
		this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.blendColor.copy(e.blendColor), this.blendAlpha = e.blendAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
		let t = e.clippingPlanes, n = null;
		if (t !== null) {
			let e = t.length;
			n = Array(e);
			for (let r = 0; r !== e; ++r) n[r] = t[r].clone();
		}
		return this.clippingPlanes = n, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.allowOverride = e.allowOverride, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
	set needsUpdate(e) {
		e === !0 && this.version++;
	}
}, Pf = /* @__PURE__ */ new X(), Ff = /* @__PURE__ */ new X(), If = /* @__PURE__ */ new X(), Lf = /* @__PURE__ */ new X(), Rf = /* @__PURE__ */ new X(), zf = /* @__PURE__ */ new X(), Bf = /* @__PURE__ */ new X(), Vf = class {
	constructor(e = new X(), t = new X(0, 0, -1)) {
		this.origin = e, this.direction = t;
	}
	set(e, t) {
		return this.origin.copy(e), this.direction.copy(t), this;
	}
	copy(e) {
		return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
	}
	at(e, t) {
		return t.copy(this.origin).addScaledVector(this.direction, e);
	}
	lookAt(e) {
		return this.direction.copy(e).sub(this.origin).normalize(), this;
	}
	recast(e) {
		return this.origin.copy(this.at(e, Pf)), this;
	}
	closestPointToPoint(e, t) {
		t.subVectors(e, this.origin);
		let n = t.dot(this.direction);
		return n < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, n);
	}
	distanceToPoint(e) {
		return Math.sqrt(this.distanceSqToPoint(e));
	}
	distanceSqToPoint(e) {
		let t = Pf.subVectors(e, this.origin).dot(this.direction);
		return t < 0 ? this.origin.distanceToSquared(e) : (Pf.copy(this.origin).addScaledVector(this.direction, t), Pf.distanceToSquared(e));
	}
	distanceSqToSegment(e, t, n, r) {
		Ff.copy(e).add(t).multiplyScalar(.5), If.copy(t).sub(e).normalize(), Lf.copy(this.origin).sub(Ff);
		let i = e.distanceTo(t) * .5, a = -this.direction.dot(If), o = Lf.dot(this.direction), s = -Lf.dot(If), c = Lf.lengthSq(), l = Math.abs(1 - a * a), u, d, f, p;
		if (l > 0) if (u = a * s - o, d = a * o - s, p = i * l, u >= 0) if (d >= -p) if (d <= p) {
			let e = 1 / l;
			u *= e, d *= e, f = u * (u + a * d + 2 * o) + d * (a * u + d + 2 * s) + c;
		} else d = i, u = Math.max(0, -(a * d + o)), f = -u * u + d * (d + 2 * s) + c;
		else d = -i, u = Math.max(0, -(a * d + o)), f = -u * u + d * (d + 2 * s) + c;
		else d <= -p ? (u = Math.max(0, -(-a * i + o)), d = u > 0 ? -i : Math.min(Math.max(-i, -s), i), f = -u * u + d * (d + 2 * s) + c) : d <= p ? (u = 0, d = Math.min(Math.max(-i, -s), i), f = d * (d + 2 * s) + c) : (u = Math.max(0, -(a * i + o)), d = u > 0 ? i : Math.min(Math.max(-i, -s), i), f = -u * u + d * (d + 2 * s) + c);
		else d = a > 0 ? -i : i, u = Math.max(0, -(a * d + o)), f = -u * u + d * (d + 2 * s) + c;
		return n && n.copy(this.origin).addScaledVector(this.direction, u), r && r.copy(Ff).addScaledVector(If, d), f;
	}
	intersectSphere(e, t) {
		Pf.subVectors(e.center, this.origin);
		let n = Pf.dot(this.direction), r = Pf.dot(Pf) - n * n, i = e.radius * e.radius;
		if (r > i) return null;
		let a = Math.sqrt(i - r), o = n - a, s = n + a;
		return s < 0 ? null : o < 0 ? this.at(s, t) : this.at(o, t);
	}
	intersectsSphere(e) {
		return e.radius < 0 ? !1 : this.distanceSqToPoint(e.center) <= e.radius * e.radius;
	}
	distanceToPlane(e) {
		let t = e.normal.dot(this.direction);
		if (t === 0) return e.distanceToPoint(this.origin) === 0 ? 0 : null;
		let n = -(this.origin.dot(e.normal) + e.constant) / t;
		return n >= 0 ? n : null;
	}
	intersectPlane(e, t) {
		let n = this.distanceToPlane(e);
		return n === null ? null : this.at(n, t);
	}
	intersectsPlane(e) {
		let t = e.distanceToPoint(this.origin);
		return t === 0 || e.normal.dot(this.direction) * t < 0;
	}
	intersectBox(e, t) {
		let n, r, i, a, o, s, c = 1 / this.direction.x, l = 1 / this.direction.y, u = 1 / this.direction.z, d = this.origin;
		return c >= 0 ? (n = (e.min.x - d.x) * c, r = (e.max.x - d.x) * c) : (n = (e.max.x - d.x) * c, r = (e.min.x - d.x) * c), l >= 0 ? (i = (e.min.y - d.y) * l, a = (e.max.y - d.y) * l) : (i = (e.max.y - d.y) * l, a = (e.min.y - d.y) * l), n > a || i > r || ((i > n || isNaN(n)) && (n = i), (a < r || isNaN(r)) && (r = a), u >= 0 ? (o = (e.min.z - d.z) * u, s = (e.max.z - d.z) * u) : (o = (e.max.z - d.z) * u, s = (e.min.z - d.z) * u), n > s || o > r) || ((o > n || n !== n) && (n = o), (s < r || r !== r) && (r = s), r < 0) ? null : this.at(n >= 0 ? n : r, t);
	}
	intersectsBox(e) {
		return this.intersectBox(e, Pf) !== null;
	}
	intersectTriangle(e, t, n, r, i) {
		Rf.subVectors(t, e), zf.subVectors(n, e), Bf.crossVectors(Rf, zf);
		let a = this.direction.dot(Bf), o;
		if (a > 0) {
			if (r) return null;
			o = 1;
		} else if (a < 0) o = -1, a = -a;
		else return null;
		Lf.subVectors(this.origin, e);
		let s = o * this.direction.dot(zf.crossVectors(Lf, zf));
		if (s < 0) return null;
		let c = o * this.direction.dot(Rf.cross(Lf));
		if (c < 0 || s + c > a) return null;
		let l = -o * Lf.dot(Bf);
		return l < 0 ? null : this.at(l / a, i);
	}
	applyMatrix4(e) {
		return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
	}
	equals(e) {
		return e.origin.equals(this.origin) && e.direction.equals(this.direction);
	}
	clone() {
		return new this.constructor().copy(this);
	}
}, Hf = class extends Nf {
	constructor(e) {
		super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Pd(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new ld(), this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
	}
	copy(e) {
		return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
	}
}, Uf = /* @__PURE__ */ new $u(), Wf = /* @__PURE__ */ new Vf(), Gf = /* @__PURE__ */ new Cf(), Kf = /* @__PURE__ */ new X(), qf = /* @__PURE__ */ new X(), Jf = /* @__PURE__ */ new X(), Yf = /* @__PURE__ */ new X(), Xf = /* @__PURE__ */ new X(), Zf = /* @__PURE__ */ new X(), Qf = /* @__PURE__ */ new X(), $f = /* @__PURE__ */ new X(), ep = class extends Ed {
	constructor(e = new jf(), t = new Hf()) {
		super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
	}
	copy(e, t) {
		return super.copy(e, t), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
	}
	updateMorphTargets() {
		let e = this.geometry.morphAttributes, t = Object.keys(e);
		if (t.length > 0) {
			let n = e[t[0]];
			if (n !== void 0) {
				this.morphTargetInfluences = [], this.morphTargetDictionary = {};
				for (let e = 0, t = n.length; e < t; e++) {
					let t = n[e].name || String(e);
					this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e;
				}
			}
		}
	}
	getVertexPosition(e, t) {
		let n = this.geometry, r = n.attributes.position, i = n.morphAttributes.position, a = n.morphTargetsRelative;
		t.fromBufferAttribute(r, e);
		let o = this.morphTargetInfluences;
		if (i && o) {
			Zf.set(0, 0, 0);
			for (let n = 0, r = i.length; n < r; n++) {
				let r = o[n], s = i[n];
				r !== 0 && (Xf.fromBufferAttribute(s, e), a ? Zf.addScaledVector(Xf, r) : Zf.addScaledVector(Xf.sub(t), r));
			}
			t.add(Zf);
		}
		return t;
	}
	raycast(e, t) {
		let n = this.geometry, r = this.material, i = this.matrixWorld;
		r !== void 0 && (n.boundingSphere === null && n.computeBoundingSphere(), Gf.copy(n.boundingSphere), Gf.applyMatrix4(i), Wf.copy(e.ray).recast(e.near), !(Gf.containsPoint(Wf.origin) === !1 && (Wf.intersectSphere(Gf, Kf) === null || Wf.origin.distanceToSquared(Kf) > (e.far - e.near) ** 2)) && (Uf.copy(i).invert(), Wf.copy(e.ray).applyMatrix4(Uf), !(n.boundingBox !== null && Wf.intersectsBox(n.boundingBox) === !1) && this._computeIntersections(e, t, Wf)));
	}
	_computeIntersections(e, t, n) {
		let r, i = this.geometry, a = this.material, o = i.index, s = i.attributes.position, c = i.attributes.uv, l = i.attributes.uv1, u = i.attributes.normal, d = i.groups, f = i.drawRange;
		if (o !== null) if (Array.isArray(a)) for (let i = 0, s = d.length; i < s; i++) {
			let s = d[i], p = a[s.materialIndex], m = Math.max(s.start, f.start), h = Math.min(o.count, Math.min(s.start + s.count, f.start + f.count));
			for (let i = m, a = h; i < a; i += 3) {
				let a = o.getX(i), d = o.getX(i + 1), f = o.getX(i + 2);
				r = np(this, p, e, n, c, l, u, a, d, f), r && (r.faceIndex = Math.floor(i / 3), r.face.materialIndex = s.materialIndex, t.push(r));
			}
		}
		else {
			let i = Math.max(0, f.start), s = Math.min(o.count, f.start + f.count);
			for (let d = i, f = s; d < f; d += 3) {
				let i = o.getX(d), s = o.getX(d + 1), f = o.getX(d + 2);
				r = np(this, a, e, n, c, l, u, i, s, f), r && (r.faceIndex = Math.floor(d / 3), t.push(r));
			}
		}
		else if (s !== void 0) if (Array.isArray(a)) for (let i = 0, o = d.length; i < o; i++) {
			let o = d[i], p = a[o.materialIndex], m = Math.max(o.start, f.start), h = Math.min(s.count, Math.min(o.start + o.count, f.start + f.count));
			for (let i = m, a = h; i < a; i += 3) {
				let a = i, s = i + 1, d = i + 2;
				r = np(this, p, e, n, c, l, u, a, s, d), r && (r.faceIndex = Math.floor(i / 3), r.face.materialIndex = o.materialIndex, t.push(r));
			}
		}
		else {
			let i = Math.max(0, f.start), o = Math.min(s.count, f.start + f.count);
			for (let s = i, d = o; s < d; s += 3) {
				let i = s, o = s + 1, d = s + 2;
				r = np(this, a, e, n, c, l, u, i, o, d), r && (r.faceIndex = Math.floor(s / 3), t.push(r));
			}
		}
	}
};
function tp(e, t, n, r, i, a, o, s) {
	let c;
	if (c = t.side === 1 ? r.intersectTriangle(o, a, i, !0, s) : r.intersectTriangle(i, a, o, t.side === 0, s), c === null) return null;
	$f.copy(s), $f.applyMatrix4(e.matrixWorld);
	let l = n.ray.origin.distanceTo($f);
	return l < n.near || l > n.far ? null : {
		distance: l,
		point: $f.clone(),
		object: e
	};
}
function np(e, t, n, r, i, a, o, s, c, l) {
	e.getVertexPosition(s, qf), e.getVertexPosition(c, Jf), e.getVertexPosition(l, Yf);
	let u = tp(e, t, n, r, qf, Jf, Yf, Qf);
	if (u) {
		let e = new X();
		Xd.getBarycoord(Qf, qf, Jf, Yf, e), i && (u.uv = Xd.getInterpolatedAttribute(i, s, c, l, e, new Ou())), a && (u.uv1 = Xd.getInterpolatedAttribute(a, s, c, l, e, new Ou())), o && (u.normal = Xd.getInterpolatedAttribute(o, s, c, l, e, new X()), u.normal.dot(r.direction) > 0 && u.normal.multiplyScalar(-1));
		let t = {
			a: s,
			b: c,
			c: l,
			normal: new X(),
			materialIndex: 0
		};
		Xd.getNormal(qf, Jf, Yf, t.normal), u.face = t, u.barycoord = e;
	}
	return u;
}
var rp = class extends qu {
	constructor(e = null, t = 1, n = 1, r, i, a, o, s, c = _c, l = _c, u, d) {
		super(null, a, o, s, c, l, r, i, u, d), this.isDataTexture = !0, this.image = {
			data: e,
			width: t,
			height: n
		}, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
	}
}, ip = /* @__PURE__ */ new X(), ap = /* @__PURE__ */ new X(), op = /* @__PURE__ */ new Mu(), sp = class {
	constructor(e = new X(1, 0, 0), t = 0) {
		this.isPlane = !0, this.normal = e, this.constant = t;
	}
	set(e, t) {
		return this.normal.copy(e), this.constant = t, this;
	}
	setComponents(e, t, n, r) {
		return this.normal.set(e, t, n), this.constant = r, this;
	}
	setFromNormalAndCoplanarPoint(e, t) {
		return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
	}
	setFromCoplanarPoints(e, t, n) {
		let r = ip.subVectors(n, t).cross(ap.subVectors(e, t)).normalize();
		return this.setFromNormalAndCoplanarPoint(r, e), this;
	}
	copy(e) {
		return this.normal.copy(e.normal), this.constant = e.constant, this;
	}
	normalize() {
		let e = 1 / this.normal.length();
		return this.normal.multiplyScalar(e), this.constant *= e, this;
	}
	negate() {
		return this.constant *= -1, this.normal.negate(), this;
	}
	distanceToPoint(e) {
		return this.normal.dot(e) + this.constant;
	}
	distanceToSphere(e) {
		return this.distanceToPoint(e.center) - e.radius;
	}
	projectPoint(e, t) {
		return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
	}
	intersectLine(e, t, n = !0) {
		let r = e.delta(ip), i = this.normal.dot(r);
		if (i === 0) return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
		let a = -(e.start.dot(this.normal) + this.constant) / i;
		return n === !0 && (a < 0 || a > 1) ? null : t.copy(e.start).addScaledVector(r, a);
	}
	intersectsLine(e) {
		let t = this.distanceToPoint(e.start), n = this.distanceToPoint(e.end);
		return t < 0 && n > 0 || n < 0 && t > 0;
	}
	intersectsBox(e) {
		return e.intersectsPlane(this);
	}
	intersectsSphere(e) {
		return e.intersectsPlane(this);
	}
	coplanarPoint(e) {
		return e.copy(this.normal).multiplyScalar(-this.constant);
	}
	applyMatrix4(e, t) {
		let n = t || op.getNormalMatrix(e), r = this.coplanarPoint(ip).applyMatrix4(e), i = this.normal.applyMatrix3(n).normalize();
		return this.constant = -r.dot(i), this;
	}
	translate(e) {
		return this.constant -= e.dot(this.normal), this;
	}
	equals(e) {
		return e.normal.equals(this.normal) && e.constant === this.constant;
	}
	clone() {
		return new this.constructor().copy(this);
	}
}, cp = /* @__PURE__ */ new Cf(), lp = /* @__PURE__ */ new Ou(.5, .5), up = /* @__PURE__ */ new X(), dp = class {
	constructor(e = new sp(), t = new sp(), n = new sp(), r = new sp(), i = new sp(), a = new sp()) {
		this.planes = [
			e,
			t,
			n,
			r,
			i,
			a
		];
	}
	set(e, t, n, r, i, a) {
		let o = this.planes;
		return o[0].copy(e), o[1].copy(t), o[2].copy(n), o[3].copy(r), o[4].copy(i), o[5].copy(a), this;
	}
	copy(e) {
		let t = this.planes;
		for (let n = 0; n < 6; n++) t[n].copy(e.planes[n]);
		return this;
	}
	setFromProjectionMatrix(e, t = Hl, n = !1) {
		let r = this.planes, i = e.elements, a = i[0], o = i[1], s = i[2], c = i[3], l = i[4], u = i[5], d = i[6], f = i[7], p = i[8], m = i[9], h = i[10], g = i[11], _ = i[12], v = i[13], y = i[14], b = i[15];
		if (r[0].setComponents(c - a, f - l, g - p, b - _).normalize(), r[1].setComponents(c + a, f + l, g + p, b + _).normalize(), r[2].setComponents(c + o, f + u, g + m, b + v).normalize(), r[3].setComponents(c - o, f - u, g - m, b - v).normalize(), n) r[4].setComponents(s, d, h, y).normalize(), r[5].setComponents(c - s, f - d, g - h, b - y).normalize();
		else if (r[4].setComponents(c - s, f - d, g - h, b - y).normalize(), t === 2e3) r[5].setComponents(c + s, f + d, g + h, b + y).normalize();
		else if (t === 2001) r[5].setComponents(s, d, h, y).normalize();
		else throw Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
		return this;
	}
	intersectsObject(e) {
		if (e.boundingSphere !== void 0) e.boundingSphere === null && e.computeBoundingSphere(), cp.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
		else {
			let t = e.geometry;
			t.boundingSphere === null && t.computeBoundingSphere(), cp.copy(t.boundingSphere).applyMatrix4(e.matrixWorld);
		}
		return this.intersectsSphere(cp);
	}
	intersectsSprite(e) {
		return cp.center.set(0, 0, 0), cp.radius = .7071067811865476 + lp.distanceTo(e.center), cp.applyMatrix4(e.matrixWorld), this.intersectsSphere(cp);
	}
	intersectsSphere(e) {
		let t = this.planes, n = e.center, r = -e.radius;
		for (let e = 0; e < 6; e++) if (t[e].distanceToPoint(n) < r) return !1;
		return !0;
	}
	intersectsBox(e) {
		let t = this.planes;
		for (let n = 0; n < 6; n++) {
			let r = t[n];
			if (up.x = r.normal.x > 0 ? e.max.x : e.min.x, up.y = r.normal.y > 0 ? e.max.y : e.min.y, up.z = r.normal.z > 0 ? e.max.z : e.min.z, r.distanceToPoint(up) < 0) return !1;
		}
		return !0;
	}
	containsPoint(e) {
		let t = this.planes;
		for (let n = 0; n < 6; n++) if (t[n].distanceToPoint(e) < 0) return !1;
		return !0;
	}
	clone() {
		return new this.constructor().copy(this);
	}
}, fp = class extends Nf {
	constructor(e) {
		super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Pd(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e);
	}
	copy(e) {
		return super.copy(e), this.color.copy(e.color), this.map = e.map, this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this.fog = e.fog, this;
	}
}, pp = /* @__PURE__ */ new X(), mp = /* @__PURE__ */ new X(), hp = /* @__PURE__ */ new $u(), gp = /* @__PURE__ */ new Vf(), _p = /* @__PURE__ */ new Cf(), vp = /* @__PURE__ */ new X(), yp = /* @__PURE__ */ new X(), bp = class extends Ed {
	constructor(e = new jf(), t = new fp()) {
		super(), this.isLine = !0, this.type = "Line", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
	}
	copy(e, t) {
		return super.copy(e, t), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
	}
	computeLineDistances() {
		let e = this.geometry;
		if (e.index === null) {
			let t = e.attributes.position, n = [0];
			for (let e = 1, r = t.count; e < r; e++) pp.fromBufferAttribute(t, e - 1), mp.fromBufferAttribute(t, e), n[e] = n[e - 1], n[e] += pp.distanceTo(mp);
			e.setAttribute("lineDistance", new yf(n, 1));
		} else Zl("Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
		return this;
	}
	raycast(e, t) {
		let n = this.geometry, r = this.matrixWorld, i = e.params.Line.threshold, a = n.drawRange;
		if (n.boundingSphere === null && n.computeBoundingSphere(), _p.copy(n.boundingSphere), _p.applyMatrix4(r), _p.radius += i, e.ray.intersectsSphere(_p) === !1) return;
		hp.copy(r).invert(), gp.copy(e.ray).applyMatrix4(hp);
		let o = i / ((this.scale.x + this.scale.y + this.scale.z) / 3), s = o * o, c = this.isLineSegments ? 2 : 1, l = n.index, u = n.attributes.position;
		if (l !== null) {
			let n = Math.max(0, a.start), r = Math.min(l.count, a.start + a.count);
			for (let i = n, a = r - 1; i < a; i += c) {
				let n = l.getX(i), r = l.getX(i + 1), a = xp(this, e, gp, s, n, r, i);
				a && t.push(a);
			}
			if (this.isLineLoop) {
				let i = l.getX(r - 1), a = l.getX(n), o = xp(this, e, gp, s, i, a, r - 1);
				o && t.push(o);
			}
		} else {
			let n = Math.max(0, a.start), r = Math.min(u.count, a.start + a.count);
			for (let i = n, a = r - 1; i < a; i += c) {
				let n = xp(this, e, gp, s, i, i + 1, i);
				n && t.push(n);
			}
			if (this.isLineLoop) {
				let i = xp(this, e, gp, s, r - 1, n, r - 1);
				i && t.push(i);
			}
		}
	}
	updateMorphTargets() {
		let e = this.geometry.morphAttributes, t = Object.keys(e);
		if (t.length > 0) {
			let n = e[t[0]];
			if (n !== void 0) {
				this.morphTargetInfluences = [], this.morphTargetDictionary = {};
				for (let e = 0, t = n.length; e < t; e++) {
					let t = n[e].name || String(e);
					this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e;
				}
			}
		}
	}
};
function xp(e, t, n, r, i, a, o) {
	let s = e.geometry.attributes.position;
	if (pp.fromBufferAttribute(s, i), mp.fromBufferAttribute(s, a), n.distanceSqToSegment(pp, mp, vp, yp) > r) return;
	vp.applyMatrix4(e.matrixWorld);
	let c = t.ray.origin.distanceTo(vp);
	if (!(c < t.near || c > t.far)) return {
		distance: c,
		point: yp.clone().applyMatrix4(e.matrixWorld),
		index: o,
		face: null,
		faceIndex: null,
		barycoord: null,
		object: e
	};
}
var Sp = /* @__PURE__ */ new X(), Cp = /* @__PURE__ */ new X(), wp = class extends bp {
	constructor(e, t) {
		super(e, t), this.isLineSegments = !0, this.type = "LineSegments";
	}
	computeLineDistances() {
		let e = this.geometry;
		if (e.index === null) {
			let t = e.attributes.position, n = [];
			for (let e = 0, r = t.count; e < r; e += 2) Sp.fromBufferAttribute(t, e), Cp.fromBufferAttribute(t, e + 1), n[e] = e === 0 ? 0 : n[e - 1], n[e + 1] = n[e] + Sp.distanceTo(Cp);
			e.setAttribute("lineDistance", new yf(n, 1));
		} else Zl("LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
		return this;
	}
}, Tp = class extends qu {
	constructor(e = [], t = 301, n, r, i, a, o, s, c, l) {
		super(e, t, n, r, i, a, o, s, c, l), this.isCubeTexture = !0, this.flipY = !1;
	}
	get images() {
		return this.image;
	}
	set images(e) {
		this.image = e;
	}
}, Ep = class extends qu {
	constructor(e, t, n = Oc, r, i, a, o = _c, s = _c, c, l = zc, u = 1) {
		if (l !== 1026 && l !== 1027) throw Error("THREE.DepthTexture: format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
		super({
			width: e,
			height: t,
			depth: u
		}, r, i, a, o, s, l, n, c), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
	}
	copy(e) {
		return super.copy(e), this.source = new Uu(Object.assign({}, e.image)), this.compareFunction = e.compareFunction, this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return this.compareFunction !== null && (t.compareFunction = this.compareFunction), t;
	}
}, Dp = class extends Ep {
	constructor(e, t = Oc, n = 301, r, i, a = _c, o = _c, s, c = zc) {
		let l = {
			width: e,
			height: e,
			depth: 1
		}, u = [
			l,
			l,
			l,
			l,
			l,
			l
		];
		super(e, e, t, n, r, i, a, o, s, c), this.image = u, this.isCubeDepthTexture = !0, this.isCubeTexture = !0;
	}
	get images() {
		return this.image;
	}
	set images(e) {
		this.image = e;
	}
}, Op = class extends qu {
	constructor(e = null) {
		super(), this.sourceTexture = e, this.isExternalTexture = !0;
	}
	copy(e) {
		return super.copy(e), this.sourceTexture = e.sourceTexture, this;
	}
}, kp = class e extends jf {
	constructor(e = 1, t = 1, n = 1, r = 1, i = 1, a = 1) {
		super(), this.type = "BoxGeometry", this.parameters = {
			width: e,
			height: t,
			depth: n,
			widthSegments: r,
			heightSegments: i,
			depthSegments: a
		};
		let o = this;
		r = Math.floor(r), i = Math.floor(i), a = Math.floor(a);
		let s = [], c = [], l = [], u = [], d = 0, f = 0;
		p("z", "y", "x", -1, -1, n, t, e, a, i, 0), p("z", "y", "x", 1, -1, n, t, -e, a, i, 1), p("x", "z", "y", 1, 1, e, n, t, r, a, 2), p("x", "z", "y", 1, -1, e, n, -t, r, a, 3), p("x", "y", "z", 1, -1, e, t, n, r, i, 4), p("x", "y", "z", -1, -1, e, t, -n, r, i, 5), this.setIndex(s), this.setAttribute("position", new yf(c, 3)), this.setAttribute("normal", new yf(l, 3)), this.setAttribute("uv", new yf(u, 2));
		function p(e, t, n, r, i, a, p, m, h, g, _) {
			let v = a / h, y = p / g, b = a / 2, x = p / 2, S = m / 2, C = h + 1, w = g + 1, T = 0, E = 0, D = new X();
			for (let a = 0; a < w; a++) {
				let o = a * y - x;
				for (let s = 0; s < C; s++) D[e] = (s * v - b) * r, D[t] = o * i, D[n] = S, c.push(D.x, D.y, D.z), D[e] = 0, D[t] = 0, D[n] = m > 0 ? 1 : -1, l.push(D.x, D.y, D.z), u.push(s / h), u.push(1 - a / g), T += 1;
			}
			for (let e = 0; e < g; e++) for (let t = 0; t < h; t++) {
				let n = d + t + C * e, r = d + t + C * (e + 1), i = d + (t + 1) + C * (e + 1), a = d + (t + 1) + C * e;
				s.push(n, r, a), s.push(r, i, a), E += 6;
			}
			o.addGroup(f, E, _), f += E, d += T;
		}
	}
	copy(e) {
		return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
	}
	static fromJSON(t) {
		return new e(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
	}
}, Ap = /* @__PURE__ */ new X(), jp = /* @__PURE__ */ new X(), Mp = /* @__PURE__ */ new X(), Np = /* @__PURE__ */ new Xd(), Pp = class extends jf {
	constructor(e = null, t = 1) {
		if (super(), this.type = "EdgesGeometry", this.parameters = {
			geometry: e,
			thresholdAngle: t
		}, e !== null) {
			let n = 10 ** 4, r = Math.cos(iu * t), i = e.getIndex(), a = e.getAttribute("position"), o = i ? i.count : a.count, s = [
				0,
				0,
				0
			], c = [
				"a",
				"b",
				"c"
			], l = [
				,
				,
				,
			], u = {}, d = [];
			for (let e = 0; e < o; e += 3) {
				i ? (s[0] = i.getX(e), s[1] = i.getX(e + 1), s[2] = i.getX(e + 2)) : (s[0] = e, s[1] = e + 1, s[2] = e + 2);
				let { a: t, b: o, c: f } = Np;
				if (t.fromBufferAttribute(a, s[0]), o.fromBufferAttribute(a, s[1]), f.fromBufferAttribute(a, s[2]), Np.getNormal(Mp), l[0] = `${Math.round(t.x * n)},${Math.round(t.y * n)},${Math.round(t.z * n)}`, l[1] = `${Math.round(o.x * n)},${Math.round(o.y * n)},${Math.round(o.z * n)}`, l[2] = `${Math.round(f.x * n)},${Math.round(f.y * n)},${Math.round(f.z * n)}`, !(l[0] === l[1] || l[1] === l[2] || l[2] === l[0])) for (let e = 0; e < 3; e++) {
					let t = (e + 1) % 3, n = l[e], i = l[t], a = Np[c[e]], o = Np[c[t]], f = `${n}_${i}`, p = `${i}_${n}`;
					p in u && u[p] ? (Mp.dot(u[p].normal) <= r && (d.push(a.x, a.y, a.z), d.push(o.x, o.y, o.z)), u[p] = null) : f in u || (u[f] = {
						index0: s[e],
						index1: s[t],
						normal: Mp.clone()
					});
				}
			}
			for (let e in u) if (u[e]) {
				let { index0: t, index1: n } = u[e];
				Ap.fromBufferAttribute(a, t), jp.fromBufferAttribute(a, n), d.push(Ap.x, Ap.y, Ap.z), d.push(jp.x, jp.y, jp.z);
			}
			this.setAttribute("position", new yf(d, 3));
		}
	}
	copy(e) {
		return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
	}
}, Fp = class e extends jf {
	constructor(e = 1, t = 1, n = 1, r = 1) {
		super(), this.type = "PlaneGeometry", this.parameters = {
			width: e,
			height: t,
			widthSegments: n,
			heightSegments: r
		};
		let i = e / 2, a = t / 2, o = Math.floor(n), s = Math.floor(r), c = o + 1, l = s + 1, u = e / o, d = t / s, f = [], p = [], m = [], h = [];
		for (let e = 0; e < l; e++) {
			let t = e * d - a;
			for (let n = 0; n < c; n++) {
				let r = n * u - i;
				p.push(r, -t, 0), m.push(0, 0, 1), h.push(n / o), h.push(1 - e / s);
			}
		}
		for (let e = 0; e < s; e++) for (let t = 0; t < o; t++) {
			let n = t + c * e, r = t + c * (e + 1), i = t + 1 + c * (e + 1), a = t + 1 + c * e;
			f.push(n, r, a), f.push(r, i, a);
		}
		this.setIndex(f), this.setAttribute("position", new yf(p, 3)), this.setAttribute("normal", new yf(m, 3)), this.setAttribute("uv", new yf(h, 2));
	}
	copy(e) {
		return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
	}
	static fromJSON(t) {
		return new e(t.width, t.height, t.widthSegments, t.heightSegments);
	}
};
function Ip(e) {
	let t = {};
	for (let n in e) {
		t[n] = {};
		for (let r in e[n]) {
			let i = e[n][r];
			if (Rp(i)) i.isRenderTargetTexture ? (Zl("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), t[n][r] = null) : t[n][r] = i.clone();
			else if (Array.isArray(i)) if (Rp(i[0])) {
				let e = [];
				for (let t = 0, n = i.length; t < n; t++) e[t] = i[t].clone();
				t[n][r] = e;
			} else t[n][r] = i.slice();
			else t[n][r] = i;
		}
	}
	return t;
}
function Lp(e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = Ip(e[n]);
		for (let e in r) t[e] = r[e];
	}
	return t;
}
function Rp(e) {
	return e && (e.isColor || e.isMatrix3 || e.isMatrix4 || e.isVector2 || e.isVector3 || e.isVector4 || e.isTexture || e.isQuaternion);
}
function zp(e) {
	let t = [];
	for (let n = 0; n < e.length; n++) t.push(e[n].clone());
	return t;
}
function Bp(e) {
	let t = e.getRenderTarget();
	return t === null ? e.outputColorSpace : t.isXRRenderTarget === !0 ? t.texture.colorSpace : Lu.workingColorSpace;
}
var Vp = {
	clone: Ip,
	merge: Lp
}, Hp = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", Up = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", Wp = class extends Nf {
	constructor(e) {
		super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = Hp, this.fragmentShader = Up, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
			clipCullDistance: !1,
			multiDraw: !1
		}, this.defaultAttributeValues = {
			color: [
				1,
				1,
				1
			],
			uv: [0, 0],
			uv1: [0, 0]
		}, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && this.setValues(e);
	}
	copy(e) {
		return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = Ip(e.uniforms), this.uniformsGroups = zp(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this.defaultAttributeValues = Object.assign({}, e.defaultAttributeValues), this.index0AttributeName = e.index0AttributeName, this.uniformsNeedUpdate = e.uniformsNeedUpdate, this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		t.glslVersion = this.glslVersion, t.uniforms = {};
		for (let n in this.uniforms) {
			let r = this.uniforms[n].value;
			r && r.isTexture ? t.uniforms[n] = {
				type: "t",
				value: r.toJSON(e).uuid
			} : r && r.isColor ? t.uniforms[n] = {
				type: "c",
				value: r.getHex()
			} : r && r.isVector2 ? t.uniforms[n] = {
				type: "v2",
				value: r.toArray()
			} : r && r.isVector3 ? t.uniforms[n] = {
				type: "v3",
				value: r.toArray()
			} : r && r.isVector4 ? t.uniforms[n] = {
				type: "v4",
				value: r.toArray()
			} : r && r.isMatrix3 ? t.uniforms[n] = {
				type: "m3",
				value: r.toArray()
			} : r && r.isMatrix4 ? t.uniforms[n] = {
				type: "m4",
				value: r.toArray()
			} : t.uniforms[n] = { value: r };
		}
		Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t.lights = this.lights, t.clipping = this.clipping;
		let n = {};
		for (let e in this.extensions) this.extensions[e] === !0 && (n[e] = !0);
		return Object.keys(n).length > 0 && (t.extensions = n), t;
	}
	fromJSON(e, t) {
		if (super.fromJSON(e, t), e.uniforms !== void 0) for (let n in e.uniforms) {
			let r = e.uniforms[n];
			switch (this.uniforms[n] = {}, r.type) {
				case "t":
					this.uniforms[n].value = t[r.value] || null;
					break;
				case "c":
					this.uniforms[n].value = new Pd().setHex(r.value);
					break;
				case "v2":
					this.uniforms[n].value = new Ou().fromArray(r.value);
					break;
				case "v3":
					this.uniforms[n].value = new X().fromArray(r.value);
					break;
				case "v4":
					this.uniforms[n].value = new Ju().fromArray(r.value);
					break;
				case "m3":
					this.uniforms[n].value = new Mu().fromArray(r.value);
					break;
				case "m4":
					this.uniforms[n].value = new $u().fromArray(r.value);
					break;
				default: this.uniforms[n].value = r.value;
			}
		}
		if (e.defines !== void 0 && (this.defines = e.defines), e.vertexShader !== void 0 && (this.vertexShader = e.vertexShader), e.fragmentShader !== void 0 && (this.fragmentShader = e.fragmentShader), e.glslVersion !== void 0 && (this.glslVersion = e.glslVersion), e.extensions !== void 0) for (let t in e.extensions) this.extensions[t] = e.extensions[t];
		return e.lights !== void 0 && (this.lights = e.lights), e.clipping !== void 0 && (this.clipping = e.clipping), this;
	}
}, Gp = class extends Wp {
	constructor(e) {
		super(e), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
	}
}, Kp = class extends Nf {
	constructor(e) {
		super(), this.isMeshStandardMaterial = !0, this.type = "MeshStandardMaterial", this.defines = { STANDARD: "" }, this.color = new Pd(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Pd(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new Ou(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new ld(), this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
	}
	copy(e) {
		return super.copy(e), this.defines = { STANDARD: "" }, this.color.copy(e.color), this.roughness = e.roughness, this.metalness = e.metalness, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.roughnessMap = e.roughnessMap, this.metalnessMap = e.metalnessMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.envMapIntensity = e.envMapIntensity, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
	}
}, qp = class extends Nf {
	constructor(e) {
		super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = Fl, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
	}
	copy(e) {
		return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
	}
}, Jp = class extends Nf {
	constructor(e) {
		super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
	}
	copy(e) {
		return super.copy(e), this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
	}
};
function Yp(e, t) {
	return !e || e.constructor === t ? e : typeof t.BYTES_PER_ELEMENT == "number" ? new t(e) : Array.prototype.slice.call(e);
}
var Xp = class {
	constructor(e, t, n, r) {
		this.parameterPositions = e, this._cachedIndex = 0, this.resultBuffer = r === void 0 ? new t.constructor(n) : r, this.sampleValues = t, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
	}
	evaluate(e) {
		let t = this.parameterPositions, n = this._cachedIndex, r = t[n], i = t[n - 1];
		validate_interval: {
			seek: {
				let a;
				linear_scan: {
					forward_scan: if (!(e < r)) {
						for (let a = n + 2;;) {
							if (r === void 0) {
								if (e < i) break forward_scan;
								return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
							}
							if (n === a) break;
							if (i = r, r = t[++n], e < r) break seek;
						}
						a = t.length;
						break linear_scan;
					}
					if (!(e >= i)) {
						let o = t[1];
						e < o && (n = 2, i = o);
						for (let a = n - 2;;) {
							if (i === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
							if (n === a) break;
							if (r = i, i = t[--n - 1], e >= i) break seek;
						}
						a = n, n = 0;
						break linear_scan;
					}
					break validate_interval;
				}
				for (; n < a;) {
					let r = n + a >>> 1;
					e < t[r] ? a = r : n = r + 1;
				}
				if (r = t[n], i = t[n - 1], i === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
				if (r === void 0) return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
			}
			this._cachedIndex = n, this.intervalChanged_(n, i, r);
		}
		return this.interpolate_(n, i, e, r);
	}
	getSettings_() {
		return this.settings || this.DefaultSettings_;
	}
	copySampleValue_(e) {
		let t = this.resultBuffer, n = this.sampleValues, r = this.valueSize, i = e * r;
		for (let e = 0; e !== r; ++e) t[e] = n[i + e];
		return t;
	}
	interpolate_() {
		throw Error("THREE.Interpolant: Call to abstract method.");
	}
	intervalChanged_() {}
}, Zp = class extends Xp {
	constructor(e, t, n, r) {
		super(e, t, n, r), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
			endingStart: Ml,
			endingEnd: Ml
		};
	}
	intervalChanged_(e, t, n) {
		let r = this.parameterPositions, i = e - 2, a = e + 1, o = r[i], s = r[a];
		if (o === void 0) switch (this.getSettings_().endingStart) {
			case Nl:
				i = e, o = 2 * t - n;
				break;
			case Pl:
				i = r.length - 2, o = t + r[i] - r[i + 1];
				break;
			default: i = e, o = n;
		}
		if (s === void 0) switch (this.getSettings_().endingEnd) {
			case Nl:
				a = e, s = 2 * n - t;
				break;
			case Pl:
				a = 1, s = n + r[1] - r[0];
				break;
			default: a = e - 1, s = t;
		}
		let c = (n - t) * .5, l = this.valueSize;
		this._weightPrev = c / (t - o), this._weightNext = c / (s - n), this._offsetPrev = i * l, this._offsetNext = a * l;
	}
	interpolate_(e, t, n, r) {
		let i = this.resultBuffer, a = this.sampleValues, o = this.valueSize, s = e * o, c = s - o, l = this._offsetPrev, u = this._offsetNext, d = this._weightPrev, f = this._weightNext, p = (n - t) / (r - t), m = p * p, h = m * p, g = -d * h + 2 * d * m - d * p, _ = (1 + d) * h + (-1.5 - 2 * d) * m + (-.5 + d) * p + 1, v = (-1 - f) * h + (1.5 + f) * m + .5 * p, y = f * h - f * m;
		for (let e = 0; e !== o; ++e) i[e] = g * a[l + e] + _ * a[c + e] + v * a[s + e] + y * a[u + e];
		return i;
	}
}, Qp = class extends Xp {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
	interpolate_(e, t, n, r) {
		let i = this.resultBuffer, a = this.sampleValues, o = this.valueSize, s = e * o, c = s - o, l = (n - t) / (r - t), u = 1 - l;
		for (let e = 0; e !== o; ++e) i[e] = a[c + e] * u + a[s + e] * l;
		return i;
	}
}, $p = class extends Xp {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
	interpolate_(e) {
		return this.copySampleValue_(e - 1);
	}
}, em = class extends Xp {
	interpolate_(e, t, n, r) {
		let i = this.resultBuffer, a = this.sampleValues, o = this.valueSize, s = e * o, c = s - o, l = this.inTangents, u = this.outTangents;
		if (!l || !u) {
			let e = (n - t) / (r - t), l = 1 - e;
			for (let t = 0; t !== o; ++t) i[t] = a[c + t] * l + a[s + t] * e;
			return i;
		}
		let d = o * 2, f = e - 1;
		for (let p = 0; p !== o; ++p) {
			let o = a[c + p], m = a[s + p], h = f * d + p * 2, g = u[h], _ = u[h + 1], v = e * d + p * 2, y = l[v], b = l[v + 1], x = (n - t) / (r - t), S, C, w, T, E;
			for (let e = 0; e < 8; e++) {
				S = x * x, C = S * x, w = 1 - x, T = w * w, E = T * w;
				let e = E * t + 3 * T * x * g + 3 * w * S * y + C * r - n;
				if (Math.abs(e) < 1e-10) break;
				let i = 3 * T * (g - t) + 6 * w * x * (y - g) + 3 * S * (r - y);
				if (Math.abs(i) < 1e-10) break;
				x -= e / i, x = Math.max(0, Math.min(1, x));
			}
			i[p] = E * o + 3 * T * x * _ + 3 * w * S * b + C * m;
		}
		return i;
	}
}, tm = class {
	constructor(e, t, n, r) {
		if (e === void 0) throw Error("THREE.KeyframeTrack: track name is undefined");
		if (t === void 0 || t.length === 0) throw Error("THREE.KeyframeTrack: no keyframes in track named " + e);
		this.name = e, this.times = Yp(t, this.TimeBufferType), this.values = Yp(n, this.ValueBufferType), this.setInterpolation(r || this.DefaultInterpolation);
	}
	static toJSON(e) {
		let t = e.constructor, n;
		if (t.toJSON !== this.toJSON) n = t.toJSON(e);
		else {
			n = {
				name: e.name,
				times: Yp(e.times, Array),
				values: Yp(e.values, Array)
			};
			let t = e.getInterpolation();
			t !== e.DefaultInterpolation && (n.interpolation = t);
		}
		return n.type = e.ValueTypeName, n;
	}
	InterpolantFactoryMethodDiscrete(e) {
		return new $p(this.times, this.values, this.getValueSize(), e);
	}
	InterpolantFactoryMethodLinear(e) {
		return new Qp(this.times, this.values, this.getValueSize(), e);
	}
	InterpolantFactoryMethodSmooth(e) {
		return new Zp(this.times, this.values, this.getValueSize(), e);
	}
	InterpolantFactoryMethodBezier(e) {
		let t = new em(this.times, this.values, this.getValueSize(), e);
		return this.settings && (t.inTangents = this.settings.inTangents, t.outTangents = this.settings.outTangents), t;
	}
	setInterpolation(e) {
		let t;
		switch (e) {
			case Ol:
				t = this.InterpolantFactoryMethodDiscrete;
				break;
			case kl:
				t = this.InterpolantFactoryMethodLinear;
				break;
			case Al:
				t = this.InterpolantFactoryMethodSmooth;
				break;
			case jl:
				t = this.InterpolantFactoryMethodBezier;
				break;
		}
		if (t === void 0) {
			let t = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
			if (this.createInterpolant === void 0) if (e !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
			else throw Error(t);
			return Zl("KeyframeTrack:", t), this;
		}
		return this.createInterpolant = t, this;
	}
	getInterpolation() {
		switch (this.createInterpolant) {
			case this.InterpolantFactoryMethodDiscrete: return Ol;
			case this.InterpolantFactoryMethodLinear: return kl;
			case this.InterpolantFactoryMethodSmooth: return Al;
			case this.InterpolantFactoryMethodBezier: return jl;
		}
	}
	getValueSize() {
		return this.values.length / this.times.length;
	}
	shift(e) {
		if (e !== 0) {
			let t = this.times;
			for (let n = 0, r = t.length; n !== r; ++n) t[n] += e;
		}
		return this;
	}
	scale(e) {
		if (e !== 1) {
			let t = this.times;
			for (let n = 0, r = t.length; n !== r; ++n) t[n] *= e;
		}
		return this;
	}
	trim(e, t) {
		let n = this.times, r = n.length, i = 0, a = r - 1;
		for (; i !== r && n[i] < e;) ++i;
		for (; a !== -1 && n[a] > t;) --a;
		if (++a, i !== 0 || a !== r) {
			i >= a && (a = Math.max(a, 1), i = a - 1);
			let e = this.getValueSize();
			this.times = n.slice(i, a), this.values = this.values.slice(i * e, a * e);
		}
		return this;
	}
	validate() {
		let e = !0, t = this.getValueSize();
		t - Math.floor(t) !== 0 && (J("KeyframeTrack: Invalid value size in track.", this), e = !1);
		let n = this.times, r = this.values, i = n.length;
		i === 0 && (J("KeyframeTrack: Track is empty.", this), e = !1);
		let a = null;
		for (let t = 0; t !== i; t++) {
			let r = n[t];
			if (typeof r == "number" && isNaN(r)) {
				J("KeyframeTrack: Time is not a valid number.", this, t, r), e = !1;
				break;
			}
			if (a !== null && a > r) {
				J("KeyframeTrack: Out of order keys.", this, t, r, a), e = !1;
				break;
			}
			a = r;
		}
		if (r !== void 0 && Wl(r)) for (let t = 0, n = r.length; t !== n; ++t) {
			let n = r[t];
			if (isNaN(n)) {
				J("KeyframeTrack: Value is not a valid number.", this, t, n), e = !1;
				break;
			}
		}
		return e;
	}
	optimize() {
		let e = this.times.slice(), t = this.values.slice(), n = this.getValueSize(), r = this.getInterpolation() === Al, i = e.length - 1, a = 1;
		for (let o = 1; o < i; ++o) {
			let i = !1, s = e[o];
			if (s !== e[o + 1] && (o !== 1 || s !== e[0])) if (r) i = !0;
			else {
				let e = o * n, r = e - n, a = e + n;
				for (let o = 0; o !== n; ++o) {
					let n = t[e + o];
					if (n !== t[r + o] || n !== t[a + o]) {
						i = !0;
						break;
					}
				}
			}
			if (i) {
				if (o !== a) {
					e[a] = e[o];
					let r = o * n, i = a * n;
					for (let e = 0; e !== n; ++e) t[i + e] = t[r + e];
				}
				++a;
			}
		}
		if (i > 0) {
			e[a] = e[i];
			for (let e = i * n, r = a * n, o = 0; o !== n; ++o) t[r + o] = t[e + o];
			++a;
		}
		return a === e.length ? (this.times = e, this.values = t) : (this.times = e.slice(0, a), this.values = t.slice(0, a * n)), this;
	}
	clone() {
		let e = this.times.slice(), t = this.values.slice(), n = this.constructor, r = new n(this.name, e, t);
		return r.createInterpolant = this.createInterpolant, r;
	}
};
tm.prototype.ValueTypeName = "", tm.prototype.TimeBufferType = Float32Array, tm.prototype.ValueBufferType = Float32Array, tm.prototype.DefaultInterpolation = kl;
var nm = class extends tm {
	constructor(e, t, n) {
		super(e, t, n);
	}
};
nm.prototype.ValueTypeName = "bool", nm.prototype.ValueBufferType = Array, nm.prototype.DefaultInterpolation = Ol, nm.prototype.InterpolantFactoryMethodLinear = void 0, nm.prototype.InterpolantFactoryMethodSmooth = void 0;
var rm = class extends tm {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
};
rm.prototype.ValueTypeName = "color";
var im = class extends tm {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
};
im.prototype.ValueTypeName = "number";
var am = class extends Xp {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
	interpolate_(e, t, n, r) {
		let i = this.resultBuffer, a = this.sampleValues, o = this.valueSize, s = (n - t) / (r - t), c = e * o;
		for (let e = c + o; c !== e; c += 4) ku.slerpFlat(i, 0, a, c - o, a, c, s);
		return i;
	}
}, om = class extends tm {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
	InterpolantFactoryMethodLinear(e) {
		return new am(this.times, this.values, this.getValueSize(), e);
	}
};
om.prototype.ValueTypeName = "quaternion", om.prototype.InterpolantFactoryMethodSmooth = void 0;
var sm = class extends tm {
	constructor(e, t, n) {
		super(e, t, n);
	}
};
sm.prototype.ValueTypeName = "string", sm.prototype.ValueBufferType = Array, sm.prototype.DefaultInterpolation = Ol, sm.prototype.InterpolantFactoryMethodLinear = void 0, sm.prototype.InterpolantFactoryMethodSmooth = void 0;
var cm = class extends tm {
	constructor(e, t, n, r) {
		super(e, t, n, r);
	}
};
cm.prototype.ValueTypeName = "vector";
var lm = /* @__PURE__ */ new class {
	constructor(e, t, n) {
		let r = this, i = !1, a = 0, o = 0, s, c = [];
		this.onStart = void 0, this.onLoad = e, this.onProgress = t, this.onError = n, this._abortController = null, this.itemStart = function(e) {
			o++, i === !1 && r.onStart !== void 0 && r.onStart(e, a, o), i = !0;
		}, this.itemEnd = function(e) {
			a++, r.onProgress !== void 0 && r.onProgress(e, a, o), a === o && (i = !1, r.onLoad !== void 0 && r.onLoad());
		}, this.itemError = function(e) {
			r.onError !== void 0 && r.onError(e);
		}, this.resolveURL = function(e) {
			return e = e.normalize("NFC"), s ? s(e) : e;
		}, this.setURLModifier = function(e) {
			return s = e, this;
		}, this.addHandler = function(e, t) {
			return c.push(e, t), this;
		}, this.removeHandler = function(e) {
			let t = c.indexOf(e);
			return t !== -1 && c.splice(t, 2), this;
		}, this.getHandler = function(e) {
			for (let t = 0, n = c.length; t < n; t += 2) {
				let n = c[t], r = c[t + 1];
				if (n.global && (n.lastIndex = 0), n.test(e)) return r;
			}
			return null;
		}, this.abort = function() {
			return this.abortController.abort(), this._abortController = null, this;
		};
	}
	get abortController() {
		return this._abortController ||= new AbortController(), this._abortController;
	}
}(), um = class {
	constructor(e) {
		this.manager = e === void 0 ? lm : e, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {}, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
	}
	load() {}
	loadAsync(e, t) {
		let n = this;
		return new Promise(function(r, i) {
			n.load(e, r, t, i);
		});
	}
	parse() {}
	setCrossOrigin(e) {
		return this.crossOrigin = e, this;
	}
	setWithCredentials(e) {
		return this.withCredentials = e, this;
	}
	setPath(e) {
		return this.path = e, this;
	}
	setResourcePath(e) {
		return this.resourcePath = e, this;
	}
	setRequestHeader(e) {
		return this.requestHeader = e, this;
	}
	abort() {
		return this;
	}
};
um.DEFAULT_MATERIAL_NAME = "__DEFAULT";
var dm = class extends Ed {
	constructor(e, t = 1) {
		super(), this.isLight = !0, this.type = "Light", this.color = new Pd(e), this.intensity = t;
	}
	dispose() {
		this.dispatchEvent({ type: "dispose" });
	}
	copy(e, t) {
		return super.copy(e, t), this.color.copy(e.color), this.intensity = e.intensity, this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return t.object.color = this.color.getHex(), t.object.intensity = this.intensity, t;
	}
}, fm = class extends dm {
	constructor(e, t, n) {
		super(e, n), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(Ed.DEFAULT_UP), this.updateMatrix(), this.groundColor = new Pd(t);
	}
	copy(e, t) {
		return super.copy(e, t), this.groundColor.copy(e.groundColor), this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return t.object.groundColor = this.groundColor.getHex(), t;
	}
}, pm = /* @__PURE__ */ new $u(), mm = /* @__PURE__ */ new X(), hm = /* @__PURE__ */ new X(), gm = class {
	constructor(e) {
		this.camera = e, this.intensity = 1, this.bias = 0, this.biasNode = null, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new Ou(512, 512), this.mapType = Cc, this.map = null, this.mapPass = null, this.matrix = new $u(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new dp(), this._frameExtents = new Ou(1, 1), this._viewportCount = 1, this._viewports = [new Ju(0, 0, 1, 1)];
	}
	getViewportCount() {
		return this._viewportCount;
	}
	getFrustum() {
		return this._frustum;
	}
	updateMatrices(e) {
		let t = this.camera, n = this.matrix;
		mm.setFromMatrixPosition(e.matrixWorld), t.position.copy(mm), hm.setFromMatrixPosition(e.target.matrixWorld), t.lookAt(hm), t.updateMatrixWorld(), pm.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), this._frustum.setFromProjectionMatrix(pm, t.coordinateSystem, t.reversedDepth), t.coordinateSystem === 2001 || t.reversedDepth ? n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, 1, 0, 0, 0, 0, 1) : n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply(pm);
	}
	getViewport(e) {
		return this._viewports[e];
	}
	getFrameExtents() {
		return this._frameExtents;
	}
	dispose() {
		this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
	}
	copy(e) {
		return this.camera = e.camera.clone(), this.intensity = e.intensity, this.bias = e.bias, this.radius = e.radius, this.autoUpdate = e.autoUpdate, this.needsUpdate = e.needsUpdate, this.normalBias = e.normalBias, this.blurSamples = e.blurSamples, this.mapSize.copy(e.mapSize), this.biasNode = e.biasNode, this;
	}
	clone() {
		return new this.constructor().copy(this);
	}
	toJSON() {
		let e = {};
		return this.intensity !== 1 && (e.intensity = this.intensity), this.bias !== 0 && (e.bias = this.bias), this.normalBias !== 0 && (e.normalBias = this.normalBias), this.radius !== 1 && (e.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (e.mapSize = this.mapSize.toArray()), e.camera = this.camera.toJSON(!1).object, delete e.camera.matrix, e;
	}
}, _m = /* @__PURE__ */ new X(), vm = /* @__PURE__ */ new ku(), ym = /* @__PURE__ */ new X(), bm = class extends Ed {
	constructor() {
		super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new $u(), this.projectionMatrix = new $u(), this.projectionMatrixInverse = new $u(), this.coordinateSystem = Hl, this._reversedDepth = !1;
	}
	get reversedDepth() {
		return this._reversedDepth;
	}
	copy(e, t) {
		return super.copy(e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
	}
	getWorldDirection(e) {
		return super.getWorldDirection(e).negate();
	}
	updateMatrixWorld(e) {
		super.updateMatrixWorld(e), this.matrixWorld.decompose(_m, vm, ym), ym.x === 1 && ym.y === 1 && ym.z === 1 ? this.matrixWorldInverse.copy(this.matrixWorld).invert() : this.matrixWorldInverse.compose(_m, vm, ym.set(1, 1, 1)).invert();
	}
	updateWorldMatrix(e, t, n = !1) {
		super.updateWorldMatrix(e, t, n), this.matrixWorld.decompose(_m, vm, ym), ym.x === 1 && ym.y === 1 && ym.z === 1 ? this.matrixWorldInverse.copy(this.matrixWorld).invert() : this.matrixWorldInverse.compose(_m, vm, ym.set(1, 1, 1)).invert();
	}
	clone() {
		return new this.constructor().copy(this);
	}
}, xm = /* @__PURE__ */ new X(), Sm = /* @__PURE__ */ new Ou(), Cm = /* @__PURE__ */ new Ou(), wm = class extends bm {
	constructor(e = 50, t = 1, n = .1, r = 2e3) {
		super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = n, this.far = r, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
	}
	copy(e, t) {
		return super.copy(e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
	}
	setFocalLength(e) {
		let t = .5 * this.getFilmHeight() / e;
		this.fov = au * 2 * Math.atan(t), this.updateProjectionMatrix();
	}
	getFocalLength() {
		let e = Math.tan(iu * .5 * this.fov);
		return .5 * this.getFilmHeight() / e;
	}
	getEffectiveFOV() {
		return au * 2 * Math.atan(Math.tan(iu * .5 * this.fov) / this.zoom);
	}
	getFilmWidth() {
		return this.filmGauge * Math.min(this.aspect, 1);
	}
	getFilmHeight() {
		return this.filmGauge / Math.max(this.aspect, 1);
	}
	getViewBounds(e, t, n) {
		xm.set(-1, -1, .5).applyMatrix4(this.projectionMatrixInverse), t.set(xm.x, xm.y).multiplyScalar(-e / xm.z), xm.set(1, 1, .5).applyMatrix4(this.projectionMatrixInverse), n.set(xm.x, xm.y).multiplyScalar(-e / xm.z);
	}
	getViewSize(e, t) {
		return this.getViewBounds(e, Sm, Cm), t.subVectors(Cm, Sm);
	}
	setViewOffset(e, t, n, r, i, a) {
		this.aspect = e / t, this.view === null && (this.view = {
			enabled: !0,
			fullWidth: 1,
			fullHeight: 1,
			offsetX: 0,
			offsetY: 0,
			width: 1,
			height: 1
		}), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = r, this.view.width = i, this.view.height = a, this.updateProjectionMatrix();
	}
	clearViewOffset() {
		this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
	}
	updateProjectionMatrix() {
		let e = this.near, t = e * Math.tan(iu * .5 * this.fov) / this.zoom, n = 2 * t, r = this.aspect * n, i = -.5 * r, a = this.view;
		if (this.view !== null && this.view.enabled) {
			let e = a.fullWidth, o = a.fullHeight;
			i += a.offsetX * r / e, t -= a.offsetY * n / o, r *= a.width / e, n *= a.height / o;
		}
		let o = this.filmOffset;
		o !== 0 && (i += e * o / this.getFilmWidth()), this.projectionMatrix.makePerspective(i, i + r, t, t - n, e, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, this.view !== null && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
	}
}, Tm = class extends bm {
	constructor(e = -1, t = 1, n = 1, r = -1, i = .1, a = 2e3) {
		super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = n, this.bottom = r, this.near = i, this.far = a, this.updateProjectionMatrix();
	}
	copy(e, t) {
		return super.copy(e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
	}
	setViewOffset(e, t, n, r, i, a) {
		this.view === null && (this.view = {
			enabled: !0,
			fullWidth: 1,
			fullHeight: 1,
			offsetX: 0,
			offsetY: 0,
			width: 1,
			height: 1
		}), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = r, this.view.width = i, this.view.height = a, this.updateProjectionMatrix();
	}
	clearViewOffset() {
		this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
	}
	updateProjectionMatrix() {
		let e = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, r = (this.top + this.bottom) / 2, i = n - e, a = n + e, o = r + t, s = r - t;
		if (this.view !== null && this.view.enabled) {
			let e = (this.right - this.left) / this.view.fullWidth / this.zoom, t = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
			i += e * this.view.offsetX, a = i + e * this.view.width, o -= t * this.view.offsetY, s = o - t * this.view.height;
		}
		this.projectionMatrix.makeOrthographic(i, a, o, s, this.near, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, this.view !== null && (t.object.view = Object.assign({}, this.view)), t;
	}
}, Em = class extends gm {
	constructor() {
		super(new Tm(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
	}
}, Dm = class extends dm {
	constructor(e, t) {
		super(e, t), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(Ed.DEFAULT_UP), this.updateMatrix(), this.target = new Ed(), this.shadow = new Em();
	}
	dispose() {
		super.dispose(), this.shadow.dispose();
	}
	copy(e) {
		return super.copy(e), this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
	}
	toJSON(e) {
		let t = super.toJSON(e);
		return t.object.shadow = this.shadow.toJSON(), t.object.target = this.target.uuid, t;
	}
}, Om = class extends dm {
	constructor(e, t) {
		super(e, t), this.isAmbientLight = !0, this.type = "AmbientLight";
	}
}, km = -90, Am = 1, jm = class extends Ed {
	constructor(e, t, n) {
		super(), this.type = "CubeCamera", this.renderTarget = n, this.coordinateSystem = null, this.activeMipmapLevel = 0;
		let r = new wm(km, Am, e, t);
		r.layers = this.layers, this.add(r);
		let i = new wm(km, Am, e, t);
		i.layers = this.layers, this.add(i);
		let a = new wm(km, Am, e, t);
		a.layers = this.layers, this.add(a);
		let o = new wm(km, Am, e, t);
		o.layers = this.layers, this.add(o);
		let s = new wm(km, Am, e, t);
		s.layers = this.layers, this.add(s);
		let c = new wm(km, Am, e, t);
		c.layers = this.layers, this.add(c);
	}
	updateCoordinateSystem() {
		let e = this.coordinateSystem, t = this.children.concat(), [n, r, i, a, o, s] = t;
		for (let e of t) this.remove(e);
		if (e === 2e3) n.up.set(0, 1, 0), n.lookAt(1, 0, 0), r.up.set(0, 1, 0), r.lookAt(-1, 0, 0), i.up.set(0, 0, -1), i.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), o.up.set(0, 1, 0), o.lookAt(0, 0, 1), s.up.set(0, 1, 0), s.lookAt(0, 0, -1);
		else if (e === 2001) n.up.set(0, -1, 0), n.lookAt(-1, 0, 0), r.up.set(0, -1, 0), r.lookAt(1, 0, 0), i.up.set(0, 0, 1), i.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), o.up.set(0, -1, 0), o.lookAt(0, 0, 1), s.up.set(0, -1, 0), s.lookAt(0, 0, -1);
		else throw Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
		for (let e of t) this.add(e), e.updateMatrixWorld();
	}
	update(e, t) {
		this.parent === null && this.updateMatrixWorld();
		let { renderTarget: n, activeMipmapLevel: r } = this;
		this.coordinateSystem !== e.coordinateSystem && (this.coordinateSystem = e.coordinateSystem, this.updateCoordinateSystem());
		let [i, a, o, s, c, l] = this.children, u = e.getRenderTarget(), d = e.getActiveCubeFace(), f = e.getActiveMipmapLevel(), p = e.xr.enabled;
		e.xr.enabled = !1;
		let m = n.texture.generateMipmaps;
		n.texture.generateMipmaps = !1;
		let h = !1;
		h = e.isWebGLRenderer === !0 ? e.state.buffers.depth.getReversed() : e.reversedDepthBuffer, e.setRenderTarget(n, 0, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, i), e.setRenderTarget(n, 1, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, a), e.setRenderTarget(n, 2, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, o), e.setRenderTarget(n, 3, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, s), e.setRenderTarget(n, 4, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, c), n.texture.generateMipmaps = m, e.setRenderTarget(n, 5, r), h && e.autoClear === !1 && e.clearDepth(), e.render(t, l), e.setRenderTarget(u, d, f), e.xr.enabled = p, n.texture.needsPMREMUpdate = !0;
	}
}, Mm = class extends wm {
	constructor(e = []) {
		super(), this.isArrayCamera = !0, this.isMultiViewCamera = !1, this.cameras = e;
	}
}, Nm = "\\[\\]\\.:\\/", Pm = RegExp("[" + Nm + "]", "g"), Fm = "[^" + Nm + "]", Im = "[^" + Nm.replace("\\.", "") + "]", Lm = /* @__PURE__ */ "((?:WC+[\\/:])*)".replace("WC", Fm), Rm = /* @__PURE__ */ "(WCOD+)?".replace("WCOD", Im), zm = /* @__PURE__ */ "(?:\\.(WC+)(?:\\[(.+)\\])?)?".replace("WC", Fm), Bm = /* @__PURE__ */ "\\.(WC+)(?:\\[(.+)\\])?".replace("WC", Fm), Vm = RegExp("^" + Lm + Rm + zm + Bm + "$"), Hm = [
	"material",
	"materials",
	"bones",
	"map"
], Um = class {
	constructor(e, t, n) {
		let r = n || Wm.parseTrackName(t);
		this._targetGroup = e, this._bindings = e.subscribe_(t, r);
	}
	getValue(e, t) {
		this.bind();
		let n = this._targetGroup.nCachedObjects_, r = this._bindings[n];
		r !== void 0 && r.getValue(e, t);
	}
	setValue(e, t) {
		let n = this._bindings;
		for (let r = this._targetGroup.nCachedObjects_, i = n.length; r !== i; ++r) n[r].setValue(e, t);
	}
	bind() {
		let e = this._bindings;
		for (let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t) e[t].bind();
	}
	unbind() {
		let e = this._bindings;
		for (let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t) e[t].unbind();
	}
}, Wm = class e {
	constructor(t, n, r) {
		this.path = n, this.parsedPath = r || e.parseTrackName(n), this.node = e.findNode(t, this.parsedPath.nodeName), this.rootNode = t, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
	}
	static create(t, n, r) {
		return t && t.isAnimationObjectGroup ? new e.Composite(t, n, r) : new e(t, n, r);
	}
	static sanitizeNodeName(e) {
		return e.replace(/\s/g, "_").replace(Pm, "");
	}
	static parseTrackName(e) {
		let t = Vm.exec(e);
		if (t === null) throw Error("THREE.PropertyBinding: Cannot parse trackName: " + e);
		let n = {
			nodeName: t[2],
			objectName: t[3],
			objectIndex: t[4],
			propertyName: t[5],
			propertyIndex: t[6]
		}, r = n.nodeName && n.nodeName.lastIndexOf(".");
		if (r !== void 0 && r !== -1) {
			let e = n.nodeName.substring(r + 1);
			Hm.indexOf(e) !== -1 && (n.nodeName = n.nodeName.substring(0, r), n.objectName = e);
		}
		if (n.propertyName === null || n.propertyName.length === 0) throw Error("THREE.PropertyBinding: can not parse propertyName from trackName: " + e);
		return n;
	}
	static findNode(e, t) {
		if (t === void 0 || t === "" || t === "." || t === -1 || t === e.name || t === e.uuid) return e;
		if (e.skeleton) {
			let n = e.skeleton.getBoneByName(t);
			if (n !== void 0) return n;
		}
		if (e.children) {
			let n = function(e) {
				for (let r = 0; r < e.length; r++) {
					let i = e[r];
					if (i.name === t || i.uuid === t) return i;
					let a = n(i.children);
					if (a) return a;
				}
				return null;
			}, r = n(e.children);
			if (r) return r;
		}
		return null;
	}
	_getValue_unavailable() {}
	_setValue_unavailable() {}
	_getValue_direct(e, t) {
		e[t] = this.targetObject[this.propertyName];
	}
	_getValue_array(e, t) {
		let n = this.resolvedProperty;
		for (let r = 0, i = n.length; r !== i; ++r) e[t++] = n[r];
	}
	_getValue_arrayElement(e, t) {
		e[t] = this.resolvedProperty[this.propertyIndex];
	}
	_getValue_toArray(e, t) {
		this.resolvedProperty.toArray(e, t);
	}
	_setValue_direct(e, t) {
		this.targetObject[this.propertyName] = e[t];
	}
	_setValue_direct_setNeedsUpdate(e, t) {
		this.targetObject[this.propertyName] = e[t], this.targetObject.needsUpdate = !0;
	}
	_setValue_direct_setMatrixWorldNeedsUpdate(e, t) {
		this.targetObject[this.propertyName] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
	}
	_setValue_array(e, t) {
		let n = this.resolvedProperty;
		for (let r = 0, i = n.length; r !== i; ++r) n[r] = e[t++];
	}
	_setValue_array_setNeedsUpdate(e, t) {
		let n = this.resolvedProperty;
		for (let r = 0, i = n.length; r !== i; ++r) n[r] = e[t++];
		this.targetObject.needsUpdate = !0;
	}
	_setValue_array_setMatrixWorldNeedsUpdate(e, t) {
		let n = this.resolvedProperty;
		for (let r = 0, i = n.length; r !== i; ++r) n[r] = e[t++];
		this.targetObject.matrixWorldNeedsUpdate = !0;
	}
	_setValue_arrayElement(e, t) {
		this.resolvedProperty[this.propertyIndex] = e[t];
	}
	_setValue_arrayElement_setNeedsUpdate(e, t) {
		this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.needsUpdate = !0;
	}
	_setValue_arrayElement_setMatrixWorldNeedsUpdate(e, t) {
		this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
	}
	_setValue_fromArray(e, t) {
		this.resolvedProperty.fromArray(e, t);
	}
	_setValue_fromArray_setNeedsUpdate(e, t) {
		this.resolvedProperty.fromArray(e, t), this.targetObject.needsUpdate = !0;
	}
	_setValue_fromArray_setMatrixWorldNeedsUpdate(e, t) {
		this.resolvedProperty.fromArray(e, t), this.targetObject.matrixWorldNeedsUpdate = !0;
	}
	_getValue_unbound(e, t) {
		this.bind(), this.getValue(e, t);
	}
	_setValue_unbound(e, t) {
		this.bind(), this.setValue(e, t);
	}
	bind() {
		let t = this.node, n = this.parsedPath, r = n.objectName, i = n.propertyName, a = n.propertyIndex;
		if (t || (t = e.findNode(this.rootNode, n.nodeName), this.node = t), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t) {
			Zl("PropertyBinding: No target node found for track: " + this.path + ".");
			return;
		}
		if (r) {
			let e = n.objectIndex;
			switch (r) {
				case "materials":
					if (!t.material) {
						J("PropertyBinding: Can not bind to material as node does not have a material.", this);
						return;
					}
					if (!t.material.materials) {
						J("PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
						return;
					}
					t = t.material.materials;
					break;
				case "bones":
					if (!t.skeleton) {
						J("PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
						return;
					}
					t = t.skeleton.bones;
					for (let n = 0; n < t.length; n++) if (t[n].name === e) {
						e = n;
						break;
					}
					break;
				case "map":
					if ("map" in t) {
						t = t.map;
						break;
					}
					if (!t.material) {
						J("PropertyBinding: Can not bind to material as node does not have a material.", this);
						return;
					}
					if (!t.material.map) {
						J("PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
						return;
					}
					t = t.material.map;
					break;
				default:
					if (t[r] === void 0) {
						J("PropertyBinding: Can not bind to objectName of node undefined.", this);
						return;
					}
					t = t[r];
			}
			if (e !== void 0) {
				if (t[e] === void 0) {
					J("PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
					return;
				}
				t = t[e];
			}
		}
		let o = t[i];
		if (o === void 0) {
			let e = n.nodeName;
			J("PropertyBinding: Trying to update property for track: " + e + "." + i + " but it wasn't found.", t);
			return;
		}
		let s = this.Versioning.None;
		this.targetObject = t, t.isMaterial === !0 ? s = this.Versioning.NeedsUpdate : t.isObject3D === !0 && (s = this.Versioning.MatrixWorldNeedsUpdate);
		let c = this.BindingType.Direct;
		if (a !== void 0) {
			if (i === "morphTargetInfluences") {
				if (!t.geometry) {
					J("PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
					return;
				}
				if (!t.geometry.morphAttributes) {
					J("PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
					return;
				}
				t.morphTargetDictionary[a] !== void 0 && (a = t.morphTargetDictionary[a]);
			}
			c = this.BindingType.ArrayElement, this.resolvedProperty = o, this.propertyIndex = a;
		} else o.fromArray !== void 0 && o.toArray !== void 0 ? (c = this.BindingType.HasFromToArray, this.resolvedProperty = o) : Array.isArray(o) ? (c = this.BindingType.EntireArray, this.resolvedProperty = o) : this.propertyName = i;
		this.getValue = this.GetterByBindingType[c], this.setValue = this.SetterByBindingTypeAndVersioning[c][s];
	}
	unbind() {
		this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
	}
};
Wm.Composite = Um, Wm.prototype.BindingType = {
	Direct: 0,
	EntireArray: 1,
	ArrayElement: 2,
	HasFromToArray: 3
}, Wm.prototype.Versioning = {
	None: 0,
	NeedsUpdate: 1,
	MatrixWorldNeedsUpdate: 2
}, Wm.prototype.GetterByBindingType = [
	Wm.prototype._getValue_direct,
	Wm.prototype._getValue_array,
	Wm.prototype._getValue_arrayElement,
	Wm.prototype._getValue_toArray
], Wm.prototype.SetterByBindingTypeAndVersioning = [
	[
		Wm.prototype._setValue_direct,
		Wm.prototype._setValue_direct_setNeedsUpdate,
		Wm.prototype._setValue_direct_setMatrixWorldNeedsUpdate
	],
	[
		Wm.prototype._setValue_array,
		Wm.prototype._setValue_array_setNeedsUpdate,
		Wm.prototype._setValue_array_setMatrixWorldNeedsUpdate
	],
	[
		Wm.prototype._setValue_arrayElement,
		Wm.prototype._setValue_arrayElement_setNeedsUpdate,
		Wm.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
	],
	[
		Wm.prototype._setValue_fromArray,
		Wm.prototype._setValue_fromArray_setNeedsUpdate,
		Wm.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
	]
];
var Gm = class {
	constructor(e = 1, t = 0, n = 0) {
		this.radius = e, this.phi = t, this.theta = n;
	}
	set(e, t, n) {
		return this.radius = e, this.phi = t, this.theta = n, this;
	}
	copy(e) {
		return this.radius = e.radius, this.phi = e.phi, this.theta = e.theta, this;
	}
	makeSafe() {
		let e = 1e-6;
		return this.phi = Y(this.phi, e, Math.PI - e), this;
	}
	setFromVector3(e) {
		return this.setFromCartesianCoords(e.x, e.y, e.z);
	}
	setFromCartesianCoords(e, t, n) {
		return this.radius = Math.sqrt(e * e + t * t + n * n), this.radius === 0 ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(e, n), this.phi = Math.acos(Y(t / this.radius, -1, 1))), this;
	}
	clone() {
		return new this.constructor().copy(this);
	}
};
(class e {
	static {
		e.prototype.isMatrix2 = !0;
	}
	constructor(e, t, n, r) {
		this.elements = [
			1,
			0,
			0,
			1
		], e !== void 0 && this.set(e, t, n, r);
	}
	identity() {
		return this.set(1, 0, 0, 1), this;
	}
	fromArray(e, t = 0) {
		for (let n = 0; n < 4; n++) this.elements[n] = e[n + t];
		return this;
	}
	set(e, t, n, r) {
		let i = this.elements;
		return i[0] = e, i[2] = t, i[1] = n, i[3] = r, this;
	}
});
var Km = class extends tu {
	constructor(e, t = null) {
		super(), this.object = e, this.domElement = t, this.enabled = !0, this.state = -1, this.keys = {}, this.mouseButtons = {
			LEFT: null,
			MIDDLE: null,
			RIGHT: null
		}, this.touches = {
			ONE: null,
			TWO: null
		};
	}
	connect(e) {
		if (e === void 0) {
			Zl("Controls: connect() now requires an element.");
			return;
		}
		this.domElement !== null && this.disconnect(), this.domElement = e;
	}
	disconnect() {}
	dispose() {}
	update() {}
};
function qm(e, t, n, r) {
	let i = Jm(r);
	switch (n) {
		case Ic: return e * t;
		case Vc: return e * t / i.components * i.byteLength;
		case Hc: return e * t / i.components * i.byteLength;
		case Uc: return e * t * 2 / i.components * i.byteLength;
		case Wc: return e * t * 2 / i.components * i.byteLength;
		case Lc: return e * t * 3 / i.components * i.byteLength;
		case Rc: return e * t * 4 / i.components * i.byteLength;
		case Gc: return e * t * 4 / i.components * i.byteLength;
		case Kc:
		case qc: return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 8;
		case Jc:
		case Yc: return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
		case Zc:
		case $c: return Math.max(e, 16) * Math.max(t, 8) / 4;
		case Xc:
		case Qc: return Math.max(e, 8) * Math.max(t, 8) / 2;
		case el:
		case tl:
		case rl:
		case il: return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 8;
		case nl:
		case al:
		case ol: return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
		case sl: return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
		case cl: return Math.floor((e + 4) / 5) * Math.floor((t + 3) / 4) * 16;
		case ll: return Math.floor((e + 4) / 5) * Math.floor((t + 4) / 5) * 16;
		case ul: return Math.floor((e + 5) / 6) * Math.floor((t + 4) / 5) * 16;
		case dl: return Math.floor((e + 5) / 6) * Math.floor((t + 5) / 6) * 16;
		case fl: return Math.floor((e + 7) / 8) * Math.floor((t + 4) / 5) * 16;
		case pl: return Math.floor((e + 7) / 8) * Math.floor((t + 5) / 6) * 16;
		case ml: return Math.floor((e + 7) / 8) * Math.floor((t + 7) / 8) * 16;
		case hl: return Math.floor((e + 9) / 10) * Math.floor((t + 4) / 5) * 16;
		case gl: return Math.floor((e + 9) / 10) * Math.floor((t + 5) / 6) * 16;
		case _l: return Math.floor((e + 9) / 10) * Math.floor((t + 7) / 8) * 16;
		case vl: return Math.floor((e + 9) / 10) * Math.floor((t + 9) / 10) * 16;
		case yl: return Math.floor((e + 11) / 12) * Math.floor((t + 9) / 10) * 16;
		case bl: return Math.floor((e + 11) / 12) * Math.floor((t + 11) / 12) * 16;
		case xl:
		case Sl:
		case Cl: return Math.ceil(e / 4) * Math.ceil(t / 4) * 16;
		case wl:
		case Tl: return Math.ceil(e / 4) * Math.ceil(t / 4) * 8;
		case El:
		case Dl: return Math.ceil(e / 4) * Math.ceil(t / 4) * 16;
	}
	throw Error(`Unable to determine texture byte length for ${n} format.`);
}
function Jm(e) {
	switch (e) {
		case Cc:
		case wc: return {
			byteLength: 1,
			components: 1
		};
		case Ec:
		case Tc:
		case Ac: return {
			byteLength: 2,
			components: 1
		};
		case jc:
		case Mc: return {
			byteLength: 2,
			components: 4
		};
		case Oc:
		case Dc:
		case kc: return {
			byteLength: 4,
			components: 1
		};
		case Pc:
		case Fc: return {
			byteLength: 4,
			components: 3
		};
	}
	throw Error(`THREE.TextureUtils: Unknown texture type ${e}.`);
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: { revision: "185" } })), typeof window < "u" && (window.__THREE__ ? Zl("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = "185");
//#endregion
//#region node_modules/three/build/three.module.js
function Ym() {
	let e = null, t = !1, n = null, r = null;
	function i(t, a) {
		n(t, a), r = e.requestAnimationFrame(i);
	}
	return {
		start: function() {
			t !== !0 && n !== null && e !== null && (r = e.requestAnimationFrame(i), t = !0);
		},
		stop: function() {
			e !== null && e.cancelAnimationFrame(r), t = !1;
		},
		setAnimationLoop: function(e) {
			n = e;
		},
		setContext: function(t) {
			e = t;
		}
	};
}
function Xm(e) {
	let t = /* @__PURE__ */ new WeakMap();
	function n(t, n) {
		let r = t.array, i = t.usage, a = r.byteLength, o = e.createBuffer();
		e.bindBuffer(n, o), e.bufferData(n, r, i), t.onUploadCallback();
		let s;
		if (r instanceof Float32Array) s = e.FLOAT;
		else if (typeof Float16Array < "u" && r instanceof Float16Array) s = e.HALF_FLOAT;
		else if (r instanceof Uint16Array) s = t.isFloat16BufferAttribute ? e.HALF_FLOAT : e.UNSIGNED_SHORT;
		else if (r instanceof Int16Array) s = e.SHORT;
		else if (r instanceof Uint32Array) s = e.UNSIGNED_INT;
		else if (r instanceof Int32Array) s = e.INT;
		else if (r instanceof Int8Array) s = e.BYTE;
		else if (r instanceof Uint8Array) s = e.UNSIGNED_BYTE;
		else if (r instanceof Uint8ClampedArray) s = e.UNSIGNED_BYTE;
		else throw Error("THREE.WebGLAttributes: Unsupported buffer data format: " + r);
		return {
			buffer: o,
			type: s,
			bytesPerElement: r.BYTES_PER_ELEMENT,
			version: t.version,
			size: a
		};
	}
	function r(t, n, r) {
		let i = n.array, a = n.updateRanges;
		if (e.bindBuffer(r, t), a.length === 0) e.bufferSubData(r, 0, i);
		else {
			a.sort((e, t) => e.start - t.start);
			let t = 0;
			for (let e = 1; e < a.length; e++) {
				let n = a[t], r = a[e];
				r.start <= n.start + n.count + 1 ? n.count = Math.max(n.count, r.start + r.count - n.start) : (++t, a[t] = r);
			}
			a.length = t + 1;
			for (let t = 0, n = a.length; t < n; t++) {
				let n = a[t];
				e.bufferSubData(r, n.start * i.BYTES_PER_ELEMENT, i, n.start, n.count);
			}
			n.clearUpdateRanges();
		}
		n.onUploadCallback();
	}
	function i(e) {
		return e.isInterleavedBufferAttribute && (e = e.data), t.get(e);
	}
	function a(n) {
		n.isInterleavedBufferAttribute && (n = n.data);
		let r = t.get(n);
		r && (e.deleteBuffer(r.buffer), t.delete(n));
	}
	function o(e, i) {
		if (e.isInterleavedBufferAttribute && (e = e.data), e.isGLBufferAttribute) {
			let n = t.get(e);
			(!n || n.version < e.version) && t.set(e, {
				buffer: e.buffer,
				type: e.type,
				bytesPerElement: e.elementSize,
				version: e.version
			});
			return;
		}
		let a = t.get(e);
		if (a === void 0) t.set(e, n(e, i));
		else if (a.version < e.version) {
			if (a.size !== e.array.byteLength) throw Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
			r(a.buffer, e, i), a.version = e.version;
		}
	}
	return {
		get: i,
		remove: a,
		update: o
	};
}
var Zm = {
	alphahash_fragment: "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
	alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif",
	alphamap_fragment: "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
	alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
	alphatest_fragment: "#ifdef USE_ALPHATEST\n	#ifdef ALPHA_TO_COVERAGE\n	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n	if ( diffuseColor.a == 0.0 ) discard;\n	#else\n	if ( diffuseColor.a < alphaTest ) discard;\n	#endif\n#endif",
	alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif",
	aomap_fragment: "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif",
	aomap_pars_fragment: "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif",
	batching_pars_vertex: "#ifdef USE_BATCHING\n	#if ! defined( GL_ANGLE_multi_draw )\n	#define gl_DrawID _gl_DrawID\n	uniform int _gl_DrawID;\n	#endif\n	uniform highp sampler2D batchingTexture;\n	uniform highp usampler2D batchingIdTexture;\n	mat4 getBatchingMatrix( const in float i ) {\n		int size = textureSize( batchingTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n	float getIndirectIndex( const in int i ) {\n		int size = textureSize( batchingIdTexture, 0 ).x;\n		int x = i % size;\n		int y = i / size;\n		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n	}\n#endif\n#ifdef USE_BATCHING_COLOR\n	uniform sampler2D batchingColorTexture;\n	vec4 getBatchingColor( const in float i ) {\n		int size = textureSize( batchingColorTexture, 0 ).x;\n		int j = int( i );\n		int x = j % size;\n		int y = j / size;\n		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 );\n	}\n#endif",
	batching_vertex: "#ifdef USE_BATCHING\n	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif",
	begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif",
	beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif",
	bsdfs: "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated",
	iridescence_fragment: "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif",
	bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif",
	clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#ifdef ALPHA_TO_COVERAGE\n		float distanceToPlane, distanceGradient;\n		float clipOpacity = 1.0;\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n			distanceGradient = fwidth( distanceToPlane ) / 2.0;\n			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			if ( clipOpacity == 0.0 ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			float unionClipOpacity = 1.0;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n				distanceGradient = fwidth( distanceToPlane ) / 2.0;\n				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			}\n			#pragma unroll_loop_end\n			clipOpacity *= 1.0 - unionClipOpacity;\n		#endif\n		diffuseColor.a *= clipOpacity;\n		if ( diffuseColor.a == 0.0 ) discard;\n	#else\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			bool clipped = true;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n			}\n			#pragma unroll_loop_end\n			if ( clipped ) discard;\n		#endif\n	#endif\n#endif",
	clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
	clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif",
	clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif",
	color_fragment: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#endif",
	color_pars_fragment: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#endif",
	color_pars_vertex: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	varying vec4 vColor;\n#endif",
	color_vertex: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	vColor = vec4( 1.0 );\n#endif\n#ifdef USE_COLOR_ALPHA\n	vColor *= color;\n#elif defined( USE_COLOR )\n	vColor.rgb *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.rgb *= instanceColor.rgb;\n#endif\n#ifdef USE_BATCHING_COLOR\n	vColor *= getBatchingColor( getIndirectIndex( gl_DrawID ) );\n#endif",
	common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\n#define inverseTransformDirection transformDirectionByInverseViewMatrix\nvec3 transformNormalByInverseViewMatrix( in vec3 normal, in mat4 viewMatrix ) {\n	return normalize( ( vec4( normal, 0.0 ) * viewMatrix ).xyz );\n}\nvec3 transformDirectionByInverseViewMatrix( in vec3 dir, in mat4 viewMatrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * viewMatrix ).xyz );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
	cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif",
	defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n	vec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n	mat3 bm = mat3( batchingMatrix );\n	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n	transformedNormal = bm * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = bm * transformedTangent;\n	#endif\n#endif\n#ifdef USE_INSTANCING\n	mat3 im = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n	transformedNormal = im * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = im * transformedTangent;\n	#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n#endif",
	displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif",
	displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
	emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n		emissiveColor = sRGBTransferEOTF( emissiveColor );\n	#endif\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
	emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif",
	colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
	colorspace_pars_fragment: "vec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}",
	envmap_fragment: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, envMapRotation * reflectVec );\n		#ifdef ENVMAP_BLENDING_MULTIPLY\n			outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n		#elif defined( ENVMAP_BLENDING_MIX )\n			outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n		#elif defined( ENVMAP_BLENDING_ADD )\n			outgoingLight += envColor.xyz * specularStrength * reflectivity;\n		#endif\n	#endif\n#endif",
	envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform mat3 envMapRotation;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n#endif",
	envmap_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif",
	envmap_pars_vertex: "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif",
	envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );\n			reflectVec = transformDirectionByInverseViewMatrix( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif",
	envmap_vertex: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = transformNormalByInverseViewMatrix( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif",
	fog_vertex: "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif",
	fog_pars_vertex: "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif",
	fog_fragment: "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
	fog_pars_fragment: "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif",
	gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}",
	lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif",
	lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
	lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert",
	lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n	if ( cutoffDistance > 0.0 ) {\n		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n	}\n	return distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif\n#include <lightprobes_pars_fragment>",
	lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
	lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon",
	lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
	lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong",
	lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.metalness = metalnessFactor;\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;\n	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = vec3( 0.04 );\n	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n	material.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	if( material.anisotropy == 0.0 ) {\n		anisotropyV = vec2( 1.0, 0.0 );\n	} else {\n		anisotropyV /= material.anisotropy;\n		material.anisotropy = saturate( material.anisotropy );\n	}\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif",
	lights_physical_pars_fragment: "uniform sampler2D dfgLUT;\nstruct PhysicalMaterial {\n	vec3 diffuseColor;\n	vec3 diffuseContribution;\n	vec3 specularColor;\n	vec3 specularColorBlended;\n	float roughness;\n	float metalness;\n	float specularF90;\n	float dispersion;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n		vec3 iridescenceFresnelDielectric;\n		vec3 iridescenceFresnelMetallic;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		return 0.5 / max( gv + gl, EPSILON );\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColorBlended;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float rInv = 1.0 / ( roughness + 0.1 );\n	float a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;\n	float b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;\n	float DG = exp( a * dotNV + b );\n	return saturate( DG );\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	vec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	float dotNV = saturate( dot( normal, viewDir ) );\n	vec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\nvec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	vec2 dfgV = texture2D( dfgLUT, vec2( material.roughness, dotNV ) ).rg;\n	vec2 dfgL = texture2D( dfgLUT, vec2( material.roughness, dotNL ) ).rg;\n	vec3 FssEss_V = material.specularColorBlended * dfgV.x + material.specularF90 * dfgV.y;\n	vec3 FssEss_L = material.specularColorBlended * dfgL.x + material.specularF90 * dfgL.y;\n	float Ess_V = dfgV.x + dfgV.y;\n	float Ess_L = dfgL.x + dfgL.y;\n	float Ems_V = 1.0 - Ess_V;\n	float Ems_L = 1.0 - Ess_L;\n	vec3 Favg = material.specularColorBlended + ( 1.0 - material.specularColorBlended ) * 0.047619;\n	vec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg + EPSILON );\n	float compensationFactor = Ems_V * Ems_L;\n	vec3 multiScatter = Fms * compensationFactor;\n	return singleScatter + multiScatter;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColorBlended * t2.x + ( material.specularF90 - material.specularColorBlended ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n		#ifdef USE_CLEARCOAT\n			vec3 Ncc = geometryClearcoatNormal;\n			vec2 uvClearcoat = LTC_Uv( Ncc, viewDir, material.clearcoatRoughness );\n			vec4 t1Clearcoat = texture2D( ltc_1, uvClearcoat );\n			vec4 t2Clearcoat = texture2D( ltc_2, uvClearcoat );\n			mat3 mInvClearcoat = mat3(\n				vec3( t1Clearcoat.x, 0, t1Clearcoat.y ),\n				vec3(             0, 1,             0 ),\n				vec3( t1Clearcoat.z, 0, t1Clearcoat.w )\n			);\n			vec3 fresnelClearcoat = material.clearcoatF0 * t2Clearcoat.x + ( material.clearcoatF90 - material.clearcoatF0 ) * t2Clearcoat.y;\n			clearcoatSpecularDirect += lightColor * fresnelClearcoat * LTC_Evaluate( Ncc, viewDir, position, mInvClearcoat, rectCoords );\n		#endif\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n \n 		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n \n 		float sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n 		float sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );\n \n 		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );\n \n 		irradiance *= sheenEnergyComp;\n \n 	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution );\n	#ifdef USE_SHEEN\n		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n		diffuse *= sheenEnergyComp;\n	#endif\n	reflectedLight.indirectDiffuse += diffuse;\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;\n 	#endif\n	vec3 singleScatteringDielectric = vec3( 0.0 );\n	vec3 multiScatteringDielectric = vec3( 0.0 );\n	vec3 singleScatteringMetallic = vec3( 0.0 );\n	vec3 multiScatteringMetallic = vec3( 0.0 );\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnelDielectric, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceFresnelMetallic, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n		computeMultiscattering( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n	#endif\n	vec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );\n	vec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );\n	vec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;\n	vec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	vec3 indirectSpecular = radiance * singleScattering;\n	indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	vec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;\n	#ifdef USE_SHEEN\n		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n		indirectSpecular *= sheenEnergyComp;\n		indirectDiffuse *= sheenEnergyComp;\n	#endif\n	reflectedLight.indirectSpecular += indirectSpecular;\n	reflectedLight.indirectDiffuse += indirectDiffuse;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
	lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );\n		material.iridescenceFresnel = mix( material.iridescenceFresnelDielectric, material.iridescenceFresnelMetallic, material.metalness );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n	#ifdef USE_LIGHT_PROBES_GRID\n		vec3 probeWorldPos = ( ( vec4( geometryPosition, 1.0 ) - viewMatrix[ 3 ] ) * viewMatrix ).xyz;\n		vec3 probeWorldNormal = transformNormalByInverseViewMatrix( geometryNormal, viewMatrix );\n		irradiance += getLightProbeGridIrradiance( probeWorldPos, probeWorldNormal );\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
	lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( ENVMAP_TYPE_CUBE_UV )\n		#if defined( STANDARD ) || defined( LAMBERT ) || defined( PHONG )\n			iblIrradiance += getIBLIrradiance( geometryNormal );\n		#endif\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif",
	lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n	#if defined( LAMBERT ) || defined( PHONG )\n		irradiance += iblIrradiance;\n	#endif\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
	lightprobes_pars_fragment: "#ifdef USE_LIGHT_PROBES_GRID\nuniform highp sampler3D probesSH;\nuniform vec3 probesMin;\nuniform vec3 probesMax;\nuniform vec3 probesResolution;\nvec3 getLightProbeGridIrradiance( vec3 worldPos, vec3 worldNormal ) {\n	vec3 res = probesResolution;\n	vec3 gridRange = probesMax - probesMin;\n	vec3 resMinusOne = res - 1.0;\n	vec3 probeSpacing = gridRange / resMinusOne;\n	vec3 samplePos = worldPos + worldNormal * probeSpacing * 0.5;\n	vec3 uvw = clamp( ( samplePos - probesMin ) / gridRange, 0.0, 1.0 );\n	uvw = uvw * resMinusOne / res + 0.5 / res;\n	float nz          = res.z;\n	float paddedSlices = nz + 2.0;\n	float atlasDepth  = 7.0 * paddedSlices;\n	float uvZBase     = uvw.z * nz + 1.0;\n	vec4 s0 = texture( probesSH, vec3( uvw.xy, ( uvZBase                       ) / atlasDepth ) );\n	vec4 s1 = texture( probesSH, vec3( uvw.xy, ( uvZBase +       paddedSlices   ) / atlasDepth ) );\n	vec4 s2 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 2.0 * paddedSlices   ) / atlasDepth ) );\n	vec4 s3 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 3.0 * paddedSlices   ) / atlasDepth ) );\n	vec4 s4 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 4.0 * paddedSlices   ) / atlasDepth ) );\n	vec4 s5 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 5.0 * paddedSlices   ) / atlasDepth ) );\n	vec4 s6 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 6.0 * paddedSlices   ) / atlasDepth ) );\n	vec3 c0 = s0.xyz;\n	vec3 c1 = vec3( s0.w, s1.xy );\n	vec3 c2 = vec3( s1.zw, s2.x );\n	vec3 c3 = s2.yzw;\n	vec3 c4 = s3.xyz;\n	vec3 c5 = vec3( s3.w, s4.xy );\n	vec3 c6 = vec3( s4.zw, s5.x );\n	vec3 c7 = s5.yzw;\n	vec3 c8 = s6.xyz;\n	float x = worldNormal.x, y = worldNormal.y, z = worldNormal.z;\n	vec3 result = c0 * 0.886227;\n	result += c1 * 2.0 * 0.511664 * y;\n	result += c2 * 2.0 * 0.511664 * z;\n	result += c3 * 2.0 * 0.511664 * x;\n	result += c4 * 2.0 * 0.429043 * x * y;\n	result += c5 * 2.0 * 0.429043 * y * z;\n	result += c6 * ( 0.743125 * z * z - 0.247708 );\n	result += c7 * 2.0 * 0.429043 * x * z;\n	result += c8 * 0.429043 * ( x * x - y * y );\n	return max( result, vec3( 0.0 ) );\n}\n#endif",
	logdepthbuf_fragment: "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
	logdepthbuf_pars_fragment: "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif",
	logdepthbuf_pars_vertex: "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif",
	logdepthbuf_vertex: "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n	vFragDepth = 1.0 + gl_Position.w;\n	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif",
	map_fragment: "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif",
	map_pars_fragment: "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif",
	map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
	map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
	metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif",
	metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif",
	morphinstance_vertex: "#ifdef USE_INSTANCING_MORPH\n	float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n	}\n#endif",
	morphcolor_vertex: "#if defined( USE_MORPHCOLORS )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif",
	morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif",
	morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n	#ifndef USE_INSTANCING_MORPH\n		uniform float morphTargetBaseInfluence;\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	#endif\n	uniform sampler2DArray morphTargetsTexture;\n	uniform ivec2 morphTargetsTextureSize;\n	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n		int y = texelIndex / morphTargetsTextureSize.x;\n		int x = texelIndex - y * morphTargetsTextureSize.x;\n		ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n		return texelFetch( morphTargetsTexture, morphUV, 0 );\n	}\n#endif",
	morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif",
	normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#ifdef DOUBLE_SIDED\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#ifdef DOUBLE_SIDED\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
	normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#if defined( USE_PACKED_NORMALMAP )\n		mapN = vec3( mapN.xy, sqrt( saturate( 1.0 - dot( mapN.xy, mapN.xy ) ) ) );\n	#endif\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
	normal_pars_fragment: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
	normal_pars_vertex: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
	normal_vertex: "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n		#ifdef FLIP_SIDED\n			vBitangent = - vBitangent;\n		#endif\n	#endif\n#endif",
	normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif",
	clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
	clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
	clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif",
	iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif",
	opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
	packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n	if( v <= 0.0 )\n		return vec4( 0., 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec4( 1., 1., 1., 1. );\n	float vuf;\n	float af = modf( v * PackFactors.a, vuf );\n	float bf = modf( vuf * ShiftRight8, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n	if( v <= 0.0 )\n		return vec3( 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec3( 1., 1., 1. );\n	float vuf;\n	float bf = modf( v * PackFactors.b, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n	if( v <= 0.0 )\n		return vec2( 0., 0. );\n	if( v >= 1.0 )\n		return vec2( 1., 1. );\n	float vuf;\n	float gf = modf( v * 256., vuf );\n	return vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n	return dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	#ifdef USE_REVERSED_DEPTH_BUFFER\n	\n		return depth * ( far - near ) - far;\n	#else\n		return depth * ( near - far ) - near;\n	#endif\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	\n	#ifdef USE_REVERSED_DEPTH_BUFFER\n		return ( near * far ) / ( ( near - far ) * depth - near );\n	#else\n		return ( near * far ) / ( ( far - near ) * depth - far );\n	#endif\n}",
	premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif",
	project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n	mvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
	dithering_fragment: "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
	dithering_pars_fragment: "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif",
	roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif",
	roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif",
	shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#if defined( SHADOWMAP_TYPE_PCF )\n			uniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		#else\n			uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		#endif\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		#if defined( SHADOWMAP_TYPE_PCF )\n			uniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		#else\n			uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		#endif\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#if defined( SHADOWMAP_TYPE_PCF )\n			uniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		#elif defined( SHADOWMAP_TYPE_BASIC )\n			uniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		#endif\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	#if defined( SHADOWMAP_TYPE_PCF )\n		float interleavedGradientNoise( vec2 position ) {\n			return fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );\n		}\n		vec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {\n			const float goldenAngle = 2.399963229728653;\n			float r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );\n			float theta = float( sampleIndex ) * goldenAngle + phi;\n			return vec2( cos( theta ), sin( theta ) ) * r;\n		}\n	#endif\n	#if defined( SHADOWMAP_TYPE_PCF )\n		float getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n			float shadow = 1.0;\n			shadowCoord.xyz /= shadowCoord.w;\n			shadowCoord.z += shadowBias;\n			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n			if ( frustumTest ) {\n				vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n				float radius = shadowRadius * texelSize.x;\n				float phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n				shadow = (\n					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +\n					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +\n					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +\n					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +\n					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )\n				) * 0.2;\n			}\n			return mix( 1.0, shadow, shadowIntensity );\n		}\n	#elif defined( SHADOWMAP_TYPE_VSM )\n		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n			float shadow = 1.0;\n			shadowCoord.xyz /= shadowCoord.w;\n			#ifdef USE_REVERSED_DEPTH_BUFFER\n				shadowCoord.z -= shadowBias;\n			#else\n				shadowCoord.z += shadowBias;\n			#endif\n			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n			if ( frustumTest ) {\n				vec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;\n				float mean = distribution.x;\n				float variance = distribution.y * distribution.y;\n				#ifdef USE_REVERSED_DEPTH_BUFFER\n					float hard_shadow = step( mean, shadowCoord.z );\n				#else\n					float hard_shadow = step( shadowCoord.z, mean );\n				#endif\n				\n				if ( hard_shadow == 1.0 ) {\n					shadow = 1.0;\n				} else {\n					variance = max( variance, 0.0000001 );\n					float d = shadowCoord.z - mean;\n					float p_max = variance / ( variance + d * d );\n					p_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );\n					shadow = max( hard_shadow, p_max );\n				}\n			}\n			return mix( 1.0, shadow, shadowIntensity );\n		}\n	#else\n		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n			float shadow = 1.0;\n			shadowCoord.xyz /= shadowCoord.w;\n			#ifdef USE_REVERSED_DEPTH_BUFFER\n				shadowCoord.z -= shadowBias;\n			#else\n				shadowCoord.z += shadowBias;\n			#endif\n			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n			if ( frustumTest ) {\n				float depth = texture2D( shadowMap, shadowCoord.xy ).r;\n				#ifdef USE_REVERSED_DEPTH_BUFFER\n					shadow = step( depth, shadowCoord.z );\n				#else\n					shadow = step( shadowCoord.z, depth );\n				#endif\n			}\n			return mix( 1.0, shadow, shadowIntensity );\n		}\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	#if defined( SHADOWMAP_TYPE_PCF )\n	float getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		float shadow = 1.0;\n		vec3 lightToPosition = shadowCoord.xyz;\n		vec3 bd3D = normalize( lightToPosition );\n		vec3 absVec = abs( lightToPosition );\n		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n			#ifdef USE_REVERSED_DEPTH_BUFFER\n				float dp = ( shadowCameraNear * ( shadowCameraFar - viewSpaceZ ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n				dp -= shadowBias;\n			#else\n				float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n				dp += shadowBias;\n			#endif\n			float texelSize = shadowRadius / shadowMapSize.x;\n			vec3 absDir = abs( bd3D );\n			vec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );\n			tangent = normalize( cross( bd3D, tangent ) );\n			vec3 bitangent = cross( bd3D, tangent );\n			float phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n			vec2 sample0 = vogelDiskSample( 0, 5, phi );\n			vec2 sample1 = vogelDiskSample( 1, 5, phi );\n			vec2 sample2 = vogelDiskSample( 2, 5, phi );\n			vec2 sample3 = vogelDiskSample( 3, 5, phi );\n			vec2 sample4 = vogelDiskSample( 4, 5, phi );\n			shadow = (\n				texture( shadowMap, vec4( bd3D + ( tangent * sample0.x + bitangent * sample0.y ) * texelSize, dp ) ) +\n				texture( shadowMap, vec4( bd3D + ( tangent * sample1.x + bitangent * sample1.y ) * texelSize, dp ) ) +\n				texture( shadowMap, vec4( bd3D + ( tangent * sample2.x + bitangent * sample2.y ) * texelSize, dp ) ) +\n				texture( shadowMap, vec4( bd3D + ( tangent * sample3.x + bitangent * sample3.y ) * texelSize, dp ) ) +\n				texture( shadowMap, vec4( bd3D + ( tangent * sample4.x + bitangent * sample4.y ) * texelSize, dp ) )\n			) * 0.2;\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n	#elif defined( SHADOWMAP_TYPE_BASIC )\n	float getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		float shadow = 1.0;\n		vec3 lightToPosition = shadowCoord.xyz;\n		vec3 absVec = abs( lightToPosition );\n		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n			float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n			dp += shadowBias;\n			vec3 bd3D = normalize( lightToPosition );\n			float depth = textureCube( shadowMap, bd3D ).r;\n			#ifdef USE_REVERSED_DEPTH_BUFFER\n				depth = 1.0 - depth;\n			#endif\n			shadow = step( dp, depth );\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n	#endif\n	#endif\n#endif",
	shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif",
	shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	#ifdef HAS_NORMAL\n		vec3 shadowWorldNormal = transformNormalByInverseViewMatrix( transformedNormal, viewMatrix );\n	#else\n		vec3 shadowWorldNormal = vec3( 0.0 );\n	#endif\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif",
	shadowmask_pars_fragment: "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}",
	skinbase_vertex: "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
	skinning_pars_vertex: "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	mat4 getBoneMatrix( const in float i ) {\n		int size = textureSize( boneTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n#endif",
	skinning_vertex: "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
	skinnormal_vertex: "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif",
	specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif",
	specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif",
	tonemapping_fragment: "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
	tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n	vec3( 1.6605, - 0.1246, - 0.0182 ),\n	vec3( - 0.5876, 1.1329, - 0.1006 ),\n	vec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n	vec3( 0.6274, 0.0691, 0.0164 ),\n	vec3( 0.3293, 0.9195, 0.0880 ),\n	vec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n	vec3 x2 = x * x;\n	vec3 x4 = x2 * x2;\n	return + 15.5 * x4 * x2\n		- 40.14 * x4 * x\n		+ 31.96 * x4\n		- 6.868 * x2 * x\n		+ 0.4298 * x2\n		+ 0.1191 * x\n		- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n	const mat3 AgXInsetMatrix = mat3(\n		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n	);\n	const mat3 AgXOutsetMatrix = mat3(\n		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n	);\n	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;\n	color *= toneMappingExposure;\n	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n	color = AgXInsetMatrix * color;\n	color = max( color, 1e-10 );	color = log2( color );\n	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n	color = clamp( color, 0.0, 1.0 );\n	color = agxDefaultContrastApprox( color );\n	color = AgXOutsetMatrix * color;\n	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n	color = clamp( color, 0.0, 1.0 );\n	return color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n	const float StartCompression = 0.8 - 0.04;\n	const float Desaturation = 0.15;\n	color *= toneMappingExposure;\n	float x = min( color.r, min( color.g, color.b ) );\n	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n	color -= offset;\n	float peak = max( color.r, max( color.g, color.b ) );\n	if ( peak < StartCompression ) return color;\n	float d = 1. - StartCompression;\n	float newPeak = 1. - d * d / ( peak + d - StartCompression );\n	color *= newPeak / peak;\n	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n	return mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
	transmission_fragment: "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = transformNormalByInverseViewMatrix( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
	transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec4 transmittedLight;\n		vec3 transmittance;\n		#ifdef USE_DISPERSION\n			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n			for ( int i = 0; i < 3; i ++ ) {\n				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n				vec3 refractedRayExit = position + transmissionRay;\n				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n				vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n				refractionCoords += 1.0;\n				refractionCoords /= 2.0;\n				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n				transmittedLight[ i ] = transmissionSample[ i ];\n				transmittedLight.a += transmissionSample.a;\n				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n			}\n			transmittedLight.a /= 3.0;\n		#else\n			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n			vec3 refractedRayExit = position + transmissionRay;\n			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n			vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n			refractionCoords += 1.0;\n			refractionCoords /= 2.0;\n			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		#endif\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif",
	uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
	uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
	uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
	worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_BATCHING\n		worldPosition = batchingMatrix * worldPosition;\n	#endif\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif",
	background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
	background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
	backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
	backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, backgroundRotation * vWorldDirection );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
	cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
	cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
	depth_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}",
	depth_frag: "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	#ifdef USE_REVERSED_DEPTH_BUFFER\n		float fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n	#else\n		float fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n	#endif\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#elif DEPTH_PACKING == 3202\n		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n	#elif DEPTH_PACKING == 3203\n		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n	#endif\n}",
	distance_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}",
	distance_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );\n}",
	equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}",
	equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
	linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
	linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
	meshbasic_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}",
	meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
	meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}",
	meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}",
	meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}",
	meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
	meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}",
	meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n	uniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n \n		outgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;\n \n 	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
	meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
	points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}",
	points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
	shadow_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
	shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
	sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix[ 3 ];\n	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
	sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}"
}, Z = {
	common: {
		diffuse: { value: /* @__PURE__ */ new Pd(16777215) },
		opacity: { value: 1 },
		map: { value: null },
		mapTransform: { value: /* @__PURE__ */ new Mu() },
		alphaMap: { value: null },
		alphaMapTransform: { value: /* @__PURE__ */ new Mu() },
		alphaTest: { value: 0 }
	},
	specularmap: {
		specularMap: { value: null },
		specularMapTransform: { value: /* @__PURE__ */ new Mu() }
	},
	envmap: {
		envMap: { value: null },
		envMapRotation: { value: /* @__PURE__ */ new Mu() },
		reflectivity: { value: 1 },
		ior: { value: 1.5 },
		refractionRatio: { value: .98 },
		dfgLUT: { value: null }
	},
	aomap: {
		aoMap: { value: null },
		aoMapIntensity: { value: 1 },
		aoMapTransform: { value: /* @__PURE__ */ new Mu() }
	},
	lightmap: {
		lightMap: { value: null },
		lightMapIntensity: { value: 1 },
		lightMapTransform: { value: /* @__PURE__ */ new Mu() }
	},
	bumpmap: {
		bumpMap: { value: null },
		bumpMapTransform: { value: /* @__PURE__ */ new Mu() },
		bumpScale: { value: 1 }
	},
	normalmap: {
		normalMap: { value: null },
		normalMapTransform: { value: /* @__PURE__ */ new Mu() },
		normalScale: { value: /* @__PURE__ */ new Ou(1, 1) }
	},
	displacementmap: {
		displacementMap: { value: null },
		displacementMapTransform: { value: /* @__PURE__ */ new Mu() },
		displacementScale: { value: 1 },
		displacementBias: { value: 0 }
	},
	emissivemap: {
		emissiveMap: { value: null },
		emissiveMapTransform: { value: /* @__PURE__ */ new Mu() }
	},
	metalnessmap: {
		metalnessMap: { value: null },
		metalnessMapTransform: { value: /* @__PURE__ */ new Mu() }
	},
	roughnessmap: {
		roughnessMap: { value: null },
		roughnessMapTransform: { value: /* @__PURE__ */ new Mu() }
	},
	gradientmap: { gradientMap: { value: null } },
	fog: {
		fogDensity: { value: 25e-5 },
		fogNear: { value: 1 },
		fogFar: { value: 2e3 },
		fogColor: { value: /* @__PURE__ */ new Pd(16777215) }
	},
	lights: {
		ambientLightColor: { value: [] },
		lightProbe: { value: [] },
		directionalLights: {
			value: [],
			properties: {
				direction: {},
				color: {}
			}
		},
		directionalLightShadows: {
			value: [],
			properties: {
				shadowIntensity: 1,
				shadowBias: {},
				shadowNormalBias: {},
				shadowRadius: {},
				shadowMapSize: {}
			}
		},
		directionalShadowMatrix: { value: [] },
		spotLights: {
			value: [],
			properties: {
				color: {},
				position: {},
				direction: {},
				distance: {},
				coneCos: {},
				penumbraCos: {},
				decay: {}
			}
		},
		spotLightShadows: {
			value: [],
			properties: {
				shadowIntensity: 1,
				shadowBias: {},
				shadowNormalBias: {},
				shadowRadius: {},
				shadowMapSize: {}
			}
		},
		spotLightMap: { value: [] },
		spotLightMatrix: { value: [] },
		pointLights: {
			value: [],
			properties: {
				color: {},
				position: {},
				decay: {},
				distance: {}
			}
		},
		pointLightShadows: {
			value: [],
			properties: {
				shadowIntensity: 1,
				shadowBias: {},
				shadowNormalBias: {},
				shadowRadius: {},
				shadowMapSize: {},
				shadowCameraNear: {},
				shadowCameraFar: {}
			}
		},
		pointShadowMatrix: { value: [] },
		hemisphereLights: {
			value: [],
			properties: {
				direction: {},
				skyColor: {},
				groundColor: {}
			}
		},
		rectAreaLights: {
			value: [],
			properties: {
				color: {},
				position: {},
				width: {},
				height: {}
			}
		},
		ltc_1: { value: null },
		ltc_2: { value: null },
		probesSH: { value: null },
		probesMin: { value: /* @__PURE__ */ new X() },
		probesMax: { value: /* @__PURE__ */ new X() },
		probesResolution: { value: /* @__PURE__ */ new X() }
	},
	points: {
		diffuse: { value: /* @__PURE__ */ new Pd(16777215) },
		opacity: { value: 1 },
		size: { value: 1 },
		scale: { value: 1 },
		map: { value: null },
		alphaMap: { value: null },
		alphaMapTransform: { value: /* @__PURE__ */ new Mu() },
		alphaTest: { value: 0 },
		uvTransform: { value: /* @__PURE__ */ new Mu() }
	},
	sprite: {
		diffuse: { value: /* @__PURE__ */ new Pd(16777215) },
		opacity: { value: 1 },
		center: { value: /* @__PURE__ */ new Ou(.5, .5) },
		rotation: { value: 0 },
		map: { value: null },
		mapTransform: { value: /* @__PURE__ */ new Mu() },
		alphaMap: { value: null },
		alphaMapTransform: { value: /* @__PURE__ */ new Mu() },
		alphaTest: { value: 0 }
	}
}, Qm = {
	basic: {
		uniforms: /* @__PURE__ */ Lp([
			Z.common,
			Z.specularmap,
			Z.envmap,
			Z.aomap,
			Z.lightmap,
			Z.fog
		]),
		vertexShader: Zm.meshbasic_vert,
		fragmentShader: Zm.meshbasic_frag
	},
	lambert: {
		uniforms: /* @__PURE__ */ Lp([
			Z.common,
			Z.specularmap,
			Z.envmap,
			Z.aomap,
			Z.lightmap,
			Z.emissivemap,
			Z.bumpmap,
			Z.normalmap,
			Z.displacementmap,
			Z.fog,
			Z.lights,
			{
				emissive: { value: /* @__PURE__ */ new Pd(0) },
				envMapIntensity: { value: 1 }
			}
		]),
		vertexShader: Zm.meshlambert_vert,
		fragmentShader: Zm.meshlambert_frag
	},
	phong: {
		uniforms: /* @__PURE__ */ Lp([
			Z.common,
			Z.specularmap,
			Z.envmap,
			Z.aomap,
			Z.lightmap,
			Z.emissivemap,
			Z.bumpmap,
			Z.normalmap,
			Z.displacementmap,
			Z.fog,
			Z.lights,
			{
				emissive: { value: /* @__PURE__ */ new Pd(0) },
				specular: { value: /* @__PURE__ */ new Pd(1118481) },
				shininess: { value: 30 },
				envMapIntensity: { value: 1 }
			}
		]),
		vertexShader: Zm.meshphong_vert,
		fragmentShader: Zm.meshphong_frag
	},
	standard: {
		uniforms: /* @__PURE__ */ Lp([
			Z.common,
			Z.envmap,
			Z.aomap,
			Z.lightmap,
			Z.emissivemap,
			Z.bumpmap,
			Z.normalmap,
			Z.displacementmap,
			Z.roughnessmap,
			Z.metalnessmap,
			Z.fog,
			Z.lights,
			{
				emissive: { value: /* @__PURE__ */ new Pd(0) },
				roughness: { value: 1 },
				metalness: { value: 0 },
				envMapIntensity: { value: 1 }
			}
		]),
		vertexShader: Zm.meshphysical_vert,
		fragmentShader: Zm.meshphysical_frag
	},
	toon: {
		uniforms: /* @__PURE__ */ Lp([
			Z.common,
			Z.aomap,
			Z.lightmap,
			Z.emissivemap,
			Z.bumpmap,
			Z.normalmap,
			Z.displacementmap,
			Z.gradientmap,
			Z.fog,
			Z.lights,
			{ emissive: { value: /* @__PURE__ */ new Pd(0) } }
		]),
		vertexShader: Zm.meshtoon_vert,
		fragmentShader: Zm.meshtoon_frag
	},
	matcap: {
		uniforms: /* @__PURE__ */ Lp([
			Z.common,
			Z.bumpmap,
			Z.normalmap,
			Z.displacementmap,
			Z.fog,
			{ matcap: { value: null } }
		]),
		vertexShader: Zm.meshmatcap_vert,
		fragmentShader: Zm.meshmatcap_frag
	},
	points: {
		uniforms: /* @__PURE__ */ Lp([Z.points, Z.fog]),
		vertexShader: Zm.points_vert,
		fragmentShader: Zm.points_frag
	},
	dashed: {
		uniforms: /* @__PURE__ */ Lp([
			Z.common,
			Z.fog,
			{
				scale: { value: 1 },
				dashSize: { value: 1 },
				totalSize: { value: 2 }
			}
		]),
		vertexShader: Zm.linedashed_vert,
		fragmentShader: Zm.linedashed_frag
	},
	depth: {
		uniforms: /* @__PURE__ */ Lp([Z.common, Z.displacementmap]),
		vertexShader: Zm.depth_vert,
		fragmentShader: Zm.depth_frag
	},
	normal: {
		uniforms: /* @__PURE__ */ Lp([
			Z.common,
			Z.bumpmap,
			Z.normalmap,
			Z.displacementmap,
			{ opacity: { value: 1 } }
		]),
		vertexShader: Zm.meshnormal_vert,
		fragmentShader: Zm.meshnormal_frag
	},
	sprite: {
		uniforms: /* @__PURE__ */ Lp([Z.sprite, Z.fog]),
		vertexShader: Zm.sprite_vert,
		fragmentShader: Zm.sprite_frag
	},
	background: {
		uniforms: {
			uvTransform: { value: /* @__PURE__ */ new Mu() },
			t2D: { value: null },
			backgroundIntensity: { value: 1 }
		},
		vertexShader: Zm.background_vert,
		fragmentShader: Zm.background_frag
	},
	backgroundCube: {
		uniforms: {
			envMap: { value: null },
			backgroundBlurriness: { value: 0 },
			backgroundIntensity: { value: 1 },
			backgroundRotation: { value: /* @__PURE__ */ new Mu() }
		},
		vertexShader: Zm.backgroundCube_vert,
		fragmentShader: Zm.backgroundCube_frag
	},
	cube: {
		uniforms: {
			tCube: { value: null },
			tFlip: { value: -1 },
			opacity: { value: 1 }
		},
		vertexShader: Zm.cube_vert,
		fragmentShader: Zm.cube_frag
	},
	equirect: {
		uniforms: { tEquirect: { value: null } },
		vertexShader: Zm.equirect_vert,
		fragmentShader: Zm.equirect_frag
	},
	distance: {
		uniforms: /* @__PURE__ */ Lp([
			Z.common,
			Z.displacementmap,
			{
				referencePosition: { value: /* @__PURE__ */ new X() },
				nearDistance: { value: 1 },
				farDistance: { value: 1e3 }
			}
		]),
		vertexShader: Zm.distance_vert,
		fragmentShader: Zm.distance_frag
	},
	shadow: {
		uniforms: /* @__PURE__ */ Lp([
			Z.lights,
			Z.fog,
			{
				color: { value: /* @__PURE__ */ new Pd(0) },
				opacity: { value: 1 }
			}
		]),
		vertexShader: Zm.shadow_vert,
		fragmentShader: Zm.shadow_frag
	}
};
Qm.physical = {
	uniforms: /* @__PURE__ */ Lp([Qm.standard.uniforms, {
		clearcoat: { value: 0 },
		clearcoatMap: { value: null },
		clearcoatMapTransform: { value: /* @__PURE__ */ new Mu() },
		clearcoatNormalMap: { value: null },
		clearcoatNormalMapTransform: { value: /* @__PURE__ */ new Mu() },
		clearcoatNormalScale: { value: /* @__PURE__ */ new Ou(1, 1) },
		clearcoatRoughness: { value: 0 },
		clearcoatRoughnessMap: { value: null },
		clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new Mu() },
		dispersion: { value: 0 },
		iridescence: { value: 0 },
		iridescenceMap: { value: null },
		iridescenceMapTransform: { value: /* @__PURE__ */ new Mu() },
		iridescenceIOR: { value: 1.3 },
		iridescenceThicknessMinimum: { value: 100 },
		iridescenceThicknessMaximum: { value: 400 },
		iridescenceThicknessMap: { value: null },
		iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new Mu() },
		sheen: { value: 0 },
		sheenColor: { value: /* @__PURE__ */ new Pd(0) },
		sheenColorMap: { value: null },
		sheenColorMapTransform: { value: /* @__PURE__ */ new Mu() },
		sheenRoughness: { value: 1 },
		sheenRoughnessMap: { value: null },
		sheenRoughnessMapTransform: { value: /* @__PURE__ */ new Mu() },
		transmission: { value: 0 },
		transmissionMap: { value: null },
		transmissionMapTransform: { value: /* @__PURE__ */ new Mu() },
		transmissionSamplerSize: { value: /* @__PURE__ */ new Ou() },
		transmissionSamplerMap: { value: null },
		thickness: { value: 0 },
		thicknessMap: { value: null },
		thicknessMapTransform: { value: /* @__PURE__ */ new Mu() },
		attenuationDistance: { value: 0 },
		attenuationColor: { value: /* @__PURE__ */ new Pd(0) },
		specularColor: { value: /* @__PURE__ */ new Pd(1, 1, 1) },
		specularColorMap: { value: null },
		specularColorMapTransform: { value: /* @__PURE__ */ new Mu() },
		specularIntensity: { value: 1 },
		specularIntensityMap: { value: null },
		specularIntensityMapTransform: { value: /* @__PURE__ */ new Mu() },
		anisotropyVector: { value: /* @__PURE__ */ new Ou() },
		anisotropyMap: { value: null },
		anisotropyMapTransform: { value: /* @__PURE__ */ new Mu() }
	}]),
	vertexShader: Zm.meshphysical_vert,
	fragmentShader: Zm.meshphysical_frag
};
var $m = {
	r: 0,
	b: 0,
	g: 0
}, eh = /* @__PURE__ */ new $u(), th = /* @__PURE__ */ new Mu();
th.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
function nh(e, t, n, r, i, a) {
	let o = new Pd(0), s = i === !0 ? 0 : 1, c, l, u = null, d = 0, f = null;
	function p(e) {
		let n = e.isScene === !0 ? e.background : null;
		if (n && n.isTexture) {
			let r = e.backgroundBlurriness > 0;
			n = t.get(n, r);
		}
		return n;
	}
	function m(t) {
		let r = !1, i = p(t);
		i === null ? g(o, s) : i && i.isColor && (g(i, 1), r = !0);
		let c = e.xr.getEnvironmentBlendMode();
		c === "additive" ? n.buffers.color.setClear(0, 0, 0, 1, a) : c === "alpha-blend" && n.buffers.color.setClear(0, 0, 0, 0, a), (e.autoClear || r) && (n.buffers.depth.setTest(!0), n.buffers.depth.setMask(!0), n.buffers.color.setMask(!0), e.clear(e.autoClearColor, e.autoClearDepth, e.autoClearStencil));
	}
	function h(t, n) {
		let i = p(n);
		i && (i.isCubeTexture || i.mapping === 306) ? (l === void 0 && (l = new ep(new kp(1, 1, 1), new Wp({
			name: "BackgroundCubeMaterial",
			uniforms: Ip(Qm.backgroundCube.uniforms),
			vertexShader: Qm.backgroundCube.vertexShader,
			fragmentShader: Qm.backgroundCube.fragmentShader,
			side: 1,
			depthTest: !1,
			depthWrite: !1,
			fog: !1,
			allowOverride: !1
		})), l.geometry.deleteAttribute("normal"), l.geometry.deleteAttribute("uv"), l.onBeforeRender = function(e, t, n) {
			this.matrixWorld.copyPosition(n.matrixWorld);
		}, Object.defineProperty(l.material, "envMap", { get: function() {
			return this.uniforms.envMap.value;
		} }), r.update(l)), l.material.uniforms.envMap.value = i, l.material.uniforms.backgroundBlurriness.value = n.backgroundBlurriness, l.material.uniforms.backgroundIntensity.value = n.backgroundIntensity, l.material.uniforms.backgroundRotation.value.setFromMatrix4(eh.makeRotationFromEuler(n.backgroundRotation)).transpose(), i.isCubeTexture && i.isRenderTargetTexture === !1 && l.material.uniforms.backgroundRotation.value.premultiply(th), l.material.toneMapped = Lu.getTransfer(i.colorSpace) !== zl, (u !== i || d !== i.version || f !== e.toneMapping) && (l.material.needsUpdate = !0, u = i, d = i.version, f = e.toneMapping), l.layers.enableAll(), t.unshift(l, l.geometry, l.material, 0, 0, null)) : i && i.isTexture && (c === void 0 && (c = new ep(new Fp(2, 2), new Wp({
			name: "BackgroundMaterial",
			uniforms: Ip(Qm.background.uniforms),
			vertexShader: Qm.background.vertexShader,
			fragmentShader: Qm.background.fragmentShader,
			side: 0,
			depthTest: !1,
			depthWrite: !1,
			fog: !1,
			allowOverride: !1
		})), c.geometry.deleteAttribute("normal"), Object.defineProperty(c.material, "map", { get: function() {
			return this.uniforms.t2D.value;
		} }), r.update(c)), c.material.uniforms.t2D.value = i, c.material.uniforms.backgroundIntensity.value = n.backgroundIntensity, c.material.toneMapped = Lu.getTransfer(i.colorSpace) !== zl, i.matrixAutoUpdate === !0 && i.updateMatrix(), c.material.uniforms.uvTransform.value.copy(i.matrix), (u !== i || d !== i.version || f !== e.toneMapping) && (c.material.needsUpdate = !0, u = i, d = i.version, f = e.toneMapping), c.layers.enableAll(), t.unshift(c, c.geometry, c.material, 0, 0, null));
	}
	function g(t, r) {
		t.getRGB($m, Bp(e)), n.buffers.color.setClear($m.r, $m.g, $m.b, r, a);
	}
	function _() {
		l !== void 0 && (l.geometry.dispose(), l.material.dispose(), l = void 0), c !== void 0 && (c.geometry.dispose(), c.material.dispose(), c = void 0);
	}
	return {
		getClearColor: function() {
			return o;
		},
		setClearColor: function(e, t = 1) {
			o.set(e), s = t, g(o, s);
		},
		getClearAlpha: function() {
			return s;
		},
		setClearAlpha: function(e) {
			s = e, g(o, s);
		},
		render: m,
		addToRenderList: h,
		dispose: _
	};
}
function rh(e, t) {
	let n = e.getParameter(e.MAX_VERTEX_ATTRIBS), r = {}, i = f(null), a = i, o = !1;
	function s(n, r, i, s, c) {
		let u = !1, f = d(n, s, i, r);
		a !== f && (a = f, l(a.object)), u = p(n, s, i, c), u && m(n, s, i, c), c !== null && t.update(c, e.ELEMENT_ARRAY_BUFFER), (u || o) && (o = !1, b(n, r, i, s), c !== null && e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, t.get(c).buffer));
	}
	function c() {
		return e.createVertexArray();
	}
	function l(t) {
		return e.bindVertexArray(t);
	}
	function u(t) {
		return e.deleteVertexArray(t);
	}
	function d(e, t, n, i) {
		let a = i.wireframe === !0, o = r[t.id];
		o === void 0 && (o = {}, r[t.id] = o);
		let s = e.isInstancedMesh === !0 ? e.id : 0, l = o[s];
		l === void 0 && (l = {}, o[s] = l);
		let u = l[n.id];
		u === void 0 && (u = {}, l[n.id] = u);
		let d = u[a];
		return d === void 0 && (d = f(c()), u[a] = d), d;
	}
	function f(e) {
		let t = [], r = [], i = [];
		for (let e = 0; e < n; e++) t[e] = 0, r[e] = 0, i[e] = 0;
		return {
			geometry: null,
			program: null,
			wireframe: !1,
			newAttributes: t,
			enabledAttributes: r,
			attributeDivisors: i,
			object: e,
			attributes: {},
			index: null
		};
	}
	function p(e, t, n, r) {
		let i = a.attributes, o = t.attributes, s = 0, c = n.getAttributes();
		for (let t in c) if (c[t].location >= 0) {
			let n = i[t], r = o[t];
			if (r === void 0 && (t === "instanceMatrix" && e.instanceMatrix && (r = e.instanceMatrix), t === "instanceColor" && e.instanceColor && (r = e.instanceColor)), n === void 0 || n.attribute !== r || r && n.data !== r.data) return !0;
			s++;
		}
		return a.attributesNum !== s || a.index !== r;
	}
	function m(e, t, n, r) {
		let i = {}, o = t.attributes, s = 0, c = n.getAttributes();
		for (let t in c) if (c[t].location >= 0) {
			let n = o[t];
			n === void 0 && (t === "instanceMatrix" && e.instanceMatrix && (n = e.instanceMatrix), t === "instanceColor" && e.instanceColor && (n = e.instanceColor));
			let r = {};
			r.attribute = n, n && n.data && (r.data = n.data), i[t] = r, s++;
		}
		a.attributes = i, a.attributesNum = s, a.index = r;
	}
	function h() {
		let e = a.newAttributes;
		for (let t = 0, n = e.length; t < n; t++) e[t] = 0;
	}
	function g(e) {
		_(e, 0);
	}
	function _(t, n) {
		let r = a.newAttributes, i = a.enabledAttributes, o = a.attributeDivisors;
		r[t] = 1, i[t] === 0 && (e.enableVertexAttribArray(t), i[t] = 1), o[t] !== n && (e.vertexAttribDivisor(t, n), o[t] = n);
	}
	function v() {
		let t = a.newAttributes, n = a.enabledAttributes;
		for (let r = 0, i = n.length; r < i; r++) n[r] !== t[r] && (e.disableVertexAttribArray(r), n[r] = 0);
	}
	function y(t, n, r, i, a, o, s) {
		s === !0 ? e.vertexAttribIPointer(t, n, r, a, o) : e.vertexAttribPointer(t, n, r, i, a, o);
	}
	function b(n, r, i, a) {
		h();
		let o = a.attributes, s = i.getAttributes(), c = r.defaultAttributeValues;
		for (let r in s) {
			let i = s[r];
			if (i.location >= 0) {
				let s = o[r];
				if (s === void 0 && (r === "instanceMatrix" && n.instanceMatrix && (s = n.instanceMatrix), r === "instanceColor" && n.instanceColor && (s = n.instanceColor)), s !== void 0) {
					let r = s.normalized, o = s.itemSize, c = t.get(s);
					if (c === void 0) continue;
					let l = c.buffer, u = c.type, d = c.bytesPerElement, f = u === e.INT || u === e.UNSIGNED_INT || s.gpuType === 1013;
					if (s.isInterleavedBufferAttribute) {
						let t = s.data, c = t.stride, p = s.offset;
						if (t.isInstancedInterleavedBuffer) {
							for (let e = 0; e < i.locationSize; e++) _(i.location + e, t.meshPerAttribute);
							n.isInstancedMesh !== !0 && a._maxInstanceCount === void 0 && (a._maxInstanceCount = t.meshPerAttribute * t.count);
						} else for (let e = 0; e < i.locationSize; e++) g(i.location + e);
						e.bindBuffer(e.ARRAY_BUFFER, l);
						for (let e = 0; e < i.locationSize; e++) y(i.location + e, o / i.locationSize, u, r, c * d, (p + o / i.locationSize * e) * d, f);
					} else {
						if (s.isInstancedBufferAttribute) {
							for (let e = 0; e < i.locationSize; e++) _(i.location + e, s.meshPerAttribute);
							n.isInstancedMesh !== !0 && a._maxInstanceCount === void 0 && (a._maxInstanceCount = s.meshPerAttribute * s.count);
						} else for (let e = 0; e < i.locationSize; e++) g(i.location + e);
						e.bindBuffer(e.ARRAY_BUFFER, l);
						for (let e = 0; e < i.locationSize; e++) y(i.location + e, o / i.locationSize, u, r, o * d, o / i.locationSize * e * d, f);
					}
				} else if (c !== void 0) {
					let t = c[r];
					if (t !== void 0) switch (t.length) {
						case 2:
							e.vertexAttrib2fv(i.location, t);
							break;
						case 3:
							e.vertexAttrib3fv(i.location, t);
							break;
						case 4:
							e.vertexAttrib4fv(i.location, t);
							break;
						default: e.vertexAttrib1fv(i.location, t);
					}
				}
			}
		}
		v();
	}
	function x() {
		T();
		for (let e in r) {
			let t = r[e];
			for (let e in t) {
				let n = t[e];
				for (let e in n) {
					let t = n[e];
					for (let e in t) u(t[e].object), delete t[e];
					delete n[e];
				}
			}
			delete r[e];
		}
	}
	function S(e) {
		if (r[e.id] === void 0) return;
		let t = r[e.id];
		for (let e in t) {
			let n = t[e];
			for (let e in n) {
				let t = n[e];
				for (let e in t) u(t[e].object), delete t[e];
				delete n[e];
			}
		}
		delete r[e.id];
	}
	function C(e) {
		for (let t in r) {
			let n = r[t];
			for (let t in n) {
				let r = n[t];
				if (r[e.id] === void 0) continue;
				let i = r[e.id];
				for (let e in i) u(i[e].object), delete i[e];
				delete r[e.id];
			}
		}
	}
	function w(e) {
		for (let t in r) {
			let n = r[t], i = e.isInstancedMesh === !0 ? e.id : 0, a = n[i];
			if (a !== void 0) {
				for (let e in a) {
					let t = a[e];
					for (let e in t) u(t[e].object), delete t[e];
					delete a[e];
				}
				delete n[i], Object.keys(n).length === 0 && delete r[t];
			}
		}
	}
	function T() {
		E(), o = !0, a !== i && (a = i, l(a.object));
	}
	function E() {
		i.geometry = null, i.program = null, i.wireframe = !1;
	}
	return {
		setup: s,
		reset: T,
		resetDefaultState: E,
		dispose: x,
		releaseStatesOfGeometry: S,
		releaseStatesOfObject: w,
		releaseStatesOfProgram: C,
		initAttributes: h,
		enableAttribute: g,
		disableUnusedAttributes: v
	};
}
function ih(e, t, n) {
	let r;
	function i(e) {
		r = e;
	}
	function a(t, i) {
		e.drawArrays(r, t, i), n.update(i, r, 1);
	}
	function o(t, i, a) {
		a !== 0 && (e.drawArraysInstanced(r, t, i, a), n.update(i, r, a));
	}
	function s(e, i, a) {
		if (a === 0) return;
		t.get("WEBGL_multi_draw").multiDrawArraysWEBGL(r, e, 0, i, 0, a);
		let o = 0;
		for (let e = 0; e < a; e++) o += i[e];
		n.update(o, r, 1);
	}
	this.setMode = i, this.render = a, this.renderInstances = o, this.renderMultiDraw = s;
}
function ah(e, t, n, r) {
	let i;
	function a() {
		if (i !== void 0) return i;
		if (t.has("EXT_texture_filter_anisotropic") === !0) {
			let n = t.get("EXT_texture_filter_anisotropic");
			i = e.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
		} else i = 0;
		return i;
	}
	function o(t) {
		return !(t !== 1023 && r.convert(t) !== e.getParameter(e.IMPLEMENTATION_COLOR_READ_FORMAT));
	}
	function s(n) {
		let i = n === 1016 && (t.has("EXT_color_buffer_half_float") || t.has("EXT_color_buffer_float"));
		return !(n !== 1009 && r.convert(n) !== e.getParameter(e.IMPLEMENTATION_COLOR_READ_TYPE) && n !== 1015 && !i);
	}
	function c(t) {
		if (t === "highp") {
			if (e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).precision > 0) return "highp";
			t = "mediump";
		}
		return t === "mediump" && e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
	}
	let l = n.precision === void 0 ? "highp" : n.precision, u = c(l);
	u !== l && (Zl("WebGLRenderer:", l, "not supported, using", u, "instead."), l = u);
	let d = n.logarithmicDepthBuffer === !0, f = n.reversedDepthBuffer === !0 && t.has("EXT_clip_control");
	n.reversedDepthBuffer === !0 && f === !1 && Zl("WebGLRenderer: Unable to use reversed depth buffer due to missing EXT_clip_control extension. Fallback to default depth buffer.");
	let p = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS), m = e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS), h = e.getParameter(e.MAX_TEXTURE_SIZE), g = e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE), _ = e.getParameter(e.MAX_VERTEX_ATTRIBS), v = e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS), y = e.getParameter(e.MAX_VARYING_VECTORS), b = e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS), x = e.getParameter(e.MAX_SAMPLES), S = e.getParameter(e.SAMPLES);
	return {
		isWebGL2: !0,
		getMaxAnisotropy: a,
		getMaxPrecision: c,
		textureFormatReadable: o,
		textureTypeReadable: s,
		precision: l,
		logarithmicDepthBuffer: d,
		reversedDepthBuffer: f,
		maxTextures: p,
		maxVertexTextures: m,
		maxTextureSize: h,
		maxCubemapSize: g,
		maxAttributes: _,
		maxVertexUniforms: v,
		maxVaryings: y,
		maxFragmentUniforms: b,
		maxSamples: x,
		samples: S
	};
}
function oh(e) {
	let t = this, n = null, r = 0, i = !1, a = !1, o = new sp(), s = new Mu(), c = {
		value: null,
		needsUpdate: !1
	};
	this.uniform = c, this.numPlanes = 0, this.numIntersection = 0, this.init = function(e, t) {
		let n = e.length !== 0 || t || r !== 0 || i;
		return i = t, r = e.length, n;
	}, this.beginShadows = function() {
		a = !0, u(null);
	}, this.endShadows = function() {
		a = !1;
	}, this.setGlobalState = function(e, t) {
		n = u(e, t, 0);
	}, this.setState = function(t, o, s) {
		let d = t.clippingPlanes, f = t.clipIntersection, p = t.clipShadows, m = e.get(t);
		if (!i || d === null || d.length === 0 || a && !p) a ? u(null) : l();
		else {
			let e = a ? 0 : r, t = e * 4, i = m.clippingState || null;
			c.value = i, i = u(d, o, t, s);
			for (let e = 0; e !== t; ++e) i[e] = n[e];
			m.clippingState = i, this.numIntersection = f ? this.numPlanes : 0, this.numPlanes += e;
		}
	};
	function l() {
		c.value !== n && (c.value = n, c.needsUpdate = r > 0), t.numPlanes = r, t.numIntersection = 0;
	}
	function u(e, n, r, i) {
		let a = e === null ? 0 : e.length, l = null;
		if (a !== 0) {
			if (l = c.value, i !== !0 || l === null) {
				let t = r + a * 4, i = n.matrixWorldInverse;
				s.getNormalMatrix(i), (l === null || l.length < t) && (l = new Float32Array(t));
				for (let t = 0, n = r; t !== a; ++t, n += 4) o.copy(e[t]).applyMatrix4(i, s), o.normal.toArray(l, n), l[n + 3] = o.constant;
			}
			c.value = l, c.needsUpdate = !0;
		}
		return t.numPlanes = a, t.numIntersection = 0, l;
	}
}
var sh = 4, ch = [
	.125,
	.215,
	.35,
	.446,
	.526,
	.582
], lh = 20, uh = 256, dh = /* @__PURE__ */ new Tm(), fh = /* @__PURE__ */ new Pd(), ph = null, mh = 0, hh = 0, gh = !1, _h = /* @__PURE__ */ new X(), vh = class {
	constructor(e) {
		this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._sizeLods = [], this._sigmas = [], this._lodMeshes = [], this._backgroundBox = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._blurMaterial = null, this._ggxMaterial = null;
	}
	fromScene(e, t = 0, n = .1, r = 100, i = {}) {
		let { size: a = 256, position: o = _h } = i;
		ph = this._renderer.getRenderTarget(), mh = this._renderer.getActiveCubeFace(), hh = this._renderer.getActiveMipmapLevel(), gh = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(a);
		let s = this._allocateTargets();
		return s.depthBuffer = !0, this._sceneToCubeUV(e, n, r, s, o), t > 0 && this._blur(s, 0, 0, t), this._applyPMREM(s), this._cleanup(s), s;
	}
	fromEquirectangular(e, t = null) {
		return this._fromTexture(e, t);
	}
	fromCubemap(e, t = null) {
		return this._fromTexture(e, t);
	}
	compileCubemapShader() {
		this._cubemapMaterial === null && (this._cubemapMaterial = Th(), this._compileMaterial(this._cubemapMaterial));
	}
	compileEquirectangularShader() {
		this._equirectMaterial === null && (this._equirectMaterial = wh(), this._compileMaterial(this._equirectMaterial));
	}
	dispose() {
		this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose(), this._backgroundBox !== null && (this._backgroundBox.geometry.dispose(), this._backgroundBox.material.dispose());
	}
	_setSize(e) {
		this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = 2 ** this._lodMax;
	}
	_dispose() {
		this._blurMaterial !== null && this._blurMaterial.dispose(), this._ggxMaterial !== null && this._ggxMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
		for (let e = 0; e < this._lodMeshes.length; e++) this._lodMeshes[e].geometry.dispose();
	}
	_cleanup(e) {
		this._renderer.setRenderTarget(ph, mh, hh), this._renderer.xr.enabled = gh, e.scissorTest = !1, xh(e, 0, 0, e.width, e.height);
	}
	_fromTexture(e, t) {
		e.mapping === 301 || e.mapping === 302 ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), ph = this._renderer.getRenderTarget(), mh = this._renderer.getActiveCubeFace(), hh = this._renderer.getActiveMipmapLevel(), gh = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
		let n = t || this._allocateTargets();
		return this._textureToCubeUV(e, n), this._applyPMREM(n), this._cleanup(n), n;
	}
	_allocateTargets() {
		let e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, n = {
			magFilter: bc,
			minFilter: bc,
			generateMipmaps: !1,
			type: Ac,
			format: Rc,
			colorSpace: Ll,
			depthBuffer: !1
		}, r = bh(e, t, n);
		if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== t) {
			this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = bh(e, t, n);
			let { _lodMax: r } = this;
			({lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas} = yh(r)), this._blurMaterial = Ch(r, e, t), this._ggxMaterial = Sh(r, e, t);
		}
		return r;
	}
	_compileMaterial(e) {
		let t = new ep(new jf(), e);
		this._renderer.compile(t, dh);
	}
	_sceneToCubeUV(e, t, n, r, i) {
		let a = new wm(90, 1, t, n), o = [
			1,
			-1,
			1,
			1,
			1,
			1
		], s = [
			1,
			1,
			1,
			-1,
			-1,
			-1
		], c = this._renderer, l = c.autoClear, u = c.toneMapping;
		c.getClearColor(fh), c.toneMapping = 0, c.autoClear = !1, c.state.buffers.depth.getReversed() && (c.setRenderTarget(r), c.clearDepth(), c.setRenderTarget(null)), this._backgroundBox === null && (this._backgroundBox = new ep(new kp(), new Hf({
			name: "PMREM.Background",
			side: 1,
			depthWrite: !1,
			depthTest: !1
		})));
		let d = this._backgroundBox, f = d.material, p = !1, m = e.background;
		m ? m.isColor && (f.color.copy(m), e.background = null, p = !0) : (f.color.copy(fh), p = !0);
		for (let t = 0; t < 6; t++) {
			let n = t % 3;
			n === 0 ? (a.up.set(0, o[t], 0), a.position.set(i.x, i.y, i.z), a.lookAt(i.x + s[t], i.y, i.z)) : n === 1 ? (a.up.set(0, 0, o[t]), a.position.set(i.x, i.y, i.z), a.lookAt(i.x, i.y + s[t], i.z)) : (a.up.set(0, o[t], 0), a.position.set(i.x, i.y, i.z), a.lookAt(i.x, i.y, i.z + s[t]));
			let l = this._cubeSize;
			xh(r, n * l, t > 2 ? l : 0, l, l), c.setRenderTarget(r), p && c.render(d, a), c.render(e, a);
		}
		c.toneMapping = u, c.autoClear = l, e.background = m;
	}
	_textureToCubeUV(e, t) {
		let n = this._renderer, r = e.mapping === 301 || e.mapping === 302;
		r ? (this._cubemapMaterial === null && (this._cubemapMaterial = Th()), this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = wh());
		let i = r ? this._cubemapMaterial : this._equirectMaterial, a = this._lodMeshes[0];
		a.material = i;
		let o = i.uniforms;
		o.envMap.value = e;
		let s = this._cubeSize;
		xh(t, 0, 0, 3 * s, 2 * s), n.setRenderTarget(t), n.render(a, dh);
	}
	_applyPMREM(e) {
		let t = this._renderer, n = t.autoClear;
		t.autoClear = !1;
		let r = this._lodMeshes.length;
		for (let t = 1; t < r; t++) this._applyGGXFilter(e, t - 1, t);
		t.autoClear = n;
	}
	_applyGGXFilter(e, t, n) {
		let r = this._renderer, i = this._pingPongRenderTarget, a = this._ggxMaterial, o = this._lodMeshes[n];
		o.material = a;
		let s = a.uniforms, c = n / (this._lodMeshes.length - 1), l = t / (this._lodMeshes.length - 1), u = Math.sqrt(c * c - l * l) * (0 + c * 1.25), { _lodMax: d } = this, f = this._sizeLods[n], p = 3 * f * (n > d - sh ? n - d + sh : 0), m = 4 * (this._cubeSize - f);
		s.envMap.value = e.texture, s.roughness.value = u, s.mipInt.value = d - t, xh(i, p, m, 3 * f, 2 * f), r.setRenderTarget(i), r.render(o, dh), s.envMap.value = i.texture, s.roughness.value = 0, s.mipInt.value = d - n, xh(e, p, m, 3 * f, 2 * f), r.setRenderTarget(e), r.render(o, dh);
	}
	_blur(e, t, n, r, i) {
		let a = this._pingPongRenderTarget;
		this._halfBlur(e, a, t, n, r, "latitudinal", i), this._halfBlur(a, e, n, n, r, "longitudinal", i);
	}
	_halfBlur(e, t, n, r, i, a, o) {
		let s = this._renderer, c = this._blurMaterial;
		a !== "latitudinal" && a !== "longitudinal" && J("blur direction must be either latitudinal or longitudinal!");
		let l = this._lodMeshes[r];
		l.material = c;
		let u = c.uniforms, d = this._sizeLods[n] - 1, f = isFinite(i) ? Math.PI / (2 * d) : 2 * Math.PI / (2 * lh - 1), p = i / f, m = isFinite(i) ? 1 + Math.floor(3 * p) : lh;
		m > lh && Zl(`sigmaRadians, ${i}, is too large and will clip, as it requested ${m} samples when the maximum is set to ${lh}`);
		let h = [], g = 0;
		for (let e = 0; e < lh; ++e) {
			let t = e / p, n = Math.exp(-t * t / 2);
			h.push(n), e === 0 ? g += n : e < m && (g += 2 * n);
		}
		for (let e = 0; e < h.length; e++) h[e] = h[e] / g;
		u.envMap.value = e.texture, u.samples.value = m, u.weights.value = h, u.latitudinal.value = a === "latitudinal", o && (u.poleAxis.value = o);
		let { _lodMax: _ } = this;
		u.dTheta.value = f, u.mipInt.value = _ - n;
		let v = this._sizeLods[r];
		xh(t, 3 * v * (r > _ - sh ? r - _ + sh : 0), 4 * (this._cubeSize - v), 3 * v, 2 * v), s.setRenderTarget(t), s.render(l, dh);
	}
};
function yh(e) {
	let t = [], n = [], r = [], i = e, a = e - sh + 1 + ch.length;
	for (let o = 0; o < a; o++) {
		let a = 2 ** i;
		t.push(a);
		let s = 1 / a;
		o > e - sh ? s = ch[o - e + sh - 1] : o === 0 && (s = 0), n.push(s);
		let c = 1 / (a - 2), l = -c, u = 1 + c, d = [
			l,
			l,
			u,
			l,
			u,
			u,
			l,
			l,
			u,
			u,
			l,
			u
		], f = new Float32Array(108), p = new Float32Array(72), m = new Float32Array(36);
		for (let e = 0; e < 6; e++) {
			let t = e % 3 * 2 / 3 - 1, n = e > 2 ? 0 : -1, r = [
				t,
				n,
				0,
				t + 2 / 3,
				n,
				0,
				t + 2 / 3,
				n + 1,
				0,
				t,
				n,
				0,
				t + 2 / 3,
				n + 1,
				0,
				t,
				n + 1,
				0
			];
			f.set(r, 18 * e), p.set(d, 12 * e);
			let i = [
				e,
				e,
				e,
				e,
				e,
				e
			];
			m.set(i, 6 * e);
		}
		let h = new jf();
		h.setAttribute("position", new gf(f, 3)), h.setAttribute("uv", new gf(p, 2)), h.setAttribute("faceIndex", new gf(m, 1)), r.push(new ep(h, null)), i > sh && i--;
	}
	return {
		lodMeshes: r,
		sizeLods: t,
		sigmas: n
	};
}
function bh(e, t, n) {
	let r = new Xu(e, t, n);
	return r.texture.mapping = 306, r.texture.name = "PMREM.cubeUv", r.scissorTest = !0, r;
}
function xh(e, t, n, r, i) {
	e.viewport.set(t, n, r, i), e.scissor.set(t, n, r, i);
}
function Sh(e, t, n) {
	return new Wp({
		name: "PMREMGGXConvolution",
		defines: {
			GGX_SAMPLES: uh,
			CUBEUV_TEXEL_WIDTH: 1 / t,
			CUBEUV_TEXEL_HEIGHT: 1 / n,
			CUBEUV_MAX_MIP: `${e}.0`
		},
		uniforms: {
			envMap: { value: null },
			roughness: { value: 0 },
			mipInt: { value: 0 }
		},
		vertexShader: Eh(),
		fragmentShader: "\n\n			precision highp float;\n			precision highp int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform float roughness;\n			uniform float mipInt;\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			#define PI 3.14159265359\n\n			// Van der Corput radical inverse\n			float radicalInverse_VdC(uint bits) {\n				bits = (bits << 16u) | (bits >> 16u);\n				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);\n				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);\n				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);\n				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);\n				return float(bits) * 2.3283064365386963e-10; // / 0x100000000\n			}\n\n			// Hammersley sequence\n			vec2 hammersley(uint i, uint N) {\n				return vec2(float(i) / float(N), radicalInverse_VdC(i));\n			}\n\n			// GGX VNDF importance sampling (Eric Heitz 2018)\n			// \"Sampling the GGX Distribution of Visible Normals\"\n			// https://jcgt.org/published/0007/04/01/\n			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {\n				float alpha = roughness * roughness;\n\n				// Section 4.1: Orthonormal basis\n				vec3 T1 = vec3(1.0, 0.0, 0.0);\n				vec3 T2 = cross(V, T1);\n\n				// Section 4.2: Parameterization of projected area\n				float r = sqrt(Xi.x);\n				float phi = 2.0 * PI * Xi.y;\n				float t1 = r * cos(phi);\n				float t2 = r * sin(phi);\n				float s = 0.5 * (1.0 + V.z);\n				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;\n\n				// Section 4.3: Reprojection onto hemisphere\n				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * V;\n\n				// Section 3.4: Transform back to ellipsoid configuration\n				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));\n			}\n\n			void main() {\n				vec3 N = normalize(vOutputDirection);\n				vec3 V = N; // Assume view direction equals normal for pre-filtering\n\n				vec3 prefilteredColor = vec3(0.0);\n				float totalWeight = 0.0;\n\n				// For very low roughness, just sample the environment directly\n				if (roughness < 0.001) {\n					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);\n					return;\n				}\n\n				// Tangent space basis for VNDF sampling\n				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);\n				vec3 tangent = normalize(cross(up, N));\n				vec3 bitangent = cross(N, tangent);\n\n				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {\n					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));\n\n					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)\n					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);\n\n					// Transform H back to world space\n					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);\n					vec3 L = normalize(2.0 * dot(V, H) * H - V);\n\n					float NdotL = max(dot(N, L), 0.0);\n\n					if(NdotL > 0.0) {\n						// Sample environment at fixed mip level\n						// VNDF importance sampling handles the distribution filtering\n						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);\n\n						// Weight by NdotL for the split-sum approximation\n						// VNDF PDF naturally accounts for the visible microfacet distribution\n						prefilteredColor += sampleColor * NdotL;\n						totalWeight += NdotL;\n					}\n				}\n\n				if (totalWeight > 0.0) {\n					prefilteredColor = prefilteredColor / totalWeight;\n				}\n\n				gl_FragColor = vec4(prefilteredColor, 1.0);\n			}\n		",
		blending: 0,
		depthTest: !1,
		depthWrite: !1
	});
}
function Ch(e, t, n) {
	let r = new Float32Array(lh), i = new X(0, 1, 0);
	return new Wp({
		name: "SphericalGaussianBlur",
		defines: {
			n: lh,
			CUBEUV_TEXEL_WIDTH: 1 / t,
			CUBEUV_TEXEL_HEIGHT: 1 / n,
			CUBEUV_MAX_MIP: `${e}.0`
		},
		uniforms: {
			envMap: { value: null },
			samples: { value: 1 },
			weights: { value: r },
			latitudinal: { value: !1 },
			dTheta: { value: 0 },
			mipInt: { value: 0 },
			poleAxis: { value: i }
		},
		vertexShader: Eh(),
		fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform int samples;\n			uniform float weights[ n ];\n			uniform bool latitudinal;\n			uniform float dTheta;\n			uniform float mipInt;\n			uniform vec3 poleAxis;\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			vec3 getSample( float theta, vec3 axis ) {\n\n				float cosTheta = cos( theta );\n				// Rodrigues' axis-angle rotation\n				vec3 sampleDirection = vOutputDirection * cosTheta\n					+ cross( axis, vOutputDirection ) * sin( theta )\n					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n				return bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n			}\n\n			void main() {\n\n				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n				}\n\n				axis = normalize( axis );\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n				for ( int i = 1; i < n; i++ ) {\n\n					if ( i >= samples ) {\n\n						break;\n\n					}\n\n					float theta = dTheta * float( i );\n					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n				}\n\n			}\n		",
		blending: 0,
		depthTest: !1,
		depthWrite: !1
	});
}
function wh() {
	return new Wp({
		name: "EquirectangularToCubeUV",
		uniforms: { envMap: { value: null } },
		vertexShader: Eh(),
		fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n\n			#include <common>\n\n			void main() {\n\n				vec3 outputDirection = normalize( vOutputDirection );\n				vec2 uv = equirectUv( outputDirection );\n\n				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n			}\n		",
		blending: 0,
		depthTest: !1,
		depthWrite: !1
	});
}
function Th() {
	return new Wp({
		name: "CubemapToCubeUV",
		uniforms: {
			envMap: { value: null },
			flipEnvMap: { value: -1 }
		},
		vertexShader: Eh(),
		fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			uniform float flipEnvMap;\n\n			varying vec3 vOutputDirection;\n\n			uniform samplerCube envMap;\n\n			void main() {\n\n				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n			}\n		",
		blending: 0,
		depthTest: !1,
		depthWrite: !1
	});
}
function Eh() {
	return "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	";
}
var Dh = class extends Xu {
	constructor(e = 1, t = {}) {
		super(e, e, t), this.isWebGLCubeRenderTarget = !0;
		let n = {
			width: e,
			height: e,
			depth: 1
		}, r = [
			n,
			n,
			n,
			n,
			n,
			n
		];
		this.texture = new Tp(r), this._setTextureOptions(t), this.texture.isRenderTargetTexture = !0;
	}
	fromEquirectangularTexture(e, t) {
		this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
		let n = {
			uniforms: { tEquirect: { value: null } },
			vertexShader: "\n\n				varying vec3 vWorldDirection;\n\n				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n				}\n\n				void main() {\n\n					vWorldDirection = transformDirection( position, modelMatrix );\n\n					#include <begin_vertex>\n					#include <project_vertex>\n\n				}\n			",
			fragmentShader: "\n\n				uniform sampler2D tEquirect;\n\n				varying vec3 vWorldDirection;\n\n				#include <common>\n\n				void main() {\n\n					vec3 direction = normalize( vWorldDirection );\n\n					vec2 sampleUV = equirectUv( direction );\n\n					gl_FragColor = texture2D( tEquirect, sampleUV );\n\n				}\n			"
		}, r = new kp(5, 5, 5), i = new Wp({
			name: "CubemapFromEquirect",
			uniforms: Ip(n.uniforms),
			vertexShader: n.vertexShader,
			fragmentShader: n.fragmentShader,
			side: 1,
			blending: 0
		});
		i.uniforms.tEquirect.value = t;
		let a = new ep(r, i), o = t.minFilter;
		return t.minFilter === 1008 && (t.minFilter = bc), new jm(1, 10, this).update(e, a), t.minFilter = o, a.geometry.dispose(), a.material.dispose(), this;
	}
	clear(e, t = !0, n = !0, r = !0) {
		let i = e.getRenderTarget();
		for (let i = 0; i < 6; i++) e.setRenderTarget(this, i), e.clear(t, n, r);
		e.setRenderTarget(i);
	}
};
function Oh(e) {
	let t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), r = null;
	function i(e, t = !1) {
		return e == null ? null : t ? o(e) : a(e);
	}
	function a(n) {
		if (n && n.isTexture) {
			let r = n.mapping;
			if (r === 303 || r === 304) if (t.has(n)) {
				let e = t.get(n).texture;
				return s(e, n.mapping);
			} else {
				let r = n.image;
				if (r && r.height > 0) {
					let i = new Dh(r.height);
					return i.fromEquirectangularTexture(e, n), t.set(n, i), n.addEventListener("dispose", l), s(i.texture, n.mapping);
				} else return null;
			}
		}
		return n;
	}
	function o(t) {
		if (t && t.isTexture) {
			let i = t.mapping, a = i === 303 || i === 304, o = i === 301 || i === 302;
			if (a || o) {
				let i = n.get(t), s = i === void 0 ? 0 : i.texture.pmremVersion;
				if (t.isRenderTargetTexture && t.pmremVersion !== s) return r === null && (r = new vh(e)), i = a ? r.fromEquirectangular(t, i) : r.fromCubemap(t, i), i.texture.pmremVersion = t.pmremVersion, n.set(t, i), i.texture;
				if (i !== void 0) return i.texture;
				{
					let s = t.image;
					return a && s && s.height > 0 || o && s && c(s) ? (r === null && (r = new vh(e)), i = a ? r.fromEquirectangular(t) : r.fromCubemap(t), i.texture.pmremVersion = t.pmremVersion, n.set(t, i), t.addEventListener("dispose", u), i.texture) : null;
				}
			}
		}
		return t;
	}
	function s(e, t) {
		return t === 303 ? e.mapping = 301 : t === 304 && (e.mapping = 302), e;
	}
	function c(e) {
		let t = 0;
		for (let n = 0; n < 6; n++) e[n] !== void 0 && t++;
		return t === 6;
	}
	function l(e) {
		let n = e.target;
		n.removeEventListener("dispose", l);
		let r = t.get(n);
		r !== void 0 && (t.delete(n), r.dispose());
	}
	function u(e) {
		let t = e.target;
		t.removeEventListener("dispose", u);
		let r = n.get(t);
		r !== void 0 && (n.delete(t), r.dispose());
	}
	function d() {
		t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), r !== null && (r.dispose(), r = null);
	}
	return {
		get: i,
		dispose: d
	};
}
function kh(e) {
	let t = {};
	function n(n) {
		if (t[n] !== void 0) return t[n];
		let r = e.getExtension(n);
		return t[n] = r, r;
	}
	return {
		has: function(e) {
			return n(e) !== null;
		},
		init: function() {
			n("EXT_color_buffer_float"), n("WEBGL_clip_cull_distance"), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture"), n("WEBGL_render_shared_exponent");
		},
		get: function(e) {
			let t = n(e);
			return t === null && Ql("WebGLRenderer: " + e + " extension not supported."), t;
		}
	};
}
function Ah(e, t, n, r) {
	let i = {}, a = /* @__PURE__ */ new WeakMap();
	function o(e) {
		let s = e.target;
		s.index !== null && t.remove(s.index);
		for (let e in s.attributes) t.remove(s.attributes[e]);
		s.removeEventListener("dispose", o), delete i[s.id];
		let c = a.get(s);
		c && (t.remove(c), a.delete(s)), r.releaseStatesOfGeometry(s), s.isInstancedBufferGeometry === !0 && delete s._maxInstanceCount, n.memory.geometries--;
	}
	function s(e, t) {
		return i[t.id] === !0 ? t : (t.addEventListener("dispose", o), i[t.id] = !0, n.memory.geometries++, t);
	}
	function c(n) {
		let r = n.attributes;
		for (let n in r) t.update(r[n], e.ARRAY_BUFFER);
	}
	function l(e) {
		let n = [], r = e.index, i = e.attributes.position, o = 0;
		if (i === void 0) return;
		if (r !== null) {
			let e = r.array;
			o = r.version;
			for (let t = 0, r = e.length; t < r; t += 3) {
				let r = e[t + 0], i = e[t + 1], a = e[t + 2];
				n.push(r, i, i, a, a, r);
			}
		} else {
			let e = i.array;
			o = i.version;
			for (let t = 0, r = e.length / 3 - 1; t < r; t += 3) {
				let e = t + 0, r = t + 1, i = t + 2;
				n.push(e, r, r, i, i, e);
			}
		}
		let s = new (i.count >= 65535 ? vf : _f)(n, 1);
		s.version = o;
		let c = a.get(e);
		c && t.remove(c), a.set(e, s);
	}
	function u(e) {
		let t = a.get(e);
		if (t) {
			let n = e.index;
			n !== null && t.version < n.version && l(e);
		} else l(e);
		return a.get(e);
	}
	return {
		get: s,
		update: c,
		getWireframeAttribute: u
	};
}
function jh(e, t, n) {
	let r;
	function i(e) {
		r = e;
	}
	let a, o;
	function s(e) {
		a = e.type, o = e.bytesPerElement;
	}
	function c(t, i) {
		e.drawElements(r, i, a, t * o), n.update(i, r, 1);
	}
	function l(t, i, s) {
		s !== 0 && (e.drawElementsInstanced(r, i, a, t * o, s), n.update(i, r, s));
	}
	function u(e, i, o) {
		if (o === 0) return;
		t.get("WEBGL_multi_draw").multiDrawElementsWEBGL(r, i, 0, a, e, 0, o);
		let s = 0;
		for (let e = 0; e < o; e++) s += i[e];
		n.update(s, r, 1);
	}
	this.setMode = i, this.setIndex = s, this.render = c, this.renderInstances = l, this.renderMultiDraw = u;
}
function Mh(e) {
	let t = {
		geometries: 0,
		textures: 0
	}, n = {
		frame: 0,
		calls: 0,
		triangles: 0,
		points: 0,
		lines: 0
	};
	function r(t, r, i) {
		switch (n.calls++, r) {
			case e.TRIANGLES:
				n.triangles += t / 3 * i;
				break;
			case e.LINES:
				n.lines += t / 2 * i;
				break;
			case e.LINE_STRIP:
				n.lines += i * (t - 1);
				break;
			case e.LINE_LOOP:
				n.lines += i * t;
				break;
			case e.POINTS:
				n.points += i * t;
				break;
			default:
				J("WebGLInfo: Unknown draw mode:", r);
				break;
		}
	}
	function i() {
		n.calls = 0, n.triangles = 0, n.points = 0, n.lines = 0;
	}
	return {
		memory: t,
		render: n,
		programs: null,
		autoReset: !0,
		reset: i,
		update: r
	};
}
function Nh(e, t, n) {
	let r = /* @__PURE__ */ new WeakMap(), i = new Ju();
	function a(a, o, s) {
		let c = a.morphTargetInfluences, l = o.morphAttributes.position || o.morphAttributes.normal || o.morphAttributes.color, u = l === void 0 ? 0 : l.length, d = r.get(o);
		if (d === void 0 || d.count !== u) {
			d !== void 0 && d.texture.dispose();
			let e = o.morphAttributes.position !== void 0, n = o.morphAttributes.normal !== void 0, a = o.morphAttributes.color !== void 0, s = o.morphAttributes.position || [], c = o.morphAttributes.normal || [], l = o.morphAttributes.color || [], f = 0;
			e === !0 && (f = 1), n === !0 && (f = 2), a === !0 && (f = 3);
			let p = o.attributes.position.count * f, m = 1;
			p > t.maxTextureSize && (m = Math.ceil(p / t.maxTextureSize), p = t.maxTextureSize);
			let h = new Float32Array(p * m * 4 * u), g = new Zu(h, p, m, u);
			g.type = kc, g.needsUpdate = !0;
			let _ = f * 4;
			for (let t = 0; t < u; t++) {
				let r = s[t], o = c[t], u = l[t], d = p * m * 4 * t;
				for (let t = 0; t < r.count; t++) {
					let s = t * _;
					e === !0 && (i.fromBufferAttribute(r, t), h[d + s + 0] = i.x, h[d + s + 1] = i.y, h[d + s + 2] = i.z, h[d + s + 3] = 0), n === !0 && (i.fromBufferAttribute(o, t), h[d + s + 4] = i.x, h[d + s + 5] = i.y, h[d + s + 6] = i.z, h[d + s + 7] = 0), a === !0 && (i.fromBufferAttribute(u, t), h[d + s + 8] = i.x, h[d + s + 9] = i.y, h[d + s + 10] = i.z, h[d + s + 11] = u.itemSize === 4 ? i.w : 1);
				}
			}
			d = {
				count: u,
				texture: g,
				size: new Ou(p, m)
			}, r.set(o, d);
			function v() {
				g.dispose(), r.delete(o), o.removeEventListener("dispose", v);
			}
			o.addEventListener("dispose", v);
		}
		if (a.isInstancedMesh === !0 && a.morphTexture !== null) s.getUniforms().setValue(e, "morphTexture", a.morphTexture, n);
		else {
			let t = 0;
			for (let e = 0; e < c.length; e++) t += c[e];
			let n = o.morphTargetsRelative ? 1 : 1 - t;
			s.getUniforms().setValue(e, "morphTargetBaseInfluence", n), s.getUniforms().setValue(e, "morphTargetInfluences", c);
		}
		s.getUniforms().setValue(e, "morphTargetsTexture", d.texture, n), s.getUniforms().setValue(e, "morphTargetsTextureSize", d.size);
	}
	return { update: a };
}
function Ph(e, t, n, r, i) {
	let a = /* @__PURE__ */ new WeakMap();
	function o(r) {
		let o = i.render.frame, s = r.geometry, l = t.get(r, s);
		if (a.get(l) !== o && (t.update(l), a.set(l, o)), r.isInstancedMesh && (r.hasEventListener("dispose", c) === !1 && r.addEventListener("dispose", c), a.get(r) !== o && (n.update(r.instanceMatrix, e.ARRAY_BUFFER), r.instanceColor !== null && n.update(r.instanceColor, e.ARRAY_BUFFER), a.set(r, o))), r.isSkinnedMesh) {
			let e = r.skeleton;
			a.get(e) !== o && (e.update(), a.set(e, o));
		}
		return l;
	}
	function s() {
		a = /* @__PURE__ */ new WeakMap();
	}
	function c(e) {
		let t = e.target;
		t.removeEventListener("dispose", c), r.releaseStatesOfObject(t), n.remove(t.instanceMatrix), t.instanceColor !== null && n.remove(t.instanceColor);
	}
	return {
		update: o,
		dispose: s
	};
}
var Fh = {
	1: "LINEAR_TONE_MAPPING",
	2: "REINHARD_TONE_MAPPING",
	3: "CINEON_TONE_MAPPING",
	4: "ACES_FILMIC_TONE_MAPPING",
	6: "AGX_TONE_MAPPING",
	7: "NEUTRAL_TONE_MAPPING",
	5: "CUSTOM_TONE_MAPPING"
};
function Ih(e, t, n, r, i, a) {
	let o = new Xu(t, n, {
		type: e,
		depthBuffer: i,
		stencilBuffer: a,
		samples: r ? 4 : 0,
		depthTexture: i ? new Ep(t, n) : void 0
	}), s = new Xu(t, n, {
		type: Ac,
		depthBuffer: !1,
		stencilBuffer: !1
	}), c = new jf();
	c.setAttribute("position", new yf([
		-1,
		3,
		0,
		-1,
		-1,
		0,
		3,
		-1,
		0
	], 3)), c.setAttribute("uv", new yf([
		0,
		2,
		0,
		0,
		2,
		0
	], 2));
	let l = new Gp({
		uniforms: { tDiffuse: { value: null } },
		vertexShader: "\n			precision highp float;\n\n			uniform mat4 modelViewMatrix;\n			uniform mat4 projectionMatrix;\n\n			attribute vec3 position;\n			attribute vec2 uv;\n\n			varying vec2 vUv;\n\n			void main() {\n				vUv = uv;\n				gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n			}",
		fragmentShader: "\n			precision highp float;\n\n			uniform sampler2D tDiffuse;\n\n			varying vec2 vUv;\n\n			#include <tonemapping_pars_fragment>\n			#include <colorspace_pars_fragment>\n\n			void main() {\n				gl_FragColor = texture2D( tDiffuse, vUv );\n\n				#ifdef LINEAR_TONE_MAPPING\n					gl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );\n				#elif defined( REINHARD_TONE_MAPPING )\n					gl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );\n				#elif defined( CINEON_TONE_MAPPING )\n					gl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );\n				#elif defined( ACES_FILMIC_TONE_MAPPING )\n					gl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );\n				#elif defined( AGX_TONE_MAPPING )\n					gl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );\n				#elif defined( NEUTRAL_TONE_MAPPING )\n					gl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );\n				#elif defined( CUSTOM_TONE_MAPPING )\n					gl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );\n				#endif\n\n				#ifdef SRGB_TRANSFER\n					gl_FragColor = sRGBTransferOETF( gl_FragColor );\n				#endif\n			}",
		depthTest: !1,
		depthWrite: !1
	}), u = new ep(c, l), d = new Tm(-1, 1, 1, -1, 0, 1), f = null, p = null, m = !1, h, g = null, _ = [], v = !1;
	this.setSize = function(e, t) {
		o.setSize(e, t), s.setSize(e, t);
		for (let n = 0; n < _.length; n++) {
			let r = _[n];
			r.setSize && r.setSize(e, t);
		}
	}, this.setEffects = function(e) {
		_ = e, v = _.length > 0 && _[0].isRenderPass === !0;
		let t = o.width, n = o.height;
		for (let e = 0; e < _.length; e++) {
			let r = _[e];
			r.setSize && r.setSize(t, n);
		}
	}, this.begin = function(e, t) {
		if (m || e.toneMapping === 0 && _.length === 0) return !1;
		if (g = t, t !== null) {
			let e = t.width, n = t.height;
			(o.width !== e || o.height !== n) && this.setSize(e, n);
		}
		return v === !1 && e.setRenderTarget(o), h = e.toneMapping, e.toneMapping = 0, !0;
	}, this.hasRenderPass = function() {
		return v;
	}, this.end = function(e, t) {
		e.toneMapping = h, m = !0;
		let n = o, r = s;
		for (let i = 0; i < _.length; i++) {
			let a = _[i];
			if (a.enabled !== !1 && (a.render(e, r, n, t), a.needsSwap !== !1)) {
				let e = n;
				n = r, r = e;
			}
		}
		if (f !== e.outputColorSpace || p !== e.toneMapping) {
			f = e.outputColorSpace, p = e.toneMapping, l.defines = {}, Lu.getTransfer(f) === "srgb" && (l.defines.SRGB_TRANSFER = "");
			let t = Fh[p];
			t && (l.defines[t] = ""), l.needsUpdate = !0;
		}
		l.uniforms.tDiffuse.value = n.texture, e.setRenderTarget(g), e.render(u, d), g = null, m = !1;
	}, this.isCompositing = function() {
		return m;
	}, this.dispose = function() {
		o.depthTexture && o.depthTexture.dispose(), o.dispose(), s.dispose(), c.dispose(), l.dispose();
	};
}
var Lh = /* @__PURE__ */ new qu(), Rh = /* @__PURE__ */ new Ep(1, 1), zh = /* @__PURE__ */ new Zu(), Bh = /* @__PURE__ */ new Qu(), Vh = /* @__PURE__ */ new Tp(), Hh = [], Uh = [], Wh = new Float32Array(16), Gh = new Float32Array(9), Kh = new Float32Array(4);
function qh(e, t, n) {
	let r = e[0];
	if (r <= 0 || r > 0) return e;
	let i = t * n, a = Hh[i];
	if (a === void 0 && (a = new Float32Array(i), Hh[i] = a), t !== 0) {
		r.toArray(a, 0);
		for (let r = 1, i = 0; r !== t; ++r) i += n, e[r].toArray(a, i);
	}
	return a;
}
function Jh(e, t) {
	if (e.length !== t.length) return !1;
	for (let n = 0, r = e.length; n < r; n++) if (e[n] !== t[n]) return !1;
	return !0;
}
function Yh(e, t) {
	for (let n = 0, r = t.length; n < r; n++) e[n] = t[n];
}
function Xh(e, t) {
	let n = Uh[t];
	n === void 0 && (n = new Int32Array(t), Uh[t] = n);
	for (let r = 0; r !== t; ++r) n[r] = e.allocateTextureUnit();
	return n;
}
function Zh(e, t) {
	let n = this.cache;
	n[0] !== t && (e.uniform1f(this.addr, t), n[0] = t);
}
function Qh(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y) && (e.uniform2f(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
	else {
		if (Jh(n, t)) return;
		e.uniform2fv(this.addr, t), Yh(n, t);
	}
}
function $h(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z) && (e.uniform3f(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
	else if (t.r !== void 0) (n[0] !== t.r || n[1] !== t.g || n[2] !== t.b) && (e.uniform3f(this.addr, t.r, t.g, t.b), n[0] = t.r, n[1] = t.g, n[2] = t.b);
	else {
		if (Jh(n, t)) return;
		e.uniform3fv(this.addr, t), Yh(n, t);
	}
}
function eg(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z || n[3] !== t.w) && (e.uniform4f(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
	else {
		if (Jh(n, t)) return;
		e.uniform4fv(this.addr, t), Yh(n, t);
	}
}
function tg(e, t) {
	let n = this.cache, r = t.elements;
	if (r === void 0) {
		if (Jh(n, t)) return;
		e.uniformMatrix2fv(this.addr, !1, t), Yh(n, t);
	} else {
		if (Jh(n, r)) return;
		Kh.set(r), e.uniformMatrix2fv(this.addr, !1, Kh), Yh(n, r);
	}
}
function ng(e, t) {
	let n = this.cache, r = t.elements;
	if (r === void 0) {
		if (Jh(n, t)) return;
		e.uniformMatrix3fv(this.addr, !1, t), Yh(n, t);
	} else {
		if (Jh(n, r)) return;
		Gh.set(r), e.uniformMatrix3fv(this.addr, !1, Gh), Yh(n, r);
	}
}
function rg(e, t) {
	let n = this.cache, r = t.elements;
	if (r === void 0) {
		if (Jh(n, t)) return;
		e.uniformMatrix4fv(this.addr, !1, t), Yh(n, t);
	} else {
		if (Jh(n, r)) return;
		Wh.set(r), e.uniformMatrix4fv(this.addr, !1, Wh), Yh(n, r);
	}
}
function ig(e, t) {
	let n = this.cache;
	n[0] !== t && (e.uniform1i(this.addr, t), n[0] = t);
}
function ag(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y) && (e.uniform2i(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
	else {
		if (Jh(n, t)) return;
		e.uniform2iv(this.addr, t), Yh(n, t);
	}
}
function og(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z) && (e.uniform3i(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
	else {
		if (Jh(n, t)) return;
		e.uniform3iv(this.addr, t), Yh(n, t);
	}
}
function sg(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z || n[3] !== t.w) && (e.uniform4i(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
	else {
		if (Jh(n, t)) return;
		e.uniform4iv(this.addr, t), Yh(n, t);
	}
}
function cg(e, t) {
	let n = this.cache;
	n[0] !== t && (e.uniform1ui(this.addr, t), n[0] = t);
}
function lg(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y) && (e.uniform2ui(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
	else {
		if (Jh(n, t)) return;
		e.uniform2uiv(this.addr, t), Yh(n, t);
	}
}
function ug(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z) && (e.uniform3ui(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
	else {
		if (Jh(n, t)) return;
		e.uniform3uiv(this.addr, t), Yh(n, t);
	}
}
function dg(e, t) {
	let n = this.cache;
	if (t.x !== void 0) (n[0] !== t.x || n[1] !== t.y || n[2] !== t.z || n[3] !== t.w) && (e.uniform4ui(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
	else {
		if (Jh(n, t)) return;
		e.uniform4uiv(this.addr, t), Yh(n, t);
	}
}
function fg(e, t, n) {
	let r = this.cache, i = n.allocateTextureUnit();
	r[0] !== i && (e.uniform1i(this.addr, i), r[0] = i);
	let a;
	this.type === e.SAMPLER_2D_SHADOW ? (Rh.compareFunction = n.isReversedDepthBuffer() ? 518 : 515, a = Rh) : a = Lh, n.setTexture2D(t || a, i);
}
function pg(e, t, n) {
	let r = this.cache, i = n.allocateTextureUnit();
	r[0] !== i && (e.uniform1i(this.addr, i), r[0] = i), n.setTexture3D(t || Bh, i);
}
function mg(e, t, n) {
	let r = this.cache, i = n.allocateTextureUnit();
	r[0] !== i && (e.uniform1i(this.addr, i), r[0] = i), n.setTextureCube(t || Vh, i);
}
function hg(e, t, n) {
	let r = this.cache, i = n.allocateTextureUnit();
	r[0] !== i && (e.uniform1i(this.addr, i), r[0] = i), n.setTexture2DArray(t || zh, i);
}
function gg(e) {
	switch (e) {
		case 5126: return Zh;
		case 35664: return Qh;
		case 35665: return $h;
		case 35666: return eg;
		case 35674: return tg;
		case 35675: return ng;
		case 35676: return rg;
		case 5124:
		case 35670: return ig;
		case 35667:
		case 35671: return ag;
		case 35668:
		case 35672: return og;
		case 35669:
		case 35673: return sg;
		case 5125: return cg;
		case 36294: return lg;
		case 36295: return ug;
		case 36296: return dg;
		case 35678:
		case 36198:
		case 36298:
		case 36306:
		case 35682: return fg;
		case 35679:
		case 36299:
		case 36307: return pg;
		case 35680:
		case 36300:
		case 36308:
		case 36293: return mg;
		case 36289:
		case 36303:
		case 36311:
		case 36292: return hg;
	}
}
function _g(e, t) {
	e.uniform1fv(this.addr, t);
}
function vg(e, t) {
	let n = qh(t, this.size, 2);
	e.uniform2fv(this.addr, n);
}
function yg(e, t) {
	let n = qh(t, this.size, 3);
	e.uniform3fv(this.addr, n);
}
function bg(e, t) {
	let n = qh(t, this.size, 4);
	e.uniform4fv(this.addr, n);
}
function xg(e, t) {
	let n = qh(t, this.size, 4);
	e.uniformMatrix2fv(this.addr, !1, n);
}
function Sg(e, t) {
	let n = qh(t, this.size, 9);
	e.uniformMatrix3fv(this.addr, !1, n);
}
function Cg(e, t) {
	let n = qh(t, this.size, 16);
	e.uniformMatrix4fv(this.addr, !1, n);
}
function wg(e, t) {
	e.uniform1iv(this.addr, t);
}
function Tg(e, t) {
	e.uniform2iv(this.addr, t);
}
function Eg(e, t) {
	e.uniform3iv(this.addr, t);
}
function Dg(e, t) {
	e.uniform4iv(this.addr, t);
}
function Og(e, t) {
	e.uniform1uiv(this.addr, t);
}
function kg(e, t) {
	e.uniform2uiv(this.addr, t);
}
function Ag(e, t) {
	e.uniform3uiv(this.addr, t);
}
function jg(e, t) {
	e.uniform4uiv(this.addr, t);
}
function Mg(e, t, n) {
	let r = this.cache, i = t.length, a = Xh(n, i);
	Jh(r, a) || (e.uniform1iv(this.addr, a), Yh(r, a));
	let o;
	o = this.type === e.SAMPLER_2D_SHADOW ? Rh : Lh;
	for (let e = 0; e !== i; ++e) n.setTexture2D(t[e] || o, a[e]);
}
function Ng(e, t, n) {
	let r = this.cache, i = t.length, a = Xh(n, i);
	Jh(r, a) || (e.uniform1iv(this.addr, a), Yh(r, a));
	for (let e = 0; e !== i; ++e) n.setTexture3D(t[e] || Bh, a[e]);
}
function Pg(e, t, n) {
	let r = this.cache, i = t.length, a = Xh(n, i);
	Jh(r, a) || (e.uniform1iv(this.addr, a), Yh(r, a));
	for (let e = 0; e !== i; ++e) n.setTextureCube(t[e] || Vh, a[e]);
}
function Fg(e, t, n) {
	let r = this.cache, i = t.length, a = Xh(n, i);
	Jh(r, a) || (e.uniform1iv(this.addr, a), Yh(r, a));
	for (let e = 0; e !== i; ++e) n.setTexture2DArray(t[e] || zh, a[e]);
}
function Ig(e) {
	switch (e) {
		case 5126: return _g;
		case 35664: return vg;
		case 35665: return yg;
		case 35666: return bg;
		case 35674: return xg;
		case 35675: return Sg;
		case 35676: return Cg;
		case 5124:
		case 35670: return wg;
		case 35667:
		case 35671: return Tg;
		case 35668:
		case 35672: return Eg;
		case 35669:
		case 35673: return Dg;
		case 5125: return Og;
		case 36294: return kg;
		case 36295: return Ag;
		case 36296: return jg;
		case 35678:
		case 36198:
		case 36298:
		case 36306:
		case 35682: return Mg;
		case 35679:
		case 36299:
		case 36307: return Ng;
		case 35680:
		case 36300:
		case 36308:
		case 36293: return Pg;
		case 36289:
		case 36303:
		case 36311:
		case 36292: return Fg;
	}
}
var Lg = class {
	constructor(e, t, n) {
		this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.setValue = gg(t.type);
	}
}, Rg = class {
	constructor(e, t, n) {
		this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.size = t.size, this.setValue = Ig(t.type);
	}
}, zg = class {
	constructor(e) {
		this.id = e, this.seq = [], this.map = {};
	}
	setValue(e, t, n) {
		let r = this.seq;
		for (let i = 0, a = r.length; i !== a; ++i) {
			let a = r[i];
			a.setValue(e, t[a.id], n);
		}
	}
}, Bg = /(\w+)(\])?(\[|\.)?/g;
function Vg(e, t) {
	e.seq.push(t), e.map[t.id] = t;
}
function Hg(e, t, n) {
	let r = e.name, i = r.length;
	for (Bg.lastIndex = 0;;) {
		let a = Bg.exec(r), o = Bg.lastIndex, s = a[1], c = a[2] === "]", l = a[3];
		if (c && (s |= 0), l === void 0 || l === "[" && o + 2 === i) {
			Vg(n, l === void 0 ? new Lg(s, e, t) : new Rg(s, e, t));
			break;
		} else {
			let e = n.map[s];
			e === void 0 && (e = new zg(s), Vg(n, e)), n = e;
		}
	}
}
var Ug = class {
	constructor(e, t) {
		this.seq = [], this.map = {};
		let n = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
		for (let r = 0; r < n; ++r) {
			let n = e.getActiveUniform(t, r);
			Hg(n, e.getUniformLocation(t, n.name), this);
		}
		let r = [], i = [];
		for (let t of this.seq) t.type === e.SAMPLER_2D_SHADOW || t.type === e.SAMPLER_CUBE_SHADOW || t.type === e.SAMPLER_2D_ARRAY_SHADOW ? r.push(t) : i.push(t);
		r.length > 0 && (this.seq = r.concat(i));
	}
	setValue(e, t, n, r) {
		let i = this.map[t];
		i !== void 0 && i.setValue(e, n, r);
	}
	setOptional(e, t, n) {
		let r = t[n];
		r !== void 0 && this.setValue(e, n, r);
	}
	static upload(e, t, n, r) {
		for (let i = 0, a = t.length; i !== a; ++i) {
			let a = t[i], o = n[a.id];
			o.needsUpdate !== !1 && a.setValue(e, o.value, r);
		}
	}
	static seqWithValue(e, t) {
		let n = [];
		for (let r = 0, i = e.length; r !== i; ++r) {
			let i = e[r];
			i.id in t && n.push(i);
		}
		return n;
	}
};
function Wg(e, t, n) {
	let r = e.createShader(t);
	return e.shaderSource(r, n), e.compileShader(r), r;
}
var Gg = 37297, Kg = 0;
function qg(e, t) {
	let n = e.split("\n"), r = [], i = Math.max(t - 6, 0), a = Math.min(t + 6, n.length);
	for (let e = i; e < a; e++) {
		let i = e + 1;
		r.push(`${i === t ? ">" : " "} ${i}: ${n[e]}`);
	}
	return r.join("\n");
}
var Jg = /* @__PURE__ */ new Mu();
function Yg(e) {
	Lu._getMatrix(Jg, Lu.workingColorSpace, e);
	let t = `mat3( ${Jg.elements.map((e) => e.toFixed(4))} )`;
	switch (Lu.getTransfer(e)) {
		case Rl: return [t, "LinearTransferOETF"];
		case zl: return [t, "sRGBTransferOETF"];
		default: return Zl("WebGLProgram: Unsupported color space: ", e), [t, "LinearTransferOETF"];
	}
}
function Xg(e, t, n) {
	let r = e.getShaderParameter(t, e.COMPILE_STATUS), i = (e.getShaderInfoLog(t) || "").trim();
	if (r && i === "") return "";
	let a = /ERROR: 0:(\d+)/.exec(i);
	if (a) {
		let r = parseInt(a[1]);
		return n.toUpperCase() + "\n\n" + i + "\n\n" + qg(e.getShaderSource(t), r);
	} else return i;
}
function Zg(e, t) {
	let n = Yg(t);
	return [
		`vec4 ${e}( vec4 value ) {`,
		`	return ${n[1]}( vec4( value.rgb * ${n[0]}, value.a ) );`,
		"}"
	].join("\n");
}
var Qg = {
	1: "Linear",
	2: "Reinhard",
	3: "Cineon",
	4: "ACESFilmic",
	6: "AgX",
	7: "Neutral",
	5: "Custom"
};
function $g(e, t) {
	let n = Qg[t];
	return n === void 0 ? (Zl("WebGLProgram: Unsupported toneMapping:", t), "vec3 " + e + "( vec3 color ) { return LinearToneMapping( color ); }") : "vec3 " + e + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
}
var e_ = /* @__PURE__ */ new X();
function t_() {
	return Lu.getLuminanceCoefficients(e_), [
		"float luminance( const in vec3 rgb ) {",
		`	const vec3 weights = vec3( ${e_.x.toFixed(4)}, ${e_.y.toFixed(4)}, ${e_.z.toFixed(4)} );`,
		"	return dot( weights, rgb );",
		"}"
	].join("\n");
}
function n_(e) {
	return [e.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "", e.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""].filter(a_).join("\n");
}
function r_(e) {
	let t = [];
	for (let n in e) {
		let r = e[n];
		r !== !1 && t.push("#define " + n + " " + r);
	}
	return t.join("\n");
}
function i_(e, t) {
	let n = {}, r = e.getProgramParameter(t, e.ACTIVE_ATTRIBUTES);
	for (let i = 0; i < r; i++) {
		let r = e.getActiveAttrib(t, i), a = r.name, o = 1;
		r.type === e.FLOAT_MAT2 && (o = 2), r.type === e.FLOAT_MAT3 && (o = 3), r.type === e.FLOAT_MAT4 && (o = 4), n[a] = {
			type: r.type,
			location: e.getAttribLocation(t, a),
			locationSize: o
		};
	}
	return n;
}
function a_(e) {
	return e !== "";
}
function o_(e, t) {
	let n = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
	return e.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, n).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
}
function s_(e, t) {
	return e.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
}
var c_ = /^[ \t]*#include +<([\w\d./]+)>/gm;
function l_(e) {
	return e.replace(c_, d_);
}
var u_ = /* @__PURE__ */ new Map();
function d_(e, t) {
	let n = Zm[t];
	if (n === void 0) {
		let e = u_.get(t);
		if (e !== void 0) n = Zm[e], Zl("WebGLRenderer: Shader chunk \"%s\" has been deprecated. Use \"%s\" instead.", t, e);
		else throw Error("THREE.WebGLProgram: Can not resolve #include <" + t + ">");
	}
	return l_(n);
}
var f_ = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function p_(e) {
	return e.replace(f_, m_);
}
function m_(e, t, n, r) {
	let i = "";
	for (let e = parseInt(t); e < parseInt(n); e++) i += r.replace(/\[\s*i\s*\]/g, "[ " + e + " ]").replace(/UNROLLED_LOOP_INDEX/g, e);
	return i;
}
function h_(e) {
	let t = `precision ${e.precision} float;
	precision ${e.precision} int;
	precision ${e.precision} sampler2D;
	precision ${e.precision} samplerCube;
	precision ${e.precision} sampler3D;
	precision ${e.precision} sampler2DArray;
	precision ${e.precision} sampler2DShadow;
	precision ${e.precision} samplerCubeShadow;
	precision ${e.precision} sampler2DArrayShadow;
	precision ${e.precision} isampler2D;
	precision ${e.precision} isampler3D;
	precision ${e.precision} isamplerCube;
	precision ${e.precision} isampler2DArray;
	precision ${e.precision} usampler2D;
	precision ${e.precision} usampler3D;
	precision ${e.precision} usamplerCube;
	precision ${e.precision} usampler2DArray;
	`;
	return e.precision === "highp" ? t += "\n#define HIGH_PRECISION" : e.precision === "mediump" ? t += "\n#define MEDIUM_PRECISION" : e.precision === "lowp" && (t += "\n#define LOW_PRECISION"), t;
}
var g_ = {
	1: "SHADOWMAP_TYPE_PCF",
	3: "SHADOWMAP_TYPE_VSM"
};
function __(e) {
	return g_[e.shadowMapType] || "SHADOWMAP_TYPE_BASIC";
}
var v_ = {
	301: "ENVMAP_TYPE_CUBE",
	302: "ENVMAP_TYPE_CUBE",
	306: "ENVMAP_TYPE_CUBE_UV"
};
function y_(e) {
	return e.envMap === !1 ? "ENVMAP_TYPE_CUBE" : v_[e.envMapMode] || "ENVMAP_TYPE_CUBE";
}
var b_ = { 302: "ENVMAP_MODE_REFRACTION" };
function x_(e) {
	return e.envMap === !1 ? "ENVMAP_MODE_REFLECTION" : b_[e.envMapMode] || "ENVMAP_MODE_REFLECTION";
}
var S_ = {
	0: "ENVMAP_BLENDING_MULTIPLY",
	1: "ENVMAP_BLENDING_MIX",
	2: "ENVMAP_BLENDING_ADD"
};
function C_(e) {
	return e.envMap === !1 ? "ENVMAP_BLENDING_NONE" : S_[e.combine] || "ENVMAP_BLENDING_NONE";
}
function w_(e) {
	let t = e.envMapCubeUVHeight;
	if (t === null) return null;
	let n = Math.log2(t) - 2, r = 1 / t;
	return {
		texelWidth: 1 / (3 * Math.max(2 ** n, 112)),
		texelHeight: r,
		maxMip: n
	};
}
function T_(e, t, n, r) {
	let i = e.getContext(), a = n.defines, o = n.vertexShader, s = n.fragmentShader, c = __(n), l = y_(n), u = x_(n), d = C_(n), f = w_(n), p = n_(n), m = r_(a), h = i.createProgram(), g, _, v = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";
	n.isRawShaderMaterial ? (g = [
		"#define SHADER_TYPE " + n.shaderType,
		"#define SHADER_NAME " + n.shaderName,
		m
	].filter(a_).join("\n"), g.length > 0 && (g += "\n"), _ = [
		"#define SHADER_TYPE " + n.shaderType,
		"#define SHADER_NAME " + n.shaderName,
		m
	].filter(a_).join("\n"), _.length > 0 && (_ += "\n")) : (g = [
		h_(n),
		"#define SHADER_TYPE " + n.shaderType,
		"#define SHADER_NAME " + n.shaderName,
		m,
		n.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
		n.batching ? "#define USE_BATCHING" : "",
		n.batchingColor ? "#define USE_BATCHING_COLOR" : "",
		n.instancing ? "#define USE_INSTANCING" : "",
		n.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
		n.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
		n.useFog && n.fog ? "#define USE_FOG" : "",
		n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
		n.map ? "#define USE_MAP" : "",
		n.envMap ? "#define USE_ENVMAP" : "",
		n.envMap ? "#define " + u : "",
		n.lightMap ? "#define USE_LIGHTMAP" : "",
		n.aoMap ? "#define USE_AOMAP" : "",
		n.bumpMap ? "#define USE_BUMPMAP" : "",
		n.normalMap ? "#define USE_NORMALMAP" : "",
		n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
		n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
		n.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
		n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
		n.anisotropy ? "#define USE_ANISOTROPY" : "",
		n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
		n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
		n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
		n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
		n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
		n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
		n.specularMap ? "#define USE_SPECULARMAP" : "",
		n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
		n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
		n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
		n.metalnessMap ? "#define USE_METALNESSMAP" : "",
		n.alphaMap ? "#define USE_ALPHAMAP" : "",
		n.alphaHash ? "#define USE_ALPHAHASH" : "",
		n.transmission ? "#define USE_TRANSMISSION" : "",
		n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
		n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
		n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
		n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
		n.mapUv ? "#define MAP_UV " + n.mapUv : "",
		n.alphaMapUv ? "#define ALPHAMAP_UV " + n.alphaMapUv : "",
		n.lightMapUv ? "#define LIGHTMAP_UV " + n.lightMapUv : "",
		n.aoMapUv ? "#define AOMAP_UV " + n.aoMapUv : "",
		n.emissiveMapUv ? "#define EMISSIVEMAP_UV " + n.emissiveMapUv : "",
		n.bumpMapUv ? "#define BUMPMAP_UV " + n.bumpMapUv : "",
		n.normalMapUv ? "#define NORMALMAP_UV " + n.normalMapUv : "",
		n.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + n.displacementMapUv : "",
		n.metalnessMapUv ? "#define METALNESSMAP_UV " + n.metalnessMapUv : "",
		n.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + n.roughnessMapUv : "",
		n.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + n.anisotropyMapUv : "",
		n.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + n.clearcoatMapUv : "",
		n.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + n.clearcoatNormalMapUv : "",
		n.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + n.clearcoatRoughnessMapUv : "",
		n.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + n.iridescenceMapUv : "",
		n.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + n.iridescenceThicknessMapUv : "",
		n.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + n.sheenColorMapUv : "",
		n.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + n.sheenRoughnessMapUv : "",
		n.specularMapUv ? "#define SPECULARMAP_UV " + n.specularMapUv : "",
		n.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + n.specularColorMapUv : "",
		n.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + n.specularIntensityMapUv : "",
		n.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + n.transmissionMapUv : "",
		n.thicknessMapUv ? "#define THICKNESSMAP_UV " + n.thicknessMapUv : "",
		n.vertexTangents && n.flatShading === !1 ? "#define USE_TANGENT" : "",
		n.vertexNormals ? "#define HAS_NORMAL" : "",
		n.vertexColors ? "#define USE_COLOR" : "",
		n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
		n.vertexUv1s ? "#define USE_UV1" : "",
		n.vertexUv2s ? "#define USE_UV2" : "",
		n.vertexUv3s ? "#define USE_UV3" : "",
		n.pointsUvs ? "#define USE_POINTS_UV" : "",
		n.flatShading ? "#define FLAT_SHADED" : "",
		n.skinning ? "#define USE_SKINNING" : "",
		n.morphTargets ? "#define USE_MORPHTARGETS" : "",
		n.morphNormals && n.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
		n.morphColors ? "#define USE_MORPHCOLORS" : "",
		n.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "",
		n.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "",
		n.doubleSided ? "#define DOUBLE_SIDED" : "",
		n.flipSided ? "#define FLIP_SIDED" : "",
		n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
		n.shadowMapEnabled ? "#define " + c : "",
		n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
		n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
		n.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
		n.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
		"uniform mat4 modelMatrix;",
		"uniform mat4 modelViewMatrix;",
		"uniform mat4 projectionMatrix;",
		"uniform mat4 viewMatrix;",
		"uniform mat3 normalMatrix;",
		"uniform vec3 cameraPosition;",
		"uniform bool isOrthographic;",
		"#ifdef USE_INSTANCING",
		"	attribute mat4 instanceMatrix;",
		"#endif",
		"#ifdef USE_INSTANCING_COLOR",
		"	attribute vec3 instanceColor;",
		"#endif",
		"#ifdef USE_INSTANCING_MORPH",
		"	uniform sampler2D morphTexture;",
		"#endif",
		"attribute vec3 position;",
		"attribute vec3 normal;",
		"attribute vec2 uv;",
		"#ifdef USE_UV1",
		"	attribute vec2 uv1;",
		"#endif",
		"#ifdef USE_UV2",
		"	attribute vec2 uv2;",
		"#endif",
		"#ifdef USE_UV3",
		"	attribute vec2 uv3;",
		"#endif",
		"#ifdef USE_TANGENT",
		"	attribute vec4 tangent;",
		"#endif",
		"#if defined( USE_COLOR_ALPHA )",
		"	attribute vec4 color;",
		"#elif defined( USE_COLOR )",
		"	attribute vec3 color;",
		"#endif",
		"#ifdef USE_SKINNING",
		"	attribute vec4 skinIndex;",
		"	attribute vec4 skinWeight;",
		"#endif",
		"\n"
	].filter(a_).join("\n"), _ = [
		h_(n),
		"#define SHADER_TYPE " + n.shaderType,
		"#define SHADER_NAME " + n.shaderName,
		m,
		n.useFog && n.fog ? "#define USE_FOG" : "",
		n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
		n.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
		n.map ? "#define USE_MAP" : "",
		n.matcap ? "#define USE_MATCAP" : "",
		n.envMap ? "#define USE_ENVMAP" : "",
		n.envMap ? "#define " + l : "",
		n.envMap ? "#define " + u : "",
		n.envMap ? "#define " + d : "",
		f ? "#define CUBEUV_TEXEL_WIDTH " + f.texelWidth : "",
		f ? "#define CUBEUV_TEXEL_HEIGHT " + f.texelHeight : "",
		f ? "#define CUBEUV_MAX_MIP " + f.maxMip + ".0" : "",
		n.lightMap ? "#define USE_LIGHTMAP" : "",
		n.aoMap ? "#define USE_AOMAP" : "",
		n.bumpMap ? "#define USE_BUMPMAP" : "",
		n.normalMap ? "#define USE_NORMALMAP" : "",
		n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
		n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
		n.packedNormalMap ? "#define USE_PACKED_NORMALMAP" : "",
		n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
		n.anisotropy ? "#define USE_ANISOTROPY" : "",
		n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
		n.clearcoat ? "#define USE_CLEARCOAT" : "",
		n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
		n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
		n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
		n.dispersion ? "#define USE_DISPERSION" : "",
		n.iridescence ? "#define USE_IRIDESCENCE" : "",
		n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
		n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
		n.specularMap ? "#define USE_SPECULARMAP" : "",
		n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
		n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
		n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
		n.metalnessMap ? "#define USE_METALNESSMAP" : "",
		n.alphaMap ? "#define USE_ALPHAMAP" : "",
		n.alphaTest ? "#define USE_ALPHATEST" : "",
		n.alphaHash ? "#define USE_ALPHAHASH" : "",
		n.sheen ? "#define USE_SHEEN" : "",
		n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
		n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
		n.transmission ? "#define USE_TRANSMISSION" : "",
		n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
		n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
		n.vertexTangents && n.flatShading === !1 ? "#define USE_TANGENT" : "",
		n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "",
		n.vertexAlphas || n.batchingColor ? "#define USE_COLOR_ALPHA" : "",
		n.vertexUv1s ? "#define USE_UV1" : "",
		n.vertexUv2s ? "#define USE_UV2" : "",
		n.vertexUv3s ? "#define USE_UV3" : "",
		n.pointsUvs ? "#define USE_POINTS_UV" : "",
		n.gradientMap ? "#define USE_GRADIENTMAP" : "",
		n.flatShading ? "#define FLAT_SHADED" : "",
		n.doubleSided ? "#define DOUBLE_SIDED" : "",
		n.flipSided ? "#define FLIP_SIDED" : "",
		n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
		n.shadowMapEnabled ? "#define " + c : "",
		n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
		n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
		n.numLightProbeGrids > 0 ? "#define USE_LIGHT_PROBES_GRID" : "",
		n.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
		n.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
		n.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
		n.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
		"uniform mat4 viewMatrix;",
		"uniform vec3 cameraPosition;",
		"uniform bool isOrthographic;",
		n.toneMapping === 0 ? "" : "#define TONE_MAPPING",
		n.toneMapping === 0 ? "" : Zm.tonemapping_pars_fragment,
		n.toneMapping === 0 ? "" : $g("toneMapping", n.toneMapping),
		n.dithering ? "#define DITHERING" : "",
		n.opaque ? "#define OPAQUE" : "",
		Zm.colorspace_pars_fragment,
		Zg("linearToOutputTexel", n.outputColorSpace),
		t_(),
		n.useDepthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "",
		"\n"
	].filter(a_).join("\n")), o = l_(o), o = o_(o, n), o = s_(o, n), s = l_(s), s = o_(s, n), s = s_(s, n), o = p_(o), s = p_(s), n.isRawShaderMaterial !== !0 && (v = "#version 300 es\n", g = [
		p,
		"#define attribute in",
		"#define varying out",
		"#define texture2D texture"
	].join("\n") + "\n" + g, _ = [
		"#define varying in",
		n.glslVersion === "300 es" ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
		n.glslVersion === "300 es" ? "" : "#define gl_FragColor pc_fragColor",
		"#define gl_FragDepthEXT gl_FragDepth",
		"#define texture2D texture",
		"#define textureCube texture",
		"#define texture2DProj textureProj",
		"#define texture2DLodEXT textureLod",
		"#define texture2DProjLodEXT textureProjLod",
		"#define textureCubeLodEXT textureLod",
		"#define texture2DGradEXT textureGrad",
		"#define texture2DProjGradEXT textureProjGrad",
		"#define textureCubeGradEXT textureGrad"
	].join("\n") + "\n" + _);
	let y = v + g + o, b = v + _ + s, x = Wg(i, i.VERTEX_SHADER, y), S = Wg(i, i.FRAGMENT_SHADER, b);
	i.attachShader(h, x), i.attachShader(h, S), n.index0AttributeName === void 0 ? n.hasPositionAttribute === !0 && i.bindAttribLocation(h, 0, "position") : i.bindAttribLocation(h, 0, n.index0AttributeName), i.linkProgram(h);
	function C(t) {
		if (e.debug.checkShaderErrors) {
			let n = i.getProgramInfoLog(h) || "", r = i.getShaderInfoLog(x) || "", a = i.getShaderInfoLog(S) || "", o = n.trim(), s = r.trim(), c = a.trim(), l = !0, u = !0;
			if (i.getProgramParameter(h, i.LINK_STATUS) === !1) if (l = !1, typeof e.debug.onShaderError == "function") e.debug.onShaderError(i, h, x, S);
			else {
				let e = Xg(i, x, "vertex"), n = Xg(i, S, "fragment");
				J("WebGLProgram: Shader Error " + i.getError() + " - VALIDATE_STATUS " + i.getProgramParameter(h, i.VALIDATE_STATUS) + "\n\nMaterial Name: " + t.name + "\nMaterial Type: " + t.type + "\n\nProgram Info Log: " + o + "\n" + e + "\n" + n);
			}
			else o === "" ? (s === "" || c === "") && (u = !1) : Zl("WebGLProgram: Program Info Log:", o);
			u && (t.diagnostics = {
				runnable: l,
				programLog: o,
				vertexShader: {
					log: s,
					prefix: g
				},
				fragmentShader: {
					log: c,
					prefix: _
				}
			});
		}
		i.deleteShader(x), i.deleteShader(S), w = new Ug(i, h), T = i_(i, h);
	}
	let w;
	this.getUniforms = function() {
		return w === void 0 && C(this), w;
	};
	let T;
	this.getAttributes = function() {
		return T === void 0 && C(this), T;
	};
	let E = n.rendererExtensionParallelShaderCompile === !1;
	return this.isReady = function() {
		return E === !1 && (E = i.getProgramParameter(h, Gg)), E;
	}, this.destroy = function() {
		r.releaseStatesOfProgram(this), i.deleteProgram(h), this.program = void 0;
	}, this.type = n.shaderType, this.name = n.shaderName, this.id = Kg++, this.cacheKey = t, this.usedTimes = 1, this.program = h, this.vertexShader = x, this.fragmentShader = S, this;
}
var E_ = 0, D_ = class {
	constructor() {
		this.shaderCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map();
	}
	update(e, t, n) {
		let r = this._getShaderCacheForMaterial(e);
		return r.has(t) === !1 && (r.add(t), t.usedTimes++), r.has(n) === !1 && (r.add(n), n.usedTimes++), this;
	}
	remove(e) {
		let t = this.materialCache.get(e);
		for (let e of t) e.usedTimes--, e.usedTimes === 0 && this.shaderCache.delete(e.code);
		return this.materialCache.delete(e), this;
	}
	getVertexShaderStage(e) {
		return this._getShaderStage(e.vertexShader);
	}
	getFragmentShaderStage(e) {
		return this._getShaderStage(e.fragmentShader);
	}
	dispose() {
		this.shaderCache.clear(), this.materialCache.clear();
	}
	_getShaderCacheForMaterial(e) {
		let t = this.materialCache, n = t.get(e);
		return n === void 0 && (n = /* @__PURE__ */ new Set(), t.set(e, n)), n;
	}
	_getShaderStage(e) {
		let t = this.shaderCache, n = t.get(e);
		return n === void 0 && (n = new O_(e), t.set(e, n)), n;
	}
}, O_ = class {
	constructor(e) {
		this.id = E_++, this.code = e, this.usedTimes = 0;
	}
};
function k_(e) {
	return e === 1030 || e === 37490 || e === 36285;
}
function A_(e, t, n, r, i, a) {
	let o = new ud(), s = new D_(), c = /* @__PURE__ */ new Set(), l = [], u = /* @__PURE__ */ new Map(), d = r.logarithmicDepthBuffer, f = r.precision, p = {
		MeshDepthMaterial: "depth",
		MeshDistanceMaterial: "distance",
		MeshNormalMaterial: "normal",
		MeshBasicMaterial: "basic",
		MeshLambertMaterial: "lambert",
		MeshPhongMaterial: "phong",
		MeshToonMaterial: "toon",
		MeshStandardMaterial: "physical",
		MeshPhysicalMaterial: "physical",
		MeshMatcapMaterial: "matcap",
		LineBasicMaterial: "basic",
		LineDashedMaterial: "dashed",
		PointsMaterial: "points",
		ShadowMaterial: "shadow",
		SpriteMaterial: "sprite"
	};
	function m(e) {
		return c.add(e), e === 0 ? "uv" : `uv${e}`;
	}
	function h(i, o, l, u, h, g) {
		let _ = u.fog, v = h.geometry, y = i.isMeshStandardMaterial || i.isMeshLambertMaterial || i.isMeshPhongMaterial ? u.environment : null, b = i.isMeshStandardMaterial || i.isMeshLambertMaterial && !i.envMap || i.isMeshPhongMaterial && !i.envMap, x = t.get(i.envMap || y, b), S = x && x.mapping === 306 ? x.image.height : null, C = p[i.type];
		i.precision !== null && (f = r.getMaxPrecision(i.precision), f !== i.precision && Zl("WebGLProgram.getParameters:", i.precision, "not supported, using", f, "instead."));
		let w = v.morphAttributes.position || v.morphAttributes.normal || v.morphAttributes.color, T = w === void 0 ? 0 : w.length, E = 0;
		v.morphAttributes.position !== void 0 && (E = 1), v.morphAttributes.normal !== void 0 && (E = 2), v.morphAttributes.color !== void 0 && (E = 3);
		let D, O, k, A;
		if (C) {
			let e = Qm[C];
			D = e.vertexShader, O = e.fragmentShader;
		} else {
			D = i.vertexShader, O = i.fragmentShader;
			let e = s.getVertexShaderStage(i), t = s.getFragmentShaderStage(i);
			s.update(i, e, t), k = e.id, A = t.id;
		}
		let j = e.getRenderTarget(), M = e.state.buffers.depth.getReversed(), N = h.isInstancedMesh === !0, P = h.isBatchedMesh === !0, F = !!i.map, I = !!i.matcap, R = !!x, ee = !!i.aoMap, te = !!i.lightMap, ne = !!i.bumpMap && i.wireframe === !1, z = !!i.normalMap, B = !!i.displacementMap, V = !!i.emissiveMap, re = !!i.metalnessMap, ie = !!i.roughnessMap, ae = i.anisotropy > 0, oe = i.clearcoat > 0, se = i.dispersion > 0, ce = i.iridescence > 0, le = i.sheen > 0, ue = i.transmission > 0, de = ae && !!i.anisotropyMap, fe = oe && !!i.clearcoatMap, pe = oe && !!i.clearcoatNormalMap, me = oe && !!i.clearcoatRoughnessMap, he = ce && !!i.iridescenceMap, ge = ce && !!i.iridescenceThicknessMap, H = le && !!i.sheenColorMap, _e = le && !!i.sheenRoughnessMap, ve = !!i.specularMap, ye = !!i.specularColorMap, U = !!i.specularIntensityMap, be = ue && !!i.transmissionMap, W = ue && !!i.thicknessMap, xe = !!i.gradientMap, Se = !!i.alphaMap, Ce = i.alphaTest > 0, we = !!i.alphaHash, Te = !!i.extensions, Ee = 0;
		i.toneMapped && (j === null || j.isXRRenderTarget === !0) && (Ee = e.toneMapping);
		let De = {
			shaderID: C,
			shaderType: i.type,
			shaderName: i.name,
			vertexShader: D,
			fragmentShader: O,
			defines: i.defines,
			customVertexShaderID: k,
			customFragmentShaderID: A,
			isRawShaderMaterial: i.isRawShaderMaterial === !0,
			glslVersion: i.glslVersion,
			precision: f,
			batching: P,
			batchingColor: P && h._colorsTexture !== null,
			instancing: N,
			instancingColor: N && h.instanceColor !== null,
			instancingMorph: N && h.morphTexture !== null,
			outputColorSpace: j === null ? e.outputColorSpace : j.isXRRenderTarget === !0 ? j.texture.colorSpace : Lu.workingColorSpace,
			alphaToCoverage: !!i.alphaToCoverage,
			map: F,
			matcap: I,
			envMap: R,
			envMapMode: R && x.mapping,
			envMapCubeUVHeight: S,
			aoMap: ee,
			lightMap: te,
			bumpMap: ne,
			normalMap: z,
			displacementMap: B,
			emissiveMap: V,
			normalMapObjectSpace: z && i.normalMapType === 1,
			normalMapTangentSpace: z && i.normalMapType === 0,
			packedNormalMap: z && i.normalMapType === 0 && k_(i.normalMap.format),
			metalnessMap: re,
			roughnessMap: ie,
			anisotropy: ae,
			anisotropyMap: de,
			clearcoat: oe,
			clearcoatMap: fe,
			clearcoatNormalMap: pe,
			clearcoatRoughnessMap: me,
			dispersion: se,
			iridescence: ce,
			iridescenceMap: he,
			iridescenceThicknessMap: ge,
			sheen: le,
			sheenColorMap: H,
			sheenRoughnessMap: _e,
			specularMap: ve,
			specularColorMap: ye,
			specularIntensityMap: U,
			transmission: ue,
			transmissionMap: be,
			thicknessMap: W,
			gradientMap: xe,
			opaque: i.transparent === !1 && i.blending === 1 && i.alphaToCoverage === !1,
			alphaMap: Se,
			alphaTest: Ce,
			alphaHash: we,
			combine: i.combine,
			mapUv: F && m(i.map.channel),
			aoMapUv: ee && m(i.aoMap.channel),
			lightMapUv: te && m(i.lightMap.channel),
			bumpMapUv: ne && m(i.bumpMap.channel),
			normalMapUv: z && m(i.normalMap.channel),
			displacementMapUv: B && m(i.displacementMap.channel),
			emissiveMapUv: V && m(i.emissiveMap.channel),
			metalnessMapUv: re && m(i.metalnessMap.channel),
			roughnessMapUv: ie && m(i.roughnessMap.channel),
			anisotropyMapUv: de && m(i.anisotropyMap.channel),
			clearcoatMapUv: fe && m(i.clearcoatMap.channel),
			clearcoatNormalMapUv: pe && m(i.clearcoatNormalMap.channel),
			clearcoatRoughnessMapUv: me && m(i.clearcoatRoughnessMap.channel),
			iridescenceMapUv: he && m(i.iridescenceMap.channel),
			iridescenceThicknessMapUv: ge && m(i.iridescenceThicknessMap.channel),
			sheenColorMapUv: H && m(i.sheenColorMap.channel),
			sheenRoughnessMapUv: _e && m(i.sheenRoughnessMap.channel),
			specularMapUv: ve && m(i.specularMap.channel),
			specularColorMapUv: ye && m(i.specularColorMap.channel),
			specularIntensityMapUv: U && m(i.specularIntensityMap.channel),
			transmissionMapUv: be && m(i.transmissionMap.channel),
			thicknessMapUv: W && m(i.thicknessMap.channel),
			alphaMapUv: Se && m(i.alphaMap.channel),
			vertexTangents: !!v.attributes.tangent && (z || ae),
			vertexNormals: !!v.attributes.normal,
			vertexColors: i.vertexColors,
			vertexAlphas: i.vertexColors === !0 && !!v.attributes.color && v.attributes.color.itemSize === 4,
			pointsUvs: h.isPoints === !0 && !!v.attributes.uv && (F || Se),
			fog: !!_,
			useFog: i.fog === !0,
			fogExp2: !!_ && _.isFogExp2,
			flatShading: i.wireframe === !1 && (i.flatShading === !0 || v.attributes.normal === void 0 && z === !1 && (i.isMeshLambertMaterial || i.isMeshPhongMaterial || i.isMeshStandardMaterial || i.isMeshPhysicalMaterial)),
			sizeAttenuation: i.sizeAttenuation === !0,
			logarithmicDepthBuffer: d,
			reversedDepthBuffer: M,
			skinning: h.isSkinnedMesh === !0,
			hasPositionAttribute: v.attributes.position !== void 0,
			morphTargets: v.morphAttributes.position !== void 0,
			morphNormals: v.morphAttributes.normal !== void 0,
			morphColors: v.morphAttributes.color !== void 0,
			morphTargetsCount: T,
			morphTextureStride: E,
			numDirLights: o.directional.length,
			numPointLights: o.point.length,
			numSpotLights: o.spot.length,
			numSpotLightMaps: o.spotLightMap.length,
			numRectAreaLights: o.rectArea.length,
			numHemiLights: o.hemi.length,
			numDirLightShadows: o.directionalShadowMap.length,
			numPointLightShadows: o.pointShadowMap.length,
			numSpotLightShadows: o.spotShadowMap.length,
			numSpotLightShadowsWithMaps: o.numSpotLightShadowsWithMaps,
			numLightProbes: o.numLightProbes,
			numLightProbeGrids: g.length,
			numClippingPlanes: a.numPlanes,
			numClipIntersection: a.numIntersection,
			dithering: i.dithering,
			shadowMapEnabled: e.shadowMap.enabled && l.length > 0,
			shadowMapType: e.shadowMap.type,
			toneMapping: Ee,
			decodeVideoTexture: F && i.map.isVideoTexture === !0 && Lu.getTransfer(i.map.colorSpace) === "srgb",
			decodeVideoTextureEmissive: V && i.emissiveMap.isVideoTexture === !0 && Lu.getTransfer(i.emissiveMap.colorSpace) === "srgb",
			premultipliedAlpha: i.premultipliedAlpha,
			doubleSided: i.side === 2,
			flipSided: i.side === 1,
			useDepthPacking: i.depthPacking >= 0,
			depthPacking: i.depthPacking || 0,
			index0AttributeName: i.index0AttributeName,
			extensionClipCullDistance: Te && i.extensions.clipCullDistance === !0 && n.has("WEBGL_clip_cull_distance"),
			extensionMultiDraw: (Te && i.extensions.multiDraw === !0 || P) && n.has("WEBGL_multi_draw"),
			rendererExtensionParallelShaderCompile: n.has("KHR_parallel_shader_compile"),
			customProgramCacheKey: i.customProgramCacheKey()
		};
		return De.vertexUv1s = c.has(1), De.vertexUv2s = c.has(2), De.vertexUv3s = c.has(3), c.clear(), De;
	}
	function g(t) {
		let n = [];
		if (t.shaderID ? n.push(t.shaderID) : (n.push(t.customVertexShaderID), n.push(t.customFragmentShaderID)), t.defines !== void 0) for (let e in t.defines) n.push(e), n.push(t.defines[e]);
		return t.isRawShaderMaterial === !1 && (_(n, t), v(n, t), n.push(e.outputColorSpace)), n.push(t.customProgramCacheKey), n.join();
	}
	function _(e, t) {
		e.push(t.precision), e.push(t.outputColorSpace), e.push(t.envMapMode), e.push(t.envMapCubeUVHeight), e.push(t.mapUv), e.push(t.alphaMapUv), e.push(t.lightMapUv), e.push(t.aoMapUv), e.push(t.bumpMapUv), e.push(t.normalMapUv), e.push(t.displacementMapUv), e.push(t.emissiveMapUv), e.push(t.metalnessMapUv), e.push(t.roughnessMapUv), e.push(t.anisotropyMapUv), e.push(t.clearcoatMapUv), e.push(t.clearcoatNormalMapUv), e.push(t.clearcoatRoughnessMapUv), e.push(t.iridescenceMapUv), e.push(t.iridescenceThicknessMapUv), e.push(t.sheenColorMapUv), e.push(t.sheenRoughnessMapUv), e.push(t.specularMapUv), e.push(t.specularColorMapUv), e.push(t.specularIntensityMapUv), e.push(t.transmissionMapUv), e.push(t.thicknessMapUv), e.push(t.combine), e.push(t.fogExp2), e.push(t.sizeAttenuation), e.push(t.morphTargetsCount), e.push(t.morphAttributeCount), e.push(t.numDirLights), e.push(t.numPointLights), e.push(t.numSpotLights), e.push(t.numSpotLightMaps), e.push(t.numHemiLights), e.push(t.numRectAreaLights), e.push(t.numDirLightShadows), e.push(t.numPointLightShadows), e.push(t.numSpotLightShadows), e.push(t.numSpotLightShadowsWithMaps), e.push(t.numLightProbes), e.push(t.shadowMapType), e.push(t.toneMapping), e.push(t.numClippingPlanes), e.push(t.numClipIntersection), e.push(t.depthPacking);
	}
	function v(e, t) {
		o.disableAll(), t.instancing && o.enable(0), t.instancingColor && o.enable(1), t.instancingMorph && o.enable(2), t.matcap && o.enable(3), t.envMap && o.enable(4), t.normalMapObjectSpace && o.enable(5), t.normalMapTangentSpace && o.enable(6), t.clearcoat && o.enable(7), t.iridescence && o.enable(8), t.alphaTest && o.enable(9), t.vertexColors && o.enable(10), t.vertexAlphas && o.enable(11), t.vertexUv1s && o.enable(12), t.vertexUv2s && o.enable(13), t.vertexUv3s && o.enable(14), t.vertexTangents && o.enable(15), t.anisotropy && o.enable(16), t.alphaHash && o.enable(17), t.batching && o.enable(18), t.dispersion && o.enable(19), t.batchingColor && o.enable(20), t.gradientMap && o.enable(21), t.packedNormalMap && o.enable(22), t.vertexNormals && o.enable(23), e.push(o.mask), o.disableAll(), t.fog && o.enable(0), t.useFog && o.enable(1), t.flatShading && o.enable(2), t.logarithmicDepthBuffer && o.enable(3), t.reversedDepthBuffer && o.enable(4), t.skinning && o.enable(5), t.morphTargets && o.enable(6), t.morphNormals && o.enable(7), t.morphColors && o.enable(8), t.premultipliedAlpha && o.enable(9), t.shadowMapEnabled && o.enable(10), t.doubleSided && o.enable(11), t.flipSided && o.enable(12), t.useDepthPacking && o.enable(13), t.dithering && o.enable(14), t.transmission && o.enable(15), t.sheen && o.enable(16), t.opaque && o.enable(17), t.pointsUvs && o.enable(18), t.decodeVideoTexture && o.enable(19), t.decodeVideoTextureEmissive && o.enable(20), t.alphaToCoverage && o.enable(21), t.numLightProbeGrids > 0 && o.enable(22), t.hasPositionAttribute && o.enable(23), e.push(o.mask);
	}
	function y(e) {
		let t = p[e.type], n;
		if (t) {
			let e = Qm[t];
			n = Vp.clone(e.uniforms);
		} else n = e.uniforms;
		return n;
	}
	function b(t, n) {
		let r = u.get(n);
		return r === void 0 ? (r = new T_(e, n, t, i), l.push(r), u.set(n, r)) : ++r.usedTimes, r;
	}
	function x(e) {
		if (--e.usedTimes === 0) {
			let t = l.indexOf(e);
			l[t] = l[l.length - 1], l.pop(), u.delete(e.cacheKey), e.destroy();
		}
	}
	function S(e) {
		s.remove(e);
	}
	function C() {
		s.dispose();
	}
	return {
		getParameters: h,
		getProgramCacheKey: g,
		getUniforms: y,
		acquireProgram: b,
		releaseProgram: x,
		releaseShaderCache: S,
		programs: l,
		dispose: C
	};
}
function j_() {
	let e = /* @__PURE__ */ new WeakMap();
	function t(t) {
		return e.has(t);
	}
	function n(t) {
		let n = e.get(t);
		return n === void 0 && (n = {}, e.set(t, n)), n;
	}
	function r(t) {
		e.delete(t);
	}
	function i(t, n, r) {
		e.get(t)[n] = r;
	}
	function a() {
		e = /* @__PURE__ */ new WeakMap();
	}
	return {
		has: t,
		get: n,
		remove: r,
		update: i,
		dispose: a
	};
}
function M_(e, t) {
	return e.groupOrder === t.groupOrder ? e.renderOrder === t.renderOrder ? e.material.id === t.material.id ? e.materialVariant === t.materialVariant ? e.z === t.z ? e.id - t.id : e.z - t.z : e.materialVariant - t.materialVariant : e.material.id - t.material.id : e.renderOrder - t.renderOrder : e.groupOrder - t.groupOrder;
}
function N_(e, t) {
	return e.groupOrder === t.groupOrder ? e.renderOrder === t.renderOrder ? e.z === t.z ? e.id - t.id : t.z - e.z : e.renderOrder - t.renderOrder : e.groupOrder - t.groupOrder;
}
function P_() {
	let e = [], t = 0, n = [], r = [], i = [];
	function a() {
		t = 0, n.length = 0, r.length = 0, i.length = 0;
	}
	function o(e) {
		let t = 0;
		return e.isInstancedMesh && (t += 2), e.isSkinnedMesh && (t += 1), t;
	}
	function s(n, r, i, a, s, c) {
		let l = e[t];
		return l === void 0 ? (l = {
			id: n.id,
			object: n,
			geometry: r,
			material: i,
			materialVariant: o(n),
			groupOrder: a,
			renderOrder: n.renderOrder,
			z: s,
			group: c
		}, e[t] = l) : (l.id = n.id, l.object = n, l.geometry = r, l.material = i, l.materialVariant = o(n), l.groupOrder = a, l.renderOrder = n.renderOrder, l.z = s, l.group = c), t++, l;
	}
	function c(e, t, a, o, c, l) {
		let u = s(e, t, a, o, c, l);
		a.transmission > 0 ? r.push(u) : a.transparent === !0 ? i.push(u) : n.push(u);
	}
	function l(e, t, a, o, c, l) {
		let u = s(e, t, a, o, c, l);
		a.transmission > 0 ? r.unshift(u) : a.transparent === !0 ? i.unshift(u) : n.unshift(u);
	}
	function u(e, t, a) {
		n.length > 1 && n.sort(e || M_), r.length > 1 && r.sort(t || N_), i.length > 1 && i.sort(t || N_), a && (n.reverse(), r.reverse(), i.reverse());
	}
	function d() {
		for (let n = t, r = e.length; n < r; n++) {
			let t = e[n];
			if (t.id === null) break;
			t.id = null, t.object = null, t.geometry = null, t.material = null, t.group = null;
		}
	}
	return {
		opaque: n,
		transmissive: r,
		transparent: i,
		init: a,
		push: c,
		unshift: l,
		finish: d,
		sort: u
	};
}
function F_() {
	let e = /* @__PURE__ */ new WeakMap();
	function t(t, n) {
		let r = e.get(t), i;
		return r === void 0 ? (i = new P_(), e.set(t, [i])) : n >= r.length ? (i = new P_(), r.push(i)) : i = r[n], i;
	}
	function n() {
		e = /* @__PURE__ */ new WeakMap();
	}
	return {
		get: t,
		dispose: n
	};
}
function I_() {
	let e = {};
	return { get: function(t) {
		if (e[t.id] !== void 0) return e[t.id];
		let n;
		switch (t.type) {
			case "DirectionalLight":
				n = {
					direction: new X(),
					color: new Pd()
				};
				break;
			case "SpotLight":
				n = {
					position: new X(),
					direction: new X(),
					color: new Pd(),
					distance: 0,
					coneCos: 0,
					penumbraCos: 0,
					decay: 0
				};
				break;
			case "PointLight":
				n = {
					position: new X(),
					color: new Pd(),
					distance: 0,
					decay: 0
				};
				break;
			case "HemisphereLight":
				n = {
					direction: new X(),
					skyColor: new Pd(),
					groundColor: new Pd()
				};
				break;
			case "RectAreaLight":
				n = {
					color: new Pd(),
					position: new X(),
					halfWidth: new X(),
					halfHeight: new X()
				};
				break;
		}
		return e[t.id] = n, n;
	} };
}
function L_() {
	let e = {};
	return { get: function(t) {
		if (e[t.id] !== void 0) return e[t.id];
		let n;
		switch (t.type) {
			case "DirectionalLight":
				n = {
					shadowIntensity: 1,
					shadowBias: 0,
					shadowNormalBias: 0,
					shadowRadius: 1,
					shadowMapSize: new Ou()
				};
				break;
			case "SpotLight":
				n = {
					shadowIntensity: 1,
					shadowBias: 0,
					shadowNormalBias: 0,
					shadowRadius: 1,
					shadowMapSize: new Ou()
				};
				break;
			case "PointLight":
				n = {
					shadowIntensity: 1,
					shadowBias: 0,
					shadowNormalBias: 0,
					shadowRadius: 1,
					shadowMapSize: new Ou(),
					shadowCameraNear: 1,
					shadowCameraFar: 1e3
				};
				break;
		}
		return e[t.id] = n, n;
	} };
}
var R_ = 0;
function z_(e, t) {
	return (t.castShadow ? 2 : 0) - (e.castShadow ? 2 : 0) + +!!t.map - !!e.map;
}
function B_(e) {
	let t = new I_(), n = L_(), r = {
		version: 0,
		hash: {
			directionalLength: -1,
			pointLength: -1,
			spotLength: -1,
			rectAreaLength: -1,
			hemiLength: -1,
			numDirectionalShadows: -1,
			numPointShadows: -1,
			numSpotShadows: -1,
			numSpotMaps: -1,
			numLightProbes: -1
		},
		ambient: [
			0,
			0,
			0
		],
		probe: [],
		directional: [],
		directionalShadow: [],
		directionalShadowMap: [],
		directionalShadowMatrix: [],
		spot: [],
		spotLightMap: [],
		spotShadow: [],
		spotShadowMap: [],
		spotLightMatrix: [],
		rectArea: [],
		rectAreaLTC1: null,
		rectAreaLTC2: null,
		point: [],
		pointShadow: [],
		pointShadowMap: [],
		pointShadowMatrix: [],
		hemi: [],
		numSpotLightShadowsWithMaps: 0,
		numLightProbes: 0
	};
	for (let e = 0; e < 9; e++) r.probe.push(new X());
	let i = new X(), a = new $u(), o = new $u();
	function s(i) {
		let a = 0, o = 0, s = 0;
		for (let e = 0; e < 9; e++) r.probe[e].set(0, 0, 0);
		let c = 0, l = 0, u = 0, d = 0, f = 0, p = 0, m = 0, h = 0, g = 0, _ = 0, v = 0;
		i.sort(z_);
		for (let e = 0, y = i.length; e < y; e++) {
			let y = i[e], b = y.color, x = y.intensity, S = y.distance, C = null;
			if (y.shadow && y.shadow.map && (C = y.shadow.map.texture.format === 1030 ? y.shadow.map.texture : y.shadow.map.depthTexture || y.shadow.map.texture), y.isAmbientLight) a += b.r * x, o += b.g * x, s += b.b * x;
			else if (y.isLightProbe) {
				for (let e = 0; e < 9; e++) r.probe[e].addScaledVector(y.sh.coefficients[e], x);
				v++;
			} else if (y.isDirectionalLight) {
				let e = t.get(y);
				if (e.color.copy(y.color).multiplyScalar(y.intensity), y.castShadow) {
					let e = y.shadow, t = n.get(y);
					t.shadowIntensity = e.intensity, t.shadowBias = e.bias, t.shadowNormalBias = e.normalBias, t.shadowRadius = e.radius, t.shadowMapSize = e.mapSize, r.directionalShadow[c] = t, r.directionalShadowMap[c] = C, r.directionalShadowMatrix[c] = y.shadow.matrix, p++;
				}
				r.directional[c] = e, c++;
			} else if (y.isSpotLight) {
				let e = t.get(y);
				e.position.setFromMatrixPosition(y.matrixWorld), e.color.copy(b).multiplyScalar(x), e.distance = S, e.coneCos = Math.cos(y.angle), e.penumbraCos = Math.cos(y.angle * (1 - y.penumbra)), e.decay = y.decay, r.spot[u] = e;
				let i = y.shadow;
				if (y.map && (r.spotLightMap[g] = y.map, g++, i.updateMatrices(y), y.castShadow && _++), r.spotLightMatrix[u] = i.matrix, y.castShadow) {
					let e = n.get(y);
					e.shadowIntensity = i.intensity, e.shadowBias = i.bias, e.shadowNormalBias = i.normalBias, e.shadowRadius = i.radius, e.shadowMapSize = i.mapSize, r.spotShadow[u] = e, r.spotShadowMap[u] = C, h++;
				}
				u++;
			} else if (y.isRectAreaLight) {
				let e = t.get(y);
				e.color.copy(b).multiplyScalar(x), e.halfWidth.set(y.width * .5, 0, 0), e.halfHeight.set(0, y.height * .5, 0), r.rectArea[d] = e, d++;
			} else if (y.isPointLight) {
				let e = t.get(y);
				if (e.color.copy(y.color).multiplyScalar(y.intensity), e.distance = y.distance, e.decay = y.decay, y.castShadow) {
					let e = y.shadow, t = n.get(y);
					t.shadowIntensity = e.intensity, t.shadowBias = e.bias, t.shadowNormalBias = e.normalBias, t.shadowRadius = e.radius, t.shadowMapSize = e.mapSize, t.shadowCameraNear = e.camera.near, t.shadowCameraFar = e.camera.far, r.pointShadow[l] = t, r.pointShadowMap[l] = C, r.pointShadowMatrix[l] = y.shadow.matrix, m++;
				}
				r.point[l] = e, l++;
			} else if (y.isHemisphereLight) {
				let e = t.get(y);
				e.skyColor.copy(y.color).multiplyScalar(x), e.groundColor.copy(y.groundColor).multiplyScalar(x), r.hemi[f] = e, f++;
			}
		}
		d > 0 && (e.has("OES_texture_float_linear") === !0 ? (r.rectAreaLTC1 = Z.LTC_FLOAT_1, r.rectAreaLTC2 = Z.LTC_FLOAT_2) : (r.rectAreaLTC1 = Z.LTC_HALF_1, r.rectAreaLTC2 = Z.LTC_HALF_2)), r.ambient[0] = a, r.ambient[1] = o, r.ambient[2] = s;
		let y = r.hash;
		(y.directionalLength !== c || y.pointLength !== l || y.spotLength !== u || y.rectAreaLength !== d || y.hemiLength !== f || y.numDirectionalShadows !== p || y.numPointShadows !== m || y.numSpotShadows !== h || y.numSpotMaps !== g || y.numLightProbes !== v) && (r.directional.length = c, r.spot.length = u, r.rectArea.length = d, r.point.length = l, r.hemi.length = f, r.directionalShadow.length = p, r.directionalShadowMap.length = p, r.pointShadow.length = m, r.pointShadowMap.length = m, r.spotShadow.length = h, r.spotShadowMap.length = h, r.directionalShadowMatrix.length = p, r.pointShadowMatrix.length = m, r.spotLightMatrix.length = h + g - _, r.spotLightMap.length = g, r.numSpotLightShadowsWithMaps = _, r.numLightProbes = v, y.directionalLength = c, y.pointLength = l, y.spotLength = u, y.rectAreaLength = d, y.hemiLength = f, y.numDirectionalShadows = p, y.numPointShadows = m, y.numSpotShadows = h, y.numSpotMaps = g, y.numLightProbes = v, r.version = R_++);
	}
	function c(e, t) {
		let n = 0, s = 0, c = 0, l = 0, u = 0, d = t.matrixWorldInverse;
		for (let t = 0, f = e.length; t < f; t++) {
			let f = e[t];
			if (f.isDirectionalLight) {
				let e = r.directional[n];
				e.direction.setFromMatrixPosition(f.matrixWorld), i.setFromMatrixPosition(f.target.matrixWorld), e.direction.sub(i), e.direction.transformDirection(d), n++;
			} else if (f.isSpotLight) {
				let e = r.spot[c];
				e.position.setFromMatrixPosition(f.matrixWorld), e.position.applyMatrix4(d), e.direction.setFromMatrixPosition(f.matrixWorld), i.setFromMatrixPosition(f.target.matrixWorld), e.direction.sub(i), e.direction.transformDirection(d), c++;
			} else if (f.isRectAreaLight) {
				let e = r.rectArea[l];
				e.position.setFromMatrixPosition(f.matrixWorld), e.position.applyMatrix4(d), o.identity(), a.copy(f.matrixWorld), a.premultiply(d), o.extractRotation(a), e.halfWidth.set(f.width * .5, 0, 0), e.halfHeight.set(0, f.height * .5, 0), e.halfWidth.applyMatrix4(o), e.halfHeight.applyMatrix4(o), l++;
			} else if (f.isPointLight) {
				let e = r.point[s];
				e.position.setFromMatrixPosition(f.matrixWorld), e.position.applyMatrix4(d), s++;
			} else if (f.isHemisphereLight) {
				let e = r.hemi[u];
				e.direction.setFromMatrixPosition(f.matrixWorld), e.direction.transformDirection(d), u++;
			}
		}
	}
	return {
		setup: s,
		setupView: c,
		state: r
	};
}
function V_(e) {
	let t = new B_(e), n = [], r = [], i = [];
	function a(e) {
		d.camera = e, n.length = 0, r.length = 0, i.length = 0;
	}
	function o(e) {
		n.push(e);
	}
	function s(e) {
		r.push(e);
	}
	function c(e) {
		i.push(e);
	}
	function l() {
		t.setup(n);
	}
	function u(e) {
		t.setupView(n, e);
	}
	let d = {
		lightsArray: n,
		shadowsArray: r,
		lightProbeGridArray: i,
		camera: null,
		lights: t,
		transmissionRenderTarget: {},
		textureUnits: 0
	};
	return {
		init: a,
		state: d,
		setupLights: l,
		setupLightsView: u,
		pushLight: o,
		pushShadow: s,
		pushLightProbeGrid: c
	};
}
function H_(e) {
	let t = /* @__PURE__ */ new WeakMap();
	function n(n, r = 0) {
		let i = t.get(n), a;
		return i === void 0 ? (a = new V_(e), t.set(n, [a])) : r >= i.length ? (a = new V_(e), i.push(a)) : a = i[r], a;
	}
	function r() {
		t = /* @__PURE__ */ new WeakMap();
	}
	return {
		get: n,
		dispose: r
	};
}
var U_ = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}", W_ = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );\n	gl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );\n}", G_ = [
	/* @__PURE__ */ new X(1, 0, 0),
	/* @__PURE__ */ new X(-1, 0, 0),
	/* @__PURE__ */ new X(0, 1, 0),
	/* @__PURE__ */ new X(0, -1, 0),
	/* @__PURE__ */ new X(0, 0, 1),
	/* @__PURE__ */ new X(0, 0, -1)
], K_ = [
	/* @__PURE__ */ new X(0, -1, 0),
	/* @__PURE__ */ new X(0, -1, 0),
	/* @__PURE__ */ new X(0, 0, 1),
	/* @__PURE__ */ new X(0, 0, -1),
	/* @__PURE__ */ new X(0, -1, 0),
	/* @__PURE__ */ new X(0, -1, 0)
], q_ = /* @__PURE__ */ new $u(), J_ = /* @__PURE__ */ new X(), Y_ = /* @__PURE__ */ new X();
function X_(e, t, n) {
	let r = new dp(), i = new Ou(), a = new Ou(), o = new Ju(), s = new qp(), c = new Jp(), l = {}, u = n.maxTextureSize, d = {
		0: 1,
		1: 0,
		2: 2
	}, f = new Wp({
		defines: { VSM_SAMPLES: 8 },
		uniforms: {
			shadow_pass: { value: null },
			resolution: { value: new Ou() },
			radius: { value: 4 }
		},
		vertexShader: U_,
		fragmentShader: W_
	}), p = f.clone();
	p.defines.HORIZONTAL_PASS = 1;
	let m = new jf();
	m.setAttribute("position", new gf(new Float32Array([
		-1,
		-1,
		.5,
		3,
		-1,
		.5,
		-1,
		3,
		.5
	]), 3));
	let h = new ep(m, f), g = this;
	this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = 1;
	let _ = this.type;
	this.render = function(t, n, s) {
		if (g.enabled === !1 || g.autoUpdate === !1 && g.needsUpdate === !1 || t.length === 0) return;
		this.type === 2 && (Zl("WebGLShadowMap: PCFSoftShadowMap has been deprecated. Using PCFShadowMap instead."), this.type = 1);
		let c = e.getRenderTarget(), l = e.getActiveCubeFace(), d = e.getActiveMipmapLevel(), f = e.state;
		f.setBlending(0), f.buffers.depth.getReversed() === !0 ? f.buffers.color.setClear(0, 0, 0, 0) : f.buffers.color.setClear(1, 1, 1, 1), f.buffers.depth.setTest(!0), f.setScissorTest(!1);
		let p = _ !== this.type;
		p && n.traverse(function(e) {
			e.material && (Array.isArray(e.material) ? e.material.forEach((e) => e.needsUpdate = !0) : e.material.needsUpdate = !0);
		});
		for (let c = 0, l = t.length; c < l; c++) {
			let l = t[c], d = l.shadow;
			if (d === void 0) {
				Zl("WebGLShadowMap:", l, "has no shadow.");
				continue;
			}
			if (d.autoUpdate === !1 && d.needsUpdate === !1) continue;
			i.copy(d.mapSize);
			let m = d.getFrameExtents();
			i.multiply(m), a.copy(d.mapSize), (i.x > u || i.y > u) && (i.x > u && (a.x = Math.floor(u / m.x), i.x = a.x * m.x, d.mapSize.x = a.x), i.y > u && (a.y = Math.floor(u / m.y), i.y = a.y * m.y, d.mapSize.y = a.y));
			let h = e.state.buffers.depth.getReversed();
			if (d.camera._reversedDepth = h, d.map === null || p === !0) {
				if (d.map !== null && (d.map.depthTexture !== null && (d.map.depthTexture.dispose(), d.map.depthTexture = null), d.map.dispose()), this.type === 3) {
					if (l.isPointLight) {
						Zl("WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.");
						continue;
					}
					d.map = new Xu(i.x, i.y, {
						format: Uc,
						type: Ac,
						minFilter: bc,
						magFilter: bc,
						generateMipmaps: !1
					}), d.map.texture.name = l.name + ".shadowMap", d.map.depthTexture = new Ep(i.x, i.y, kc), d.map.depthTexture.name = l.name + ".shadowMapDepth", d.map.depthTexture.format = zc, d.map.depthTexture.compareFunction = null, d.map.depthTexture.minFilter = _c, d.map.depthTexture.magFilter = _c;
				} else l.isPointLight ? (d.map = new Dh(i.x), d.map.depthTexture = new Dp(i.x, Oc)) : (d.map = new Xu(i.x, i.y), d.map.depthTexture = new Ep(i.x, i.y, Oc)), d.map.depthTexture.name = l.name + ".shadowMap", d.map.depthTexture.format = zc, this.type === 1 ? (d.map.depthTexture.compareFunction = h ? 518 : 515, d.map.depthTexture.minFilter = bc, d.map.depthTexture.magFilter = bc) : (d.map.depthTexture.compareFunction = null, d.map.depthTexture.minFilter = _c, d.map.depthTexture.magFilter = _c);
				d.camera.updateProjectionMatrix();
			}
			let g = d.map.isWebGLCubeRenderTarget ? 6 : 1;
			for (let t = 0; t < g; t++) {
				if (d.map.isWebGLCubeRenderTarget) e.setRenderTarget(d.map, t), e.clear();
				else {
					t === 0 && (e.setRenderTarget(d.map), e.clear());
					let n = d.getViewport(t);
					o.set(a.x * n.x, a.y * n.y, a.x * n.z, a.y * n.w), f.viewport(o);
				}
				if (l.isPointLight) {
					let e = d.camera, n = d.matrix, r = l.distance || e.far;
					r !== e.far && (e.far = r, e.updateProjectionMatrix()), J_.setFromMatrixPosition(l.matrixWorld), e.position.copy(J_), Y_.copy(e.position), Y_.add(G_[t]), e.up.copy(K_[t]), e.lookAt(Y_), e.updateMatrixWorld(), n.makeTranslation(-J_.x, -J_.y, -J_.z), q_.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), d._frustum.setFromProjectionMatrix(q_, e.coordinateSystem, e.reversedDepth);
				} else d.updateMatrices(l);
				r = d.getFrustum(), b(n, s, d.camera, l, this.type);
			}
			d.isPointLightShadow !== !0 && this.type === 3 && v(d, s), d.needsUpdate = !1;
		}
		_ = this.type, g.needsUpdate = !1, e.setRenderTarget(c, l, d);
	};
	function v(n, r) {
		let a = t.update(h);
		f.defines.VSM_SAMPLES !== n.blurSamples && (f.defines.VSM_SAMPLES = n.blurSamples, p.defines.VSM_SAMPLES = n.blurSamples, f.needsUpdate = !0, p.needsUpdate = !0), n.mapPass === null && (n.mapPass = new Xu(i.x, i.y, {
			format: Uc,
			type: Ac
		})), f.uniforms.shadow_pass.value = n.map.depthTexture, f.uniforms.resolution.value = n.mapSize, f.uniforms.radius.value = n.radius, e.setRenderTarget(n.mapPass), e.clear(), e.renderBufferDirect(r, null, a, f, h, null), p.uniforms.shadow_pass.value = n.mapPass.texture, p.uniforms.resolution.value = n.mapSize, p.uniforms.radius.value = n.radius, e.setRenderTarget(n.map), e.clear(), e.renderBufferDirect(r, null, a, p, h, null);
	}
	function y(t, n, r, i) {
		let a = null, o = r.isPointLight === !0 ? t.customDistanceMaterial : t.customDepthMaterial;
		if (o !== void 0) a = o;
		else if (a = r.isPointLight === !0 ? c : s, e.localClippingEnabled && n.clipShadows === !0 && Array.isArray(n.clippingPlanes) && n.clippingPlanes.length !== 0 || n.displacementMap && n.displacementScale !== 0 || n.alphaMap && n.alphaTest > 0 || n.map && n.alphaTest > 0 || n.alphaToCoverage === !0) {
			let e = a.uuid, t = n.uuid, r = l[e];
			r === void 0 && (r = {}, l[e] = r);
			let i = r[t];
			i === void 0 && (i = a.clone(), r[t] = i, n.addEventListener("dispose", x)), a = i;
		}
		if (a.visible = n.visible, a.wireframe = n.wireframe, i === 3 ? a.side = n.shadowSide === null ? n.side : n.shadowSide : a.side = n.shadowSide === null ? d[n.side] : n.shadowSide, a.alphaMap = n.alphaMap, a.alphaTest = n.alphaToCoverage === !0 ? .5 : n.alphaTest, a.map = n.map, a.clipShadows = n.clipShadows, a.clippingPlanes = n.clippingPlanes, a.clipIntersection = n.clipIntersection, a.displacementMap = n.displacementMap, a.displacementScale = n.displacementScale, a.displacementBias = n.displacementBias, a.wireframeLinewidth = n.wireframeLinewidth, a.linewidth = n.linewidth, r.isPointLight === !0 && a.isMeshDistanceMaterial === !0) {
			let t = e.properties.get(a);
			t.light = r;
		}
		return a;
	}
	function b(n, i, a, o, s) {
		if (n.visible === !1) return;
		if (n.layers.test(i.layers) && (n.isMesh || n.isLine || n.isPoints) && (n.castShadow || n.receiveShadow && s === 3) && (!n.frustumCulled || r.intersectsObject(n))) {
			n.modelViewMatrix.multiplyMatrices(a.matrixWorldInverse, n.matrixWorld);
			let r = t.update(n), c = n.material;
			if (Array.isArray(c)) {
				let t = r.groups;
				for (let l = 0, u = t.length; l < u; l++) {
					let u = t[l], d = c[u.materialIndex];
					if (d && d.visible) {
						let t = y(n, d, o, s);
						n.onBeforeShadow(e, n, i, a, r, t, u), e.renderBufferDirect(a, null, r, t, n, u), n.onAfterShadow(e, n, i, a, r, t, u);
					}
				}
			} else if (c.visible) {
				let t = y(n, c, o, s);
				n.onBeforeShadow(e, n, i, a, r, t, null), e.renderBufferDirect(a, null, r, t, n, null), n.onAfterShadow(e, n, i, a, r, t, null);
			}
		}
		let c = n.children;
		for (let e = 0, t = c.length; e < t; e++) b(c[e], i, a, o, s);
	}
	function x(e) {
		e.target.removeEventListener("dispose", x);
		for (let t in l) {
			let n = l[t], r = e.target.uuid;
			r in n && (n[r].dispose(), delete n[r]);
		}
	}
}
function Z_(e, t) {
	function n() {
		let t = !1, n = new Ju(), r = null, i = new Ju(0, 0, 0, 0);
		return {
			setMask: function(n) {
				r !== n && !t && (e.colorMask(n, n, n, n), r = n);
			},
			setLocked: function(e) {
				t = e;
			},
			setClear: function(t, r, a, o, s) {
				s === !0 && (t *= o, r *= o, a *= o), n.set(t, r, a, o), i.equals(n) === !1 && (e.clearColor(t, r, a, o), i.copy(n));
			},
			reset: function() {
				t = !1, r = null, i.set(-1, 0, 0, 0);
			}
		};
	}
	function r() {
		let n = !1, r = !1, i = null, a = null, o = null;
		return {
			setReversed: function(e) {
				if (r !== e) {
					let n = t.get("EXT_clip_control");
					e ? n.clipControlEXT(n.LOWER_LEFT_EXT, n.ZERO_TO_ONE_EXT) : n.clipControlEXT(n.LOWER_LEFT_EXT, n.NEGATIVE_ONE_TO_ONE_EXT), r = e;
					let i = o;
					o = null, this.setClear(i);
				}
			},
			getReversed: function() {
				return r;
			},
			setTest: function(t) {
				t ? re(e.DEPTH_TEST) : ie(e.DEPTH_TEST);
			},
			setMask: function(t) {
				i !== t && !n && (e.depthMask(t), i = t);
			},
			setFunc: function(t) {
				if (r && (t = eu[t]), a !== t) {
					switch (t) {
						case 0:
							e.depthFunc(e.NEVER);
							break;
						case 1:
							e.depthFunc(e.ALWAYS);
							break;
						case 2:
							e.depthFunc(e.LESS);
							break;
						case 3:
							e.depthFunc(e.LEQUAL);
							break;
						case 4:
							e.depthFunc(e.EQUAL);
							break;
						case 5:
							e.depthFunc(e.GEQUAL);
							break;
						case 6:
							e.depthFunc(e.GREATER);
							break;
						case 7:
							e.depthFunc(e.NOTEQUAL);
							break;
						default: e.depthFunc(e.LEQUAL);
					}
					a = t;
				}
			},
			setLocked: function(e) {
				n = e;
			},
			setClear: function(t) {
				o !== t && (o = t, r && (t = 1 - t), e.clearDepth(t));
			},
			reset: function() {
				n = !1, i = null, a = null, o = null, r = !1;
			}
		};
	}
	function i() {
		let t = !1, n = null, r = null, i = null, a = null, o = null, s = null, c = null, l = null;
		return {
			setTest: function(n) {
				t || (n ? re(e.STENCIL_TEST) : ie(e.STENCIL_TEST));
			},
			setMask: function(r) {
				n !== r && !t && (e.stencilMask(r), n = r);
			},
			setFunc: function(t, n, o) {
				(r !== t || i !== n || a !== o) && (e.stencilFunc(t, n, o), r = t, i = n, a = o);
			},
			setOp: function(t, n, r) {
				(o !== t || s !== n || c !== r) && (e.stencilOp(t, n, r), o = t, s = n, c = r);
			},
			setLocked: function(e) {
				t = e;
			},
			setClear: function(t) {
				l !== t && (e.clearStencil(t), l = t);
			},
			reset: function() {
				t = !1, n = null, r = null, i = null, a = null, o = null, s = null, c = null, l = null;
			}
		};
	}
	let a = new n(), o = new r(), s = new i(), c = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap(), u = {}, d = {}, f = {}, p = /* @__PURE__ */ new WeakMap(), m = [], h = null, g = !1, _ = null, v = null, y = null, b = null, x = null, S = null, C = null, w = new Pd(0, 0, 0), T = 0, E = !1, D = null, O = null, k = null, A = null, j = null, M = e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS), N = !1, P = 0, F = e.getParameter(e.VERSION);
	F.indexOf("WebGL") === -1 ? F.indexOf("OpenGL ES") !== -1 && (P = parseFloat(/^OpenGL ES (\d)/.exec(F)[1]), N = P >= 2) : (P = parseFloat(/^WebGL (\d)/.exec(F)[1]), N = P >= 1);
	let I = null, R = {}, ee = e.getParameter(e.SCISSOR_BOX), te = e.getParameter(e.VIEWPORT), ne = new Ju().fromArray(ee), z = new Ju().fromArray(te);
	function B(t, n, r, i) {
		let a = new Uint8Array(4), o = e.createTexture();
		e.bindTexture(t, o), e.texParameteri(t, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(t, e.TEXTURE_MAG_FILTER, e.NEAREST);
		for (let o = 0; o < r; o++) t === e.TEXTURE_3D || t === e.TEXTURE_2D_ARRAY ? e.texImage3D(n, 0, e.RGBA, 1, 1, i, 0, e.RGBA, e.UNSIGNED_BYTE, a) : e.texImage2D(n + o, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, a);
		return o;
	}
	let V = {};
	V[e.TEXTURE_2D] = B(e.TEXTURE_2D, e.TEXTURE_2D, 1), V[e.TEXTURE_CUBE_MAP] = B(e.TEXTURE_CUBE_MAP, e.TEXTURE_CUBE_MAP_POSITIVE_X, 6), V[e.TEXTURE_2D_ARRAY] = B(e.TEXTURE_2D_ARRAY, e.TEXTURE_2D_ARRAY, 1, 1), V[e.TEXTURE_3D] = B(e.TEXTURE_3D, e.TEXTURE_3D, 1, 1), a.setClear(0, 0, 0, 1), o.setClear(1), s.setClear(0), re(e.DEPTH_TEST), o.setFunc(3), fe(!1), pe(1), re(e.CULL_FACE), ue(0);
	function re(t) {
		u[t] !== !0 && (e.enable(t), u[t] = !0);
	}
	function ie(t) {
		u[t] !== !1 && (e.disable(t), u[t] = !1);
	}
	function ae(t, n) {
		return f[t] === n ? !1 : (e.bindFramebuffer(t, n), f[t] = n, t === e.DRAW_FRAMEBUFFER && (f[e.FRAMEBUFFER] = n), t === e.FRAMEBUFFER && (f[e.DRAW_FRAMEBUFFER] = n), !0);
	}
	function oe(t, n) {
		let r = m, i = !1;
		if (t) {
			r = p.get(n), r === void 0 && (r = [], p.set(n, r));
			let a = t.textures;
			if (r.length !== a.length || r[0] !== e.COLOR_ATTACHMENT0) {
				for (let t = 0, n = a.length; t < n; t++) r[t] = e.COLOR_ATTACHMENT0 + t;
				r.length = a.length, i = !0;
			}
		} else r[0] !== e.BACK && (r[0] = e.BACK, i = !0);
		i && e.drawBuffers(r);
	}
	function se(t) {
		return h === t ? !1 : (e.useProgram(t), h = t, !0);
	}
	let ce = {
		100: e.FUNC_ADD,
		101: e.FUNC_SUBTRACT,
		102: e.FUNC_REVERSE_SUBTRACT
	};
	ce[103] = e.MIN, ce[104] = e.MAX;
	let le = {
		200: e.ZERO,
		201: e.ONE,
		202: e.SRC_COLOR,
		204: e.SRC_ALPHA,
		210: e.SRC_ALPHA_SATURATE,
		208: e.DST_COLOR,
		206: e.DST_ALPHA,
		203: e.ONE_MINUS_SRC_COLOR,
		205: e.ONE_MINUS_SRC_ALPHA,
		209: e.ONE_MINUS_DST_COLOR,
		207: e.ONE_MINUS_DST_ALPHA,
		211: e.CONSTANT_COLOR,
		212: e.ONE_MINUS_CONSTANT_COLOR,
		213: e.CONSTANT_ALPHA,
		214: e.ONE_MINUS_CONSTANT_ALPHA
	};
	function ue(t, n, r, i, a, o, s, c, l, u) {
		if (t === 0) {
			g === !0 && (ie(e.BLEND), g = !1);
			return;
		}
		if (g === !1 && (re(e.BLEND), g = !0), t !== 5) {
			if (t !== _ || u !== E) {
				if ((v !== 100 || x !== 100) && (e.blendEquation(e.FUNC_ADD), v = 100, x = 100), u) switch (t) {
					case 1:
						e.blendFuncSeparate(e.ONE, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
						break;
					case 2:
						e.blendFunc(e.ONE, e.ONE);
						break;
					case 3:
						e.blendFuncSeparate(e.ZERO, e.ONE_MINUS_SRC_COLOR, e.ZERO, e.ONE);
						break;
					case 4:
						e.blendFuncSeparate(e.DST_COLOR, e.ONE_MINUS_SRC_ALPHA, e.ZERO, e.ONE);
						break;
					default:
						J("WebGLState: Invalid blending: ", t);
						break;
				}
				else switch (t) {
					case 1:
						e.blendFuncSeparate(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
						break;
					case 2:
						e.blendFuncSeparate(e.SRC_ALPHA, e.ONE, e.ONE, e.ONE);
						break;
					case 3:
						J("WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
						break;
					case 4:
						J("WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
						break;
					default:
						J("WebGLState: Invalid blending: ", t);
						break;
				}
				y = null, b = null, S = null, C = null, w.set(0, 0, 0), T = 0, _ = t, E = u;
			}
			return;
		}
		a ||= n, o ||= r, s ||= i, (n !== v || a !== x) && (e.blendEquationSeparate(ce[n], ce[a]), v = n, x = a), (r !== y || i !== b || o !== S || s !== C) && (e.blendFuncSeparate(le[r], le[i], le[o], le[s]), y = r, b = i, S = o, C = s), (c.equals(w) === !1 || l !== T) && (e.blendColor(c.r, c.g, c.b, l), w.copy(c), T = l), _ = t, E = !1;
	}
	function de(t, n) {
		t.side === 2 ? ie(e.CULL_FACE) : re(e.CULL_FACE);
		let r = t.side === 1;
		n && (r = !r), fe(r), t.blending === 1 && t.transparent === !1 ? ue(0) : ue(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.blendColor, t.blendAlpha, t.premultipliedAlpha), o.setFunc(t.depthFunc), o.setTest(t.depthTest), o.setMask(t.depthWrite), a.setMask(t.colorWrite);
		let i = t.stencilWrite;
		s.setTest(i), i && (s.setMask(t.stencilWriteMask), s.setFunc(t.stencilFunc, t.stencilRef, t.stencilFuncMask), s.setOp(t.stencilFail, t.stencilZFail, t.stencilZPass)), he(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits), t.alphaToCoverage === !0 ? re(e.SAMPLE_ALPHA_TO_COVERAGE) : ie(e.SAMPLE_ALPHA_TO_COVERAGE);
	}
	function fe(t) {
		D !== t && (t ? e.frontFace(e.CW) : e.frontFace(e.CCW), D = t);
	}
	function pe(t) {
		t === 0 ? ie(e.CULL_FACE) : (re(e.CULL_FACE), t !== O && (t === 1 ? e.cullFace(e.BACK) : t === 2 ? e.cullFace(e.FRONT) : e.cullFace(e.FRONT_AND_BACK))), O = t;
	}
	function me(t) {
		t !== k && (N && e.lineWidth(t), k = t);
	}
	function he(t, n, r) {
		t ? (re(e.POLYGON_OFFSET_FILL), (A !== n || j !== r) && (A = n, j = r, o.getReversed() && (n = -n), e.polygonOffset(n, r))) : ie(e.POLYGON_OFFSET_FILL);
	}
	function ge(t) {
		t ? re(e.SCISSOR_TEST) : ie(e.SCISSOR_TEST);
	}
	function H(t) {
		t === void 0 && (t = e.TEXTURE0 + M - 1), I !== t && (e.activeTexture(t), I = t);
	}
	function _e(t, n, r) {
		r === void 0 && (r = I === null ? e.TEXTURE0 + M - 1 : I);
		let i = R[r];
		i === void 0 && (i = {
			type: void 0,
			texture: void 0
		}, R[r] = i), (i.type !== t || i.texture !== n) && (I !== r && (e.activeTexture(r), I = r), e.bindTexture(t, n || V[t]), i.type = t, i.texture = n);
	}
	function ve() {
		let t = R[I];
		t !== void 0 && t.type !== void 0 && (e.bindTexture(t.type, null), t.type = void 0, t.texture = void 0);
	}
	function ye() {
		try {
			e.compressedTexImage2D(...arguments);
		} catch (e) {
			J("WebGLState:", e);
		}
	}
	function U() {
		try {
			e.compressedTexImage3D(...arguments);
		} catch (e) {
			J("WebGLState:", e);
		}
	}
	function be() {
		try {
			e.texSubImage2D(...arguments);
		} catch (e) {
			J("WebGLState:", e);
		}
	}
	function W() {
		try {
			e.texSubImage3D(...arguments);
		} catch (e) {
			J("WebGLState:", e);
		}
	}
	function xe() {
		try {
			e.compressedTexSubImage2D(...arguments);
		} catch (e) {
			J("WebGLState:", e);
		}
	}
	function Se() {
		try {
			e.compressedTexSubImage3D(...arguments);
		} catch (e) {
			J("WebGLState:", e);
		}
	}
	function Ce() {
		try {
			e.texStorage2D(...arguments);
		} catch (e) {
			J("WebGLState:", e);
		}
	}
	function we() {
		try {
			e.texStorage3D(...arguments);
		} catch (e) {
			J("WebGLState:", e);
		}
	}
	function Te() {
		try {
			e.texImage2D(...arguments);
		} catch (e) {
			J("WebGLState:", e);
		}
	}
	function Ee() {
		try {
			e.texImage3D(...arguments);
		} catch (e) {
			J("WebGLState:", e);
		}
	}
	function De(t) {
		return d[t] === void 0 ? e.getParameter(t) : d[t];
	}
	function Oe(t, n) {
		d[t] !== n && (e.pixelStorei(t, n), d[t] = n);
	}
	function ke(t) {
		ne.equals(t) === !1 && (e.scissor(t.x, t.y, t.z, t.w), ne.copy(t));
	}
	function Ae(t) {
		z.equals(t) === !1 && (e.viewport(t.x, t.y, t.z, t.w), z.copy(t));
	}
	function je(t, n) {
		let r = l.get(n);
		r === void 0 && (r = /* @__PURE__ */ new WeakMap(), l.set(n, r));
		let i = r.get(t);
		i === void 0 && (i = e.getUniformBlockIndex(n, t.name), r.set(t, i));
	}
	function Me(t, n) {
		let r = l.get(n).get(t);
		c.get(n) !== r && (e.uniformBlockBinding(n, r, t.__bindingPointIndex), c.set(n, r));
	}
	function Ne() {
		e.disable(e.BLEND), e.disable(e.CULL_FACE), e.disable(e.DEPTH_TEST), e.disable(e.POLYGON_OFFSET_FILL), e.disable(e.SCISSOR_TEST), e.disable(e.STENCIL_TEST), e.disable(e.SAMPLE_ALPHA_TO_COVERAGE), e.blendEquation(e.FUNC_ADD), e.blendFunc(e.ONE, e.ZERO), e.blendFuncSeparate(e.ONE, e.ZERO, e.ONE, e.ZERO), e.blendColor(0, 0, 0, 0), e.colorMask(!0, !0, !0, !0), e.clearColor(0, 0, 0, 0), e.depthMask(!0), e.depthFunc(e.LESS), o.setReversed(!1), e.clearDepth(1), e.stencilMask(4294967295), e.stencilFunc(e.ALWAYS, 0, 4294967295), e.stencilOp(e.KEEP, e.KEEP, e.KEEP), e.clearStencil(0), e.cullFace(e.BACK), e.frontFace(e.CCW), e.polygonOffset(0, 0), e.activeTexture(e.TEXTURE0), e.bindFramebuffer(e.FRAMEBUFFER, null), e.bindFramebuffer(e.DRAW_FRAMEBUFFER, null), e.bindFramebuffer(e.READ_FRAMEBUFFER, null), e.useProgram(null), e.lineWidth(1), e.scissor(0, 0, e.canvas.width, e.canvas.height), e.viewport(0, 0, e.canvas.width, e.canvas.height), e.pixelStorei(e.PACK_ALIGNMENT, 4), e.pixelStorei(e.UNPACK_ALIGNMENT, 4), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, !1), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, e.BROWSER_DEFAULT_WEBGL), e.pixelStorei(e.PACK_ROW_LENGTH, 0), e.pixelStorei(e.PACK_SKIP_PIXELS, 0), e.pixelStorei(e.PACK_SKIP_ROWS, 0), e.pixelStorei(e.UNPACK_ROW_LENGTH, 0), e.pixelStorei(e.UNPACK_IMAGE_HEIGHT, 0), e.pixelStorei(e.UNPACK_SKIP_PIXELS, 0), e.pixelStorei(e.UNPACK_SKIP_ROWS, 0), e.pixelStorei(e.UNPACK_SKIP_IMAGES, 0), u = {}, d = {}, I = null, R = {}, f = {}, p = /* @__PURE__ */ new WeakMap(), m = [], h = null, g = !1, _ = null, v = null, y = null, b = null, x = null, S = null, C = null, w = new Pd(0, 0, 0), T = 0, E = !1, D = null, O = null, k = null, A = null, j = null, ne.set(0, 0, e.canvas.width, e.canvas.height), z.set(0, 0, e.canvas.width, e.canvas.height), a.reset(), o.reset(), s.reset();
	}
	return {
		buffers: {
			color: a,
			depth: o,
			stencil: s
		},
		enable: re,
		disable: ie,
		bindFramebuffer: ae,
		drawBuffers: oe,
		useProgram: se,
		setBlending: ue,
		setMaterial: de,
		setFlipSided: fe,
		setCullFace: pe,
		setLineWidth: me,
		setPolygonOffset: he,
		setScissorTest: ge,
		activeTexture: H,
		bindTexture: _e,
		unbindTexture: ve,
		compressedTexImage2D: ye,
		compressedTexImage3D: U,
		texImage2D: Te,
		texImage3D: Ee,
		pixelStorei: Oe,
		getParameter: De,
		updateUBOMapping: je,
		uniformBlockBinding: Me,
		texStorage2D: Ce,
		texStorage3D: we,
		texSubImage2D: be,
		texSubImage3D: W,
		compressedTexSubImage2D: xe,
		compressedTexSubImage3D: Se,
		scissor: ke,
		viewport: Ae,
		reset: Ne
	};
}
function Q_(e, t, n, r, i, a, o) {
	let s = t.has("WEBGL_multisampled_render_to_texture") ? t.get("WEBGL_multisampled_render_to_texture") : null, c = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), l = new Ou(), u = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new Set(), f, p = /* @__PURE__ */ new WeakMap(), m = !1;
	try {
		m = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
	} catch {}
	function h(e, t) {
		return m ? new OffscreenCanvas(e, t) : Gl("canvas");
	}
	function g(e, t, n) {
		let r = 1, i = ye(e);
		if ((i.width > n || i.height > n) && (r = n / Math.max(i.width, i.height)), r < 1) if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap || typeof VideoFrame < "u" && e instanceof VideoFrame) {
			let n = Math.floor(r * i.width), a = Math.floor(r * i.height);
			f === void 0 && (f = h(n, a));
			let o = t ? h(n, a) : f;
			return o.width = n, o.height = a, o.getContext("2d").drawImage(e, 0, 0, n, a), Zl("WebGLRenderer: Texture has been resized from (" + i.width + "x" + i.height + ") to (" + n + "x" + a + ")."), o;
		} else return "data" in e && Zl("WebGLRenderer: Image in DataTexture is too big (" + i.width + "x" + i.height + ")."), e;
		return e;
	}
	function _(e) {
		return e.generateMipmaps;
	}
	function v(t) {
		e.generateMipmap(t);
	}
	function y(t) {
		return t.isWebGLCubeRenderTarget ? e.TEXTURE_CUBE_MAP : t.isWebGL3DRenderTarget ? e.TEXTURE_3D : t.isWebGLArrayRenderTarget || t.isCompressedArrayTexture ? e.TEXTURE_2D_ARRAY : e.TEXTURE_2D;
	}
	function b(n, r, i, a, o, s = !1) {
		if (n !== null) {
			if (e[n] !== void 0) return e[n];
			Zl("WebGLRenderer: Attempt to use non-existing WebGL internal format '" + n + "'");
		}
		let c;
		a && (c = t.get("EXT_texture_norm16"), c || Zl("WebGLRenderer: Unable to use normalized textures without EXT_texture_norm16 extension"));
		let l = r;
		if (r === e.RED && (i === e.FLOAT && (l = e.R32F), i === e.HALF_FLOAT && (l = e.R16F), i === e.UNSIGNED_BYTE && (l = e.R8), i === e.UNSIGNED_SHORT && c && (l = c.R16_EXT), i === e.SHORT && c && (l = c.R16_SNORM_EXT)), r === e.RED_INTEGER && (i === e.UNSIGNED_BYTE && (l = e.R8UI), i === e.UNSIGNED_SHORT && (l = e.R16UI), i === e.UNSIGNED_INT && (l = e.R32UI), i === e.BYTE && (l = e.R8I), i === e.SHORT && (l = e.R16I), i === e.INT && (l = e.R32I)), r === e.RG && (i === e.FLOAT && (l = e.RG32F), i === e.HALF_FLOAT && (l = e.RG16F), i === e.UNSIGNED_BYTE && (l = e.RG8), i === e.UNSIGNED_SHORT && c && (l = c.RG16_EXT), i === e.SHORT && c && (l = c.RG16_SNORM_EXT)), r === e.RG_INTEGER && (i === e.UNSIGNED_BYTE && (l = e.RG8UI), i === e.UNSIGNED_SHORT && (l = e.RG16UI), i === e.UNSIGNED_INT && (l = e.RG32UI), i === e.BYTE && (l = e.RG8I), i === e.SHORT && (l = e.RG16I), i === e.INT && (l = e.RG32I)), r === e.RGB_INTEGER && (i === e.UNSIGNED_BYTE && (l = e.RGB8UI), i === e.UNSIGNED_SHORT && (l = e.RGB16UI), i === e.UNSIGNED_INT && (l = e.RGB32UI), i === e.BYTE && (l = e.RGB8I), i === e.SHORT && (l = e.RGB16I), i === e.INT && (l = e.RGB32I)), r === e.RGBA_INTEGER && (i === e.UNSIGNED_BYTE && (l = e.RGBA8UI), i === e.UNSIGNED_SHORT && (l = e.RGBA16UI), i === e.UNSIGNED_INT && (l = e.RGBA32UI), i === e.BYTE && (l = e.RGBA8I), i === e.SHORT && (l = e.RGBA16I), i === e.INT && (l = e.RGBA32I)), r === e.RGB && (i === e.UNSIGNED_SHORT && c && (l = c.RGB16_EXT), i === e.SHORT && c && (l = c.RGB16_SNORM_EXT), i === e.UNSIGNED_INT_5_9_9_9_REV && (l = e.RGB9_E5), i === e.UNSIGNED_INT_10F_11F_11F_REV && (l = e.R11F_G11F_B10F)), r === e.RGBA) {
			let t = s ? Rl : Lu.getTransfer(o);
			i === e.FLOAT && (l = e.RGBA32F), i === e.HALF_FLOAT && (l = e.RGBA16F), i === e.UNSIGNED_BYTE && (l = t === "srgb" ? e.SRGB8_ALPHA8 : e.RGBA8), i === e.UNSIGNED_SHORT && c && (l = c.RGBA16_EXT), i === e.SHORT && c && (l = c.RGBA16_SNORM_EXT), i === e.UNSIGNED_SHORT_4_4_4_4 && (l = e.RGBA4), i === e.UNSIGNED_SHORT_5_5_5_1 && (l = e.RGB5_A1);
		}
		return (l === e.R16F || l === e.R32F || l === e.RG16F || l === e.RG32F || l === e.RGBA16F || l === e.RGBA32F) && t.get("EXT_color_buffer_float"), l;
	}
	function x(t, n) {
		let r;
		return t ? n === null || n === 1014 || n === 1020 ? r = e.DEPTH24_STENCIL8 : n === 1015 ? r = e.DEPTH32F_STENCIL8 : n === 1012 && (r = e.DEPTH24_STENCIL8, Zl("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : n === null || n === 1014 || n === 1020 ? r = e.DEPTH_COMPONENT24 : n === 1015 ? r = e.DEPTH_COMPONENT32F : n === 1012 && (r = e.DEPTH_COMPONENT16), r;
	}
	function S(e, t) {
		return _(e) === !0 || e.isFramebufferTexture && e.minFilter !== 1003 && e.minFilter !== 1006 ? Math.log2(Math.max(t.width, t.height)) + 1 : e.mipmaps !== void 0 && e.mipmaps.length > 0 ? e.mipmaps.length : e.isCompressedTexture && Array.isArray(e.image) ? t.mipmaps.length : 1;
	}
	function C(e) {
		let t = e.target;
		t.removeEventListener("dispose", C), T(t), t.isVideoTexture && u.delete(t), t.isHTMLTexture && d.delete(t);
	}
	function w(e) {
		let t = e.target;
		t.removeEventListener("dispose", w), D(t);
	}
	function T(e) {
		let t = r.get(e);
		if (t.__webglInit === void 0) return;
		let n = e.source, i = p.get(n);
		if (i) {
			let r = i[t.__cacheKey];
			r.usedTimes--, r.usedTimes === 0 && E(e), Object.keys(i).length === 0 && p.delete(n);
		}
		r.remove(e);
	}
	function E(t) {
		let n = r.get(t);
		e.deleteTexture(n.__webglTexture);
		let i = t.source, a = p.get(i);
		delete a[n.__cacheKey], o.memory.textures--;
	}
	function D(t) {
		let n = r.get(t);
		if (t.depthTexture && (t.depthTexture.dispose(), r.remove(t.depthTexture)), t.isWebGLCubeRenderTarget) for (let t = 0; t < 6; t++) {
			if (Array.isArray(n.__webglFramebuffer[t])) for (let r = 0; r < n.__webglFramebuffer[t].length; r++) e.deleteFramebuffer(n.__webglFramebuffer[t][r]);
			else e.deleteFramebuffer(n.__webglFramebuffer[t]);
			n.__webglDepthbuffer && e.deleteRenderbuffer(n.__webglDepthbuffer[t]);
		}
		else {
			if (Array.isArray(n.__webglFramebuffer)) for (let t = 0; t < n.__webglFramebuffer.length; t++) e.deleteFramebuffer(n.__webglFramebuffer[t]);
			else e.deleteFramebuffer(n.__webglFramebuffer);
			if (n.__webglDepthbuffer && e.deleteRenderbuffer(n.__webglDepthbuffer), n.__webglMultisampledFramebuffer && e.deleteFramebuffer(n.__webglMultisampledFramebuffer), n.__webglColorRenderbuffer) for (let t = 0; t < n.__webglColorRenderbuffer.length; t++) n.__webglColorRenderbuffer[t] && e.deleteRenderbuffer(n.__webglColorRenderbuffer[t]);
			n.__webglDepthRenderbuffer && e.deleteRenderbuffer(n.__webglDepthRenderbuffer);
		}
		let i = t.textures;
		for (let t = 0, n = i.length; t < n; t++) {
			let n = r.get(i[t]);
			n.__webglTexture && (e.deleteTexture(n.__webglTexture), o.memory.textures--), r.remove(i[t]);
		}
		r.remove(t);
	}
	let O = 0;
	function k() {
		O = 0;
	}
	function A() {
		return O;
	}
	function j(e) {
		O = e;
	}
	function M() {
		let e = O;
		return e >= i.maxTextures && Zl("WebGLTextures: Trying to use " + e + " texture units while this GPU supports only " + i.maxTextures), O += 1, e;
	}
	function N(e) {
		let t = [];
		return t.push(e.wrapS), t.push(e.wrapT), t.push(e.wrapR || 0), t.push(e.magFilter), t.push(e.minFilter), t.push(e.anisotropy), t.push(e.internalFormat), t.push(e.format), t.push(e.type), t.push(e.generateMipmaps), t.push(e.premultiplyAlpha), t.push(e.flipY), t.push(e.unpackAlignment), t.push(e.colorSpace), t.join();
	}
	function P(t, i) {
		let a = r.get(t);
		if (t.isVideoTexture && _e(t), t.isRenderTargetTexture === !1 && t.isExternalTexture !== !0 && t.version > 0 && a.__version !== t.version) {
			let e = t.image;
			if (e === null) Zl("WebGLRenderer: Texture marked for update but no image data found.");
			else if (e.complete === !1) Zl("WebGLRenderer: Texture marked for update but image is incomplete");
			else {
				ie(a, t, i);
				return;
			}
		} else t.isExternalTexture && (a.__webglTexture = t.sourceTexture ? t.sourceTexture : null);
		n.bindTexture(e.TEXTURE_2D, a.__webglTexture, e.TEXTURE0 + i);
	}
	function F(t, i) {
		let a = r.get(t);
		if (t.isRenderTargetTexture === !1 && t.version > 0 && a.__version !== t.version) {
			ie(a, t, i);
			return;
		} else t.isExternalTexture && (a.__webglTexture = t.sourceTexture ? t.sourceTexture : null);
		n.bindTexture(e.TEXTURE_2D_ARRAY, a.__webglTexture, e.TEXTURE0 + i);
	}
	function I(t, i) {
		let a = r.get(t);
		if (t.isRenderTargetTexture === !1 && t.version > 0 && a.__version !== t.version) {
			ie(a, t, i);
			return;
		}
		n.bindTexture(e.TEXTURE_3D, a.__webglTexture, e.TEXTURE0 + i);
	}
	function R(t, i) {
		let a = r.get(t);
		if (t.isCubeDepthTexture !== !0 && t.version > 0 && a.__version !== t.version) {
			ae(a, t, i);
			return;
		}
		n.bindTexture(e.TEXTURE_CUBE_MAP, a.__webglTexture, e.TEXTURE0 + i);
	}
	let ee = {
		[mc]: e.REPEAT,
		[hc]: e.CLAMP_TO_EDGE,
		[gc]: e.MIRRORED_REPEAT
	}, te = {
		[_c]: e.NEAREST,
		[vc]: e.NEAREST_MIPMAP_NEAREST,
		[yc]: e.NEAREST_MIPMAP_LINEAR,
		[bc]: e.LINEAR,
		[xc]: e.LINEAR_MIPMAP_NEAREST,
		[Sc]: e.LINEAR_MIPMAP_LINEAR
	}, ne = {
		512: e.NEVER,
		519: e.ALWAYS,
		513: e.LESS,
		515: e.LEQUAL,
		514: e.EQUAL,
		518: e.GEQUAL,
		516: e.GREATER,
		517: e.NOTEQUAL
	};
	function z(n, a) {
		if (a.type === 1015 && t.has("OES_texture_float_linear") === !1 && (a.magFilter === 1006 || a.magFilter === 1007 || a.magFilter === 1005 || a.magFilter === 1008 || a.minFilter === 1006 || a.minFilter === 1007 || a.minFilter === 1005 || a.minFilter === 1008) && Zl("WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), e.texParameteri(n, e.TEXTURE_WRAP_S, ee[a.wrapS]), e.texParameteri(n, e.TEXTURE_WRAP_T, ee[a.wrapT]), (n === e.TEXTURE_3D || n === e.TEXTURE_2D_ARRAY) && e.texParameteri(n, e.TEXTURE_WRAP_R, ee[a.wrapR]), e.texParameteri(n, e.TEXTURE_MAG_FILTER, te[a.magFilter]), e.texParameteri(n, e.TEXTURE_MIN_FILTER, te[a.minFilter]), a.compareFunction && (e.texParameteri(n, e.TEXTURE_COMPARE_MODE, e.COMPARE_REF_TO_TEXTURE), e.texParameteri(n, e.TEXTURE_COMPARE_FUNC, ne[a.compareFunction])), t.has("EXT_texture_filter_anisotropic") === !0) {
			if (a.magFilter === 1003 || a.minFilter !== 1005 && a.minFilter !== 1008 || a.type === 1015 && t.has("OES_texture_float_linear") === !1) return;
			if (a.anisotropy > 1 || r.get(a).__currentAnisotropy) {
				let o = t.get("EXT_texture_filter_anisotropic");
				e.texParameterf(n, o.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(a.anisotropy, i.getMaxAnisotropy())), r.get(a).__currentAnisotropy = a.anisotropy;
			}
		}
	}
	function B(t, n) {
		let r = !1;
		t.__webglInit === void 0 && (t.__webglInit = !0, n.addEventListener("dispose", C));
		let i = n.source, a = p.get(i);
		a === void 0 && (a = {}, p.set(i, a));
		let s = N(n);
		if (s !== t.__cacheKey) {
			a[s] === void 0 && (a[s] = {
				texture: e.createTexture(),
				usedTimes: 0
			}, o.memory.textures++, r = !0), a[s].usedTimes++;
			let i = a[t.__cacheKey];
			i !== void 0 && (a[t.__cacheKey].usedTimes--, i.usedTimes === 0 && E(n)), t.__cacheKey = s, t.__webglTexture = a[s].texture;
		}
		return r;
	}
	function V(e, t, n) {
		return Math.floor(Math.floor(e / n) / t);
	}
	function re(t, r, i, a) {
		let o = t.updateRanges;
		if (o.length === 0) n.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, r.width, r.height, i, a, r.data);
		else {
			o.sort((e, t) => e.start - t.start);
			let s = 0;
			for (let e = 1; e < o.length; e++) {
				let t = o[s], n = o[e], i = t.start + t.count, a = V(n.start, r.width, 4), c = V(t.start, r.width, 4);
				n.start <= i + 1 && a === c && V(n.start + n.count - 1, r.width, 4) === a ? t.count = Math.max(t.count, n.start + n.count - t.start) : (++s, o[s] = n);
			}
			o.length = s + 1;
			let c = n.getParameter(e.UNPACK_ROW_LENGTH), l = n.getParameter(e.UNPACK_SKIP_PIXELS), u = n.getParameter(e.UNPACK_SKIP_ROWS);
			n.pixelStorei(e.UNPACK_ROW_LENGTH, r.width);
			for (let t = 0, s = o.length; t < s; t++) {
				let s = o[t], c = Math.floor(s.start / 4), l = Math.ceil(s.count / 4), u = c % r.width, d = Math.floor(c / r.width), f = l;
				n.pixelStorei(e.UNPACK_SKIP_PIXELS, u), n.pixelStorei(e.UNPACK_SKIP_ROWS, d), n.texSubImage2D(e.TEXTURE_2D, 0, u, d, f, 1, i, a, r.data);
			}
			t.clearUpdateRanges(), n.pixelStorei(e.UNPACK_ROW_LENGTH, c), n.pixelStorei(e.UNPACK_SKIP_PIXELS, l), n.pixelStorei(e.UNPACK_SKIP_ROWS, u);
		}
	}
	function ie(t, o, s) {
		let c = e.TEXTURE_2D;
		(o.isDataArrayTexture || o.isCompressedArrayTexture) && (c = e.TEXTURE_2D_ARRAY), o.isData3DTexture && (c = e.TEXTURE_3D);
		let l = B(t, o), u = o.source;
		n.bindTexture(c, t.__webglTexture, e.TEXTURE0 + s);
		let f = r.get(u);
		if (u.version !== f.__version || l === !0) {
			if (n.activeTexture(e.TEXTURE0 + s), !(typeof ImageBitmap < "u" && o.image instanceof ImageBitmap)) {
				let t = Lu.getPrimaries(Lu.workingColorSpace), r = o.colorSpace === "" ? null : Lu.getPrimaries(o.colorSpace), i = o.colorSpace === "" || t === r ? e.NONE : e.BROWSER_DEFAULT_WEBGL;
				n.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, o.flipY), n.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, o.premultiplyAlpha), n.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, i);
			}
			n.pixelStorei(e.UNPACK_ALIGNMENT, o.unpackAlignment);
			let t = g(o.image, !1, i.maxTextureSize);
			t = ve(o, t);
			let r = a.convert(o.format, o.colorSpace), p = a.convert(o.type), m = b(o.internalFormat, r, p, o.normalized, o.colorSpace, o.isVideoTexture);
			z(c, o);
			let h, y = o.mipmaps, C = o.isVideoTexture !== !0, w = f.__version === void 0 || l === !0, T = u.dataReady, E = S(o, t);
			if (o.isDepthTexture) m = x(o.format === Bc, o.type), w && (C ? n.texStorage2D(e.TEXTURE_2D, 1, m, t.width, t.height) : n.texImage2D(e.TEXTURE_2D, 0, m, t.width, t.height, 0, r, p, null));
			else if (o.isDataTexture) if (y.length > 0) {
				C && w && n.texStorage2D(e.TEXTURE_2D, E, m, y[0].width, y[0].height);
				for (let t = 0, i = y.length; t < i; t++) h = y[t], C ? T && n.texSubImage2D(e.TEXTURE_2D, t, 0, 0, h.width, h.height, r, p, h.data) : n.texImage2D(e.TEXTURE_2D, t, m, h.width, h.height, 0, r, p, h.data);
				o.generateMipmaps = !1;
			} else C ? (w && n.texStorage2D(e.TEXTURE_2D, E, m, t.width, t.height), T && re(o, t, r, p)) : n.texImage2D(e.TEXTURE_2D, 0, m, t.width, t.height, 0, r, p, t.data);
			else if (o.isCompressedTexture) if (o.isCompressedArrayTexture) {
				C && w && n.texStorage3D(e.TEXTURE_2D_ARRAY, E, m, y[0].width, y[0].height, t.depth);
				for (let i = 0, a = y.length; i < a; i++) if (h = y[i], o.format !== 1023) if (r !== null) if (C) {
					if (T) if (o.layerUpdates.size > 0) {
						let t = qm(h.width, h.height, o.format, o.type);
						for (let a of o.layerUpdates) {
							let o = h.data.subarray(a * t / h.data.BYTES_PER_ELEMENT, (a + 1) * t / h.data.BYTES_PER_ELEMENT);
							n.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY, i, 0, 0, a, h.width, h.height, 1, r, o);
						}
						o.clearLayerUpdates();
					} else n.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY, i, 0, 0, 0, h.width, h.height, t.depth, r, h.data);
				} else n.compressedTexImage3D(e.TEXTURE_2D_ARRAY, i, m, h.width, h.height, t.depth, 0, h.data, 0, 0);
				else Zl("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
				else C ? T && n.texSubImage3D(e.TEXTURE_2D_ARRAY, i, 0, 0, 0, h.width, h.height, t.depth, r, p, h.data) : n.texImage3D(e.TEXTURE_2D_ARRAY, i, m, h.width, h.height, t.depth, 0, r, p, h.data);
			} else {
				C && w && n.texStorage2D(e.TEXTURE_2D, E, m, y[0].width, y[0].height);
				for (let t = 0, i = y.length; t < i; t++) h = y[t], o.format === 1023 ? C ? T && n.texSubImage2D(e.TEXTURE_2D, t, 0, 0, h.width, h.height, r, p, h.data) : n.texImage2D(e.TEXTURE_2D, t, m, h.width, h.height, 0, r, p, h.data) : r === null ? Zl("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : C ? T && n.compressedTexSubImage2D(e.TEXTURE_2D, t, 0, 0, h.width, h.height, r, h.data) : n.compressedTexImage2D(e.TEXTURE_2D, t, m, h.width, h.height, 0, h.data);
			}
			else if (o.isDataArrayTexture) if (C) {
				if (w && n.texStorage3D(e.TEXTURE_2D_ARRAY, E, m, t.width, t.height, t.depth), T) if (o.layerUpdates.size > 0) {
					let i = qm(t.width, t.height, o.format, o.type);
					for (let a of o.layerUpdates) {
						let o = t.data.subarray(a * i / t.data.BYTES_PER_ELEMENT, (a + 1) * i / t.data.BYTES_PER_ELEMENT);
						n.texSubImage3D(e.TEXTURE_2D_ARRAY, 0, 0, 0, a, t.width, t.height, 1, r, p, o);
					}
					o.clearLayerUpdates();
				} else n.texSubImage3D(e.TEXTURE_2D_ARRAY, 0, 0, 0, 0, t.width, t.height, t.depth, r, p, t.data);
			} else n.texImage3D(e.TEXTURE_2D_ARRAY, 0, m, t.width, t.height, t.depth, 0, r, p, t.data);
			else if (o.isData3DTexture) C ? (w && n.texStorage3D(e.TEXTURE_3D, E, m, t.width, t.height, t.depth), T && n.texSubImage3D(e.TEXTURE_3D, 0, 0, 0, 0, t.width, t.height, t.depth, r, p, t.data)) : n.texImage3D(e.TEXTURE_3D, 0, m, t.width, t.height, t.depth, 0, r, p, t.data);
			else if (o.isFramebufferTexture) {
				if (w) if (C) n.texStorage2D(e.TEXTURE_2D, E, m, t.width, t.height);
				else {
					let i = t.width, a = t.height;
					for (let t = 0; t < E; t++) n.texImage2D(e.TEXTURE_2D, t, m, i, a, 0, r, p, null), i >>= 1, a >>= 1;
				}
			} else if (o.isHTMLTexture) {
				if ("texElementImage2D" in e) {
					let n = e.canvas;
					if (n.hasAttribute("layoutsubtree") || n.setAttribute("layoutsubtree", "true"), t.parentNode !== n) {
						n.appendChild(t), d.add(o), n.onpaint = (e) => {
							let t = e.changedElements;
							for (let e of d) t.includes(e.image) && (e.needsUpdate = !0);
						}, n.requestPaint();
						return;
					}
					if (e.texElementImage2D.length === 3) e.texElementImage2D(e.TEXTURE_2D, e.RGBA8, t);
					else {
						let n = e.RGBA, r = e.RGBA, i = e.UNSIGNED_BYTE;
						e.texElementImage2D(e.TEXTURE_2D, 0, n, r, i, t);
					}
					e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
				}
			} else if (y.length > 0) {
				if (C && w) {
					let t = ye(y[0]);
					n.texStorage2D(e.TEXTURE_2D, E, m, t.width, t.height);
				}
				for (let t = 0, i = y.length; t < i; t++) h = y[t], C ? T && n.texSubImage2D(e.TEXTURE_2D, t, 0, 0, r, p, h) : n.texImage2D(e.TEXTURE_2D, t, m, r, p, h);
				o.generateMipmaps = !1;
			} else if (C) {
				if (w) {
					let r = ye(t);
					n.texStorage2D(e.TEXTURE_2D, E, m, r.width, r.height);
				}
				T && n.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, r, p, t);
			} else n.texImage2D(e.TEXTURE_2D, 0, m, r, p, t);
			_(o) && v(c), f.__version = u.version, o.onUpdate && o.onUpdate(o);
		}
		t.__version = o.version;
	}
	function ae(t, o, s) {
		if (o.image.length !== 6) return;
		let c = B(t, o), l = o.source;
		n.bindTexture(e.TEXTURE_CUBE_MAP, t.__webglTexture, e.TEXTURE0 + s);
		let u = r.get(l);
		if (l.version !== u.__version || c === !0) {
			n.activeTexture(e.TEXTURE0 + s);
			let t = Lu.getPrimaries(Lu.workingColorSpace), r = o.colorSpace === "" ? null : Lu.getPrimaries(o.colorSpace), d = o.colorSpace === "" || t === r ? e.NONE : e.BROWSER_DEFAULT_WEBGL;
			n.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, o.flipY), n.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, o.premultiplyAlpha), n.pixelStorei(e.UNPACK_ALIGNMENT, o.unpackAlignment), n.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, d);
			let f = o.isCompressedTexture || o.image[0].isCompressedTexture, p = o.image[0] && o.image[0].isDataTexture, m = [];
			for (let e = 0; e < 6; e++) !f && !p ? m[e] = g(o.image[e], !0, i.maxCubemapSize) : m[e] = p ? o.image[e].image : o.image[e], m[e] = ve(o, m[e]);
			let h = m[0], y = a.convert(o.format, o.colorSpace), x = a.convert(o.type), C = b(o.internalFormat, y, x, o.normalized, o.colorSpace), w = o.isVideoTexture !== !0, T = u.__version === void 0 || c === !0, E = l.dataReady, D = S(o, h);
			z(e.TEXTURE_CUBE_MAP, o);
			let O;
			if (f) {
				w && T && n.texStorage2D(e.TEXTURE_CUBE_MAP, D, C, h.width, h.height);
				for (let t = 0; t < 6; t++) {
					O = m[t].mipmaps;
					for (let r = 0; r < O.length; r++) {
						let i = O[r];
						o.format === 1023 ? w ? E && n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, 0, 0, i.width, i.height, y, x, i.data) : n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, C, i.width, i.height, 0, y, x, i.data) : y === null ? Zl("WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : w ? E && n.compressedTexSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, 0, 0, i.width, i.height, y, i.data) : n.compressedTexImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, C, i.width, i.height, 0, i.data);
					}
				}
			} else {
				if (O = o.mipmaps, w && T) {
					O.length > 0 && D++;
					let t = ye(m[0]);
					n.texStorage2D(e.TEXTURE_CUBE_MAP, D, C, t.width, t.height);
				}
				for (let t = 0; t < 6; t++) if (p) {
					w ? E && n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, m[t].width, m[t].height, y, x, m[t].data) : n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, C, m[t].width, m[t].height, 0, y, x, m[t].data);
					for (let r = 0; r < O.length; r++) {
						let i = O[r].image[t].image;
						w ? E && n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r + 1, 0, 0, i.width, i.height, y, x, i.data) : n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r + 1, C, i.width, i.height, 0, y, x, i.data);
					}
				} else {
					w ? E && n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, y, x, m[t]) : n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, C, y, x, m[t]);
					for (let r = 0; r < O.length; r++) {
						let i = O[r];
						w ? E && n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r + 1, 0, 0, y, x, i.image[t]) : n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r + 1, C, y, x, i.image[t]);
					}
				}
			}
			_(o) && v(e.TEXTURE_CUBE_MAP), u.__version = l.version, o.onUpdate && o.onUpdate(o);
		}
		t.__version = o.version;
	}
	function oe(t, i, o, c, l, u) {
		let d = a.convert(o.format, o.colorSpace), f = a.convert(o.type), p = b(o.internalFormat, d, f, o.normalized, o.colorSpace), m = r.get(i), h = r.get(o);
		if (h.__renderTarget = i, !m.__hasExternalTextures) {
			let t = Math.max(1, i.width >> u), r = Math.max(1, i.height >> u);
			l === e.TEXTURE_3D || l === e.TEXTURE_2D_ARRAY ? n.texImage3D(l, u, p, t, r, i.depth, 0, d, f, null) : n.texImage2D(l, u, p, t, r, 0, d, f, null);
		}
		n.bindFramebuffer(e.FRAMEBUFFER, t), H(i) ? s.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, c, l, h.__webglTexture, 0, ge(i)) : (l === e.TEXTURE_2D || l >= e.TEXTURE_CUBE_MAP_POSITIVE_X && l <= e.TEXTURE_CUBE_MAP_NEGATIVE_Z) && e.framebufferTexture2D(e.FRAMEBUFFER, c, l, h.__webglTexture, u), n.bindFramebuffer(e.FRAMEBUFFER, null);
	}
	function se(t, n, r) {
		if (e.bindRenderbuffer(e.RENDERBUFFER, t), n.depthBuffer) {
			let i = n.depthTexture, a = i && i.isDepthTexture ? i.type : null, o = x(n.stencilBuffer, a), c = n.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
			H(n) ? s.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, ge(n), o, n.width, n.height) : r ? e.renderbufferStorageMultisample(e.RENDERBUFFER, ge(n), o, n.width, n.height) : e.renderbufferStorage(e.RENDERBUFFER, o, n.width, n.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, c, e.RENDERBUFFER, t);
		} else {
			let t = n.textures;
			for (let i = 0; i < t.length; i++) {
				let o = t[i], c = a.convert(o.format, o.colorSpace), l = a.convert(o.type), u = b(o.internalFormat, c, l, o.normalized, o.colorSpace);
				H(n) ? s.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, ge(n), u, n.width, n.height) : r ? e.renderbufferStorageMultisample(e.RENDERBUFFER, ge(n), u, n.width, n.height) : e.renderbufferStorage(e.RENDERBUFFER, u, n.width, n.height);
			}
		}
		e.bindRenderbuffer(e.RENDERBUFFER, null);
	}
	function ce(t, i, o) {
		let c = i.isWebGLCubeRenderTarget === !0;
		if (n.bindFramebuffer(e.FRAMEBUFFER, t), !(i.depthTexture && i.depthTexture.isDepthTexture)) throw Error("THREE.WebGLTextures: renderTarget.depthTexture must be an instance of THREE.DepthTexture.");
		let l = r.get(i.depthTexture);
		if (l.__renderTarget = i, (!l.__webglTexture || i.depthTexture.image.width !== i.width || i.depthTexture.image.height !== i.height) && (i.depthTexture.image.width = i.width, i.depthTexture.image.height = i.height, i.depthTexture.needsUpdate = !0), c) {
			if (l.__webglInit === void 0 && (l.__webglInit = !0, i.depthTexture.addEventListener("dispose", C)), l.__webglTexture === void 0) {
				l.__webglTexture = e.createTexture(), n.bindTexture(e.TEXTURE_CUBE_MAP, l.__webglTexture), z(e.TEXTURE_CUBE_MAP, i.depthTexture);
				let t = a.convert(i.depthTexture.format), r = a.convert(i.depthTexture.type), o;
				i.depthTexture.format === 1026 ? o = e.DEPTH_COMPONENT24 : i.depthTexture.format === 1027 && (o = e.DEPTH24_STENCIL8);
				for (let n = 0; n < 6; n++) e.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + n, 0, o, i.width, i.height, 0, t, r, null);
			}
		} else P(i.depthTexture, 0);
		let u = l.__webglTexture, d = ge(i), f = c ? e.TEXTURE_CUBE_MAP_POSITIVE_X + o : e.TEXTURE_2D, p = i.depthTexture.format === 1027 ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
		if (i.depthTexture.format === 1026) H(i) ? s.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, p, f, u, 0, d) : e.framebufferTexture2D(e.FRAMEBUFFER, p, f, u, 0);
		else if (i.depthTexture.format === 1027) H(i) ? s.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, p, f, u, 0, d) : e.framebufferTexture2D(e.FRAMEBUFFER, p, f, u, 0);
		else throw Error("THREE.WebGLTextures: Unknown depthTexture format.");
	}
	function le(t) {
		let i = r.get(t), a = t.isWebGLCubeRenderTarget === !0;
		if (i.__boundDepthTexture !== t.depthTexture) {
			let e = t.depthTexture;
			if (i.__depthDisposeCallback && i.__depthDisposeCallback(), e) {
				let t = () => {
					delete i.__boundDepthTexture, delete i.__depthDisposeCallback, e.removeEventListener("dispose", t);
				};
				e.addEventListener("dispose", t), i.__depthDisposeCallback = t;
			}
			i.__boundDepthTexture = e;
		}
		if (t.depthTexture && !i.__autoAllocateDepthBuffer) if (a) for (let e = 0; e < 6; e++) ce(i.__webglFramebuffer[e], t, e);
		else {
			let e = t.texture.mipmaps;
			e && e.length > 0 ? ce(i.__webglFramebuffer[0], t, 0) : ce(i.__webglFramebuffer, t, 0);
		}
		else if (a) {
			i.__webglDepthbuffer = [];
			for (let r = 0; r < 6; r++) if (n.bindFramebuffer(e.FRAMEBUFFER, i.__webglFramebuffer[r]), i.__webglDepthbuffer[r] === void 0) i.__webglDepthbuffer[r] = e.createRenderbuffer(), se(i.__webglDepthbuffer[r], t, !1);
			else {
				let n = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, a = i.__webglDepthbuffer[r];
				e.bindRenderbuffer(e.RENDERBUFFER, a), e.framebufferRenderbuffer(e.FRAMEBUFFER, n, e.RENDERBUFFER, a);
			}
		} else {
			let r = t.texture.mipmaps;
			if (r && r.length > 0 ? n.bindFramebuffer(e.FRAMEBUFFER, i.__webglFramebuffer[0]) : n.bindFramebuffer(e.FRAMEBUFFER, i.__webglFramebuffer), i.__webglDepthbuffer === void 0) i.__webglDepthbuffer = e.createRenderbuffer(), se(i.__webglDepthbuffer, t, !1);
			else {
				let n = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, r = i.__webglDepthbuffer;
				e.bindRenderbuffer(e.RENDERBUFFER, r), e.framebufferRenderbuffer(e.FRAMEBUFFER, n, e.RENDERBUFFER, r);
			}
		}
		n.bindFramebuffer(e.FRAMEBUFFER, null);
	}
	function ue(t, n, i) {
		let a = r.get(t);
		n !== void 0 && oe(a.__webglFramebuffer, t, t.texture, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, 0), i !== void 0 && le(t);
	}
	function de(t) {
		let i = t.texture, s = r.get(t), c = r.get(i);
		t.addEventListener("dispose", w);
		let l = t.textures, u = t.isWebGLCubeRenderTarget === !0, d = l.length > 1;
		if (d || (c.__webglTexture === void 0 && (c.__webglTexture = e.createTexture()), c.__version = i.version, o.memory.textures++), u) {
			s.__webglFramebuffer = [];
			for (let t = 0; t < 6; t++) if (i.mipmaps && i.mipmaps.length > 0) {
				s.__webglFramebuffer[t] = [];
				for (let n = 0; n < i.mipmaps.length; n++) s.__webglFramebuffer[t][n] = e.createFramebuffer();
			} else s.__webglFramebuffer[t] = e.createFramebuffer();
		} else {
			if (i.mipmaps && i.mipmaps.length > 0) {
				s.__webglFramebuffer = [];
				for (let t = 0; t < i.mipmaps.length; t++) s.__webglFramebuffer[t] = e.createFramebuffer();
			} else s.__webglFramebuffer = e.createFramebuffer();
			if (d) for (let t = 0, n = l.length; t < n; t++) {
				let n = r.get(l[t]);
				n.__webglTexture === void 0 && (n.__webglTexture = e.createTexture(), o.memory.textures++);
			}
			if (t.samples > 0 && H(t) === !1) {
				s.__webglMultisampledFramebuffer = e.createFramebuffer(), s.__webglColorRenderbuffer = [], n.bindFramebuffer(e.FRAMEBUFFER, s.__webglMultisampledFramebuffer);
				for (let n = 0; n < l.length; n++) {
					let r = l[n];
					s.__webglColorRenderbuffer[n] = e.createRenderbuffer(), e.bindRenderbuffer(e.RENDERBUFFER, s.__webglColorRenderbuffer[n]);
					let i = a.convert(r.format, r.colorSpace), o = a.convert(r.type), c = b(r.internalFormat, i, o, r.normalized, r.colorSpace, t.isXRRenderTarget === !0), u = ge(t);
					e.renderbufferStorageMultisample(e.RENDERBUFFER, u, c, t.width, t.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + n, e.RENDERBUFFER, s.__webglColorRenderbuffer[n]);
				}
				e.bindRenderbuffer(e.RENDERBUFFER, null), t.depthBuffer && (s.__webglDepthRenderbuffer = e.createRenderbuffer(), se(s.__webglDepthRenderbuffer, t, !0)), n.bindFramebuffer(e.FRAMEBUFFER, null);
			}
		}
		if (u) {
			n.bindTexture(e.TEXTURE_CUBE_MAP, c.__webglTexture), z(e.TEXTURE_CUBE_MAP, i);
			for (let n = 0; n < 6; n++) if (i.mipmaps && i.mipmaps.length > 0) for (let r = 0; r < i.mipmaps.length; r++) oe(s.__webglFramebuffer[n][r], t, i, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + n, r);
			else oe(s.__webglFramebuffer[n], t, i, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + n, 0);
			_(i) && v(e.TEXTURE_CUBE_MAP), n.unbindTexture();
		} else if (d) {
			for (let i = 0, a = l.length; i < a; i++) {
				let a = l[i], o = r.get(a), c = e.TEXTURE_2D;
				(t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) && (c = t.isWebGL3DRenderTarget ? e.TEXTURE_3D : e.TEXTURE_2D_ARRAY), n.bindTexture(c, o.__webglTexture), z(c, a), oe(s.__webglFramebuffer, t, a, e.COLOR_ATTACHMENT0 + i, c, 0), _(a) && v(c);
			}
			n.unbindTexture();
		} else {
			let r = e.TEXTURE_2D;
			if ((t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) && (r = t.isWebGL3DRenderTarget ? e.TEXTURE_3D : e.TEXTURE_2D_ARRAY), n.bindTexture(r, c.__webglTexture), z(r, i), i.mipmaps && i.mipmaps.length > 0) for (let n = 0; n < i.mipmaps.length; n++) oe(s.__webglFramebuffer[n], t, i, e.COLOR_ATTACHMENT0, r, n);
			else oe(s.__webglFramebuffer, t, i, e.COLOR_ATTACHMENT0, r, 0);
			_(i) && v(r), n.unbindTexture();
		}
		t.depthBuffer && le(t);
	}
	function fe(e) {
		let t = e.textures;
		for (let i = 0, a = t.length; i < a; i++) {
			let a = t[i];
			if (_(a)) {
				let t = y(e), i = r.get(a).__webglTexture;
				n.bindTexture(t, i), v(t), n.unbindTexture();
			}
		}
	}
	let pe = [], me = [];
	function he(t) {
		if (t.samples > 0) {
			if (H(t) === !1) {
				let i = t.textures, a = t.width, o = t.height, s = e.COLOR_BUFFER_BIT, l = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, u = r.get(t), d = i.length > 1;
				if (d) for (let t = 0; t < i.length; t++) n.bindFramebuffer(e.FRAMEBUFFER, u.__webglMultisampledFramebuffer), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.RENDERBUFFER, null), n.bindFramebuffer(e.FRAMEBUFFER, u.__webglFramebuffer), e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.TEXTURE_2D, null, 0);
				n.bindFramebuffer(e.READ_FRAMEBUFFER, u.__webglMultisampledFramebuffer);
				let f = t.texture.mipmaps;
				f && f.length > 0 ? n.bindFramebuffer(e.DRAW_FRAMEBUFFER, u.__webglFramebuffer[0]) : n.bindFramebuffer(e.DRAW_FRAMEBUFFER, u.__webglFramebuffer);
				for (let n = 0; n < i.length; n++) {
					if (t.resolveDepthBuffer && (t.depthBuffer && (s |= e.DEPTH_BUFFER_BIT), t.stencilBuffer && t.resolveStencilBuffer && (s |= e.STENCIL_BUFFER_BIT)), d) {
						e.framebufferRenderbuffer(e.READ_FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.RENDERBUFFER, u.__webglColorRenderbuffer[n]);
						let t = r.get(i[n]).__webglTexture;
						e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0);
					}
					e.blitFramebuffer(0, 0, a, o, 0, 0, a, o, s, e.NEAREST), c === !0 && (pe.length = 0, me.length = 0, pe.push(e.COLOR_ATTACHMENT0 + n), t.depthBuffer && t.resolveDepthBuffer === !1 && (pe.push(l), me.push(l), e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, me)), e.invalidateFramebuffer(e.READ_FRAMEBUFFER, pe));
				}
				if (n.bindFramebuffer(e.READ_FRAMEBUFFER, null), n.bindFramebuffer(e.DRAW_FRAMEBUFFER, null), d) for (let t = 0; t < i.length; t++) {
					n.bindFramebuffer(e.FRAMEBUFFER, u.__webglMultisampledFramebuffer), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.RENDERBUFFER, u.__webglColorRenderbuffer[t]);
					let a = r.get(i[t]).__webglTexture;
					n.bindFramebuffer(e.FRAMEBUFFER, u.__webglFramebuffer), e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.TEXTURE_2D, a, 0);
				}
				n.bindFramebuffer(e.DRAW_FRAMEBUFFER, u.__webglMultisampledFramebuffer);
			} else if (t.depthBuffer && t.resolveDepthBuffer === !1 && c) {
				let n = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
				e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, [n]);
			}
		}
	}
	function ge(e) {
		return Math.min(i.maxSamples, e.samples);
	}
	function H(e) {
		let n = r.get(e);
		return e.samples > 0 && t.has("WEBGL_multisampled_render_to_texture") === !0 && n.__useRenderToTexture !== !1;
	}
	function _e(e) {
		let t = o.render.frame;
		u.get(e) !== t && (u.set(e, t), e.update());
	}
	function ve(e, t) {
		let n = e.colorSpace, r = e.format, i = e.type;
		return e.isCompressedTexture === !0 || e.isVideoTexture === !0 || n !== "srgb-linear" && n !== "" && (Lu.getTransfer(n) === "srgb" ? (r !== 1023 || i !== 1009) && Zl("WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : J("WebGLTextures: Unsupported texture color space:", n)), t;
	}
	function ye(e) {
		return typeof HTMLImageElement < "u" && e instanceof HTMLImageElement ? (l.width = e.naturalWidth || e.width, l.height = e.naturalHeight || e.height) : typeof VideoFrame < "u" && e instanceof VideoFrame ? (l.width = e.displayWidth, l.height = e.displayHeight) : (l.width = e.width, l.height = e.height), l;
	}
	this.allocateTextureUnit = M, this.resetTextureUnits = k, this.getTextureUnits = A, this.setTextureUnits = j, this.setTexture2D = P, this.setTexture2DArray = F, this.setTexture3D = I, this.setTextureCube = R, this.rebindTextures = ue, this.setupRenderTarget = de, this.updateRenderTargetMipmap = fe, this.updateMultisampleRenderTarget = he, this.setupDepthRenderbuffer = le, this.setupFrameBufferTexture = oe, this.useMultisampledRTT = H, this.isReversedDepthBuffer = function() {
		return n.buffers.depth.getReversed();
	};
}
function $_(e, t) {
	function n(n, r = "") {
		let i, a = Lu.getTransfer(r);
		if (n === 1009) return e.UNSIGNED_BYTE;
		if (n === 1017) return e.UNSIGNED_SHORT_4_4_4_4;
		if (n === 1018) return e.UNSIGNED_SHORT_5_5_5_1;
		if (n === 35902) return e.UNSIGNED_INT_5_9_9_9_REV;
		if (n === 35899) return e.UNSIGNED_INT_10F_11F_11F_REV;
		if (n === 1010) return e.BYTE;
		if (n === 1011) return e.SHORT;
		if (n === 1012) return e.UNSIGNED_SHORT;
		if (n === 1013) return e.INT;
		if (n === 1014) return e.UNSIGNED_INT;
		if (n === 1015) return e.FLOAT;
		if (n === 1016) return e.HALF_FLOAT;
		if (n === 1021) return e.ALPHA;
		if (n === 1022) return e.RGB;
		if (n === 1023) return e.RGBA;
		if (n === 1026) return e.DEPTH_COMPONENT;
		if (n === 1027) return e.DEPTH_STENCIL;
		if (n === 1028) return e.RED;
		if (n === 1029) return e.RED_INTEGER;
		if (n === 1030) return e.RG;
		if (n === 1031) return e.RG_INTEGER;
		if (n === 1033) return e.RGBA_INTEGER;
		if (n === 33776 || n === 33777 || n === 33778 || n === 33779) if (a === "srgb") if (i = t.get("WEBGL_compressed_texture_s3tc_srgb"), i !== null) {
			if (n === 33776) return i.COMPRESSED_SRGB_S3TC_DXT1_EXT;
			if (n === 33777) return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
			if (n === 33778) return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
			if (n === 33779) return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
		} else return null;
		else if (i = t.get("WEBGL_compressed_texture_s3tc"), i !== null) {
			if (n === 33776) return i.COMPRESSED_RGB_S3TC_DXT1_EXT;
			if (n === 33777) return i.COMPRESSED_RGBA_S3TC_DXT1_EXT;
			if (n === 33778) return i.COMPRESSED_RGBA_S3TC_DXT3_EXT;
			if (n === 33779) return i.COMPRESSED_RGBA_S3TC_DXT5_EXT;
		} else return null;
		if (n === 35840 || n === 35841 || n === 35842 || n === 35843) if (i = t.get("WEBGL_compressed_texture_pvrtc"), i !== null) {
			if (n === 35840) return i.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
			if (n === 35841) return i.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
			if (n === 35842) return i.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
			if (n === 35843) return i.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
		} else return null;
		if (n === 36196 || n === 37492 || n === 37496 || n === 37488 || n === 37489 || n === 37490 || n === 37491) if (i = t.get("WEBGL_compressed_texture_etc"), i !== null) {
			if (n === 36196 || n === 37492) return a === "srgb" ? i.COMPRESSED_SRGB8_ETC2 : i.COMPRESSED_RGB8_ETC2;
			if (n === 37496) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : i.COMPRESSED_RGBA8_ETC2_EAC;
			if (n === 37488) return i.COMPRESSED_R11_EAC;
			if (n === 37489) return i.COMPRESSED_SIGNED_R11_EAC;
			if (n === 37490) return i.COMPRESSED_RG11_EAC;
			if (n === 37491) return i.COMPRESSED_SIGNED_RG11_EAC;
		} else return null;
		if (n === 37808 || n === 37809 || n === 37810 || n === 37811 || n === 37812 || n === 37813 || n === 37814 || n === 37815 || n === 37816 || n === 37817 || n === 37818 || n === 37819 || n === 37820 || n === 37821) if (i = t.get("WEBGL_compressed_texture_astc"), i !== null) {
			if (n === 37808) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : i.COMPRESSED_RGBA_ASTC_4x4_KHR;
			if (n === 37809) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : i.COMPRESSED_RGBA_ASTC_5x4_KHR;
			if (n === 37810) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : i.COMPRESSED_RGBA_ASTC_5x5_KHR;
			if (n === 37811) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : i.COMPRESSED_RGBA_ASTC_6x5_KHR;
			if (n === 37812) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : i.COMPRESSED_RGBA_ASTC_6x6_KHR;
			if (n === 37813) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : i.COMPRESSED_RGBA_ASTC_8x5_KHR;
			if (n === 37814) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : i.COMPRESSED_RGBA_ASTC_8x6_KHR;
			if (n === 37815) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : i.COMPRESSED_RGBA_ASTC_8x8_KHR;
			if (n === 37816) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : i.COMPRESSED_RGBA_ASTC_10x5_KHR;
			if (n === 37817) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : i.COMPRESSED_RGBA_ASTC_10x6_KHR;
			if (n === 37818) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : i.COMPRESSED_RGBA_ASTC_10x8_KHR;
			if (n === 37819) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : i.COMPRESSED_RGBA_ASTC_10x10_KHR;
			if (n === 37820) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : i.COMPRESSED_RGBA_ASTC_12x10_KHR;
			if (n === 37821) return a === "srgb" ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : i.COMPRESSED_RGBA_ASTC_12x12_KHR;
		} else return null;
		if (n === 36492 || n === 36494 || n === 36495) if (i = t.get("EXT_texture_compression_bptc"), i !== null) {
			if (n === 36492) return a === "srgb" ? i.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : i.COMPRESSED_RGBA_BPTC_UNORM_EXT;
			if (n === 36494) return i.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
			if (n === 36495) return i.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
		} else return null;
		if (n === 36283 || n === 36284 || n === 36285 || n === 36286) if (i = t.get("EXT_texture_compression_rgtc"), i !== null) {
			if (n === 36283) return i.COMPRESSED_RED_RGTC1_EXT;
			if (n === 36284) return i.COMPRESSED_SIGNED_RED_RGTC1_EXT;
			if (n === 36285) return i.COMPRESSED_RED_GREEN_RGTC2_EXT;
			if (n === 36286) return i.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
		} else return null;
		return n === 1020 ? e.UNSIGNED_INT_24_8 : e[n] === void 0 ? null : e[n];
	}
	return { convert: n };
}
var ev = "\nvoid main() {\n\n	gl_Position = vec4( position, 1.0 );\n\n}", tv = "\nuniform sampler2DArray depthColor;\nuniform float depthWidth;\nuniform float depthHeight;\n\nvoid main() {\n\n	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );\n\n	if ( coord.x >= 1.0 ) {\n\n		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;\n\n	} else {\n\n		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;\n\n	}\n\n}", nv = class {
	constructor() {
		this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
	}
	init(e, t) {
		if (this.texture === null) {
			let n = new Op(e.texture);
			(e.depthNear !== t.depthNear || e.depthFar !== t.depthFar) && (this.depthNear = e.depthNear, this.depthFar = e.depthFar), this.texture = n;
		}
	}
	getMesh(e) {
		if (this.texture !== null && this.mesh === null) {
			let t = e.cameras[0].viewport, n = new Wp({
				vertexShader: ev,
				fragmentShader: tv,
				uniforms: {
					depthColor: { value: this.texture },
					depthWidth: { value: t.z },
					depthHeight: { value: t.w }
				}
			});
			this.mesh = new ep(new Fp(20, 20), n);
		}
		return this.mesh;
	}
	reset() {
		this.texture = null, this.mesh = null;
	}
	getDepthTexture() {
		return this.texture;
	}
}, rv = class extends tu {
	constructor(e, t) {
		super();
		let n = this, r = null, i = 1, a = null, o = "local-floor", s = 1, c = null, l = null, u = null, d = null, f = null, p = null, m = typeof XRWebGLBinding < "u", h = new nv(), g = {}, _ = t.getContextAttributes(), v = null, y = null, b = [], x = [], S = new Ou(), C = null, w = new wm();
		w.viewport = new Ju();
		let T = new wm();
		T.viewport = new Ju();
		let E = [w, T], D = new Mm(), O = null, k = null;
		this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(e) {
			let t = b[e];
			return t === void 0 && (t = new kd(), b[e] = t), t.getTargetRaySpace();
		}, this.getControllerGrip = function(e) {
			let t = b[e];
			return t === void 0 && (t = new kd(), b[e] = t), t.getGripSpace();
		}, this.getHand = function(e) {
			let t = b[e];
			return t === void 0 && (t = new kd(), b[e] = t), t.getHandSpace();
		};
		function A(e) {
			let t = x.indexOf(e.inputSource);
			if (t === -1) return;
			let n = b[t];
			n !== void 0 && (n.update(e.inputSource, e.frame, c || a), n.dispatchEvent({
				type: e.type,
				data: e.inputSource
			}));
		}
		function j() {
			r.removeEventListener("select", A), r.removeEventListener("selectstart", A), r.removeEventListener("selectend", A), r.removeEventListener("squeeze", A), r.removeEventListener("squeezestart", A), r.removeEventListener("squeezeend", A), r.removeEventListener("end", j), r.removeEventListener("inputsourceschange", M);
			for (let e = 0; e < b.length; e++) {
				let t = x[e];
				t !== null && (x[e] = null, b[e].disconnect(t));
			}
			O = null, k = null, h.reset();
			for (let e in g) delete g[e];
			e.setRenderTarget(v), f = null, d = null, u = null, r = null, y = null, ne.stop(), n.isPresenting = !1, e.setPixelRatio(C), e.setSize(S.width, S.height, !1), n.dispatchEvent({ type: "sessionend" });
		}
		this.setFramebufferScaleFactor = function(e) {
			i = e, n.isPresenting === !0 && Zl("WebXRManager: Cannot change framebuffer scale while presenting.");
		}, this.setReferenceSpaceType = function(e) {
			o = e, n.isPresenting === !0 && Zl("WebXRManager: Cannot change reference space type while presenting.");
		}, this.getReferenceSpace = function() {
			return c || a;
		}, this.setReferenceSpace = function(e) {
			c = e;
		}, this.getBaseLayer = function() {
			return d === null ? f : d;
		}, this.getBinding = function() {
			return u === null && m && (u = new XRWebGLBinding(r, t)), u;
		}, this.getFrame = function() {
			return p;
		}, this.getSession = function() {
			return r;
		}, this.setSession = async function(l) {
			if (r = l, r !== null) {
				if (v = e.getRenderTarget(), r.addEventListener("select", A), r.addEventListener("selectstart", A), r.addEventListener("selectend", A), r.addEventListener("squeeze", A), r.addEventListener("squeezestart", A), r.addEventListener("squeezeend", A), r.addEventListener("end", j), r.addEventListener("inputsourceschange", M), _.xrCompatible !== !0 && await t.makeXRCompatible(), C = e.getPixelRatio(), e.getSize(S), m && "createProjectionLayer" in XRWebGLBinding.prototype) {
					let n = null, a = null, o = null;
					_.depth && (o = _.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24, n = _.stencil ? Bc : zc, a = _.stencil ? Nc : Oc);
					let s = {
						colorFormat: t.RGBA8,
						depthFormat: o,
						scaleFactor: i
					};
					u = this.getBinding(), d = u.createProjectionLayer(s), r.updateRenderState({ layers: [d] }), e.setPixelRatio(1), e.setSize(d.textureWidth, d.textureHeight, !1), y = new Xu(d.textureWidth, d.textureHeight, {
						format: Rc,
						type: Cc,
						depthTexture: new Ep(d.textureWidth, d.textureHeight, a, void 0, void 0, void 0, void 0, void 0, void 0, n),
						stencilBuffer: _.stencil,
						colorSpace: e.outputColorSpace,
						samples: _.antialias ? 4 : 0,
						resolveDepthBuffer: d.ignoreDepthValues === !1,
						resolveStencilBuffer: d.ignoreDepthValues === !1
					});
				} else {
					let n = {
						antialias: _.antialias,
						alpha: !0,
						depth: _.depth,
						stencil: _.stencil,
						framebufferScaleFactor: i
					};
					f = new XRWebGLLayer(r, t, n), r.updateRenderState({ baseLayer: f }), e.setPixelRatio(1), e.setSize(f.framebufferWidth, f.framebufferHeight, !1), y = new Xu(f.framebufferWidth, f.framebufferHeight, {
						format: Rc,
						type: Cc,
						colorSpace: e.outputColorSpace,
						stencilBuffer: _.stencil,
						resolveDepthBuffer: f.ignoreDepthValues === !1,
						resolveStencilBuffer: f.ignoreDepthValues === !1
					});
				}
				y.isXRRenderTarget = !0, this.setFoveation(s), c = null, a = await r.requestReferenceSpace(o), ne.setContext(r), ne.start(), n.isPresenting = !0, n.dispatchEvent({ type: "sessionstart" });
			}
		}, this.getEnvironmentBlendMode = function() {
			if (r !== null) return r.environmentBlendMode;
		}, this.getDepthTexture = function() {
			return h.getDepthTexture();
		};
		function M(e) {
			for (let t = 0; t < e.removed.length; t++) {
				let n = e.removed[t], r = x.indexOf(n);
				r >= 0 && (x[r] = null, b[r].disconnect(n));
			}
			for (let t = 0; t < e.added.length; t++) {
				let n = e.added[t], r = x.indexOf(n);
				if (r === -1) {
					for (let e = 0; e < b.length; e++) if (e >= x.length) {
						x.push(n), r = e;
						break;
					} else if (x[e] === null) {
						x[e] = n, r = e;
						break;
					}
					if (r === -1) break;
				}
				let i = b[r];
				i && i.connect(n);
			}
		}
		let N = new X(), P = new X();
		function F(e, t, n) {
			N.setFromMatrixPosition(t.matrixWorld), P.setFromMatrixPosition(n.matrixWorld);
			let r = N.distanceTo(P), i = t.projectionMatrix.elements, a = n.projectionMatrix.elements, o = i[14] / (i[10] - 1), s = i[14] / (i[10] + 1), c = (i[9] + 1) / i[5], l = (i[9] - 1) / i[5], u = (i[8] - 1) / i[0], d = (a[8] + 1) / a[0], f = o * u, p = o * d, m = r / (-u + d), h = m * -u;
			if (t.matrixWorld.decompose(e.position, e.quaternion, e.scale), e.translateX(h), e.translateZ(m), e.matrixWorld.compose(e.position, e.quaternion, e.scale), e.matrixWorldInverse.copy(e.matrixWorld).invert(), i[10] === -1) e.projectionMatrix.copy(t.projectionMatrix), e.projectionMatrixInverse.copy(t.projectionMatrixInverse);
			else {
				let t = o + m, n = s + m, i = f - h, a = p + (r - h), u = c * s / n * t, d = l * s / n * t;
				e.projectionMatrix.makePerspective(i, a, u, d, t, n), e.projectionMatrixInverse.copy(e.projectionMatrix).invert();
			}
		}
		function I(e, t) {
			t === null ? e.matrixWorld.copy(e.matrix) : e.matrixWorld.multiplyMatrices(t.matrixWorld, e.matrix), e.matrixWorldInverse.copy(e.matrixWorld).invert();
		}
		this.updateCamera = function(e) {
			if (r === null) return;
			let t = e.near, n = e.far;
			h.texture !== null && (h.depthNear > 0 && (t = h.depthNear), h.depthFar > 0 && (n = h.depthFar)), D.near = T.near = w.near = t, D.far = T.far = w.far = n, (O !== D.near || k !== D.far) && (r.updateRenderState({
				depthNear: D.near,
				depthFar: D.far
			}), O = D.near, k = D.far), D.layers.mask = e.layers.mask | 6, w.layers.mask = D.layers.mask & -5, T.layers.mask = D.layers.mask & -3;
			let i = e.parent, a = D.cameras;
			I(D, i);
			for (let e = 0; e < a.length; e++) I(a[e], i);
			a.length === 2 ? F(D, w, T) : D.projectionMatrix.copy(w.projectionMatrix), R(e, D, i);
		};
		function R(e, t, n) {
			n === null ? e.matrix.copy(t.matrixWorld) : (e.matrix.copy(n.matrixWorld), e.matrix.invert(), e.matrix.multiply(t.matrixWorld)), e.matrix.decompose(e.position, e.quaternion, e.scale), e.updateMatrixWorld(!0), e.projectionMatrix.copy(t.projectionMatrix), e.projectionMatrixInverse.copy(t.projectionMatrixInverse), e.isPerspectiveCamera && (e.fov = au * 2 * Math.atan(1 / e.projectionMatrix.elements[5]), e.zoom = 1);
		}
		this.getCamera = function() {
			return D;
		}, this.getFoveation = function() {
			if (!(d === null && f === null)) return s;
		}, this.setFoveation = function(e) {
			s = e, d !== null && (d.fixedFoveation = e), f !== null && f.fixedFoveation !== void 0 && (f.fixedFoveation = e);
		}, this.hasDepthSensing = function() {
			return h.texture !== null;
		}, this.getDepthSensingMesh = function() {
			return h.getMesh(D);
		}, this.getCameraTexture = function(e) {
			return g[e];
		};
		let ee = null;
		function te(t, i) {
			if (l = i.getViewerPose(c || a), p = i, l !== null) {
				let t = l.views;
				f !== null && (e.setRenderTargetFramebuffer(y, f.framebuffer), e.setRenderTarget(y));
				let i = !1;
				t.length !== D.cameras.length && (D.cameras.length = 0, i = !0);
				for (let n = 0; n < t.length; n++) {
					let r = t[n], a = null;
					if (f !== null) a = f.getViewport(r);
					else {
						let t = u.getViewSubImage(d, r);
						a = t.viewport, n === 0 && (e.setRenderTargetTextures(y, t.colorTexture, t.depthStencilTexture), e.setRenderTarget(y));
					}
					let o = E[n];
					o === void 0 && (o = new wm(), o.layers.enable(n), o.viewport = new Ju(), E[n] = o), o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.quaternion, o.scale), o.projectionMatrix.fromArray(r.projectionMatrix), o.projectionMatrixInverse.copy(o.projectionMatrix).invert(), o.viewport.set(a.x, a.y, a.width, a.height), n === 0 && (D.matrix.copy(o.matrix), D.matrix.decompose(D.position, D.quaternion, D.scale)), i === !0 && D.cameras.push(o);
				}
				let a = r.enabledFeatures;
				if (a && a.includes("depth-sensing") && r.depthUsage == "gpu-optimized" && m) {
					u = n.getBinding();
					let e = u.getDepthInformation(t[0]);
					e && e.isValid && e.texture && h.init(e, r.renderState);
				}
				if (a && a.includes("camera-access") && m) {
					e.state.unbindTexture(), u = n.getBinding();
					for (let e = 0; e < t.length; e++) {
						let n = t[e].camera;
						if (n) {
							let e = g[n];
							e || (e = new Op(), g[n] = e);
							let t = u.getCameraImage(n);
							e.sourceTexture = t;
						}
					}
				}
			}
			for (let e = 0; e < b.length; e++) {
				let t = x[e], n = b[e];
				t !== null && n !== void 0 && n.update(t, i, c || a);
			}
			ee && ee(t, i), i.detectedPlanes && n.dispatchEvent({
				type: "planesdetected",
				data: i
			}), p = null;
		}
		let ne = new Ym();
		ne.setAnimationLoop(te), this.setAnimationLoop = function(e) {
			ee = e;
		}, this.dispose = function() {};
	}
}, iv = /* @__PURE__ */ new $u(), av = /* @__PURE__ */ new Mu();
av.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
function ov(e, t) {
	function n(e, t) {
		e.matrixAutoUpdate === !0 && e.updateMatrix(), t.value.copy(e.matrix);
	}
	function r(t, n) {
		n.color.getRGB(t.fogColor.value, Bp(e)), n.isFog ? (t.fogNear.value = n.near, t.fogFar.value = n.far) : n.isFogExp2 && (t.fogDensity.value = n.density);
	}
	function i(e, t, n, r, i) {
		t.isNodeMaterial ? t.uniformsNeedUpdate = !1 : t.isMeshBasicMaterial ? a(e, t) : t.isMeshLambertMaterial ? (a(e, t), t.envMap && (e.envMapIntensity.value = t.envMapIntensity)) : t.isMeshToonMaterial ? (a(e, t), d(e, t)) : t.isMeshPhongMaterial ? (a(e, t), u(e, t), t.envMap && (e.envMapIntensity.value = t.envMapIntensity)) : t.isMeshStandardMaterial ? (a(e, t), f(e, t), t.isMeshPhysicalMaterial && p(e, t, i)) : t.isMeshMatcapMaterial ? (a(e, t), m(e, t)) : t.isMeshDepthMaterial ? a(e, t) : t.isMeshDistanceMaterial ? (a(e, t), h(e, t)) : t.isMeshNormalMaterial ? a(e, t) : t.isLineBasicMaterial ? (o(e, t), t.isLineDashedMaterial && s(e, t)) : t.isPointsMaterial ? c(e, t, n, r) : t.isSpriteMaterial ? l(e, t) : t.isShadowMaterial ? (e.color.value.copy(t.color), e.opacity.value = t.opacity) : t.isShaderMaterial && (t.uniformsNeedUpdate = !1);
	}
	function a(e, r) {
		e.opacity.value = r.opacity, r.color && e.diffuse.value.copy(r.color), r.emissive && e.emissive.value.copy(r.emissive).multiplyScalar(r.emissiveIntensity), r.map && (e.map.value = r.map, n(r.map, e.mapTransform)), r.alphaMap && (e.alphaMap.value = r.alphaMap, n(r.alphaMap, e.alphaMapTransform)), r.bumpMap && (e.bumpMap.value = r.bumpMap, n(r.bumpMap, e.bumpMapTransform), e.bumpScale.value = r.bumpScale, r.side === 1 && (e.bumpScale.value *= -1)), r.normalMap && (e.normalMap.value = r.normalMap, n(r.normalMap, e.normalMapTransform), e.normalScale.value.copy(r.normalScale), r.side === 1 && e.normalScale.value.negate()), r.displacementMap && (e.displacementMap.value = r.displacementMap, n(r.displacementMap, e.displacementMapTransform), e.displacementScale.value = r.displacementScale, e.displacementBias.value = r.displacementBias), r.emissiveMap && (e.emissiveMap.value = r.emissiveMap, n(r.emissiveMap, e.emissiveMapTransform)), r.specularMap && (e.specularMap.value = r.specularMap, n(r.specularMap, e.specularMapTransform)), r.alphaTest > 0 && (e.alphaTest.value = r.alphaTest);
		let i = t.get(r), a = i.envMap, o = i.envMapRotation;
		a && (e.envMap.value = a, e.envMapRotation.value.setFromMatrix4(iv.makeRotationFromEuler(o)).transpose(), a.isCubeTexture && a.isRenderTargetTexture === !1 && e.envMapRotation.value.premultiply(av), e.reflectivity.value = r.reflectivity, e.ior.value = r.ior, e.refractionRatio.value = r.refractionRatio), r.lightMap && (e.lightMap.value = r.lightMap, e.lightMapIntensity.value = r.lightMapIntensity, n(r.lightMap, e.lightMapTransform)), r.aoMap && (e.aoMap.value = r.aoMap, e.aoMapIntensity.value = r.aoMapIntensity, n(r.aoMap, e.aoMapTransform));
	}
	function o(e, t) {
		e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, t.map && (e.map.value = t.map, n(t.map, e.mapTransform));
	}
	function s(e, t) {
		e.dashSize.value = t.dashSize, e.totalSize.value = t.dashSize + t.gapSize, e.scale.value = t.scale;
	}
	function c(e, t, r, i) {
		e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, e.size.value = t.size * r, e.scale.value = i * .5, t.map && (e.map.value = t.map, n(t.map, e.uvTransform)), t.alphaMap && (e.alphaMap.value = t.alphaMap, n(t.alphaMap, e.alphaMapTransform)), t.alphaTest > 0 && (e.alphaTest.value = t.alphaTest);
	}
	function l(e, t) {
		e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, e.rotation.value = t.rotation, t.map && (e.map.value = t.map, n(t.map, e.mapTransform)), t.alphaMap && (e.alphaMap.value = t.alphaMap, n(t.alphaMap, e.alphaMapTransform)), t.alphaTest > 0 && (e.alphaTest.value = t.alphaTest);
	}
	function u(e, t) {
		e.specular.value.copy(t.specular), e.shininess.value = Math.max(t.shininess, 1e-4);
	}
	function d(e, t) {
		t.gradientMap && (e.gradientMap.value = t.gradientMap);
	}
	function f(e, t) {
		e.metalness.value = t.metalness, t.metalnessMap && (e.metalnessMap.value = t.metalnessMap, n(t.metalnessMap, e.metalnessMapTransform)), e.roughness.value = t.roughness, t.roughnessMap && (e.roughnessMap.value = t.roughnessMap, n(t.roughnessMap, e.roughnessMapTransform)), t.envMap && (e.envMapIntensity.value = t.envMapIntensity);
	}
	function p(e, t, r) {
		e.ior.value = t.ior, t.sheen > 0 && (e.sheenColor.value.copy(t.sheenColor).multiplyScalar(t.sheen), e.sheenRoughness.value = t.sheenRoughness, t.sheenColorMap && (e.sheenColorMap.value = t.sheenColorMap, n(t.sheenColorMap, e.sheenColorMapTransform)), t.sheenRoughnessMap && (e.sheenRoughnessMap.value = t.sheenRoughnessMap, n(t.sheenRoughnessMap, e.sheenRoughnessMapTransform))), t.clearcoat > 0 && (e.clearcoat.value = t.clearcoat, e.clearcoatRoughness.value = t.clearcoatRoughness, t.clearcoatMap && (e.clearcoatMap.value = t.clearcoatMap, n(t.clearcoatMap, e.clearcoatMapTransform)), t.clearcoatRoughnessMap && (e.clearcoatRoughnessMap.value = t.clearcoatRoughnessMap, n(t.clearcoatRoughnessMap, e.clearcoatRoughnessMapTransform)), t.clearcoatNormalMap && (e.clearcoatNormalMap.value = t.clearcoatNormalMap, n(t.clearcoatNormalMap, e.clearcoatNormalMapTransform), e.clearcoatNormalScale.value.copy(t.clearcoatNormalScale), t.side === 1 && e.clearcoatNormalScale.value.negate())), t.dispersion > 0 && (e.dispersion.value = t.dispersion), t.iridescence > 0 && (e.iridescence.value = t.iridescence, e.iridescenceIOR.value = t.iridescenceIOR, e.iridescenceThicknessMinimum.value = t.iridescenceThicknessRange[0], e.iridescenceThicknessMaximum.value = t.iridescenceThicknessRange[1], t.iridescenceMap && (e.iridescenceMap.value = t.iridescenceMap, n(t.iridescenceMap, e.iridescenceMapTransform)), t.iridescenceThicknessMap && (e.iridescenceThicknessMap.value = t.iridescenceThicknessMap, n(t.iridescenceThicknessMap, e.iridescenceThicknessMapTransform))), t.transmission > 0 && (e.transmission.value = t.transmission, e.transmissionSamplerMap.value = r.texture, e.transmissionSamplerSize.value.set(r.width, r.height), t.transmissionMap && (e.transmissionMap.value = t.transmissionMap, n(t.transmissionMap, e.transmissionMapTransform)), e.thickness.value = t.thickness, t.thicknessMap && (e.thicknessMap.value = t.thicknessMap, n(t.thicknessMap, e.thicknessMapTransform)), e.attenuationDistance.value = t.attenuationDistance, e.attenuationColor.value.copy(t.attenuationColor)), t.anisotropy > 0 && (e.anisotropyVector.value.set(t.anisotropy * Math.cos(t.anisotropyRotation), t.anisotropy * Math.sin(t.anisotropyRotation)), t.anisotropyMap && (e.anisotropyMap.value = t.anisotropyMap, n(t.anisotropyMap, e.anisotropyMapTransform))), e.specularIntensity.value = t.specularIntensity, e.specularColor.value.copy(t.specularColor), t.specularColorMap && (e.specularColorMap.value = t.specularColorMap, n(t.specularColorMap, e.specularColorMapTransform)), t.specularIntensityMap && (e.specularIntensityMap.value = t.specularIntensityMap, n(t.specularIntensityMap, e.specularIntensityMapTransform));
	}
	function m(e, t) {
		t.matcap && (e.matcap.value = t.matcap);
	}
	function h(e, n) {
		let r = t.get(n).light;
		e.referencePosition.value.setFromMatrixPosition(r.matrixWorld), e.nearDistance.value = r.shadow.camera.near, e.farDistance.value = r.shadow.camera.far;
	}
	return {
		refreshFogUniforms: r,
		refreshMaterialUniforms: i
	};
}
function sv(e, t, n, r) {
	let i = {}, a = {}, o = [], s = e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS);
	function c(e, t) {
		let n = t.program;
		r.uniformBlockBinding(e, n);
	}
	function l(e, n) {
		let o = i[e.id];
		o === void 0 && (g(e), o = u(e), i[e.id] = o, e.addEventListener("dispose", v));
		let s = n.program;
		r.updateUBOMapping(e, s);
		let c = t.render.frame;
		a[e.id] !== c && (f(e), a[e.id] = c);
	}
	function u(t) {
		let n = d();
		t.__bindingPointIndex = n;
		let r = e.createBuffer(), i = t.__size, a = t.usage;
		return e.bindBuffer(e.UNIFORM_BUFFER, r), e.bufferData(e.UNIFORM_BUFFER, i, a), e.bindBuffer(e.UNIFORM_BUFFER, null), e.bindBufferBase(e.UNIFORM_BUFFER, n, r), r;
	}
	function d() {
		for (let e = 0; e < s; e++) if (o.indexOf(e) === -1) return o.push(e), e;
		return J("WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
	}
	function f(t) {
		let n = i[t.id], r = t.uniforms, a = t.__cache;
		e.bindBuffer(e.UNIFORM_BUFFER, n);
		for (let e = 0, t = r.length; e < t; e++) {
			let t = r[e];
			if (Array.isArray(t)) for (let n = 0, r = t.length; n < r; n++) p(t[n], e, n, a);
			else p(t, e, 0, a);
		}
		e.bindBuffer(e.UNIFORM_BUFFER, null);
	}
	function p(t, n, r, i) {
		if (h(t, n, r, i) === !0) {
			let n = t.__offset, r = t.value;
			if (Array.isArray(r)) {
				let e = 0;
				for (let n = 0; n < r.length; n++) {
					let i = r[n], a = _(i);
					m(i, t.__data, e), typeof i != "number" && typeof i != "boolean" && !i.isMatrix3 && !ArrayBuffer.isView(i) && (e += a.storage / Float32Array.BYTES_PER_ELEMENT);
				}
			} else m(r, t.__data, 0);
			e.bufferSubData(e.UNIFORM_BUFFER, n, t.__data);
		}
	}
	function m(e, t, n) {
		typeof e == "number" || typeof e == "boolean" ? t[0] = e : e.isMatrix3 ? (t[0] = e.elements[0], t[1] = e.elements[1], t[2] = e.elements[2], t[3] = 0, t[4] = e.elements[3], t[5] = e.elements[4], t[6] = e.elements[5], t[7] = 0, t[8] = e.elements[6], t[9] = e.elements[7], t[10] = e.elements[8], t[11] = 0) : ArrayBuffer.isView(e) ? t.set(new e.constructor(e.buffer, e.byteOffset, t.length)) : e.toArray(t, n);
	}
	function h(e, t, n, r) {
		let i = e.value, a = t + "_" + n;
		if (r[a] === void 0) return typeof i == "number" || typeof i == "boolean" ? r[a] = i : ArrayBuffer.isView(i) ? r[a] = i.slice() : r[a] = i.clone(), !0;
		{
			let e = r[a];
			if (typeof i == "number" || typeof i == "boolean") {
				if (e !== i) return r[a] = i, !0;
			} else if (ArrayBuffer.isView(i)) return !0;
			else if (e.equals(i) === !1) return e.copy(i), !0;
		}
		return !1;
	}
	function g(e) {
		let t = e.uniforms, n = 0;
		for (let e = 0, r = t.length; e < r; e++) {
			let r = Array.isArray(t[e]) ? t[e] : [t[e]];
			for (let e = 0, t = r.length; e < t; e++) {
				let t = r[e], i = Array.isArray(t.value) ? t.value : [t.value];
				for (let e = 0, r = i.length; e < r; e++) {
					let r = i[e], a = _(r), o = n % 16, s = o % a.boundary, c = o + s;
					n += s, c !== 0 && 16 - c < a.storage && (n += 16 - c), t.__data = new Float32Array(a.storage / Float32Array.BYTES_PER_ELEMENT), t.__offset = n, n += a.storage;
				}
			}
		}
		let r = n % 16;
		return r > 0 && (n += 16 - r), e.__size = n, e.__cache = {}, this;
	}
	function _(e) {
		let t = {
			boundary: 0,
			storage: 0
		};
		return typeof e == "number" || typeof e == "boolean" ? (t.boundary = 4, t.storage = 4) : e.isVector2 ? (t.boundary = 8, t.storage = 8) : e.isVector3 || e.isColor ? (t.boundary = 16, t.storage = 12) : e.isVector4 ? (t.boundary = 16, t.storage = 16) : e.isMatrix3 ? (t.boundary = 48, t.storage = 48) : e.isMatrix4 ? (t.boundary = 64, t.storage = 64) : e.isTexture ? Zl("WebGLRenderer: Texture samplers can not be part of an uniforms group.") : ArrayBuffer.isView(e) ? (t.boundary = 16, t.storage = e.byteLength) : Zl("WebGLRenderer: Unsupported uniform value type.", e), t;
	}
	function v(t) {
		let n = t.target;
		n.removeEventListener("dispose", v);
		let r = o.indexOf(n.__bindingPointIndex);
		o.splice(r, 1), e.deleteBuffer(i[n.id]), delete i[n.id], delete a[n.id];
	}
	function y() {
		for (let t in i) e.deleteBuffer(i[t]);
		o = [], i = {}, a = {};
	}
	return {
		bind: c,
		update: l,
		dispose: y
	};
}
var cv = new Uint16Array([
	12469,
	15057,
	12620,
	14925,
	13266,
	14620,
	13807,
	14376,
	14323,
	13990,
	14545,
	13625,
	14713,
	13328,
	14840,
	12882,
	14931,
	12528,
	14996,
	12233,
	15039,
	11829,
	15066,
	11525,
	15080,
	11295,
	15085,
	10976,
	15082,
	10705,
	15073,
	10495,
	13880,
	14564,
	13898,
	14542,
	13977,
	14430,
	14158,
	14124,
	14393,
	13732,
	14556,
	13410,
	14702,
	12996,
	14814,
	12596,
	14891,
	12291,
	14937,
	11834,
	14957,
	11489,
	14958,
	11194,
	14943,
	10803,
	14921,
	10506,
	14893,
	10278,
	14858,
	9960,
	14484,
	14039,
	14487,
	14025,
	14499,
	13941,
	14524,
	13740,
	14574,
	13468,
	14654,
	13106,
	14743,
	12678,
	14818,
	12344,
	14867,
	11893,
	14889,
	11509,
	14893,
	11180,
	14881,
	10751,
	14852,
	10428,
	14812,
	10128,
	14765,
	9754,
	14712,
	9466,
	14764,
	13480,
	14764,
	13475,
	14766,
	13440,
	14766,
	13347,
	14769,
	13070,
	14786,
	12713,
	14816,
	12387,
	14844,
	11957,
	14860,
	11549,
	14868,
	11215,
	14855,
	10751,
	14825,
	10403,
	14782,
	10044,
	14729,
	9651,
	14666,
	9352,
	14599,
	9029,
	14967,
	12835,
	14966,
	12831,
	14963,
	12804,
	14954,
	12723,
	14936,
	12564,
	14917,
	12347,
	14900,
	11958,
	14886,
	11569,
	14878,
	11247,
	14859,
	10765,
	14828,
	10401,
	14784,
	10011,
	14727,
	9600,
	14660,
	9289,
	14586,
	8893,
	14508,
	8533,
	15111,
	12234,
	15110,
	12234,
	15104,
	12216,
	15092,
	12156,
	15067,
	12010,
	15028,
	11776,
	14981,
	11500,
	14942,
	11205,
	14902,
	10752,
	14861,
	10393,
	14812,
	9991,
	14752,
	9570,
	14682,
	9252,
	14603,
	8808,
	14519,
	8445,
	14431,
	8145,
	15209,
	11449,
	15208,
	11451,
	15202,
	11451,
	15190,
	11438,
	15163,
	11384,
	15117,
	11274,
	15055,
	10979,
	14994,
	10648,
	14932,
	10343,
	14871,
	9936,
	14803,
	9532,
	14729,
	9218,
	14645,
	8742,
	14556,
	8381,
	14461,
	8020,
	14365,
	7603,
	15273,
	10603,
	15272,
	10607,
	15267,
	10619,
	15256,
	10631,
	15231,
	10614,
	15182,
	10535,
	15118,
	10389,
	15042,
	10167,
	14963,
	9787,
	14883,
	9447,
	14800,
	9115,
	14710,
	8665,
	14615,
	8318,
	14514,
	7911,
	14411,
	7507,
	14279,
	7198,
	15314,
	9675,
	15313,
	9683,
	15309,
	9712,
	15298,
	9759,
	15277,
	9797,
	15229,
	9773,
	15166,
	9668,
	15084,
	9487,
	14995,
	9274,
	14898,
	8910,
	14800,
	8539,
	14697,
	8234,
	14590,
	7790,
	14479,
	7409,
	14367,
	7067,
	14178,
	6621,
	15337,
	8619,
	15337,
	8631,
	15333,
	8677,
	15325,
	8769,
	15305,
	8871,
	15264,
	8940,
	15202,
	8909,
	15119,
	8775,
	15022,
	8565,
	14916,
	8328,
	14804,
	8009,
	14688,
	7614,
	14569,
	7287,
	14448,
	6888,
	14321,
	6483,
	14088,
	6171,
	15350,
	7402,
	15350,
	7419,
	15347,
	7480,
	15340,
	7613,
	15322,
	7804,
	15287,
	7973,
	15229,
	8057,
	15148,
	8012,
	15046,
	7846,
	14933,
	7611,
	14810,
	7357,
	14682,
	7069,
	14552,
	6656,
	14421,
	6316,
	14251,
	5948,
	14007,
	5528,
	15356,
	5942,
	15356,
	5977,
	15353,
	6119,
	15348,
	6294,
	15332,
	6551,
	15302,
	6824,
	15249,
	7044,
	15171,
	7122,
	15070,
	7050,
	14949,
	6861,
	14818,
	6611,
	14679,
	6349,
	14538,
	6067,
	14398,
	5651,
	14189,
	5311,
	13935,
	4958,
	15359,
	4123,
	15359,
	4153,
	15356,
	4296,
	15353,
	4646,
	15338,
	5160,
	15311,
	5508,
	15263,
	5829,
	15188,
	6042,
	15088,
	6094,
	14966,
	6001,
	14826,
	5796,
	14678,
	5543,
	14527,
	5287,
	14377,
	4985,
	14133,
	4586,
	13869,
	4257,
	15360,
	1563,
	15360,
	1642,
	15358,
	2076,
	15354,
	2636,
	15341,
	3350,
	15317,
	4019,
	15273,
	4429,
	15203,
	4732,
	15105,
	4911,
	14981,
	4932,
	14836,
	4818,
	14679,
	4621,
	14517,
	4386,
	14359,
	4156,
	14083,
	3795,
	13808,
	3437,
	15360,
	122,
	15360,
	137,
	15358,
	285,
	15355,
	636,
	15344,
	1274,
	15322,
	2177,
	15281,
	2765,
	15215,
	3223,
	15120,
	3451,
	14995,
	3569,
	14846,
	3567,
	14681,
	3466,
	14511,
	3305,
	14344,
	3121,
	14037,
	2800,
	13753,
	2467,
	15360,
	0,
	15360,
	1,
	15359,
	21,
	15355,
	89,
	15346,
	253,
	15325,
	479,
	15287,
	796,
	15225,
	1148,
	15133,
	1492,
	15008,
	1749,
	14856,
	1882,
	14685,
	1886,
	14506,
	1783,
	14324,
	1608,
	13996,
	1398,
	13702,
	1183
]), lv = null;
function uv() {
	return lv === null && (lv = new rp(cv, 16, 16, Uc, Ac), lv.name = "DFG_LUT", lv.minFilter = bc, lv.magFilter = bc, lv.wrapS = hc, lv.wrapT = hc, lv.generateMipmaps = !1, lv.needsUpdate = !0), lv;
}
var dv = class {
	constructor(e = {}) {
		let { canvas: t = Kl(), context: n = null, depth: r = !0, stencil: i = !1, alpha: a = !1, antialias: o = !1, premultipliedAlpha: s = !0, preserveDrawingBuffer: c = !1, powerPreference: l = "default", failIfMajorPerformanceCaveat: u = !1, reversedDepthBuffer: d = !1, outputBufferType: f = Cc } = e;
		this.isWebGLRenderer = !0;
		let p;
		if (n !== null) {
			if (typeof WebGLRenderingContext < "u" && n instanceof WebGLRenderingContext) throw Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
			p = n.getContextAttributes().alpha;
		} else p = a;
		let m = f, h = new Set([
			Gc,
			Wc,
			Hc
		]), g = new Set([
			Cc,
			Oc,
			Ec,
			Nc,
			jc,
			Mc
		]), _ = new Uint32Array(4), v = new Int32Array(4), y = new X(), b = null, x = null, S = [], C = [], w = null;
		this.domElement = t, this.debug = {
			checkShaderErrors: !0,
			onShaderError: null
		}, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = 0, this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
		let T = this, E = !1, D = null, O = null, k = null, A = null;
		this._outputColorSpace = Il;
		let j = 0, M = 0, N = null, P = -1, F = null, I = new Ju(), R = new Ju(), ee = null, te = new Pd(0), ne = 0, z = t.width, B = t.height, V = 1, re = null, ie = null, ae = new Ju(0, 0, z, B), oe = new Ju(0, 0, z, B), se = !1, ce = new dp(), le = !1, ue = !1, de = new $u(), fe = new X(), pe = new Ju(), me = {
			background: null,
			fog: null,
			environment: null,
			overrideMaterial: null,
			isScene: !0
		}, he = !1;
		function ge() {
			return N === null ? V : 1;
		}
		let H = n;
		function _e(e, n) {
			return t.getContext(e, n);
		}
		try {
			let e = {
				alpha: !0,
				depth: r,
				stencil: i,
				antialias: o,
				premultipliedAlpha: s,
				preserveDrawingBuffer: c,
				powerPreference: l,
				failIfMajorPerformanceCaveat: u
			};
			if ("setAttribute" in t && t.setAttribute("data-engine", "three.js r185"), t.addEventListener("webglcontextlost", Ve, !1), t.addEventListener("webglcontextrestored", He, !1), t.addEventListener("webglcontextcreationerror", Ue, !1), H === null) {
				let t = "webgl2";
				if (H = _e(t, e), H === null) throw _e(t) ? Error("THREE.WebGLRenderer: Error creating WebGL context with your selected attributes.") : Error("THREE.WebGLRenderer: Error creating WebGL context.");
			}
		} catch (e) {
			throw J("WebGLRenderer: " + e.message), e;
		}
		let ve, ye, U, be, W, xe, Se, Ce, we, Te, Ee, De, Oe, ke, Ae, je, Me, Ne, Pe, Fe, Ie, Le, Re;
		function ze() {
			ve = new kh(H), ve.init(), Ie = new $_(H, ve), ye = new ah(H, ve, e, Ie), U = new Z_(H, ve), ye.reversedDepthBuffer && d && U.buffers.depth.setReversed(!0), O = H.createFramebuffer(), k = H.createFramebuffer(), A = H.createFramebuffer(), be = new Mh(H), W = new j_(), xe = new Q_(H, ve, U, W, ye, Ie, be), Se = new Oh(T), Ce = new Xm(H), Le = new rh(H, Ce), we = new Ah(H, Ce, be, Le), Te = new Ph(H, we, Ce, Le, be), Ne = new Nh(H, ye, xe), Ae = new oh(W), Ee = new A_(T, Se, ve, ye, Le, Ae), De = new ov(T, W), Oe = new F_(), ke = new H_(ve), Me = new nh(T, Se, U, Te, p, s), je = new X_(T, Te, ye), Re = new sv(H, be, ye, U), Pe = new ih(H, ve, be), Fe = new jh(H, ve, be), be.programs = Ee.programs, T.capabilities = ye, T.extensions = ve, T.properties = W, T.renderLists = Oe, T.shadowMap = je, T.state = U, T.info = be;
		}
		ze(), m !== 1009 && (w = new Ih(m, t.width, t.height, o, r, i));
		let Be = new rv(T, H);
		this.xr = Be, this.getContext = function() {
			return H;
		}, this.getContextAttributes = function() {
			return H.getContextAttributes();
		}, this.forceContextLoss = function() {
			let e = ve.get("WEBGL_lose_context");
			e && e.loseContext();
		}, this.forceContextRestore = function() {
			let e = ve.get("WEBGL_lose_context");
			e && e.restoreContext();
		}, this.getPixelRatio = function() {
			return V;
		}, this.setPixelRatio = function(e) {
			e !== void 0 && (V = e, this.setSize(z, B, !1));
		}, this.getSize = function(e) {
			return e.set(z, B);
		}, this.setSize = function(e, n, r = !0) {
			if (Be.isPresenting) {
				Zl("WebGLRenderer: Can't change size while VR device is presenting.");
				return;
			}
			z = e, B = n, t.width = Math.floor(e * V), t.height = Math.floor(n * V), r === !0 && (t.style.width = e + "px", t.style.height = n + "px"), w !== null && w.setSize(t.width, t.height), this.setViewport(0, 0, e, n);
		}, this.getDrawingBufferSize = function(e) {
			return e.set(z * V, B * V).floor();
		}, this.setDrawingBufferSize = function(e, n, r) {
			z = e, B = n, V = r, t.width = Math.floor(e * r), t.height = Math.floor(n * r), this.setViewport(0, 0, e, n);
		}, this.setEffects = function(e) {
			if (m === 1009) {
				J("WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.");
				return;
			}
			if (e) {
				for (let t = 0; t < e.length; t++) if (e[t].isOutputPass === !0) {
					Zl("WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.");
					break;
				}
			}
			w.setEffects(e || []);
		}, this.getCurrentViewport = function(e) {
			return e.copy(I);
		}, this.getViewport = function(e) {
			return e.copy(ae);
		}, this.setViewport = function(e, t, n, r) {
			e.isVector4 ? ae.set(e.x, e.y, e.z, e.w) : ae.set(e, t, n, r), U.viewport(I.copy(ae).multiplyScalar(V).round());
		}, this.getScissor = function(e) {
			return e.copy(oe);
		}, this.setScissor = function(e, t, n, r) {
			e.isVector4 ? oe.set(e.x, e.y, e.z, e.w) : oe.set(e, t, n, r), U.scissor(R.copy(oe).multiplyScalar(V).round());
		}, this.getScissorTest = function() {
			return se;
		}, this.setScissorTest = function(e) {
			U.setScissorTest(se = e);
		}, this.setOpaqueSort = function(e) {
			re = e;
		}, this.setTransparentSort = function(e) {
			ie = e;
		}, this.getClearColor = function(e) {
			return e.copy(Me.getClearColor());
		}, this.setClearColor = function() {
			Me.setClearColor(...arguments);
		}, this.getClearAlpha = function() {
			return Me.getClearAlpha();
		}, this.setClearAlpha = function() {
			Me.setClearAlpha(...arguments);
		}, this.clear = function(e = !0, t = !0, n = !0) {
			let r = 0;
			if (e) {
				let e = !1;
				if (N !== null) {
					let t = N.texture.format;
					e = h.has(t);
				}
				if (e) {
					let e = N.texture.type, t = g.has(e), n = Me.getClearColor(), r = Me.getClearAlpha(), i = n.r, a = n.g, o = n.b;
					t ? (_[0] = i, _[1] = a, _[2] = o, _[3] = r, H.clearBufferuiv(H.COLOR, 0, _)) : (v[0] = i, v[1] = a, v[2] = o, v[3] = r, H.clearBufferiv(H.COLOR, 0, v));
				} else r |= H.COLOR_BUFFER_BIT;
			}
			t && (r |= H.DEPTH_BUFFER_BIT, this.state.buffers.depth.setMask(!0)), n && (r |= H.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), r !== 0 && H.clear(r);
		}, this.clearColor = function() {
			this.clear(!0, !1, !1);
		}, this.clearDepth = function() {
			this.clear(!1, !0, !1);
		}, this.clearStencil = function() {
			this.clear(!1, !1, !0);
		}, this.setNodesHandler = function(e) {
			e.setRenderer(this), D = e;
		}, this.dispose = function() {
			t.removeEventListener("webglcontextlost", Ve, !1), t.removeEventListener("webglcontextrestored", He, !1), t.removeEventListener("webglcontextcreationerror", Ue, !1), Me.dispose(), Oe.dispose(), ke.dispose(), W.dispose(), Se.dispose(), Te.dispose(), Le.dispose(), Re.dispose(), Ee.dispose(), Be.dispose(), Be.removeEventListener("sessionstart", Xe), Be.removeEventListener("sessionend", Ze), Qe.stop();
		};
		function Ve(e) {
			e.preventDefault(), Yl("WebGLRenderer: Context Lost."), E = !0;
		}
		function He() {
			Yl("WebGLRenderer: Context Restored."), E = !1;
			let e = be.autoReset, t = je.enabled, n = je.autoUpdate, r = je.needsUpdate, i = je.type;
			ze(), be.autoReset = e, je.enabled = t, je.autoUpdate = n, je.needsUpdate = r, je.type = i;
		}
		function Ue(e) {
			J("WebGLRenderer: A WebGL context could not be created. Reason: ", e.statusMessage);
		}
		function We(e) {
			let t = e.target;
			t.removeEventListener("dispose", We), Ge(t);
		}
		function Ge(e) {
			Ke(e), W.remove(e);
		}
		function Ke(e) {
			let t = W.get(e).programs;
			t !== void 0 && (t.forEach(function(e) {
				Ee.releaseProgram(e);
			}), e.isShaderMaterial && Ee.releaseShaderCache(e));
		}
		this.renderBufferDirect = function(e, t, n, r, i, a) {
			t === null && (t = me);
			let o = i.isMesh && i.matrixWorld.determinantAffine() < 0, s = st(e, t, n, r, i);
			U.setMaterial(r, o);
			let c = n.index, l = 1;
			if (r.wireframe === !0) {
				if (c = we.getWireframeAttribute(n), c === void 0) return;
				l = 2;
			}
			let u = n.drawRange, d = n.attributes.position, f = u.start * l, p = (u.start + u.count) * l;
			a !== null && (f = Math.max(f, a.start * l), p = Math.min(p, (a.start + a.count) * l)), c === null ? d != null && (f = Math.max(f, 0), p = Math.min(p, d.count)) : (f = Math.max(f, 0), p = Math.min(p, c.count));
			let m = p - f;
			if (m < 0 || m === Infinity) return;
			Le.setup(i, r, s, n, c);
			let h, g = Pe;
			if (c !== null && (h = Ce.get(c), g = Fe, g.setIndex(h)), i.isMesh) r.wireframe === !0 ? (U.setLineWidth(r.wireframeLinewidth * ge()), g.setMode(H.LINES)) : g.setMode(H.TRIANGLES);
			else if (i.isLine) {
				let e = r.linewidth;
				e === void 0 && (e = 1), U.setLineWidth(e * ge()), i.isLineSegments ? g.setMode(H.LINES) : i.isLineLoop ? g.setMode(H.LINE_LOOP) : g.setMode(H.LINE_STRIP);
			} else i.isPoints ? g.setMode(H.POINTS) : i.isSprite && g.setMode(H.TRIANGLES);
			if (i.isBatchedMesh) if (ve.get("WEBGL_multi_draw")) g.renderMultiDraw(i._multiDrawStarts, i._multiDrawCounts, i._multiDrawCount);
			else {
				let e = i._multiDrawStarts, t = i._multiDrawCounts, n = i._multiDrawCount, a = c ? Ce.get(c).bytesPerElement : 1, o = W.get(r).currentProgram.getUniforms();
				for (let r = 0; r < n; r++) o.setValue(H, "_gl_DrawID", r), g.render(e[r] / a, t[r]);
			}
			else if (i.isInstancedMesh) g.renderInstances(f, m, i.count);
			else if (n.isInstancedBufferGeometry) {
				let e = n._maxInstanceCount === void 0 ? Infinity : n._maxInstanceCount, t = Math.min(n.instanceCount, e);
				g.renderInstances(f, m, t);
			} else g.render(f, m);
		};
		function qe(e, t, n) {
			e.transparent === !0 && e.side === 2 && e.forceSinglePass === !1 ? (e.side = 1, e.needsUpdate = !0, it(e, t, n), e.side = 0, e.needsUpdate = !0, it(e, t, n), e.side = 2) : it(e, t, n);
		}
		this.compile = function(e, t, n = null) {
			n === null && (n = e), x = ke.get(n), x.init(t), C.push(x), n.traverseVisible(function(e) {
				e.isLight && e.layers.test(t.layers) && (x.pushLight(e), e.castShadow && x.pushShadow(e));
			}), e !== n && e.traverseVisible(function(e) {
				e.isLight && e.layers.test(t.layers) && (x.pushLight(e), e.castShadow && x.pushShadow(e));
			}), x.setupLights();
			let r = /* @__PURE__ */ new Set();
			return e.traverse(function(e) {
				if (!(e.isMesh || e.isPoints || e.isLine || e.isSprite)) return;
				let t = e.material;
				if (t) if (Array.isArray(t)) for (let i = 0; i < t.length; i++) {
					let a = t[i];
					qe(a, n, e), r.add(a);
				}
				else qe(t, n, e), r.add(t);
			}), x = C.pop(), r;
		}, this.compileAsync = function(e, t, n = null) {
			let r = this.compile(e, t, n);
			return new Promise((t) => {
				function n() {
					if (r.forEach(function(e) {
						W.get(e).currentProgram.isReady() && r.delete(e);
					}), r.size === 0) {
						t(e);
						return;
					}
					setTimeout(n, 10);
				}
				ve.get("KHR_parallel_shader_compile") === null ? setTimeout(n, 10) : n();
			});
		};
		let Je = null;
		function Ye(e) {
			Je && Je(e);
		}
		function Xe() {
			Qe.stop();
		}
		function Ze() {
			Qe.start();
		}
		let Qe = new Ym();
		Qe.setAnimationLoop(Ye), typeof self < "u" && Qe.setContext(self), this.setAnimationLoop = function(e) {
			Je = e, Be.setAnimationLoop(e), e === null ? Qe.stop() : Qe.start();
		}, Be.addEventListener("sessionstart", Xe), Be.addEventListener("sessionend", Ze), this.render = function(e, t) {
			if (t !== void 0 && t.isCamera !== !0) {
				J("WebGLRenderer.render: camera is not an instance of THREE.Camera.");
				return;
			}
			if (E === !0) return;
			D !== null && D.renderStart(e, t);
			let n = Be.enabled === !0 && Be.isPresenting === !0, r = w !== null && (N === null || n) && w.begin(T, N);
			if (e.matrixWorldAutoUpdate === !0 && e.updateMatrixWorld(), t.parent === null && t.matrixWorldAutoUpdate === !0 && t.updateMatrixWorld(), Be.enabled === !0 && Be.isPresenting === !0 && (w === null || w.isCompositing() === !1) && (Be.cameraAutoUpdate === !0 && Be.updateCamera(t), t = Be.getCamera()), e.isScene === !0 && e.onBeforeRender(T, e, t, N), x = ke.get(e, C.length), x.init(t), x.state.textureUnits = xe.getTextureUnits(), C.push(x), de.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), ce.setFromProjectionMatrix(de, Hl, t.reversedDepth), ue = this.localClippingEnabled, le = Ae.init(this.clippingPlanes, ue), b = Oe.get(e, S.length), b.init(), S.push(b), Be.enabled === !0 && Be.isPresenting === !0) {
				let e = T.xr.getDepthSensingMesh();
				e !== null && $e(e, t, -Infinity, T.sortObjects);
			}
			$e(e, t, 0, T.sortObjects), b.finish(), T.sortObjects === !0 && b.sort(re, ie, t.reversedDepth), he = Be.enabled === !1 || Be.isPresenting === !1 || Be.hasDepthSensing() === !1, he && Me.addToRenderList(b, e), this.info.render.frame++, this.info.autoReset === !0 && this.info.reset(), le === !0 && Ae.beginShadows();
			let i = x.state.shadowsArray;
			if (je.render(i, e, t), le === !0 && Ae.endShadows(), (r && w.hasRenderPass()) === !1) {
				let n = b.opaque, r = b.transmissive;
				if (x.setupLights(), t.isArrayCamera) {
					let i = t.cameras;
					if (r.length > 0) for (let t = 0, a = i.length; t < a; t++) {
						let a = i[t];
						tt(n, r, e, a);
					}
					he && Me.render(e);
					for (let t = 0, n = i.length; t < n; t++) {
						let n = i[t];
						et(b, e, n, n.viewport);
					}
				} else r.length > 0 && tt(n, r, e, t), he && Me.render(e), et(b, e, t);
			}
			N !== null && M === 0 && (xe.updateMultisampleRenderTarget(N), xe.updateRenderTargetMipmap(N)), r && w.end(T), e.isScene === !0 && e.onAfterRender(T, e, t), Le.resetDefaultState(), P = -1, F = null, C.pop(), C.length > 0 ? (x = C[C.length - 1], xe.setTextureUnits(x.state.textureUnits), le === !0 && Ae.setGlobalState(T.clippingPlanes, x.state.camera)) : x = null, S.pop(), b = S.length > 0 ? S[S.length - 1] : null, D !== null && D.renderEnd();
		};
		function $e(e, t, n, r) {
			if (e.visible === !1) return;
			if (e.layers.test(t.layers)) {
				if (e.isGroup) n = e.renderOrder;
				else if (e.isLOD) e.autoUpdate === !0 && e.update(t);
				else if (e.isLightProbeGrid) x.pushLightProbeGrid(e);
				else if (e.isLight) x.pushLight(e), e.castShadow && x.pushShadow(e);
				else if (e.isSprite) {
					if (!e.frustumCulled || ce.intersectsSprite(e)) {
						r && pe.setFromMatrixPosition(e.matrixWorld).applyMatrix4(de);
						let t = Te.update(e), i = e.material;
						i.visible && b.push(e, t, i, n, pe.z, null);
					}
				} else if ((e.isMesh || e.isLine || e.isPoints) && (!e.frustumCulled || ce.intersectsObject(e))) {
					let t = Te.update(e), i = e.material;
					if (r && (e.boundingSphere === void 0 ? (t.boundingSphere === null && t.computeBoundingSphere(), pe.copy(t.boundingSphere.center)) : (e.boundingSphere === null && e.computeBoundingSphere(), pe.copy(e.boundingSphere.center)), pe.applyMatrix4(e.matrixWorld).applyMatrix4(de)), Array.isArray(i)) {
						let r = t.groups;
						for (let a = 0, o = r.length; a < o; a++) {
							let o = r[a], s = i[o.materialIndex];
							s && s.visible && b.push(e, t, s, n, pe.z, o);
						}
					} else i.visible && b.push(e, t, i, n, pe.z, null);
				}
			}
			let i = e.children;
			for (let e = 0, a = i.length; e < a; e++) $e(i[e], t, n, r);
		}
		function et(e, t, n, r) {
			let { opaque: i, transmissive: a, transparent: o } = e;
			x.setupLightsView(n), le === !0 && Ae.setGlobalState(T.clippingPlanes, n), r && U.viewport(I.copy(r)), i.length > 0 && nt(i, t, n), a.length > 0 && nt(a, t, n), o.length > 0 && nt(o, t, n), U.buffers.depth.setTest(!0), U.buffers.depth.setMask(!0), U.buffers.color.setMask(!0), U.setPolygonOffset(!1);
		}
		function tt(e, t, n, r) {
			if ((n.isScene === !0 ? n.overrideMaterial : null) !== null) return;
			if (x.state.transmissionRenderTarget[r.id] === void 0) {
				let e = ve.has("EXT_color_buffer_half_float") || ve.has("EXT_color_buffer_float");
				x.state.transmissionRenderTarget[r.id] = new Xu(1, 1, {
					generateMipmaps: !0,
					type: e ? Ac : Cc,
					minFilter: Sc,
					samples: Math.max(4, ye.samples),
					stencilBuffer: i,
					resolveDepthBuffer: !1,
					resolveStencilBuffer: !1,
					colorSpace: Lu.workingColorSpace
				});
			}
			let a = x.state.transmissionRenderTarget[r.id], o = r.viewport || I;
			a.setSize(o.z * T.transmissionResolutionScale, o.w * T.transmissionResolutionScale);
			let s = T.getRenderTarget(), c = T.getActiveCubeFace(), l = T.getActiveMipmapLevel();
			T.setRenderTarget(a), T.getClearColor(te), ne = T.getClearAlpha(), ne < 1 && T.setClearColor(16777215, .5), T.clear(), he && Me.render(n);
			let u = T.toneMapping;
			T.toneMapping = 0;
			let d = r.viewport;
			if (r.viewport !== void 0 && (r.viewport = void 0), x.setupLightsView(r), le === !0 && Ae.setGlobalState(T.clippingPlanes, r), nt(e, n, r), xe.updateMultisampleRenderTarget(a), xe.updateRenderTargetMipmap(a), ve.has("WEBGL_multisampled_render_to_texture") === !1) {
				let e = !1;
				for (let i = 0, a = t.length; i < a; i++) {
					let { object: a, geometry: o, material: s, group: c } = t[i];
					if (s.side === 2 && a.layers.test(r.layers)) {
						let t = s.side;
						s.side = 1, s.needsUpdate = !0, rt(a, n, r, o, s, c), s.side = t, s.needsUpdate = !0, e = !0;
					}
				}
				e === !0 && (xe.updateMultisampleRenderTarget(a), xe.updateRenderTargetMipmap(a));
			}
			T.setRenderTarget(s, c, l), T.setClearColor(te, ne), d !== void 0 && (r.viewport = d), T.toneMapping = u;
		}
		function nt(e, t, n) {
			let r = t.isScene === !0 ? t.overrideMaterial : null;
			for (let i = 0, a = e.length; i < a; i++) {
				let a = e[i], { object: o, geometry: s, group: c } = a, l = a.material;
				l.allowOverride === !0 && r !== null && (l = r), o.layers.test(n.layers) && rt(o, t, n, s, l, c);
			}
		}
		function rt(e, t, n, r, i, a) {
			e.onBeforeRender(T, t, n, r, i, a), e.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, e.matrixWorld), e.normalMatrix.getNormalMatrix(e.modelViewMatrix), i.onBeforeRender(T, t, n, r, e, a), i.transparent === !0 && i.side === 2 && i.forceSinglePass === !1 ? (i.side = 1, i.needsUpdate = !0, T.renderBufferDirect(n, t, r, i, e, a), i.side = 0, i.needsUpdate = !0, T.renderBufferDirect(n, t, r, i, e, a), i.side = 2) : T.renderBufferDirect(n, t, r, i, e, a), e.onAfterRender(T, t, n, r, i, a);
		}
		function it(e, t, n) {
			t.isScene !== !0 && (t = me);
			let r = W.get(e), i = x.state.lights, a = x.state.shadowsArray, o = i.state.version, s = Ee.getParameters(e, i.state, a, t, n, x.state.lightProbeGridArray), c = Ee.getProgramCacheKey(s), l = r.programs;
			r.environment = e.isMeshStandardMaterial || e.isMeshLambertMaterial || e.isMeshPhongMaterial ? t.environment : null, r.fog = t.fog;
			let u = e.isMeshStandardMaterial || e.isMeshLambertMaterial && !e.envMap || e.isMeshPhongMaterial && !e.envMap;
			r.envMap = Se.get(e.envMap || r.environment, u), r.envMapRotation = r.environment !== null && e.envMap === null ? t.environmentRotation : e.envMapRotation, l === void 0 && (e.addEventListener("dispose", We), l = /* @__PURE__ */ new Map(), r.programs = l);
			let d = l.get(c);
			if (d !== void 0) {
				if (r.currentProgram === d && r.lightsStateVersion === o) return ot(e, s), d;
			} else s.uniforms = Ee.getUniforms(e), D !== null && e.isNodeMaterial && D.build(e, n, s), e.onBeforeCompile(s, T), d = Ee.acquireProgram(s, c), l.set(c, d), r.uniforms = s.uniforms;
			let f = r.uniforms;
			return (!e.isShaderMaterial && !e.isRawShaderMaterial || e.clipping === !0) && (f.clippingPlanes = Ae.uniform), ot(e, s), r.needsLights = lt(e), r.lightsStateVersion = o, r.needsLights && (f.ambientLightColor.value = i.state.ambient, f.lightProbe.value = i.state.probe, f.directionalLights.value = i.state.directional, f.directionalLightShadows.value = i.state.directionalShadow, f.spotLights.value = i.state.spot, f.spotLightShadows.value = i.state.spotShadow, f.rectAreaLights.value = i.state.rectArea, f.ltc_1.value = i.state.rectAreaLTC1, f.ltc_2.value = i.state.rectAreaLTC2, f.pointLights.value = i.state.point, f.pointLightShadows.value = i.state.pointShadow, f.hemisphereLights.value = i.state.hemi, f.directionalShadowMatrix.value = i.state.directionalShadowMatrix, f.spotLightMatrix.value = i.state.spotLightMatrix, f.spotLightMap.value = i.state.spotLightMap, f.pointShadowMatrix.value = i.state.pointShadowMatrix), r.lightProbeGrid = x.state.lightProbeGridArray.length > 0, r.currentProgram = d, r.uniformsList = null, d;
		}
		function at(e) {
			if (e.uniformsList === null) {
				let t = e.currentProgram.getUniforms();
				e.uniformsList = Ug.seqWithValue(t.seq, e.uniforms);
			}
			return e.uniformsList;
		}
		function ot(e, t) {
			let n = W.get(e);
			n.outputColorSpace = t.outputColorSpace, n.batching = t.batching, n.batchingColor = t.batchingColor, n.instancing = t.instancing, n.instancingColor = t.instancingColor, n.instancingMorph = t.instancingMorph, n.skinning = t.skinning, n.morphTargets = t.morphTargets, n.morphNormals = t.morphNormals, n.morphColors = t.morphColors, n.morphTargetsCount = t.morphTargetsCount, n.numClippingPlanes = t.numClippingPlanes, n.numIntersection = t.numClipIntersection, n.vertexAlphas = t.vertexAlphas, n.vertexTangents = t.vertexTangents, n.toneMapping = t.toneMapping;
		}
		function G(e, t) {
			if (e.length === 0) return null;
			if (e.length === 1) return e[0].texture === null ? null : e[0];
			y.setFromMatrixPosition(t.matrixWorld);
			for (let t = 0, n = e.length; t < n; t++) {
				let n = e[t];
				if (n.texture !== null && n.boundingBox.containsPoint(y)) return n;
			}
			return null;
		}
		function st(e, t, n, r, i) {
			t.isScene !== !0 && (t = me), xe.resetTextureUnits();
			let a = t.fog, o = r.isMeshStandardMaterial || r.isMeshLambertMaterial || r.isMeshPhongMaterial ? t.environment : null, s = N === null ? T.outputColorSpace : N.isXRRenderTarget === !0 ? N.texture.colorSpace : Lu.workingColorSpace, c = r.isMeshStandardMaterial || r.isMeshLambertMaterial && !r.envMap || r.isMeshPhongMaterial && !r.envMap, l = Se.get(r.envMap || o, c), u = r.vertexColors === !0 && !!n.attributes.color && n.attributes.color.itemSize === 4, d = !!n.attributes.tangent && (!!r.normalMap || r.anisotropy > 0), f = !!n.morphAttributes.position, p = !!n.morphAttributes.normal, m = !!n.morphAttributes.color, h = 0;
			r.toneMapped && (N === null || N.isXRRenderTarget === !0) && (h = T.toneMapping);
			let g = n.morphAttributes.position || n.morphAttributes.normal || n.morphAttributes.color, _ = g === void 0 ? 0 : g.length, v = W.get(r), y = x.state.lights;
			if (le === !0 && (ue === !0 || e !== F)) {
				let t = e === F && r.id === P;
				Ae.setState(r, e, t);
			}
			let b = !1;
			r.version === v.__version ? v.needsLights && v.lightsStateVersion !== y.state.version ? b = !0 : v.outputColorSpace === s ? i.isBatchedMesh && v.batching === !1 || !i.isBatchedMesh && v.batching === !0 || i.isBatchedMesh && v.batchingColor === !0 && i.colorTexture === null || i.isBatchedMesh && v.batchingColor === !1 && i.colorTexture !== null || i.isInstancedMesh && v.instancing === !1 || !i.isInstancedMesh && v.instancing === !0 || i.isSkinnedMesh && v.skinning === !1 || !i.isSkinnedMesh && v.skinning === !0 || i.isInstancedMesh && v.instancingColor === !0 && i.instanceColor === null || i.isInstancedMesh && v.instancingColor === !1 && i.instanceColor !== null || i.isInstancedMesh && v.instancingMorph === !0 && i.morphTexture === null || i.isInstancedMesh && v.instancingMorph === !1 && i.morphTexture !== null ? b = !0 : v.envMap === l ? r.fog === !0 && v.fog !== a || v.numClippingPlanes !== void 0 && (v.numClippingPlanes !== Ae.numPlanes || v.numIntersection !== Ae.numIntersection) ? b = !0 : v.vertexAlphas === u && v.vertexTangents === d && v.morphTargets === f && v.morphNormals === p && v.morphColors === m && v.toneMapping === h && v.morphTargetsCount === _ ? !!v.lightProbeGrid != x.state.lightProbeGridArray.length > 0 && (b = !0) : b = !0 : b = !0 : b = !0 : (b = !0, v.__version = r.version);
			let S = v.currentProgram;
			b === !0 && (S = it(r, t, i), D && r.isNodeMaterial && D.onUpdateProgram(r, S, v));
			let C = !1, w = !1, E = !1, O = S.getUniforms(), k = v.uniforms;
			if (U.useProgram(S.program) && (C = !0, w = !0, E = !0), r.id !== P && (P = r.id, w = !0), v.needsLights) {
				let e = G(x.state.lightProbeGridArray, i);
				v.lightProbeGrid !== e && (v.lightProbeGrid = e, w = !0);
			}
			if (C || F !== e) {
				U.buffers.depth.getReversed() && e.reversedDepth !== !0 && (e._reversedDepth = !0, e.updateProjectionMatrix()), O.setValue(H, "projectionMatrix", e.projectionMatrix), O.setValue(H, "viewMatrix", e.matrixWorldInverse);
				let t = O.map.cameraPosition;
				t !== void 0 && t.setValue(H, fe.setFromMatrixPosition(e.matrixWorld)), ye.logarithmicDepthBuffer && O.setValue(H, "logDepthBufFC", 2 / (Math.log(e.far + 1) / Math.LN2)), (r.isMeshPhongMaterial || r.isMeshToonMaterial || r.isMeshLambertMaterial || r.isMeshBasicMaterial || r.isMeshStandardMaterial || r.isShaderMaterial) && O.setValue(H, "isOrthographic", e.isOrthographicCamera === !0), F !== e && (F = e, w = !0, E = !0);
			}
			if (v.needsLights && (y.state.directionalShadowMap.length > 0 && O.setValue(H, "directionalShadowMap", y.state.directionalShadowMap, xe), y.state.spotShadowMap.length > 0 && O.setValue(H, "spotShadowMap", y.state.spotShadowMap, xe), y.state.pointShadowMap.length > 0 && O.setValue(H, "pointShadowMap", y.state.pointShadowMap, xe)), i.isSkinnedMesh) {
				O.setOptional(H, i, "bindMatrix"), O.setOptional(H, i, "bindMatrixInverse");
				let e = i.skeleton;
				e && (e.boneTexture === null && e.computeBoneTexture(), O.setValue(H, "boneTexture", e.boneTexture, xe));
			}
			i.isBatchedMesh && (O.setOptional(H, i, "batchingTexture"), O.setValue(H, "batchingTexture", i._matricesTexture, xe), O.setOptional(H, i, "batchingIdTexture"), O.setValue(H, "batchingIdTexture", i._indirectTexture, xe), O.setOptional(H, i, "batchingColorTexture"), i._colorsTexture !== null && O.setValue(H, "batchingColorTexture", i._colorsTexture, xe));
			let A = n.morphAttributes;
			if ((A.position !== void 0 || A.normal !== void 0 || A.color !== void 0) && Ne.update(i, n, S), (w || v.receiveShadow !== i.receiveShadow) && (v.receiveShadow = i.receiveShadow, O.setValue(H, "receiveShadow", i.receiveShadow)), (r.isMeshStandardMaterial || r.isMeshLambertMaterial || r.isMeshPhongMaterial) && r.envMap === null && t.environment !== null && (k.envMapIntensity.value = t.environmentIntensity), k.dfgLUT !== void 0 && (k.dfgLUT.value = uv()), w) {
				if (O.setValue(H, "toneMappingExposure", T.toneMappingExposure), v.needsLights && ct(k, E), a && r.fog === !0 && De.refreshFogUniforms(k, a), De.refreshMaterialUniforms(k, r, V, B, x.state.transmissionRenderTarget[e.id]), v.needsLights && v.lightProbeGrid) {
					let e = v.lightProbeGrid;
					k.probesSH.value = e.texture, k.probesMin.value.copy(e.boundingBox.min), k.probesMax.value.copy(e.boundingBox.max), k.probesResolution.value.copy(e.resolution);
				}
				Ug.upload(H, at(v), k, xe);
			}
			if (r.isShaderMaterial && r.uniformsNeedUpdate === !0 && (Ug.upload(H, at(v), k, xe), r.uniformsNeedUpdate = !1), r.isSpriteMaterial && O.setValue(H, "center", i.center), O.setValue(H, "modelViewMatrix", i.modelViewMatrix), O.setValue(H, "normalMatrix", i.normalMatrix), O.setValue(H, "modelMatrix", i.matrixWorld), r.uniformsGroups !== void 0) {
				let e = r.uniformsGroups;
				for (let t = 0, n = e.length; t < n; t++) {
					let n = e[t];
					Re.update(n, S), Re.bind(n, S);
				}
			}
			return S;
		}
		function ct(e, t) {
			e.ambientLightColor.needsUpdate = t, e.lightProbe.needsUpdate = t, e.directionalLights.needsUpdate = t, e.directionalLightShadows.needsUpdate = t, e.pointLights.needsUpdate = t, e.pointLightShadows.needsUpdate = t, e.spotLights.needsUpdate = t, e.spotLightShadows.needsUpdate = t, e.rectAreaLights.needsUpdate = t, e.hemisphereLights.needsUpdate = t;
		}
		function lt(e) {
			return e.isMeshLambertMaterial || e.isMeshToonMaterial || e.isMeshPhongMaterial || e.isMeshStandardMaterial || e.isShadowMaterial || e.isShaderMaterial && e.lights === !0;
		}
		this.getActiveCubeFace = function() {
			return j;
		}, this.getActiveMipmapLevel = function() {
			return M;
		}, this.getRenderTarget = function() {
			return N;
		}, this.setRenderTargetTextures = function(e, t, n) {
			let r = W.get(e);
			r.__autoAllocateDepthBuffer = e.resolveDepthBuffer === !1, r.__autoAllocateDepthBuffer === !1 && (r.__useRenderToTexture = !1), W.get(e.texture).__webglTexture = t, W.get(e.depthTexture).__webglTexture = r.__autoAllocateDepthBuffer ? void 0 : n, r.__hasExternalTextures = !0;
		}, this.setRenderTargetFramebuffer = function(e, t) {
			let n = W.get(e);
			n.__webglFramebuffer = t, n.__useDefaultFramebuffer = t === void 0;
		}, this.setRenderTarget = function(e, t = 0, n = 0) {
			N = e, j = t, M = n;
			let r = null, i = !1, a = !1;
			if (e) {
				let o = W.get(e);
				if (o.__useDefaultFramebuffer !== void 0) {
					U.bindFramebuffer(H.FRAMEBUFFER, o.__webglFramebuffer), I.copy(e.viewport), R.copy(e.scissor), ee = e.scissorTest, U.viewport(I), U.scissor(R), U.setScissorTest(ee), P = -1;
					return;
				} else if (o.__webglFramebuffer === void 0) xe.setupRenderTarget(e);
				else if (o.__hasExternalTextures) xe.rebindTextures(e, W.get(e.texture).__webglTexture, W.get(e.depthTexture).__webglTexture);
				else if (e.depthBuffer) {
					let t = e.depthTexture;
					if (o.__boundDepthTexture !== t) {
						if (t !== null && W.has(t) && (e.width !== t.image.width || e.height !== t.image.height)) throw Error("THREE.WebGLRenderer: Attached DepthTexture is initialized to the incorrect size.");
						xe.setupDepthRenderbuffer(e);
					}
				}
				let s = e.texture;
				(s.isData3DTexture || s.isDataArrayTexture || s.isCompressedArrayTexture) && (a = !0);
				let c = W.get(e).__webglFramebuffer;
				e.isWebGLCubeRenderTarget ? (r = Array.isArray(c[t]) ? c[t][n] : c[t], i = !0) : r = e.samples > 0 && xe.useMultisampledRTT(e) === !1 ? W.get(e).__webglMultisampledFramebuffer : Array.isArray(c) ? c[n] : c, I.copy(e.viewport), R.copy(e.scissor), ee = e.scissorTest;
			} else I.copy(ae).multiplyScalar(V).floor(), R.copy(oe).multiplyScalar(V).floor(), ee = se;
			if (n !== 0 && (r = O), U.bindFramebuffer(H.FRAMEBUFFER, r) && U.drawBuffers(e, r), U.viewport(I), U.scissor(R), U.setScissorTest(ee), i) {
				let r = W.get(e.texture);
				H.framebufferTexture2D(H.FRAMEBUFFER, H.COLOR_ATTACHMENT0, H.TEXTURE_CUBE_MAP_POSITIVE_X + t, r.__webglTexture, n);
			} else if (a) {
				let r = t;
				for (let t = 0; t < e.textures.length; t++) {
					let i = W.get(e.textures[t]);
					H.framebufferTextureLayer(H.FRAMEBUFFER, H.COLOR_ATTACHMENT0 + t, i.__webglTexture, n, r);
				}
			} else if (e !== null && n !== 0) {
				let t = W.get(e.texture);
				H.framebufferTexture2D(H.FRAMEBUFFER, H.COLOR_ATTACHMENT0, H.TEXTURE_2D, t.__webglTexture, n);
			}
			P = -1;
		}, this.readRenderTargetPixels = function(e, t, n, r, i, a, o, s = 0) {
			if (!(e && e.isWebGLRenderTarget)) {
				J("WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
				return;
			}
			let c = W.get(e).__webglFramebuffer;
			if (e.isWebGLCubeRenderTarget && o !== void 0 && (c = c[o]), c) {
				U.bindFramebuffer(H.FRAMEBUFFER, c);
				try {
					let o = e.textures[s], c = o.format, l = o.type;
					if (e.textures.length > 1 && H.readBuffer(H.COLOR_ATTACHMENT0 + s), !ye.textureFormatReadable(c)) {
						J("WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
						return;
					}
					if (!ye.textureTypeReadable(l)) {
						J("WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
						return;
					}
					t >= 0 && t <= e.width - r && n >= 0 && n <= e.height - i && H.readPixels(t, n, r, i, Ie.convert(c), Ie.convert(l), a);
				} finally {
					let e = N === null ? null : W.get(N).__webglFramebuffer;
					U.bindFramebuffer(H.FRAMEBUFFER, e);
				}
			}
		}, this.readRenderTargetPixelsAsync = async function(e, t, n, r, i, a, o, s = 0) {
			if (!(e && e.isWebGLRenderTarget)) throw Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
			let c = W.get(e).__webglFramebuffer;
			if (e.isWebGLCubeRenderTarget && o !== void 0 && (c = c[o]), c) if (t >= 0 && t <= e.width - r && n >= 0 && n <= e.height - i) {
				U.bindFramebuffer(H.FRAMEBUFFER, c);
				let o = e.textures[s], l = o.format, u = o.type;
				if (e.textures.length > 1 && H.readBuffer(H.COLOR_ATTACHMENT0 + s), !ye.textureFormatReadable(l)) throw Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
				if (!ye.textureTypeReadable(u)) throw Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
				let d = H.createBuffer();
				H.bindBuffer(H.PIXEL_PACK_BUFFER, d), H.bufferData(H.PIXEL_PACK_BUFFER, a.byteLength, H.STREAM_READ), H.readPixels(t, n, r, i, Ie.convert(l), Ie.convert(u), 0);
				let f = N === null ? null : W.get(N).__webglFramebuffer;
				U.bindFramebuffer(H.FRAMEBUFFER, f);
				let p = H.fenceSync(H.SYNC_GPU_COMMANDS_COMPLETE, 0);
				return H.flush(), await $l(H, p, 4), H.bindBuffer(H.PIXEL_PACK_BUFFER, d), H.getBufferSubData(H.PIXEL_PACK_BUFFER, 0, a), H.deleteBuffer(d), H.deleteSync(p), a;
			} else throw Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
		}, this.copyFramebufferToTexture = function(e, t = null, n = 0) {
			let r = 2 ** -n, i = Math.floor(e.image.width * r), a = Math.floor(e.image.height * r), o = t === null ? 0 : t.x, s = t === null ? 0 : t.y;
			xe.setTexture2D(e, 0), H.copyTexSubImage2D(H.TEXTURE_2D, n, 0, 0, o, s, i, a), U.unbindTexture();
		}, this.copyTextureToTexture = function(e, t, n = null, r = null, i = 0, a = 0) {
			let o, s, c, l, u, d, f, p, m, h = e.isCompressedTexture ? e.mipmaps[a] : e.image;
			if (n !== null) o = n.max.x - n.min.x, s = n.max.y - n.min.y, c = n.isBox3 ? n.max.z - n.min.z : 1, l = n.min.x, u = n.min.y, d = n.isBox3 ? n.min.z : 0;
			else {
				let t = 2 ** -i;
				o = Math.floor(h.width * t), s = Math.floor(h.height * t), c = e.isDataArrayTexture ? h.depth : e.isData3DTexture ? Math.floor(h.depth * t) : 1, l = 0, u = 0, d = 0;
			}
			r === null ? (f = 0, p = 0, m = 0) : (f = r.x, p = r.y, m = r.z);
			let g = Ie.convert(t.format), _ = Ie.convert(t.type), v;
			t.isData3DTexture ? (xe.setTexture3D(t, 0), v = H.TEXTURE_3D) : t.isDataArrayTexture || t.isCompressedArrayTexture ? (xe.setTexture2DArray(t, 0), v = H.TEXTURE_2D_ARRAY) : (xe.setTexture2D(t, 0), v = H.TEXTURE_2D), U.activeTexture(H.TEXTURE0), U.pixelStorei(H.UNPACK_FLIP_Y_WEBGL, t.flipY), U.pixelStorei(H.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha), U.pixelStorei(H.UNPACK_ALIGNMENT, t.unpackAlignment);
			let y = U.getParameter(H.UNPACK_ROW_LENGTH), b = U.getParameter(H.UNPACK_IMAGE_HEIGHT), x = U.getParameter(H.UNPACK_SKIP_PIXELS), S = U.getParameter(H.UNPACK_SKIP_ROWS), C = U.getParameter(H.UNPACK_SKIP_IMAGES);
			U.pixelStorei(H.UNPACK_ROW_LENGTH, h.width), U.pixelStorei(H.UNPACK_IMAGE_HEIGHT, h.height), U.pixelStorei(H.UNPACK_SKIP_PIXELS, l), U.pixelStorei(H.UNPACK_SKIP_ROWS, u), U.pixelStorei(H.UNPACK_SKIP_IMAGES, d);
			let w = e.isDataArrayTexture || e.isData3DTexture, T = t.isDataArrayTexture || t.isData3DTexture;
			if (e.isDepthTexture) {
				let n = W.get(e), r = W.get(t), h = W.get(n.__renderTarget), g = W.get(r.__renderTarget);
				U.bindFramebuffer(H.READ_FRAMEBUFFER, h.__webglFramebuffer), U.bindFramebuffer(H.DRAW_FRAMEBUFFER, g.__webglFramebuffer);
				for (let n = 0; n < c; n++) w && (H.framebufferTextureLayer(H.READ_FRAMEBUFFER, H.COLOR_ATTACHMENT0, W.get(e).__webglTexture, i, d + n), H.framebufferTextureLayer(H.DRAW_FRAMEBUFFER, H.COLOR_ATTACHMENT0, W.get(t).__webglTexture, a, m + n)), H.blitFramebuffer(l, u, o, s, f, p, o, s, H.DEPTH_BUFFER_BIT, H.NEAREST);
				U.bindFramebuffer(H.READ_FRAMEBUFFER, null), U.bindFramebuffer(H.DRAW_FRAMEBUFFER, null);
			} else if (i !== 0 || e.isRenderTargetTexture || W.has(e)) {
				let n = W.get(e), r = W.get(t);
				U.bindFramebuffer(H.READ_FRAMEBUFFER, k), U.bindFramebuffer(H.DRAW_FRAMEBUFFER, A);
				for (let e = 0; e < c; e++) w ? H.framebufferTextureLayer(H.READ_FRAMEBUFFER, H.COLOR_ATTACHMENT0, n.__webglTexture, i, d + e) : H.framebufferTexture2D(H.READ_FRAMEBUFFER, H.COLOR_ATTACHMENT0, H.TEXTURE_2D, n.__webglTexture, i), T ? H.framebufferTextureLayer(H.DRAW_FRAMEBUFFER, H.COLOR_ATTACHMENT0, r.__webglTexture, a, m + e) : H.framebufferTexture2D(H.DRAW_FRAMEBUFFER, H.COLOR_ATTACHMENT0, H.TEXTURE_2D, r.__webglTexture, a), i === 0 ? T ? H.copyTexSubImage3D(v, a, f, p, m + e, l, u, o, s) : H.copyTexSubImage2D(v, a, f, p, l, u, o, s) : H.blitFramebuffer(l, u, o, s, f, p, o, s, H.COLOR_BUFFER_BIT, H.NEAREST);
				U.bindFramebuffer(H.READ_FRAMEBUFFER, null), U.bindFramebuffer(H.DRAW_FRAMEBUFFER, null);
			} else T ? e.isDataTexture || e.isData3DTexture ? H.texSubImage3D(v, a, f, p, m, o, s, c, g, _, h.data) : t.isCompressedArrayTexture ? H.compressedTexSubImage3D(v, a, f, p, m, o, s, c, g, h.data) : H.texSubImage3D(v, a, f, p, m, o, s, c, g, _, h) : e.isDataTexture ? H.texSubImage2D(H.TEXTURE_2D, a, f, p, o, s, g, _, h.data) : e.isCompressedTexture ? H.compressedTexSubImage2D(H.TEXTURE_2D, a, f, p, h.width, h.height, g, h.data) : H.texSubImage2D(H.TEXTURE_2D, a, f, p, o, s, g, _, h);
			U.pixelStorei(H.UNPACK_ROW_LENGTH, y), U.pixelStorei(H.UNPACK_IMAGE_HEIGHT, b), U.pixelStorei(H.UNPACK_SKIP_PIXELS, x), U.pixelStorei(H.UNPACK_SKIP_ROWS, S), U.pixelStorei(H.UNPACK_SKIP_IMAGES, C), a === 0 && t.generateMipmaps && H.generateMipmap(v), U.unbindTexture();
		}, this.initRenderTarget = function(e) {
			W.get(e).__webglFramebuffer === void 0 && xe.setupRenderTarget(e);
		}, this.initTexture = function(e) {
			e.isCubeTexture ? xe.setTextureCube(e, 0) : e.isData3DTexture ? xe.setTexture3D(e, 0) : e.isDataArrayTexture || e.isCompressedArrayTexture ? xe.setTexture2DArray(e, 0) : xe.setTexture2D(e, 0), U.unbindTexture();
		}, this.resetState = function() {
			j = 0, M = 0, N = null, U.reset(), Le.reset();
		}, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
	}
	get coordinateSystem() {
		return Hl;
	}
	get outputColorSpace() {
		return this._outputColorSpace;
	}
	set outputColorSpace(e) {
		this._outputColorSpace = e;
		let t = this.getContext();
		t.drawingBufferColorSpace = Lu._getDrawingBufferColorSpace(e), t.unpackColorSpace = Lu._getUnpackColorSpace();
	}
}, fv = { type: "change" }, pv = { type: "start" }, mv = { type: "end" }, hv = new Vf(), gv = new sp(), _v = Math.cos(70 * Du.DEG2RAD), vv = new X(), yv = 2 * Math.PI, bv = {
	NONE: -1,
	ROTATE: 0,
	DOLLY: 1,
	PAN: 2,
	TOUCH_ROTATE: 3,
	TOUCH_PAN: 4,
	TOUCH_DOLLY_PAN: 5,
	TOUCH_DOLLY_ROTATE: 6
}, xv = 1e-6, Sv = class extends Km {
	constructor(e, t = null) {
		super(e, t), this.state = bv.NONE, this.target = new X(), this.cursor = new X(), this.minDistance = 0, this.maxDistance = Infinity, this.minZoom = 0, this.maxZoom = Infinity, this.minTargetRadius = 0, this.maxTargetRadius = Infinity, this.minPolarAngle = 0, this.maxPolarAngle = Math.PI, this.minAzimuthAngle = -Infinity, this.maxAzimuthAngle = Infinity, this.enableDamping = !1, this.dampingFactor = .05, this.enableZoom = !0, this.zoomSpeed = 1, this.enableRotate = !0, this.rotateSpeed = 1, this.keyRotateSpeed = 1, this.enablePan = !0, this.panSpeed = 1, this.screenSpacePanning = !0, this.keyPanSpeed = 7, this.zoomToCursor = !1, this.autoRotate = !1, this.autoRotateSpeed = 2, this.keys = {
			LEFT: "ArrowLeft",
			UP: "ArrowUp",
			RIGHT: "ArrowRight",
			BOTTOM: "ArrowDown"
		}, this.mouseButtons = {
			LEFT: fc.ROTATE,
			MIDDLE: fc.DOLLY,
			RIGHT: fc.PAN
		}, this.touches = {
			ONE: pc.ROTATE,
			TWO: pc.DOLLY_PAN
		}, this.target0 = this.target.clone(), this.position0 = this.object.position.clone(), this.zoom0 = this.object.zoom, this._cursorStyle = "auto", this._domElementKeyEvents = null, this._lastPosition = new X(), this._lastQuaternion = new ku(), this._lastTargetPosition = new X(), this._quat = new ku().setFromUnitVectors(e.up, new X(0, 1, 0)), this._quatInverse = this._quat.clone().invert(), this._spherical = new Gm(), this._sphericalDelta = new Gm(), this._scale = 1, this._panOffset = new X(), this._rotateStart = new Ou(), this._rotateEnd = new Ou(), this._rotateDelta = new Ou(), this._panStart = new Ou(), this._panEnd = new Ou(), this._panDelta = new Ou(), this._dollyStart = new Ou(), this._dollyEnd = new Ou(), this._dollyDelta = new Ou(), this._dollyDirection = new X(), this._mouse = new Ou(), this._performCursorZoom = !1, this._pointers = [], this._pointerPositions = {}, this._controlActive = !1, this._onPointerMove = wv.bind(this), this._onPointerDown = Cv.bind(this), this._onPointerUp = Tv.bind(this), this._onContextMenu = Mv.bind(this), this._onMouseWheel = Ov.bind(this), this._onKeyDown = kv.bind(this), this._onTouchStart = Av.bind(this), this._onTouchMove = jv.bind(this), this._onMouseDown = Ev.bind(this), this._onMouseMove = Dv.bind(this), this._interceptControlDown = Nv.bind(this), this._interceptControlUp = Pv.bind(this), this.domElement !== null && this.connect(this.domElement), this.update();
	}
	set cursorStyle(e) {
		this._cursorStyle = e, e === "grab" ? this.domElement.style.cursor = "grab" : this.domElement.style.cursor = "auto";
	}
	get cursorStyle() {
		return this._cursorStyle;
	}
	connect(e) {
		super.connect(e), this.domElement.addEventListener("pointerdown", this._onPointerDown), this.domElement.addEventListener("pointercancel", this._onPointerUp), this.domElement.addEventListener("contextmenu", this._onContextMenu), this.domElement.addEventListener("wheel", this._onMouseWheel, { passive: !1 }), this.domElement.getRootNode().addEventListener("keydown", this._interceptControlDown, {
			passive: !0,
			capture: !0
		}), this.domElement.style.touchAction = "none";
	}
	disconnect() {
		this.domElement.removeEventListener("pointerdown", this._onPointerDown), this.domElement.ownerDocument.removeEventListener("pointermove", this._onPointerMove), this.domElement.ownerDocument.removeEventListener("pointerup", this._onPointerUp), this.domElement.removeEventListener("pointercancel", this._onPointerUp), this.domElement.removeEventListener("wheel", this._onMouseWheel), this.domElement.removeEventListener("contextmenu", this._onContextMenu), this.stopListenToKeyEvents(), this.domElement.getRootNode().removeEventListener("keydown", this._interceptControlDown, { capture: !0 }), this.domElement.style.touchAction = "";
	}
	dispose() {
		this.disconnect();
	}
	getPolarAngle() {
		return this._spherical.phi;
	}
	getAzimuthalAngle() {
		return this._spherical.theta;
	}
	getDistance() {
		return this.object.position.distanceTo(this.target);
	}
	listenToKeyEvents(e) {
		e.addEventListener("keydown", this._onKeyDown), this._domElementKeyEvents = e;
	}
	stopListenToKeyEvents() {
		this._domElementKeyEvents !== null && (this._domElementKeyEvents.removeEventListener("keydown", this._onKeyDown), this._domElementKeyEvents = null);
	}
	saveState() {
		this.target0.copy(this.target), this.position0.copy(this.object.position), this.zoom0 = this.object.zoom;
	}
	reset() {
		this.target.copy(this.target0), this.object.position.copy(this.position0), this.object.zoom = this.zoom0, this.object.updateProjectionMatrix(), this.dispatchEvent(fv), this.update(), this.state = bv.NONE;
	}
	pan(e, t) {
		this._pan(e, t), this.update();
	}
	dollyIn(e) {
		this._dollyIn(e), this.update();
	}
	dollyOut(e) {
		this._dollyOut(e), this.update();
	}
	rotateLeft(e) {
		this._rotateLeft(e), this.update();
	}
	rotateUp(e) {
		this._rotateUp(e), this.update();
	}
	update(e = null) {
		let t = this.object.position;
		vv.copy(t).sub(this.target), vv.applyQuaternion(this._quat), this._spherical.setFromVector3(vv), this.autoRotate && this.state === bv.NONE && this._rotateLeft(this._getAutoRotationAngle(e)), this.enableDamping ? (this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor, this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor) : (this._spherical.theta += this._sphericalDelta.theta, this._spherical.phi += this._sphericalDelta.phi);
		let n = this.minAzimuthAngle, r = this.maxAzimuthAngle;
		isFinite(n) && isFinite(r) && (n < -Math.PI ? n += yv : n > Math.PI && (n -= yv), r < -Math.PI ? r += yv : r > Math.PI && (r -= yv), n <= r ? this._spherical.theta = Math.max(n, Math.min(r, this._spherical.theta)) : this._spherical.theta = this._spherical.theta > (n + r) / 2 ? Math.max(n, this._spherical.theta) : Math.min(r, this._spherical.theta)), this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi)), this._spherical.makeSafe(), this.enableDamping === !0 ? this.target.addScaledVector(this._panOffset, this.dampingFactor) : this.target.add(this._panOffset), this.target.sub(this.cursor), this.target.clampLength(this.minTargetRadius, this.maxTargetRadius), this.target.add(this.cursor);
		let i = !1;
		if (this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera) this._spherical.radius = this._clampDistance(this._spherical.radius);
		else {
			let e = this._spherical.radius;
			this._spherical.radius = this._clampDistance(this._spherical.radius * this._scale), i = e != this._spherical.radius;
		}
		if (vv.setFromSpherical(this._spherical), vv.applyQuaternion(this._quatInverse), t.copy(this.target).add(vv), this.object.lookAt(this.target), this.enableDamping === !0 ? (this._sphericalDelta.theta *= 1 - this.dampingFactor, this._sphericalDelta.phi *= 1 - this.dampingFactor, this._panOffset.multiplyScalar(1 - this.dampingFactor)) : (this._sphericalDelta.set(0, 0, 0), this._panOffset.set(0, 0, 0)), this.zoomToCursor && this._performCursorZoom) {
			let e = null;
			if (this.object.isPerspectiveCamera) {
				let t = vv.length();
				e = this._clampDistance(t * this._scale);
				let n = t - e;
				this.object.position.addScaledVector(this._dollyDirection, n), this.object.updateMatrixWorld(), i = !!n;
			} else if (this.object.isOrthographicCamera) {
				let t = new X(this._mouse.x, this._mouse.y, 0);
				t.unproject(this.object);
				let n = this.object.zoom;
				this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale)), this.object.updateProjectionMatrix(), i = n !== this.object.zoom;
				let r = new X(this._mouse.x, this._mouse.y, 0);
				r.unproject(this.object), this.object.position.sub(r).add(t), this.object.updateMatrixWorld(), e = vv.length();
			} else console.warn("WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled."), this.zoomToCursor = !1;
			e !== null && (this.screenSpacePanning ? this.target.set(0, 0, -1).transformDirection(this.object.matrix).multiplyScalar(e).add(this.object.position) : (hv.origin.copy(this.object.position), hv.direction.set(0, 0, -1).transformDirection(this.object.matrix), Math.abs(this.object.up.dot(hv.direction)) < _v ? this.object.lookAt(this.target) : (gv.setFromNormalAndCoplanarPoint(this.object.up, this.target), hv.intersectPlane(gv, this.target))));
		} else if (this.object.isOrthographicCamera) {
			let e = this.object.zoom;
			this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale)), e !== this.object.zoom && (this.object.updateProjectionMatrix(), i = !0);
		}
		return this._scale = 1, this._performCursorZoom = !1, i || this._lastPosition.distanceToSquared(this.object.position) > xv || 8 * (1 - this._lastQuaternion.dot(this.object.quaternion)) > xv || this._lastTargetPosition.distanceToSquared(this.target) > xv ? (this.dispatchEvent(fv), this._lastPosition.copy(this.object.position), this._lastQuaternion.copy(this.object.quaternion), this._lastTargetPosition.copy(this.target), !0) : !1;
	}
	_getAutoRotationAngle(e) {
		return e === null ? yv / 60 / 60 * this.autoRotateSpeed : yv / 60 * this.autoRotateSpeed * e;
	}
	_getZoomScale(e) {
		let t = Math.abs(e * .01);
		return .95 ** (this.zoomSpeed * t);
	}
	_rotateLeft(e) {
		this._sphericalDelta.theta -= e;
	}
	_rotateUp(e) {
		this._sphericalDelta.phi -= e;
	}
	_panLeft(e, t) {
		vv.setFromMatrixColumn(t, 0), vv.multiplyScalar(-e), this._panOffset.add(vv);
	}
	_panUp(e, t) {
		this.screenSpacePanning === !0 ? vv.setFromMatrixColumn(t, 1) : (vv.setFromMatrixColumn(t, 0), vv.crossVectors(this.object.up, vv)), vv.multiplyScalar(e), this._panOffset.add(vv);
	}
	_pan(e, t) {
		let n = this.domElement;
		if (this.object.isPerspectiveCamera) {
			let r = this.object.position;
			vv.copy(r).sub(this.target);
			let i = vv.length();
			i *= Math.tan(this.object.fov / 2 * Math.PI / 180), this._panLeft(2 * e * i / n.clientHeight, this.object.matrix), this._panUp(2 * t * i / n.clientHeight, this.object.matrix);
		} else this.object.isOrthographicCamera ? (this._panLeft(e * (this.object.right - this.object.left) / this.object.zoom / n.clientWidth, this.object.matrix), this._panUp(t * (this.object.top - this.object.bottom) / this.object.zoom / n.clientHeight, this.object.matrix)) : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled."), this.enablePan = !1);
	}
	_dollyOut(e) {
		this.object.isPerspectiveCamera || this.object.isOrthographicCamera ? this._scale /= e : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."), this.enableZoom = !1);
	}
	_dollyIn(e) {
		this.object.isPerspectiveCamera || this.object.isOrthographicCamera ? this._scale *= e : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."), this.enableZoom = !1);
	}
	_updateZoomParameters(e, t) {
		if (!this.zoomToCursor) return;
		this._performCursorZoom = !0;
		let n = this.domElement.getBoundingClientRect(), r = e - n.left, i = t - n.top, a = n.width, o = n.height;
		this._mouse.x = r / a * 2 - 1, this._mouse.y = -(i / o) * 2 + 1, this._dollyDirection.set(this._mouse.x, this._mouse.y, 1).unproject(this.object).sub(this.object.position).normalize();
	}
	_clampDistance(e) {
		return Math.max(this.minDistance, Math.min(this.maxDistance, e));
	}
	_handleMouseDownRotate(e) {
		this._rotateStart.set(e.clientX, e.clientY);
	}
	_handleMouseDownDolly(e) {
		this._updateZoomParameters(e.clientX, e.clientX), this._dollyStart.set(e.clientX, e.clientY);
	}
	_handleMouseDownPan(e) {
		this._panStart.set(e.clientX, e.clientY);
	}
	_handleMouseMoveRotate(e) {
		this._rotateEnd.set(e.clientX, e.clientY), this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
		let t = this.domElement;
		this._rotateLeft(yv * this._rotateDelta.x / t.clientHeight), this._rotateUp(yv * this._rotateDelta.y / t.clientHeight), this._rotateStart.copy(this._rotateEnd), this.update();
	}
	_handleMouseMoveDolly(e) {
		this._dollyEnd.set(e.clientX, e.clientY), this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart), this._dollyDelta.y > 0 ? this._dollyOut(this._getZoomScale(this._dollyDelta.y)) : this._dollyDelta.y < 0 && this._dollyIn(this._getZoomScale(this._dollyDelta.y)), this._dollyStart.copy(this._dollyEnd), this.update();
	}
	_handleMouseMovePan(e) {
		this._panEnd.set(e.clientX, e.clientY), this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed), this._pan(this._panDelta.x, this._panDelta.y), this._panStart.copy(this._panEnd), this.update();
	}
	_handleMouseWheel(e) {
		this._updateZoomParameters(e.clientX, e.clientY), e.deltaY < 0 ? this._dollyIn(this._getZoomScale(e.deltaY)) : e.deltaY > 0 && this._dollyOut(this._getZoomScale(e.deltaY)), this.update();
	}
	_handleKeyDown(e) {
		let t = !1;
		switch (e.code) {
			case this.keys.UP:
				e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateUp(yv * this.keyRotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(0, this.keyPanSpeed), t = !0;
				break;
			case this.keys.BOTTOM:
				e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateUp(-yv * this.keyRotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(0, -this.keyPanSpeed), t = !0;
				break;
			case this.keys.LEFT:
				e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateLeft(yv * this.keyRotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(this.keyPanSpeed, 0), t = !0;
				break;
			case this.keys.RIGHT:
				e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateLeft(-yv * this.keyRotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(-this.keyPanSpeed, 0), t = !0;
				break;
		}
		t && (e.preventDefault(), this.update());
	}
	_handleTouchStartRotate(e) {
		if (this._pointers.length === 1) this._rotateStart.set(e.pageX, e.pageY);
		else {
			let t = this._getSecondPointerPosition(e), n = .5 * (e.pageX + t.x), r = .5 * (e.pageY + t.y);
			this._rotateStart.set(n, r);
		}
	}
	_handleTouchStartPan(e) {
		if (this._pointers.length === 1) this._panStart.set(e.pageX, e.pageY);
		else {
			let t = this._getSecondPointerPosition(e), n = .5 * (e.pageX + t.x), r = .5 * (e.pageY + t.y);
			this._panStart.set(n, r);
		}
	}
	_handleTouchStartDolly(e) {
		let t = this._getSecondPointerPosition(e), n = e.pageX - t.x, r = e.pageY - t.y, i = Math.sqrt(n * n + r * r);
		this._dollyStart.set(0, i);
	}
	_handleTouchStartDollyPan(e) {
		this.enableZoom && this._handleTouchStartDolly(e), this.enablePan && this._handleTouchStartPan(e);
	}
	_handleTouchStartDollyRotate(e) {
		this.enableZoom && this._handleTouchStartDolly(e), this.enableRotate && this._handleTouchStartRotate(e);
	}
	_handleTouchMoveRotate(e) {
		if (this._pointers.length == 1) this._rotateEnd.set(e.pageX, e.pageY);
		else {
			let t = this._getSecondPointerPosition(e), n = .5 * (e.pageX + t.x), r = .5 * (e.pageY + t.y);
			this._rotateEnd.set(n, r);
		}
		this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
		let t = this.domElement;
		this._rotateLeft(yv * this._rotateDelta.x / t.clientHeight), this._rotateUp(yv * this._rotateDelta.y / t.clientHeight), this._rotateStart.copy(this._rotateEnd);
	}
	_handleTouchMovePan(e) {
		if (this._pointers.length === 1) this._panEnd.set(e.pageX, e.pageY);
		else {
			let t = this._getSecondPointerPosition(e), n = .5 * (e.pageX + t.x), r = .5 * (e.pageY + t.y);
			this._panEnd.set(n, r);
		}
		this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed), this._pan(this._panDelta.x, this._panDelta.y), this._panStart.copy(this._panEnd);
	}
	_handleTouchMoveDolly(e) {
		let t = this._getSecondPointerPosition(e), n = e.pageX - t.x, r = e.pageY - t.y, i = Math.sqrt(n * n + r * r);
		this._dollyEnd.set(0, i), this._dollyDelta.set(0, (this._dollyEnd.y / this._dollyStart.y) ** +this.zoomSpeed), this._dollyOut(this._dollyDelta.y), this._dollyStart.copy(this._dollyEnd);
		let a = (e.pageX + t.x) * .5, o = (e.pageY + t.y) * .5;
		this._updateZoomParameters(a, o);
	}
	_handleTouchMoveDollyPan(e) {
		this.enableZoom && this._handleTouchMoveDolly(e), this.enablePan && this._handleTouchMovePan(e);
	}
	_handleTouchMoveDollyRotate(e) {
		this.enableZoom && this._handleTouchMoveDolly(e), this.enableRotate && this._handleTouchMoveRotate(e);
	}
	_addPointer(e) {
		this._pointers.push(e.pointerId);
	}
	_removePointer(e) {
		delete this._pointerPositions[e.pointerId];
		for (let t = 0; t < this._pointers.length; t++) if (this._pointers[t] == e.pointerId) {
			this._pointers.splice(t, 1);
			return;
		}
	}
	_isTrackingPointer(e) {
		for (let t = 0; t < this._pointers.length; t++) if (this._pointers[t] == e.pointerId) return !0;
		return !1;
	}
	_trackPointer(e) {
		let t = this._pointerPositions[e.pointerId];
		t === void 0 && (t = new Ou(), this._pointerPositions[e.pointerId] = t), t.set(e.pageX, e.pageY);
	}
	_getSecondPointerPosition(e) {
		let t = e.pointerId === this._pointers[0] ? this._pointers[1] : this._pointers[0];
		return this._pointerPositions[t];
	}
	_customWheelEvent(e) {
		let t = e.deltaMode, n = {
			clientX: e.clientX,
			clientY: e.clientY,
			deltaY: e.deltaY
		};
		switch (t) {
			case 1:
				n.deltaY *= 16;
				break;
			case 2:
				n.deltaY *= 100;
				break;
		}
		return e.ctrlKey && !this._controlActive && (n.deltaY *= 10), n;
	}
};
function Cv(e) {
	this.enabled !== !1 && (this._pointers.length === 0 && (this.domElement.setPointerCapture(e.pointerId), this.domElement.ownerDocument.addEventListener("pointermove", this._onPointerMove), this.domElement.ownerDocument.addEventListener("pointerup", this._onPointerUp)), !this._isTrackingPointer(e) && (this._addPointer(e), e.pointerType === "touch" ? this._onTouchStart(e) : this._onMouseDown(e), this._cursorStyle === "grab" && (this.domElement.style.cursor = "grabbing")));
}
function wv(e) {
	this.enabled !== !1 && (e.pointerType === "touch" ? this._onTouchMove(e) : this._onMouseMove(e));
}
function Tv(e) {
	switch (this._removePointer(e), this._pointers.length) {
		case 0:
			this.domElement.releasePointerCapture(e.pointerId), this.domElement.ownerDocument.removeEventListener("pointermove", this._onPointerMove), this.domElement.ownerDocument.removeEventListener("pointerup", this._onPointerUp), this.dispatchEvent(mv), this.state = bv.NONE, this._cursorStyle === "grab" && (this.domElement.style.cursor = "grab");
			break;
		case 1:
			let t = this._pointers[0], n = this._pointerPositions[t];
			this._onTouchStart({
				pointerId: t,
				pageX: n.x,
				pageY: n.y
			});
			break;
	}
}
function Ev(e) {
	let t;
	switch (e.button) {
		case 0:
			t = this.mouseButtons.LEFT;
			break;
		case 1:
			t = this.mouseButtons.MIDDLE;
			break;
		case 2:
			t = this.mouseButtons.RIGHT;
			break;
		default: t = -1;
	}
	switch (t) {
		case fc.DOLLY:
			if (this.enableZoom === !1) return;
			this._handleMouseDownDolly(e), this.state = bv.DOLLY;
			break;
		case fc.ROTATE:
			if (e.ctrlKey || e.metaKey || e.shiftKey) {
				if (this.enablePan === !1) return;
				this._handleMouseDownPan(e), this.state = bv.PAN;
			} else {
				if (this.enableRotate === !1) return;
				this._handleMouseDownRotate(e), this.state = bv.ROTATE;
			}
			break;
		case fc.PAN:
			if (e.ctrlKey || e.metaKey || e.shiftKey) {
				if (this.enableRotate === !1) return;
				this._handleMouseDownRotate(e), this.state = bv.ROTATE;
			} else {
				if (this.enablePan === !1) return;
				this._handleMouseDownPan(e), this.state = bv.PAN;
			}
			break;
		default: this.state = bv.NONE;
	}
	this.state !== bv.NONE && this.dispatchEvent(pv);
}
function Dv(e) {
	switch (this.state) {
		case bv.ROTATE:
			if (this.enableRotate === !1) return;
			this._handleMouseMoveRotate(e);
			break;
		case bv.DOLLY:
			if (this.enableZoom === !1) return;
			this._handleMouseMoveDolly(e);
			break;
		case bv.PAN:
			if (this.enablePan === !1) return;
			this._handleMouseMovePan(e);
			break;
	}
}
function Ov(e) {
	this.enabled === !1 || this.enableZoom === !1 || this.state !== bv.NONE || (e.preventDefault(), this.dispatchEvent(pv), this._handleMouseWheel(this._customWheelEvent(e)), this.dispatchEvent(mv));
}
function kv(e) {
	this.enabled !== !1 && this._handleKeyDown(e);
}
function Av(e) {
	switch (this._trackPointer(e), this._pointers.length) {
		case 1:
			switch (this.touches.ONE) {
				case pc.ROTATE:
					if (this.enableRotate === !1) return;
					this._handleTouchStartRotate(e), this.state = bv.TOUCH_ROTATE;
					break;
				case pc.PAN:
					if (this.enablePan === !1) return;
					this._handleTouchStartPan(e), this.state = bv.TOUCH_PAN;
					break;
				default: this.state = bv.NONE;
			}
			break;
		case 2:
			switch (this.touches.TWO) {
				case pc.DOLLY_PAN:
					if (this.enableZoom === !1 && this.enablePan === !1) return;
					this._handleTouchStartDollyPan(e), this.state = bv.TOUCH_DOLLY_PAN;
					break;
				case pc.DOLLY_ROTATE:
					if (this.enableZoom === !1 && this.enableRotate === !1) return;
					this._handleTouchStartDollyRotate(e), this.state = bv.TOUCH_DOLLY_ROTATE;
					break;
				default: this.state = bv.NONE;
			}
			break;
		default: this.state = bv.NONE;
	}
	this.state !== bv.NONE && this.dispatchEvent(pv);
}
function jv(e) {
	switch (this._trackPointer(e), this.state) {
		case bv.TOUCH_ROTATE:
			if (this.enableRotate === !1) return;
			this._handleTouchMoveRotate(e), this.update();
			break;
		case bv.TOUCH_PAN:
			if (this.enablePan === !1) return;
			this._handleTouchMovePan(e), this.update();
			break;
		case bv.TOUCH_DOLLY_PAN:
			if (this.enableZoom === !1 && this.enablePan === !1) return;
			this._handleTouchMoveDollyPan(e), this.update();
			break;
		case bv.TOUCH_DOLLY_ROTATE:
			if (this.enableZoom === !1 && this.enableRotate === !1) return;
			this._handleTouchMoveDollyRotate(e), this.update();
			break;
		default: this.state = bv.NONE;
	}
}
function Mv(e) {
	this.enabled !== !1 && e.preventDefault();
}
function Nv(e) {
	e.key === "Control" && (this._controlActive = !0, this.domElement.getRootNode().addEventListener("keyup", this._interceptControlUp, {
		passive: !0,
		capture: !0
	}));
}
function Pv(e) {
	e.key === "Control" && (this._controlActive = !1, this.domElement.getRootNode().removeEventListener("keyup", this._interceptControlUp, {
		passive: !0,
		capture: !0
	}));
}
//#endregion
//#region components/canvas-preview.tsx
function Fv([e, t, n]) {
	let r = [
		t[0] - e[0],
		t[1] - e[1],
		t[2] - e[2]
	], i = [
		n[0] - e[0],
		n[1] - e[1],
		n[2] - e[2]
	], a = [
		r[1] * i[2] - r[2] * i[1],
		r[2] * i[0] - r[0] * i[2],
		r[0] * i[1] - r[1] * i[0]
	], o = Math.hypot(...a) || 1;
	return [
		a[0] / o,
		a[1] / o,
		a[2] / o
	];
}
function Iv(e, t) {
	let n = /^[0-9a-f]{6}$/i.test(e.replace("#", "")) ? e.replace("#", "") : "b8b8b8", r = (e) => Math.max(0, Math.min(255, Math.round(Number.parseInt(n.slice(e, e + 2), 16) * t)));
	return `rgb(${r(0)} ${r(2)} ${r(4)})`;
}
function Lv(e) {
	let t = Math.hypot(...e) || 1;
	return [
		e[0] / t,
		e[1] / t,
		e[2] / t
	];
}
function Rv(e, t) {
	return [
		e[1] * t[2] - e[2] * t[1],
		e[2] * t[0] - e[0] * t[2],
		e[0] * t[1] - e[1] * t[0]
	];
}
function zv(e, t) {
	return e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
}
function Bv({ layers: e, colors: t, compassRef: n }) {
	let r = (0, A.useRef)(null), i = (0, A.useRef)(void 0), [a, o] = (0, A.useState)(-Math.PI / 4), [s, c] = (0, A.useState)(.62), [l, u] = (0, A.useState)(1), d = (0, A.useMemo)(() => e.flatMap((e) => e.triangles.map((t) => ({
		triangle: t,
		kind: e.kind
	}))), [e]);
	(0, A.useEffect)(() => {
		let e = r.current;
		if (!e) return;
		let i = e.getContext("2d");
		if (!i) return;
		let o = () => {
			let r = e.getBoundingClientRect(), o = Math.min(window.devicePixelRatio || 1, 2);
			e.width = Math.max(1, Math.floor(r.width * o)), e.height = Math.max(1, Math.floor(r.height * o)), i.setTransform(o, 0, 0, o, 0, 0);
			let c = r.width, u = r.height;
			if (i.clearRect(0, 0, c, u), d.length === 0) return;
			let f = [
				Infinity,
				Infinity,
				Infinity
			], p = [
				-Infinity,
				-Infinity,
				-Infinity
			];
			for (let e of d) for (let t of e.triangle) f[0] = Math.min(f[0], t[0]), f[1] = Math.min(f[1], t[1]), f[2] = Math.min(f[2], t[2]), p[0] = Math.max(p[0], t[0]), p[1] = Math.max(p[1], t[1]), p[2] = Math.max(p[2], t[2]);
			let m = [
				(f[0] + p[0]) / 2,
				(f[1] + p[1]) / 2,
				(f[2] + p[2]) / 2
			], h = Math.max(p[0] - f[0], p[1] - f[1], 1), g = [
				Math.cos(a) * Math.cos(s),
				Math.sin(a) * Math.cos(s),
				Math.sin(s)
			], _ = Lv(g.map((e) => -e)), v = Lv(Rv(_, [
				0,
				0,
				1
			])), y = Lv(Rv(v, _)), b = Math.min(c, u) / (h * 1.52) * l, x = (e) => {
				let t = [
					e[0] - m[0],
					e[1] - m[1],
					e[2] - m[2]
				];
				return {
					x: c / 2 + zv(t, v) * b,
					y: u / 2 - zv(t, y) * b,
					depth: zv(t, g)
				};
			}, S = d.map((e) => {
				let t = e.triangle.map(x);
				return {
					...e,
					points: t,
					depth: (t[0].depth + t[1].depth + t[2].depth) / 3
				};
			}).sort((e, t) => e.depth - t.depth), C = Lv([
				-.35,
				-.45,
				.82
			]);
			for (let e of S) {
				let n = Fv(e.triangle), r = .72 + Math.max(0, zv(n, C)) * .2;
				i.beginPath(), i.moveTo(e.points[0].x, e.points[0].y), i.lineTo(e.points[1].x, e.points[1].y), i.lineTo(e.points[2].x, e.points[2].y), i.closePath(), i.fillStyle = Iv(t[e.kind], r), i.fill();
			}
			if (n.current) {
				let e = v[1], t = -y[1];
				n.current.style.transform = `rotate(${Math.atan2(e, -t)}rad)`;
			}
		};
		o();
		let c = new ResizeObserver(o);
		return c.observe(e), () => c.disconnect();
	}, [
		t,
		n,
		s,
		d,
		a,
		l
	]);
	function f(e) {
		e.currentTarget.setPointerCapture(e.pointerId), i.current = {
			pointerId: e.pointerId,
			x: e.clientX,
			y: e.clientY,
			yaw: a,
			elevation: s
		};
	}
	function p(e) {
		let t = i.current;
		!t || t.pointerId !== e.pointerId || (o(t.yaw - (e.clientX - t.x) * .009), c(Math.max(.22, Math.min(1.25, t.elevation + (t.y - e.clientY) * .007))));
	}
	function m(e) {
		i.current?.pointerId === e.pointerId && (i.current = void 0);
	}
	function h(e) {
		e.preventDefault(), u((t) => Math.max(.6, Math.min(3.5, t * (e.deltaY > 0 ? .91 : 1.1))));
	}
	function g(e) {
		if (e.key === "ArrowLeft") o((e) => e + .12);
		else if (e.key === "ArrowRight") o((e) => e - .12);
		else if (e.key === "ArrowUp") c((e) => Math.min(1.25, e + .08));
		else if (e.key === "ArrowDown") c((e) => Math.max(.22, e - .08));
		else return;
		e.preventDefault();
	}
	return /* @__PURE__ */ (0, q.jsx)("canvas", {
		ref: r,
		className: "preview-webgl preview-canvas-fallback",
		tabIndex: 0,
		"aria-label": "3D-compatibiliteitsweergave; sleep om te draaien en scroll om te zoomen",
		onPointerDown: f,
		onPointerMove: p,
		onPointerUp: m,
		onPointerCancel: m,
		onWheel: h,
		onKeyDown: g,
		onDoubleClick: () => {
			o(-Math.PI / 4), c(.62), u(1);
		}
	});
}
//#endregion
//#region components/isometric-preview.tsx
var Vv = {
	base: "Zijkant",
	terrain: "Terrein",
	greenery: "Groen",
	trees: "Bomen",
	water: "Water",
	roads: "Wegen",
	track: "Route",
	buildings: "Gebouwen"
}, Hv = {};
function Uv(e) {
	let t = [], n = [], r = /* @__PURE__ */ new Map();
	for (let i of e) for (let e of i) {
		let i = e.map((e) => Math.round(e * 1e5)).join(","), a = r.get(i);
		a === void 0 && (a = t.length, t.push(e), r.set(i, a)), n.push(a);
	}
	let i = new Float32Array(t.length * 3);
	t.forEach((e, t) => i.set(e, t * 3));
	let a = new jf();
	return a.setAttribute("position", new gf(i, 3)), a.setIndex(n), a.computeVertexNormals(), a;
}
function Wv({ layers: e, colors: t, modelMillimeters: n, loading: r, layerOpacity: i = Hv, buildingEdges: a = !1, progressMessage: o, frameFinish: s = "none", presentation: c = !1 }) {
	let l = (0, A.useRef)(null), u = (0, A.useRef)(null), d = (0, A.useRef)(() => void 0), [f, p] = (0, A.useState)(!1), [m, h] = (0, A.useState)(0), [g, _] = (0, A.useState)(!1), v = (0, A.useMemo)(() => e.map((e) => ({
		...e,
		triangles: e.kind === "terrain" ? e.triangles.filter((e) => e.some((e) => e[2] > .001)) : e.triangles
	})), [e]);
	(0, A.useEffect)(() => {
		let e = l.current;
		if (!e || f || v.every((e) => e.triangles.length === 0)) return;
		if (!document.createElement("canvas").getContext("webgl2")) {
			let e = window.setTimeout(() => p(!0), 0);
			return () => window.clearTimeout(e);
		}
		let r;
		try {
			r = new dv({
				antialias: !0,
				alpha: !0,
				powerPreference: "high-performance"
			});
		} catch {
			let e = window.setTimeout(() => p(!0), 0);
			return () => window.clearTimeout(e);
		}
		r.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2)), r.setClearColor(0, 0), r.outputColorSpace = Il, r.toneMapping = 1, r.toneMappingExposure = 1.06, r.domElement.className = "preview-webgl", r.domElement.tabIndex = 0, r.domElement.setAttribute("aria-label", "3D-model; sleep om te draaien en scroll om te zoomen"), e.prepend(r.domElement);
		let o = new Id(), m = new Dd();
		o.add(m);
		let h = [], _ = [];
		for (let e of v) {
			if (e.triangles.length === 0) continue;
			let n = Uv(e.triangles), r = new Kp({
				color: t[e.kind],
				opacity: i[e.kind] ?? 1,
				transparent: (i[e.kind] ?? 1) < 1,
				roughness: 1,
				metalness: 0,
				side: 2,
				flatShading: !0
			});
			h.push(n), _.push(r);
			let o = new ep(n, r);
			if (o.renderOrder = e.kind === "terrain" ? 0 : 1, m.add(o), a && e.kind === "buildings") {
				let e = new Pp(n, 28), t = new fp({
					color: 6834989,
					transparent: !0,
					opacity: .42
				});
				h.push(e), _.push(t), m.add(new wp(e, t));
			}
		}
		if (s !== "none") {
			let e = new Zd().setFromObject(m), t = (e.min.x + e.max.x) / 2, r = (e.min.y + e.max.y) / 2, i = Math.max(e.max.x - e.min.x, e.max.y - e.min.y, n), a = i, o = t - i / 2, c = t + i / 2, l = r - a / 2, u = r + a / 2, d = Math.max(12, e.max.z + 2), f = new Kp({
				color: s === "black" ? "#292929" : s === "oak" ? "#b48a5d" : "#f5f4f0",
				roughness: .85
			});
			_.push(f);
			let p = [
				[
					i + 20,
					8,
					t,
					l - 2 - 8 / 2
				],
				[
					i + 20,
					8,
					t,
					u + 2 + 8 / 2
				],
				[
					8,
					a + 4,
					o - 2 - 8 / 2,
					r
				],
				[
					8,
					a + 4,
					c + 2 + 8 / 2,
					r
				]
			];
			for (let [e, t, n, r] of p) {
				let i = new kp(e, t, d);
				h.push(i);
				let a = new ep(i, f);
				a.position.set(n, r, d / 2 - 2), m.add(a);
			}
			let g = new kp(i + 4, a + 4, 2), v = new Kp({
				color: "#efebe4",
				roughness: 1
			});
			h.push(g), _.push(v);
			let y = new ep(g, v);
			y.position.set(t, r, -1), m.add(y);
		}
		o.add(new fm(16118767, 13290440, 1.65)), o.add(new Om(16052974, .55));
		let y = new Dm(16775144, 1.05);
		y.position.set(-1.4, -1, 2.8), o.add(y);
		let b = new Dm(14674150, .32);
		b.position.set(1.3, 1.5, .8), o.add(b);
		let x = new Zd().setFromObject(m), S = x.getCenter(new X()), C = x.getSize(new X()), w = Math.max(C.x, C.y, n * .75, 1), T = g ? new wm(44, 1, Math.max(.05, w / 1e4), w * 30) : new Tm(-w, w, w, -w, -w * 8, w * 8);
		T.up.set(0, 0, 1);
		let E = 0, D = -.38, O = () => {
			let e = new X(Math.cos(D) * Math.cos(E), Math.cos(D) * Math.sin(E), Math.sin(D));
			T.lookAt(T.position.clone().add(e));
		}, k = () => {
			if (T.position.set(S.x + w * (c ? .16 : 1.25), S.y - w * (c ? .6 : 1.35), S.z + w * (c ? 1.6 : .92)), T instanceof Tm && (T.zoom = 1.23), T instanceof wm) {
				let e = S.clone().sub(T.position).normalize();
				E = Math.atan2(e.y, e.x), D = Math.asin(e.z), O();
			}
			T.updateProjectionMatrix();
		};
		k();
		let A = new Sv(T, r.domElement);
		A.target.copy(S), A.enabled = !g, A.enableDamping = !0, A.dampingFactor = .08, A.enablePan = !0, A.rotateSpeed = .72, A.enableZoom = !1, A.minZoom = .45, A.maxZoom = 7, A.update(), d.current = () => {
			k(), g || (A.target.copy(S), A.update());
		};
		let j = T instanceof Tm ? T.zoom : 1, M = (e) => {
			if (e.preventDefault(), T instanceof Tm) j = Du.clamp(j * Math.exp(-e.deltaY * .00125), A.minZoom, A.maxZoom);
			else {
				let t = new X();
				T.getWorldDirection(t), T.position.addScaledVector(t, -e.deltaY * w * 55e-5);
			}
		};
		r.domElement.addEventListener("wheel", M, { passive: !1 });
		let N = /* @__PURE__ */ new Set(), P = new Set([
			"w",
			"a",
			"s",
			"d",
			"arrowup",
			"arrowleft",
			"arrowdown",
			"arrowright",
			"shift",
			"control"
		]), F = (e) => {
			!g || document.pointerLockElement !== r.domElement && document.activeElement !== r.domElement || (P.has(e.key.toLowerCase()) && e.preventDefault(), N.add(e.key.toLowerCase()));
		}, I = (e) => N.delete(e.key.toLowerCase()), R = (e) => {
			!g || document.pointerLockElement !== r.domElement || (E -= e.movementX * .002, D = Du.clamp(D - e.movementY * .002, -1.48, 1.48), O());
		}, ee = () => {
			r.domElement.focus(), g && document.pointerLockElement !== r.domElement && r.domElement.requestPointerLock();
		};
		window.addEventListener("keydown", F), window.addEventListener("keyup", I), document.addEventListener("mousemove", R), r.domElement.addEventListener("click", ee);
		let te = () => {
			let t = e.getBoundingClientRect(), n = Math.max(1, t.width), i = Math.max(1, t.height);
			r.setSize(n, i, !1);
			let a = n / i;
			if (T instanceof Tm) {
				let e = w * .72;
				T.left = -e * a, T.right = e * a, T.top = e, T.bottom = -e;
			} else T.aspect = a;
			T.updateProjectionMatrix();
		}, ne = new ResizeObserver(te);
		ne.observe(e), te();
		let z = 0, B = performance.now(), V = () => {
			let e = performance.now(), t = Math.min(.05, (e - B) / 1e3);
			if (B = e, T instanceof Tm) T.zoom = Du.lerp(T.zoom, j, .16), T.updateProjectionMatrix(), A.update();
			else if (g) {
				let e = new X();
				T.getWorldDirection(e);
				let n = e.clone().cross(T.up).normalize(), r = w * .42 * t;
				(N.has("w") || N.has("arrowup")) && T.position.addScaledVector(e, r), (N.has("s") || N.has("arrowdown")) && T.position.addScaledVector(e, -r), (N.has("a") || N.has("arrowleft")) && T.position.addScaledVector(n, -r), (N.has("d") || N.has("arrowright")) && T.position.addScaledVector(n, r), N.has("shift") && (T.position.z += r), N.has("control") && (T.position.z -= r);
			}
			if (r.render(o, T), u.current) {
				let e = S.clone().project(T), t = S.clone().add(new X(0, w * .18, 0)).project(T), n = Math.atan2(t.x - e.x, t.y - e.y);
				u.current.style.transform = `rotate(${n}rad)`;
			}
			z = window.requestAnimationFrame(V);
		};
		return V(), () => {
			window.cancelAnimationFrame(z), ne.disconnect(), r.domElement.removeEventListener("wheel", M), r.domElement.removeEventListener("click", ee), window.removeEventListener("keydown", F), window.removeEventListener("keyup", I), document.removeEventListener("mousemove", R), document.pointerLockElement === r.domElement && document.exitPointerLock(), A.dispose();
			for (let e of h) e.dispose();
			for (let e of _) e.dispose();
			r.dispose(), r.domElement.remove(), d.current = () => void 0;
		};
	}, [
		a,
		f,
		t,
		v,
		g,
		s,
		c,
		i,
		n
	]);
	let y = v.every((e) => e.triangles.length === 0);
	return /* @__PURE__ */ (0, q.jsxs)("div", {
		ref: l,
		className: `preview-stage${c ? " shop-model-stage" : ""}`,
		"aria-label": "Interactieve 3D-voorbeeldweergave van het model",
		children: [
			f && !y ? /* @__PURE__ */ (0, q.jsx)(Bv, {
				layers: e,
				colors: t,
				compassRef: u
			}, m) : null,
			f && c && s !== "none" ? /* @__PURE__ */ (0, q.jsx)("div", {
				className: "shop-frame-fallback-note",
				children: "2D-voorbeeld · 3D-lijstweergave vereist WebGL"
			}) : null,
			y && !r ? /* @__PURE__ */ (0, q.jsx)("div", {
				className: "preview-empty",
				children: "Kies eerst een gebied en bouw de 3D-preview."
			}) : null,
			/* @__PURE__ */ (0, q.jsxs)("div", {
				className: "preview-compass",
				"aria-label": "Noordrichting",
				children: [/* @__PURE__ */ (0, q.jsx)("span", { children: "N" }), /* @__PURE__ */ (0, q.jsx)("i", { ref: u })]
			}),
			/* @__PURE__ */ (0, q.jsx)("button", {
				className: "preview-reset",
				type: "button",
				onClick: () => {
					f ? h((e) => e + 1) : d.current();
				},
				children: "Aanzicht resetten"
			}),
			/* @__PURE__ */ (0, q.jsx)("button", {
				className: g ? "preview-camera active" : "preview-camera",
				type: "button",
				disabled: f,
				onClick: () => _((e) => !e),
				children: g ? "Orbit camera" : "Freecam"
			}),
			/* @__PURE__ */ (0, q.jsx)("div", {
				className: "preview-help",
				children: g ? "Klik in beeld · muis kijkt · WASD/pijltjes · Shift omhoog · Ctrl omlaag · Esc vrij" : "Sleep: draaien/verplaatsen · scroll: soepel zoomen · +Y is noord"
			}),
			/* @__PURE__ */ (0, q.jsx)("div", {
				className: "preview-legend",
				"aria-label": "Zichtbare 3D-lagen",
				children: v.filter((e) => e.triangles.length > 0).map((e) => /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("i", { style: { backgroundColor: t[e.kind] } }), Vv[e.kind]] }, e.kind))
			}),
			r ? /* @__PURE__ */ (0, q.jsxs)("div", {
				className: "preview-loading",
				role: "status",
				children: [/* @__PURE__ */ (0, q.jsx)("span", { className: "preview-spinner" }), o || "Open geodata en printlagen worden opgebouwd…"]
			}) : null
		]
	});
}
//#endregion
//#region node_modules/clsx/dist/clsx.mjs
function Gv(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = Gv(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function Kv() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = Gv(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region node_modules/class-variance-authority/dist/index.mjs
var qv = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Jv = Kv, Yv = (e, t) => (n) => {
	if (t?.variants == null) return Jv(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = qv(t) || qv(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return Jv(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
}, Xv = Object.defineProperty, Zv = (e, t) => Xv(e, "name", {
	value: t,
	configurable: !0
});
function Qv(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Zv(Qv, "setRef");
function $v(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = Qv(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : Qv(e[t], null);
			}
		};
	};
}
Zv($v, "composeRefs");
function ey(...e) {
	return A.useCallback($v(...e), e);
}
Zv(ey, "useComposedRefs");
//#endregion
//#region node_modules/@radix-ui/react-primitive/node_modules/@radix-ui/react-slot/dist/index.mjs
var ty = Object.defineProperty, ny = (e, t) => ty(e, "name", {
	value: t,
	configurable: !0
});
/* @__NO_SIDE_EFFECTS__ */
function ry(e) {
	let t = A.forwardRef((t, n) => {
		let { children: r, ...i } = t, a = null, o = !1, s = [];
		dy(r) && typeof hy == "function" && (r = hy(r._payload)), A.Children.forEach(r, (e) => {
			if (ly(e)) {
				o = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				dy(n) && typeof hy == "function" && (n = hy(n._payload)), a = oy(t, n), s.push(a?.props?.children);
			} else s.push(e);
		}), a ? a = A.cloneElement(a, void 0, s) : !o && A.Children.count(r) === 1 && A.isValidElement(r) && (a = r);
		let c = a ? cy(a) : void 0, l = ey(n, c);
		if (!a) {
			if (r || r === 0) throw Error(o ? my(e) : py(e));
			return r;
		}
		let u = sy(i, a.props ?? {});
		return a.type !== A.Fragment && (u.ref = n ? l : c), A.cloneElement(a, u);
	});
	return t.displayName = `${e}.Slot`, t;
}
ny(ry, "createSlot");
var iy = Symbol.for("radix.slottable");
/* @__NO_SIDE_EFFECTS__ */
function ay(e) {
	let t = /* @__PURE__ */ ny((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = iy, t;
}
ny(ay, "createSlottable");
var oy = /* @__PURE__ */ ny((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return A.isValidElement(t) ? A.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return A.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function sy(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
ny(sy, "mergeProps");
function cy(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
ny(cy, "getElementRef");
function ly(e) {
	return A.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === iy;
}
ny(ly, "isSlottable");
var uy = Symbol.for("react.lazy");
function dy(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === uy && "_payload" in e && fy(e._payload);
}
ny(dy, "isLazyComponent");
function fy(e) {
	return typeof e == "object" && !!e && "then" in e;
}
ny(fy, "isPromiseLike");
var py = /* @__PURE__ */ ny((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), my = /* @__PURE__ */ ny((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), hy = A.use, gy = Object.defineProperty, _y = (e, t) => gy(e, "name", {
	value: t,
	configurable: !0
}), vy = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /* @__PURE__ */ ry(`Primitive.${t}`), r = A.forwardRef((e, r) => {
		let { asChild: i, ...a } = e, o = i ? n : t;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ (0, q.jsx)(o, {
			...a,
			ref: r
		});
	});
	return r.displayName = `Primitive.${t}`, {
		...e,
		[t]: r
	};
}, {});
function yy(e, t) {
	e && Ce.flushSync(() => e.dispatchEvent(t));
}
_y(yy, "dispatchDiscreteCustomEvent");
//#endregion
//#region node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
var by = Object.freeze({
	position: "absolute",
	border: 0,
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	wordWrap: "normal"
}), xy = Object.defineProperty, Sy = (e, t) => xy(e, "name", {
	value: t,
	configurable: !0
});
/* @__NO_SIDE_EFFECTS__ */
function Cy(e, t) {
	let n = A.createContext(t);
	n.displayName = e + "Context";
	let r = /* @__PURE__ */ Sy((e) => {
		let { children: t, ...r } = e, i = A.useMemo(() => r, Object.values(r));
		return /* @__PURE__ */ (0, q.jsx)(n.Provider, {
			value: i,
			children: t
		});
	}, "Provider");
	r.displayName = e + "Provider";
	function i(r, i = {}) {
		let { optional: a = !1 } = i, o = A.useContext(n);
		if (o) return o;
		if (t !== void 0) return t;
		if (!a) throw Error(`\`${r}\` must be used within \`${e}\``);
	}
	return Sy(i, "useContext"), [r, i];
}
Sy(Cy, "createContext");
/* @__NO_SIDE_EFFECTS__ */
function wy(e, t = []) {
	let n = [];
	function r(t, r) {
		let i = A.createContext(r);
		i.displayName = t + "Context";
		let a = n.length;
		n = [...n, r];
		let o = /* @__PURE__ */ Sy((t) => {
			let { scope: n, children: r, ...o } = t, s = n?.[e]?.[a] || i, c = A.useMemo(() => o, Object.values(o));
			return /* @__PURE__ */ (0, q.jsx)(s.Provider, {
				value: c,
				children: r
			});
		}, "Provider");
		o.displayName = t + "Provider";
		function s(n, o, s = {}) {
			let { optional: c = !1 } = s, l = o?.[e]?.[a] || i, u = A.useContext(l);
			if (u) return u;
			if (r !== void 0) return r;
			if (!c) throw Error(`\`${n}\` must be used within \`${t}\``);
		}
		return Sy(s, "useContext"), [o, s];
	}
	Sy(r, "createContext");
	let i = /* @__PURE__ */ Sy(() => {
		let t = n.map((e) => A.createContext(e));
		return /* @__PURE__ */ Sy(function(n) {
			let r = n?.[e] || t;
			return A.useMemo(() => ({ [`__scope${e}`]: {
				...n,
				[e]: r
			} }), [n, r]);
		}, "useScope");
	}, "createScope");
	return i.scopeName = e, [r, Ty(i, ...t)];
}
Sy(wy, "createContextScope");
function Ty(...e) {
	let t = e[0];
	if (e.length === 1) return t;
	let n = /* @__PURE__ */ Sy(() => {
		let n = e.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ Sy(function(e) {
			let r = n.reduce((t, { useScope: n, scopeName: r }) => {
				let i = n(e)[`__scope${r}`];
				return {
					...t,
					...i
				};
			}, {});
			return A.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
		}, "useComposedScopes");
	}, "createScope");
	return n.scopeName = t.scopeName, n;
}
Sy(Ty, "composeContextScopes");
//#endregion
//#region node_modules/@radix-ui/react-collection/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var Ey = Object.defineProperty, Dy = (e, t) => Ey(e, "name", {
	value: t,
	configurable: !0
});
function Oy(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Dy(Oy, "setRef");
function ky(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = Oy(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : Oy(e[t], null);
			}
		};
	};
}
Dy(ky, "composeRefs");
function Ay(...e) {
	return A.useCallback(ky(...e), e);
}
Dy(Ay, "useComposedRefs");
//#endregion
//#region node_modules/@radix-ui/react-collection/node_modules/@radix-ui/react-slot/dist/index.mjs
var jy = Object.defineProperty, My = (e, t) => jy(e, "name", {
	value: t,
	configurable: !0
});
/* @__NO_SIDE_EFFECTS__ */
function Ny(e) {
	let t = A.forwardRef((t, n) => {
		let { children: r, ...i } = t, a = null, o = !1, s = [];
		Vy(r) && typeof Gy == "function" && (r = Gy(r._payload)), A.Children.forEach(r, (e) => {
			if (zy(e)) {
				o = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				Vy(n) && typeof Gy == "function" && (n = Gy(n._payload)), a = Iy(t, n), s.push(a?.props?.children);
			} else s.push(e);
		}), a ? a = A.cloneElement(a, void 0, s) : !o && A.Children.count(r) === 1 && A.isValidElement(r) && (a = r);
		let c = a ? Ry(a) : void 0, l = Ay(n, c);
		if (!a) {
			if (r || r === 0) throw Error(o ? Wy(e) : Uy(e));
			return r;
		}
		let u = Ly(i, a.props ?? {});
		return a.type !== A.Fragment && (u.ref = n ? l : c), A.cloneElement(a, u);
	});
	return t.displayName = `${e}.Slot`, t;
}
My(Ny, "createSlot");
var Py = Symbol.for("radix.slottable");
/* @__NO_SIDE_EFFECTS__ */
function Fy(e) {
	let t = /* @__PURE__ */ My((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = Py, t;
}
My(Fy, "createSlottable");
var Iy = /* @__PURE__ */ My((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return A.isValidElement(t) ? A.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return A.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function Ly(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
My(Ly, "mergeProps");
function Ry(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
My(Ry, "getElementRef");
function zy(e) {
	return A.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Py;
}
My(zy, "isSlottable");
var By = Symbol.for("react.lazy");
function Vy(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === By && "_payload" in e && Hy(e._payload);
}
My(Vy, "isLazyComponent");
function Hy(e) {
	return typeof e == "object" && !!e && "then" in e;
}
My(Hy, "isPromiseLike");
var Uy = /* @__PURE__ */ My((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), Wy = /* @__PURE__ */ My((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), Gy = A.use, Ky = Object.defineProperty, qy = (e, t) => Ky(e, "name", {
	value: t,
	configurable: !0
});
/* @__NO_SIDE_EFFECTS__ */
function Jy(e) {
	let t = e + "CollectionProvider", [n, r] = /* @__PURE__ */ wy(t), [i, a] = n(t, {
		collectionRef: { current: null },
		itemMap: /* @__PURE__ */ new Map()
	}), o = /* @__PURE__ */ qy((e) => {
		let { scope: t, children: n } = e, r = A.useRef(null), a = A.useRef(/* @__PURE__ */ new Map()).current;
		return /* @__PURE__ */ (0, q.jsx)(i, {
			scope: t,
			itemMap: a,
			collectionRef: r,
			children: n
		});
	}, "CollectionProvider");
	o.displayName = t;
	let s = e + "CollectionSlot", c = /* @__PURE__ */ Ny(s), l = A.forwardRef((e, t) => {
		let { scope: n, children: r } = e;
		return /* @__PURE__ */ (0, q.jsx)(c, {
			ref: Ay(t, a(s, n).collectionRef),
			children: r
		});
	});
	l.displayName = s;
	let u = e + "CollectionItemSlot", d = "data-radix-collection-item", f = /* @__PURE__ */ Ny(u), p = A.forwardRef((e, t) => {
		let { scope: n, children: r, ...i } = e, o = A.useRef(null), s = Ay(t, o), c = a(u, n);
		return A.useEffect(() => (c.itemMap.set(o, {
			ref: o,
			...i
		}), () => void c.itemMap.delete(o))), /* @__PURE__ */ (0, q.jsx)(f, {
			[d]: "",
			ref: s,
			children: r
		});
	});
	p.displayName = u;
	function m(t) {
		let n = a(e + "CollectionConsumer", t);
		return A.useCallback(() => {
			let e = n.collectionRef.current;
			if (!e) return [];
			let t = Array.from(e.querySelectorAll(`[${d}]`));
			return Array.from(n.itemMap.values()).sort((e, n) => t.indexOf(e.ref.current) - t.indexOf(n.ref.current));
		}, [n.collectionRef, n.itemMap]);
	}
	return qy(m, "useCollection"), [
		{
			Provider: o,
			Slot: l,
			ItemSlot: p
		},
		m,
		r
	];
}
qy(Jy, "createCollection");
var Yy = /* @__PURE__ */ new WeakMap(), Xy = class e extends Map {
	static {
		qy(this, "OrderedDict");
	}
	#e;
	constructor(e) {
		super(e), this.#e = [...super.keys()], Yy.set(this, !0);
	}
	set(e, t) {
		return Yy.get(this) && (this.has(e) ? this.#e[this.#e.indexOf(e)] = e : this.#e.push(e)), super.set(e, t), this;
	}
	insert(e, t, n) {
		let r = this.has(t), i = this.#e.length, a = $y(e), o = a >= 0 ? a : i + a, s = o < 0 || o >= i ? -1 : o;
		if (s === this.size || r && s === this.size - 1 || s === -1) return this.set(t, n), this;
		let c = this.size + +!r;
		a < 0 && o++;
		let l = [...this.#e], u, d = !1;
		for (let e = o; e < c; e++) if (o === e) {
			let i = l[e];
			l[e] === t && (i = l[e + 1]), r && this.delete(t), u = this.get(i), this.set(t, n);
		} else {
			!d && l[e - 1] === t && (d = !0);
			let n = l[d ? e : e - 1], r = u;
			u = this.get(n), this.delete(n), this.set(n, r);
		}
		return this;
	}
	with(t, n, r) {
		let i = new e(this);
		return i.insert(t, n, r), i;
	}
	before(e) {
		let t = this.#e.indexOf(e) - 1;
		if (!(t < 0)) return this.entryAt(t);
	}
	setBefore(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r, t, n);
	}
	after(e) {
		let t = this.#e.indexOf(e);
		if (t = t === -1 || t === this.size - 1 ? -1 : t + 1, t !== -1) return this.entryAt(t);
	}
	setAfter(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r + 1, t, n);
	}
	first() {
		return this.entryAt(0);
	}
	last() {
		return this.entryAt(-1);
	}
	clear() {
		return this.#e = [], super.clear();
	}
	delete(e) {
		let t = super.delete(e);
		return t && this.#e.splice(this.#e.indexOf(e), 1), t;
	}
	deleteAt(e) {
		let t = this.keyAt(e);
		return t === void 0 ? !1 : this.delete(t);
	}
	at(e) {
		let t = Zy(this.#e, e);
		if (t !== void 0) return this.get(t);
	}
	entryAt(e) {
		let t = Zy(this.#e, e);
		if (t !== void 0) return [t, this.get(t)];
	}
	indexOf(e) {
		return this.#e.indexOf(e);
	}
	keyAt(e) {
		return Zy(this.#e, e);
	}
	from(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.at(r);
	}
	keyFrom(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.keyAt(r);
	}
	find(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return r;
			n++;
		}
	}
	findIndex(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return n;
			n++;
		}
		return -1;
	}
	filter(t, n) {
		let r = [], i = 0;
		for (let e of this) Reflect.apply(t, n, [
			e,
			i,
			this
		]) && r.push(e), i++;
		return new e(r);
	}
	map(t, n) {
		let r = [], i = 0;
		for (let e of this) r.push([e[0], Reflect.apply(t, n, [
			e,
			i,
			this
		])]), i++;
		return new e(r);
	}
	reduce(...e) {
		let [t, n] = e, r = 0, i = n ?? this.at(0);
		for (let n of this) i = r === 0 && e.length === 1 ? n : Reflect.apply(t, this, [
			i,
			n,
			r,
			this
		]), r++;
		return i;
	}
	reduceRight(...e) {
		let [t, n] = e, r = n ?? this.at(-1);
		for (let n = this.size - 1; n >= 0; n--) {
			let i = this.at(n);
			r = n === this.size - 1 && e.length === 1 ? i : Reflect.apply(t, this, [
				r,
				i,
				n,
				this
			]);
		}
		return r;
	}
	toSorted(t) {
		return new e([...this.entries()].sort(t));
	}
	toReversed() {
		let t = new e();
		for (let e = this.size - 1; e >= 0; e--) {
			let n = this.keyAt(e), r = this.get(n);
			t.set(n, r);
		}
		return t;
	}
	toSpliced(...t) {
		let n = [...this.entries()];
		return n.splice(...t), new e(n);
	}
	slice(t, n) {
		let r = new e(), i = this.size - 1;
		if (t === void 0) return r;
		t < 0 && (t += this.size), n !== void 0 && n > 0 && (i = n - 1);
		for (let e = t; e <= i; e++) {
			let t = this.keyAt(e), n = this.get(t);
			r.set(t, n);
		}
		return r;
	}
	every(e, t) {
		let n = 0;
		for (let r of this) {
			if (!Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !1;
			n++;
		}
		return !0;
	}
	some(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !0;
			n++;
		}
		return !1;
	}
};
function Zy(e, t) {
	if ("at" in Array.prototype) return Array.prototype.at.call(e, t);
	let n = Qy(e, t);
	return n === -1 ? void 0 : e[n];
}
qy(Zy, "at");
function Qy(e, t) {
	let n = e.length, r = $y(t), i = r >= 0 ? r : n + r;
	return i < 0 || i >= n ? -1 : i;
}
qy(Qy, "toSafeIndex");
function $y(e) {
	return e !== e || e === 0 ? 0 : Math.trunc(e);
}
qy($y, "toSafeInteger");
/* @__NO_SIDE_EFFECTS__ */
function eb(e) {
	let t = e + "CollectionProvider", [n, r] = /* @__PURE__ */ wy(t), [i, a] = n(t, {
		collectionElement: null,
		collectionRef: { current: null },
		collectionRefObject: { current: null },
		itemMap: new Xy(),
		setItemMap: /* @__PURE__ */ qy(() => void 0, "setItemMap")
	}), o = /* @__PURE__ */ qy(({ state: e, ...t }) => e ? /* @__PURE__ */ (0, q.jsx)(c, {
		...t,
		state: e
	}) : /* @__PURE__ */ (0, q.jsx)(s, { ...t }), "CollectionProvider");
	o.displayName = t;
	let s = /* @__PURE__ */ qy((e) => {
		let t = h();
		return /* @__PURE__ */ (0, q.jsx)(c, {
			...e,
			state: t
		});
	}, "CollectionInit");
	s.displayName = t + "Init";
	let c = /* @__PURE__ */ qy((e) => {
		let { scope: t, children: n, state: r } = e, a = A.useRef(null), [o, s] = A.useState(null), c = Ay(a, s), [l, u] = r;
		return A.useEffect(() => {
			if (!o) return;
			let e = ib(() => {});
			return e.observe(o, {
				childList: !0,
				subtree: !0
			}), () => {
				e.disconnect();
			};
		}, [o]), /* @__PURE__ */ (0, q.jsx)(i, {
			scope: t,
			itemMap: l,
			setItemMap: u,
			collectionRef: c,
			collectionRefObject: a,
			collectionElement: o,
			children: n
		});
	}, "CollectionProviderImpl");
	c.displayName = t + "Impl";
	let l = e + "CollectionSlot", u = /* @__PURE__ */ Ny(l), d = A.forwardRef((e, t) => {
		let { scope: n, children: r } = e;
		return /* @__PURE__ */ (0, q.jsx)(u, {
			ref: Ay(t, a(l, n).collectionRef),
			children: r
		});
	});
	d.displayName = l;
	let f = e + "CollectionItemSlot", p = /* @__PURE__ */ Ny(f), m = A.forwardRef((e, t) => {
		let { scope: n, children: r, ...i } = e, o = A.useRef(null), [s, c] = A.useState(null), l = Ay(t, o, c), { setItemMap: u } = a(f, n), d = A.useRef(i);
		tb(d.current, i) || (d.current = i);
		let m = d.current;
		return A.useEffect(() => {
			let e = m;
			return u((t) => s ? t.has(s) ? t.set(s, {
				...e,
				element: s
			}).toSorted(rb) : (t.set(s, {
				...e,
				element: s
			}), t.toSorted(rb)) : t), () => {
				u((e) => !s || !e.has(s) ? e : (e.delete(s), new Xy(e)));
			};
		}, [
			s,
			m,
			u
		]), /* @__PURE__ */ (0, q.jsx)(p, {
			"data-radix-collection-item": "",
			ref: l,
			children: r
		});
	});
	m.displayName = f;
	function h() {
		return A.useState(new Xy());
	}
	qy(h, "useInitCollection");
	function g(t) {
		let { itemMap: n } = a(e + "CollectionConsumer", t);
		return n;
	}
	return qy(g, "useCollection"), [{
		Provider: o,
		Slot: d,
		ItemSlot: m
	}, {
		createCollectionScope: r,
		useCollection: g,
		useInitCollection: h
	}];
}
qy(eb, "createCollection");
function tb(e, t) {
	if (e === t) return !0;
	if (typeof e != "object" || typeof t != "object" || e == null || t == null) return !1;
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let r of n) if (!Object.prototype.hasOwnProperty.call(t, r) || e[r] !== t[r]) return !1;
	return !0;
}
qy(tb, "shallowEqual");
function nb(e, t) {
	return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
qy(nb, "isElementPreceding");
function rb(e, t) {
	return !e[1].element || !t[1].element ? 0 : nb(e[1].element, t[1].element) ? -1 : 1;
}
qy(rb, "sortByDocumentPosition");
function ib(e) {
	return new MutationObserver((t) => {
		for (let n of t) if (n.type === "childList") {
			e();
			return;
		}
	});
}
qy(ib, "getChildListObserver");
//#endregion
//#region node_modules/@radix-ui/primitive/dist/index.mjs
var ab = Object.defineProperty, ob = (e, t) => ab(e, "name", {
	value: t,
	configurable: !0
}), sb = !!(typeof window < "u" && window.document && window.document.createElement);
function cb(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return /* @__PURE__ */ ob(function(r) {
		if (e?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
	}, "handleEvent");
}
ob(cb, "composeEventHandlers");
function lb(e) {
	if (!sb) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
ob(lb, "getOwnerWindow");
function ub(e) {
	if (!sb) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
ob(ub, "getOwnerDocument");
function db(e, t = !1) {
	let { activeElement: n } = ub(e);
	if (!n?.nodeName) return null;
	if (fb(n) && n.contentDocument) return db(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = ub(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
ob(db, "getActiveElement");
function fb(e) {
	return e.tagName === "IFRAME";
}
ob(fb, "isFrame");
//#endregion
//#region node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var pb = globalThis?.document ? A.useLayoutEffect : () => {}, mb = Object.defineProperty, hb = (e, t) => mb(e, "name", {
	value: t,
	configurable: !0
}), gb = A.useEffectEvent, _b = A.useInsertionEffect;
function vb(e) {
	if (typeof gb == "function") return gb(e);
	let t = A.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof _b == "function" ? _b(() => {
		t.current = e;
	}) : pb(() => {
		t.current = e;
	}), A.useMemo(() => ((...e) => t.current?.(...e)), []);
}
hb(vb, "useEffectEvent");
//#endregion
//#region node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var yb = Object.defineProperty, bb = (e, t) => yb(e, "name", {
	value: t,
	configurable: !0
}), xb = A.useInsertionEffect || pb;
function Sb({ prop: e, defaultProp: t, onChange: n = /* @__PURE__ */ bb(() => {}, "onChange"), caller: r }) {
	let [i, a, o] = Cb({
		defaultProp: t,
		onChange: n
	}), s = e !== void 0;
	return [s ? e : i, A.useCallback((t) => {
		if (s) {
			let n = wb(t) ? t(e) : t;
			n !== e && o.current?.(n);
		} else a(t);
	}, [
		s,
		e,
		a,
		o
	])];
}
bb(Sb, "useControllableState");
function Cb({ defaultProp: e, onChange: t }) {
	let [n, r] = A.useState(e), i = A.useRef(n), a = A.useRef(t);
	return xb(() => {
		a.current = t;
	}, [t]), A.useEffect(() => {
		i.current !== n && (a.current?.(n), i.current = n);
	}, [n, i]), [
		n,
		r,
		a
	];
}
bb(Cb, "useUncontrolledState");
function wb(e) {
	return typeof e == "function";
}
bb(wb, "isFunction");
var Tb = Symbol("RADIX:SYNC_STATE");
function Eb(e, t, n, r) {
	let { prop: i, defaultProp: a, onChange: o, caller: s } = t, c = i !== void 0, l = vb(o), u = [{
		...n,
		state: a
	}];
	r && u.push(r);
	let [d, f] = A.useReducer((t, n) => {
		if (n.type === Tb) return {
			...t,
			state: n.state
		};
		let r = e(t, n);
		return c && !Object.is(r.state, t.state) && l(r.state), r;
	}, ...u), p = d.state, m = A.useRef(p);
	A.useEffect(() => {
		m.current !== p && (m.current = p, c || l(p));
	}, [
		p,
		m,
		c
	]);
	let h = A.useMemo(() => i === void 0 ? d : {
		...d,
		state: i
	}, [d, i]);
	return A.useEffect(() => {
		c && !Object.is(i, d.state) && f({
			type: Tb,
			state: i
		});
	}, [
		i,
		d.state,
		c
	]), [h, f];
}
bb(Eb, "useControllableStateReducer");
//#endregion
//#region node_modules/@radix-ui/react-presence/dist/index.mjs
var Db = Object.defineProperty, Ob = (e, t) => Db(e, "name", {
	value: t,
	configurable: !0
});
function kb(e, t) {
	return A.useReducer((e, n) => t[e][n] ?? e, e);
}
Ob(kb, "useStateMachine");
var Ab = /* @__PURE__ */ Ob((e) => {
	let { present: t, children: n } = e, r = jb(t), i = typeof n == "function" ? n({ present: r.isPresent }) : A.Children.only(n), a = Nb(r.ref, Fb(i));
	return typeof n == "function" || r.isPresent ? A.cloneElement(i, { ref: a }) : null;
}, "Presence");
function jb(e) {
	let [t, n] = A.useState(), r = A.useRef(null), i = A.useRef(e), a = A.useRef("none"), o = A.useRef(void 0), [s, c] = kb(e ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return A.useEffect(() => {
		s === "mounted" ? (a.current = o.current ?? Pb(r.current), o.current = void 0) : a.current = "none";
	}, [s]), pb(() => {
		let t = r.current, n = i.current;
		if (n !== e) {
			let r = a.current, s = Pb(t);
			e ? (o.current = s, c("MOUNT")) : s === "none" || t?.display === "none" ? c("UNMOUNT") : c(n && r !== s ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
		}
	}, [e, c]), pb(() => {
		if (t) {
			let e, n = t.ownerDocument.defaultView ?? window, o = /* @__PURE__ */ Ob((a) => {
				let o = Pb(r.current).includes(CSS.escape(a.animationName));
				if (a.target === t && o && (c("ANIMATION_END"), !i.current)) {
					let r = t.style.animationFillMode;
					t.style.animationFillMode = "forwards", e = n.setTimeout(() => {
						t.style.animationFillMode === "forwards" && (t.style.animationFillMode = r);
					});
				}
			}, "handleAnimationEnd"), s = /* @__PURE__ */ Ob((e) => {
				e.target === t && (a.current = Pb(r.current));
			}, "handleAnimationStart");
			return t.addEventListener("animationstart", s), t.addEventListener("animationcancel", o), t.addEventListener("animationend", o), () => {
				n.clearTimeout(e), t.removeEventListener("animationstart", s), t.removeEventListener("animationcancel", o), t.removeEventListener("animationend", o);
			};
		} else c("ANIMATION_END");
	}, [t, c]), {
		isPresent: ["mounted", "unmountSuspended"].includes(s),
		ref: A.useCallback((e) => {
			if (e) {
				let t = getComputedStyle(e);
				r.current = t, o.current = Pb(t);
			} else r.current = null;
			n(e);
		}, [])
	};
}
Ob(jb, "usePresence");
function Mb(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Ob(Mb, "setRef");
function Nb(...e) {
	let t = A.useRef(e);
	return t.current = e, A.useCallback((e) => {
		let n = t.current, r = !1, i = n.map((t) => {
			let n = Mb(t, e);
			return !r && typeof n == "function" && (r = !0), n;
		});
		if (r) return () => {
			for (let e = 0; e < i.length; e++) {
				let t = i[e];
				typeof t == "function" ? t() : Mb(n[e], null);
			}
		};
	}, []);
}
Ob(Nb, "useStableComposedRefs");
function Pb(e) {
	return e?.animationName || "none";
}
Ob(Pb, "getAnimationName");
function Fb(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Ob(Fb, "getElementRef");
//#endregion
//#region node_modules/@radix-ui/react-id/dist/index.mjs
var Ib = Object.defineProperty, Lb = (e, t) => Ib(e, "name", {
	value: t,
	configurable: !0
}), Rb = A.useId || (() => void 0), zb = 0;
function Bb(e) {
	let [t, n] = A.useState(Rb());
	return pb(() => {
		e || n((e) => e ?? String(zb++));
	}, [e]), e || (t ? `radix-${t}` : "");
}
Lb(Bb, "useId");
//#endregion
//#region node_modules/@radix-ui/react-direction/dist/index.mjs
var Vb = Object.defineProperty, Hb = (e, t) => Vb(e, "name", {
	value: t,
	configurable: !0
}), Ub = A.createContext(void 0);
function Wb(e) {
	let t = A.useContext(Ub);
	return e || t || "ltr";
}
Hb(Wb, "useDirection");
//#endregion
//#region node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var Gb = Object.defineProperty, Kb = (e, t) => Gb(e, "name", {
	value: t,
	configurable: !0
});
function qb(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Kb(qb, "setRef");
function Jb(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = qb(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : qb(e[t], null);
			}
		};
	};
}
Kb(Jb, "composeRefs");
function Yb(...e) {
	return A.useCallback(Jb(...e), e);
}
Kb(Yb, "useComposedRefs");
//#endregion
//#region node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var Xb = Object.defineProperty, Zb = (e, t) => Xb(e, "name", {
	value: t,
	configurable: !0
});
function Qb(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Zb(Qb, "setRef");
function $b(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = Qb(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : Qb(e[t], null);
			}
		};
	};
}
Zb($b, "composeRefs");
function ex(...e) {
	return A.useCallback($b(...e), e);
}
Zb(ex, "useComposedRefs");
//#endregion
//#region node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var tx = Object.defineProperty, nx = (e, t) => tx(e, "name", {
	value: t,
	configurable: !0
});
function rx(e) {
	let t = A.useRef(e);
	return A.useEffect(() => {
		t.current = e;
	}), A.useMemo(() => ((...e) => t.current?.(...e)), []);
}
nx(rx, "useCallbackRef");
//#endregion
//#region node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var ix = Object.defineProperty, ax = (e, t) => ix(e, "name", {
	value: t,
	configurable: !0
}), ox = "dismissableLayer.update", sx = "dismissableLayer.pointerDownOutside", cx = "dismissableLayer.focusOutside", lx, ux = A.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set(),
	dismissableSurfaces: /* @__PURE__ */ new Set()
}), dx = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ax(function(e, t) {
	let { disableOutsidePointerEvents: n = !1, deferPointerDownOutside: r = !1, onEscapeKeyDown: i, onPointerDownOutside: a, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...l } = e, u = A.useContext(ux), [d, f] = A.useState(null), p = d?.ownerDocument ?? globalThis?.document, [, m] = A.useState({}), h = ex(t, f), g = Array.from(u.layers), [_] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), v = _ ? g.indexOf(_) : -1, y = d ? g.indexOf(d) : -1, b = u.layersWithOutsidePointerEventsDisabled.size > 0, x = y >= v, S = A.useRef(!1), C = mx((e) => {
		a?.(e), s?.(e), e.defaultPrevented || c?.();
	}, {
		ownerDocument: p,
		deferPointerDownOutside: r,
		isDeferredPointerDownOutsideRef: S,
		dismissableSurfaces: u.dismissableSurfaces,
		shouldHandlePointerDownOutside: A.useCallback((e) => {
			if (!(e instanceof Node)) return !1;
			let t = [...u.branches].some((t) => t.contains(e));
			return x && !t;
		}, [u.branches, x])
	}), w = hx((e) => {
		if (r && S.current) return;
		let t = e.target;
		[...u.branches].some((e) => e.contains(t)) || (o?.(e), s?.(e), e.defaultPrevented || c?.());
	}, p), T = d ? y === g.length - 1 : !1, E = rx((e) => {
		e.key === "Escape" && (i?.(e), !e.defaultPrevented && c && (e.preventDefault(), c()));
	});
	return A.useEffect(() => {
		if (T) return p.addEventListener("keydown", E, { capture: !0 }), () => p.removeEventListener("keydown", E, { capture: !0 });
	}, [
		p,
		T,
		E
	]), A.useEffect(() => {
		if (d) return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (lx = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), gx(), () => {
			n && (u.layersWithOutsidePointerEventsDisabled.delete(d), u.layersWithOutsidePointerEventsDisabled.size === 0 && (p.body.style.pointerEvents = lx));
		};
	}, [
		d,
		p,
		n,
		u
	]), A.useEffect(() => () => {
		d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), gx());
	}, [d, u]), A.useEffect(() => {
		let e = /* @__PURE__ */ ax(() => m({}), "handleUpdate");
		return document.addEventListener(ox, e), () => document.removeEventListener(ox, e);
	}, []), /* @__PURE__ */ (0, q.jsx)(vy.div, {
		...l,
		ref: h,
		style: {
			pointerEvents: b ? x ? "auto" : "none" : void 0,
			...e.style
		},
		onFocusCapture: cb(e.onFocusCapture, w.onFocusCapture),
		onBlurCapture: cb(e.onBlurCapture, w.onBlurCapture),
		onPointerDownCapture: cb(e.onPointerDownCapture, C.onPointerDownCapture)
	});
}, "DismissableLayer"));
function fx() {
	let e = A.useContext(ux), [t, n] = A.useState(null);
	return A.useEffect(() => {
		if (t) return e.dismissableSurfaces.add(t), () => {
			e.dismissableSurfaces.delete(t);
		};
	}, [t, e.dismissableSurfaces]), n;
}
ax(fx, "useDismissableLayerSurface");
var px = /* @__PURE__ */ ax(() => !0, "IS_TRUE");
function mx(e, t) {
	let { ownerDocument: n = globalThis?.document, deferPointerDownOutside: r = !1, isDeferredPointerDownOutsideRef: i, dismissableSurfaces: a, shouldHandlePointerDownOutside: o = px } = t, s = rx(e), c = A.useRef(!1), l = A.useRef(!1), u = A.useRef(/* @__PURE__ */ new Map()), d = A.useRef(() => {});
	return A.useEffect(() => {
		function e() {
			l.current = !1, i.current = !1, u.current.clear();
		}
		ax(e, "resetOutsideInteraction");
		function t() {
			return Array.from(u.current.values()).some(Boolean);
		}
		ax(t, "isOutsideInteractionIntercepted");
		function f(e) {
			if (!l.current) return;
			let t = e.target;
			t instanceof Node && [...a].some((e) => e.contains(t)) || u.current.set(e.type, !0), e.type === "click" && window.setTimeout(() => {
				l.current && d.current();
			}, 0);
		}
		ax(f, "handleInteractionCapture");
		function p(e) {
			l.current && u.current.set(e.type, !1);
		}
		ax(p, "handleInteractionBubble");
		let m = /* @__PURE__ */ ax((a) => {
			if (a.target && !c.current) {
				let f = function() {
					n.removeEventListener("click", d.current);
					let r = t();
					e(), r || _x(sx, s, p, { discrete: !0 });
				};
				if (ax(f, "handleAndDispatchPointerDownOutsideEvent"), !o(a.target)) {
					n.removeEventListener("click", d.current), e(), c.current = !1;
					return;
				}
				let p = { originalEvent: a };
				l.current = !0, i.current = r && a.button === 0, u.current.clear(), !r || a.button !== 0 ? f() : (n.removeEventListener("click", d.current), d.current = f, n.addEventListener("click", d.current, { once: !0 }));
			} else n.removeEventListener("click", d.current), e();
			c.current = !1;
		}, "handlePointerDown"), h = [
			"pointerup",
			"mousedown",
			"mouseup",
			"touchstart",
			"touchend",
			"click"
		];
		for (let e of h) n.addEventListener(e, f, !0), n.addEventListener(e, p);
		let g = window.setTimeout(() => {
			n.addEventListener("pointerdown", m);
		}, 0);
		return () => {
			window.clearTimeout(g), n.removeEventListener("pointerdown", m), n.removeEventListener("click", d.current);
			for (let e of h) n.removeEventListener(e, f, !0), n.removeEventListener(e, p);
		};
	}, [
		n,
		s,
		r,
		i,
		a,
		o
	]), { onPointerDownCapture: /* @__PURE__ */ ax(() => c.current = !0, "onPointerDownCapture") };
}
ax(mx, "usePointerDownOutside");
function hx(e, t = globalThis?.document) {
	let n = rx(e), r = A.useRef(!1);
	return A.useEffect(() => {
		let e = /* @__PURE__ */ ax((e) => {
			e.target && !r.current && _x(cx, n, { originalEvent: e }, { discrete: !1 });
		}, "handleFocus");
		return t.addEventListener("focusin", e), () => t.removeEventListener("focusin", e);
	}, [t, n]), {
		onFocusCapture: /* @__PURE__ */ ax(() => r.current = !0, "onFocusCapture"),
		onBlurCapture: /* @__PURE__ */ ax(() => r.current = !1, "onBlurCapture")
	};
}
ax(hx, "useFocusOutside");
function gx() {
	let e = new CustomEvent(ox);
	document.dispatchEvent(e);
}
ax(gx, "dispatchUpdate");
function _x(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? yy(i, a) : i.dispatchEvent(a);
}
ax(_x, "handleAndDispatchCustomEvent");
//#endregion
//#region node_modules/@radix-ui/react-focus-scope/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var vx = Object.defineProperty, yx = (e, t) => vx(e, "name", {
	value: t,
	configurable: !0
});
function bx(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
yx(bx, "setRef");
function xx(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = bx(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : bx(e[t], null);
			}
		};
	};
}
yx(xx, "composeRefs");
function Sx(...e) {
	return A.useCallback(xx(...e), e);
}
yx(Sx, "useComposedRefs");
//#endregion
//#region node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var Cx = Object.defineProperty, wx = (e, t) => Cx(e, "name", {
	value: t,
	configurable: !0
}), Tx = "focusScope.autoFocusOnMount", Ex = "focusScope.autoFocusOnUnmount", Dx = {
	bubbles: !1,
	cancelable: !0
}, Ox = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ wx(function(e, t) {
	let { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: a, ...o } = e, [s, c] = A.useState(null), l = rx(i), u = rx(a), d = A.useRef(null), f = Sx(t, c), p = A.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	A.useEffect(() => {
		if (r) {
			let e = function(e) {
				if (p.paused || !s) return;
				let t = e.target;
				s.contains(t) ? d.current = t : Fx(d.current, { select: !0 });
			}, t = function(e) {
				if (p.paused || !s) return;
				let t = e.relatedTarget;
				t !== null && (s.contains(t) || Fx(d.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && Fx(s);
			};
			wx(e, "handleFocusIn"), wx(t, "handleFocusOut"), wx(n, "handleMutations"), document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return s && r.observe(s, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		r,
		s,
		p.paused
	]), A.useEffect(() => {
		if (s) {
			Ix.add(p);
			let e = document.activeElement;
			if (!s.contains(e)) {
				let t = new CustomEvent(Tx, Dx);
				s.addEventListener(Tx, l), s.dispatchEvent(t), t.defaultPrevented || (kx(zx(jx(s)), { select: !0 }), document.activeElement === e && Fx(s));
			}
			return () => {
				s.removeEventListener(Tx, l), setTimeout(() => {
					let t = new CustomEvent(Ex, Dx);
					s.addEventListener(Ex, u), s.dispatchEvent(t), t.defaultPrevented || Fx(e ?? document.body, { select: !0 }), s.removeEventListener(Ex, u), Ix.remove(p);
				}, 0);
			};
		}
	}, [
		s,
		l,
		u,
		p
	]);
	let m = A.useCallback((e) => {
		if (!n && !r || p.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, i = document.activeElement;
		if (t && i) {
			let t = e.currentTarget, [r, a] = Ax(t);
			r && a ? !e.shiftKey && i === a ? (e.preventDefault(), n && Fx(r, { select: !0 })) : e.shiftKey && i === r && (e.preventDefault(), n && Fx(a, { select: !0 })) : i === t && e.preventDefault();
		}
	}, [
		n,
		r,
		p.paused
	]);
	return /* @__PURE__ */ (0, q.jsx)(vy.div, {
		tabIndex: -1,
		...o,
		ref: f,
		onKeyDown: m
	});
}, "FocusScope"));
function kx(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (Fx(r, { select: t }), document.activeElement !== n) return;
}
wx(kx, "focusFirst");
function Ax(e) {
	let t = jx(e);
	return [Mx(t, e), Mx(t.reverse(), e)];
}
wx(Ax, "getTabbableEdges");
function jx(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ wx((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
wx(jx, "getTabbableCandidates");
function Mx(e, t) {
	let n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
	for (let r of e) if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : Nx(r, { upTo: t }))) return r;
}
wx(Mx, "findVisible");
function Nx(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
wx(Nx, "isHidden");
function Px(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
wx(Px, "isSelectableInput");
function Fx(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && Px(e) && t && e.select();
	}
}
wx(Fx, "focus");
var Ix = Lx();
function Lx() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = Rx(e, t), e.unshift(t);
		},
		remove(t) {
			e = Rx(e, t), e[0]?.resume();
		}
	};
}
wx(Lx, "createFocusScopesStack");
function Rx(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
wx(Rx, "arrayRemove");
function zx(e) {
	return e.filter((e) => e.tagName !== "A");
}
wx(zx, "removeLinks");
//#endregion
//#region node_modules/@radix-ui/react-portal/dist/index.mjs
var Bx = Object.defineProperty, Vx = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ((e, t) => Bx(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	let { container: n, ...r } = e, [i, a] = A.useState(!1);
	pb(() => a(!0), []);
	let o = n || i && globalThis?.document?.body;
	return o ? Ce.createPortal(/* @__PURE__ */ (0, q.jsx)(vy.div, {
		...r,
		ref: t
	}), o) : null;
}, "Portal")), Hx = Object.defineProperty, Ux = (e, t) => Hx(e, "name", {
	value: t,
	configurable: !0
}), Wx = 0, Gx = null;
function Kx(e) {
	return qx(), e.children;
}
Ux(Kx, "FocusGuards");
function qx() {
	A.useEffect(() => {
		Gx ||= {
			start: Jx(),
			end: Jx()
		};
		let { start: e, end: t } = Gx;
		return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), Wx++, () => {
			Wx === 1 && (Gx?.start.remove(), Gx?.end.remove(), Gx = null), Wx = Math.max(0, Wx - 1);
		};
	}, []);
}
Ux(qx, "useFocusGuards");
function Jx() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
Ux(Jx, "createFocusGuard");
//#endregion
//#region node_modules/tslib/tslib.es6.mjs
var Yx = function() {
	return Yx = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, Yx.apply(this, arguments);
};
function Xx(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function Zx(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var Qx = "right-scroll-bar-position", $x = "width-before-scroll-bar", eS = "with-scroll-bars-hidden", tS = "--removed-body-scroll-bar-size";
//#endregion
//#region node_modules/use-callback-ref/dist/es2015/assignRef.js
function nS(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
//#endregion
//#region node_modules/use-callback-ref/dist/es2015/useRef.js
function rS(e, t) {
	var n = (0, A.useState)(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return n.value;
				},
				set current(e) {
					var t = n.value;
					t !== e && (n.value = e, n.callback(e, t));
				}
			}
		};
	})[0];
	return n.callback = t, n.facade;
}
//#endregion
//#region node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var iS = typeof window < "u" ? A.useLayoutEffect : A.useEffect, aS = /* @__PURE__ */ new WeakMap();
function oS(e, t) {
	var n = rS(t || null, function(t) {
		return e.forEach(function(e) {
			return nS(e, t);
		});
	});
	return iS(function() {
		var t = aS.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || nS(e, null);
			}), i.forEach(function(e) {
				r.has(e) || nS(e, a);
			});
		}
		aS.set(n, e);
	}, [e]), n;
}
//#endregion
//#region node_modules/use-sidecar/dist/es2015/medium.js
function sS(e) {
	return e;
}
function cS(e, t) {
	t === void 0 && (t = sS);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function lS(e) {
	e === void 0 && (e = {});
	var t = cS(null);
	return t.options = Yx({
		async: !0,
		ssr: !1
	}, e), t;
}
//#endregion
//#region node_modules/use-sidecar/dist/es2015/exports.js
var uS = function(e) {
	var t = e.sideCar, n = Xx(e, ["sideCar"]);
	if (!t) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var r = t.read();
	if (!r) throw Error("Sidecar medium not found");
	return A.createElement(r, Yx({}, n));
};
uS.isSideCarExport = !0;
function dS(e, t) {
	return e.useMedium(t), uS;
}
//#endregion
//#region node_modules/react-remove-scroll/dist/es2015/medium.js
var fS = lS(), pS = function() {}, mS = A.forwardRef(function(e, t) {
	var n = A.useRef(null), r = A.useState({
		onScrollCapture: pS,
		onWheelCapture: pS,
		onTouchMoveCapture: pS
	}), i = r[0], a = r[1], o = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, p = e.noRelative, m = e.noIsolation, h = e.inert, g = e.allowPinchZoom, _ = e.as, v = _ === void 0 ? "div" : _, y = e.gapMode, b = Xx(e, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noRelative",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), x = f, S = oS([n, t]), C = Yx(Yx({}, b), i);
	return A.createElement(A.Fragment, null, u && A.createElement(x, {
		sideCar: fS,
		removeScrollBar: l,
		shards: d,
		noRelative: p,
		noIsolation: m,
		inert: h,
		setCallbacks: a,
		allowPinchZoom: !!g,
		lockRef: n,
		gapMode: y
	}), o ? A.cloneElement(A.Children.only(s), Yx(Yx({}, C), { ref: S })) : A.createElement(v, Yx({}, C, {
		className: c,
		ref: S
	}), s));
});
mS.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, mS.classNames = {
	fullWidth: $x,
	zeroRight: Qx
};
//#endregion
//#region node_modules/get-nonce/dist/es2015/index.js
var hS, gS = function() {
	if (hS) return hS;
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
//#endregion
//#region node_modules/react-style-singleton/dist/es2015/singleton.js
function _S() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = gS();
	return t && e.setAttribute("nonce", t), e;
}
function vS(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function yS(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var bS = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = _S()) && (vS(t, n), yS(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, xS = function() {
	var e = bS();
	return function(t, n) {
		A.useEffect(function() {
			return e.add(t), function() {
				e.remove();
			};
		}, [t && n]);
	};
}, SS = function() {
	var e = xS();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, CS = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, wS = function(e) {
	return parseInt(e || "", 10) || 0;
}, TS = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		wS(n),
		wS(r),
		wS(i)
	];
}, ES = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return CS;
	var t = TS(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, DS = SS(), OS = "data-scroll-locked", kS = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${eS} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${OS}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${Qx} {
    right: ${s}px ${r};
  }
  
  .${$x} {
    margin-right: ${s}px ${r};
  }
  
  .${Qx} .${Qx} {
    right: 0 ${r};
  }
  
  .${$x} .${$x} {
    margin-right: 0 ${r};
  }
  
  body[${OS}] {
    ${tS}: ${s}px;
  }
`;
}, AS = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, jS = function() {
	A.useEffect(function() {
		return document.body.setAttribute(OS, (AS() + 1).toString()), function() {
			var e = AS() - 1;
			e <= 0 ? document.body.removeAttribute(OS) : document.body.setAttribute(OS, e.toString());
		};
	}, []);
}, MS = function(e) {
	var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
	jS();
	var a = A.useMemo(function() {
		return ES(i);
	}, [i]);
	return A.createElement(DS, { styles: kS(a, !t, i, n ? "" : "!important") });
}, NS = !1;
if (typeof window < "u") try {
	var PS = Object.defineProperty({}, "passive", { get: function() {
		return NS = !0, !0;
	} });
	window.addEventListener("test", PS, PS), window.removeEventListener("test", PS, PS);
} catch {
	NS = !1;
}
var FS = NS ? { passive: !1 } : !1, IS = function(e) {
	return e.tagName === "TEXTAREA";
}, LS = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !IS(e) && n[t] === "visible");
}, RS = function(e) {
	return LS(e, "overflowY");
}, zS = function(e) {
	return LS(e, "overflowX");
}, BS = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), US(e, r)) {
			var i = WS(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, VS = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, HS = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, US = function(e, t) {
	return e === "v" ? RS(t) : zS(t);
}, WS = function(e, t) {
	return e === "v" ? VS(t) : HS(t);
}, GS = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, KS = function(e, t, n, r, i) {
	var a = GS(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		if (!s) break;
		var p = WS(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && US(e, s) && (d += h, f += m);
		var g = s.parentNode;
		s = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
}, qS = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, JS = function(e) {
	return [e.deltaX, e.deltaY];
}, YS = function(e) {
	return e && "current" in e ? e.current : e;
}, XS = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, ZS = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, QS = 0, $S = [];
function eC(e) {
	var t = A.useRef([]), n = A.useRef([0, 0]), r = A.useRef(), i = A.useState(QS++)[0], a = A.useState(SS)[0], o = A.useRef(e);
	A.useEffect(function() {
		o.current = e;
	}, [e]), A.useEffect(function() {
		if (e.inert) {
			document.body.classList.add(`block-interactivity-${i}`);
			var t = Zx([e.lockRef.current], (e.shards || []).map(YS), !0).filter(Boolean);
			return t.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${i}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${i}`), t.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${i}`);
				});
			};
		}
	}, [
		e.inert,
		e.lockRef.current,
		e.shards
	]);
	var s = A.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !o.current.allowPinchZoom;
		var i = qS(e), a = n.current, s = "deltaX" in e ? e.deltaX : a[0] - i[0], c = "deltaY" in e ? e.deltaY : a[1] - i[1], l, u = e.target, d = Math.abs(s) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = window.getSelection(), p = f && f.anchorNode;
		if (p && (p === u || p.contains(u))) return !1;
		var m = BS(d, u);
		if (!m) return !0;
		if (m ? l = d : (l = d === "v" ? "h" : "v", m = BS(d, u)), !m) return !1;
		if (!r.current && "changedTouches" in e && (s || c) && (r.current = l), !l) return !0;
		var h = r.current || l;
		return KS(h, t, e, h === "h" ? s : c, !0);
	}, []), c = A.useCallback(function(e) {
		var n = e;
		if (!(!$S.length || $S[$S.length - 1] !== a)) {
			var r = "deltaY" in n ? JS(n) : qS(n), i = t.current.filter(function(e) {
				return e.name === n.type && (e.target === n.target || n.target === e.shadowParent) && XS(e.delta, r);
			})[0];
			if (i && i.should) {
				n.cancelable && n.preventDefault();
				return;
			}
			if (!i) {
				var c = (o.current.shards || []).map(YS).filter(Boolean).filter(function(e) {
					return e.contains(n.target);
				});
				(c.length > 0 ? s(n, c[0]) : !o.current.noIsolation) && n.cancelable && n.preventDefault();
			}
		}
	}, []), l = A.useCallback(function(e, n, r, i) {
		var a = {
			name: e,
			delta: n,
			target: r,
			should: i,
			shadowParent: tC(r)
		};
		t.current.push(a), setTimeout(function() {
			t.current = t.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), u = A.useCallback(function(e) {
		n.current = qS(e), r.current = void 0;
	}, []), d = A.useCallback(function(t) {
		l(t.type, JS(t), t.target, s(t, e.lockRef.current));
	}, []), f = A.useCallback(function(t) {
		l(t.type, qS(t), t.target, s(t, e.lockRef.current));
	}, []);
	A.useEffect(function() {
		return $S.push(a), e.setCallbacks({
			onScrollCapture: d,
			onWheelCapture: d,
			onTouchMoveCapture: f
		}), document.addEventListener("wheel", c, FS), document.addEventListener("touchmove", c, FS), document.addEventListener("touchstart", u, FS), function() {
			$S = $S.filter(function(e) {
				return e !== a;
			}), document.removeEventListener("wheel", c, FS), document.removeEventListener("touchmove", c, FS), document.removeEventListener("touchstart", u, FS);
		};
	}, []);
	var p = e.removeScrollBar, m = e.inert;
	return A.createElement(A.Fragment, null, m ? A.createElement(a, { styles: ZS(i) }) : null, p ? A.createElement(MS, {
		noRelative: e.noRelative,
		gapMode: e.gapMode
	}) : null);
}
function tC(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
//#endregion
//#region node_modules/react-remove-scroll/dist/es2015/sidecar.js
var nC = dS(fS, eC), rC = A.forwardRef(function(e, t) {
	return A.createElement(mS, Yx({}, e, {
		ref: t,
		sideCar: nC
	}));
});
rC.classNames = mS.classNames;
//#endregion
//#region node_modules/aria-hidden/dist/es2015/index.js
var iC = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, aC = /* @__PURE__ */ new WeakMap(), oC = /* @__PURE__ */ new WeakMap(), sC = {}, cC = 0, lC = function(e) {
	return e && (e.host || lC(e.parentNode));
}, uC = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = lC(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, dC = function(e, t, n, r) {
	var i = uC(t, Array.isArray(e) ? e : [e]);
	sC[n] || (sC[n] = /* @__PURE__ */ new WeakMap());
	var a = sC[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		!e || s.has(e) || (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		!e || c.has(e) || Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (aC.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				aC.set(e, c), a.set(e, l), o.push(e), c === 1 && i && oC.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), cC++, function() {
		o.forEach(function(e) {
			var t = aC.get(e) - 1, i = a.get(e) - 1;
			aC.set(e, t), a.set(e, i), t || (oC.has(e) || e.removeAttribute(r), oC.delete(e)), i || e.removeAttribute(n);
		}), cC--, cC || (aC = /* @__PURE__ */ new WeakMap(), aC = /* @__PURE__ */ new WeakMap(), oC = /* @__PURE__ */ new WeakMap(), sC = {});
	};
}, fC = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || iC(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), dC(r, i, n, "aria-hidden")) : function() {
		return null;
	};
}, pC = Object.defineProperty, mC = (e, t) => pC(e, "name", {
	value: t,
	configurable: !0
});
/* @__NO_SIDE_EFFECTS__ */
function hC(e) {
	let t = A.forwardRef((t, n) => {
		let { children: r, ...i } = t, a = null, o = !1, s = [];
		CC(r) && typeof DC == "function" && (r = DC(r._payload)), A.Children.forEach(r, (e) => {
			if (xC(e)) {
				o = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				CC(n) && typeof DC == "function" && (n = DC(n._payload)), a = vC(t, n), s.push(a?.props?.children);
			} else s.push(e);
		}), a ? a = A.cloneElement(a, void 0, s) : !o && A.Children.count(r) === 1 && A.isValidElement(r) && (a = r);
		let c = a ? bC(a) : void 0, l = Yb(n, c);
		if (!a) {
			if (r || r === 0) throw Error(o ? EC(e) : TC(e));
			return r;
		}
		let u = yC(i, a.props ?? {});
		return a.type !== A.Fragment && (u.ref = n ? l : c), A.cloneElement(a, u);
	});
	return t.displayName = `${e}.Slot`, t;
}
mC(hC, "createSlot");
var gC = Symbol.for("radix.slottable");
/* @__NO_SIDE_EFFECTS__ */
function _C(e) {
	let t = /* @__PURE__ */ mC((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = gC, t;
}
mC(_C, "createSlottable");
var vC = /* @__PURE__ */ mC((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return A.isValidElement(t) ? A.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return A.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function yC(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
mC(yC, "mergeProps");
function bC(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
mC(bC, "getElementRef");
function xC(e) {
	return A.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === gC;
}
mC(xC, "isSlottable");
var SC = Symbol.for("react.lazy");
function CC(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === SC && "_payload" in e && wC(e._payload);
}
mC(CC, "isLazyComponent");
function wC(e) {
	return typeof e == "object" && !!e && "then" in e;
}
mC(wC, "isPromiseLike");
var TC = /* @__PURE__ */ mC((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), EC = /* @__PURE__ */ mC((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), DC = A.use, OC = Object.defineProperty, kC = (e, t) => OC(e, "name", {
	value: t,
	configurable: !0
}), AC = "Dialog", [jC, MC] = /* @__PURE__ */ wy(AC), [NC, PC] = jC(AC), FC = /* @__PURE__ */ kC((e) => {
	let { __scopeDialog: t, children: n, open: r, defaultOpen: i, onOpenChange: a, modal: o = !0 } = e, s = A.useRef(null), c = A.useRef(null), [l, u] = Sb({
		prop: r,
		defaultProp: i ?? !1,
		onChange: a,
		caller: AC
	}), [d, f] = A.useState(0), [p, m] = A.useState(0);
	return /* @__PURE__ */ (0, q.jsx)(NC, {
		scope: t,
		triggerRef: s,
		contentRef: c,
		contentId: Bb(),
		titleId: Bb(),
		descriptionId: Bb(),
		titlePresent: d > 0,
		descriptionPresent: p > 0,
		setTitleCount: f,
		setDescriptionCount: m,
		open: l,
		onOpenChange: u,
		onOpenToggle: A.useCallback(() => u((e) => !e), [u]),
		modal: o,
		children: n
	});
}, "Dialog"), IC = "DialogTrigger", LC = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ kC(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = PC(IC, n), a = Yb(t, i.triggerRef);
	return /* @__PURE__ */ (0, q.jsx)(vy.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": i.open,
		"aria-controls": i.open ? i.contentId : void 0,
		"data-state": rw(i.open),
		...r,
		ref: a,
		onClick: cb(e.onClick, i.onOpenToggle)
	});
}, "DialogTrigger")), RC = "DialogPortal", [zC, BC] = jC(RC, { forceMount: void 0 }), VC = /* @__PURE__ */ kC((e) => {
	let { __scopeDialog: t, forceMount: n, children: r, container: i } = e, a = PC(RC, t);
	return /* @__PURE__ */ (0, q.jsx)(zC, {
		scope: t,
		forceMount: n,
		children: A.Children.map(r, (e) => /* @__PURE__ */ (0, q.jsx)(Ab, {
			present: n || a.open,
			children: /* @__PURE__ */ (0, q.jsx)(Vx, {
				asChild: !0,
				container: i,
				children: e
			})
		}))
	});
}, "DialogPortal"), HC = "DialogOverlay", UC = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ kC(function(e, t) {
	let n = BC(HC, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = PC(HC, e.__scopeDialog);
	return a.modal ? /* @__PURE__ */ (0, q.jsx)(Ab, {
		present: r || a.open,
		children: /* @__PURE__ */ (0, q.jsx)(GC, {
			...i,
			ref: t
		})
	}) : null;
}, "DialogOverlay")), WC = /* @__PURE__ */ hC("DialogOverlay.RemoveScroll"), GC = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ kC(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = PC(HC, n), a = Yb(t, fx());
	return /* @__PURE__ */ (0, q.jsx)(rC, {
		as: WC,
		allowPinchZoom: !0,
		shards: [i.contentRef],
		children: /* @__PURE__ */ (0, q.jsx)(vy.div, {
			"data-state": rw(i.open),
			...r,
			ref: a,
			style: {
				pointerEvents: "auto",
				...r.style
			}
		})
	});
}, "DialogOverlayImpl")), KC = "DialogContent", qC = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ kC(function(e, t) {
	let n = BC(KC, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = PC(KC, e.__scopeDialog);
	return /* @__PURE__ */ (0, q.jsx)(Ab, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ (0, q.jsx)(JC, {
			...i,
			ref: t
		}) : /* @__PURE__ */ (0, q.jsx)(YC, {
			...i,
			ref: t
		})
	});
}, "DialogContent")), JC = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ kC(function(e, t) {
	let n = PC(KC, e.__scopeDialog), r = A.useRef(null), i = Yb(t, n.contentRef, r);
	return A.useEffect(() => {
		let e = r.current;
		if (e) return fC(e);
	}, []), /* @__PURE__ */ (0, q.jsx)(XC, {
		...e,
		ref: i,
		trapFocus: n.open,
		disableOutsidePointerEvents: n.open,
		onCloseAutoFocus: cb(e.onCloseAutoFocus, (e) => {
			e.preventDefault(), n.triggerRef.current?.focus();
		}),
		onPointerDownOutside: cb(e.onPointerDownOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
			(t.button === 2 || n) && e.preventDefault();
		}),
		onFocusOutside: cb(e.onFocusOutside, (e) => e.preventDefault())
	});
}, "DialogContentModal")), YC = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ kC(function(e, t) {
	let n = PC(KC, e.__scopeDialog), r = A.useRef(!1), i = A.useRef(!1);
	return /* @__PURE__ */ (0, q.jsx)(XC, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (t) => {
			e.onCloseAutoFocus?.(t), t.defaultPrevented || (r.current || n.triggerRef.current?.focus(), t.preventDefault()), r.current = !1, i.current = !1;
		},
		onInteractOutside: (t) => {
			e.onInteractOutside?.(t), t.defaultPrevented || (r.current = !0, t.detail.originalEvent.type === "pointerdown" && (i.current = !0));
			let a = t.target;
			n.triggerRef.current?.contains(a) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && i.current && t.preventDefault();
		}
	});
}, "DialogContentNonModal")), XC = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ kC(function(e, t) {
	let { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...o } = e, s = PC(KC, n);
	return qx(), /* @__PURE__ */ (0, q.jsx)(q.Fragment, { children: /* @__PURE__ */ (0, q.jsx)(Ox, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: i,
		onUnmountAutoFocus: a,
		children: /* @__PURE__ */ (0, q.jsx)(dx, {
			role: "dialog",
			id: s.contentId,
			"aria-describedby": s.descriptionPresent ? s.descriptionId : void 0,
			"aria-labelledby": s.titlePresent ? s.titleId : void 0,
			"data-state": rw(s.open),
			...o,
			ref: t,
			deferPointerDownOutside: !0,
			onDismiss: () => s.onOpenChange(!1)
		})
	}) });
}, "DialogContentImpl")), ZC = "DialogTitle", QC = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ kC(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = PC(ZC, n), { setTitleCount: a } = i;
	return pb(() => (a((e) => e + 1), () => a((e) => e - 1)), [a]), /* @__PURE__ */ (0, q.jsx)(vy.h2, {
		id: i.titleId,
		...r,
		ref: t
	});
}, "DialogTitle")), $C = "DialogDescription", ew = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ kC(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = PC($C, n), { setDescriptionCount: a } = i;
	return pb(() => (a((e) => e + 1), () => a((e) => e - 1)), [a]), /* @__PURE__ */ (0, q.jsx)(vy.p, {
		id: i.descriptionId,
		...r,
		ref: t
	});
}, "DialogDescription")), tw = "DialogClose", nw = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ kC(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = PC(tw, n);
	return /* @__PURE__ */ (0, q.jsx)(vy.button, {
		type: "button",
		...r,
		ref: t,
		onClick: cb(e.onClick, () => i.onOpenChange(!1))
	});
}, "DialogClose"));
function rw(e) {
	return e ? "open" : "closed";
}
kC(rw, "getState");
//#endregion
//#region node_modules/@radix-ui/react-use-size/dist/index.mjs
var iw = Object.defineProperty, aw = (e, t) => iw(e, "name", {
	value: t,
	configurable: !0
});
function ow(e) {
	let [t, n] = A.useState(void 0);
	return pb(() => {
		if (e) {
			n({
				width: e.offsetWidth,
				height: e.offsetHeight
			});
			let t = new ResizeObserver((t) => {
				if (!Array.isArray(t) || !t.length) return;
				let r = t[0], i, a;
				if ("borderBoxSize" in r) {
					let e = r.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = e.offsetWidth, a = e.offsetHeight;
				n({
					width: i,
					height: a
				});
			});
			return t.observe(e, { box: "border-box" }), () => t.unobserve(e);
		} else n(void 0);
	}, [e]), t;
}
aw(ow, "useSize");
//#endregion
//#region node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var sw = [
	"top",
	"right",
	"bottom",
	"left"
], cw = Math.min, lw = Math.max, uw = Math.round, dw = Math.floor, fw = (e) => ({
	x: e,
	y: e
}), pw = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function mw(e, t, n) {
	return lw(e, cw(t, n));
}
function hw(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function gw(e) {
	return e.split("-")[0];
}
function _w(e) {
	return e.split("-")[1];
}
function vw(e) {
	return e === "x" ? "y" : "x";
}
function yw(e) {
	return e === "y" ? "height" : "width";
}
function bw(e) {
	let t = e[0];
	return t === "t" || t === "b" ? "y" : "x";
}
function xw(e) {
	return vw(bw(e));
}
function Sw(e, t, n) {
	n === void 0 && (n = !1);
	let r = _w(e), i = xw(e), a = yw(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = jw(o)), [o, jw(o)];
}
function Cw(e) {
	let t = jw(e);
	return [
		ww(e),
		t,
		ww(t)
	];
}
function ww(e) {
	return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var Tw = ["left", "right"], Ew = ["right", "left"], Dw = ["top", "bottom"], Ow = ["bottom", "top"];
function kw(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? Ew : Tw : t ? Tw : Ew;
		case "left":
		case "right": return t ? Dw : Ow;
		default: return [];
	}
}
function Aw(e, t, n, r) {
	let i = _w(e), a = kw(gw(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(ww)))), a;
}
function jw(e) {
	let t = gw(e);
	return pw[t] + e.slice(t.length);
}
function Mw(e) {
	return {
		top: e.top ?? 0,
		right: e.right ?? 0,
		bottom: e.bottom ?? 0,
		left: e.left ?? 0
	};
}
function Nw(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : Mw(e);
}
function Pw(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function Fw(e, t, n) {
	let { reference: r, floating: i } = e, a = bw(t), o = xw(t), s = yw(o), c = gw(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	let m = _w(t);
	return m && (p[o] += f * (m === "end" ? 1 : -1) * (n && l ? -1 : 1)), p;
}
async function Iw(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = hw(t, e), p = Nw(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = Pw(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = Pw(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var Lw = 50, Rw = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
		...o,
		detectOverflow: Iw
	}, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = Fw(l, r, c), f = r, p = 0, m = {};
	for (let n = 0; n < a.length; n++) {
		let h = a[n];
		if (!h) continue;
		let { name: g, fn: _ } = h, { x: v, y, data: b, reset: x } = await _({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: m,
			rects: l,
			platform: s,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = v ?? u, d = y ?? d, m[g] = {
			...m[g],
			...b
		}, x && p < Lw && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : x.rects), {x: u, y: d} = Fw(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: m
	};
}, zw = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = hw(e, t) || {};
		if (l == null) return {};
		let d = Nw(u), f = {
			x: n,
			y: r
		}, p = xw(i), m = yw(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = cw(d[_], T), D = cw(d[v], T), O = C - h[m] - D, k = C / 2 - h[m] / 2 + w, A = mw(E, k, O), j = !c.arrow && _w(i) != null && k !== A && a.reference[m] / 2 - (k < E ? E : D) - h[m] / 2 < 0, M = j ? k < E ? k - E : k - O : 0;
		return {
			[p]: f[p] + M,
			data: {
				[p]: A,
				centerOffset: k - A - M,
				...j && { alignmentOffset: M }
			},
			reset: j
		};
	}
}), Bw = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = hw(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = gw(r), _ = bw(o), v = gw(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [jw(o)] : Cw(o)), x = p !== "none";
			!d && x && b.push(...Aw(o, m, p, y));
			let S = [o, ...b], C = await s.detectOverflow(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = Sw(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (!(u === "alignment" && _ !== bw(t)) || T.every((e) => bw(e.placement) === _ ? e.overflows[0] > 0 : !0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = bw(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement":
						n = o;
						break;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
};
function Vw(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function Hw(e) {
	return sw.some((t) => e[t] >= 0);
}
var Uw = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n, platform: r } = t, { strategy: i = "referenceHidden", ...a } = hw(e, t);
			switch (i) {
				case "referenceHidden": {
					let e = Vw(await r.detectOverflow(t, {
						...a,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: Hw(e)
					} };
				}
				case "escaped": {
					let e = Vw(await r.detectOverflow(t, {
						...a,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: Hw(e)
					} };
				}
				default: return {};
			}
		}
	};
}, Ww = /* @__PURE__ */ new Set(["left", "top"]);
async function Gw(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = gw(n), s = _w(n), c = bw(n) === "y", l = Ww.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = hw(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var Kw = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await Gw(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, qw = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i, platform: a } = t, { mainAxis: o = !0, crossAxis: s = !1, limiter: c = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...l } = hw(e, t), u = {
				x: n,
				y: r
			}, d = await a.detectOverflow(t, l), f = bw(i), p = vw(f), m = u[p], h = u[f], g = (e, t) => mw(t + d[e === "y" ? "top" : "left"], t, t - d[e === "y" ? "bottom" : "right"]);
			o && (m = g(p, m)), s && (h = g(f, h));
			let _ = c.fn({
				...t,
				[p]: m,
				[f]: h
			});
			return {
				..._,
				data: {
					x: _.x - n,
					y: _.y - r,
					enabled: {
						[p]: o,
						[f]: s
					}
				}
			};
		}
	};
}, Jw = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = hw(e, t), u = {
				x: n,
				y: r
			}, d = bw(i), f = vw(d), p = u[f], m = u[d], h = hw(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: h.mainAxis ?? 0,
				crossAxis: h.crossAxis ?? 0
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = Ww.has(gw(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, Yw = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			let { placement: n, rects: r, platform: i, elements: a } = t, { apply: o = () => {}, ...s } = hw(e, t), c = await i.detectOverflow(t, s), l = gw(n), u = _w(n), d = bw(n) === "y", { width: f, height: p } = r.floating, m, h;
			l === "top" || l === "bottom" ? (m = l, h = u === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (h = l, m = u === "end" ? "top" : "bottom");
			let g = p - c.top - c.bottom, _ = f - c.left - c.right, v = cw(p - c[m], g), y = cw(f - c[h], _), b = t.middlewareData.shift, x = !b, S = v, C = y;
			b != null && b.enabled.x && (C = _), b != null && b.enabled.y && (S = g), x && !u && (d ? C = f - 2 * lw(c.left, c.right) : S = p - 2 * lw(c.top, c.bottom)), await o({
				...t,
				availableWidth: C,
				availableHeight: S
			});
			let w = await i.getDimensions(a.floating);
			return f !== w.width || p !== w.height ? { reset: { rects: !0 } } : {};
		}
	};
};
//#endregion
//#region node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Xw() {
	return typeof window < "u";
}
function Zw(e) {
	return eT(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Qw(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function $w(e) {
	return ((eT(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function eT(e) {
	return Xw() ? e instanceof Node || e instanceof Qw(e).Node : !1;
}
function tT(e) {
	return Xw() ? e instanceof Element || e instanceof Qw(e).Element : !1;
}
function nT(e) {
	return Xw() ? e instanceof HTMLElement || e instanceof Qw(e).HTMLElement : !1;
}
function rT(e) {
	return !Xw() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Qw(e).ShadowRoot;
}
function iT(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = hT(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function aT(e) {
	return /^(table|td|th)$/.test(Zw(e));
}
function oT(e) {
	try {
		if (e.matches(":popover-open")) return !0;
	} catch {}
	try {
		return e.matches(":modal");
	} catch {
		return !1;
	}
}
var sT = /transform|translate|scale|rotate|perspective|filter/, cT = /paint|layout|strict|content/, lT = (e) => !!e && e !== "none", uT;
function dT(e) {
	let t = tT(e) ? hT(e) : e;
	return lT(t.transform) || lT(t.translate) || lT(t.scale) || lT(t.rotate) || lT(t.perspective) || !pT() && (lT(t.backdropFilter) || lT(t.filter)) || sT.test(t.willChange || "") || cT.test(t.contain || "");
}
function fT(e) {
	let t = _T(e);
	for (; nT(t) && !mT(t);) {
		if (dT(t)) return t;
		if (oT(t)) return null;
		t = _T(t);
	}
	return null;
}
function pT() {
	return uT ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), uT;
}
function mT(e) {
	return /^(html|body|#document)$/.test(Zw(e));
}
function hT(e) {
	return Qw(e).getComputedStyle(e);
}
function gT(e) {
	return tT(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function _T(e) {
	if (Zw(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || rT(e) && e.host || $w(e);
	return rT(t) ? t.host : t;
}
function vT(e) {
	let t = _T(e);
	return mT(t) ? (e.ownerDocument || e).body : nT(t) && iT(t) ? t : vT(t);
}
function yT(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = vT(e), i = r === e.ownerDocument?.body, a = Qw(r);
	if (i) {
		let e = bT(a);
		return t.concat(a, a.visualViewport || [], iT(r) ? r : [], e && n ? yT(e) : []);
	} else return t.concat(r, yT(r, [], n));
}
function bT(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function xT(e) {
	let t = hT(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = nT(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = uw(n) !== a || uw(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function ST(e) {
	return tT(e) ? e : e.contextElement;
}
function CT(e) {
	let t = ST(e);
	if (!nT(t)) return fw(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = xT(t), o = (a ? uw(n.width) : n.width) / r, s = (a ? uw(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var wT = /* @__PURE__ */ fw(0);
function TT(e) {
	let t = Qw(e);
	return !pT() || !t.visualViewport ? wT : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function ET(e, t, n) {
	return t === void 0 && (t = !1), !!n && t && n === Qw(e);
}
function DT(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = ST(e), o = fw(1);
	t && (r ? tT(r) && (o = CT(r)) : o = CT(e));
	let s = ET(a, n, r) ? TT(a) : fw(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a && r) {
		let e = Qw(a), t = tT(r) ? Qw(r) : r, n = e, i = bT(n);
		for (; i && t !== n;) {
			let e = CT(i), t = i.getBoundingClientRect(), r = hT(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = Qw(i), i = bT(n);
		}
	}
	return Pw({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function OT(e, t) {
	let n = gT(e).scrollLeft;
	return t ? t.left + n : DT($w(e)).left + n;
}
function kT(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - OT(e, n),
		y: n.top + t.scrollTop
	};
}
function AT(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = $w(r), s = t ? oT(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = fw(1), u = fw(0), d = nT(r);
	if ((d || !a) && ((Zw(r) !== "body" || iT(o)) && (c = gT(r)), d)) {
		let e = DT(r);
		l = CT(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? kT(o, c) : fw(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function jT(e) {
	return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function MT(e) {
	let t = gT(e), n = e.ownerDocument.body, r = lw(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), i = lw(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight), a = -t.scrollLeft + OT(e), o = -t.scrollTop;
	return hT(n).direction === "rtl" && (a += lw(e.clientWidth, n.clientWidth) - r), {
		width: r,
		height: i,
		x: a,
		y: o
	};
}
var NT = 25;
function PT(e, t, n) {
	n === void 0 && (n = "viewport");
	let r = n === "layoutViewport", i = Qw(e), a = $w(e), o = i.visualViewport, s = a.clientWidth, c = a.clientHeight, l = 0, u = 0;
	if (o) {
		let e = !pT() || t === "fixed";
		r ? e || (l = -o.offsetLeft, u = -o.offsetTop) : (s = o.width, c = o.height, e && (l = o.offsetLeft, u = o.offsetTop));
	}
	if (OT(a) <= 0) {
		let e = a.ownerDocument, t = e.body, n = getComputedStyle(t), r = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, i = Math.abs(a.clientWidth - t.clientWidth - r), o = getComputedStyle(a).scrollbarGutter === "stable both-edges" ? i / 2 : i;
		o <= NT && (s -= o);
	}
	return {
		width: s,
		height: c,
		x: l,
		y: u
	};
}
function FT(e, t) {
	let n = DT(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = CT(e);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function IT(e, t, n) {
	let r;
	if (t === "viewport" || t === "layoutViewport") r = PT(e, n, t);
	else if (t === "document") r = MT($w(e));
	else if (tT(t)) r = FT(t, n);
	else {
		let n = TT(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return Pw(r);
}
function LT(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = yT(e, [], !1).filter((e) => tT(e) && Zw(e) !== "body"), i = null, a = hT(e).position === "fixed", o = a ? _T(e) : e;
	for (; tT(o) && !mT(o);) {
		let e = hT(o), t = dT(o), n = i ? i.position : a ? "fixed" : "";
		!t && (n === "fixed" || n === "absolute" && e.position === "static") ? r = r.filter((e) => e !== o) : i = e, o = _T(o);
	}
	return t.set(e, r), r;
}
function RT(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? oT(t) ? [] : LT(t, this._c) : [].concat(n), r], o = IT(t, a[0], i), s = o.top, c = o.right, l = o.bottom, u = o.left;
	for (let e = 1; e < a.length; e++) {
		let n = IT(t, a[e], i);
		s = lw(n.top, s), c = cw(n.right, c), l = cw(n.bottom, l), u = lw(n.left, u);
	}
	return {
		width: c - u,
		height: l - s,
		x: u,
		y: s
	};
}
function zT(e) {
	let { width: t, height: n } = xT(e);
	return {
		width: t,
		height: n
	};
}
function BT(e, t, n) {
	let r = nT(t), i = $w(t), a = n === "fixed", o = DT(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = fw(0);
	if ((r || !a) && ((Zw(t) !== "body" || iT(i)) && (s = gT(t)), r)) {
		let e = DT(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	}
	!r && i && (c.x = OT(i));
	let l = i && !r && !a ? kT(i, s) : fw(0);
	return {
		x: o.left + s.scrollLeft - c.x - l.x,
		y: o.top + s.scrollTop - c.y - l.y,
		width: o.width,
		height: o.height
	};
}
function VT(e) {
	return hT(e).position === "static";
}
function HT(e, t) {
	if (!nT(e) || hT(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return $w(e) === n && (n = n.ownerDocument.body), n;
}
function UT(e, t) {
	let n = Qw(e);
	if (oT(e)) return n;
	if (!nT(e)) {
		let t = _T(e);
		for (; t && !mT(t);) {
			if (tT(t) && !VT(t)) return t;
			t = _T(t);
		}
		return n;
	}
	let r = HT(e, t);
	for (; r && aT(r) && VT(r);) r = HT(r, t);
	return r && mT(r) && VT(r) && !dT(r) ? n : r || fT(e) || n;
}
var WT = async function(e) {
	let t = this.getOffsetParent || UT, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: BT(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function GT(e) {
	return hT(e).direction === "rtl";
}
var KT = {
	convertOffsetParentRelativeRectToViewportRelativeRect: AT,
	getDocumentElement: $w,
	getClippingRect: RT,
	getOffsetParent: UT,
	getElementRects: WT,
	getClientRects: jT,
	getDimensions: zT,
	getScale: CT,
	isElement: tT,
	isRTL: GT
};
function qT(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function JT(e, t, n) {
	let r = null, i, a = $w(e);
	function o() {
		var e;
		clearTimeout(i), (e = r) == null || e.disconnect(), r = null;
	}
	function s(n, c) {
		n === void 0 && (n = !1), c === void 0 && (c = 1), o();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (n || t(), !f || !p) return;
		let m = dw(d), h = dw(a.clientWidth - (u + f)), g = dw(a.clientHeight - (d + p)), _ = dw(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: lw(0, cw(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (!qT(l, e.getBoundingClientRect())) return s();
			if (n !== c) {
				if (!y) return s();
				n ? s(!1, n) : i = setTimeout(() => {
					s(!1, 1e-7);
				}, 1e3);
			}
			y = !1;
		}
		try {
			r = new IntersectionObserver(b, {
				...v,
				root: a.ownerDocument
			});
		} catch {
			r = new IntersectionObserver(b, v);
		}
		r.observe(e);
	}
	let c = Qw(e), l = () => s(n);
	return c.addEventListener("resize", l), s(!0), () => {
		c.removeEventListener("resize", l), o();
	};
}
function YT(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = ST(e), u = i || a ? [...l ? yT(l) : [], ...t ? yT(t) : []] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n), a && e.addEventListener("resize", n);
	});
	let d = l && s ? JT(l, n, a) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), t && p.observe(t));
	let m, h = c ? DT(e) : null;
	c && g();
	function g() {
		let t = DT(e);
		h && !qT(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var XT = Kw, ZT = qw, QT = Bw, $T = Yw, eE = Uw, tE = zw, nE = Jw, rE = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = n ?? {}, a = {
		...KT,
		...i.platform,
		_c: r
	};
	return Rw(e, t, {
		...i,
		platform: a
	});
}, iE = typeof document < "u" ? A.useLayoutEffect : function() {};
function aE(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!aE(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !aE(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function oE(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function sE(e, t) {
	let n = oE(e);
	return Math.round(t * n) / n;
}
function cE(e) {
	let t = A.useRef(e);
	return iE(() => {
		t.current = e;
	}), t;
}
function lE(e) {
	e === void 0 && (e = {});
	let { placement: t = "bottom", strategy: n = "absolute", middleware: r = [], platform: i, elements: { reference: a, floating: o } = {}, transform: s = !0, whileElementsMounted: c, open: l } = e, [u, d] = A.useState({
		x: 0,
		y: 0,
		strategy: n,
		placement: t,
		middlewareData: {},
		isPositioned: !1
	}), [f, p] = A.useState(r);
	aE(f, r) || p(r);
	let [m, h] = A.useState(null), [g, _] = A.useState(null), v = A.useCallback((e) => {
		e !== S.current && (S.current = e, h(e));
	}, []), y = A.useCallback((e) => {
		e !== C.current && (C.current = e, _(e));
	}, []), b = a || m, x = o || g, S = A.useRef(null), C = A.useRef(null), w = A.useRef(u), T = c != null, E = cE(c), D = cE(i), O = cE(l), k = A.useCallback(() => {
		if (!S.current || !C.current) return;
		let e = {
			placement: t,
			strategy: n,
			middleware: f
		};
		D.current && (e.platform = D.current), rE(S.current, C.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: O.current !== !1
			};
			j.current && !aE(w.current, t) && (w.current = t, Ce.flushSync(() => {
				d(t);
			}));
		});
	}, [
		f,
		t,
		n,
		D,
		O
	]);
	iE(() => {
		l === !1 && w.current.isPositioned && (w.current.isPositioned = !1, d((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [l]);
	let j = A.useRef(!1);
	iE(() => (j.current = !0, () => {
		j.current = !1;
	}), []), iE(() => {
		if (b && (S.current = b), x && (C.current = x), b && x) {
			if (E.current) return E.current(b, x, k);
			k();
		}
	}, [
		b,
		x,
		k,
		E,
		T
	]);
	let M = A.useMemo(() => ({
		reference: S,
		floating: C,
		setReference: v,
		setFloating: y
	}), [v, y]), N = A.useMemo(() => ({
		reference: b,
		floating: x
	}), [b, x]), P = A.useMemo(() => {
		let e = {
			position: n,
			left: 0,
			top: 0
		};
		if (!N.floating) return e;
		let t = sE(N.floating, u.x), r = sE(N.floating, u.y);
		return s ? {
			...e,
			transform: "translate(" + t + "px, " + r + "px)",
			...oE(N.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: n,
			left: t,
			top: r
		};
	}, [
		n,
		s,
		N.floating,
		u.x,
		u.y
	]);
	return A.useMemo(() => ({
		...u,
		update: k,
		refs: M,
		elements: N,
		floatingStyles: P
	}), [
		u,
		k,
		M,
		N,
		P
	]);
}
var uE = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : tE({
				element: r.current,
				padding: i
			}).fn(n) : r ? tE({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, dE = (e, t) => {
	let n = XT(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, fE = (e, t) => {
	let n = ZT(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, pE = (e, t) => ({
	fn: nE(e).fn,
	options: [e, t]
}), mE = (e, t) => {
	let n = QT(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, hE = (e, t) => {
	let n = $T(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, gE = (e, t) => {
	let n = eE(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, _E = (e, t) => {
	let n = uE(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, vE = Object.defineProperty, yE = (e, t) => vE(e, "name", {
	value: t,
	configurable: !0
});
function bE(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
yE(bE, "setRef");
function xE(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = bE(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : bE(e[t], null);
			}
		};
	};
}
yE(xE, "composeRefs");
function SE(...e) {
	return A.useCallback(xE(...e), e);
}
yE(SE, "useComposedRefs");
//#endregion
//#region node_modules/@radix-ui/react-popper/dist/index.mjs
var CE = Object.defineProperty, wE = (e, t) => CE(e, "name", {
	value: t,
	configurable: !0
}), TE = "Popper", [EE, DE] = /* @__PURE__ */ wy(TE), [OE, kE] = EE(TE), AE = /* @__PURE__ */ wE((e) => {
	let { __scopePopper: t, children: n } = e, [r, i] = A.useState(null), [a, o] = A.useState(void 0);
	return /* @__PURE__ */ (0, q.jsx)(OE, {
		scope: t,
		anchor: r,
		onAnchorChange: i,
		placementState: a,
		setPlacementState: o,
		children: n
	});
}, "Popper"), jE = "PopperAnchor", ME = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ wE(function(e, t) {
	let { __scopePopper: n, virtualRef: r, ...i } = e, a = kE(jE, n), o = A.useRef(null), s = a.onAnchorChange, c = SE(t, A.useCallback((e) => {
		o.current = e, e && s(e);
	}, [s])), l = A.useRef(null);
	A.useEffect(() => {
		if (!r) return;
		let e = l.current;
		l.current = r.current, e !== l.current && s(l.current);
	});
	let u = a.placementState && zE(a.placementState), d = u?.[0], f = u?.[1];
	return r ? null : /* @__PURE__ */ (0, q.jsx)(vy.div, {
		"data-radix-popper-side": d,
		"data-radix-popper-align": f,
		...i,
		ref: c
	});
}, "PopperAnchor")), NE = "PopperContent", [PE, FE] = EE(NE), IE = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ wE(function(e, t) {
	let { __scopePopper: n, side: r = "bottom", sideOffset: i = 0, align: a = "center", alignOffset: o = 0, arrowPadding: s = 0, avoidCollisions: c = !0, collisionBoundary: l = [], collisionPadding: u = 0, sticky: d = "partial", hideWhenDetached: f = !1, updatePositionStrategy: p = "optimized", onPlaced: m, ...h } = e, g = kE(NE, n), [_, v] = A.useState(null), y = SE(t, v), [b, x] = A.useState(null), S = ow(b), C = S?.width ?? 0, w = S?.height ?? 0, T = r + (a === "center" ? "" : "-" + a), E = typeof u == "number" ? u : {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...u
	}, D = Array.isArray(l) ? l : [l], O = D.length > 0, k = {
		padding: E,
		boundary: D.filter(LE),
		altBoundary: O
	}, { refs: j, floatingStyles: M, placement: N, isPositioned: P, middlewareData: F } = lE({
		strategy: "fixed",
		placement: T,
		whileElementsMounted: /* @__PURE__ */ wE((...e) => YT(...e, { animationFrame: p === "always" }), "whileElementsMounted"),
		elements: { reference: g.anchor },
		middleware: [
			dE({
				mainAxis: i + w,
				alignmentAxis: o
			}),
			c && fE({
				mainAxis: !0,
				crossAxis: !1,
				limiter: d === "partial" ? pE() : void 0,
				...k
			}),
			c && mE({ ...k }),
			hE({
				...k,
				apply: /* @__PURE__ */ wE(({ elements: e, rects: t, availableWidth: n, availableHeight: r }) => {
					let { width: i, height: a } = t.reference, o = e.floating.style;
					o.setProperty("--radix-popper-available-width", `${n}px`), o.setProperty("--radix-popper-available-height", `${r}px`), o.setProperty("--radix-popper-anchor-width", `${i}px`), o.setProperty("--radix-popper-anchor-height", `${a}px`);
				}, "apply")
			}),
			b && _E({
				element: b,
				padding: s
			}),
			RE({
				arrowWidth: C,
				arrowHeight: w
			}),
			f && gE({
				strategy: "referenceHidden",
				...k,
				boundary: O ? k.boundary : void 0
			})
		]
	}), I = g.setPlacementState;
	pb(() => (I(N), () => {
		I(void 0);
	}), [N, I]);
	let [R, ee] = zE(N), te = rx(m);
	pb(() => {
		P && te?.();
	}, [P, te]);
	let ne = F.arrow?.x, z = F.arrow?.y, B = F.arrow?.centerOffset !== 0, [V, re] = A.useState();
	return pb(() => {
		_ && re(window.getComputedStyle(_).zIndex);
	}, [_]), /* @__PURE__ */ (0, q.jsx)("div", {
		ref: j.setFloating,
		"data-radix-popper-content-wrapper": "",
		style: {
			...M,
			transform: P ? M.transform : "translate(0, -200%)",
			minWidth: "max-content",
			zIndex: V,
			"--radix-popper-transform-origin": [F.transformOrigin?.x, F.transformOrigin?.y].join(" "),
			...F.hide?.referenceHidden && {
				visibility: "hidden",
				pointerEvents: "none"
			}
		},
		dir: e.dir,
		children: /* @__PURE__ */ (0, q.jsx)(PE, {
			scope: n,
			placedSide: R,
			placedAlign: ee,
			onArrowChange: x,
			arrowX: ne,
			arrowY: z,
			shouldHideArrow: B,
			children: /* @__PURE__ */ (0, q.jsx)(vy.div, {
				"data-side": R,
				"data-align": ee,
				...h,
				ref: y,
				style: {
					...h.style,
					animation: P ? h.style?.animation : "none"
				}
			})
		})
	});
}, "PopperContent"));
function LE(e) {
	return e !== null;
}
wE(LE, "isNotNull");
var RE = /* @__PURE__ */ wE((e) => ({
	name: "transformOrigin",
	options: e,
	fn(t) {
		let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = zE(n), u = {
			start: "0%",
			center: "50%",
			end: "100%"
		}[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
		return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), { data: {
			x: p,
			y: m
		} };
	}
}), "transformOrigin");
function zE(e) {
	let [t, n = "center"] = e.split("-");
	return [t, n];
}
wE(zE, "getSideAndAlignFromPlacement");
var BE = AE, VE = ME, HE = IE, UE = Object.defineProperty, WE = (e, t) => UE(e, "name", {
	value: t,
	configurable: !0
});
function GE(e) {
	let t = A.useRef({
		value: e,
		previous: e
	});
	return A.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
WE(GE, "usePrevious");
//#endregion
//#region node_modules/@radix-ui/number/dist/index.mjs
var KE = Object.defineProperty, qE = (e, t) => KE(e, "name", {
	value: t,
	configurable: !0
});
function JE(e, [t, n]) {
	return Math.min(n, Math.max(t, e));
}
qE(JE, "clamp");
//#endregion
//#region node_modules/@radix-ui/react-progress/dist/index.mjs
var YE = Object.defineProperty, XE = (e, t) => YE(e, "name", {
	value: t,
	configurable: !0
}), ZE = "Progress", QE = 100, [$E, eD] = /* @__PURE__ */ wy(ZE), [tD, nD] = $E(ZE), rD = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ XE(function(e, t) {
	let { __scopeProgress: n, value: r = null, max: i, getValueLabel: a = oD, ...o } = e;
	(i || i === 0) && !lD(i) && console.error(dD(`${i}`, "Progress"));
	let s = lD(i) ? i : QE;
	r !== null && !uD(r, s) && console.error(fD(`${r}`, "Progress"));
	let c = uD(r, s) ? r : null, l = cD(c) ? a(c, s) : void 0;
	return /* @__PURE__ */ (0, q.jsx)(tD, {
		scope: n,
		value: c,
		max: s,
		children: /* @__PURE__ */ (0, q.jsx)(vy.div, {
			"aria-valuemax": s,
			"aria-valuemin": 0,
			"aria-valuenow": cD(c) ? c : void 0,
			"aria-valuetext": l,
			role: "progressbar",
			"data-state": sD(c, s),
			"data-value": c ?? void 0,
			"data-max": s,
			...o,
			ref: t
		})
	});
}, "Progress")), iD = "ProgressIndicator", aD = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ XE(function(e, t) {
	let { __scopeProgress: n, ...r } = e, i = nD(iD, n);
	return /* @__PURE__ */ (0, q.jsx)(vy.div, {
		"data-state": sD(i.value, i.max),
		"data-value": i.value ?? void 0,
		"data-max": i.max,
		...r,
		ref: t
	});
}, "ProgressIndicator"));
function oD(e, t) {
	return `${Math.round(e / t * 100)}%`;
}
XE(oD, "defaultGetValueLabel");
function sD(e, t) {
	return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
XE(sD, "getProgressState");
function cD(e) {
	return typeof e == "number";
}
XE(cD, "isNumber");
function lD(e) {
	return cD(e) && !isNaN(e) && e > 0;
}
XE(lD, "isValidMaxNumber");
function uD(e, t) {
	return cD(e) && !isNaN(e) && e <= t && e >= 0;
}
XE(uD, "isValidValueNumber");
function dD(e, t) {
	return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${QE}\`.`;
}
XE(dD, "getInvalidMaxError");
function fD(e, t) {
	return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${QE} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
XE(fD, "getInvalidValueError");
var pD = rD, mD = aD, hD = Object.defineProperty, gD = (e, t) => hD(e, "name", {
	value: t,
	configurable: !0
});
function _D(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
gD(_D, "setRef");
function vD(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = _D(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : _D(e[t], null);
			}
		};
	};
}
gD(vD, "composeRefs");
function yD(...e) {
	return A.useCallback(vD(...e), e);
}
gD(yD, "useComposedRefs");
//#endregion
//#region node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-slot/dist/index.mjs
var bD = Object.defineProperty, xD = (e, t) => bD(e, "name", {
	value: t,
	configurable: !0
});
/* @__NO_SIDE_EFFECTS__ */
function SD(e) {
	let t = A.forwardRef((t, n) => {
		let { children: r, ...i } = t, a = null, o = !1, s = [];
		AD(r) && typeof PD == "function" && (r = PD(r._payload)), A.Children.forEach(r, (e) => {
			if (OD(e)) {
				o = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				AD(n) && typeof PD == "function" && (n = PD(n._payload)), a = TD(t, n), s.push(a?.props?.children);
			} else s.push(e);
		}), a ? a = A.cloneElement(a, void 0, s) : !o && A.Children.count(r) === 1 && A.isValidElement(r) && (a = r);
		let c = a ? DD(a) : void 0, l = yD(n, c);
		if (!a) {
			if (r || r === 0) throw Error(o ? ND(e) : MD(e));
			return r;
		}
		let u = ED(i, a.props ?? {});
		return a.type !== A.Fragment && (u.ref = n ? l : c), A.cloneElement(a, u);
	});
	return t.displayName = `${e}.Slot`, t;
}
xD(SD, "createSlot");
var CD = Symbol.for("radix.slottable");
/* @__NO_SIDE_EFFECTS__ */
function wD(e) {
	let t = /* @__PURE__ */ xD((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = CD, t;
}
xD(wD, "createSlottable");
var TD = /* @__PURE__ */ xD((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return A.isValidElement(t) ? A.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return A.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function ED(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
xD(ED, "mergeProps");
function DD(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
xD(DD, "getElementRef");
function OD(e) {
	return A.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === CD;
}
xD(OD, "isSlottable");
var kD = Symbol.for("react.lazy");
function AD(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === kD && "_payload" in e && jD(e._payload);
}
xD(AD, "isLazyComponent");
function jD(e) {
	return typeof e == "object" && !!e && "then" in e;
}
xD(jD, "isPromiseLike");
var MD = /* @__PURE__ */ xD((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), ND = /* @__PURE__ */ xD((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), PD = A.use, FD = Object.defineProperty, ID = (e, t) => FD(e, "name", {
	value: t,
	configurable: !0
}), LD = [
	" ",
	"Enter",
	"ArrowUp",
	"ArrowDown"
], RD = [" ", "Enter"], zD = "Select", [BD, VD, HD] = /* @__PURE__ */ Jy(zD), [UD, WD] = /* @__PURE__ */ wy(zD, [HD, DE]), GD = DE(), [KD, qD] = UD(zD), [JD, YD] = UD(zD);
function XD(e) {
	let { __scopeSelect: t, children: n, open: r, defaultOpen: i, onOpenChange: a, value: o, defaultValue: s, onValueChange: c, dir: l, name: u, autoComplete: d, disabled: f, required: p, form: m, internal_do_not_use_render: h } = e, g = GD(t), [_, v] = A.useState(null), [y, b] = A.useState(null), [x, S] = A.useState(!1), C = Wb(l), [w, T] = Sb({
		prop: r,
		defaultProp: i ?? !1,
		onChange: a,
		caller: zD
	}), [E, D] = Sb({
		prop: o,
		defaultProp: s,
		onChange: c,
		caller: zD
	}), O = A.useRef(null), k = A.useRef(E);
	A.useEffect(() => {
		let e = m ? _?.ownerDocument.getElementById(m) : _?.form;
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ ID(() => D(k.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		m,
		_,
		D
	]);
	let j = _ ? !!m || !!_.closest("form") : !0, [M, N] = A.useState(/* @__PURE__ */ new Set()), P = Bb(), F = Array.from(M).map((e) => e.props.value).join(";"), I = A.useCallback((e) => {
		N((t) => new Set(t).add(e));
	}, []), R = A.useCallback((e) => {
		N((t) => {
			let n = new Set(t);
			return n.delete(e), n;
		});
	}, []), ee = {
		required: p,
		trigger: _,
		onTriggerChange: v,
		valueNode: y,
		onValueNodeChange: b,
		valueNodeHasChildren: x,
		onValueNodeHasChildrenChange: S,
		contentId: P,
		value: E,
		onValueChange: D,
		open: w,
		onOpenChange: T,
		dir: C,
		triggerPointerDownPosRef: O,
		disabled: f,
		name: u,
		autoComplete: d,
		form: m,
		nativeOptions: M,
		nativeSelectKey: F,
		isFormControl: j
	};
	return /* @__PURE__ */ (0, q.jsx)(BE, {
		...g,
		children: /* @__PURE__ */ (0, q.jsx)(KD, {
			scope: t,
			...ee,
			children: /* @__PURE__ */ (0, q.jsx)(BD.Provider, {
				scope: t,
				children: /* @__PURE__ */ (0, q.jsx)(JD, {
					scope: t,
					onNativeOptionAdd: I,
					onNativeOptionRemove: R,
					children: LO(h) ? h(ee) : n
				})
			})
		})
	});
}
ID(XD, "SelectProvider");
var ZD = /* @__PURE__ */ ID((e) => {
	let { __scopeSelect: t, children: n, ...r } = e;
	return /* @__PURE__ */ (0, q.jsx)(XD, {
		__scopeSelect: t,
		...r,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [n, e ? /* @__PURE__ */ (0, q.jsx)(IO, { __scopeSelect: t }) : null] })
	});
}, "Select"), QD = "SelectTrigger", $D = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n, disabled: r = !1, ...i } = e, a = GD(n), o = qD(QD, n), s = o.disabled || r, c = yD(t, o.onTriggerChange), l = VD(n), u = A.useRef("touch"), [d, f, p] = zO((e) => {
		let t = l().filter((e) => !e.disabled), n = BO(t, e, t.find((e) => e.value === o.value));
		n !== void 0 && o.onValueChange(n.value);
	}), m = /* @__PURE__ */ ID((e) => {
		s || (o.onOpenChange(!0), p()), e && (o.triggerPointerDownPosRef.current = {
			x: Math.round(e.pageX),
			y: Math.round(e.pageY)
		});
	}, "handleOpen");
	return /* @__PURE__ */ (0, q.jsx)(VE, {
		asChild: !0,
		...a,
		children: /* @__PURE__ */ (0, q.jsx)(vy.button, {
			type: "button",
			role: "combobox",
			"aria-controls": o.open ? o.contentId : void 0,
			"aria-expanded": o.open,
			"aria-required": o.required,
			"aria-autocomplete": "none",
			dir: o.dir,
			"data-state": o.open ? "open" : "closed",
			disabled: s,
			"data-disabled": s ? "" : void 0,
			"data-placeholder": RO(o.value) ? "" : void 0,
			...i,
			ref: c,
			onClick: cb(i.onClick, (e) => {
				e.currentTarget.focus(), u.current !== "mouse" && m(e);
			}),
			onPointerDown: cb(i.onPointerDown, (e) => {
				u.current = e.pointerType;
				let t = e.target;
				t.hasPointerCapture(e.pointerId) && t.releasePointerCapture(e.pointerId), e.button === 0 && e.ctrlKey === !1 && e.pointerType === "mouse" && (m(e), e.preventDefault());
			}),
			onKeyDown: cb(i.onKeyDown, (e) => {
				let t = d.current !== "";
				!(e.ctrlKey || e.altKey || e.metaKey) && e.key.length === 1 && f(e.key), !(t && e.key === " ") && LD.includes(e.key) && (m(), e.preventDefault());
			})
		})
	});
}, "SelectTrigger")), eO = "SelectValue", tO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n, className: r, style: i, children: a, placeholder: o = "", ...s } = e, c = qD(eO, n), { onValueNodeHasChildrenChange: l } = c, u = a !== void 0, d = yD(t, c.onValueNodeChange);
	pb(() => {
		l(u);
	}, [l, u]);
	let f = RO(c.value);
	return /* @__PURE__ */ (0, q.jsx)(vy.span, {
		...s,
		asChild: f ? !1 : s.asChild,
		ref: d,
		style: { pointerEvents: "none" },
		children: /* @__PURE__ */ (0, q.jsx)(A.Fragment, { children: f ? o : a }, f ? "placeholder" : "value")
	});
}, "SelectValue")), nO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n, children: r, ...i } = e;
	return /* @__PURE__ */ (0, q.jsx)(vy.span, {
		"aria-hidden": !0,
		...i,
		ref: t,
		children: r || "▼"
	});
}, "SelectIcon")), [rO, iO] = UD("SelectPortal", { forceMount: void 0 }), aO = /* @__PURE__ */ ID((e) => {
	let { __scopeSelect: t, forceMount: n, ...r } = e;
	return /* @__PURE__ */ (0, q.jsx)(rO, {
		scope: e.__scopeSelect,
		forceMount: n,
		children: /* @__PURE__ */ (0, q.jsx)(Vx, {
			asChild: !0,
			...r
		})
	});
}, "SelectPortal"), oO = "SelectContent", sO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let n = iO(oO, e.__scopeSelect), { forceMount: r = n.forceMount, ...i } = e, a = qD(oO, e.__scopeSelect), [o, s] = A.useState();
	return pb(() => {
		s(new DocumentFragment());
	}, []), /* @__PURE__ */ (0, q.jsx)(Ab, {
		present: r || a.open,
		children: ({ present: e }) => e ? /* @__PURE__ */ (0, q.jsx)(pO, {
			...i,
			ref: t
		}) : /* @__PURE__ */ (0, q.jsx)(cO, {
			...i,
			fragment: o
		})
	});
}, "SelectContent")), cO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n, children: r, fragment: i } = e;
	return i ? Ce.createPortal(/* @__PURE__ */ (0, q.jsx)(uO, {
		scope: n,
		children: /* @__PURE__ */ (0, q.jsx)(BD.Slot, {
			scope: n,
			children: /* @__PURE__ */ (0, q.jsx)("div", {
				ref: t,
				children: r
			})
		})
	}), i) : null;
}, "SelectContentFragment")), lO = 10, [uO, dO] = UD(oO), fO = /* @__PURE__ */ SD("SelectContent.RemoveScroll"), pO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n } = e, { position: r = "item-aligned", onCloseAutoFocus: i, onEscapeKeyDown: a, onPointerDownOutside: o, side: s, sideOffset: c, align: l, alignOffset: u, arrowPadding: d, collisionBoundary: f, collisionPadding: p, sticky: m, hideWhenDetached: h, avoidCollisions: g, ..._ } = e, v = qD(oO, n), [y, b] = A.useState(null), [x, S] = A.useState(null), C = yD(t, b), [w, T] = A.useState(null), [E, D] = A.useState(null), O = VD(n), [k, j] = A.useState(!1), M = A.useRef(!1);
	A.useEffect(() => {
		if (y) return fC(y);
	}, [y]), qx();
	let N = A.useCallback((e) => {
		let [t, ...n] = O().map((e) => e.ref.current), [r] = n.slice(-1), i = document.activeElement;
		for (let n of e) if (n === i || (n?.scrollIntoView({ block: "nearest" }), n === t && x && (x.scrollTop = 0), n === r && x && (x.scrollTop = x.scrollHeight), n?.focus(), document.activeElement !== i)) return;
	}, [O, x]), P = A.useCallback(() => N([w, y]), [
		N,
		w,
		y
	]);
	A.useEffect(() => {
		k && P();
	}, [k, P]);
	let { onOpenChange: F, triggerPointerDownPosRef: I } = v;
	A.useEffect(() => {
		if (y) {
			let e = {
				x: 0,
				y: 0
			}, t = /* @__PURE__ */ ID((t) => {
				e = {
					x: Math.abs(Math.round(t.pageX) - (I.current?.x ?? 0)),
					y: Math.abs(Math.round(t.pageY) - (I.current?.y ?? 0))
				};
			}, "handlePointerMove"), n = /* @__PURE__ */ ID((n) => {
				e.x <= 10 && e.y <= 10 ? n.preventDefault() : n.composedPath().includes(y) || F(!1), document.removeEventListener("pointermove", t), I.current = null;
			}, "handlePointerUp");
			return I.current !== null && (document.addEventListener("pointermove", t), document.addEventListener("pointerup", n, {
				capture: !0,
				once: !0
			})), () => {
				document.removeEventListener("pointermove", t), document.removeEventListener("pointerup", n, { capture: !0 });
			};
		}
	}, [
		y,
		F,
		I
	]), A.useEffect(() => {
		let e = /* @__PURE__ */ ID(() => F(!1), "close");
		return window.addEventListener("blur", e), window.addEventListener("resize", e), () => {
			window.removeEventListener("blur", e), window.removeEventListener("resize", e);
		};
	}, [F]);
	let [R, ee] = zO((e) => {
		let t = O().filter((e) => !e.disabled), n = BO(t, e, t.find((e) => e.ref.current === document.activeElement));
		n && setTimeout(() => n.ref.current?.focus());
	}), te = A.useCallback((e, t, n) => {
		let r = !M.current && !n;
		(v.value !== void 0 && v.value === t || r) && (T(e), r && (M.current = !0));
	}, [v.value]), ne = A.useCallback(() => y?.focus(), [y]), z = A.useCallback((e, t, n) => {
		let r = !M.current && !n;
		(v.value !== void 0 && v.value === t || r) && D(e);
	}, [v.value]), B = r === "popper" ? hO : mO, V = B === hO ? {
		side: s,
		sideOffset: c,
		align: l,
		alignOffset: u,
		arrowPadding: d,
		collisionBoundary: f,
		collisionPadding: p,
		sticky: m,
		hideWhenDetached: h,
		avoidCollisions: g
	} : {};
	return /* @__PURE__ */ (0, q.jsx)(uO, {
		scope: n,
		content: y,
		viewport: x,
		onViewportChange: S,
		itemRefCallback: te,
		selectedItem: w,
		onItemLeave: ne,
		itemTextRefCallback: z,
		focusSelectedItem: P,
		selectedItemText: E,
		position: r,
		isPositioned: k,
		searchRef: R,
		children: /* @__PURE__ */ (0, q.jsx)(rC, {
			as: fO,
			allowPinchZoom: !0,
			children: /* @__PURE__ */ (0, q.jsx)(Ox, {
				asChild: !0,
				trapped: v.open,
				onMountAutoFocus: (e) => {
					e.preventDefault();
				},
				onUnmountAutoFocus: cb(i, (e) => {
					v.trigger?.focus({ preventScroll: !0 }), e.preventDefault();
				}),
				children: /* @__PURE__ */ (0, q.jsx)(dx, {
					asChild: !0,
					disableOutsidePointerEvents: !0,
					onEscapeKeyDown: a,
					onPointerDownOutside: o,
					onFocusOutside: (e) => e.preventDefault(),
					onDismiss: () => v.onOpenChange(!1),
					children: /* @__PURE__ */ (0, q.jsx)(B, {
						role: "listbox",
						id: v.contentId,
						"data-state": v.open ? "open" : "closed",
						dir: v.dir,
						onContextMenu: (e) => e.preventDefault(),
						..._,
						...V,
						onPlaced: () => j(!0),
						ref: C,
						style: {
							display: "flex",
							flexDirection: "column",
							outline: "none",
							..._.style
						},
						onKeyDown: cb(_.onKeyDown, (e) => {
							let t = e.ctrlKey || e.altKey || e.metaKey;
							if (e.key === "Tab" && e.preventDefault(), !t && e.key.length === 1 && ee(e.key), [
								"ArrowUp",
								"ArrowDown",
								"Home",
								"End"
							].includes(e.key)) {
								let t = O().filter((e) => !e.disabled).map((e) => e.ref.current);
								if (["ArrowUp", "End"].includes(e.key) && (t = t.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(e.key)) {
									let n = e.target, r = t.indexOf(n);
									t = t.slice(r + 1);
								}
								setTimeout(() => N(t)), e.preventDefault();
							}
						})
					})
				})
			})
		})
	});
}, "SelectContentImpl")), mO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n, onPlaced: r, ...i } = e, a = qD(oO, n), o = dO(oO, n), [s, c] = A.useState(null), [l, u] = A.useState(null), d = yD(t, u), f = VD(n), p = A.useRef(!1), m = A.useRef(!0), { viewport: h, selectedItem: g, selectedItemText: _, focusSelectedItem: v } = o, y = A.useCallback(() => {
		if (a.trigger && a.valueNode && s && l && h && g && _) {
			let e = a.trigger.getBoundingClientRect(), t = l.getBoundingClientRect(), n = a.valueNode.getBoundingClientRect(), i = _.getBoundingClientRect();
			if (a.dir !== "rtl") {
				let r = i.left - t.left, a = n.left - r, o = e.left - a, c = e.width + o, l = Math.max(c, t.width), u = window.innerWidth - lO, d = JE(a, [lO, Math.max(lO, u - l)]);
				s.style.minWidth = c + "px", s.style.left = d + "px";
			} else {
				let r = t.right - i.right, a = window.innerWidth - n.right - r, o = window.innerWidth - e.right - a, c = e.width + o, l = Math.max(c, t.width), u = window.innerWidth - lO, d = JE(a, [lO, Math.max(lO, u - l)]);
				s.style.minWidth = c + "px", s.style.right = d + "px";
			}
			let o = f(), c = window.innerHeight - lO * 2, u = h.scrollHeight, d = window.getComputedStyle(l), m = parseInt(d.borderTopWidth, 10), v = parseInt(d.paddingTop, 10), y = parseInt(d.borderBottomWidth, 10), b = parseInt(d.paddingBottom, 10), x = m + v + u + b + y, S = Math.min(g.offsetHeight * 5, x), C = window.getComputedStyle(h), w = parseInt(C.paddingTop, 10), T = parseInt(C.paddingBottom, 10), E = e.top + e.height / 2 - lO, D = c - E, O = g.offsetHeight / 2, k = g.offsetTop + O, A = m + v + k, j = x - A;
			if (A <= E) {
				let e = o.length > 0 && g === o[o.length - 1].ref.current;
				s.style.bottom = "0px";
				let t = l.clientHeight - h.offsetTop - h.offsetHeight, n = A + Math.max(D, O + (e ? T : 0) + t + y);
				s.style.height = n + "px";
			} else {
				let e = o.length > 0 && g === o[0].ref.current;
				s.style.top = "0px";
				let t = Math.max(E, m + h.offsetTop + (e ? w : 0) + O) + j;
				s.style.height = t + "px", h.scrollTop = A - E + h.offsetTop;
			}
			s.style.margin = `${lO}px 0`, s.style.minHeight = S + "px", s.style.maxHeight = c + "px", r?.(), requestAnimationFrame(() => p.current = !0);
		}
	}, [
		f,
		a.trigger,
		a.valueNode,
		s,
		l,
		h,
		g,
		_,
		a.dir,
		r
	]);
	pb(() => y(), [y]);
	let [b, x] = A.useState();
	return pb(() => {
		l && x(window.getComputedStyle(l).zIndex);
	}, [l]), /* @__PURE__ */ (0, q.jsx)(gO, {
		scope: n,
		contentWrapper: s,
		shouldExpandOnScrollRef: p,
		onScrollButtonChange: A.useCallback((e) => {
			e && m.current === !0 && (y(), v?.(), m.current = !1);
		}, [y, v]),
		children: /* @__PURE__ */ (0, q.jsx)("div", {
			ref: c,
			style: {
				display: "flex",
				flexDirection: "column",
				position: "fixed",
				zIndex: b
			},
			children: /* @__PURE__ */ (0, q.jsx)(vy.div, {
				...i,
				ref: d,
				style: {
					boxSizing: "border-box",
					maxHeight: "100%",
					...i.style
				}
			})
		})
	});
}, "SelectItemAlignedPosition")), hO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n, align: r = "start", collisionPadding: i = lO, ...a } = e, o = GD(n);
	return /* @__PURE__ */ (0, q.jsx)(HE, {
		...o,
		...a,
		ref: t,
		align: r,
		collisionPadding: i,
		style: {
			boxSizing: "border-box",
			...a.style,
			"--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-select-content-available-width": "var(--radix-popper-available-width)",
			"--radix-select-content-available-height": "var(--radix-popper-available-height)",
			"--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "SelectPopperPosition")), [gO, _O] = UD(oO, {}), vO = "SelectViewport", yO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n, nonce: r, ...i } = e, a = dO(vO, n), o = _O(vO, n), s = yD(t, a.onViewportChange), c = A.useRef(0);
	return /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [/* @__PURE__ */ (0, q.jsx)("style", {
		dangerouslySetInnerHTML: { __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}" },
		nonce: r
	}), /* @__PURE__ */ (0, q.jsx)(BD.Slot, {
		scope: n,
		children: /* @__PURE__ */ (0, q.jsx)(vy.div, {
			"data-radix-select-viewport": "",
			role: "presentation",
			...i,
			ref: s,
			style: {
				position: "relative",
				flex: 1,
				overflow: "hidden auto",
				...i.style
			},
			onScroll: cb(i.onScroll, (e) => {
				let t = e.currentTarget, { contentWrapper: n, shouldExpandOnScrollRef: r } = o;
				if (r?.current && n) {
					let e = Math.abs(c.current - t.scrollTop);
					if (e > 0) {
						let r = window.innerHeight - lO * 2, i = parseFloat(n.style.minHeight), a = parseFloat(n.style.height), o = Math.max(i, a);
						if (o < r) {
							let i = o + e, a = Math.min(r, i), s = i - a;
							n.style.height = a + "px", n.style.bottom === "0px" && (t.scrollTop = s > 0 ? s : 0, n.style.justifyContent = "flex-end");
						}
					}
				}
				c.current = t.scrollTop;
			})
		})
	})] });
}, "SelectViewport")), [bO, xO] = UD("SelectGroup"), SO = "SelectItem", [CO, wO] = UD(SO), TO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n, value: r, disabled: i = !1, textValue: a, ...o } = e, s = qD(SO, n), c = dO(SO, n), l = s.value === r, [u, d] = A.useState(a ?? ""), [f, p] = A.useState(!1), m = yD(t, rx((e) => c.itemRefCallback?.(e, r, i))), h = Bb(), g = A.useRef("touch"), _ = /* @__PURE__ */ ID(() => {
		i || (s.onValueChange(r), s.onOpenChange(!1));
	}, "handleSelect");
	return /* @__PURE__ */ (0, q.jsx)(CO, {
		scope: n,
		value: r,
		disabled: i,
		textId: h,
		isSelected: l,
		onItemTextChange: A.useCallback((e) => {
			d((t) => t || (e?.textContent ?? "").trim());
		}, []),
		children: /* @__PURE__ */ (0, q.jsx)(BD.ItemSlot, {
			scope: n,
			value: r,
			disabled: i,
			textValue: u,
			children: /* @__PURE__ */ (0, q.jsx)(vy.div, {
				role: "option",
				"aria-labelledby": h,
				"data-highlighted": f ? "" : void 0,
				"aria-selected": l && f,
				"data-state": l ? "checked" : "unchecked",
				"aria-disabled": i || void 0,
				"data-disabled": i ? "" : void 0,
				tabIndex: i ? void 0 : -1,
				...o,
				ref: m,
				onFocus: cb(o.onFocus, () => p(!0)),
				onBlur: cb(o.onBlur, () => p(!1)),
				onClick: cb(o.onClick, () => {
					g.current !== "mouse" && _();
				}),
				onPointerUp: cb(o.onPointerUp, () => {
					g.current === "mouse" && _();
				}),
				onPointerDown: cb(o.onPointerDown, (e) => {
					g.current = e.pointerType;
				}),
				onPointerMove: cb(o.onPointerMove, (e) => {
					g.current = e.pointerType, i ? c.onItemLeave?.() : g.current === "mouse" && e.currentTarget.focus({ preventScroll: !0 });
				}),
				onPointerLeave: cb(o.onPointerLeave, (e) => {
					e.currentTarget === document.activeElement && c.onItemLeave?.();
				}),
				onKeyDown: cb(o.onKeyDown, (e) => {
					i || e.target !== e.currentTarget || c.searchRef?.current !== "" && e.key === " " || (RD.includes(e.key) && _(), e.key === " " && e.preventDefault());
				})
			})
		})
	});
}, "SelectItem")), EO = "SelectItemText", DO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n, className: r, style: i, ...a } = e, o = qD(EO, n), s = dO(EO, n), c = wO(EO, n), l = YD(EO, n), [u, d] = A.useState(null), f = rx((e) => s.itemTextRefCallback?.(e, c.value, c.disabled)), p = yD(t, d, c.onItemTextChange, f), m = u?.textContent, h = A.useMemo(() => /* @__PURE__ */ (0, q.jsx)("option", {
		value: c.value,
		disabled: c.disabled,
		children: m
	}, c.value), [
		c.disabled,
		c.value,
		m
	]), { onNativeOptionAdd: g, onNativeOptionRemove: _ } = l;
	return pb(() => (g(h), () => _(h)), [
		g,
		_,
		h
	]), /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [/* @__PURE__ */ (0, q.jsx)(vy.span, {
		id: c.textId,
		...a,
		ref: p
	}), c.isSelected && o.valueNode && !o.valueNodeHasChildren && !RO(o.value) ? Ce.createPortal(a.children, o.valueNode) : null] });
}, "SelectItemText")), OO = "SelectItemIndicator", kO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n, ...r } = e;
	return wO(OO, n).isSelected ? /* @__PURE__ */ (0, q.jsx)(vy.span, {
		"aria-hidden": !0,
		...r,
		ref: t
	}) : null;
}, "SelectItemIndicator")), AO = "SelectScrollUpButton", jO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let n = dO(AO, e.__scopeSelect), r = _O(AO, e.__scopeSelect), [i, a] = A.useState(!1), o = yD(t, r.onScrollButtonChange);
	return pb(() => {
		if (n.viewport && n.isPositioned) {
			let e = function() {
				a(t.scrollTop > 0);
			};
			ID(e, "handleScroll");
			let t = n.viewport;
			return e(), t.addEventListener("scroll", e), () => t.removeEventListener("scroll", e);
		}
	}, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ (0, q.jsx)(PO, {
		...e,
		ref: o,
		onAutoScroll: () => {
			let { viewport: e, selectedItem: t } = n;
			e && t && (e.scrollTop -= t.offsetHeight);
		}
	}) : null;
}, "SelectScrollUpButton")), MO = "SelectScrollDownButton", NO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let n = dO(MO, e.__scopeSelect), r = _O(MO, e.__scopeSelect), [i, a] = A.useState(!1), o = yD(t, r.onScrollButtonChange);
	return pb(() => {
		if (n.viewport && n.isPositioned) {
			let e = function() {
				let e = t.scrollHeight - t.clientHeight;
				a(Math.ceil(t.scrollTop) < e);
			};
			ID(e, "handleScroll");
			let t = n.viewport;
			return e(), t.addEventListener("scroll", e), () => t.removeEventListener("scroll", e);
		}
	}, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ (0, q.jsx)(PO, {
		...e,
		ref: o,
		onAutoScroll: () => {
			let { viewport: e, selectedItem: t } = n;
			e && t && (e.scrollTop += t.offsetHeight);
		}
	}) : null;
}, "SelectScrollDownButton")), PO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function(e, t) {
	let { __scopeSelect: n, onAutoScroll: r, ...i } = e, a = dO("SelectScrollButton", n), o = A.useRef(null), s = VD(n), c = A.useCallback(() => {
		o.current !== null && (window.clearInterval(o.current), o.current = null);
	}, []);
	return A.useEffect(() => () => c(), [c]), pb(() => {
		s().find((e) => e.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
	}, [s]), /* @__PURE__ */ (0, q.jsx)(vy.div, {
		"aria-hidden": !0,
		...i,
		ref: t,
		style: {
			flexShrink: 0,
			...i.style
		},
		onPointerDown: cb(i.onPointerDown, () => {
			o.current === null && (o.current = window.setInterval(r, 50));
		}),
		onPointerMove: cb(i.onPointerMove, () => {
			a.onItemLeave?.(), o.current === null && (o.current = window.setInterval(r, 50));
		}),
		onPointerLeave: cb(i.onPointerLeave, () => {
			c();
		})
	});
}, "SelectScrollButtonImpl")), FO = "SelectBubbleInput", IO = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ ID(function({ __scopeSelect: e, ...t }, n) {
	let r = qD(FO, e), { value: i, onValueChange: a, required: o, disabled: s, name: c, autoComplete: l, form: u } = r, { nativeOptions: d, nativeSelectKey: f } = r, p = A.useRef(null), m = yD(n, p), h = i ?? "", g = GE(h), _ = Array.from(d).some((e) => (e.props.value ?? "") === "");
	return A.useEffect(() => {
		let e = p.current;
		if (!e) return;
		let t = window.HTMLSelectElement.prototype, n = Object.getOwnPropertyDescriptor(t, "value").set;
		if (g !== h && n) {
			let t = new Event("change", { bubbles: !0 });
			n.call(e, h), e.dispatchEvent(t);
		}
	}, [g, h]), /* @__PURE__ */ (0, q.jsxs)(vy.select, {
		"aria-hidden": !0,
		required: o,
		tabIndex: -1,
		name: c,
		autoComplete: l,
		disabled: s,
		form: u,
		onChange: (e) => a(e.target.value),
		...t,
		style: {
			...by,
			...t.style
		},
		ref: m,
		defaultValue: h,
		children: [RO(i) && !_ ? /* @__PURE__ */ (0, q.jsx)("option", { value: "" }) : null, Array.from(d)]
	}, f);
}, "SelectBubbleInput"));
function LO(e) {
	return typeof e == "function";
}
ID(LO, "isFunction");
function RO(e) {
	return e === "" || e === void 0;
}
ID(RO, "shouldShowPlaceholder");
function zO(e) {
	let t = rx(e), n = A.useRef(""), r = A.useRef(0), i = A.useCallback((e) => {
		let i = n.current + e;
		t(i), (/* @__PURE__ */ ID((function e(t) {
			n.current = t, window.clearTimeout(r.current), t !== "" && (r.current = window.setTimeout(() => e(""), 1e3));
		}), "updateSearch"))(i);
	}, [t]), a = A.useCallback(() => {
		n.current = "", window.clearTimeout(r.current);
	}, []);
	return A.useEffect(() => () => window.clearTimeout(r.current), []), [
		n,
		i,
		a
	];
}
ID(zO, "useTypeaheadSearch");
function BO(e, t, n) {
	let r = t.length > 1 && Array.from(t).every((e) => e === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1, a = VO(e, Math.max(i, 0));
	r.length === 1 && (a = a.filter((e) => e !== n));
	let o = a.find((e) => e.textValue.toLowerCase().startsWith(r.toLowerCase()));
	return o === n ? void 0 : o;
}
ID(BO, "findNextItem");
function VO(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
ID(VO, "wrapArray");
//#endregion
//#region node_modules/@radix-ui/react-slider/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var HO = Object.defineProperty, UO = (e, t) => HO(e, "name", {
	value: t,
	configurable: !0
});
function WO(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
UO(WO, "setRef");
function GO(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = WO(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : WO(e[t], null);
			}
		};
	};
}
UO(GO, "composeRefs");
function KO(...e) {
	return A.useCallback(GO(...e), e);
}
UO(KO, "useComposedRefs");
//#endregion
//#region node_modules/@radix-ui/react-slider/dist/index.mjs
var qO = Object.defineProperty, JO = (e, t) => qO(e, "name", {
	value: t,
	configurable: !0
}), YO = ["PageUp", "PageDown"], XO = [
	"ArrowUp",
	"ArrowDown",
	"ArrowLeft",
	"ArrowRight"
], ZO = {
	"from-left": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowLeft"
	],
	"from-right": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowRight"
	],
	"from-bottom": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowLeft"
	],
	"from-top": [
		"Home",
		"PageDown",
		"ArrowUp",
		"ArrowLeft"
	]
}, QO = "Slider", [$O, ek, tk] = /* @__PURE__ */ Jy(QO), [nk, rk] = /* @__PURE__ */ wy(QO, [tk]), [ik, ak] = nk(QO), ok = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ JO(function(e, t) {
	let { name: n, min: r = 0, max: i = 100, step: a = 1, orientation: o = "horizontal", disabled: s = !1, minStepsBetweenThumbs: c = 0, defaultValue: l = [r], value: u, onValueChange: d = /* @__PURE__ */ JO(() => {}, "onValueChange"), onValueCommit: f = /* @__PURE__ */ JO(() => {}, "onValueCommit"), inverted: p = !1, form: m, ...h } = e, g = A.useRef(/* @__PURE__ */ new Set()), _ = A.useRef(0), v = A.useRef(!1), y = o === "horizontal" ? lk : uk, [b, x] = A.useState(null), S = KO(t, x), [C = [], w] = Sb({
		prop: u,
		defaultProp: l,
		onChange: /* @__PURE__ */ JO((e) => {
			[...g.current][_.current]?.focus({
				preventScroll: !0,
				focusVisible: v.current
			}), v.current = !1, d(e);
		}, "onChange")
	}), T = A.useRef(C), E = A.useRef(C);
	A.useEffect(() => {
		let e = m ? b?.ownerDocument.getElementById(m) : b?.closest("form");
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ JO(() => w(E.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		b,
		m,
		w
	]);
	function D(e) {
		j(e, Ok(C, e));
	}
	JO(D, "handleSlideStart");
	function O(e) {
		j(e, _.current);
	}
	JO(O, "handleSlideMove");
	function k() {
		String(C) !== String(T.current) && f(C);
	}
	JO(k, "handleSlideEnd");
	function j(e, t, { commit: n } = { commit: !1 }) {
		let o = Nk(a), s = JE(Pk(Math.round((e - r) / a) * a + r, o), [r, i]);
		w((e = []) => {
			let r = Tk(e, s, t);
			if (jk(r, c * a)) {
				_.current = r.indexOf(s);
				let t = String(r) !== String(e);
				return t && n && f(r), t ? r : e;
			} else return e;
		});
	}
	return JO(j, "updateValues"), /* @__PURE__ */ (0, q.jsx)(ik, {
		scope: e.__scopeSlider,
		name: n,
		disabled: s,
		min: r,
		max: i,
		valueIndexToChangeRef: _,
		thumbs: g.current,
		values: C,
		orientation: o,
		form: m,
		children: /* @__PURE__ */ (0, q.jsx)($O.Provider, {
			scope: e.__scopeSlider,
			children: /* @__PURE__ */ (0, q.jsx)($O.Slot, {
				scope: e.__scopeSlider,
				children: /* @__PURE__ */ (0, q.jsx)(y, {
					"aria-disabled": s,
					"data-disabled": s ? "" : void 0,
					...h,
					ref: S,
					onPointerDown: cb(h.onPointerDown, () => {
						s || (T.current = C, v.current = !1);
					}),
					min: r,
					max: i,
					inverted: p,
					onSlideStart: s ? void 0 : D,
					onSlideMove: s ? void 0 : O,
					onSlideEnd: s ? void 0 : k,
					onHomeKeyDown: () => {
						s || (v.current = !0, j(r, 0, { commit: !0 }));
					},
					onEndKeyDown: () => {
						s || (v.current = !0, j(i, C.length - 1, { commit: !0 }));
					},
					onStepKeyDown: ({ event: e, direction: t }) => {
						if (!s) {
							v.current = !0;
							let n = YO.includes(e.key) || e.shiftKey && XO.includes(e.key) ? 10 : 1, i = _.current, o = C[i];
							j(Fk(o, {
								min: r,
								step: a,
								direction: t,
								multiplier: n
							}), i, { commit: !0 });
						}
					}
				})
			})
		})
	});
}, "Slider")), [sk, ck] = nk(QO, {
	startEdge: "left",
	endEdge: "right",
	size: "width",
	direction: 1
}), lk = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ JO(function(e, t) {
	let { min: n, max: r, dir: i, inverted: a, onSlideStart: o, onSlideMove: s, onSlideEnd: c, onStepKeyDown: l, ...u } = e, [d, f] = A.useState(null), p = KO(t, f), m = A.useRef(void 0), h = Wb(i), g = h === "ltr", _ = g && !a || !g && a;
	function v(e) {
		let t = m.current || d.getBoundingClientRect(), i = Mk([0, t.width], _ ? [n, r] : [r, n]);
		return m.current = t, i(e - t.left);
	}
	return JO(v, "getValueFromPointer"), /* @__PURE__ */ (0, q.jsx)(sk, {
		scope: e.__scopeSlider,
		startEdge: _ ? "left" : "right",
		endEdge: _ ? "right" : "left",
		direction: _ ? 1 : -1,
		size: "width",
		children: /* @__PURE__ */ (0, q.jsx)(dk, {
			dir: h,
			"data-orientation": "horizontal",
			...u,
			ref: p,
			style: {
				...u.style,
				"--radix-slider-thumb-transform": "translateX(-50%)"
			},
			onSlideStart: (e) => {
				let t = v(e.clientX);
				o?.(t);
			},
			onSlideMove: (e) => {
				let t = v(e.clientX);
				s?.(t);
			},
			onSlideEnd: () => {
				m.current = void 0, c?.();
			},
			onStepKeyDown: (e) => {
				let t = ZO[_ ? "from-left" : "from-right"].includes(e.key);
				l?.({
					event: e,
					direction: t ? -1 : 1
				});
			}
		})
	});
}, "SliderHorizontal")), uk = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ JO(function(e, t) {
	let { min: n, max: r, inverted: i, onSlideStart: a, onSlideMove: o, onSlideEnd: s, onStepKeyDown: c, ...l } = e, u = A.useRef(null), d = KO(t, u), f = A.useRef(void 0), p = !i;
	function m(e) {
		let t = f.current || u.current.getBoundingClientRect(), i = Mk([0, t.height], p ? [r, n] : [n, r]);
		return f.current = t, i(e - t.top);
	}
	return JO(m, "getValueFromPointer"), /* @__PURE__ */ (0, q.jsx)(sk, {
		scope: e.__scopeSlider,
		startEdge: p ? "bottom" : "top",
		endEdge: p ? "top" : "bottom",
		size: "height",
		direction: p ? 1 : -1,
		children: /* @__PURE__ */ (0, q.jsx)(dk, {
			"data-orientation": "vertical",
			...l,
			ref: d,
			style: {
				...l.style,
				"--radix-slider-thumb-transform": "translateY(50%)"
			},
			onSlideStart: (e) => {
				let t = m(e.clientY);
				a?.(t);
			},
			onSlideMove: (e) => {
				let t = m(e.clientY);
				o?.(t);
			},
			onSlideEnd: () => {
				f.current = void 0, s?.();
			},
			onStepKeyDown: (e) => {
				let t = ZO[p ? "from-bottom" : "from-top"].includes(e.key);
				c?.({
					event: e,
					direction: t ? -1 : 1
				});
			}
		})
	});
}, "SliderVertical")), dk = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ JO(function(e, t) {
	let { __scopeSlider: n, onSlideStart: r, onSlideMove: i, onSlideEnd: a, onHomeKeyDown: o, onEndKeyDown: s, onStepKeyDown: c, ...l } = e, u = ak(QO, n);
	return /* @__PURE__ */ (0, q.jsx)(vy.span, {
		...l,
		ref: t,
		onKeyDown: cb(e.onKeyDown, (e) => {
			e.key === "Home" ? (o(e), e.preventDefault()) : e.key === "End" ? (s(e), e.preventDefault()) : YO.concat(XO).includes(e.key) && (c(e), e.preventDefault());
		}),
		onPointerDown: cb(e.onPointerDown, (e) => {
			let t = e.target;
			t.setPointerCapture(e.pointerId), e.preventDefault(), u.thumbs.has(t) ? t.focus({
				preventScroll: !0,
				focusVisible: !1
			}) : r(e);
		}),
		onPointerMove: cb(e.onPointerMove, (e) => {
			e.target.hasPointerCapture(e.pointerId) && i(e);
		}),
		onPointerUp: cb(e.onPointerUp, (e) => {
			let t = e.target;
			t.hasPointerCapture(e.pointerId) && (t.releasePointerCapture(e.pointerId), a(e));
		})
	});
}, "SliderImpl")), fk = "SliderTrack", pk = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ JO(function(e, t) {
	let { __scopeSlider: n, ...r } = e, i = ak(fk, n);
	return /* @__PURE__ */ (0, q.jsx)(vy.span, {
		"data-disabled": i.disabled ? "" : void 0,
		"data-orientation": i.orientation,
		...r,
		ref: t
	});
}, "SliderTrack")), mk = "SliderRange", hk = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ JO(function(e, t) {
	let { __scopeSlider: n, ...r } = e, i = ak(mk, n), a = ck(mk, n), o = KO(t, A.useRef(null)), s = i.values.length, c = i.values.map((e) => Ek(e, i.min, i.max)), l = s > 1 ? Math.min(...c) : 0, u = 100 - Math.max(...c);
	return /* @__PURE__ */ (0, q.jsx)(vy.span, {
		"data-orientation": i.orientation,
		"data-disabled": i.disabled ? "" : void 0,
		...r,
		ref: o,
		style: {
			...e.style,
			[a.startEdge]: l + "%",
			[a.endEdge]: u + "%"
		}
	});
}, "SliderRange")), [gk, _k] = nk("SliderThumb"), vk = "SliderThumbProvider";
function yk(e) {
	let { __scopeSlider: t, name: n, children: r, internal_do_not_use_render: i } = e, a = ak(vk, t), o = ek(t), [s, c] = A.useState(null), l = A.useMemo(() => s ? o().findIndex((e) => e.ref.current === s) : -1, [o, s]), u = ow(s), d = s ? !!a.form || !!s.closest("form") : !0, f = a.values[l], p = n ?? (a.name ? a.name + (a.values.length > 1 ? "[]" : "") : void 0), m = f === void 0 ? 0 : Ek(f, a.min, a.max);
	A.useEffect(() => {
		if (s) return a.thumbs.add(s), () => {
			a.thumbs.delete(s);
		};
	}, [s, a.thumbs]);
	let h = {
		value: f,
		name: p,
		form: a.form,
		isFormControl: d,
		index: l,
		thumb: s,
		onThumbChange: c,
		percent: m,
		size: u
	};
	return /* @__PURE__ */ (0, q.jsx)(gk, {
		scope: t,
		...h,
		children: Ik(i) ? i(h) : r
	});
}
JO(yk, "SliderThumbProvider");
var bk = "SliderThumbTrigger", xk = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ JO(function(e, t) {
	let { __scopeSlider: n, ...r } = e, i = ak(bk, n), a = ck(bk, n), { index: o, value: s, percent: c, size: l, onThumbChange: u } = _k(bk, n), d = KO(t, u), f = Dk(o, i.values.length), p = l?.[a.size], m = p ? kk(p, c, a.direction) : 0;
	return /* @__PURE__ */ (0, q.jsx)("span", {
		style: {
			transform: "var(--radix-slider-thumb-transform)",
			position: "absolute",
			[a.startEdge]: `calc(${c}% + ${m}px)`
		},
		children: /* @__PURE__ */ (0, q.jsx)($O.ItemSlot, {
			scope: n,
			children: /* @__PURE__ */ (0, q.jsx)(vy.span, {
				role: "slider",
				"aria-label": e["aria-label"] || f,
				"aria-valuemin": i.min,
				"aria-valuenow": s,
				"aria-valuemax": i.max,
				"aria-orientation": i.orientation,
				"data-orientation": i.orientation,
				"data-disabled": i.disabled ? "" : void 0,
				tabIndex: i.disabled ? void 0 : 0,
				...r,
				ref: d,
				style: s === void 0 ? { display: "none" } : e.style,
				onFocus: cb(e.onFocus, () => {
					i.valueIndexToChangeRef.current = o;
				})
			})
		})
	});
}, "SliderThumbTrigger")), Sk = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ JO(function(e, t) {
	let { __scopeSlider: n, name: r, ...i } = e;
	return /* @__PURE__ */ (0, q.jsx)(yk, {
		__scopeSlider: n,
		name: r,
		internal_do_not_use_render: ({ index: e, isFormControl: r }) => /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [/* @__PURE__ */ (0, q.jsx)(xk, {
			...i,
			ref: t,
			__scopeSlider: n
		}), r ? /* @__PURE__ */ (0, q.jsx)(wk, { __scopeSlider: n }, e) : null] })
	});
}, "SliderThumb")), Ck = "SliderBubbleInput", wk = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ JO(function({ __scopeSlider: e, ...t }, n) {
	let { value: r, name: i, form: a } = _k(Ck, e), o = A.useRef(null), s = KO(o, n), c = GE(r);
	return A.useEffect(() => {
		let e = o.current;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "value").set;
		if (c !== r && n) {
			let t = new Event("input", { bubbles: !0 });
			n.call(e, r), e.dispatchEvent(t);
		}
	}, [c, r]), /* @__PURE__ */ (0, q.jsx)(vy.input, {
		style: { display: "none" },
		name: i,
		form: a,
		...t,
		ref: s,
		defaultValue: r
	});
}, "SliderBubbleInput"));
function Tk(e = [], t, n) {
	let r = [...e];
	return r[n] = t, r.sort((e, t) => e - t);
}
JO(Tk, "getNextSortedValues");
function Ek(e, t, n) {
	return JE(100 / (n - t) * (e - t), [0, 100]);
}
JO(Ek, "convertValueToPercentage");
function Dk(e, t) {
	if (t > 2) return `Value ${e + 1} of ${t}`;
	if (t === 2) return ["Minimum", "Maximum"][e];
}
JO(Dk, "getLabel");
function Ok(e, t) {
	if (e.length === 1) return 0;
	let n = e.map((e) => Math.abs(e - t)), r = Math.min(...n);
	return n.indexOf(r);
}
JO(Ok, "getClosestValueIndex");
function kk(e, t, n) {
	let r = e / 2;
	return (r - Mk([0, 50], [0, r])(t) * n) * n;
}
JO(kk, "getThumbInBoundsOffset");
function Ak(e) {
	return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
JO(Ak, "getStepsBetweenValues");
function jk(e, t) {
	if (t > 0) {
		let n = Ak(e);
		return Math.min(...n) >= t;
	}
	return !0;
}
JO(jk, "hasMinStepsBetweenValues");
function Mk(e, t) {
	return (n) => {
		if (e[0] === e[1] || t[0] === t[1]) return t[0];
		let r = (t[1] - t[0]) / (e[1] - e[0]);
		return t[0] + r * (n - e[0]);
	};
}
JO(Mk, "linearScale");
function Nk(e) {
	if (!Number.isFinite(e)) return 0;
	let t = e.toString();
	if (t.includes("e")) {
		let [e, n] = t.split("e"), r = e.split(".")[1] || "", i = Number(n);
		return Math.max(0, r.length - i);
	}
	let n = t.split(".")[1];
	return n ? n.length : 0;
}
JO(Nk, "getDecimalCount");
function Pk(e, t) {
	let n = 10 ** t;
	return Math.round(e * n) / n;
}
JO(Pk, "roundValue");
function Fk(e, { min: t, step: n, direction: r, multiplier: i }) {
	let a = Nk(n), o = (e - t) / n, s = Math.round(o), c = Pk(s * n + t, a) === Pk(e, a), l;
	return l = c ? s + i * r : r > 0 ? Math.ceil(o) : Math.floor(o), Pk(l * n + t, a);
}
JO(Fk, "getNextStepValue");
function Ik(e) {
	return typeof e == "function";
}
JO(Ik, "isFunction");
//#endregion
//#region node_modules/radix-ui/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var Lk = Object.defineProperty, Rk = (e, t) => Lk(e, "name", {
	value: t,
	configurable: !0
});
function zk(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Rk(zk, "setRef");
function Bk(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = zk(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : zk(e[t], null);
			}
		};
	};
}
Rk(Bk, "composeRefs");
function Vk(...e) {
	return A.useCallback(Bk(...e), e);
}
Rk(Vk, "useComposedRefs");
//#endregion
//#region node_modules/radix-ui/node_modules/@radix-ui/react-slot/dist/index.mjs
var Hk = Object.defineProperty, Uk = (e, t) => Hk(e, "name", {
	value: t,
	configurable: !0
});
/* @__NO_SIDE_EFFECTS__ */
function Wk(e) {
	let t = A.forwardRef((t, n) => {
		let { children: r, ...i } = t, a = null, o = !1, s = [];
		$k(r) && typeof rA == "function" && (r = rA(r._payload)), A.Children.forEach(r, (e) => {
			if (Zk(e)) {
				o = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				$k(n) && typeof rA == "function" && (n = rA(n._payload)), a = Jk(t, n), s.push(a?.props?.children);
			} else s.push(e);
		}), a ? a = A.cloneElement(a, void 0, s) : !o && A.Children.count(r) === 1 && A.isValidElement(r) && (a = r);
		let c = a ? Xk(a) : void 0, l = Vk(n, c);
		if (!a) {
			if (r || r === 0) throw Error(o ? nA(e) : tA(e));
			return r;
		}
		let u = Yk(i, a.props ?? {});
		return a.type !== A.Fragment && (u.ref = n ? l : c), A.cloneElement(a, u);
	});
	return t.displayName = `${e}.Slot`, t;
}
Uk(Wk, "createSlot");
var Gk = /* @__PURE__ */ Wk("Slot"), Kk = Symbol.for("radix.slottable");
/* @__NO_SIDE_EFFECTS__ */
function qk(e) {
	let t = /* @__PURE__ */ Uk((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = Kk, t;
}
Uk(qk, "createSlottable");
var Jk = /* @__PURE__ */ Uk((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return A.isValidElement(t) ? A.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return A.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function Yk(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
Uk(Yk, "mergeProps");
function Xk(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Uk(Xk, "getElementRef");
function Zk(e) {
	return A.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Kk;
}
Uk(Zk, "isSlottable");
var Qk = Symbol.for("react.lazy");
function $k(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === Qk && "_payload" in e && eA(e._payload);
}
Uk($k, "isLazyComponent");
function eA(e) {
	return typeof e == "object" && !!e && "then" in e;
}
Uk(eA, "isPromiseLike");
var tA = /* @__PURE__ */ Uk((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), nA = /* @__PURE__ */ Uk((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), rA = A.use, iA = Object.defineProperty, aA = (e, t) => iA(e, "name", {
	value: t,
	configurable: !0
});
function oA(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
aA(oA, "setRef");
function sA(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = oA(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : oA(e[t], null);
			}
		};
	};
}
aA(sA, "composeRefs");
function cA(...e) {
	return A.useCallback(sA(...e), e);
}
aA(cA, "useComposedRefs");
//#endregion
//#region node_modules/@radix-ui/react-switch/dist/index.mjs
var lA = Object.defineProperty, uA = (e, t) => lA(e, "name", {
	value: t,
	configurable: !0
}), dA = "Switch", [fA, pA] = /* @__PURE__ */ wy(dA), [mA, hA] = fA(dA);
function gA(e) {
	let { __scopeSwitch: t, checked: n, children: r, defaultChecked: i, disabled: a, form: o, name: s, onCheckedChange: c, required: l, value: u = "on", internal_do_not_use_render: d } = e, [f, p] = Sb({
		prop: n,
		defaultProp: i ?? !1,
		onChange: c,
		caller: dA
	}), [m, h] = A.useState(null), [g, _] = A.useState(null), v = A.useRef(!1), [y, b] = A.useReducer((e) => e + 1, 0), x = {
		checked: f,
		setChecked: p,
		disabled: a,
		control: m,
		setControl: h,
		name: s,
		form: o,
		value: u,
		hasConsumerStoppedPropagationRef: v,
		userInteractionCount: y,
		onUserInteraction: b,
		required: l,
		defaultChecked: i,
		isFormControl: m ? !!o || !!m.closest("form") : !0,
		bubbleInput: g,
		setBubbleInput: _
	};
	return /* @__PURE__ */ (0, q.jsx)(mA, {
		scope: t,
		...x,
		children: wA(d) ? d(x) : r
	});
}
uA(gA, "SwitchProvider");
var _A = "SwitchTrigger", vA = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ uA(function({ __scopeSwitch: e, onClick: t, ...n }, r) {
	let { control: i, form: a, value: o, disabled: s, checked: c, required: l, setControl: u, setChecked: d, hasConsumerStoppedPropagationRef: f, onUserInteraction: p, isFormControl: m, bubbleInput: h } = hA(_A, e), g = cA(r, u), _ = A.useRef(c);
	return A.useEffect(() => {
		let e = a ? i?.ownerDocument.getElementById(a) : i?.form;
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ uA(() => d(_.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		i,
		a,
		d
	]), /* @__PURE__ */ (0, q.jsx)(vy.button, {
		type: "button",
		role: "switch",
		"aria-checked": c,
		"aria-required": l,
		"data-state": TA(c),
		"data-disabled": s ? "" : void 0,
		disabled: s,
		value: o,
		...n,
		ref: g,
		onClick: cb(t, (e) => {
			p(), d((e) => !e), h && m && (f.current = e.isPropagationStopped(), f.current || e.stopPropagation());
		})
	});
}, "SwitchTrigger")), yA = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ uA(function(e, t) {
	let { __scopeSwitch: n, name: r, checked: i, defaultChecked: a, required: o, disabled: s, value: c, onCheckedChange: l, form: u, ...d } = e;
	return /* @__PURE__ */ (0, q.jsx)(gA, {
		__scopeSwitch: n,
		checked: i,
		defaultChecked: a,
		disabled: s,
		required: o,
		onCheckedChange: l,
		name: r,
		form: u,
		value: c,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [/* @__PURE__ */ (0, q.jsx)(vA, {
			...d,
			ref: t,
			__scopeSwitch: n
		}), e && /* @__PURE__ */ (0, q.jsx)(CA, { __scopeSwitch: n })] })
	});
}, "Switch")), bA = "SwitchThumb", xA = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ uA(function(e, t) {
	let { __scopeSwitch: n, ...r } = e, i = hA(bA, n);
	return /* @__PURE__ */ (0, q.jsx)(vy.span, {
		"data-state": TA(i.checked),
		"data-disabled": i.disabled ? "" : void 0,
		...r,
		ref: t
	});
}, "SwitchThumb")), SA = "SwitchBubbleInput", CA = /* @__PURE__ */ A.forwardRef(/* @__PURE__ */ uA(function({ __scopeSwitch: e, onClick: t, ...n }, r) {
	let { control: i, hasConsumerStoppedPropagationRef: a, userInteractionCount: o, checked: s, defaultChecked: c, required: l, disabled: u, name: d, value: f, form: p, bubbleInput: m, setBubbleInput: h } = hA(SA, e), g = cA(r, h), _ = ow(i), v = A.useRef(!1), y = A.useRef(s), b = A.useRef(o);
	A.useEffect(() => {
		let e = m;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "checked").set, r = o !== b.current;
		b.current = o;
		let i = y.current !== s;
		y.current = s;
		let c = !(r && a.current);
		if (i && n) {
			v.current = !r;
			let t = new Event("click", { bubbles: c });
			n.call(e, s), e.dispatchEvent(t), v.current = !1;
		}
	}, [
		m,
		s,
		a,
		o
	]);
	let x = A.useRef(s);
	return /* @__PURE__ */ (0, q.jsx)(vy.input, {
		type: "checkbox",
		"aria-hidden": !0,
		defaultChecked: c ?? x.current,
		required: l,
		disabled: u,
		name: d,
		value: f,
		form: p,
		...n,
		tabIndex: -1,
		ref: g,
		onClick: cb(t, (e) => {
			v.current && e.stopPropagation();
		}),
		style: {
			...n.style,
			..._,
			position: "absolute",
			pointerEvents: "none",
			opacity: 0,
			margin: 0,
			transform: "translateX(-100%)"
		}
	});
}, "SwitchBubbleInput"));
function wA(e) {
	return typeof e == "function";
}
uA(wA, "isFunction");
function TA(e) {
	return e ? "checked" : "unchecked";
}
uA(TA, "getState");
//#endregion
//#region node_modules/tailwind-merge/dist/bundle-mjs.mjs
var EA = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, DA = (e, t) => ({
	classGroupId: e,
	validator: t
}), OA = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), kA = "-", AA = [], jA = "arbitrary..", MA = (e) => {
	let t = FA(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return PA(e);
			let n = e.split(kA);
			return NA(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? EA(i, t) : t : i || AA;
			}
			return n[e] || AA;
		}
	};
}, NA = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = NA(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(kA) : e.slice(t).join(kA), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, PA = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? jA + r : void 0;
})(), FA = (e) => {
	let { theme: t, classGroups: n } = e;
	return IA(n, t);
}, IA = (e, t) => {
	let n = OA();
	for (let r in e) {
		let i = e[r];
		LA(i, n, r, t);
	}
	return n;
}, LA = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		RA(i, t, n, r);
	}
}, RA = (e, t, n, r) => {
	if (typeof e == "string") {
		zA(e, t, n);
		return;
	}
	if (typeof e == "function") {
		BA(e, t, n, r);
		return;
	}
	VA(e, t, n, r);
}, zA = (e, t, n) => {
	let r = e === "" ? t : HA(t, e);
	r.classGroupId = n;
}, BA = (e, t, n, r) => {
	if (UA(e)) {
		LA(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(DA(n, e));
}, VA = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		LA(o, HA(t, a), n, r);
	}
}, HA = (e, t) => {
	let n = e, r = t.split(kA), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = OA(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, UA = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, WA = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, GA = "!", KA = ":", qA = [], JA = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), YA = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === KA) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(GA) ? (c = s.slice(0, -1), l = !0) : s.startsWith(GA) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return JA(t, l, c, u);
	};
	if (t) {
		let e = t + KA, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : JA(qA, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, XA = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, ZA = (e) => ({
	cache: WA(e.cacheSize),
	parseClassName: YA(e),
	sortModifiers: XA(e),
	postfixLookupClassGroupIds: QA(e),
	...MA(e)
}), QA = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, $A = /\s+/, ej = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split($A), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			if (g = r(p), !g) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let _ = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), v = f ? _ + GA : _, y = v + g;
		if (s.indexOf(y) > -1) continue;
		s.push(y);
		let b = i(g, h);
		for (let e = 0; e < b.length; ++e) {
			let t = b[e];
			s.push(v + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, tj = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = nj(n)) && (i && (i += " "), i += r);
	return i;
}, nj = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = nj(e[r])) && (n && (n += " "), n += t);
	return n;
}, rj = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = ZA(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = ej(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(tj(...e));
}, ij = [], aj = (e) => {
	let t = (t) => t[e] || ij;
	return t.isThemeGetter = !0, t;
}, oj = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, sj = /^\((?:(\w[\w-]*):)?(.+)\)$/i, cj = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, lj = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, uj = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, dj = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, fj = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, pj = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, mj = (e) => cj.test(e), hj = (e) => !!e && !Number.isNaN(Number(e)), gj = (e) => !!e && Number.isInteger(Number(e)), _j = (e) => e.endsWith("%") && hj(e.slice(0, -1)), vj = (e) => lj.test(e), yj = () => !0, bj = (e) => uj.test(e) && !dj.test(e), xj = () => !1, Sj = (e) => fj.test(e), Cj = (e) => pj.test(e), wj = (e) => !Q(e) && !$(e), Tj = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), Ej = (e) => Vj(e, Gj, xj), Q = (e) => oj.test(e), Dj = (e) => Vj(e, Kj, bj), Oj = (e) => Vj(e, qj, hj), kj = (e) => Vj(e, Yj, yj), Aj = (e) => Vj(e, Jj, xj), jj = (e) => Vj(e, Uj, xj), Mj = (e) => Vj(e, Wj, Cj), Nj = (e) => Vj(e, Xj, Sj), $ = (e) => sj.test(e), Pj = (e) => Hj(e, Kj), Fj = (e) => Hj(e, Jj), Ij = (e) => Hj(e, Uj), Lj = (e) => Hj(e, Gj), Rj = (e) => Hj(e, Wj), zj = (e) => Hj(e, Xj, !0), Bj = (e) => Hj(e, Yj, !0), Vj = (e, t, n) => {
	let r = oj.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Hj = (e, t, n = !1) => {
	let r = sj.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, Uj = (e) => e === "position" || e === "percentage", Wj = (e) => e === "image" || e === "url", Gj = (e) => e === "length" || e === "size" || e === "bg-size", Kj = (e) => e === "length", qj = (e) => e === "number", Jj = (e) => e === "family-name", Yj = (e) => e === "number" || e === "weight", Xj = (e) => e === "shadow", Zj = /* @__PURE__ */ rj(() => {
	let e = aj("color"), t = aj("font"), n = aj("text"), r = aj("font-weight"), i = aj("tracking"), a = aj("leading"), o = aj("breakpoint"), s = aj("container"), c = aj("spacing"), l = aj("radius"), u = aj("shadow"), d = aj("inset-shadow"), f = aj("text-shadow"), p = aj("drop-shadow"), m = aj("blur"), h = aj("perspective"), g = aj("aspect"), _ = aj("ease"), v = aj("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		$,
		Q
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		$,
		Q,
		c
	], T = () => [
		mj,
		"full",
		"auto",
		...w()
	], E = () => [
		gj,
		"none",
		"subgrid",
		$,
		Q
	], D = () => [
		"auto",
		{ span: [
			"full",
			gj,
			$,
			Q
		] },
		gj,
		$,
		Q
	], O = () => [
		gj,
		"auto",
		$,
		Q
	], k = () => [
		"auto",
		"min",
		"max",
		"fr",
		$,
		Q
	], A = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], j = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], M = () => ["auto", ...w()], N = () => [
		mj,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], P = () => [
		mj,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...w()
	], F = () => [
		mj,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], I = () => [
		e,
		$,
		Q
	], R = () => [
		...b(),
		Ij,
		jj,
		{ position: [$, Q] }
	], ee = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], te = () => [
		"auto",
		"cover",
		"contain",
		Lj,
		Ej,
		{ size: [$, Q] }
	], ne = () => [
		_j,
		Pj,
		Dj
	], z = () => [
		"",
		"none",
		"full",
		l,
		$,
		Q
	], B = () => [
		"",
		hj,
		Pj,
		Dj
	], V = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], re = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], ie = () => [
		hj,
		_j,
		Ij,
		jj
	], ae = () => [
		"",
		"none",
		m,
		$,
		Q
	], oe = () => [
		"none",
		hj,
		$,
		Q
	], se = () => [
		"none",
		hj,
		$,
		Q
	], ce = () => [
		hj,
		$,
		Q
	], le = () => [
		mj,
		"full",
		...w()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [vj],
			breakpoint: [vj],
			color: [yj],
			container: [vj],
			"drop-shadow": [vj],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [wj],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [vj],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [vj],
			shadow: [vj],
			spacing: ["px", hj],
			text: [vj],
			"text-shadow": [vj],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				mj,
				Q,
				$,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				$,
				Q
			] }],
			"container-named": [Tj],
			columns: [{ columns: [
				hj,
				Q,
				$,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{
				"inset-s": T(),
				start: T()
			}],
			end: [{
				"inset-e": T(),
				end: T()
			}],
			"inset-bs": [{ "inset-bs": T() }],
			"inset-be": [{ "inset-be": T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				gj,
				"auto",
				$,
				Q
			] }],
			basis: [{ basis: [
				mj,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				hj,
				mj,
				"auto",
				"initial",
				"none",
				Q
			] }],
			grow: [{ grow: [
				"",
				hj,
				$,
				Q
			] }],
			shrink: [{ shrink: [
				"",
				hj,
				$,
				Q
			] }],
			order: [{ order: [
				gj,
				"first",
				"last",
				"none",
				$,
				Q
			] }],
			"grid-cols": [{ "grid-cols": E() }],
			"col-start-end": [{ col: D() }],
			"col-start": [{ "col-start": O() }],
			"col-end": [{ "col-end": O() }],
			"grid-rows": [{ "grid-rows": E() }],
			"row-start-end": [{ row: D() }],
			"row-start": [{ "row-start": O() }],
			"row-end": [{ "row-end": O() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": k() }],
			"auto-rows": [{ "auto-rows": k() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...A(), "normal"] }],
			"justify-items": [{ "justify-items": [...j(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...j()] }],
			"align-content": [{ content: ["normal", ...A()] }],
			"align-items": [{ items: [...j(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...j(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": A() }],
			"place-items": [{ "place-items": [...j(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...j()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pbs: [{ pbs: w() }],
			pbe: [{ pbe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: M() }],
			mx: [{ mx: M() }],
			my: [{ my: M() }],
			ms: [{ ms: M() }],
			me: [{ me: M() }],
			mbs: [{ mbs: M() }],
			mbe: [{ mbe: M() }],
			mt: [{ mt: M() }],
			mr: [{ mr: M() }],
			mb: [{ mb: M() }],
			ml: [{ ml: M() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: N() }],
			"inline-size": [{ inline: ["auto", ...P()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...P()] }],
			"max-inline-size": [{ "max-inline": ["none", ...P()] }],
			"block-size": [{ block: ["auto", ...F()] }],
			"min-block-size": [{ "min-block": ["auto", ...F()] }],
			"max-block-size": [{ "max-block": ["none", ...F()] }],
			w: [{ w: [
				s,
				"screen",
				...N()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...N()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...N()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...N()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...N()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				...N()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				Pj,
				Dj
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				Bj,
				kj
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				_j,
				Q
			] }],
			"font-family": [{ font: [
				Fj,
				Aj,
				t
			] }],
			"font-features": [{ "font-features": [Q] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				$,
				Q
			] }],
			"line-clamp": [{ "line-clamp": [
				hj,
				"none",
				$,
				Oj
			] }],
			leading: [{ leading: [a, ...w()] }],
			"list-image": [{ "list-image": [
				"none",
				$,
				Q
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				$,
				Q
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: I() }],
			"text-color": [{ text: I() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...V(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				hj,
				"from-font",
				"auto",
				$,
				Dj
			] }],
			"text-decoration-color": [{ decoration: I() }],
			"underline-offset": [{ "underline-offset": [
				hj,
				"auto",
				$,
				Q
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"tab-size": [{ tab: [
				gj,
				$,
				Q
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				$,
				Q
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				$,
				Q
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: R() }],
			"bg-repeat": [{ bg: ee() }],
			"bg-size": [{ bg: te() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						gj,
						$,
						Q
					],
					radial: [
						"",
						$,
						Q
					],
					conic: [
						gj,
						$,
						Q
					]
				},
				Rj,
				Mj
			] }],
			"bg-color": [{ bg: I() }],
			"gradient-from-pos": [{ from: ne() }],
			"gradient-via-pos": [{ via: ne() }],
			"gradient-to-pos": [{ to: ne() }],
			"gradient-from": [{ from: I() }],
			"gradient-via": [{ via: I() }],
			"gradient-to": [{ to: I() }],
			rounded: [{ rounded: z() }],
			"rounded-s": [{ "rounded-s": z() }],
			"rounded-e": [{ "rounded-e": z() }],
			"rounded-t": [{ "rounded-t": z() }],
			"rounded-r": [{ "rounded-r": z() }],
			"rounded-b": [{ "rounded-b": z() }],
			"rounded-l": [{ "rounded-l": z() }],
			"rounded-ss": [{ "rounded-ss": z() }],
			"rounded-se": [{ "rounded-se": z() }],
			"rounded-ee": [{ "rounded-ee": z() }],
			"rounded-es": [{ "rounded-es": z() }],
			"rounded-tl": [{ "rounded-tl": z() }],
			"rounded-tr": [{ "rounded-tr": z() }],
			"rounded-br": [{ "rounded-br": z() }],
			"rounded-bl": [{ "rounded-bl": z() }],
			"border-w": [{ border: B() }],
			"border-w-x": [{ "border-x": B() }],
			"border-w-y": [{ "border-y": B() }],
			"border-w-s": [{ "border-s": B() }],
			"border-w-e": [{ "border-e": B() }],
			"border-w-bs": [{ "border-bs": B() }],
			"border-w-be": [{ "border-be": B() }],
			"border-w-t": [{ "border-t": B() }],
			"border-w-r": [{ "border-r": B() }],
			"border-w-b": [{ "border-b": B() }],
			"border-w-l": [{ "border-l": B() }],
			"divide-x": [{ "divide-x": B() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": B() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...V(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...V(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: I() }],
			"border-color-x": [{ "border-x": I() }],
			"border-color-y": [{ "border-y": I() }],
			"border-color-s": [{ "border-s": I() }],
			"border-color-e": [{ "border-e": I() }],
			"border-color-bs": [{ "border-bs": I() }],
			"border-color-be": [{ "border-be": I() }],
			"border-color-t": [{ "border-t": I() }],
			"border-color-r": [{ "border-r": I() }],
			"border-color-b": [{ "border-b": I() }],
			"border-color-l": [{ "border-l": I() }],
			"divide-color": [{ divide: I() }],
			"outline-style": [{ outline: [
				...V(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				hj,
				$,
				Q
			] }],
			"outline-w": [{ outline: [
				"",
				hj,
				Pj,
				Dj
			] }],
			"outline-color": [{ outline: I() }],
			shadow: [{ shadow: [
				"",
				"none",
				u,
				zj,
				Nj
			] }],
			"shadow-color": [{ shadow: I() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				zj,
				Nj
			] }],
			"inset-shadow-color": [{ "inset-shadow": I() }],
			"ring-w": [{ ring: B() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: I() }],
			"ring-offset-w": [{ "ring-offset": [hj, Dj] }],
			"ring-offset-color": [{ "ring-offset": I() }],
			"inset-ring-w": [{ "inset-ring": B() }],
			"inset-ring-color": [{ "inset-ring": I() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				zj,
				Nj
			] }],
			"text-shadow-color": [{ "text-shadow": I() }],
			opacity: [{ opacity: [
				hj,
				$,
				Q
			] }],
			"mix-blend": [{ "mix-blend": [
				...re(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": re() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [hj] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": ie() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": ie() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": I() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": I() }],
			"mask-image-t-from-pos": [{ "mask-t-from": ie() }],
			"mask-image-t-to-pos": [{ "mask-t-to": ie() }],
			"mask-image-t-from-color": [{ "mask-t-from": I() }],
			"mask-image-t-to-color": [{ "mask-t-to": I() }],
			"mask-image-r-from-pos": [{ "mask-r-from": ie() }],
			"mask-image-r-to-pos": [{ "mask-r-to": ie() }],
			"mask-image-r-from-color": [{ "mask-r-from": I() }],
			"mask-image-r-to-color": [{ "mask-r-to": I() }],
			"mask-image-b-from-pos": [{ "mask-b-from": ie() }],
			"mask-image-b-to-pos": [{ "mask-b-to": ie() }],
			"mask-image-b-from-color": [{ "mask-b-from": I() }],
			"mask-image-b-to-color": [{ "mask-b-to": I() }],
			"mask-image-l-from-pos": [{ "mask-l-from": ie() }],
			"mask-image-l-to-pos": [{ "mask-l-to": ie() }],
			"mask-image-l-from-color": [{ "mask-l-from": I() }],
			"mask-image-l-to-color": [{ "mask-l-to": I() }],
			"mask-image-x-from-pos": [{ "mask-x-from": ie() }],
			"mask-image-x-to-pos": [{ "mask-x-to": ie() }],
			"mask-image-x-from-color": [{ "mask-x-from": I() }],
			"mask-image-x-to-color": [{ "mask-x-to": I() }],
			"mask-image-y-from-pos": [{ "mask-y-from": ie() }],
			"mask-image-y-to-pos": [{ "mask-y-to": ie() }],
			"mask-image-y-from-color": [{ "mask-y-from": I() }],
			"mask-image-y-to-color": [{ "mask-y-to": I() }],
			"mask-image-radial": [{ "mask-radial": [$, Q] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": ie() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": ie() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": I() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": I() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [hj] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": ie() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": ie() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": I() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": I() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: R() }],
			"mask-repeat": [{ mask: ee() }],
			"mask-size": [{ mask: te() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				$,
				Q
			] }],
			filter: [{ filter: [
				"",
				"none",
				$,
				Q
			] }],
			blur: [{ blur: ae() }],
			brightness: [{ brightness: [
				hj,
				$,
				Q
			] }],
			contrast: [{ contrast: [
				hj,
				$,
				Q
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				zj,
				Nj
			] }],
			"drop-shadow-color": [{ "drop-shadow": I() }],
			grayscale: [{ grayscale: [
				"",
				hj,
				$,
				Q
			] }],
			"hue-rotate": [{ "hue-rotate": [
				hj,
				$,
				Q
			] }],
			invert: [{ invert: [
				"",
				hj,
				$,
				Q
			] }],
			saturate: [{ saturate: [
				hj,
				$,
				Q
			] }],
			sepia: [{ sepia: [
				"",
				hj,
				$,
				Q
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				$,
				Q
			] }],
			"backdrop-blur": [{ "backdrop-blur": ae() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				hj,
				$,
				Q
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				hj,
				$,
				Q
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				hj,
				$,
				Q
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				hj,
				$,
				Q
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				hj,
				$,
				Q
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				hj,
				$,
				Q
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				hj,
				$,
				Q
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				hj,
				$,
				Q
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				$,
				Q
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				hj,
				"initial",
				$,
				Q
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				$,
				Q
			] }],
			delay: [{ delay: [
				hj,
				$,
				Q
			] }],
			animate: [{ animate: [
				"none",
				v,
				$,
				Q
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				$,
				Q
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: oe() }],
			"rotate-x": [{ "rotate-x": oe() }],
			"rotate-y": [{ "rotate-y": oe() }],
			"rotate-z": [{ "rotate-z": oe() }],
			scale: [{ scale: se() }],
			"scale-x": [{ "scale-x": se() }],
			"scale-y": [{ "scale-y": se() }],
			"scale-z": [{ "scale-z": se() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: ce() }],
			"skew-x": [{ "skew-x": ce() }],
			"skew-y": [{ "skew-y": ce() }],
			transform: [{ transform: [
				$,
				Q,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: le() }],
			"translate-x": [{ "translate-x": le() }],
			"translate-y": [{ "translate-y": le() }],
			"translate-z": [{ "translate-z": le() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				gj,
				$,
				Q
			] }],
			accent: [{ accent: I() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: I() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				$,
				Q
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": I() }],
			"scrollbar-track-color": [{ "scrollbar-track": I() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mbs": [{ "scroll-mbs": w() }],
			"scroll-mbe": [{ "scroll-mbe": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pbs": [{ "scroll-pbs": w() }],
			"scroll-pbe": [{ "scroll-pbe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				$,
				Q
			] }],
			fill: [{ fill: ["none", ...I()] }],
			"stroke-w": [{ stroke: [
				hj,
				Pj,
				Dj,
				Oj
			] }],
			stroke: [{ stroke: ["none", ...I()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
});
//#endregion
//#region lib/utils.ts
function Qj(...e) {
	return Zj(Kv(e));
}
//#endregion
//#region components/ui/button.tsx
var $j = Yv("inline-flex shrink-0 items-center justify-center gap-2 rounded-md text-sm font-medium whitespace-nowrap transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground hover:bg-primary/90",
			destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:bg-destructive/60 dark:focus-visible:ring-destructive/40",
			outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
			secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
			ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-9 px-4 py-2 has-[>svg]:px-3",
			xs: "h-6 gap-1 rounded-md px-2 text-xs has-[>svg]:px-1.5 [&_svg:not([class*='size-'])]:size-3",
			sm: "h-8 gap-1.5 rounded-md px-3 has-[>svg]:px-2.5",
			lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
			icon: "size-9",
			"icon-xs": "size-6 rounded-md [&_svg:not([class*='size-'])]:size-3",
			"icon-sm": "size-8",
			"icon-lg": "size-10"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function eM({ className: e, variant: t = "default", size: n = "default", asChild: r = !1, ...i }) {
	return /* @__PURE__ */ (0, q.jsx)(r ? Gk : "button", {
		"data-slot": "button",
		"data-variant": t,
		"data-size": n,
		className: Qj($j({
			variant: t,
			size: n,
			className: e
		})),
		...i
	});
}
//#endregion
//#region components/ui/dialog.tsx
function tM({ ...e }) {
	return /* @__PURE__ */ (0, q.jsx)(FC, {
		"data-slot": "dialog",
		...e
	});
}
function nM({ ...e }) {
	return /* @__PURE__ */ (0, q.jsx)(LC, {
		"data-slot": "dialog-trigger",
		...e
	});
}
function rM({ ...e }) {
	return /* @__PURE__ */ (0, q.jsx)(VC, {
		"data-slot": "dialog-portal",
		...e
	});
}
function iM({ ...e }) {
	return /* @__PURE__ */ (0, q.jsx)(nw, {
		"data-slot": "dialog-close",
		...e
	});
}
function aM({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(UC, {
		"data-slot": "dialog-overlay",
		className: Qj("fixed inset-0 z-50 bg-black/50 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0", e),
		...t
	});
}
function oM({ className: e, children: t, showCloseButton: n = !0, ...r }) {
	return /* @__PURE__ */ (0, q.jsxs)(rM, {
		"data-slot": "dialog-portal",
		children: [/* @__PURE__ */ (0, q.jsx)(aM, {}), /* @__PURE__ */ (0, q.jsxs)(qC, {
			"data-slot": "dialog-content",
			className: Qj("fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border bg-background p-6 shadow-lg duration-200 outline-none data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 sm:max-w-lg", e),
			...r,
			children: [t, n && /* @__PURE__ */ (0, q.jsxs)(nw, {
				"data-slot": "dialog-close",
				className: "absolute top-4 right-4 rounded-xs opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
				children: [/* @__PURE__ */ (0, q.jsx)(xe, {}), /* @__PURE__ */ (0, q.jsx)("span", {
					className: "sr-only",
					children: "Close"
				})]
			})]
		})]
	});
}
function sM({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)("div", {
		"data-slot": "dialog-header",
		className: Qj("flex flex-col gap-2 text-center sm:text-left", e),
		...t
	});
}
function cM({ className: e, showCloseButton: t = !1, children: n, ...r }) {
	return /* @__PURE__ */ (0, q.jsxs)("div", {
		"data-slot": "dialog-footer",
		className: Qj("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", e),
		...r,
		children: [n, t && /* @__PURE__ */ (0, q.jsx)(nw, {
			asChild: !0,
			children: /* @__PURE__ */ (0, q.jsx)(eM, {
				variant: "outline",
				children: "Close"
			})
		})]
	});
}
function lM({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(QC, {
		"data-slot": "dialog-title",
		className: Qj("text-lg leading-none font-semibold", e),
		...t
	});
}
function uM({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(ew, {
		"data-slot": "dialog-description",
		className: Qj("text-sm text-muted-foreground", e),
		...t
	});
}
//#endregion
//#region components/ui/input.tsx
function dM({ className: e, type: t, ...n }) {
	return /* @__PURE__ */ (0, q.jsx)("input", {
		type: t,
		"data-slot": "input",
		className: Qj("h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30", "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50", "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40", e),
		...n
	});
}
//#endregion
//#region components/ui/progress.tsx
function fM({ className: e, value: t, ...n }) {
	return /* @__PURE__ */ (0, q.jsx)(pD, {
		"data-slot": "progress",
		value: t,
		className: Qj("relative h-2 w-full overflow-hidden rounded-full bg-primary/20", e),
		...n,
		children: /* @__PURE__ */ (0, q.jsx)(mD, {
			"data-slot": "progress-indicator",
			className: "h-full w-full flex-1 bg-primary transition-all",
			style: { transform: `translateX(-${100 - (t ?? 0)}%)` }
		})
	});
}
//#endregion
//#region components/ui/select.tsx
function pM({ ...e }) {
	return /* @__PURE__ */ (0, q.jsx)(ZD, {
		"data-slot": "select",
		...e
	});
}
function mM({ ...e }) {
	return /* @__PURE__ */ (0, q.jsx)(tO, {
		"data-slot": "select-value",
		...e
	});
}
function hM({ className: e, size: t = "default", children: n, ...r }) {
	return /* @__PURE__ */ (0, q.jsxs)($D, {
		"data-slot": "select-trigger",
		"data-size": t,
		className: Qj("flex w-fit items-center justify-between gap-2 rounded-md border border-input bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[placeholder]:text-muted-foreground data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 dark:bg-input/30 dark:hover:bg-input/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground", e),
		...r,
		children: [n, /* @__PURE__ */ (0, q.jsx)(nO, {
			asChild: !0,
			children: /* @__PURE__ */ (0, q.jsx)(ee, { className: "size-4 opacity-50" })
		})]
	});
}
function gM({ className: e, children: t, position: n = "item-aligned", align: r = "center", ...i }) {
	return /* @__PURE__ */ (0, q.jsx)(aO, { children: /* @__PURE__ */ (0, q.jsxs)(sO, {
		"data-slot": "select-content",
		className: Qj("relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border bg-popover text-popover-foreground shadow-md data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95", n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", e),
		position: n,
		align: r,
		...i,
		children: [
			/* @__PURE__ */ (0, q.jsx)(vM, {}),
			/* @__PURE__ */ (0, q.jsx)(yO, {
				className: Qj("p-1", n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"),
				children: t
			}),
			/* @__PURE__ */ (0, q.jsx)(yM, {})
		]
	}) });
}
function _M({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ (0, q.jsxs)(TO, {
		"data-slot": "select-item",
		className: Qj("relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", e),
		...n,
		children: [/* @__PURE__ */ (0, q.jsx)("span", {
			"data-slot": "select-item-indicator",
			className: "absolute right-2 flex size-3.5 items-center justify-center",
			children: /* @__PURE__ */ (0, q.jsx)(kO, { children: /* @__PURE__ */ (0, q.jsx)(R, { className: "size-4" }) })
		}), /* @__PURE__ */ (0, q.jsx)(DO, { children: t })]
	});
}
function vM({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(jO, {
		"data-slot": "select-scroll-up-button",
		className: Qj("flex cursor-default items-center justify-center py-1", e),
		...t,
		children: /* @__PURE__ */ (0, q.jsx)(te, { className: "size-4" })
	});
}
function yM({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(NO, {
		"data-slot": "select-scroll-down-button",
		className: Qj("flex cursor-default items-center justify-center py-1", e),
		...t,
		children: /* @__PURE__ */ (0, q.jsx)(ee, { className: "size-4" })
	});
}
//#endregion
//#region components/ui/slider.tsx
function bM({ className: e, defaultValue: t, value: n, min: r = 0, max: i = 100, ...a }) {
	let o = A.useMemo(() => Array.isArray(n) ? n : Array.isArray(t) ? t : [r, i], [
		n,
		t,
		r,
		i
	]);
	return /* @__PURE__ */ (0, q.jsxs)(ok, {
		"data-slot": "slider",
		defaultValue: t,
		value: n,
		min: r,
		max: i,
		className: Qj("relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col", e),
		...a,
		children: [/* @__PURE__ */ (0, q.jsx)(pk, {
			"data-slot": "slider-track",
			className: Qj("relative grow overflow-hidden rounded-full bg-muted data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"),
			children: /* @__PURE__ */ (0, q.jsx)(hk, {
				"data-slot": "slider-range",
				className: Qj("absolute bg-primary data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full")
			})
		}), Array.from({ length: o.length }, (e, t) => /* @__PURE__ */ (0, q.jsx)(Sk, {
			"data-slot": "slider-thumb",
			className: "block size-4 shrink-0 rounded-full border border-primary bg-white shadow-sm ring-ring/50 transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50"
		}, t))]
	});
}
//#endregion
//#region components/ui/switch.tsx
function xM({ className: e, size: t = "default", ...n }) {
	return /* @__PURE__ */ (0, q.jsx)(yA, {
		"data-slot": "switch",
		"data-size": t,
		className: Qj("peer group/switch inline-flex shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-[1.15rem] data-[size=default]:w-8 data-[size=sm]:h-3.5 data-[size=sm]:w-6 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input dark:data-[state=unchecked]:bg-input/80", e),
		...n,
		children: /* @__PURE__ */ (0, q.jsx)(xA, {
			"data-slot": "switch-thumb",
			className: Qj("pointer-events-none block rounded-full bg-background ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0 dark:data-[state=checked]:bg-primary-foreground dark:data-[state=unchecked]:bg-foreground")
		})
	});
}
//#endregion
//#region node_modules/next-themes/dist/index.mjs
var SM = (e, t, n, r, i, a, o, s) => {
	let c = document.documentElement, l = ["light", "dark"];
	function u(t) {
		(Array.isArray(e) ? e : [e]).forEach((e) => {
			let n = e === "class", r = n && a ? i.map((e) => a[e] || e) : i;
			n ? (c.classList.remove(...r), c.classList.add(a && a[t] ? a[t] : t)) : c.setAttribute(e, t);
		}), d(t);
	}
	function d(e) {
		s && l.includes(e) && (c.style.colorScheme = e);
	}
	function f() {
		return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
	}
	if (r) u(r);
	else try {
		let e = localStorage.getItem(t) || n;
		u(o && e === "system" ? f() : e);
	} catch {}
}, CM = A.createContext(void 0), wM = {
	setTheme: (e) => {},
	themes: []
}, TM = () => A.useContext(CM) ?? wM;
A.memo(({ forcedTheme: e, storageKey: t, attribute: n, enableSystem: r, enableColorScheme: i, defaultTheme: a, value: o, themes: s, nonce: c, scriptProps: l }) => {
	let u = JSON.stringify([
		n,
		t,
		a,
		e,
		s,
		o,
		r,
		i
	]).slice(1, -1);
	return A.createElement("script", {
		...l,
		suppressHydrationWarning: !0,
		nonce: typeof window > "u" ? c : "",
		dangerouslySetInnerHTML: { __html: `(${SM.toString()})(${u})` }
	});
});
var EM = ({ ...e }) => {
	let { theme: t = "system" } = TM();
	return /* @__PURE__ */ (0, q.jsx)(tt, {
		theme: t,
		className: "toaster group",
		icons: {
			success: /* @__PURE__ */ (0, q.jsx)(ne, { className: "size-4" }),
			info: /* @__PURE__ */ (0, q.jsx)(ie, { className: "size-4" }),
			warning: /* @__PURE__ */ (0, q.jsx)(be, { className: "size-4" }),
			error: /* @__PURE__ */ (0, q.jsx)(de, { className: "size-4" }),
			loading: /* @__PURE__ */ (0, q.jsx)(oe, { className: "size-4 animate-spin" })
		},
		style: {
			"--normal-bg": "var(--popover)",
			"--normal-text": "var(--popover-foreground)",
			"--normal-border": "var(--border)",
			"--border-radius": "var(--radius)"
		},
		...e
	});
}, DM = Uint8Array, OM = Uint16Array, kM = Int32Array, AM = new DM([
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	1,
	1,
	1,
	1,
	2,
	2,
	2,
	2,
	3,
	3,
	3,
	3,
	4,
	4,
	4,
	4,
	5,
	5,
	5,
	5,
	0,
	0,
	0,
	0
]), jM = new DM([
	0,
	0,
	0,
	0,
	1,
	1,
	2,
	2,
	3,
	3,
	4,
	4,
	5,
	5,
	6,
	6,
	7,
	7,
	8,
	8,
	9,
	9,
	10,
	10,
	11,
	11,
	12,
	12,
	13,
	13,
	0,
	0
]), MM = new DM([
	16,
	17,
	18,
	0,
	8,
	7,
	9,
	6,
	10,
	5,
	11,
	4,
	12,
	3,
	13,
	2,
	14,
	1,
	15
]), NM = function(e, t) {
	for (var n = new OM(31), r = 0; r < 31; ++r) n[r] = t += 1 << e[r - 1];
	for (var i = new kM(n[30]), r = 1; r < 30; ++r) for (var a = n[r]; a < n[r + 1]; ++a) i[a] = a - n[r] << 5 | r;
	return {
		b: n,
		r: i
	};
}, PM = NM(AM, 2), FM = PM.b, IM = PM.r;
FM[28] = 258, IM[258] = 28;
for (var LM = NM(jM, 0), RM = LM.b, zM = LM.r, BM = new OM(32768), VM = 0; VM < 32768; ++VM) {
	var HM = (VM & 43690) >> 1 | (VM & 21845) << 1;
	HM = (HM & 52428) >> 2 | (HM & 13107) << 2, HM = (HM & 61680) >> 4 | (HM & 3855) << 4, BM[VM] = ((HM & 65280) >> 8 | (HM & 255) << 8) >> 1;
}
for (var UM = (function(e, t, n) {
	for (var r = e.length, i = 0, a = new OM(t); i < r; ++i) e[i] && ++a[e[i] - 1];
	var o = new OM(t);
	for (i = 1; i < t; ++i) o[i] = o[i - 1] + a[i - 1] << 1;
	var s;
	if (n) {
		s = new OM(1 << t);
		var c = 15 - t;
		for (i = 0; i < r; ++i) if (e[i]) for (var l = i << 4 | e[i], u = t - e[i], d = o[e[i] - 1]++ << u, f = d | (1 << u) - 1; d <= f; ++d) s[BM[d] >> c] = l;
	} else for (s = new OM(r), i = 0; i < r; ++i) e[i] && (s[i] = BM[o[e[i] - 1]++] >> 15 - e[i]);
	return s;
}), WM = new DM(288), VM = 0; VM < 144; ++VM) WM[VM] = 8;
for (var VM = 144; VM < 256; ++VM) WM[VM] = 9;
for (var VM = 256; VM < 280; ++VM) WM[VM] = 7;
for (var VM = 280; VM < 288; ++VM) WM[VM] = 8;
for (var GM = new DM(32), VM = 0; VM < 32; ++VM) GM[VM] = 5;
var KM = /* @__PURE__ */ UM(WM, 9, 0), qM = /* @__PURE__ */ UM(WM, 9, 1), JM = /* @__PURE__ */ UM(GM, 5, 0), YM = /* @__PURE__ */ UM(GM, 5, 1), XM = function(e) {
	for (var t = e[0], n = 1; n < e.length; ++n) e[n] > t && (t = e[n]);
	return t;
}, ZM = function(e, t, n) {
	var r = t / 8 | 0;
	return (e[r] | e[r + 1] << 8) >> (t & 7) & n;
}, QM = function(e, t) {
	var n = t / 8 | 0;
	return (e[n] | e[n + 1] << 8 | e[n + 2] << 16) >> (t & 7);
}, $M = function(e) {
	return (e + 7) / 8 | 0;
}, eN = function(e, t, n) {
	return (t == null || t < 0) && (t = 0), (n == null || n > e.length) && (n = e.length), new DM(e.subarray(t, n));
}, tN = [
	"unexpected EOF",
	"invalid block type",
	"invalid length/literal",
	"invalid distance",
	"stream finished",
	"no stream handler",
	,
	"no callback",
	"invalid UTF-8 data",
	"extra field too long",
	"date not in range 1980-2099",
	"filename too long",
	"stream finishing",
	"invalid zip data"
], nN = function(e, t, n) {
	var r = Error(t || tN[e]);
	if (r.code = e, Error.captureStackTrace && Error.captureStackTrace(r, nN), !n) throw r;
	return r;
}, rN = function(e, t, n, r) {
	var i = e.length, a = r ? r.length : 0;
	if (!i || t.f && !t.l) return n || new DM(0);
	var o = !n, s = o || t.i != 2, c = t.i;
	o && (n = new DM(i * 3));
	var l = function(e) {
		var t = n.length;
		if (e > t) {
			var r = new DM(Math.max(t * 2, e));
			r.set(n), n = r;
		}
	}, u = t.f || 0, d = t.p || 0, f = t.b || 0, p = t.l, m = t.d, h = t.m, g = t.n, _ = i * 8;
	do {
		if (!p) {
			u = ZM(e, d, 1);
			var v = ZM(e, d + 1, 3);
			if (d += 3, !v) {
				var y = $M(d) + 4, b = e[y - 4] | e[y - 3] << 8, x = y + b;
				if (x > i) {
					c && nN(0);
					break;
				}
				s && l(f + b), n.set(e.subarray(y, x), f), t.b = f += b, t.p = d = x * 8, t.f = u;
				continue;
			} else if (v == 1) p = qM, m = YM, h = 9, g = 5;
			else if (v == 2) {
				var S = ZM(e, d, 31) + 257, C = ZM(e, d + 10, 15) + 4, w = S + ZM(e, d + 5, 31) + 1;
				d += 14;
				for (var T = new DM(w), E = new DM(19), D = 0; D < C; ++D) E[MM[D]] = ZM(e, d + D * 3, 7);
				d += C * 3;
				for (var O = XM(E), k = (1 << O) - 1, A = UM(E, O, 1), D = 0; D < w;) {
					var j = A[ZM(e, d, k)];
					d += j & 15;
					var y = j >> 4;
					if (y < 16) T[D++] = y;
					else {
						var M = 0, N = 0;
						for (y == 16 ? (N = 3 + ZM(e, d, 3), d += 2, M = T[D - 1]) : y == 17 ? (N = 3 + ZM(e, d, 7), d += 3) : y == 18 && (N = 11 + ZM(e, d, 127), d += 7); N--;) T[D++] = M;
					}
				}
				var P = T.subarray(0, S), F = T.subarray(S);
				h = XM(P), g = XM(F), p = UM(P, h, 1), m = UM(F, g, 1);
			} else nN(1);
			if (d > _) {
				c && nN(0);
				break;
			}
		}
		s && l(f + 131072);
		for (var I = (1 << h) - 1, R = (1 << g) - 1, ee = d;; ee = d) {
			var M = p[QM(e, d) & I], te = M >> 4;
			if (d += M & 15, d > _) {
				c && nN(0);
				break;
			}
			if (M || nN(2), te < 256) n[f++] = te;
			else if (te == 256) {
				ee = d, p = null;
				break;
			} else {
				var ne = te - 254;
				if (te > 264) {
					var D = te - 257, z = AM[D];
					ne = ZM(e, d, (1 << z) - 1) + FM[D], d += z;
				}
				var B = m[QM(e, d) & R], V = B >> 4;
				B || nN(3), d += B & 15;
				var F = RM[V];
				if (V > 3) {
					var z = jM[V];
					F += QM(e, d) & (1 << z) - 1, d += z;
				}
				if (d > _) {
					c && nN(0);
					break;
				}
				s && l(f + 131072);
				var re = f + ne;
				if (f < F) {
					var ie = a - F, ae = Math.min(F, re);
					for (ie + f < 0 && nN(3); f < ae; ++f) n[f] = r[ie + f];
				}
				for (; f < re; ++f) n[f] = n[f - F];
			}
		}
		t.l = p, t.p = ee, t.b = f, t.f = u, p && (u = 1, t.m = h, t.d = m, t.n = g);
	} while (!u);
	return f != n.length && o ? eN(n, 0, f) : n.subarray(0, f);
}, iN = function(e, t, n) {
	n <<= t & 7;
	var r = t / 8 | 0;
	e[r] |= n, e[r + 1] |= n >> 8;
}, aN = function(e, t, n) {
	n <<= t & 7;
	var r = t / 8 | 0;
	e[r] |= n, e[r + 1] |= n >> 8, e[r + 2] |= n >> 16;
}, oN = function(e, t) {
	for (var n = [], r = 0; r < e.length; ++r) e[r] && n.push({
		s: r,
		f: e[r]
	});
	var i = n.length, a = n.slice();
	if (!i) return {
		t: pN,
		l: 0
	};
	if (i == 1) {
		var o = new DM(n[0].s + 1);
		return o[n[0].s] = 1, {
			t: o,
			l: 1
		};
	}
	n.sort(function(e, t) {
		return e.f - t.f;
	}), n.push({
		s: -1,
		f: 25001
	});
	var s = n[0], c = n[1], l = 0, u = 1, d = 2;
	for (n[0] = {
		s: -1,
		f: s.f + c.f,
		l: s,
		r: c
	}; u != i - 1;) s = n[n[l].f < n[d].f ? l++ : d++], c = n[l != u && n[l].f < n[d].f ? l++ : d++], n[u++] = {
		s: -1,
		f: s.f + c.f,
		l: s,
		r: c
	};
	for (var f = a[0].s, r = 1; r < i; ++r) a[r].s > f && (f = a[r].s);
	var p = new OM(f + 1), m = sN(n[u - 1], p, 0);
	if (m > t) {
		var r = 0, h = 0, g = m - t, _ = 1 << g;
		for (a.sort(function(e, t) {
			return p[t.s] - p[e.s] || e.f - t.f;
		}); r < i; ++r) {
			var v = a[r].s;
			if (p[v] > t) h += _ - (1 << m - p[v]), p[v] = t;
			else break;
		}
		for (h >>= g; h > 0;) {
			var y = a[r].s;
			p[y] < t ? h -= 1 << t - p[y]++ - 1 : ++r;
		}
		for (; r >= 0 && h; --r) {
			var b = a[r].s;
			p[b] == t && (--p[b], ++h);
		}
		m = t;
	}
	return {
		t: new DM(p),
		l: m
	};
}, sN = function(e, t, n) {
	return e.s == -1 ? Math.max(sN(e.l, t, n + 1), sN(e.r, t, n + 1)) : t[e.s] = n;
}, cN = function(e) {
	for (var t = e.length; t && !e[--t];);
	for (var n = new OM(++t), r = 0, i = e[0], a = 1, o = function(e) {
		n[r++] = e;
	}, s = 1; s <= t; ++s) if (e[s] == i && s != t) ++a;
	else {
		if (!i && a > 2) {
			for (; a > 138; a -= 138) o(32754);
			a > 2 && (o(a > 10 ? a - 11 << 5 | 28690 : a - 3 << 5 | 12305), a = 0);
		} else if (a > 3) {
			for (o(i), --a; a > 6; a -= 6) o(8304);
			a > 2 && (o(a - 3 << 5 | 8208), a = 0);
		}
		for (; a--;) o(i);
		a = 1, i = e[s];
	}
	return {
		c: n.subarray(0, r),
		n: t
	};
}, lN = function(e, t) {
	for (var n = 0, r = 0; r < t.length; ++r) n += e[r] * t[r];
	return n;
}, uN = function(e, t, n) {
	var r = n.length, i = $M(t + 2);
	e[i] = r & 255, e[i + 1] = r >> 8, e[i + 2] = e[i] ^ 255, e[i + 3] = e[i + 1] ^ 255;
	for (var a = 0; a < r; ++a) e[i + a + 4] = n[a];
	return (i + 4 + r) * 8;
}, dN = function(e, t, n, r, i, a, o, s, c, l, u) {
	iN(t, u++, n), ++i[256];
	for (var d = oN(i, 15), f = d.t, p = d.l, m = oN(a, 15), h = m.t, g = m.l, _ = cN(f), v = _.c, y = _.n, b = cN(h), x = b.c, S = b.n, C = new OM(19), w = 0; w < v.length; ++w) ++C[v[w] & 31];
	for (var w = 0; w < x.length; ++w) ++C[x[w] & 31];
	for (var T = oN(C, 7), E = T.t, D = T.l, O = 19; O > 4 && !E[MM[O - 1]]; --O);
	var k = l + 5 << 3, A = lN(i, WM) + lN(a, GM) + o, j = lN(i, f) + lN(a, h) + o + 14 + 3 * O + lN(C, E) + 2 * C[16] + 3 * C[17] + 7 * C[18];
	if (c >= 0 && k <= A && k <= j) return uN(t, u, e.subarray(c, c + l));
	var M, N, P, F;
	if (iN(t, u, 1 + (j < A)), u += 2, j < A) {
		M = UM(f, p, 0), N = f, P = UM(h, g, 0), F = h;
		var I = UM(E, D, 0);
		iN(t, u, y - 257), iN(t, u + 5, S - 1), iN(t, u + 10, O - 4), u += 14;
		for (var w = 0; w < O; ++w) iN(t, u + 3 * w, E[MM[w]]);
		u += 3 * O;
		for (var R = [v, x], ee = 0; ee < 2; ++ee) for (var te = R[ee], w = 0; w < te.length; ++w) {
			var ne = te[w] & 31;
			iN(t, u, I[ne]), u += E[ne], ne > 15 && (iN(t, u, te[w] >> 5 & 127), u += te[w] >> 12);
		}
	} else M = KM, N = WM, P = JM, F = GM;
	for (var w = 0; w < s; ++w) {
		var z = r[w];
		if (z > 255) {
			var ne = z >> 18 & 31;
			aN(t, u, M[ne + 257]), u += N[ne + 257], ne > 7 && (iN(t, u, z >> 23 & 31), u += AM[ne]);
			var B = z & 31;
			aN(t, u, P[B]), u += F[B], B > 3 && (aN(t, u, z >> 5 & 8191), u += jM[B]);
		} else aN(t, u, M[z]), u += N[z];
	}
	return aN(t, u, M[256]), u + N[256];
}, fN = /* @__PURE__ */ new kM([
	65540,
	131080,
	131088,
	131104,
	262176,
	1048704,
	1048832,
	2114560,
	2117632
]), pN = /* @__PURE__ */ new DM(0), mN = function(e, t, n, r, i, a) {
	var o = a.z || e.length, s = new DM(r + o + 5 * (1 + Math.ceil(o / 7e3)) + i), c = s.subarray(r, s.length - i), l = a.l, u = (a.r || 0) & 7;
	if (t) {
		u && (c[0] = a.r >> 3);
		for (var d = fN[t - 1], f = d >> 13, p = d & 8191, m = (1 << n) - 1, h = a.p || new OM(32768), g = a.h || new OM(m + 1), _ = Math.ceil(n / 3), v = 2 * _, y = function(t) {
			return (e[t] ^ e[t + 1] << _ ^ e[t + 2] << v) & m;
		}, b = new kM(25e3), x = new OM(288), S = new OM(32), C = 0, w = 0, T = a.i || 0, E = 0, D = a.w || 0, O = 0; T + 2 < o; ++T) {
			var k = y(T), A = T & 32767, j = g[k];
			if (h[A] = j, g[k] = A, D <= T) {
				var M = o - T;
				if ((C > 7e3 || E > 24576) && (M > 423 || !l)) {
					u = dN(e, c, 0, b, x, S, w, E, O, T - O, u), E = C = w = 0, O = T;
					for (var N = 0; N < 286; ++N) x[N] = 0;
					for (var N = 0; N < 30; ++N) S[N] = 0;
				}
				var P = 2, F = 0, I = p, R = A - j & 32767;
				if (M > 2 && k == y(T - R)) for (var ee = Math.min(f, M) - 1, te = Math.min(32767, T), ne = Math.min(258, M); R <= te && --I && A != j;) {
					if (e[T + P] == e[T + P - R]) {
						for (var z = 0; z < ne && e[T + z] == e[T + z - R]; ++z);
						if (z > P) {
							if (P = z, F = R, z > ee) break;
							for (var B = Math.min(R, z - 2), V = 0, N = 0; N < B; ++N) {
								var re = T - R + N & 32767, ie = re - h[re] & 32767;
								ie > V && (V = ie, j = re);
							}
						}
					}
					A = j, j = h[A], R += A - j & 32767;
				}
				if (F) {
					b[E++] = 268435456 | IM[P] << 18 | zM[F];
					var ae = IM[P] & 31, oe = zM[F] & 31;
					w += AM[ae] + jM[oe], ++x[257 + ae], ++S[oe], D = T + P, ++C;
				} else b[E++] = e[T], ++x[e[T]];
			}
		}
		for (T = Math.max(T, D); T < o; ++T) b[E++] = e[T], ++x[e[T]];
		u = dN(e, c, l, b, x, S, w, E, O, T - O, u), l || (a.r = u & 7 | c[u / 8 | 0] << 3, u -= 7, a.h = g, a.p = h, a.i = T, a.w = D);
	} else {
		for (var T = a.w || 0; T < o + l; T += 65535) {
			var se = T + 65535;
			se >= o && (c[u / 8 | 0] = l, se = o), u = uN(c, u + 1, e.subarray(T, se));
		}
		a.i = o;
	}
	return eN(s, 0, r + $M(u) + i);
}, hN = /* @__PURE__ */ (function() {
	for (var e = new Int32Array(256), t = 0; t < 256; ++t) {
		for (var n = t, r = 9; --r;) n = (n & 1 && -306674912) ^ n >>> 1;
		e[t] = n;
	}
	return e;
})(), gN = function() {
	var e = -1;
	return {
		p: function(t) {
			for (var n = e, r = 0; r < t.length; ++r) n = hN[n & 255 ^ t[r]] ^ n >>> 8;
			e = n;
		},
		d: function() {
			return ~e;
		}
	};
}, _N = function(e, t, n, r, i) {
	if (!i && (i = { l: 1 }, t.dictionary)) {
		var a = t.dictionary.subarray(-32768), o = new DM(a.length + e.length);
		o.set(a), o.set(e, a.length), e = o, i.w = a.length;
	}
	return mN(e, t.level == null ? 6 : t.level, t.mem == null ? i.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(e.length))) * 1.5) : 20 : 12 + t.mem, n, r, i);
}, vN = function(e, t) {
	var n = {};
	for (var r in e) n[r] = e[r];
	for (var r in t) n[r] = t[r];
	return n;
}, yN = function(e, t, n) {
	for (; n; ++t) e[t] = n, n >>>= 8;
}, bN = function(e) {
	(e[0] != 31 || e[1] != 139 || e[2] != 8) && nN(6, "invalid gzip data");
	var t = e[3], n = 10;
	t & 4 && (n += (e[10] | e[11] << 8) + 2);
	for (var r = (t >> 3 & 1) + (t >> 4 & 1); r > 0; r -= !e[n++]);
	return n + (t & 2);
}, xN = function(e) {
	var t = e.length;
	return (e[t - 4] | e[t - 3] << 8 | e[t - 2] << 16 | e[t - 1] << 24) >>> 0;
}, SN = function(e, t) {
	return ((e[0] & 15) != 8 || e[0] >> 4 > 7 || (e[0] << 8 | e[1]) % 31) && nN(6, "invalid zlib data"), (e[1] >> 5 & 1) == +!t && nN(6, "invalid zlib data: " + (e[1] & 32 ? "need" : "unexpected") + " dictionary"), (e[1] >> 3 & 4) + 2;
};
function CN(e, t) {
	return _N(e, t || {}, 0, 0);
}
function wN(e, t) {
	return rN(e, { i: 2 }, t && t.out, t && t.dictionary);
}
function TN(e, t) {
	var n = bN(e);
	return n + 8 > e.length && nN(6, "invalid gzip data"), rN(e.subarray(n, -8), { i: 2 }, t && t.out || new DM(xN(e)), t && t.dictionary);
}
function EN(e, t) {
	return rN(e.subarray(SN(e, t && t.dictionary), -4), { i: 2 }, t && t.out, t && t.dictionary);
}
function DN(e, t) {
	return e[0] == 31 && e[1] == 139 && e[2] == 8 ? TN(e, t) : (e[0] & 15) != 8 || e[0] >> 4 > 7 || (e[0] << 8 | e[1]) % 31 ? wN(e, t) : EN(e, t);
}
var ON = function(e, t, n, r) {
	for (var i in e) {
		var a = e[i], o = t + i, s = r;
		Array.isArray(a) && (s = vN(r, a[1]), a = a[0]), a instanceof DM ? n[o] = [a, s] : (n[o += "/"] = [new DM(0), s], ON(a, o, n, r));
	}
}, kN = typeof TextEncoder < "u" && /* @__PURE__ */ new TextEncoder(), AN = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder();
try {
	AN.decode(pN, { stream: !0 });
} catch {}
function jN(e, t) {
	if (t) {
		for (var n = new DM(e.length), r = 0; r < e.length; ++r) n[r] = e.charCodeAt(r);
		return n;
	}
	if (kN) return kN.encode(e);
	for (var i = e.length, a = new DM(e.length + (e.length >> 1)), o = 0, s = function(e) {
		a[o++] = e;
	}, r = 0; r < i; ++r) {
		if (o + 5 > a.length) {
			var c = new DM(o + 8 + (i - r << 1));
			c.set(a), a = c;
		}
		var l = e.charCodeAt(r);
		l < 128 || t ? s(l) : l < 2048 ? (s(192 | l >> 6), s(128 | l & 63)) : l > 55295 && l < 57344 ? (l = 65536 + (l & 1047552) | e.charCodeAt(++r) & 1023, s(240 | l >> 18), s(128 | l >> 12 & 63), s(128 | l >> 6 & 63), s(128 | l & 63)) : (s(224 | l >> 12), s(128 | l >> 6 & 63), s(128 | l & 63));
	}
	return eN(a, 0, o);
}
var MN = function(e) {
	var t = 0;
	if (e) for (var n in e) {
		var r = e[n].length;
		r > 65535 && nN(9), t += r + 4;
	}
	return t;
}, NN = function(e, t, n, r, i, a, o, s) {
	var c = r.length, l = n.extra, u = s && s.length, d = MN(l);
	yN(e, t, o == null ? 67324752 : 33639248), t += 4, o != null && (e[t++] = 20, e[t++] = n.os), e[t] = 20, t += 2, e[t++] = n.flag << 1 | (a < 0 && 8), e[t++] = i && 8, e[t++] = n.compression & 255, e[t++] = n.compression >> 8;
	var f = new Date(n.mtime == null ? Date.now() : n.mtime), p = f.getFullYear() - 1980;
	if ((p < 0 || p > 119) && nN(10), yN(e, t, p << 25 | f.getMonth() + 1 << 21 | f.getDate() << 16 | f.getHours() << 11 | f.getMinutes() << 5 | f.getSeconds() >> 1), t += 4, a != -1 && (yN(e, t, n.crc), yN(e, t + 4, a < 0 ? -a - 2 : a), yN(e, t + 8, n.size)), yN(e, t + 12, c), yN(e, t + 14, d), t += 16, o != null && (yN(e, t, u), yN(e, t + 6, n.attrs), yN(e, t + 10, o), t += 14), e.set(r, t), t += c, d) for (var m in l) {
		var h = l[m], g = h.length;
		yN(e, t, +m), yN(e, t + 2, g), e.set(h, t + 4), t += 4 + g;
	}
	return u && (e.set(s, t), t += u), t;
}, PN = function(e, t, n, r, i) {
	yN(e, t, 101010256), yN(e, t + 8, n), yN(e, t + 10, n), yN(e, t + 12, r), yN(e, t + 16, i);
};
function FN(e, t) {
	t ||= {};
	var n = {}, r = [];
	ON(e, "", n, t);
	var i = 0, a = 0;
	for (var o in n) {
		var s = n[o], c = s[0], l = s[1], u = l.level == 0 ? 0 : 8, d = jN(o), f = d.length, p = l.comment, m = p && jN(p), h = m && m.length, g = MN(l.extra);
		f > 65535 && nN(11);
		var _ = u ? CN(c, l) : c, v = _.length, y = gN();
		y.p(c), r.push(vN(l, {
			size: c.length,
			crc: y.d(),
			c: _,
			f: d,
			m,
			u: f != o.length || m && p.length != h,
			o: i,
			compression: u
		})), i += 30 + f + g + v, a += 76 + 2 * (f + g) + (h || 0) + v;
	}
	for (var b = new DM(a + 22), x = i, S = a - i, C = 0; C < r.length; ++C) {
		var d = r[C];
		NN(b, d.o, d, d.f, d.u, d.c.length);
		var w = 30 + d.f.length + MN(d.extra);
		b.set(d.c, d.o + w), NN(b, i, d, d.f, d.u, d.c.length, d.o, d.m), i += 16 + w + (d.m ? d.m.length : 0);
	}
	return PN(b, i, r.length, S, x), b;
}
//#endregion
//#region lib/exporters.ts
var IN = {
	base: "#e3e1dd",
	terrain: "#f7f5ef",
	greenery: "#b9ddbb",
	trees: "#8fc486",
	buildings: "#f3d486",
	roads: "#969ca1",
	track: "#c56b6b",
	water: "#7dcae8"
};
function LN([e, t, n]) {
	let r = [
		t[0] - e[0],
		t[1] - e[1],
		t[2] - e[2]
	], i = [
		n[0] - e[0],
		n[1] - e[1],
		n[2] - e[2]
	], a = [
		r[1] * i[2] - r[2] * i[1],
		r[2] * i[0] - r[0] * i[2],
		r[0] * i[1] - r[1] * i[0]
	], o = Math.hypot(...a) || 1;
	return [
		a[0] / o,
		a[1] / o,
		a[2] / o
	];
}
function RN(e, t = "Plaats in 3D") {
	let n = /* @__PURE__ */ new ArrayBuffer(84 + e.length * 50), r = new Uint8Array(n), i = new DataView(n);
	r.set(new TextEncoder().encode(t.slice(0, 80)), 0), i.setUint32(80, e.length, !0);
	let a = 84;
	for (let t of e) {
		let e = LN(t);
		for (let t of e) i.setFloat32(a, t, !0), a += 4;
		for (let e of t) for (let t of e) i.setFloat32(a, t, !0), a += 4;
		i.setUint16(a, 0, !0), a += 2;
	}
	return r;
}
function zN(e) {
	return FN(Object.fromEntries(e.map((e) => [e.name, e.data])), { level: 6 });
}
function BN(e) {
	return e.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll("\"", "&quot;").replaceAll("'", "&apos;");
}
function VN(e) {
	let t = [], n = /* @__PURE__ */ new Map(), r = [], i = (e) => {
		let r = e.map((e) => Math.round(e * 1e5)).join(","), i = n.get(r);
		if (i !== void 0) return i;
		let a = t.length;
		return t.push(e), n.set(r, a), a;
	};
	for (let t of e) r.push([
		i(t[0]),
		i(t[1]),
		i(t[2])
	]);
	return {
		vertices: t.map(([e, t, n]) => `<vertex x="${e.toFixed(5)}" y="${t.toFixed(5)}" z="${n.toFixed(5)}"/>`).join(""),
		triangles: r.map(([e, t, n]) => `<triangle v1="${e}" v2="${t}" v3="${n}"/>`).join("")
	};
}
function HN(e) {
	let t = e.trim().match(/^#?([0-9a-f]{6})([0-9a-f]{2})?$/i);
	return t ? `#${t[1].toUpperCase()}${(t[2] ?? "FF").toUpperCase()}` : "#B8B8B8FF";
}
function UN(e, t = IN, n = "Plaats in 3D") {
	let r = e.filter((e) => e.triangles.length > 0);
	if (r.length === 0) throw Error("Het 3MF-model bevat geen geometrie.");
	let i = r.map((e) => HN(t[e.kind])), a = /* @__PURE__ */ new Map(), o = i.map((e) => {
		let t = a.get(e);
		if (t !== void 0) return t;
		let n = a.size + 1;
		return a.set(e, n), n;
	}), s = r.map((e, t) => `<base name="${BN(e.name)}" displaycolor="${i[t]}"/>`).join(""), c = r.map((e, t) => {
		let n = VN(e.triangles);
		return `<object id="${t + 3}" name="${BN(e.name)}" type="model" pid="1" pindex="${t}"><mesh><vertices>${n.vertices}</vertices><triangles>${n.triangles}</triangles></mesh></object>`;
	}).join(""), l = r.map((e, t) => `<component objectid="${t + 3}"/>`).join(""), u = `<object id="2" name="${BN(n)}" type="model"><components>${l}</components></object>`, d = `<?xml version="1.0" encoding="UTF-8"?>\n<model unit="millimeter" xml:lang="nl-NL" xmlns="http://schemas.microsoft.com/3dmanufacturing/core/2015/02"><metadata name="BambuStudio:3mfVersion">1</metadata><metadata name="Application">BambuStudio-2.8.2.60</metadata><metadata name="Title">${BN(n)}</metadata><metadata name="Designer">Plaats in 3D</metadata><metadata name="Copyright">3DBAG by tudelft3d + 3DGI, CC BY 4.0; PDOK open data; Overture Maps/OpenStreetMap open data; IGN France, Licence Ouverte 2.0; Mapterhorn elevation</metadata><resources><basematerials id="1">${s}</basematerials>${u}${c}</resources><build><item objectid="2" printable="1"/></build></model>`, f = r.map((e, t) => {
		let n = t + 3, r = o[t];
		return `<part id="${n}" subtype="normal_part"><metadata key="name" value="${BN(e.name)}"/><metadata key="matrix" value="1 0 0 0 0 1 0 0 0 0 1 0 0 0 0 1"/><metadata key="extruder" value="${r}"/><mesh_stat face_count="${e.triangles.length}" edges_fixed="0" degenerate_facets="0" facets_removed="0" facets_reversed="0" backwards_edges="0"/></part>`;
	}).join(""), p = [...new Set(o)].join(" "), m = o.join(" "), h = `<?xml version="1.0" encoding="UTF-8"?>\n<config><object id="2"><metadata key="name" value="${BN(n)}"/><metadata key="extruder" value="1"/>${f}</object><plate><metadata key="plater_id" value="1"/><metadata key="plater_name" value="Plaats in 3D"/><metadata key="locked" value="false"/><metadata key="filament_maps" value="${p}"/><metadata key="filament_volume_maps" value="${m}"/><model_instance><metadata key="object_id" value="2"/><metadata key="instance_id" value="0"/><metadata key="identify_id" value="1"/></model_instance></plate><assemble/></config>`, g = [...a.keys()].map((e) => e.slice(0, 7)), _ = JSON.stringify({
		name: "project_settings",
		from: "project",
		inherits: "",
		version: "2.8.2.60",
		filament_colour: g,
		filament_type: g.map(() => "PLA"),
		filament_settings_id: g.map(() => "Generic PLA")
	}), v = new TextEncoder();
	return zN([
		{
			name: "[Content_Types].xml",
			data: v.encode("<?xml version=\"1.0\" encoding=\"UTF-8\"?><Types xmlns=\"http://schemas.openxmlformats.org/package/2006/content-types\"><Default Extension=\"rels\" ContentType=\"application/vnd.openxmlformats-package.relationships+xml\"/><Default Extension=\"model\" ContentType=\"application/vnd.ms-package.3dmanufacturing-3dmodel+xml\"/></Types>")
		},
		{
			name: "_rels/.rels",
			data: v.encode("<?xml version=\"1.0\" encoding=\"UTF-8\"?><Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\"><Relationship Target=\"/3D/3dmodel.model\" Id=\"rel-1\" Type=\"http://schemas.microsoft.com/3dmanufacturing/2013/01/3dmodel\"/></Relationships>")
		},
		{
			name: "3D/3dmodel.model",
			data: v.encode(d)
		},
		{
			name: "Metadata/model_settings.config",
			data: v.encode(h)
		},
		{
			name: "Metadata/project_settings.config",
			data: v.encode(_)
		}
	]);
}
//#endregion
//#region node_modules/earcut/src/earcut.js
var WN = /* @__PURE__ */ new Set(), GN = !1;
function KN(e, t, n = 2) {
	let r = t && t.length, i = r ? t[0] * n : e.length;
	WN.size && WN.clear();
	let a = qN(e, 0, i, n, !0), o = [];
	if (!a || a.next === a.prev) return o;
	let s = 0, c = 0, l = 0;
	if (r && (a = tP(e, t, a, n)), e.length > 80 * n) {
		s = e[0], c = e[1];
		let t = s, r = c;
		for (let a = n; a < i; a += n) {
			let n = e[a], i = e[a + 1];
			n < s && (s = n), i < c && (c = i), n > t && (t = n), i > r && (r = i);
		}
		l = Math.max(t - s, r - c), l = l === 0 ? 0 : 32767 / l;
	}
	return YN(a, o, s, c, l), o;
}
function qN(e, t, n, r, i) {
	let a = null;
	if (i === zP(e, t, n, r) > 0) for (let i = t; i < n; i += r) a = IP(i / r | 0, e[i], e[i + 1], a);
	else for (let i = n - r; i >= t; i -= r) a = IP(i / r | 0, e[i], e[i + 1], a);
	return a && kP(a, a.next) && (LP(a), a = a.next), a;
}
function JN(e, t = e) {
	let n = t === e, r = e, i;
	do
		i = !1, r !== r.next && (WN.size === 0 || !WN.has(r)) && (kP(r, r.next) || OP(r.prev, r, r.next) === 0) ? ((n || r === t) && (t = r.prev), GN = !0, LP(r), r = r.prev, i = !0) : (n || r !== t) && (r = r.next, i = !n);
	while (i || r !== t);
	return t;
}
function YN(e, t, n, r, i) {
	i && xP(e, n, r, i);
	let a = e, o = !1;
	for (; e.prev !== e.next;) {
		let s = e.prev, c = e.next;
		if (OP(s, e, c) < 0 && (i ? ZN(e, n, r, i) : XN(e))) {
			t.push(s.i, e.i, c.i), LP(e), e = c, a = c;
			continue;
		}
		if (e = c, e === a) {
			if (GN = !1, e = JN(e), GN) {
				a = e;
				continue;
			}
			if (!o) {
				e = QN(e, t), a = e, o = !0;
				continue;
			}
			$N(e, t, n, r, i);
			break;
		}
	}
}
function XN(e) {
	let t = e.prev, n = e, r = e.next, i = t.x, a = n.x, o = r.x, s = t.y, c = n.y, l = r.y, u = Math.min(i, a, o), d = Math.min(s, c, l), f = Math.max(i, a, o), p = Math.max(s, c, l), m = r.next;
	for (; m !== t;) {
		if (m.x >= u && m.x <= f && m.y >= d && m.y <= p && !(i === m.x && s === m.y) && EP(i, s, a, c, o, l, m.x, m.y) && OP(m.prev, m, m.next) >= 0) return !1;
		m = m.next;
	}
	return !0;
}
function ZN(e, t, n, r) {
	let i = e.prev, a = e, o = e.next, s = i.x, c = a.x, l = o.x, u = i.y, d = a.y, f = o.y, p = Math.min(s, c, l), m = Math.min(u, d, f), h = Math.max(s, c, l), g = Math.max(u, d, f), _ = wP(p, m, t, n, r), v = wP(h, g, t, n, r), y = e.prevZ;
	for (; y && y.z >= _;) {
		if (y.x >= p && y.x <= h && y.y >= m && y.y <= g && y !== o && !(s === y.x && u === y.y) && EP(s, u, c, d, l, f, y.x, y.y) && OP(y.prev, y, y.next) >= 0) return !1;
		y = y.prevZ;
	}
	let b = e.nextZ;
	for (; b && b.z <= v;) {
		if (b.x >= p && b.x <= h && b.y >= m && b.y <= g && b !== o && !(s === b.x && u === b.y) && EP(s, u, c, d, l, f, b.x, b.y) && OP(b.prev, b, b.next) >= 0) return !1;
		b = b.nextZ;
	}
	return !0;
}
function QN(e, t) {
	let n = e, r = !1;
	do {
		let i = n.prev, a = n.next.next;
		AP(i, n, n.next, a, !1) && NP(i, a) && NP(a, i) && (t.push(i.i, n.i, a.i), LP(n), LP(n.next), n = e = a, r = !0), n = n.next;
	} while (n !== e);
	return r ? JN(n) : n;
}
function $N(e, t, n, r, i) {
	let a = e;
	do {
		let e = a.next.next;
		for (; e !== a.prev;) {
			if (a.i !== e.i && DP(a, e)) {
				let o = FP(a, e);
				a = JN(a, a.next), o = JN(o, o.next), YN(a, t, n, r, i), YN(o, t, n, r, i);
				return;
			}
			e = e.next;
		}
		a = a.next;
	} while (a !== e);
}
var eP = !1;
function tP(e, t, n, r) {
	let i = [];
	for (let n = 0, a = t.length; n < a; n++) {
		let o = qN(e, t[n] * r, n < a - 1 ? t[n + 1] * r : e.length, r, !1);
		o === o.next && WN.add(o), i.push(TP(o));
	}
	i.sort(nP), lP(e.length / r, t.length), uP(n, n), eP = !0;
	for (let e = 0; e < i.length; e++) n = rP(i[e], n);
	return eP = !1, JN(n);
}
function nP(e, t) {
	return e.x - t.x || e.y - t.y || (e.next.y - e.y) / (e.next.x - e.x) - (t.next.y - t.y) / (t.next.x - t.x);
}
function rP(e, t) {
	let n = mP(e, t);
	if (!n) return t;
	let r = FP(n, e), i = r.next;
	return uP(n, i.next), JN(r, r.next), JN(n, n.next);
}
var iP = 16, aP = new Float64Array(), oP = 0, sP = [], cP = [];
function lP(e, t) {
	let n = Math.ceil((e + 2 * t) / iP) + t + 2;
	aP.length < n * 4 && (aP = new Float64Array(n * 4)), oP = 0;
}
function uP(e, t) {
	let n = e;
	do {
		let e = oP++;
		sP[e] = n;
		let r = Infinity, i = Infinity, a = -Infinity, o = -Infinity, s = 0;
		do {
			let t = n.next;
			n.z = e, n.x < r && (r = n.x), n.x > a && (a = n.x), n.y < i && (i = n.y), n.y > o && (o = n.y), t.x < r && (r = t.x), t.x > a && (a = t.x), t.y < i && (i = t.y), t.y > o && (o = t.y), n = t;
		} while (++s < iP && n !== t);
		cP[e] = n;
		let c = e * 4;
		aP[c] = r, aP[c + 1] = i, aP[c + 2] = a, aP[c + 3] = o;
	} while (n !== t);
}
function dP(e, t) {
	let n = e.z * 4;
	t.x < aP[n] && (aP[n] = t.x), t.y < aP[n + 1] && (aP[n + 1] = t.y), t.x > aP[n + 2] && (aP[n + 2] = t.x), t.y > aP[n + 3] && (aP[n + 3] = t.y);
}
function fP(e) {
	let t = cP[e];
	for (; t.prev.next !== t;) t = t.next;
	return cP[e] = t, t;
}
function pP(e) {
	let t = sP[e];
	for (; t.prev.next !== t;) t = t.next;
	return sP[e] = t, t;
}
function mP(e, t) {
	let n = t, r = e.x, i = e.y, a = -Infinity, o;
	if (kP(e, n)) return n;
	for (let t = 0, s = 0; t < oP; t++, s += 4) {
		if (i < aP[s + 1] || i > aP[s + 3] || aP[s] > r || aP[s + 2] <= a) continue;
		let c = fP(t);
		n = pP(t);
		do {
			if (n.prev.next === n) {
				if (kP(e, n.next)) return n.next;
				if (i <= n.y && i >= n.next.y && n.next.y !== n.y) {
					let e = n.x + (i - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
					if (e <= r && e > a && (a = e, o = n.x < n.next.x ? n : n.next, e === r)) return o;
				}
			}
			n = n.next;
		} while (n !== c);
	}
	if (!o) return null;
	let s = o.x, c = o.y, l = Math.min(i, c), u = Math.max(i, c), d = Infinity;
	for (let t = 0, f = 0; t < oP; t++, f += 4) {
		if (aP[f + 2] < s || aP[f] > r || aP[f + 3] < l || aP[f + 1] > u) continue;
		let p = fP(t);
		n = pP(t);
		do {
			if (n.prev.next === n && r >= n.x && n.x >= s && r !== n.x && EP(i < c ? r : a, i, s, c, i < c ? a : r, i, n.x, n.y)) {
				let t = Math.abs(i - n.y) / (r - n.x);
				(NP(n, e) || n.y === i && n.next.y === i && n.next.x > r) && (t < d || t === d && (n.x > o.x || n.x === o.x && hP(o, n))) && (o = n, d = t);
			}
			n = n.next;
		} while (n !== p);
	}
	return o;
}
function hP(e, t) {
	return OP(e.prev, e, t.prev) < 0 && OP(t.next, e, e.next) < 0;
}
var gP = [], _P = [], vP = new Uint32Array(), yP = new Uint32Array(), bP = new Uint32Array(256);
function xP(e, t, n, r) {
	let i = e, a = 0;
	do
		i.z = wP(i.x, i.y, t, n, r), gP[a++] = i, i = i.next;
	while (i !== e);
	SP(a);
	let o = null;
	for (let e = 0; e < a; e++) {
		let t = gP[e];
		t.prevZ = o, o && (o.nextZ = t), o = t;
	}
	o.nextZ = null;
}
function SP(e) {
	if (e <= 32) {
		for (let t = 1; t < e; t++) {
			let e = gP[t], n = e.z, r = t - 1;
			for (; r >= 0 && gP[r].z > n;) gP[r + 1] = gP[r], r--;
			gP[r + 1] = e;
		}
		return;
	}
	vP.length < e && (vP = new Uint32Array(e), yP = new Uint32Array(e), _P = Array(e));
	for (let t = 0; t < e; t++) vP[t] = gP[t].z;
	CP(e, gP, vP, _P, yP, 0), CP(e, _P, yP, gP, vP, 8), CP(e, gP, vP, _P, yP, 16), CP(e, _P, yP, gP, vP, 24);
}
function CP(e, t, n, r, i, a) {
	bP.fill(0);
	for (let t = 0; t < e; t++) bP[n[t] >>> a & 255]++;
	let o = 0;
	for (let e = 0; e < 256; e++) {
		let t = bP[e];
		bP[e] = o, o += t;
	}
	for (let o = 0; o < e; o++) {
		let e = n[o], s = bP[e >>> a & 255]++;
		r[s] = t[o], i[s] = e;
	}
}
function wP(e, t, n, r, i) {
	return e = (e - n) * i | 0, t = (t - r) * i | 0, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, e | t << 1;
}
function TP(e) {
	let t = e, n = e;
	do
		(t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
	while (t !== e);
	return n;
}
function EP(e, t, n, r, i, a, o, s) {
	return (i - o) * (t - s) >= (e - o) * (a - s) && (e - o) * (r - s) >= (n - o) * (t - s) && (n - o) * (a - s) >= (i - o) * (r - s);
}
function DP(e, t) {
	let n = kP(e, t) && OP(e.prev, e, e.next) > 0 && OP(t.prev, t, t.next) > 0;
	return e.next.i !== t.i && (n || NP(e, t) && NP(t, e) && (OP(e.prev, e, t.prev) !== 0 || OP(e, t.prev, t) !== 0)) && !MP(e, t) && (n || PP(e, t));
}
function OP(e, t, n) {
	return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
}
function kP(e, t) {
	return e.x === t.x && e.y === t.y;
}
function AP(e, t, n, r, i = !0) {
	let a = OP(e, t, n), o = OP(e, t, r), s = OP(n, r, e), c = OP(n, r, t);
	return (a > 0 && o < 0 || a < 0 && o > 0) && (s > 0 && c < 0 || s < 0 && c > 0) ? !0 : i ? !!(a === 0 && jP(e, n, t) || o === 0 && jP(e, r, t) || s === 0 && jP(n, e, r) || c === 0 && jP(n, t, r)) : !1;
}
function jP(e, t, n) {
	return t.x <= Math.max(e.x, n.x) && t.x >= Math.min(e.x, n.x) && t.y <= Math.max(e.y, n.y) && t.y >= Math.min(e.y, n.y);
}
function MP(e, t) {
	let n = Math.min(e.x, t.x), r = Math.max(e.x, t.x), i = Math.min(e.y, t.y), a = Math.max(e.y, t.y), o = e;
	do {
		let s = o.next;
		if (o.x > r && s.x > r || o.x < n && s.x < n || o.y > a && s.y > a || o.y < i && s.y < i) {
			o = s;
			continue;
		}
		if (o.i !== e.i && s.i !== e.i && o.i !== t.i && s.i !== t.i && AP(o, s, e, t)) return !0;
		o = s;
	} while (o !== e);
	return !1;
}
function NP(e, t) {
	return OP(e.prev, e, e.next) < 0 ? OP(e, t, e.next) >= 0 && OP(e, e.prev, t) >= 0 : OP(e, t, e.prev) < 0 || OP(e, e.next, t) < 0;
}
function PP(e, t) {
	let n = e, r = !1, i = (e.x + t.x) / 2, a = (e.y + t.y) / 2;
	do {
		let e = n.next;
		n.y > a != e.y > a && i < (e.x - n.x) * (a - n.y) / (e.y - n.y) + n.x && (r = !r), n = e;
	} while (n !== e);
	return r;
}
function FP(e, t) {
	let n = RP(e.i, e.x, e.y), r = RP(t.i, t.x, t.y), i = e.next, a = t.prev;
	return e.next = t, t.prev = e, n.next = i, i.prev = n, r.next = n, n.prev = r, a.next = r, r.prev = a, r;
}
function IP(e, t, n, r) {
	let i = RP(e, t, n);
	return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
}
function LP(e) {
	e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ), eP && dP(e.prev, e.next);
}
function RP(e, t, n) {
	return {
		i: e,
		x: t,
		y: n,
		prev: null,
		next: null,
		z: 0,
		prevZ: null,
		nextZ: null
	};
}
function zP(e, t, n, r) {
	let i = 0;
	for (let a = t, o = n - r; a < n; a += r) i += (e[o] - e[a]) * (e[a + 1] + e[o + 1]), o = a;
	return i;
}
//#endregion
//#region lib/geometry.ts
var BP = 1e-8;
function VP(e) {
	let t = 0;
	for (let n = 0; n < e.length; n += 1) {
		let r = e[n], i = e[(n + 1) % e.length];
		t += r[0] * i[1] - i[0] * r[1];
	}
	return t / 2;
}
function HP(e, t) {
	return Math.abs(e[0] - t[0]) < BP && Math.abs(e[1] - t[1]) < BP;
}
function UP(e) {
	let t = [];
	for (let n of e) (t.length === 0 || !HP(t[t.length - 1], n)) && t.push(n);
	t.length > 2 && HP(t[0], t[t.length - 1]) && t.pop();
	let n = !0;
	for (; n && t.length > 3;) {
		n = !1;
		for (let e = 0; e < t.length; e += 1) {
			let r = t[(e - 1 + t.length) % t.length], i = t[e], a = t[(e + 1) % t.length], o = (i[0] - r[0]) * (a[1] - i[1]) - (i[1] - r[1]) * (a[0] - i[0]);
			if (Math.abs(o) < BP) {
				t.splice(e, 1), n = !0;
				break;
			}
		}
	}
	return t;
}
function WP(e, t, n) {
	let r = n[0] - t[0], i = n[1] - t[1];
	if (Math.abs(r) < BP && Math.abs(i) < BP) return (e[0] - t[0]) ** 2 + (e[1] - t[1]) ** 2;
	let a = Math.max(0, Math.min(1, ((e[0] - t[0]) * r + (e[1] - t[1]) * i) / (r * r + i * i))), o = t[0] + a * r, s = t[1] + a * i;
	return (e[0] - o) ** 2 + (e[1] - s) ** 2;
}
function GP(e, t) {
	if (e.length <= 2 || t <= 0) return [...e];
	let n = new Uint8Array(e.length);
	n[0] = 1, n[e.length - 1] = 1;
	let r = [[0, e.length - 1]], i = t * t;
	for (; r.length > 0;) {
		let [t, a] = r.pop(), o = -1, s = i;
		for (let n = t + 1; n < a; n += 1) {
			let r = WP(e[n], e[t], e[a]);
			r > s && (s = r, o = n);
		}
		o >= 0 && (n[o] = 1, r.push([t, o], [o, a]));
	}
	return e.filter((e, t) => n[t] === 1);
}
function KP(e, t) {
	let n = UP(e);
	if (n.length <= 4 || t <= 0) return n;
	let r = UP(GP([...n, n[0]], t));
	return r.length >= 3 ? r : n;
}
function qP(e, t, n) {
	return t === "left" ? e[0] >= n - BP : t === "right" ? e[0] <= n + BP : t === "bottom" ? e[1] >= n - BP : e[1] <= n + BP;
}
function JP(e, t, n, r) {
	if (n === "left" || n === "right") {
		let n = Math.abs(t[0] - e[0]) < BP ? 0 : (r - e[0]) / (t[0] - e[0]);
		return [r, e[1] + n * (t[1] - e[1])];
	}
	let i = Math.abs(t[1] - e[1]) < BP ? 0 : (r - e[1]) / (t[1] - e[1]);
	return [e[0] + i * (t[0] - e[0]), r];
}
function YP(e, t, n, r, i) {
	let a = UP(e), o = [
		["left", t],
		["right", r],
		["bottom", n],
		["top", i]
	];
	for (let [e, t] of o) {
		let n = a;
		if (a = [], n.length === 0) break;
		let r = n[n.length - 1];
		for (let i of n) {
			let n = qP(i, e, t), o = qP(r, e, t);
			n ? (o || a.push(JP(r, i, e, t)), a.push(i)) : o && a.push(JP(r, i, e, t)), r = i;
		}
	}
	return UP(a);
}
function XP(e, t, n, r) {
	let i = (e, t, n) => (t[0] - e[0]) * (n[1] - e[1]) - (t[1] - e[1]) * (n[0] - e[0]), a = i(e, t, n), o = i(e, n, r), s = i(e, r, t);
	return !((a < -BP || o < -BP || s < -BP) && (a > BP || o > BP || s > BP));
}
function ZP(e) {
	let t = e;
	if (t.length < 3) return [];
	if (t.length === 3) return [[
		0,
		1,
		2
	]];
	let n = VP(t) > 0, r = t.map((e, t) => t), i = [], a = t.length * t.length;
	for (; r.length > 3 && a > 0;) {
		--a;
		let e = !1;
		for (let a = 0; a < r.length; a += 1) {
			let o = r[(a - 1 + r.length) % r.length], s = r[a], c = r[(a + 1) % r.length], l = t[o], u = t[s], d = t[c], f = (u[0] - l[0]) * (d[1] - u[1]) - (u[1] - l[1]) * (d[0] - u[0]);
			if (!(n ? f > BP : f < -BP)) continue;
			let p = !1;
			for (let e of r) if (!(e === o || e === s || e === c) && XP(t[e], l, u, d)) {
				p = !0;
				break;
			}
			if (!p) {
				i.push([
					o,
					s,
					c
				]), r.splice(a, 1), e = !0;
				break;
			}
		}
		if (!e) return [];
	}
	return r.length === 3 && i.push([
		r[0],
		r[1],
		r[2]
	]), i;
}
function QP(e) {
	let t = e.map(UP).filter((e) => e.length >= 3);
	if (t.length === 0) return {
		vertices: [],
		faces: []
	};
	let n = [], r = [];
	for (let e = 0; e < t.length; e += 1) e > 0 && r.push(n.length), n.push(...t[e]);
	let i = KN(n.flatMap(([e, t]) => [e, t]), r, 2), a = [];
	for (let e = 0; e < i.length; e += 3) a.push([
		i[e],
		i[e + 1],
		i[e + 2]
	]);
	return {
		vertices: n,
		faces: a
	};
}
function $P(e) {
	if (e.length < 3) return [];
	let t = [
		0,
		0,
		0
	];
	for (let n = 0; n < e.length; n += 1) {
		let r = e[n], i = e[(n + 1) % e.length];
		t = [
			t[0] + (r[1] - i[1]) * (r[2] + i[2]),
			t[1] + (r[2] - i[2]) * (r[0] + i[0]),
			t[2] + (r[0] - i[0]) * (r[1] + i[1])
		];
	}
	let n = Math.abs(t[0]) >= Math.abs(t[1]) && Math.abs(t[0]) >= Math.abs(t[2]) ? 0 : Math.abs(t[1]) >= Math.abs(t[2]) ? 1 : 2;
	return ZP(e.map((e) => n === 0 ? [e[1], e[2]] : n === 1 ? [e[0], e[2]] : [e[0], e[1]])).map(([t, n, r]) => [
		e[t],
		e[n],
		e[r]
	]);
}
function eF(e, t, n) {
	let r = UP(e), i = ZP(r);
	if (i.length === 0) return [];
	let a = r.map(([e, n]) => [
		e,
		n,
		t
	]), o = r.map(([e, t]) => [
		e,
		t,
		n
	]), s = [];
	for (let [e, t, n] of i) s.push([
		o[e],
		o[t],
		o[n]
	]), s.push([
		a[n],
		a[t],
		a[e]
	]);
	for (let e = 0; e < r.length; e += 1) {
		let t = (e + 1) % r.length;
		s.push([
			a[e],
			a[t],
			o[t]
		]), s.push([
			a[e],
			o[t],
			o[e]
		]);
	}
	return s;
}
function tF(e, t, n) {
	let r = e.map(UP).filter((e) => e.length >= 3), { vertices: i, faces: a } = QP(r);
	if (a.length === 0) return [];
	let o = i.map(([e, n]) => [
		e,
		n,
		t
	]), s = i.map(([e, t]) => [
		e,
		t,
		n
	]), c = [];
	for (let [e, t, n] of a) c.push([
		s[e],
		s[t],
		s[n]
	]), c.push([
		o[n],
		o[t],
		o[e]
	]);
	let l = 0;
	for (let e of r) {
		for (let t = 0; t < e.length; t += 1) {
			let n = (t + 1) % e.length, r = l + t, i = l + n;
			l === 0 ? c.push([
				o[r],
				o[i],
				s[i]
			], [
				o[r],
				s[i],
				s[r]
			]) : c.push([
				o[i],
				o[r],
				s[r]
			], [
				o[i],
				s[r],
				s[i]
			]);
		}
		l += e.length;
	}
	return c;
}
function nF(e, t) {
	let n = !1;
	for (let r = 0, i = t.length - 1; r < t.length; i = r++) {
		let a = t[r], o = t[i];
		a[1] > e[1] != o[1] > e[1] && e[0] < (o[0] - a[0]) * (e[1] - a[1]) / (o[1] - a[1] || BP) + a[0] && (n = !n);
	}
	return n;
}
function rF(e) {
	return e.map((e) => Math.round(e * 1e5)).join(",");
}
function iF([e, t, n]) {
	let r = [
		t[0] - e[0],
		t[1] - e[1],
		t[2] - e[2]
	], i = [
		n[0] - e[0],
		n[1] - e[1],
		n[2] - e[2]
	], a = [
		r[1] * i[2] - r[2] * i[1],
		r[2] * i[0] - r[0] * i[2],
		r[0] * i[1] - r[1] * i[0]
	];
	return a[0] ** 2 + a[1] ** 2 + a[2] ** 2;
}
function aF(e) {
	let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = 0, i = 0;
	for (let a of e) {
		if (iF(a) < 1e-12) {
			r += 1;
			continue;
		}
		let e = a.map(rF).sort().join("|");
		n.has(e) ? i += 1 : n.add(e);
		for (let [e, n] of [
			[0, 1],
			[1, 2],
			[2, 0]
		]) {
			let r = rF(a[e]), i = rF(a[n]), o = r < i ? `${r}|${i}` : `${i}|${r}`;
			t.set(o, (t.get(o) ?? 0) + 1);
		}
	}
	let a = 0, o = 0;
	for (let e of t.values()) e === 1 ? a += 1 : e > 2 && (o += 1);
	return {
		valid: a === 0 && o === 0 && r === 0 && i === 0,
		openEdges: a,
		nonManifoldEdges: o,
		degenerateTriangles: r,
		duplicateTriangles: i,
		disconnectedComponents: +(e.length > 0)
	};
}
function oF(e) {
	let t = [
		Infinity,
		Infinity,
		Infinity
	], n = [
		-Infinity,
		-Infinity,
		-Infinity
	];
	for (let r of e) for (let e of r) t = [
		Math.min(t[0], e[0]),
		Math.min(t[1], e[1]),
		Math.min(t[2], e[2])
	], n = [
		Math.max(n[0], e[0]),
		Math.max(n[1], e[1]),
		Math.max(n[2], e[2])
	];
	return {
		minimum: t,
		maximum: n
	};
}
//#endregion
//#region lib/selection.ts
var sF = 1e-7;
function cF(e) {
	let t = e.map((e) => e[0]), n = e.map((e) => e[1]);
	return [
		Math.min(...t),
		Math.min(...n),
		Math.max(...t),
		Math.max(...n)
	];
}
function lF(e, t, n, r, i = 0) {
	let a = n / 2, o;
	if (r === "circle") o = Array.from({ length: 48 }, (e, t) => {
		let n = t / 48 * Math.PI * 2;
		return [Math.cos(n) * a, Math.sin(n) * a];
	});
	else if (r === "hexagon") o = Array.from({ length: 6 }, (e, t) => {
		let n = Math.PI / 6 + t / 6 * Math.PI * 2;
		return [Math.cos(n) * a, Math.sin(n) * a];
	});
	else {
		let e = a, t = r === "rectangle" ? a * .68 : a;
		o = [
			[-e, -t],
			[e, -t],
			[e, t],
			[-e, t]
		];
	}
	let s = i * Math.PI / 180, c = Math.cos(s), l = Math.sin(s), u = o.map(([e, t]) => [e * c - t * l, e * l + t * c]), d = cF(u), f = Math.max(d[2] - d[0], d[3] - d[1]), p = f > 0 ? n / f : 1;
	return u.map(([n, r]) => [e + n * p, t + r * p]);
}
function uF(e) {
	let t = UP((e.selectionPolygon ?? []).filter((e) => Array.isArray(e) && e.length === 2 && e.every(Number.isFinite)));
	return t.length >= 3 && Math.abs(VP(t)) >= 1 ? t : lF(e.centerX, e.centerY, e.areaMeters, "square");
}
function dF(e) {
	return cF(uF(e));
}
function fF(e) {
	let [t, n, r, i] = dF(e), a = Math.max(r - t, i - n);
	return e.modelMillimeters / a;
}
function pF(e) {
	let [t, n, r, i] = dF(e), a = fF(e);
	return [(r - t) * a, (i - n) * a];
}
function mF(e, t) {
	let [n, r] = dF(t), i = fF(t);
	return [(e[0] - n) * i, (e[1] - r) * i];
}
function hF(e, t) {
	let [n, r] = dF(t), i = fF(t);
	return [n + e[0] / i, r + e[1] / i];
}
function gF(e, t, n) {
	let r = n[0] - t[0], i = n[1] - t[1], a = r * r + i * i;
	if (a < sF) return (e[0] - t[0]) ** 2 + (e[1] - t[1]) ** 2;
	let o = Math.max(0, Math.min(1, ((e[0] - t[0]) * r + (e[1] - t[1]) * i) / a));
	return (e[0] - (t[0] + o * r)) ** 2 + (e[1] - (t[1] + o * i)) ** 2;
}
function _F(e, t) {
	if (nF(e, t)) return !0;
	for (let n = 0; n < t.length; n += 1) if (gF(e, t[n], t[(n + 1) % t.length]) < sF) return !0;
	return !1;
}
function vF(e, t) {
	return e.every((e) => _F(e, t));
}
function yF(e, t, n) {
	return (t[0] - e[0]) * (n[1] - e[1]) - (t[1] - e[1]) * (n[0] - e[0]);
}
function bF(e, t, n, r) {
	let i = yF(e, t, n), a = yF(e, t, r), o = yF(n, r, e), s = yF(n, r, t);
	return i * a < -sF && o * s < -sF;
}
function xF(e) {
	let t = UP(e);
	if (t.length < 3) return !1;
	for (let e = 0; e < t.length; e += 1) {
		let n = (e + 1) % t.length;
		for (let r = e + 1; r < t.length; r += 1) {
			let i = (r + 1) % t.length;
			if (!(e === r || n === r || i === e) && !(e === 0 && i === 0) && bF(t[e], t[n], t[r], t[i])) return !1;
		}
	}
	return !0;
}
function SF(e, t, n, r) {
	let i = t[0] - e[0], a = t[1] - e[1], o = r[0] - n[0], s = r[1] - n[1], c = i * s - a * o;
	if (Math.abs(c) < sF) return t;
	let l = ((n[0] - e[0]) * s - (n[1] - e[1]) * o) / c;
	return [e[0] + l * i, e[1] + l * a];
}
function CF(e, t) {
	let n = UP(e), r = UP(t);
	if (n.length < 3 || r.length < 3) return [];
	let i = VP(r) >= 0 ? 1 : -1, a = (e, t, n) => i * ((n[0] - t[0]) * (e[1] - t[1]) - (n[1] - t[1]) * (e[0] - t[0])) >= -sF;
	for (let e = 0; e < r.length; e += 1) {
		let t = n;
		if (n = [], t.length === 0) break;
		let i = r[e], o = r[(e + 1) % r.length], s = t[t.length - 1];
		for (let e of t) {
			let t = a(s, i, o);
			a(e, i, o) ? (t || n.push(SF(s, e, i, o)), n.push(e)) : t && n.push(SF(s, e, i, o)), s = e;
		}
		n = UP(n);
	}
	return n.length >= 3 && Math.abs(VP(n)) > sF ? n : [];
}
function wF(e, t) {
	let n = UP(e), r = UP(t);
	if (n.length < 3 || r.length < 3) return [];
	if (vF(n, r)) return [n];
	let i = ZP(n), a = ZP(r), o = [];
	for (let e of i) {
		let t = e.map((e) => n[e]);
		for (let e of a) {
			let n = CF(t, e.map((e) => r[e]));
			n.length >= 3 && Math.abs(VP(n)) > 1e-6 && o.push(n);
		}
	}
	return o;
}
//#endregion
//#region lib/data/bag-tile-index.json
var TF = /* @__PURE__ */ JSON.parse("[[\"8/760/72\",203593.331,324890.397,205593.331,326890.397],[\"8/760/64\",203593.331,322890.397,205593.331,324890.397],[\"8/760/56\",203593.331,320890.397,205593.331,322890.397],[\"8/760/48\",203593.331,318890.397,205593.331,320890.397],[\"9/756/40\",202593.331,316890.397,203593.331,317890.397],[\"10/756/44\",202593.331,317890.397,203093.331,318390.397],[\"10/758/44\",203093.331,317890.397,203593.331,318390.397],[\"10/758/46\",203093.331,318390.397,203593.331,318890.397],[\"10/758/48\",203093.331,318890.397,203593.331,319390.397],[\"10/756/48\",202593.331,318890.397,203093.331,319390.397],[\"10/756/46\",202593.331,318390.397,203093.331,318890.397],[\"9/752/44\",201593.331,317890.397,202593.331,318890.397],[\"9/752/48\",201593.331,318890.397,202593.331,319890.397],[\"8/744/40\",199593.331,316890.397,201593.331,318890.397],[\"9/740/48\",198593.331,318890.397,199593.331,319890.397],[\"10/744/48\",199593.331,318890.397,200093.331,319390.397],[\"10/746/48\",200093.331,318890.397,200593.331,319390.397],[\"9/748/48\",200593.331,318890.397,201593.331,319890.397],[\"9/748/52\",200593.331,319890.397,201593.331,320890.397],[\"9/744/52\",199593.331,319890.397,200593.331,320890.397],[\"10/746/50\",200093.331,319390.397,200593.331,319890.397],[\"10/744/50\",199593.331,319390.397,200093.331,319890.397],[\"9/740/52\",198593.331,319890.397,199593.331,320890.397],[\"9/740/56\",198593.331,320890.397,199593.331,321890.397],[\"8/744/56\",199593.331,320890.397,201593.331,322890.397],[\"9/752/56\",201593.331,320890.397,202593.331,321890.397],[\"9/752/52\",201593.331,319890.397,202593.331,320890.397],[\"10/756/50\",202593.331,319390.397,203093.331,319890.397],[\"10/758/50\",203093.331,319390.397,203593.331,319890.397],[\"9/756/52\",202593.331,319890.397,203593.331,320890.397],[\"9/756/56\",202593.331,320890.397,203593.331,321890.397],[\"9/756/60\",202593.331,321890.397,203593.331,322890.397],[\"9/752/60\",201593.331,321890.397,202593.331,322890.397],[\"8/752/64\",201593.331,322890.397,203593.331,324890.397],[\"8/752/72\",201593.331,324890.397,203593.331,326890.397],[\"10/750/74\",201093.331,325390.397,201593.331,325890.397],[\"10/750/72\",201093.331,324890.397,201593.331,325390.397],[\"9/744/72\",199593.331,324890.397,200593.331,325890.397],[\"10/748/72\",200593.331,324890.397,201093.331,325390.397],[\"10/748/74\",200593.331,325390.397,201093.331,325890.397],[\"9/748/76\",200593.331,325890.397,201593.331,326890.397],[\"9/744/76\",199593.331,325890.397,200593.331,326890.397],[\"9/740/68\",198593.331,323890.397,199593.331,324890.397],[\"9/740/64\",198593.331,322890.397,199593.331,323890.397],[\"9/744/68\",199593.331,323890.397,200593.331,324890.397],[\"9/748/68\",200593.331,323890.397,201593.331,324890.397],[\"9/748/64\",200593.331,322890.397,201593.331,323890.397],[\"9/744/64\",199593.331,322890.397,200593.331,323890.397],[\"9/740/60\",198593.331,321890.397,199593.331,322890.397],[\"9/736/60\",197593.331,321890.397,198593.331,322890.397],[\"9/732/60\",196593.331,321890.397,197593.331,322890.397],[\"9/732/64\",196593.331,322890.397,197593.331,323890.397],[\"9/732/68\",196593.331,323890.397,197593.331,324890.397],[\"9/736/64\",197593.331,322890.397,198593.331,323890.397],[\"9/736/68\",197593.331,323890.397,198593.331,324890.397],[\"8/736/72\",197593.331,324890.397,199593.331,326890.397],[\"9/732/76\",196593.331,325890.397,197593.331,326890.397],[\"9/732/72\",196593.331,324890.397,197593.331,325890.397],[\"9/724/72\",194593.331,324890.397,195593.331,325890.397],[\"9/728/72\",195593.331,324890.397,196593.331,325890.397],[\"9/728/76\",195593.331,325890.397,196593.331,326890.397],[\"9/724/76\",194593.331,325890.397,195593.331,326890.397],[\"9/720/76\",193593.331,325890.397,194593.331,326890.397],[\"9/720/72\",193593.331,324890.397,194593.331,325890.397],[\"9/720/68\",193593.331,323890.397,194593.331,324890.397],[\"9/720/64\",193593.331,322890.397,194593.331,323890.397],[\"9/724/68\",194593.331,323890.397,195593.331,324890.397],[\"9/728/68\",195593.331,323890.397,196593.331,324890.397],[\"9/728/64\",195593.331,322890.397,196593.331,323890.397],[\"9/724/64\",194593.331,322890.397,195593.331,323890.397],[\"9/728/60\",195593.331,321890.397,196593.331,322890.397],[\"8/720/56\",193593.331,320890.397,195593.331,322890.397],[\"8/720/48\",193593.331,318890.397,195593.331,320890.397],[\"9/728/56\",195593.331,320890.397,196593.331,321890.397],[\"9/732/56\",196593.331,320890.397,197593.331,321890.397],[\"9/736/56\",197593.331,320890.397,198593.331,321890.397],[\"9/736/52\",197593.331,319890.397,198593.331,320890.397],[\"8/728/48\",195593.331,318890.397,197593.331,320890.397],[\"9/736/48\",197593.331,318890.397,198593.331,319890.397],[\"8/736/40\",197593.331,316890.397,199593.331,318890.397],[\"8/728/40\",195593.331,316890.397,197593.331,318890.397],[\"8/720/40\",193593.331,316890.397,195593.331,318890.397],[\"8/720/32\",193593.331,314890.397,195593.331,316890.397],[\"7/720/16\",193593.331,310890.397,197593.331,314890.397],[\"9/736/24\",197593.331,312890.397,198593.331,313890.397],[\"9/736/28\",197593.331,313890.397,198593.331,314890.397],[\"8/728/32\",195593.331,314890.397,197593.331,316890.397],[\"8/736/32\",197593.331,314890.397,199593.331,316890.397],[\"8/744/32\",199593.331,314890.397,201593.331,316890.397],[\"8/744/24\",199593.331,312890.397,201593.331,314890.397],[\"9/740/28\",198593.331,313890.397,199593.331,314890.397],[\"9/740/24\",198593.331,312890.397,199593.331,313890.397],[\"9/740/12\",198593.331,309890.397,199593.331,310890.397],[\"8/744/8\",199593.331,308890.397,201593.331,310890.397],[\"8/744/0\",199593.331,306890.397,201593.331,308890.397],[\"9/740/8\",198593.331,308890.397,199593.331,309890.397],[\"8/736/0\",197593.331,306890.397,199593.331,308890.397],[\"9/736/8\",197593.331,308890.397,198593.331,309890.397],[\"9/736/12\",197593.331,309890.397,198593.331,310890.397],[\"8/736/16\",197593.331,310890.397,199593.331,312890.397],[\"7/720/0\",193593.331,306890.397,197593.331,310890.397],[\"7/704/0\",189593.331,306890.397,193593.331,310890.397],[\"8/704/16\",189593.331,310890.397,191593.331,312890.397],[\"8/712/16\",191593.331,310890.397,193593.331,312890.397],[\"8/712/24\",191593.331,312890.397,193593.331,314890.397],[\"7/704/32\",189593.331,314890.397,193593.331,318890.397],[\"8/704/24\",189593.331,312890.397,191593.331,314890.397],[\"7/688/16\",185593.331,310890.397,189593.331,314890.397],[\"8/696/32\",187593.331,314890.397,189593.331,316890.397],[\"8/688/32\",185593.331,314890.397,187593.331,316890.397],[\"8/680/32\",183593.331,314890.397,185593.331,316890.397],[\"7/688/0\",185593.331,306890.397,189593.331,310890.397],[\"7/672/0\",181593.331,306890.397,185593.331,310890.397],[\"8/664/8\",179593.331,308890.397,181593.331,310890.397],[\"8/664/16\",179593.331,310890.397,181593.331,312890.397],[\"9/660/12\",178593.331,309890.397,179593.331,310890.397],[\"9/660/8\",178593.331,308890.397,179593.331,309890.397],[\"8/664/0\",179593.331,306890.397,181593.331,308890.397],[\"8/656/0\",177593.331,306890.397,179593.331,308890.397],[\"9/656/8\",177593.331,308890.397,178593.331,309890.397],[\"7/640/0\",173593.331,306890.397,177593.331,310890.397],[\"9/656/12\",177593.331,309890.397,178593.331,310890.397],[\"8/656/16\",177593.331,310890.397,179593.331,312890.397],[\"8/656/24\",177593.331,312890.397,179593.331,314890.397],[\"7/640/16\",173593.331,310890.397,177593.331,314890.397],[\"9/648/32\",175593.331,314890.397,176593.331,315890.397],[\"9/644/32\",174593.331,314890.397,175593.331,315890.397],[\"9/640/32\",173593.331,314890.397,174593.331,315890.397],[\"9/640/36\",173593.331,315890.397,174593.331,316890.397],[\"9/644/36\",174593.331,315890.397,175593.331,316890.397],[\"9/648/36\",175593.331,315890.397,176593.331,316890.397],[\"9/652/36\",176593.331,315890.397,177593.331,316890.397],[\"9/652/32\",176593.331,314890.397,177593.331,315890.397],[\"9/656/32\",177593.331,314890.397,178593.331,315890.397],[\"9/656/36\",177593.331,315890.397,178593.331,316890.397],[\"9/660/36\",178593.331,315890.397,179593.331,316890.397],[\"8/664/32\",179593.331,314890.397,181593.331,316890.397],[\"9/660/32\",178593.331,314890.397,179593.331,315890.397],[\"8/664/24\",179593.331,312890.397,181593.331,314890.397],[\"7/672/16\",181593.331,310890.397,185593.331,314890.397],[\"8/672/32\",181593.331,314890.397,183593.331,316890.397],[\"8/672/40\",181593.331,316890.397,183593.331,318890.397],[\"8/672/48\",181593.331,318890.397,183593.331,320890.397],[\"8/672/56\",181593.331,320890.397,183593.331,322890.397],[\"8/664/48\",179593.331,318890.397,181593.331,320890.397],[\"9/668/56\",180593.331,320890.397,181593.331,321890.397],[\"9/664/56\",179593.331,320890.397,180593.331,321890.397],[\"9/660/52\",178593.331,319890.397,179593.331,320890.397],[\"9/660/48\",178593.331,318890.397,179593.331,319890.397],[\"9/660/44\",178593.331,317890.397,179593.331,318890.397],[\"8/664/40\",179593.331,316890.397,181593.331,318890.397],[\"9/660/40\",178593.331,316890.397,179593.331,317890.397],[\"9/656/40\",177593.331,316890.397,178593.331,317890.397],[\"9/656/44\",177593.331,317890.397,178593.331,318890.397],[\"9/656/48\",177593.331,318890.397,178593.331,319890.397],[\"9/652/44\",176593.331,317890.397,177593.331,318890.397],[\"10/650/42\",176093.331,317390.397,176593.331,317890.397],[\"9/652/40\",176593.331,316890.397,177593.331,317890.397],[\"10/650/40\",176093.331,316890.397,176593.331,317390.397],[\"10/648/40\",175593.331,316890.397,176093.331,317390.397],[\"10/648/42\",175593.331,317390.397,176093.331,317890.397],[\"10/646/42\",175093.331,317390.397,175593.331,317890.397],[\"10/646/40\",175093.331,316890.397,175593.331,317390.397],[\"10/644/40\",174593.331,316890.397,175093.331,317390.397],[\"9/640/40\",173593.331,316890.397,174593.331,317890.397],[\"10/644/42\",174593.331,317390.397,175093.331,317890.397],[\"9/640/44\",173593.331,317890.397,174593.331,318890.397],[\"9/644/44\",174593.331,317890.397,175593.331,318890.397],[\"9/648/44\",175593.331,317890.397,176593.331,318890.397],[\"8/640/48\",173593.331,318890.397,175593.331,320890.397],[\"8/640/56\",173593.331,320890.397,175593.331,322890.397],[\"8/648/56\",175593.331,320890.397,177593.331,322890.397],[\"8/648/48\",175593.331,318890.397,177593.331,320890.397],[\"9/656/52\",177593.331,319890.397,178593.331,320890.397],[\"8/656/56\",177593.331,320890.397,179593.331,322890.397],[\"8/656/64\",177593.331,322890.397,179593.331,324890.397],[\"7/640/64\",173593.331,322890.397,177593.331,326890.397],[\"8/656/72\",177593.331,324890.397,179593.331,326890.397],[\"8/664/72\",179593.331,324890.397,181593.331,326890.397],[\"9/664/60\",179593.331,321890.397,180593.331,322890.397],[\"9/668/60\",180593.331,321890.397,181593.331,322890.397],[\"8/664/64\",179593.331,322890.397,181593.331,324890.397],[\"8/672/64\",181593.331,322890.397,183593.331,324890.397],[\"8/672/72\",181593.331,324890.397,183593.331,326890.397],[\"8/680/72\",183593.331,324890.397,185593.331,326890.397],[\"8/688/72\",185593.331,324890.397,187593.331,326890.397],[\"8/696/72\",187593.331,324890.397,189593.331,326890.397],[\"8/688/64\",185593.331,322890.397,187593.331,324890.397],[\"8/696/64\",187593.331,322890.397,189593.331,324890.397],[\"8/680/64\",183593.331,322890.397,185593.331,324890.397],[\"8/680/56\",183593.331,320890.397,185593.331,322890.397],[\"9/688/52\",185593.331,319890.397,186593.331,320890.397],[\"8/680/48\",183593.331,318890.397,185593.331,320890.397],[\"8/680/40\",183593.331,316890.397,185593.331,318890.397],[\"9/688/48\",185593.331,318890.397,186593.331,319890.397],[\"9/692/48\",186593.331,318890.397,187593.331,319890.397],[\"8/688/40\",185593.331,316890.397,187593.331,318890.397],[\"8/696/40\",187593.331,316890.397,189593.331,318890.397],[\"8/696/48\",187593.331,318890.397,189593.331,320890.397],[\"9/692/52\",186593.331,319890.397,187593.331,320890.397],[\"8/688/56\",185593.331,320890.397,187593.331,322890.397],[\"8/696/56\",187593.331,320890.397,189593.331,322890.397],[\"8/704/56\",189593.331,320890.397,191593.331,322890.397],[\"8/704/48\",189593.331,318890.397,191593.331,320890.397],[\"8/712/48\",191593.331,318890.397,193593.331,320890.397],[\"9/712/56\",191593.331,320890.397,192593.331,321890.397],[\"9/716/56\",192593.331,320890.397,193593.331,321890.397],[\"9/716/60\",192593.331,321890.397,193593.331,322890.397],[\"8/712/64\",191593.331,322890.397,193593.331,324890.397],[\"9/712/60\",191593.331,321890.397,192593.331,322890.397],[\"8/704/64\",189593.331,322890.397,191593.331,324890.397],[\"9/708/72\",190593.331,324890.397,191593.331,325890.397],[\"9/704/72\",189593.331,324890.397,190593.331,325890.397],[\"9/704/76\",189593.331,325890.397,190593.331,326890.397],[\"9/708/76\",190593.331,325890.397,191593.331,326890.397],[\"9/712/76\",191593.331,325890.397,192593.331,326890.397],[\"9/712/72\",191593.331,324890.397,192593.331,325890.397],[\"9/716/72\",192593.331,324890.397,193593.331,325890.397],[\"9/716/76\",192593.331,325890.397,193593.331,326890.397],[\"9/716/80\",192593.331,326890.397,193593.331,327890.397],[\"9/716/84\",192593.331,327890.397,193593.331,328890.397],[\"9/712/84\",191593.331,327890.397,192593.331,328890.397],[\"9/712/80\",191593.331,326890.397,192593.331,327890.397],[\"8/704/80\",189593.331,326890.397,191593.331,328890.397],[\"8/704/88\",189593.331,328890.397,191593.331,330890.397],[\"9/700/96\",188593.331,330890.397,189593.331,331890.397],[\"8/704/96\",189593.331,330890.397,191593.331,332890.397],[\"8/712/88\",191593.331,328890.397,193593.331,330890.397],[\"8/712/96\",191593.331,330890.397,193593.331,332890.397],[\"7/704/112\",189593.331,334890.397,193593.331,338890.397],[\"9/700/116\",188593.331,335890.397,189593.331,336890.397],[\"9/700/112\",188593.331,334890.397,189593.331,335890.397],[\"9/700/108\",188593.331,333890.397,189593.331,334890.397],[\"9/700/104\",188593.331,332890.397,189593.331,333890.397],[\"9/704/108\",189593.331,333890.397,190593.331,334890.397],[\"9/708/108\",190593.331,333890.397,191593.331,334890.397],[\"9/708/104\",190593.331,332890.397,191593.331,333890.397],[\"9/704/104\",189593.331,332890.397,190593.331,333890.397],[\"9/700/100\",188593.331,331890.397,189593.331,332890.397],[\"9/696/100\",187593.331,331890.397,188593.331,332890.397],[\"9/692/100\",186593.331,331890.397,187593.331,332890.397],[\"9/692/104\",186593.331,332890.397,187593.331,333890.397],[\"9/692/108\",186593.331,333890.397,187593.331,334890.397],[\"9/696/104\",187593.331,332890.397,188593.331,333890.397],[\"9/696/108\",187593.331,333890.397,188593.331,334890.397],[\"9/696/112\",187593.331,334890.397,188593.331,335890.397],[\"9/696/116\",187593.331,335890.397,188593.331,336890.397],[\"8/688/112\",185593.331,334890.397,187593.331,336890.397],[\"8/680/112\",183593.331,334890.397,185593.331,336890.397],[\"8/680/104\",183593.331,332890.397,185593.331,334890.397],[\"9/688/108\",185593.331,333890.397,186593.331,334890.397],[\"9/688/104\",185593.331,332890.397,186593.331,333890.397],[\"9/688/100\",185593.331,331890.397,186593.331,332890.397],[\"9/684/100\",184593.331,331890.397,185593.331,332890.397],[\"9/680/100\",183593.331,331890.397,184593.331,332890.397],[\"9/680/96\",183593.331,330890.397,184593.331,331890.397],[\"9/680/92\",183593.331,329890.397,184593.331,330890.397],[\"9/684/92\",184593.331,329890.397,185593.331,330890.397],[\"10/688/92\",185593.331,329890.397,186093.331,330390.397],[\"10/688/94\",185593.331,330390.397,186093.331,330890.397],[\"9/684/96\",184593.331,330890.397,185593.331,331890.397],[\"9/688/96\",185593.331,330890.397,186593.331,331890.397],[\"9/692/96\",186593.331,330890.397,187593.331,331890.397],[\"9/696/96\",187593.331,330890.397,188593.331,331890.397],[\"8/696/88\",187593.331,328890.397,189593.331,330890.397],[\"9/692/92\",186593.331,329890.397,187593.331,330890.397],[\"10/690/94\",186093.331,330390.397,186593.331,330890.397],[\"10/690/92\",186093.331,329890.397,186593.331,330390.397],[\"9/692/88\",186593.331,328890.397,187593.331,329890.397],[\"8/696/80\",187593.331,326890.397,189593.331,328890.397],[\"8/688/80\",185593.331,326890.397,187593.331,328890.397],[\"9/684/80\",184593.331,326890.397,185593.331,327890.397],[\"9/688/88\",185593.331,328890.397,186593.331,329890.397],[\"9/684/88\",184593.331,328890.397,185593.331,329890.397],[\"9/684/84\",184593.331,327890.397,185593.331,328890.397],[\"9/680/88\",183593.331,328890.397,184593.331,329890.397],[\"9/680/84\",183593.331,327890.397,184593.331,328890.397],[\"9/680/80\",183593.331,326890.397,184593.331,327890.397],[\"9/676/80\",182593.331,326890.397,183593.331,327890.397],[\"9/672/80\",181593.331,326890.397,182593.331,327890.397],[\"9/672/84\",181593.331,327890.397,182593.331,328890.397],[\"9/672/88\",181593.331,328890.397,182593.331,329890.397],[\"9/676/84\",182593.331,327890.397,183593.331,328890.397],[\"9/676/88\",182593.331,328890.397,183593.331,329890.397],[\"9/676/92\",182593.331,329890.397,183593.331,330890.397],[\"9/676/96\",182593.331,330890.397,183593.331,331890.397],[\"9/672/96\",181593.331,330890.397,182593.331,331890.397],[\"9/672/92\",181593.331,329890.397,182593.331,330890.397],[\"7/656/80\",177593.331,326890.397,181593.331,330890.397],[\"6/640/96\",173593.331,330890.397,181593.331,338890.397],[\"9/672/100\",181593.331,331890.397,182593.331,332890.397],[\"9/676/100\",182593.331,331890.397,183593.331,332890.397],[\"8/672/104\",181593.331,332890.397,183593.331,334890.397],[\"8/672/112\",181593.331,334890.397,183593.331,336890.397],[\"8/672/120\",181593.331,336890.397,183593.331,338890.397],[\"8/672/128\",181593.331,338890.397,183593.331,340890.397],[\"7/672/144\",181593.331,342890.397,185593.331,346890.397],[\"8/688/152\",185593.331,344890.397,187593.331,346890.397],[\"9/696/156\",187593.331,345890.397,188593.331,346890.397],[\"9/696/152\",187593.331,344890.397,188593.331,345890.397],[\"8/688/144\",185593.331,342890.397,187593.331,344890.397],[\"8/696/144\",187593.331,342890.397,189593.331,344890.397],[\"9/696/140\",187593.331,341890.397,188593.331,342890.397],[\"8/680/136\",183593.331,340890.397,185593.331,342890.397],[\"8/680/128\",183593.331,338890.397,185593.331,340890.397],[\"9/680/124\",183593.331,337890.397,184593.331,338890.397],[\"9/680/120\",183593.331,336890.397,184593.331,337890.397],[\"9/684/120\",184593.331,336890.397,185593.331,337890.397],[\"9/684/124\",184593.331,337890.397,185593.331,338890.397],[\"8/688/120\",185593.331,336890.397,187593.331,338890.397],[\"8/696/120\",187593.331,336890.397,189593.331,338890.397],[\"8/696/128\",187593.331,338890.397,189593.331,340890.397],[\"8/688/128\",185593.331,338890.397,187593.331,340890.397],[\"8/688/136\",185593.331,340890.397,187593.331,342890.397],[\"9/696/136\",187593.331,340890.397,188593.331,341890.397],[\"9/700/136\",188593.331,340890.397,189593.331,341890.397],[\"7/704/128\",189593.331,338890.397,193593.331,342890.397],[\"8/712/144\",191593.331,342890.397,193593.331,344890.397],[\"9/700/140\",188593.331,341890.397,189593.331,342890.397],[\"8/704/144\",189593.331,342890.397,191593.331,344890.397],[\"9/708/152\",190593.331,344890.397,191593.331,345890.397],[\"9/704/152\",189593.331,344890.397,190593.331,345890.397],[\"9/700/152\",188593.331,344890.397,189593.331,345890.397],[\"9/700/156\",188593.331,345890.397,189593.331,346890.397],[\"9/704/156\",189593.331,345890.397,190593.331,346890.397],[\"9/708/156\",190593.331,345890.397,191593.331,346890.397],[\"8/712/152\",191593.331,344890.397,193593.331,346890.397],[\"7/720/144\",193593.331,342890.397,197593.331,346890.397],[\"6/736/128\",197593.331,338890.397,205593.331,346890.397],[\"7/720/128\",193593.331,338890.397,197593.331,342890.397],[\"7/720/112\",193593.331,334890.397,197593.331,338890.397],[\"8/720/104\",193593.331,332890.397,195593.331,334890.397],[\"8/720/96\",193593.331,330890.397,195593.331,332890.397],[\"9/728/92\",195593.331,329890.397,196593.331,330890.397],[\"8/720/88\",193593.331,328890.397,195593.331,330890.397],[\"9/720/84\",193593.331,327890.397,194593.331,328890.397],[\"9/720/80\",193593.331,326890.397,194593.331,327890.397],[\"9/724/80\",194593.331,326890.397,195593.331,327890.397],[\"9/728/80\",195593.331,326890.397,196593.331,327890.397],[\"9/728/84\",195593.331,327890.397,196593.331,328890.397],[\"9/724/84\",194593.331,327890.397,195593.331,328890.397],[\"9/728/88\",195593.331,328890.397,196593.331,329890.397],[\"9/732/88\",196593.331,328890.397,197593.331,329890.397],[\"9/732/84\",196593.331,327890.397,197593.331,328890.397],[\"9/732/80\",196593.331,326890.397,197593.331,327890.397],[\"9/732/92\",196593.331,329890.397,197593.331,330890.397],[\"8/728/96\",195593.331,330890.397,197593.331,332890.397],[\"7/736/80\",197593.331,326890.397,201593.331,330890.397],[\"6/736/96\",197593.331,330890.397,205593.331,338890.397],[\"5/768/128\",205593.331,338890.397,221593.331,354890.397],[\"8/760/176\",203593.331,350890.397,205593.331,352890.397],[\"8/760/184\",203593.331,352890.397,205593.331,354890.397],[\"6/768/192\",205593.331,354890.397,213593.331,362890.397],[\"7/768/224\",205593.331,362890.397,209593.331,366890.397],[\"9/764/232\",204593.331,364890.397,205593.331,365890.397],[\"9/764/236\",204593.331,365890.397,205593.331,366890.397],[\"9/760/236\",203593.331,365890.397,204593.331,366890.397],[\"9/760/232\",203593.331,364890.397,204593.331,365890.397],[\"8/760/224\",203593.331,362890.397,205593.331,364890.397],[\"8/744/200\",199593.331,356890.397,201593.331,358890.397],[\"9/740/200\",198593.331,356890.397,199593.331,357890.397],[\"9/740/204\",198593.331,357890.397,199593.331,358890.397],[\"9/744/208\",199593.331,358890.397,200593.331,359890.397],[\"9/748/208\",200593.331,358890.397,201593.331,359890.397],[\"9/748/212\",200593.331,359890.397,201593.331,360890.397],[\"9/744/212\",199593.331,359890.397,200593.331,360890.397],[\"8/744/216\",199593.331,360890.397,201593.331,362890.397],[\"7/752/208\",201593.331,358890.397,205593.331,362890.397],[\"8/752/224\",201593.331,362890.397,203593.331,364890.397],[\"9/756/232\",202593.331,364890.397,203593.331,365890.397],[\"9/756/236\",202593.331,365890.397,203593.331,366890.397],[\"9/752/236\",201593.331,365890.397,202593.331,366890.397],[\"9/752/232\",201593.331,364890.397,202593.331,365890.397],[\"8/744/232\",199593.331,364890.397,201593.331,366890.397],[\"8/744/224\",199593.331,362890.397,201593.331,364890.397],[\"8/736/224\",197593.331,362890.397,199593.331,364890.397],[\"8/736/232\",197593.331,364890.397,199593.331,366890.397],[\"7/720/224\",193593.331,362890.397,197593.331,366890.397],[\"8/720/216\",193593.331,360890.397,195593.331,362890.397],[\"8/720/208\",193593.331,358890.397,195593.331,360890.397],[\"8/728/216\",195593.331,360890.397,197593.331,362890.397],[\"8/736/216\",197593.331,360890.397,199593.331,362890.397],[\"8/736/208\",197593.331,358890.397,199593.331,360890.397],[\"8/728/208\",195593.331,358890.397,197593.331,360890.397],[\"9/736/204\",197593.331,357890.397,198593.331,358890.397],[\"9/736/200\",197593.331,356890.397,198593.331,357890.397],[\"8/728/200\",195593.331,356890.397,197593.331,358890.397],[\"8/720/200\",193593.331,356890.397,195593.331,358890.397],[\"8/720/192\",193593.331,354890.397,195593.331,356890.397],[\"9/728/196\",195593.331,355890.397,196593.331,356890.397],[\"9/728/192\",195593.331,354890.397,196593.331,355890.397],[\"9/720/188\",193593.331,353890.397,194593.331,354890.397],[\"9/724/184\",194593.331,352890.397,195593.331,353890.397],[\"9/724/188\",194593.331,353890.397,195593.331,354890.397],[\"8/728/184\",195593.331,352890.397,197593.331,354890.397],[\"9/736/184\",197593.331,352890.397,198593.331,353890.397],[\"9/736/188\",197593.331,353890.397,198593.331,354890.397],[\"9/736/192\",197593.331,354890.397,198593.331,355890.397],[\"9/732/192\",196593.331,354890.397,197593.331,355890.397],[\"10/734/196\",197093.331,355890.397,197593.331,356390.397],[\"10/732/196\",196593.331,355890.397,197093.331,356390.397],[\"10/732/198\",196593.331,356390.397,197093.331,356890.397],[\"10/734/198\",197093.331,356390.397,197593.331,356890.397],[\"9/736/196\",197593.331,355890.397,198593.331,356890.397],[\"9/740/196\",198593.331,355890.397,199593.331,356890.397],[\"9/740/192\",198593.331,354890.397,199593.331,355890.397],[\"8/744/192\",199593.331,354890.397,201593.331,356890.397],[\"7/752/192\",201593.331,354890.397,205593.331,358890.397],[\"8/752/184\",201593.331,352890.397,203593.331,354890.397],[\"9/756/180\",202593.331,351890.397,203593.331,352890.397],[\"9/752/180\",201593.331,351890.397,202593.331,352890.397],[\"8/744/184\",199593.331,352890.397,201593.331,354890.397],[\"9/740/188\",198593.331,353890.397,199593.331,354890.397],[\"9/740/184\",198593.331,352890.397,199593.331,353890.397],[\"8/744/168\",199593.331,348890.397,201593.331,350890.397],[\"8/744/176\",199593.331,350890.397,201593.331,352890.397],[\"9/752/176\",201593.331,350890.397,202593.331,351890.397],[\"9/756/176\",202593.331,350890.397,203593.331,351890.397],[\"7/752/160\",201593.331,346890.397,205593.331,350890.397],[\"8/744/160\",199593.331,346890.397,201593.331,348890.397],[\"8/736/160\",197593.331,346890.397,199593.331,348890.397],[\"8/736/168\",197593.331,348890.397,199593.331,350890.397],[\"8/736/176\",197593.331,350890.397,199593.331,352890.397],[\"8/728/176\",195593.331,350890.397,197593.331,352890.397],[\"8/720/176\",193593.331,350890.397,195593.331,352890.397],[\"7/720/160\",193593.331,346890.397,197593.331,350890.397],[\"8/712/160\",191593.331,346890.397,193593.331,348890.397],[\"8/704/160\",189593.331,346890.397,191593.331,348890.397],[\"8/704/168\",189593.331,348890.397,191593.331,350890.397],[\"8/704/176\",189593.331,350890.397,191593.331,352890.397],[\"8/712/168\",191593.331,348890.397,193593.331,350890.397],[\"8/712/176\",191593.331,350890.397,193593.331,352890.397],[\"8/712/184\",191593.331,352890.397,193593.331,354890.397],[\"8/712/192\",191593.331,354890.397,193593.331,356890.397],[\"8/704/192\",189593.331,354890.397,191593.331,356890.397],[\"8/704/184\",189593.331,352890.397,191593.331,354890.397],[\"8/688/184\",185593.331,352890.397,187593.331,354890.397],[\"8/696/184\",187593.331,352890.397,189593.331,354890.397],[\"7/688/192\",185593.331,354890.397,189593.331,358890.397],[\"8/688/176\",185593.331,350890.397,187593.331,352890.397],[\"8/696/176\",187593.331,350890.397,189593.331,352890.397],[\"8/696/168\",187593.331,348890.397,189593.331,350890.397],[\"8/688/168\",185593.331,348890.397,187593.331,350890.397],[\"8/696/160\",187593.331,346890.397,189593.331,348890.397],[\"8/688/160\",185593.331,346890.397,187593.331,348890.397],[\"7/672/160\",181593.331,346890.397,185593.331,350890.397],[\"6/640/160\",173593.331,346890.397,181593.331,354890.397],[\"7/640/192\",173593.331,354890.397,177593.331,358890.397],[\"9/656/192\",177593.331,354890.397,178593.331,355890.397],[\"9/656/196\",177593.331,355890.397,178593.331,356890.397],[\"9/660/196\",178593.331,355890.397,179593.331,356890.397],[\"8/664/192\",179593.331,354890.397,181593.331,356890.397],[\"9/660/192\",178593.331,354890.397,179593.331,355890.397],[\"7/672/176\",181593.331,350890.397,185593.331,354890.397],[\"7/672/192\",181593.331,354890.397,185593.331,358890.397],[\"7/672/208\",181593.331,358890.397,185593.331,362890.397],[\"8/664/208\",179593.331,358890.397,181593.331,360890.397],[\"8/664/216\",179593.331,360890.397,181593.331,362890.397],[\"9/660/216\",178593.331,360890.397,179593.331,361890.397],[\"8/664/200\",179593.331,356890.397,181593.331,358890.397],[\"8/656/200\",177593.331,356890.397,179593.331,358890.397],[\"8/640/208\",173593.331,358890.397,175593.331,360890.397],[\"8/640/216\",173593.331,360890.397,175593.331,362890.397],[\"9/648/216\",175593.331,360890.397,176593.331,361890.397],[\"9/652/216\",176593.331,360890.397,177593.331,361890.397],[\"8/648/208\",175593.331,358890.397,177593.331,360890.397],[\"8/656/208\",177593.331,358890.397,179593.331,360890.397],[\"9/656/216\",177593.331,360890.397,178593.331,361890.397],[\"9/656/220\",177593.331,361890.397,178593.331,362890.397],[\"9/656/224\",177593.331,362890.397,178593.331,363890.397],[\"9/656/228\",177593.331,363890.397,178593.331,364890.397],[\"9/652/224\",176593.331,362890.397,177593.331,363890.397],[\"9/652/228\",176593.331,363890.397,177593.331,364890.397],[\"10/654/222\",177093.331,362390.397,177593.331,362890.397],[\"10/652/222\",176593.331,362390.397,177093.331,362890.397],[\"10/654/220\",177093.331,361890.397,177593.331,362390.397],[\"10/652/220\",176593.331,361890.397,177093.331,362390.397],[\"9/648/220\",175593.331,361890.397,176593.331,362890.397],[\"8/640/224\",173593.331,362890.397,175593.331,364890.397],[\"9/648/224\",175593.331,362890.397,176593.331,363890.397],[\"9/648/228\",175593.331,363890.397,176593.331,364890.397],[\"8/640/232\",173593.331,364890.397,175593.331,366890.397],[\"8/648/232\",175593.331,364890.397,177593.331,366890.397],[\"8/656/232\",177593.331,364890.397,179593.331,366890.397],[\"10/664/236\",179593.331,365890.397,180093.331,366390.397],[\"10/664/238\",179593.331,366390.397,180093.331,366890.397],[\"10/666/238\",180093.331,366390.397,180593.331,366890.397],[\"9/668/236\",180593.331,365890.397,181593.331,366890.397],[\"10/666/236\",180093.331,365890.397,180593.331,366390.397],[\"9/664/232\",179593.331,364890.397,180593.331,365890.397],[\"9/668/232\",180593.331,364890.397,181593.331,365890.397],[\"9/660/228\",178593.331,363890.397,179593.331,364890.397],[\"9/660/224\",178593.331,362890.397,179593.331,363890.397],[\"9/660/220\",178593.331,361890.397,179593.331,362890.397],[\"8/664/224\",179593.331,362890.397,181593.331,364890.397],[\"7/672/224\",181593.331,362890.397,185593.331,366890.397],[\"7/688/224\",185593.331,362890.397,189593.331,366890.397],[\"7/688/208\",185593.331,358890.397,189593.331,362890.397],[\"9/704/216\",189593.331,360890.397,190593.331,361890.397],[\"9/708/216\",190593.331,360890.397,191593.331,361890.397],[\"8/704/208\",189593.331,358890.397,191593.331,360890.397],[\"8/704/200\",189593.331,356890.397,191593.331,358890.397],[\"8/712/200\",191593.331,356890.397,193593.331,358890.397],[\"8/712/208\",191593.331,358890.397,193593.331,360890.397],[\"8/712/216\",191593.331,360890.397,193593.331,362890.397],[\"8/712/224\",191593.331,362890.397,193593.331,364890.397],[\"9/708/220\",190593.331,361890.397,191593.331,362890.397],[\"9/704/220\",189593.331,361890.397,190593.331,362890.397],[\"8/704/224\",189593.331,362890.397,191593.331,364890.397],[\"8/704/232\",189593.331,364890.397,191593.331,366890.397],[\"8/712/232\",191593.331,364890.397,193593.331,366890.397],[\"7/704/240\",189593.331,366890.397,193593.331,370890.397],[\"8/704/256\",189593.331,370890.397,191593.331,372890.397],[\"8/712/256\",191593.331,370890.397,193593.331,372890.397],[\"8/712/264\",191593.331,372890.397,193593.331,374890.397],[\"7/704/272\",189593.331,374890.397,193593.331,378890.397],[\"8/704/264\",189593.331,372890.397,191593.331,374890.397],[\"7/688/256\",185593.331,370890.397,189593.331,374890.397],[\"7/688/272\",185593.331,374890.397,189593.331,378890.397],[\"8/680/248\",183593.331,368890.397,185593.331,370890.397],[\"7/688/240\",185593.331,366890.397,189593.331,370890.397],[\"8/680/240\",183593.331,366890.397,185593.331,368890.397],[\"8/672/240\",181593.331,366890.397,183593.331,368890.397],[\"8/672/248\",181593.331,368890.397,183593.331,370890.397],[\"7/656/240\",177593.331,366890.397,181593.331,370890.397],[\"7/640/240\",173593.331,366890.397,177593.331,370890.397],[\"7/640/256\",173593.331,370890.397,177593.331,374890.397],[\"8/640/272\",173593.331,374890.397,175593.331,376890.397],[\"8/648/272\",175593.331,374890.397,177593.331,376890.397],[\"8/656/272\",177593.331,374890.397,179593.331,376890.397],[\"8/664/272\",179593.331,374890.397,181593.331,376890.397],[\"7/656/256\",177593.331,370890.397,181593.331,374890.397],[\"7/672/256\",181593.331,370890.397,185593.331,374890.397],[\"7/672/272\",181593.331,374890.397,185593.331,378890.397],[\"7/672/288\",181593.331,378890.397,185593.331,382890.397],[\"10/666/290\",180093.331,379390.397,180593.331,379890.397],[\"9/664/292\",179593.331,379890.397,180593.331,380890.397],[\"9/668/292\",180593.331,379890.397,181593.331,380890.397],[\"8/664/296\",179593.331,380890.397,181593.331,382890.397],[\"10/664/290\",179593.331,379390.397,180093.331,379890.397],[\"9/660/284\",178593.331,377890.397,179593.331,378890.397],[\"10/664/288\",179593.331,378890.397,180093.331,379390.397],[\"10/666/288\",180093.331,378890.397,180593.331,379390.397],[\"9/668/288\",180593.331,378890.397,181593.331,379890.397],[\"8/664/280\",179593.331,376890.397,181593.331,378890.397],[\"9/660/280\",178593.331,376890.397,179593.331,377890.397],[\"9/656/280\",177593.331,376890.397,178593.331,377890.397],[\"9/656/284\",177593.331,377890.397,178593.331,378890.397],[\"8/648/280\",175593.331,376890.397,177593.331,378890.397],[\"8/640/280\",173593.331,376890.397,175593.331,378890.397],[\"7/640/288\",173593.331,378890.397,177593.331,382890.397],[\"8/656/288\",177593.331,378890.397,179593.331,380890.397],[\"8/656/296\",177593.331,380890.397,179593.331,382890.397],[\"8/648/304\",175593.331,382890.397,177593.331,384890.397],[\"8/640/304\",173593.331,382890.397,175593.331,384890.397],[\"9/648/312\",175593.331,384890.397,176593.331,385890.397],[\"8/640/312\",173593.331,384890.397,175593.331,386890.397],[\"9/648/316\",175593.331,385890.397,176593.331,386890.397],[\"9/652/316\",176593.331,385890.397,177593.331,386890.397],[\"9/652/312\",176593.331,384890.397,177593.331,385890.397],[\"7/656/304\",177593.331,382890.397,181593.331,386890.397],[\"8/672/304\",181593.331,382890.397,183593.331,384890.397],[\"9/676/312\",182593.331,384890.397,183593.331,385890.397],[\"9/672/312\",181593.331,384890.397,182593.331,385890.397],[\"9/672/316\",181593.331,385890.397,182593.331,386890.397],[\"9/676/316\",182593.331,385890.397,183593.331,386890.397],[\"10/680/318\",183593.331,386390.397,184093.331,386890.397],[\"10/682/318\",184093.331,386390.397,184593.331,386890.397],[\"10/682/316\",184093.331,385890.397,184593.331,386390.397],[\"10/680/316\",183593.331,385890.397,184093.331,386390.397],[\"9/680/312\",183593.331,384890.397,184593.331,385890.397],[\"9/684/312\",184593.331,384890.397,185593.331,385890.397],[\"9/684/316\",184593.331,385890.397,185593.331,386890.397],[\"7/688/304\",185593.331,382890.397,189593.331,386890.397],[\"8/680/304\",183593.331,382890.397,185593.331,384890.397],[\"7/688/288\",185593.331,378890.397,189593.331,382890.397],[\"7/704/288\",189593.331,378890.397,193593.331,382890.397],[\"7/704/304\",189593.331,382890.397,193593.331,386890.397],[\"8/720/312\",193593.331,384890.397,195593.331,386890.397],[\"8/720/304\",193593.331,382890.397,195593.331,384890.397],[\"8/728/304\",195593.331,382890.397,197593.331,384890.397],[\"8/736/304\",197593.331,382890.397,199593.331,384890.397],[\"8/728/312\",195593.331,384890.397,197593.331,386890.397],[\"8/736/312\",197593.331,384890.397,199593.331,386890.397],[\"9/744/312\",199593.331,384890.397,200593.331,385890.397],[\"9/748/312\",200593.331,384890.397,201593.331,385890.397],[\"9/744/316\",199593.331,385890.397,200593.331,386890.397],[\"9/748/316\",200593.331,385890.397,201593.331,386890.397],[\"8/752/312\",201593.331,384890.397,203593.331,386890.397],[\"8/752/304\",201593.331,382890.397,203593.331,384890.397],[\"9/748/304\",200593.331,382890.397,201593.331,383890.397],[\"9/748/308\",200593.331,383890.397,201593.331,384890.397],[\"9/744/308\",199593.331,383890.397,200593.331,384890.397],[\"9/744/304\",199593.331,382890.397,200593.331,383890.397],[\"9/744/292\",199593.331,379890.397,200593.331,380890.397],[\"9/748/292\",200593.331,379890.397,201593.331,380890.397],[\"8/744/296\",199593.331,380890.397,201593.331,382890.397],[\"7/752/288\",201593.331,378890.397,205593.331,382890.397],[\"9/748/288\",200593.331,378890.397,201593.331,379890.397],[\"9/744/288\",199593.331,378890.397,200593.331,379890.397],[\"8/736/288\",197593.331,378890.397,199593.331,380890.397],[\"8/736/296\",197593.331,380890.397,199593.331,382890.397],[\"7/720/288\",193593.331,378890.397,197593.331,382890.397],[\"7/720/272\",193593.331,374890.397,197593.331,378890.397],[\"8/728/264\",195593.331,372890.397,197593.331,374890.397],[\"8/736/264\",197593.331,372890.397,199593.331,374890.397],[\"9/732/260\",196593.331,371890.397,197593.331,372890.397],[\"9/728/260\",195593.331,371890.397,196593.331,372890.397],[\"8/720/264\",193593.331,372890.397,195593.331,374890.397],[\"8/720/256\",193593.331,370890.397,195593.331,372890.397],[\"9/728/256\",195593.331,370890.397,196593.331,371890.397],[\"9/728/252\",195593.331,369890.397,196593.331,370890.397],[\"8/720/248\",193593.331,368890.397,195593.331,370890.397],[\"8/720/240\",193593.331,366890.397,195593.331,368890.397],[\"9/728/248\",195593.331,368890.397,196593.331,369890.397],[\"9/732/248\",196593.331,368890.397,197593.331,369890.397],[\"8/728/240\",195593.331,366890.397,197593.331,368890.397],[\"8/736/240\",197593.331,366890.397,199593.331,368890.397],[\"8/736/248\",197593.331,368890.397,199593.331,370890.397],[\"9/732/252\",196593.331,369890.397,197593.331,370890.397],[\"9/732/256\",196593.331,370890.397,197593.331,371890.397],[\"8/736/256\",197593.331,370890.397,199593.331,372890.397],[\"8/744/256\",199593.331,370890.397,201593.331,372890.397],[\"8/744/248\",199593.331,368890.397,201593.331,370890.397],[\"8/744/240\",199593.331,366890.397,201593.331,368890.397],[\"8/752/240\",201593.331,366890.397,203593.331,368890.397],[\"8/752/248\",201593.331,368890.397,203593.331,370890.397],[\"8/752/256\",201593.331,370890.397,203593.331,372890.397],[\"8/752/264\",201593.331,372890.397,203593.331,374890.397],[\"8/744/264\",199593.331,372890.397,201593.331,374890.397],[\"7/736/272\",197593.331,374890.397,201593.331,378890.397],[\"7/752/272\",201593.331,374890.397,205593.331,378890.397],[\"9/768/272\",205593.331,374890.397,206593.331,375890.397],[\"9/768/276\",205593.331,375890.397,206593.331,376890.397],[\"9/772/276\",206593.331,375890.397,207593.331,376890.397],[\"9/776/276\",207593.331,375890.397,208593.331,376890.397],[\"9/776/272\",207593.331,374890.397,208593.331,375890.397],[\"9/772/272\",206593.331,374890.397,207593.331,375890.397],[\"9/772/264\",206593.331,372890.397,207593.331,373890.397],[\"9/772/268\",206593.331,373890.397,207593.331,374890.397],[\"9/776/268\",207593.331,373890.397,208593.331,374890.397],[\"9/776/264\",207593.331,372890.397,208593.331,373890.397],[\"9/776/260\",207593.331,371890.397,208593.331,372890.397],[\"9/772/260\",206593.331,371890.397,207593.331,372890.397],[\"9/768/260\",205593.331,371890.397,206593.331,372890.397],[\"9/768/264\",205593.331,372890.397,206593.331,373890.397],[\"9/768/268\",205593.331,373890.397,206593.331,374890.397],[\"8/760/264\",203593.331,372890.397,205593.331,374890.397],[\"8/760/256\",203593.331,370890.397,205593.331,372890.397],[\"9/768/256\",205593.331,370890.397,206593.331,371890.397],[\"8/760/248\",203593.331,368890.397,205593.331,370890.397],[\"8/760/240\",203593.331,366890.397,205593.331,368890.397],[\"8/768/240\",205593.331,366890.397,207593.331,368890.397],[\"8/776/240\",207593.331,366890.397,209593.331,368890.397],[\"8/776/248\",207593.331,368890.397,209593.331,370890.397],[\"8/768/248\",205593.331,368890.397,207593.331,370890.397],[\"9/772/256\",206593.331,370890.397,207593.331,371890.397],[\"9/776/256\",207593.331,370890.397,208593.331,371890.397],[\"9/780/256\",208593.331,370890.397,209593.331,371890.397],[\"8/784/256\",209593.331,370890.397,211593.331,372890.397],[\"8/792/264\",211593.331,372890.397,213593.331,374890.397],[\"9/780/260\",208593.331,371890.397,209593.331,372890.397],[\"9/780/264\",208593.331,372890.397,209593.331,373890.397],[\"9/780/268\",208593.331,373890.397,209593.331,374890.397],[\"9/784/268\",209593.331,373890.397,210593.331,374890.397],[\"9/784/264\",209593.331,372890.397,210593.331,373890.397],[\"9/788/264\",210593.331,372890.397,211593.331,373890.397],[\"9/788/268\",210593.331,373890.397,211593.331,374890.397],[\"9/788/272\",210593.331,374890.397,211593.331,375890.397],[\"10/786/272\",210093.331,374890.397,210593.331,375390.397],[\"10/786/274\",210093.331,375390.397,210593.331,375890.397],[\"9/780/272\",208593.331,374890.397,209593.331,375890.397],[\"10/784/272\",209593.331,374890.397,210093.331,375390.397],[\"10/784/274\",209593.331,375390.397,210093.331,375890.397],[\"9/780/276\",208593.331,375890.397,209593.331,376890.397],[\"9/784/276\",209593.331,375890.397,210593.331,376890.397],[\"9/788/276\",210593.331,375890.397,211593.331,376890.397],[\"8/792/272\",211593.331,374890.397,213593.331,376890.397],[\"8/792/280\",211593.331,376890.397,213593.331,378890.397],[\"7/784/288\",209593.331,378890.397,213593.331,382890.397],[\"9/788/284\",210593.331,377890.397,211593.331,378890.397],[\"9/784/284\",209593.331,377890.397,210593.331,378890.397],[\"9/788/280\",210593.331,376890.397,211593.331,377890.397],[\"9/784/280\",209593.331,376890.397,210593.331,377890.397],[\"8/776/280\",207593.331,376890.397,209593.331,378890.397],[\"8/768/280\",205593.331,376890.397,207593.331,378890.397],[\"8/768/296\",205593.331,380890.397,207593.331,382890.397],[\"8/768/288\",205593.331,378890.397,207593.331,380890.397],[\"8/776/288\",207593.331,378890.397,209593.331,380890.397],[\"8/776/296\",207593.331,380890.397,209593.331,382890.397],[\"8/760/304\",203593.331,382890.397,205593.331,384890.397],[\"8/760/312\",203593.331,384890.397,205593.331,386890.397],[\"7/768/304\",205593.331,382890.397,209593.331,386890.397],[\"7/784/304\",209593.331,382890.397,213593.331,386890.397],[\"8/792/320\",211593.331,386890.397,213593.331,388890.397],[\"8/792/328\",211593.331,388890.397,213593.331,390890.397],[\"8/784/328\",209593.331,388890.397,211593.331,390890.397],[\"8/784/320\",209593.331,386890.397,211593.331,388890.397],[\"7/768/320\",205593.331,386890.397,209593.331,390890.397],[\"8/760/336\",203593.331,390890.397,205593.331,392890.397],[\"7/768/336\",205593.331,390890.397,209593.331,394890.397],[\"8/760/344\",203593.331,392890.397,205593.331,394890.397],[\"7/784/336\",209593.331,390890.397,213593.331,394890.397],[\"6/768/352\",205593.331,394890.397,213593.331,402890.397],[\"8/744/368\",199593.331,398890.397,201593.331,400890.397],[\"9/744/376\",199593.331,400890.397,200593.331,401890.397],[\"9/748/376\",200593.331,400890.397,201593.331,401890.397],[\"7/752/368\",201593.331,398890.397,205593.331,402890.397],[\"7/752/384\",201593.331,402890.397,205593.331,406890.397],[\"7/736/384\",197593.331,402890.397,201593.331,406890.397],[\"9/748/380\",200593.331,401890.397,201593.331,402890.397],[\"9/744/380\",199593.331,401890.397,200593.331,402890.397],[\"8/728/384\",195593.331,402890.397,197593.331,404890.397],[\"8/728/392\",195593.331,404890.397,197593.331,406890.397],[\"9/724/392\",194593.331,404890.397,195593.331,405890.397],[\"9/724/396\",194593.331,405890.397,195593.331,406890.397],[\"9/720/396\",193593.331,405890.397,194593.331,406890.397],[\"9/720/392\",193593.331,404890.397,194593.331,405890.397],[\"8/720/384\",193593.331,402890.397,195593.331,404890.397],[\"7/720/368\",193593.331,398890.397,197593.331,402890.397],[\"8/736/376\",197593.331,400890.397,199593.331,402890.397],[\"8/736/368\",197593.331,398890.397,199593.331,400890.397],[\"7/720/352\",193593.331,394890.397,197593.331,398890.397],[\"9/720/348\",193593.331,393890.397,194593.331,394890.397],[\"9/720/344\",193593.331,392890.397,194593.331,393890.397],[\"9/728/340\",195593.331,391890.397,196593.331,392890.397],[\"9/728/344\",195593.331,392890.397,196593.331,393890.397],[\"9/724/344\",194593.331,392890.397,195593.331,393890.397],[\"9/724/348\",194593.331,393890.397,195593.331,394890.397],[\"9/728/348\",195593.331,393890.397,196593.331,394890.397],[\"9/732/348\",196593.331,393890.397,197593.331,394890.397],[\"9/732/344\",196593.331,392890.397,197593.331,393890.397],[\"9/732/340\",196593.331,391890.397,197593.331,392890.397],[\"7/736/352\",197593.331,394890.397,201593.331,398890.397],[\"7/752/352\",201593.331,394890.397,205593.331,398890.397],[\"8/752/344\",201593.331,392890.397,203593.331,394890.397],[\"7/736/336\",197593.331,390890.397,201593.331,394890.397],[\"8/752/336\",201593.331,390890.397,203593.331,392890.397],[\"7/752/320\",201593.331,386890.397,205593.331,390890.397],[\"7/736/320\",197593.331,386890.397,201593.331,390890.397],[\"9/732/336\",196593.331,390890.397,197593.331,391890.397],[\"9/728/336\",195593.331,390890.397,196593.331,391890.397],[\"8/720/336\",193593.331,390890.397,195593.331,392890.397],[\"7/720/320\",193593.331,386890.397,197593.331,390890.397],[\"7/704/320\",189593.331,386890.397,193593.331,390890.397],[\"7/704/336\",189593.331,390890.397,193593.331,394890.397],[\"7/704/352\",189593.331,394890.397,193593.331,398890.397],[\"7/688/336\",185593.331,390890.397,189593.331,394890.397],[\"7/688/352\",185593.331,394890.397,189593.331,398890.397],[\"8/680/328\",183593.331,388890.397,185593.331,390890.397],[\"7/688/320\",185593.331,386890.397,189593.331,390890.397],[\"8/680/320\",183593.331,386890.397,185593.331,388890.397],[\"8/672/320\",181593.331,386890.397,183593.331,388890.397],[\"8/672/328\",181593.331,388890.397,183593.331,390890.397],[\"8/664/328\",179593.331,388890.397,181593.331,390890.397],[\"8/664/320\",179593.331,386890.397,181593.331,388890.397],[\"8/656/320\",177593.331,386890.397,179593.331,388890.397],[\"9/652/324\",176593.331,387890.397,177593.331,388890.397],[\"9/652/328\",176593.331,388890.397,177593.331,389890.397],[\"9/652/320\",176593.331,386890.397,177593.331,387890.397],[\"9/648/320\",175593.331,386890.397,176593.331,387890.397],[\"9/644/320\",174593.331,386890.397,175593.331,387890.397],[\"9/640/320\",173593.331,386890.397,174593.331,387890.397],[\"10/640/324\",173593.331,387890.397,174093.331,388390.397],[\"10/642/324\",174093.331,387890.397,174593.331,388390.397],[\"10/642/326\",174093.331,388390.397,174593.331,388890.397],[\"10/640/326\",173593.331,388390.397,174093.331,388890.397],[\"9/640/328\",173593.331,388890.397,174593.331,389890.397],[\"9/644/328\",174593.331,388890.397,175593.331,389890.397],[\"9/644/324\",174593.331,387890.397,175593.331,388890.397],[\"9/648/324\",175593.331,387890.397,176593.331,388890.397],[\"9/648/328\",175593.331,388890.397,176593.331,389890.397],[\"9/648/332\",175593.331,389890.397,176593.331,390890.397],[\"9/644/332\",174593.331,389890.397,175593.331,390890.397],[\"9/640/332\",173593.331,389890.397,174593.331,390890.397],[\"9/652/332\",176593.331,389890.397,177593.331,390890.397],[\"8/656/328\",177593.331,388890.397,179593.331,390890.397],[\"7/640/336\",173593.331,390890.397,177593.331,394890.397],[\"9/648/352\",175593.331,394890.397,176593.331,395890.397],[\"8/640/352\",173593.331,394890.397,175593.331,396890.397],[\"10/648/356\",175593.331,395890.397,176093.331,396390.397],[\"10/648/358\",175593.331,396390.397,176093.331,396890.397],[\"10/650/358\",176093.331,396390.397,176593.331,396890.397],[\"9/652/356\",176593.331,395890.397,177593.331,396890.397],[\"10/650/356\",176093.331,395890.397,176593.331,396390.397],[\"9/652/352\",176593.331,394890.397,177593.331,395890.397],[\"7/656/352\",177593.331,394890.397,181593.331,398890.397],[\"7/656/336\",177593.331,390890.397,181593.331,394890.397],[\"7/672/336\",181593.331,390890.397,185593.331,394890.397],[\"7/672/352\",181593.331,394890.397,185593.331,398890.397],[\"7/672/368\",181593.331,398890.397,185593.331,402890.397],[\"7/656/368\",177593.331,398890.397,181593.331,402890.397],[\"9/652/364\",176593.331,397890.397,177593.331,398890.397],[\"9/652/360\",176593.331,396890.397,177593.331,397890.397],[\"9/648/360\",175593.331,396890.397,176593.331,397890.397],[\"8/640/360\",173593.331,396890.397,175593.331,398890.397],[\"9/648/364\",175593.331,397890.397,176593.331,398890.397],[\"8/640/368\",173593.331,398890.397,175593.331,400890.397],[\"9/640/376\",173593.331,400890.397,174593.331,401890.397],[\"9/644/376\",174593.331,400890.397,175593.331,401890.397],[\"8/648/376\",175593.331,400890.397,177593.331,402890.397],[\"8/648/368\",175593.331,398890.397,177593.331,400890.397],[\"8/648/384\",175593.331,402890.397,177593.331,404890.397],[\"9/644/380\",174593.331,401890.397,175593.331,402890.397],[\"9/640/380\",173593.331,401890.397,174593.331,402890.397],[\"8/640/384\",173593.331,402890.397,175593.331,404890.397],[\"8/640/392\",173593.331,404890.397,175593.331,406890.397],[\"8/648/392\",175593.331,404890.397,177593.331,406890.397],[\"7/656/384\",177593.331,402890.397,181593.331,406890.397],[\"7/672/384\",181593.331,402890.397,185593.331,406890.397],[\"8/688/392\",185593.331,404890.397,187593.331,406890.397],[\"8/696/392\",187593.331,404890.397,189593.331,406890.397],[\"8/688/384\",185593.331,402890.397,187593.331,404890.397],[\"8/696/384\",187593.331,402890.397,189593.331,404890.397],[\"7/688/368\",185593.331,398890.397,189593.331,402890.397],[\"7/704/368\",189593.331,398890.397,193593.331,402890.397],[\"7/704/384\",189593.331,402890.397,193593.331,406890.397],[\"8/712/400\",191593.331,406890.397,193593.331,408890.397],[\"8/704/400\",189593.331,406890.397,191593.331,408890.397],[\"8/704/408\",189593.331,408890.397,191593.331,410890.397],[\"8/704/416\",189593.331,410890.397,191593.331,412890.397],[\"8/712/408\",191593.331,408890.397,193593.331,410890.397],[\"8/712/416\",191593.331,410890.397,193593.331,412890.397],[\"8/712/424\",191593.331,412890.397,193593.331,414890.397],[\"7/704/432\",189593.331,414890.397,193593.331,418890.397],[\"9/700/436\",188593.331,415890.397,189593.331,416890.397],[\"9/700/432\",188593.331,414890.397,189593.331,415890.397],[\"8/704/424\",189593.331,412890.397,191593.331,414890.397],[\"8/688/424\",185593.331,412890.397,187593.331,414890.397],[\"8/696/424\",187593.331,412890.397,189593.331,414890.397],[\"9/696/432\",187593.331,414890.397,188593.331,415890.397],[\"9/696/436\",187593.331,415890.397,188593.331,416890.397],[\"8/688/432\",185593.331,414890.397,187593.331,416890.397],[\"8/680/408\",183593.331,408890.397,185593.331,410890.397],[\"8/688/416\",185593.331,410890.397,187593.331,412890.397],[\"8/696/416\",187593.331,410890.397,189593.331,412890.397],[\"7/688/400\",185593.331,406890.397,189593.331,410890.397],[\"8/680/400\",183593.331,406890.397,185593.331,408890.397],[\"8/672/400\",181593.331,406890.397,183593.331,408890.397],[\"8/672/408\",181593.331,408890.397,183593.331,410890.397],[\"8/664/416\",179593.331,410890.397,181593.331,412890.397],[\"7/656/400\",177593.331,406890.397,181593.331,410890.397],[\"7/640/400\",173593.331,406890.397,177593.331,410890.397],[\"9/640/416\",173593.331,410890.397,174593.331,411890.397],[\"9/644/416\",174593.331,410890.397,175593.331,411890.397],[\"8/648/416\",175593.331,410890.397,177593.331,412890.397],[\"8/656/416\",177593.331,410890.397,179593.331,412890.397],[\"8/656/424\",177593.331,412890.397,179593.331,414890.397],[\"8/648/424\",175593.331,412890.397,177593.331,414890.397],[\"9/644/420\",174593.331,411890.397,175593.331,412890.397],[\"9/640/420\",173593.331,411890.397,174593.331,412890.397],[\"8/640/424\",173593.331,412890.397,175593.331,414890.397],[\"7/640/432\",173593.331,414890.397,177593.331,418890.397],[\"8/656/432\",177593.331,414890.397,179593.331,416890.397],[\"8/664/432\",179593.331,414890.397,181593.331,416890.397],[\"8/664/424\",179593.331,412890.397,181593.331,414890.397],[\"7/672/416\",181593.331,410890.397,185593.331,414890.397],[\"7/672/432\",181593.331,414890.397,185593.331,418890.397],[\"7/672/448\",181593.331,418890.397,185593.331,422890.397],[\"8/664/448\",179593.331,418890.397,181593.331,420890.397],[\"8/664/456\",179593.331,420890.397,181593.331,422890.397],[\"8/664/440\",179593.331,416890.397,181593.331,418890.397],[\"8/656/440\",177593.331,416890.397,179593.331,418890.397],[\"7/640/448\",173593.331,418890.397,177593.331,422890.397],[\"8/656/448\",177593.331,418890.397,179593.331,420890.397],[\"8/656/456\",177593.331,420890.397,179593.331,422890.397],[\"9/656/464\",177593.331,422890.397,178593.331,423890.397],[\"9/656/468\",177593.331,423890.397,178593.331,424890.397],[\"8/648/464\",175593.331,422890.397,177593.331,424890.397],[\"8/640/464\",173593.331,422890.397,175593.331,424890.397],[\"8/640/472\",173593.331,424890.397,175593.331,426890.397],[\"8/648/472\",175593.331,424890.397,177593.331,426890.397],[\"9/656/472\",177593.331,424890.397,178593.331,425890.397],[\"9/656/476\",177593.331,425890.397,178593.331,426890.397],[\"9/660/476\",178593.331,425890.397,179593.331,426890.397],[\"8/664/472\",179593.331,424890.397,181593.331,426890.397],[\"9/660/472\",178593.331,424890.397,179593.331,425890.397],[\"9/660/468\",178593.331,423890.397,179593.331,424890.397],[\"9/660/464\",178593.331,422890.397,179593.331,423890.397],[\"8/664/464\",179593.331,422890.397,181593.331,424890.397],[\"8/672/464\",181593.331,422890.397,183593.331,424890.397],[\"9/676/472\",182593.331,424890.397,183593.331,425890.397],[\"9/672/472\",181593.331,424890.397,182593.331,425890.397],[\"9/672/476\",181593.331,425890.397,182593.331,426890.397],[\"9/676/476\",182593.331,425890.397,183593.331,426890.397],[\"9/680/476\",183593.331,425890.397,184593.331,426890.397],[\"9/680/472\",183593.331,424890.397,184593.331,425890.397],[\"9/684/472\",184593.331,424890.397,185593.331,425890.397],[\"9/688/472\",185593.331,424890.397,186593.331,425890.397],[\"9/684/476\",184593.331,425890.397,185593.331,426890.397],[\"9/688/476\",185593.331,425890.397,186593.331,426890.397],[\"10/692/476\",186593.331,425890.397,187093.331,426390.397],[\"10/694/476\",187093.331,425890.397,187593.331,426390.397],[\"10/692/478\",186593.331,426390.397,187093.331,426890.397],[\"10/694/478\",187093.331,426390.397,187593.331,426890.397],[\"9/696/476\",187593.331,425890.397,188593.331,426890.397],[\"9/696/472\",187593.331,424890.397,188593.331,425890.397],[\"9/692/472\",186593.331,424890.397,187593.331,425890.397],[\"8/688/464\",185593.331,422890.397,187593.331,424890.397],[\"8/696/464\",187593.331,422890.397,189593.331,424890.397],[\"9/692/460\",186593.331,421890.397,187593.331,422890.397],[\"9/688/460\",185593.331,421890.397,186593.331,422890.397],[\"9/684/468\",184593.331,423890.397,185593.331,424890.397],[\"9/684/464\",184593.331,422890.397,185593.331,423890.397],[\"9/680/468\",183593.331,423890.397,184593.331,424890.397],[\"9/680/464\",183593.331,422890.397,184593.331,423890.397],[\"9/688/456\",185593.331,420890.397,186593.331,421890.397],[\"8/688/440\",185593.331,416890.397,187593.331,418890.397],[\"9/696/440\",187593.331,416890.397,188593.331,417890.397],[\"9/696/444\",187593.331,417890.397,188593.331,418890.397],[\"9/696/448\",187593.331,418890.397,188593.331,419890.397],[\"9/696/452\",187593.331,419890.397,188593.331,420890.397],[\"8/688/448\",185593.331,418890.397,187593.331,420890.397],[\"9/692/456\",186593.331,420890.397,187593.331,421890.397],[\"8/696/456\",187593.331,420890.397,189593.331,422890.397],[\"8/704/456\",189593.331,420890.397,191593.331,422890.397],[\"8/704/448\",189593.331,418890.397,191593.331,420890.397],[\"9/700/452\",188593.331,419890.397,189593.331,420890.397],[\"9/700/448\",188593.331,418890.397,189593.331,419890.397],[\"9/700/444\",188593.331,417890.397,189593.331,418890.397],[\"9/700/440\",188593.331,416890.397,189593.331,417890.397],[\"9/712/448\",191593.331,418890.397,192593.331,419890.397],[\"9/716/448\",192593.331,418890.397,193593.331,419890.397],[\"9/716/452\",192593.331,419890.397,193593.331,420890.397],[\"9/712/452\",191593.331,419890.397,192593.331,420890.397],[\"9/712/456\",191593.331,420890.397,192593.331,421890.397],[\"9/716/456\",192593.331,420890.397,193593.331,421890.397],[\"9/716/460\",192593.331,421890.397,193593.331,422890.397],[\"8/712/464\",191593.331,422890.397,193593.331,424890.397],[\"9/712/460\",191593.331,421890.397,192593.331,422890.397],[\"8/704/464\",189593.331,422890.397,191593.331,424890.397],[\"9/700/472\",188593.331,424890.397,189593.331,425890.397],[\"9/700/476\",188593.331,425890.397,189593.331,426890.397],[\"8/704/472\",189593.331,424890.397,191593.331,426890.397],[\"8/712/472\",191593.331,424890.397,193593.331,426890.397],[\"7/720/464\",193593.331,422890.397,197593.331,426890.397],[\"7/720/448\",193593.331,418890.397,197593.331,422890.397],[\"7/720/432\",193593.331,414890.397,197593.331,418890.397],[\"8/728/424\",195593.331,412890.397,197593.331,414890.397],[\"9/732/420\",196593.331,411890.397,197593.331,412890.397],[\"9/728/420\",195593.331,411890.397,196593.331,412890.397],[\"8/720/424\",193593.331,412890.397,195593.331,414890.397],[\"8/720/416\",193593.331,410890.397,195593.331,412890.397],[\"9/728/416\",195593.331,410890.397,196593.331,411890.397],[\"8/720/408\",193593.331,408890.397,195593.331,410890.397],[\"8/720/400\",193593.331,406890.397,195593.331,408890.397],[\"8/728/400\",195593.331,406890.397,197593.331,408890.397],[\"8/728/408\",195593.331,408890.397,197593.331,410890.397],[\"9/732/416\",196593.331,410890.397,197593.331,411890.397],[\"7/736/400\",197593.331,406890.397,201593.331,410890.397],[\"7/752/400\",201593.331,406890.397,205593.331,410890.397],[\"6/736/416\",197593.331,410890.397,205593.331,418890.397],[\"6/768/480\",205593.331,426890.397,213593.331,434890.397],[\"9/760/488\",203593.331,428890.397,204593.331,429890.397],[\"9/764/488\",204593.331,428890.397,205593.331,429890.397],[\"9/764/492\",204593.331,429890.397,205593.331,430890.397],[\"9/760/492\",203593.331,429890.397,204593.331,430890.397],[\"8/760/512\",203593.331,434890.397,205593.331,436890.397],[\"8/768/512\",205593.331,434890.397,207593.331,436890.397],[\"8/776/512\",207593.331,434890.397,209593.331,436890.397],[\"7/784/512\",209593.331,434890.397,213593.331,438890.397],[\"8/784/528\",209593.331,438890.397,211593.331,440890.397],[\"8/784/536\",209593.331,440890.397,211593.331,442890.397],[\"8/792/528\",211593.331,438890.397,213593.331,440890.397],[\"8/792/536\",211593.331,440890.397,213593.331,442890.397],[\"7/784/544\",209593.331,442890.397,213593.331,446890.397],[\"8/768/544\",205593.331,442890.397,207593.331,444890.397],[\"8/776/544\",207593.331,442890.397,209593.331,444890.397],[\"8/776/552\",207593.331,444890.397,209593.331,446890.397],[\"9/772/556\",206593.331,445890.397,207593.331,446890.397],[\"9/772/552\",206593.331,444890.397,207593.331,445890.397],[\"9/768/552\",205593.331,444890.397,206593.331,445890.397],[\"9/768/556\",205593.331,445890.397,206593.331,446890.397],[\"9/768/532\",205593.331,439890.397,206593.331,440890.397],[\"8/768/536\",205593.331,440890.397,207593.331,442890.397],[\"8/776/536\",207593.331,440890.397,209593.331,442890.397],[\"8/776/528\",207593.331,438890.397,209593.331,440890.397],[\"9/772/532\",206593.331,439890.397,207593.331,440890.397],[\"9/772/528\",206593.331,438890.397,207593.331,439890.397],[\"8/776/520\",207593.331,436890.397,209593.331,438890.397],[\"8/768/520\",205593.331,436890.397,207593.331,438890.397],[\"9/768/528\",205593.331,438890.397,206593.331,439890.397],[\"8/760/520\",203593.331,436890.397,205593.331,438890.397],[\"9/756/520\",202593.331,436890.397,203593.331,437890.397],[\"9/756/524\",202593.331,437890.397,203593.331,438890.397],[\"10/752/526\",201593.331,438390.397,202093.331,438890.397],[\"10/754/526\",202093.331,438390.397,202593.331,438890.397],[\"10/752/524\",201593.331,437890.397,202093.331,438390.397],[\"10/754/524\",202093.331,437890.397,202593.331,438390.397],[\"9/752/520\",201593.331,436890.397,202593.331,437890.397],[\"9/748/520\",200593.331,436890.397,201593.331,437890.397],[\"9/744/520\",199593.331,436890.397,200593.331,437890.397],[\"9/740/528\",198593.331,438890.397,199593.331,439890.397],[\"9/744/524\",199593.331,437890.397,200593.331,438890.397],[\"9/748/524\",200593.331,437890.397,201593.331,438890.397],[\"8/744/528\",199593.331,438890.397,201593.331,440890.397],[\"9/740/532\",198593.331,439890.397,199593.331,440890.397],[\"8/744/536\",199593.331,440890.397,201593.331,442890.397],[\"7/752/528\",201593.331,438890.397,205593.331,442890.397],[\"7/752/544\",201593.331,442890.397,205593.331,446890.397],[\"8/744/552\",199593.331,444890.397,201593.331,446890.397],[\"10/742/556\",199093.331,445890.397,199593.331,446390.397],[\"10/742/558\",199093.331,446390.397,199593.331,446890.397],[\"10/740/558\",198593.331,446390.397,199093.331,446890.397],[\"10/740/556\",198593.331,445890.397,199093.331,446390.397],[\"9/740/552\",198593.331,444890.397,199593.331,445890.397],[\"8/744/544\",199593.331,442890.397,201593.331,444890.397],[\"8/728/544\",195593.331,442890.397,197593.331,444890.397],[\"8/736/544\",197593.331,442890.397,199593.331,444890.397],[\"9/736/552\",197593.331,444890.397,198593.331,445890.397],[\"9/736/556\",197593.331,445890.397,198593.331,446890.397],[\"8/728/552\",195593.331,444890.397,197593.331,446890.397],[\"10/726/552\",195093.331,444890.397,195593.331,445390.397],[\"10/726/554\",195093.331,445390.397,195593.331,445890.397],[\"9/724/556\",194593.331,445890.397,195593.331,446890.397],[\"9/720/556\",193593.331,445890.397,194593.331,446890.397],[\"9/720/552\",193593.331,444890.397,194593.331,445890.397],[\"10/724/554\",194593.331,445390.397,195093.331,445890.397],[\"10/724/552\",194593.331,444890.397,195093.331,445390.397],[\"9/720/548\",193593.331,443890.397,194593.331,444890.397],[\"9/720/544\",193593.331,442890.397,194593.331,443890.397],[\"9/724/548\",194593.331,443890.397,195593.331,444890.397],[\"9/724/544\",194593.331,442890.397,195593.331,443890.397],[\"9/724/540\",194593.331,441890.397,195593.331,442890.397],[\"9/720/540\",193593.331,441890.397,194593.331,442890.397],[\"9/720/536\",193593.331,440890.397,194593.331,441890.397],[\"8/720/528\",193593.331,438890.397,195593.331,440890.397],[\"9/728/532\",195593.331,439890.397,196593.331,440890.397],[\"9/724/536\",194593.331,440890.397,195593.331,441890.397],[\"8/728/536\",195593.331,440890.397,197593.331,442890.397],[\"8/736/536\",197593.331,440890.397,199593.331,442890.397],[\"9/736/532\",197593.331,439890.397,198593.331,440890.397],[\"9/732/532\",196593.331,439890.397,197593.331,440890.397],[\"9/732/528\",196593.331,438890.397,197593.331,439890.397],[\"9/736/528\",197593.331,438890.397,198593.331,439890.397],[\"8/736/520\",197593.331,436890.397,199593.331,438890.397],[\"9/728/528\",195593.331,438890.397,196593.331,439890.397],[\"7/720/512\",193593.331,434890.397,197593.331,438890.397],[\"8/720/504\",193593.331,432890.397,195593.331,434890.397],[\"9/720/500\",193593.331,431890.397,194593.331,432890.397],[\"9/724/500\",194593.331,431890.397,195593.331,432890.397],[\"8/728/504\",195593.331,432890.397,197593.331,434890.397],[\"8/736/504\",197593.331,432890.397,199593.331,434890.397],[\"8/736/512\",197593.331,434890.397,199593.331,436890.397],[\"8/744/512\",199593.331,434890.397,201593.331,436890.397],[\"8/752/512\",201593.331,434890.397,203593.331,436890.397],[\"7/752/496\",201593.331,430890.397,205593.331,434890.397],[\"8/744/504\",199593.331,432890.397,201593.331,434890.397],[\"8/744/488\",199593.331,428890.397,201593.331,430890.397],[\"8/744/496\",199593.331,430890.397,201593.331,432890.397],[\"8/752/488\",201593.331,428890.397,203593.331,430890.397],[\"8/744/480\",199593.331,426890.397,201593.331,428890.397],[\"8/736/480\",197593.331,426890.397,199593.331,428890.397],[\"8/736/488\",197593.331,428890.397,199593.331,430890.397],[\"8/736/496\",197593.331,430890.397,199593.331,432890.397],[\"8/728/496\",195593.331,430890.397,197593.331,432890.397],[\"9/724/496\",194593.331,430890.397,195593.331,431890.397],[\"9/720/496\",193593.331,430890.397,194593.331,431890.397],[\"7/720/480\",193593.331,426890.397,197593.331,430890.397],[\"8/712/480\",191593.331,426890.397,193593.331,428890.397],[\"8/704/480\",189593.331,426890.397,191593.331,428890.397],[\"10/702/480\",189093.331,426890.397,189593.331,427390.397],[\"10/700/480\",188593.331,426890.397,189093.331,427390.397],[\"10/700/482\",188593.331,427390.397,189093.331,427890.397],[\"10/702/482\",189093.331,427390.397,189593.331,427890.397],[\"9/700/484\",188593.331,427890.397,189593.331,428890.397],[\"8/704/488\",189593.331,428890.397,191593.331,430890.397],[\"9/700/496\",188593.331,430890.397,189593.331,431890.397],[\"8/704/496\",189593.331,430890.397,191593.331,432890.397],[\"8/712/488\",191593.331,428890.397,193593.331,430890.397],[\"8/712/496\",191593.331,430890.397,193593.331,432890.397],[\"8/712/504\",191593.331,432890.397,193593.331,434890.397],[\"8/712/512\",191593.331,434890.397,193593.331,436890.397],[\"8/704/512\",189593.331,434890.397,191593.331,436890.397],[\"9/704/508\",189593.331,433890.397,190593.331,434890.397],[\"9/708/508\",190593.331,433890.397,191593.331,434890.397],[\"9/708/504\",190593.331,432890.397,191593.331,433890.397],[\"9/704/504\",189593.331,432890.397,190593.331,433890.397],[\"9/700/500\",188593.331,431890.397,189593.331,432890.397],[\"9/696/500\",187593.331,431890.397,188593.331,432890.397],[\"9/692/500\",186593.331,431890.397,187593.331,432890.397],[\"8/688/504\",185593.331,432890.397,187593.331,434890.397],[\"8/696/504\",187593.331,432890.397,189593.331,434890.397],[\"8/696/512\",187593.331,434890.397,189593.331,436890.397],[\"9/692/516\",186593.331,435890.397,187593.331,436890.397],[\"9/692/512\",186593.331,434890.397,187593.331,435890.397],[\"9/688/512\",185593.331,434890.397,186593.331,435890.397],[\"9/688/516\",185593.331,435890.397,186593.331,436890.397],[\"8/680/512\",183593.331,434890.397,185593.331,436890.397],[\"9/688/500\",185593.331,431890.397,186593.331,432890.397],[\"8/680/488\",183593.331,428890.397,185593.331,430890.397],[\"9/688/492\",185593.331,429890.397,186593.331,430890.397],[\"9/688/496\",185593.331,430890.397,186593.331,431890.397],[\"9/692/496\",186593.331,430890.397,187593.331,431890.397],[\"9/696/496\",187593.331,430890.397,188593.331,431890.397],[\"8/696/488\",187593.331,428890.397,189593.331,430890.397],[\"9/692/492\",186593.331,429890.397,187593.331,430890.397],[\"10/690/486\",186093.331,428390.397,186593.331,428890.397],[\"9/692/484\",186593.331,427890.397,187593.331,428890.397],[\"9/692/488\",186593.331,428890.397,187593.331,429890.397],[\"10/698/486\",188093.331,428390.397,188593.331,428890.397],[\"10/696/486\",187593.331,428390.397,188093.331,428890.397],[\"10/696/482\",187593.331,427390.397,188093.331,427890.397],[\"10/696/484\",187593.331,427890.397,188093.331,428390.397],[\"10/698/484\",188093.331,427890.397,188593.331,428390.397],[\"10/698/482\",188093.331,427390.397,188593.331,427890.397],[\"10/698/480\",188093.331,426890.397,188593.331,427390.397],[\"10/696/480\",187593.331,426890.397,188093.331,427390.397],[\"10/694/480\",187093.331,426890.397,187593.331,427390.397],[\"10/692/480\",186593.331,426890.397,187093.331,427390.397],[\"10/694/482\",187093.331,427390.397,187593.331,427890.397],[\"10/692/482\",186593.331,427390.397,187093.331,427890.397],[\"10/690/484\",186093.331,427890.397,186593.331,428390.397],[\"10/690/482\",186093.331,427390.397,186593.331,427890.397],[\"10/690/480\",186093.331,426890.397,186593.331,427390.397],[\"10/688/480\",185593.331,426890.397,186093.331,427390.397],[\"9/684/480\",184593.331,426890.397,185593.331,427890.397],[\"10/688/482\",185593.331,427390.397,186093.331,427890.397],[\"10/688/484\",185593.331,427890.397,186093.331,428390.397],[\"10/688/486\",185593.331,428390.397,186093.331,428890.397],[\"9/688/488\",185593.331,428890.397,186593.331,429890.397],[\"9/684/484\",184593.331,427890.397,185593.331,428890.397],[\"9/680/484\",183593.331,427890.397,184593.331,428890.397],[\"9/680/480\",183593.331,426890.397,184593.331,427890.397],[\"9/676/480\",182593.331,426890.397,183593.331,427890.397],[\"9/672/480\",181593.331,426890.397,182593.331,427890.397],[\"9/672/484\",181593.331,427890.397,182593.331,428890.397],[\"9/676/484\",182593.331,427890.397,183593.331,428890.397],[\"8/672/488\",181593.331,428890.397,183593.331,430890.397],[\"9/664/492\",179593.331,429890.397,180593.331,430890.397],[\"9/668/492\",180593.331,429890.397,181593.331,430890.397],[\"8/664/496\",179593.331,430890.397,181593.331,432890.397],[\"9/664/488\",179593.331,428890.397,180593.331,429890.397],[\"9/668/488\",180593.331,428890.397,181593.331,429890.397],[\"8/664/480\",179593.331,426890.397,181593.331,428890.397],[\"8/656/480\",177593.331,426890.397,179593.331,428890.397],[\"7/640/480\",173593.331,426890.397,177593.331,430890.397],[\"8/640/496\",173593.331,430890.397,175593.331,432890.397],[\"8/648/496\",175593.331,430890.397,177593.331,432890.397],[\"8/656/488\",177593.331,428890.397,179593.331,430890.397],[\"8/656/496\",177593.331,430890.397,179593.331,432890.397],[\"8/656/504\",177593.331,432890.397,179593.331,434890.397],[\"8/648/504\",175593.331,432890.397,177593.331,434890.397],[\"8/640/504\",173593.331,432890.397,175593.331,434890.397],[\"8/640/512\",173593.331,434890.397,175593.331,436890.397],[\"8/648/512\",175593.331,434890.397,177593.331,436890.397],[\"8/656/512\",177593.331,434890.397,179593.331,436890.397],[\"8/664/512\",179593.331,434890.397,181593.331,436890.397],[\"8/664/504\",179593.331,432890.397,181593.331,434890.397],[\"7/672/496\",181593.331,430890.397,185593.331,434890.397],[\"8/672/512\",181593.331,434890.397,183593.331,436890.397],[\"8/672/520\",181593.331,436890.397,183593.331,438890.397],[\"8/672/528\",181593.331,438890.397,183593.331,440890.397],[\"8/672/536\",181593.331,440890.397,183593.331,442890.397],[\"8/664/528\",179593.331,438890.397,181593.331,440890.397],[\"8/664/536\",179593.331,440890.397,181593.331,442890.397],[\"8/664/520\",179593.331,436890.397,181593.331,438890.397],[\"8/656/520\",177593.331,436890.397,179593.331,438890.397],[\"8/648/520\",175593.331,436890.397,177593.331,438890.397],[\"8/640/520\",173593.331,436890.397,175593.331,438890.397],[\"8/640/528\",173593.331,438890.397,175593.331,440890.397],[\"9/640/536\",173593.331,440890.397,174593.331,441890.397],[\"9/644/536\",174593.331,440890.397,175593.331,441890.397],[\"8/648/536\",175593.331,440890.397,177593.331,442890.397],[\"8/648/528\",175593.331,438890.397,177593.331,440890.397],[\"8/656/528\",177593.331,438890.397,179593.331,440890.397],[\"8/656/536\",177593.331,440890.397,179593.331,442890.397],[\"9/656/544\",177593.331,442890.397,178593.331,443890.397],[\"9/656/548\",177593.331,443890.397,178593.331,444890.397],[\"8/648/544\",175593.331,442890.397,177593.331,444890.397],[\"9/644/540\",174593.331,441890.397,175593.331,442890.397],[\"10/642/540\",174093.331,441890.397,174593.331,442390.397],[\"10/640/540\",173593.331,441890.397,174093.331,442390.397],[\"10/640/542\",173593.331,442390.397,174093.331,442890.397],[\"10/642/542\",174093.331,442390.397,174593.331,442890.397],[\"9/640/544\",173593.331,442890.397,174593.331,443890.397],[\"9/640/548\",173593.331,443890.397,174593.331,444890.397],[\"9/644/548\",174593.331,443890.397,175593.331,444890.397],[\"9/644/544\",174593.331,442890.397,175593.331,443890.397],[\"9/644/552\",174593.331,444890.397,175593.331,445890.397],[\"9/640/552\",173593.331,444890.397,174593.331,445890.397],[\"9/640/556\",173593.331,445890.397,174593.331,446890.397],[\"9/644/556\",174593.331,445890.397,175593.331,446890.397],[\"8/648/552\",175593.331,444890.397,177593.331,446890.397],[\"8/656/552\",177593.331,444890.397,179593.331,446890.397],[\"8/664/552\",179593.331,444890.397,181593.331,446890.397],[\"9/660/548\",178593.331,443890.397,179593.331,444890.397],[\"9/660/544\",178593.331,442890.397,179593.331,443890.397],[\"8/664/544\",179593.331,442890.397,181593.331,444890.397],[\"8/672/544\",181593.331,442890.397,183593.331,444890.397],[\"8/672/552\",181593.331,444890.397,183593.331,446890.397],[\"8/680/552\",183593.331,444890.397,185593.331,446890.397],[\"8/688/552\",185593.331,444890.397,187593.331,446890.397],[\"9/696/556\",187593.331,445890.397,188593.331,446890.397],[\"9/696/552\",187593.331,444890.397,188593.331,445890.397],[\"9/692/544\",186593.331,442890.397,187593.331,443890.397],[\"9/692/548\",186593.331,443890.397,187593.331,444890.397],[\"8/696/544\",187593.331,442890.397,189593.331,444890.397],[\"9/696/540\",187593.331,441890.397,188593.331,442890.397],[\"9/692/540\",186593.331,441890.397,187593.331,442890.397],[\"9/688/540\",185593.331,441890.397,186593.331,442890.397],[\"9/688/544\",185593.331,442890.397,186593.331,443890.397],[\"9/688/548\",185593.331,443890.397,186593.331,444890.397],[\"8/680/544\",183593.331,442890.397,185593.331,444890.397],[\"8/680/536\",183593.331,440890.397,185593.331,442890.397],[\"9/688/536\",185593.331,440890.397,186593.331,441890.397],[\"9/688/532\",185593.331,439890.397,186593.331,440890.397],[\"8/680/528\",183593.331,438890.397,185593.331,440890.397],[\"8/680/520\",183593.331,436890.397,185593.331,438890.397],[\"9/688/520\",185593.331,436890.397,186593.331,437890.397],[\"9/688/524\",185593.331,437890.397,186593.331,438890.397],[\"9/688/528\",185593.331,438890.397,186593.331,439890.397],[\"9/692/528\",186593.331,438890.397,187593.331,439890.397],[\"9/692/524\",186593.331,437890.397,187593.331,438890.397],[\"9/692/520\",186593.331,436890.397,187593.331,437890.397],[\"8/696/520\",187593.331,436890.397,189593.331,438890.397],[\"9/696/528\",187593.331,438890.397,188593.331,439890.397],[\"9/696/532\",187593.331,439890.397,188593.331,440890.397],[\"9/692/532\",186593.331,439890.397,187593.331,440890.397],[\"9/692/536\",186593.331,440890.397,187593.331,441890.397],[\"9/696/536\",187593.331,440890.397,188593.331,441890.397],[\"9/700/536\",188593.331,440890.397,189593.331,441890.397],[\"9/704/536\",189593.331,440890.397,190593.331,441890.397],[\"9/708/536\",190593.331,440890.397,191593.331,441890.397],[\"9/704/532\",189593.331,439890.397,190593.331,440890.397],[\"9/708/532\",190593.331,439890.397,191593.331,440890.397],[\"9/700/532\",188593.331,439890.397,189593.331,440890.397],[\"9/700/528\",188593.331,438890.397,189593.331,439890.397],[\"8/704/520\",189593.331,436890.397,191593.331,438890.397],[\"9/704/528\",189593.331,438890.397,190593.331,439890.397],[\"9/708/528\",190593.331,438890.397,191593.331,439890.397],[\"9/712/528\",191593.331,438890.397,192593.331,439890.397],[\"9/712/524\",191593.331,437890.397,192593.331,438890.397],[\"9/712/520\",191593.331,436890.397,192593.331,437890.397],[\"9/716/520\",192593.331,436890.397,193593.331,437890.397],[\"9/716/524\",192593.331,437890.397,193593.331,438890.397],[\"9/716/528\",192593.331,438890.397,193593.331,439890.397],[\"9/716/532\",192593.331,439890.397,193593.331,440890.397],[\"9/712/532\",191593.331,439890.397,192593.331,440890.397],[\"8/712/536\",191593.331,440890.397,193593.331,442890.397],[\"9/716/544\",192593.331,442890.397,193593.331,443890.397],[\"9/716/548\",192593.331,443890.397,193593.331,444890.397],[\"9/712/544\",191593.331,442890.397,192593.331,443890.397],[\"9/712/548\",191593.331,443890.397,192593.331,444890.397],[\"10/710/548\",191093.331,443890.397,191593.331,444390.397],[\"9/708/540\",190593.331,441890.397,191593.331,442890.397],[\"9/704/540\",189593.331,441890.397,190593.331,442890.397],[\"9/700/540\",188593.331,441890.397,189593.331,442890.397],[\"9/704/548\",189593.331,443890.397,190593.331,444890.397],[\"9/704/544\",189593.331,442890.397,190593.331,443890.397],[\"9/708/544\",190593.331,442890.397,191593.331,443890.397],[\"10/708/548\",190593.331,443890.397,191093.331,444390.397],[\"10/708/550\",190593.331,444390.397,191093.331,444890.397],[\"9/708/552\",190593.331,444890.397,191593.331,445890.397],[\"9/704/552\",189593.331,444890.397,190593.331,445890.397],[\"9/700/552\",188593.331,444890.397,189593.331,445890.397],[\"9/700/556\",188593.331,445890.397,189593.331,446890.397],[\"9/704/556\",189593.331,445890.397,190593.331,446890.397],[\"9/708/556\",190593.331,445890.397,191593.331,446890.397],[\"9/712/556\",191593.331,445890.397,192593.331,446890.397],[\"10/710/550\",191093.331,444390.397,191593.331,444890.397],[\"9/712/552\",191593.331,444890.397,192593.331,445890.397],[\"9/716/552\",192593.331,444890.397,193593.331,445890.397],[\"10/718/556\",193093.331,445890.397,193593.331,446390.397],[\"10/716/556\",192593.331,445890.397,193093.331,446390.397],[\"10/716/558\",192593.331,446390.397,193093.331,446890.397],[\"10/718/558\",193093.331,446390.397,193593.331,446890.397],[\"7/704/560\",189593.331,446890.397,193593.331,450890.397],[\"6/704/576\",189593.331,450890.397,197593.331,458890.397],[\"6/672/576\",181593.331,450890.397,189593.331,458890.397],[\"7/688/560\",185593.331,446890.397,189593.331,450890.397],[\"7/672/560\",181593.331,446890.397,185593.331,450890.397],[\"7/656/560\",177593.331,446890.397,181593.331,450890.397],[\"8/648/560\",175593.331,446890.397,177593.331,448890.397],[\"9/644/560\",174593.331,446890.397,175593.331,447890.397],[\"9/640/560\",173593.331,446890.397,174593.331,447890.397],[\"9/640/564\",173593.331,447890.397,174593.331,448890.397],[\"9/640/568\",173593.331,448890.397,174593.331,449890.397],[\"9/644/568\",174593.331,448890.397,175593.331,449890.397],[\"9/644/564\",174593.331,447890.397,175593.331,448890.397],[\"9/644/572\",174593.331,449890.397,175593.331,450890.397],[\"9/640/572\",173593.331,449890.397,174593.331,450890.397],[\"8/640/576\",173593.331,450890.397,175593.331,452890.397],[\"8/648/576\",175593.331,450890.397,177593.331,452890.397],[\"8/648/568\",175593.331,448890.397,177593.331,450890.397],[\"8/648/584\",175593.331,452890.397,177593.331,454890.397],[\"8/640/584\",173593.331,452890.397,175593.331,454890.397],[\"7/640/592\",173593.331,454890.397,177593.331,458890.397],[\"7/656/592\",177593.331,454890.397,181593.331,458890.397],[\"7/656/576\",177593.331,450890.397,181593.331,454890.397],[\"7/656/608\",177593.331,458890.397,181593.331,462890.397],[\"8/640/608\",173593.331,458890.397,175593.331,460890.397],[\"8/640/616\",173593.331,460890.397,175593.331,462890.397],[\"8/648/616\",175593.331,460890.397,177593.331,462890.397],[\"8/648/608\",175593.331,458890.397,177593.331,460890.397],[\"7/640/624\",173593.331,462890.397,177593.331,466890.397],[\"7/656/624\",177593.331,462890.397,181593.331,466890.397],[\"6/672/608\",181593.331,458890.397,189593.331,466890.397],[\"7/704/608\",189593.331,458890.397,193593.331,462890.397],[\"8/712/624\",191593.331,462890.397,193593.331,464890.397],[\"8/704/624\",189593.331,462890.397,191593.331,464890.397],[\"8/704/632\",189593.331,464890.397,191593.331,466890.397],[\"9/712/636\",191593.331,465890.397,192593.331,466890.397],[\"9/712/632\",191593.331,464890.397,192593.331,465890.397],[\"9/716/632\",192593.331,464890.397,193593.331,465890.397],[\"9/716/636\",192593.331,465890.397,193593.331,466890.397],[\"8/720/632\",193593.331,464890.397,195593.331,466890.397],[\"8/720/624\",193593.331,462890.397,195593.331,464890.397],[\"8/728/624\",195593.331,462890.397,197593.331,464890.397],[\"8/728/632\",195593.331,464890.397,197593.331,466890.397],[\"7/736/624\",197593.331,462890.397,201593.331,466890.397],[\"7/752/624\",201593.331,462890.397,205593.331,466890.397],[\"7/736/608\",197593.331,458890.397,201593.331,462890.397],[\"7/752/608\",201593.331,458890.397,205593.331,462890.397],[\"9/748/600\",200593.331,456890.397,201593.331,457890.397],[\"9/744/600\",199593.331,456890.397,200593.331,457890.397],[\"9/748/604\",200593.331,457890.397,201593.331,458890.397],[\"9/744/604\",199593.331,457890.397,200593.331,458890.397],[\"8/736/600\",197593.331,456890.397,199593.331,458890.397],[\"7/720/608\",193593.331,458890.397,197593.331,462890.397],[\"8/736/592\",197593.331,454890.397,199593.331,456890.397],[\"7/720/560\",193593.331,446890.397,197593.331,450890.397],[\"7/736/560\",197593.331,446890.397,201593.331,450890.397],[\"7/752/560\",201593.331,446890.397,205593.331,450890.397],[\"8/752/576\",201593.331,450890.397,203593.331,452890.397],[\"8/752/584\",201593.331,452890.397,203593.331,454890.397],[\"7/736/576\",197593.331,450890.397,201593.331,454890.397],[\"8/744/592\",199593.331,454890.397,201593.331,456890.397],[\"7/752/592\",201593.331,454890.397,205593.331,458890.397],[\"8/768/592\",205593.331,454890.397,207593.331,456890.397],[\"8/776/592\",207593.331,454890.397,209593.331,456890.397],[\"7/768/576\",205593.331,450890.397,209593.331,454890.397],[\"9/764/580\",204593.331,451890.397,205593.331,452890.397],[\"8/760/584\",203593.331,452890.397,205593.331,454890.397],[\"9/760/580\",203593.331,451890.397,204593.331,452890.397],[\"9/760/576\",203593.331,450890.397,204593.331,451890.397],[\"9/764/576\",204593.331,450890.397,205593.331,451890.397],[\"9/768/560\",205593.331,446890.397,206593.331,447890.397],[\"9/768/564\",205593.331,447890.397,206593.331,448890.397],[\"9/772/564\",206593.331,447890.397,207593.331,448890.397],[\"9/772/560\",206593.331,446890.397,207593.331,447890.397],[\"8/776/560\",207593.331,446890.397,209593.331,448890.397],[\"8/776/568\",207593.331,448890.397,209593.331,450890.397],[\"8/768/568\",205593.331,448890.397,207593.331,450890.397],[\"7/784/560\",209593.331,446890.397,213593.331,450890.397],[\"7/784/576\",209593.331,450890.397,213593.331,454890.397],[\"7/784/592\",209593.331,454890.397,213593.331,458890.397],[\"9/792/608\",211593.331,458890.397,212593.331,459890.397],[\"9/796/608\",212593.331,458890.397,213593.331,459890.397],[\"10/796/612\",212593.331,459890.397,213093.331,460390.397],[\"10/796/614\",212593.331,460390.397,213093.331,460890.397],[\"10/798/612\",213093.331,459890.397,213593.331,460390.397],[\"10/798/614\",213093.331,460390.397,213593.331,460890.397],[\"9/796/616\",212593.331,460890.397,213593.331,461890.397],[\"9/792/616\",211593.331,460890.397,212593.331,461890.397],[\"10/790/618\",211093.331,461390.397,211593.331,461890.397],[\"10/790/616\",211093.331,460890.397,211593.331,461390.397],[\"9/792/612\",211593.331,459890.397,212593.331,460890.397],[\"9/784/612\",209593.331,459890.397,210593.331,460890.397],[\"9/788/612\",210593.331,459890.397,211593.331,460890.397],[\"10/788/616\",210593.331,460890.397,211093.331,461390.397],[\"10/788/618\",210593.331,461390.397,211093.331,461890.397],[\"9/784/616\",209593.331,460890.397,210593.331,461890.397],[\"9/784/608\",209593.331,458890.397,210593.331,459890.397],[\"9/788/608\",210593.331,458890.397,211593.331,459890.397],[\"8/776/600\",207593.331,456890.397,209593.331,458890.397],[\"8/768/600\",205593.331,456890.397,207593.331,458890.397],[\"7/768/608\",205593.331,458890.397,209593.331,462890.397],[\"7/768/624\",205593.331,462890.397,209593.331,466890.397],[\"8/784/632\",209593.331,464890.397,211593.331,466890.397],[\"9/784/620\",209593.331,461890.397,210593.331,462890.397],[\"9/788/620\",210593.331,461890.397,211593.331,462890.397],[\"8/784/624\",209593.331,462890.397,211593.331,464890.397],[\"9/792/620\",211593.331,461890.397,212593.331,462890.397],[\"9/796/620\",212593.331,461890.397,213593.331,462890.397],[\"8/792/624\",211593.331,462890.397,213593.331,464890.397],[\"8/792/632\",211593.331,464890.397,213593.331,466890.397],[\"7/800/624\",213593.331,462890.397,217593.331,466890.397],[\"7/800/608\",213593.331,458890.397,217593.331,462890.397],[\"9/816/600\",217593.331,456890.397,218593.331,457890.397],[\"9/816/604\",217593.331,457890.397,218593.331,458890.397],[\"7/816/608\",217593.331,458890.397,221593.331,462890.397],[\"9/820/604\",218593.331,457890.397,219593.331,458890.397],[\"9/820/600\",218593.331,456890.397,219593.331,457890.397],[\"8/824/600\",219593.331,456890.397,221593.331,458890.397],[\"7/832/608\",221593.331,458890.397,225593.331,462890.397],[\"8/832/624\",221593.331,462890.397,223593.331,464890.397],[\"7/816/624\",217593.331,462890.397,221593.331,466890.397],[\"8/832/632\",221593.331,464890.397,223593.331,466890.397],[\"8/840/632\",223593.331,464890.397,225593.331,466890.397],[\"9/840/628\",223593.331,463890.397,224593.331,464890.397],[\"9/840/624\",223593.331,462890.397,224593.331,463890.397],[\"9/844/624\",224593.331,462890.397,225593.331,463890.397],[\"9/844/628\",224593.331,463890.397,225593.331,464890.397],[\"7/848/624\",225593.331,462890.397,229593.331,466890.397],[\"7/864/624\",229593.331,462890.397,233593.331,466890.397],[\"8/864/608\",229593.331,458890.397,231593.331,460890.397],[\"8/864/616\",229593.331,460890.397,231593.331,462890.397],[\"8/872/616\",231593.331,460890.397,233593.331,462890.397],[\"9/876/612\",232593.331,459890.397,233593.331,460890.397],[\"9/872/612\",231593.331,459890.397,232593.331,460890.397],[\"9/872/608\",231593.331,458890.397,232593.331,459890.397],[\"9/876/608\",232593.331,458890.397,233593.331,459890.397],[\"8/856/600\",227593.331,456890.397,229593.331,458890.397],[\"8/848/600\",225593.331,456890.397,227593.331,458890.397],[\"7/848/608\",225593.331,458890.397,229593.331,462890.397],[\"7/848/576\",225593.331,450890.397,229593.331,454890.397],[\"9/856/592\",227593.331,454890.397,228593.331,455890.397],[\"8/848/592\",225593.331,454890.397,227593.331,456890.397],[\"9/856/596\",227593.331,455890.397,228593.331,456890.397],[\"9/860/596\",228593.331,455890.397,229593.331,456890.397],[\"9/860/592\",228593.331,454890.397,229593.331,455890.397],[\"7/864/592\",229593.331,454890.397,233593.331,458890.397],[\"7/864/576\",229593.331,450890.397,233593.331,454890.397],[\"7/864/560\",229593.331,446890.397,233593.331,450890.397],[\"7/848/560\",225593.331,446890.397,229593.331,450890.397],[\"7/832/560\",221593.331,446890.397,225593.331,450890.397],[\"8/824/560\",219593.331,446890.397,221593.331,448890.397],[\"8/824/568\",219593.331,448890.397,221593.331,450890.397],[\"9/820/576\",218593.331,450890.397,219593.331,451890.397],[\"8/824/576\",219593.331,450890.397,221593.331,452890.397],[\"7/832/576\",221593.331,450890.397,225593.331,454890.397],[\"7/832/592\",221593.331,454890.397,225593.331,458890.397],[\"8/824/592\",219593.331,454890.397,221593.331,456890.397],[\"8/824/584\",219593.331,452890.397,221593.331,454890.397],[\"9/820/580\",218593.331,451890.397,219593.331,452890.397],[\"9/816/580\",217593.331,451890.397,218593.331,452890.397],[\"8/816/584\",217593.331,452890.397,219593.331,454890.397],[\"8/816/592\",217593.331,454890.397,219593.331,456890.397],[\"7/800/592\",213593.331,454890.397,217593.331,458890.397],[\"7/800/576\",213593.331,450890.397,217593.331,454890.397],[\"9/816/576\",217593.331,450890.397,218593.331,451890.397],[\"8/816/568\",217593.331,448890.397,219593.331,450890.397],[\"8/816/560\",217593.331,446890.397,219593.331,448890.397],[\"7/800/560\",213593.331,446890.397,217593.331,450890.397],[\"8/800/552\",213593.331,444890.397,215593.331,446890.397],[\"8/800/544\",213593.331,442890.397,215593.331,444890.397],[\"9/800/540\",213593.331,441890.397,214593.331,442890.397],[\"9/804/540\",214593.331,441890.397,215593.331,442890.397],[\"9/808/540\",215593.331,441890.397,216593.331,442890.397],[\"9/808/544\",215593.331,442890.397,216593.331,443890.397],[\"9/808/548\",215593.331,443890.397,216593.331,444890.397],[\"9/812/548\",216593.331,443890.397,217593.331,444890.397],[\"9/812/544\",216593.331,442890.397,217593.331,443890.397],[\"9/812/540\",216593.331,441890.397,217593.331,442890.397],[\"9/816/540\",217593.331,441890.397,218593.331,442890.397],[\"8/816/544\",217593.331,442890.397,219593.331,444890.397],[\"8/808/552\",215593.331,444890.397,217593.331,446890.397],[\"8/816/552\",217593.331,444890.397,219593.331,446890.397],[\"8/824/552\",219593.331,444890.397,221593.331,446890.397],[\"7/832/544\",221593.331,442890.397,225593.331,446890.397],[\"8/824/544\",219593.331,442890.397,221593.331,444890.397],[\"9/820/540\",218593.331,441890.397,219593.331,442890.397],[\"9/820/536\",218593.331,440890.397,219593.331,441890.397],[\"8/824/528\",219593.331,438890.397,221593.331,440890.397],[\"8/824/536\",219593.331,440890.397,221593.331,442890.397],[\"7/832/528\",221593.331,438890.397,225593.331,442890.397],[\"8/832/520\",221593.331,436890.397,223593.331,438890.397],[\"9/828/520\",220593.331,436890.397,221593.331,437890.397],[\"9/824/520\",219593.331,436890.397,220593.331,437890.397],[\"9/828/524\",220593.331,437890.397,221593.331,438890.397],[\"9/824/524\",219593.331,437890.397,220593.331,438890.397],[\"8/816/520\",217593.331,436890.397,219593.331,438890.397],[\"8/808/520\",215593.331,436890.397,217593.331,438890.397],[\"8/816/528\",217593.331,438890.397,219593.331,440890.397],[\"9/816/536\",217593.331,440890.397,218593.331,441890.397],[\"9/812/536\",216593.331,440890.397,217593.331,441890.397],[\"8/808/528\",215593.331,438890.397,217593.331,440890.397],[\"9/808/536\",215593.331,440890.397,216593.331,441890.397],[\"10/806/538\",215093.331,441390.397,215593.331,441890.397],[\"10/806/536\",215093.331,440890.397,215593.331,441390.397],[\"10/804/536\",214593.331,440890.397,215093.331,441390.397],[\"10/804/538\",214593.331,441390.397,215093.331,441890.397],[\"9/800/536\",213593.331,440890.397,214593.331,441890.397],[\"8/800/528\",213593.331,438890.397,215593.331,440890.397],[\"8/800/520\",213593.331,436890.397,215593.331,438890.397],[\"8/800/512\",213593.331,434890.397,215593.331,436890.397],[\"8/808/512\",215593.331,434890.397,217593.331,436890.397],[\"8/816/512\",217593.331,434890.397,219593.331,436890.397],[\"8/808/504\",215593.331,432890.397,217593.331,434890.397],[\"9/804/500\",214593.331,431890.397,215593.331,432890.397],[\"8/800/504\",213593.331,432890.397,215593.331,434890.397],[\"9/800/500\",213593.331,431890.397,214593.331,432890.397],[\"9/800/496\",213593.331,430890.397,214593.331,431890.397],[\"9/804/496\",214593.331,430890.397,215593.331,431890.397],[\"8/808/496\",215593.331,430890.397,217593.331,432890.397],[\"7/816/480\",217593.331,426890.397,221593.331,430890.397],[\"7/832/480\",221593.331,426890.397,225593.331,430890.397],[\"8/832/496\",221593.331,430890.397,223593.331,432890.397],[\"9/836/504\",222593.331,432890.397,223593.331,433890.397],[\"9/836/508\",222593.331,433890.397,223593.331,434890.397],[\"9/832/504\",221593.331,432890.397,222593.331,433890.397],[\"9/832/508\",221593.331,433890.397,222593.331,434890.397],[\"7/816/496\",217593.331,430890.397,221593.331,434890.397],[\"8/824/512\",219593.331,434890.397,221593.331,436890.397],[\"8/832/512\",221593.331,434890.397,223593.331,436890.397],[\"8/840/512\",223593.331,434890.397,225593.331,436890.397],[\"7/848/512\",225593.331,434890.397,229593.331,438890.397],[\"7/848/496\",225593.331,430890.397,229593.331,434890.397],[\"8/840/504\",223593.331,432890.397,225593.331,434890.397],[\"8/840/496\",223593.331,430890.397,225593.331,432890.397],[\"7/848/480\",225593.331,426890.397,229593.331,430890.397],[\"9/864/496\",229593.331,430890.397,230593.331,431890.397],[\"9/868/496\",230593.331,430890.397,231593.331,431890.397],[\"7/864/480\",229593.331,426890.397,233593.331,430890.397],[\"8/872/496\",231593.331,430890.397,233593.331,432890.397],[\"8/872/504\",231593.331,432890.397,233593.331,434890.397],[\"9/868/500\",230593.331,431890.397,231593.331,432890.397],[\"9/864/500\",229593.331,431890.397,230593.331,432890.397],[\"8/864/504\",229593.331,432890.397,231593.331,434890.397],[\"7/864/512\",229593.331,434890.397,233593.331,438890.397],[\"7/864/528\",229593.331,438890.397,233593.331,442890.397],[\"9/860/532\",228593.331,439890.397,229593.331,440890.397],[\"9/860/528\",228593.331,438890.397,229593.331,439890.397],[\"9/856/528\",227593.331,438890.397,228593.331,439890.397],[\"8/840/520\",223593.331,436890.397,225593.331,438890.397],[\"8/848/536\",225593.331,440890.397,227593.331,442890.397],[\"8/848/528\",225593.331,438890.397,227593.331,440890.397],[\"9/856/532\",227593.331,439890.397,228593.331,440890.397],[\"8/856/536\",227593.331,440890.397,229593.331,442890.397],[\"7/848/544\",225593.331,442890.397,229593.331,446890.397],[\"7/864/544\",229593.331,442890.397,233593.331,446890.397],[\"8/880/552\",233593.331,444890.397,235593.331,446890.397],[\"8/880/544\",233593.331,442890.397,235593.331,444890.397],[\"9/888/544\",235593.331,442890.397,236593.331,443890.397],[\"9/888/548\",235593.331,443890.397,236593.331,444890.397],[\"9/892/548\",236593.331,443890.397,237593.331,444890.397],[\"9/892/544\",236593.331,442890.397,237593.331,443890.397],[\"8/888/552\",235593.331,444890.397,237593.331,446890.397],[\"7/896/544\",237593.331,442890.397,241593.331,446890.397],[\"7/912/544\",241593.331,442890.397,245593.331,446890.397],[\"7/896/528\",237593.331,438890.397,241593.331,442890.397],[\"7/912/528\",241593.331,438890.397,245593.331,442890.397],[\"9/892/520\",236593.331,436890.397,237593.331,437890.397],[\"9/892/524\",236593.331,437890.397,237593.331,438890.397],[\"7/880/528\",233593.331,438890.397,237593.331,442890.397],[\"9/888/524\",235593.331,437890.397,236593.331,438890.397],[\"9/888/520\",235593.331,436890.397,236593.331,437890.397],[\"8/880/520\",233593.331,436890.397,235593.331,438890.397],[\"8/880/512\",233593.331,434890.397,235593.331,436890.397],[\"8/888/512\",235593.331,434890.397,237593.331,436890.397],[\"7/880/496\",233593.331,430890.397,237593.331,434890.397],[\"7/896/512\",237593.331,434890.397,241593.331,438890.397],[\"7/912/512\",241593.331,434890.397,245593.331,438890.397],[\"7/928/512\",245593.331,434890.397,249593.331,438890.397],[\"7/944/512\",249593.331,434890.397,253593.331,438890.397],[\"7/944/528\",249593.331,438890.397,253593.331,442890.397],[\"8/928/536\",245593.331,440890.397,247593.331,442890.397],[\"8/928/528\",245593.331,438890.397,247593.331,440890.397],[\"8/936/528\",247593.331,438890.397,249593.331,440890.397],[\"8/936/536\",247593.331,440890.397,249593.331,442890.397],[\"8/936/544\",247593.331,442890.397,249593.331,444890.397],[\"10/932/546\",246593.331,443390.397,247093.331,443890.397],[\"10/934/546\",247093.331,443390.397,247593.331,443890.397],[\"9/932/548\",246593.331,443890.397,247593.331,444890.397],[\"10/932/544\",246593.331,442890.397,247093.331,443390.397],[\"10/934/544\",247093.331,442890.397,247593.331,443390.397],[\"9/928/544\",245593.331,442890.397,246593.331,443890.397],[\"9/928/548\",245593.331,443890.397,246593.331,444890.397],[\"8/928/552\",245593.331,444890.397,247593.331,446890.397],[\"8/936/552\",247593.331,444890.397,249593.331,446890.397],[\"7/944/544\",249593.331,442890.397,253593.331,446890.397],[\"7/944/560\",249593.331,446890.397,253593.331,450890.397],[\"6/928/576\",245593.331,450890.397,253593.331,458890.397],[\"8/920/592\",243593.331,454890.397,245593.331,456890.397],[\"7/928/560\",245593.331,446890.397,249593.331,450890.397],[\"7/912/560\",241593.331,446890.397,245593.331,450890.397],[\"8/904/568\",239593.331,448890.397,241593.331,450890.397],[\"8/904/576\",239593.331,450890.397,241593.331,452890.397],[\"9/900/576\",238593.331,450890.397,239593.331,451890.397],[\"8/904/560\",239593.331,446890.397,241593.331,448890.397],[\"8/896/560\",237593.331,446890.397,239593.331,448890.397],[\"7/880/560\",233593.331,446890.397,237593.331,450890.397],[\"8/896/568\",237593.331,448890.397,239593.331,450890.397],[\"9/896/576\",237593.331,450890.397,238593.331,451890.397],[\"9/896/580\",237593.331,451890.397,238593.331,452890.397],[\"8/896/584\",237593.331,452890.397,239593.331,454890.397],[\"7/880/576\",233593.331,450890.397,237593.331,454890.397],[\"7/880/592\",233593.331,454890.397,237593.331,458890.397],[\"8/896/592\",237593.331,454890.397,239593.331,456890.397],[\"8/904/592\",239593.331,454890.397,241593.331,456890.397],[\"9/900/580\",238593.331,451890.397,239593.331,452890.397],[\"8/904/584\",239593.331,452890.397,241593.331,454890.397],[\"7/912/576\",241593.331,450890.397,245593.331,454890.397],[\"8/912/592\",241593.331,454890.397,243593.331,456890.397],[\"8/912/600\",241593.331,456890.397,243593.331,458890.397],[\"7/912/608\",241593.331,458890.397,245593.331,462890.397],[\"8/904/608\",239593.331,458890.397,241593.331,460890.397],[\"8/904/616\",239593.331,460890.397,241593.331,462890.397],[\"9/900/616\",238593.331,460890.397,239593.331,461890.397],[\"9/908/604\",240593.331,457890.397,241593.331,458890.397],[\"9/904/604\",239593.331,457890.397,240593.331,458890.397],[\"9/908/600\",240593.331,456890.397,241593.331,457890.397],[\"9/904/600\",239593.331,456890.397,240593.331,457890.397],[\"8/896/600\",237593.331,456890.397,239593.331,458890.397],[\"7/880/608\",233593.331,458890.397,237593.331,462890.397],[\"8/896/608\",237593.331,458890.397,239593.331,460890.397],[\"9/896/616\",237593.331,460890.397,238593.331,461890.397],[\"9/896/620\",237593.331,461890.397,238593.331,462890.397],[\"7/880/624\",233593.331,462890.397,237593.331,466890.397],[\"7/896/624\",237593.331,462890.397,241593.331,466890.397],[\"9/900/620\",238593.331,461890.397,239593.331,462890.397],[\"7/912/624\",241593.331,462890.397,245593.331,466890.397],[\"8/928/632\",245593.331,464890.397,247593.331,466890.397],[\"8/936/632\",247593.331,464890.397,249593.331,466890.397],[\"9/932/624\",246593.331,462890.397,247593.331,463890.397],[\"9/932/628\",246593.331,463890.397,247593.331,464890.397],[\"9/936/628\",247593.331,463890.397,248593.331,464890.397],[\"9/936/624\",247593.331,462890.397,248593.331,463890.397],[\"9/928/624\",245593.331,462890.397,246593.331,463890.397],[\"9/928/628\",245593.331,463890.397,246593.331,464890.397],[\"8/920/600\",243593.331,456890.397,245593.331,458890.397],[\"7/928/608\",245593.331,458890.397,249593.331,462890.397],[\"7/944/608\",249593.331,458890.397,253593.331,462890.397],[\"9/940/624\",248593.331,462890.397,249593.331,463890.397],[\"9/940/628\",248593.331,463890.397,249593.331,464890.397],[\"7/944/624\",249593.331,462890.397,253593.331,466890.397],[\"5/960/576\",253593.331,450890.397,269593.331,466890.397],[\"5/960/512\",253593.331,434890.397,269593.331,450890.397],[\"3/1024/512\",269593.331,434890.397,333593.331,498890.397],[\"8/1008/664\",265593.331,472890.397,267593.331,474890.397],[\"8/1016/664\",267593.331,472890.397,269593.331,474890.397],[\"8/1016/672\",267593.331,474890.397,269593.331,476890.397],[\"8/1008/672\",265593.331,474890.397,267593.331,476890.397],[\"9/1004/672\",264593.331,474890.397,265593.331,475890.397],[\"9/1004/676\",264593.331,475890.397,265593.331,476890.397],[\"9/1000/676\",263593.331,475890.397,264593.331,476890.397],[\"9/1000/672\",263593.331,474890.397,264593.331,475890.397],[\"8/1000/664\",263593.331,472890.397,265593.331,474890.397],[\"8/1000/656\",263593.331,470890.397,265593.331,472890.397],[\"8/1000/648\",263593.331,468890.397,265593.331,470890.397],[\"8/1008/656\",265593.331,470890.397,267593.331,472890.397],[\"8/1016/656\",267593.331,470890.397,269593.331,472890.397],[\"8/992/640\",261593.331,466890.397,263593.331,468890.397],[\"9/992/648\",261593.331,468890.397,262593.331,469890.397],[\"9/996/648\",262593.331,468890.397,263593.331,469890.397],[\"10/996/652\",262593.331,469890.397,263093.331,470390.397],[\"10/996/654\",262593.331,470390.397,263093.331,470890.397],[\"10/998/652\",263093.331,469890.397,263593.331,470390.397],[\"10/998/654\",263093.331,470390.397,263593.331,470890.397],[\"9/996/656\",262593.331,470890.397,263593.331,471890.397],[\"9/992/656\",261593.331,470890.397,262593.331,471890.397],[\"9/992/652\",261593.331,469890.397,262593.331,470890.397],[\"8/984/648\",259593.331,468890.397,261593.331,470890.397],[\"9/988/656\",260593.331,470890.397,261593.331,471890.397],[\"9/984/656\",259593.331,470890.397,260593.331,471890.397],[\"10/982/656\",259093.331,470890.397,259593.331,471390.397],[\"10/982/658\",259093.331,471390.397,259593.331,471890.397],[\"10/980/658\",258593.331,471390.397,259093.331,471890.397],[\"10/980/656\",258593.331,470890.397,259093.331,471390.397],[\"10/980/654\",258593.331,470390.397,259093.331,470890.397],[\"10/980/652\",258593.331,469890.397,259093.331,470390.397],[\"10/982/654\",259093.331,470390.397,259593.331,470890.397],[\"10/982/652\",259093.331,469890.397,259593.331,470390.397],[\"9/980/648\",258593.331,468890.397,259593.331,469890.397],[\"9/980/644\",258593.331,467890.397,259593.331,468890.397],[\"8/984/640\",259593.331,466890.397,261593.331,468890.397],[\"9/980/640\",258593.331,466890.397,259593.331,467890.397],[\"9/976/640\",257593.331,466890.397,258593.331,467890.397],[\"9/976/644\",257593.331,467890.397,258593.331,468890.397],[\"9/976/648\",257593.331,468890.397,258593.331,469890.397],[\"9/972/644\",256593.331,467890.397,257593.331,468890.397],[\"9/972/648\",256593.331,468890.397,257593.331,469890.397],[\"9/972/640\",256593.331,466890.397,257593.331,467890.397],[\"9/968/640\",255593.331,466890.397,256593.331,467890.397],[\"9/964/640\",254593.331,466890.397,255593.331,467890.397],[\"9/960/640\",253593.331,466890.397,254593.331,467890.397],[\"9/960/644\",253593.331,467890.397,254593.331,468890.397],[\"9/964/644\",254593.331,467890.397,255593.331,468890.397],[\"9/968/644\",255593.331,467890.397,256593.331,468890.397],[\"9/968/648\",255593.331,468890.397,256593.331,469890.397],[\"10/968/652\",255593.331,469890.397,256093.331,470390.397],[\"10/968/654\",255593.331,470390.397,256093.331,470890.397],[\"8/960/648\",253593.331,468890.397,255593.331,470890.397],[\"8/960/656\",253593.331,470890.397,255593.331,472890.397],[\"9/968/656\",255593.331,470890.397,256593.331,471890.397],[\"9/972/656\",256593.331,470890.397,257593.331,471890.397],[\"10/970/654\",256093.331,470390.397,256593.331,470890.397],[\"10/970/652\",256093.331,469890.397,256593.331,470390.397],[\"10/974/652\",257093.331,469890.397,257593.331,470390.397],[\"10/972/652\",256593.331,469890.397,257093.331,470390.397],[\"10/972/654\",256593.331,470390.397,257093.331,470890.397],[\"10/974/654\",257093.331,470390.397,257593.331,470890.397],[\"10/976/654\",257593.331,470390.397,258093.331,470890.397],[\"10/976/652\",257593.331,469890.397,258093.331,470390.397],[\"10/978/652\",258093.331,469890.397,258593.331,470390.397],[\"10/978/654\",258093.331,470390.397,258593.331,470890.397],[\"9/976/656\",257593.331,470890.397,258593.331,471890.397],[\"10/978/660\",258093.331,471890.397,258593.331,472390.397],[\"10/976/660\",257593.331,471890.397,258093.331,472390.397],[\"10/976/662\",257593.331,472390.397,258093.331,472890.397],[\"10/978/662\",258093.331,472390.397,258593.331,472890.397],[\"9/976/664\",257593.331,472890.397,258593.331,473890.397],[\"9/976/668\",257593.331,473890.397,258593.331,474890.397],[\"8/968/664\",255593.331,472890.397,257593.331,474890.397],[\"9/972/660\",256593.331,471890.397,257593.331,472890.397],[\"9/968/660\",255593.331,471890.397,256593.331,472890.397],[\"8/960/664\",253593.331,472890.397,255593.331,474890.397],[\"8/960/672\",253593.331,474890.397,255593.331,476890.397],[\"8/968/672\",255593.331,474890.397,257593.331,476890.397],[\"7/976/672\",257593.331,474890.397,261593.331,478890.397],[\"9/980/668\",258593.331,473890.397,259593.331,474890.397],[\"9/980/664\",258593.331,472890.397,259593.331,473890.397],[\"10/980/662\",258593.331,472390.397,259093.331,472890.397],[\"10/980/660\",258593.331,471890.397,259093.331,472390.397],[\"10/982/660\",259093.331,471890.397,259593.331,472390.397],[\"10/982/662\",259093.331,472390.397,259593.331,472890.397],[\"9/984/660\",259593.331,471890.397,260593.331,472890.397],[\"9/988/660\",260593.331,471890.397,261593.331,472890.397],[\"8/984/664\",259593.331,472890.397,261593.331,474890.397],[\"9/992/660\",261593.331,471890.397,262593.331,472890.397],[\"9/996/660\",262593.331,471890.397,263593.331,472890.397],[\"8/992/664\",261593.331,472890.397,263593.331,474890.397],[\"8/992/672\",261593.331,474890.397,263593.331,476890.397],[\"8/992/680\",261593.331,476890.397,263593.331,478890.397],[\"7/992/688\",261593.331,478890.397,265593.331,482890.397],[\"9/984/692\",259593.331,479890.397,260593.331,480890.397],[\"9/988/692\",260593.331,479890.397,261593.331,480890.397],[\"9/988/696\",260593.331,480890.397,261593.331,481890.397],[\"10/986/698\",260093.331,481390.397,260593.331,481890.397],[\"10/986/696\",260093.331,480890.397,260593.331,481390.397],[\"10/984/696\",259593.331,480890.397,260093.331,481390.397],[\"10/984/698\",259593.331,481390.397,260093.331,481890.397],[\"9/980/696\",258593.331,480890.397,259593.331,481890.397],[\"9/984/688\",259593.331,478890.397,260593.331,479890.397],[\"9/988/688\",260593.331,478890.397,261593.331,479890.397],[\"8/968/680\",255593.331,476890.397,257593.331,478890.397],[\"9/964/680\",254593.331,476890.397,255593.331,477890.397],[\"9/960/680\",253593.331,476890.397,254593.331,477890.397],[\"9/960/684\",253593.331,477890.397,254593.331,478890.397],[\"9/964/684\",254593.331,477890.397,255593.331,478890.397],[\"7/960/688\",253593.331,478890.397,257593.331,482890.397],[\"8/976/688\",257593.331,478890.397,259593.331,480890.397],[\"9/976/696\",257593.331,480890.397,258593.331,481890.397],[\"9/976/700\",257593.331,481890.397,258593.331,482890.397],[\"8/976/704\",257593.331,482890.397,259593.331,484890.397],[\"7/960/704\",253593.331,482890.397,257593.331,486890.397],[\"8/976/712\",257593.331,484890.397,259593.331,486890.397],[\"8/984/712\",259593.331,484890.397,261593.331,486890.397],[\"9/980/700\",258593.331,481890.397,259593.331,482890.397],[\"9/984/700\",259593.331,481890.397,260593.331,482890.397],[\"9/988/700\",260593.331,481890.397,261593.331,482890.397],[\"8/984/704\",259593.331,482890.397,261593.331,484890.397],[\"7/992/704\",261593.331,482890.397,265593.331,486890.397],[\"7/1008/704\",265593.331,482890.397,269593.331,486890.397],[\"8/1000/680\",263593.331,476890.397,265593.331,478890.397],[\"8/1008/680\",265593.331,476890.397,267593.331,478890.397],[\"7/1008/688\",265593.331,478890.397,269593.331,482890.397],[\"6/992/736\",261593.331,490890.397,269593.331,498890.397],[\"8/1000/728\",263593.331,488890.397,265593.331,490890.397],[\"7/1008/720\",265593.331,486890.397,269593.331,490890.397],[\"8/1000/720\",263593.331,486890.397,265593.331,488890.397],[\"8/992/720\",261593.331,486890.397,263593.331,488890.397],[\"8/992/728\",261593.331,488890.397,263593.331,490890.397],[\"8/984/736\",259593.331,490890.397,261593.331,492890.397],[\"9/980/736\",258593.331,490890.397,259593.331,491890.397],[\"7/976/720\",257593.331,486890.397,261593.331,490890.397],[\"7/960/720\",253593.331,486890.397,257593.331,490890.397],[\"9/976/736\",257593.331,490890.397,258593.331,491890.397],[\"9/976/740\",257593.331,491890.397,258593.331,492890.397],[\"8/976/744\",257593.331,492890.397,259593.331,494890.397],[\"7/960/736\",253593.331,490890.397,257593.331,494890.397],[\"7/960/752\",253593.331,494890.397,257593.331,498890.397],[\"7/976/752\",257593.331,494890.397,261593.331,498890.397],[\"9/980/740\",258593.331,491890.397,259593.331,492890.397],[\"8/984/744\",259593.331,492890.397,261593.331,494890.397],[\"5/960/768\",253593.331,498890.397,269593.331,514890.397],[\"7/976/832\",257593.331,514890.397,261593.331,518890.397],[\"7/976/848\",257593.331,518890.397,261593.331,522890.397],[\"8/960/848\",253593.331,518890.397,255593.331,520890.397],[\"8/960/856\",253593.331,520890.397,255593.331,522890.397],[\"8/968/856\",255593.331,520890.397,257593.331,522890.397],[\"8/968/848\",255593.331,518890.397,257593.331,520890.397],[\"8/976/864\",257593.331,522890.397,259593.331,524890.397],[\"8/968/864\",255593.331,522890.397,257593.331,524890.397],[\"8/960/864\",253593.331,522890.397,255593.331,524890.397],[\"9/964/872\",254593.331,524890.397,255593.331,525890.397],[\"9/960/872\",253593.331,524890.397,254593.331,525890.397],[\"9/960/876\",253593.331,525890.397,254593.331,526890.397],[\"9/964/876\",254593.331,525890.397,255593.331,526890.397],[\"8/968/872\",255593.331,524890.397,257593.331,526890.397],[\"8/976/872\",257593.331,524890.397,259593.331,526890.397],[\"8/984/872\",259593.331,524890.397,261593.331,526890.397],[\"8/984/864\",259593.331,522890.397,261593.331,524890.397],[\"7/992/864\",261593.331,522890.397,265593.331,526890.397],[\"7/1008/864\",265593.331,522890.397,269593.331,526890.397],[\"6/992/832\",261593.331,514890.397,269593.331,522890.397],[\"7/1008/896\",265593.331,530890.397,269593.331,534890.397],[\"8/1016/912\",267593.331,534890.397,269593.331,536890.397],[\"8/1008/912\",265593.331,534890.397,267593.331,536890.397],[\"8/1000/888\",263593.331,528890.397,265593.331,530890.397],[\"7/1008/880\",265593.331,526890.397,269593.331,530890.397],[\"8/1000/880\",263593.331,526890.397,265593.331,528890.397],[\"9/996/880\",262593.331,526890.397,263593.331,527890.397],[\"9/992/880\",261593.331,526890.397,262593.331,527890.397],[\"9/992/884\",261593.331,527890.397,262593.331,528890.397],[\"9/996/884\",262593.331,527890.397,263593.331,528890.397],[\"8/992/888\",261593.331,528890.397,263593.331,530890.397],[\"8/984/896\",259593.331,530890.397,261593.331,532890.397],[\"7/976/880\",257593.331,526890.397,261593.331,530890.397],[\"9/972/888\",256593.331,528890.397,257593.331,529890.397],[\"8/968/880\",255593.331,526890.397,257593.331,528890.397],[\"8/960/880\",253593.331,526890.397,255593.331,528890.397],[\"9/968/888\",255593.331,528890.397,256593.331,529890.397],[\"9/968/892\",255593.331,529890.397,256593.331,530890.397],[\"8/960/888\",253593.331,528890.397,255593.331,530890.397],[\"8/960/896\",253593.331,530890.397,255593.331,532890.397],[\"9/968/896\",255593.331,530890.397,256593.331,531890.397],[\"9/972/896\",256593.331,530890.397,257593.331,531890.397],[\"9/972/892\",256593.331,529890.397,257593.331,530890.397],[\"8/976/896\",257593.331,530890.397,259593.331,532890.397],[\"9/976/904\",257593.331,532890.397,258593.331,533890.397],[\"9/976/908\",257593.331,533890.397,258593.331,534890.397],[\"9/972/904\",256593.331,532890.397,257593.331,533890.397],[\"9/972/908\",256593.331,533890.397,257593.331,534890.397],[\"9/972/900\",256593.331,531890.397,257593.331,532890.397],[\"9/968/900\",255593.331,531890.397,256593.331,532890.397],[\"8/960/904\",253593.331,532890.397,255593.331,534890.397],[\"9/968/904\",255593.331,532890.397,256593.331,533890.397],[\"9/968/908\",255593.331,533890.397,256593.331,534890.397],[\"9/968/912\",255593.331,534890.397,256593.331,535890.397],[\"8/960/912\",253593.331,534890.397,255593.331,536890.397],[\"9/968/916\",255593.331,535890.397,256593.331,536890.397],[\"9/972/916\",256593.331,535890.397,257593.331,536890.397],[\"9/972/912\",256593.331,534890.397,257593.331,535890.397],[\"7/976/912\",257593.331,534890.397,261593.331,538890.397],[\"9/980/908\",258593.331,533890.397,259593.331,534890.397],[\"9/980/904\",258593.331,532890.397,259593.331,533890.397],[\"8/984/904\",259593.331,532890.397,261593.331,534890.397],[\"7/992/896\",261593.331,530890.397,265593.331,534890.397],[\"7/992/912\",261593.331,534890.397,265593.331,538890.397],[\"7/992/928\",261593.331,538890.397,265593.331,542890.397],[\"7/976/928\",257593.331,538890.397,261593.331,542890.397],[\"8/968/920\",255593.331,536890.397,257593.331,538890.397],[\"8/960/920\",253593.331,536890.397,255593.331,538890.397],[\"7/960/928\",253593.331,538890.397,257593.331,542890.397],[\"7/960/944\",253593.331,542890.397,257593.331,546890.397],[\"7/976/944\",257593.331,542890.397,261593.331,546890.397],[\"7/992/944\",261593.331,542890.397,265593.331,546890.397],[\"8/1008/952\",265593.331,544890.397,267593.331,546890.397],[\"8/1016/952\",267593.331,544890.397,269593.331,546890.397],[\"8/1008/944\",265593.331,542890.397,267593.331,544890.397],[\"8/1016/944\",267593.331,542890.397,269593.331,544890.397],[\"8/1008/920\",265593.331,536890.397,267593.331,538890.397],[\"8/1016/920\",267593.331,536890.397,269593.331,538890.397],[\"7/1008/928\",265593.331,538890.397,269593.331,542890.397],[\"5/1024/896\",269593.331,530890.397,285593.331,546890.397],[\"6/960/1184\",253593.331,602890.397,261593.331,610890.397],[\"7/960/1168\",253593.331,598890.397,257593.331,602890.397],[\"8/960/1160\",253593.331,596890.397,255593.331,598890.397],[\"6/992/1120\",261593.331,586890.397,269593.331,594890.397],[\"7/976/1120\",257593.331,586890.397,261593.331,590890.397],[\"7/976/1152\",257593.331,594890.397,261593.331,598890.397],[\"7/976/1136\",257593.331,590890.397,261593.331,594890.397],[\"9/972/1144\",256593.331,592890.397,257593.331,593890.397],[\"9/972/1148\",256593.331,593890.397,257593.331,594890.397],[\"9/972/1156\",256593.331,595890.397,257593.331,596890.397],[\"9/972/1152\",256593.331,594890.397,257593.331,595890.397],[\"9/968/1152\",255593.331,594890.397,256593.331,595890.397],[\"9/968/1156\",255593.331,595890.397,256593.331,596890.397],[\"8/960/1152\",253593.331,594890.397,255593.331,596890.397],[\"9/960/1148\",253593.331,593890.397,254593.331,594890.397],[\"9/960/1144\",253593.331,592890.397,254593.331,593890.397],[\"9/964/1148\",254593.331,593890.397,255593.331,594890.397],[\"9/968/1148\",255593.331,593890.397,256593.331,594890.397],[\"9/968/1144\",255593.331,592890.397,256593.331,593890.397],[\"9/964/1144\",254593.331,592890.397,255593.331,593890.397],[\"8/960/1136\",253593.331,590890.397,255593.331,592890.397],[\"8/968/1136\",255593.331,590890.397,257593.331,592890.397],[\"7/960/1120\",253593.331,586890.397,257593.331,590890.397],[\"7/960/1104\",253593.331,582890.397,257593.331,586890.397],[\"7/976/1104\",257593.331,582890.397,261593.331,586890.397],[\"7/992/1104\",261593.331,582890.397,265593.331,586890.397],[\"7/976/1088\",257593.331,578890.397,261593.331,582890.397],[\"7/992/1088\",261593.331,578890.397,265593.331,582890.397],[\"8/992/1080\",261593.331,576890.397,263593.331,578890.397],[\"8/984/1080\",259593.331,576890.397,261593.331,578890.397],[\"8/976/1080\",257593.331,576890.397,259593.331,578890.397],[\"7/960/1088\",253593.331,578890.397,257593.331,582890.397],[\"7/960/1072\",253593.331,574890.397,257593.331,578890.397],[\"8/976/1072\",257593.331,574890.397,259593.331,576890.397],[\"8/968/1064\",255593.331,572890.397,257593.331,574890.397],[\"8/960/1064\",253593.331,572890.397,255593.331,574890.397],[\"8/960/1056\",253593.331,570890.397,255593.331,572890.397],[\"9/964/1052\",254593.331,569890.397,255593.331,570890.397],[\"9/960/1052\",253593.331,569890.397,254593.331,570890.397],[\"9/960/1048\",253593.331,568890.397,254593.331,569890.397],[\"9/960/1044\",253593.331,567890.397,254593.331,568890.397],[\"9/960/1040\",253593.331,566890.397,254593.331,567890.397],[\"9/964/1040\",254593.331,566890.397,255593.331,567890.397],[\"9/964/1044\",254593.331,567890.397,255593.331,568890.397],[\"9/964/1048\",254593.331,568890.397,255593.331,569890.397],[\"8/968/1040\",255593.331,566890.397,257593.331,568890.397],[\"8/968/1048\",255593.331,568890.397,257593.331,570890.397],[\"8/968/1056\",255593.331,570890.397,257593.331,572890.397],[\"7/976/1040\",257593.331,566890.397,261593.331,570890.397],[\"8/992/1040\",261593.331,566890.397,263593.331,568890.397],[\"8/992/1048\",261593.331,568890.397,263593.331,570890.397],[\"8/992/1056\",261593.331,570890.397,263593.331,572890.397],[\"8/992/1064\",261593.331,572890.397,263593.331,574890.397],[\"7/976/1056\",257593.331,570890.397,261593.331,574890.397],[\"8/984/1072\",259593.331,574890.397,261593.331,576890.397],[\"8/992/1072\",261593.331,574890.397,263593.331,576890.397],[\"9/1000/1076\",263593.331,575890.397,264593.331,576890.397],[\"9/1000/1072\",263593.331,574890.397,264593.331,575890.397],[\"9/1004/1072\",264593.331,574890.397,265593.331,575890.397],[\"9/1004/1076\",264593.331,575890.397,265593.331,576890.397],[\"7/1008/1072\",265593.331,574890.397,269593.331,578890.397],[\"7/1008/1056\",265593.331,570890.397,269593.331,574890.397],[\"9/1004/1068\",264593.331,573890.397,265593.331,574890.397],[\"9/1004/1064\",264593.331,572890.397,265593.331,573890.397],[\"9/1000/1068\",263593.331,573890.397,264593.331,574890.397],[\"9/1000/1064\",263593.331,572890.397,264593.331,573890.397],[\"8/1000/1056\",263593.331,570890.397,265593.331,572890.397],[\"8/1000/1048\",263593.331,568890.397,265593.331,570890.397],[\"8/1000/1040\",263593.331,566890.397,265593.331,568890.397],[\"7/1008/1040\",265593.331,566890.397,269593.331,570890.397],[\"7/1024/1040\",269593.331,566890.397,273593.331,570890.397],[\"6/1024/1056\",269593.331,570890.397,277593.331,578890.397],[\"8/1000/1080\",263593.331,576890.397,265593.331,578890.397],[\"7/1008/1088\",265593.331,578890.397,269593.331,582890.397],[\"7/1008/1104\",265593.331,582890.397,269593.331,586890.397],[\"5/1024/1088\",269593.331,578890.397,285593.331,594890.397],[\"6/1056/1056\",277593.331,570890.397,285593.331,578890.397],[\"7/1040/1040\",273593.331,566890.397,277593.331,570890.397],[\"7/1040/1024\",273593.331,562890.397,277593.331,566890.397],[\"7/1040/1008\",273593.331,558890.397,277593.331,562890.397],[\"6/1056/992\",277593.331,554890.397,285593.331,562890.397],[\"7/1040/992\",273593.331,554890.397,277593.331,558890.397],[\"6/1024/960\",269593.331,546890.397,277593.331,554890.397],[\"7/1008/960\",265593.331,546890.397,269593.331,550890.397],[\"8/1000/960\",263593.331,546890.397,265593.331,548890.397],[\"8/1000/968\",263593.331,548890.397,265593.331,550890.397],[\"8/1000/976\",263593.331,550890.397,265593.331,552890.397],[\"7/1008/976\",265593.331,550890.397,269593.331,554890.397],[\"8/1000/984\",263593.331,552890.397,265593.331,554890.397],[\"7/1008/992\",265593.331,554890.397,269593.331,558890.397],[\"7/1024/992\",269593.331,554890.397,273593.331,558890.397],[\"7/1024/1008\",269593.331,558890.397,273593.331,562890.397],[\"7/1024/1024\",269593.331,562890.397,273593.331,566890.397],[\"7/1008/1024\",265593.331,562890.397,269593.331,566890.397],[\"7/1008/1008\",265593.331,558890.397,269593.331,562890.397],[\"9/988/1000\",260593.331,556890.397,261593.331,557890.397],[\"9/984/1000\",259593.331,556890.397,260593.331,557890.397],[\"9/984/1004\",259593.331,557890.397,260593.331,558890.397],[\"9/988/1004\",260593.331,557890.397,261593.331,558890.397],[\"7/976/1008\",257593.331,558890.397,261593.331,562890.397],[\"7/992/1008\",261593.331,558890.397,265593.331,562890.397],[\"7/992/1024\",261593.331,562890.397,265593.331,566890.397],[\"7/976/1024\",257593.331,562890.397,261593.331,566890.397],[\"7/960/1024\",253593.331,562890.397,257593.331,566890.397],[\"7/960/1008\",253593.331,558890.397,257593.331,562890.397],[\"8/976/1000\",257593.331,556890.397,259593.331,558890.397],[\"7/960/992\",253593.331,554890.397,257593.331,558890.397],[\"7/960/976\",253593.331,550890.397,257593.331,554890.397],[\"8/976/992\",257593.331,554890.397,259593.331,556890.397],[\"9/984/992\",259593.331,554890.397,260593.331,555890.397],[\"9/988/992\",260593.331,554890.397,261593.331,555890.397],[\"9/984/996\",259593.331,555890.397,260593.331,556890.397],[\"9/988/996\",260593.331,555890.397,261593.331,556890.397],[\"7/992/992\",261593.331,554890.397,265593.331,558890.397],[\"8/992/984\",261593.331,552890.397,263593.331,554890.397],[\"7/976/976\",257593.331,550890.397,261593.331,554890.397],[\"8/992/976\",261593.331,550890.397,263593.331,552890.397],[\"8/992/968\",261593.331,548890.397,263593.331,550890.397],[\"8/992/960\",261593.331,546890.397,263593.331,548890.397],[\"7/976/960\",257593.331,546890.397,261593.331,550890.397],[\"7/960/960\",253593.331,546890.397,257593.331,550890.397],[\"8/952/960\",251593.331,546890.397,253593.331,548890.397],[\"8/952/968\",251593.331,548890.397,253593.331,550890.397],[\"8/944/968\",249593.331,548890.397,251593.331,550890.397],[\"8/944/960\",249593.331,546890.397,251593.331,548890.397],[\"7/928/960\",245593.331,546890.397,249593.331,550890.397],[\"7/928/976\",245593.331,550890.397,249593.331,554890.397],[\"8/928/992\",245593.331,554890.397,247593.331,556890.397],[\"8/936/992\",247593.331,554890.397,249593.331,556890.397],[\"7/944/976\",249593.331,550890.397,253593.331,554890.397],[\"7/944/992\",249593.331,554890.397,253593.331,558890.397],[\"7/944/1008\",249593.331,558890.397,253593.331,562890.397],[\"7/944/1024\",249593.331,562890.397,253593.331,566890.397],[\"7/928/1024\",245593.331,562890.397,249593.331,566890.397],[\"8/920/1032\",243593.331,564890.397,245593.331,566890.397],[\"8/920/1024\",243593.331,562890.397,245593.331,564890.397],[\"7/928/1008\",245593.331,558890.397,249593.331,562890.397],[\"8/936/1000\",247593.331,556890.397,249593.331,558890.397],[\"8/928/1000\",245593.331,556890.397,247593.331,558890.397],[\"8/904/1000\",239593.331,556890.397,241593.331,558890.397],[\"7/896/1008\",237593.331,558890.397,241593.331,562890.397],[\"7/912/1008\",241593.331,558890.397,245593.331,562890.397],[\"8/912/1024\",241593.331,562890.397,243593.331,564890.397],[\"8/912/1032\",241593.331,564890.397,243593.331,566890.397],[\"7/896/1024\",237593.331,562890.397,241593.331,566890.397],[\"8/888/1024\",235593.331,562890.397,237593.331,564890.397],[\"8/888/1032\",235593.331,564890.397,237593.331,566890.397],[\"8/880/1032\",233593.331,564890.397,235593.331,566890.397],[\"8/880/1024\",233593.331,562890.397,235593.331,564890.397],[\"8/880/1016\",233593.331,560890.397,235593.331,562890.397],[\"9/880/1012\",233593.331,559890.397,234593.331,560890.397],[\"9/884/1012\",234593.331,559890.397,235593.331,560890.397],[\"9/888/1012\",235593.331,559890.397,236593.331,560890.397],[\"8/888/1016\",235593.331,560890.397,237593.331,562890.397],[\"9/892/1012\",236593.331,559890.397,237593.331,560890.397],[\"9/892/1008\",236593.331,558890.397,237593.331,559890.397],[\"8/896/1000\",237593.331,556890.397,239593.331,558890.397],[\"8/888/1000\",235593.331,556890.397,237593.331,558890.397],[\"9/884/1000\",234593.331,556890.397,235593.331,557890.397],[\"9/888/1008\",235593.331,558890.397,236593.331,559890.397],[\"9/884/1008\",234593.331,558890.397,235593.331,559890.397],[\"9/884/1004\",234593.331,557890.397,235593.331,558890.397],[\"9/880/1008\",233593.331,558890.397,234593.331,559890.397],[\"9/880/1004\",233593.331,557890.397,234593.331,558890.397],[\"9/880/1000\",233593.331,556890.397,234593.331,557890.397],[\"9/880/996\",233593.331,555890.397,234593.331,556890.397],[\"9/884/996\",234593.331,555890.397,235593.331,556890.397],[\"9/884/992\",234593.331,554890.397,235593.331,555890.397],[\"9/880/992\",233593.331,554890.397,234593.331,555890.397],[\"8/888/992\",235593.331,554890.397,237593.331,556890.397],[\"8/896/992\",237593.331,554890.397,239593.331,556890.397],[\"8/904/992\",239593.331,554890.397,241593.331,556890.397],[\"7/912/992\",241593.331,554890.397,245593.331,558890.397],[\"6/896/960\",237593.331,546890.397,245593.331,554890.397],[\"6/864/960\",229593.331,546890.397,237593.331,554890.397],[\"9/876/992\",232593.331,554890.397,233593.331,555890.397],[\"9/876/996\",232593.331,555890.397,233593.331,556890.397],[\"9/872/996\",231593.331,555890.397,232593.331,556890.397],[\"9/872/992\",231593.331,554890.397,232593.331,555890.397],[\"8/864/992\",229593.331,554890.397,231593.331,556890.397],[\"8/848/984\",225593.331,552890.397,227593.331,554890.397],[\"8/856/984\",227593.331,552890.397,229593.331,554890.397],[\"7/848/992\",225593.331,554890.397,229593.331,558890.397],[\"8/848/976\",225593.331,550890.397,227593.331,552890.397],[\"8/856/976\",227593.331,550890.397,229593.331,552890.397],[\"7/848/960\",225593.331,546890.397,229593.331,550890.397],[\"7/832/960\",221593.331,546890.397,225593.331,550890.397],[\"8/824/976\",219593.331,550890.397,221593.331,552890.397],[\"7/816/960\",217593.331,546890.397,221593.331,550890.397],[\"7/800/960\",213593.331,546890.397,217593.331,550890.397],[\"8/816/976\",217593.331,550890.397,219593.331,552890.397],[\"8/816/984\",217593.331,552890.397,219593.331,554890.397],[\"7/800/976\",213593.331,550890.397,217593.331,554890.397],[\"9/808/992\",215593.331,554890.397,216593.331,555890.397],[\"8/800/992\",213593.331,554890.397,215593.331,556890.397],[\"9/808/996\",215593.331,555890.397,216593.331,556890.397],[\"9/812/996\",216593.331,555890.397,217593.331,556890.397],[\"9/812/992\",216593.331,554890.397,217593.331,555890.397],[\"7/816/992\",217593.331,554890.397,221593.331,558890.397],[\"8/824/984\",219593.331,552890.397,221593.331,554890.397],[\"7/832/976\",221593.331,550890.397,225593.331,554890.397],[\"7/832/992\",221593.331,554890.397,225593.331,558890.397],[\"7/832/1008\",221593.331,558890.397,225593.331,562890.397],[\"7/816/1008\",217593.331,558890.397,221593.331,562890.397],[\"8/808/1000\",215593.331,556890.397,217593.331,558890.397],[\"8/800/1000\",213593.331,556890.397,215593.331,558890.397],[\"7/800/1008\",213593.331,558890.397,217593.331,562890.397],[\"7/800/1024\",213593.331,562890.397,217593.331,566890.397],[\"7/816/1024\",217593.331,562890.397,221593.331,566890.397],[\"7/832/1024\",221593.331,562890.397,225593.331,566890.397],[\"8/848/1032\",225593.331,564890.397,227593.331,566890.397],[\"8/856/1032\",227593.331,564890.397,229593.331,566890.397],[\"8/848/1024\",225593.331,562890.397,227593.331,564890.397],[\"8/856/1024\",227593.331,562890.397,229593.331,564890.397],[\"7/848/1008\",225593.331,558890.397,229593.331,562890.397],[\"9/864/1000\",229593.331,556890.397,230593.331,557890.397],[\"9/868/1000\",230593.331,556890.397,231593.331,557890.397],[\"9/868/1004\",230593.331,557890.397,231593.331,558890.397],[\"9/864/1004\",229593.331,557890.397,230593.331,558890.397],[\"9/872/1004\",231593.331,557890.397,232593.331,558890.397],[\"9/872/1000\",231593.331,556890.397,232593.331,557890.397],[\"9/876/1000\",232593.331,556890.397,233593.331,557890.397],[\"9/876/1004\",232593.331,557890.397,233593.331,558890.397],[\"7/864/1008\",229593.331,558890.397,233593.331,562890.397],[\"7/864/1024\",229593.331,562890.397,233593.331,566890.397],[\"7/864/1040\",229593.331,566890.397,233593.331,570890.397],[\"8/864/1056\",229593.331,570890.397,231593.331,572890.397],[\"8/872/1056\",231593.331,570890.397,233593.331,572890.397],[\"8/872/1064\",231593.331,572890.397,233593.331,574890.397],[\"8/872/1072\",231593.331,574890.397,233593.331,576890.397],[\"8/864/1072\",229593.331,574890.397,231593.331,576890.397],[\"8/864/1064\",229593.331,572890.397,231593.331,574890.397],[\"7/848/1056\",225593.331,570890.397,229593.331,574890.397],[\"7/848/1072\",225593.331,574890.397,229593.331,578890.397],[\"9/840/1068\",223593.331,573890.397,224593.331,574890.397],[\"9/840/1064\",223593.331,572890.397,224593.331,573890.397],[\"9/844/1068\",224593.331,573890.397,225593.331,574890.397],[\"9/844/1064\",224593.331,572890.397,225593.331,573890.397],[\"8/840/1056\",223593.331,570890.397,225593.331,572890.397],[\"7/848/1040\",225593.331,566890.397,229593.331,570890.397],[\"7/832/1040\",221593.331,566890.397,225593.331,570890.397],[\"9/836/1056\",222593.331,570890.397,223593.331,571890.397],[\"9/832/1056\",221593.331,570890.397,222593.331,571890.397],[\"8/824/1056\",219593.331,570890.397,221593.331,572890.397],[\"7/816/1040\",217593.331,566890.397,221593.331,570890.397],[\"7/800/1040\",213593.331,566890.397,217593.331,570890.397],[\"8/800/1056\",213593.331,570890.397,215593.331,572890.397],[\"8/808/1056\",215593.331,570890.397,217593.331,572890.397],[\"8/816/1056\",217593.331,570890.397,219593.331,572890.397],[\"8/816/1064\",217593.331,572890.397,219593.331,574890.397],[\"8/808/1064\",215593.331,572890.397,217593.331,574890.397],[\"8/800/1064\",213593.331,572890.397,215593.331,574890.397],[\"7/800/1072\",213593.331,574890.397,217593.331,578890.397],[\"8/816/1072\",217593.331,574890.397,219593.331,576890.397],[\"9/824/1076\",219593.331,575890.397,220593.331,576890.397],[\"9/828/1076\",220593.331,575890.397,221593.331,576890.397],[\"9/824/1072\",219593.331,574890.397,220593.331,575890.397],[\"9/828/1072\",220593.331,574890.397,221593.331,575890.397],[\"8/824/1064\",219593.331,572890.397,221593.331,574890.397],[\"9/832/1060\",221593.331,571890.397,222593.331,572890.397],[\"9/836/1060\",222593.331,571890.397,223593.331,572890.397],[\"8/832/1064\",221593.331,572890.397,223593.331,574890.397],[\"7/832/1072\",221593.331,574890.397,225593.331,578890.397],[\"7/832/1088\",221593.331,578890.397,225593.331,582890.397],[\"7/816/1088\",217593.331,578890.397,221593.331,582890.397],[\"8/824/1080\",219593.331,576890.397,221593.331,578890.397],[\"8/816/1080\",217593.331,576890.397,219593.331,578890.397],[\"8/800/1088\",213593.331,578890.397,215593.331,580890.397],[\"8/800/1096\",213593.331,580890.397,215593.331,582890.397],[\"8/808/1096\",215593.331,580890.397,217593.331,582890.397],[\"8/808/1088\",215593.331,578890.397,217593.331,580890.397],[\"7/800/1104\",213593.331,582890.397,217593.331,586890.397],[\"7/816/1104\",217593.331,582890.397,221593.331,586890.397],[\"8/832/1104\",221593.331,582890.397,223593.331,584890.397],[\"9/836/1112\",222593.331,584890.397,223593.331,585890.397],[\"9/832/1112\",221593.331,584890.397,222593.331,585890.397],[\"9/832/1116\",221593.331,585890.397,222593.331,586890.397],[\"9/836/1116\",222593.331,585890.397,223593.331,586890.397],[\"8/840/1112\",223593.331,584890.397,225593.331,586890.397],[\"7/848/1104\",225593.331,582890.397,229593.331,586890.397],[\"8/840/1104\",223593.331,582890.397,225593.331,584890.397],[\"8/856/1088\",227593.331,578890.397,229593.331,580890.397],[\"8/848/1088\",225593.331,578890.397,227593.331,580890.397],[\"8/848/1096\",225593.331,580890.397,227593.331,582890.397],[\"8/856/1096\",227593.331,580890.397,229593.331,582890.397],[\"8/864/1096\",229593.331,580890.397,231593.331,582890.397],[\"8/864/1088\",229593.331,578890.397,231593.331,580890.397],[\"8/864/1080\",229593.331,576890.397,231593.331,578890.397],[\"9/872/1084\",231593.331,577890.397,232593.331,578890.397],[\"9/872/1080\",231593.331,576890.397,232593.331,577890.397],[\"9/876/1080\",232593.331,576890.397,233593.331,577890.397],[\"9/876/1084\",232593.331,577890.397,233593.331,578890.397],[\"8/872/1088\",231593.331,578890.397,233593.331,580890.397],[\"9/872/1096\",231593.331,580890.397,232593.331,581890.397],[\"10/876/1098\",232593.331,581390.397,233093.331,581890.397],[\"10/876/1096\",232593.331,580890.397,233093.331,581390.397],[\"10/878/1096\",233093.331,580890.397,233593.331,581390.397],[\"10/878/1098\",233093.331,581390.397,233593.331,581890.397],[\"10/878/1100\",233093.331,581890.397,233593.331,582390.397],[\"10/876/1100\",232593.331,581890.397,233093.331,582390.397],[\"10/876/1102\",232593.331,582390.397,233093.331,582890.397],[\"10/876/1104\",232593.331,582890.397,233093.331,583390.397],[\"10/878/1102\",233093.331,582390.397,233593.331,582890.397],[\"10/878/1104\",233093.331,582890.397,233593.331,583390.397],[\"10/878/1106\",233093.331,583390.397,233593.331,583890.397],[\"9/876/1108\",232593.331,583890.397,233593.331,584890.397],[\"10/876/1106\",232593.331,583390.397,233093.331,583890.397],[\"9/872/1104\",231593.331,582890.397,232593.331,583890.397],[\"9/872/1108\",231593.331,583890.397,232593.331,584890.397],[\"9/872/1100\",231593.331,581890.397,232593.331,582890.397],[\"9/864/1108\",229593.331,583890.397,230593.331,584890.397],[\"9/864/1104\",229593.331,582890.397,230593.331,583890.397],[\"9/868/1104\",230593.331,582890.397,231593.331,583890.397],[\"9/868/1108\",230593.331,583890.397,231593.331,584890.397],[\"8/864/1112\",229593.331,584890.397,231593.331,586890.397],[\"8/872/1112\",231593.331,584890.397,233593.331,586890.397],[\"8/880/1112\",233593.331,584890.397,235593.331,586890.397],[\"9/880/1108\",233593.331,583890.397,234593.331,584890.397],[\"10/882/1106\",234093.331,583390.397,234593.331,583890.397],[\"10/880/1106\",233593.331,583390.397,234093.331,583890.397],[\"10/880/1104\",233593.331,582890.397,234093.331,583390.397],[\"10/880/1102\",233593.331,582390.397,234093.331,582890.397],[\"10/880/1100\",233593.331,581890.397,234093.331,582390.397],[\"10/882/1100\",234093.331,581890.397,234593.331,582390.397],[\"10/882/1102\",234093.331,582390.397,234593.331,582890.397],[\"10/882/1104\",234093.331,582890.397,234593.331,583390.397],[\"9/884/1100\",234593.331,581890.397,235593.331,582890.397],[\"9/888/1104\",235593.331,582890.397,236593.331,583890.397],[\"9/884/1104\",234593.331,582890.397,235593.331,583890.397],[\"9/884/1108\",234593.331,583890.397,235593.331,584890.397],[\"9/888/1108\",235593.331,583890.397,236593.331,584890.397],[\"9/892/1108\",236593.331,583890.397,237593.331,584890.397],[\"9/892/1104\",236593.331,582890.397,237593.331,583890.397],[\"8/896/1104\",237593.331,582890.397,239593.331,584890.397],[\"8/888/1112\",235593.331,584890.397,237593.331,586890.397],[\"8/896/1112\",237593.331,584890.397,239593.331,586890.397],[\"8/904/1112\",239593.331,584890.397,241593.331,586890.397],[\"7/912/1104\",241593.331,582890.397,245593.331,586890.397],[\"8/904/1104\",239593.331,582890.397,241593.331,584890.397],[\"8/904/1088\",239593.331,578890.397,241593.331,580890.397],[\"8/904/1096\",239593.331,580890.397,241593.331,582890.397],[\"7/912/1088\",241593.331,578890.397,245593.331,582890.397],[\"8/912/1080\",241593.331,576890.397,243593.331,578890.397],[\"8/904/1080\",239593.331,576890.397,241593.331,578890.397],[\"8/896/1080\",237593.331,576890.397,239593.331,578890.397],[\"9/892/1080\",236593.331,576890.397,237593.331,577890.397],[\"9/892/1084\",236593.331,577890.397,237593.331,578890.397],[\"8/896/1088\",237593.331,578890.397,239593.331,580890.397],[\"8/896/1096\",237593.331,580890.397,239593.331,582890.397],[\"8/888/1096\",235593.331,580890.397,237593.331,582890.397],[\"8/888/1088\",235593.331,578890.397,237593.331,580890.397],[\"9/884/1092\",234593.331,579890.397,235593.331,580890.397],[\"9/884/1096\",234593.331,580890.397,235593.331,581890.397],[\"10/882/1096\",234093.331,580890.397,234593.331,581390.397],[\"10/882/1098\",234093.331,581390.397,234593.331,581890.397],[\"10/880/1098\",233593.331,581390.397,234093.331,581890.397],[\"10/880/1096\",233593.331,580890.397,234093.331,581390.397],[\"9/880/1092\",233593.331,579890.397,234593.331,580890.397],[\"9/880/1088\",233593.331,578890.397,234593.331,579890.397],[\"9/884/1088\",234593.331,578890.397,235593.331,579890.397],[\"9/888/1084\",235593.331,577890.397,236593.331,578890.397],[\"9/888/1080\",235593.331,576890.397,236593.331,577890.397],[\"8/880/1080\",233593.331,576890.397,235593.331,578890.397],[\"8/880/1072\",233593.331,574890.397,235593.331,576890.397],[\"9/888/1072\",235593.331,574890.397,236593.331,575890.397],[\"9/888/1076\",235593.331,575890.397,236593.331,576890.397],[\"9/892/1076\",236593.331,575890.397,237593.331,576890.397],[\"8/896/1072\",237593.331,574890.397,239593.331,576890.397],[\"9/892/1072\",236593.331,574890.397,237593.331,575890.397],[\"8/888/1064\",235593.331,572890.397,237593.331,574890.397],[\"8/880/1064\",233593.331,572890.397,235593.331,574890.397],[\"8/880/1056\",233593.331,570890.397,235593.331,572890.397],[\"7/880/1040\",233593.331,566890.397,237593.331,570890.397],[\"8/896/1040\",237593.331,566890.397,239593.331,568890.397],[\"8/896/1048\",237593.331,568890.397,239593.331,570890.397],[\"8/888/1056\",235593.331,570890.397,237593.331,572890.397],[\"8/904/1048\",239593.331,568890.397,241593.331,570890.397],[\"9/904/1040\",239593.331,566890.397,240593.331,567890.397],[\"9/908/1040\",240593.331,566890.397,241593.331,567890.397],[\"9/908/1044\",240593.331,567890.397,241593.331,568890.397],[\"9/904/1044\",239593.331,567890.397,240593.331,568890.397],[\"7/912/1040\",241593.331,566890.397,245593.331,570890.397],[\"7/912/1056\",241593.331,570890.397,245593.331,574890.397],[\"7/896/1056\",237593.331,570890.397,241593.331,574890.397],[\"8/904/1072\",239593.331,574890.397,241593.331,576890.397],[\"8/912/1072\",241593.331,574890.397,243593.331,576890.397],[\"8/920/1072\",243593.331,574890.397,245593.331,576890.397],[\"9/928/1072\",245593.331,574890.397,246593.331,575890.397],[\"9/928/1076\",245593.331,575890.397,246593.331,576890.397],[\"9/932/1076\",246593.331,575890.397,247593.331,576890.397],[\"9/936/1076\",247593.331,575890.397,248593.331,576890.397],[\"9/936/1072\",247593.331,574890.397,248593.331,575890.397],[\"9/932/1072\",246593.331,574890.397,247593.331,575890.397],[\"7/928/1056\",245593.331,570890.397,249593.331,574890.397],[\"7/928/1040\",245593.331,566890.397,249593.331,570890.397],[\"8/944/1048\",249593.331,568890.397,251593.331,570890.397],[\"8/944/1040\",249593.331,566890.397,251593.331,568890.397],[\"8/952/1040\",251593.331,566890.397,253593.331,568890.397],[\"8/952/1048\",251593.331,568890.397,253593.331,570890.397],[\"7/944/1056\",249593.331,570890.397,253593.331,574890.397],[\"9/940/1072\",248593.331,574890.397,249593.331,575890.397],[\"9/940/1076\",248593.331,575890.397,249593.331,576890.397],[\"7/944/1072\",249593.331,574890.397,253593.331,578890.397],[\"7/944/1088\",249593.331,578890.397,253593.331,582890.397],[\"8/936/1080\",247593.331,576890.397,249593.331,578890.397],[\"8/928/1080\",245593.331,576890.397,247593.331,578890.397],[\"8/920/1080\",243593.331,576890.397,245593.331,578890.397],[\"7/928/1088\",245593.331,578890.397,249593.331,582890.397],[\"7/928/1104\",245593.331,582890.397,249593.331,586890.397],[\"7/944/1104\",249593.331,582890.397,253593.331,586890.397],[\"7/944/1120\",249593.331,586890.397,253593.331,590890.397],[\"8/944/1136\",249593.331,590890.397,251593.331,592890.397],[\"8/952/1136\",251593.331,590890.397,253593.331,592890.397],[\"9/952/1144\",251593.331,592890.397,252593.331,593890.397],[\"9/952/1148\",251593.331,593890.397,252593.331,594890.397],[\"9/956/1144\",252593.331,592890.397,253593.331,593890.397],[\"9/956/1148\",252593.331,593890.397,253593.331,594890.397],[\"7/944/1152\",249593.331,594890.397,253593.331,598890.397],[\"8/944/1144\",249593.331,592890.397,251593.331,594890.397],[\"7/928/1136\",245593.331,590890.397,249593.331,594890.397],[\"7/928/1152\",245593.331,594890.397,249593.331,598890.397],[\"8/920/1128\",243593.331,588890.397,245593.331,590890.397],[\"7/928/1120\",245593.331,586890.397,249593.331,590890.397],[\"8/920/1120\",243593.331,586890.397,245593.331,588890.397],[\"8/912/1120\",241593.331,586890.397,243593.331,588890.397],[\"8/912/1128\",241593.331,588890.397,243593.331,590890.397],[\"7/896/1120\",237593.331,586890.397,241593.331,590890.397],[\"7/880/1120\",233593.331,586890.397,237593.331,590890.397],[\"8/880/1136\",233593.331,590890.397,235593.331,592890.397],[\"9/888/1136\",235593.331,590890.397,236593.331,591890.397],[\"9/892/1136\",236593.331,590890.397,237593.331,591890.397],[\"8/888/1144\",235593.331,592890.397,237593.331,594890.397],[\"9/892/1140\",236593.331,591890.397,237593.331,592890.397],[\"9/888/1140\",235593.331,591890.397,236593.331,592890.397],[\"8/880/1144\",233593.331,592890.397,235593.331,594890.397],[\"7/880/1152\",233593.331,594890.397,237593.331,598890.397],[\"7/896/1152\",237593.331,594890.397,241593.331,598890.397],[\"7/896/1136\",237593.331,590890.397,241593.331,594890.397],[\"7/912/1136\",241593.331,590890.397,245593.331,594890.397],[\"7/912/1152\",241593.331,594890.397,245593.331,598890.397],[\"7/912/1168\",241593.331,598890.397,245593.331,602890.397],[\"7/896/1168\",237593.331,598890.397,241593.331,602890.397],[\"7/880/1168\",233593.331,598890.397,237593.331,602890.397],[\"7/896/1184\",237593.331,602890.397,241593.331,606890.397],[\"7/912/1184\",241593.331,602890.397,245593.331,606890.397],[\"7/928/1168\",245593.331,598890.397,249593.331,602890.397],[\"7/944/1168\",249593.331,598890.397,253593.331,602890.397],[\"6/928/1184\",245593.331,602890.397,253593.331,610890.397],[\"7/912/1200\",241593.331,606890.397,245593.331,610890.397],[\"7/896/1200\",237593.331,606890.397,241593.331,610890.397],[\"7/800/1168\",213593.331,598890.397,217593.331,602890.397],[\"7/816/1168\",217593.331,598890.397,221593.331,602890.397],[\"7/832/1168\",221593.331,598890.397,225593.331,602890.397],[\"6/832/1184\",221593.331,602890.397,229593.331,610890.397],[\"6/864/1184\",229593.331,602890.397,237593.331,610890.397],[\"7/864/1168\",229593.331,598890.397,233593.331,602890.397],[\"7/848/1168\",225593.331,598890.397,229593.331,602890.397],[\"7/848/1136\",225593.331,590890.397,229593.331,594890.397],[\"7/848/1152\",225593.331,594890.397,229593.331,598890.397],[\"7/864/1152\",229593.331,594890.397,233593.331,598890.397],[\"8/872/1144\",231593.331,592890.397,233593.331,594890.397],[\"9/868/1144\",230593.331,592890.397,231593.331,593890.397],[\"9/868/1148\",230593.331,593890.397,231593.331,594890.397],[\"9/864/1148\",229593.331,593890.397,230593.331,594890.397],[\"9/864/1144\",229593.331,592890.397,230593.331,593890.397],[\"8/864/1136\",229593.331,590890.397,231593.331,592890.397],[\"8/872/1136\",231593.331,590890.397,233593.331,592890.397],[\"7/864/1120\",229593.331,586890.397,233593.331,590890.397],[\"7/848/1120\",225593.331,586890.397,229593.331,590890.397],[\"7/832/1120\",221593.331,586890.397,225593.331,590890.397],[\"7/832/1136\",221593.331,590890.397,225593.331,594890.397],[\"7/832/1152\",221593.331,594890.397,225593.331,598890.397],[\"7/816/1152\",217593.331,594890.397,221593.331,598890.397],[\"7/800/1152\",213593.331,594890.397,217593.331,598890.397],[\"6/800/1120\",213593.331,586890.397,221593.331,594890.397],[\"7/784/1120\",209593.331,586890.397,213593.331,590890.397],[\"7/784/1136\",209593.331,590890.397,213593.331,594890.397],[\"7/768/1136\",205593.331,590890.397,209593.331,594890.397],[\"8/776/1128\",207593.331,588890.397,209593.331,590890.397],[\"8/768/1128\",205593.331,588890.397,207593.331,590890.397],[\"8/776/1120\",207593.331,586890.397,209593.331,588890.397],[\"8/768/1120\",205593.331,586890.397,207593.331,588890.397],[\"7/752/1120\",201593.331,586890.397,205593.331,590890.397],[\"7/736/1120\",197593.331,586890.397,201593.331,590890.397],[\"8/728/1120\",195593.331,586890.397,197593.331,588890.397],[\"8/720/1120\",193593.331,586890.397,195593.331,588890.397],[\"8/720/1128\",193593.331,588890.397,195593.331,590890.397],[\"8/720/1136\",193593.331,590890.397,195593.331,592890.397],[\"8/728/1136\",195593.331,590890.397,197593.331,592890.397],[\"8/728/1128\",195593.331,588890.397,197593.331,590890.397],[\"9/732/1144\",196593.331,592890.397,197593.331,593890.397],[\"9/732/1148\",196593.331,593890.397,197593.331,594890.397],[\"8/720/1144\",193593.331,592890.397,195593.331,594890.397],[\"9/728/1144\",195593.331,592890.397,196593.331,593890.397],[\"9/728/1148\",195593.331,593890.397,196593.331,594890.397],[\"7/736/1152\",197593.331,594890.397,201593.331,598890.397],[\"7/736/1136\",197593.331,590890.397,201593.331,594890.397],[\"7/752/1136\",201593.331,590890.397,205593.331,594890.397],[\"7/752/1152\",201593.331,594890.397,205593.331,598890.397],[\"7/752/1168\",201593.331,598890.397,205593.331,602890.397],[\"7/736/1168\",197593.331,598890.397,201593.331,602890.397],[\"6/736/1184\",197593.331,602890.397,205593.331,610890.397],[\"6/768/1152\",205593.331,594890.397,213593.331,602890.397],[\"6/768/1184\",205593.331,602890.397,213593.331,610890.397],[\"5/768/1216\",205593.331,610890.397,221593.331,626890.397],[\"5/704/1216\",189593.331,610890.397,205593.331,626890.397],[\"6/640/1184\",173593.331,602890.397,181593.331,610890.397],[\"6/672/1184\",181593.331,602890.397,189593.331,610890.397],[\"6/704/1184\",189593.331,602890.397,197593.331,610890.397],[\"6/704/1152\",189593.331,594890.397,197593.331,602890.397],[\"6/672/1152\",181593.331,594890.397,189593.331,602890.397],[\"7/688/1136\",185593.331,590890.397,189593.331,594890.397],[\"7/704/1136\",189593.331,590890.397,193593.331,594890.397],[\"7/704/1120\",189593.331,586890.397,193593.331,590890.397],[\"7/688/1120\",185593.331,586890.397,189593.331,590890.397],[\"7/672/1120\",181593.331,586890.397,185593.331,590890.397],[\"7/656/1120\",177593.331,586890.397,181593.331,590890.397],[\"7/672/1136\",181593.331,590890.397,185593.331,594890.397],[\"7/656/1136\",177593.331,590890.397,181593.331,594890.397],[\"7/640/1136\",173593.331,590890.397,177593.331,594890.397],[\"7/640/1120\",173593.331,586890.397,177593.331,590890.397],[\"7/640/1104\",173593.331,582890.397,177593.331,586890.397],[\"8/656/1104\",177593.331,582890.397,179593.331,584890.397],[\"8/656/1112\",177593.331,584890.397,179593.331,586890.397],[\"9/664/1112\",179593.331,584890.397,180593.331,585890.397],[\"9/668/1112\",180593.331,584890.397,181593.331,585890.397],[\"9/664/1116\",179593.331,585890.397,180593.331,586890.397],[\"9/668/1116\",180593.331,585890.397,181593.331,586890.397],[\"7/672/1104\",181593.331,582890.397,185593.331,586890.397],[\"8/664/1104\",179593.331,582890.397,181593.331,584890.397],[\"9/664/1092\",179593.331,579890.397,180593.331,580890.397],[\"10/668/1090\",180593.331,579390.397,181093.331,579890.397],[\"10/668/1092\",180593.331,579890.397,181093.331,580390.397],[\"10/668/1094\",180593.331,580390.397,181093.331,580890.397],[\"8/664/1096\",179593.331,580890.397,181593.331,582890.397],[\"8/672/1096\",181593.331,580890.397,183593.331,582890.397],[\"10/676/1092\",182593.331,579890.397,183093.331,580390.397],[\"10/676/1094\",182593.331,580390.397,183093.331,580890.397],[\"10/678/1094\",183093.331,580390.397,183593.331,580890.397],[\"10/678/1092\",183093.331,579890.397,183593.331,580390.397],[\"10/678/1090\",183093.331,579390.397,183593.331,579890.397],[\"10/676/1090\",182593.331,579390.397,183093.331,579890.397],[\"10/674/1090\",182093.331,579390.397,182593.331,579890.397],[\"10/672/1090\",181593.331,579390.397,182093.331,579890.397],[\"9/672/1092\",181593.331,579890.397,182593.331,580890.397],[\"10/670/1094\",181093.331,580390.397,181593.331,580890.397],[\"10/670/1092\",181093.331,579890.397,181593.331,580390.397],[\"10/670/1090\",181093.331,579390.397,181593.331,579890.397],[\"10/670/1088\",181093.331,578890.397,181593.331,579390.397],[\"10/672/1086\",181593.331,578390.397,182093.331,578890.397],[\"10/674/1086\",182093.331,578390.397,182593.331,578890.397],[\"10/672/1088\",181593.331,578890.397,182093.331,579390.397],[\"10/674/1088\",182093.331,578890.397,182593.331,579390.397],[\"10/676/1088\",182593.331,578890.397,183093.331,579390.397],[\"10/678/1088\",183093.331,578890.397,183593.331,579390.397],[\"9/676/1084\",182593.331,577890.397,183593.331,578890.397],[\"9/676/1080\",182593.331,576890.397,183593.331,577890.397],[\"9/672/1080\",181593.331,576890.397,182593.331,577890.397],[\"10/674/1084\",182093.331,577890.397,182593.331,578390.397],[\"10/672/1084\",181593.331,577890.397,182093.331,578390.397],[\"10/668/1088\",180593.331,578890.397,181093.331,579390.397],[\"9/664/1088\",179593.331,578890.397,180593.331,579890.397],[\"8/656/1088\",177593.331,578890.397,179593.331,580890.397],[\"8/656/1096\",177593.331,580890.397,179593.331,582890.397],[\"7/640/1088\",173593.331,578890.397,177593.331,582890.397],[\"7/640/1072\",173593.331,574890.397,177593.331,578890.397],[\"7/640/1056\",173593.331,570890.397,177593.331,574890.397],[\"7/640/1040\",173593.331,566890.397,177593.331,570890.397],[\"7/656/1040\",177593.331,566890.397,181593.331,570890.397],[\"8/672/1040\",181593.331,566890.397,183593.331,568890.397],[\"8/672/1048\",181593.331,568890.397,183593.331,570890.397],[\"7/672/1056\",181593.331,570890.397,185593.331,574890.397],[\"7/656/1056\",177593.331,570890.397,181593.331,574890.397],[\"7/656/1072\",177593.331,574890.397,181593.331,578890.397],[\"8/672/1072\",181593.331,574890.397,183593.331,576890.397],[\"8/680/1072\",183593.331,574890.397,185593.331,576890.397],[\"7/688/1072\",185593.331,574890.397,189593.331,578890.397],[\"7/688/1056\",185593.331,570890.397,189593.331,574890.397],[\"8/680/1048\",183593.331,568890.397,185593.331,570890.397],[\"9/680/1044\",183593.331,567890.397,184593.331,568890.397],[\"9/680/1040\",183593.331,566890.397,184593.331,567890.397],[\"9/684/1040\",184593.331,566890.397,185593.331,567890.397],[\"9/684/1044\",184593.331,567890.397,185593.331,568890.397],[\"7/688/1040\",185593.331,566890.397,189593.331,570890.397],[\"7/704/1056\",189593.331,570890.397,193593.331,574890.397],[\"7/704/1072\",189593.331,574890.397,193593.331,578890.397],[\"8/712/1088\",191593.331,578890.397,193593.331,580890.397],[\"8/712/1096\",191593.331,580890.397,193593.331,582890.397],[\"8/704/1088\",189593.331,578890.397,191593.331,580890.397],[\"8/704/1096\",189593.331,580890.397,191593.331,582890.397],[\"9/684/1080\",184593.331,576890.397,185593.331,577890.397],[\"9/680/1080\",183593.331,576890.397,184593.331,577890.397],[\"9/680/1084\",183593.331,577890.397,184593.331,578890.397],[\"9/680/1088\",183593.331,578890.397,184593.331,579890.397],[\"9/684/1088\",184593.331,578890.397,185593.331,579890.397],[\"9/684/1084\",184593.331,577890.397,185593.331,578890.397],[\"9/684/1092\",184593.331,579890.397,185593.331,580890.397],[\"9/680/1092\",183593.331,579890.397,184593.331,580890.397],[\"8/680/1096\",183593.331,580890.397,185593.331,582890.397],[\"8/688/1096\",185593.331,580890.397,187593.331,582890.397],[\"8/688/1088\",185593.331,578890.397,187593.331,580890.397],[\"8/696/1088\",187593.331,578890.397,189593.331,580890.397],[\"8/696/1096\",187593.331,580890.397,189593.331,582890.397],[\"8/696/1104\",187593.331,582890.397,189593.331,584890.397],[\"8/688/1104\",185593.331,582890.397,187593.331,584890.397],[\"8/688/1112\",185593.331,584890.397,187593.331,586890.397],[\"8/696/1112\",187593.331,584890.397,189593.331,586890.397],[\"7/704/1104\",189593.331,582890.397,193593.331,586890.397],[\"8/720/1112\",193593.331,584890.397,195593.331,586890.397],[\"8/728/1112\",195593.331,584890.397,197593.331,586890.397],[\"9/736/1116\",197593.331,585890.397,198593.331,586890.397],[\"9/736/1112\",197593.331,584890.397,198593.331,585890.397],[\"8/728/1104\",195593.331,582890.397,197593.331,584890.397],[\"8/736/1104\",197593.331,582890.397,199593.331,584890.397],[\"8/720/1104\",193593.331,582890.397,195593.331,584890.397],[\"8/720/1096\",193593.331,580890.397,195593.331,582890.397],[\"8/720/1088\",193593.331,578890.397,195593.331,580890.397],[\"8/720/1080\",193593.331,576890.397,195593.331,578890.397],[\"8/728/1080\",195593.331,576890.397,197593.331,578890.397],[\"8/728/1088\",195593.331,578890.397,197593.331,580890.397],[\"8/728/1096\",195593.331,580890.397,197593.331,582890.397],[\"7/736/1088\",197593.331,578890.397,201593.331,582890.397],[\"8/752/1080\",201593.331,576890.397,203593.331,578890.397],[\"8/752/1088\",201593.331,578890.397,203593.331,580890.397],[\"8/752/1096\",201593.331,580890.397,203593.331,582890.397],[\"8/752/1104\",201593.331,582890.397,203593.331,584890.397],[\"8/744/1104\",199593.331,582890.397,201593.331,584890.397],[\"9/740/1112\",198593.331,584890.397,199593.331,585890.397],[\"9/740/1116\",198593.331,585890.397,199593.331,586890.397],[\"8/744/1112\",199593.331,584890.397,201593.331,586890.397],[\"8/752/1112\",201593.331,584890.397,203593.331,586890.397],[\"8/760/1112\",203593.331,584890.397,205593.331,586890.397],[\"8/760/1104\",203593.331,582890.397,205593.331,584890.397],[\"7/768/1104\",205593.331,582890.397,209593.331,586890.397],[\"7/784/1104\",209593.331,582890.397,213593.331,586890.397],[\"7/784/1088\",209593.331,578890.397,213593.331,582890.397],[\"8/776/1080\",207593.331,576890.397,209593.331,578890.397],[\"9/772/1080\",206593.331,576890.397,207593.331,577890.397],[\"9/772/1084\",206593.331,577890.397,207593.331,578890.397],[\"7/768/1088\",205593.331,578890.397,209593.331,582890.397],[\"8/760/1096\",203593.331,580890.397,205593.331,582890.397],[\"8/760/1088\",203593.331,578890.397,205593.331,580890.397],[\"9/760/1084\",203593.331,577890.397,204593.331,578890.397],[\"9/768/1084\",205593.331,577890.397,206593.331,578890.397],[\"9/764/1084\",204593.331,577890.397,205593.331,578890.397],[\"9/768/1080\",205593.331,576890.397,206593.331,577890.397],[\"9/764/1080\",204593.331,576890.397,205593.331,577890.397],[\"9/760/1080\",203593.331,576890.397,204593.331,577890.397],[\"8/760/1072\",203593.331,574890.397,205593.331,576890.397],[\"8/760/1064\",203593.331,572890.397,205593.331,574890.397],[\"7/768/1056\",205593.331,570890.397,209593.331,574890.397],[\"8/768/1072\",205593.331,574890.397,207593.331,576890.397],[\"8/776/1072\",207593.331,574890.397,209593.331,576890.397],[\"7/784/1072\",209593.331,574890.397,213593.331,578890.397],[\"7/784/1056\",209593.331,570890.397,213593.331,574890.397],[\"7/784/1040\",209593.331,566890.397,213593.331,570890.397],[\"8/776/1040\",207593.331,566890.397,209593.331,568890.397],[\"8/768/1040\",205593.331,566890.397,207593.331,568890.397],[\"8/776/1048\",207593.331,568890.397,209593.331,570890.397],[\"8/768/1048\",205593.331,568890.397,207593.331,570890.397],[\"8/760/1056\",203593.331,570890.397,205593.331,572890.397],[\"8/760/1048\",203593.331,568890.397,205593.331,570890.397],[\"8/760/1040\",203593.331,566890.397,205593.331,568890.397],[\"9/756/1040\",202593.331,566890.397,203593.331,567890.397],[\"9/756/1044\",202593.331,567890.397,203593.331,568890.397],[\"9/756/1048\",202593.331,568890.397,203593.331,569890.397],[\"9/752/1044\",201593.331,567890.397,202593.331,568890.397],[\"9/752/1048\",201593.331,568890.397,202593.331,569890.397],[\"9/752/1040\",201593.331,566890.397,202593.331,567890.397],[\"9/748/1040\",200593.331,566890.397,201593.331,567890.397],[\"9/744/1040\",199593.331,566890.397,200593.331,567890.397],[\"9/744/1044\",199593.331,567890.397,200593.331,568890.397],[\"9/748/1044\",200593.331,567890.397,201593.331,568890.397],[\"8/744/1048\",199593.331,568890.397,201593.331,570890.397],[\"9/752/1052\",201593.331,569890.397,202593.331,570890.397],[\"9/756/1052\",202593.331,569890.397,203593.331,570890.397],[\"8/752/1056\",201593.331,570890.397,203593.331,572890.397],[\"8/752/1064\",201593.331,572890.397,203593.331,574890.397],[\"8/752/1072\",201593.331,574890.397,203593.331,576890.397],[\"7/736/1072\",197593.331,574890.397,201593.331,578890.397],[\"7/736/1056\",197593.331,570890.397,201593.331,574890.397],[\"8/728/1072\",195593.331,574890.397,197593.331,576890.397],[\"8/720/1072\",193593.331,574890.397,195593.331,576890.397],[\"7/720/1056\",193593.331,570890.397,197593.331,574890.397],[\"8/736/1048\",197593.331,568890.397,199593.331,570890.397],[\"8/736/1040\",197593.331,566890.397,199593.331,568890.397],[\"8/736/1032\",197593.331,564890.397,199593.331,566890.397],[\"8/736/1024\",197593.331,562890.397,199593.331,564890.397],[\"7/720/1008\",193593.331,558890.397,197593.331,562890.397],[\"8/736/1000\",197593.331,556890.397,199593.331,558890.397],[\"7/736/1008\",197593.331,558890.397,201593.331,562890.397],[\"9/744/1000\",199593.331,556890.397,200593.331,557890.397],[\"9/748/1000\",200593.331,556890.397,201593.331,557890.397],[\"9/748/1004\",200593.331,557890.397,201593.331,558890.397],[\"9/744/1004\",199593.331,557890.397,200593.331,558890.397],[\"7/752/1008\",201593.331,558890.397,205593.331,562890.397],[\"8/744/1024\",199593.331,562890.397,201593.331,564890.397],[\"8/744/1032\",199593.331,564890.397,201593.331,566890.397],[\"7/752/1024\",201593.331,562890.397,205593.331,566890.397],[\"7/768/1024\",205593.331,562890.397,209593.331,566890.397],[\"7/784/1024\",209593.331,562890.397,213593.331,566890.397],[\"7/784/1008\",209593.331,558890.397,213593.331,562890.397],[\"7/768/1008\",205593.331,558890.397,209593.331,562890.397],[\"7/768/992\",205593.331,554890.397,209593.331,558890.397],[\"7/784/992\",209593.331,554890.397,213593.331,558890.397],[\"6/768/960\",205593.331,546890.397,213593.331,554890.397],[\"7/752/960\",201593.331,546890.397,205593.331,550890.397],[\"7/736/960\",197593.331,546890.397,201593.331,550890.397],[\"7/752/976\",201593.331,550890.397,205593.331,554890.397],[\"7/752/992\",201593.331,554890.397,205593.331,558890.397],[\"8/744/992\",199593.331,554890.397,201593.331,556890.397],[\"7/736/976\",197593.331,550890.397,201593.331,554890.397],[\"8/736/992\",197593.331,554890.397,199593.331,556890.397],[\"7/720/992\",193593.331,554890.397,197593.331,558890.397],[\"7/720/976\",193593.331,550890.397,197593.331,554890.397],[\"7/720/960\",193593.331,546890.397,197593.331,550890.397],[\"7/704/960\",189593.331,546890.397,193593.331,550890.397],[\"9/716/976\",192593.331,550890.397,193593.331,551890.397],[\"9/712/976\",191593.331,550890.397,192593.331,551890.397],[\"9/708/976\",190593.331,550890.397,191593.331,551890.397],[\"9/704/976\",189593.331,550890.397,190593.331,551890.397],[\"7/688/960\",185593.331,546890.397,189593.331,550890.397],[\"8/680/976\",183593.331,550890.397,185593.331,552890.397],[\"7/688/976\",185593.331,550890.397,189593.331,554890.397],[\"8/680/984\",183593.331,552890.397,185593.331,554890.397],[\"7/688/992\",185593.331,554890.397,189593.331,558890.397],[\"9/704/980\",189593.331,551890.397,190593.331,552890.397],[\"9/708/980\",190593.331,551890.397,191593.331,552890.397],[\"9/708/984\",190593.331,552890.397,191593.331,553890.397],[\"9/704/984\",189593.331,552890.397,190593.331,553890.397],[\"9/704/988\",189593.331,553890.397,190593.331,554890.397],[\"9/708/988\",190593.331,553890.397,191593.331,554890.397],[\"9/712/980\",191593.331,551890.397,192593.331,552890.397],[\"9/716/980\",192593.331,551890.397,193593.331,552890.397],[\"8/712/984\",191593.331,552890.397,193593.331,554890.397],[\"7/704/992\",189593.331,554890.397,193593.331,558890.397],[\"7/704/1008\",189593.331,558890.397,193593.331,562890.397],[\"6/704/1024\",189593.331,562890.397,197593.331,570890.397],[\"7/688/1024\",185593.331,562890.397,189593.331,566890.397],[\"7/688/1008\",185593.331,558890.397,189593.331,562890.397],[\"7/656/1008\",177593.331,558890.397,181593.331,562890.397],[\"7/672/1008\",181593.331,558890.397,185593.331,562890.397],[\"7/672/1024\",181593.331,562890.397,185593.331,566890.397],[\"7/656/1024\",177593.331,562890.397,181593.331,566890.397],[\"7/640/1024\",173593.331,562890.397,177593.331,566890.397],[\"9/644/1020\",174593.331,561890.397,175593.331,562890.397],[\"9/640/1020\",173593.331,561890.397,174593.331,562890.397],[\"9/640/1016\",173593.331,560890.397,174593.331,561890.397],[\"9/640/1012\",173593.331,559890.397,174593.331,560890.397],[\"9/644/1012\",174593.331,559890.397,175593.331,560890.397],[\"9/644/1016\",174593.331,560890.397,175593.331,561890.397],[\"8/648/1016\",175593.331,560890.397,177593.331,562890.397],[\"8/648/1008\",175593.331,558890.397,177593.331,560890.397],[\"9/644/1008\",174593.331,558890.397,175593.331,559890.397],[\"9/640/1008\",173593.331,558890.397,174593.331,559890.397],[\"7/640/992\",173593.331,554890.397,177593.331,558890.397],[\"7/640/976\",173593.331,550890.397,177593.331,554890.397],[\"7/656/992\",177593.331,554890.397,181593.331,558890.397],[\"7/672/992\",181593.331,554890.397,185593.331,558890.397],[\"9/672/984\",181593.331,552890.397,182593.331,553890.397],[\"9/672/988\",181593.331,553890.397,182593.331,554890.397],[\"9/676/988\",182593.331,553890.397,183593.331,554890.397],[\"9/676/984\",182593.331,552890.397,183593.331,553890.397],[\"7/656/976\",177593.331,550890.397,181593.331,554890.397],[\"8/672/976\",181593.331,550890.397,183593.331,552890.397],[\"7/672/960\",181593.331,546890.397,185593.331,550890.397],[\"7/656/960\",177593.331,546890.397,181593.331,550890.397],[\"7/640/960\",173593.331,546890.397,177593.331,550890.397],[\"7/640/944\",173593.331,542890.397,177593.331,546890.397],[\"8/640/936\",173593.331,540890.397,175593.331,542890.397],[\"9/648/932\",175593.331,539890.397,176593.331,540890.397],[\"8/640/928\",173593.331,538890.397,175593.331,540890.397],[\"9/648/928\",175593.331,538890.397,176593.331,539890.397],[\"9/652/928\",176593.331,538890.397,177593.331,539890.397],[\"9/652/932\",176593.331,539890.397,177593.331,540890.397],[\"8/648/936\",175593.331,540890.397,177593.331,542890.397],[\"7/656/928\",177593.331,538890.397,181593.331,542890.397],[\"7/656/944\",177593.331,542890.397,181593.331,546890.397],[\"6/672/928\",181593.331,538890.397,189593.331,546890.397],[\"7/704/944\",189593.331,542890.397,193593.331,546890.397],[\"7/704/928\",189593.331,538890.397,193593.331,542890.397],[\"6/672/896\",181593.331,530890.397,189593.331,538890.397],[\"7/704/912\",189593.331,534890.397,193593.331,538890.397],[\"7/704/896\",189593.331,530890.397,193593.331,534890.397],[\"7/688/880\",185593.331,526890.397,189593.331,530890.397],[\"7/672/880\",181593.331,526890.397,185593.331,530890.397],[\"7/656/880\",177593.331,526890.397,181593.331,530890.397],[\"6/640/896\",173593.331,530890.397,181593.331,538890.397],[\"7/640/880\",173593.331,526890.397,177593.331,530890.397],[\"7/640/864\",173593.331,522890.397,177593.331,526890.397],[\"8/656/864\",177593.331,522890.397,179593.331,524890.397],[\"9/656/872\",177593.331,524890.397,178593.331,525890.397],[\"9/656/876\",177593.331,525890.397,178593.331,526890.397],[\"9/660/876\",178593.331,525890.397,179593.331,526890.397],[\"9/660/872\",178593.331,524890.397,179593.331,525890.397],[\"8/664/872\",179593.331,524890.397,181593.331,526890.397],[\"7/672/864\",181593.331,522890.397,185593.331,526890.397],[\"8/664/864\",179593.331,522890.397,181593.331,524890.397],[\"6/640/832\",173593.331,514890.397,181593.331,522890.397],[\"6/640/800\",173593.331,506890.397,181593.331,514890.397],[\"7/672/800\",181593.331,506890.397,185593.331,510890.397],[\"7/672/816\",181593.331,510890.397,185593.331,514890.397],[\"7/688/816\",185593.331,510890.397,189593.331,514890.397],[\"8/688/800\",185593.331,506890.397,187593.331,508890.397],[\"9/696/800\",187593.331,506890.397,188593.331,507890.397],[\"9/696/804\",187593.331,507890.397,188593.331,508890.397],[\"8/696/808\",187593.331,508890.397,189593.331,510890.397],[\"8/688/808\",185593.331,508890.397,187593.331,510890.397],[\"8/704/808\",189593.331,508890.397,191593.331,510890.397],[\"10/704/806\",189593.331,508390.397,190093.331,508890.397],[\"9/700/804\",188593.331,507890.397,189593.331,508890.397],[\"9/700/800\",188593.331,506890.397,189593.331,507890.397],[\"10/704/804\",189593.331,507890.397,190093.331,508390.397],[\"10/706/804\",190093.331,507890.397,190593.331,508390.397],[\"9/704/800\",189593.331,506890.397,190593.331,507890.397],[\"10/708/800\",190593.331,506890.397,191093.331,507390.397],[\"10/708/802\",190593.331,507390.397,191093.331,507890.397],[\"9/708/804\",190593.331,507890.397,191593.331,508890.397],[\"10/706/806\",190093.331,508390.397,190593.331,508890.397],[\"9/712/808\",191593.331,508890.397,192593.331,509890.397],[\"9/712/804\",191593.331,507890.397,192593.331,508890.397],[\"10/710/802\",191093.331,507390.397,191593.331,507890.397],[\"10/710/800\",191093.331,506890.397,191593.331,507390.397],[\"9/712/800\",191593.331,506890.397,192593.331,507890.397],[\"9/716/800\",192593.331,506890.397,193593.331,507890.397],[\"9/716/804\",192593.331,507890.397,193593.331,508890.397],[\"9/716/808\",192593.331,508890.397,193593.331,509890.397],[\"9/716/812\",192593.331,509890.397,193593.331,510890.397],[\"9/712/812\",191593.331,509890.397,192593.331,510890.397],[\"7/704/816\",189593.331,510890.397,193593.331,514890.397],[\"7/704/832\",189593.331,514890.397,193593.331,518890.397],[\"7/704/848\",189593.331,518890.397,193593.331,522890.397],[\"6/672/832\",181593.331,514890.397,189593.331,522890.397],[\"7/688/864\",185593.331,522890.397,189593.331,526890.397],[\"6/704/864\",189593.331,522890.397,197593.331,530890.397],[\"7/736/864\",197593.331,522890.397,201593.331,526890.397],[\"7/752/864\",201593.331,522890.397,205593.331,526890.397],[\"7/736/848\",197593.331,518890.397,201593.331,522890.397],[\"7/752/848\",201593.331,518890.397,205593.331,522890.397],[\"8/744/840\",199593.331,516890.397,201593.331,518890.397],[\"8/736/840\",197593.331,516890.397,199593.331,518890.397],[\"7/720/848\",193593.331,518890.397,197593.331,522890.397],[\"7/720/832\",193593.331,514890.397,197593.331,518890.397],[\"9/736/836\",197593.331,515890.397,198593.331,516890.397],[\"9/736/832\",197593.331,514890.397,198593.331,515890.397],[\"7/720/816\",193593.331,510890.397,197593.331,514890.397],[\"7/720/800\",193593.331,506890.397,197593.331,510890.397],[\"7/736/800\",197593.331,506890.397,201593.331,510890.397],[\"7/752/800\",201593.331,506890.397,205593.331,510890.397],[\"9/752/816\",201593.331,510890.397,202593.331,511890.397],[\"9/756/816\",202593.331,510890.397,203593.331,511890.397],[\"9/756/820\",202593.331,511890.397,203593.331,512890.397],[\"8/752/824\",201593.331,512890.397,203593.331,514890.397],[\"9/752/820\",201593.331,511890.397,202593.331,512890.397],[\"7/736/816\",197593.331,510890.397,201593.331,514890.397],[\"9/740/832\",198593.331,514890.397,199593.331,515890.397],[\"9/740/836\",198593.331,515890.397,199593.331,516890.397],[\"8/744/832\",199593.331,514890.397,201593.331,516890.397],[\"7/752/832\",201593.331,514890.397,205593.331,518890.397],[\"7/768/832\",205593.331,514890.397,209593.331,518890.397],[\"7/768/816\",205593.331,510890.397,209593.331,514890.397],[\"8/760/824\",203593.331,512890.397,205593.331,514890.397],[\"8/760/816\",203593.331,510890.397,205593.331,512890.397],[\"7/768/800\",205593.331,506890.397,209593.331,510890.397],[\"7/784/800\",209593.331,506890.397,213593.331,510890.397],[\"7/784/816\",209593.331,510890.397,213593.331,514890.397],[\"8/784/832\",209593.331,514890.397,211593.331,516890.397],[\"8/792/832\",211593.331,514890.397,213593.331,516890.397],[\"8/792/840\",211593.331,516890.397,213593.331,518890.397],[\"7/784/848\",209593.331,518890.397,213593.331,522890.397],[\"9/780/856\",208593.331,520890.397,209593.331,521890.397],[\"9/788/844\",210593.331,517890.397,211593.331,518890.397],[\"9/784/844\",209593.331,517890.397,210593.331,518890.397],[\"9/788/840\",210593.331,516890.397,211593.331,517890.397],[\"9/784/840\",209593.331,516890.397,210593.331,517890.397],[\"8/768/856\",205593.331,520890.397,207593.331,522890.397],[\"8/768/848\",205593.331,518890.397,207593.331,520890.397],[\"8/776/848\",207593.331,518890.397,209593.331,520890.397],[\"9/776/856\",207593.331,520890.397,208593.331,521890.397],[\"9/776/860\",207593.331,521890.397,208593.331,522890.397],[\"9/776/864\",207593.331,522890.397,208593.331,523890.397],[\"9/776/868\",207593.331,523890.397,208593.331,524890.397],[\"8/768/864\",205593.331,522890.397,207593.331,524890.397],[\"8/768/872\",205593.331,524890.397,207593.331,526890.397],[\"8/776/872\",207593.331,524890.397,209593.331,526890.397],[\"8/784/872\",209593.331,524890.397,211593.331,526890.397],[\"9/780/868\",208593.331,523890.397,209593.331,524890.397],[\"9/780/864\",208593.331,522890.397,209593.331,523890.397],[\"9/780/860\",208593.331,521890.397,209593.331,522890.397],[\"9/788/864\",210593.331,522890.397,211593.331,523890.397],[\"9/784/864\",209593.331,522890.397,210593.331,523890.397],[\"9/784/868\",209593.331,523890.397,210593.331,524890.397],[\"9/788/868\",210593.331,523890.397,211593.331,524890.397],[\"8/792/864\",211593.331,522890.397,213593.331,524890.397],[\"8/792/872\",211593.331,524890.397,213593.331,526890.397],[\"7/784/880\",209593.331,526890.397,213593.331,530890.397],[\"8/784/896\",209593.331,530890.397,211593.331,532890.397],[\"8/792/896\",211593.331,530890.397,213593.331,532890.397],[\"8/792/904\",211593.331,532890.397,213593.331,534890.397],[\"7/784/912\",209593.331,534890.397,213593.331,538890.397],[\"8/784/904\",209593.331,532890.397,211593.331,534890.397],[\"8/768/904\",205593.331,532890.397,207593.331,534890.397],[\"8/776/904\",207593.331,532890.397,209593.331,534890.397],[\"7/768/912\",205593.331,534890.397,209593.331,538890.397],[\"9/760/908\",203593.331,533890.397,204593.331,534890.397],[\"10/760/906\",203593.331,533390.397,204093.331,533890.397],[\"10/762/906\",204093.331,533390.397,204593.331,533890.397],[\"9/764/908\",204593.331,533890.397,205593.331,534890.397],[\"9/764/904\",204593.331,532890.397,205593.331,533890.397],[\"10/762/904\",204093.331,532890.397,204593.331,533390.397],[\"10/760/904\",203593.331,532890.397,204093.331,533390.397],[\"8/760/896\",203593.331,530890.397,205593.331,532890.397],[\"8/768/896\",205593.331,530890.397,207593.331,532890.397],[\"8/776/896\",207593.331,530890.397,209593.331,532890.397],[\"7/768/880\",205593.331,526890.397,209593.331,530890.397],[\"7/752/880\",201593.331,526890.397,205593.331,530890.397],[\"8/752/896\",201593.331,530890.397,203593.331,532890.397],[\"7/736/880\",197593.331,526890.397,201593.331,530890.397],[\"7/720/896\",193593.331,530890.397,197593.331,534890.397],[\"7/720/912\",193593.331,534890.397,197593.331,538890.397],[\"7/736/912\",197593.331,534890.397,201593.331,538890.397],[\"7/736/896\",197593.331,530890.397,201593.331,534890.397],[\"8/752/904\",201593.331,532890.397,203593.331,534890.397],[\"7/752/912\",201593.331,534890.397,205593.331,538890.397],[\"7/752/928\",201593.331,538890.397,205593.331,542890.397],[\"7/736/928\",197593.331,538890.397,201593.331,542890.397],[\"7/720/928\",193593.331,538890.397,197593.331,542890.397],[\"9/732/944\",196593.331,542890.397,197593.331,543890.397],[\"9/732/948\",196593.331,543890.397,197593.331,544890.397],[\"10/730/946\",196093.331,543390.397,196593.331,543890.397],[\"10/730/944\",196093.331,542890.397,196593.331,543390.397],[\"10/728/944\",195593.331,542890.397,196093.331,543390.397],[\"8/720/944\",193593.331,542890.397,195593.331,544890.397],[\"10/728/946\",195593.331,543390.397,196093.331,543890.397],[\"9/728/948\",195593.331,543890.397,196593.331,544890.397],[\"8/720/952\",193593.331,544890.397,195593.331,546890.397],[\"8/728/952\",195593.331,544890.397,197593.331,546890.397],[\"7/736/944\",197593.331,542890.397,201593.331,546890.397],[\"7/752/944\",201593.331,542890.397,205593.331,546890.397],[\"8/768/952\",205593.331,544890.397,207593.331,546890.397],[\"8/776/952\",207593.331,544890.397,209593.331,546890.397],[\"8/768/944\",205593.331,542890.397,207593.331,544890.397],[\"8/776/944\",207593.331,542890.397,209593.331,544890.397],[\"7/768/928\",205593.331,538890.397,209593.331,542890.397],[\"7/784/928\",209593.331,538890.397,213593.331,542890.397],[\"7/784/944\",209593.331,542890.397,213593.331,546890.397],[\"7/800/944\",213593.331,542890.397,217593.331,546890.397],[\"7/816/944\",217593.331,542890.397,221593.331,546890.397],[\"7/816/928\",217593.331,538890.397,221593.331,542890.397],[\"7/800/928\",213593.331,538890.397,217593.331,542890.397],[\"7/800/912\",213593.331,534890.397,217593.331,538890.397],[\"7/800/896\",213593.331,530890.397,217593.331,534890.397],[\"7/800/880\",213593.331,526890.397,217593.331,530890.397],[\"7/816/880\",217593.331,526890.397,221593.331,530890.397],[\"7/832/880\",221593.331,526890.397,225593.331,530890.397],[\"7/816/896\",217593.331,530890.397,221593.331,534890.397],[\"7/816/912\",217593.331,534890.397,221593.331,538890.397],[\"6/832/896\",221593.331,530890.397,229593.331,538890.397],[\"8/848/880\",225593.331,526890.397,227593.331,528890.397],[\"9/856/880\",227593.331,526890.397,228593.331,527890.397],[\"9/856/884\",227593.331,527890.397,228593.331,528890.397],[\"8/856/888\",227593.331,528890.397,229593.331,530890.397],[\"8/848/888\",225593.331,528890.397,227593.331,530890.397],[\"8/864/888\",229593.331,528890.397,231593.331,530890.397],[\"9/860/884\",228593.331,527890.397,229593.331,528890.397],[\"9/860/880\",228593.331,526890.397,229593.331,527890.397],[\"8/864/880\",229593.331,526890.397,231593.331,528890.397],[\"8/872/880\",231593.331,526890.397,233593.331,528890.397],[\"8/872/888\",231593.331,528890.397,233593.331,530890.397],[\"6/864/896\",229593.331,530890.397,237593.331,538890.397],[\"8/872/928\",231593.331,538890.397,233593.331,540890.397],[\"8/872/936\",231593.331,540890.397,233593.331,542890.397],[\"8/864/928\",229593.331,538890.397,231593.331,540890.397],[\"9/868/936\",230593.331,540890.397,231593.331,541890.397],[\"9/864/936\",229593.331,540890.397,230593.331,541890.397],[\"6/832/928\",221593.331,538890.397,229593.331,546890.397],[\"9/864/940\",229593.331,541890.397,230593.331,542890.397],[\"9/868/940\",230593.331,541890.397,231593.331,542890.397],[\"7/864/944\",229593.331,542890.397,233593.331,546890.397],[\"7/880/944\",233593.331,542890.397,237593.331,546890.397],[\"8/880/936\",233593.331,540890.397,235593.331,542890.397],[\"8/880/928\",233593.331,538890.397,235593.331,540890.397],[\"8/888/928\",235593.331,538890.397,237593.331,540890.397],[\"8/888/936\",235593.331,540890.397,237593.331,542890.397],[\"6/896/928\",237593.331,538890.397,245593.331,546890.397],[\"7/928/944\",245593.331,542890.397,249593.331,546890.397],[\"7/944/944\",249593.331,542890.397,253593.331,546890.397],[\"7/944/928\",249593.331,538890.397,253593.331,542890.397],[\"7/928/928\",245593.331,538890.397,249593.331,542890.397],[\"7/928/896\",245593.331,530890.397,249593.331,534890.397],[\"7/928/912\",245593.331,534890.397,249593.331,538890.397],[\"7/944/912\",249593.331,534890.397,253593.331,538890.397],[\"7/944/896\",249593.331,530890.397,253593.331,534890.397],[\"7/944/880\",249593.331,526890.397,253593.331,530890.397],[\"7/928/880\",245593.331,526890.397,249593.331,530890.397],[\"7/912/880\",241593.331,526890.397,245593.331,530890.397],[\"7/896/880\",237593.331,526890.397,241593.331,530890.397],[\"7/912/896\",241593.331,530890.397,245593.331,534890.397],[\"7/912/912\",241593.331,534890.397,245593.331,538890.397],[\"7/896/912\",237593.331,534890.397,241593.331,538890.397],[\"7/896/896\",237593.331,530890.397,241593.331,534890.397],[\"7/880/880\",233593.331,526890.397,237593.331,530890.397],[\"7/880/864\",233593.331,522890.397,237593.331,526890.397],[\"7/880/848\",233593.331,518890.397,237593.331,522890.397],[\"8/880/840\",233593.331,516890.397,235593.331,518890.397],[\"8/888/840\",235593.331,516890.397,237593.331,518890.397],[\"7/896/848\",237593.331,518890.397,241593.331,522890.397],[\"7/912/848\",241593.331,518890.397,245593.331,522890.397],[\"7/896/864\",237593.331,522890.397,241593.331,526890.397],[\"7/912/864\",241593.331,522890.397,245593.331,526890.397],[\"7/928/864\",245593.331,522890.397,249593.331,526890.397],[\"7/944/864\",249593.331,522890.397,253593.331,526890.397],[\"7/944/848\",249593.331,518890.397,253593.331,522890.397],[\"9/932/848\",246593.331,518890.397,247593.331,519890.397],[\"8/936/848\",247593.331,518890.397,249593.331,520890.397],[\"8/936/856\",247593.331,520890.397,249593.331,522890.397],[\"8/928/856\",245593.331,520890.397,247593.331,522890.397],[\"9/932/852\",246593.331,519890.397,247593.331,520890.397],[\"9/928/852\",245593.331,519890.397,246593.331,520890.397],[\"9/928/848\",245593.331,518890.397,246593.331,519890.397],[\"7/928/832\",245593.331,514890.397,249593.331,518890.397],[\"7/944/832\",249593.331,514890.397,253593.331,518890.397],[\"6/928/800\",245593.331,506890.397,253593.331,514890.397],[\"7/912/800\",241593.331,506890.397,245593.331,510890.397],[\"8/904/800\",239593.331,506890.397,241593.331,508890.397],[\"9/900/808\",238593.331,508890.397,239593.331,509890.397],[\"8/904/808\",239593.331,508890.397,241593.331,510890.397],[\"9/900/812\",238593.331,509890.397,239593.331,510890.397],[\"8/904/816\",239593.331,510890.397,241593.331,512890.397],[\"7/912/816\",241593.331,510890.397,245593.331,514890.397],[\"7/912/832\",241593.331,514890.397,245593.331,518890.397],[\"7/896/832\",237593.331,514890.397,241593.331,518890.397],[\"8/904/824\",239593.331,512890.397,241593.331,514890.397],[\"8/896/824\",237593.331,512890.397,239593.331,514890.397],[\"8/888/832\",235593.331,514890.397,237593.331,516890.397],[\"8/880/832\",233593.331,514890.397,235593.331,516890.397],[\"7/880/816\",233593.331,510890.397,237593.331,514890.397],[\"8/896/816\",237593.331,510890.397,239593.331,512890.397],[\"9/896/812\",237593.331,509890.397,238593.331,510890.397],[\"9/896/808\",237593.331,508890.397,238593.331,509890.397],[\"8/896/800\",237593.331,506890.397,239593.331,508890.397],[\"7/880/800\",233593.331,506890.397,237593.331,510890.397],[\"7/864/800\",229593.331,506890.397,233593.331,510890.397],[\"7/848/800\",225593.331,506890.397,229593.331,510890.397],[\"8/848/816\",225593.331,510890.397,227593.331,512890.397],[\"8/856/816\",227593.331,510890.397,229593.331,512890.397],[\"8/856/824\",227593.331,512890.397,229593.331,514890.397],[\"8/848/824\",225593.331,512890.397,227593.331,514890.397],[\"7/848/832\",225593.331,514890.397,229593.331,518890.397],[\"7/864/816\",229593.331,510890.397,233593.331,514890.397],[\"7/864/832\",229593.331,514890.397,233593.331,518890.397],[\"7/864/848\",229593.331,518890.397,233593.331,522890.397],[\"8/872/864\",231593.331,522890.397,233593.331,524890.397],[\"8/872/872\",231593.331,524890.397,233593.331,526890.397],[\"9/864/872\",229593.331,524890.397,230593.331,525890.397],[\"9/868/872\",230593.331,524890.397,231593.331,525890.397],[\"9/868/876\",230593.331,525890.397,231593.331,526890.397],[\"9/864/876\",229593.331,525890.397,230593.331,526890.397],[\"9/860/876\",228593.331,525890.397,229593.331,526890.397],[\"9/860/872\",228593.331,524890.397,229593.331,525890.397],[\"8/864/864\",229593.331,522890.397,231593.331,524890.397],[\"8/848/864\",225593.331,522890.397,227593.331,524890.397],[\"8/856/864\",227593.331,522890.397,229593.331,524890.397],[\"9/856/872\",227593.331,524890.397,228593.331,525890.397],[\"9/856/876\",227593.331,525890.397,228593.331,526890.397],[\"9/852/876\",226593.331,525890.397,227593.331,526890.397],[\"9/852/872\",226593.331,524890.397,227593.331,525890.397],[\"9/848/872\",225593.331,524890.397,226593.331,525890.397],[\"9/848/876\",225593.331,525890.397,226593.331,526890.397],[\"8/840/856\",223593.331,520890.397,225593.331,522890.397],[\"8/840/848\",223593.331,518890.397,225593.331,520890.397],[\"7/848/848\",225593.331,518890.397,229593.331,522890.397],[\"7/816/848\",217593.331,518890.397,221593.331,522890.397],[\"8/832/848\",221593.331,518890.397,223593.331,520890.397],[\"8/832/856\",221593.331,520890.397,223593.331,522890.397],[\"7/832/864\",221593.331,522890.397,225593.331,526890.397],[\"7/816/864\",217593.331,522890.397,221593.331,526890.397],[\"7/800/864\",213593.331,522890.397,217593.331,526890.397],[\"8/800/856\",213593.331,520890.397,215593.331,522890.397],[\"8/800/848\",213593.331,518890.397,215593.331,520890.397],[\"8/808/856\",215593.331,520890.397,217593.331,522890.397],[\"8/808/848\",215593.331,518890.397,217593.331,520890.397],[\"7/800/832\",213593.331,514890.397,217593.331,518890.397],[\"8/800/824\",213593.331,512890.397,215593.331,514890.397],[\"8/808/824\",215593.331,512890.397,217593.331,514890.397],[\"7/816/832\",217593.331,514890.397,221593.331,518890.397],[\"7/832/832\",221593.331,514890.397,225593.331,518890.397],[\"7/832/816\",221593.331,510890.397,225593.331,514890.397],[\"7/816/816\",217593.331,510890.397,221593.331,514890.397],[\"7/832/800\",221593.331,506890.397,225593.331,510890.397],[\"7/816/800\",217593.331,506890.397,221593.331,510890.397],[\"8/808/800\",215593.331,506890.397,217593.331,508890.397],[\"8/808/816\",215593.331,510890.397,217593.331,512890.397],[\"8/808/808\",215593.331,508890.397,217593.331,510890.397],[\"8/800/816\",213593.331,510890.397,215593.331,512890.397],[\"8/800/808\",213593.331,508890.397,215593.331,510890.397],[\"8/800/800\",213593.331,506890.397,215593.331,508890.397],[\"8/800/792\",213593.331,504890.397,215593.331,506890.397],[\"9/800/788\",213593.331,503890.397,214593.331,504890.397],[\"9/800/784\",213593.331,502890.397,214593.331,503890.397],[\"9/804/784\",214593.331,502890.397,215593.331,503890.397],[\"9/804/788\",214593.331,503890.397,215593.331,504890.397],[\"8/808/784\",215593.331,502890.397,217593.331,504890.397],[\"8/808/792\",215593.331,504890.397,217593.331,506890.397],[\"7/816/784\",217593.331,502890.397,221593.331,506890.397],[\"8/832/792\",221593.331,504890.397,223593.331,506890.397],[\"8/832/784\",221593.331,502890.397,223593.331,504890.397],[\"7/816/768\",217593.331,498890.397,221593.331,502890.397],[\"7/832/768\",221593.331,498890.397,225593.331,502890.397],[\"8/824/760\",219593.331,496890.397,221593.331,498890.397],[\"8/816/760\",217593.331,496890.397,219593.331,498890.397],[\"7/800/768\",213593.331,498890.397,217593.331,502890.397],[\"7/800/752\",213593.331,494890.397,217593.331,498890.397],[\"8/816/752\",217593.331,494890.397,219593.331,496890.397],[\"7/800/736\",213593.331,490890.397,217593.331,494890.397],[\"9/808/732\",215593.331,489890.397,216593.331,490890.397],[\"8/800/728\",213593.331,488890.397,215593.331,490890.397],[\"9/800/724\",213593.331,487890.397,214593.331,488890.397],[\"9/800/720\",213593.331,486890.397,214593.331,487890.397],[\"9/804/720\",214593.331,486890.397,215593.331,487890.397],[\"9/804/724\",214593.331,487890.397,215593.331,488890.397],[\"9/808/728\",215593.331,488890.397,216593.331,489890.397],[\"9/812/728\",216593.331,488890.397,217593.331,489890.397],[\"8/808/720\",215593.331,486890.397,217593.331,488890.397],[\"9/812/732\",216593.331,489890.397,217593.331,490890.397],[\"7/816/720\",217593.331,486890.397,221593.331,490890.397],[\"7/832/720\",221593.331,486890.397,225593.331,490890.397],[\"7/832/736\",221593.331,490890.397,225593.331,494890.397],[\"7/816/736\",217593.331,490890.397,221593.331,494890.397],[\"8/824/752\",219593.331,494890.397,221593.331,496890.397],[\"7/832/752\",221593.331,494890.397,225593.331,498890.397],[\"7/848/752\",225593.331,494890.397,229593.331,498890.397],[\"7/848/736\",225593.331,490890.397,229593.331,494890.397],[\"8/848/720\",225593.331,486890.397,227593.331,488890.397],[\"9/856/720\",227593.331,486890.397,228593.331,487890.397],[\"9/856/724\",227593.331,487890.397,228593.331,488890.397],[\"8/856/728\",227593.331,488890.397,229593.331,490890.397],[\"8/848/728\",225593.331,488890.397,227593.331,490890.397],[\"9/860/724\",228593.331,487890.397,229593.331,488890.397],[\"9/860/720\",228593.331,486890.397,229593.331,487890.397],[\"7/864/720\",229593.331,486890.397,233593.331,490890.397],[\"7/864/736\",229593.331,490890.397,233593.331,494890.397],[\"8/864/752\",229593.331,494890.397,231593.331,496890.397],[\"8/872/752\",231593.331,494890.397,233593.331,496890.397],[\"8/872/760\",231593.331,496890.397,233593.331,498890.397],[\"7/864/768\",229593.331,498890.397,233593.331,502890.397],[\"8/864/760\",229593.331,496890.397,231593.331,498890.397],[\"7/848/768\",225593.331,498890.397,229593.331,502890.397],[\"8/856/784\",227593.331,502890.397,229593.331,504890.397],[\"8/848/784\",225593.331,502890.397,227593.331,504890.397],[\"9/840/784\",223593.331,502890.397,224593.331,503890.397],[\"9/840/788\",223593.331,503890.397,224593.331,504890.397],[\"9/844/788\",224593.331,503890.397,225593.331,504890.397],[\"9/844/784\",224593.331,502890.397,225593.331,503890.397],[\"8/840/792\",223593.331,504890.397,225593.331,506890.397],[\"8/848/792\",225593.331,504890.397,227593.331,506890.397],[\"8/856/792\",227593.331,504890.397,229593.331,506890.397],[\"7/864/784\",229593.331,502890.397,233593.331,506890.397],[\"7/880/784\",233593.331,502890.397,237593.331,506890.397],[\"7/880/768\",233593.331,498890.397,237593.331,502890.397],[\"9/880/764\",233593.331,497890.397,234593.331,498890.397],[\"9/880/760\",233593.331,496890.397,234593.331,497890.397],[\"9/884/760\",234593.331,496890.397,235593.331,497890.397],[\"9/884/764\",234593.331,497890.397,235593.331,498890.397],[\"8/888/760\",235593.331,496890.397,237593.331,498890.397],[\"7/896/768\",237593.331,498890.397,241593.331,502890.397],[\"7/912/768\",241593.331,498890.397,245593.331,502890.397],[\"7/896/784\",237593.331,502890.397,241593.331,506890.397],[\"7/912/784\",241593.331,502890.397,245593.331,506890.397],[\"6/928/768\",245593.331,498890.397,253593.331,506890.397],[\"7/928/736\",245593.331,490890.397,249593.331,494890.397],[\"7/928/752\",245593.331,494890.397,249593.331,498890.397],[\"7/944/752\",249593.331,494890.397,253593.331,498890.397],[\"8/952/744\",251593.331,492890.397,253593.331,494890.397],[\"9/948/740\",250593.331,491890.397,251593.331,492890.397],[\"9/944/740\",249593.331,491890.397,250593.331,492890.397],[\"8/944/744\",249593.331,492890.397,251593.331,494890.397],[\"9/944/736\",249593.331,490890.397,250593.331,491890.397],[\"9/948/736\",250593.331,490890.397,251593.331,491890.397],[\"8/952/736\",251593.331,490890.397,253593.331,492890.397],[\"7/944/720\",249593.331,486890.397,253593.331,490890.397],[\"8/936/720\",247593.331,486890.397,249593.331,488890.397],[\"8/928/720\",245593.331,486890.397,247593.331,488890.397],[\"8/936/728\",247593.331,488890.397,249593.331,490890.397],[\"8/928/728\",245593.331,488890.397,247593.331,490890.397],[\"8/920/728\",243593.331,488890.397,245593.331,490890.397],[\"8/920/720\",243593.331,486890.397,245593.331,488890.397],[\"9/916/720\",242593.331,486890.397,243593.331,487890.397],[\"9/916/724\",242593.331,487890.397,243593.331,488890.397],[\"9/912/724\",241593.331,487890.397,242593.331,488890.397],[\"9/912/720\",241593.331,486890.397,242593.331,487890.397],[\"8/904/720\",239593.331,486890.397,241593.331,488890.397],[\"8/904/728\",239593.331,488890.397,241593.331,490890.397],[\"9/900/736\",238593.331,490890.397,239593.331,491890.397],[\"8/904/736\",239593.331,490890.397,241593.331,492890.397],[\"8/912/728\",241593.331,488890.397,243593.331,490890.397],[\"7/912/736\",241593.331,490890.397,245593.331,494890.397],[\"7/912/752\",241593.331,494890.397,245593.331,498890.397],[\"7/896/752\",237593.331,494890.397,241593.331,498890.397],[\"8/904/744\",239593.331,492890.397,241593.331,494890.397],[\"9/900/740\",238593.331,491890.397,239593.331,492890.397],[\"9/896/740\",237593.331,491890.397,238593.331,492890.397],[\"8/896/744\",237593.331,492890.397,239593.331,494890.397],[\"8/888/752\",235593.331,494890.397,237593.331,496890.397],[\"8/880/752\",233593.331,494890.397,235593.331,496890.397],[\"7/880/736\",233593.331,490890.397,237593.331,494890.397],[\"9/896/736\",237593.331,490890.397,238593.331,491890.397],[\"8/896/728\",237593.331,488890.397,239593.331,490890.397],[\"8/896/720\",237593.331,486890.397,239593.331,488890.397],[\"7/880/720\",233593.331,486890.397,237593.331,490890.397],[\"8/880/712\",233593.331,484890.397,235593.331,486890.397],[\"9/888/712\",235593.331,484890.397,236593.331,485890.397],[\"9/888/716\",235593.331,485890.397,236593.331,486890.397],[\"9/892/716\",236593.331,485890.397,237593.331,486890.397],[\"8/896/712\",237593.331,484890.397,239593.331,486890.397],[\"9/892/712\",236593.331,484890.397,237593.331,485890.397],[\"8/888/704\",235593.331,482890.397,237593.331,484890.397],[\"8/896/704\",237593.331,482890.397,239593.331,484890.397],[\"8/880/704\",233593.331,482890.397,235593.331,484890.397],[\"8/880/696\",233593.331,480890.397,235593.331,482890.397],[\"8/880/688\",233593.331,478890.397,235593.331,480890.397],[\"8/888/688\",235593.331,478890.397,237593.331,480890.397],[\"8/888/696\",235593.331,480890.397,237593.331,482890.397],[\"7/896/688\",237593.331,478890.397,241593.331,482890.397],[\"8/912/680\",241593.331,476890.397,243593.331,478890.397],[\"7/912/688\",241593.331,478890.397,245593.331,482890.397],[\"9/916/704\",242593.331,482890.397,243593.331,483890.397],[\"9/916/708\",242593.331,483890.397,243593.331,484890.397],[\"9/912/704\",241593.331,482890.397,242593.331,483890.397],[\"9/912/708\",241593.331,483890.397,242593.331,484890.397],[\"9/904/708\",239593.331,483890.397,240593.331,484890.397],[\"9/904/704\",239593.331,482890.397,240593.331,483890.397],[\"9/908/704\",240593.331,482890.397,241593.331,483890.397],[\"9/908/708\",240593.331,483890.397,241593.331,484890.397],[\"9/908/712\",240593.331,484890.397,241593.331,485890.397],[\"9/904/712\",239593.331,484890.397,240593.331,485890.397],[\"9/904/716\",239593.331,485890.397,240593.331,486890.397],[\"9/908/716\",240593.331,485890.397,241593.331,486890.397],[\"9/912/716\",241593.331,485890.397,242593.331,486890.397],[\"10/914/712\",242093.331,484890.397,242593.331,485390.397],[\"10/912/712\",241593.331,484890.397,242093.331,485390.397],[\"10/912/714\",241593.331,485390.397,242093.331,485890.397],[\"10/914/714\",242093.331,485390.397,242593.331,485890.397],[\"9/916/712\",242593.331,484890.397,243593.331,485890.397],[\"9/916/716\",242593.331,485890.397,243593.331,486890.397],[\"8/920/712\",243593.331,484890.397,245593.331,486890.397],[\"8/920/704\",243593.331,482890.397,245593.331,484890.397],[\"7/928/704\",245593.331,482890.397,249593.331,486890.397],[\"7/944/704\",249593.331,482890.397,253593.331,486890.397],[\"9/940/692\",248593.331,479890.397,249593.331,480890.397],[\"8/944/688\",249593.331,478890.397,251593.331,480890.397],[\"8/944/696\",249593.331,480890.397,251593.331,482890.397],[\"8/952/696\",251593.331,480890.397,253593.331,482890.397],[\"9/956/692\",252593.331,479890.397,253593.331,480890.397],[\"9/952/692\",251593.331,479890.397,252593.331,480890.397],[\"9/952/684\",251593.331,477890.397,252593.331,478890.397],[\"9/952/688\",251593.331,478890.397,252593.331,479890.397],[\"9/956/688\",252593.331,478890.397,253593.331,479890.397],[\"9/956/684\",252593.331,477890.397,253593.331,478890.397],[\"9/956/680\",252593.331,476890.397,253593.331,477890.397],[\"9/952/680\",251593.331,476890.397,252593.331,477890.397],[\"9/948/680\",250593.331,476890.397,251593.331,477890.397],[\"9/944/680\",249593.331,476890.397,250593.331,477890.397],[\"9/948/684\",250593.331,477890.397,251593.331,478890.397],[\"9/944/684\",249593.331,477890.397,250593.331,478890.397],[\"9/940/688\",248593.331,478890.397,249593.331,479890.397],[\"8/936/680\",247593.331,476890.397,249593.331,478890.397],[\"8/928/680\",245593.331,476890.397,247593.331,478890.397],[\"9/936/688\",247593.331,478890.397,248593.331,479890.397],[\"9/936/692\",247593.331,479890.397,248593.331,480890.397],[\"8/936/696\",247593.331,480890.397,249593.331,482890.397],[\"8/928/696\",245593.331,480890.397,247593.331,482890.397],[\"8/928/688\",245593.331,478890.397,247593.331,480890.397],[\"8/920/680\",243593.331,476890.397,245593.331,478890.397],[\"9/920/676\",243593.331,475890.397,244593.331,476890.397],[\"9/924/676\",244593.331,475890.397,245593.331,476890.397],[\"9/924/672\",244593.331,474890.397,245593.331,475890.397],[\"9/920/672\",243593.331,474890.397,244593.331,475890.397],[\"7/928/656\",245593.331,470890.397,249593.331,474890.397],[\"9/936/672\",247593.331,474890.397,248593.331,475890.397],[\"8/928/672\",245593.331,474890.397,247593.331,476890.397],[\"9/936/676\",247593.331,475890.397,248593.331,476890.397],[\"9/940/676\",248593.331,475890.397,249593.331,476890.397],[\"10/944/678\",249593.331,476390.397,250093.331,476890.397],[\"10/944/676\",249593.331,475890.397,250093.331,476390.397],[\"9/940/672\",248593.331,474890.397,249593.331,475890.397],[\"10/944/672\",249593.331,474890.397,250093.331,475390.397],[\"10/944/674\",249593.331,475390.397,250093.331,475890.397],[\"10/946/674\",250093.331,475390.397,250593.331,475890.397],[\"10/946/672\",250093.331,474890.397,250593.331,475390.397],[\"9/948/672\",250593.331,474890.397,251593.331,475890.397],[\"10/948/676\",250593.331,475890.397,251093.331,476390.397],[\"10/946/676\",250093.331,475890.397,250593.331,476390.397],[\"10/946/678\",250093.331,476390.397,250593.331,476890.397],[\"10/948/678\",250593.331,476390.397,251093.331,476890.397],[\"10/950/678\",251093.331,476390.397,251593.331,476890.397],[\"10/950/676\",251093.331,475890.397,251593.331,476390.397],[\"9/952/676\",251593.331,475890.397,252593.331,476890.397],[\"9/956/676\",252593.331,475890.397,253593.331,476890.397],[\"9/956/672\",252593.331,474890.397,253593.331,475890.397],[\"9/952/672\",251593.331,474890.397,252593.331,475890.397],[\"8/952/664\",251593.331,472890.397,253593.331,474890.397],[\"8/944/664\",249593.331,472890.397,251593.331,474890.397],[\"8/944/648\",249593.331,468890.397,251593.331,470890.397],[\"8/944/656\",249593.331,470890.397,251593.331,472890.397],[\"8/952/656\",251593.331,470890.397,253593.331,472890.397],[\"8/952/648\",251593.331,468890.397,253593.331,470890.397],[\"8/952/640\",251593.331,466890.397,253593.331,468890.397],[\"8/944/640\",249593.331,466890.397,251593.331,468890.397],[\"7/928/640\",245593.331,466890.397,249593.331,470890.397],[\"7/912/640\",241593.331,466890.397,245593.331,470890.397],[\"7/896/640\",237593.331,466890.397,241593.331,470890.397],[\"7/912/656\",241593.331,470890.397,245593.331,474890.397],[\"8/912/672\",241593.331,474890.397,243593.331,476890.397],[\"7/896/672\",237593.331,474890.397,241593.331,478890.397],[\"7/896/656\",237593.331,470890.397,241593.331,474890.397],[\"9/892/660\",236593.331,471890.397,237593.331,472890.397],[\"8/888/664\",235593.331,472890.397,237593.331,474890.397],[\"7/880/672\",233593.331,474890.397,237593.331,478890.397],[\"8/880/664\",233593.331,472890.397,235593.331,474890.397],[\"9/888/660\",235593.331,471890.397,236593.331,472890.397],[\"8/880/656\",233593.331,470890.397,235593.331,472890.397],[\"9/888/656\",235593.331,470890.397,236593.331,471890.397],[\"9/892/656\",236593.331,470890.397,237593.331,471890.397],[\"7/880/640\",233593.331,466890.397,237593.331,470890.397],[\"7/864/640\",229593.331,466890.397,233593.331,470890.397],[\"8/872/656\",231593.331,470890.397,233593.331,472890.397],[\"8/864/656\",229593.331,470890.397,231593.331,472890.397],[\"7/848/640\",225593.331,466890.397,229593.331,470890.397],[\"7/848/656\",225593.331,470890.397,229593.331,474890.397],[\"8/840/672\",223593.331,474890.397,225593.331,476890.397],[\"8/848/672\",225593.331,474890.397,227593.331,476890.397],[\"8/856/672\",227593.331,474890.397,229593.331,476890.397],[\"8/864/664\",229593.331,472890.397,231593.331,474890.397],[\"8/872/664\",231593.331,472890.397,233593.331,474890.397],[\"7/864/672\",229593.331,474890.397,233593.331,478890.397],[\"9/876/688\",232593.331,478890.397,233593.331,479890.397],[\"9/872/688\",231593.331,478890.397,232593.331,479890.397],[\"9/864/688\",229593.331,478890.397,230593.331,479890.397],[\"9/868/688\",230593.331,478890.397,231593.331,479890.397],[\"9/868/692\",230593.331,479890.397,231593.331,480890.397],[\"9/864/692\",229593.331,479890.397,230593.331,480890.397],[\"8/864/696\",229593.331,480890.397,231593.331,482890.397],[\"9/872/692\",231593.331,479890.397,232593.331,480890.397],[\"9/876/692\",232593.331,479890.397,233593.331,480890.397],[\"8/872/696\",231593.331,480890.397,233593.331,482890.397],[\"7/864/704\",229593.331,482890.397,233593.331,486890.397],[\"9/860/716\",228593.331,485890.397,229593.331,486890.397],[\"9/860/712\",228593.331,484890.397,229593.331,485890.397],[\"8/856/704\",227593.331,482890.397,229593.331,484890.397],[\"9/856/712\",227593.331,484890.397,228593.331,485890.397],[\"9/856/716\",227593.331,485890.397,228593.331,486890.397],[\"8/848/712\",225593.331,484890.397,227593.331,486890.397],[\"7/848/688\",225593.331,478890.397,229593.331,482890.397],[\"8/856/680\",227593.331,476890.397,229593.331,478890.397],[\"8/848/680\",225593.331,476890.397,227593.331,478890.397],[\"8/840/680\",223593.331,476890.397,225593.331,478890.397],[\"8/832/680\",221593.331,476890.397,223593.331,478890.397],[\"7/816/688\",217593.331,478890.397,221593.331,482890.397],[\"7/832/688\",221593.331,478890.397,225593.331,482890.397],[\"7/832/704\",221593.331,482890.397,225593.331,486890.397],[\"7/816/704\",217593.331,482890.397,221593.331,486890.397],[\"7/800/704\",213593.331,482890.397,217593.331,486890.397],[\"7/800/688\",213593.331,478890.397,217593.331,482890.397],[\"7/800/672\",213593.331,474890.397,217593.331,478890.397],[\"8/800/664\",213593.331,472890.397,215593.331,474890.397],[\"9/808/664\",215593.331,472890.397,216593.331,473890.397],[\"9/808/668\",215593.331,473890.397,216593.331,474890.397],[\"9/812/668\",216593.331,473890.397,217593.331,474890.397],[\"9/812/664\",216593.331,472890.397,217593.331,473890.397],[\"7/816/672\",217593.331,474890.397,221593.331,478890.397],[\"8/832/672\",221593.331,474890.397,223593.331,476890.397],[\"7/832/656\",221593.331,470890.397,225593.331,474890.397],[\"7/816/656\",217593.331,470890.397,221593.331,474890.397],[\"7/832/640\",221593.331,466890.397,225593.331,470890.397],[\"7/816/640\",217593.331,466890.397,221593.331,470890.397],[\"8/808/656\",215593.331,470890.397,217593.331,472890.397],[\"8/800/656\",213593.331,470890.397,215593.331,472890.397],[\"7/800/640\",213593.331,466890.397,217593.331,470890.397],[\"8/792/640\",211593.331,466890.397,213593.331,468890.397],[\"8/784/640\",209593.331,466890.397,211593.331,468890.397],[\"8/784/648\",209593.331,468890.397,211593.331,470890.397],[\"8/784/656\",209593.331,470890.397,211593.331,472890.397],[\"8/792/648\",211593.331,468890.397,213593.331,470890.397],[\"8/792/656\",211593.331,470890.397,213593.331,472890.397],[\"9/792/664\",211593.331,472890.397,212593.331,473890.397],[\"9/792/668\",211593.331,473890.397,212593.331,474890.397],[\"9/796/664\",212593.331,472890.397,213593.331,473890.397],[\"9/796/668\",212593.331,473890.397,213593.331,474890.397],[\"9/796/672\",212593.331,474890.397,213593.331,475890.397],[\"9/796/676\",212593.331,475890.397,213593.331,476890.397],[\"9/792/676\",211593.331,475890.397,212593.331,476890.397],[\"9/792/672\",211593.331,474890.397,212593.331,475890.397],[\"9/784/672\",209593.331,474890.397,210593.331,475890.397],[\"9/788/672\",210593.331,474890.397,211593.331,475890.397],[\"9/788/676\",210593.331,475890.397,211593.331,476890.397],[\"9/784/676\",209593.331,475890.397,210593.331,476890.397],[\"9/780/676\",208593.331,475890.397,209593.331,476890.397],[\"9/780/672\",208593.331,474890.397,209593.331,475890.397],[\"9/780/668\",208593.331,473890.397,209593.331,474890.397],[\"9/780/664\",208593.331,472890.397,209593.331,473890.397],[\"9/784/668\",209593.331,473890.397,210593.331,474890.397],[\"9/788/668\",210593.331,473890.397,211593.331,474890.397],[\"9/788/664\",210593.331,472890.397,211593.331,473890.397],[\"9/784/664\",209593.331,472890.397,210593.331,473890.397],[\"9/772/664\",206593.331,472890.397,207593.331,473890.397],[\"10/772/668\",206593.331,473890.397,207093.331,474390.397],[\"10/774/668\",207093.331,473890.397,207593.331,474390.397],[\"10/776/668\",207593.331,473890.397,208093.331,474390.397],[\"9/776/664\",207593.331,472890.397,208593.331,473890.397],[\"10/778/668\",208093.331,473890.397,208593.331,474390.397],[\"10/778/670\",208093.331,474390.397,208593.331,474890.397],[\"10/776/670\",207593.331,474390.397,208093.331,474890.397],[\"10/776/672\",207593.331,474890.397,208093.331,475390.397],[\"10/776/674\",207593.331,475390.397,208093.331,475890.397],[\"10/778/672\",208093.331,474890.397,208593.331,475390.397],[\"10/778/674\",208093.331,475390.397,208593.331,475890.397],[\"9/776/676\",207593.331,475890.397,208593.331,476890.397],[\"9/772/676\",206593.331,475890.397,207593.331,476890.397],[\"10/772/674\",206593.331,475390.397,207093.331,475890.397],[\"10/774/674\",207093.331,475390.397,207593.331,475890.397],[\"10/774/672\",207093.331,474890.397,207593.331,475390.397],[\"10/772/672\",206593.331,474890.397,207093.331,475390.397],[\"10/774/670\",207093.331,474390.397,207593.331,474890.397],[\"10/772/670\",206593.331,474390.397,207093.331,474890.397],[\"9/768/672\",205593.331,474890.397,206593.331,475890.397],[\"9/768/676\",205593.331,475890.397,206593.331,476890.397],[\"8/760/664\",203593.331,472890.397,205593.331,474890.397],[\"9/768/668\",205593.331,473890.397,206593.331,474890.397],[\"9/768/664\",205593.331,472890.397,206593.331,473890.397],[\"9/764/660\",204593.331,471890.397,205593.331,472890.397],[\"9/760/660\",203593.331,471890.397,204593.331,472890.397],[\"9/760/656\",203593.331,470890.397,204593.331,471890.397],[\"9/764/656\",204593.331,470890.397,205593.331,471890.397],[\"8/768/656\",205593.331,470890.397,207593.331,472890.397],[\"8/776/656\",207593.331,470890.397,209593.331,472890.397],[\"7/768/640\",205593.331,466890.397,209593.331,470890.397],[\"7/752/640\",201593.331,466890.397,205593.331,470890.397],[\"8/752/656\",201593.331,470890.397,203593.331,472890.397],[\"8/744/648\",199593.331,468890.397,201593.331,470890.397],[\"9/740/652\",198593.331,469890.397,199593.331,470890.397],[\"9/740/648\",198593.331,468890.397,199593.331,469890.397],[\"8/744/640\",199593.331,466890.397,201593.331,468890.397],[\"8/736/640\",197593.331,466890.397,199593.331,468890.397],[\"9/736/648\",197593.331,468890.397,198593.331,469890.397],[\"9/732/644\",196593.331,467890.397,197593.331,468890.397],[\"9/732/648\",196593.331,468890.397,197593.331,469890.397],[\"9/732/640\",196593.331,466890.397,197593.331,467890.397],[\"9/728/640\",195593.331,466890.397,196593.331,467890.397],[\"9/724/640\",194593.331,466890.397,195593.331,467890.397],[\"9/720/640\",193593.331,466890.397,194593.331,467890.397],[\"10/720/644\",193593.331,467890.397,194093.331,468390.397],[\"10/722/644\",194093.331,467890.397,194593.331,468390.397],[\"10/722/646\",194093.331,468390.397,194593.331,468890.397],[\"10/720/646\",193593.331,468390.397,194093.331,468890.397],[\"10/720/648\",193593.331,468890.397,194093.331,469390.397],[\"10/722/648\",194093.331,468890.397,194593.331,469390.397],[\"9/724/648\",194593.331,468890.397,195593.331,469890.397],[\"9/724/644\",194593.331,467890.397,195593.331,468890.397],[\"9/728/644\",195593.331,467890.397,196593.331,468890.397],[\"9/728/648\",195593.331,468890.397,196593.331,469890.397],[\"9/728/652\",195593.331,469890.397,196593.331,470890.397],[\"9/724/652\",194593.331,469890.397,195593.331,470890.397],[\"10/722/650\",194093.331,469390.397,194593.331,469890.397],[\"10/720/650\",193593.331,469390.397,194093.331,469890.397],[\"10/720/652\",193593.331,469890.397,194093.331,470390.397],[\"10/720/654\",193593.331,470390.397,194093.331,470890.397],[\"10/722/654\",194093.331,470390.397,194593.331,470890.397],[\"10/722/652\",194093.331,469890.397,194593.331,470390.397],[\"9/720/656\",193593.331,470890.397,194593.331,471890.397],[\"9/724/656\",194593.331,470890.397,195593.331,471890.397],[\"9/728/656\",195593.331,470890.397,196593.331,471890.397],[\"9/732/656\",196593.331,470890.397,197593.331,471890.397],[\"9/732/652\",196593.331,469890.397,197593.331,470890.397],[\"9/736/652\",197593.331,469890.397,198593.331,470890.397],[\"8/728/664\",195593.331,472890.397,197593.331,474890.397],[\"9/732/660\",196593.331,471890.397,197593.331,472890.397],[\"9/728/660\",195593.331,471890.397,196593.331,472890.397],[\"9/724/660\",194593.331,471890.397,195593.331,472890.397],[\"9/720/660\",193593.331,471890.397,194593.331,472890.397],[\"8/720/664\",193593.331,472890.397,195593.331,474890.397],[\"8/720/672\",193593.331,474890.397,195593.331,476890.397],[\"8/728/672\",195593.331,474890.397,197593.331,476890.397],[\"7/736/672\",197593.331,474890.397,201593.331,478890.397],[\"7/736/656\",197593.331,470890.397,201593.331,474890.397],[\"8/752/664\",201593.331,472890.397,203593.331,474890.397],[\"7/752/672\",201593.331,474890.397,205593.331,478890.397],[\"7/752/688\",201593.331,478890.397,205593.331,482890.397],[\"7/736/688\",197593.331,478890.397,201593.331,482890.397],[\"8/728/680\",195593.331,476890.397,197593.331,478890.397],[\"9/724/680\",194593.331,476890.397,195593.331,477890.397],[\"9/720/680\",193593.331,476890.397,194593.331,477890.397],[\"9/720/684\",193593.331,477890.397,194593.331,478890.397],[\"9/724/684\",194593.331,477890.397,195593.331,478890.397],[\"7/720/688\",193593.331,478890.397,197593.331,482890.397],[\"9/732/704\",196593.331,482890.397,197593.331,483890.397],[\"9/732/708\",196593.331,483890.397,197593.331,484890.397],[\"9/720/704\",193593.331,482890.397,194593.331,483890.397],[\"9/720/708\",193593.331,483890.397,194593.331,484890.397],[\"9/724/708\",194593.331,483890.397,195593.331,484890.397],[\"9/724/704\",194593.331,482890.397,195593.331,483890.397],[\"9/728/704\",195593.331,482890.397,196593.331,483890.397],[\"9/728/708\",195593.331,483890.397,196593.331,484890.397],[\"8/720/712\",193593.331,484890.397,195593.331,486890.397],[\"8/728/712\",195593.331,484890.397,197593.331,486890.397],[\"7/736/704\",197593.331,482890.397,201593.331,486890.397],[\"8/752/704\",201593.331,482890.397,203593.331,484890.397],[\"8/752/712\",201593.331,484890.397,203593.331,486890.397],[\"8/760/712\",203593.331,484890.397,205593.331,486890.397],[\"7/768/704\",205593.331,482890.397,209593.331,486890.397],[\"9/764/708\",204593.331,483890.397,205593.331,484890.397],[\"9/764/704\",204593.331,482890.397,205593.331,483890.397],[\"9/760/708\",203593.331,483890.397,204593.331,484890.397],[\"9/760/704\",203593.331,482890.397,204593.331,483890.397],[\"9/768/680\",205593.331,476890.397,206593.331,477890.397],[\"9/768/684\",205593.331,477890.397,206593.331,478890.397],[\"9/772/684\",206593.331,477890.397,207593.331,478890.397],[\"9/772/680\",206593.331,476890.397,207593.331,477890.397],[\"8/776/680\",207593.331,476890.397,209593.331,478890.397],[\"7/768/688\",205593.331,478890.397,209593.331,482890.397],[\"8/784/680\",209593.331,476890.397,211593.331,478890.397],[\"8/792/680\",211593.331,476890.397,213593.331,478890.397],[\"7/784/688\",209593.331,478890.397,213593.331,482890.397],[\"7/784/704\",209593.331,482890.397,213593.331,486890.397],[\"7/784/720\",209593.331,486890.397,213593.331,490890.397],[\"8/792/736\",211593.331,490890.397,213593.331,492890.397],[\"8/784/736\",209593.331,490890.397,211593.331,492890.397],[\"8/776/720\",207593.331,486890.397,209593.331,488890.397],[\"8/768/720\",205593.331,486890.397,207593.331,488890.397],[\"8/768/728\",205593.331,488890.397,207593.331,490890.397],[\"8/776/728\",207593.331,488890.397,209593.331,490890.397],[\"7/768/736\",205593.331,490890.397,209593.331,494890.397],[\"7/768/752\",205593.331,494890.397,209593.331,498890.397],[\"8/784/744\",209593.331,492890.397,211593.331,494890.397],[\"8/792/744\",211593.331,492890.397,213593.331,494890.397],[\"7/784/752\",209593.331,494890.397,213593.331,498890.397],[\"7/784/768\",209593.331,498890.397,213593.331,502890.397],[\"7/784/784\",209593.331,502890.397,213593.331,506890.397],[\"7/768/784\",205593.331,502890.397,209593.331,506890.397],[\"8/760/792\",203593.331,504890.397,205593.331,506890.397],[\"9/760/788\",203593.331,503890.397,204593.331,504890.397],[\"10/760/786\",203593.331,503390.397,204093.331,503890.397],[\"10/762/786\",204093.331,503390.397,204593.331,503890.397],[\"9/764/788\",204593.331,503890.397,205593.331,504890.397],[\"9/764/784\",204593.331,502890.397,205593.331,503890.397],[\"9/764/780\",204593.331,501890.397,205593.331,502890.397],[\"10/762/784\",204093.331,502890.397,204593.331,503390.397],[\"10/760/784\",203593.331,502890.397,204093.331,503390.397],[\"9/760/780\",203593.331,501890.397,204593.331,502890.397],[\"9/760/776\",203593.331,500890.397,204593.331,501890.397],[\"9/760/772\",203593.331,499890.397,204593.331,500890.397],[\"9/764/772\",204593.331,499890.397,205593.331,500890.397],[\"9/764/776\",204593.331,500890.397,205593.331,501890.397],[\"7/768/768\",205593.331,498890.397,209593.331,502890.397],[\"9/764/768\",204593.331,498890.397,205593.331,499890.397],[\"9/760/768\",203593.331,498890.397,204593.331,499890.397],[\"9/748/760\",200593.331,496890.397,201593.331,497890.397],[\"9/744/760\",199593.331,496890.397,200593.331,497890.397],[\"9/744/768\",199593.331,498890.397,200593.331,499890.397],[\"9/744/764\",199593.331,497890.397,200593.331,498890.397],[\"9/748/764\",200593.331,497890.397,201593.331,498890.397],[\"9/748/768\",200593.331,498890.397,201593.331,499890.397],[\"9/748/772\",200593.331,499890.397,201593.331,500890.397],[\"9/744/772\",199593.331,499890.397,200593.331,500890.397],[\"8/744/776\",199593.331,500890.397,201593.331,502890.397],[\"9/752/776\",201593.331,500890.397,202593.331,501890.397],[\"8/752/768\",201593.331,498890.397,203593.331,500890.397],[\"9/756/776\",202593.331,500890.397,203593.331,501890.397],[\"10/758/780\",203093.331,501890.397,203593.331,502390.397],[\"10/758/782\",203093.331,502390.397,203593.331,502890.397],[\"10/758/784\",203093.331,502890.397,203593.331,503390.397],[\"10/756/782\",202593.331,502390.397,203093.331,502890.397],[\"10/756/784\",202593.331,502890.397,203093.331,503390.397],[\"10/756/780\",202593.331,501890.397,203093.331,502390.397],[\"9/752/780\",201593.331,501890.397,202593.331,502890.397],[\"9/752/784\",201593.331,502890.397,202593.331,503890.397],[\"9/752/788\",201593.331,503890.397,202593.331,504890.397],[\"10/756/786\",202593.331,503390.397,203093.331,503890.397],[\"10/758/786\",203093.331,503390.397,203593.331,503890.397],[\"9/756/788\",202593.331,503890.397,203593.331,504890.397],[\"9/756/792\",202593.331,504890.397,203593.331,505890.397],[\"9/756/796\",202593.331,505890.397,203593.331,506890.397],[\"9/752/796\",201593.331,505890.397,202593.331,506890.397],[\"9/752/792\",201593.331,504890.397,202593.331,505890.397],[\"9/744/792\",199593.331,504890.397,200593.331,505890.397],[\"9/748/792\",200593.331,504890.397,201593.331,505890.397],[\"9/748/796\",200593.331,505890.397,201593.331,506890.397],[\"9/744/796\",199593.331,505890.397,200593.331,506890.397],[\"9/744/788\",199593.331,503890.397,200593.331,504890.397],[\"9/748/788\",200593.331,503890.397,201593.331,504890.397],[\"9/748/784\",200593.331,502890.397,201593.331,503890.397],[\"9/744/784\",199593.331,502890.397,200593.331,503890.397],[\"8/736/784\",197593.331,502890.397,199593.331,504890.397],[\"8/736/792\",197593.331,504890.397,199593.331,506890.397],[\"7/720/784\",193593.331,502890.397,197593.331,506890.397],[\"7/720/768\",193593.331,498890.397,197593.331,502890.397],[\"8/736/776\",197593.331,500890.397,199593.331,502890.397],[\"8/736/768\",197593.331,498890.397,199593.331,500890.397],[\"9/732/764\",196593.331,497890.397,197593.331,498890.397],[\"8/736/760\",197593.331,496890.397,199593.331,498890.397],[\"9/732/760\",196593.331,496890.397,197593.331,497890.397],[\"9/728/760\",195593.331,496890.397,196593.331,497890.397],[\"9/728/764\",195593.331,497890.397,196593.331,498890.397],[\"8/720/760\",193593.331,496890.397,195593.331,498890.397],[\"8/720/752\",193593.331,494890.397,195593.331,496890.397],[\"7/720/736\",193593.331,490890.397,197593.331,494890.397],[\"8/728/752\",195593.331,494890.397,197593.331,496890.397],[\"8/736/752\",197593.331,494890.397,199593.331,496890.397],[\"8/744/752\",199593.331,494890.397,201593.331,496890.397],[\"7/752/752\",201593.331,494890.397,205593.331,498890.397],[\"7/752/736\",201593.331,490890.397,205593.331,494890.397],[\"7/736/736\",197593.331,490890.397,201593.331,494890.397],[\"9/740/732\",198593.331,489890.397,199593.331,490890.397],[\"8/744/728\",199593.331,488890.397,201593.331,490890.397],[\"7/752/720\",201593.331,486890.397,205593.331,490890.397],[\"8/744/720\",199593.331,486890.397,201593.331,488890.397],[\"9/740/728\",198593.331,488890.397,199593.331,489890.397],[\"8/736/720\",197593.331,486890.397,199593.331,488890.397],[\"9/736/728\",197593.331,488890.397,198593.331,489890.397],[\"9/736/732\",197593.331,489890.397,198593.331,490890.397],[\"7/720/720\",193593.331,486890.397,197593.331,490890.397],[\"7/704/720\",189593.331,486890.397,193593.331,490890.397],[\"9/700/736\",188593.331,490890.397,189593.331,491890.397],[\"7/688/720\",185593.331,486890.397,189593.331,490890.397],[\"8/680/720\",183593.331,486890.397,185593.331,488890.397],[\"8/680/728\",183593.331,488890.397,185593.331,490890.397],[\"8/688/736\",185593.331,490890.397,187593.331,492890.397],[\"9/696/736\",187593.331,490890.397,188593.331,491890.397],[\"9/696/740\",187593.331,491890.397,188593.331,492890.397],[\"8/696/744\",187593.331,492890.397,189593.331,494890.397],[\"8/688/744\",185593.331,492890.397,187593.331,494890.397],[\"9/688/752\",185593.331,494890.397,186593.331,495890.397],[\"9/688/756\",185593.331,495890.397,186593.331,496890.397],[\"9/692/756\",186593.331,495890.397,187593.331,496890.397],[\"9/692/752\",186593.331,494890.397,187593.331,495890.397],[\"8/696/752\",187593.331,494890.397,189593.331,496890.397],[\"8/704/752\",189593.331,494890.397,191593.331,496890.397],[\"9/700/740\",188593.331,491890.397,189593.331,492890.397],[\"7/704/736\",189593.331,490890.397,193593.331,494890.397],[\"8/712/752\",191593.331,494890.397,193593.331,496890.397],[\"8/712/760\",191593.331,496890.397,193593.331,498890.397],[\"8/704/760\",189593.331,496890.397,191593.331,498890.397],[\"7/704/768\",189593.331,498890.397,193593.331,502890.397],[\"8/712/784\",191593.331,502890.397,193593.331,504890.397],[\"8/712/792\",191593.331,504890.397,193593.331,506890.397],[\"9/704/792\",189593.331,504890.397,190593.331,505890.397],[\"9/708/792\",190593.331,504890.397,191593.331,505890.397],[\"9/708/796\",190593.331,505890.397,191593.331,506890.397],[\"9/704/796\",189593.331,505890.397,190593.331,506890.397],[\"8/704/784\",189593.331,502890.397,191593.331,504890.397],[\"6/672/768\",181593.331,498890.397,189593.331,506890.397],[\"8/696/760\",187593.331,496890.397,189593.331,498890.397],[\"8/688/760\",185593.331,496890.397,187593.331,498890.397],[\"7/656/768\",177593.331,498890.397,181593.331,502890.397],[\"8/664/792\",179593.331,504890.397,181593.331,506890.397],[\"9/660/788\",178593.331,503890.397,179593.331,504890.397],[\"9/660/784\",178593.331,502890.397,179593.331,503890.397],[\"8/664/784\",179593.331,502890.397,181593.331,504890.397],[\"9/652/784\",176593.331,502890.397,177593.331,503890.397],[\"9/652/788\",176593.331,503890.397,177593.331,504890.397],[\"9/656/784\",177593.331,502890.397,178593.331,503890.397],[\"9/656/788\",177593.331,503890.397,178593.331,504890.397],[\"8/656/792\",177593.331,504890.397,179593.331,506890.397],[\"8/648/792\",175593.331,504890.397,177593.331,506890.397],[\"8/640/792\",173593.331,504890.397,175593.331,506890.397],[\"8/640/784\",173593.331,502890.397,175593.331,504890.397],[\"9/648/788\",175593.331,503890.397,176593.331,504890.397],[\"9/648/784\",175593.331,502890.397,176593.331,503890.397],[\"7/640/768\",173593.331,498890.397,177593.331,502890.397],[\"8/648/760\",175593.331,496890.397,177593.331,498890.397],[\"8/640/760\",173593.331,496890.397,175593.331,498890.397],[\"8/640/752\",173593.331,494890.397,175593.331,496890.397],[\"7/640/736\",173593.331,490890.397,177593.331,494890.397],[\"8/648/752\",175593.331,494890.397,177593.331,496890.397],[\"7/656/752\",177593.331,494890.397,181593.331,498890.397],[\"7/672/752\",181593.331,494890.397,185593.331,498890.397],[\"7/672/736\",181593.331,490890.397,185593.331,494890.397],[\"7/656/736\",177593.331,490890.397,181593.331,494890.397],[\"8/664/728\",179593.331,488890.397,181593.331,490890.397],[\"8/672/728\",181593.331,488890.397,183593.331,490890.397],[\"9/672/724\",181593.331,487890.397,182593.331,488890.397],[\"9/676/724\",182593.331,487890.397,183593.331,488890.397],[\"9/676/720\",182593.331,486890.397,183593.331,487890.397],[\"9/672/720\",181593.331,486890.397,182593.331,487890.397],[\"9/668/720\",180593.331,486890.397,181593.331,487890.397],[\"9/664/720\",179593.331,486890.397,180593.331,487890.397],[\"9/668/724\",180593.331,487890.397,181593.331,488890.397],[\"9/664/724\",179593.331,487890.397,180593.331,488890.397],[\"8/656/720\",177593.331,486890.397,179593.331,488890.397],[\"8/656/728\",177593.331,488890.397,179593.331,490890.397],[\"7/640/720\",173593.331,486890.397,177593.331,490890.397],[\"8/640/712\",173593.331,484890.397,175593.331,486890.397],[\"8/648/712\",175593.331,484890.397,177593.331,486890.397],[\"8/648/704\",175593.331,482890.397,177593.331,484890.397],[\"8/640/704\",173593.331,482890.397,175593.331,484890.397],[\"6/640/672\",173593.331,474890.397,181593.331,482890.397],[\"7/672/688\",181593.331,478890.397,185593.331,482890.397],[\"7/656/704\",177593.331,482890.397,181593.331,486890.397],[\"7/672/704\",181593.331,482890.397,185593.331,486890.397],[\"7/688/704\",185593.331,482890.397,189593.331,486890.397],[\"7/704/704\",189593.331,482890.397,193593.331,486890.397],[\"7/704/688\",189593.331,478890.397,193593.331,482890.397],[\"7/688/688\",185593.331,478890.397,189593.331,482890.397],[\"7/704/672\",189593.331,474890.397,193593.331,478890.397],[\"7/704/656\",189593.331,470890.397,193593.331,474890.397],[\"8/704/648\",189593.331,468890.397,191593.331,470890.397],[\"10/716/652\",192593.331,469890.397,193093.331,470390.397],[\"10/716/654\",192593.331,470390.397,193093.331,470890.397],[\"10/718/654\",193093.331,470390.397,193593.331,470890.397],[\"10/718/652\",193093.331,469890.397,193593.331,470390.397],[\"10/718/650\",193093.331,469390.397,193593.331,469890.397],[\"10/716/650\",192593.331,469390.397,193093.331,469890.397],[\"9/712/652\",191593.331,469890.397,192593.331,470890.397],[\"9/712/644\",191593.331,467890.397,192593.331,468890.397],[\"9/712/648\",191593.331,468890.397,192593.331,469890.397],[\"10/716/648\",192593.331,468890.397,193093.331,469390.397],[\"10/718/648\",193093.331,468890.397,193593.331,469390.397],[\"9/716/644\",192593.331,467890.397,193593.331,468890.397],[\"9/716/640\",192593.331,466890.397,193593.331,467890.397],[\"9/712/640\",191593.331,466890.397,192593.331,467890.397],[\"8/704/640\",189593.331,466890.397,191593.331,468890.397],[\"6/672/640\",181593.331,466890.397,189593.331,474890.397],[\"7/656/640\",177593.331,466890.397,181593.331,470890.397],[\"7/672/672\",181593.331,474890.397,185593.331,478890.397],[\"7/656/656\",177593.331,470890.397,181593.331,474890.397],[\"7/640/656\",173593.331,470890.397,177593.331,474890.397],[\"7/640/640\",173593.331,466890.397,177593.331,470890.397],[\"8/632/640\",171593.331,466890.397,173593.331,468890.397],[\"8/624/640\",169593.331,466890.397,171593.331,468890.397],[\"8/624/648\",169593.331,468890.397,171593.331,470890.397],[\"8/624/656\",169593.331,470890.397,171593.331,472890.397],[\"8/632/648\",171593.331,468890.397,173593.331,470890.397],[\"8/632/656\",171593.331,470890.397,173593.331,472890.397],[\"8/632/664\",171593.331,472890.397,173593.331,474890.397],[\"8/632/672\",171593.331,474890.397,173593.331,476890.397],[\"10/626/670\",170093.331,474390.397,170593.331,474890.397],[\"8/624/672\",169593.331,474890.397,171593.331,476890.397],[\"10/624/670\",169593.331,474390.397,170093.331,474890.397],[\"9/620/668\",168593.331,473890.397,169593.331,474890.397],[\"9/620/664\",168593.331,472890.397,169593.331,473890.397],[\"10/624/668\",169593.331,473890.397,170093.331,474390.397],[\"10/626/668\",170093.331,473890.397,170593.331,474390.397],[\"9/628/668\",170593.331,473890.397,171593.331,474890.397],[\"9/628/664\",170593.331,472890.397,171593.331,473890.397],[\"9/624/664\",169593.331,472890.397,170593.331,473890.397],[\"8/608/664\",165593.331,472890.397,167593.331,474890.397],[\"9/616/664\",167593.331,472890.397,168593.331,473890.397],[\"9/616/668\",167593.331,473890.397,168593.331,474890.397],[\"8/616/672\",167593.331,474890.397,169593.331,476890.397],[\"8/608/672\",165593.331,474890.397,167593.331,476890.397],[\"8/600/648\",163593.331,468890.397,165593.331,470890.397],[\"8/608/656\",165593.331,470890.397,167593.331,472890.397],[\"8/616/656\",167593.331,470890.397,169593.331,472890.397],[\"7/608/640\",165593.331,466890.397,169593.331,470890.397],[\"8/600/640\",163593.331,466890.397,165593.331,468890.397],[\"8/592/640\",161593.331,466890.397,163593.331,468890.397],[\"9/592/648\",161593.331,468890.397,162593.331,469890.397],[\"9/596/648\",162593.331,468890.397,163593.331,469890.397],[\"9/596/652\",162593.331,469890.397,163593.331,470890.397],[\"10/590/654\",161093.331,470390.397,161593.331,470890.397],[\"10/590/652\",161093.331,469890.397,161593.331,470390.397],[\"9/592/652\",161593.331,469890.397,162593.331,470890.397],[\"9/584/652\",159593.331,469890.397,160593.331,470890.397],[\"10/588/652\",160593.331,469890.397,161093.331,470390.397],[\"10/588/654\",160593.331,470390.397,161093.331,470890.397],[\"9/580/644\",158593.331,467890.397,159593.331,468890.397],[\"9/584/648\",159593.331,468890.397,160593.331,469890.397],[\"9/588/648\",160593.331,468890.397,161593.331,469890.397],[\"8/584/640\",159593.331,466890.397,161593.331,468890.397],[\"9/580/640\",158593.331,466890.397,159593.331,467890.397],[\"9/576/640\",157593.331,466890.397,158593.331,467890.397],[\"9/576/644\",157593.331,467890.397,158593.331,468890.397],[\"9/572/644\",156593.331,467890.397,157593.331,468890.397],[\"10/574/642\",157093.331,467390.397,157593.331,467890.397],[\"10/572/642\",156593.331,467390.397,157093.331,467890.397],[\"10/574/640\",157093.331,466890.397,157593.331,467390.397],[\"10/572/640\",156593.331,466890.397,157093.331,467390.397],[\"9/568/640\",155593.331,466890.397,156593.331,467890.397],[\"9/564/640\",154593.331,466890.397,155593.331,467890.397],[\"10/562/640\",154093.331,466890.397,154593.331,467390.397],[\"10/560/640\",153593.331,466890.397,154093.331,467390.397],[\"10/560/642\",153593.331,467390.397,154093.331,467890.397],[\"10/562/642\",154093.331,467390.397,154593.331,467890.397],[\"9/560/644\",153593.331,467890.397,154593.331,468890.397],[\"9/564/644\",154593.331,467890.397,155593.331,468890.397],[\"9/568/644\",155593.331,467890.397,156593.331,468890.397],[\"8/560/648\",153593.331,468890.397,155593.331,470890.397],[\"9/560/656\",153593.331,470890.397,154593.331,471890.397],[\"9/564/656\",154593.331,470890.397,155593.331,471890.397],[\"8/568/656\",155593.331,470890.397,157593.331,472890.397],[\"8/568/648\",155593.331,468890.397,157593.331,470890.397],[\"8/576/648\",157593.331,468890.397,159593.331,470890.397],[\"8/568/664\",155593.331,472890.397,157593.331,474890.397],[\"9/564/660\",154593.331,471890.397,155593.331,472890.397],[\"9/560/660\",153593.331,471890.397,154593.331,472890.397],[\"10/560/664\",153593.331,472890.397,154093.331,473390.397],[\"10/562/664\",154093.331,472890.397,154593.331,473390.397],[\"10/562/666\",154093.331,473390.397,154593.331,473890.397],[\"10/560/666\",153593.331,473390.397,154093.331,473890.397],[\"9/560/668\",153593.331,473890.397,154593.331,474890.397],[\"9/564/668\",154593.331,473890.397,155593.331,474890.397],[\"9/564/664\",154593.331,472890.397,155593.331,473890.397],[\"7/576/672\",157593.331,474890.397,161593.331,478890.397],[\"7/576/656\",157593.331,470890.397,161593.331,474890.397],[\"7/592/656\",161593.331,470890.397,165593.331,474890.397],[\"7/592/672\",161593.331,474890.397,165593.331,478890.397],[\"8/592/688\",161593.331,478890.397,163593.331,480890.397],[\"8/592/696\",161593.331,480890.397,163593.331,482890.397],[\"7/576/688\",157593.331,478890.397,161593.331,482890.397],[\"7/560/704\",153593.331,482890.397,157593.331,486890.397],[\"7/576/704\",157593.331,482890.397,161593.331,486890.397],[\"8/592/704\",161593.331,482890.397,163593.331,484890.397],[\"8/592/712\",161593.331,484890.397,163593.331,486890.397],[\"8/600/712\",163593.331,484890.397,165593.331,486890.397],[\"7/608/704\",165593.331,482890.397,169593.331,486890.397],[\"9/616/700\",167593.331,481890.397,168593.331,482890.397],[\"9/604/700\",164593.331,481890.397,165593.331,482890.397],[\"9/604/708\",164593.331,483890.397,165593.331,484890.397],[\"9/604/704\",164593.331,482890.397,165593.331,483890.397],[\"9/600/708\",163593.331,483890.397,164593.331,484890.397],[\"9/600/704\",163593.331,482890.397,164593.331,483890.397],[\"9/600/700\",163593.331,481890.397,164593.331,482890.397],[\"9/604/696\",164593.331,480890.397,165593.331,481890.397],[\"8/600/688\",163593.331,478890.397,165593.331,480890.397],[\"8/608/680\",165593.331,476890.397,167593.331,478890.397],[\"8/616/680\",167593.331,476890.397,169593.331,478890.397],[\"8/616/688\",167593.331,478890.397,169593.331,480890.397],[\"8/608/688\",165593.331,478890.397,167593.331,480890.397],[\"8/608/696\",165593.331,480890.397,167593.331,482890.397],[\"9/616/696\",167593.331,480890.397,168593.331,481890.397],[\"9/620/696\",168593.331,480890.397,169593.331,481890.397],[\"9/624/696\",169593.331,480890.397,170593.331,481890.397],[\"9/628/696\",170593.331,480890.397,171593.331,481890.397],[\"9/624/692\",169593.331,479890.397,170593.331,480890.397],[\"9/628/692\",170593.331,479890.397,171593.331,480890.397],[\"9/624/680\",169593.331,476890.397,170593.331,477890.397],[\"9/628/680\",170593.331,476890.397,171593.331,477890.397],[\"9/628/684\",170593.331,477890.397,171593.331,478890.397],[\"9/624/684\",169593.331,477890.397,170593.331,478890.397],[\"9/624/688\",169593.331,478890.397,170593.331,479890.397],[\"9/628/688\",170593.331,478890.397,171593.331,479890.397],[\"8/632/680\",171593.331,476890.397,173593.331,478890.397],[\"8/632/688\",171593.331,478890.397,173593.331,480890.397],[\"8/632/696\",171593.331,480890.397,173593.331,482890.397],[\"9/636/704\",172593.331,482890.397,173593.331,483890.397],[\"9/636/708\",172593.331,483890.397,173593.331,484890.397],[\"9/632/704\",171593.331,482890.397,172593.331,483890.397],[\"9/632/708\",171593.331,483890.397,172593.331,484890.397],[\"10/630/708\",171093.331,483890.397,171593.331,484390.397],[\"9/628/700\",170593.331,481890.397,171593.331,482890.397],[\"9/624/700\",169593.331,481890.397,170593.331,482890.397],[\"9/620/700\",168593.331,481890.397,169593.331,482890.397],[\"9/624/708\",169593.331,483890.397,170593.331,484890.397],[\"9/624/704\",169593.331,482890.397,170593.331,483890.397],[\"9/628/704\",170593.331,482890.397,171593.331,483890.397],[\"10/628/708\",170593.331,483890.397,171093.331,484390.397],[\"10/628/710\",170593.331,484390.397,171093.331,484890.397],[\"8/624/712\",169593.331,484890.397,171593.331,486890.397],[\"10/630/710\",171093.331,484390.397,171593.331,484890.397],[\"8/632/712\",171593.331,484890.397,173593.331,486890.397],[\"7/624/720\",169593.331,486890.397,173593.331,490890.397],[\"7/608/720\",165593.331,486890.397,169593.331,490890.397],[\"6/608/736\",165593.331,490890.397,173593.331,498890.397],[\"6/608/768\",165593.331,498890.397,173593.331,506890.397],[\"8/600/792\",163593.331,504890.397,165593.331,506890.397],[\"8/600/784\",163593.331,502890.397,165593.331,504890.397],[\"8/600/776\",163593.331,500890.397,165593.331,502890.397],[\"8/600/768\",163593.331,498890.397,165593.331,500890.397],[\"9/596/768\",162593.331,498890.397,163593.331,499890.397],[\"9/592/768\",161593.331,498890.397,162593.331,499890.397],[\"8/584/768\",159593.331,498890.397,161593.331,500890.397],[\"9/580/776\",158593.331,500890.397,159593.331,501890.397],[\"9/584/776\",159593.331,500890.397,160593.331,501890.397],[\"9/588/776\",160593.331,500890.397,161593.331,501890.397],[\"9/592/776\",161593.331,500890.397,162593.331,501890.397],[\"9/592/772\",161593.331,499890.397,162593.331,500890.397],[\"9/596/772\",162593.331,499890.397,163593.331,500890.397],[\"9/596/776\",162593.331,500890.397,163593.331,501890.397],[\"9/596/780\",162593.331,501890.397,163593.331,502890.397],[\"9/592/780\",161593.331,501890.397,162593.331,502890.397],[\"9/592/784\",161593.331,502890.397,162593.331,503890.397],[\"9/592/788\",161593.331,503890.397,162593.331,504890.397],[\"9/596/784\",162593.331,502890.397,163593.331,503890.397],[\"9/596/788\",162593.331,503890.397,163593.331,504890.397],[\"8/592/792\",161593.331,504890.397,163593.331,506890.397],[\"8/584/792\",159593.331,504890.397,161593.331,506890.397],[\"9/584/788\",159593.331,503890.397,160593.331,504890.397],[\"9/588/788\",160593.331,503890.397,161593.331,504890.397],[\"9/588/784\",160593.331,502890.397,161593.331,503890.397],[\"9/584/784\",159593.331,502890.397,160593.331,503890.397],[\"9/588/780\",160593.331,501890.397,161593.331,502890.397],[\"9/584/780\",159593.331,501890.397,160593.331,502890.397],[\"9/580/780\",158593.331,501890.397,159593.331,502890.397],[\"9/576/780\",157593.331,501890.397,158593.331,502890.397],[\"8/576/784\",157593.331,502890.397,159593.331,504890.397],[\"8/576/792\",157593.331,504890.397,159593.331,506890.397],[\"9/576/776\",157593.331,500890.397,158593.331,501890.397],[\"8/576/768\",157593.331,498890.397,159593.331,500890.397],[\"6/576/736\",157593.331,490890.397,165593.331,498890.397],[\"7/592/720\",161593.331,486890.397,165593.331,490890.397],[\"7/576/720\",157593.331,486890.397,161593.331,490890.397],[\"7/560/720\",153593.331,486890.397,157593.331,490890.397],[\"8/552/720\",151593.331,486890.397,153593.331,488890.397],[\"8/552/728\",151593.331,488890.397,153593.331,490890.397],[\"9/544/732\",149593.331,489890.397,150593.331,490890.397],[\"9/548/732\",150593.331,489890.397,151593.331,490890.397],[\"9/540/732\",148593.331,489890.397,149593.331,490890.397],[\"9/540/728\",148593.331,488890.397,149593.331,489890.397],[\"9/544/728\",149593.331,488890.397,150593.331,489890.397],[\"8/544/720\",149593.331,486890.397,151593.331,488890.397],[\"8/536/720\",147593.331,486890.397,149593.331,488890.397],[\"9/536/728\",147593.331,488890.397,148593.331,489890.397],[\"9/532/724\",146593.331,487890.397,147593.331,488890.397],[\"9/532/728\",146593.331,488890.397,147593.331,489890.397],[\"9/532/720\",146593.331,486890.397,147593.331,487890.397],[\"9/528/720\",145593.331,486890.397,146593.331,487890.397],[\"9/524/720\",144593.331,486890.397,145593.331,487890.397],[\"9/520/720\",143593.331,486890.397,144593.331,487890.397],[\"9/520/724\",143593.331,487890.397,144593.331,488890.397],[\"9/524/724\",144593.331,487890.397,145593.331,488890.397],[\"9/528/724\",145593.331,487890.397,146593.331,488890.397],[\"9/528/728\",145593.331,488890.397,146593.331,489890.397],[\"9/528/732\",145593.331,489890.397,146593.331,490890.397],[\"8/520/728\",143593.331,488890.397,145593.331,490890.397],[\"9/532/732\",146593.331,489890.397,147593.331,490890.397],[\"9/536/732\",147593.331,489890.397,148593.331,490890.397],[\"6/512/736\",141593.331,490890.397,149593.331,498890.397],[\"6/544/736\",149593.331,490890.397,157593.331,498890.397],[\"5/512/768\",141593.331,498890.397,157593.331,514890.397],[\"7/480/784\",133593.331,502890.397,137593.331,506890.397],[\"9/480/780\",133593.331,501890.397,134593.331,502890.397],[\"9/480/776\",133593.331,500890.397,134593.331,501890.397],[\"8/480/768\",133593.331,498890.397,135593.331,500890.397],[\"6/480/736\",133593.331,490890.397,141593.331,498890.397],[\"8/504/728\",139593.331,488890.397,141593.331,490890.397],[\"8/512/728\",141593.331,488890.397,143593.331,490890.397],[\"9/512/724\",141593.331,487890.397,142593.331,488890.397],[\"9/516/724\",142593.331,487890.397,143593.331,488890.397],[\"9/516/720\",142593.331,486890.397,143593.331,487890.397],[\"9/512/720\",141593.331,486890.397,142593.331,487890.397],[\"9/508/720\",140593.331,486890.397,141593.331,487890.397],[\"9/504/720\",139593.331,486890.397,140593.331,487890.397],[\"9/508/724\",140593.331,487890.397,141593.331,488890.397],[\"8/496/720\",137593.331,486890.397,139593.331,488890.397],[\"7/480/720\",133593.331,486890.397,137593.331,490890.397],[\"7/480/704\",133593.331,482890.397,137593.331,486890.397],[\"8/496/712\",137593.331,484890.397,139593.331,486890.397],[\"9/496/708\",137593.331,483890.397,138593.331,484890.397],[\"9/496/704\",137593.331,482890.397,138593.331,483890.397],[\"7/480/688\",133593.331,478890.397,137593.331,482890.397],[\"9/496/680\",137593.331,476890.397,138593.331,477890.397],[\"9/496/684\",137593.331,477890.397,138593.331,478890.397],[\"7/496/688\",137593.331,478890.397,141593.331,482890.397],[\"9/500/684\",138593.331,477890.397,139593.331,478890.397],[\"10/500/682\",138593.331,477390.397,139093.331,477890.397],[\"10/500/680\",138593.331,476890.397,139093.331,477390.397],[\"10/502/680\",139093.331,476890.397,139593.331,477390.397],[\"10/502/682\",139093.331,477390.397,139593.331,477890.397],[\"9/504/680\",139593.331,476890.397,140593.331,477890.397],[\"9/508/680\",140593.331,476890.397,141593.331,477890.397],[\"9/508/684\",140593.331,477890.397,141593.331,478890.397],[\"9/504/684\",139593.331,477890.397,140593.331,478890.397],[\"8/512/680\",141593.331,476890.397,143593.331,478890.397],[\"8/512/688\",141593.331,478890.397,143593.331,480890.397],[\"8/512/696\",141593.331,480890.397,143593.331,482890.397],[\"9/516/704\",142593.331,482890.397,143593.331,483890.397],[\"9/516/708\",142593.331,483890.397,143593.331,484890.397],[\"9/512/704\",141593.331,482890.397,142593.331,483890.397],[\"9/512/708\",141593.331,483890.397,142593.331,484890.397],[\"9/500/704\",138593.331,482890.397,139593.331,483890.397],[\"9/500/708\",138593.331,483890.397,139593.331,484890.397],[\"8/504/704\",139593.331,482890.397,141593.331,484890.397],[\"9/508/712\",140593.331,484890.397,141593.331,485890.397],[\"9/504/712\",139593.331,484890.397,140593.331,485890.397],[\"9/504/716\",139593.331,485890.397,140593.331,486890.397],[\"9/508/716\",140593.331,485890.397,141593.331,486890.397],[\"9/512/716\",141593.331,485890.397,142593.331,486890.397],[\"9/512/712\",141593.331,484890.397,142593.331,485890.397],[\"9/516/712\",142593.331,484890.397,143593.331,485890.397],[\"9/516/716\",142593.331,485890.397,143593.331,486890.397],[\"9/520/716\",143593.331,485890.397,144593.331,486890.397],[\"9/524/716\",144593.331,485890.397,145593.331,486890.397],[\"9/528/716\",145593.331,485890.397,146593.331,486890.397],[\"9/524/712\",144593.331,484890.397,145593.331,485890.397],[\"9/528/712\",145593.331,484890.397,146593.331,485890.397],[\"9/520/712\",143593.331,484890.397,144593.331,485890.397],[\"9/520/708\",143593.331,483890.397,144593.331,484890.397],[\"9/520/704\",143593.331,482890.397,144593.331,483890.397],[\"9/524/704\",144593.331,482890.397,145593.331,483890.397],[\"9/524/708\",144593.331,483890.397,145593.331,484890.397],[\"8/528/704\",145593.331,482890.397,147593.331,484890.397],[\"8/536/704\",147593.331,482890.397,149593.331,484890.397],[\"9/532/712\",146593.331,484890.397,147593.331,485890.397],[\"9/532/716\",146593.331,485890.397,147593.331,486890.397],[\"8/536/712\",147593.331,484890.397,149593.331,486890.397],[\"7/544/704\",149593.331,482890.397,153593.331,486890.397],[\"6/544/672\",149593.331,474890.397,157593.331,482890.397],[\"8/536/680\",147593.331,476890.397,149593.331,478890.397],[\"9/532/680\",146593.331,476890.397,147593.331,477890.397],[\"9/532/684\",146593.331,477890.397,147593.331,478890.397],[\"9/532/688\",146593.331,478890.397,147593.331,479890.397],[\"8/536/688\",147593.331,478890.397,149593.331,480890.397],[\"8/536/696\",147593.331,480890.397,149593.331,482890.397],[\"8/528/696\",145593.331,480890.397,147593.331,482890.397],[\"9/524/692\",144593.331,479890.397,145593.331,480890.397],[\"9/528/692\",145593.331,479890.397,146593.331,480890.397],[\"8/520/696\",143593.331,480890.397,145593.331,482890.397],[\"9/520/692\",143593.331,479890.397,144593.331,480890.397],[\"9/520/688\",143593.331,478890.397,144593.331,479890.397],[\"9/520/684\",143593.331,477890.397,144593.331,478890.397],[\"10/524/686\",144593.331,478390.397,145093.331,478890.397],[\"9/524/688\",144593.331,478890.397,145593.331,479890.397],[\"9/528/688\",145593.331,478890.397,146593.331,479890.397],[\"9/528/684\",145593.331,477890.397,146593.331,478890.397],[\"10/526/686\",145093.331,478390.397,145593.331,478890.397],[\"10/526/684\",145093.331,477890.397,145593.331,478390.397],[\"9/528/680\",145593.331,476890.397,146593.331,477890.397],[\"9/524/680\",144593.331,476890.397,145593.331,477890.397],[\"10/524/684\",144593.331,477890.397,145093.331,478390.397],[\"9/520/680\",143593.331,476890.397,144593.331,477890.397],[\"9/520/676\",143593.331,475890.397,144593.331,476890.397],[\"9/524/676\",144593.331,475890.397,145593.331,476890.397],[\"9/524/672\",144593.331,474890.397,145593.331,475890.397],[\"10/522/670\",144093.331,474390.397,144593.331,474890.397],[\"9/520/672\",143593.331,474890.397,144593.331,475890.397],[\"10/520/670\",143593.331,474390.397,144093.331,474890.397],[\"10/520/668\",143593.331,473890.397,144093.331,474390.397],[\"10/522/668\",144093.331,473890.397,144593.331,474390.397],[\"9/520/664\",143593.331,472890.397,144593.331,473890.397],[\"9/528/664\",145593.331,472890.397,146593.331,473890.397],[\"9/524/664\",144593.331,472890.397,145593.331,473890.397],[\"9/524/668\",144593.331,473890.397,145593.331,474890.397],[\"9/528/668\",145593.331,473890.397,146593.331,474890.397],[\"9/532/668\",146593.331,473890.397,147593.331,474890.397],[\"9/532/664\",146593.331,472890.397,147593.331,473890.397],[\"8/536/664\",147593.331,472890.397,149593.331,474890.397],[\"8/528/672\",145593.331,474890.397,147593.331,476890.397],[\"8/536/672\",147593.331,474890.397,149593.331,476890.397],[\"8/552/664\",151593.331,472890.397,153593.331,474890.397],[\"8/544/664\",149593.331,472890.397,151593.331,474890.397],[\"9/540/652\",148593.331,469890.397,149593.331,470890.397],[\"8/544/656\",149593.331,470890.397,151593.331,472890.397],[\"8/552/656\",151593.331,470890.397,153593.331,472890.397],[\"7/544/640\",149593.331,466890.397,153593.331,470890.397],[\"9/540/648\",148593.331,468890.397,149593.331,469890.397],[\"9/540/644\",148593.331,467890.397,149593.331,468890.397],[\"9/540/640\",148593.331,466890.397,149593.331,467890.397],[\"9/536/640\",147593.331,466890.397,148593.331,467890.397],[\"8/528/640\",145593.331,466890.397,147593.331,468890.397],[\"10/536/648\",147593.331,468890.397,148093.331,469390.397],[\"9/536/644\",147593.331,467890.397,148593.331,468890.397],[\"10/538/648\",148093.331,468890.397,148593.331,469390.397],[\"10/538/650\",148093.331,469390.397,148593.331,469890.397],[\"10/536/650\",147593.331,469390.397,148093.331,469890.397],[\"9/536/652\",147593.331,469890.397,148593.331,470890.397],[\"8/536/656\",147593.331,470890.397,149593.331,472890.397],[\"8/528/656\",145593.331,470890.397,147593.331,472890.397],[\"8/528/648\",145593.331,468890.397,147593.331,470890.397],[\"8/520/656\",143593.331,470890.397,145593.331,472890.397],[\"8/520/648\",143593.331,468890.397,145593.331,470890.397],[\"8/520/640\",143593.331,466890.397,145593.331,468890.397],[\"8/512/640\",141593.331,466890.397,143593.331,468890.397],[\"9/516/648\",142593.331,468890.397,143593.331,469890.397],[\"9/512/648\",141593.331,468890.397,142593.331,469890.397],[\"8/504/640\",139593.331,466890.397,141593.331,468890.397],[\"9/500/640\",138593.331,466890.397,139593.331,467890.397],[\"9/500/644\",138593.331,467890.397,139593.331,468890.397],[\"9/500/648\",138593.331,468890.397,139593.331,469890.397],[\"10/504/648\",139593.331,468890.397,140093.331,469390.397],[\"10/506/648\",140093.331,468890.397,140593.331,469390.397],[\"9/508/648\",140593.331,468890.397,141593.331,469890.397],[\"10/508/652\",140593.331,469890.397,141093.331,470390.397],[\"10/508/654\",140593.331,470390.397,141093.331,470890.397],[\"10/506/652\",140093.331,469890.397,140593.331,470390.397],[\"10/506/654\",140093.331,470390.397,140593.331,470890.397],[\"10/506/650\",140093.331,469390.397,140593.331,469890.397],[\"10/504/650\",139593.331,469390.397,140093.331,469890.397],[\"10/500/652\",138593.331,469890.397,139093.331,470390.397],[\"10/500/654\",138593.331,470390.397,139093.331,470890.397],[\"10/502/654\",139093.331,470390.397,139593.331,470890.397],[\"10/502/652\",139093.331,469890.397,139593.331,470390.397],[\"10/504/652\",139593.331,469890.397,140093.331,470390.397],[\"10/504/654\",139593.331,470390.397,140093.331,470890.397],[\"10/504/656\",139593.331,470890.397,140093.331,471390.397],[\"10/504/658\",139593.331,471390.397,140093.331,471890.397],[\"10/506/658\",140093.331,471390.397,140593.331,471890.397],[\"10/506/656\",140093.331,470890.397,140593.331,471390.397],[\"10/508/656\",140593.331,470890.397,141093.331,471390.397],[\"10/508/658\",140593.331,471390.397,141093.331,471890.397],[\"10/510/658\",141093.331,471390.397,141593.331,471890.397],[\"10/512/658\",141593.331,471390.397,142093.331,471890.397],[\"10/514/658\",142093.331,471390.397,142593.331,471890.397],[\"10/512/656\",141593.331,470890.397,142093.331,471390.397],[\"10/514/656\",142093.331,470890.397,142593.331,471390.397],[\"10/510/656\",141093.331,470890.397,141593.331,471390.397],[\"10/510/654\",141093.331,470390.397,141593.331,470890.397],[\"10/510/652\",141093.331,469890.397,141593.331,470390.397],[\"9/512/652\",141593.331,469890.397,142593.331,470890.397],[\"9/516/652\",142593.331,469890.397,143593.331,470890.397],[\"9/516/656\",142593.331,470890.397,143593.331,471890.397],[\"9/516/660\",142593.331,471890.397,143593.331,472890.397],[\"9/512/660\",141593.331,471890.397,142593.331,472890.397],[\"8/512/664\",141593.331,472890.397,143593.331,474890.397],[\"8/512/672\",141593.331,474890.397,143593.331,476890.397],[\"10/510/678\",141093.331,476390.397,141593.331,476890.397],[\"10/510/676\",141093.331,475890.397,141593.331,476390.397],[\"10/506/672\",140093.331,474890.397,140593.331,475390.397],[\"10/506/674\",140093.331,475390.397,140593.331,475890.397],[\"9/508/672\",140593.331,474890.397,141593.331,475890.397],[\"10/508/676\",140593.331,475890.397,141093.331,476390.397],[\"10/508/678\",140593.331,476390.397,141093.331,476890.397],[\"10/506/678\",140093.331,476390.397,140593.331,476890.397],[\"10/506/676\",140093.331,475890.397,140593.331,476390.397],[\"10/502/676\",139093.331,475890.397,139593.331,476390.397],[\"10/504/676\",139593.331,475890.397,140093.331,476390.397],[\"10/504/678\",139593.331,476390.397,140093.331,476890.397],[\"10/502/678\",139093.331,476390.397,139593.331,476890.397],[\"10/500/678\",138593.331,476390.397,139093.331,476890.397],[\"10/500/676\",138593.331,475890.397,139093.331,476390.397],[\"9/500/672\",138593.331,474890.397,139593.331,475890.397],[\"10/504/674\",139593.331,475390.397,140093.331,475890.397],[\"10/504/672\",139593.331,474890.397,140093.331,475390.397],[\"8/504/664\",139593.331,472890.397,141593.331,474890.397],[\"9/508/660\",140593.331,471890.397,141593.331,472890.397],[\"9/504/660\",139593.331,471890.397,140593.331,472890.397],[\"9/492/660\",136593.331,471890.397,137593.331,472890.397],[\"8/488/664\",135593.331,472890.397,137593.331,474890.397],[\"8/496/664\",137593.331,472890.397,139593.331,474890.397],[\"9/496/672\",137593.331,474890.397,138593.331,475890.397],[\"9/496/676\",137593.331,475890.397,138593.331,476890.397],[\"7/480/672\",133593.331,474890.397,137593.331,478890.397],[\"8/480/664\",133593.331,472890.397,135593.331,474890.397],[\"9/488/660\",135593.331,471890.397,136593.331,472890.397],[\"8/480/656\",133593.331,470890.397,135593.331,472890.397],[\"8/480/648\",133593.331,468890.397,135593.331,470890.397],[\"9/488/656\",135593.331,470890.397,136593.331,471890.397],[\"9/492/656\",136593.331,470890.397,137593.331,471890.397],[\"8/496/656\",137593.331,470890.397,139593.331,472890.397],[\"9/496/652\",137593.331,469890.397,138593.331,470890.397],[\"8/488/648\",135593.331,468890.397,137593.331,470890.397],[\"9/496/648\",137593.331,468890.397,138593.331,469890.397],[\"9/496/644\",137593.331,467890.397,138593.331,468890.397],[\"9/496/640\",137593.331,466890.397,138593.331,467890.397],[\"8/488/640\",135593.331,466890.397,137593.331,468890.397],[\"8/480/640\",133593.331,466890.397,135593.331,468890.397],[\"8/472/640\",131593.331,466890.397,133593.331,468890.397],[\"8/472/648\",131593.331,468890.397,133593.331,470890.397],[\"8/472/656\",131593.331,470890.397,133593.331,472890.397],[\"8/464/648\",129593.331,468890.397,131593.331,470890.397],[\"8/464/656\",129593.331,470890.397,131593.331,472890.397],[\"8/464/640\",129593.331,466890.397,131593.331,468890.397],[\"7/448/640\",125593.331,466890.397,129593.331,470890.397],[\"8/440/640\",123593.331,466890.397,125593.331,468890.397],[\"8/440/648\",123593.331,468890.397,125593.331,470890.397],[\"7/448/656\",125593.331,470890.397,129593.331,474890.397],[\"9/448/672\",125593.331,474890.397,126593.331,475890.397],[\"8/440/672\",123593.331,474890.397,125593.331,476890.397],[\"9/448/676\",125593.331,475890.397,126593.331,476890.397],[\"9/452/676\",126593.331,475890.397,127593.331,476890.397],[\"9/452/672\",126593.331,474890.397,127593.331,475890.397],[\"8/456/672\",127593.331,474890.397,129593.331,476890.397],[\"8/464/664\",129593.331,472890.397,131593.331,474890.397],[\"8/472/664\",131593.331,472890.397,133593.331,474890.397],[\"7/464/672\",129593.331,474890.397,133593.331,478890.397],[\"9/464/688\",129593.331,478890.397,130593.331,479890.397],[\"9/468/688\",130593.331,478890.397,131593.331,479890.397],[\"10/468/692\",130593.331,479890.397,131093.331,480390.397],[\"10/468/694\",130593.331,480390.397,131093.331,480890.397],[\"9/464/692\",129593.331,479890.397,130593.331,480890.397],[\"8/464/696\",129593.331,480890.397,131593.331,482890.397],[\"10/470/694\",131093.331,480390.397,131593.331,480890.397],[\"10/470/692\",131093.331,479890.397,131593.331,480390.397],[\"8/472/688\",131593.331,478890.397,133593.331,480890.397],[\"8/472/696\",131593.331,480890.397,133593.331,482890.397],[\"7/464/704\",129593.331,482890.397,133593.331,486890.397],[\"9/452/700\",126593.331,481890.397,127593.331,482890.397],[\"9/452/704\",126593.331,482890.397,127593.331,483890.397],[\"9/452/708\",126593.331,483890.397,127593.331,484890.397],[\"8/456/704\",127593.331,482890.397,129593.331,484890.397],[\"8/456/712\",127593.331,484890.397,129593.331,486890.397],[\"8/448/712\",125593.331,484890.397,127593.331,486890.397],[\"9/444/712\",124593.331,484890.397,125593.331,485890.397],[\"9/444/716\",124593.331,485890.397,125593.331,486890.397],[\"9/440/716\",123593.331,485890.397,124593.331,486890.397],[\"9/440/712\",123593.331,484890.397,124593.331,485890.397],[\"9/440/708\",123593.331,483890.397,124593.331,484890.397],[\"9/440/704\",123593.331,482890.397,124593.331,483890.397],[\"9/444/708\",124593.331,483890.397,125593.331,484890.397],[\"9/448/708\",125593.331,483890.397,126593.331,484890.397],[\"9/448/704\",125593.331,482890.397,126593.331,483890.397],[\"9/444/704\",124593.331,482890.397,125593.331,483890.397],[\"9/448/700\",125593.331,481890.397,126593.331,482890.397],[\"9/444/700\",124593.331,481890.397,125593.331,482890.397],[\"9/440/700\",123593.331,481890.397,124593.331,482890.397],[\"9/440/696\",123593.331,480890.397,124593.331,481890.397],[\"8/440/688\",123593.331,478890.397,125593.331,480890.397],[\"9/448/692\",125593.331,479890.397,126593.331,480890.397],[\"9/444/696\",124593.331,480890.397,125593.331,481890.397],[\"9/448/696\",125593.331,480890.397,126593.331,481890.397],[\"9/452/696\",126593.331,480890.397,127593.331,481890.397],[\"8/456/696\",127593.331,480890.397,129593.331,482890.397],[\"8/456/688\",127593.331,478890.397,129593.331,480890.397],[\"9/452/692\",126593.331,479890.397,127593.331,480890.397],[\"9/452/688\",126593.331,478890.397,127593.331,479890.397],[\"8/456/680\",127593.331,476890.397,129593.331,478890.397],[\"8/448/680\",125593.331,476890.397,127593.331,478890.397],[\"9/448/688\",125593.331,478890.397,126593.331,479890.397],[\"8/440/680\",123593.331,476890.397,125593.331,478890.397],[\"9/436/680\",122593.331,476890.397,123593.331,477890.397],[\"9/436/684\",122593.331,477890.397,123593.331,478890.397],[\"9/432/684\",121593.331,477890.397,122593.331,478890.397],[\"8/424/680\",119593.331,476890.397,121593.331,478890.397],[\"9/420/680\",118593.331,476890.397,119593.331,477890.397],[\"9/420/684\",118593.331,477890.397,119593.331,478890.397],[\"9/420/688\",118593.331,478890.397,119593.331,479890.397],[\"9/424/688\",119593.331,478890.397,120593.331,479890.397],[\"9/428/688\",120593.331,478890.397,121593.331,479890.397],[\"9/428/692\",120593.331,479890.397,121593.331,480890.397],[\"9/424/692\",119593.331,479890.397,120593.331,480890.397],[\"10/420/692\",118593.331,479890.397,119093.331,480390.397],[\"10/420/694\",118593.331,480390.397,119093.331,480890.397],[\"10/422/694\",119093.331,480390.397,119593.331,480890.397],[\"10/422/692\",119093.331,479890.397,119593.331,480390.397],[\"9/420/696\",118593.331,480890.397,119593.331,481890.397],[\"8/424/696\",119593.331,480890.397,121593.331,482890.397],[\"8/432/688\",121593.331,478890.397,123593.331,480890.397],[\"8/432/696\",121593.331,480890.397,123593.331,482890.397],[\"9/432/704\",121593.331,482890.397,122593.331,483890.397],[\"10/432/708\",121593.331,483890.397,122093.331,484390.397],[\"10/434/708\",122093.331,483890.397,122593.331,484390.397],[\"9/436/704\",122593.331,482890.397,123593.331,483890.397],[\"9/436/708\",122593.331,483890.397,123593.331,484890.397],[\"9/436/712\",122593.331,484890.397,123593.331,485890.397],[\"9/436/716\",122593.331,485890.397,123593.331,486890.397],[\"10/432/716\",121593.331,485890.397,122093.331,486390.397],[\"10/434/716\",122093.331,485890.397,122593.331,486390.397],[\"10/434/718\",122093.331,486390.397,122593.331,486890.397],[\"10/432/718\",121593.331,486390.397,122093.331,486890.397],[\"10/430/718\",121093.331,486390.397,121593.331,486890.397],[\"10/430/716\",121093.331,485890.397,121593.331,486390.397],[\"10/430/714\",121093.331,485390.397,121593.331,485890.397],[\"10/430/712\",121093.331,484890.397,121593.331,485390.397],[\"10/432/714\",121593.331,485390.397,122093.331,485890.397],[\"10/434/714\",122093.331,485390.397,122593.331,485890.397],[\"10/434/712\",122093.331,484890.397,122593.331,485390.397],[\"10/432/712\",121593.331,484890.397,122093.331,485390.397],[\"10/434/710\",122093.331,484390.397,122593.331,484890.397],[\"10/432/710\",121593.331,484390.397,122093.331,484890.397],[\"10/426/712\",120093.331,484890.397,120593.331,485390.397],[\"10/426/714\",120093.331,485390.397,120593.331,485890.397],[\"10/428/712\",120593.331,484890.397,121093.331,485390.397],[\"10/428/714\",120593.331,485390.397,121093.331,485890.397],[\"10/428/716\",120593.331,485890.397,121093.331,486390.397],[\"10/428/718\",120593.331,486390.397,121093.331,486890.397],[\"10/426/718\",120093.331,486390.397,120593.331,486890.397],[\"10/426/716\",120093.331,485890.397,120593.331,486390.397],[\"10/422/716\",119093.331,485890.397,119593.331,486390.397],[\"10/424/716\",119593.331,485890.397,120093.331,486390.397],[\"10/424/718\",119593.331,486390.397,120093.331,486890.397],[\"10/422/718\",119093.331,486390.397,119593.331,486890.397],[\"10/420/718\",118593.331,486390.397,119093.331,486890.397],[\"10/420/716\",118593.331,485890.397,119093.331,486390.397],[\"10/420/714\",118593.331,485390.397,119093.331,485890.397],[\"10/420/712\",118593.331,484890.397,119093.331,485390.397],[\"10/422/714\",119093.331,485390.397,119593.331,485890.397],[\"10/424/714\",119593.331,485390.397,120093.331,485890.397],[\"10/424/712\",119593.331,484890.397,120093.331,485390.397],[\"10/422/712\",119093.331,484890.397,119593.331,485390.397],[\"9/420/708\",118593.331,483890.397,119593.331,484890.397],[\"9/420/704\",118593.331,482890.397,119593.331,483890.397],[\"9/424/708\",119593.331,483890.397,120593.331,484890.397],[\"9/428/708\",120593.331,483890.397,121593.331,484890.397],[\"9/428/704\",120593.331,482890.397,121593.331,483890.397],[\"9/424/704\",119593.331,482890.397,120593.331,483890.397],[\"9/420/700\",118593.331,481890.397,119593.331,482890.397],[\"9/416/700\",117593.331,481890.397,118593.331,482890.397],[\"9/412/704\",116593.331,482890.397,117593.331,483890.397],[\"9/412/708\",116593.331,483890.397,117593.331,484890.397],[\"9/416/704\",117593.331,482890.397,118593.331,483890.397],[\"9/416/708\",117593.331,483890.397,118593.331,484890.397],[\"9/416/712\",117593.331,484890.397,118593.331,485890.397],[\"9/416/716\",117593.331,485890.397,118593.331,486890.397],[\"9/412/716\",116593.331,485890.397,117593.331,486890.397],[\"9/412/712\",116593.331,484890.397,117593.331,485890.397],[\"9/404/712\",114593.331,484890.397,115593.331,485890.397],[\"9/408/712\",115593.331,484890.397,116593.331,485890.397],[\"9/408/716\",115593.331,485890.397,116593.331,486890.397],[\"9/404/716\",114593.331,485890.397,115593.331,486890.397],[\"9/400/716\",113593.331,485890.397,114593.331,486890.397],[\"9/400/712\",113593.331,484890.397,114593.331,485890.397],[\"9/400/708\",113593.331,483890.397,114593.331,484890.397],[\"9/400/704\",113593.331,482890.397,114593.331,483890.397],[\"9/404/708\",114593.331,483890.397,115593.331,484890.397],[\"9/408/708\",115593.331,483890.397,116593.331,484890.397],[\"9/408/704\",115593.331,482890.397,116593.331,483890.397],[\"9/404/704\",114593.331,482890.397,115593.331,483890.397],[\"7/400/688\",113593.331,478890.397,117593.331,482890.397],[\"9/416/696\",117593.331,480890.397,118593.331,481890.397],[\"9/416/692\",117593.331,479890.397,118593.331,480890.397],[\"9/412/684\",116593.331,477890.397,117593.331,478890.397],[\"9/416/688\",117593.331,478890.397,118593.331,479890.397],[\"9/416/684\",117593.331,477890.397,118593.331,478890.397],[\"9/416/680\",117593.331,476890.397,118593.331,477890.397],[\"9/412/680\",116593.331,476890.397,117593.331,477890.397],[\"9/408/680\",115593.331,476890.397,116593.331,477890.397],[\"9/408/684\",115593.331,477890.397,116593.331,478890.397],[\"8/400/680\",113593.331,476890.397,115593.331,478890.397],[\"9/400/676\",113593.331,475890.397,114593.331,476890.397],[\"9/404/676\",114593.331,475890.397,115593.331,476890.397],[\"9/408/676\",115593.331,475890.397,116593.331,476890.397],[\"9/404/672\",114593.331,474890.397,115593.331,475890.397],[\"9/408/672\",115593.331,474890.397,116593.331,475890.397],[\"9/400/672\",113593.331,474890.397,114593.331,475890.397],[\"8/400/664\",113593.331,472890.397,115593.331,474890.397],[\"9/400/660\",113593.331,471890.397,114593.331,472890.397],[\"9/404/660\",114593.331,471890.397,115593.331,472890.397],[\"9/408/660\",115593.331,471890.397,116593.331,472890.397],[\"9/408/664\",115593.331,472890.397,116593.331,473890.397],[\"9/408/668\",115593.331,473890.397,116593.331,474890.397],[\"9/412/668\",116593.331,473890.397,117593.331,474890.397],[\"9/412/664\",116593.331,472890.397,117593.331,473890.397],[\"9/412/660\",116593.331,471890.397,117593.331,472890.397],[\"9/412/672\",116593.331,474890.397,117593.331,475890.397],[\"9/412/676\",116593.331,475890.397,117593.331,476890.397],[\"8/416/672\",117593.331,474890.397,119593.331,476890.397],[\"8/424/672\",119593.331,474890.397,121593.331,476890.397],[\"8/432/672\",121593.331,474890.397,123593.331,476890.397],[\"7/432/656\",121593.331,470890.397,125593.331,474890.397],[\"7/416/656\",117593.331,470890.397,121593.331,474890.397],[\"8/424/648\",119593.331,468890.397,121593.331,470890.397],[\"8/432/648\",121593.331,468890.397,123593.331,470890.397],[\"8/432/640\",121593.331,466890.397,123593.331,468890.397],[\"9/428/640\",120593.331,466890.397,121593.331,467890.397],[\"9/424/640\",119593.331,466890.397,120593.331,467890.397],[\"9/428/644\",120593.331,467890.397,121593.331,468890.397],[\"9/424/644\",119593.331,467890.397,120593.331,468890.397],[\"9/420/644\",118593.331,467890.397,119593.331,468890.397],[\"9/420/640\",118593.331,466890.397,119593.331,467890.397],[\"9/416/640\",117593.331,466890.397,118593.331,467890.397],[\"9/416/644\",117593.331,467890.397,118593.331,468890.397],[\"8/416/648\",117593.331,468890.397,119593.331,470890.397],[\"9/412/656\",116593.331,470890.397,117593.331,471890.397],[\"9/408/656\",115593.331,470890.397,116593.331,471890.397],[\"9/404/656\",114593.331,470890.397,115593.331,471890.397],[\"9/400/656\",113593.331,470890.397,114593.331,471890.397],[\"7/400/640\",113593.331,466890.397,117593.331,470890.397],[\"8/392/640\",111593.331,466890.397,113593.331,468890.397],[\"8/384/640\",109593.331,466890.397,111593.331,468890.397],[\"8/384/648\",109593.331,468890.397,111593.331,470890.397],[\"8/384/656\",109593.331,470890.397,111593.331,472890.397],[\"8/392/648\",111593.331,468890.397,113593.331,470890.397],[\"8/392/656\",111593.331,470890.397,113593.331,472890.397],[\"8/392/664\",111593.331,472890.397,113593.331,474890.397],[\"9/396/672\",112593.331,474890.397,113593.331,475890.397],[\"9/396/676\",112593.331,475890.397,113593.331,476890.397],[\"9/392/676\",111593.331,475890.397,112593.331,476890.397],[\"9/392/672\",111593.331,474890.397,112593.331,475890.397],[\"8/384/672\",109593.331,474890.397,111593.331,476890.397],[\"8/384/664\",109593.331,472890.397,111593.331,474890.397],[\"8/368/664\",105593.331,472890.397,107593.331,474890.397],[\"8/376/664\",107593.331,472890.397,109593.331,474890.397],[\"8/376/672\",107593.331,474890.397,109593.331,476890.397],[\"8/368/672\",105593.331,474890.397,107593.331,476890.397],[\"8/360/672\",103593.331,474890.397,105593.331,476890.397],[\"9/360/652\",103593.331,469890.397,104593.331,470890.397],[\"9/364/652\",104593.331,469890.397,105593.331,470890.397],[\"8/368/656\",105593.331,470890.397,107593.331,472890.397],[\"8/376/656\",107593.331,470890.397,109593.331,472890.397],[\"8/376/648\",107593.331,468890.397,109593.331,470890.397],[\"8/368/648\",105593.331,468890.397,107593.331,470890.397],[\"8/376/640\",107593.331,466890.397,109593.331,468890.397],[\"8/368/640\",105593.331,466890.397,107593.331,468890.397],[\"9/364/648\",104593.331,468890.397,105593.331,469890.397],[\"9/360/648\",103593.331,468890.397,104593.331,469890.397],[\"8/360/640\",103593.331,466890.397,105593.331,468890.397],[\"9/356/640\",102593.331,466890.397,103593.331,467890.397],[\"9/352/640\",101593.331,466890.397,102593.331,467890.397],[\"9/352/644\",101593.331,467890.397,102593.331,468890.397],[\"9/356/644\",102593.331,467890.397,103593.331,468890.397],[\"8/352/648\",101593.331,468890.397,103593.331,470890.397],[\"8/344/656\",99593.331,470890.397,101593.331,472890.397],[\"7/336/640\",97593.331,466890.397,101593.331,470890.397],[\"8/328/640\",95593.331,466890.397,97593.331,468890.397],[\"8/320/640\",93593.331,466890.397,95593.331,468890.397],[\"9/320/648\",93593.331,468890.397,94593.331,469890.397],[\"9/324/648\",94593.331,468890.397,95593.331,469890.397],[\"9/324/652\",94593.331,469890.397,95593.331,470890.397],[\"9/320/652\",93593.331,469890.397,94593.331,470890.397],[\"9/320/656\",93593.331,470890.397,94593.331,471890.397],[\"9/324/656\",94593.331,470890.397,95593.331,471890.397],[\"10/328/656\",95593.331,470890.397,96093.331,471390.397],[\"10/328/658\",95593.331,471390.397,96093.331,471890.397],[\"10/330/658\",96093.331,471390.397,96593.331,471890.397],[\"9/332/656\",96593.331,470890.397,97593.331,471890.397],[\"10/330/656\",96093.331,470890.397,96593.331,471390.397],[\"8/328/648\",95593.331,468890.397,97593.331,470890.397],[\"8/336/656\",97593.331,470890.397,99593.331,472890.397],[\"9/336/664\",97593.331,472890.397,98593.331,473890.397],[\"9/336/668\",97593.331,473890.397,98593.331,474890.397],[\"8/328/664\",95593.331,472890.397,97593.331,474890.397],[\"9/332/660\",96593.331,471890.397,97593.331,472890.397],[\"9/328/660\",95593.331,471890.397,96593.331,472890.397],[\"9/324/660\",94593.331,471890.397,95593.331,472890.397],[\"9/320/660\",93593.331,471890.397,94593.331,472890.397],[\"8/320/664\",93593.331,472890.397,95593.331,474890.397],[\"9/324/672\",94593.331,474890.397,95593.331,475890.397],[\"10/320/672\",93593.331,474890.397,94093.331,475390.397],[\"10/320/674\",93593.331,475390.397,94093.331,475890.397],[\"10/322/674\",94093.331,475390.397,94593.331,475890.397],[\"10/322/672\",94093.331,474890.397,94593.331,475390.397],[\"9/320/676\",93593.331,475890.397,94593.331,476890.397],[\"9/324/676\",94593.331,475890.397,95593.331,476890.397],[\"8/328/672\",95593.331,474890.397,97593.331,476890.397],[\"9/336/672\",97593.331,474890.397,98593.331,475890.397],[\"9/336/676\",97593.331,475890.397,98593.331,476890.397],[\"9/340/676\",98593.331,475890.397,99593.331,476890.397],[\"8/344/672\",99593.331,474890.397,101593.331,476890.397],[\"9/340/672\",98593.331,474890.397,99593.331,475890.397],[\"9/340/668\",98593.331,473890.397,99593.331,474890.397],[\"9/340/664\",98593.331,472890.397,99593.331,473890.397],[\"8/344/664\",99593.331,472890.397,101593.331,474890.397],[\"7/352/656\",101593.331,470890.397,105593.331,474890.397],[\"9/356/672\",102593.331,474890.397,103593.331,475890.397],[\"9/352/672\",101593.331,474890.397,102593.331,475890.397],[\"9/352/676\",101593.331,475890.397,102593.331,476890.397],[\"9/356/676\",102593.331,475890.397,103593.331,476890.397],[\"8/352/680\",101593.331,476890.397,103593.331,478890.397],[\"8/352/688\",101593.331,478890.397,103593.331,480890.397],[\"8/352/696\",101593.331,480890.397,103593.331,482890.397],[\"9/344/692\",99593.331,479890.397,100593.331,480890.397],[\"9/348/692\",100593.331,479890.397,101593.331,480890.397],[\"9/348/696\",100593.331,480890.397,101593.331,481890.397],[\"9/344/696\",99593.331,480890.397,100593.331,481890.397],[\"10/344/686\",99593.331,478390.397,100093.331,478890.397],[\"9/344/688\",99593.331,478890.397,100593.331,479890.397],[\"9/348/688\",100593.331,478890.397,101593.331,479890.397],[\"9/348/684\",100593.331,477890.397,101593.331,478890.397],[\"10/346/686\",100093.331,478390.397,100593.331,478890.397],[\"10/346/684\",100093.331,477890.397,100593.331,478390.397],[\"9/348/680\",100593.331,476890.397,101593.331,477890.397],[\"9/344/680\",99593.331,476890.397,100593.331,477890.397],[\"10/344/684\",99593.331,477890.397,100093.331,478390.397],[\"8/336/680\",97593.331,476890.397,99593.331,478890.397],[\"8/328/680\",95593.331,476890.397,97593.331,478890.397],[\"8/320/680\",93593.331,476890.397,95593.331,478890.397],[\"7/320/688\",93593.331,478890.397,97593.331,482890.397],[\"8/336/688\",97593.331,478890.397,99593.331,480890.397],[\"8/336/696\",97593.331,480890.397,99593.331,482890.397],[\"8/336/704\",97593.331,482890.397,99593.331,484890.397],[\"7/320/704\",93593.331,482890.397,97593.331,486890.397],[\"8/336/712\",97593.331,484890.397,99593.331,486890.397],[\"9/344/716\",99593.331,485890.397,100593.331,486890.397],[\"9/348/716\",100593.331,485890.397,101593.331,486890.397],[\"9/344/712\",99593.331,484890.397,100593.331,485890.397],[\"9/348/712\",100593.331,484890.397,101593.331,485890.397],[\"9/344/700\",99593.331,481890.397,100593.331,482890.397],[\"9/348/700\",100593.331,481890.397,101593.331,482890.397],[\"8/344/704\",99593.331,482890.397,101593.331,484890.397],[\"9/352/708\",101593.331,483890.397,102593.331,484890.397],[\"9/352/704\",101593.331,482890.397,102593.331,483890.397],[\"9/356/704\",102593.331,482890.397,103593.331,483890.397],[\"10/356/708\",102593.331,483890.397,103093.331,484390.397],[\"10/358/708\",103093.331,483890.397,103593.331,484390.397],[\"10/358/710\",103093.331,484390.397,103593.331,484890.397],[\"10/358/712\",103093.331,484890.397,103593.331,485390.397],[\"10/358/714\",103093.331,485390.397,103593.331,485890.397],[\"10/356/712\",102593.331,484890.397,103093.331,485390.397],[\"10/356/714\",102593.331,485390.397,103093.331,485890.397],[\"10/356/710\",102593.331,484390.397,103093.331,484890.397],[\"9/352/712\",101593.331,484890.397,102593.331,485890.397],[\"9/352/716\",101593.331,485890.397,102593.331,486890.397],[\"9/356/716\",102593.331,485890.397,103593.331,486890.397],[\"9/360/716\",103593.331,485890.397,104593.331,486890.397],[\"9/360/712\",103593.331,484890.397,104593.331,485890.397],[\"9/364/712\",104593.331,484890.397,105593.331,485890.397],[\"9/368/712\",105593.331,484890.397,106593.331,485890.397],[\"9/364/716\",104593.331,485890.397,105593.331,486890.397],[\"9/368/716\",105593.331,485890.397,106593.331,486890.397],[\"9/372/716\",106593.331,485890.397,107593.331,486890.397],[\"8/376/712\",107593.331,484890.397,109593.331,486890.397],[\"9/372/712\",106593.331,484890.397,107593.331,485890.397],[\"8/368/704\",105593.331,482890.397,107593.331,484890.397],[\"8/376/704\",107593.331,482890.397,109593.331,484890.397],[\"9/364/700\",104593.331,481890.397,105593.331,482890.397],[\"8/360/704\",103593.331,482890.397,105593.331,484890.397],[\"9/360/700\",103593.331,481890.397,104593.331,482890.397],[\"9/360/696\",103593.331,480890.397,104593.331,481890.397],[\"9/364/696\",104593.331,480890.397,105593.331,481890.397],[\"9/364/692\",104593.331,479890.397,105593.331,480890.397],[\"10/368/694\",105593.331,480390.397,106093.331,480890.397],[\"10/368/692\",105593.331,479890.397,106093.331,480390.397],[\"9/360/692\",103593.331,479890.397,104593.331,480890.397],[\"9/360/688\",103593.331,478890.397,104593.331,479890.397],[\"8/360/680\",103593.331,476890.397,105593.331,478890.397],[\"9/364/688\",104593.331,478890.397,105593.331,479890.397],[\"9/368/688\",105593.331,478890.397,106593.331,479890.397],[\"9/372/688\",106593.331,478890.397,107593.331,479890.397],[\"8/368/680\",105593.331,476890.397,107593.331,478890.397],[\"8/376/680\",107593.331,476890.397,109593.331,478890.397],[\"9/376/688\",107593.331,478890.397,108593.331,479890.397],[\"9/376/692\",107593.331,479890.397,108593.331,480890.397],[\"10/370/692\",106093.331,479890.397,106593.331,480390.397],[\"10/370/694\",106093.331,480390.397,106593.331,480890.397],[\"9/372/692\",106593.331,479890.397,107593.331,480890.397],[\"8/368/696\",105593.331,480890.397,107593.331,482890.397],[\"8/376/696\",107593.331,480890.397,109593.331,482890.397],[\"9/380/692\",108593.331,479890.397,109593.331,480890.397],[\"9/380/688\",108593.331,478890.397,109593.331,479890.397],[\"8/384/680\",109593.331,476890.397,111593.331,478890.397],[\"8/392/680\",111593.331,476890.397,113593.331,478890.397],[\"7/384/688\",109593.331,478890.397,113593.331,482890.397],[\"9/396/704\",112593.331,482890.397,113593.331,483890.397],[\"9/396/708\",112593.331,483890.397,113593.331,484890.397],[\"9/392/704\",111593.331,482890.397,112593.331,483890.397],[\"9/392/708\",111593.331,483890.397,112593.331,484890.397],[\"8/384/704\",109593.331,482890.397,111593.331,484890.397],[\"8/384/712\",109593.331,484890.397,111593.331,486890.397],[\"8/392/712\",111593.331,484890.397,113593.331,486890.397],[\"8/392/720\",111593.331,486890.397,113593.331,488890.397],[\"9/388/720\",110593.331,486890.397,111593.331,487890.397],[\"9/384/720\",109593.331,486890.397,110593.331,487890.397],[\"9/384/724\",109593.331,487890.397,110593.331,488890.397],[\"9/388/724\",110593.331,487890.397,111593.331,488890.397],[\"8/384/728\",109593.331,488890.397,111593.331,490890.397],[\"8/392/728\",111593.331,488890.397,113593.331,490890.397],[\"7/384/736\",109593.331,490890.397,113593.331,494890.397],[\"8/392/752\",111593.331,494890.397,113593.331,496890.397],[\"8/384/752\",109593.331,494890.397,111593.331,496890.397],[\"8/368/744\",105593.331,492890.397,107593.331,494890.397],[\"8/376/744\",107593.331,492890.397,109593.331,494890.397],[\"7/368/752\",105593.331,494890.397,109593.331,498890.397],[\"10/366/750\",105093.331,494390.397,105593.331,494890.397],[\"9/364/752\",104593.331,494890.397,105593.331,495890.397],[\"9/364/756\",104593.331,495890.397,105593.331,496890.397],[\"9/360/756\",103593.331,495890.397,104593.331,496890.397],[\"9/360/752\",103593.331,494890.397,104593.331,495890.397],[\"10/364/750\",104593.331,494390.397,105093.331,494890.397],[\"10/362/750\",104093.331,494390.397,104593.331,494890.397],[\"10/360/750\",103593.331,494390.397,104093.331,494890.397],[\"10/360/748\",103593.331,493890.397,104093.331,494390.397],[\"9/360/744\",103593.331,492890.397,104593.331,493890.397],[\"10/362/748\",104093.331,493890.397,104593.331,494390.397],[\"10/364/748\",104593.331,493890.397,105093.331,494390.397],[\"10/366/748\",105093.331,493890.397,105593.331,494390.397],[\"9/364/744\",104593.331,492890.397,105593.331,493890.397],[\"10/366/742\",105093.331,492390.397,105593.331,492890.397],[\"10/366/740\",105093.331,491890.397,105593.331,492390.397],[\"10/364/740\",104593.331,491890.397,105093.331,492390.397],[\"10/364/742\",104593.331,492390.397,105093.331,492890.397],[\"9/360/740\",103593.331,491890.397,104593.331,492890.397],[\"9/360/736\",103593.331,490890.397,104593.331,491890.397],[\"10/364/738\",104593.331,491390.397,105093.331,491890.397],[\"10/364/736\",104593.331,490890.397,105093.331,491390.397],[\"10/360/734\",103593.331,490390.397,104093.331,490890.397],[\"10/360/732\",103593.331,489890.397,104093.331,490390.397],[\"10/360/730\",103593.331,489390.397,104093.331,489890.397],[\"10/362/730\",104093.331,489390.397,104593.331,489890.397],[\"10/362/732\",104093.331,489890.397,104593.331,490390.397],[\"10/362/734\",104093.331,490390.397,104593.331,490890.397],[\"9/364/732\",104593.331,489890.397,105593.331,490890.397],[\"10/366/736\",105093.331,490890.397,105593.331,491390.397],[\"10/366/738\",105093.331,491390.397,105593.331,491890.397],[\"8/368/736\",105593.331,490890.397,107593.331,492890.397],[\"8/376/736\",107593.331,490890.397,109593.331,492890.397],[\"8/376/728\",107593.331,488890.397,109593.331,490890.397],[\"8/368/728\",105593.331,488890.397,107593.331,490890.397],[\"8/376/720\",107593.331,486890.397,109593.331,488890.397],[\"8/368/720\",105593.331,486890.397,107593.331,488890.397],[\"9/364/720\",104593.331,486890.397,105593.331,487890.397],[\"10/366/724\",105093.331,487890.397,105593.331,488390.397],[\"9/364/728\",104593.331,488890.397,105593.331,489890.397],[\"10/366/726\",105093.331,488390.397,105593.331,488890.397],[\"10/362/726\",104093.331,488390.397,104593.331,488890.397],[\"10/364/726\",104593.331,488390.397,105093.331,488890.397],[\"10/362/728\",104093.331,488890.397,104593.331,489390.397],[\"10/360/728\",103593.331,488890.397,104093.331,489390.397],[\"10/360/726\",103593.331,488390.397,104093.331,488890.397],[\"10/360/724\",103593.331,487890.397,104093.331,488390.397],[\"10/360/722\",103593.331,487390.397,104093.331,487890.397],[\"10/362/724\",104093.331,487890.397,104593.331,488390.397],[\"10/364/724\",104593.331,487890.397,105093.331,488390.397],[\"10/362/722\",104093.331,487390.397,104593.331,487890.397],[\"10/362/720\",104093.331,486890.397,104593.331,487390.397],[\"10/360/720\",103593.331,486890.397,104093.331,487390.397],[\"10/358/720\",103093.331,486890.397,103593.331,487390.397],[\"10/358/722\",103093.331,487390.397,103593.331,487890.397],[\"10/358/724\",103093.331,487890.397,103593.331,488390.397],[\"10/356/722\",102593.331,487390.397,103093.331,487890.397],[\"10/356/724\",102593.331,487890.397,103093.331,488390.397],[\"10/356/720\",102593.331,486890.397,103093.331,487390.397],[\"10/354/720\",102093.331,486890.397,102593.331,487390.397],[\"10/352/720\",101593.331,486890.397,102093.331,487390.397],[\"10/352/722\",101593.331,487390.397,102093.331,487890.397],[\"10/354/722\",102093.331,487390.397,102593.331,487890.397],[\"9/352/724\",101593.331,487890.397,102593.331,488890.397],[\"9/352/728\",101593.331,488890.397,102593.331,489890.397],[\"10/356/728\",102593.331,488890.397,103093.331,489390.397],[\"10/356/726\",102593.331,488390.397,103093.331,488890.397],[\"10/358/726\",103093.331,488390.397,103593.331,488890.397],[\"10/358/728\",103093.331,488890.397,103593.331,489390.397],[\"10/358/730\",103093.331,489390.397,103593.331,489890.397],[\"10/356/730\",102593.331,489390.397,103093.331,489890.397],[\"9/356/732\",102593.331,489890.397,103593.331,490890.397],[\"9/356/736\",102593.331,490890.397,103593.331,491890.397],[\"9/352/736\",101593.331,490890.397,102593.331,491890.397],[\"9/352/732\",101593.331,489890.397,102593.331,490890.397],[\"7/336/720\",97593.331,486890.397,101593.331,490890.397],[\"9/332/724\",96593.331,487890.397,97593.331,488890.397],[\"10/334/722\",97093.331,487390.397,97593.331,487890.397],[\"10/332/722\",96593.331,487390.397,97093.331,487890.397],[\"10/334/720\",97093.331,486890.397,97593.331,487390.397],[\"10/332/720\",96593.331,486890.397,97093.331,487390.397],[\"9/328/720\",95593.331,486890.397,96593.331,487890.397],[\"9/328/724\",95593.331,487890.397,96593.331,488890.397],[\"8/328/728\",95593.331,488890.397,97593.331,490890.397],[\"7/320/752\",93593.331,494890.397,97593.331,498890.397],[\"8/336/752\",97593.331,494890.397,99593.331,496890.397],[\"8/344/752\",99593.331,494890.397,101593.331,496890.397],[\"7/336/736\",97593.331,490890.397,101593.331,494890.397],[\"9/352/740\",101593.331,491890.397,102593.331,492890.397],[\"9/356/740\",102593.331,491890.397,103593.331,492890.397],[\"8/352/744\",101593.331,492890.397,103593.331,494890.397],[\"9/356/752\",102593.331,494890.397,103593.331,495890.397],[\"9/352/752\",101593.331,494890.397,102593.331,495890.397],[\"9/352/756\",101593.331,495890.397,102593.331,496890.397],[\"9/356/756\",102593.331,495890.397,103593.331,496890.397],[\"10/358/760\",103093.331,496890.397,103593.331,497390.397],[\"10/358/762\",103093.331,497390.397,103593.331,497890.397],[\"10/356/762\",102593.331,497390.397,103093.331,497890.397],[\"10/356/760\",102593.331,496890.397,103093.331,497390.397],[\"10/354/760\",102093.331,496890.397,102593.331,497390.397],[\"10/352/760\",101593.331,496890.397,102093.331,497390.397],[\"10/352/762\",101593.331,497390.397,102093.331,497890.397],[\"10/354/762\",102093.331,497390.397,102593.331,497890.397],[\"9/352/764\",101593.331,497890.397,102593.331,498890.397],[\"9/356/764\",102593.331,497890.397,103593.331,498890.397],[\"8/352/768\",101593.331,498890.397,103593.331,500890.397],[\"8/352/776\",101593.331,500890.397,103593.331,502890.397],[\"8/344/760\",99593.331,496890.397,101593.331,498890.397],[\"8/336/760\",97593.331,496890.397,99593.331,498890.397],[\"6/320/768\",93593.331,498890.397,101593.331,506890.397],[\"7/352/784\",101593.331,502890.397,105593.331,506890.397],[\"9/368/792\",105593.331,504890.397,106593.331,505890.397],[\"9/368/796\",105593.331,505890.397,106593.331,506890.397],[\"9/372/796\",106593.331,505890.397,107593.331,506890.397],[\"8/376/792\",107593.331,504890.397,109593.331,506890.397],[\"9/372/792\",106593.331,504890.397,107593.331,505890.397],[\"9/372/784\",106593.331,502890.397,107593.331,503890.397],[\"9/372/788\",106593.331,503890.397,107593.331,504890.397],[\"9/376/788\",107593.331,503890.397,108593.331,504890.397],[\"9/376/784\",107593.331,502890.397,108593.331,503890.397],[\"9/372/780\",106593.331,501890.397,107593.331,502890.397],[\"10/370/782\",106093.331,502390.397,106593.331,502890.397],[\"10/370/780\",106093.331,501890.397,106593.331,502390.397],[\"10/368/780\",105593.331,501890.397,106093.331,502390.397],[\"9/364/780\",104593.331,501890.397,105593.331,502890.397],[\"10/368/782\",105593.331,502390.397,106093.331,502890.397],[\"9/368/784\",105593.331,502890.397,106593.331,503890.397],[\"9/368/788\",105593.331,503890.397,106593.331,504890.397],[\"9/360/780\",103593.331,501890.397,104593.331,502890.397],[\"9/360/776\",103593.331,500890.397,104593.331,501890.397],[\"9/364/776\",104593.331,500890.397,105593.331,501890.397],[\"9/368/776\",105593.331,500890.397,106593.331,501890.397],[\"10/366/772\",105093.331,499890.397,105593.331,500390.397],[\"10/366/774\",105093.331,500390.397,105593.331,500890.397],[\"9/368/772\",105593.331,499890.397,106593.331,500890.397],[\"10/364/772\",104593.331,499890.397,105093.331,500390.397],[\"10/364/774\",104593.331,500390.397,105093.331,500890.397],[\"9/360/772\",103593.331,499890.397,104593.331,500890.397],[\"9/360/768\",103593.331,498890.397,104593.331,499890.397],[\"9/360/764\",103593.331,497890.397,104593.331,498890.397],[\"9/360/760\",103593.331,496890.397,104593.331,497890.397],[\"9/364/760\",104593.331,496890.397,105593.331,497890.397],[\"9/364/764\",104593.331,497890.397,105593.331,498890.397],[\"9/364/768\",104593.331,498890.397,105593.331,499890.397],[\"9/368/768\",105593.331,498890.397,106593.331,499890.397],[\"9/372/768\",106593.331,498890.397,107593.331,499890.397],[\"8/376/768\",107593.331,498890.397,109593.331,500890.397],[\"10/372/774\",106593.331,500390.397,107093.331,500890.397],[\"10/372/772\",106593.331,499890.397,107093.331,500390.397],[\"10/374/772\",107093.331,499890.397,107593.331,500390.397],[\"10/374/774\",107093.331,500390.397,107593.331,500890.397],[\"9/372/776\",106593.331,500890.397,107593.331,501890.397],[\"8/376/776\",107593.331,500890.397,109593.331,502890.397],[\"8/384/776\",109593.331,500890.397,111593.331,502890.397],[\"8/384/768\",109593.331,498890.397,111593.331,500890.397],[\"8/384/760\",109593.331,496890.397,111593.331,498890.397],[\"9/392/768\",111593.331,498890.397,112593.331,499890.397],[\"8/392/760\",111593.331,496890.397,113593.331,498890.397],[\"9/396/768\",112593.331,498890.397,113593.331,499890.397],[\"9/396/772\",112593.331,499890.397,113593.331,500890.397],[\"10/392/774\",111593.331,500390.397,112093.331,500890.397],[\"10/392/772\",111593.331,499890.397,112093.331,500390.397],[\"10/394/772\",112093.331,499890.397,112593.331,500390.397],[\"10/394/774\",112093.331,500390.397,112593.331,500890.397],[\"9/392/776\",111593.331,500890.397,112593.331,501890.397],[\"9/396/776\",112593.331,500890.397,113593.331,501890.397],[\"9/396/780\",112593.331,501890.397,113593.331,502890.397],[\"9/392/780\",111593.331,501890.397,112593.331,502890.397],[\"9/380/784\",108593.331,502890.397,109593.331,503890.397],[\"9/380/788\",108593.331,503890.397,109593.331,504890.397],[\"7/384/784\",109593.331,502890.397,113593.331,506890.397],[\"7/400/784\",113593.331,502890.397,117593.331,506890.397],[\"9/400/780\",113593.331,501890.397,114593.331,502890.397],[\"9/404/780\",114593.331,501890.397,115593.331,502890.397],[\"7/416/784\",117593.331,502890.397,121593.331,506890.397],[\"8/432/792\",121593.331,504890.397,123593.331,506890.397],[\"8/432/784\",121593.331,502890.397,123593.331,504890.397],[\"7/416/768\",117593.331,498890.397,121593.331,502890.397],[\"8/432/776\",121593.331,500890.397,123593.331,502890.397],[\"8/432/768\",121593.331,498890.397,123593.331,500890.397],[\"8/424/760\",119593.331,496890.397,121593.331,498890.397],[\"8/416/760\",117593.331,496890.397,119593.331,498890.397],[\"9/412/760\",116593.331,496890.397,117593.331,497890.397],[\"9/412/764\",116593.331,497890.397,117593.331,498890.397],[\"8/408/776\",115593.331,500890.397,117593.331,502890.397],[\"8/408/768\",115593.331,498890.397,117593.331,500890.397],[\"9/404/772\",114593.331,499890.397,115593.331,500890.397],[\"9/404/776\",114593.331,500890.397,115593.331,501890.397],[\"9/400/776\",113593.331,500890.397,114593.331,501890.397],[\"9/400/772\",113593.331,499890.397,114593.331,500890.397],[\"9/400/768\",113593.331,498890.397,114593.331,499890.397],[\"9/400/764\",113593.331,497890.397,114593.331,498890.397],[\"9/404/768\",114593.331,498890.397,115593.331,499890.397],[\"9/408/764\",115593.331,497890.397,116593.331,498890.397],[\"9/404/764\",114593.331,497890.397,115593.331,498890.397],[\"9/408/760\",115593.331,496890.397,116593.331,497890.397],[\"9/404/760\",114593.331,496890.397,115593.331,497890.397],[\"9/400/760\",113593.331,496890.397,114593.331,497890.397],[\"9/400/756\",113593.331,495890.397,114593.331,496890.397],[\"9/400/752\",113593.331,494890.397,114593.331,495890.397],[\"9/404/752\",114593.331,494890.397,115593.331,495890.397],[\"9/408/752\",115593.331,494890.397,116593.331,495890.397],[\"9/404/756\",114593.331,495890.397,115593.331,496890.397],[\"9/408/756\",115593.331,495890.397,116593.331,496890.397],[\"9/412/756\",116593.331,495890.397,117593.331,496890.397],[\"8/416/752\",117593.331,494890.397,119593.331,496890.397],[\"10/414/750\",117093.331,494390.397,117593.331,494890.397],[\"10/412/750\",116593.331,494390.397,117093.331,494890.397],[\"10/414/752\",117093.331,494890.397,117593.331,495390.397],[\"10/414/754\",117093.331,495390.397,117593.331,495890.397],[\"10/412/754\",116593.331,495390.397,117093.331,495890.397],[\"10/412/752\",116593.331,494890.397,117093.331,495390.397],[\"9/412/744\",116593.331,492890.397,117593.331,493890.397],[\"10/412/748\",116593.331,493890.397,117093.331,494390.397],[\"10/414/748\",117093.331,493890.397,117593.331,494390.397],[\"9/416/748\",117593.331,493890.397,118593.331,494890.397],[\"9/416/744\",117593.331,492890.397,118593.331,493890.397],[\"9/408/744\",115593.331,492890.397,116593.331,493890.397],[\"9/408/748\",115593.331,493890.397,116593.331,494890.397],[\"8/400/744\",113593.331,492890.397,115593.331,494890.397],[\"8/400/736\",113593.331,490890.397,115593.331,492890.397],[\"8/400/728\",113593.331,488890.397,115593.331,490890.397],[\"9/400/724\",113593.331,487890.397,114593.331,488890.397],[\"9/400/720\",113593.331,486890.397,114593.331,487890.397],[\"9/404/720\",114593.331,486890.397,115593.331,487890.397],[\"9/408/720\",115593.331,486890.397,116593.331,487890.397],[\"9/408/724\",115593.331,487890.397,116593.331,488890.397],[\"9/404/724\",114593.331,487890.397,115593.331,488890.397],[\"9/412/724\",116593.331,487890.397,117593.331,488890.397],[\"9/412/720\",116593.331,486890.397,117593.331,487890.397],[\"9/416/720\",117593.331,486890.397,118593.331,487890.397],[\"9/416/724\",117593.331,487890.397,118593.331,488890.397],[\"8/416/728\",117593.331,488890.397,119593.331,490890.397],[\"8/408/728\",115593.331,488890.397,117593.331,490890.397],[\"8/408/736\",115593.331,490890.397,117593.331,492890.397],[\"8/416/736\",117593.331,490890.397,119593.331,492890.397],[\"9/424/736\",119593.331,490890.397,120593.331,491890.397],[\"9/428/736\",120593.331,490890.397,121593.331,491890.397],[\"9/424/732\",119593.331,489890.397,120593.331,490890.397],[\"9/428/732\",120593.331,489890.397,121593.331,490890.397],[\"9/420/724\",118593.331,487890.397,119593.331,488890.397],[\"9/420/720\",118593.331,486890.397,119593.331,487890.397],[\"10/424/720\",119593.331,486890.397,120093.331,487390.397],[\"10/424/722\",119593.331,487390.397,120093.331,487890.397],[\"10/426/722\",120093.331,487390.397,120593.331,487890.397],[\"10/426/720\",120093.331,486890.397,120593.331,487390.397],[\"10/428/720\",120593.331,486890.397,121093.331,487390.397],[\"10/428/722\",120593.331,487390.397,121093.331,487890.397],[\"10/428/724\",120593.331,487890.397,121093.331,488390.397],[\"10/428/726\",120593.331,488390.397,121093.331,488890.397],[\"9/424/724\",119593.331,487890.397,120593.331,488890.397],[\"9/424/728\",119593.331,488890.397,120593.331,489890.397],[\"9/428/728\",120593.331,488890.397,121593.331,489890.397],[\"9/432/728\",121593.331,488890.397,122593.331,489890.397],[\"9/432/724\",121593.331,487890.397,122593.331,488890.397],[\"10/430/726\",121093.331,488390.397,121593.331,488890.397],[\"10/430/724\",121093.331,487890.397,121593.331,488390.397],[\"10/430/722\",121093.331,487390.397,121593.331,487890.397],[\"10/430/720\",121093.331,486890.397,121593.331,487390.397],[\"10/432/720\",121593.331,486890.397,122093.331,487390.397],[\"10/434/720\",122093.331,486890.397,122593.331,487390.397],[\"10/434/722\",122093.331,487390.397,122593.331,487890.397],[\"10/432/722\",121593.331,487390.397,122093.331,487890.397],[\"9/436/720\",122593.331,486890.397,123593.331,487890.397],[\"9/436/724\",122593.331,487890.397,123593.331,488890.397],[\"9/436/728\",122593.331,488890.397,123593.331,489890.397],[\"9/436/732\",122593.331,489890.397,123593.331,490890.397],[\"9/432/732\",121593.331,489890.397,122593.331,490890.397],[\"9/432/736\",121593.331,490890.397,122593.331,491890.397],[\"9/436/736\",122593.331,490890.397,123593.331,491890.397],[\"9/436/740\",122593.331,491890.397,123593.331,492890.397],[\"9/436/744\",122593.331,492890.397,123593.331,493890.397],[\"9/436/748\",122593.331,493890.397,123593.331,494890.397],[\"9/432/744\",121593.331,492890.397,122593.331,493890.397],[\"9/432/748\",121593.331,493890.397,122593.331,494890.397],[\"9/432/740\",121593.331,491890.397,122593.331,492890.397],[\"9/428/740\",120593.331,491890.397,121593.331,492890.397],[\"9/424/740\",119593.331,491890.397,120593.331,492890.397],[\"9/420/744\",118593.331,492890.397,119593.331,493890.397],[\"9/420/748\",118593.331,493890.397,119593.331,494890.397],[\"9/424/748\",119593.331,493890.397,120593.331,494890.397],[\"9/424/744\",119593.331,492890.397,120593.331,493890.397],[\"9/428/744\",120593.331,492890.397,121593.331,493890.397],[\"9/428/748\",120593.331,493890.397,121593.331,494890.397],[\"8/424/752\",119593.331,494890.397,121593.331,496890.397],[\"7/432/752\",121593.331,494890.397,125593.331,498890.397],[\"7/448/752\",125593.331,494890.397,129593.331,498890.397],[\"7/448/736\",125593.331,490890.397,129593.331,494890.397],[\"8/440/744\",123593.331,492890.397,125593.331,494890.397],[\"8/440/736\",123593.331,490890.397,125593.331,492890.397],[\"9/444/732\",124593.331,489890.397,125593.331,490890.397],[\"9/440/732\",123593.331,489890.397,124593.331,490890.397],[\"9/440/728\",123593.331,488890.397,124593.331,489890.397],[\"9/440/724\",123593.331,487890.397,124593.331,488890.397],[\"9/440/720\",123593.331,486890.397,124593.331,487890.397],[\"9/444/720\",124593.331,486890.397,125593.331,487890.397],[\"9/444/724\",124593.331,487890.397,125593.331,488890.397],[\"9/444/728\",124593.331,488890.397,125593.331,489890.397],[\"7/448/720\",125593.331,486890.397,129593.331,490890.397],[\"7/464/720\",129593.331,486890.397,133593.331,490890.397],[\"7/464/736\",129593.331,490890.397,133593.331,494890.397],[\"9/468/752\",130593.331,494890.397,131593.331,495890.397],[\"9/464/752\",129593.331,494890.397,130593.331,495890.397],[\"9/464/756\",129593.331,495890.397,130593.331,496890.397],[\"9/468/756\",130593.331,495890.397,131593.331,496890.397],[\"8/472/752\",131593.331,494890.397,133593.331,496890.397],[\"8/472/760\",131593.331,496890.397,133593.331,498890.397],[\"8/472/768\",131593.331,498890.397,133593.331,500890.397],[\"10/478/776\",133093.331,500890.397,133593.331,501390.397],[\"10/478/778\",133093.331,501390.397,133593.331,501890.397],[\"10/476/778\",132593.331,501390.397,133093.331,501890.397],[\"10/476/776\",132593.331,500890.397,133093.331,501390.397],[\"9/472/776\",131593.331,500890.397,132593.331,501890.397],[\"8/464/768\",129593.331,498890.397,131593.331,500890.397],[\"8/464/776\",129593.331,500890.397,131593.331,502890.397],[\"8/464/760\",129593.331,496890.397,131593.331,498890.397],[\"9/452/768\",126593.331,498890.397,127593.331,499890.397],[\"9/440/768\",123593.331,498890.397,124593.331,499890.397],[\"9/444/768\",124593.331,498890.397,125593.331,499890.397],[\"9/448/768\",125593.331,498890.397,126593.331,499890.397],[\"9/448/772\",125593.331,499890.397,126593.331,500890.397],[\"9/444/772\",124593.331,499890.397,125593.331,500890.397],[\"9/440/772\",123593.331,499890.397,124593.331,500890.397],[\"9/440/776\",123593.331,500890.397,124593.331,501890.397],[\"9/444/776\",124593.331,500890.397,125593.331,501890.397],[\"9/448/776\",125593.331,500890.397,126593.331,501890.397],[\"9/452/776\",126593.331,500890.397,127593.331,501890.397],[\"9/452/772\",126593.331,499890.397,127593.331,500890.397],[\"8/456/768\",127593.331,498890.397,129593.331,500890.397],[\"9/456/776\",127593.331,500890.397,128593.331,501890.397],[\"9/456/780\",127593.331,501890.397,128593.331,502890.397],[\"8/456/784\",127593.331,502890.397,129593.331,504890.397],[\"9/452/784\",126593.331,502890.397,127593.331,503890.397],[\"9/452/788\",126593.331,503890.397,127593.331,504890.397],[\"9/452/780\",126593.331,501890.397,127593.331,502890.397],[\"9/448/780\",125593.331,501890.397,126593.331,502890.397],[\"9/444/780\",124593.331,501890.397,125593.331,502890.397],[\"9/440/780\",123593.331,501890.397,124593.331,502890.397],[\"8/440/784\",123593.331,502890.397,125593.331,504890.397],[\"9/448/784\",125593.331,502890.397,126593.331,503890.397],[\"9/448/788\",125593.331,503890.397,126593.331,504890.397],[\"8/440/792\",123593.331,504890.397,125593.331,506890.397],[\"8/448/792\",125593.331,504890.397,127593.331,506890.397],[\"8/456/792\",127593.331,504890.397,129593.331,506890.397],[\"9/460/780\",128593.331,501890.397,129593.331,502890.397],[\"9/472/780\",131593.331,501890.397,132593.331,502890.397],[\"9/476/780\",132593.331,501890.397,133593.331,502890.397],[\"7/464/784\",129593.331,502890.397,133593.331,506890.397],[\"7/464/800\",129593.331,506890.397,133593.331,510890.397],[\"7/448/800\",125593.331,506890.397,129593.331,510890.397],[\"7/448/816\",125593.331,510890.397,129593.331,514890.397],[\"9/444/832\",124593.331,514890.397,125593.331,515890.397],[\"9/440/832\",123593.331,514890.397,124593.331,515890.397],[\"9/440/836\",123593.331,515890.397,124593.331,516890.397],[\"9/444/836\",124593.331,515890.397,125593.331,516890.397],[\"7/448/832\",125593.331,514890.397,129593.331,518890.397],[\"8/464/832\",129593.331,514890.397,131593.331,516890.397],[\"7/464/816\",129593.331,510890.397,133593.331,514890.397],[\"8/472/832\",131593.331,514890.397,133593.331,516890.397],[\"10/478/840\",133093.331,516890.397,133593.331,517390.397],[\"10/476/840\",132593.331,516890.397,133093.331,517390.397],[\"10/476/842\",132593.331,517390.397,133093.331,517890.397],[\"10/478/842\",133093.331,517390.397,133593.331,517890.397],[\"9/476/844\",132593.331,517890.397,133593.331,518890.397],[\"9/476/848\",132593.331,518890.397,133593.331,519890.397],[\"9/472/844\",131593.331,517890.397,132593.331,518890.397],[\"9/472/848\",131593.331,518890.397,132593.331,519890.397],[\"9/472/840\",131593.331,516890.397,132593.331,517890.397],[\"8/464/840\",129593.331,516890.397,131593.331,518890.397],[\"8/464/848\",129593.331,518890.397,131593.331,520890.397],[\"9/464/856\",129593.331,520890.397,130593.331,521890.397],[\"9/468/856\",130593.331,520890.397,131593.331,521890.397],[\"9/472/852\",131593.331,519890.397,132593.331,520890.397],[\"9/476/852\",132593.331,519890.397,133593.331,520890.397],[\"8/472/856\",131593.331,520890.397,133593.331,522890.397],[\"7/464/864\",129593.331,522890.397,133593.331,526890.397],[\"9/468/860\",130593.331,521890.397,131593.331,522890.397],[\"9/464/860\",129593.331,521890.397,130593.331,522890.397],[\"8/448/864\",125593.331,522890.397,127593.331,524890.397],[\"8/456/864\",127593.331,522890.397,129593.331,524890.397],[\"8/456/872\",127593.331,524890.397,129593.331,526890.397],[\"8/448/872\",125593.331,524890.397,127593.331,526890.397],[\"8/440/872\",123593.331,524890.397,125593.331,526890.397],[\"8/440/864\",123593.331,522890.397,125593.331,524890.397],[\"8/440/856\",123593.331,520890.397,125593.331,522890.397],[\"8/440/848\",123593.331,518890.397,125593.331,520890.397],[\"7/448/848\",125593.331,518890.397,129593.331,522890.397],[\"8/440/840\",123593.331,516890.397,125593.331,518890.397],[\"8/432/840\",121593.331,516890.397,123593.331,518890.397],[\"8/424/840\",119593.331,516890.397,121593.331,518890.397],[\"9/420/848\",118593.331,518890.397,119593.331,519890.397],[\"8/424/848\",119593.331,518890.397,121593.331,520890.397],[\"9/420/852\",118593.331,519890.397,119593.331,520890.397],[\"8/424/856\",119593.331,520890.397,121593.331,522890.397],[\"8/432/848\",121593.331,518890.397,123593.331,520890.397],[\"8/432/856\",121593.331,520890.397,123593.331,522890.397],[\"8/432/864\",121593.331,522890.397,123593.331,524890.397],[\"8/432/872\",121593.331,524890.397,123593.331,526890.397],[\"8/424/872\",119593.331,524890.397,121593.331,526890.397],[\"8/424/864\",119593.331,522890.397,121593.331,524890.397],[\"9/412/860\",116593.331,521890.397,117593.331,522890.397],[\"9/412/864\",116593.331,522890.397,117593.331,523890.397],[\"9/412/868\",116593.331,523890.397,117593.331,524890.397],[\"8/416/864\",117593.331,522890.397,119593.331,524890.397],[\"8/416/872\",117593.331,524890.397,119593.331,526890.397],[\"8/408/872\",115593.331,524890.397,117593.331,526890.397],[\"8/400/872\",113593.331,524890.397,115593.331,526890.397],[\"8/400/864\",113593.331,522890.397,115593.331,524890.397],[\"9/408/868\",115593.331,523890.397,116593.331,524890.397],[\"9/408/864\",115593.331,522890.397,116593.331,523890.397],[\"9/408/860\",115593.331,521890.397,116593.331,522890.397],[\"8/400/856\",113593.331,520890.397,115593.331,522890.397],[\"9/400/852\",113593.331,519890.397,114593.331,520890.397],[\"9/404/852\",114593.331,519890.397,115593.331,520890.397],[\"9/408/852\",115593.331,519890.397,116593.331,520890.397],[\"9/408/856\",115593.331,520890.397,116593.331,521890.397],[\"9/412/856\",116593.331,520890.397,117593.331,521890.397],[\"8/416/856\",117593.331,520890.397,119593.331,522890.397],[\"9/416/852\",117593.331,519890.397,118593.331,520890.397],[\"9/412/852\",116593.331,519890.397,117593.331,520890.397],[\"10/412/846\",116593.331,518390.397,117093.331,518890.397],[\"10/414/846\",117093.331,518390.397,117593.331,518890.397],[\"9/412/848\",116593.331,518890.397,117593.331,519890.397],[\"9/416/848\",117593.331,518890.397,118593.331,519890.397],[\"8/416/840\",117593.331,516890.397,119593.331,518890.397],[\"9/412/840\",116593.331,516890.397,117593.331,517890.397],[\"10/414/844\",117093.331,517890.397,117593.331,518390.397],[\"10/412/844\",116593.331,517890.397,117093.331,518390.397],[\"9/408/840\",115593.331,516890.397,116593.331,517890.397],[\"9/408/844\",115593.331,517890.397,116593.331,518890.397],[\"9/408/848\",115593.331,518890.397,116593.331,519890.397],[\"9/404/848\",114593.331,518890.397,115593.331,519890.397],[\"9/400/848\",113593.331,518890.397,114593.331,519890.397],[\"8/400/840\",113593.331,516890.397,115593.331,518890.397],[\"8/400/832\",113593.331,514890.397,115593.331,516890.397],[\"7/400/816\",113593.331,510890.397,117593.331,514890.397],[\"8/408/832\",115593.331,514890.397,117593.331,516890.397],[\"8/416/832\",117593.331,514890.397,119593.331,516890.397],[\"8/424/832\",119593.331,514890.397,121593.331,516890.397],[\"8/432/832\",121593.331,514890.397,123593.331,516890.397],[\"7/432/816\",121593.331,510890.397,125593.331,514890.397],[\"7/416/816\",117593.331,510890.397,121593.331,514890.397],[\"8/424/808\",119593.331,508890.397,121593.331,510890.397],[\"7/432/800\",121593.331,506890.397,125593.331,510890.397],[\"8/424/800\",119593.331,506890.397,121593.331,508890.397],[\"9/420/804\",118593.331,507890.397,119593.331,508890.397],[\"9/420/800\",118593.331,506890.397,119593.331,507890.397],[\"9/416/800\",117593.331,506890.397,118593.331,507890.397],[\"9/416/804\",117593.331,507890.397,118593.331,508890.397],[\"8/416/808\",117593.331,508890.397,119593.331,510890.397],[\"7/400/800\",113593.331,506890.397,117593.331,510890.397],[\"8/392/800\",111593.331,506890.397,113593.331,508890.397],[\"9/388/800\",110593.331,506890.397,111593.331,507890.397],[\"9/384/800\",109593.331,506890.397,110593.331,507890.397],[\"9/380/808\",108593.331,508890.397,109593.331,509890.397],[\"9/384/804\",109593.331,507890.397,110593.331,508890.397],[\"9/388/804\",110593.331,507890.397,111593.331,508890.397],[\"8/384/808\",109593.331,508890.397,111593.331,510890.397],[\"9/380/812\",108593.331,509890.397,109593.331,510890.397],[\"9/380/816\",108593.331,510890.397,109593.331,511890.397],[\"8/384/816\",109593.331,510890.397,111593.331,512890.397],[\"8/392/808\",111593.331,508890.397,113593.331,510890.397],[\"8/392/816\",111593.331,510890.397,113593.331,512890.397],[\"8/392/824\",111593.331,512890.397,113593.331,514890.397],[\"9/396/832\",112593.331,514890.397,113593.331,515890.397],[\"9/396/836\",112593.331,515890.397,113593.331,516890.397],[\"10/392/836\",111593.331,515890.397,112093.331,516390.397],[\"10/394/836\",112093.331,515890.397,112593.331,516390.397],[\"10/394/838\",112093.331,516390.397,112593.331,516890.397],[\"10/392/838\",111593.331,516390.397,112093.331,516890.397],[\"10/390/838\",111093.331,516390.397,111593.331,516890.397],[\"10/390/836\",111093.331,515890.397,111593.331,516390.397],[\"10/390/834\",111093.331,515390.397,111593.331,515890.397],[\"10/390/832\",111093.331,514890.397,111593.331,515390.397],[\"9/392/832\",111593.331,514890.397,112593.331,515890.397],[\"9/384/832\",109593.331,514890.397,110593.331,515890.397],[\"10/388/832\",110593.331,514890.397,111093.331,515390.397],[\"10/388/834\",110593.331,515390.397,111093.331,515890.397],[\"10/388/836\",110593.331,515890.397,111093.331,516390.397],[\"10/388/838\",110593.331,516390.397,111093.331,516890.397],[\"9/384/836\",109593.331,515890.397,110593.331,516890.397],[\"9/380/828\",108593.331,513890.397,109593.331,514890.397],[\"9/380/824\",108593.331,512890.397,109593.331,513890.397],[\"8/384/824\",109593.331,512890.397,111593.331,514890.397],[\"9/380/820\",108593.331,511890.397,109593.331,512890.397],[\"10/378/820\",108093.331,511890.397,108593.331,512390.397],[\"10/378/822\",108093.331,512390.397,108593.331,512890.397],[\"10/376/822\",107593.331,512390.397,108093.331,512890.397],[\"10/376/820\",107593.331,511890.397,108093.331,512390.397],[\"8/368/824\",105593.331,512890.397,107593.331,514890.397],[\"9/376/824\",107593.331,512890.397,108593.331,513890.397],[\"9/376/828\",107593.331,513890.397,108593.331,514890.397],[\"7/368/832\",105593.331,514890.397,109593.331,518890.397],[\"8/360/832\",103593.331,514890.397,105593.331,516890.397],[\"8/360/824\",103593.331,512890.397,105593.331,514890.397],[\"8/360/816\",103593.331,510890.397,105593.331,512890.397],[\"8/368/816\",105593.331,510890.397,107593.331,512890.397],[\"9/376/816\",107593.331,510890.397,108593.331,511890.397],[\"9/376/812\",107593.331,509890.397,108593.331,510890.397],[\"8/368/808\",105593.331,508890.397,107593.331,510890.397],[\"9/372/804\",106593.331,507890.397,107593.331,508890.397],[\"9/376/808\",107593.331,508890.397,108593.331,509890.397],[\"8/376/800\",107593.331,506890.397,109593.331,508890.397],[\"9/372/800\",106593.331,506890.397,107593.331,507890.397],[\"10/370/802\",106093.331,507390.397,106593.331,507890.397],[\"10/370/800\",106093.331,506890.397,106593.331,507390.397],[\"10/368/800\",105593.331,506890.397,106093.331,507390.397],[\"10/368/802\",105593.331,507390.397,106093.331,507890.397],[\"9/368/804\",105593.331,507890.397,106593.331,508890.397],[\"7/352/800\",101593.331,506890.397,105593.331,510890.397],[\"8/352/824\",101593.331,512890.397,103593.331,514890.397],[\"8/352/832\",101593.331,514890.397,103593.331,516890.397],[\"7/352/848\",101593.331,518890.397,105593.331,522890.397],[\"7/352/864\",101593.331,522890.397,105593.331,526890.397],[\"8/368/872\",105593.331,524890.397,107593.331,526890.397],[\"8/376/872\",107593.331,524890.397,109593.331,526890.397],[\"8/368/864\",105593.331,522890.397,107593.331,524890.397],[\"8/376/864\",107593.331,522890.397,109593.331,524890.397],[\"8/360/840\",103593.331,516890.397,105593.331,518890.397],[\"9/376/848\",107593.331,518890.397,108593.331,519890.397],[\"9/376/852\",107593.331,519890.397,108593.331,520890.397],[\"8/368/848\",105593.331,518890.397,107593.331,520890.397],[\"8/368/856\",105593.331,520890.397,107593.331,522890.397],[\"8/376/856\",107593.331,520890.397,109593.331,522890.397],[\"8/384/856\",109593.331,520890.397,111593.331,522890.397],[\"8/384/848\",109593.331,518890.397,111593.331,520890.397],[\"9/380/852\",108593.331,519890.397,109593.331,520890.397],[\"9/380/848\",108593.331,518890.397,109593.331,519890.397],[\"9/384/840\",109593.331,516890.397,110593.331,517890.397],[\"9/388/840\",110593.331,516890.397,111593.331,517890.397],[\"9/388/844\",110593.331,517890.397,111593.331,518890.397],[\"9/384/844\",109593.331,517890.397,110593.331,518890.397],[\"9/392/848\",111593.331,518890.397,112593.331,519890.397],[\"9/392/844\",111593.331,517890.397,112593.331,518890.397],[\"9/392/840\",111593.331,516890.397,112593.331,517890.397],[\"9/396/840\",112593.331,516890.397,113593.331,517890.397],[\"9/396/844\",112593.331,517890.397,113593.331,518890.397],[\"10/396/848\",112593.331,518890.397,113093.331,519390.397],[\"10/398/848\",113093.331,518890.397,113593.331,519390.397],[\"10/398/850\",113093.331,519390.397,113593.331,519890.397],[\"10/398/852\",113093.331,519890.397,113593.331,520390.397],[\"10/398/854\",113093.331,520390.397,113593.331,520890.397],[\"10/396/852\",112593.331,519890.397,113093.331,520390.397],[\"10/396/854\",112593.331,520390.397,113093.331,520890.397],[\"10/396/850\",112593.331,519390.397,113093.331,519890.397],[\"9/392/852\",111593.331,519890.397,112593.331,520890.397],[\"8/392/856\",111593.331,520890.397,113593.331,522890.397],[\"8/392/864\",111593.331,522890.397,113593.331,524890.397],[\"8/384/864\",109593.331,522890.397,111593.331,524890.397],[\"8/384/872\",109593.331,524890.397,111593.331,526890.397],[\"8/392/872\",111593.331,524890.397,113593.331,526890.397],[\"8/392/880\",111593.331,526890.397,113593.331,528890.397],[\"8/384/880\",109593.331,526890.397,111593.331,528890.397],[\"8/384/888\",109593.331,528890.397,111593.331,530890.397],[\"8/392/888\",111593.331,528890.397,113593.331,530890.397],[\"7/384/896\",109593.331,530890.397,113593.331,534890.397],[\"7/384/912\",109593.331,534890.397,113593.331,538890.397],[\"7/368/896\",105593.331,530890.397,109593.331,534890.397],[\"7/368/912\",105593.331,534890.397,109593.331,538890.397],[\"7/368/880\",105593.331,526890.397,109593.331,530890.397],[\"7/352/880\",101593.331,526890.397,105593.331,530890.397],[\"7/352/896\",101593.331,530890.397,105593.331,534890.397],[\"6/352/928\",101593.331,538890.397,109593.331,546890.397],[\"7/384/928\",109593.331,538890.397,113593.331,542890.397],[\"8/392/944\",111593.331,542890.397,113593.331,544890.397],[\"8/384/944\",109593.331,542890.397,111593.331,544890.397],[\"9/388/952\",110593.331,544890.397,111593.331,545890.397],[\"9/384/952\",109593.331,544890.397,110593.331,545890.397],[\"9/384/956\",109593.331,545890.397,110593.331,546890.397],[\"9/388/956\",110593.331,545890.397,111593.331,546890.397],[\"8/392/952\",111593.331,544890.397,113593.331,546890.397],[\"8/400/952\",113593.331,544890.397,115593.331,546890.397],[\"8/400/944\",113593.331,542890.397,115593.331,544890.397],[\"9/408/940\",115593.331,541890.397,116593.331,542890.397],[\"8/408/944\",115593.331,542890.397,117593.331,544890.397],[\"9/412/940\",116593.331,541890.397,117593.331,542890.397],[\"8/408/952\",115593.331,544890.397,117593.331,546890.397],[\"7/416/944\",117593.331,542890.397,121593.331,546890.397],[\"7/432/944\",121593.331,542890.397,125593.331,546890.397],[\"7/416/928\",117593.331,538890.397,121593.331,542890.397],[\"7/432/928\",121593.331,538890.397,125593.331,542890.397],[\"9/412/936\",116593.331,540890.397,117593.331,541890.397],[\"8/408/928\",115593.331,538890.397,117593.331,540890.397],[\"9/408/936\",115593.331,540890.397,116593.331,541890.397],[\"8/400/936\",113593.331,540890.397,115593.331,542890.397],[\"8/400/928\",113593.331,538890.397,115593.331,540890.397],[\"7/400/912\",113593.331,534890.397,117593.331,538890.397],[\"8/408/904\",115593.331,532890.397,117593.331,534890.397],[\"9/404/908\",114593.331,533890.397,115593.331,534890.397],[\"9/404/904\",114593.331,532890.397,115593.331,533890.397],[\"9/400/908\",113593.331,533890.397,114593.331,534890.397],[\"9/400/904\",113593.331,532890.397,114593.331,533890.397],[\"8/400/896\",113593.331,530890.397,115593.331,532890.397],[\"7/400/880\",113593.331,526890.397,117593.331,530890.397],[\"8/416/880\",117593.331,526890.397,119593.331,528890.397],[\"8/416/888\",117593.331,528890.397,119593.331,530890.397],[\"8/408/896\",115593.331,530890.397,117593.331,532890.397],[\"8/424/888\",119593.331,528890.397,121593.331,530890.397],[\"8/424/880\",119593.331,526890.397,121593.331,528890.397],[\"8/432/880\",121593.331,526890.397,123593.331,528890.397],[\"8/432/888\",121593.331,528890.397,123593.331,530890.397],[\"7/432/896\",121593.331,530890.397,125593.331,534890.397],[\"7/416/896\",117593.331,530890.397,121593.331,534890.397],[\"7/416/912\",117593.331,534890.397,121593.331,538890.397],[\"7/432/912\",121593.331,534890.397,125593.331,538890.397],[\"7/448/912\",125593.331,534890.397,129593.331,538890.397],[\"7/448/896\",125593.331,530890.397,129593.331,534890.397],[\"8/440/888\",123593.331,528890.397,125593.331,530890.397],[\"8/440/880\",123593.331,526890.397,125593.331,528890.397],[\"7/448/880\",125593.331,526890.397,129593.331,530890.397],[\"7/464/880\",129593.331,526890.397,133593.331,530890.397],[\"7/464/896\",129593.331,530890.397,133593.331,534890.397],[\"7/464/912\",129593.331,534890.397,133593.331,538890.397],[\"8/472/928\",131593.331,538890.397,133593.331,540890.397],[\"8/472/936\",131593.331,540890.397,133593.331,542890.397],[\"9/464/932\",129593.331,539890.397,130593.331,540890.397],[\"9/468/932\",130593.331,539890.397,131593.331,540890.397],[\"8/464/936\",129593.331,540890.397,131593.331,542890.397],[\"9/464/928\",129593.331,538890.397,130593.331,539890.397],[\"9/468/928\",130593.331,538890.397,131593.331,539890.397],[\"7/448/928\",125593.331,538890.397,129593.331,542890.397],[\"7/448/944\",125593.331,542890.397,129593.331,546890.397],[\"7/464/944\",129593.331,542890.397,133593.331,546890.397],[\"6/480/928\",133593.331,538890.397,141593.331,546890.397],[\"5/512/896\",141593.331,530890.397,157593.331,546890.397],[\"7/528/880\",145593.331,526890.397,149593.331,530890.397],[\"8/520/888\",143593.331,528890.397,145593.331,530890.397],[\"8/520/880\",143593.331,526890.397,145593.331,528890.397],[\"8/512/880\",141593.331,526890.397,143593.331,528890.397],[\"8/504/880\",139593.331,526890.397,141593.331,528890.397],[\"9/500/880\",138593.331,526890.397,139593.331,527890.397],[\"9/500/884\",138593.331,527890.397,139593.331,528890.397],[\"8/504/888\",139593.331,528890.397,141593.331,530890.397],[\"8/512/888\",141593.331,528890.397,143593.331,530890.397],[\"8/488/904\",135593.331,532890.397,137593.331,534890.397],[\"7/480/912\",133593.331,534890.397,137593.331,538890.397],[\"8/480/904\",133593.331,532890.397,135593.331,534890.397],[\"8/480/896\",133593.331,530890.397,135593.331,532890.397],[\"8/480/888\",133593.331,528890.397,135593.331,530890.397],[\"8/488/896\",135593.331,530890.397,137593.331,532890.397],[\"8/496/888\",137593.331,528890.397,139593.331,530890.397],[\"8/488/888\",135593.331,528890.397,137593.331,530890.397],[\"9/496/884\",137593.331,527890.397,138593.331,528890.397],[\"9/496/880\",137593.331,526890.397,138593.331,527890.397],[\"8/488/880\",135593.331,526890.397,137593.331,528890.397],[\"8/480/880\",133593.331,526890.397,135593.331,528890.397],[\"8/480/872\",133593.331,524890.397,135593.331,526890.397],[\"8/480/864\",133593.331,522890.397,135593.331,524890.397],[\"8/488/864\",135593.331,522890.397,137593.331,524890.397],[\"8/496/864\",137593.331,522890.397,139593.331,524890.397],[\"8/488/872\",135593.331,524890.397,137593.331,526890.397],[\"8/496/872\",137593.331,524890.397,139593.331,526890.397],[\"8/504/872\",139593.331,524890.397,141593.331,526890.397],[\"8/512/872\",141593.331,524890.397,143593.331,526890.397],[\"8/512/864\",141593.331,522890.397,143593.331,524890.397],[\"8/504/864\",139593.331,522890.397,141593.331,524890.397],[\"8/504/848\",139593.331,518890.397,141593.331,520890.397],[\"8/504/856\",139593.331,520890.397,141593.331,522890.397],[\"8/512/856\",141593.331,520890.397,143593.331,522890.397],[\"8/512/848\",141593.331,518890.397,143593.331,520890.397],[\"9/492/840\",136593.331,516890.397,137593.331,517890.397],[\"10/490/844\",136093.331,517890.397,136593.331,518390.397],[\"9/492/844\",136593.331,517890.397,137593.331,518890.397],[\"10/490/846\",136093.331,518390.397,136593.331,518890.397],[\"8/496/848\",137593.331,518890.397,139593.331,520890.397],[\"8/496/856\",137593.331,520890.397,139593.331,522890.397],[\"8/488/856\",135593.331,520890.397,137593.331,522890.397],[\"8/488/848\",135593.331,518890.397,137593.331,520890.397],[\"9/484/852\",134593.331,519890.397,135593.331,520890.397],[\"8/480/856\",133593.331,520890.397,135593.331,522890.397],[\"9/480/852\",133593.331,519890.397,134593.331,520890.397],[\"9/480/848\",133593.331,518890.397,134593.331,519890.397],[\"9/480/844\",133593.331,517890.397,134593.331,518890.397],[\"10/484/846\",134593.331,518390.397,135093.331,518890.397],[\"9/484/848\",134593.331,518890.397,135593.331,519890.397],[\"10/488/846\",135593.331,518390.397,136093.331,518890.397],[\"10/486/846\",135093.331,518390.397,135593.331,518890.397],[\"10/486/844\",135093.331,517890.397,135593.331,518390.397],[\"10/488/844\",135593.331,517890.397,136093.331,518390.397],[\"9/488/840\",135593.331,516890.397,136593.331,517890.397],[\"9/484/840\",134593.331,516890.397,135593.331,517890.397],[\"10/484/844\",134593.331,517890.397,135093.331,518390.397],[\"9/480/840\",133593.331,516890.397,134593.331,517890.397],[\"8/480/832\",133593.331,514890.397,135593.331,516890.397],[\"8/488/832\",135593.331,514890.397,137593.331,516890.397],[\"7/496/832\",137593.331,514890.397,141593.331,518890.397],[\"7/512/832\",141593.331,514890.397,145593.331,518890.397],[\"6/544/832\",149593.331,514890.397,157593.331,522890.397],[\"8/520/848\",143593.331,518890.397,145593.331,520890.397],[\"9/520/856\",143593.331,520890.397,144593.331,521890.397],[\"9/524/856\",144593.331,520890.397,145593.331,521890.397],[\"7/528/848\",145593.331,518890.397,149593.331,522890.397],[\"9/536/864\",147593.331,522890.397,148593.331,523890.397],[\"10/538/868\",148093.331,523890.397,148593.331,524390.397],[\"10/536/868\",147593.331,523890.397,148093.331,524390.397],[\"8/528/864\",145593.331,522890.397,147593.331,524890.397],[\"9/524/860\",144593.331,521890.397,145593.331,522890.397],[\"9/520/860\",143593.331,521890.397,144593.331,522890.397],[\"9/520/864\",143593.331,522890.397,144593.331,523890.397],[\"9/520/868\",143593.331,523890.397,144593.331,524890.397],[\"9/524/868\",144593.331,523890.397,145593.331,524890.397],[\"9/524/864\",144593.331,522890.397,145593.331,523890.397],[\"9/528/872\",145593.331,524890.397,146593.331,525890.397],[\"8/520/872\",143593.331,524890.397,145593.331,526890.397],[\"9/528/876\",145593.331,525890.397,146593.331,526890.397],[\"9/532/876\",146593.331,525890.397,147593.331,526890.397],[\"10/534/872\",147093.331,524890.397,147593.331,525390.397],[\"10/532/872\",146593.331,524890.397,147093.331,525390.397],[\"10/532/874\",146593.331,525390.397,147093.331,525890.397],[\"10/534/874\",147093.331,525390.397,147593.331,525890.397],[\"10/536/870\",147593.331,524390.397,148093.331,524890.397],[\"10/538/870\",148093.331,524390.397,148593.331,524890.397],[\"8/536/872\",147593.331,524890.397,149593.331,526890.397],[\"9/540/868\",148593.331,523890.397,149593.331,524890.397],[\"9/540/864\",148593.331,522890.397,149593.331,523890.397],[\"6/576/800\",157593.331,506890.397,165593.331,514890.397],[\"7/608/816\",165593.331,510890.397,169593.331,514890.397],[\"7/608/800\",165593.331,506890.397,169593.331,510890.397],[\"8/624/808\",169593.331,508890.397,171593.331,510890.397],[\"8/624/800\",169593.331,506890.397,171593.331,508890.397],[\"8/632/800\",171593.331,506890.397,173593.331,508890.397],[\"8/632/808\",171593.331,508890.397,173593.331,510890.397],[\"7/624/816\",169593.331,510890.397,173593.331,514890.397],[\"7/624/832\",169593.331,514890.397,173593.331,518890.397],[\"8/632/848\",171593.331,518890.397,173593.331,520890.397],[\"8/632/856\",171593.331,520890.397,173593.331,522890.397],[\"9/624/852\",169593.331,519890.397,170593.331,520890.397],[\"9/628/852\",170593.331,519890.397,171593.331,520890.397],[\"8/624/856\",169593.331,520890.397,171593.331,522890.397],[\"9/624/848\",169593.331,518890.397,170593.331,519890.397],[\"9/628/848\",170593.331,518890.397,171593.331,519890.397],[\"7/608/848\",165593.331,518890.397,169593.331,522890.397],[\"6/608/864\",165593.331,522890.397,173593.331,530890.397],[\"6/608/896\",165593.331,530890.397,173593.331,538890.397],[\"6/576/896\",157593.331,530890.397,165593.331,538890.397],[\"7/592/928\",161593.331,538890.397,165593.331,542890.397],[\"7/576/928\",157593.331,538890.397,161593.331,542890.397],[\"7/576/944\",157593.331,542890.397,161593.331,546890.397],[\"7/592/944\",161593.331,542890.397,165593.331,546890.397],[\"8/608/952\",165593.331,544890.397,167593.331,546890.397],[\"8/616/952\",167593.331,544890.397,169593.331,546890.397],[\"8/608/944\",165593.331,542890.397,167593.331,544890.397],[\"8/616/944\",167593.331,542890.397,169593.331,544890.397],[\"7/608/928\",165593.331,538890.397,169593.331,542890.397],[\"7/624/928\",169593.331,538890.397,173593.331,542890.397],[\"7/624/944\",169593.331,542890.397,173593.331,546890.397],[\"7/624/960\",169593.331,546890.397,173593.331,550890.397],[\"7/608/960\",165593.331,546890.397,169593.331,550890.397],[\"7/608/976\",165593.331,550890.397,169593.331,554890.397],[\"7/608/992\",165593.331,554890.397,169593.331,558890.397],[\"7/624/976\",169593.331,550890.397,173593.331,554890.397],[\"7/624/992\",169593.331,554890.397,173593.331,558890.397],[\"9/636/1008\",172593.331,558890.397,173593.331,559890.397],[\"9/632/1008\",171593.331,558890.397,172593.331,559890.397],[\"8/624/1008\",169593.331,558890.397,171593.331,560890.397],[\"8/624/1016\",169593.331,560890.397,171593.331,562890.397],[\"9/632/1016\",171593.331,560890.397,172593.331,561890.397],[\"9/632/1012\",171593.331,559890.397,172593.331,560890.397],[\"10/636/1014\",172593.331,560390.397,173093.331,560890.397],[\"10/636/1012\",172593.331,559890.397,173093.331,560390.397],[\"10/638/1012\",173093.331,559890.397,173593.331,560390.397],[\"10/638/1014\",173093.331,560390.397,173593.331,560890.397],[\"9/636/1016\",172593.331,560890.397,173593.331,561890.397],[\"9/636/1020\",172593.331,561890.397,173593.331,562890.397],[\"9/632/1020\",171593.331,561890.397,172593.331,562890.397],[\"7/624/1024\",169593.331,562890.397,173593.331,566890.397],[\"7/608/1024\",165593.331,562890.397,169593.331,566890.397],[\"8/600/1032\",163593.331,564890.397,165593.331,566890.397],[\"9/600/1028\",163593.331,563890.397,164593.331,564890.397],[\"9/600/1024\",163593.331,562890.397,164593.331,563890.397],[\"9/604/1028\",164593.331,563890.397,165593.331,564890.397],[\"9/604/1024\",164593.331,562890.397,165593.331,563890.397],[\"7/608/1008\",165593.331,558890.397,169593.331,562890.397],[\"6/576/992\",157593.331,554890.397,165593.331,562890.397],[\"8/592/1024\",161593.331,562890.397,163593.331,564890.397],[\"8/592/1032\",161593.331,564890.397,163593.331,566890.397],[\"7/576/1024\",157593.331,562890.397,161593.331,566890.397],[\"7/560/1024\",153593.331,562890.397,157593.331,566890.397],[\"8/576/984\",157593.331,552890.397,159593.331,554890.397],[\"7/592/976\",161593.331,550890.397,165593.331,554890.397],[\"8/584/984\",159593.331,552890.397,161593.331,554890.397],[\"8/584/976\",159593.331,550890.397,161593.331,552890.397],[\"7/592/960\",161593.331,546890.397,165593.331,550890.397],[\"7/576/960\",157593.331,546890.397,161593.331,550890.397],[\"8/576/976\",157593.331,550890.397,159593.331,552890.397],[\"5/512/960\",141593.331,546890.397,157593.331,562890.397],[\"6/480/960\",133593.331,546890.397,141593.331,554890.397],[\"7/544/1024\",149593.331,562890.397,153593.331,566890.397],[\"7/592/1104\",161593.331,582890.397,165593.331,586890.397],[\"7/576/1088\",157593.331,578890.397,161593.331,582890.397],[\"7/592/1088\",161593.331,578890.397,165593.331,582890.397],[\"8/592/1080\",161593.331,576890.397,163593.331,578890.397],[\"8/584/1080\",159593.331,576890.397,161593.331,578890.397],[\"8/576/1080\",157593.331,576890.397,159593.331,578890.397],[\"8/568/1080\",155593.331,576890.397,157593.331,578890.397],[\"9/568/1076\",155593.331,575890.397,156593.331,576890.397],[\"9/572/1076\",156593.331,575890.397,157593.331,576890.397],[\"9/576/1076\",157593.331,575890.397,158593.331,576890.397],[\"9/576/1072\",157593.331,574890.397,158593.331,575890.397],[\"9/572/1072\",156593.331,574890.397,157593.331,575890.397],[\"7/560/1056\",153593.331,570890.397,157593.331,574890.397],[\"7/560/1040\",153593.331,566890.397,157593.331,570890.397],[\"7/576/1040\",157593.331,566890.397,161593.331,570890.397],[\"7/592/1040\",161593.331,566890.397,165593.331,570890.397],[\"7/592/1056\",161593.331,570890.397,165593.331,574890.397],[\"7/576/1056\",157593.331,570890.397,161593.331,574890.397],[\"9/580/1072\",158593.331,574890.397,159593.331,575890.397],[\"9/580/1076\",158593.331,575890.397,159593.331,576890.397],[\"8/584/1072\",159593.331,574890.397,161593.331,576890.397],[\"8/592/1072\",161593.331,574890.397,163593.331,576890.397],[\"8/600/1072\",163593.331,574890.397,165593.331,576890.397],[\"8/608/1072\",165593.331,574890.397,167593.331,576890.397],[\"8/616/1072\",167593.331,574890.397,169593.331,576890.397],[\"7/608/1056\",165593.331,570890.397,169593.331,574890.397],[\"7/608/1040\",165593.331,566890.397,169593.331,570890.397],[\"7/624/1040\",169593.331,566890.397,173593.331,570890.397],[\"7/624/1056\",169593.331,570890.397,173593.331,574890.397],[\"7/624/1072\",169593.331,574890.397,173593.331,578890.397],[\"7/624/1088\",169593.331,578890.397,173593.331,582890.397],[\"8/616/1080\",167593.331,576890.397,169593.331,578890.397],[\"9/612/1084\",166593.331,577890.397,167593.331,578890.397],[\"9/612/1080\",166593.331,576890.397,167593.331,577890.397],[\"9/608/1080\",165593.331,576890.397,166593.331,577890.397],[\"9/604/1080\",164593.331,576890.397,165593.331,577890.397],[\"9/600/1080\",163593.331,576890.397,164593.331,577890.397],[\"9/600/1084\",163593.331,577890.397,164593.331,578890.397],[\"9/604/1084\",164593.331,577890.397,165593.331,578890.397],[\"9/608/1084\",165593.331,577890.397,166593.331,578890.397],[\"7/608/1088\",165593.331,578890.397,169593.331,582890.397],[\"7/608/1104\",165593.331,582890.397,169593.331,586890.397],[\"7/624/1104\",169593.331,582890.397,173593.331,586890.397],[\"8/632/1120\",171593.331,586890.397,173593.331,588890.397],[\"8/624/1120\",169593.331,586890.397,171593.331,588890.397],[\"8/624/1128\",169593.331,588890.397,171593.331,590890.397],[\"8/632/1128\",171593.331,588890.397,173593.331,590890.397],[\"7/624/1136\",169593.331,590890.397,173593.331,594890.397],[\"7/608/1120\",165593.331,586890.397,169593.331,590890.397],[\"5/576/1152\",157593.331,594890.397,173593.331,610890.397],[\"7/512/1168\",141593.331,598890.397,145593.331,602890.397],[\"6/544/1184\",149593.331,602890.397,157593.331,610890.397],[\"6/544/1152\",149593.331,594890.397,157593.331,602890.397],[\"7/528/1168\",145593.331,598890.397,149593.331,602890.397],[\"7/528/1152\",145593.331,594890.397,149593.331,598890.397],[\"7/512/1152\",141593.331,594890.397,145593.331,598890.397],[\"7/384/1040\",109593.331,566890.397,113593.331,570890.397],[\"6/384/1056\",109593.331,570890.397,117593.331,578890.397],[\"5/384/1088\",109593.331,578890.397,125593.331,594890.397],[\"5/448/1088\",125593.331,578890.397,141593.331,594890.397],[\"6/416/1056\",117593.331,570890.397,125593.331,578890.397],[\"7/400/1040\",113593.331,566890.397,117593.331,570890.397],[\"8/400/1032\",113593.331,564890.397,115593.331,566890.397],[\"8/408/1032\",115593.331,564890.397,117593.331,566890.397],[\"8/408/1024\",115593.331,562890.397,117593.331,564890.397],[\"8/400/1024\",113593.331,562890.397,115593.331,564890.397],[\"6/416/992\",117593.331,554890.397,125593.331,562890.397],[\"6/416/1024\",117593.331,562890.397,125593.331,570890.397],[\"7/464/960\",129593.331,546890.397,133593.331,550890.397],[\"7/448/960\",125593.331,546890.397,129593.331,550890.397],[\"7/400/976\",113593.331,550890.397,117593.331,554890.397],[\"7/400/960\",113593.331,546890.397,117593.331,550890.397],[\"8/392/960\",111593.331,546890.397,113593.331,548890.397],[\"9/392/968\",111593.331,548890.397,112593.331,549890.397],[\"9/396/968\",112593.331,548890.397,113593.331,549890.397],[\"9/396/972\",112593.331,549890.397,113593.331,550890.397],[\"9/396/976\",112593.331,550890.397,113593.331,551890.397],[\"9/392/976\",111593.331,550890.397,112593.331,551890.397],[\"9/392/972\",111593.331,549890.397,112593.331,550890.397],[\"8/384/968\",109593.331,548890.397,111593.331,550890.397],[\"8/384/976\",109593.331,550890.397,111593.331,552890.397],[\"8/384/960\",109593.331,546890.397,111593.331,548890.397],[\"8/384/984\",109593.331,552890.397,111593.331,554890.397],[\"10/392/980\",111593.331,551890.397,112093.331,552390.397],[\"10/394/980\",112093.331,551890.397,112593.331,552390.397],[\"10/394/982\",112093.331,552390.397,112593.331,552890.397],[\"10/392/982\",111593.331,552390.397,112093.331,552890.397],[\"10/396/982\",112593.331,552390.397,113093.331,552890.397],[\"10/396/980\",112593.331,551890.397,113093.331,552390.397],[\"10/398/980\",113093.331,551890.397,113593.331,552390.397],[\"10/398/982\",113093.331,552390.397,113593.331,552890.397],[\"8/392/984\",111593.331,552890.397,113593.331,554890.397],[\"6/384/992\",109593.331,554890.397,117593.331,562890.397],[\"7/384/1024\",109593.331,562890.397,113593.331,566890.397],[\"6/288/672\",85593.331,474890.397,93593.331,482890.397],[\"7/288/656\",85593.331,470890.397,89593.331,474890.397],[\"8/312/664\",91593.331,472890.397,93593.331,474890.397],[\"10/310/662\",91093.331,472390.397,91593.331,472890.397],[\"10/310/660\",91093.331,471890.397,91593.331,472390.397],[\"10/308/660\",90593.331,471890.397,91093.331,472390.397],[\"9/304/660\",89593.331,471890.397,90593.331,472890.397],[\"10/306/664\",90093.331,472890.397,90593.331,473390.397],[\"10/308/662\",90593.331,472390.397,91093.331,472890.397],[\"9/308/664\",90593.331,472890.397,91593.331,473890.397],[\"9/308/668\",90593.331,473890.397,91593.331,474890.397],[\"9/304/668\",89593.331,473890.397,90593.331,474890.397],[\"10/306/666\",90093.331,473390.397,90593.331,473890.397],[\"10/304/666\",89593.331,473390.397,90093.331,473890.397],[\"10/304/664\",89593.331,472890.397,90093.331,473390.397],[\"9/300/652\",88593.331,469890.397,89593.331,470890.397],[\"8/304/648\",89593.331,468890.397,91593.331,470890.397],[\"9/304/656\",89593.331,470890.397,90593.331,471890.397],[\"9/308/656\",90593.331,470890.397,91593.331,471890.397],[\"8/312/656\",91593.331,470890.397,93593.331,472890.397],[\"8/312/648\",91593.331,468890.397,93593.331,470890.397],[\"9/312/644\",91593.331,467890.397,92593.331,468890.397],[\"9/316/644\",92593.331,467890.397,93593.331,468890.397],[\"9/316/640\",92593.331,466890.397,93593.331,467890.397],[\"9/312/640\",91593.331,466890.397,92593.331,467890.397],[\"9/308/640\",90593.331,466890.397,91593.331,467890.397],[\"10/306/640\",90093.331,466890.397,90593.331,467390.397],[\"10/306/642\",90093.331,467390.397,90593.331,467890.397],[\"9/308/644\",90593.331,467890.397,91593.331,468890.397],[\"9/304/644\",89593.331,467890.397,90593.331,468890.397],[\"9/300/648\",88593.331,468890.397,89593.331,469890.397],[\"9/300/644\",88593.331,467890.397,89593.331,468890.397],[\"10/304/642\",89593.331,467390.397,90093.331,467890.397],[\"10/304/640\",89593.331,466890.397,90093.331,467390.397],[\"9/300/640\",88593.331,466890.397,89593.331,467890.397],[\"9/296/640\",87593.331,466890.397,88593.331,467890.397],[\"8/288/640\",85593.331,466890.397,87593.331,468890.397],[\"9/296/644\",87593.331,467890.397,88593.331,468890.397],[\"9/296/648\",87593.331,468890.397,88593.331,469890.397],[\"9/296/652\",87593.331,469890.397,88593.331,470890.397],[\"8/288/648\",85593.331,468890.397,87593.331,470890.397],[\"5/128/512\",45593.331000000006,434890.397,61593.331000000006,450890.397],[\"6/128/480\",45593.331000000006,426890.397,53593.331000000006,434890.397],[\"6/64/416\",29593.331000000006,410890.397,37593.331000000006,418890.397],[\"7/32/368\",21593.331000000006,398890.397,25593.331000000006,402890.397],[\"6/0/352\",13593.331000000006,394890.397,21593.331000000006,402890.397],[\"6/0/320\",13593.331000000006,386890.397,21593.331000000006,394890.397],[\"7/32/320\",21593.331000000006,386890.397,25593.331000000006,390890.397],[\"8/32/336\",21593.331000000006,390890.397,23593.331000000006,392890.397],[\"8/32/344\",21593.331000000006,392890.397,23593.331000000006,394890.397],[\"7/32/352\",21593.331000000006,394890.397,25593.331000000006,398890.397],[\"7/48/352\",25593.331000000006,394890.397,29593.331000000006,398890.397],[\"7/48/336\",25593.331000000006,390890.397,29593.331000000006,394890.397],[\"8/40/344\",23593.331000000006,392890.397,25593.331000000006,394890.397],[\"8/40/336\",23593.331000000006,390890.397,25593.331000000006,392890.397],[\"8/48/320\",25593.331000000006,386890.397,27593.331000000006,388890.397],[\"9/56/320\",27593.331000000006,386890.397,28593.331000000006,387890.397],[\"9/56/324\",27593.331000000006,387890.397,28593.331000000006,388890.397],[\"8/56/328\",27593.331000000006,388890.397,29593.331000000006,390890.397],[\"8/48/328\",25593.331000000006,388890.397,27593.331000000006,390890.397],[\"9/64/336\",29593.331000000006,390890.397,30593.331000000006,391890.397],[\"9/68/336\",30593.331000000006,390890.397,31593.331000000006,391890.397],[\"9/64/332\",29593.331000000006,389890.397,30593.331000000006,390890.397],[\"9/68/332\",30593.331000000006,389890.397,31593.331000000006,390890.397],[\"9/60/324\",28593.331000000006,387890.397,29593.331000000006,388890.397],[\"9/60/320\",28593.331000000006,386890.397,29593.331000000006,387890.397],[\"9/64/320\",29593.331000000006,386890.397,30593.331000000006,387890.397],[\"9/68/320\",30593.331000000006,386890.397,31593.331000000006,387890.397],[\"9/68/324\",30593.331000000006,387890.397,31593.331000000006,388890.397],[\"9/64/324\",29593.331000000006,387890.397,30593.331000000006,388890.397],[\"9/64/328\",29593.331000000006,388890.397,30593.331000000006,389890.397],[\"9/68/328\",30593.331000000006,388890.397,31593.331000000006,389890.397],[\"9/72/328\",31593.331000000006,388890.397,32593.331000000006,389890.397],[\"8/72/320\",31593.331000000006,386890.397,33593.331000000006,388890.397],[\"9/76/328\",32593.331000000006,388890.397,33593.331000000006,389890.397],[\"9/76/332\",32593.331000000006,389890.397,33593.331000000006,390890.397],[\"9/72/332\",31593.331000000006,389890.397,32593.331000000006,390890.397],[\"10/74/336\",32093.331000000006,390890.397,32593.331000000006,391390.397],[\"10/72/336\",31593.331000000006,390890.397,32093.331000000006,391390.397],[\"10/72/338\",31593.331000000006,391390.397,32093.331000000006,391890.397],[\"10/74/338\",32093.331000000006,391390.397,32593.331000000006,391890.397],[\"9/76/336\",32593.331000000006,390890.397,33593.331000000006,391890.397],[\"9/76/340\",32593.331000000006,391890.397,33593.331000000006,392890.397],[\"8/72/344\",31593.331000000006,392890.397,33593.331000000006,394890.397],[\"9/72/340\",31593.331000000006,391890.397,32593.331000000006,392890.397],[\"9/68/340\",30593.331000000006,391890.397,31593.331000000006,392890.397],[\"9/64/340\",29593.331000000006,391890.397,30593.331000000006,392890.397],[\"8/64/344\",29593.331000000006,392890.397,31593.331000000006,394890.397],[\"7/64/352\",29593.331000000006,394890.397,33593.331000000006,398890.397],[\"7/64/368\",29593.331000000006,398890.397,33593.331000000006,402890.397],[\"7/48/368\",25593.331000000006,398890.397,29593.331000000006,402890.397],[\"6/64/384\",29593.331000000006,402890.397,37593.331000000006,410890.397],[\"6/96/384\",37593.331000000006,402890.397,45593.331000000006,410890.397],[\"8/104/368\",39593.331000000006,398890.397,41593.331000000006,400890.397],[\"8/104/376\",39593.331000000006,400890.397,41593.331000000006,402890.397],[\"7/112/368\",41593.331000000006,398890.397,45593.331000000006,402890.397],[\"8/96/368\",37593.331000000006,398890.397,39593.331000000006,400890.397],[\"8/96/376\",37593.331000000006,400890.397,39593.331000000006,402890.397],[\"7/80/368\",33593.331000000006,398890.397,37593.331000000006,402890.397],[\"7/80/352\",33593.331000000006,394890.397,37593.331000000006,398890.397],[\"8/88/344\",35593.331000000006,392890.397,37593.331000000006,394890.397],[\"8/80/344\",33593.331000000006,392890.397,35593.331000000006,394890.397],[\"8/80/336\",33593.331000000006,390890.397,35593.331000000006,392890.397],[\"7/80/320\",33593.331000000006,386890.397,37593.331000000006,390890.397],[\"8/88/336\",35593.331000000006,390890.397,37593.331000000006,392890.397],[\"7/96/320\",37593.331000000006,386890.397,41593.331000000006,390890.397],[\"7/112/320\",41593.331000000006,386890.397,45593.331000000006,390890.397],[\"7/112/336\",41593.331000000006,390890.397,45593.331000000006,394890.397],[\"7/96/336\",37593.331000000006,390890.397,41593.331000000006,394890.397],[\"7/96/352\",37593.331000000006,394890.397,41593.331000000006,398890.397],[\"7/112/352\",41593.331000000006,394890.397,45593.331000000006,398890.397],[\"7/128/352\",45593.331000000006,394890.397,49593.331000000006,398890.397],[\"7/128/336\",45593.331000000006,390890.397,49593.331000000006,394890.397],[\"8/128/320\",45593.331000000006,386890.397,47593.331000000006,388890.397],[\"8/136/320\",47593.331000000006,386890.397,49593.331000000006,388890.397],[\"8/136/328\",47593.331000000006,388890.397,49593.331000000006,390890.397],[\"8/128/328\",45593.331000000006,388890.397,47593.331000000006,390890.397],[\"9/144/336\",49593.331000000006,390890.397,50593.331000000006,391890.397],[\"10/148/338\",50593.331000000006,391390.397,51093.331000000006,391890.397],[\"10/148/336\",50593.331000000006,390890.397,51093.331000000006,391390.397],[\"8/144/328\",49593.331000000006,388890.397,51593.331000000006,390890.397],[\"8/144/320\",49593.331000000006,386890.397,51593.331000000006,388890.397],[\"9/152/328\",51593.331000000006,388890.397,52593.331000000006,389890.397],[\"8/152/320\",51593.331000000006,386890.397,53593.331000000006,388890.397],[\"9/156/328\",52593.331000000006,388890.397,53593.331000000006,389890.397],[\"9/156/332\",52593.331000000006,389890.397,53593.331000000006,390890.397],[\"9/152/332\",51593.331000000006,389890.397,52593.331000000006,390890.397],[\"10/150/336\",51093.331000000006,390890.397,51593.331000000006,391390.397],[\"10/150/338\",51093.331000000006,391390.397,51593.331000000006,391890.397],[\"9/152/336\",51593.331000000006,390890.397,52593.331000000006,391890.397],[\"9/156/336\",52593.331000000006,390890.397,53593.331000000006,391890.397],[\"9/156/340\",52593.331000000006,391890.397,53593.331000000006,392890.397],[\"8/152/344\",51593.331000000006,392890.397,53593.331000000006,394890.397],[\"9/152/340\",51593.331000000006,391890.397,52593.331000000006,392890.397],[\"9/148/340\",50593.331000000006,391890.397,51593.331000000006,392890.397],[\"9/144/340\",49593.331000000006,391890.397,50593.331000000006,392890.397],[\"8/144/344\",49593.331000000006,392890.397,51593.331000000006,394890.397],[\"7/144/352\",49593.331000000006,394890.397,53593.331000000006,398890.397],[\"7/144/368\",49593.331000000006,398890.397,53593.331000000006,402890.397],[\"7/128/368\",45593.331000000006,398890.397,49593.331000000006,402890.397],[\"7/144/384\",49593.331000000006,402890.397,53593.331000000006,406890.397],[\"9/156/400\",52593.331000000006,406890.397,53593.331000000006,407890.397],[\"9/156/404\",52593.331000000006,407890.397,53593.331000000006,408890.397],[\"9/152/404\",51593.331000000006,407890.397,52593.331000000006,408890.397],[\"9/152/400\",51593.331000000006,406890.397,52593.331000000006,407890.397],[\"8/144/400\",49593.331000000006,406890.397,51593.331000000006,408890.397],[\"8/144/408\",49593.331000000006,408890.397,51593.331000000006,410890.397],[\"8/152/408\",51593.331000000006,408890.397,53593.331000000006,410890.397],[\"7/144/416\",49593.331000000006,410890.397,53593.331000000006,414890.397],[\"7/144/432\",49593.331000000006,414890.397,53593.331000000006,418890.397],[\"7/128/416\",45593.331000000006,410890.397,49593.331000000006,414890.397],[\"7/128/432\",45593.331000000006,414890.397,49593.331000000006,418890.397],[\"8/104/416\",39593.331000000006,410890.397,41593.331000000006,412890.397],[\"8/96/416\",37593.331000000006,410890.397,39593.331000000006,412890.397],[\"8/96/424\",37593.331000000006,412890.397,39593.331000000006,414890.397],[\"7/96/432\",37593.331000000006,414890.397,41593.331000000006,418890.397],[\"8/104/424\",39593.331000000006,412890.397,41593.331000000006,414890.397],[\"7/112/416\",41593.331000000006,410890.397,45593.331000000006,414890.397],[\"7/112/432\",41593.331000000006,414890.397,45593.331000000006,418890.397],[\"7/128/448\",45593.331000000006,418890.397,49593.331000000006,422890.397],[\"7/144/448\",49593.331000000006,418890.397,53593.331000000006,422890.397],[\"7/144/464\",49593.331000000006,422890.397,53593.331000000006,426890.397],[\"9/160/476\",53593.331000000006,425890.397,54593.331000000006,426890.397],[\"9/160/472\",53593.331000000006,424890.397,54593.331000000006,425890.397],[\"9/164/472\",54593.331000000006,424890.397,55593.331000000006,425890.397],[\"9/164/476\",54593.331000000006,425890.397,55593.331000000006,426890.397],[\"8/168/472\",55593.331000000006,424890.397,57593.331000000006,426890.397],[\"8/176/472\",57593.331000000006,424890.397,59593.331000000006,426890.397],[\"8/160/464\",53593.331000000006,422890.397,55593.331000000006,424890.397],[\"7/192/448\",61593.331000000006,418890.397,65593.331,422890.397],[\"8/184/464\",59593.331000000006,422890.397,61593.331000000006,424890.397],[\"8/184/472\",59593.331000000006,424890.397,61593.331000000006,426890.397],[\"7/192/464\",61593.331000000006,422890.397,65593.331,426890.397],[\"7/208/464\",65593.331,422890.397,69593.331,426890.397],[\"7/224/464\",69593.331,422890.397,73593.331,426890.397],[\"10/224/450\",69593.331,419390.397,70093.331,419890.397],[\"9/224/452\",69593.331,419890.397,70593.331,420890.397],[\"10/226/450\",70093.331,419390.397,70593.331,419890.397],[\"9/228/452\",70593.331,419890.397,71593.331,420890.397],[\"8/224/456\",69593.331,420890.397,71593.331,422890.397],[\"8/232/456\",71593.331,420890.397,73593.331,422890.397],[\"8/232/448\",71593.331,418890.397,73593.331,420890.397],[\"9/228/448\",70593.331,418890.397,71593.331,419890.397],[\"10/226/448\",70093.331,418890.397,70593.331,419390.397],[\"10/224/448\",69593.331,418890.397,70093.331,419390.397],[\"8/216/440\",67593.331,416890.397,69593.331,418890.397],[\"9/212/440\",66593.331,416890.397,67593.331,417890.397],[\"9/212/444\",66593.331,417890.397,67593.331,418890.397],[\"7/208/448\",65593.331,418890.397,69593.331,422890.397],[\"9/208/444\",65593.331,417890.397,66593.331,418890.397],[\"9/208/440\",65593.331,416890.397,66593.331,417890.397],[\"7/208/416\",65593.331,410890.397,69593.331,414890.397],[\"8/208/432\",65593.331,414890.397,67593.331,416890.397],[\"8/216/432\",67593.331,414890.397,69593.331,416890.397],[\"7/224/432\",69593.331,414890.397,73593.331,418890.397],[\"8/232/424\",71593.331,412890.397,73593.331,414890.397],[\"8/224/424\",69593.331,412890.397,71593.331,414890.397],[\"8/224/416\",69593.331,410890.397,71593.331,412890.397],[\"8/232/416\",71593.331,410890.397,73593.331,412890.397],[\"7/208/400\",65593.331,406890.397,69593.331,410890.397],[\"8/200/408\",63593.331000000006,408890.397,65593.331,410890.397],[\"8/200/400\",63593.331000000006,406890.397,65593.331,408890.397],[\"8/192/400\",61593.331000000006,406890.397,63593.331000000006,408890.397],[\"7/176/400\",57593.331000000006,406890.397,61593.331000000006,410890.397],[\"8/192/408\",61593.331000000006,408890.397,63593.331000000006,410890.397],[\"7/192/416\",61593.331000000006,410890.397,65593.331,414890.397],[\"7/192/432\",61593.331000000006,414890.397,65593.331,418890.397],[\"6/160/416\",53593.331000000006,410890.397,61593.331000000006,418890.397],[\"7/160/400\",53593.331000000006,406890.397,57593.331000000006,410890.397],[\"7/160/384\",53593.331000000006,402890.397,57593.331000000006,406890.397],[\"7/176/384\",57593.331000000006,402890.397,61593.331000000006,406890.397],[\"7/192/384\",61593.331000000006,402890.397,65593.331,406890.397],[\"7/192/368\",61593.331000000006,398890.397,65593.331,402890.397],[\"6/160/352\",53593.331000000006,394890.397,61593.331000000006,402890.397],[\"7/160/336\",53593.331000000006,390890.397,57593.331000000006,394890.397],[\"9/168/332\",55593.331000000006,389890.397,56593.331000000006,390890.397],[\"8/160/328\",53593.331000000006,388890.397,55593.331000000006,390890.397],[\"8/160/320\",53593.331000000006,386890.397,55593.331000000006,388890.397],[\"9/168/328\",55593.331000000006,388890.397,56593.331000000006,389890.397],[\"9/172/328\",56593.331000000006,388890.397,57593.331000000006,389890.397],[\"8/168/320\",55593.331000000006,386890.397,57593.331000000006,388890.397],[\"9/172/332\",56593.331000000006,389890.397,57593.331000000006,390890.397],[\"7/176/320\",57593.331000000006,386890.397,61593.331000000006,390890.397],[\"9/192/328\",61593.331000000006,388890.397,62593.331000000006,389890.397],[\"8/192/320\",61593.331000000006,386890.397,63593.331000000006,388890.397],[\"9/196/328\",62593.331000000006,388890.397,63593.331000000006,389890.397],[\"9/196/332\",62593.331000000006,389890.397,63593.331000000006,390890.397],[\"9/192/332\",61593.331000000006,389890.397,62593.331000000006,390890.397],[\"7/192/336\",61593.331000000006,390890.397,65593.331,394890.397],[\"7/176/336\",57593.331000000006,390890.397,61593.331000000006,394890.397],[\"7/192/352\",61593.331000000006,394890.397,65593.331,398890.397],[\"7/208/352\",65593.331,394890.397,69593.331,398890.397],[\"7/208/336\",65593.331,390890.397,69593.331,394890.397],[\"7/224/320\",69593.331,386890.397,73593.331,390890.397],[\"7/224/336\",69593.331,390890.397,73593.331,394890.397],[\"7/224/352\",69593.331,394890.397,73593.331,398890.397],[\"7/224/368\",69593.331,398890.397,73593.331,402890.397],[\"7/208/368\",65593.331,398890.397,69593.331,402890.397],[\"7/208/384\",65593.331,402890.397,69593.331,406890.397],[\"6/224/384\",69593.331,402890.397,77593.331,410890.397],[\"7/256/384\",77593.331,402890.397,81593.331,406890.397],[\"8/272/392\",81593.331,404890.397,83593.331,406890.397],[\"8/272/384\",81593.331,402890.397,83593.331,404890.397],[\"9/264/372\",79593.331,399890.397,80593.331,400890.397],[\"9/268/372\",80593.331,399890.397,81593.331,400890.397],[\"8/264/376\",79593.331,400890.397,81593.331,402890.397],[\"7/272/368\",81593.331,398890.397,85593.331,402890.397],[\"9/268/368\",80593.331,398890.397,81593.331,399890.397],[\"9/264/368\",79593.331,398890.397,80593.331,399890.397],[\"8/256/368\",77593.331,398890.397,79593.331,400890.397],[\"8/256/376\",77593.331,400890.397,79593.331,402890.397],[\"7/240/368\",73593.331,398890.397,77593.331,402890.397],[\"7/240/352\",73593.331,394890.397,77593.331,398890.397],[\"8/248/344\",75593.331,392890.397,77593.331,394890.397],[\"9/256/348\",77593.331,393890.397,78593.331,394890.397],[\"9/256/344\",77593.331,392890.397,78593.331,393890.397],[\"9/256/340\",77593.331,391890.397,78593.331,392890.397],[\"8/240/344\",73593.331,392890.397,75593.331,394890.397],[\"8/240/336\",73593.331,390890.397,75593.331,392890.397],[\"7/240/320\",73593.331,386890.397,77593.331,390890.397],[\"9/256/320\",77593.331,386890.397,78593.331,387890.397],[\"9/256/324\",77593.331,387890.397,78593.331,388890.397],[\"9/256/328\",77593.331,388890.397,78593.331,389890.397],[\"10/258/332\",78093.331,389890.397,78593.331,390390.397],[\"10/258/334\",78093.331,390390.397,78593.331,390890.397],[\"10/256/332\",77593.331,389890.397,78093.331,390390.397],[\"10/256/334\",77593.331,390390.397,78093.331,390890.397],[\"8/248/336\",75593.331,390890.397,77593.331,392890.397],[\"9/256/336\",77593.331,390890.397,78593.331,391890.397],[\"9/260/336\",78593.331,390890.397,79593.331,391890.397],[\"8/264/336\",79593.331,390890.397,81593.331,392890.397],[\"9/264/332\",79593.331,389890.397,80593.331,390890.397],[\"9/268/332\",80593.331,389890.397,81593.331,390890.397],[\"10/262/330\",79093.331,389390.397,79593.331,389890.397],[\"10/262/334\",79093.331,390390.397,79593.331,390890.397],[\"10/262/332\",79093.331,389890.397,79593.331,390390.397],[\"10/260/334\",78593.331,390390.397,79093.331,390890.397],[\"10/260/332\",78593.331,389890.397,79093.331,390390.397],[\"10/260/330\",78593.331,389390.397,79093.331,389890.397],[\"10/260/328\",78593.331,388890.397,79093.331,389390.397],[\"10/262/328\",79093.331,388890.397,79593.331,389390.397],[\"9/260/324\",78593.331,387890.397,79593.331,388890.397],[\"9/260/320\",78593.331,386890.397,79593.331,387890.397],[\"8/264/320\",79593.331,386890.397,81593.331,388890.397],[\"9/264/328\",79593.331,388890.397,80593.331,389890.397],[\"9/268/328\",80593.331,388890.397,81593.331,389890.397],[\"7/272/320\",81593.331,386890.397,85593.331,390890.397],[\"7/272/336\",81593.331,390890.397,85593.331,394890.397],[\"9/260/340\",78593.331,391890.397,79593.331,392890.397],[\"9/260/344\",78593.331,392890.397,79593.331,393890.397],[\"9/260/348\",78593.331,393890.397,79593.331,394890.397],[\"8/264/344\",79593.331,392890.397,81593.331,394890.397],[\"7/256/352\",77593.331,394890.397,81593.331,398890.397],[\"7/272/352\",81593.331,394890.397,85593.331,398890.397],[\"7/288/352\",85593.331,394890.397,89593.331,398890.397],[\"8/288/344\",85593.331,392890.397,87593.331,394890.397],[\"9/296/348\",87593.331,393890.397,88593.331,394890.397],[\"9/296/344\",87593.331,392890.397,88593.331,393890.397],[\"9/296/340\",87593.331,391890.397,88593.331,392890.397],[\"7/288/320\",85593.331,386890.397,89593.331,390890.397],[\"8/288/336\",85593.331,390890.397,87593.331,392890.397],[\"9/296/336\",87593.331,390890.397,88593.331,391890.397],[\"9/300/336\",88593.331,390890.397,89593.331,391890.397],[\"9/304/336\",89593.331,390890.397,90593.331,391890.397],[\"9/308/336\",90593.331,390890.397,91593.331,391890.397],[\"7/304/320\",89593.331,386890.397,93593.331,390890.397],[\"8/312/336\",91593.331,390890.397,93593.331,392890.397],[\"9/316/344\",92593.331,392890.397,93593.331,393890.397],[\"9/316/348\",92593.331,393890.397,93593.331,394890.397],[\"9/312/344\",91593.331,392890.397,92593.331,393890.397],[\"9/312/348\",91593.331,393890.397,92593.331,394890.397],[\"10/310/348\",91093.331,393890.397,91593.331,394390.397],[\"9/308/340\",90593.331,391890.397,91593.331,392890.397],[\"9/304/340\",89593.331,391890.397,90593.331,392890.397],[\"9/300/340\",88593.331,391890.397,89593.331,392890.397],[\"9/300/344\",88593.331,392890.397,89593.331,393890.397],[\"9/300/348\",88593.331,393890.397,89593.331,394890.397],[\"9/304/348\",89593.331,393890.397,90593.331,394890.397],[\"9/304/344\",89593.331,392890.397,90593.331,393890.397],[\"9/308/344\",90593.331,392890.397,91593.331,393890.397],[\"10/308/348\",90593.331,393890.397,91093.331,394390.397],[\"10/308/350\",90593.331,394390.397,91093.331,394890.397],[\"8/304/352\",89593.331,394890.397,91593.331,396890.397],[\"10/310/350\",91093.331,394390.397,91593.331,394890.397],[\"8/312/352\",91593.331,394890.397,93593.331,396890.397],[\"8/312/360\",91593.331,396890.397,93593.331,398890.397],[\"8/312/368\",91593.331,398890.397,93593.331,400890.397],[\"8/312/376\",91593.331,400890.397,93593.331,402890.397],[\"9/304/372\",89593.331,399890.397,90593.331,400890.397],[\"9/308/372\",90593.331,399890.397,91593.331,400890.397],[\"8/304/376\",89593.331,400890.397,91593.331,402890.397],[\"9/304/368\",89593.331,398890.397,90593.331,399890.397],[\"9/308/368\",90593.331,398890.397,91593.331,399890.397],[\"8/304/360\",89593.331,396890.397,91593.331,398890.397],[\"7/288/368\",85593.331,398890.397,89593.331,402890.397],[\"8/280/384\",83593.331,402890.397,85593.331,404890.397],[\"9/284/392\",84593.331,404890.397,85593.331,405890.397],[\"9/280/392\",83593.331,404890.397,84593.331,405890.397],[\"9/280/396\",83593.331,405890.397,84593.331,406890.397],[\"9/284/396\",84593.331,405890.397,85593.331,406890.397],[\"7/288/384\",85593.331,402890.397,89593.331,406890.397],[\"8/304/392\",89593.331,404890.397,91593.331,406890.397],[\"8/304/384\",89593.331,402890.397,91593.331,404890.397],[\"8/312/384\",91593.331,402890.397,93593.331,404890.397],[\"8/312/392\",91593.331,404890.397,93593.331,406890.397],[\"7/304/400\",89593.331,406890.397,93593.331,410890.397],[\"7/304/416\",89593.331,410890.397,93593.331,414890.397],[\"8/312/432\",91593.331,414890.397,93593.331,416890.397],[\"8/304/432\",89593.331,414890.397,91593.331,416890.397],[\"7/288/416\",85593.331,410890.397,89593.331,414890.397],[\"8/296/432\",87593.331,414890.397,89593.331,416890.397],[\"8/288/432\",85593.331,414890.397,87593.331,416890.397],[\"7/288/400\",85593.331,406890.397,89593.331,410890.397],[\"7/272/400\",81593.331,406890.397,85593.331,410890.397],[\"7/256/400\",77593.331,406890.397,81593.331,410890.397],[\"7/240/416\",73593.331,410890.397,77593.331,414890.397],[\"7/240/432\",73593.331,414890.397,77593.331,418890.397],[\"7/256/432\",77593.331,414890.397,81593.331,418890.397],[\"7/256/416\",77593.331,410890.397,81593.331,414890.397],[\"7/272/416\",81593.331,410890.397,85593.331,414890.397],[\"7/272/432\",81593.331,414890.397,85593.331,418890.397],[\"7/272/448\",81593.331,418890.397,85593.331,422890.397],[\"7/256/448\",77593.331,418890.397,81593.331,422890.397],[\"7/240/448\",73593.331,418890.397,77593.331,422890.397],[\"7/240/464\",73593.331,422890.397,77593.331,426890.397],[\"7/256/464\",77593.331,422890.397,81593.331,426890.397],[\"8/272/464\",81593.331,422890.397,83593.331,424890.397],[\"9/276/472\",82593.331,424890.397,83593.331,425890.397],[\"9/272/472\",81593.331,424890.397,82593.331,425890.397],[\"9/272/476\",81593.331,425890.397,82593.331,426890.397],[\"9/276/476\",82593.331,425890.397,83593.331,426890.397],[\"8/280/472\",83593.331,424890.397,85593.331,426890.397],[\"9/288/472\",85593.331,424890.397,86593.331,425890.397],[\"9/288/476\",85593.331,425890.397,86593.331,426890.397],[\"10/292/476\",86593.331,425890.397,87093.331,426390.397],[\"10/294/476\",87093.331,425890.397,87593.331,426390.397],[\"10/292/478\",86593.331,426390.397,87093.331,426890.397],[\"10/294/478\",87093.331,426390.397,87593.331,426890.397],[\"9/296/476\",87593.331,425890.397,88593.331,426890.397],[\"9/296/472\",87593.331,424890.397,88593.331,425890.397],[\"9/292/472\",86593.331,424890.397,87593.331,425890.397],[\"8/288/464\",85593.331,422890.397,87593.331,424890.397],[\"8/296/464\",87593.331,422890.397,89593.331,424890.397],[\"8/280/464\",83593.331,422890.397,85593.331,424890.397],[\"8/288/440\",85593.331,416890.397,87593.331,418890.397],[\"8/296/440\",87593.331,416890.397,89593.331,418890.397],[\"7/288/448\",85593.331,418890.397,89593.331,422890.397],[\"8/304/456\",89593.331,420890.397,91593.331,422890.397],[\"8/304/448\",89593.331,418890.397,91593.331,420890.397],[\"8/304/440\",89593.331,416890.397,91593.331,418890.397],[\"8/312/440\",91593.331,416890.397,93593.331,418890.397],[\"8/312/448\",91593.331,418890.397,93593.331,420890.397],[\"8/312/456\",91593.331,420890.397,93593.331,422890.397],[\"8/312/464\",91593.331,422890.397,93593.331,424890.397],[\"8/304/464\",89593.331,422890.397,91593.331,424890.397],[\"9/300/472\",88593.331,424890.397,89593.331,425890.397],[\"9/300/476\",88593.331,425890.397,89593.331,426890.397],[\"8/304/472\",89593.331,424890.397,91593.331,426890.397],[\"8/312/472\",91593.331,424890.397,93593.331,426890.397],[\"8/312/480\",91593.331,426890.397,93593.331,428890.397],[\"9/312/488\",91593.331,428890.397,92593.331,429890.397],[\"9/316/488\",92593.331,428890.397,93593.331,429890.397],[\"9/316/492\",92593.331,429890.397,93593.331,430890.397],[\"8/312/496\",91593.331,430890.397,93593.331,432890.397],[\"9/312/492\",91593.331,429890.397,92593.331,430890.397],[\"8/304/488\",89593.331,428890.397,91593.331,430890.397],[\"8/304/496\",89593.331,430890.397,91593.331,432890.397],[\"9/300/492\",88593.331,429890.397,89593.331,430890.397],[\"9/300/488\",88593.331,428890.397,89593.331,429890.397],[\"8/304/480\",89593.331,426890.397,91593.331,428890.397],[\"8/296/480\",87593.331,426890.397,89593.331,428890.397],[\"9/296/488\",87593.331,428890.397,88593.331,429890.397],[\"9/292/488\",86593.331,428890.397,87593.331,429890.397],[\"8/288/480\",85593.331,426890.397,87593.331,428890.397],[\"9/284/480\",84593.331,426890.397,85593.331,427890.397],[\"9/280/480\",83593.331,426890.397,84593.331,427890.397],[\"9/280/484\",83593.331,427890.397,84593.331,428890.397],[\"9/280/488\",83593.331,428890.397,84593.331,429890.397],[\"9/284/488\",84593.331,428890.397,85593.331,429890.397],[\"9/284/484\",84593.331,427890.397,85593.331,428890.397],[\"9/288/488\",85593.331,428890.397,86593.331,429890.397],[\"9/288/492\",85593.331,429890.397,86593.331,430890.397],[\"9/284/492\",84593.331,429890.397,85593.331,430890.397],[\"9/280/492\",83593.331,429890.397,84593.331,430890.397],[\"9/280/496\",83593.331,430890.397,84593.331,431890.397],[\"9/284/496\",84593.331,430890.397,85593.331,431890.397],[\"8/288/496\",85593.331,430890.397,87593.331,432890.397],[\"9/292/492\",86593.331,429890.397,87593.331,430890.397],[\"9/296/492\",87593.331,429890.397,88593.331,430890.397],[\"8/296/496\",87593.331,430890.397,89593.331,432890.397],[\"8/296/504\",87593.331,432890.397,89593.331,434890.397],[\"8/288/504\",85593.331,432890.397,87593.331,434890.397],[\"9/284/500\",84593.331,431890.397,85593.331,432890.397],[\"9/280/500\",83593.331,431890.397,84593.331,432890.397],[\"8/280/504\",83593.331,432890.397,85593.331,434890.397],[\"9/288/512\",85593.331,434890.397,86593.331,435890.397],[\"9/284/512\",84593.331,434890.397,85593.331,435890.397],[\"9/280/512\",83593.331,434890.397,84593.331,435890.397],[\"9/280/516\",83593.331,435890.397,84593.331,436890.397],[\"9/284/516\",84593.331,435890.397,85593.331,436890.397],[\"9/288/516\",85593.331,435890.397,86593.331,436890.397],[\"10/292/518\",86593.331,436390.397,87093.331,436890.397],[\"10/294/518\",87093.331,436390.397,87593.331,436890.397],[\"10/292/516\",86593.331,435890.397,87093.331,436390.397],[\"10/294/516\",87093.331,435890.397,87593.331,436390.397],[\"9/292/512\",86593.331,434890.397,87593.331,435890.397],[\"8/296/512\",87593.331,434890.397,89593.331,436890.397],[\"9/304/516\",89593.331,435890.397,90593.331,436890.397],[\"9/308/516\",90593.331,435890.397,91593.331,436890.397],[\"9/304/512\",89593.331,434890.397,90593.331,435890.397],[\"9/308/512\",90593.331,434890.397,91593.331,435890.397],[\"8/304/504\",89593.331,432890.397,91593.331,434890.397],[\"9/312/508\",91593.331,433890.397,92593.331,434890.397],[\"9/312/504\",91593.331,432890.397,92593.331,433890.397],[\"9/316/504\",92593.331,432890.397,93593.331,433890.397],[\"9/316/508\",92593.331,433890.397,93593.331,434890.397],[\"9/316/512\",92593.331,434890.397,93593.331,435890.397],[\"9/312/512\",91593.331,434890.397,92593.331,435890.397],[\"9/312/516\",91593.331,435890.397,92593.331,436890.397],[\"9/316/516\",92593.331,435890.397,93593.331,436890.397],[\"9/316/520\",92593.331,436890.397,93593.331,437890.397],[\"9/316/524\",92593.331,437890.397,93593.331,438890.397],[\"9/316/528\",92593.331,438890.397,93593.331,439890.397],[\"9/312/524\",91593.331,437890.397,92593.331,438890.397],[\"9/312/528\",91593.331,438890.397,92593.331,439890.397],[\"9/312/520\",91593.331,436890.397,92593.331,437890.397],[\"9/308/520\",90593.331,436890.397,91593.331,437890.397],[\"9/304/520\",89593.331,436890.397,90593.331,437890.397],[\"9/300/520\",88593.331,436890.397,89593.331,437890.397],[\"9/300/524\",88593.331,437890.397,89593.331,438890.397],[\"9/300/528\",88593.331,438890.397,89593.331,439890.397],[\"9/304/528\",89593.331,438890.397,90593.331,439890.397],[\"9/304/524\",89593.331,437890.397,90593.331,438890.397],[\"9/308/524\",90593.331,437890.397,91593.331,438890.397],[\"9/308/528\",90593.331,438890.397,91593.331,439890.397],[\"9/308/532\",90593.331,439890.397,91593.331,440890.397],[\"9/304/532\",89593.331,439890.397,90593.331,440890.397],[\"9/300/532\",88593.331,439890.397,89593.331,440890.397],[\"8/304/536\",89593.331,440890.397,91593.331,442890.397],[\"9/312/536\",91593.331,440890.397,92593.331,441890.397],[\"9/312/532\",91593.331,439890.397,92593.331,440890.397],[\"9/316/532\",92593.331,439890.397,93593.331,440890.397],[\"9/316/536\",92593.331,440890.397,93593.331,441890.397],[\"9/316/540\",92593.331,441890.397,93593.331,442890.397],[\"9/312/540\",91593.331,441890.397,92593.331,442890.397],[\"9/312/544\",91593.331,442890.397,92593.331,443890.397],[\"9/312/548\",91593.331,443890.397,92593.331,444890.397],[\"9/316/544\",92593.331,442890.397,93593.331,443890.397],[\"9/316/548\",92593.331,443890.397,93593.331,444890.397],[\"9/316/552\",92593.331,444890.397,93593.331,445890.397],[\"9/316/556\",92593.331,445890.397,93593.331,446890.397],[\"9/312/556\",91593.331,445890.397,92593.331,446890.397],[\"9/312/552\",91593.331,444890.397,92593.331,445890.397],[\"9/304/552\",89593.331,444890.397,90593.331,445890.397],[\"9/308/552\",90593.331,444890.397,91593.331,445890.397],[\"9/308/556\",90593.331,445890.397,91593.331,446890.397],[\"9/304/556\",89593.331,445890.397,90593.331,446890.397],[\"9/304/548\",89593.331,443890.397,90593.331,444890.397],[\"9/308/548\",90593.331,443890.397,91593.331,444890.397],[\"9/308/544\",90593.331,442890.397,91593.331,443890.397],[\"9/304/544\",89593.331,442890.397,90593.331,443890.397],[\"8/288/544\",85593.331,442890.397,87593.331,444890.397],[\"8/296/544\",87593.331,442890.397,89593.331,444890.397],[\"8/296/552\",87593.331,444890.397,89593.331,446890.397],[\"9/292/556\",86593.331,445890.397,87593.331,446890.397],[\"9/292/552\",86593.331,444890.397,87593.331,445890.397],[\"9/284/552\",84593.331,444890.397,85593.331,445890.397],[\"9/288/552\",85593.331,444890.397,86593.331,445890.397],[\"9/288/556\",85593.331,445890.397,86593.331,446890.397],[\"9/284/556\",84593.331,445890.397,85593.331,446890.397],[\"9/280/556\",83593.331,445890.397,84593.331,446890.397],[\"9/280/552\",83593.331,444890.397,84593.331,445890.397],[\"9/280/548\",83593.331,443890.397,84593.331,444890.397],[\"9/280/544\",83593.331,442890.397,84593.331,443890.397],[\"9/284/548\",84593.331,443890.397,85593.331,444890.397],[\"9/284/544\",84593.331,442890.397,85593.331,443890.397],[\"8/280/536\",83593.331,440890.397,85593.331,442890.397],[\"9/280/532\",83593.331,439890.397,84593.331,440890.397],[\"9/284/532\",84593.331,439890.397,85593.331,440890.397],[\"9/288/532\",85593.331,439890.397,86593.331,440890.397],[\"8/288/536\",85593.331,440890.397,87593.331,442890.397],[\"8/296/536\",87593.331,440890.397,89593.331,442890.397],[\"9/296/532\",87593.331,439890.397,88593.331,440890.397],[\"9/292/532\",86593.331,439890.397,87593.331,440890.397],[\"9/292/524\",86593.331,437890.397,87593.331,438890.397],[\"9/292/528\",86593.331,438890.397,87593.331,439890.397],[\"9/296/528\",87593.331,438890.397,88593.331,439890.397],[\"9/296/524\",87593.331,437890.397,88593.331,438890.397],[\"9/296/520\",87593.331,436890.397,88593.331,437890.397],[\"9/292/520\",86593.331,436890.397,87593.331,437890.397],[\"9/288/520\",85593.331,436890.397,86593.331,437890.397],[\"9/284/520\",84593.331,436890.397,85593.331,437890.397],[\"9/288/524\",85593.331,437890.397,86593.331,438890.397],[\"9/288/528\",85593.331,438890.397,86593.331,439890.397],[\"9/284/528\",84593.331,438890.397,85593.331,439890.397],[\"9/284/524\",84593.331,437890.397,85593.331,438890.397],[\"9/280/528\",83593.331,438890.397,84593.331,439890.397],[\"9/280/524\",83593.331,437890.397,84593.331,438890.397],[\"9/280/520\",83593.331,436890.397,84593.331,437890.397],[\"9/276/520\",82593.331,436890.397,83593.331,437890.397],[\"9/276/524\",82593.331,437890.397,83593.331,438890.397],[\"9/272/524\",81593.331,437890.397,82593.331,438890.397],[\"9/272/520\",81593.331,436890.397,82593.331,437890.397],[\"8/264/520\",79593.331,436890.397,81593.331,438890.397],[\"8/264/528\",79593.331,438890.397,81593.331,440890.397],[\"8/264/536\",79593.331,440890.397,81593.331,442890.397],[\"8/272/528\",81593.331,438890.397,83593.331,440890.397],[\"8/272/536\",81593.331,440890.397,83593.331,442890.397],[\"9/272/544\",81593.331,442890.397,82593.331,443890.397],[\"9/272/548\",81593.331,443890.397,82593.331,444890.397],[\"9/276/544\",82593.331,442890.397,83593.331,443890.397],[\"9/276/548\",82593.331,443890.397,83593.331,444890.397],[\"9/276/552\",82593.331,444890.397,83593.331,445890.397],[\"9/276/556\",82593.331,445890.397,83593.331,446890.397],[\"9/272/556\",81593.331,445890.397,82593.331,446890.397],[\"9/272/552\",81593.331,444890.397,82593.331,445890.397],[\"8/264/552\",79593.331,444890.397,81593.331,446890.397],[\"8/264/544\",79593.331,442890.397,81593.331,444890.397],[\"9/252/544\",76593.331,442890.397,77593.331,443890.397],[\"9/252/548\",76593.331,443890.397,77593.331,444890.397],[\"8/256/544\",77593.331,442890.397,79593.331,444890.397],[\"8/256/552\",77593.331,444890.397,79593.331,446890.397],[\"8/248/552\",75593.331,444890.397,77593.331,446890.397],[\"9/244/552\",74593.331,444890.397,75593.331,445890.397],[\"9/244/556\",74593.331,445890.397,75593.331,446890.397],[\"9/240/556\",73593.331,445890.397,74593.331,446890.397],[\"10/240/554\",73593.331,445390.397,74093.331,445890.397],[\"10/240/552\",73593.331,444890.397,74093.331,445390.397],[\"10/242/554\",74093.331,445390.397,74593.331,445890.397],[\"10/242/552\",74093.331,444890.397,74593.331,445390.397],[\"8/240/544\",73593.331,442890.397,75593.331,444890.397],[\"9/248/548\",75593.331,443890.397,76593.331,444890.397],[\"9/248/544\",75593.331,442890.397,76593.331,443890.397],[\"8/240/536\",73593.331,440890.397,75593.331,442890.397],[\"9/240/532\",73593.331,439890.397,74593.331,440890.397],[\"9/244/532\",74593.331,439890.397,75593.331,440890.397],[\"8/248/536\",75593.331,440890.397,77593.331,442890.397],[\"8/256/536\",77593.331,440890.397,79593.331,442890.397],[\"8/256/528\",77593.331,438890.397,79593.331,440890.397],[\"8/248/528\",75593.331,438890.397,77593.331,440890.397],[\"9/252/524\",76593.331,437890.397,77593.331,438890.397],[\"8/256/520\",77593.331,436890.397,79593.331,438890.397],[\"10/254/520\",77093.331,436890.397,77593.331,437390.397],[\"10/252/520\",76593.331,436890.397,77093.331,437390.397],[\"10/254/522\",77093.331,437390.397,77593.331,437890.397],[\"10/252/522\",76593.331,437390.397,77093.331,437890.397],[\"9/248/520\",75593.331,436890.397,76593.331,437890.397],[\"9/248/524\",75593.331,437890.397,76593.331,438890.397],[\"9/244/528\",74593.331,438890.397,75593.331,439890.397],[\"9/240/528\",73593.331,438890.397,74593.331,439890.397],[\"8/240/520\",73593.331,436890.397,75593.331,438890.397],[\"8/240/512\",73593.331,434890.397,75593.331,436890.397],[\"9/248/516\",75593.331,435890.397,76593.331,436890.397],[\"9/248/512\",75593.331,434890.397,76593.331,435890.397],[\"8/240/504\",73593.331,432890.397,75593.331,434890.397],[\"8/248/504\",75593.331,432890.397,77593.331,434890.397],[\"9/252/512\",76593.331,434890.397,77593.331,435890.397],[\"9/252/516\",76593.331,435890.397,77593.331,436890.397],[\"8/256/512\",77593.331,434890.397,79593.331,436890.397],[\"8/264/512\",79593.331,434890.397,81593.331,436890.397],[\"9/272/516\",81593.331,435890.397,82593.331,436890.397],[\"10/276/518\",82593.331,436390.397,83093.331,436890.397],[\"10/278/518\",83093.331,436390.397,83593.331,436890.397],[\"10/278/516\",83093.331,435890.397,83593.331,436390.397],[\"10/276/516\",82593.331,435890.397,83093.331,436390.397],[\"9/276/512\",82593.331,434890.397,83593.331,435890.397],[\"9/272/512\",81593.331,434890.397,82593.331,435890.397],[\"8/272/504\",81593.331,432890.397,83593.331,434890.397],[\"7/256/496\",77593.331,430890.397,81593.331,434890.397],[\"9/264/492\",79593.331,429890.397,80593.331,430890.397],[\"9/268/492\",80593.331,429890.397,81593.331,430890.397],[\"8/272/496\",81593.331,430890.397,83593.331,432890.397],[\"9/276/492\",82593.331,429890.397,83593.331,430890.397],[\"9/272/492\",81593.331,429890.397,82593.331,430890.397],[\"9/272/484\",81593.331,427890.397,82593.331,428890.397],[\"9/272/488\",81593.331,428890.397,82593.331,429890.397],[\"9/276/488\",82593.331,428890.397,83593.331,429890.397],[\"9/276/484\",82593.331,427890.397,83593.331,428890.397],[\"9/276/480\",82593.331,426890.397,83593.331,427890.397],[\"9/272/480\",81593.331,426890.397,82593.331,427890.397],[\"9/268/480\",80593.331,426890.397,81593.331,427890.397],[\"9/264/480\",79593.331,426890.397,80593.331,427890.397],[\"9/268/484\",80593.331,427890.397,81593.331,428890.397],[\"9/268/488\",80593.331,428890.397,81593.331,429890.397],[\"9/264/488\",79593.331,428890.397,80593.331,429890.397],[\"9/264/484\",79593.331,427890.397,80593.331,428890.397],[\"8/256/480\",77593.331,426890.397,79593.331,428890.397],[\"8/256/488\",77593.331,428890.397,79593.331,430890.397],[\"8/248/496\",75593.331,430890.397,77593.331,432890.397],[\"8/240/496\",73593.331,430890.397,75593.331,432890.397],[\"7/240/480\",73593.331,426890.397,77593.331,430890.397],[\"8/232/480\",71593.331,426890.397,73593.331,428890.397],[\"9/228/480\",70593.331,426890.397,71593.331,427890.397],[\"9/224/480\",69593.331,426890.397,70593.331,427890.397],[\"9/220/480\",68593.331,426890.397,69593.331,427890.397],[\"9/220/484\",68593.331,427890.397,69593.331,428890.397],[\"9/224/484\",69593.331,427890.397,70593.331,428890.397],[\"9/228/484\",70593.331,427890.397,71593.331,428890.397],[\"8/224/488\",69593.331,428890.397,71593.331,430890.397],[\"8/224/496\",69593.331,430890.397,71593.331,432890.397],[\"8/232/488\",71593.331,428890.397,73593.331,430890.397],[\"8/232/496\",71593.331,430890.397,73593.331,432890.397],[\"8/232/504\",71593.331,432890.397,73593.331,434890.397],[\"8/232/512\",71593.331,434890.397,73593.331,436890.397],[\"9/224/512\",69593.331,434890.397,70593.331,435890.397],[\"9/228/512\",70593.331,434890.397,71593.331,435890.397],[\"9/228/516\",70593.331,435890.397,71593.331,436890.397],[\"9/224/516\",69593.331,435890.397,70593.331,436890.397],[\"8/224/504\",69593.331,432890.397,71593.331,434890.397],[\"7/208/496\",65593.331,430890.397,69593.331,434890.397],[\"8/216/512\",67593.331,434890.397,69593.331,436890.397],[\"9/212/516\",66593.331,435890.397,67593.331,436890.397],[\"9/212/512\",66593.331,434890.397,67593.331,435890.397],[\"9/208/512\",65593.331,434890.397,66593.331,435890.397],[\"9/208/516\",65593.331,435890.397,66593.331,436890.397],[\"8/200/504\",63593.331000000006,432890.397,65593.331,434890.397],[\"8/200/496\",63593.331000000006,430890.397,65593.331,432890.397],[\"8/216/488\",67593.331,428890.397,69593.331,430890.397],[\"8/208/488\",65593.331,428890.397,67593.331,430890.397],[\"9/216/484\",67593.331,427890.397,68593.331,428890.397],[\"9/216/480\",67593.331,426890.397,68593.331,427890.397],[\"8/208/480\",65593.331,426890.397,67593.331,428890.397],[\"7/192/480\",61593.331000000006,426890.397,65593.331,430890.397],[\"8/192/496\",61593.331000000006,430890.397,63593.331000000006,432890.397],[\"6/160/480\",53593.331000000006,426890.397,61593.331000000006,434890.397],[\"8/192/504\",61593.331000000006,432890.397,63593.331000000006,434890.397],[\"7/192/512\",61593.331000000006,434890.397,65593.331,438890.397],[\"7/192/528\",61593.331000000006,438890.397,65593.331,442890.397],[\"7/192/544\",61593.331000000006,442890.397,65593.331,446890.397],[\"8/208/552\",65593.331,444890.397,67593.331,446890.397],[\"8/216/552\",67593.331,444890.397,69593.331,446890.397],[\"8/208/544\",65593.331,442890.397,67593.331,444890.397],[\"9/216/548\",67593.331,443890.397,68593.331,444890.397],[\"9/216/544\",67593.331,442890.397,68593.331,443890.397],[\"8/208/520\",65593.331,436890.397,67593.331,438890.397],[\"8/216/520\",67593.331,436890.397,69593.331,438890.397],[\"7/208/528\",65593.331,438890.397,69593.331,442890.397],[\"8/224/520\",69593.331,436890.397,71593.331,438890.397],[\"8/232/520\",71593.331,436890.397,73593.331,438890.397],[\"7/224/528\",69593.331,438890.397,73593.331,442890.397],[\"8/232/544\",71593.331,442890.397,73593.331,444890.397],[\"9/220/544\",68593.331,442890.397,69593.331,443890.397],[\"9/220/548\",68593.331,443890.397,69593.331,444890.397],[\"8/224/544\",69593.331,442890.397,71593.331,444890.397],[\"9/228/552\",70593.331,444890.397,71593.331,445890.397],[\"9/224/552\",69593.331,444890.397,70593.331,445890.397],[\"9/224/556\",69593.331,445890.397,70593.331,446890.397],[\"10/228/556\",70593.331,445890.397,71093.331,446390.397],[\"10/228/558\",70593.331,446390.397,71093.331,446890.397],[\"10/230/558\",71093.331,446390.397,71593.331,446890.397],[\"9/232/556\",71593.331,445890.397,72593.331,446890.397],[\"10/230/556\",71093.331,445890.397,71593.331,446390.397],[\"9/232/552\",71593.331,444890.397,72593.331,445890.397],[\"9/236/552\",72593.331,444890.397,73593.331,445890.397],[\"9/236/556\",72593.331,445890.397,73593.331,446890.397],[\"8/232/560\",71593.331,446890.397,73593.331,448890.397],[\"9/236/568\",72593.331,448890.397,73593.331,449890.397],[\"10/234/568\",72093.331,448890.397,72593.331,449390.397],[\"10/232/568\",71593.331,448890.397,72093.331,449390.397],[\"9/228/560\",70593.331,446890.397,71593.331,447890.397],[\"9/224/560\",69593.331,446890.397,70593.331,447890.397],[\"9/224/564\",69593.331,447890.397,70593.331,448890.397],[\"9/228/564\",70593.331,447890.397,71593.331,448890.397],[\"8/224/568\",69593.331,448890.397,71593.331,450890.397],[\"10/232/570\",71593.331,449390.397,72093.331,449890.397],[\"10/234/570\",72093.331,449390.397,72593.331,449890.397],[\"9/232/572\",71593.331,449890.397,72593.331,450890.397],[\"9/236/572\",72593.331,449890.397,73593.331,450890.397],[\"7/224/576\",69593.331,450890.397,73593.331,454890.397],[\"7/208/560\",65593.331,446890.397,69593.331,450890.397],[\"7/272/624\",81593.331,462890.397,85593.331,466890.397],[\"7/256/608\",77593.331,458890.397,81593.331,462890.397],[\"8/272/616\",81593.331,460890.397,83593.331,462890.397],[\"8/272/608\",81593.331,458890.397,83593.331,460890.397],[\"9/272/604\",81593.331,457890.397,82593.331,458890.397],[\"9/276/604\",82593.331,457890.397,83593.331,458890.397],[\"9/276/600\",82593.331,456890.397,83593.331,457890.397],[\"9/272/600\",81593.331,456890.397,82593.331,457890.397],[\"9/268/600\",80593.331,456890.397,81593.331,457890.397],[\"9/264/600\",79593.331,456890.397,80593.331,457890.397],[\"9/268/604\",80593.331,457890.397,81593.331,458890.397],[\"9/264/604\",79593.331,457890.397,80593.331,458890.397],[\"10/262/606\",79093.331,458390.397,79593.331,458890.397],[\"10/260/606\",78593.331,458390.397,79093.331,458890.397],[\"10/260/604\",78593.331,457890.397,79093.331,458390.397],[\"10/260/602\",78593.331,457390.397,79093.331,457890.397],[\"10/262/604\",79093.331,457890.397,79593.331,458390.397],[\"10/262/602\",79093.331,457390.397,79593.331,457890.397],[\"10/262/600\",79093.331,456890.397,79593.331,457390.397],[\"10/260/600\",78593.331,456890.397,79093.331,457390.397],[\"9/256/600\",77593.331,456890.397,78593.331,457890.397],[\"9/256/604\",77593.331,457890.397,78593.331,458890.397],[\"7/240/592\",73593.331,454890.397,77593.331,458890.397],[\"10/256/598\",77593.331,456390.397,78093.331,456890.397],[\"10/258/598\",78093.331,456390.397,78593.331,456890.397],[\"10/258/596\",78093.331,455890.397,78593.331,456390.397],[\"10/256/596\",77593.331,455890.397,78093.331,456390.397],[\"9/256/592\",77593.331,454890.397,78593.331,455890.397],[\"10/258/590\",78093.331,454390.397,78593.331,454890.397],[\"10/256/590\",77593.331,454390.397,78093.331,454890.397],[\"9/252/584\",76593.331,452890.397,77593.331,453890.397],[\"9/252/588\",76593.331,453890.397,77593.331,454890.397],[\"10/256/588\",77593.331,453890.397,78093.331,454390.397],[\"10/258/588\",78093.331,453890.397,78593.331,454390.397],[\"9/256/584\",77593.331,452890.397,78593.331,453890.397],[\"9/256/580\",77593.331,451890.397,78593.331,452890.397],[\"9/252/580\",76593.331,451890.397,77593.331,452890.397],[\"9/248/580\",75593.331,451890.397,76593.331,452890.397],[\"9/248/584\",75593.331,452890.397,76593.331,453890.397],[\"9/248/588\",75593.331,453890.397,76593.331,454890.397],[\"8/240/584\",73593.331,452890.397,75593.331,454890.397],[\"8/240/576\",73593.331,450890.397,75593.331,452890.397],[\"9/248/576\",75593.331,450890.397,76593.331,451890.397],[\"9/244/572\",74593.331,449890.397,75593.331,450890.397],[\"9/240/572\",73593.331,449890.397,74593.331,450890.397],[\"9/240/568\",73593.331,448890.397,74593.331,449890.397],[\"8/240/560\",73593.331,446890.397,75593.331,448890.397],[\"9/248/560\",75593.331,446890.397,76593.331,447890.397],[\"9/248/564\",75593.331,447890.397,76593.331,448890.397],[\"9/244/568\",74593.331,448890.397,75593.331,449890.397],[\"9/252/564\",76593.331,447890.397,77593.331,448890.397],[\"9/252/560\",76593.331,446890.397,77593.331,447890.397],[\"9/256/560\",77593.331,446890.397,78593.331,447890.397],[\"9/256/564\",77593.331,447890.397,78593.331,448890.397],[\"9/256/568\",77593.331,448890.397,78593.331,449890.397],[\"9/256/572\",77593.331,449890.397,78593.331,450890.397],[\"8/248/568\",75593.331,448890.397,77593.331,450890.397],[\"9/252/576\",76593.331,450890.397,77593.331,451890.397],[\"9/256/576\",77593.331,450890.397,78593.331,451890.397],[\"9/260/576\",78593.331,450890.397,79593.331,451890.397],[\"9/264/576\",79593.331,450890.397,80593.331,451890.397],[\"9/268/576\",80593.331,450890.397,81593.331,451890.397],[\"9/264/572\",79593.331,449890.397,80593.331,450890.397],[\"9/268/572\",80593.331,449890.397,81593.331,450890.397],[\"10/266/570\",80093.331,449390.397,80593.331,449890.397],[\"10/264/570\",79593.331,449390.397,80093.331,449890.397],[\"10/262/570\",79093.331,449390.397,79593.331,449890.397],[\"9/260/572\",78593.331,449890.397,79593.331,450890.397],[\"10/260/570\",78593.331,449390.397,79093.331,449890.397],[\"10/260/568\",78593.331,448890.397,79093.331,449390.397],[\"10/262/568\",79093.331,448890.397,79593.331,449390.397],[\"10/264/568\",79593.331,448890.397,80093.331,449390.397],[\"9/260/564\",78593.331,447890.397,79593.331,448890.397],[\"9/260/560\",78593.331,446890.397,79593.331,447890.397],[\"9/264/560\",79593.331,446890.397,80593.331,447890.397],[\"9/268/560\",80593.331,446890.397,81593.331,447890.397],[\"9/268/564\",80593.331,447890.397,81593.331,448890.397],[\"9/264/564\",79593.331,447890.397,80593.331,448890.397],[\"10/266/568\",80093.331,448890.397,80593.331,449390.397],[\"9/268/568\",80593.331,448890.397,81593.331,449890.397],[\"9/272/564\",81593.331,447890.397,82593.331,448890.397],[\"9/272/560\",81593.331,446890.397,82593.331,447890.397],[\"9/276/560\",82593.331,446890.397,83593.331,447890.397],[\"9/276/564\",82593.331,447890.397,83593.331,448890.397],[\"8/272/568\",81593.331,448890.397,83593.331,450890.397],[\"9/272/576\",81593.331,450890.397,82593.331,451890.397],[\"9/276/576\",82593.331,450890.397,83593.331,451890.397],[\"10/278/580\",83093.331,451890.397,83593.331,452390.397],[\"10/276/580\",82593.331,451890.397,83093.331,452390.397],[\"10/276/582\",82593.331,452390.397,83093.331,452890.397],[\"10/278/582\",83093.331,452390.397,83593.331,452890.397],[\"9/276/584\",82593.331,452890.397,83593.331,453890.397],[\"9/276/588\",82593.331,453890.397,83593.331,454890.397],[\"9/272/584\",81593.331,452890.397,82593.331,453890.397],[\"10/274/588\",82093.331,453890.397,82593.331,454390.397],[\"10/272/588\",81593.331,453890.397,82093.331,454390.397],[\"10/270/588\",81093.331,453890.397,81593.331,454390.397],[\"9/272/580\",81593.331,451890.397,82593.331,452890.397],[\"9/268/580\",80593.331,451890.397,81593.331,452890.397],[\"10/266/584\",80093.331,452890.397,80593.331,453390.397],[\"9/264/580\",79593.331,451890.397,80593.331,452890.397],[\"9/260/580\",78593.331,451890.397,79593.331,452890.397],[\"10/260/584\",78593.331,452890.397,79093.331,453390.397],[\"10/262/584\",79093.331,452890.397,79593.331,453390.397],[\"10/264/584\",79593.331,452890.397,80093.331,453390.397],[\"10/264/586\",79593.331,453390.397,80093.331,453890.397],[\"10/262/586\",79093.331,453390.397,79593.331,453890.397],[\"10/260/586\",78593.331,453390.397,79093.331,453890.397],[\"10/260/588\",78593.331,453890.397,79093.331,454390.397],[\"10/262/588\",79093.331,453890.397,79593.331,454390.397],[\"9/264/588\",79593.331,453890.397,80593.331,454890.397],[\"10/266/586\",80093.331,453390.397,80593.331,453890.397],[\"9/268/584\",80593.331,452890.397,81593.331,453890.397],[\"10/268/588\",80593.331,453890.397,81093.331,454390.397],[\"10/268/590\",80593.331,454390.397,81093.331,454890.397],[\"10/268/592\",80593.331,454890.397,81093.331,455390.397],[\"10/268/594\",80593.331,455390.397,81093.331,455890.397],[\"10/266/592\",80093.331,454890.397,80593.331,455390.397],[\"10/266/594\",80093.331,455390.397,80593.331,455890.397],[\"10/262/590\",79093.331,454390.397,79593.331,454890.397],[\"10/260/590\",78593.331,454390.397,79093.331,454890.397],[\"10/260/592\",78593.331,454890.397,79093.331,455390.397],[\"10/260/594\",78593.331,455390.397,79093.331,455890.397],[\"10/262/594\",79093.331,455390.397,79593.331,455890.397],[\"10/262/592\",79093.331,454890.397,79593.331,455390.397],[\"10/264/592\",79593.331,454890.397,80093.331,455390.397],[\"10/264/594\",79593.331,455390.397,80093.331,455890.397],[\"10/262/596\",79093.331,455890.397,79593.331,456390.397],[\"10/260/596\",78593.331,455890.397,79093.331,456390.397],[\"10/260/598\",78593.331,456390.397,79093.331,456890.397],[\"10/262/598\",79093.331,456390.397,79593.331,456890.397],[\"9/264/596\",79593.331,455890.397,80593.331,456890.397],[\"10/268/596\",80593.331,455890.397,81093.331,456390.397],[\"10/268/598\",80593.331,456390.397,81093.331,456890.397],[\"10/270/598\",81093.331,456390.397,81593.331,456890.397],[\"9/272/596\",81593.331,455890.397,82593.331,456890.397],[\"10/270/596\",81093.331,455890.397,81593.331,456390.397],[\"10/270/594\",81093.331,455390.397,81593.331,455890.397],[\"10/270/592\",81093.331,454890.397,81593.331,455390.397],[\"10/270/590\",81093.331,454390.397,81593.331,454890.397],[\"10/272/590\",81593.331,454390.397,82093.331,454890.397],[\"10/274/590\",82093.331,454390.397,82593.331,454890.397],[\"9/272/592\",81593.331,454890.397,82593.331,455890.397],[\"10/276/594\",82593.331,455390.397,83093.331,455890.397],[\"10/276/592\",82593.331,454890.397,83093.331,455390.397],[\"10/278/592\",83093.331,454890.397,83593.331,455390.397],[\"10/278/594\",83093.331,455390.397,83593.331,455890.397],[\"9/276/596\",82593.331,455890.397,83593.331,456890.397],[\"9/280/596\",83593.331,455890.397,84593.331,456890.397],[\"9/280/592\",83593.331,454890.397,84593.331,455890.397],[\"10/284/590\",84593.331,454390.397,85093.331,454890.397],[\"9/284/592\",84593.331,454890.397,85593.331,455890.397],[\"10/286/590\",85093.331,454390.397,85593.331,454890.397],[\"9/288/592\",85593.331,454890.397,86593.331,455890.397],[\"9/284/596\",84593.331,455890.397,85593.331,456890.397],[\"9/288/596\",85593.331,455890.397,86593.331,456890.397],[\"9/292/596\",86593.331,455890.397,87593.331,456890.397],[\"8/296/592\",87593.331,454890.397,89593.331,456890.397],[\"10/294/592\",87093.331,454890.397,87593.331,455390.397],[\"10/294/594\",87093.331,455390.397,87593.331,455890.397],[\"10/292/594\",86593.331,455390.397,87093.331,455890.397],[\"10/292/592\",86593.331,454890.397,87093.331,455390.397],[\"9/292/584\",86593.331,452890.397,87593.331,453890.397],[\"9/292/588\",86593.331,453890.397,87593.331,454890.397],[\"9/296/588\",87593.331,453890.397,88593.331,454890.397],[\"9/296/584\",87593.331,452890.397,88593.331,453890.397],[\"9/292/580\",86593.331,451890.397,87593.331,452890.397],[\"9/288/580\",85593.331,451890.397,86593.331,452890.397],[\"9/284/580\",84593.331,451890.397,85593.331,452890.397],[\"9/288/584\",85593.331,452890.397,86593.331,453890.397],[\"9/288/588\",85593.331,453890.397,86593.331,454890.397],[\"10/286/588\",85093.331,453890.397,85593.331,454390.397],[\"9/284/584\",84593.331,452890.397,85593.331,453890.397],[\"10/284/588\",84593.331,453890.397,85093.331,454390.397],[\"9/280/588\",83593.331,453890.397,84593.331,454890.397],[\"9/280/584\",83593.331,452890.397,84593.331,453890.397],[\"9/280/580\",83593.331,451890.397,84593.331,452890.397],[\"9/280/576\",83593.331,450890.397,84593.331,451890.397],[\"9/284/576\",84593.331,450890.397,85593.331,451890.397],[\"9/288/576\",85593.331,450890.397,86593.331,451890.397],[\"9/284/572\",84593.331,449890.397,85593.331,450890.397],[\"9/288/572\",85593.331,449890.397,86593.331,450890.397],[\"9/280/572\",83593.331,449890.397,84593.331,450890.397],[\"9/280/568\",83593.331,448890.397,84593.331,449890.397],[\"10/282/566\",84093.331,448390.397,84593.331,448890.397],[\"10/280/566\",83593.331,448390.397,84093.331,448890.397],[\"10/280/564\",83593.331,447890.397,84093.331,448390.397],[\"10/280/562\",83593.331,447390.397,84093.331,447890.397],[\"10/280/560\",83593.331,446890.397,84093.331,447390.397],[\"10/282/560\",84093.331,446890.397,84593.331,447390.397],[\"10/284/560\",84593.331,446890.397,85093.331,447390.397],[\"10/284/562\",84593.331,447390.397,85093.331,447890.397],[\"10/282/562\",84093.331,447390.397,84593.331,447890.397],[\"10/282/564\",84093.331,447890.397,84593.331,448390.397],[\"10/286/562\",85093.331,447390.397,85593.331,447890.397],[\"10/286/560\",85093.331,446890.397,85593.331,447390.397],[\"9/284/564\",84593.331,447890.397,85593.331,448890.397],[\"9/284/568\",84593.331,448890.397,85593.331,449890.397],[\"9/288/568\",85593.331,448890.397,86593.331,449890.397],[\"9/292/568\",86593.331,448890.397,87593.331,449890.397],[\"8/288/560\",85593.331,446890.397,87593.331,448890.397],[\"9/296/560\",87593.331,446890.397,88593.331,447890.397],[\"9/296/564\",87593.331,447890.397,88593.331,448890.397],[\"8/296/568\",87593.331,448890.397,89593.331,450890.397],[\"9/292/572\",86593.331,449890.397,87593.331,450890.397],[\"10/294/576\",87093.331,450890.397,87593.331,451390.397],[\"10/292/576\",86593.331,450890.397,87093.331,451390.397],[\"10/292/578\",86593.331,451390.397,87093.331,451890.397],[\"10/294/578\",87093.331,451390.397,87593.331,451890.397],[\"8/296/576\",87593.331,450890.397,89593.331,452890.397],[\"8/304/576\",89593.331,450890.397,91593.331,452890.397],[\"8/304/568\",89593.331,448890.397,91593.331,450890.397],[\"10/304/566\",89593.331,448390.397,90093.331,448890.397],[\"9/300/564\",88593.331,447890.397,89593.331,448890.397],[\"9/300/560\",88593.331,446890.397,89593.331,447890.397],[\"10/304/560\",89593.331,446890.397,90093.331,447390.397],[\"10/304/562\",89593.331,447390.397,90093.331,447890.397],[\"10/304/564\",89593.331,447890.397,90093.331,448390.397],[\"10/306/564\",90093.331,447890.397,90593.331,448390.397],[\"10/306/562\",90093.331,447390.397,90593.331,447890.397],[\"10/306/560\",90093.331,446890.397,90593.331,447390.397],[\"9/308/560\",90593.331,446890.397,91593.331,447890.397],[\"9/308/564\",90593.331,447890.397,91593.331,448890.397],[\"10/306/566\",90093.331,448390.397,90593.331,448890.397],[\"9/312/568\",91593.331,448890.397,92593.331,449890.397],[\"8/312/560\",91593.331,446890.397,93593.331,448890.397],[\"9/316/568\",92593.331,448890.397,93593.331,449890.397],[\"9/316/572\",92593.331,449890.397,93593.331,450890.397],[\"9/312/572\",91593.331,449890.397,92593.331,450890.397],[\"9/312/576\",91593.331,450890.397,92593.331,451890.397],[\"9/316/576\",92593.331,450890.397,93593.331,451890.397],[\"9/316/580\",92593.331,451890.397,93593.331,452890.397],[\"9/316/584\",92593.331,452890.397,93593.331,453890.397],[\"9/316/588\",92593.331,453890.397,93593.331,454890.397],[\"9/312/584\",91593.331,452890.397,92593.331,453890.397],[\"9/312/588\",91593.331,453890.397,92593.331,454890.397],[\"9/312/580\",91593.331,451890.397,92593.331,452890.397],[\"9/300/584\",88593.331,452890.397,89593.331,453890.397],[\"9/300/588\",88593.331,453890.397,89593.331,454890.397],[\"8/304/584\",89593.331,452890.397,91593.331,454890.397],[\"7/304/592\",89593.331,454890.397,93593.331,458890.397],[\"8/312/608\",91593.331,458890.397,93593.331,460890.397],[\"9/316/616\",92593.331,460890.397,93593.331,461890.397],[\"9/312/616\",91593.331,460890.397,92593.331,461890.397],[\"9/304/612\",89593.331,459890.397,90593.331,460890.397],[\"9/308/612\",90593.331,459890.397,91593.331,460890.397],[\"9/308/616\",90593.331,460890.397,91593.331,461890.397],[\"9/304/616\",89593.331,460890.397,90593.331,461890.397],[\"9/300/616\",88593.331,460890.397,89593.331,461890.397],[\"9/304/608\",89593.331,458890.397,90593.331,459890.397],[\"9/308/608\",90593.331,458890.397,91593.331,459890.397],[\"8/296/600\",87593.331,456890.397,89593.331,458890.397],[\"8/288/600\",85593.331,456890.397,87593.331,458890.397],[\"9/284/600\",84593.331,456890.397,85593.331,457890.397],[\"9/280/600\",83593.331,456890.397,84593.331,457890.397],[\"9/280/604\",83593.331,457890.397,84593.331,458890.397],[\"9/280/608\",83593.331,458890.397,84593.331,459890.397],[\"9/284/608\",84593.331,458890.397,85593.331,459890.397],[\"9/284/604\",84593.331,457890.397,85593.331,458890.397],[\"9/284/612\",84593.331,459890.397,85593.331,460890.397],[\"9/280/612\",83593.331,459890.397,84593.331,460890.397],[\"8/280/616\",83593.331,460890.397,85593.331,462890.397],[\"9/288/616\",85593.331,460890.397,86593.331,461890.397],[\"9/292/616\",86593.331,460890.397,87593.331,461890.397],[\"8/288/608\",85593.331,458890.397,87593.331,460890.397],[\"8/296/608\",87593.331,458890.397,89593.331,460890.397],[\"9/296/616\",87593.331,460890.397,88593.331,461890.397],[\"9/296/620\",87593.331,461890.397,88593.331,462890.397],[\"8/296/624\",87593.331,462890.397,89593.331,464890.397],[\"8/288/624\",85593.331,462890.397,87593.331,464890.397],[\"10/294/622\",87093.331,462390.397,87593.331,462890.397],[\"10/292/622\",86593.331,462390.397,87093.331,462890.397],[\"10/294/620\",87093.331,461890.397,87593.331,462390.397],[\"10/292/620\",86593.331,461890.397,87093.331,462390.397],[\"9/288/620\",85593.331,461890.397,86593.331,462890.397],[\"8/288/632\",85593.331,464890.397,87593.331,466890.397],[\"8/296/632\",87593.331,464890.397,89593.331,466890.397],[\"9/304/636\",89593.331,465890.397,90593.331,466890.397],[\"9/308/636\",90593.331,465890.397,91593.331,466890.397],[\"9/304/632\",89593.331,464890.397,90593.331,465890.397],[\"9/308/632\",90593.331,464890.397,91593.331,465890.397],[\"9/300/620\",88593.331,461890.397,89593.331,462890.397],[\"9/304/620\",89593.331,461890.397,90593.331,462890.397],[\"9/308/620\",90593.331,461890.397,91593.331,462890.397],[\"9/308/624\",90593.331,462890.397,91593.331,463890.397],[\"9/304/624\",89593.331,462890.397,90593.331,463890.397],[\"9/304/628\",89593.331,463890.397,90593.331,464890.397],[\"9/308/628\",90593.331,463890.397,91593.331,464890.397],[\"9/312/628\",91593.331,463890.397,92593.331,464890.397],[\"9/312/624\",91593.331,462890.397,92593.331,463890.397],[\"9/312/620\",91593.331,461890.397,92593.331,462890.397],[\"10/316/624\",92593.331,462890.397,93093.331,463390.397],[\"9/316/620\",92593.331,461890.397,93593.331,462890.397],[\"10/318/624\",93093.331,462890.397,93593.331,463390.397],[\"10/318/626\",93093.331,463390.397,93593.331,463890.397],[\"10/316/626\",92593.331,463390.397,93093.331,463890.397],[\"10/316/628\",92593.331,463890.397,93093.331,464390.397],[\"10/318/628\",93093.331,463890.397,93593.331,464390.397],[\"10/318/630\",93093.331,464390.397,93593.331,464890.397],[\"9/316/632\",92593.331,464890.397,93593.331,465890.397],[\"10/316/630\",92593.331,464390.397,93093.331,464890.397],[\"9/312/632\",91593.331,464890.397,92593.331,465890.397],[\"10/314/636\",92093.331,465890.397,92593.331,466390.397],[\"10/312/636\",91593.331,465890.397,92093.331,466390.397],[\"10/312/638\",91593.331,466390.397,92093.331,466890.397],[\"10/314/638\",92093.331,466390.397,92593.331,466890.397],[\"9/316/636\",92593.331,465890.397,93593.331,466890.397],[\"9/320/636\",93593.331,465890.397,94593.331,466890.397],[\"9/320/632\",93593.331,464890.397,94593.331,465890.397],[\"10/320/630\",93593.331,464390.397,94093.331,464890.397],[\"10/322/630\",94093.331,464390.397,94593.331,464890.397],[\"10/324/630\",94593.331,464390.397,95093.331,464890.397],[\"9/324/632\",94593.331,464890.397,95593.331,465890.397],[\"10/326/630\",95093.331,464390.397,95593.331,464890.397],[\"9/324/636\",94593.331,465890.397,95593.331,466890.397],[\"8/328/632\",95593.331,464890.397,97593.331,466890.397],[\"9/332/624\",96593.331,462890.397,97593.331,463890.397],[\"9/332/628\",96593.331,463890.397,97593.331,464890.397],[\"9/332/620\",96593.331,461890.397,97593.331,462890.397],[\"10/330/622\",96093.331,462390.397,96593.331,462890.397],[\"10/330/620\",96093.331,461890.397,96593.331,462390.397],[\"10/328/620\",95593.331,461890.397,96093.331,462390.397],[\"9/324/620\",94593.331,461890.397,95593.331,462890.397],[\"10/326/624\",95093.331,462890.397,95593.331,463390.397],[\"10/328/622\",95593.331,462390.397,96093.331,462890.397],[\"9/328/624\",95593.331,462890.397,96593.331,463890.397],[\"9/328/628\",95593.331,463890.397,96593.331,464890.397],[\"10/326/628\",95093.331,463890.397,95593.331,464390.397],[\"10/326/626\",95093.331,463390.397,95593.331,463890.397],[\"10/322/626\",94093.331,463390.397,94593.331,463890.397],[\"10/324/626\",94593.331,463390.397,95093.331,463890.397],[\"10/324/628\",94593.331,463890.397,95093.331,464390.397],[\"10/322/628\",94093.331,463890.397,94593.331,464390.397],[\"10/320/628\",93593.331,463890.397,94093.331,464390.397],[\"10/320/626\",93593.331,463390.397,94093.331,463890.397],[\"10/320/624\",93593.331,462890.397,94093.331,463390.397],[\"10/320/622\",93593.331,462390.397,94093.331,462890.397],[\"10/322/624\",94093.331,462890.397,94593.331,463390.397],[\"10/324/624\",94593.331,462890.397,95093.331,463390.397],[\"10/322/622\",94093.331,462390.397,94593.331,462890.397],[\"10/322/620\",94093.331,461890.397,94593.331,462390.397],[\"10/320/620\",93593.331,461890.397,94093.331,462390.397],[\"9/320/616\",93593.331,460890.397,94593.331,461890.397],[\"9/324/616\",94593.331,460890.397,95593.331,461890.397],[\"9/328/616\",95593.331,460890.397,96593.331,461890.397],[\"8/320/608\",93593.331,458890.397,95593.331,460890.397],[\"8/336/600\",97593.331,456890.397,99593.331,458890.397],[\"8/336/608\",97593.331,458890.397,99593.331,460890.397],[\"8/328/608\",95593.331,458890.397,97593.331,460890.397],[\"9/332/616\",96593.331,460890.397,97593.331,461890.397],[\"8/336/616\",97593.331,460890.397,99593.331,462890.397],[\"8/344/616\",99593.331,460890.397,101593.331,462890.397],[\"9/344/612\",99593.331,459890.397,100593.331,460890.397],[\"9/348/612\",100593.331,459890.397,101593.331,460890.397],[\"8/344/600\",99593.331,456890.397,101593.331,458890.397],[\"9/344/608\",99593.331,458890.397,100593.331,459890.397],[\"9/348/608\",100593.331,458890.397,101593.331,459890.397],[\"8/352/600\",101593.331,456890.397,103593.331,458890.397],[\"8/352/608\",101593.331,458890.397,103593.331,460890.397],[\"8/352/616\",101593.331,460890.397,103593.331,462890.397],[\"8/352/624\",101593.331,462890.397,103593.331,464890.397],[\"7/336/624\",97593.331,462890.397,101593.331,466890.397],[\"8/352/632\",101593.331,464890.397,103593.331,466890.397],[\"8/360/632\",103593.331,464890.397,105593.331,466890.397],[\"9/360/628\",103593.331,463890.397,104593.331,464890.397],[\"9/360/624\",103593.331,462890.397,104593.331,463890.397],[\"9/360/620\",103593.331,461890.397,104593.331,462890.397],[\"9/364/620\",104593.331,461890.397,105593.331,462890.397],[\"9/368/620\",105593.331,461890.397,106593.331,462890.397],[\"9/364/624\",104593.331,462890.397,105593.331,463890.397],[\"9/364/628\",104593.331,463890.397,105593.331,464890.397],[\"8/368/624\",105593.331,462890.397,107593.331,464890.397],[\"9/372/620\",106593.331,461890.397,107593.331,462890.397],[\"8/376/624\",107593.331,462890.397,109593.331,464890.397],[\"8/368/632\",105593.331,464890.397,107593.331,466890.397],[\"8/376/632\",107593.331,464890.397,109593.331,466890.397],[\"8/384/632\",109593.331,464890.397,111593.331,466890.397],[\"8/392/632\",111593.331,464890.397,113593.331,466890.397],[\"8/392/624\",111593.331,462890.397,113593.331,464890.397],[\"9/396/620\",112593.331,461890.397,113593.331,462890.397],[\"9/392/620\",111593.331,461890.397,112593.331,462890.397],[\"8/384/624\",109593.331,462890.397,111593.331,464890.397],[\"8/384/608\",109593.331,458890.397,111593.331,460890.397],[\"8/384/616\",109593.331,460890.397,111593.331,462890.397],[\"9/392/616\",111593.331,460890.397,112593.331,461890.397],[\"9/396/616\",112593.331,460890.397,113593.331,461890.397],[\"8/392/608\",111593.331,458890.397,113593.331,460890.397],[\"8/392/600\",111593.331,456890.397,113593.331,458890.397],[\"8/384/600\",109593.331,456890.397,111593.331,458890.397],[\"9/372/608\",106593.331,458890.397,107593.331,459890.397],[\"8/376/608\",107593.331,458890.397,109593.331,460890.397],[\"8/376/616\",107593.331,460890.397,109593.331,462890.397],[\"9/372/616\",106593.331,460890.397,107593.331,461890.397],[\"9/372/612\",106593.331,459890.397,107593.331,460890.397],[\"10/366/610\",105093.331,459390.397,105593.331,459890.397],[\"9/364/612\",104593.331,459890.397,105593.331,460890.397],[\"9/368/612\",105593.331,459890.397,106593.331,460890.397],[\"9/368/616\",105593.331,460890.397,106593.331,461890.397],[\"9/364/616\",104593.331,460890.397,105593.331,461890.397],[\"9/360/616\",103593.331,460890.397,104593.331,461890.397],[\"9/360/612\",103593.331,459890.397,104593.331,460890.397],[\"10/364/610\",104593.331,459390.397,105093.331,459890.397],[\"10/362/610\",104093.331,459390.397,104593.331,459890.397],[\"10/360/610\",103593.331,459390.397,104093.331,459890.397],[\"10/360/608\",103593.331,458890.397,104093.331,459390.397],[\"10/362/608\",104093.331,458890.397,104593.331,459390.397],[\"10/364/608\",104593.331,458890.397,105093.331,459390.397],[\"10/366/608\",105093.331,458890.397,105593.331,459390.397],[\"9/368/608\",105593.331,458890.397,106593.331,459890.397],[\"8/360/600\",103593.331,456890.397,105593.331,458890.397],[\"8/360/592\",103593.331,454890.397,105593.331,456890.397],[\"9/360/588\",103593.331,453890.397,104593.331,454890.397],[\"9/360/584\",103593.331,452890.397,104593.331,453890.397],[\"9/360/580\",103593.331,451890.397,104593.331,452890.397],[\"9/364/580\",104593.331,451890.397,105593.331,452890.397],[\"9/364/584\",104593.331,452890.397,105593.331,453890.397],[\"9/364/588\",104593.331,453890.397,105593.331,454890.397],[\"8/368/584\",105593.331,452890.397,107593.331,454890.397],[\"8/376/584\",107593.331,452890.397,109593.331,454890.397],[\"7/368/592\",105593.331,454890.397,109593.331,458890.397],[\"9/384/592\",109593.331,454890.397,110593.331,455890.397],[\"10/388/592\",110593.331,454890.397,111093.331,455390.397],[\"10/388/594\",110593.331,455390.397,111093.331,455890.397],[\"9/384/596\",109593.331,455890.397,110593.331,456890.397],[\"9/388/596\",110593.331,455890.397,111593.331,456890.397],[\"8/392/592\",111593.331,454890.397,113593.331,456890.397],[\"10/390/594\",111093.331,455390.397,111593.331,455890.397],[\"10/390/592\",111093.331,454890.397,111593.331,455390.397],[\"8/392/584\",111593.331,452890.397,113593.331,454890.397],[\"8/384/584\",109593.331,452890.397,111593.331,454890.397],[\"9/380/572\",108593.331,449890.397,109593.331,450890.397],[\"8/384/568\",109593.331,448890.397,111593.331,450890.397],[\"8/384/576\",109593.331,450890.397,111593.331,452890.397],[\"8/392/576\",111593.331,450890.397,113593.331,452890.397],[\"8/392/568\",111593.331,448890.397,113593.331,450890.397],[\"8/392/560\",111593.331,446890.397,113593.331,448890.397],[\"9/388/560\",110593.331,446890.397,111593.331,447890.397],[\"9/384/560\",109593.331,446890.397,110593.331,447890.397],[\"9/388/564\",110593.331,447890.397,111593.331,448890.397],[\"9/384/564\",109593.331,447890.397,110593.331,448890.397],[\"9/380/568\",108593.331,448890.397,109593.331,449890.397],[\"9/380/564\",108593.331,447890.397,109593.331,448890.397],[\"10/380/562\",108593.331,447390.397,109093.331,447890.397],[\"10/382/562\",109093.331,447390.397,109593.331,447890.397],[\"10/382/560\",109093.331,446890.397,109593.331,447390.397],[\"10/380/560\",108593.331,446890.397,109093.331,447390.397],[\"10/378/560\",108093.331,446890.397,108593.331,447390.397],[\"10/378/562\",108093.331,447390.397,108593.331,447890.397],[\"10/376/562\",107593.331,447390.397,108093.331,447890.397],[\"10/376/560\",107593.331,446890.397,108093.331,447390.397],[\"8/368/560\",105593.331,446890.397,107593.331,448890.397],[\"9/376/564\",107593.331,447890.397,108593.331,448890.397],[\"9/376/568\",107593.331,448890.397,108593.331,449890.397],[\"9/376/572\",107593.331,449890.397,108593.331,450890.397],[\"8/376/576\",107593.331,450890.397,109593.331,452890.397],[\"8/368/576\",105593.331,450890.397,107593.331,452890.397],[\"8/368/568\",105593.331,448890.397,107593.331,450890.397],[\"9/364/572\",104593.331,449890.397,105593.331,450890.397],[\"9/364/576\",104593.331,450890.397,105593.331,451890.397],[\"9/360/576\",103593.331,450890.397,104593.331,451890.397],[\"9/360/572\",103593.331,449890.397,104593.331,450890.397],[\"9/360/568\",103593.331,448890.397,104593.331,449890.397],[\"9/364/568\",104593.331,448890.397,105593.331,449890.397],[\"8/360/560\",103593.331,446890.397,105593.331,448890.397],[\"8/352/560\",101593.331,446890.397,103593.331,448890.397],[\"8/344/560\",99593.331,446890.397,101593.331,448890.397],[\"8/344/568\",99593.331,448890.397,101593.331,450890.397],[\"8/344/576\",99593.331,450890.397,101593.331,452890.397],[\"8/352/568\",101593.331,448890.397,103593.331,450890.397],[\"8/352/576\",101593.331,450890.397,103593.331,452890.397],[\"8/352/584\",101593.331,452890.397,103593.331,454890.397],[\"8/352/592\",101593.331,454890.397,103593.331,456890.397],[\"8/344/592\",99593.331,454890.397,101593.331,456890.397],[\"8/344/584\",99593.331,452890.397,101593.331,454890.397],[\"9/332/580\",96593.331,451890.397,97593.331,452890.397],[\"9/332/584\",96593.331,452890.397,97593.331,453890.397],[\"9/332/588\",96593.331,453890.397,97593.331,454890.397],[\"8/336/584\",97593.331,452890.397,99593.331,454890.397],[\"8/336/592\",97593.331,454890.397,99593.331,456890.397],[\"7/320/592\",93593.331,454890.397,97593.331,458890.397],[\"9/320/588\",93593.331,453890.397,94593.331,454890.397],[\"9/320/584\",93593.331,452890.397,94593.331,453890.397],[\"10/324/586\",94593.331,453390.397,95093.331,453890.397],[\"9/324/588\",94593.331,453890.397,95593.331,454890.397],[\"9/328/588\",95593.331,453890.397,96593.331,454890.397],[\"9/328/584\",95593.331,452890.397,96593.331,453890.397],[\"10/326/586\",95093.331,453390.397,95593.331,453890.397],[\"10/326/584\",95093.331,452890.397,95593.331,453390.397],[\"9/328/580\",95593.331,451890.397,96593.331,452890.397],[\"9/324/580\",94593.331,451890.397,95593.331,452890.397],[\"10/324/584\",94593.331,452890.397,95093.331,453390.397],[\"9/320/580\",93593.331,451890.397,94593.331,452890.397],[\"9/320/576\",93593.331,450890.397,94593.331,451890.397],[\"8/320/568\",93593.331,448890.397,95593.331,450890.397],[\"9/324/576\",94593.331,450890.397,95593.331,451890.397],[\"9/328/576\",95593.331,450890.397,96593.331,451890.397],[\"9/332/576\",96593.331,450890.397,97593.331,451890.397],[\"8/336/576\",97593.331,450890.397,99593.331,452890.397],[\"8/336/568\",97593.331,448890.397,99593.331,450890.397],[\"8/328/568\",95593.331,448890.397,97593.331,450890.397],[\"9/332/564\",96593.331,447890.397,97593.331,448890.397],[\"8/336/560\",97593.331,446890.397,99593.331,448890.397],[\"9/332/560\",96593.331,446890.397,97593.331,447890.397],[\"9/328/560\",95593.331,446890.397,96593.331,447890.397],[\"9/328/564\",95593.331,447890.397,96593.331,448890.397],[\"8/320/560\",93593.331,446890.397,95593.331,448890.397],[\"9/320/556\",93593.331,445890.397,94593.331,446890.397],[\"9/324/556\",94593.331,445890.397,95593.331,446890.397],[\"9/324/552\",94593.331,444890.397,95593.331,445890.397],[\"10/322/554\",94093.331,445390.397,94593.331,445890.397],[\"10/322/552\",94093.331,444890.397,94593.331,445390.397],[\"10/320/554\",93593.331,445390.397,94093.331,445890.397],[\"10/320/552\",93593.331,444890.397,94093.331,445390.397],[\"8/320/544\",93593.331,442890.397,95593.331,444890.397],[\"9/320/540\",93593.331,441890.397,94593.331,442890.397],[\"9/324/540\",94593.331,441890.397,95593.331,442890.397],[\"9/328/540\",95593.331,441890.397,96593.331,442890.397],[\"8/328/544\",95593.331,442890.397,97593.331,444890.397],[\"9/332/540\",96593.331,441890.397,97593.331,442890.397],[\"9/336/540\",97593.331,441890.397,98593.331,442890.397],[\"8/336/544\",97593.331,442890.397,99593.331,444890.397],[\"8/328/552\",95593.331,444890.397,97593.331,446890.397],[\"8/336/552\",97593.331,444890.397,99593.331,446890.397],[\"8/344/552\",99593.331,444890.397,101593.331,446890.397],[\"8/352/552\",101593.331,444890.397,103593.331,446890.397],[\"8/352/544\",101593.331,442890.397,103593.331,444890.397],[\"9/356/540\",102593.331,441890.397,103593.331,442890.397],[\"9/352/540\",101593.331,441890.397,102593.331,442890.397],[\"9/348/540\",100593.331,441890.397,101593.331,442890.397],[\"9/344/540\",99593.331,441890.397,100593.331,442890.397],[\"9/348/544\",100593.331,442890.397,101593.331,443890.397],[\"9/348/548\",100593.331,443890.397,101593.331,444890.397],[\"9/344/548\",99593.331,443890.397,100593.331,444890.397],[\"9/344/544\",99593.331,442890.397,100593.331,443890.397],[\"9/340/540\",98593.331,441890.397,99593.331,442890.397],[\"9/340/536\",98593.331,440890.397,99593.331,441890.397],[\"9/340/532\",98593.331,439890.397,99593.331,440890.397],[\"9/344/532\",99593.331,439890.397,100593.331,440890.397],[\"9/348/532\",100593.331,439890.397,101593.331,440890.397],[\"9/344/536\",99593.331,440890.397,100593.331,441890.397],[\"9/348/536\",100593.331,440890.397,101593.331,441890.397],[\"9/352/536\",101593.331,440890.397,102593.331,441890.397],[\"9/356/536\",102593.331,440890.397,103593.331,441890.397],[\"8/352/528\",101593.331,438890.397,103593.331,440890.397],[\"9/352/524\",101593.331,437890.397,102593.331,438890.397],[\"9/356/524\",102593.331,437890.397,103593.331,438890.397],[\"9/356/520\",102593.331,436890.397,103593.331,437890.397],[\"9/352/520\",101593.331,436890.397,102593.331,437890.397],[\"9/348/520\",100593.331,436890.397,101593.331,437890.397],[\"9/344/520\",99593.331,436890.397,100593.331,437890.397],[\"9/348/524\",100593.331,437890.397,101593.331,438890.397],[\"9/348/528\",100593.331,438890.397,101593.331,439890.397],[\"9/344/528\",99593.331,438890.397,100593.331,439890.397],[\"9/344/524\",99593.331,437890.397,100593.331,438890.397],[\"9/340/528\",98593.331,438890.397,99593.331,439890.397],[\"9/340/524\",98593.331,437890.397,99593.331,438890.397],[\"9/340/520\",98593.331,436890.397,99593.331,437890.397],[\"9/336/520\",97593.331,436890.397,98593.331,437890.397],[\"9/332/520\",96593.331,436890.397,97593.331,437890.397],[\"9/332/524\",96593.331,437890.397,97593.331,438890.397],[\"9/336/524\",97593.331,437890.397,98593.331,438890.397],[\"9/336/528\",97593.331,438890.397,98593.331,439890.397],[\"9/336/532\",97593.331,439890.397,98593.331,440890.397],[\"9/336/536\",97593.331,440890.397,98593.331,441890.397],[\"9/332/536\",96593.331,440890.397,97593.331,441890.397],[\"8/328/528\",95593.331,438890.397,97593.331,440890.397],[\"9/328/536\",95593.331,440890.397,96593.331,441890.397],[\"9/324/536\",94593.331,440890.397,95593.331,441890.397],[\"9/320/536\",93593.331,440890.397,94593.331,441890.397],[\"8/320/528\",93593.331,438890.397,95593.331,440890.397],[\"9/320/524\",93593.331,437890.397,94593.331,438890.397],[\"9/328/524\",95593.331,437890.397,96593.331,438890.397],[\"9/324/524\",94593.331,437890.397,95593.331,438890.397],[\"9/328/520\",95593.331,436890.397,96593.331,437890.397],[\"9/324/520\",94593.331,436890.397,95593.331,437890.397],[\"9/320/520\",93593.331,436890.397,94593.331,437890.397],[\"9/320/516\",93593.331,435890.397,94593.331,436890.397],[\"9/320/512\",93593.331,434890.397,94593.331,435890.397],[\"10/320/510\",93593.331,434390.397,94093.331,434890.397],[\"10/322/510\",94093.331,434390.397,94593.331,434890.397],[\"9/324/512\",94593.331,434890.397,95593.331,435890.397],[\"9/324/516\",94593.331,435890.397,95593.331,436890.397],[\"8/328/512\",95593.331,434890.397,97593.331,436890.397],[\"9/336/516\",97593.331,435890.397,98593.331,436890.397],[\"9/336/512\",97593.331,434890.397,98593.331,435890.397],[\"9/332/504\",96593.331,432890.397,97593.331,433890.397],[\"9/332/508\",96593.331,433890.397,97593.331,434890.397],[\"9/336/508\",97593.331,433890.397,98593.331,434890.397],[\"9/336/504\",97593.331,432890.397,98593.331,433890.397],[\"9/332/500\",96593.331,431890.397,97593.331,432890.397],[\"9/328/500\",95593.331,431890.397,96593.331,432890.397],[\"10/326/504\",95093.331,432890.397,95593.331,433390.397],[\"9/328/504\",95593.331,432890.397,96593.331,433890.397],[\"9/328/508\",95593.331,433890.397,96593.331,434890.397],[\"9/324/508\",94593.331,433890.397,95593.331,434890.397],[\"10/326/506\",95093.331,433390.397,95593.331,433890.397],[\"10/324/506\",94593.331,433390.397,95093.331,433890.397],[\"10/322/508\",94093.331,433890.397,94593.331,434390.397],[\"10/320/508\",93593.331,433890.397,94093.331,434390.397],[\"9/320/504\",93593.331,432890.397,94593.331,433890.397],[\"10/324/504\",94593.331,432890.397,95093.331,433390.397],[\"8/320/496\",93593.331,430890.397,95593.331,432890.397],[\"9/328/496\",95593.331,430890.397,96593.331,431890.397],[\"9/324/492\",94593.331,429890.397,95593.331,430890.397],[\"9/328/492\",95593.331,429890.397,96593.331,430890.397],[\"9/320/492\",93593.331,429890.397,94593.331,430890.397],[\"9/320/488\",93593.331,428890.397,94593.331,429890.397],[\"8/320/480\",93593.331,426890.397,95593.331,428890.397],[\"9/324/488\",94593.331,428890.397,95593.331,429890.397],[\"9/328/488\",95593.331,428890.397,96593.331,429890.397],[\"9/332/488\",96593.331,428890.397,97593.331,429890.397],[\"8/328/480\",95593.331,426890.397,97593.331,428890.397],[\"8/336/480\",97593.331,426890.397,99593.331,428890.397],[\"8/336/488\",97593.331,428890.397,99593.331,430890.397],[\"9/332/492\",96593.331,429890.397,97593.331,430890.397],[\"9/332/496\",96593.331,430890.397,97593.331,431890.397],[\"8/336/496\",97593.331,430890.397,99593.331,432890.397],[\"9/344/496\",99593.331,430890.397,100593.331,431890.397],[\"9/348/496\",100593.331,430890.397,101593.331,431890.397],[\"9/344/492\",99593.331,429890.397,100593.331,430890.397],[\"9/348/492\",100593.331,429890.397,101593.331,430890.397],[\"8/344/480\",99593.331,426890.397,101593.331,428890.397],[\"9/344/488\",99593.331,428890.397,100593.331,429890.397],[\"9/348/488\",100593.331,428890.397,101593.331,429890.397],[\"9/352/488\",101593.331,428890.397,102593.331,429890.397],[\"9/352/484\",101593.331,427890.397,102593.331,428890.397],[\"9/352/480\",101593.331,426890.397,102593.331,427890.397],[\"9/356/480\",102593.331,426890.397,103593.331,427890.397],[\"9/356/484\",102593.331,427890.397,103593.331,428890.397],[\"9/356/488\",102593.331,428890.397,103593.331,429890.397],[\"9/356/492\",102593.331,429890.397,103593.331,430890.397],[\"9/352/492\",101593.331,429890.397,102593.331,430890.397],[\"9/352/496\",101593.331,430890.397,102593.331,431890.397],[\"9/356/496\",102593.331,430890.397,103593.331,431890.397],[\"9/356/500\",102593.331,431890.397,103593.331,432890.397],[\"9/356/504\",102593.331,432890.397,103593.331,433890.397],[\"9/356/508\",102593.331,433890.397,103593.331,434890.397],[\"9/352/504\",101593.331,432890.397,102593.331,433890.397],[\"9/352/508\",101593.331,433890.397,102593.331,434890.397],[\"9/352/500\",101593.331,431890.397,102593.331,432890.397],[\"9/348/500\",100593.331,431890.397,101593.331,432890.397],[\"9/344/500\",99593.331,431890.397,100593.331,432890.397],[\"9/340/504\",98593.331,432890.397,99593.331,433890.397],[\"10/340/508\",98593.331,433890.397,99093.331,434390.397],[\"10/342/508\",99093.331,433890.397,99593.331,434390.397],[\"8/344/504\",99593.331,432890.397,101593.331,434890.397],[\"9/348/512\",100593.331,434890.397,101593.331,435890.397],[\"9/344/512\",99593.331,434890.397,100593.331,435890.397],[\"10/342/510\",99093.331,434390.397,99593.331,434890.397],[\"10/340/510\",98593.331,434390.397,99093.331,434890.397],[\"9/340/512\",98593.331,434890.397,99593.331,435890.397],[\"9/340/516\",98593.331,435890.397,99593.331,436890.397],[\"9/344/516\",99593.331,435890.397,100593.331,436890.397],[\"9/348/516\",100593.331,435890.397,101593.331,436890.397],[\"8/352/512\",101593.331,434890.397,103593.331,436890.397],[\"8/360/512\",103593.331,434890.397,105593.331,436890.397],[\"7/368/512\",105593.331,434890.397,109593.331,438890.397],[\"9/372/504\",106593.331,432890.397,107593.331,433890.397],[\"9/372/508\",106593.331,433890.397,107593.331,434890.397],[\"8/376/504\",107593.331,432890.397,109593.331,434890.397],[\"9/364/500\",104593.331,431890.397,105593.331,432890.397],[\"9/368/504\",105593.331,432890.397,106593.331,433890.397],[\"9/368/508\",105593.331,433890.397,106593.331,434890.397],[\"8/360/504\",103593.331,432890.397,105593.331,434890.397],[\"9/360/500\",103593.331,431890.397,104593.331,432890.397],[\"9/360/496\",103593.331,430890.397,104593.331,431890.397],[\"10/364/496\",104593.331,430890.397,105093.331,431390.397],[\"10/364/498\",104593.331,431390.397,105093.331,431890.397],[\"10/366/498\",105093.331,431390.397,105593.331,431890.397],[\"10/366/496\",105093.331,430890.397,105593.331,431390.397],[\"9/364/492\",104593.331,429890.397,105593.331,430890.397],[\"9/360/492\",103593.331,429890.397,104593.331,430890.397],[\"9/360/488\",103593.331,428890.397,104593.331,429890.397],[\"9/360/484\",103593.331,427890.397,104593.331,428890.397],[\"9/360/480\",103593.331,426890.397,104593.331,427890.397],[\"9/364/480\",104593.331,426890.397,105593.331,427890.397],[\"9/368/480\",105593.331,426890.397,106593.331,427890.397],[\"9/368/484\",105593.331,427890.397,106593.331,428890.397],[\"9/364/484\",104593.331,427890.397,105593.331,428890.397],[\"9/364/488\",104593.331,428890.397,105593.331,429890.397],[\"9/372/484\",106593.331,427890.397,107593.331,428890.397],[\"9/372/480\",106593.331,426890.397,107593.331,427890.397],[\"9/376/480\",107593.331,426890.397,108593.331,427890.397],[\"9/376/484\",107593.331,427890.397,108593.331,428890.397],[\"8/376/488\",107593.331,428890.397,109593.331,430890.397],[\"8/368/488\",105593.331,428890.397,107593.331,430890.397],[\"8/368/496\",105593.331,430890.397,107593.331,432890.397],[\"8/376/496\",107593.331,430890.397,109593.331,432890.397],[\"9/380/484\",108593.331,427890.397,109593.331,428890.397],[\"9/380/480\",108593.331,426890.397,109593.331,427890.397],[\"7/384/480\",109593.331,426890.397,113593.331,430890.397],[\"7/384/496\",109593.331,430890.397,113593.331,434890.397],[\"7/384/512\",109593.331,434890.397,113593.331,438890.397],[\"7/384/528\",109593.331,438890.397,113593.331,442890.397],[\"8/360/520\",103593.331,436890.397,105593.331,438890.397],[\"8/360/528\",103593.331,438890.397,105593.331,440890.397],[\"8/360/536\",103593.331,440890.397,105593.331,442890.397],[\"7/368/528\",105593.331,438890.397,109593.331,442890.397],[\"8/376/544\",107593.331,442890.397,109593.331,444890.397],[\"8/368/544\",105593.331,442890.397,107593.331,444890.397],[\"8/360/544\",103593.331,442890.397,105593.331,444890.397],[\"8/360/552\",103593.331,444890.397,105593.331,446890.397],[\"8/368/552\",105593.331,444890.397,107593.331,446890.397],[\"9/376/552\",107593.331,444890.397,108593.331,445890.397],[\"9/376/556\",107593.331,445890.397,108593.331,446890.397],[\"9/380/556\",108593.331,445890.397,109593.331,446890.397],[\"8/384/552\",109593.331,444890.397,111593.331,446890.397],[\"9/380/552\",108593.331,444890.397,109593.331,445890.397],[\"8/384/544\",109593.331,442890.397,111593.331,444890.397],[\"8/392/544\",111593.331,442890.397,113593.331,444890.397],[\"8/392/552\",111593.331,444890.397,113593.331,446890.397],[\"7/400/544\",113593.331,442890.397,117593.331,446890.397],[\"7/416/544\",117593.331,442890.397,121593.331,446890.397],[\"7/432/544\",121593.331,442890.397,125593.331,446890.397],[\"9/420/532\",118593.331,439890.397,119593.331,440890.397],[\"8/424/528\",119593.331,438890.397,121593.331,440890.397],[\"8/424/536\",119593.331,440890.397,121593.331,442890.397],[\"8/432/536\",121593.331,440890.397,123593.331,442890.397],[\"8/432/528\",121593.331,438890.397,123593.331,440890.397],[\"9/420/528\",118593.331,438890.397,119593.331,439890.397],[\"8/408/520\",115593.331,436890.397,117593.331,438890.397],[\"9/416/528\",117593.331,438890.397,118593.331,439890.397],[\"9/416/532\",117593.331,439890.397,118593.331,440890.397],[\"8/416/536\",117593.331,440890.397,119593.331,442890.397],[\"8/408/536\",115593.331,440890.397,117593.331,442890.397],[\"8/408/528\",115593.331,438890.397,117593.331,440890.397],[\"8/400/536\",113593.331,440890.397,115593.331,442890.397],[\"8/400/528\",113593.331,438890.397,115593.331,440890.397],[\"8/400/520\",113593.331,436890.397,115593.331,438890.397],[\"8/400/512\",113593.331,434890.397,115593.331,436890.397],[\"8/408/512\",115593.331,434890.397,117593.331,436890.397],[\"7/400/496\",113593.331,430890.397,117593.331,434890.397],[\"7/400/480\",113593.331,426890.397,117593.331,430890.397],[\"8/416/480\",117593.331,426890.397,119593.331,428890.397],[\"8/416/488\",117593.331,428890.397,119593.331,430890.397],[\"8/424/488\",119593.331,428890.397,121593.331,430890.397],[\"8/424/480\",119593.331,426890.397,121593.331,428890.397],[\"8/432/480\",121593.331,426890.397,123593.331,428890.397],[\"8/432/488\",121593.331,428890.397,123593.331,430890.397],[\"7/432/496\",121593.331,430890.397,125593.331,434890.397],[\"7/416/496\",117593.331,430890.397,121593.331,434890.397],[\"7/416/512\",117593.331,434890.397,121593.331,438890.397],[\"7/432/512\",121593.331,434890.397,125593.331,438890.397],[\"8/448/512\",125593.331,434890.397,127593.331,436890.397],[\"8/456/512\",127593.331,434890.397,129593.331,436890.397],[\"7/448/496\",125593.331,430890.397,129593.331,434890.397],[\"8/440/488\",123593.331,428890.397,125593.331,430890.397],[\"8/440/480\",123593.331,426890.397,125593.331,428890.397],[\"9/448/480\",125593.331,426890.397,126593.331,427890.397],[\"9/448/484\",125593.331,427890.397,126593.331,428890.397],[\"9/452/484\",126593.331,427890.397,127593.331,428890.397],[\"9/452/480\",126593.331,426890.397,127593.331,427890.397],[\"9/456/480\",127593.331,426890.397,128593.331,427890.397],[\"9/456/484\",127593.331,427890.397,128593.331,428890.397],[\"8/456/488\",127593.331,428890.397,129593.331,430890.397],[\"8/448/488\",125593.331,428890.397,127593.331,430890.397],[\"9/460/484\",128593.331,427890.397,129593.331,428890.397],[\"9/460/480\",128593.331,426890.397,129593.331,427890.397],[\"7/464/480\",129593.331,426890.397,133593.331,430890.397],[\"7/464/496\",129593.331,430890.397,133593.331,434890.397],[\"7/464/512\",129593.331,434890.397,133593.331,438890.397],[\"7/464/528\",129593.331,438890.397,133593.331,442890.397],[\"8/456/520\",127593.331,436890.397,129593.331,438890.397],[\"8/448/520\",125593.331,436890.397,127593.331,438890.397],[\"8/440/528\",123593.331,438890.397,125593.331,440890.397],[\"8/440/536\",123593.331,440890.397,125593.331,442890.397],[\"7/448/528\",125593.331,438890.397,129593.331,442890.397],[\"7/448/544\",125593.331,442890.397,129593.331,446890.397],[\"8/464/552\",129593.331,444890.397,131593.331,446890.397],[\"8/464/544\",129593.331,442890.397,131593.331,444890.397],[\"8/472/544\",131593.331,442890.397,133593.331,444890.397],[\"8/472/552\",131593.331,444890.397,133593.331,446890.397],[\"9/476/560\",132593.331,446890.397,133593.331,447890.397],[\"9/476/564\",132593.331,447890.397,133593.331,448890.397],[\"9/476/568\",132593.331,448890.397,133593.331,449890.397],[\"9/472/564\",131593.331,447890.397,132593.331,448890.397],[\"9/472/568\",131593.331,448890.397,132593.331,449890.397],[\"9/472/560\",131593.331,446890.397,132593.331,447890.397],[\"9/468/560\",130593.331,446890.397,131593.331,447890.397],[\"9/464/560\",129593.331,446890.397,130593.331,447890.397],[\"9/464/564\",129593.331,447890.397,130593.331,448890.397],[\"9/468/564\",130593.331,447890.397,131593.331,448890.397],[\"8/464/568\",129593.331,448890.397,131593.331,450890.397],[\"8/464/576\",129593.331,450890.397,131593.331,452890.397],[\"9/472/572\",131593.331,449890.397,132593.331,450890.397],[\"9/476/572\",132593.331,449890.397,133593.331,450890.397],[\"8/472/576\",131593.331,450890.397,133593.331,452890.397],[\"8/472/584\",131593.331,452890.397,133593.331,454890.397],[\"9/476/592\",132593.331,454890.397,133593.331,455890.397],[\"9/476/596\",132593.331,455890.397,133593.331,456890.397],[\"9/472/596\",131593.331,455890.397,132593.331,456890.397],[\"9/472/592\",131593.331,454890.397,132593.331,455890.397],[\"9/464/592\",129593.331,454890.397,130593.331,455890.397],[\"9/468/592\",130593.331,454890.397,131593.331,455890.397],[\"9/468/596\",130593.331,455890.397,131593.331,456890.397],[\"9/464/596\",129593.331,455890.397,130593.331,456890.397],[\"10/462/596\",129093.331,455890.397,129593.331,456390.397],[\"10/462/598\",129093.331,456390.397,129593.331,456890.397],[\"10/460/598\",128593.331,456390.397,129093.331,456890.397],[\"10/460/596\",128593.331,455890.397,129093.331,456390.397],[\"9/460/592\",128593.331,454890.397,129593.331,455890.397],[\"9/464/588\",129593.331,453890.397,130593.331,454890.397],[\"9/468/588\",130593.331,453890.397,131593.331,454890.397],[\"9/468/584\",130593.331,452890.397,131593.331,453890.397],[\"9/464/584\",129593.331,452890.397,130593.331,453890.397],[\"7/448/576\",125593.331,450890.397,129593.331,454890.397],[\"9/456/592\",127593.331,454890.397,128593.331,455890.397],[\"9/456/596\",127593.331,455890.397,128593.331,456890.397],[\"8/448/592\",125593.331,454890.397,127593.331,456890.397],[\"8/440/592\",123593.331,454890.397,125593.331,456890.397],[\"8/440/584\",123593.331,452890.397,125593.331,454890.397],[\"8/440/576\",123593.331,450890.397,125593.331,452890.397],[\"9/440/572\",123593.331,449890.397,124593.331,450890.397],[\"9/444/572\",124593.331,449890.397,125593.331,450890.397],[\"7/448/560\",125593.331,446890.397,129593.331,450890.397],[\"9/444/568\",124593.331,448890.397,125593.331,449890.397],[\"9/440/568\",123593.331,448890.397,124593.331,449890.397],[\"8/440/560\",123593.331,446890.397,125593.331,448890.397],[\"8/432/560\",121593.331,446890.397,123593.331,448890.397],[\"8/432/568\",121593.331,448890.397,123593.331,450890.397],[\"8/432/576\",121593.331,450890.397,123593.331,452890.397],[\"8/424/568\",119593.331,448890.397,121593.331,450890.397],[\"8/424/576\",119593.331,450890.397,121593.331,452890.397],[\"8/424/560\",119593.331,446890.397,121593.331,448890.397],[\"8/416/560\",117593.331,446890.397,119593.331,448890.397],[\"7/400/560\",113593.331,446890.397,117593.331,450890.397],[\"8/416/568\",117593.331,448890.397,119593.331,450890.397],[\"8/416/576\",117593.331,450890.397,119593.331,452890.397],[\"9/416/584\",117593.331,452890.397,118593.331,453890.397],[\"9/416/588\",117593.331,453890.397,118593.331,454890.397],[\"7/400/576\",113593.331,450890.397,117593.331,454890.397],[\"7/400/592\",113593.331,454890.397,117593.331,458890.397],[\"8/416/592\",117593.331,454890.397,119593.331,456890.397],[\"9/424/596\",119593.331,455890.397,120593.331,456890.397],[\"9/428/596\",120593.331,455890.397,121593.331,456890.397],[\"10/426/592\",120093.331,454890.397,120593.331,455390.397],[\"10/426/594\",120093.331,455390.397,120593.331,455890.397],[\"9/428/592\",120593.331,454890.397,121593.331,455890.397],[\"10/424/592\",119593.331,454890.397,120093.331,455390.397],[\"10/424/594\",119593.331,455390.397,120093.331,455890.397],[\"9/420/588\",118593.331,453890.397,119593.331,454890.397],[\"9/420/584\",118593.331,452890.397,119593.331,453890.397],[\"8/424/584\",119593.331,452890.397,121593.331,454890.397],[\"8/432/584\",121593.331,452890.397,123593.331,454890.397],[\"9/436/592\",122593.331,454890.397,123593.331,455890.397],[\"9/432/592\",121593.331,454890.397,122593.331,455890.397],[\"9/432/596\",121593.331,455890.397,122593.331,456890.397],[\"9/436/596\",122593.331,455890.397,123593.331,456890.397],[\"8/432/600\",121593.331,456890.397,123593.331,458890.397],[\"7/432/608\",121593.331,458890.397,125593.331,462890.397],[\"7/416/608\",117593.331,458890.397,121593.331,462890.397],[\"8/424/600\",119593.331,456890.397,121593.331,458890.397],[\"8/416/600\",117593.331,456890.397,119593.331,458890.397],[\"7/400/608\",113593.331,458890.397,117593.331,462890.397],[\"7/400/624\",113593.331,462890.397,117593.331,466890.397],[\"7/416/624\",117593.331,462890.397,121593.331,466890.397],[\"7/432/624\",121593.331,462890.397,125593.331,466890.397],[\"8/448/632\",125593.331,464890.397,127593.331,466890.397],[\"9/456/636\",127593.331,465890.397,128593.331,466890.397],[\"9/456/632\",127593.331,464890.397,128593.331,465890.397],[\"8/448/624\",125593.331,462890.397,127593.331,464890.397],[\"8/456/624\",127593.331,462890.397,129593.331,464890.397],[\"8/440/600\",123593.331,456890.397,125593.331,458890.397],[\"8/448/600\",125593.331,456890.397,127593.331,458890.397],[\"9/456/600\",127593.331,456890.397,128593.331,457890.397],[\"9/456/604\",127593.331,457890.397,128593.331,458890.397],[\"8/456/608\",127593.331,458890.397,129593.331,460890.397],[\"8/448/608\",125593.331,458890.397,127593.331,460890.397],[\"8/448/616\",125593.331,460890.397,127593.331,462890.397],[\"8/456/616\",127593.331,460890.397,129593.331,462890.397],[\"9/464/616\",129593.331,460890.397,130593.331,461890.397],[\"9/468/616\",130593.331,460890.397,131593.331,461890.397],[\"10/466/612\",130093.331,459890.397,130593.331,460390.397],[\"10/466/614\",130093.331,460390.397,130593.331,460890.397],[\"9/468/612\",130593.331,459890.397,131593.331,460890.397],[\"10/464/612\",129593.331,459890.397,130093.331,460390.397],[\"10/464/614\",129593.331,460390.397,130093.331,460890.397],[\"9/460/604\",128593.331,457890.397,129593.331,458890.397],[\"9/460/600\",128593.331,456890.397,129593.331,457890.397],[\"9/464/600\",129593.331,456890.397,130593.331,457890.397],[\"9/468/600\",130593.331,456890.397,131593.331,457890.397],[\"9/468/604\",130593.331,457890.397,131593.331,458890.397],[\"9/464/604\",129593.331,457890.397,130593.331,458890.397],[\"9/464/608\",129593.331,458890.397,130593.331,459890.397],[\"9/468/608\",130593.331,458890.397,131593.331,459890.397],[\"9/472/608\",131593.331,458890.397,132593.331,459890.397],[\"8/472/600\",131593.331,456890.397,133593.331,458890.397],[\"9/476/608\",132593.331,458890.397,133593.331,459890.397],[\"9/476/612\",132593.331,459890.397,133593.331,460890.397],[\"9/472/612\",131593.331,459890.397,132593.331,460890.397],[\"8/472/616\",131593.331,460890.397,133593.331,462890.397],[\"9/468/620\",130593.331,461890.397,131593.331,462890.397],[\"9/464/620\",129593.331,461890.397,130593.331,462890.397],[\"9/460/632\",128593.331,464890.397,129593.331,465890.397],[\"9/460/636\",128593.331,465890.397,129593.331,466890.397],[\"7/464/624\",129593.331,462890.397,133593.331,466890.397],[\"7/480/624\",133593.331,462890.397,137593.331,466890.397],[\"8/496/624\",137593.331,462890.397,139593.331,464890.397],[\"8/496/632\",137593.331,464890.397,139593.331,466890.397],[\"8/504/632\",139593.331,464890.397,141593.331,466890.397],[\"7/512/624\",141593.331,462890.397,145593.331,466890.397],[\"8/504/624\",139593.331,462890.397,141593.331,464890.397],[\"8/504/608\",139593.331,458890.397,141593.331,460890.397],[\"8/504/616\",139593.331,460890.397,141593.331,462890.397],[\"8/512/616\",141593.331,460890.397,143593.331,462890.397],[\"9/516/612\",142593.331,459890.397,143593.331,460890.397],[\"9/512/612\",141593.331,459890.397,142593.331,460890.397],[\"9/512/608\",141593.331,458890.397,142593.331,459890.397],[\"9/516/608\",142593.331,458890.397,143593.331,459890.397],[\"8/512/600\",141593.331,456890.397,143593.331,458890.397],[\"9/508/600\",140593.331,456890.397,141593.331,457890.397],[\"9/504/600\",139593.331,456890.397,140593.331,457890.397],[\"9/508/604\",140593.331,457890.397,141593.331,458890.397],[\"9/504/604\",139593.331,457890.397,140593.331,458890.397],[\"9/500/604\",138593.331,457890.397,139593.331,458890.397],[\"9/500/600\",138593.331,456890.397,139593.331,457890.397],[\"9/496/600\",137593.331,456890.397,138593.331,457890.397],[\"10/494/600\",137093.331,456890.397,137593.331,457390.397],[\"10/492/600\",136593.331,456890.397,137093.331,457390.397],[\"10/490/600\",136093.331,456890.397,136593.331,457390.397],[\"10/490/602\",136093.331,457390.397,136593.331,457890.397],[\"10/492/602\",136593.331,457390.397,137093.331,457890.397],[\"10/494/602\",137093.331,457390.397,137593.331,457890.397],[\"9/492/604\",136593.331,457890.397,137593.331,458890.397],[\"9/496/604\",137593.331,457890.397,138593.331,458890.397],[\"8/496/608\",137593.331,458890.397,139593.331,460890.397],[\"8/496/616\",137593.331,460890.397,139593.331,462890.397],[\"8/488/616\",135593.331,460890.397,137593.331,462890.397],[\"8/488/608\",135593.331,458890.397,137593.331,460890.397],[\"8/480/616\",133593.331,460890.397,135593.331,462890.397],[\"8/480/608\",133593.331,458890.397,135593.331,460890.397],[\"10/480/606\",133593.331,458390.397,134093.331,458890.397],[\"10/482/606\",134093.331,458390.397,134593.331,458890.397],[\"9/488/604\",135593.331,457890.397,136593.331,458890.397],[\"9/484/604\",134593.331,457890.397,135593.331,458890.397],[\"10/486/602\",135093.331,457390.397,135593.331,457890.397],[\"10/488/602\",135593.331,457390.397,136093.331,457890.397],[\"10/488/600\",135593.331,456890.397,136093.331,457390.397],[\"10/486/600\",135093.331,456890.397,135593.331,457390.397],[\"10/484/600\",134593.331,456890.397,135093.331,457390.397],[\"10/484/602\",134593.331,457390.397,135093.331,457890.397],[\"10/482/604\",134093.331,457890.397,134593.331,458390.397],[\"10/480/604\",133593.331,457890.397,134093.331,458390.397],[\"9/480/600\",133593.331,456890.397,134593.331,457890.397],[\"9/480/596\",133593.331,455890.397,134593.331,456890.397],[\"10/484/598\",134593.331,456390.397,135093.331,456890.397],[\"10/484/596\",134593.331,455890.397,135093.331,456390.397],[\"9/480/592\",133593.331,454890.397,134593.331,455890.397],[\"9/484/592\",134593.331,454890.397,135593.331,455890.397],[\"10/488/590\",135593.331,454390.397,136093.331,454890.397],[\"9/488/592\",135593.331,454890.397,136593.331,455890.397],[\"10/488/596\",135593.331,455890.397,136093.331,456390.397],[\"10/486/596\",135093.331,455890.397,135593.331,456390.397],[\"10/486/598\",135093.331,456390.397,135593.331,456890.397],[\"10/488/598\",135593.331,456390.397,136093.331,456890.397],[\"10/490/598\",136093.331,456390.397,136593.331,456890.397],[\"10/490/596\",136093.331,455890.397,136593.331,456390.397],[\"10/492/596\",136593.331,455890.397,137093.331,456390.397],[\"10/494/596\",137093.331,455890.397,137593.331,456390.397],[\"10/492/598\",136593.331,456390.397,137093.331,456890.397],[\"10/494/598\",137093.331,456390.397,137593.331,456890.397],[\"10/496/598\",137593.331,456390.397,138093.331,456890.397],[\"10/498/598\",138093.331,456390.397,138593.331,456890.397],[\"10/498/596\",138093.331,455890.397,138593.331,456390.397],[\"10/496/596\",137593.331,455890.397,138093.331,456390.397],[\"10/496/592\",137593.331,454890.397,138093.331,455390.397],[\"10/496/594\",137593.331,455390.397,138093.331,455890.397],[\"10/498/594\",138093.331,455390.397,138593.331,455890.397],[\"10/498/592\",138093.331,454890.397,138593.331,455390.397],[\"10/494/592\",137093.331,454890.397,137593.331,455390.397],[\"10/494/594\",137093.331,455390.397,137593.331,455890.397],[\"10/492/594\",136593.331,455390.397,137093.331,455890.397],[\"10/492/592\",136593.331,454890.397,137093.331,455390.397],[\"10/490/590\",136093.331,454390.397,136593.331,454890.397],[\"10/490/588\",136093.331,453890.397,136593.331,454390.397],[\"9/492/584\",136593.331,452890.397,137593.331,453890.397],[\"9/492/588\",136593.331,453890.397,137593.331,454890.397],[\"8/496/584\",137593.331,452890.397,139593.331,454890.397],[\"9/492/580\",136593.331,451890.397,137593.331,452890.397],[\"9/488/580\",135593.331,451890.397,136593.331,452890.397],[\"9/484/580\",134593.331,451890.397,135593.331,452890.397],[\"9/488/584\",135593.331,452890.397,136593.331,453890.397],[\"10/488/588\",135593.331,453890.397,136093.331,454390.397],[\"9/484/588\",134593.331,453890.397,135593.331,454890.397],[\"9/484/584\",134593.331,452890.397,135593.331,453890.397],[\"9/480/588\",133593.331,453890.397,134593.331,454890.397],[\"9/480/584\",133593.331,452890.397,134593.331,453890.397],[\"9/480/580\",133593.331,451890.397,134593.331,452890.397],[\"9/480/576\",133593.331,450890.397,134593.331,451890.397],[\"9/484/576\",134593.331,450890.397,135593.331,451890.397],[\"9/488/576\",135593.331,450890.397,136593.331,451890.397],[\"9/484/572\",134593.331,449890.397,135593.331,450890.397],[\"9/480/572\",133593.331,449890.397,134593.331,450890.397],[\"9/480/568\",133593.331,448890.397,134593.331,449890.397],[\"9/480/564\",133593.331,447890.397,134593.331,448890.397],[\"9/480/560\",133593.331,446890.397,134593.331,447890.397],[\"9/484/560\",134593.331,446890.397,135593.331,447890.397],[\"9/484/564\",134593.331,447890.397,135593.331,448890.397],[\"9/484/568\",134593.331,448890.397,135593.331,449890.397],[\"8/488/560\",135593.331,446890.397,137593.331,448890.397],[\"8/496/560\",137593.331,446890.397,139593.331,448890.397],[\"9/496/568\",137593.331,448890.397,138593.331,449890.397],[\"9/496/572\",137593.331,449890.397,138593.331,450890.397],[\"8/488/568\",135593.331,448890.397,137593.331,450890.397],[\"9/492/576\",136593.331,450890.397,137593.331,451890.397],[\"8/496/576\",137593.331,450890.397,139593.331,452890.397],[\"8/504/576\",139593.331,450890.397,141593.331,452890.397],[\"9/504/572\",139593.331,449890.397,140593.331,450890.397],[\"9/508/572\",140593.331,449890.397,141593.331,450890.397],[\"10/506/570\",140093.331,449390.397,140593.331,449890.397],[\"10/504/570\",139593.331,449390.397,140093.331,449890.397],[\"10/502/570\",139093.331,449390.397,139593.331,449890.397],[\"9/500/572\",138593.331,449890.397,139593.331,450890.397],[\"10/500/570\",138593.331,449390.397,139093.331,449890.397],[\"10/500/568\",138593.331,448890.397,139093.331,449390.397],[\"10/502/568\",139093.331,448890.397,139593.331,449390.397],[\"10/504/568\",139593.331,448890.397,140093.331,449390.397],[\"9/504/560\",139593.331,446890.397,140593.331,447890.397],[\"9/508/560\",140593.331,446890.397,141593.331,447890.397],[\"9/508/564\",140593.331,447890.397,141593.331,448890.397],[\"9/504/564\",139593.331,447890.397,140593.331,448890.397],[\"10/506/568\",140093.331,448890.397,140593.331,449390.397],[\"9/508/568\",140593.331,448890.397,141593.331,449890.397],[\"8/512/560\",141593.331,446890.397,143593.331,448890.397],[\"8/512/568\",141593.331,448890.397,143593.331,450890.397],[\"8/512/576\",141593.331,450890.397,143593.331,452890.397],[\"9/516/584\",142593.331,452890.397,143593.331,453890.397],[\"9/516/588\",142593.331,453890.397,143593.331,454890.397],[\"9/512/584\",141593.331,452890.397,142593.331,453890.397],[\"9/512/588\",141593.331,453890.397,142593.331,454890.397],[\"8/504/584\",139593.331,452890.397,141593.331,454890.397],[\"9/500/592\",138593.331,454890.397,139593.331,455890.397],[\"9/500/596\",138593.331,455890.397,139593.331,456890.397],[\"8/504/592\",139593.331,454890.397,141593.331,456890.397],[\"9/512/596\",141593.331,455890.397,142593.331,456890.397],[\"9/512/592\",141593.331,454890.397,142593.331,455890.397],[\"9/516/592\",142593.331,454890.397,143593.331,455890.397],[\"9/516/596\",142593.331,455890.397,143593.331,456890.397],[\"9/520/596\",143593.331,455890.397,144593.331,456890.397],[\"10/524/598\",144593.331,456390.397,145093.331,456890.397],[\"10/524/596\",144593.331,455890.397,145093.331,456390.397],[\"9/520/592\",143593.331,454890.397,144593.331,455890.397],[\"10/524/592\",144593.331,454890.397,145093.331,455390.397],[\"10/524/594\",144593.331,455390.397,145093.331,455890.397],[\"10/526/594\",145093.331,455390.397,145593.331,455890.397],[\"10/526/592\",145093.331,454890.397,145593.331,455390.397],[\"9/528/592\",145593.331,454890.397,146593.331,455890.397],[\"10/526/596\",145093.331,455890.397,145593.331,456390.397],[\"10/526/598\",145093.331,456390.397,145593.331,456890.397],[\"9/528/596\",145593.331,455890.397,146593.331,456890.397],[\"9/532/596\",146593.331,455890.397,147593.331,456890.397],[\"8/536/592\",147593.331,454890.397,149593.331,456890.397],[\"9/532/592\",146593.331,454890.397,147593.331,455890.397],[\"9/532/584\",146593.331,452890.397,147593.331,453890.397],[\"9/532/588\",146593.331,453890.397,147593.331,454890.397],[\"8/536/584\",147593.331,452890.397,149593.331,454890.397],[\"9/536/580\",147593.331,451890.397,148593.331,452890.397],[\"9/532/580\",146593.331,451890.397,147593.331,452890.397],[\"9/528/580\",145593.331,451890.397,146593.331,452890.397],[\"9/524/580\",144593.331,451890.397,145593.331,452890.397],[\"9/528/584\",145593.331,452890.397,146593.331,453890.397],[\"9/528/588\",145593.331,453890.397,146593.331,454890.397],[\"8/520/584\",143593.331,452890.397,145593.331,454890.397],[\"9/520/580\",143593.331,451890.397,144593.331,452890.397],[\"9/520/576\",143593.331,450890.397,144593.331,451890.397],[\"9/524/576\",144593.331,450890.397,145593.331,451890.397],[\"9/528/576\",145593.331,450890.397,146593.331,451890.397],[\"8/520/568\",143593.331,448890.397,145593.331,450890.397],[\"8/520/560\",143593.331,446890.397,145593.331,448890.397],[\"7/528/560\",145593.331,446890.397,149593.331,450890.397],[\"9/532/576\",146593.331,450890.397,147593.331,451890.397],[\"9/536/576\",147593.331,450890.397,148593.331,451890.397],[\"9/540/576\",148593.331,450890.397,149593.331,451890.397],[\"8/544/576\",149593.331,450890.397,151593.331,452890.397],[\"8/544/568\",149593.331,448890.397,151593.331,450890.397],[\"8/544/560\",149593.331,446890.397,151593.331,448890.397],[\"9/552/568\",151593.331,448890.397,152593.331,449890.397],[\"8/552/560\",151593.331,446890.397,153593.331,448890.397],[\"9/556/568\",152593.331,448890.397,153593.331,449890.397],[\"9/556/572\",152593.331,449890.397,153593.331,450890.397],[\"9/552/572\",151593.331,449890.397,152593.331,450890.397],[\"8/552/576\",151593.331,450890.397,153593.331,452890.397],[\"8/552/584\",151593.331,452890.397,153593.331,454890.397],[\"9/540/580\",148593.331,451890.397,149593.331,452890.397],[\"8/544/584\",149593.331,452890.397,151593.331,454890.397],[\"7/544/592\",149593.331,454890.397,153593.331,458890.397],[\"8/552/608\",151593.331,458890.397,153593.331,460890.397],[\"8/552/616\",151593.331,460890.397,153593.331,462890.397],[\"8/544/608\",149593.331,458890.397,151593.331,460890.397],[\"8/544/616\",149593.331,460890.397,151593.331,462890.397],[\"8/536/600\",147593.331,456890.397,149593.331,458890.397],[\"8/528/600\",145593.331,456890.397,147593.331,458890.397],[\"8/520/600\",143593.331,456890.397,145593.331,458890.397],[\"8/520/608\",143593.331,458890.397,145593.331,460890.397],[\"9/520/616\",143593.331,460890.397,144593.331,461890.397],[\"9/524/616\",144593.331,460890.397,145593.331,461890.397],[\"8/528/616\",145593.331,460890.397,147593.331,462890.397],[\"8/528/608\",145593.331,458890.397,147593.331,460890.397],[\"8/536/608\",147593.331,458890.397,149593.331,460890.397],[\"8/536/616\",147593.331,460890.397,149593.331,462890.397],[\"9/536/624\",147593.331,462890.397,148593.331,463890.397],[\"9/536/628\",147593.331,463890.397,148593.331,464890.397],[\"8/528/624\",145593.331,462890.397,147593.331,464890.397],[\"9/524/620\",144593.331,461890.397,145593.331,462890.397],[\"9/520/620\",143593.331,461890.397,144593.331,462890.397],[\"8/528/632\",145593.331,464890.397,147593.331,466890.397],[\"9/536/632\",147593.331,464890.397,148593.331,465890.397],[\"9/536/636\",147593.331,465890.397,148593.331,466890.397],[\"9/540/636\",148593.331,465890.397,149593.331,466890.397],[\"8/544/632\",149593.331,464890.397,151593.331,466890.397],[\"9/540/632\",148593.331,464890.397,149593.331,465890.397],[\"9/540/628\",148593.331,463890.397,149593.331,464890.397],[\"9/540/624\",148593.331,462890.397,149593.331,463890.397],[\"8/544/624\",149593.331,462890.397,151593.331,464890.397],[\"9/552/628\",151593.331,463890.397,152593.331,464890.397],[\"9/552/624\",151593.331,462890.397,152593.331,463890.397],[\"10/556/624\",152593.331,462890.397,153093.331,463390.397],[\"10/558/624\",153093.331,462890.397,153593.331,463390.397],[\"10/558/626\",153093.331,463390.397,153593.331,463890.397],[\"10/556/626\",152593.331,463390.397,153093.331,463890.397],[\"9/556/628\",152593.331,463890.397,153593.331,464890.397],[\"8/552/632\",151593.331,464890.397,153593.331,466890.397],[\"9/560/636\",153593.331,465890.397,154593.331,466890.397],[\"9/560/632\",153593.331,464890.397,154593.331,465890.397],[\"9/564/632\",154593.331,464890.397,155593.331,465890.397],[\"9/568/632\",155593.331,464890.397,156593.331,465890.397],[\"9/564/636\",154593.331,465890.397,155593.331,466890.397],[\"9/568/636\",155593.331,465890.397,156593.331,466890.397],[\"9/572/636\",156593.331,465890.397,157593.331,466890.397],[\"9/576/636\",157593.331,465890.397,158593.331,466890.397],[\"9/576/632\",157593.331,464890.397,158593.331,465890.397],[\"9/572/632\",156593.331,464890.397,157593.331,465890.397],[\"9/572/624\",156593.331,462890.397,157593.331,463890.397],[\"9/572/628\",156593.331,463890.397,157593.331,464890.397],[\"8/576/624\",157593.331,462890.397,159593.331,464890.397],[\"9/576/620\",157593.331,461890.397,158593.331,462890.397],[\"9/572/620\",156593.331,461890.397,157593.331,462890.397],[\"9/568/620\",155593.331,461890.397,156593.331,462890.397],[\"10/566/620\",155093.331,461890.397,155593.331,462390.397],[\"10/566/622\",155093.331,462390.397,155593.331,462890.397],[\"10/566/624\",155093.331,462890.397,155593.331,463390.397],[\"9/568/624\",155593.331,462890.397,156593.331,463890.397],[\"9/568/628\",155593.331,463890.397,156593.331,464890.397],[\"9/564/628\",154593.331,463890.397,155593.331,464890.397],[\"10/566/626\",155093.331,463390.397,155593.331,463890.397],[\"10/564/626\",154593.331,463390.397,155093.331,463890.397],[\"9/560/628\",153593.331,463890.397,154593.331,464890.397],[\"9/560/624\",153593.331,462890.397,154593.331,463890.397],[\"10/564/624\",154593.331,462890.397,155093.331,463390.397],[\"10/564/622\",154593.331,462390.397,155093.331,462890.397],[\"10/564/620\",154593.331,461890.397,155093.331,462390.397],[\"9/560/620\",153593.331,461890.397,154593.331,462890.397],[\"9/560/616\",153593.331,460890.397,154593.331,461890.397],[\"9/564/616\",154593.331,460890.397,155593.331,461890.397],[\"9/568/616\",155593.331,460890.397,156593.331,461890.397],[\"9/568/612\",155593.331,459890.397,156593.331,460890.397],[\"8/560/608\",153593.331,458890.397,155593.331,460890.397],[\"8/560/600\",153593.331,456890.397,155593.331,458890.397],[\"9/568/608\",155593.331,458890.397,156593.331,459890.397],[\"9/572/608\",156593.331,458890.397,157593.331,459890.397],[\"8/568/600\",155593.331,456890.397,157593.331,458890.397],[\"9/576/608\",157593.331,458890.397,158593.331,459890.397],[\"9/576/612\",157593.331,459890.397,158593.331,460890.397],[\"9/572/612\",156593.331,459890.397,157593.331,460890.397],[\"9/572/616\",156593.331,460890.397,157593.331,461890.397],[\"9/576/616\",157593.331,460890.397,158593.331,461890.397],[\"9/580/616\",158593.331,460890.397,159593.331,461890.397],[\"8/584/616\",159593.331,460890.397,161593.331,462890.397],[\"8/584/608\",159593.331,458890.397,161593.331,460890.397],[\"9/580/612\",158593.331,459890.397,159593.331,460890.397],[\"9/580/608\",158593.331,458890.397,159593.331,459890.397],[\"7/592/608\",161593.331,458890.397,165593.331,462890.397],[\"9/580/620\",158593.331,461890.397,159593.331,462890.397],[\"8/584/624\",159593.331,462890.397,161593.331,464890.397],[\"9/588/632\",160593.331,464890.397,161593.331,465890.397],[\"9/584/632\",159593.331,464890.397,160593.331,465890.397],[\"9/580/632\",158593.331,464890.397,159593.331,465890.397],[\"9/580/636\",158593.331,465890.397,159593.331,466890.397],[\"9/584/636\",159593.331,465890.397,160593.331,466890.397],[\"9/588/636\",160593.331,465890.397,161593.331,466890.397],[\"7/592/624\",161593.331,462890.397,165593.331,466890.397],[\"8/608/624\",165593.331,462890.397,167593.331,464890.397],[\"9/616/620\",167593.331,461890.397,168593.331,462890.397],[\"8/616/624\",167593.331,462890.397,169593.331,464890.397],[\"8/608/632\",165593.331,464890.397,167593.331,466890.397],[\"8/616/632\",167593.331,464890.397,169593.331,466890.397],[\"9/624/632\",169593.331,464890.397,170593.331,465890.397],[\"9/628/632\",170593.331,464890.397,171593.331,465890.397],[\"9/624/636\",169593.331,465890.397,170593.331,466890.397],[\"9/628/636\",170593.331,465890.397,171593.331,466890.397],[\"8/632/632\",171593.331,464890.397,173593.331,466890.397],[\"8/632/624\",171593.331,462890.397,173593.331,464890.397],[\"8/624/624\",169593.331,462890.397,171593.331,464890.397],[\"9/620/620\",168593.331,461890.397,169593.331,462890.397],[\"9/620/616\",168593.331,460890.397,169593.331,461890.397],[\"9/620/612\",168593.331,459890.397,169593.331,460890.397],[\"8/624/608\",169593.331,458890.397,171593.331,460890.397],[\"8/624/616\",169593.331,460890.397,171593.331,462890.397],[\"8/632/616\",171593.331,460890.397,173593.331,462890.397],[\"8/632/608\",171593.331,458890.397,173593.331,460890.397],[\"8/632/600\",171593.331,456890.397,173593.331,458890.397],[\"8/624/600\",169593.331,456890.397,171593.331,458890.397],[\"9/620/608\",168593.331,458890.397,169593.331,459890.397],[\"9/616/608\",167593.331,458890.397,168593.331,459890.397],[\"9/616/612\",167593.331,459890.397,168593.331,460890.397],[\"9/616/616\",167593.331,460890.397,168593.331,461890.397],[\"8/608/616\",165593.331,460890.397,167593.331,462890.397],[\"8/608/608\",165593.331,458890.397,167593.331,460890.397],[\"8/600/584\",163593.331,452890.397,165593.331,454890.397],[\"8/608/584\",165593.331,452890.397,167593.331,454890.397],[\"8/616/584\",167593.331,452890.397,169593.331,454890.397],[\"7/608/592\",165593.331,454890.397,169593.331,458890.397],[\"9/624/592\",169593.331,454890.397,170593.331,455890.397],[\"9/628/592\",170593.331,454890.397,171593.331,455890.397],[\"9/624/596\",169593.331,455890.397,170593.331,456890.397],[\"9/628/596\",170593.331,455890.397,171593.331,456890.397],[\"8/632/592\",171593.331,454890.397,173593.331,456890.397],[\"8/632/584\",171593.331,452890.397,173593.331,454890.397],[\"9/636/580\",172593.331,451890.397,173593.331,452890.397],[\"9/632/580\",171593.331,451890.397,172593.331,452890.397],[\"8/624/584\",169593.331,452890.397,171593.331,454890.397],[\"8/624/568\",169593.331,448890.397,171593.331,450890.397],[\"8/624/576\",169593.331,450890.397,171593.331,452890.397],[\"9/632/576\",171593.331,450890.397,172593.331,451890.397],[\"9/636/576\",172593.331,450890.397,173593.331,451890.397],[\"9/636/572\",172593.331,449890.397,173593.331,450890.397],[\"9/632/572\",171593.331,449890.397,172593.331,450890.397],[\"9/632/564\",171593.331,447890.397,172593.331,448890.397],[\"9/632/568\",171593.331,448890.397,172593.331,449890.397],[\"9/636/568\",172593.331,448890.397,173593.331,449890.397],[\"9/636/564\",172593.331,447890.397,173593.331,448890.397],[\"9/636/560\",172593.331,446890.397,173593.331,447890.397],[\"9/632/560\",171593.331,446890.397,172593.331,447890.397],[\"8/624/560\",169593.331,446890.397,171593.331,448890.397],[\"9/620/564\",168593.331,447890.397,169593.331,448890.397],[\"9/620/560\",168593.331,446890.397,169593.331,447890.397],[\"9/616/560\",167593.331,446890.397,168593.331,447890.397],[\"9/612/560\",166593.331,446890.397,167593.331,447890.397],[\"10/610/560\",166093.331,446890.397,166593.331,447390.397],[\"10/610/562\",166093.331,447390.397,166593.331,447890.397],[\"9/612/564\",166593.331,447890.397,167593.331,448890.397],[\"10/610/568\",166093.331,448890.397,166593.331,449390.397],[\"10/612/568\",166593.331,448890.397,167093.331,449390.397],[\"10/614/568\",167093.331,448890.397,167593.331,449390.397],[\"9/616/564\",167593.331,447890.397,168593.331,448890.397],[\"8/616/568\",167593.331,448890.397,169593.331,450890.397],[\"8/616/576\",167593.331,450890.397,169593.331,452890.397],[\"8/608/576\",165593.331,450890.397,167593.331,452890.397],[\"9/612/572\",166593.331,449890.397,167593.331,450890.397],[\"10/614/570\",167093.331,449390.397,167593.331,449890.397],[\"10/612/570\",166593.331,449390.397,167093.331,449890.397],[\"10/610/570\",166093.331,449390.397,166593.331,449890.397],[\"10/608/570\",165593.331,449390.397,166093.331,449890.397],[\"10/606/570\",165093.331,449390.397,165593.331,449890.397],[\"9/604/572\",164593.331,449890.397,165593.331,450890.397],[\"9/608/572\",165593.331,449890.397,166593.331,450890.397],[\"8/600/576\",163593.331,450890.397,165593.331,452890.397],[\"9/600/572\",163593.331,449890.397,164593.331,450890.397],[\"10/604/570\",164593.331,449390.397,165093.331,449890.397],[\"9/600/568\",163593.331,448890.397,164593.331,449890.397],[\"9/600/564\",163593.331,447890.397,164593.331,448890.397],[\"10/604/568\",164593.331,448890.397,165093.331,449390.397],[\"10/606/568\",165093.331,448890.397,165593.331,449390.397],[\"10/608/568\",165593.331,448890.397,166093.331,449390.397],[\"9/608/564\",165593.331,447890.397,166593.331,448890.397],[\"9/604/564\",164593.331,447890.397,165593.331,448890.397],[\"10/608/562\",165593.331,447390.397,166093.331,447890.397],[\"10/608/560\",165593.331,446890.397,166093.331,447390.397],[\"9/604/560\",164593.331,446890.397,165593.331,447890.397],[\"9/600/560\",163593.331,446890.397,164593.331,447890.397],[\"8/592/560\",161593.331,446890.397,163593.331,448890.397],[\"7/576/560\",157593.331,446890.397,161593.331,450890.397],[\"8/584/576\",159593.331,450890.397,161593.331,452890.397],[\"8/592/568\",161593.331,448890.397,163593.331,450890.397],[\"8/592/576\",161593.331,450890.397,163593.331,452890.397],[\"9/592/584\",161593.331,452890.397,162593.331,453890.397],[\"9/592/588\",161593.331,453890.397,162593.331,454890.397],[\"9/596/584\",162593.331,452890.397,163593.331,453890.397],[\"9/596/588\",162593.331,453890.397,163593.331,454890.397],[\"7/592/592\",161593.331,454890.397,165593.331,458890.397],[\"7/576/592\",157593.331,454890.397,161593.331,458890.397],[\"8/584/584\",159593.331,452890.397,161593.331,454890.397],[\"8/568/584\",155593.331,452890.397,157593.331,454890.397],[\"8/576/584\",157593.331,452890.397,159593.331,454890.397],[\"8/568/592\",155593.331,454890.397,157593.331,456890.397],[\"8/560/592\",153593.331,454890.397,155593.331,456890.397],[\"8/560/584\",153593.331,452890.397,155593.331,454890.397],[\"8/560/576\",153593.331,450890.397,155593.331,452890.397],[\"8/568/576\",155593.331,450890.397,157593.331,452890.397],[\"8/576/576\",157593.331,450890.397,159593.331,452890.397],[\"7/560/560\",153593.331,446890.397,157593.331,450890.397],[\"7/560/544\",153593.331,442890.397,157593.331,446890.397],[\"8/576/552\",157593.331,444890.397,159593.331,446890.397],[\"8/576/544\",157593.331,442890.397,159593.331,444890.397],[\"7/560/528\",153593.331,438890.397,157593.331,442890.397],[\"8/576/528\",157593.331,438890.397,159593.331,440890.397],[\"8/576/536\",157593.331,440890.397,159593.331,442890.397],[\"8/584/536\",159593.331,440890.397,161593.331,442890.397],[\"8/584/528\",159593.331,438890.397,161593.331,440890.397],[\"8/592/528\",161593.331,438890.397,163593.331,440890.397],[\"8/592/536\",161593.331,440890.397,163593.331,442890.397],[\"8/592/544\",161593.331,442890.397,163593.331,444890.397],[\"8/584/544\",159593.331,442890.397,161593.331,444890.397],[\"8/584/552\",159593.331,444890.397,161593.331,446890.397],[\"8/592/552\",161593.331,444890.397,163593.331,446890.397],[\"8/600/552\",163593.331,444890.397,165593.331,446890.397],[\"9/608/556\",165593.331,445890.397,166593.331,446890.397],[\"9/608/552\",165593.331,444890.397,166593.331,445890.397],[\"8/600/544\",163593.331,442890.397,165593.331,444890.397],[\"9/608/540\",165593.331,441890.397,166593.331,442890.397],[\"8/608/544\",165593.331,442890.397,167593.331,444890.397],[\"9/612/540\",166593.331,441890.397,167593.331,442890.397],[\"9/616/540\",167593.331,441890.397,168593.331,442890.397],[\"8/616/544\",167593.331,442890.397,169593.331,444890.397],[\"9/612/552\",166593.331,444890.397,167593.331,445890.397],[\"9/612/556\",166593.331,445890.397,167593.331,446890.397],[\"8/616/552\",167593.331,444890.397,169593.331,446890.397],[\"8/624/552\",169593.331,444890.397,171593.331,446890.397],[\"8/632/552\",171593.331,444890.397,173593.331,446890.397],[\"9/632/544\",171593.331,442890.397,172593.331,443890.397],[\"9/632/548\",171593.331,443890.397,172593.331,444890.397],[\"9/636/548\",172593.331,443890.397,173593.331,444890.397],[\"9/636/544\",172593.331,442890.397,173593.331,443890.397],[\"8/624/544\",169593.331,442890.397,171593.331,444890.397],[\"9/620/540\",168593.331,441890.397,169593.331,442890.397],[\"9/620/536\",168593.331,440890.397,169593.331,441890.397],[\"7/624/528\",169593.331,438890.397,173593.331,442890.397],[\"8/632/520\",171593.331,436890.397,173593.331,438890.397],[\"8/624/520\",169593.331,436890.397,171593.331,438890.397],[\"8/616/520\",167593.331,436890.397,169593.331,438890.397],[\"8/608/520\",165593.331,436890.397,167593.331,438890.397],[\"8/616/528\",167593.331,438890.397,169593.331,440890.397],[\"9/616/536\",167593.331,440890.397,168593.331,441890.397],[\"9/612/536\",166593.331,440890.397,167593.331,441890.397],[\"8/608/528\",165593.331,438890.397,167593.331,440890.397],[\"9/608/536\",165593.331,440890.397,166593.331,441890.397],[\"8/600/536\",163593.331,440890.397,165593.331,442890.397],[\"8/600/528\",163593.331,438890.397,165593.331,440890.397],[\"8/600/504\",163593.331,432890.397,165593.331,434890.397],[\"9/600/500\",163593.331,431890.397,164593.331,432890.397],[\"9/604/500\",164593.331,431890.397,165593.331,432890.397],[\"8/608/504\",165593.331,432890.397,167593.331,434890.397],[\"8/616/504\",167593.331,432890.397,169593.331,434890.397],[\"8/608/512\",165593.331,434890.397,167593.331,436890.397],[\"8/616/512\",167593.331,434890.397,169593.331,436890.397],[\"8/624/512\",169593.331,434890.397,171593.331,436890.397],[\"8/632/512\",171593.331,434890.397,173593.331,436890.397],[\"8/632/504\",171593.331,432890.397,173593.331,434890.397],[\"9/628/504\",170593.331,432890.397,171593.331,433890.397],[\"9/628/508\",170593.331,433890.397,171593.331,434890.397],[\"9/624/508\",169593.331,433890.397,170593.331,434890.397],[\"9/624/504\",169593.331,432890.397,170593.331,433890.397],[\"8/624/496\",169593.331,430890.397,171593.331,432890.397],[\"8/632/496\",171593.331,430890.397,173593.331,432890.397],[\"7/624/480\",169593.331,426890.397,173593.331,430890.397],[\"7/608/480\",165593.331,426890.397,169593.331,430890.397],[\"8/616/496\",167593.331,430890.397,169593.331,432890.397],[\"8/608/496\",165593.331,430890.397,167593.331,432890.397],[\"9/604/496\",164593.331,430890.397,165593.331,431890.397],[\"9/600/496\",163593.331,430890.397,164593.331,431890.397],[\"7/592/480\",161593.331,426890.397,165593.331,430890.397],[\"7/576/480\",157593.331,426890.397,161593.331,430890.397],[\"8/584/496\",159593.331,430890.397,161593.331,432890.397],[\"8/592/496\",161593.331,430890.397,163593.331,432890.397],[\"8/592/504\",161593.331,432890.397,163593.331,434890.397],[\"7/592/512\",161593.331,434890.397,165593.331,438890.397],[\"7/576/512\",157593.331,434890.397,161593.331,438890.397],[\"9/580/508\",158593.331,433890.397,159593.331,434890.397],[\"9/580/504\",158593.331,432890.397,159593.331,433890.397],[\"8/584/504\",159593.331,432890.397,161593.331,434890.397],[\"10/578/504\",158093.331,432890.397,158593.331,433390.397],[\"10/576/504\",157593.331,432890.397,158093.331,433390.397],[\"9/572/500\",156593.331,431890.397,157593.331,432890.397],[\"9/572/504\",156593.331,432890.397,157593.331,433890.397],[\"9/572/508\",156593.331,433890.397,157593.331,434890.397],[\"10/576/506\",157593.331,433390.397,158093.331,433890.397],[\"10/578/506\",158093.331,433390.397,158593.331,433890.397],[\"9/576/508\",157593.331,433890.397,158593.331,434890.397],[\"7/560/512\",153593.331,434890.397,157593.331,438890.397],[\"8/560/504\",153593.331,432890.397,155593.331,434890.397],[\"9/568/508\",155593.331,433890.397,156593.331,434890.397],[\"9/568/504\",155593.331,432890.397,156593.331,433890.397],[\"9/568/500\",155593.331,431890.397,156593.331,432890.397],[\"8/560/496\",153593.331,430890.397,155593.331,432890.397],[\"9/568/496\",155593.331,430890.397,156593.331,431890.397],[\"9/572/496\",156593.331,430890.397,157593.331,431890.397],[\"8/576/496\",157593.331,430890.397,159593.331,432890.397],[\"7/560/480\",153593.331,426890.397,157593.331,430890.397],[\"7/544/480\",149593.331,426890.397,153593.331,430890.397],[\"9/540/496\",148593.331,430890.397,149593.331,431890.397],[\"7/528/480\",145593.331,426890.397,149593.331,430890.397],[\"8/528/496\",145593.331,430890.397,147593.331,432890.397],[\"9/536/496\",147593.331,430890.397,148593.331,431890.397],[\"9/536/500\",147593.331,431890.397,148593.331,432890.397],[\"8/536/504\",147593.331,432890.397,149593.331,434890.397],[\"8/528/504\",145593.331,432890.397,147593.331,434890.397],[\"7/528/512\",145593.331,434890.397,149593.331,438890.397],[\"9/540/500\",148593.331,431890.397,149593.331,432890.397],[\"7/544/496\",149593.331,430890.397,153593.331,434890.397],[\"7/544/512\",149593.331,434890.397,153593.331,438890.397],[\"8/544/528\",149593.331,438890.397,151593.331,440890.397],[\"8/544/536\",149593.331,440890.397,151593.331,442890.397],[\"8/552/528\",151593.331,438890.397,153593.331,440890.397],[\"8/552/536\",151593.331,440890.397,153593.331,442890.397],[\"8/552/544\",151593.331,442890.397,153593.331,444890.397],[\"8/552/552\",151593.331,444890.397,153593.331,446890.397],[\"8/544/552\",149593.331,444890.397,151593.331,446890.397],[\"8/544/544\",149593.331,442890.397,151593.331,444890.397],[\"7/528/544\",145593.331,442890.397,149593.331,446890.397],[\"9/524/540\",144593.331,441890.397,145593.331,442890.397],[\"9/520/540\",143593.331,441890.397,144593.331,442890.397],[\"9/520/536\",143593.331,440890.397,144593.331,441890.397],[\"9/520/532\",143593.331,439890.397,144593.331,440890.397],[\"9/524/532\",144593.331,439890.397,145593.331,440890.397],[\"9/524/536\",144593.331,440890.397,145593.331,441890.397],[\"8/528/536\",145593.331,440890.397,147593.331,442890.397],[\"8/536/536\",147593.331,440890.397,149593.331,442890.397],[\"8/536/528\",147593.331,438890.397,149593.331,440890.397],[\"8/528/528\",145593.331,438890.397,147593.331,440890.397],[\"9/524/528\",144593.331,438890.397,145593.331,439890.397],[\"9/520/528\",143593.331,438890.397,144593.331,439890.397],[\"9/516/528\",142593.331,438890.397,143593.331,439890.397],[\"9/512/528\",141593.331,438890.397,142593.331,439890.397],[\"7/496/528\",137593.331,438890.397,141593.331,442890.397],[\"9/512/532\",141593.331,439890.397,142593.331,440890.397],[\"9/516/532\",142593.331,439890.397,143593.331,440890.397],[\"8/512/536\",141593.331,440890.397,143593.331,442890.397],[\"7/512/544\",141593.331,442890.397,145593.331,446890.397],[\"7/496/544\",137593.331,442890.397,141593.331,446890.397],[\"9/492/544\",136593.331,442890.397,137593.331,443890.397],[\"9/492/548\",136593.331,443890.397,137593.331,444890.397],[\"8/488/552\",135593.331,444890.397,137593.331,446890.397],[\"9/484/552\",134593.331,444890.397,135593.331,445890.397],[\"9/484/556\",134593.331,445890.397,135593.331,446890.397],[\"9/480/556\",133593.331,445890.397,134593.331,446890.397],[\"9/480/552\",133593.331,444890.397,134593.331,445890.397],[\"9/480/548\",133593.331,443890.397,134593.331,444890.397],[\"9/480/544\",133593.331,442890.397,134593.331,443890.397],[\"9/484/548\",134593.331,443890.397,135593.331,444890.397],[\"9/488/548\",135593.331,443890.397,136593.331,444890.397],[\"9/488/544\",135593.331,442890.397,136593.331,443890.397],[\"9/484/544\",134593.331,442890.397,135593.331,443890.397],[\"7/480/528\",133593.331,438890.397,137593.331,442890.397],[\"7/480/512\",133593.331,434890.397,137593.331,438890.397],[\"9/480/508\",133593.331,433890.397,134593.331,434890.397],[\"9/480/504\",133593.331,432890.397,134593.331,433890.397],[\"9/484/504\",134593.331,432890.397,135593.331,433890.397],[\"9/484/508\",134593.331,433890.397,135593.331,434890.397],[\"8/488/504\",135593.331,432890.397,137593.331,434890.397],[\"8/496/504\",137593.331,432890.397,139593.331,434890.397],[\"7/496/512\",137593.331,434890.397,141593.331,438890.397],[\"7/512/512\",141593.331,434890.397,145593.331,438890.397],[\"7/512/496\",141593.331,430890.397,145593.331,434890.397],[\"8/504/504\",139593.331,432890.397,141593.331,434890.397],[\"8/504/496\",139593.331,430890.397,141593.331,432890.397],[\"7/512/480\",141593.331,426890.397,145593.331,430890.397],[\"7/496/480\",137593.331,426890.397,141593.331,430890.397],[\"8/496/496\",137593.331,430890.397,139593.331,432890.397],[\"8/488/496\",135593.331,430890.397,137593.331,432890.397],[\"8/480/496\",133593.331,430890.397,135593.331,432890.397],[\"7/480/480\",133593.331,426890.397,137593.331,430890.397],[\"8/480/472\",133593.331,424890.397,135593.331,426890.397],[\"8/480/464\",133593.331,422890.397,135593.331,424890.397],[\"8/488/464\",135593.331,422890.397,137593.331,424890.397],[\"8/488/472\",135593.331,424890.397,137593.331,426890.397],[\"7/496/464\",137593.331,422890.397,141593.331,426890.397],[\"8/512/472\",141593.331,424890.397,143593.331,426890.397],[\"8/512/464\",141593.331,422890.397,143593.331,424890.397],[\"7/496/448\",137593.331,418890.397,141593.331,422890.397],[\"7/512/448\",141593.331,418890.397,145593.331,422890.397],[\"8/512/440\",141593.331,416890.397,143593.331,418890.397],[\"8/488/440\",135593.331,416890.397,137593.331,418890.397],[\"8/488/456\",135593.331,420890.397,137593.331,422890.397],[\"8/488/448\",135593.331,418890.397,137593.331,420890.397],[\"8/480/456\",133593.331,420890.397,135593.331,422890.397],[\"8/480/448\",133593.331,418890.397,135593.331,420890.397],[\"8/480/440\",133593.331,416890.397,135593.331,418890.397],[\"8/480/432\",133593.331,414890.397,135593.331,416890.397],[\"8/488/432\",135593.331,414890.397,137593.331,416890.397],[\"8/488/424\",135593.331,412890.397,137593.331,414890.397],[\"8/496/424\",137593.331,412890.397,139593.331,414890.397],[\"9/496/420\",137593.331,411890.397,138593.331,412890.397],[\"9/492/420\",136593.331,411890.397,137593.331,412890.397],[\"9/488/420\",135593.331,411890.397,136593.331,412890.397],[\"9/484/420\",134593.331,411890.397,135593.331,412890.397],[\"8/480/424\",133593.331,412890.397,135593.331,414890.397],[\"9/480/420\",133593.331,411890.397,134593.331,412890.397],[\"9/480/416\",133593.331,410890.397,134593.331,411890.397],[\"9/484/416\",134593.331,410890.397,135593.331,411890.397],[\"9/488/416\",135593.331,410890.397,136593.331,411890.397],[\"9/488/412\",135593.331,409890.397,136593.331,410890.397],[\"8/480/408\",133593.331,408890.397,135593.331,410890.397],[\"8/480/400\",133593.331,406890.397,135593.331,408890.397],[\"9/488/408\",135593.331,408890.397,136593.331,409890.397],[\"9/492/408\",136593.331,408890.397,137593.331,409890.397],[\"8/488/400\",135593.331,406890.397,137593.331,408890.397],[\"8/496/400\",137593.331,406890.397,139593.331,408890.397],[\"8/496/408\",137593.331,408890.397,139593.331,410890.397],[\"10/492/414\",136593.331,410390.397,137093.331,410890.397],[\"10/492/412\",136593.331,409890.397,137093.331,410390.397],[\"10/494/412\",137093.331,409890.397,137593.331,410390.397],[\"10/494/414\",137093.331,410390.397,137593.331,410890.397],[\"9/492/416\",136593.331,410890.397,137593.331,411890.397],[\"9/496/416\",137593.331,410890.397,138593.331,411890.397],[\"9/500/416\",138593.331,410890.397,139593.331,411890.397],[\"8/504/416\",139593.331,410890.397,141593.331,412890.397],[\"8/504/408\",139593.331,408890.397,141593.331,410890.397],[\"8/504/400\",139593.331,406890.397,141593.331,408890.397],[\"7/512/400\",141593.331,406890.397,145593.331,410890.397],[\"9/512/416\",141593.331,410890.397,142593.331,411890.397],[\"9/516/416\",142593.331,410890.397,143593.331,411890.397],[\"9/516/420\",142593.331,411890.397,143593.331,412890.397],[\"8/512/424\",141593.331,412890.397,143593.331,414890.397],[\"9/512/420\",141593.331,411890.397,142593.331,412890.397],[\"9/500/420\",138593.331,411890.397,139593.331,412890.397],[\"8/504/424\",139593.331,412890.397,141593.331,414890.397],[\"7/496/432\",137593.331,414890.397,141593.331,418890.397],[\"8/512/432\",141593.331,414890.397,143593.331,416890.397],[\"8/520/432\",143593.331,414890.397,145593.331,416890.397],[\"8/528/432\",145593.331,414890.397,147593.331,416890.397],[\"9/536/436\",147593.331,415890.397,148593.331,416890.397],[\"9/536/432\",147593.331,414890.397,148593.331,415890.397],[\"8/528/424\",145593.331,412890.397,147593.331,414890.397],[\"8/536/424\",147593.331,412890.397,149593.331,414890.397],[\"9/536/420\",147593.331,411890.397,148593.331,412890.397],[\"9/532/420\",146593.331,411890.397,147593.331,412890.397],[\"9/528/420\",145593.331,411890.397,146593.331,412890.397],[\"8/520/424\",143593.331,412890.397,145593.331,414890.397],[\"8/520/416\",143593.331,410890.397,145593.331,412890.397],[\"9/528/416\",145593.331,410890.397,146593.331,411890.397],[\"8/528/400\",145593.331,406890.397,147593.331,408890.397],[\"9/536/400\",147593.331,406890.397,148593.331,407890.397],[\"9/536/404\",147593.331,407890.397,148593.331,408890.397],[\"9/536/408\",147593.331,408890.397,148593.331,409890.397],[\"9/536/412\",147593.331,409890.397,148593.331,410890.397],[\"8/528/408\",145593.331,408890.397,147593.331,410890.397],[\"9/532/416\",146593.331,410890.397,147593.331,411890.397],[\"9/536/416\",147593.331,410890.397,148593.331,411890.397],[\"10/540/418\",148593.331,411390.397,149093.331,411890.397],[\"10/540/416\",148593.331,410890.397,149093.331,411390.397],[\"10/542/416\",149093.331,410890.397,149593.331,411390.397],[\"10/544/416\",149593.331,410890.397,150093.331,411390.397],[\"10/542/418\",149093.331,411390.397,149593.331,411890.397],[\"10/544/418\",149593.331,411390.397,150093.331,411890.397],[\"10/546/418\",150093.331,411390.397,150593.331,411890.397],[\"10/548/418\",150593.331,411390.397,151093.331,411890.397],[\"10/548/416\",150593.331,410890.397,151093.331,411390.397],[\"10/546/416\",150093.331,410890.397,150593.331,411390.397],[\"9/544/412\",149593.331,409890.397,150593.331,410890.397],[\"9/548/412\",150593.331,409890.397,151593.331,410890.397],[\"9/540/412\",148593.331,409890.397,149593.331,410890.397],[\"9/540/408\",148593.331,408890.397,149593.331,409890.397],[\"9/540/404\",148593.331,407890.397,149593.331,408890.397],[\"9/540/400\",148593.331,406890.397,149593.331,407890.397],[\"8/544/400\",149593.331,406890.397,151593.331,408890.397],[\"9/544/408\",149593.331,408890.397,150593.331,409890.397],[\"9/548/408\",150593.331,408890.397,151593.331,409890.397],[\"8/552/400\",151593.331,406890.397,153593.331,408890.397],[\"8/552/408\",151593.331,408890.397,153593.331,410890.397],[\"10/550/416\",151093.331,410890.397,151593.331,411390.397],[\"10/550/418\",151093.331,411390.397,151593.331,411890.397],[\"8/552/416\",151593.331,410890.397,153593.331,412890.397],[\"9/556/424\",152593.331,412890.397,153593.331,413890.397],[\"10/558/428\",153093.331,413890.397,153593.331,414390.397],[\"10/556/428\",152593.331,413890.397,153093.331,414390.397],[\"9/552/424\",151593.331,412890.397,152593.331,413890.397],[\"9/552/428\",151593.331,413890.397,152593.331,414890.397],[\"9/548/420\",150593.331,411890.397,151593.331,412890.397],[\"9/544/420\",149593.331,411890.397,150593.331,412890.397],[\"9/540/420\",148593.331,411890.397,149593.331,412890.397],[\"9/544/428\",149593.331,413890.397,150593.331,414890.397],[\"9/544/424\",149593.331,412890.397,150593.331,413890.397],[\"9/548/424\",150593.331,412890.397,151593.331,413890.397],[\"9/548/428\",150593.331,413890.397,151593.331,414890.397],[\"9/548/432\",150593.331,414890.397,151593.331,415890.397],[\"9/544/432\",149593.331,414890.397,150593.331,415890.397],[\"10/540/432\",148593.331,414890.397,149093.331,415390.397],[\"10/540/434\",148593.331,415390.397,149093.331,415890.397],[\"10/542/434\",149093.331,415390.397,149593.331,415890.397],[\"10/542/432\",149093.331,414890.397,149593.331,415390.397],[\"9/540/436\",148593.331,415890.397,149593.331,416890.397],[\"9/544/436\",149593.331,415890.397,150593.331,416890.397],[\"9/548/436\",150593.331,415890.397,151593.331,416890.397],[\"9/552/436\",151593.331,415890.397,152593.331,416890.397],[\"9/552/432\",151593.331,414890.397,152593.331,415890.397],[\"10/556/430\",152593.331,414390.397,153093.331,414890.397],[\"10/558/430\",153093.331,414390.397,153593.331,414890.397],[\"9/556/432\",152593.331,414890.397,153593.331,415890.397],[\"9/556/436\",152593.331,415890.397,153593.331,416890.397],[\"8/552/440\",151593.331,416890.397,153593.331,418890.397],[\"8/552/448\",151593.331,418890.397,153593.331,420890.397],[\"8/552/456\",151593.331,420890.397,153593.331,422890.397],[\"9/544/452\",149593.331,419890.397,150593.331,420890.397],[\"9/548/452\",150593.331,419890.397,151593.331,420890.397],[\"8/544/456\",149593.331,420890.397,151593.331,422890.397],[\"9/544/448\",149593.331,418890.397,150593.331,419890.397],[\"9/548/448\",150593.331,418890.397,151593.331,419890.397],[\"8/544/440\",149593.331,416890.397,151593.331,418890.397],[\"8/536/440\",147593.331,416890.397,149593.331,418890.397],[\"9/532/444\",146593.331,417890.397,147593.331,418890.397],[\"9/532/440\",146593.331,416890.397,147593.331,417890.397],[\"9/528/440\",145593.331,416890.397,146593.331,417890.397],[\"8/520/440\",143593.331,416890.397,145593.331,418890.397],[\"9/528/444\",145593.331,417890.397,146593.331,418890.397],[\"7/528/448\",145593.331,418890.397,149593.331,422890.397],[\"8/536/464\",147593.331,422890.397,149593.331,424890.397],[\"8/528/464\",145593.331,422890.397,147593.331,424890.397],[\"9/520/464\",143593.331,422890.397,144593.331,423890.397],[\"9/520/468\",143593.331,423890.397,144593.331,424890.397],[\"9/524/468\",144593.331,423890.397,145593.331,424890.397],[\"9/524/464\",144593.331,422890.397,145593.331,423890.397],[\"8/520/472\",143593.331,424890.397,145593.331,426890.397],[\"8/528/472\",145593.331,424890.397,147593.331,426890.397],[\"8/536/472\",147593.331,424890.397,149593.331,426890.397],[\"8/544/472\",149593.331,424890.397,151593.331,426890.397],[\"8/544/464\",149593.331,422890.397,151593.331,424890.397],[\"8/552/464\",151593.331,422890.397,153593.331,424890.397],[\"8/552/472\",151593.331,424890.397,153593.331,426890.397],[\"7/560/464\",153593.331,422890.397,157593.331,426890.397],[\"8/576/472\",157593.331,424890.397,159593.331,426890.397],[\"8/576/464\",157593.331,422890.397,159593.331,424890.397],[\"7/560/448\",153593.331,418890.397,157593.331,422890.397],[\"8/560/440\",153593.331,416890.397,155593.331,418890.397],[\"8/568/440\",155593.331,416890.397,157593.331,418890.397],[\"8/576/440\",157593.331,416890.397,159593.331,418890.397],[\"7/576/448\",157593.331,418890.397,161593.331,422890.397],[\"8/584/440\",159593.331,416890.397,161593.331,418890.397],[\"9/592/448\",161593.331,418890.397,162593.331,419890.397],[\"9/592/444\",161593.331,417890.397,162593.331,418890.397],[\"9/592/440\",161593.331,416890.397,162593.331,417890.397],[\"9/596/440\",162593.331,416890.397,163593.331,417890.397],[\"9/596/444\",162593.331,417890.397,163593.331,418890.397],[\"10/596/448\",162593.331,418890.397,163093.331,419390.397],[\"10/598/448\",163093.331,418890.397,163593.331,419390.397],[\"10/598/450\",163093.331,419390.397,163593.331,419890.397],[\"10/598/452\",163093.331,419890.397,163593.331,420390.397],[\"10/598/454\",163093.331,420390.397,163593.331,420890.397],[\"10/596/452\",162593.331,419890.397,163093.331,420390.397],[\"10/596/454\",162593.331,420390.397,163093.331,420890.397],[\"10/596/450\",162593.331,419390.397,163093.331,419890.397],[\"9/592/452\",161593.331,419890.397,162593.331,420890.397],[\"8/592/456\",161593.331,420890.397,163593.331,422890.397],[\"8/584/464\",159593.331,422890.397,161593.331,424890.397],[\"8/584/472\",159593.331,424890.397,161593.331,426890.397],[\"7/592/464\",161593.331,422890.397,165593.331,426890.397],[\"7/608/464\",165593.331,422890.397,169593.331,426890.397],[\"7/624/464\",169593.331,422890.397,173593.331,426890.397],[\"9/620/452\",168593.331,419890.397,169593.331,420890.397],[\"8/624/448\",169593.331,418890.397,171593.331,420890.397],[\"8/624/456\",169593.331,420890.397,171593.331,422890.397],[\"8/632/456\",171593.331,420890.397,173593.331,422890.397],[\"8/632/448\",171593.331,418890.397,173593.331,420890.397],[\"9/632/444\",171593.331,417890.397,172593.331,418890.397],[\"9/636/444\",172593.331,417890.397,173593.331,418890.397],[\"9/636/440\",172593.331,416890.397,173593.331,417890.397],[\"9/632/440\",171593.331,416890.397,172593.331,417890.397],[\"8/624/440\",169593.331,416890.397,171593.331,418890.397],[\"9/620/448\",168593.331,418890.397,169593.331,419890.397],[\"9/612/448\",166593.331,418890.397,167593.331,419890.397],[\"9/616/448\",167593.331,418890.397,168593.331,419890.397],[\"9/616/452\",167593.331,419890.397,168593.331,420890.397],[\"8/616/456\",167593.331,420890.397,169593.331,422890.397],[\"8/608/456\",165593.331,420890.397,167593.331,422890.397],[\"9/612/452\",166593.331,419890.397,167593.331,420890.397],[\"9/604/452\",164593.331,419890.397,165593.331,420890.397],[\"9/608/452\",165593.331,419890.397,166593.331,420890.397],[\"8/600/456\",163593.331,420890.397,165593.331,422890.397],[\"10/600/454\",163593.331,420390.397,164093.331,420890.397],[\"10/600/452\",163593.331,419890.397,164093.331,420390.397],[\"10/602/454\",164093.331,420390.397,164593.331,420890.397],[\"10/602/452\",164093.331,419890.397,164593.331,420390.397],[\"9/600/448\",163593.331,418890.397,164593.331,419890.397],[\"9/600/444\",163593.331,417890.397,164593.331,418890.397],[\"9/604/448\",164593.331,418890.397,165593.331,419890.397],[\"9/608/448\",165593.331,418890.397,166593.331,419890.397],[\"9/604/444\",164593.331,417890.397,165593.331,418890.397],[\"9/604/440\",164593.331,416890.397,165593.331,417890.397],[\"9/600/440\",163593.331,416890.397,164593.331,417890.397],[\"9/600/436\",163593.331,415890.397,164593.331,416890.397],[\"9/604/436\",164593.331,415890.397,165593.331,416890.397],[\"9/604/432\",164593.331,414890.397,165593.331,415890.397],[\"9/600/432\",163593.331,414890.397,164593.331,415890.397],[\"8/608/424\",165593.331,412890.397,167593.331,414890.397],[\"8/616/424\",167593.331,412890.397,169593.331,414890.397],[\"7/608/432\",165593.331,414890.397,169593.331,418890.397],[\"8/624/432\",169593.331,414890.397,171593.331,416890.397],[\"8/632/432\",171593.331,414890.397,173593.331,416890.397],[\"7/624/416\",169593.331,410890.397,173593.331,414890.397],[\"8/624/408\",169593.331,408890.397,171593.331,410890.397],[\"8/632/408\",171593.331,408890.397,173593.331,410890.397],[\"9/632/404\",171593.331,407890.397,172593.331,408890.397],[\"9/636/404\",172593.331,407890.397,173593.331,408890.397],[\"9/636/400\",172593.331,406890.397,173593.331,407890.397],[\"9/632/400\",171593.331,406890.397,172593.331,407890.397],[\"9/628/400\",170593.331,406890.397,171593.331,407890.397],[\"9/624/400\",169593.331,406890.397,170593.331,407890.397],[\"9/628/404\",170593.331,407890.397,171593.331,408890.397],[\"9/624/404\",169593.331,407890.397,170593.331,408890.397],[\"7/608/400\",165593.331,406890.397,169593.331,410890.397],[\"8/616/416\",167593.331,410890.397,169593.331,412890.397],[\"8/608/416\",165593.331,410890.397,167593.331,412890.397],[\"7/592/400\",161593.331,406890.397,165593.331,410890.397],[\"8/584/400\",159593.331,406890.397,161593.331,408890.397],[\"8/584/408\",159593.331,408890.397,161593.331,410890.397],[\"7/592/416\",161593.331,410890.397,165593.331,414890.397],[\"8/592/432\",161593.331,414890.397,163593.331,416890.397],[\"8/584/432\",159593.331,414890.397,161593.331,416890.397],[\"9/580/436\",158593.331,415890.397,159593.331,416890.397],[\"9/580/432\",158593.331,414890.397,159593.331,415890.397],[\"7/576/416\",157593.331,410890.397,161593.331,414890.397],[\"8/568/424\",155593.331,412890.397,157593.331,414890.397],[\"9/576/432\",157593.331,414890.397,158593.331,415890.397],[\"9/576/436\",157593.331,415890.397,158593.331,416890.397],[\"8/568/432\",155593.331,414890.397,157593.331,416890.397],[\"8/560/432\",153593.331,414890.397,155593.331,416890.397],[\"9/560/428\",153593.331,413890.397,154593.331,414890.397],[\"9/560/424\",153593.331,412890.397,154593.331,413890.397],[\"9/564/428\",154593.331,413890.397,155593.331,414890.397],[\"9/564/424\",154593.331,412890.397,155593.331,413890.397],[\"8/560/416\",153593.331,410890.397,155593.331,412890.397],[\"8/560/408\",153593.331,408890.397,155593.331,410890.397],[\"9/568/412\",155593.331,409890.397,156593.331,410890.397],[\"8/568/416\",155593.331,410890.397,157593.331,412890.397],[\"8/576/408\",157593.331,408890.397,159593.331,410890.397],[\"9/572/412\",156593.331,409890.397,157593.331,410890.397],[\"9/572/408\",156593.331,408890.397,157593.331,409890.397],[\"8/576/400\",157593.331,406890.397,159593.331,408890.397],[\"8/568/400\",155593.331,406890.397,157593.331,408890.397],[\"9/564/400\",154593.331,406890.397,155593.331,407890.397],[\"9/568/408\",155593.331,408890.397,156593.331,409890.397],[\"9/564/404\",154593.331,407890.397,155593.331,408890.397],[\"9/560/404\",153593.331,407890.397,154593.331,408890.397],[\"9/560/400\",153593.331,406890.397,154593.331,407890.397],[\"8/560/392\",153593.331,404890.397,155593.331,406890.397],[\"8/568/392\",155593.331,404890.397,157593.331,406890.397],[\"8/576/392\",157593.331,404890.397,159593.331,406890.397],[\"10/574/390\",157093.331,404390.397,157593.331,404890.397],[\"10/572/390\",156593.331,404390.397,157093.331,404890.397],[\"9/572/384\",156593.331,402890.397,157593.331,403890.397],[\"10/572/388\",156593.331,403890.397,157093.331,404390.397],[\"10/574/388\",157093.331,403890.397,157593.331,404390.397],[\"9/576/388\",157593.331,403890.397,158593.331,404890.397],[\"9/576/384\",157593.331,402890.397,158593.331,403890.397],[\"9/576/380\",157593.331,401890.397,158593.331,402890.397],[\"9/568/384\",155593.331,402890.397,156593.331,403890.397],[\"9/568/388\",155593.331,403890.397,156593.331,404890.397],[\"8/560/384\",153593.331,402890.397,155593.331,404890.397],[\"7/560/368\",153593.331,398890.397,157593.331,402890.397],[\"8/560/360\",153593.331,396890.397,155593.331,398890.397],[\"8/568/360\",155593.331,396890.397,157593.331,398890.397],[\"8/576/360\",157593.331,396890.397,159593.331,398890.397],[\"8/576/368\",157593.331,398890.397,159593.331,400890.397],[\"9/576/376\",157593.331,400890.397,158593.331,401890.397],[\"9/580/376\",158593.331,400890.397,159593.331,401890.397],[\"8/584/376\",159593.331,400890.397,161593.331,402890.397],[\"8/584/368\",159593.331,398890.397,161593.331,400890.397],[\"9/584/360\",159593.331,396890.397,160593.331,397890.397],[\"9/588/360\",160593.331,396890.397,161593.331,397890.397],[\"9/588/364\",160593.331,397890.397,161593.331,398890.397],[\"9/584/364\",159593.331,397890.397,160593.331,398890.397],[\"8/592/368\",161593.331,398890.397,163593.331,400890.397],[\"8/592/376\",161593.331,400890.397,163593.331,402890.397],[\"8/592/384\",161593.331,402890.397,163593.331,404890.397],[\"9/580/380\",158593.331,401890.397,159593.331,402890.397],[\"9/580/384\",158593.331,402890.397,159593.331,403890.397],[\"9/580/388\",158593.331,403890.397,159593.331,404890.397],[\"8/584/384\",159593.331,402890.397,161593.331,404890.397],[\"8/584/392\",159593.331,404890.397,161593.331,406890.397],[\"8/592/392\",161593.331,404890.397,163593.331,406890.397],[\"8/600/392\",163593.331,404890.397,165593.331,406890.397],[\"8/600/384\",163593.331,402890.397,165593.331,404890.397],[\"9/608/380\",165593.331,401890.397,166593.331,402890.397],[\"9/608/384\",165593.331,402890.397,166593.331,403890.397],[\"9/608/388\",165593.331,403890.397,166593.331,404890.397],[\"9/612/388\",166593.331,403890.397,167593.331,404890.397],[\"9/612/384\",166593.331,402890.397,167593.331,403890.397],[\"9/612/380\",166593.331,401890.397,167593.331,402890.397],[\"8/616/384\",167593.331,402890.397,169593.331,404890.397],[\"8/608/392\",165593.331,404890.397,167593.331,406890.397],[\"8/616/392\",167593.331,404890.397,169593.331,406890.397],[\"9/624/392\",169593.331,404890.397,170593.331,405890.397],[\"9/628/392\",170593.331,404890.397,171593.331,405890.397],[\"9/624/396\",169593.331,405890.397,170593.331,406890.397],[\"9/628/396\",170593.331,405890.397,171593.331,406890.397],[\"9/632/396\",171593.331,405890.397,172593.331,406890.397],[\"9/636/396\",172593.331,405890.397,173593.331,406890.397],[\"9/636/392\",172593.331,404890.397,173593.331,405890.397],[\"9/632/392\",171593.331,404890.397,172593.331,405890.397],[\"8/632/384\",171593.331,402890.397,173593.331,404890.397],[\"8/624/384\",169593.331,402890.397,171593.331,404890.397],[\"8/624/368\",169593.331,398890.397,171593.331,400890.397],[\"8/624/376\",169593.331,400890.397,171593.331,402890.397],[\"8/632/376\",171593.331,400890.397,173593.331,402890.397],[\"8/632/368\",171593.331,398890.397,173593.331,400890.397],[\"8/616/368\",167593.331,398890.397,169593.331,400890.397],[\"8/616/376\",167593.331,400890.397,169593.331,402890.397],[\"9/612/376\",166593.331,400890.397,167593.331,401890.397],[\"8/608/368\",165593.331,398890.397,167593.331,400890.397],[\"9/608/376\",165593.331,400890.397,166593.331,401890.397],[\"8/600/376\",163593.331,400890.397,165593.331,402890.397],[\"8/600/368\",163593.331,398890.397,165593.331,400890.397],[\"8/600/344\",163593.331,392890.397,165593.331,394890.397],[\"8/608/344\",165593.331,392890.397,167593.331,394890.397],[\"8/616/344\",167593.331,392890.397,169593.331,394890.397],[\"7/608/352\",165593.331,394890.397,169593.331,398890.397],[\"7/624/352\",169593.331,394890.397,173593.331,398890.397],[\"9/632/344\",171593.331,392890.397,172593.331,393890.397],[\"9/632/348\",171593.331,393890.397,172593.331,394890.397],[\"9/636/348\",172593.331,393890.397,173593.331,394890.397],[\"9/636/344\",172593.331,392890.397,173593.331,393890.397],[\"9/636/340\",172593.331,391890.397,173593.331,392890.397],[\"9/632/340\",171593.331,391890.397,172593.331,392890.397],[\"8/624/344\",169593.331,392890.397,171593.331,394890.397],[\"8/624/328\",169593.331,388890.397,171593.331,390890.397],[\"8/624/336\",169593.331,390890.397,171593.331,392890.397],[\"9/632/336\",171593.331,390890.397,172593.331,391890.397],[\"9/636/336\",172593.331,390890.397,173593.331,391890.397],[\"8/632/328\",171593.331,388890.397,173593.331,390890.397],[\"9/632/324\",171593.331,387890.397,172593.331,388890.397],[\"9/636/324\",172593.331,387890.397,173593.331,388890.397],[\"9/636/320\",172593.331,386890.397,173593.331,387890.397],[\"9/632/320\",171593.331,386890.397,172593.331,387890.397],[\"9/628/320\",170593.331,386890.397,171593.331,387890.397],[\"9/624/320\",169593.331,386890.397,170593.331,387890.397],[\"9/628/324\",170593.331,387890.397,171593.331,388890.397],[\"9/624/324\",169593.331,387890.397,170593.331,388890.397],[\"8/616/320\",167593.331,386890.397,169593.331,388890.397],[\"9/612/320\",166593.331,386890.397,167593.331,387890.397],[\"9/612/324\",166593.331,387890.397,167593.331,388890.397],[\"8/616/328\",167593.331,388890.397,169593.331,390890.397],[\"8/616/336\",167593.331,390890.397,169593.331,392890.397],[\"8/608/336\",165593.331,390890.397,167593.331,392890.397],[\"8/608/328\",165593.331,388890.397,167593.331,390890.397],[\"8/600/336\",163593.331,390890.397,165593.331,392890.397],[\"8/600/328\",163593.331,388890.397,165593.331,390890.397],[\"9/608/324\",165593.331,387890.397,166593.331,388890.397],[\"9/608/320\",165593.331,386890.397,166593.331,387890.397],[\"8/600/320\",163593.331,386890.397,165593.331,388890.397],[\"9/596/320\",162593.331,386890.397,163593.331,387890.397],[\"9/596/324\",162593.331,387890.397,163593.331,388890.397],[\"9/592/324\",161593.331,387890.397,162593.331,388890.397],[\"9/592/320\",161593.331,386890.397,162593.331,387890.397],[\"9/588/320\",160593.331,386890.397,161593.331,387890.397],[\"9/584/320\",159593.331,386890.397,160593.331,387890.397],[\"9/580/320\",158593.331,386890.397,159593.331,387890.397],[\"10/580/324\",158593.331,387890.397,159093.331,388390.397],[\"10/582/324\",159093.331,387890.397,159593.331,388390.397],[\"10/582/326\",159093.331,388390.397,159593.331,388890.397],[\"10/580/326\",158593.331,388390.397,159093.331,388890.397],[\"9/584/328\",159593.331,388890.397,160593.331,389890.397],[\"9/584/324\",159593.331,387890.397,160593.331,388890.397],[\"9/588/324\",160593.331,387890.397,161593.331,388890.397],[\"9/588/328\",160593.331,388890.397,161593.331,389890.397],[\"9/588/332\",160593.331,389890.397,161593.331,390890.397],[\"9/584/332\",159593.331,389890.397,160593.331,390890.397],[\"8/584/336\",159593.331,390890.397,161593.331,392890.397],[\"9/592/336\",161593.331,390890.397,162593.331,391890.397],[\"8/592/328\",161593.331,388890.397,163593.331,390890.397],[\"9/596/336\",162593.331,390890.397,163593.331,391890.397],[\"9/596/340\",162593.331,391890.397,163593.331,392890.397],[\"9/592/340\",161593.331,391890.397,162593.331,392890.397],[\"8/592/344\",161593.331,392890.397,163593.331,394890.397],[\"7/592/352\",161593.331,394890.397,165593.331,398890.397],[\"8/584/352\",159593.331,394890.397,161593.331,396890.397],[\"8/584/344\",159593.331,392890.397,161593.331,394890.397],[\"8/568/344\",155593.331,392890.397,157593.331,394890.397],[\"8/576/344\",157593.331,392890.397,159593.331,394890.397],[\"8/576/352\",157593.331,394890.397,159593.331,396890.397],[\"8/568/352\",155593.331,394890.397,157593.331,396890.397],[\"8/560/352\",153593.331,394890.397,155593.331,396890.397],[\"8/560/344\",153593.331,392890.397,155593.331,394890.397],[\"9/564/340\",154593.331,391890.397,155593.331,392890.397],[\"9/560/340\",153593.331,391890.397,154593.331,392890.397],[\"9/560/336\",153593.331,390890.397,154593.331,391890.397],[\"10/564/338\",154593.331,391390.397,155093.331,391890.397],[\"10/564/336\",154593.331,390890.397,155093.331,391390.397],[\"9/560/332\",153593.331,389890.397,154593.331,390890.397],[\"9/564/332\",154593.331,389890.397,155593.331,390890.397],[\"10/566/336\",155093.331,390890.397,155593.331,391390.397],[\"10/566/338\",155093.331,391390.397,155593.331,391890.397],[\"8/568/336\",155593.331,390890.397,157593.331,392890.397],[\"8/576/336\",157593.331,390890.397,159593.331,392890.397],[\"8/576/328\",157593.331,388890.397,159593.331,390890.397],[\"8/568/328\",155593.331,388890.397,157593.331,390890.397],[\"9/576/324\",157593.331,387890.397,158593.331,388890.397],[\"9/576/320\",157593.331,386890.397,158593.331,387890.397],[\"8/568/320\",155593.331,386890.397,157593.331,388890.397],[\"9/564/328\",154593.331,388890.397,155593.331,389890.397],[\"9/560/328\",153593.331,388890.397,154593.331,389890.397],[\"8/560/320\",153593.331,386890.397,155593.331,388890.397],[\"8/552/320\",151593.331,386890.397,153593.331,388890.397],[\"8/552/328\",151593.331,388890.397,153593.331,390890.397],[\"8/552/336\",151593.331,390890.397,153593.331,392890.397],[\"8/544/328\",149593.331,388890.397,151593.331,390890.397],[\"8/544/336\",149593.331,390890.397,151593.331,392890.397],[\"8/544/320\",149593.331,386890.397,151593.331,388890.397],[\"7/528/320\",145593.331,386890.397,149593.331,390890.397],[\"7/528/336\",145593.331,390890.397,149593.331,394890.397],[\"8/520/352\",143593.331,394890.397,145593.331,396890.397],[\"7/528/352\",145593.331,394890.397,149593.331,398890.397],[\"8/544/344\",149593.331,392890.397,151593.331,394890.397],[\"8/552/344\",151593.331,392890.397,153593.331,394890.397],[\"7/544/352\",149593.331,394890.397,153593.331,398890.397],[\"9/556/368\",152593.331,398890.397,153593.331,399890.397],[\"9/552/368\",151593.331,398890.397,152593.331,399890.397],[\"9/544/368\",149593.331,398890.397,150593.331,399890.397],[\"9/548/368\",150593.331,398890.397,151593.331,399890.397],[\"9/548/372\",150593.331,399890.397,151593.331,400890.397],[\"9/544/372\",149593.331,399890.397,150593.331,400890.397],[\"8/544/376\",149593.331,400890.397,151593.331,402890.397],[\"9/552/372\",151593.331,399890.397,152593.331,400890.397],[\"9/556/372\",152593.331,399890.397,153593.331,400890.397],[\"8/552/376\",151593.331,400890.397,153593.331,402890.397],[\"8/552/384\",151593.331,402890.397,153593.331,404890.397],[\"9/556/392\",152593.331,404890.397,153593.331,405890.397],[\"9/556/396\",152593.331,405890.397,153593.331,406890.397],[\"9/552/396\",151593.331,405890.397,152593.331,406890.397],[\"9/552/392\",151593.331,404890.397,152593.331,405890.397],[\"8/544/392\",149593.331,404890.397,151593.331,406890.397],[\"9/540/396\",148593.331,405890.397,149593.331,406890.397],[\"9/540/392\",148593.331,404890.397,149593.331,405890.397],[\"8/544/384\",149593.331,402890.397,151593.331,404890.397],[\"8/528/384\",145593.331,402890.397,147593.331,404890.397],[\"8/536/384\",147593.331,402890.397,149593.331,404890.397],[\"9/536/392\",147593.331,404890.397,148593.331,405890.397],[\"9/536/396\",147593.331,405890.397,148593.331,406890.397],[\"8/528/392\",145593.331,404890.397,147593.331,406890.397],[\"8/520/392\",143593.331,404890.397,145593.331,406890.397],[\"8/520/384\",143593.331,402890.397,145593.331,404890.397],[\"8/520/376\",143593.331,400890.397,145593.331,402890.397],[\"8/520/368\",143593.331,398890.397,145593.331,400890.397],[\"7/528/368\",145593.331,398890.397,149593.331,402890.397],[\"8/520/360\",143593.331,396890.397,145593.331,398890.397],[\"8/512/360\",141593.331,396890.397,143593.331,398890.397],[\"9/516/368\",142593.331,398890.397,143593.331,399890.397],[\"9/512/368\",141593.331,398890.397,142593.331,399890.397],[\"9/508/360\",140593.331,396890.397,141593.331,397890.397],[\"9/504/360\",139593.331,396890.397,140593.331,397890.397],[\"9/500/368\",138593.331,398890.397,139593.331,399890.397],[\"9/504/368\",139593.331,398890.397,140593.331,399890.397],[\"9/504/364\",139593.331,397890.397,140593.331,398890.397],[\"9/508/364\",140593.331,397890.397,141593.331,398890.397],[\"9/508/368\",140593.331,398890.397,141593.331,399890.397],[\"9/508/372\",140593.331,399890.397,141593.331,400890.397],[\"9/504/372\",139593.331,399890.397,140593.331,400890.397],[\"9/500/372\",138593.331,399890.397,139593.331,400890.397],[\"9/500/376\",138593.331,400890.397,139593.331,401890.397],[\"8/504/376\",139593.331,400890.397,141593.331,402890.397],[\"9/512/372\",141593.331,399890.397,142593.331,400890.397],[\"9/516/372\",142593.331,399890.397,143593.331,400890.397],[\"8/512/376\",141593.331,400890.397,143593.331,402890.397],[\"8/512/384\",141593.331,402890.397,143593.331,404890.397],[\"8/512/392\",141593.331,404890.397,143593.331,406890.397],[\"7/496/384\",137593.331,402890.397,141593.331,406890.397],[\"9/500/380\",138593.331,401890.397,139593.331,402890.397],[\"9/496/380\",137593.331,401890.397,138593.331,402890.397],[\"7/480/384\",133593.331,402890.397,137593.331,406890.397],[\"8/480/376\",133593.331,400890.397,135593.331,402890.397],[\"9/480/372\",133593.331,399890.397,134593.331,400890.397],[\"9/484/372\",134593.331,399890.397,135593.331,400890.397],[\"8/488/376\",135593.331,400890.397,137593.331,402890.397],[\"9/496/376\",137593.331,400890.397,138593.331,401890.397],[\"9/496/372\",137593.331,399890.397,138593.331,400890.397],[\"8/488/368\",135593.331,398890.397,137593.331,400890.397],[\"9/496/368\",137593.331,398890.397,138593.331,399890.397],[\"8/496/360\",137593.331,396890.397,139593.331,398890.397],[\"8/488/360\",135593.331,396890.397,137593.331,398890.397],[\"10/486/360\",135093.331,396890.397,135593.331,397390.397],[\"10/486/362\",135093.331,397390.397,135593.331,397890.397],[\"9/484/368\",134593.331,398890.397,135593.331,399890.397],[\"9/484/364\",134593.331,397890.397,135593.331,398890.397],[\"10/482/366\",134093.331,398390.397,134593.331,398890.397],[\"9/480/368\",133593.331,398890.397,134593.331,399890.397],[\"10/480/366\",133593.331,398390.397,134093.331,398890.397],[\"10/480/364\",133593.331,397890.397,134093.331,398390.397],[\"10/480/362\",133593.331,397390.397,134093.331,397890.397],[\"10/482/364\",134093.331,397890.397,134593.331,398390.397],[\"10/484/362\",134593.331,397390.397,135093.331,397890.397],[\"10/482/362\",134093.331,397390.397,134593.331,397890.397],[\"10/484/360\",134593.331,396890.397,135093.331,397390.397],[\"10/482/360\",134093.331,396890.397,134593.331,397390.397],[\"10/480/360\",133593.331,396890.397,134093.331,397390.397],[\"10/480/358\",133593.331,396390.397,134093.331,396890.397],[\"10/480/356\",133593.331,395890.397,134093.331,396390.397],[\"10/482/356\",134093.331,395890.397,134593.331,396390.397],[\"10/484/356\",134593.331,395890.397,135093.331,396390.397],[\"10/482/358\",134093.331,396390.397,134593.331,396890.397],[\"10/484/358\",134593.331,396390.397,135093.331,396890.397],[\"10/486/358\",135093.331,396390.397,135593.331,396890.397],[\"10/486/356\",135093.331,395890.397,135593.331,396390.397],[\"10/486/352\",135093.331,394890.397,135593.331,395390.397],[\"10/486/354\",135093.331,395390.397,135593.331,395890.397],[\"10/484/352\",134593.331,394890.397,135093.331,395390.397],[\"10/484/354\",134593.331,395390.397,135093.331,395890.397],[\"10/482/354\",134093.331,395390.397,134593.331,395890.397],[\"10/482/352\",134093.331,394890.397,134593.331,395390.397],[\"10/480/354\",133593.331,395390.397,134093.331,395890.397],[\"10/480/352\",133593.331,394890.397,134093.331,395390.397],[\"9/480/348\",133593.331,393890.397,134593.331,394890.397],[\"9/480/344\",133593.331,392890.397,134593.331,393890.397],[\"9/484/344\",134593.331,392890.397,135593.331,393890.397],[\"9/484/348\",134593.331,393890.397,135593.331,394890.397],[\"8/488/344\",135593.331,392890.397,137593.331,394890.397],[\"8/488/352\",135593.331,394890.397,137593.331,396890.397],[\"8/496/352\",137593.331,394890.397,139593.331,396890.397],[\"8/504/352\",139593.331,394890.397,141593.331,396890.397],[\"8/512/352\",141593.331,394890.397,143593.331,396890.397],[\"7/512/336\",141593.331,390890.397,145593.331,394890.397],[\"7/496/336\",137593.331,390890.397,141593.331,394890.397],[\"8/504/328\",139593.331,388890.397,141593.331,390890.397],[\"7/512/320\",141593.331,386890.397,145593.331,390890.397],[\"8/504/320\",139593.331,386890.397,141593.331,388890.397],[\"8/496/320\",137593.331,386890.397,139593.331,388890.397],[\"8/488/320\",135593.331,386890.397,137593.331,388890.397],[\"8/496/328\",137593.331,388890.397,139593.331,390890.397],[\"8/488/336\",135593.331,390890.397,137593.331,392890.397],[\"8/488/328\",135593.331,388890.397,137593.331,390890.397],[\"8/480/336\",133593.331,390890.397,135593.331,392890.397],[\"8/480/328\",133593.331,388890.397,135593.331,390890.397],[\"8/480/320\",133593.331,386890.397,135593.331,388890.397],[\"7/464/320\",129593.331,386890.397,133593.331,390890.397],[\"8/464/336\",129593.331,390890.397,131593.331,392890.397],[\"9/472/336\",131593.331,390890.397,132593.331,391890.397],[\"9/476/336\",132593.331,390890.397,133593.331,391890.397],[\"9/476/340\",132593.331,391890.397,133593.331,392890.397],[\"9/472/340\",131593.331,391890.397,132593.331,392890.397],[\"9/472/344\",131593.331,392890.397,132593.331,393890.397],[\"9/472/348\",131593.331,393890.397,132593.331,394890.397],[\"9/476/344\",132593.331,392890.397,133593.331,393890.397],[\"9/476/348\",132593.331,393890.397,133593.331,394890.397],[\"10/476/352\",132593.331,394890.397,133093.331,395390.397],[\"10/476/354\",132593.331,395390.397,133093.331,395890.397],[\"10/478/352\",133093.331,394890.397,133593.331,395390.397],[\"10/478/354\",133093.331,395390.397,133593.331,395890.397],[\"10/478/356\",133093.331,395890.397,133593.331,396390.397],[\"10/478/358\",133093.331,396390.397,133593.331,396890.397],[\"10/476/358\",132593.331,396390.397,133093.331,396890.397],[\"10/476/356\",132593.331,395890.397,133093.331,396390.397],[\"9/472/356\",131593.331,395890.397,132593.331,396890.397],[\"10/470/354\",131093.331,395390.397,131593.331,395890.397],[\"10/470/352\",131093.331,394890.397,131593.331,395390.397],[\"9/472/352\",131593.331,394890.397,132593.331,395890.397],[\"9/464/352\",129593.331,394890.397,130593.331,395890.397],[\"10/468/352\",130593.331,394890.397,131093.331,395390.397],[\"10/468/354\",130593.331,395390.397,131093.331,395890.397],[\"9/468/356\",130593.331,395890.397,131593.331,396890.397],[\"9/464/356\",129593.331,395890.397,130593.331,396890.397],[\"8/464/344\",129593.331,392890.397,131593.331,394890.397],[\"7/448/336\",125593.331,390890.397,129593.331,394890.397],[\"8/456/352\",127593.331,394890.397,129593.331,396890.397],[\"8/448/352\",125593.331,394890.397,127593.331,396890.397],[\"9/444/352\",124593.331,394890.397,125593.331,395890.397],[\"9/444/356\",124593.331,395890.397,125593.331,396890.397],[\"9/440/356\",123593.331,395890.397,124593.331,396890.397],[\"9/440/352\",123593.331,394890.397,124593.331,395890.397],[\"8/440/328\",123593.331,388890.397,125593.331,390890.397],[\"7/448/320\",125593.331,386890.397,129593.331,390890.397],[\"8/440/320\",123593.331,386890.397,125593.331,388890.397],[\"8/432/320\",121593.331,386890.397,123593.331,388890.397],[\"8/432/328\",121593.331,388890.397,123593.331,390890.397],[\"7/416/320\",117593.331,386890.397,121593.331,390890.397],[\"9/404/352\",114593.331,394890.397,115593.331,395890.397],[\"9/400/352\",113593.331,394890.397,114593.331,395890.397],[\"9/400/356\",113593.331,395890.397,114593.331,396890.397],[\"9/404/356\",114593.331,395890.397,115593.331,396890.397],[\"8/408/352\",115593.331,394890.397,117593.331,396890.397],[\"7/416/352\",117593.331,394890.397,121593.331,398890.397],[\"7/416/336\",117593.331,390890.397,121593.331,394890.397],[\"7/432/336\",121593.331,390890.397,125593.331,394890.397],[\"8/432/352\",121593.331,394890.397,123593.331,396890.397],[\"8/432/360\",121593.331,396890.397,123593.331,398890.397],[\"9/432/368\",121593.331,398890.397,122593.331,399890.397],[\"9/436/368\",122593.331,398890.397,123593.331,399890.397],[\"10/436/372\",122593.331,399890.397,123093.331,400390.397],[\"10/436/374\",122593.331,400390.397,123093.331,400890.397],[\"10/438/372\",123093.331,399890.397,123593.331,400390.397],[\"10/438/374\",123093.331,400390.397,123593.331,400890.397],[\"8/432/376\",121593.331,400890.397,123593.331,402890.397],[\"10/432/374\",121593.331,400390.397,122093.331,400890.397],[\"10/434/374\",122093.331,400390.397,122593.331,400890.397],[\"10/434/372\",122093.331,399890.397,122593.331,400390.397],[\"10/432/372\",121593.331,399890.397,122093.331,400390.397],[\"8/424/368\",119593.331,398890.397,121593.331,400890.397],[\"8/424/376\",119593.331,400890.397,121593.331,402890.397],[\"9/412/364\",116593.331,397890.397,117593.331,398890.397],[\"9/412/360\",116593.331,396890.397,117593.331,397890.397],[\"9/408/360\",115593.331,396890.397,116593.331,397890.397],[\"9/404/360\",114593.331,396890.397,115593.331,397890.397],[\"9/400/360\",113593.331,396890.397,114593.331,397890.397],[\"10/400/364\",113593.331,397890.397,114093.331,398390.397],[\"10/402/364\",114093.331,397890.397,114593.331,398390.397],[\"10/402/366\",114093.331,398390.397,114593.331,398890.397],[\"10/400/366\",113593.331,398390.397,114093.331,398890.397],[\"9/400/368\",113593.331,398890.397,114593.331,399890.397],[\"9/404/368\",114593.331,398890.397,115593.331,399890.397],[\"9/404/364\",114593.331,397890.397,115593.331,398890.397],[\"9/408/364\",115593.331,397890.397,116593.331,398890.397],[\"9/404/372\",114593.331,399890.397,115593.331,400890.397],[\"9/400/372\",113593.331,399890.397,114593.331,400890.397],[\"9/400/376\",113593.331,400890.397,114593.331,401890.397],[\"9/404/376\",114593.331,400890.397,115593.331,401890.397],[\"8/408/376\",115593.331,400890.397,117593.331,402890.397],[\"8/408/368\",115593.331,398890.397,117593.331,400890.397],[\"8/416/368\",117593.331,398890.397,119593.331,400890.397],[\"8/416/376\",117593.331,400890.397,119593.331,402890.397],[\"9/416/384\",117593.331,402890.397,118593.331,403890.397],[\"9/416/388\",117593.331,403890.397,118593.331,404890.397],[\"8/408/384\",115593.331,402890.397,117593.331,404890.397],[\"9/404/380\",114593.331,401890.397,115593.331,402890.397],[\"9/400/380\",113593.331,401890.397,114593.331,402890.397],[\"8/400/384\",113593.331,402890.397,115593.331,404890.397],[\"9/408/392\",115593.331,404890.397,116593.331,405890.397],[\"8/400/392\",113593.331,404890.397,115593.331,406890.397],[\"9/408/396\",115593.331,405890.397,116593.331,406890.397],[\"9/412/396\",116593.331,405890.397,117593.331,406890.397],[\"9/412/392\",116593.331,404890.397,117593.331,405890.397],[\"9/416/392\",117593.331,404890.397,118593.331,405890.397],[\"10/418/396\",118093.331,405890.397,118593.331,406390.397],[\"10/416/396\",117593.331,405890.397,118093.331,406390.397],[\"10/416/398\",117593.331,406390.397,118093.331,406890.397],[\"10/418/398\",118093.331,406390.397,118593.331,406890.397],[\"10/420/398\",118593.331,406390.397,119093.331,406890.397],[\"10/420/396\",118593.331,405890.397,119093.331,406390.397],[\"10/422/396\",119093.331,405890.397,119593.331,406390.397],[\"10/422/398\",119093.331,406390.397,119593.331,406890.397],[\"8/424/392\",119593.331,404890.397,121593.331,406890.397],[\"9/420/392\",118593.331,404890.397,119593.331,405890.397],[\"9/420/388\",118593.331,403890.397,119593.331,404890.397],[\"9/420/384\",118593.331,402890.397,119593.331,403890.397],[\"8/424/384\",119593.331,402890.397,121593.331,404890.397],[\"9/432/388\",121593.331,403890.397,122593.331,404890.397],[\"9/432/384\",121593.331,402890.397,122593.331,403890.397],[\"9/436/384\",122593.331,402890.397,123593.331,403890.397],[\"9/436/388\",122593.331,403890.397,123593.331,404890.397],[\"8/432/392\",121593.331,404890.397,123593.331,406890.397],[\"9/440/396\",123593.331,405890.397,124593.331,406890.397],[\"9/440/392\",123593.331,404890.397,124593.331,405890.397],[\"10/440/390\",123593.331,404390.397,124093.331,404890.397],[\"10/442/390\",124093.331,404390.397,124593.331,404890.397],[\"9/444/392\",124593.331,404890.397,125593.331,405890.397],[\"9/444/396\",124593.331,405890.397,125593.331,406890.397],[\"7/448/384\",125593.331,402890.397,129593.331,406890.397],[\"9/444/388\",124593.331,403890.397,125593.331,404890.397],[\"9/444/384\",124593.331,402890.397,125593.331,403890.397],[\"10/442/388\",124093.331,403890.397,124593.331,404390.397],[\"10/440/388\",123593.331,403890.397,124093.331,404390.397],[\"9/440/384\",123593.331,402890.397,124593.331,403890.397],[\"8/440/376\",123593.331,400890.397,125593.331,402890.397],[\"9/448/372\",125593.331,399890.397,126593.331,400890.397],[\"8/440/368\",123593.331,398890.397,125593.331,400890.397],[\"8/440/360\",123593.331,396890.397,125593.331,398890.397],[\"9/448/360\",125593.331,396890.397,126593.331,397890.397],[\"9/448/364\",125593.331,397890.397,126593.331,398890.397],[\"9/448/368\",125593.331,398890.397,126593.331,399890.397],[\"9/452/368\",126593.331,398890.397,127593.331,399890.397],[\"9/452/364\",126593.331,397890.397,127593.331,398890.397],[\"9/452/360\",126593.331,396890.397,127593.331,397890.397],[\"9/456/360\",127593.331,396890.397,128593.331,397890.397],[\"9/456/364\",127593.331,397890.397,128593.331,398890.397],[\"9/456/368\",127593.331,398890.397,128593.331,399890.397],[\"9/456/372\",127593.331,399890.397,128593.331,400890.397],[\"10/452/374\",126593.331,400390.397,127093.331,400890.397],[\"10/452/372\",126593.331,399890.397,127093.331,400390.397],[\"10/454/372\",127093.331,399890.397,127593.331,400390.397],[\"10/454/374\",127093.331,400390.397,127593.331,400890.397],[\"8/448/376\",125593.331,400890.397,127593.331,402890.397],[\"8/456/376\",127593.331,400890.397,129593.331,402890.397],[\"8/464/376\",129593.331,400890.397,131593.331,402890.397],[\"8/464/368\",129593.331,398890.397,131593.331,400890.397],[\"9/460/372\",128593.331,399890.397,129593.331,400890.397],[\"9/460/368\",128593.331,398890.397,129593.331,399890.397],[\"9/460/364\",128593.331,397890.397,129593.331,398890.397],[\"9/460/360\",128593.331,396890.397,129593.331,397890.397],[\"9/464/360\",129593.331,396890.397,130593.331,397890.397],[\"9/468/360\",130593.331,396890.397,131593.331,397890.397],[\"9/468/364\",130593.331,397890.397,131593.331,398890.397],[\"9/464/364\",129593.331,397890.397,130593.331,398890.397],[\"9/472/364\",131593.331,397890.397,132593.331,398890.397],[\"9/472/360\",131593.331,396890.397,132593.331,397890.397],[\"10/476/362\",132593.331,397390.397,133093.331,397890.397],[\"10/476/360\",132593.331,396890.397,133093.331,397390.397],[\"10/478/360\",133093.331,396890.397,133593.331,397390.397],[\"10/478/362\",133093.331,397390.397,133593.331,397890.397],[\"9/476/364\",132593.331,397890.397,133593.331,398890.397],[\"8/472/368\",131593.331,398890.397,133593.331,400890.397],[\"8/472/376\",131593.331,400890.397,133593.331,402890.397],[\"7/464/384\",129593.331,402890.397,133593.331,406890.397],[\"8/472/400\",131593.331,406890.397,133593.331,408890.397],[\"9/472/408\",131593.331,408890.397,132593.331,409890.397],[\"9/476/408\",132593.331,408890.397,133593.331,409890.397],[\"9/476/412\",132593.331,409890.397,133593.331,410890.397],[\"9/476/416\",132593.331,410890.397,133593.331,411890.397],[\"9/472/416\",131593.331,410890.397,132593.331,411890.397],[\"9/472/412\",131593.331,409890.397,132593.331,410890.397],[\"9/464/412\",129593.331,409890.397,130593.331,410890.397],[\"9/468/412\",130593.331,409890.397,131593.331,410890.397],[\"8/464/416\",129593.331,410890.397,131593.331,412890.397],[\"9/464/408\",129593.331,408890.397,130593.331,409890.397],[\"9/468/408\",130593.331,408890.397,131593.331,409890.397],[\"9/468/404\",130593.331,407890.397,131593.331,408890.397],[\"9/464/404\",129593.331,407890.397,130593.331,408890.397],[\"10/466/402\",130093.331,407390.397,130593.331,407890.397],[\"9/468/400\",130593.331,406890.397,131593.331,407890.397],[\"10/466/400\",130093.331,406890.397,130593.331,407390.397],[\"10/464/400\",129593.331,406890.397,130093.331,407390.397],[\"10/464/402\",129593.331,407390.397,130093.331,407890.397],[\"8/456/400\",127593.331,406890.397,129593.331,408890.397],[\"8/448/400\",125593.331,406890.397,127593.331,408890.397],[\"8/440/400\",123593.331,406890.397,125593.331,408890.397],[\"8/440/408\",123593.331,408890.397,125593.331,410890.397],[\"8/448/408\",125593.331,408890.397,127593.331,410890.397],[\"8/456/408\",127593.331,408890.397,129593.331,410890.397],[\"7/448/416\",125593.331,410890.397,129593.331,414890.397],[\"7/448/432\",125593.331,414890.397,129593.331,418890.397],[\"8/464/424\",129593.331,412890.397,131593.331,414890.397],[\"9/472/420\",131593.331,411890.397,132593.331,412890.397],[\"9/476/420\",132593.331,411890.397,133593.331,412890.397],[\"8/472/424\",131593.331,412890.397,133593.331,414890.397],[\"7/464/432\",129593.331,414890.397,133593.331,418890.397],[\"8/464/448\",129593.331,418890.397,131593.331,420890.397],[\"8/464/456\",129593.331,420890.397,131593.331,422890.397],[\"8/472/448\",131593.331,418890.397,133593.331,420890.397],[\"8/472/456\",131593.331,420890.397,133593.331,422890.397],[\"7/464/464\",129593.331,422890.397,133593.331,426890.397],[\"8/448/464\",125593.331,422890.397,127593.331,424890.397],[\"8/456/464\",127593.331,422890.397,129593.331,424890.397],[\"8/456/472\",127593.331,424890.397,129593.331,426890.397],[\"8/448/472\",125593.331,424890.397,127593.331,426890.397],[\"9/444/472\",124593.331,424890.397,125593.331,425890.397],[\"9/444/476\",124593.331,425890.397,125593.331,426890.397],[\"9/440/476\",123593.331,425890.397,124593.331,426890.397],[\"9/440/472\",123593.331,424890.397,124593.331,425890.397],[\"8/440/464\",123593.331,422890.397,125593.331,424890.397],[\"8/440/456\",123593.331,420890.397,125593.331,422890.397],[\"8/440/448\",123593.331,418890.397,125593.331,420890.397],[\"7/448/448\",125593.331,418890.397,129593.331,422890.397],[\"7/416/448\",117593.331,418890.397,121593.331,422890.397],[\"8/432/448\",121593.331,418890.397,123593.331,420890.397],[\"8/432/456\",121593.331,420890.397,123593.331,422890.397],[\"8/432/464\",121593.331,422890.397,123593.331,424890.397],[\"8/432/472\",121593.331,424890.397,123593.331,426890.397],[\"9/424/472\",119593.331,424890.397,120593.331,425890.397],[\"9/428/472\",120593.331,424890.397,121593.331,425890.397],[\"9/428/476\",120593.331,425890.397,121593.331,426890.397],[\"9/424/476\",119593.331,425890.397,120593.331,426890.397],[\"9/424/468\",119593.331,423890.397,120593.331,424890.397],[\"9/428/468\",120593.331,423890.397,121593.331,424890.397],[\"9/428/464\",120593.331,422890.397,121593.331,423890.397],[\"9/424/464\",119593.331,422890.397,120593.331,423890.397],[\"8/408/464\",115593.331,422890.397,117593.331,424890.397],[\"8/416/464\",117593.331,422890.397,119593.331,424890.397],[\"8/416/472\",117593.331,424890.397,119593.331,426890.397],[\"9/412/476\",116593.331,425890.397,117593.331,426890.397],[\"9/404/472\",114593.331,424890.397,115593.331,425890.397],[\"9/408/472\",115593.331,424890.397,116593.331,425890.397],[\"9/408/476\",115593.331,425890.397,116593.331,426890.397],[\"9/404/476\",114593.331,425890.397,115593.331,426890.397],[\"9/400/476\",113593.331,425890.397,114593.331,426890.397],[\"9/400/472\",113593.331,424890.397,114593.331,425890.397],[\"8/400/464\",113593.331,422890.397,115593.331,424890.397],[\"7/400/448\",113593.331,418890.397,117593.331,422890.397],[\"9/416/420\",117593.331,411890.397,118593.331,412890.397],[\"8/416/424\",117593.331,412890.397,119593.331,414890.397],[\"7/416/432\",117593.331,414890.397,121593.331,418890.397],[\"7/432/432\",121593.331,414890.397,125593.331,418890.397],[\"7/432/416\",121593.331,410890.397,125593.331,414890.397],[\"9/428/420\",120593.331,411890.397,121593.331,412890.397],[\"9/424/420\",119593.331,411890.397,120593.331,412890.397],[\"8/424/424\",119593.331,412890.397,121593.331,414890.397],[\"9/420/420\",118593.331,411890.397,119593.331,412890.397],[\"9/420/416\",118593.331,410890.397,119593.331,411890.397],[\"8/424/408\",119593.331,408890.397,121593.331,410890.397],[\"9/424/416\",119593.331,410890.397,120593.331,411890.397],[\"9/428/416\",120593.331,410890.397,121593.331,411890.397],[\"8/432/408\",121593.331,408890.397,123593.331,410890.397],[\"8/432/400\",121593.331,406890.397,123593.331,408890.397],[\"8/424/400\",119593.331,406890.397,121593.331,408890.397],[\"9/420/404\",118593.331,407890.397,119593.331,408890.397],[\"9/420/400\",118593.331,406890.397,119593.331,407890.397],[\"9/416/400\",117593.331,406890.397,118593.331,407890.397],[\"8/408/400\",115593.331,406890.397,117593.331,408890.397],[\"9/416/404\",117593.331,407890.397,118593.331,408890.397],[\"8/416/408\",117593.331,408890.397,119593.331,410890.397],[\"9/416/416\",117593.331,410890.397,118593.331,411890.397],[\"8/408/408\",115593.331,408890.397,117593.331,410890.397],[\"9/404/412\",114593.331,409890.397,115593.331,410890.397],[\"9/400/412\",113593.331,409890.397,114593.331,410890.397],[\"9/400/408\",113593.331,408890.397,114593.331,409890.397],[\"9/404/408\",114593.331,408890.397,115593.331,409890.397],[\"8/400/400\",113593.331,406890.397,115593.331,408890.397],[\"8/392/400\",111593.331,406890.397,113593.331,408890.397],[\"9/392/408\",111593.331,408890.397,112593.331,409890.397],[\"9/396/408\",112593.331,408890.397,113593.331,409890.397],[\"9/396/412\",112593.331,409890.397,113593.331,410890.397],[\"9/392/412\",111593.331,409890.397,112593.331,410890.397],[\"8/384/408\",109593.331,408890.397,111593.331,410890.397],[\"8/384/400\",109593.331,406890.397,111593.331,408890.397],[\"7/368/400\",105593.331,406890.397,109593.331,410890.397],[\"7/368/416\",105593.331,410890.397,109593.331,414890.397],[\"7/368/432\",105593.331,414890.397,109593.331,418890.397],[\"6/384/416\",109593.331,410890.397,117593.331,418890.397],[\"7/384/448\",109593.331,418890.397,113593.331,422890.397],[\"8/392/464\",111593.331,422890.397,113593.331,424890.397],[\"9/396/472\",112593.331,424890.397,113593.331,425890.397],[\"9/396/476\",112593.331,425890.397,113593.331,426890.397],[\"9/392/476\",111593.331,425890.397,112593.331,426890.397],[\"9/392/472\",111593.331,424890.397,112593.331,425890.397],[\"8/384/472\",109593.331,424890.397,111593.331,426890.397],[\"9/380/468\",108593.331,423890.397,109593.331,424890.397],[\"9/380/464\",108593.331,422890.397,109593.331,423890.397],[\"8/384/464\",109593.331,422890.397,111593.331,424890.397],[\"9/372/460\",106593.331,421890.397,107593.331,422890.397],[\"9/372/464\",106593.331,422890.397,107593.331,423890.397],[\"10/370/468\",106093.331,423890.397,106593.331,424390.397],[\"9/372/468\",106593.331,423890.397,107593.331,424890.397],[\"9/376/464\",107593.331,422890.397,108593.331,423890.397],[\"9/376/468\",107593.331,423890.397,108593.331,424890.397],[\"8/376/472\",107593.331,424890.397,109593.331,426890.397],[\"9/372/476\",106593.331,425890.397,107593.331,426890.397],[\"10/370/474\",106093.331,425390.397,106593.331,425890.397],[\"10/370/472\",106093.331,424890.397,106593.331,425390.397],[\"9/372/472\",106593.331,424890.397,107593.331,425890.397],[\"10/370/470\",106093.331,424390.397,106593.331,424890.397],[\"10/368/470\",105593.331,424390.397,106093.331,424890.397],[\"10/366/470\",105093.331,424390.397,105593.331,424890.397],[\"10/366/472\",105093.331,424890.397,105593.331,425390.397],[\"10/366/474\",105093.331,425390.397,105593.331,425890.397],[\"10/368/472\",105593.331,424890.397,106093.331,425390.397],[\"10/368/474\",105593.331,425390.397,106093.331,425890.397],[\"9/368/476\",105593.331,425890.397,106593.331,426890.397],[\"9/364/476\",104593.331,425890.397,105593.331,426890.397],[\"9/360/476\",103593.331,425890.397,104593.331,426890.397],[\"9/360/472\",103593.331,424890.397,104593.331,425890.397],[\"10/364/474\",104593.331,425390.397,105093.331,425890.397],[\"10/364/472\",104593.331,424890.397,105093.331,425390.397],[\"10/364/470\",104593.331,424390.397,105093.331,424890.397],[\"9/360/468\",103593.331,423890.397,104593.331,424890.397],[\"9/360/464\",103593.331,422890.397,104593.331,423890.397],[\"10/364/468\",104593.331,423890.397,105093.331,424390.397],[\"10/366/468\",105093.331,423890.397,105593.331,424390.397],[\"10/368/468\",105593.331,423890.397,106093.331,424390.397],[\"9/368/464\",105593.331,422890.397,106593.331,423890.397],[\"9/364/464\",104593.331,422890.397,105593.331,423890.397],[\"9/368/460\",105593.331,421890.397,106593.331,422890.397],[\"9/364/460\",104593.331,421890.397,105593.331,422890.397],[\"9/360/460\",103593.331,421890.397,104593.331,422890.397],[\"9/360/456\",103593.331,420890.397,104593.331,421890.397],[\"8/360/448\",103593.331,418890.397,105593.331,420890.397],[\"9/364/456\",104593.331,420890.397,105593.331,421890.397],[\"9/368/456\",105593.331,420890.397,106593.331,421890.397],[\"9/372/456\",106593.331,420890.397,107593.331,421890.397],[\"8/376/456\",107593.331,420890.397,109593.331,422890.397],[\"8/376/448\",107593.331,418890.397,109593.331,420890.397],[\"8/368/448\",105593.331,418890.397,107593.331,420890.397],[\"8/344/448\",99593.331,418890.397,101593.331,420890.397],[\"8/344/456\",99593.331,420890.397,101593.331,422890.397],[\"9/352/456\",101593.331,420890.397,102593.331,421890.397],[\"8/352/448\",101593.331,418890.397,103593.331,420890.397],[\"9/356/456\",102593.331,420890.397,103593.331,421890.397],[\"9/356/460\",102593.331,421890.397,103593.331,422890.397],[\"9/352/460\",101593.331,421890.397,102593.331,422890.397],[\"8/352/464\",101593.331,422890.397,103593.331,424890.397],[\"9/356/472\",102593.331,424890.397,103593.331,425890.397],[\"9/356/476\",102593.331,425890.397,103593.331,426890.397],[\"9/352/476\",101593.331,425890.397,102593.331,426890.397],[\"9/352/472\",101593.331,424890.397,102593.331,425890.397],[\"9/344/472\",99593.331,424890.397,100593.331,425890.397],[\"9/348/472\",100593.331,424890.397,101593.331,425890.397],[\"9/348/476\",100593.331,425890.397,101593.331,426890.397],[\"9/344/476\",99593.331,425890.397,100593.331,426890.397],[\"9/340/468\",98593.331,423890.397,99593.331,424890.397],[\"9/340/464\",98593.331,422890.397,99593.331,423890.397],[\"8/344/464\",99593.331,422890.397,101593.331,424890.397],[\"9/336/464\",97593.331,422890.397,98593.331,423890.397],[\"9/336/468\",97593.331,423890.397,98593.331,424890.397],[\"8/336/472\",97593.331,424890.397,99593.331,426890.397],[\"7/320/464\",93593.331,422890.397,97593.331,426890.397],[\"7/320/448\",93593.331,418890.397,97593.331,422890.397],[\"8/336/456\",97593.331,420890.397,99593.331,422890.397],[\"8/336/448\",97593.331,418890.397,99593.331,420890.397],[\"8/328/440\",95593.331,416890.397,97593.331,418890.397],[\"8/320/440\",93593.331,416890.397,95593.331,418890.397],[\"8/320/432\",93593.331,414890.397,95593.331,416890.397],[\"7/320/416\",93593.331,410890.397,97593.331,414890.397],[\"8/328/432\",95593.331,414890.397,97593.331,416890.397],[\"7/336/432\",97593.331,414890.397,101593.331,418890.397],[\"7/352/432\",101593.331,414890.397,105593.331,418890.397],[\"7/352/416\",101593.331,410890.397,105593.331,414890.397],[\"7/336/416\",97593.331,410890.397,101593.331,414890.397],[\"7/352/400\",101593.331,406890.397,105593.331,410890.397],[\"7/336/400\",97593.331,406890.397,101593.331,410890.397],[\"8/328/400\",95593.331,406890.397,97593.331,408890.397],[\"8/328/408\",95593.331,408890.397,97593.331,410890.397],[\"8/320/408\",93593.331,408890.397,95593.331,410890.397],[\"8/320/400\",93593.331,406890.397,95593.331,408890.397],[\"7/320/384\",93593.331,402890.397,97593.331,406890.397],[\"8/336/392\",97593.331,404890.397,99593.331,406890.397],[\"8/336/384\",97593.331,402890.397,99593.331,404890.397],[\"8/320/376\",93593.331,400890.397,95593.331,402890.397],[\"9/324/372\",94593.331,399890.397,95593.331,400890.397],[\"9/328/372\",95593.331,399890.397,96593.331,400890.397],[\"9/320/372\",93593.331,399890.397,94593.331,400890.397],[\"9/320/368\",93593.331,398890.397,94593.331,399890.397],[\"8/320/360\",93593.331,396890.397,95593.331,398890.397],[\"9/324/368\",94593.331,398890.397,95593.331,399890.397],[\"9/328/368\",95593.331,398890.397,96593.331,399890.397],[\"9/332/368\",96593.331,398890.397,97593.331,399890.397],[\"8/328/360\",95593.331,396890.397,97593.331,398890.397],[\"8/336/360\",97593.331,396890.397,99593.331,398890.397],[\"9/336/368\",97593.331,398890.397,98593.331,399890.397],[\"9/336/372\",97593.331,399890.397,98593.331,400890.397],[\"9/332/372\",96593.331,399890.397,97593.331,400890.397],[\"8/328/376\",95593.331,400890.397,97593.331,402890.397],[\"8/336/376\",97593.331,400890.397,99593.331,402890.397],[\"8/344/376\",99593.331,400890.397,101593.331,402890.397],[\"8/344/368\",99593.331,398890.397,101593.331,400890.397],[\"9/340/372\",98593.331,399890.397,99593.331,400890.397],[\"9/340/368\",98593.331,398890.397,99593.331,399890.397],[\"8/344/360\",99593.331,396890.397,101593.331,398890.397],[\"9/352/368\",101593.331,398890.397,102593.331,399890.397],[\"9/352/364\",101593.331,397890.397,102593.331,398890.397],[\"9/352/360\",101593.331,396890.397,102593.331,397890.397],[\"10/356/362\",102593.331,397390.397,103093.331,397890.397],[\"10/356/360\",102593.331,396890.397,103093.331,397390.397],[\"10/358/360\",103093.331,396890.397,103593.331,397390.397],[\"10/358/362\",103093.331,397390.397,103593.331,397890.397],[\"9/356/364\",102593.331,397890.397,103593.331,398890.397],[\"9/356/368\",102593.331,398890.397,103593.331,399890.397],[\"9/356/372\",102593.331,399890.397,103593.331,400890.397],[\"9/352/372\",101593.331,399890.397,102593.331,400890.397],[\"8/352/376\",101593.331,400890.397,103593.331,402890.397],[\"8/344/384\",99593.331,402890.397,101593.331,404890.397],[\"9/348/392\",100593.331,404890.397,101593.331,405890.397],[\"9/344/392\",99593.331,404890.397,100593.331,405890.397],[\"9/344/396\",99593.331,405890.397,100593.331,406890.397],[\"9/348/396\",100593.331,405890.397,101593.331,406890.397],[\"7/352/384\",101593.331,402890.397,105593.331,406890.397],[\"9/376/380\",107593.331,401890.397,108593.331,402890.397],[\"7/368/384\",105593.331,402890.397,109593.331,406890.397],[\"9/384/392\",109593.331,404890.397,110593.331,405890.397],[\"9/388/392\",110593.331,404890.397,111593.331,405890.397],[\"9/384/396\",109593.331,405890.397,110593.331,406890.397],[\"9/388/396\",110593.331,405890.397,111593.331,406890.397],[\"8/392/392\",111593.331,404890.397,113593.331,406890.397],[\"8/392/384\",111593.331,402890.397,113593.331,404890.397],[\"9/396/380\",112593.331,401890.397,113593.331,402890.397],[\"9/392/380\",111593.331,401890.397,112593.331,402890.397],[\"9/388/380\",110593.331,401890.397,111593.331,402890.397],[\"9/384/380\",109593.331,401890.397,110593.331,402890.397],[\"9/388/384\",110593.331,402890.397,111593.331,403890.397],[\"9/388/388\",110593.331,403890.397,111593.331,404890.397],[\"9/384/388\",109593.331,403890.397,110593.331,404890.397],[\"9/384/384\",109593.331,402890.397,110593.331,403890.397],[\"9/380/380\",108593.331,401890.397,109593.331,402890.397],[\"9/380/376\",108593.331,400890.397,109593.331,401890.397],[\"9/384/372\",109593.331,399890.397,110593.331,400890.397],[\"9/388/372\",110593.331,399890.397,111593.331,400890.397],[\"9/384/376\",109593.331,400890.397,110593.331,401890.397],[\"9/388/376\",110593.331,400890.397,111593.331,401890.397],[\"9/392/376\",111593.331,400890.397,112593.331,401890.397],[\"9/396/376\",112593.331,400890.397,113593.331,401890.397],[\"9/396/372\",112593.331,399890.397,113593.331,400890.397],[\"10/398/370\",113093.331,399390.397,113593.331,399890.397],[\"10/396/370\",112593.331,399390.397,113093.331,399890.397],[\"10/394/370\",112093.331,399390.397,112593.331,399890.397],[\"10/392/370\",111593.331,399390.397,112093.331,399890.397],[\"9/392/372\",111593.331,399890.397,112593.331,400890.397],[\"9/392/364\",111593.331,397890.397,112593.331,398890.397],[\"10/392/368\",111593.331,398890.397,112093.331,399390.397],[\"10/394/368\",112093.331,398890.397,112593.331,399390.397],[\"10/396/368\",112593.331,398890.397,113093.331,399390.397],[\"10/398/368\",113093.331,398890.397,113593.331,399390.397],[\"10/398/366\",113093.331,398390.397,113593.331,398890.397],[\"10/396/366\",112593.331,398390.397,113093.331,398890.397],[\"10/396/364\",112593.331,397890.397,113093.331,398390.397],[\"10/398/364\",113093.331,397890.397,113593.331,398390.397],[\"9/396/360\",112593.331,396890.397,113593.331,397890.397],[\"9/392/360\",111593.331,396890.397,112593.331,397890.397],[\"9/388/360\",110593.331,396890.397,111593.331,397890.397],[\"9/384/360\",109593.331,396890.397,110593.331,397890.397],[\"10/386/364\",110093.331,397890.397,110593.331,398390.397],[\"9/388/364\",110593.331,397890.397,111593.331,398890.397],[\"9/388/368\",110593.331,398890.397,111593.331,399890.397],[\"9/384/368\",109593.331,398890.397,110593.331,399890.397],[\"10/386/366\",110093.331,398390.397,110593.331,398890.397],[\"10/384/366\",109593.331,398390.397,110093.331,398890.397],[\"10/384/364\",109593.331,397890.397,110093.331,398390.397],[\"8/376/368\",107593.331,398890.397,109593.331,400890.397],[\"10/378/376\",108093.331,400890.397,108593.331,401390.397],[\"10/378/378\",108093.331,401390.397,108593.331,401890.397],[\"10/376/378\",107593.331,401390.397,108093.331,401890.397],[\"10/376/376\",107593.331,400890.397,108093.331,401390.397],[\"8/368/376\",105593.331,400890.397,107593.331,402890.397],[\"8/368/368\",105593.331,398890.397,107593.331,400890.397],[\"9/364/372\",104593.331,399890.397,105593.331,400890.397],[\"8/360/376\",103593.331,400890.397,105593.331,402890.397],[\"9/360/372\",103593.331,399890.397,104593.331,400890.397],[\"10/362/370\",104093.331,399390.397,104593.331,399890.397],[\"10/360/370\",103593.331,399390.397,104093.331,399890.397],[\"10/360/368\",103593.331,398890.397,104093.331,399390.397],[\"9/360/364\",103593.331,397890.397,104593.331,398890.397],[\"10/362/368\",104093.331,398890.397,104593.331,399390.397],[\"9/364/368\",104593.331,398890.397,105593.331,399890.397],[\"9/364/364\",104593.331,397890.397,105593.331,398890.397],[\"9/364/360\",104593.331,396890.397,105593.331,397890.397],[\"9/360/360\",103593.331,396890.397,104593.331,397890.397],[\"8/360/352\",103593.331,394890.397,105593.331,396890.397],[\"9/368/340\",105593.331,391890.397,106593.331,392890.397],[\"8/368/344\",105593.331,392890.397,107593.331,394890.397],[\"9/372/340\",106593.331,391890.397,107593.331,392890.397],[\"8/376/344\",107593.331,392890.397,109593.331,394890.397],[\"7/368/352\",105593.331,394890.397,109593.331,398890.397],[\"8/384/352\",109593.331,394890.397,111593.331,396890.397],[\"8/392/352\",111593.331,394890.397,113593.331,396890.397],[\"6/384/320\",109593.331,386890.397,117593.331,394890.397],[\"7/368/320\",105593.331,386890.397,109593.331,390890.397],[\"8/376/336\",107593.331,390890.397,109593.331,392890.397],[\"9/372/336\",106593.331,390890.397,107593.331,391890.397],[\"9/368/336\",105593.331,390890.397,106593.331,391890.397],[\"8/360/328\",103593.331,388890.397,105593.331,390890.397],[\"9/360/324\",103593.331,387890.397,104593.331,388890.397],[\"9/364/324\",104593.331,387890.397,105593.331,388890.397],[\"9/364/320\",104593.331,386890.397,105593.331,387890.397],[\"9/360/320\",103593.331,386890.397,104593.331,387890.397],[\"8/352/320\",101593.331,386890.397,103593.331,388890.397],[\"7/336/320\",97593.331,386890.397,101593.331,390890.397],[\"8/344/336\",99593.331,390890.397,101593.331,392890.397],[\"8/352/328\",101593.331,388890.397,103593.331,390890.397],[\"7/352/336\",101593.331,390890.397,105593.331,394890.397],[\"8/352/352\",101593.331,394890.397,103593.331,396890.397],[\"9/344/352\",99593.331,394890.397,100593.331,395890.397],[\"9/348/352\",100593.331,394890.397,101593.331,395890.397],[\"9/348/356\",100593.331,395890.397,101593.331,396890.397],[\"9/344/356\",99593.331,395890.397,100593.331,396890.397],[\"9/340/356\",98593.331,395890.397,99593.331,396890.397],[\"9/340/352\",98593.331,394890.397,99593.331,395890.397],[\"8/344/344\",99593.331,392890.397,101593.331,394890.397],[\"8/336/344\",97593.331,392890.397,99593.331,394890.397],[\"9/336/352\",97593.331,394890.397,98593.331,395890.397],[\"9/336/356\",97593.331,395890.397,98593.331,396890.397],[\"8/328/352\",95593.331,394890.397,97593.331,396890.397],[\"8/320/352\",93593.331,394890.397,95593.331,396890.397],[\"7/320/336\",93593.331,390890.397,97593.331,394890.397],[\"8/336/336\",97593.331,390890.397,99593.331,392890.397],[\"7/320/320\",93593.331,386890.397,97593.331,390890.397],[\"6/320/288\",93593.331,378890.397,101593.331,386890.397],[\"7/352/288\",101593.331,378890.397,105593.331,382890.397],[\"8/352/304\",101593.331,382890.397,103593.331,384890.397],[\"8/352/312\",101593.331,384890.397,103593.331,386890.397],[\"8/360/312\",103593.331,384890.397,105593.331,386890.397],[\"8/360/304\",103593.331,382890.397,105593.331,384890.397],[\"7/368/304\",105593.331,382890.397,109593.331,386890.397],[\"6/384/288\",109593.331,378890.397,117593.331,386890.397],[\"6/416/256\",117593.331,370890.397,125593.331,378890.397],[\"7/432/288\",121593.331,378890.397,125593.331,382890.397],[\"7/416/288\",117593.331,378890.397,121593.331,382890.397],[\"7/416/304\",117593.331,382890.397,121593.331,386890.397],[\"9/432/308\",121593.331,383890.397,122593.331,384890.397],[\"9/432/304\",121593.331,382890.397,122593.331,383890.397],[\"9/436/304\",122593.331,382890.397,123593.331,383890.397],[\"9/436/308\",122593.331,383890.397,123593.331,384890.397],[\"8/432/312\",121593.331,384890.397,123593.331,386890.397],[\"8/440/312\",123593.331,384890.397,125593.331,386890.397],[\"8/440/304\",123593.331,382890.397,125593.331,384890.397],[\"6/448/288\",125593.331,378890.397,133593.331,386890.397],[\"7/480/304\",133593.331,382890.397,137593.331,386890.397],[\"7/496/304\",137593.331,382890.397,141593.331,386890.397],[\"7/512/304\",141593.331,382890.397,145593.331,386890.397],[\"7/496/288\",137593.331,378890.397,141593.331,382890.397],[\"7/512/288\",141593.331,378890.397,145593.331,382890.397],[\"8/512/280\",141593.331,376890.397,143593.331,378890.397],[\"8/504/280\",139593.331,376890.397,141593.331,378890.397],[\"8/496/280\",137593.331,376890.397,139593.331,378890.397],[\"7/480/288\",133593.331,378890.397,137593.331,382890.397],[\"7/480/272\",133593.331,374890.397,137593.331,378890.397],[\"8/496/272\",137593.331,374890.397,139593.331,376890.397],[\"8/496/264\",137593.331,372890.397,139593.331,374890.397],[\"7/480/256\",133593.331,370890.397,137593.331,374890.397],[\"8/496/256\",137593.331,370890.397,139593.331,372890.397],[\"8/504/256\",139593.331,370890.397,141593.331,372890.397],[\"7/512/256\",141593.331,370890.397,145593.331,374890.397],[\"8/504/264\",139593.331,372890.397,141593.331,374890.397],[\"8/504/272\",139593.331,374890.397,141593.331,376890.397],[\"9/512/276\",141593.331,375890.397,142593.331,376890.397],[\"9/512/272\",141593.331,374890.397,142593.331,375890.397],[\"9/516/272\",142593.331,374890.397,143593.331,375890.397],[\"9/516/276\",142593.331,375890.397,143593.331,376890.397],[\"9/520/276\",143593.331,375890.397,144593.331,376890.397],[\"9/520/272\",143593.331,374890.397,144593.331,375890.397],[\"9/524/272\",144593.331,374890.397,145593.331,375890.397],[\"9/528/272\",145593.331,374890.397,146593.331,375890.397],[\"9/524/276\",144593.331,375890.397,145593.331,376890.397],[\"9/528/276\",145593.331,375890.397,146593.331,376890.397],[\"9/532/276\",146593.331,375890.397,147593.331,376890.397],[\"8/536/272\",147593.331,374890.397,149593.331,376890.397],[\"9/532/272\",146593.331,374890.397,147593.331,375890.397],[\"7/528/256\",145593.331,370890.397,149593.331,374890.397],[\"8/544/256\",149593.331,370890.397,151593.331,372890.397],[\"8/544/248\",149593.331,368890.397,151593.331,370890.397],[\"8/544/240\",149593.331,366890.397,151593.331,368890.397],[\"9/552/248\",151593.331,368890.397,152593.331,369890.397],[\"8/552/240\",151593.331,366890.397,153593.331,368890.397],[\"9/556/248\",152593.331,368890.397,153593.331,369890.397],[\"9/556/252\",152593.331,369890.397,153593.331,370890.397],[\"9/552/252\",151593.331,369890.397,152593.331,370890.397],[\"8/552/256\",151593.331,370890.397,153593.331,372890.397],[\"8/552/264\",151593.331,372890.397,153593.331,374890.397],[\"9/544/268\",149593.331,373890.397,150593.331,374890.397],[\"9/544/264\",149593.331,372890.397,150593.331,373890.397],[\"9/548/264\",150593.331,372890.397,151593.331,373890.397],[\"9/548/268\",150593.331,373890.397,151593.331,374890.397],[\"7/544/272\",149593.331,374890.397,153593.331,378890.397],[\"7/544/288\",149593.331,378890.397,153593.331,382890.397],[\"8/536/280\",147593.331,376890.397,149593.331,378890.397],[\"8/528/280\",145593.331,376890.397,147593.331,378890.397],[\"8/520/280\",143593.331,376890.397,145593.331,378890.397],[\"7/528/288\",145593.331,378890.397,149593.331,382890.397],[\"7/528/304\",145593.331,382890.397,149593.331,386890.397],[\"7/544/304\",149593.331,382890.397,153593.331,386890.397],[\"8/560/312\",153593.331,384890.397,155593.331,386890.397],[\"8/568/312\",155593.331,384890.397,157593.331,386890.397],[\"8/576/312\",157593.331,384890.397,159593.331,386890.397],[\"9/572/304\",156593.331,382890.397,157593.331,383890.397],[\"9/572/308\",156593.331,383890.397,157593.331,384890.397],[\"9/576/308\",157593.331,383890.397,158593.331,384890.397],[\"9/576/304\",157593.331,382890.397,158593.331,383890.397],[\"9/576/300\",157593.331,381890.397,158593.331,382890.397],[\"9/572/300\",156593.331,381890.397,157593.331,382890.397],[\"9/568/300\",155593.331,381890.397,156593.331,382890.397],[\"10/566/300\",155093.331,381890.397,155593.331,382390.397],[\"10/566/302\",155093.331,382390.397,155593.331,382890.397],[\"9/568/304\",155593.331,382890.397,156593.331,383890.397],[\"9/568/308\",155593.331,383890.397,156593.331,384890.397],[\"8/560/304\",153593.331,382890.397,155593.331,384890.397],[\"10/564/302\",154593.331,382390.397,155093.331,382890.397],[\"10/564/300\",154593.331,381890.397,155093.331,382390.397],[\"9/560/300\",153593.331,381890.397,154593.331,382890.397],[\"9/560/296\",153593.331,380890.397,154593.331,381890.397],[\"10/564/296\",154593.331,380890.397,155093.331,381390.397],[\"10/564/298\",154593.331,381390.397,155093.331,381890.397],[\"10/566/298\",155093.331,381390.397,155593.331,381890.397],[\"9/568/296\",155593.331,380890.397,156593.331,381890.397],[\"10/566/296\",155093.331,380890.397,155593.331,381390.397],[\"9/564/292\",154593.331,379890.397,155593.331,380890.397],[\"9/568/292\",155593.331,379890.397,156593.331,380890.397],[\"9/560/292\",153593.331,379890.397,154593.331,380890.397],[\"9/560/288\",153593.331,378890.397,154593.331,379890.397],[\"9/564/288\",154593.331,378890.397,155593.331,379890.397],[\"9/568/288\",155593.331,378890.397,156593.331,379890.397],[\"9/572/288\",156593.331,378890.397,157593.331,379890.397],[\"9/576/280\",157593.331,376890.397,158593.331,377890.397],[\"9/576/284\",157593.331,377890.397,158593.331,378890.397],[\"8/576/288\",157593.331,378890.397,159593.331,380890.397],[\"9/572/292\",156593.331,379890.397,157593.331,380890.397],[\"9/572/296\",156593.331,380890.397,157593.331,381890.397],[\"9/576/296\",157593.331,380890.397,158593.331,381890.397],[\"9/580/296\",158593.331,380890.397,159593.331,381890.397],[\"10/584/296\",159593.331,380890.397,160093.331,381390.397],[\"10/584/298\",159593.331,381390.397,160093.331,381890.397],[\"10/586/298\",160093.331,381390.397,160593.331,381890.397],[\"9/588/296\",160593.331,380890.397,161593.331,381890.397],[\"10/586/296\",160093.331,380890.397,160593.331,381390.397],[\"8/584/288\",159593.331,378890.397,161593.331,380890.397],[\"9/580/284\",158593.331,377890.397,159593.331,378890.397],[\"9/580/280\",158593.331,376890.397,159593.331,377890.397],[\"9/584/280\",159593.331,376890.397,160593.331,377890.397],[\"9/588/280\",160593.331,376890.397,161593.331,377890.397],[\"9/588/284\",160593.331,377890.397,161593.331,378890.397],[\"9/584/284\",159593.331,377890.397,160593.331,378890.397],[\"9/592/288\",161593.331,378890.397,162593.331,379890.397],[\"9/596/288\",162593.331,378890.397,163593.331,379890.397],[\"9/596/292\",162593.331,379890.397,163593.331,380890.397],[\"9/592/292\",161593.331,379890.397,162593.331,380890.397],[\"10/594/296\",162093.331,380890.397,162593.331,381390.397],[\"10/592/296\",161593.331,380890.397,162093.331,381390.397],[\"10/592/298\",161593.331,381390.397,162093.331,381890.397],[\"10/594/298\",162093.331,381390.397,162593.331,381890.397],[\"10/596/298\",162593.331,381390.397,163093.331,381890.397],[\"10/596/296\",162593.331,380890.397,163093.331,381390.397],[\"10/598/296\",163093.331,380890.397,163593.331,381390.397],[\"10/598/298\",163093.331,381390.397,163593.331,381890.397],[\"9/596/300\",162593.331,381890.397,163593.331,382890.397],[\"10/596/304\",162593.331,382890.397,163093.331,383390.397],[\"10/598/304\",163093.331,382890.397,163593.331,383390.397],[\"10/598/306\",163093.331,383390.397,163593.331,383890.397],[\"9/596/308\",162593.331,383890.397,163593.331,384890.397],[\"10/596/306\",162593.331,383390.397,163093.331,383890.397],[\"9/592/304\",161593.331,382890.397,162593.331,383890.397],[\"9/592/308\",161593.331,383890.397,162593.331,384890.397],[\"10/590/302\",161093.331,382390.397,161593.331,382890.397],[\"10/594/302\",162093.331,382390.397,162593.331,382890.397],[\"10/592/302\",161593.331,382390.397,162093.331,382890.397],[\"10/594/300\",162093.331,381890.397,162593.331,382390.397],[\"10/592/300\",161593.331,381890.397,162093.331,382390.397],[\"10/590/300\",161093.331,381890.397,161593.331,382390.397],[\"10/588/300\",160593.331,381890.397,161093.331,382390.397],[\"10/588/302\",160593.331,382390.397,161093.331,382890.397],[\"10/586/304\",160093.331,382890.397,160593.331,383390.397],[\"9/584/300\",159593.331,381890.397,160593.331,382890.397],[\"9/580/300\",158593.331,381890.397,159593.331,382890.397],[\"10/584/304\",159593.331,382890.397,160093.331,383390.397],[\"10/584/306\",159593.331,383390.397,160093.331,383890.397],[\"9/580/304\",158593.331,382890.397,159593.331,383890.397],[\"9/580/308\",158593.331,383890.397,159593.331,384890.397],[\"9/584/308\",159593.331,383890.397,160593.331,384890.397],[\"10/586/306\",160093.331,383390.397,160593.331,383890.397],[\"9/588/304\",160593.331,382890.397,161593.331,383890.397],[\"9/588/308\",160593.331,383890.397,161593.331,384890.397],[\"9/588/312\",160593.331,384890.397,161593.331,385890.397],[\"10/586/312\",160093.331,384890.397,160593.331,385390.397],[\"10/586/314\",160093.331,385390.397,160593.331,385890.397],[\"10/584/312\",159593.331,384890.397,160093.331,385390.397],[\"10/584/314\",159593.331,385390.397,160093.331,385890.397],[\"9/584/316\",159593.331,385890.397,160593.331,386890.397],[\"9/588/316\",160593.331,385890.397,161593.331,386890.397],[\"9/592/316\",161593.331,385890.397,162593.331,386890.397],[\"9/592/312\",161593.331,384890.397,162593.331,385890.397],[\"9/596/312\",162593.331,384890.397,163593.331,385890.397],[\"9/596/316\",162593.331,385890.397,163593.331,386890.397],[\"8/600/312\",163593.331,384890.397,165593.331,386890.397],[\"9/608/316\",165593.331,385890.397,166593.331,386890.397],[\"9/608/312\",165593.331,384890.397,166593.331,385890.397],[\"9/600/308\",163593.331,383890.397,164593.331,384890.397],[\"10/602/306\",164093.331,383390.397,164593.331,383890.397],[\"10/600/306\",163593.331,383390.397,164093.331,383890.397],[\"10/600/304\",163593.331,382890.397,164093.331,383390.397],[\"9/600/300\",163593.331,381890.397,164593.331,382890.397],[\"10/602/304\",164093.331,382890.397,164593.331,383390.397],[\"9/604/300\",164593.331,381890.397,165593.331,382890.397],[\"9/608/300\",165593.331,381890.397,166593.331,382890.397],[\"9/604/304\",164593.331,382890.397,165593.331,383890.397],[\"9/604/308\",164593.331,383890.397,165593.331,384890.397],[\"8/608/304\",165593.331,382890.397,167593.331,384890.397],[\"9/612/300\",166593.331,381890.397,167593.331,382890.397],[\"9/616/300\",167593.331,381890.397,168593.331,382890.397],[\"8/616/304\",167593.331,382890.397,169593.331,384890.397],[\"9/612/312\",166593.331,384890.397,167593.331,385890.397],[\"9/612/316\",166593.331,385890.397,167593.331,386890.397],[\"8/616/312\",167593.331,384890.397,169593.331,386890.397],[\"9/624/312\",169593.331,384890.397,170593.331,385890.397],[\"9/628/312\",170593.331,384890.397,171593.331,385890.397],[\"9/624/316\",169593.331,385890.397,170593.331,386890.397],[\"9/628/316\",170593.331,385890.397,171593.331,386890.397],[\"10/632/316\",171593.331,385890.397,172093.331,386390.397],[\"10/634/316\",172093.331,385890.397,172593.331,386390.397],[\"10/632/318\",171593.331,386390.397,172093.331,386890.397],[\"10/634/318\",172093.331,386390.397,172593.331,386890.397],[\"9/636/316\",172593.331,385890.397,173593.331,386890.397],[\"9/636/312\",172593.331,384890.397,173593.331,385890.397],[\"9/632/312\",171593.331,384890.397,172593.331,385890.397],[\"10/630/306\",171093.331,383390.397,171593.331,383890.397],[\"8/632/304\",171593.331,382890.397,173593.331,384890.397],[\"10/630/304\",171093.331,382890.397,171593.331,383390.397],[\"10/628/304\",170593.331,382890.397,171093.331,383390.397],[\"10/628/306\",170593.331,383390.397,171093.331,383890.397],[\"9/628/308\",170593.331,383890.397,171593.331,384890.397],[\"9/624/308\",169593.331,383890.397,170593.331,384890.397],[\"9/624/304\",169593.331,382890.397,170593.331,383890.397],[\"9/620/300\",168593.331,381890.397,169593.331,382890.397],[\"9/620/296\",168593.331,380890.397,169593.331,381890.397],[\"7/624/288\",169593.331,378890.397,173593.331,382890.397],[\"8/616/280\",167593.331,376890.397,169593.331,378890.397],[\"8/608/280\",165593.331,376890.397,167593.331,378890.397],[\"9/612/288\",166593.331,378890.397,167593.331,379890.397],[\"8/616/288\",167593.331,378890.397,169593.331,380890.397],[\"9/616/296\",167593.331,380890.397,168593.331,381890.397],[\"9/612/296\",166593.331,380890.397,167593.331,381890.397],[\"9/612/292\",166593.331,379890.397,167593.331,380890.397],[\"9/608/292\",165593.331,379890.397,166593.331,380890.397],[\"9/608/296\",165593.331,380890.397,166593.331,381890.397],[\"9/604/296\",164593.331,380890.397,165593.331,381890.397],[\"9/600/296\",163593.331,380890.397,164593.331,381890.397],[\"8/600/288\",163593.331,378890.397,165593.331,380890.397],[\"9/608/288\",165593.331,378890.397,166593.331,379890.397],[\"8/608/264\",165593.331,372890.397,167593.331,374890.397],[\"8/616/264\",167593.331,372890.397,169593.331,374890.397],[\"8/608/272\",165593.331,374890.397,167593.331,376890.397],[\"8/616/272\",167593.331,374890.397,169593.331,376890.397],[\"7/624/272\",169593.331,374890.397,173593.331,378890.397],[\"7/624/256\",169593.331,370890.397,173593.331,374890.397],[\"8/624/248\",169593.331,368890.397,171593.331,370890.397],[\"8/632/248\",171593.331,368890.397,173593.331,370890.397],[\"8/632/240\",171593.331,366890.397,173593.331,368890.397],[\"8/624/240\",169593.331,366890.397,171593.331,368890.397],[\"7/608/240\",165593.331,366890.397,169593.331,370890.397],[\"8/616/256\",167593.331,370890.397,169593.331,372890.397],[\"8/608/256\",165593.331,370890.397,167593.331,372890.397],[\"8/584/256\",159593.331,370890.397,161593.331,372890.397],[\"7/592/256\",161593.331,370890.397,165593.331,374890.397],[\"7/592/272\",161593.331,374890.397,165593.331,378890.397],[\"8/584/272\",159593.331,374890.397,161593.331,376890.397],[\"9/580/268\",158593.331,373890.397,159593.331,374890.397],[\"9/580/264\",158593.331,372890.397,159593.331,373890.397],[\"10/584/266\",159593.331,373390.397,160093.331,373890.397],[\"9/584/268\",159593.331,373890.397,160593.331,374890.397],[\"9/588/268\",160593.331,373890.397,161593.331,374890.397],[\"9/588/264\",160593.331,372890.397,161593.331,373890.397],[\"10/586/266\",160093.331,373390.397,160593.331,373890.397],[\"10/586/264\",160093.331,372890.397,160593.331,373390.397],[\"10/584/264\",159593.331,372890.397,160093.331,373390.397],[\"8/568/264\",155593.331,372890.397,157593.331,374890.397],[\"9/576/264\",157593.331,372890.397,158593.331,373890.397],[\"9/576/268\",157593.331,373890.397,158593.331,374890.397],[\"8/576/272\",157593.331,374890.397,159593.331,376890.397],[\"7/560/272\",153593.331,374890.397,157593.331,378890.397],[\"8/560/264\",153593.331,372890.397,155593.331,374890.397],[\"8/560/256\",153593.331,370890.397,155593.331,372890.397],[\"8/568/256\",155593.331,370890.397,157593.331,372890.397],[\"8/576/256\",157593.331,370890.397,159593.331,372890.397],[\"7/560/240\",153593.331,366890.397,157593.331,370890.397],[\"7/560/224\",153593.331,362890.397,157593.331,366890.397],[\"6/576/224\",157593.331,362890.397,165593.331,370890.397],[\"8/608/224\",165593.331,362890.397,167593.331,364890.397],[\"9/616/224\",167593.331,362890.397,168593.331,363890.397],[\"9/616/228\",167593.331,363890.397,168593.331,364890.397],[\"8/608/232\",165593.331,364890.397,167593.331,366890.397],[\"8/616/232\",167593.331,364890.397,169593.331,366890.397],[\"7/624/224\",169593.331,362890.397,173593.331,366890.397],[\"9/620/228\",168593.331,363890.397,169593.331,364890.397],[\"9/620/224\",168593.331,362890.397,169593.331,363890.397],[\"7/624/208\",169593.331,358890.397,173593.331,362890.397],[\"7/608/208\",165593.331,358890.397,169593.331,362890.397],[\"7/608/192\",165593.331,354890.397,169593.331,358890.397],[\"7/624/192\",169593.331,354890.397,173593.331,358890.397],[\"7/544/224\",149593.331,362890.397,153593.331,366890.397],[\"6/512/224\",141593.331,362890.397,149593.331,370890.397],[\"7/624/48\",169593.331,318890.397,173593.331,322890.397],[\"7/624/32\",169593.331,314890.397,173593.331,318890.397],[\"3/256/0\",77593.331,306890.397,141593.331,370890.397],[\"6/288/256\",85593.331,370890.397,93593.331,378890.397],[\"6/288/288\",85593.331,378890.397,93593.331,386890.397],[\"8/264/288\",79593.331,378890.397,81593.331,380890.397],[\"9/264/296\",79593.331,380890.397,80593.331,381890.397],[\"9/268/296\",80593.331,380890.397,81593.331,381890.397],[\"7/272/288\",81593.331,378890.397,85593.331,382890.397],[\"7/272/304\",81593.331,382890.397,85593.331,386890.397],[\"7/256/304\",77593.331,382890.397,81593.331,386890.397],[\"9/268/300\",80593.331,381890.397,81593.331,382890.397],[\"9/264/300\",79593.331,381890.397,80593.331,382890.397],[\"8/256/296\",77593.331,380890.397,79593.331,382890.397],[\"8/256/288\",77593.331,378890.397,79593.331,380890.397],[\"6/256/256\",77593.331,370890.397,85593.331,378890.397],[\"7/208/240\",65593.331,366890.397,69593.331,370890.397],[\"8/200/240\",63593.331000000006,366890.397,65593.331,368890.397],[\"8/200/248\",63593.331000000006,368890.397,65593.331,370890.397],[\"6/192/256\",61593.331000000006,370890.397,69593.331,378890.397],[\"6/224/256\",69593.331,370890.397,77593.331,378890.397],[\"6/224/288\",69593.331,378890.397,77593.331,386890.397],[\"7/208/304\",65593.331,382890.397,69593.331,386890.397],[\"7/208/288\",65593.331,378890.397,69593.331,382890.397],[\"8/184/280\",59593.331000000006,376890.397,61593.331000000006,378890.397],[\"7/176/288\",57593.331000000006,378890.397,61593.331000000006,382890.397],[\"7/192/288\",61593.331000000006,378890.397,65593.331,382890.397],[\"7/192/304\",61593.331000000006,382890.397,65593.331,386890.397],[\"8/184/312\",59593.331000000006,384890.397,61593.331000000006,386890.397],[\"8/184/304\",59593.331000000006,382890.397,61593.331000000006,384890.397],[\"8/176/304\",57593.331000000006,382890.397,59593.331000000006,384890.397],[\"8/176/312\",57593.331000000006,384890.397,59593.331000000006,386890.397],[\"7/160/304\",53593.331000000006,382890.397,57593.331000000006,386890.397],[\"7/160/288\",53593.331000000006,378890.397,57593.331000000006,382890.397],[\"8/176/280\",57593.331000000006,376890.397,59593.331000000006,378890.397],[\"7/160/272\",53593.331000000006,374890.397,57593.331000000006,378890.397],[\"7/160/256\",53593.331000000006,370890.397,57593.331000000006,374890.397],[\"8/176/272\",57593.331000000006,374890.397,59593.331000000006,376890.397],[\"8/184/272\",59593.331000000006,374890.397,61593.331000000006,376890.397],[\"7/176/256\",57593.331000000006,370890.397,61593.331000000006,374890.397],[\"8/192/248\",61593.331000000006,368890.397,63593.331000000006,370890.397],[\"9/192/244\",61593.331000000006,367890.397,62593.331000000006,368890.397],[\"9/196/244\",62593.331000000006,367890.397,63593.331000000006,368890.397],[\"9/196/240\",62593.331000000006,366890.397,63593.331000000006,367890.397],[\"9/192/240\",61593.331000000006,366890.397,62593.331000000006,367890.397],[\"7/176/240\",57593.331000000006,366890.397,61593.331000000006,370890.397],[\"7/160/240\",53593.331000000006,366890.397,57593.331000000006,370890.397],[\"7/160/224\",53593.331000000006,362890.397,57593.331000000006,366890.397],[\"6/160/192\",53593.331000000006,354890.397,61593.331000000006,362890.397],[\"8/192/224\",61593.331000000006,362890.397,63593.331000000006,364890.397],[\"7/176/224\",57593.331000000006,362890.397,61593.331000000006,366890.397],[\"9/192/236\",61593.331000000006,365890.397,62593.331000000006,366890.397],[\"9/192/232\",61593.331000000006,364890.397,62593.331000000006,365890.397],[\"9/196/232\",62593.331000000006,364890.397,63593.331000000006,365890.397],[\"9/196/236\",62593.331000000006,365890.397,63593.331000000006,366890.397],[\"8/200/232\",63593.331000000006,364890.397,65593.331,366890.397],[\"8/200/224\",63593.331000000006,362890.397,65593.331,364890.397],[\"7/208/224\",65593.331,362890.397,69593.331,366890.397],[\"6/224/224\",69593.331,362890.397,77593.331,370890.397],[\"6/192/192\",61593.331000000006,354890.397,69593.331,362890.397],[\"8/112/208\",41593.331000000006,358890.397,43593.331000000006,360890.397],[\"8/112/216\",41593.331000000006,360890.397,43593.331000000006,362890.397],[\"7/96/224\",37593.331000000006,362890.397,41593.331000000006,366890.397],[\"7/112/224\",41593.331000000006,362890.397,45593.331000000006,366890.397],[\"7/128/224\",45593.331000000006,362890.397,49593.331000000006,366890.397],[\"8/120/216\",43593.331000000006,360890.397,45593.331000000006,362890.397],[\"8/120/208\",43593.331000000006,358890.397,45593.331000000006,360890.397],[\"6/128/192\",45593.331000000006,354890.397,53593.331000000006,362890.397],[\"8/152/224\",51593.331000000006,362890.397,53593.331000000006,364890.397],[\"8/144/224\",49593.331000000006,362890.397,51593.331000000006,364890.397],[\"8/144/232\",49593.331000000006,364890.397,51593.331000000006,366890.397],[\"8/152/232\",51593.331000000006,364890.397,53593.331000000006,366890.397],[\"7/144/240\",49593.331000000006,366890.397,53593.331000000006,370890.397],[\"9/140/256\",48593.331000000006,370890.397,49593.331000000006,371890.397],[\"8/136/240\",47593.331000000006,366890.397,49593.331000000006,368890.397],[\"8/128/240\",45593.331000000006,366890.397,47593.331000000006,368890.397],[\"9/128/256\",45593.331000000006,370890.397,46593.331000000006,371890.397],[\"9/132/256\",46593.331000000006,370890.397,47593.331000000006,371890.397],[\"8/128/248\",45593.331000000006,368890.397,47593.331000000006,370890.397],[\"8/136/248\",47593.331000000006,368890.397,49593.331000000006,370890.397],[\"9/136/256\",47593.331000000006,370890.397,48593.331000000006,371890.397],[\"9/136/260\",47593.331000000006,371890.397,48593.331000000006,372890.397],[\"8/136/264\",47593.331000000006,372890.397,49593.331000000006,374890.397],[\"8/128/264\",45593.331000000006,372890.397,47593.331000000006,374890.397],[\"9/132/260\",46593.331000000006,371890.397,47593.331000000006,372890.397],[\"9/128/260\",45593.331000000006,371890.397,46593.331000000006,372890.397],[\"7/128/272\",45593.331000000006,374890.397,49593.331000000006,378890.397],[\"9/140/260\",48593.331000000006,371890.397,49593.331000000006,372890.397],[\"7/144/256\",49593.331000000006,370890.397,53593.331000000006,374890.397],[\"7/144/272\",49593.331000000006,374890.397,53593.331000000006,378890.397],[\"7/144/288\",49593.331000000006,378890.397,53593.331000000006,382890.397],[\"8/152/304\",51593.331000000006,382890.397,53593.331000000006,384890.397],[\"8/152/312\",51593.331000000006,384890.397,53593.331000000006,386890.397],[\"8/144/312\",49593.331000000006,384890.397,51593.331000000006,386890.397],[\"8/144/304\",49593.331000000006,382890.397,51593.331000000006,384890.397],[\"7/128/304\",45593.331000000006,382890.397,49593.331000000006,386890.397],[\"7/128/288\",45593.331000000006,378890.397,49593.331000000006,382890.397],[\"7/96/288\",37593.331000000006,378890.397,41593.331000000006,382890.397],[\"7/112/288\",41593.331000000006,378890.397,45593.331000000006,382890.397],[\"7/112/304\",41593.331000000006,382890.397,45593.331000000006,386890.397],[\"7/96/304\",37593.331000000006,382890.397,41593.331000000006,386890.397],[\"7/80/272\",33593.331000000006,374890.397,37593.331000000006,378890.397],[\"7/80/256\",33593.331000000006,370890.397,37593.331000000006,374890.397],[\"6/96/256\",37593.331000000006,370890.397,45593.331000000006,378890.397],[\"7/112/240\",41593.331000000006,366890.397,45593.331000000006,370890.397],[\"7/96/240\",37593.331000000006,366890.397,41593.331000000006,370890.397],[\"8/40/256\",23593.331000000006,370890.397,25593.331000000006,372890.397],[\"7/48/256\",25593.331000000006,370890.397,29593.331000000006,374890.397],[\"8/40/264\",23593.331000000006,372890.397,25593.331000000006,374890.397],[\"7/48/272\",25593.331000000006,374890.397,29593.331000000006,378890.397],[\"7/64/256\",29593.331000000006,370890.397,33593.331000000006,374890.397],[\"7/64/272\",29593.331000000006,374890.397,33593.331000000006,378890.397],[\"6/64/288\",29593.331000000006,378890.397,37593.331000000006,386890.397],[\"10/62/316\",29093.331000000006,385890.397,29593.331000000006,386390.397],[\"10/62/318\",29093.331000000006,386390.397,29593.331000000006,386890.397],[\"10/60/318\",28593.331000000006,386390.397,29093.331000000006,386890.397],[\"10/60/316\",28593.331000000006,385890.397,29093.331000000006,386390.397],[\"10/60/314\",28593.331000000006,385390.397,29093.331000000006,385890.397],[\"10/60/312\",28593.331000000006,384890.397,29093.331000000006,385390.397],[\"10/62/314\",29093.331000000006,385390.397,29593.331000000006,385890.397],[\"10/62/312\",29093.331000000006,384890.397,29593.331000000006,385390.397],[\"9/56/312\",27593.331000000006,384890.397,28593.331000000006,385890.397],[\"9/56/316\",27593.331000000006,385890.397,28593.331000000006,386890.397],[\"8/48/312\",25593.331000000006,384890.397,27593.331000000006,386890.397],[\"8/48/296\",25593.331000000006,380890.397,27593.331000000006,382890.397],[\"8/56/288\",27593.331000000006,378890.397,29593.331000000006,380890.397],[\"8/48/288\",25593.331000000006,378890.397,27593.331000000006,380890.397],[\"7/32/288\",21593.331000000006,378890.397,25593.331000000006,382890.397],[\"6/0/288\",13593.331000000006,378890.397,21593.331000000006,386890.397],[\"8/8/280\",15593.331000000006,376890.397,17593.331000000006,378890.397],[\"8/0/280\",13593.331000000006,376890.397,15593.331000000006,378890.397],[\"8/0/272\",13593.331000000006,374890.397,15593.331000000006,376890.397],[\"7/0/256\",13593.331000000006,370890.397,17593.331000000006,374890.397],[\"8/8/272\",15593.331000000006,374890.397,17593.331000000006,376890.397],[\"7/16/272\",17593.331000000006,374890.397,21593.331000000006,378890.397],[\"7/32/272\",21593.331000000006,374890.397,25593.331000000006,378890.397],[\"8/32/264\",21593.331000000006,372890.397,23593.331000000006,374890.397],[\"7/16/256\",17593.331000000006,370890.397,21593.331000000006,374890.397],[\"8/32/256\",21593.331000000006,370890.397,23593.331000000006,372890.397],[\"7/16/240\",17593.331000000006,366890.397,21593.331000000006,370890.397],[\"7/0/240\",13593.331000000006,366890.397,17593.331000000006,370890.397],[\"7/0/224\",13593.331000000006,362890.397,17593.331000000006,366890.397],[\"7/16/224\",17593.331000000006,362890.397,21593.331000000006,366890.397],[\"6/32/224\",21593.331000000006,362890.397,29593.331000000006,370890.397],[\"6/64/224\",29593.331000000006,362890.397,37593.331000000006,370890.397]]"), EF = "v20250903";
function DF(e) {
	return TF.filter(([, t, n, r, i]) => t <= e[2] && r >= e[0] && n <= e[3] && i >= e[1]);
}
function OF(e) {
	if (!TF.some((t) => t[0] === e)) throw Error("Onbekende 3DBAG-tegel.");
	return `https://data.3dbag.nl/${EF}/tiles/${e}/${e.replaceAll("/", "-")}.city.json.gz`;
}
//#endregion
//#region lib/tile-transfer.ts
async function kF(e, t, n = 3e4) {
	let r = new AbortController(), i = setTimeout(() => r.abort(new DOMException("De tegelserver antwoordt niet op tijd.", "TimeoutError")), n);
	try {
		return await e(t, { signal: AbortSignal.any([r.signal, AbortSignal.timeout(1e5)]) });
	} finally {
		clearTimeout(i);
	}
}
async function AF(e, t = 2e3) {
	if (!e) return;
	let n;
	try {
		return await Promise.race([e.catch(() => void 0), new Promise((e) => {
			n = setTimeout(() => e(void 0), t);
		})]);
	} finally {
		clearTimeout(n);
	}
}
async function jF(e, t, n = 2e4) {
	if (!e.body) throw Error("De gebouwtegel bevat geen gegevens.");
	let r = e.body.getReader(), i = [], a = 0;
	try {
		for (;;) {
			let e, o;
			try {
				o = await Promise.race([r.read(), new Promise((t, r) => {
					e = setTimeout(() => r(/* @__PURE__ */ Error("De download levert geen nieuwe gegevens meer.")), n);
				})]);
			} finally {
				clearTimeout(e);
			}
			if (o.done) break;
			i.push(o.value), a += o.value.length, t(a);
		}
	} catch (e) {
		throw r.cancel().catch(() => void 0), e;
	} finally {
		r.releaseLock();
	}
	let o = new Uint8Array(a), s = 0;
	for (let e of i) o.set(e, s), s += e.length;
	return o;
}
//#endregion
//#region lib/geodata.ts
var MF = "https://api.pdok.nl/bzk/locatieserver/search/v3_1/free", NF = "https://api.3dbag.nl/collections/pand/items", PF = /* @__PURE__ */ new Map();
async function FF(e, t, n) {
	let r = 0, i = !1, a = Array.from({ length: Math.min(t, e.length) }, async () => {
		for (; !i && r < e.length;) {
			let t = e[r++];
			try {
				await n(t);
			} catch (e) {
				throw i = !0, e;
			}
		}
	});
	await Promise.all(a);
}
function IF(e) {
	return new Promise((t) => setTimeout(t, e));
}
function LF(e, t) {
	return typeof window < "u" ? new URL(e, window.__PLEKBEELD_API_ORIGIN__ || window.location.origin) : new URL(t);
}
function RF(e) {
	return e && typeof e == "object" ? e : void 0;
}
function zF(e) {
	return typeof e == "number" && Number.isFinite(e) ? e : void 0;
}
function BF(e) {
	if (typeof e != "string") return;
	let t = e.match(/POINT\(\s*([-+\d.]+)\s+([-+\d.]+)\s*\)/i);
	if (!t) return;
	let n = [Number(t[1]), Number(t[2])];
	return n.every(Number.isFinite) ? n : void 0;
}
async function VF(e, t = fetch) {
	let n = e.trim();
	if (n.length < 3) return [];
	let r = LF("/api/geodata/search", MF);
	r.searchParams.set("q", n), r.searchParams.set("rows", "8");
	let i = await t(r, {
		headers: { Accept: "application/json" },
		signal: AbortSignal.timeout(15e3)
	});
	if (!i.ok) throw Error(`PDOK gaf status ${i.status}.`);
	let a = RF(RF(await i.json())?.response)?.docs;
	if (!Array.isArray(a)) return [];
	let o = [];
	for (let e of a) {
		let t = RF(e), n = BF(t?.centroide_rd);
		if (!t || !n || typeof t.weergavenaam != "string") continue;
		let r = BF(t.centroide_ll);
		o.push({
			id: typeof t.id == "string" ? t.id : `${n[0]}-${n[1]}`,
			label: t.weergavenaam,
			type: typeof t.type == "string" ? t.type : "locatie",
			x: n[0],
			y: n[1],
			longitude: r?.[0],
			latitude: r?.[1]
		});
	}
	let s = (e) => e === "adres" ? 0 : e === "woonplaats" ? 1 : e === "weg" ? 2 : e === "postcode" ? 3 : e === "gemeente" ? 5 : 4;
	return o.sort((e, t) => s(e.type) - s(t.type));
}
async function HF(e, t = fetch) {
	let n = e.trim();
	if (n.length < 2) return [];
	let r = LF("/api/geodata/search", MF);
	r.searchParams.set("scope", "world"), r.searchParams.set("q", n);
	let i = await t(r, {
		headers: { Accept: "application/json" },
		signal: AbortSignal.timeout(15e3)
	});
	if (!i.ok) throw Error(`Wereldwijde locatiezoeker gaf status ${i.status}.`);
	let a = RF(await i.json());
	return (Array.isArray(a?.results) ? a.results : []).flatMap((e) => {
		let t = RF(e), n = zF(t?.lon), r = zF(t?.lat);
		if (!t || n === void 0 || r === void 0 || typeof t.name != "string") return [];
		let [i, a] = nc([n, r]);
		return [{
			id: typeof t.gers_id == "string" ? t.gers_id : `world-${n}-${r}`,
			label: t.name,
			type: typeof t.type == "string" ? t.type : "locatie",
			x: i,
			y: a,
			longitude: n,
			latitude: r,
			coordinateSystem: "web-mercator"
		}];
	});
}
function UF(e) {
	let t = RF(e), n = t?.scale, r = t?.translate;
	if (!Array.isArray(n) || !Array.isArray(r) || n.length < 3 || r.length < 3) return;
	let i = [
		Number(n[0]),
		Number(n[1]),
		Number(n[2])
	], a = [
		Number(r[0]),
		Number(r[1]),
		Number(r[2])
	];
	if ([...i, ...a].every(Number.isFinite)) return {
		scale: i,
		translate: a
	};
}
function WF(e, t) {
	if (!Array.isArray(e)) return [];
	let n = [];
	for (let r of e) {
		if (!Array.isArray(r) || r.length < 3) {
			n.push([
				NaN,
				NaN,
				NaN
			]);
			continue;
		}
		n.push([
			Number(r[0]) * t.scale[0] + t.translate[0],
			Number(r[1]) * t.scale[1] + t.translate[1],
			Number(r[2]) * t.scale[2] + t.translate[2]
		]);
	}
	return n;
}
function GF(e, t) {
	let n = e.geometry;
	if (!Array.isArray(n)) return;
	let r = n.map(RF).find((e) => e?.lod === "0" && e.type === "MultiSurface");
	if (!r || !Array.isArray(r.boundaries)) return;
	let i;
	for (let e of r.boundaries) {
		if (!Array.isArray(e) || !Array.isArray(e[0])) continue;
		let n = UP(e[0].map((e) => t[Number(e)]).filter((e) => !!e?.every(Number.isFinite)).map((e) => [e[0], e[1]]));
		n.length < 3 || (!i || Math.abs(VP(n)) > Math.abs(VP(i))) && (i = n);
	}
	return i;
}
function KF(e, t, n, r) {
	let i = RF(t.attributes), a = `b3_val3dity_lod${r.replace(".", "")}`;
	if (i?.[a] !== "[]") return;
	let o = Array.isArray(t.children) ? t.children : [], s = [], c = [t, ...o.filter((e) => typeof e == "string").map((t) => RF(e[t])).filter((e) => !!e)];
	for (let e of c) {
		let t = (Array.isArray(e?.geometry) ? e.geometry.map(RF) : []).find((e) => e?.lod === r && e.type === "Solid");
		if (!t || !Array.isArray(t.boundaries)) continue;
		let i = t.boundaries[0];
		if (Array.isArray(i)) for (let e of i) {
			if (!Array.isArray(e) || e.length !== 1 || !Array.isArray(e[0])) return;
			let t = e[0].map((e) => n[Number(e)]).filter((e) => !!e?.every(Number.isFinite));
			if (t.length < 3) return;
			let r = $P(t);
			if (r.length === 0) return;
			s.push(...r);
		}
	}
	return s.length > 0 ? s : void 0;
}
function qF(e) {
	let t = e.buildingLod ?? "auto";
	return t === "lod22" ? "2.2" : t === "lod13" ? "1.3" : t === "lod12" ? "1.2" : e.areaMeters <= 500 ? "2.2" : e.areaMeters <= 800 ? "1.3" : "1.2";
}
function JF(e, t, n, r) {
	let i = RF(e), a = RF(i?.CityObjects);
	if (!i || !a) return;
	let o = typeof i.id == "string" ? i.id : void 0, s = (o ? RF(a[o]) : void 0) ?? Object.values(a).map(RF).find((e) => e?.type === "Building");
	if (!s) return;
	let c = o ?? (typeof RF(s.attributes)?.identificatie == "string" ? String(RF(s.attributes)?.identificatie) : `building-${Math.random()}`), l = r ?? WF(i.vertices, t), u = GF(s, l);
	if (!u) return;
	let [d, f, p, m] = dF(n), h = YP(u, d, f, p, m);
	if (h.length < 3 || Math.abs(VP(h)) < 1) return;
	let g = RF(s.attributes) ?? {}, _ = zF(g.b3_h_maaiveld) ?? 0, v = zF(g.b3_h_dak_70p) ?? zF(g.b3_h_dak_50p) ?? zF(g.b3_h_dak_max) ?? _ + 3.2, y = Math.min(120, Math.max(2.4, v - _)), b = h.length !== u.length || h.some((e, t) => {
		let n = u[t];
		return !n || Math.abs(e[0] - n[0]) > 1e-5 || Math.abs(e[1] - n[1]) > 1e-5;
	}), x = qF(n), S = n.roofMode === "detailed" && !b ? KF(a, s, l, x) : void 0;
	return {
		id: c,
		footprint: h,
		groundMeters: _,
		heightMeters: y,
		detailedTriangles: S,
		sourceLod: S ? `LoD${x}` : "LoD0"
	};
}
async function YF(e, t, n) {
	let r = UF(e.transform), i = RF(e.CityObjects);
	if (e.type !== "CityJSON" || !r || !i || !Array.isArray(e.vertices)) throw Error("Ongeldige CityJSON-tegel.");
	let a = WF(e.vertices, r), o = [], s = 0;
	for (let [e, c] of Object.entries(i)) {
		if (RF(c)?.type !== "Building") continue;
		let l = JF({
			id: e,
			CityObjects: i
		}, r, t, a);
		l && o.push(l), ++s % 100 == 0 && (await IF(0), n?.());
	}
	return o;
}
async function XF(e, t = fetch, n) {
	let r = DF(dF(e));
	if (!r.length) throw Error("Geen 3DBAG-tegels voor deze selectie gevonden.");
	let i = /* @__PURE__ */ new Map(), a = 0, o = /* @__PURE__ */ new Map(), s = () => n?.({
		stage: "buildings",
		completed: a,
		total: r.length,
		message: `Gebouwtegels laden: ${a} van ${r.length} delen${o.size ? " · " + [...o.values()].join(" / ") : ""}`
	});
	s();
	let c = typeof window < "u" && typeof caches < "u" ? await AF(caches.open(`3dbag-${EF}`)) : void 0;
	return await FF(r, 2, async ([n]) => {
		let r = LF("/api/geodata/building-tile", OF(n));
		typeof window < "u" && r.searchParams.set("id", n);
		let l;
		for (let e = 0; e < 3; e++) try {
			o.set(n, e ? `opnieuw proberen (${e + 1}/3)` : "verbinding maken"), s();
			let i = await AF(c?.match(r.toString())), a = i ?? await kF(t, r);
			if (!a.ok) throw Error(`Gebouwtegel ${n}: status ${a.status}.`);
			let u = 0, d = await jF(a, (e) => {
				o.set(n, `${i ? "opgeslagen tegel" : "download"} ${(e / 1e6).toFixed(1)} MB`), Date.now() - u > 250 && (s(), u = Date.now());
			});
			o.set(n, "tegel uitpakken"), s(), await IF(0);
			let f = d[0] === 31 && d[1] === 139 ? TN(d) : d;
			if (l = RF(JSON.parse(new TextDecoder().decode(f))), l?.type !== "CityJSON") throw Error("Geen geldig CityJSON-bestand ontvangen.");
			if (c && !i) try {
				let e = await AF(c.keys()) ?? [];
				for (let t of e.slice(0, Math.max(0, e.length - 23))) await AF(c.delete(t));
				await AF(c.put(r.toString(), new Response(d)));
			} catch {}
			break;
		} catch (t) {
			if (t instanceof Error && t.name === "AbortError") throw t;
			if (await AF(c?.delete(r.toString())), e === 2) throw Error(`Gebouwtegel ${n} kon niet worden geladen. Probeer opnieuw; gedownloade tegels blijven bewaard.`, { cause: t });
			await IF(500 * (e + 1));
		}
		o.set(n, "gebouwen verwerken"), s();
		for (let t of await YF(l, e, () => {
			typeof window < "u" && s();
		})) i.set(t.id, t);
		o.delete(n), a++, s();
	}), {
		buildings: [...i.values()],
		warnings: [],
		matchedCount: i.size
	};
}
async function ZF(e, t = fetch, n) {
	if (e.areaMeters > 800 && qF(e) === "2.2") return XF(e, t, n);
	let r = /* @__PURE__ */ new Map(), i = [], a = 0, o = qF(e), [s, c, l, u] = dF(e), d = o === "2.2" ? 750 : o === "1.3" ? 900 : 1100, f = Math.max(1, Math.ceil((l - s) / d)), p = Math.max(1, Math.ceil((u - c) / d)), m = (l - s) / f, h = (u - c) / p, g = e.areaMeters > 800 ? 6 : 4, _ = Array.from({ length: p * f }, (e, t) => {
		let n = t % f, r = Math.floor(t / f);
		return [
			s + n * m,
			c + r * h,
			s + (n + 1) * m,
			c + (r + 1) * h
		];
	}), v = (e, t = 0) => {
		let n = LF("/api/geodata/buildings", NF);
		return n.searchParams.set("bbox", e.map((e) => e.toFixed(3)).join(",")), n.searchParams.set("limit", "100"), t > 0 && n.searchParams.set("offset", String(t)), n.toString();
	}, y = async (e) => {
		let n = PF.get(e), r = t === fetch || typeof window < "u";
		if (r && n && n.expires > Date.now()) return n.payload;
		let i = 0;
		for (let n = 0; n < 4; n += 1) {
			let a;
			try {
				a = await t(e, {
					headers: { Accept: "application/json" },
					signal: AbortSignal.timeout(55e3)
				});
			} catch (e) {
				if (e instanceof DOMException && e.name === "AbortError") throw e;
				if (n === 3) throw Error("3DBAG reageerde vier keer niet binnen 55 seconden.", { cause: e });
				await IF(Math.min(5e3, 450 * 2 ** n + Math.random() * 280));
				continue;
			}
			if (a.ok) {
				let t = RF(await a.json());
				if (!t) throw Error("3DBAG gaf geen geldig JSON-object terug.");
				if (r) {
					for (; PF.size >= 64;) PF.delete(PF.keys().next().value);
					PF.set(e, {
						expires: Date.now() + 10 * 6e4,
						payload: t
					});
				}
				return t;
			}
			if (i = a.status, ![
				429,
				502,
				503,
				504
			].includes(a.status) || n === 3) break;
			let o = Number(a.headers.get("retry-after"));
			await IF(Number.isFinite(o) && o > 0 ? Math.min(1e4, o * 1e3) : Math.min(8e3, 450 * 2 ** n + Math.random() * 280));
		}
		throw Error(`3DBAG bleef tijdelijk onbereikbaar (status ${i || 502}) na 4 pogingen.`);
	}, b = (t, n) => {
		let i = Array.isArray(t?.features) ? t.features : [];
		if (i.length === 0) return n;
		let a = UF(RF(t?.metadata)?.transform) ?? n;
		if (!a) throw Error("De 3DBAG-coördinatentransformatie ontbreekt.");
		for (let t of i) {
			let n = JF(t, a, e);
			n && r.set(n.id, n);
		}
		return a;
	}, x = [], S = 0, C = 0;
	n?.({
		stage: "buildings",
		completed: 0,
		total: _.length,
		message: `Gebouwen zoeken: 0 van ${_.length} gebieden`
	}), await FF(_, g, async (e) => {
		try {
			let t = await y(v(e)), n = zF(t.numberMatched) ?? 0;
			a += n;
			let r = Array.isArray(t.links) ? t.links.map(RF) : [], i = r.some((e) => e?.rel === "next" && typeof e.href == "string") ? Math.max(2, Math.ceil(n / 100)) : 1, o = r.find((e) => e?.rel === "next" && typeof e.href == "string"), s = o ? Number(new URL(String(o.href), NF).searchParams.get("offset")) : 0, c = Number.isInteger(s) && s > 0 ? s : 100, l = b(t);
			x.push({
				bounds: e,
				pageCount: i,
				firstOffset: c,
				transform: l
			});
		} catch (e) {
			if (e instanceof DOMException && e.name === "AbortError") throw e;
			S += 1;
		} finally {
			C += 1, n?.({
				stage: "buildings",
				completed: C,
				total: _.length,
				message: `Gebouwen zoeken: ${C} van ${_.length} gebieden`
			});
		}
	});
	let w = x.flatMap((e) => Array.from({ length: Math.max(0, e.pageCount - 1) }, (t, n) => ({
		bounds: e.bounds,
		offset: e.firstOffset + n * 100,
		transform: e.transform
	}))), T = x.length + w.length, E = x.length, D = 0;
	return n?.({
		stage: "buildings",
		completed: E,
		total: Math.max(1, T),
		message: `Gebouwen laden: ${E} van ${Math.max(1, T)} delen`
	}), await FF(w, g, async (e) => {
		try {
			b(await y(v(e.bounds, e.offset)), e.transform);
		} catch (e) {
			if (e instanceof DOMException && e.name === "AbortError") throw e;
			D += 1;
		} finally {
			E += 1, n?.({
				stage: "buildings",
				completed: E,
				total: Math.max(1, T),
				message: `Gebouwen laden: ${E} van ${Math.max(1, T)} delen`
			});
		}
	}), (S > 0 || D > 0) && i.push(`${S} 3DBAG-tegels en ${D} vervolgpagina's bleven na automatische retries ontbreken. Probeer de ontbrekende tegels opnieuw; reeds geladen tegels komen uit de cache.`), r.size === 0 && i.push("Binnen deze uitsnede zijn geen bruikbare 3DBAG-gebouwen gevonden."), {
		buildings: [...r.values()],
		warnings: i,
		matchedCount: a
	};
}
//#endregion
//#region node_modules/@mapbox/point-geometry/index.js
function QF(e, t) {
	this.x = e, this.y = t;
}
QF.prototype = {
	clone() {
		return new QF(this.x, this.y);
	},
	add(e) {
		return this.clone()._add(e);
	},
	sub(e) {
		return this.clone()._sub(e);
	},
	multByPoint(e) {
		return this.clone()._multByPoint(e);
	},
	divByPoint(e) {
		return this.clone()._divByPoint(e);
	},
	mult(e) {
		return this.clone()._mult(e);
	},
	div(e) {
		return this.clone()._div(e);
	},
	rotate(e) {
		return this.clone()._rotate(e);
	},
	rotateAround(e, t) {
		return this.clone()._rotateAround(e, t);
	},
	matMult(e) {
		return this.clone()._matMult(e);
	},
	unit() {
		return this.clone()._unit();
	},
	perp() {
		return this.clone()._perp();
	},
	round() {
		return this.clone()._round();
	},
	mag() {
		return Math.sqrt(this.x * this.x + this.y * this.y);
	},
	equals(e) {
		return this.x === e.x && this.y === e.y;
	},
	dist(e) {
		return Math.sqrt(this.distSqr(e));
	},
	distSqr(e) {
		let t = e.x - this.x, n = e.y - this.y;
		return t * t + n * n;
	},
	angle() {
		return Math.atan2(this.y, this.x);
	},
	angleTo(e) {
		return Math.atan2(this.y - e.y, this.x - e.x);
	},
	angleWith(e) {
		return this.angleWithSep(e.x, e.y);
	},
	angleWithSep(e, t) {
		return Math.atan2(this.x * t - this.y * e, this.x * e + this.y * t);
	},
	_matMult(e) {
		let t = e[0] * this.x + e[1] * this.y, n = e[2] * this.x + e[3] * this.y;
		return this.x = t, this.y = n, this;
	},
	_add(e) {
		return this.x += e.x, this.y += e.y, this;
	},
	_sub(e) {
		return this.x -= e.x, this.y -= e.y, this;
	},
	_mult(e) {
		return this.x *= e, this.y *= e, this;
	},
	_div(e) {
		return this.x /= e, this.y /= e, this;
	},
	_multByPoint(e) {
		return this.x *= e.x, this.y *= e.y, this;
	},
	_divByPoint(e) {
		return this.x /= e.x, this.y /= e.y, this;
	},
	_unit() {
		return this._div(this.mag()), this;
	},
	_perp() {
		let e = this.y;
		return this.y = this.x, this.x = -e, this;
	},
	_rotate(e) {
		let t = Math.cos(e), n = Math.sin(e), r = t * this.x - n * this.y, i = n * this.x + t * this.y;
		return this.x = r, this.y = i, this;
	},
	_rotateAround(e, t) {
		let n = Math.cos(e), r = Math.sin(e), i = t.x + n * (this.x - t.x) - r * (this.y - t.y), a = t.y + r * (this.x - t.x) + n * (this.y - t.y);
		return this.x = i, this.y = a, this;
	},
	_round() {
		return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
	},
	constructor: QF
}, QF.convert = function(e) {
	if (e instanceof QF) return e;
	if (Array.isArray(e)) return new QF(+e[0], +e[1]);
	if (e.x !== void 0 && e.y !== void 0) return new QF(+e.x, +e.y);
	throw Error("Expected [x, y] or {x, y} point format");
};
//#endregion
//#region node_modules/@mapbox/vector-tile/index.js
var $F = class {
	constructor(e, t, n, r, i) {
		for (this.properties = Object.create(null), this.extent = n, this.type = 0, this.id = void 0, this._pbf = e, this._geometry = -1, this._keys = r, this._values = i; e.pos < t;) {
			let t = e.readVarint();
			if (t === 8) this.id = e.readVarint();
			else if (t === 18) {
				let t = e.readVarint() + e.pos;
				for (; e.pos < t;) {
					let t = r[e.readVarint()], n = i[e.readVarint()];
					this.properties[t] = n;
				}
			} else t === 24 ? this.type = e.readVarint() : (t === 34 && (this._geometry = e.pos), e.skip(t));
		}
	}
	loadGeometry() {
		if (this._geometry < 0) throw Error("feature has no geometry");
		let e = this._pbf;
		e.pos = this._geometry;
		let t = e.readVarint() + e.pos, n = [], r, i = 1, a = 0, o = 0, s = 0;
		for (; e.pos < t;) {
			if (a <= 0) {
				let t = e.readVarint();
				if (i = t & 7, a = t >> 3, a === 0) continue;
			}
			if (a--, i === 1) o += e.readSVarint(), s += e.readSVarint(), r && n.push(r), r = [new QF(o, s)];
			else if (i === 2) o += e.readSVarint(), s += e.readSVarint(), r && r.push(new QF(o, s));
			else if (i === 7) r && r.push(r[0].clone());
			else throw Error(`unknown command ${i}`);
		}
		return r && n.push(r), n;
	}
	bbox() {
		if (this._geometry < 0) throw Error("feature has no geometry");
		let e = this._pbf;
		e.pos = this._geometry;
		let t = e.readVarint() + e.pos, n = 1, r = 0, i = 0, a = 0, o = Infinity, s = -Infinity, c = Infinity, l = -Infinity;
		for (; e.pos < t;) {
			if (r <= 0) {
				let t = e.readVarint();
				if (n = t & 7, r = t >> 3, r === 0) continue;
			}
			if (r--, n === 1 || n === 2) i += e.readSVarint(), a += e.readSVarint(), i < o && (o = i), i > s && (s = i), a < c && (c = a), a > l && (l = a);
			else if (n !== 7) throw Error(`unknown command ${n}`);
		}
		return [
			o,
			c,
			s,
			l
		];
	}
	toGeoJSON(e, t, n) {
		let r = this.extent * 2 ** n, i = this.extent * e, a = this.extent * t, o = this.loadGeometry();
		function s(e) {
			return [(e.x + i) * 360 / r - 180, 360 / Math.PI * Math.atan(Math.exp((1 - (e.y + a) * 2 / r) * Math.PI)) - 90];
		}
		function c(e) {
			return e.map(s);
		}
		let l;
		if (this.type === 1) {
			let e = [];
			for (let t of o) e.push(t[0]);
			let t = c(e);
			l = e.length === 1 ? {
				type: "Point",
				coordinates: t[0]
			} : {
				type: "MultiPoint",
				coordinates: t
			};
		} else if (this.type === 2) {
			let e = o.map(c);
			l = e.length === 1 ? {
				type: "LineString",
				coordinates: e[0]
			} : {
				type: "MultiLineString",
				coordinates: e
			};
		} else if (this.type === 3) {
			let e = eI(o), t = [];
			for (let n of e) t.push(n.map(c));
			l = t.length === 1 ? {
				type: "Polygon",
				coordinates: t[0]
			} : {
				type: "MultiPolygon",
				coordinates: t
			};
		} else throw Error("unknown feature type");
		let u = {
			type: "Feature",
			geometry: l,
			properties: this.properties
		};
		return this.id != null && (u.id = this.id), u;
	}
};
$F.types = [
	"Unknown",
	"Point",
	"LineString",
	"Polygon"
];
function eI(e) {
	let t = e.length;
	if (t <= 1) return [e];
	let n = [], r, i;
	for (let a = 0; a < t; a++) {
		let t = tI(e[a]);
		t !== 0 && (i === void 0 && (i = t < 0), i === t < 0 ? (r && n.push(r), r = [e[a]]) : r && r.push(e[a]));
	}
	return r && n.push(r), n;
}
function tI(e) {
	let t = 0;
	for (let n = 0, r = e.length, i = r - 1, a, o; n < r; i = n++) a = e[n], o = e[i], t += (o.x - a.x) * (a.y + o.y);
	return t;
}
var nI = class {
	constructor(e, t) {
		for (this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = e, this._keys = [], this._values = [], this._features = [], t === void 0 && (t = e.length); e.pos < t;) {
			let t = e.readVarint();
			t === 10 ? this.name = e.readString() : t === 18 ? (this._features.push(e.pos), e.skip(t)) : t === 26 ? this._keys.push(e.readString()) : t === 34 ? this._values.push(rI(e)) : t === 40 ? this.extent = e.readVarint() : t === 120 ? this.version = e.readVarint() : e.skip(t);
		}
		this.length = this._features.length;
	}
	feature(e) {
		if (e < 0 || e >= this._features.length) throw Error("feature index out of bounds");
		this._pbf.pos = this._features[e];
		let t = this._pbf.readVarint() + this._pbf.pos;
		return new $F(this._pbf, t, this.extent, this._keys, this._values);
	}
};
function rI(e) {
	let t = null, n = e.readVarint() + e.pos;
	for (; e.pos < n;) {
		let n = e.readVarint();
		t = n === 10 ? e.readString() : n === 21 ? e.readFloat() : n === 25 ? e.readDouble() : n === 32 ? e.readVarint(!0) : n === 40 ? e.readVarint() : n === 48 ? e.readSVarint() : n === 56 ? e.readBoolean() : (e.skip(n), null);
	}
	if (t == null) throw Error("unknown feature value");
	return t;
}
var iI = class {
	constructor(e, t = e.length) {
		let n = Object.create(null);
		for (; e.pos < t;) {
			let t = e.readVarint();
			if (t === 26) {
				let t = new nI(e, e.readVarint() + e.pos);
				t.length && (n[t.name] = t);
			} else e.skip(t);
		}
		this.layers = n;
	}
};
//#endregion
//#region node_modules/@petamoriken/float16/src/_util/primordials.mjs
function aI(e) {
	return (t, ...n) => sI(e, t, n);
}
function oI(e, t) {
	return aI(dI(e, t).get);
}
var { apply: sI, construct: cI, defineProperty: lI, get: uI, getOwnPropertyDescriptor: dI, getPrototypeOf: fI, has: pI, ownKeys: mI, set: hI, setPrototypeOf: gI } = Reflect, { EPSILON: _I, MAX_SAFE_INTEGER: vI, isFinite: yI, isNaN: bI } = Number, { iterator: xI, species: SI, toStringTag: CI, for: wI } = Symbol, TI = Object, { create: EI, defineProperty: DI, freeze: OI, is: kI } = TI, AI = TI.prototype;
AI.__lookupGetter__ && AI.__lookupGetter__, TI.hasOwn || AI.hasOwnProperty;
var jI = Array;
jI.isArray;
var MI = jI.prototype;
MI.join, MI.push, MI.toLocaleString;
var NI = MI[xI], PI = aI(NI), { abs: FI, trunc: II } = Math, LI = ArrayBuffer;
LI.isView;
var RI = LI.prototype;
RI.slice, oI(RI, "byteLength");
var zI = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : null;
zI && oI(zI.prototype, "byteLength");
var BI = fI(Uint8Array);
BI.from;
var VI = BI.prototype;
VI[xI], VI.keys, VI.values, VI.entries, VI.set, VI.reverse, VI.fill, VI.copyWithin, VI.sort, VI.slice, VI.subarray, oI(VI, "buffer"), oI(VI, "byteOffset"), oI(VI, "length"), oI(VI, CI);
var HI = Uint8Array, UI = Uint16Array, WI = Uint32Array, GI = Float32Array, KI = fI([][xI]()), qI = aI(KI.next), JI = aI((function* () {})().next), YI = fI(KI), XI = DataView.prototype, ZI = aI(XI.getUint16);
XI.setUint16;
var QI = WeakSet.prototype;
QI.add, QI.has;
var $I = WeakMap, eL = $I.prototype, tL = aI(eL.get);
eL.has;
var nL = aI(eL.set), rL = new $I(), iL = EI(null, {
	next: { value: function() {
		return qI(tL(rL, this));
	} },
	[xI]: { value: function() {
		return this;
	} }
});
function aL(e) {
	if (e[xI] === NI && KI.next === qI) return e;
	let t = EI(iL);
	return nL(rL, t, PI(e)), t;
}
var oL = new $I(), sL = EI(YI, { next: {
	value: function() {
		return JI(tL(oL, this));
	},
	writable: !0,
	configurable: !0
} });
for (let e of mI(KI)) e !== "next" && DI(sL, e, dI(KI, e));
//#endregion
//#region node_modules/@petamoriken/float16/src/_util/converter.mjs
var cL = 1 / _I, lL = 6103515625e-14, uL = .0009765625;
uL * lL, uL * cL;
var dL = new LI(4), fL = new GI(dL), pL = new WI(dL), mL = new UI(512), hL = new HI(512);
for (let e = 0; e < 256; ++e) {
	let t = e - 127;
	t < -24 ? (mL[e] = 0, mL[e | 256] = 32768, hL[e] = 24, hL[e | 256] = 24) : t < -14 ? (mL[e] = 1024 >> -t - 14, mL[e | 256] = 1024 >> -t - 14 | 32768, hL[e] = -t - 1, hL[e | 256] = -t - 1) : t <= 15 ? (mL[e] = t + 15 << 10, mL[e | 256] = t + 15 << 10 | 32768, hL[e] = 13, hL[e | 256] = 13) : t < 128 ? (mL[e] = 31744, mL[e | 256] = 64512, hL[e] = 24, hL[e | 256] = 24) : (mL[e] = 31744, mL[e | 256] = 64512, hL[e] = 13, hL[e | 256] = 13);
}
var gL = new WI(2048);
for (let e = 1; e < 1024; ++e) {
	let t = e << 13, n = 0;
	for (; !(t & 8388608);) t <<= 1, n -= 8388608;
	t &= -8388609, n += 947912704, gL[e] = t | n;
}
for (let e = 1024; e < 2048; ++e) gL[e] = 939524096 + (e - 1024 << 13);
var _L = new WI(64);
for (let e = 1; e < 31; ++e) _L[e] = e << 23;
_L[31] = 1199570944, _L[32] = 2147483648;
for (let e = 33; e < 63; ++e) _L[e] = 2147483648 + (e - 32 << 23);
_L[63] = 3347054592;
var vL = new UI(64);
for (let e = 1; e < 64; ++e) e !== 32 && (vL[e] = 1024);
function yL(e) {
	let t = e >> 10;
	return pL[0] = gL[vL[t] + (e & 1023)] + _L[t], fL[0];
}
//#endregion
//#region node_modules/@petamoriken/float16/src/DataView.mjs
function bL(e, t, ...n) {
	return yL(ZI(e, t, ...aL(n)));
}
//#endregion
//#region node_modules/xml-utils/get-attribute.mjs
function xL(e, t, n) {
	let r = n && n.debug || !1;
	r && console.log("[xml-utils] getting " + t + " in " + e);
	let i = typeof e == "object" ? e.outer : e, a = i.slice(0, i.indexOf(">") + 1), o = ["\"", "'"];
	for (let e = 0; e < o.length; e++) {
		let n = o[e], i = t + "\\=" + n + "([^" + n + "]*)" + n;
		r && console.log("[xml-utils] pattern:", i);
		let s = new RegExp(i).exec(a);
		if (r && console.log("[xml-utils] match:", s), s) return s[1];
	}
}
//#endregion
//#region node_modules/xml-utils/index-of-match.mjs
function SL(e, t, n) {
	let r = new RegExp(t).exec(e.slice(n));
	return r ? n + r.index : -1;
}
//#endregion
//#region node_modules/xml-utils/index-of-match-end.mjs
function CL(e, t, n) {
	let r = new RegExp(t).exec(e.slice(n));
	return r ? n + r.index + r[0].length - 1 : -1;
}
//#endregion
//#region node_modules/xml-utils/count-substring.mjs
function wL(e, t) {
	let n = new RegExp(t, "g"), r = e.match(n);
	return r ? r.length : 0;
}
//#endregion
//#region node_modules/xml-utils/find-tag-by-name.mjs
function TL(e, t, n) {
	let r = n && n.debug || !1, i = n && n.startIndex || 0;
	r && console.log("[xml-utils] starting findTagByName with", t, " and ", n);
	let a = SL(e, `\<${t}[ \n\>\/]`, i);
	if (r && console.log("[xml-utils] start:", a), a === -1) return;
	let o = e.slice(a + t.length), s = CL(o, "^[^<]*[ /]>", 0), c = s !== -1 && o[s - 1] === "/";
	if (r && console.log("[xml-utils] selfClosing:", c), c === !1) {
		let e = 0, n = 1, r = 0;
		for (; (s = CL(o, "[ /]" + t + ">", e)) !== -1;) {
			let i = o.substring(e, s + 1);
			if (n += wL(i, "<" + t + "[ \n	>]"), r += wL(i, "</" + t + ">"), r >= n) break;
			e = s;
		}
	}
	let l = a + t.length + s + 1;
	if (r && console.log("[xml-utils] end:", l), l === -1) return;
	let u = e.slice(a, l), d;
	return d = c ? null : u.slice(u.indexOf(">") + 1, u.lastIndexOf("<")), {
		inner: d,
		outer: u,
		start: a,
		end: l
	};
}
//#endregion
//#region node_modules/xml-utils/find-tags-by-name.mjs
function EL(e, t, n) {
	let r = [], i = n && n.debug || !1, a = n && typeof n.nested == "boolean" ? n.nested : !0, o = n && n.startIndex || 0, s;
	for (; s = TL(e, t, {
		debug: i,
		startIndex: o
	});) o = a ? s.start + 1 + t.length : s.end, r.push(s);
	return i && console.log("findTagsByName found", r.length, "tags"), r;
}
//#endregion
//#region node_modules/geotiff/dist-module/rgb.js
function DL(e, t) {
	let { width: n, height: r } = e, i = new Uint8Array(n * r * 3), a;
	for (let n = 0, r = 0; n < e.length; ++n, r += 3) a = 256 - e[n] / t * 256, i[r] = a, i[r + 1] = a, i[r + 2] = a;
	return i;
}
function OL(e, t) {
	let { width: n, height: r } = e, i = new Uint8Array(n * r * 3), a;
	for (let n = 0, r = 0; n < e.length; ++n, r += 3) a = e[n] / t * 256, i[r] = a, i[r + 1] = a, i[r + 2] = a;
	return i;
}
function kL(e, t) {
	let { width: n, height: r } = e, i = new Uint8Array(n * r * 3), a = t.length / 3, o = t.length / 3 * 2;
	for (let n = 0, r = 0; n < e.length; ++n, r += 3) {
		let s = e[n];
		i[r] = t[s] / 65536 * 256, i[r + 1] = t[s + a] / 65536 * 256, i[r + 2] = t[s + o] / 65536 * 256;
	}
	return i;
}
function AL(e) {
	let { width: t, height: n } = e, r = new Uint8Array(t * n * 3);
	for (let t = 0, n = 0; t < e.length; t += 4, n += 3) {
		let i = e[t], a = e[t + 1], o = e[t + 2], s = e[t + 3];
		r[n] = 255 * ((255 - i) / 256) * ((255 - s) / 256), r[n + 1] = 255 * ((255 - a) / 256) * ((255 - s) / 256), r[n + 2] = 255 * ((255 - o) / 256) * ((255 - s) / 256);
	}
	return r;
}
function jL(e) {
	let { width: t, height: n } = e, r = new Uint8ClampedArray(t * n * 3);
	for (let t = 0, n = 0; t < e.length; t += 3, n += 3) {
		let i = e[t], a = e[t + 1], o = e[t + 2];
		r[n] = i + 1.402 * (o - 128), r[n + 1] = i - .34414 * (a - 128) - .71414 * (o - 128), r[n + 2] = i + 1.772 * (a - 128);
	}
	return r;
}
var ML = .95047, NL = 1, PL = 1.08883;
function FL(e) {
	let { width: t, height: n } = e, r = new Uint8Array(t * n * 3);
	for (let t = 0, n = 0; t < e.length; t += 3, n += 3) {
		let i = e[t + 0], a = e[t + 1] << 24 >> 24, o = e[t + 2] << 24 >> 24, s = (i + 16) / 116, c = a / 500 + s, l = s - o / 200, u, d, f;
		c = ML * (c * c * c > .008856 ? c * c * c : (c - 16 / 116) / 7.787), s = NL * (s * s * s > .008856 ? s * s * s : (s - 16 / 116) / 7.787), l = PL * (l * l * l > .008856 ? l * l * l : (l - 16 / 116) / 7.787), u = c * 3.2406 + s * -1.5372 + l * -.4986, d = c * -.9689 + s * 1.8758 + l * .0415, f = c * .0557 + s * -.204 + l * 1.057, u = u > .0031308 ? 1.055 * u ** (1 / 2.4) - .055 : 12.92 * u, d = d > .0031308 ? 1.055 * d ** (1 / 2.4) - .055 : 12.92 * d, f = f > .0031308 ? 1.055 * f ** (1 / 2.4) - .055 : 12.92 * f, r[n] = Math.max(0, Math.min(1, u)) * 255, r[n + 1] = Math.max(0, Math.min(1, d)) * 255, r[n + 2] = Math.max(0, Math.min(1, f)) * 255;
	}
	return r;
}
//#endregion
//#region node_modules/geotiff/dist-module/compression/index.js
var IL = /* @__PURE__ */ new Map();
async function LL(e) {
	let t = !e.hasTag("StripOffsets");
	return {
		tileWidth: t ? await e.loadValue("TileWidth") : await e.loadValue("ImageWidth"),
		tileHeight: t ? await e.loadValue("TileLength") : await e.loadValue("RowsPerStrip") || await e.loadValue("ImageLength"),
		planarConfiguration: await e.loadValue("PlanarConfiguration"),
		bitsPerSample: await e.loadValue("BitsPerSample"),
		predictor: await e.loadValue("Predictor") || 1
	};
}
function RL(e, t, n = LL, r = !0) {
	Array.isArray(e) || (e = [e]), e.forEach((e) => {
		IL.set(e, {
			importFn: t,
			decoderParameterFn: n,
			preferWorker: r
		});
	});
}
async function zL(e, t) {
	if (!IL.has(e)) throw Error(`Unknown compression method identifier: ${e}`);
	let { decoderParameterFn: n } = IL.get(e);
	return n(t);
}
async function BL(e, t) {
	if (!IL.has(e)) throw Error(`Unknown compression method identifier: ${e}`);
	let { importFn: n } = IL.get(e);
	return new (await (n()))(t);
}
var VL = [
	{
		cases: [void 0, 1],
		importFn: () => import("./chunk-CvN-Ty0s.js").then((e) => e.default),
		preferWorker: !1
	},
	{
		cases: 5,
		importFn: () => import("./chunk-BxFF-qrt.js").then((e) => e.default)
	},
	{
		cases: 6,
		importFn: () => {
			throw Error("old style JPEG compression is not supported.");
		}
	},
	{
		cases: 7,
		importFn: () => import("./chunk-CnLfhCcJ.js").then((e) => e.default),
		decoderParameterFn: async (e) => ({
			...await LL(e),
			JPEGTables: await e.loadValue("JPEGTables")
		})
	},
	{
		cases: [8, 32946],
		importFn: () => import("./chunk-g697Dhf1.js").then((e) => e.default)
	},
	{
		cases: 32773,
		importFn: () => import("./chunk-6k1-zDUq.js").then((e) => e.default)
	},
	{
		cases: 34887,
		importFn: () => import("./chunk-BL8h6oGe.js").then(async (e) => (await e.zstd.init(), e)).then((e) => e.default),
		decoderParameterFn: async (e) => ({
			...await LL(e),
			LercParameters: await e.loadValue("LercParameters")
		})
	},
	{
		cases: 5e4,
		importFn: () => import("./chunk-CluF7ii8.js").then(async (e) => (await e.zstd.init(), e)).then((e) => e.default)
	},
	{
		cases: 50001,
		importFn: () => import("./chunk-BawSDy7e.js").then((e) => e.default),
		decoderParameterFn: async (e) => ({
			...await LL(e),
			samplesPerPixel: Number(await e.loadValue("SamplesPerPixel")) || 4
		}),
		preferWorker: !1
	}
];
for (let e of VL) {
	let { cases: t, importFn: n, decoderParameterFn: r, preferWorker: i } = e;
	RL(t, n, r, i);
}
//#endregion
//#region node_modules/geotiff/dist-module/resample.js
function HL(e, t, n, r = 1) {
	return new (Object.getPrototypeOf(e)).constructor(t * n * r);
}
function UL(e, t, n, r, i) {
	let a = t / r, o = n / i;
	return e.map((e) => {
		let s = HL(e, r, i);
		for (let c = 0; c < i; ++c) {
			let i = Math.min(Math.round(o * c), n - 1);
			for (let n = 0; n < r; ++n) {
				let o = Math.min(Math.round(a * n), t - 1), l = e[i * t + o];
				s[c * r + n] = l;
			}
		}
		return s;
	});
}
function WL(e, t, n) {
	return (1 - n) * e + n * t;
}
function GL(e, t, n, r, i) {
	let a = t / r, o = n / i;
	return e.map((e) => {
		let s = HL(e, r, i);
		for (let c = 0; c < i; ++c) {
			let i = o * c, l = Math.floor(i), u = Math.min(Math.ceil(i), n - 1);
			for (let n = 0; n < r; ++n) {
				let o = a * n, d = o % 1, f = Math.floor(o), p = Math.min(Math.ceil(o), t - 1), m = e[l * t + f], h = e[l * t + p], g = e[u * t + f], _ = e[u * t + p], v = WL(WL(m, h, d), WL(g, _, d), i % 1);
				s[c * r + n] = v;
			}
		}
		return s;
	});
}
function KL(e, t, n, r, i, a = "nearest") {
	switch (a.toLowerCase()) {
		case "nearest": return UL(e, t, n, r, i);
		case "bilinear":
		case "linear": return GL(e, t, n, r, i);
		default: throw Error(`Unsupported resampling method: '${a}'`);
	}
}
function qL(e, t, n, r, i, a) {
	let o = t / r, s = n / i, c = HL(e, r, i, a);
	for (let l = 0; l < i; ++l) {
		let i = Math.min(Math.round(s * l), n - 1);
		for (let n = 0; n < r; ++n) {
			let s = Math.min(Math.round(o * n), t - 1);
			for (let o = 0; o < a; ++o) {
				let u = e[i * t * a + s * a + o];
				c[l * r * a + n * a + o] = u;
			}
		}
	}
	return c;
}
function JL(e, t, n, r, i, a) {
	let o = t / r, s = n / i, c = HL(e, r, i, a);
	for (let l = 0; l < i; ++l) {
		let i = s * l, u = Math.floor(i), d = Math.min(Math.ceil(i), n - 1);
		for (let n = 0; n < r; ++n) {
			let s = o * n, f = s % 1, p = Math.floor(s), m = Math.min(Math.ceil(s), t - 1);
			for (let o = 0; o < a; ++o) {
				let s = e[u * t * a + p * a + o], h = e[u * t * a + m * a + o], g = e[d * t * a + p * a + o], _ = e[d * t * a + m * a + o], v = WL(WL(s, h, f), WL(g, _, f), i % 1);
				c[l * r * a + n * a + o] = v;
			}
		}
	}
	return c;
}
function YL(e, t, n, r, i, a, o = "nearest") {
	switch (o.toLowerCase()) {
		case "nearest": return qL(e, t, n, r, i, a);
		case "bilinear":
		case "linear": return JL(e, t, n, r, i, a);
		default: throw Error(`Unsupported resampling method: '${o}'`);
	}
}
//#endregion
//#region node_modules/geotiff/dist-module/geotiffimage.js
function XL(e, t, n) {
	let r = 0;
	for (let i = t; i < n; ++i) r += e[i];
	return r;
}
function ZL(e, t, n) {
	let r;
	switch (e) {
		case 1:
			t <= 8 ? r = Uint8Array : t <= 16 ? r = Uint16Array : t <= 32 && (r = Uint32Array);
			break;
		case 2:
			t === 8 ? r = Int8Array : t === 16 ? r = Int16Array : t === 32 && (r = Int32Array);
			break;
		case 3:
			switch (t) {
				case 16:
				case 32:
					r = Float32Array;
					break;
				case 64:
					r = Float64Array;
					break;
				default: break;
			}
			break;
		default: break;
	}
	if (r && (typeof n == "number" || n instanceof ArrayBuffer)) return new r(n);
	throw Error("Unsupported data format/bitsPerSample");
}
function QL(e, t) {
	return (e === 1 || e === 2) && t <= 32 && t % 8 == 0 ? !1 : !(e === 3 && (t === 16 || t === 32 || t === 64));
}
function $L(e, t, n, r, i, a, o) {
	let s = new DataView(e), c = n === 2 ? o * a : o * a * r, l = n === 2 ? 1 : r, u = ZL(t, i, c), d = parseInt("1".repeat(i), 2);
	if (t === 1) {
		let e;
		e = n === 1 ? r * i : i;
		let t = a * e;
		t & 7 && (t = t + 7 & -8);
		for (let e = 0; e < o; ++e) {
			let n = e * t;
			for (let t = 0; t < a; ++t) {
				let r = n + t * l * i;
				for (let n = 0; n < l; ++n) {
					let o = r + n * i, c = (e * a + t) * l + n, f = Math.floor(o / 8), p = o % 8;
					p + i <= 8 ? u[c] = s.getUint8(f) >> 8 - i - p & d : p + i <= 16 ? u[c] = s.getUint16(f) >> 16 - i - p & d : p + i <= 24 ? u[c] = (s.getUint16(f) << 8 | s.getUint8(f + 2)) >> 24 - i - p & d : u[c] = s.getUint32(f) >> 32 - i - p & d;
				}
			}
		}
	}
	return u.buffer;
}
var eR = class {
	constructor(e, t, n, r) {
		this.fileDirectory = e, this.littleEndian = t, this.tiles = n ? [] : null, this.isTiled = !e.hasTag("StripOffsets");
		let i = e.getValue("PlanarConfiguration") ?? 1;
		if (i !== 1 && i !== 2) throw Error("Invalid planar configuration.");
		this.planarConfiguration = i, this.source = r;
	}
	getFileDirectory() {
		return this.fileDirectory;
	}
	getGeoKeys() {
		return this.fileDirectory.parseGeoKeyDirectory();
	}
	getWidth() {
		return this.fileDirectory.getValue("ImageWidth") || 0;
	}
	getHeight() {
		return this.fileDirectory.getValue("ImageLength") || 0;
	}
	getSamplesPerPixel() {
		return this.fileDirectory.getValue("SamplesPerPixel") ?? 1;
	}
	getTileWidth() {
		return this.isTiled ? this.fileDirectory.getValue("TileWidth") || 0 : this.getWidth();
	}
	getTileHeight() {
		if (this.isTiled) return this.fileDirectory.getValue("TileLength") || 0;
		let e = this.fileDirectory.hasTag("RowsPerStrip") && this.fileDirectory.getValue("RowsPerStrip");
		return e ? Math.min(e, this.getHeight()) : this.getHeight();
	}
	getBlockWidth() {
		return this.getTileWidth();
	}
	getBlockHeight(e) {
		return this.isTiled || (e + 1) * this.getTileHeight() <= this.getHeight() ? this.getTileHeight() : this.getHeight() - e * this.getTileHeight();
	}
	getBytesPerPixel() {
		let e = 0, t = this.fileDirectory.getValue("BitsPerSample") || [];
		for (let n = 0; n < t.length; ++n) e += this.getSampleByteSize(n);
		return e;
	}
	getSampleByteSize(e) {
		let t = this.fileDirectory.getValue("BitsPerSample") || [];
		if (e >= t.length) throw RangeError(`Sample index ${e} is out of range.`);
		return Math.ceil(t[e] / 8);
	}
	getReaderForSample(e) {
		let t = this.fileDirectory.getValue("SampleFormat"), n = t ? t[e] : 1, r = (this.fileDirectory.getValue("BitsPerSample") || [])[e];
		switch (n) {
			case 1:
				if (r <= 8) return DataView.prototype.getUint8;
				if (r <= 16) return DataView.prototype.getUint16;
				if (r <= 32) return DataView.prototype.getUint32;
				break;
			case 2:
				if (r <= 8) return DataView.prototype.getInt8;
				if (r <= 16) return DataView.prototype.getInt16;
				if (r <= 32) return DataView.prototype.getInt32;
				break;
			case 3:
				switch (r) {
					case 16: return function(e, t) {
						return bL(this, e, t);
					};
					case 32: return DataView.prototype.getFloat32;
					case 64: return DataView.prototype.getFloat64;
					default: break;
				}
				break;
			default: break;
		}
		throw Error("Unsupported data format/bitsPerSample");
	}
	getSampleFormat(e = 0) {
		let t = this.fileDirectory.getValue("SampleFormat");
		return t ? t[e] : 1;
	}
	getBitsPerSample(e = 0) {
		let t = this.fileDirectory.getValue("BitsPerSample");
		return t ? t[e] : 0;
	}
	getArrayForSample(e, t) {
		return ZL(this.getSampleFormat(e), this.getBitsPerSample(e), t);
	}
	async getTileOrStrip(e, t, n, r, i) {
		let a = Math.ceil(this.getWidth() / this.getTileWidth()), o = Math.ceil(this.getHeight() / this.getTileHeight()), s, { tiles: c } = this;
		if (this.planarConfiguration === 1 ? s = t * a + e : this.planarConfiguration === 2 && (s = n * a * o + t * a + e), s === void 0) throw Error("Could not determine tile or strip index.");
		let l, u;
		if (this.isTiled ? (l = Number(await this.fileDirectory.loadValueIndexed("TileOffsets", s)), u = Number(await this.fileDirectory.loadValueIndexed("TileByteCounts", s))) : (l = Number(await this.fileDirectory.loadValueIndexed("StripOffsets", s)), u = Number(await this.fileDirectory.loadValueIndexed("StripByteCounts", s))), u === 0) {
			let r = this.getBlockHeight(t) * this.getTileWidth(), i = this.planarConfiguration === 2 ? this.getSampleByteSize(n) : this.getBytesPerPixel(), a = new ArrayBuffer(r * i);
			return this.getArrayForSample(n, a).fill(this.getGDALNoData() || 0), {
				x: e,
				y: t,
				sample: n,
				data: a
			};
		}
		let d = (await this.source.fetch([{
			offset: l,
			length: u
		}], i))[0], f;
		return c === null || !c[s] ? (f = (async () => {
			let e = await r.decode(d), n = this.getSampleFormat(), i = this.getBitsPerSample();
			return QL(n, i) && (e = $L(e, n, this.planarConfiguration, this.getSamplesPerPixel(), i, this.getTileWidth(), this.getBlockHeight(t))), e;
		})(), c !== null && (c[s] = f)) : f = c[s], {
			x: e,
			y: t,
			sample: n,
			data: await f
		};
	}
	async _readRaster(e, t, n, r, i, a, o, s, c) {
		let l = this.getTileWidth(), u = this.getTileHeight(), d = this.getWidth(), f = this.getHeight(), p = Math.max(Math.floor(e[0] / l), 0), m = Math.min(Math.ceil(e[2] / l), Math.ceil(d / l)), h = Math.max(Math.floor(e[1] / u), 0), g = Math.min(Math.ceil(e[3] / u), Math.ceil(f / u)), _ = e[2] - e[0], v = this.getBytesPerPixel(), y = [], b = [];
		for (let e = 0; e < t.length; ++e) {
			if (this.planarConfiguration === 1) {
				let n = await this.fileDirectory.loadValue("BitsPerSample");
				if (typeof n != "object") throw Error("Expected BitsPerSample to be an array or typed array.");
				y.push(XL(n, 0, t[e]) / 8);
			} else y.push(0);
			b.push(this.getReaderForSample(t[e]));
		}
		let x = [], { littleEndian: S } = this;
		for (let a = h; a < g; ++a) for (let o = p; o < m; ++o) {
			let s;
			this.planarConfiguration === 1 && (s = this.getTileOrStrip(o, a, 0, i, c));
			for (let p = 0; p < t.length; ++p) {
				let m = p, h = t[p];
				if (this.planarConfiguration === 2 && (v = this.getSampleByteSize(h), s = this.getTileOrStrip(o, a, h, i, c)), !s) throw Error("Could not get tile or strip data.");
				let g = s.then((i) => {
					let a = i.data, o = new DataView(a), s = this.getBlockHeight(i.y), c = i.y * u, p = i.x * l, h = c + s, g = (i.x + 1) * l, x = b[m], C = Math.min(s, s - (h - e[3]), f - c), w = Math.min(l, l - (g - e[2]), d - p);
					for (let i = Math.max(0, e[1] - c); i < C; ++i) for (let a = Math.max(0, e[0] - p); a < w; ++a) {
						let s = (i * l + a) * v, u = x.call(o, s + y[m], S), d;
						r ? (d = (i + c - e[1]) * _ * t.length + (a + p - e[0]) * t.length + m, n[d] = u) : (d = (i + c - e[1]) * _ + a + p - e[0], n[m][d] = u);
					}
				});
				x.push(g);
			}
		}
		if (await Promise.all(x), a && e[2] - e[0] !== a || o && e[3] - e[1] !== o) {
			let i;
			i = r ? YL(n, e[2] - e[0], e[3] - e[1], a, o, t.length, s) : KL(n, e[2] - e[0], e[3] - e[1], a, o, s);
			let c = i;
			return c.width = a ?? e[2] - e[0], c.height = o ?? e[3] - e[1], c;
		}
		let C = n;
		return C.width = a || e[2] - e[0], C.height = o || e[3] - e[1], C;
	}
	async readRasters(e = {}) {
		let { window: t, samples: n = [], pool: r = null, width: i, height: a, resampleMethod: o, fillValue: s, signal: c } = e, l = "interleave" in e && e.interleave, u = t || [
			0,
			0,
			this.getWidth(),
			this.getHeight()
		];
		if (u[0] > u[2] || u[1] > u[3]) throw Error("Invalid subsets");
		let d = (u[2] - u[0]) * (u[3] - u[1]), f = this.getSamplesPerPixel();
		if (!n || !n.length) for (let e = 0; e < f; ++e) n.push(e);
		else for (let e = 0; e < n.length; ++e) if (n[e] >= f) return Promise.reject(/* @__PURE__ */ RangeError(`Invalid sample index '${n[e]}'.`));
		let p;
		if (l) {
			let { fileDirectory: e } = this, t = e.getValue("SampleFormat"), r = t ? Math.max.apply(null, Array.from(t)) : 1;
			if (r !== 1 && r !== 2 && r !== 3) throw Error("Unsupported sample format for interleaved data. Must be 1, 2, or 3.");
			let i = e.getValue("BitsPerSample");
			if (p = ZL(r, i ? Math.max.apply(null, Array.from(i)) : 8, d * n.length), s) {
				if (Array.isArray(s)) throw Error("When reading interleaved data, fillValue must be a single number.");
				p.fill(s);
			}
		} else {
			p = [];
			for (let e = 0; e < n.length; ++e) {
				let t = this.getArrayForSample(n[e], d);
				Array.isArray(s) && e < s.length ? t.fill(s[e]) : s && !Array.isArray(s) && t.fill(s), p.push(t);
			}
		}
		let m = this.fileDirectory.getValue("Compression") || 1, h = await zL(m, this.fileDirectory), g = r ? r.bindParameters(m, h) : await BL(m, h);
		return await this._readRaster(u, n, p, l, g, i, a, o, c);
	}
	async readRGB(e = {}) {
		let { window: t, pool: n = null, width: r, height: i, resampleMethod: s, enableAlpha: c = !1, signal: l } = e, u = ("interleave" in e && e.interleave) ?? !1, d = t || [
			0,
			0,
			this.getWidth(),
			this.getHeight()
		];
		if (d[0] > d[2] || d[1] > d[3]) throw Error("Invalid subsets");
		let f = this.fileDirectory.getValue("PhotometricInterpretation");
		if (f === a.RGB) {
			let e = [
				0,
				1,
				2
			], a = this.fileDirectory.getValue("ExtraSamples");
			if (a && a[0] !== o.Unspecified && c) {
				e = [];
				let t = this.fileDirectory.getValue("BitsPerSample") || [];
				for (let n = 0; n < t.length; n += 1) e.push(n);
			}
			return this.readRasters({
				window: t,
				interleave: u,
				samples: e,
				pool: n,
				width: r,
				height: i,
				resampleMethod: s,
				signal: l
			});
		}
		let p;
		switch (f) {
			case a.WhiteIsZero:
			case a.BlackIsZero:
			case a.Palette:
				p = [0];
				break;
			case a.CMYK:
				p = [
					0,
					1,
					2,
					3
				];
				break;
			case a.YCbCr:
			case a.CIELab:
				p = [
					0,
					1,
					2
				];
				break;
			default: throw Error("Invalid or unsupported photometric interpretation.");
		}
		let m = {
			window: d,
			interleave: !0,
			samples: p,
			pool: n,
			width: r,
			height: i,
			resampleMethod: s,
			signal: l
		}, { fileDirectory: h } = this, g = await this.readRasters(m), _ = 2 ** this.getBitsPerSample(0), v;
		switch (f) {
			case a.WhiteIsZero:
				v = DL(g, _);
				break;
			case a.BlackIsZero:
				v = OL(g, _);
				break;
			case a.Palette:
				v = kL(g, await h.loadValue("ColorMap"));
				break;
			case a.CMYK:
				v = AL(g);
				break;
			case a.YCbCr:
				v = jL(g);
				break;
			case a.CIELab:
				v = FL(g);
				break;
			default: throw Error("Unsupported photometric interpretation.");
		}
		if (!u) {
			let e = new Uint8Array(v.length / 3), t = new Uint8Array(v.length / 3), n = new Uint8Array(v.length / 3);
			for (let r = 0, i = 0; r < v.length; r += 3, ++i) e[i] = v[r], t[i] = v[r + 1], n[i] = v[r + 2];
			v = [
				e,
				t,
				n
			];
		}
		let y = v;
		return y.width = g.width, y.height = g.height, y;
	}
	async getTiePoints() {
		if (!this.fileDirectory.hasTag("ModelTiepoint")) return [];
		let e = await this.fileDirectory.loadValue("ModelTiepoint");
		if (typeof e != "object") throw Error("Expected ModelTiepoint to be an array or typed array.");
		let t = [];
		for (let n = 0; n < e.length; n += 6) t.push({
			i: e[n],
			j: e[n + 1],
			k: e[n + 2],
			x: e[n + 3],
			y: e[n + 4],
			z: e[n + 5]
		});
		return t;
	}
	async getGDALMetadata(e = null) {
		let t = {};
		if (!this.fileDirectory.hasTag("GDAL_METADATA")) return null;
		let n = EL(await this.fileDirectory.loadValue("GDAL_METADATA"), "Item");
		n = e === null ? n.filter((e) => xL(e, "sample") === void 0) : n.filter((t) => Number(xL(t, "sample")) === e);
		for (let e = 0; e < n.length; ++e) {
			let r = n[e];
			t[xL(r, "name")] = r.inner;
		}
		return t;
	}
	getGDALNoData() {
		let e = this.fileDirectory.hasTag("GDAL_NODATA") && this.fileDirectory.getValue("GDAL_NODATA");
		return e ? Number(e.substring(0, e.length - 1)) : null;
	}
	getOrigin() {
		let e = this.fileDirectory.getValue("ModelTiepoint"), t = this.fileDirectory.getValue("ModelTransformation");
		if (e && e.length === 6) return [
			e[3],
			e[4],
			e[5]
		];
		if (t) return [
			t[3],
			t[7],
			t[11]
		];
		throw Error("The image does not have an affine transformation.");
	}
	getResolution(e = null) {
		let t = this.fileDirectory.getValue("ModelPixelScale"), n = this.fileDirectory.getValue("ModelTransformation");
		if (t) return [
			t[0],
			-t[1],
			t[2]
		];
		if (n) return n[1] === 0 && n[4] === 0 ? [
			n[0],
			-n[5],
			n[10]
		] : [
			Math.sqrt(n[0] * n[0] + n[4] * n[4]),
			-Math.sqrt(n[1] * n[1] + n[5] * n[5]),
			n[10]
		];
		if (e) {
			let [t, n, r] = e.getResolution();
			return [
				t * e.getWidth() / this.getWidth(),
				n * e.getHeight() / this.getHeight(),
				r * e.getWidth() / this.getWidth()
			];
		}
		throw Error("The image does not have an affine transformation.");
	}
	pixelIsArea() {
		return this.getGeoKeys()?.GTRasterTypeGeoKey === 1;
	}
	getBoundingBox(e = !1) {
		let t = this.getHeight(), n = this.getWidth(), r = this.fileDirectory.getValue("ModelTransformation");
		if (r && !e) {
			let [e, i, , a, o, s, , c] = r, l = [
				[0, 0],
				[0, t],
				[n, 0],
				[n, t]
			].map(([t, n]) => [a + e * t + i * n, c + o * t + s * n]), u = l.map((e) => e[0]), d = l.map((e) => e[1]);
			return [
				Math.min(...u),
				Math.min(...d),
				Math.max(...u),
				Math.max(...d)
			];
		} else {
			let e = this.getOrigin(), r = this.getResolution(), i = e[0], a = e[1], o = i + r[0] * n, s = a + r[1] * t;
			return [
				Math.min(i, o),
				Math.min(a, s),
				Math.max(i, o),
				Math.max(a, s)
			];
		}
	}
}, tR = class {
	constructor(e) {
		this._dataView = new DataView(e);
	}
	get buffer() {
		return this._dataView.buffer;
	}
	getUint64(e, t) {
		let n = this.getUint32(e, t), r = this.getUint32(e + 4, t), i;
		if (t) {
			if (i = n + 2 ** 32 * r, !Number.isSafeInteger(i)) throw Error(`${i} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`);
			return i;
		}
		if (i = 2 ** 32 * n + r, !Number.isSafeInteger(i)) throw Error(`${i} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`);
		return i;
	}
	getInt64(e, t) {
		let n = 0, r = (this._dataView.getUint8(e + (t ? 7 : 0)) & 128) > 0, i = !0;
		for (let a = 0; a < 8; a++) {
			let o = this._dataView.getUint8(e + (t ? a : 7 - a));
			r && (i ? o !== 0 && (o = ~(o - 1) & 255, i = !1) : o = ~o & 255), n += o * 256 ** a;
		}
		return r && (n = -n), n;
	}
	getUint8(e) {
		return this._dataView.getUint8(e);
	}
	getInt8(e) {
		return this._dataView.getInt8(e);
	}
	getUint16(e, t) {
		return this._dataView.getUint16(e, t);
	}
	getInt16(e, t) {
		return this._dataView.getInt16(e, t);
	}
	getUint32(e, t) {
		return this._dataView.getUint32(e, t);
	}
	getInt32(e, t) {
		return this._dataView.getInt32(e, t);
	}
	getFloat16(e, t) {
		return bL(this._dataView, e, t);
	}
	getFloat32(e, t) {
		return this._dataView.getFloat32(e, t);
	}
	getFloat64(e, t) {
		return this._dataView.getFloat64(e, t);
	}
}, nR = class {
	constructor(e, t, n, r) {
		this._dataView = new DataView(e), this._sliceOffset = t, this._littleEndian = n, this._bigTiff = r;
	}
	get sliceOffset() {
		return this._sliceOffset;
	}
	get sliceTop() {
		return this._sliceOffset + this.buffer.byteLength;
	}
	get littleEndian() {
		return this._littleEndian;
	}
	get bigTiff() {
		return this._bigTiff;
	}
	get buffer() {
		return this._dataView.buffer;
	}
	covers(e, t) {
		return this.sliceOffset <= e && this.sliceTop >= e + t;
	}
	readUint8(e) {
		return this._dataView.getUint8(e - this._sliceOffset);
	}
	readInt8(e) {
		return this._dataView.getInt8(e - this._sliceOffset);
	}
	readUint16(e) {
		return this._dataView.getUint16(e - this._sliceOffset, this._littleEndian);
	}
	readInt16(e) {
		return this._dataView.getInt16(e - this._sliceOffset, this._littleEndian);
	}
	readUint32(e) {
		return this._dataView.getUint32(e - this._sliceOffset, this._littleEndian);
	}
	readInt32(e) {
		return this._dataView.getInt32(e - this._sliceOffset, this._littleEndian);
	}
	readFloat32(e) {
		return this._dataView.getFloat32(e - this._sliceOffset, this._littleEndian);
	}
	readFloat64(e) {
		return this._dataView.getFloat64(e - this._sliceOffset, this._littleEndian);
	}
	readUint64(e) {
		let t = this.readUint32(e), n = this.readUint32(e + 4), r;
		if (this._littleEndian) {
			if (r = t + 2 ** 32 * n, !Number.isSafeInteger(r)) throw Error(`${r} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`);
			return r;
		}
		if (r = 2 ** 32 * t + n, !Number.isSafeInteger(r)) throw Error(`${r} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`);
		return r;
	}
	readInt64(e) {
		let t = 0, n = (this._dataView.getUint8(e + (this._littleEndian ? 7 : 0)) & 128) > 0, r = !0;
		for (let i = 0; i < 8; i++) {
			let a = this._dataView.getUint8(e + (this._littleEndian ? i : 7 - i));
			n && (r ? a !== 0 && (a = ~(a - 1) & 255, r = !1) : a = ~a & 255), t += a * 256 ** i;
		}
		return n && (t = -t), t;
	}
	readOffset(e) {
		return this._bigTiff ? this.readUint64(e) : this.readUint32(e);
	}
}, rR = class {
	async fetch(e, t) {
		return Promise.all(e.map(async (e) => (await this.fetchSlice(e, t)).data));
	}
	async fetchSlice(e, t) {
		throw Error(`fetching of slice ${e} not possible, not implemented`);
	}
	get fileSize() {
		return null;
	}
	async close() {}
}, iR = class e extends Error {
	constructor(...t) {
		super(...t), Error.captureStackTrace && Error.captureStackTrace(this, e), this.name = "AbortError", this.signal = void 0;
	}
}, aR = class extends rR {
	constructor(e) {
		super(), this.arrayBuffer = e;
	}
	fetchSlice(e, t) {
		if (t && t.aborted) throw new iR("Request aborted");
		return Promise.resolve({
			data: this.arrayBuffer.slice(e.offset, e.offset + e.length),
			offset: e.offset,
			length: e.length
		});
	}
};
function oR(e) {
	return new aR(e);
}
//#endregion
//#region node_modules/geotiff/dist-module/imagefiledirectory.js
function sR(e, t) {
	switch (e) {
		case n.BYTE:
		case n.ASCII:
		case n.UNDEFINED: return new Uint8Array(t);
		case n.SBYTE: return new Int8Array(t);
		case n.SHORT: return new Uint16Array(t);
		case n.SSHORT: return new Int16Array(t);
		case n.LONG:
		case n.IFD: return new Uint32Array(t);
		case n.SLONG: return new Int32Array(t);
		case n.LONG8:
		case n.IFD8: return Array(t);
		case n.SLONG8: return Array(t);
		case n.RATIONAL: return new Uint32Array(t * 2);
		case n.SRATIONAL: return new Int32Array(t * 2);
		case n.FLOAT: return new Float32Array(t);
		case n.DOUBLE: return new Float64Array(t);
		default: throw RangeError(`Invalid field type: ${e}`);
	}
}
function cR(e, t) {
	switch (t) {
		case n.BYTE:
		case n.ASCII:
		case n.UNDEFINED: return e.readUint8;
		case n.SBYTE: return e.readInt8;
		case n.SHORT: return e.readUint16;
		case n.SSHORT: return e.readInt16;
		case n.LONG:
		case n.IFD: return e.readUint32;
		case n.SLONG: return e.readInt32;
		case n.LONG8:
		case n.IFD8: return e.readUint64;
		case n.SLONG8: return e.readInt64;
		case n.RATIONAL: return e.readUint32;
		case n.SRATIONAL: return e.readInt32;
		case n.FLOAT: return e.readFloat32;
		case n.DOUBLE: return e.readFloat64;
		default: throw RangeError(`Invalid field type: ${t}`);
	}
}
function lR(e = null, t, r, a, o, s, c = !1) {
	let l = i(a), u = e || sR(a, o), d = a === n.RATIONAL || a === n.SRATIONAL;
	if (d) for (let e = 0; e < o; e += 2) u[e] = t.call(r, s + e * l), u[e + 1] = t.call(r, s + (e * l + 4));
	else for (let e = 0; e < o; ++e) u[e] = t.call(r, s + e * l);
	return a === n.ASCII ? new TextDecoder("utf-8").decode(u) : o === 1 && !c && !d ? u[0] : u;
}
var uR = class {
	constructor(e, t, n, r, a) {
		this.source = e, this.arrayOffset = t, this.littleEndian = n, this.fieldType = r, this.length = a, this.data = sR(r, a), this.itemSize = i(r), this.maskBitmap = new Uint8Array(Math.ceil(a / 8)), this.fetchIndexPromises = /* @__PURE__ */ new Map(), this.fullFetchPromise = null;
	}
	async loadAll() {
		return this.fullFetchPromise ||= this.source.fetch([{
			offset: this.arrayOffset,
			length: this.itemSize * this.length
		}]).then((e) => {
			let t = new nR(e[0], this.arrayOffset, !0, !1), n = lR(this.data, cR(t, this.fieldType), t, this.fieldType, this.length, this.arrayOffset, !0);
			return this.maskBitmap.fill(255), this.fetchIndexPromises.clear(), n;
		}), this.fullFetchPromise;
	}
	async get(e) {
		if (e < 0 || e >= this.data.length) throw RangeError(`Index ${e} out of bounds for length ${this.data.length}`);
		let t = Math.floor(e / 8), n = 1 << e % 8, r = this.arrayOffset + e * this.itemSize;
		if ((this.maskBitmap[t] & n) === 0) {
			if (!this.fetchIndexPromises.has(e)) {
				let i = this.source.fetch([{
					offset: r,
					length: this.itemSize
				}]).then((i) => {
					let a = new nR(i[0], this.arrayOffset + e * this.itemSize, !0, !1), o = cR(a, this.fieldType).call(a, r);
					return this.data[e] = o, this.maskBitmap[t] |= n, this.fetchIndexPromises.delete(e), o;
				});
				this.fetchIndexPromises.set(e, i);
			}
			return this.fetchIndexPromises.get(e);
		}
		return this.data[e];
	}
}, dR = class {
	constructor(e, t, n, r) {
		this.actualizedFields = e, this.deferredFields = t, this.deferredFieldsBeingResolved = /* @__PURE__ */ new Map(), this.deferredArrays = n, this.nextIFDByteOffset = r;
	}
	hasTag(e) {
		let n = t(e);
		return this.actualizedFields.has(n) || this.deferredFields.has(n) || this.deferredArrays.has(n);
	}
	getValue(e) {
		let n = t(e);
		if (this.deferredFields.has(n) || this.deferredArrays.has(n)) {
			let e = r[n]?.name || `Tag${n}`;
			throw Error(`Field '${e}' (${n}) is deferred. Use loadValue() to load it asynchronously.`);
		}
		if (this.actualizedFields.has(n)) return this.actualizedFields.get(n);
	}
	async loadValue(e) {
		let n = t(e);
		if (this.actualizedFields.has(n)) return this.actualizedFields.get(n);
		if (this.deferredFieldsBeingResolved.has(n)) return this.deferredFieldsBeingResolved.get(n);
		let r = this.deferredFields.get(n);
		if (r) {
			this.deferredFields.delete(n);
			let e = (async () => {
				try {
					let e = await r();
					return this.actualizedFields.set(n, e), e;
				} finally {
					this.deferredFieldsBeingResolved.delete(n);
				}
			})();
			return this.deferredFieldsBeingResolved.set(n, e), e;
		}
		let i = this.deferredArrays.get(n);
		if (i) return i.loadAll();
	}
	async loadValueIndexed(e, n) {
		let r = t(e);
		if (this.actualizedFields.has(r)) return this.actualizedFields.get(r)[n];
		if (this.deferredArrays.has(r)) return this.deferredArrays.get(r).get(n);
		if (this.hasTag(r)) {
			let e = await this.loadValue(r);
			if (e && typeof e != "number") return e[n];
		}
	}
	parseGeoKeyDirectory() {
		let t = this.getValue("GeoKeyDirectory");
		if (!t) return null;
		let n = {};
		for (let r = 4; r <= t[3] * 4; r += 4) {
			let i = e[t[r]], a = t[r + 1] || null, o = t[r + 2], s = t[r + 3], c = null;
			if (!a) c = s;
			else {
				if (c = this.getValue(a), c == null) throw Error(`Could not get value of geoKey '${i}'.`);
				typeof c == "string" ? c = c.substring(s, s + o - 1) : c.subarray && (c = c.subarray(s, s + o), o === 1 && (c = c[0]));
			}
			n[i] = c;
		}
		return n;
	}
	toObject() {
		let e = {};
		for (let [t, n] of this.actualizedFields.entries()) {
			let i = typeof t == "number" ? r[t] : void 0, a = i ? i.name : `Tag${t}`;
			e[a] = n;
		}
		return e;
	}
}, fR = class {
	constructor(e, t, n, r = !1) {
		this.source = e, this.littleEndian = t, this.bigTiff = n, this.eager = r;
	}
	async getSlice(e, t) {
		let n = this.bigTiff ? 4048 : 1024;
		return new nR((await this.source.fetch([{
			offset: e,
			length: t === void 0 ? n : t
		}]))[0], e, this.littleEndian, this.bigTiff);
	}
	async parseFileDirectoryAt(e) {
		let t = this.bigTiff ? 20 : 12, n = this.bigTiff ? 8 : 2, a = await this.getSlice(e), o = this.bigTiff ? a.readUint64(e) : a.readUint16(e), s = o * (t + (this.bigTiff ? 16 : 6));
		a.covers(e, s) || (a = await this.getSlice(e, s));
		let c = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), d = e + (this.bigTiff ? 8 : 2);
		for (let e = 0; e < o; d += t, ++e) {
			let e = a.readUint16(d), t = a.readUint16(d + 2), n = this.bigTiff ? a.readUint64(d + 4) : a.readUint32(d + 4), o = null, s = null, f = null, p = i(t), m = d + (this.bigTiff ? 12 : 8), h = r[e]?.isArray, g = r[e]?.eager || this.eager;
			if (p * n <= (this.bigTiff ? 8 : 4)) o = lR(sR(t, n), cR(a, t), a, t, n, m, h);
			else {
				let e = a.readOffset(m), r = i(t) * n;
				if (a.covers(e, r)) o = lR(sR(t, n), cR(a, t), a, t, n, e, h);
				else if (g) {
					let i = await this.getSlice(e, r);
					o = lR(sR(t, n), cR(i, t), i, t, n, e, h);
				} else h ? f = new uR(this.source, e, this.littleEndian, t, n) : s = async () => {
					let i = await this.getSlice(e, r);
					return lR(sR(t, n), cR(i, t), i, t, n, e, h);
				};
			}
			o === null ? s === null ? f !== null && u.set(e, f) : l.set(e, s) : c.set(e, o);
		}
		return new dR(c, l, u, a.readOffset(e + n + t * o));
	}
};
//#endregion
//#region node_modules/geotiff/dist-module/geotiff.js
function pR(e, t, r, a) {
	let o = null, s = null, c = i(t);
	switch (t) {
		case n.BYTE:
		case n.ASCII:
		case n.UNDEFINED:
			o = new Uint8Array(r), s = e.readUint8;
			break;
		case n.SBYTE:
			o = new Int8Array(r), s = e.readInt8;
			break;
		case n.SHORT:
			o = new Uint16Array(r), s = e.readUint16;
			break;
		case n.SSHORT:
			o = new Int16Array(r), s = e.readInt16;
			break;
		case n.LONG:
		case n.IFD:
			o = new Uint32Array(r), s = e.readUint32;
			break;
		case n.SLONG:
			o = new Int32Array(r), s = e.readInt32;
			break;
		case n.LONG8:
		case n.IFD8:
			o = Array(r), s = e.readUint64;
			break;
		case n.SLONG8:
			o = Array(r), s = e.readInt64;
			break;
		case n.RATIONAL:
			o = new Uint32Array(r * 2), s = e.readUint32;
			break;
		case n.SRATIONAL:
			o = new Int32Array(r * 2), s = e.readInt32;
			break;
		case n.FLOAT:
			o = new Float32Array(r), s = e.readFloat32;
			break;
		case n.DOUBLE:
			o = new Float64Array(r), s = e.readFloat64;
			break;
		default:
	}
	if (o === null || s === null) throw RangeError(`Invalid field type: ${t}`);
	if (t === n.RATIONAL || t === n.SRATIONAL) for (let t = 0; t < r; t += 2) o[t] = s.call(e, a + t * c), o[t + 1] = s.call(e, a + (t * c + 4));
	else for (let t = 0; t < r; ++t) o[t] = s.call(e, a + t * c);
	return t === n.ASCII ? new TextDecoder("utf-8").decode(o) : o;
}
var mR = class extends Error {
	constructor(e) {
		super(`No image at index ${e}`), this.index = e;
	}
}, hR = class {
	async getImage(e = 0) {
		throw Error("Not implemented");
	}
	async getImageCount() {
		throw Error("Not implemented");
	}
	async readRasters(e = {}) {
		let { window: t, width: n, height: r } = e, { resX: i, resY: a, bbox: o } = e, s = await this.getImage(), c = s, l = await this.getImageCount(), u = s.getBoundingBox();
		if (t && o) throw Error("Both \"bbox\" and \"window\" passed.");
		if (n || r) {
			if (t) {
				let [e, n] = s.getOrigin(), [r, i] = s.getResolution();
				o = [
					e + t[0] * r,
					n + t[1] * i,
					e + t[2] * r,
					n + t[3] * i
				];
			}
			let e = o || u;
			if (n) {
				if (i) throw Error("Both width and resX passed");
				i = (e[2] - e[0]) / n;
			}
			if (r) {
				if (a) throw Error("Both width and resY passed");
				a = (e[3] - e[1]) / r;
			}
		}
		if (i || a) {
			let e = [];
			for (let t = 0; t < l; ++t) {
				let n = await this.getImage(t), r = n.fileDirectory.getValue("SubfileType"), i = n.fileDirectory.getValue("NewSubfileType");
				(t === 0 || r === 2 || (i || 0) & 1) && e.push(n);
			}
			e.sort((e, t) => e.getWidth() - t.getWidth());
			for (let t = 0; t < e.length; ++t) {
				let n = e[t], r = (u[2] - u[0]) / n.getWidth(), o = (u[3] - u[1]) / n.getHeight();
				if (c = n, i && i > r || a && a > o) break;
			}
		}
		let d = t;
		if (o) {
			let [e, t] = s.getOrigin(), [n, r] = c.getResolution(s);
			d = [
				Math.round((o[0] - e) / n),
				Math.round((o[1] - t) / r),
				Math.round((o[2] - e) / n),
				Math.round((o[3] - t) / r)
			], d = [
				Math.min(d[0], d[2]),
				Math.min(d[1], d[3]),
				Math.max(d[0], d[2]),
				Math.max(d[1], d[3])
			];
		}
		return c.readRasters({
			...e,
			window: d
		});
	}
}, gR = class e extends hR {
	constructor(e, t, n, r, i = {}) {
		super(), this.source = e, this.parser = new fR(e, t, n, !1), this.littleEndian = t, this.bigTiff = n, this.firstIFDOffset = r, this.cache = i.cache || !1, this.ifdRequests = [], this.ghostValues = null;
	}
	async getSlice(e, t) {
		let n = this.bigTiff ? 4048 : 1024;
		return new nR((await this.source.fetch([{
			offset: e,
			length: t === void 0 ? n : t
		}]))[0], e, this.littleEndian, this.bigTiff);
	}
	async requestIFD(e) {
		if (this.ifdRequests[e]) return this.ifdRequests[e];
		if (e === 0) return this.ifdRequests[e] = this.parser.parseFileDirectoryAt(this.firstIFDOffset), this.ifdRequests[e];
		if (!this.ifdRequests[e - 1]) try {
			this.ifdRequests[e - 1] = this.requestIFD(e - 1);
		} catch (t) {
			throw t instanceof mR ? new mR(e) : t;
		}
		return this.ifdRequests[e] = (async () => {
			let t = this.ifdRequests[e - 1];
			if (!t) throw Error("Previous IFD request missing");
			let n = await t;
			if (n.nextIFDByteOffset === 0) throw new mR(e);
			return this.parser.parseFileDirectoryAt(n.nextIFDByteOffset);
		})(), this.ifdRequests[e];
	}
	async getImage(e = 0) {
		return new eR(await this.requestIFD(e), this.littleEndian, this.cache, this.source);
	}
	async getImageCount() {
		let e = 0, t = !0;
		for (; t;) try {
			await this.requestIFD(e), ++e;
		} catch (e) {
			if (e instanceof mR) t = !1;
			else throw e;
		}
		return e;
	}
	async getGhostValues() {
		let e = this.bigTiff ? 16 : 8;
		if (this.ghostValues !== null) return this.ghostValues;
		let t = await this.getSlice(e, 130);
		if (pR(t, n.ASCII, 30, e) === "GDAL_STRUCTURAL_METADATA_SIZE=") {
			let r = pR(t, n.ASCII, 130, e).split("\n")[0], i = Number(r.split("=")[1].split(" ")[0]) + r.length;
			i > 130 && (t = await this.getSlice(e, i));
			let a = pR(t, n.ASCII, i, e), o = {};
			a.split("\n").filter((e) => e.length > 0).map((e) => e.split("=")).forEach(([e, t]) => {
				o[e] = t;
			}), this.ghostValues = o;
		}
		return this.ghostValues;
	}
	static async fromSource(t, n, r) {
		let i = (await t.fetch([{
			offset: 0,
			length: 1024
		}], r))[0], a = new tR(i), o = a.getUint16(0, !1), s;
		if (o === 18761) s = !0;
		else if (o === 19789) s = !1;
		else throw TypeError("Invalid byte order value.");
		let c = a.getUint16(2, s), l;
		if (c === 42) l = !1;
		else if (c === 43) {
			if (l = !0, a.getUint16(4, s) !== 8) throw Error("Unsupported offset byte-size.");
		} else throw TypeError("Invalid magic number.");
		let u = l ? a.getUint64(8, s) : a.getUint32(4, s);
		return new e(t, s, l, u, n);
	}
	close() {
		return typeof this.source.close == "function" ? this.source.close() : !1;
	}
};
async function _R(e, t) {
	return gR.fromSource(oR(e), void 0, t);
}
//#endregion
//#region node_modules/pbf/index.js
var vR = 65536 * 65536;
1 / vR;
var yR = 12, bR = typeof TextDecoder > "u" ? null : new TextDecoder("utf-8"), xR = 0, SR = 1, CR = 2, wR = 5, TR = class {
	constructor(e) {
		this.buf = ArrayBuffer.isView(e) ? e : new Uint8Array(e), this.dataView = new DataView(this.buf.buffer, this.buf.byteOffset, this.buf.byteLength), this.pos = 0, this.type = 0, this._valueStart = -1, this.length = this.buf.length;
	}
	readFields(e, t, n = this.length) {
		let r;
		for (; r = this.nextField(n);) e(r, t, this);
		return t;
	}
	readMessage(e, t) {
		return this.readFields(e, t, this.readVarint() + this.pos);
	}
	readFixed32() {
		let e = this.dataView.getUint32(this.pos, !0);
		return this.pos += 4, e;
	}
	readSFixed32() {
		let e = this.dataView.getInt32(this.pos, !0);
		return this.pos += 4, e;
	}
	readFixed64() {
		let e = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * vR;
		return this.pos += 8, e;
	}
	readSFixed64() {
		let e = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * vR;
		return this.pos += 8, e;
	}
	readFloat() {
		let e = this.dataView.getFloat32(this.pos, !0);
		return this.pos += 4, e;
	}
	readDouble() {
		let e = this.dataView.getFloat64(this.pos, !0);
		return this.pos += 8, e;
	}
	readVarint(e) {
		let t = this.buf, n = t[this.pos++];
		if (n < 128) return n;
		let r = n & 127, i;
		return i = t[this.pos++], r |= (i & 127) << 7, i < 128 || (i = t[this.pos++], r |= (i & 127) << 14, i < 128) || (i = t[this.pos++], r |= (i & 127) << 21, i < 128) ? r : (i = t[this.pos], r |= (i & 15) << 28, ER(r, e, this));
	}
	readSVarint() {
		let e = this.readVarint();
		return e % 2 == 1 ? (e + 1) / -2 : e / 2;
	}
	readBoolean() {
		return !!this.readVarint();
	}
	readString() {
		let e = this.readVarint() + this.pos, t = this.pos;
		return this.pos = e, e - t >= yR && bR ? bR.decode(this.buf.subarray(t, e)) : OR(this.buf, t, e);
	}
	readBytes() {
		let e = this.readVarint() + this.pos, t = this.buf.subarray(this.pos, e);
		return this.pos = e, t;
	}
	readPackedVarint(e = [], t) {
		let n = this.readPackedEnd();
		for (; this.pos < n;) e.push(this.readVarint(t));
		return e;
	}
	readPackedSVarint(e = []) {
		let t = this.readPackedEnd();
		for (; this.pos < t;) e.push(this.readSVarint());
		return e;
	}
	readPackedBoolean(e = []) {
		let t = this.readPackedEnd();
		for (; this.pos < t;) e.push(this.readBoolean());
		return e;
	}
	readPackedFloat(e = []) {
		let t = this.readPackedEnd();
		for (; this.pos < t;) e.push(this.readFloat());
		return e;
	}
	readPackedDouble(e = []) {
		let t = this.readPackedEnd();
		for (; this.pos < t;) e.push(this.readDouble());
		return e;
	}
	readPackedFixed32(e = []) {
		let t = this.readPackedEnd();
		for (; this.pos < t;) e.push(this.readFixed32());
		return e;
	}
	readPackedSFixed32(e = []) {
		let t = this.readPackedEnd();
		for (; this.pos < t;) e.push(this.readSFixed32());
		return e;
	}
	readPackedFixed64(e = []) {
		let t = this.readPackedEnd();
		for (; this.pos < t;) e.push(this.readFixed64());
		return e;
	}
	readPackedSFixed64(e = []) {
		let t = this.readPackedEnd();
		for (; this.pos < t;) e.push(this.readSFixed64());
		return e;
	}
	readPackedEnd() {
		return this.type === CR ? this.readVarint() + this.pos : this.pos + 1;
	}
	nextField(e = this.length) {
		if (this.pos === this._valueStart && this.skip(this.type), this.pos >= e) return 0;
		let t = this.readVarint();
		return this.type = t & 7, this._valueStart = this.pos, t >>> 3;
	}
	skip(e) {
		let t = e & 7;
		if (t === xR) for (; this.buf[this.pos++] > 127;);
		else if (t === CR) this.pos = this.readVarint() + this.pos;
		else if (t === wR) this.pos += 4;
		else if (t === SR) this.pos += 8;
		else throw Error(`Unimplemented type: ${t}`);
	}
};
function ER(e, t, n) {
	let r = n.buf, i, a;
	if (a = r[n.pos++], i = (a & 112) >> 4, a < 128 || (a = r[n.pos++], i |= (a & 127) << 3, a < 128) || (a = r[n.pos++], i |= (a & 127) << 10, a < 128) || (a = r[n.pos++], i |= (a & 127) << 17, a < 128) || (a = r[n.pos++], i |= (a & 127) << 24, a < 128) || (a = r[n.pos++], i |= (a & 1) << 31, a < 128)) return DR(e, i, t);
	throw Error("Expected varint not more than 10 bytes");
}
function DR(e, t, n) {
	return n ? t * 4294967296 + (e >>> 0) : (t >>> 0) * 4294967296 + (e >>> 0);
}
function OR(e, t, n) {
	let r = "", i = t;
	for (; i < n;) {
		let t = e[i], a = null, o = t > 239 ? 4 : t > 223 ? 3 : t > 191 ? 2 : 1;
		if (i + o > n) break;
		let s, c, l;
		o === 1 ? t < 128 && (a = t) : o === 2 ? (s = e[i + 1], (s & 192) == 128 && (a = (t & 31) << 6 | s & 63, a <= 127 && (a = null))) : o === 3 ? (s = e[i + 1], c = e[i + 2], (s & 192) == 128 && (c & 192) == 128 && (a = (t & 15) << 12 | (s & 63) << 6 | c & 63, (a <= 2047 || a >= 55296 && a <= 57343) && (a = null))) : o === 4 && (s = e[i + 1], c = e[i + 2], l = e[i + 3], (s & 192) == 128 && (c & 192) == 128 && (l & 192) == 128 && (a = (t & 15) << 18 | (s & 63) << 12 | (c & 63) << 6 | l & 63, (a <= 65535 || a >= 1114112) && (a = null))), a === null ? (a = 65533, o = 1) : a > 65535 && (a -= 65536, r += String.fromCharCode(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), r += String.fromCharCode(a), i += o;
	}
	return r;
}
//#endregion
//#region node_modules/pmtiles/dist/esm/index.js
var kR = Object.defineProperty, AR = Math.pow, jR = (e, t) => kR(e, "name", {
	value: t,
	configurable: !0
}), MR = (e, t, n) => new Promise((r, i) => {
	var a = (e) => {
		try {
			s(n.next(e));
		} catch (e) {
			i(e);
		}
	}, o = (e) => {
		try {
			s(n.throw(e));
		} catch (e) {
			i(e);
		}
	}, s = (e) => e.done ? r(e.value) : Promise.resolve(e.value).then(a, o);
	s((n = n.apply(e, t)).next());
});
jR((e, t) => {
	let n = !1, r = "";
	return new (L.GridLayer.extend({
		createTile: jR((t, i) => {
			let a = document.createElement("img"), o = new AbortController(), s = o.signal;
			return a.cancel = () => {
				o.abort();
			}, n ||= (e.getHeader().then((e) => {
				e.tileType === 1 ? console.error("Error: archive contains MVT vector tiles, but leafletRasterLayer is for displaying raster tiles. See https://github.com/protomaps/PMTiles/tree/main/js for details.") : e.tileType === 2 ? r = "image/png" : e.tileType === 3 ? r = "image/jpeg" : e.tileType === 4 ? r = "image/webp" : e.tileType === 5 && (r = "image/avif");
			}), !0), e.getZxy(t.z, t.x, t.y, s).then((e) => {
				if (e) {
					let t = new Blob([e.data], { type: r });
					a.src = window.URL.createObjectURL(t), a.cancel = void 0, i(void 0, a);
				}
			}).catch((e) => {
				if (e.name !== "AbortError") throw e;
			}), a;
		}, "createTile"),
		_removeTile: jR(function(e) {
			let t = this._tiles[e];
			t && (t.el.cancel && t.el.cancel(), t.el.width = 0, t.el.height = 0, t.el.deleted = !0, L.DomUtil.remove(t.el), delete this._tiles[e], this.fire("tileunload", {
				tile: t.el,
				coords: this._keyToTileCoords(e)
			}));
		}, "_removeTile")
	}))(t);
}, "leafletRasterLayer");
var NR = jR((e) => (t, n) => {
	if (n instanceof AbortController) return e(t, n);
	let r = new AbortController();
	return e(t, r).then((e) => n(void 0, e.data, e.cacheControl || "", e.expires || ""), (e) => n(e)).catch((e) => n(e)), { cancel: jR(() => r.abort(), "cancel") };
}, "v3compat");
jR(class {
	constructor(e) {
		this.tilev4 = jR((e, t) => MR(this, null, function* () {
			if (e.type === "json") {
				let t = e.url.substr(10), n = this.tiles.get(t);
				if (n || (n = new oz(t), this.tiles.set(t, n)), this.metadata) return { data: yield n.getTileJson(e.url) };
				let r = yield n.getHeader();
				return (r.minLon >= r.maxLon || r.minLat >= r.maxLat) && console.error(`Bounds of PMTiles archive ${r.minLon},${r.minLat},${r.maxLon},${r.maxLat} are not valid.`), { data: {
					tiles: [`${e.url}/{z}/{x}/{y}`],
					minzoom: r.minZoom,
					maxzoom: r.maxZoom,
					bounds: [
						r.minLon,
						r.minLat,
						r.maxLon,
						r.maxLat
					]
				} };
			}
			let n = /* @__PURE__ */ new RegExp(/pmtiles:\/\/(.+)\/(\d+)\/(\d+)\/(\d+)/), r = e.url.match(n);
			if (!r) throw Error("Invalid PMTiles protocol URL");
			let i = r[1], a = this.tiles.get(i);
			a || (a = new oz(i), this.tiles.set(i, a));
			let o = r[2], s = r[3], c = r[4], l = yield a.getHeader(), u = yield a?.getZxy(+o, +s, +c, t.signal);
			if (u) return {
				data: new Uint8Array(u.data),
				cacheControl: u.cacheControl,
				expires: u.expires
			};
			if (l.tileType === 1) {
				if (this.errorOnMissingTile) throw Error("Tile not found.");
				return { data: new Uint8Array() };
			}
			return { data: null };
		}), "tilev4"), this.tile = NR(this.tilev4), this.tiles = /* @__PURE__ */ new Map(), this.metadata = e?.metadata || !1, this.errorOnMissingTile = e?.errorOnMissingTile || !1;
	}
	add(e) {
		this.tiles.set(e.source.getKey(), e);
	}
	get(e) {
		return this.tiles.get(e);
	}
}, "Protocol");
function PR(e, t) {
	return (t >>> 0) * 4294967296 + (e >>> 0);
}
jR(PR, "toNum");
function FR(e, t) {
	let n = t.buf, r = n[t.pos++], i = (r & 112) >> 4;
	if (r < 128 || (r = n[t.pos++], i |= (r & 127) << 3, r < 128) || (r = n[t.pos++], i |= (r & 127) << 10, r < 128) || (r = n[t.pos++], i |= (r & 127) << 17, r < 128) || (r = n[t.pos++], i |= (r & 127) << 24, r < 128) || (r = n[t.pos++], i |= (r & 1) << 31, r < 128)) return PR(e, i);
	throw Error("Expected varint not more than 10 bytes");
}
jR(FR, "readVarintRemainder");
function IR(e) {
	let t = e.buf, n = t[e.pos++], r = n & 127;
	return n < 128 || (n = t[e.pos++], r |= (n & 127) << 7, n < 128) || (n = t[e.pos++], r |= (n & 127) << 14, n < 128) || (n = t[e.pos++], r |= (n & 127) << 21, n < 128) ? r : (n = t[e.pos], r |= (n & 15) << 28, FR(r, e));
}
jR(IR, "readVarint");
function LR(e, t, n, r) {
	if (r === 0) {
		n === 1 && (t[0] = e - 1 - t[0], t[1] = e - 1 - t[1]);
		let r = t[0];
		t[0] = t[1], t[1] = r;
	}
}
jR(LR, "rotate");
function RR(e, t) {
	let n = AR(2, e), r = t, i = t, a = t, o = [0, 0], s = 1;
	for (; s < n;) r = 1 & a / 2, i = 1 & (a ^ r), LR(s, o, r, i), o[0] += s * r, o[1] += s * i, a /= 4, s *= 2;
	return [
		e,
		o[0],
		o[1]
	];
}
jR(RR, "idOnLevel");
var zR = [
	0,
	1,
	5,
	21,
	85,
	341,
	1365,
	5461,
	21845,
	87381,
	349525,
	1398101,
	5592405,
	22369621,
	89478485,
	357913941,
	1431655765,
	5726623061,
	22906492245,
	91625968981,
	366503875925,
	1466015503701,
	5864062014805,
	23456248059221,
	93824992236885,
	375299968947541,
	0x5555555555555
];
function BR(e, t, n) {
	if (e > 26) throw Error("Tile zoom level exceeds max safe number limit (26)");
	if (t > AR(2, e) - 1 || n > AR(2, e) - 1) throw Error("tile x/y outside zoom level bounds");
	let r = zR[e], i = AR(2, e), a = 0, o = 0, s = 0, c = [t, n], l = i / 2;
	for (; l > 0;) a = +((c[0] & l) > 0), o = +((c[1] & l) > 0), s += l * l * (3 * a ^ o), LR(l, c, a, o), l /= 2;
	return r + s;
}
jR(BR, "zxyToTileId");
function VR(e) {
	let t = 0;
	for (let n = 0; n < 27; n++) {
		let r = (1 << n) * (1 << n);
		if (t + r > e) return RR(n, e - t);
		t += r;
	}
	throw Error("Tile zoom level exceeds max safe number limit (26)");
}
jR(VR, "tileIdToZxy");
var HR = ((e) => (e[e.Unknown = 0] = "Unknown", e[e.None = 1] = "None", e[e.Gzip = 2] = "Gzip", e[e.Brotli = 3] = "Brotli", e[e.Zstd = 4] = "Zstd", e))(HR || {});
function UR(e, t) {
	return MR(this, null, function* () {
		if (t === 1 || t === 0) return e;
		if (t === 2) {
			if (globalThis.DecompressionStream === void 0) return DN(new Uint8Array(e));
			let t = new Response(e).body;
			if (!t) throw Error("Failed to read response stream");
			let n = t.pipeThrough(new globalThis.DecompressionStream("gzip"));
			return new Response(n).arrayBuffer();
		}
		throw Error("Compression method not supported");
	});
}
jR(UR, "defaultDecompress");
var WR = ((e) => (e[e.Unknown = 0] = "Unknown", e[e.Mvt = 1] = "Mvt", e[e.Png = 2] = "Png", e[e.Jpeg = 3] = "Jpeg", e[e.Webp = 4] = "Webp", e[e.Avif = 5] = "Avif", e))(WR || {});
function GR(e) {
	return e === 1 ? ".mvt" : e === 2 ? ".png" : e === 3 ? ".jpg" : e === 4 ? ".webp" : e === 5 ? ".avif" : "";
}
jR(GR, "tileTypeExt");
var KR = 127;
function qR(e, t) {
	let n = 0, r = e.length - 1;
	for (; n <= r;) {
		let i = r + n >> 1, a = t - e[i].tileId;
		if (a > 0) n = i + 1;
		else if (a < 0) r = i - 1;
		else return e[i];
	}
	return r >= 0 && (e[r].runLength === 0 || t - e[r].tileId < e[r].runLength) ? e[r] : null;
}
jR(qR, "findTile"), jR(class {
	constructor(e) {
		this.file = e;
	}
	getKey() {
		return this.file.name;
	}
	getBytes(e, t) {
		return MR(this, null, function* () {
			return { data: yield this.file.slice(e, e + t).arrayBuffer() };
		});
	}
}, "FileSource");
var JR = class {
	constructor(e, t = new Headers()) {
		this.url = e, this.customHeaders = t, this.mustReload = !1;
		let n = "";
		"navigator" in globalThis && (n = globalThis.navigator.userAgent || "");
		let r = n.indexOf("Windows") > -1, i = /Chrome|Chromium|Edg|OPR|Brave/.test(n);
		this.chromeWindowsNoCache = !1, r && i && (this.chromeWindowsNoCache = !0);
	}
	getKey() {
		return this.url;
	}
	setHeaders(e) {
		this.customHeaders = e;
	}
	getBytes(e, t, n, r) {
		return MR(this, null, function* () {
			let i, a;
			n ? a = n : (i = new AbortController(), a = i.signal);
			let o = new Headers(this.customHeaders);
			o.set("range", `bytes=${e}-${e + t - 1}`);
			let s;
			this.mustReload ? s = "reload" : this.chromeWindowsNoCache && (s = "no-store");
			let c = yield fetch(this.url, {
				signal: a,
				cache: s,
				headers: o
			});
			if (e === 0 && c.status === 416) {
				let e = c.headers.get("Content-Range");
				if (!e || !e.startsWith("bytes */")) throw Error("Missing content-length on 416 response");
				let t = +e.substr(8);
				c = yield fetch(this.url, {
					signal: a,
					cache: "reload",
					headers: { range: `bytes=0-${t - 1}` }
				});
			}
			let l = c.headers.get("Etag");
			if (l != null && l.startsWith("W/") && (l = null), c.status === 416 || r && l && l !== r) throw this.mustReload = !0, new ez(`Server returned non-matching ETag ${r} after one retry. Check browser extensions and servers for issues that may affect correct ETag headers.`);
			if (c.status >= 300) throw Error(`Bad response code: ${c.status}`);
			let u = c.headers.get("Content-Length");
			if (c.status === 200 && (!u || +u > t)) throw i && i.abort(), /* @__PURE__ */ Error("Server returned no content-length header or content-length exceeding request. Check that your storage backend supports HTTP Byte Serving.");
			return {
				data: yield c.arrayBuffer(),
				etag: l || void 0,
				cacheControl: c.headers.get("Cache-Control") || void 0,
				expires: c.headers.get("Expires") || void 0
			};
		});
	}
};
jR(JR, "FetchSource");
var YR = JR;
function XR(e, t) {
	let n = e.getUint32(t + 4, !0), r = e.getUint32(t + 0, !0);
	return n * AR(2, 32) + r;
}
jR(XR, "getUint64");
function ZR(e, t) {
	let n = new DataView(e), r = n.getUint8(7);
	if (r > 3) throw Error(`Archive is spec version ${r} but this library supports up to spec version 3`);
	return {
		specVersion: r,
		rootDirectoryOffset: XR(n, 8),
		rootDirectoryLength: XR(n, 16),
		jsonMetadataOffset: XR(n, 24),
		jsonMetadataLength: XR(n, 32),
		leafDirectoryOffset: XR(n, 40),
		leafDirectoryLength: XR(n, 48),
		tileDataOffset: XR(n, 56),
		tileDataLength: XR(n, 64),
		numAddressedTiles: XR(n, 72),
		numTileEntries: XR(n, 80),
		numTileContents: XR(n, 88),
		clustered: n.getUint8(96) === 1,
		internalCompression: n.getUint8(97),
		tileCompression: n.getUint8(98),
		tileType: n.getUint8(99),
		minZoom: n.getUint8(100),
		maxZoom: n.getUint8(101),
		minLon: n.getInt32(102, !0) / 1e7,
		minLat: n.getInt32(106, !0) / 1e7,
		maxLon: n.getInt32(110, !0) / 1e7,
		maxLat: n.getInt32(114, !0) / 1e7,
		centerZoom: n.getUint8(118),
		centerLon: n.getInt32(119, !0) / 1e7,
		centerLat: n.getInt32(123, !0) / 1e7,
		etag: t
	};
}
jR(ZR, "bytesToHeader");
function QR(e) {
	let t = {
		buf: new Uint8Array(e),
		pos: 0
	}, n = IR(t), r = [], i = 0;
	for (let e = 0; e < n; e++) {
		let e = IR(t);
		r.push({
			tileId: i + e,
			offset: 0,
			length: 0,
			runLength: 1
		}), i += e;
	}
	for (let e = 0; e < n; e++) r[e].runLength = IR(t);
	for (let e = 0; e < n; e++) r[e].length = IR(t);
	for (let e = 0; e < n; e++) {
		let n = IR(t);
		n === 0 && e > 0 ? r[e].offset = r[e - 1].offset + r[e - 1].length : r[e].offset = n - 1;
	}
	return r;
}
jR(QR, "deserializeIndex");
var $R = class extends Error {};
jR($R, "EtagMismatch");
var ez = $R;
function tz(e, t) {
	return MR(this, null, function* () {
		let n = yield e.getBytes(0, 16384);
		if (new DataView(n.data).getUint16(0, !0) !== 19792) throw Error("Wrong magic number for PMTiles archive");
		let r = ZR(n.data.slice(0, KR), n.etag), i = n.data.slice(r.rootDirectoryOffset, r.rootDirectoryOffset + r.rootDirectoryLength), a = `${e.getKey()}|${r.etag || ""}|${r.rootDirectoryOffset}|${r.rootDirectoryLength}`, o = QR(yield t(i, r.internalCompression));
		return [r, [
			a,
			o.length,
			o
		]];
	});
}
jR(tz, "getHeaderAndRoot");
function nz(e, t, n, r, i) {
	return MR(this, null, function* () {
		let a = QR(yield t((yield e.getBytes(n, r, void 0, i.etag)).data, i.internalCompression));
		if (a.length === 0) throw Error("Empty directory is invalid");
		return a;
	});
}
jR(nz, "getDirectory"), jR(class {
	constructor(e = 100, t = !0, n = UR) {
		this.cache = /* @__PURE__ */ new Map(), this.maxCacheEntries = e, this.counter = 1, this.decompress = n;
	}
	getHeader(e) {
		return MR(this, null, function* () {
			let t = e.getKey(), n = this.cache.get(t);
			if (n) return n.lastUsed = this.counter++, n.data;
			let r = yield tz(e, this.decompress);
			return r[1] && this.cache.set(r[1][0], {
				lastUsed: this.counter++,
				data: r[1][2]
			}), this.cache.set(t, {
				lastUsed: this.counter++,
				data: r[0]
			}), this.prune(), r[0];
		});
	}
	getDirectory(e, t, n, r) {
		return MR(this, null, function* () {
			let i = `${e.getKey()}|${r.etag || ""}|${t}|${n}`, a = this.cache.get(i);
			if (a) return a.lastUsed = this.counter++, a.data;
			let o = yield nz(e, this.decompress, t, n, r);
			return this.cache.set(i, {
				lastUsed: this.counter++,
				data: o
			}), this.prune(), o;
		});
	}
	prune() {
		if (this.cache.size > this.maxCacheEntries) {
			let e = Infinity, t;
			this.cache.forEach((n, r) => {
				n.lastUsed < e && (e = n.lastUsed, t = r);
			}), t && this.cache.delete(t);
		}
	}
	invalidate(e) {
		return MR(this, null, function* () {
			this.cache.delete(e.getKey());
		});
	}
}, "ResolvedValueCache");
var rz = class {
	constructor(e = 100, t = !0, n = UR) {
		this.cache = /* @__PURE__ */ new Map(), this.invalidations = /* @__PURE__ */ new Map(), this.maxCacheEntries = e, this.counter = 1, this.decompress = n;
	}
	getHeader(e) {
		return MR(this, null, function* () {
			let t = e.getKey(), n = this.cache.get(t);
			if (n) return n.lastUsed = this.counter++, yield n.data;
			let r = new Promise((t, n) => {
				tz(e, this.decompress).then((e) => {
					e[1] && this.cache.set(e[1][0], {
						lastUsed: this.counter++,
						data: Promise.resolve(e[1][2])
					}), t(e[0]), this.prune();
				}).catch((e) => {
					n(e);
				});
			});
			return this.cache.set(t, {
				lastUsed: this.counter++,
				data: r
			}), r;
		});
	}
	getDirectory(e, t, n, r) {
		return MR(this, null, function* () {
			let i = `${e.getKey()}|${r.etag || ""}|${t}|${n}`, a = this.cache.get(i);
			if (a) return a.lastUsed = this.counter++, yield a.data;
			let o = new Promise((i, a) => {
				nz(e, this.decompress, t, n, r).then((e) => {
					i(e), this.prune();
				}).catch((e) => {
					a(e);
				});
			});
			return this.cache.set(i, {
				lastUsed: this.counter++,
				data: o
			}), o;
		});
	}
	prune() {
		if (this.cache.size >= this.maxCacheEntries) {
			let e = Infinity, t;
			this.cache.forEach((n, r) => {
				n.lastUsed < e && (e = n.lastUsed, t = r);
			}), t && this.cache.delete(t);
		}
	}
	invalidate(e) {
		return MR(this, null, function* () {
			let t = e.getKey();
			if (this.invalidations.get(t)) return yield this.invalidations.get(t);
			this.cache.delete(e.getKey());
			let n = new Promise((n, r) => {
				this.getHeader(e).then((e) => {
					n(), this.invalidations.delete(t);
				}).catch((e) => {
					r(e);
				});
			});
			this.invalidations.set(t, n);
		});
	}
};
jR(rz, "SharedPromiseCache");
var iz = rz, az = class {
	constructor(e, t, n) {
		typeof e == "string" ? this.source = new YR(e) : this.source = e, n ? this.decompress = n : this.decompress = UR, t ? this.cache = t : this.cache = new iz();
	}
	getHeader() {
		return MR(this, null, function* () {
			return yield this.cache.getHeader(this.source);
		});
	}
	getZxyAttempt(e, t, n, r) {
		return MR(this, null, function* () {
			let i = BR(e, t, n), a = yield this.cache.getHeader(this.source);
			if (e < a.minZoom || e > a.maxZoom) return;
			let o = a.rootDirectoryOffset, s = a.rootDirectoryLength;
			for (let e = 0; e <= 3; e++) {
				let e = qR(yield this.cache.getDirectory(this.source, o, s, a), i);
				if (e) {
					if (e.runLength > 0) {
						let t = yield this.source.getBytes(a.tileDataOffset + e.offset, e.length, r, a.etag);
						return {
							data: yield this.decompress(t.data, a.tileCompression),
							cacheControl: t.cacheControl,
							expires: t.expires
						};
					}
					o = a.leafDirectoryOffset + e.offset, s = e.length;
				} else return;
			}
			throw Error("Maximum directory depth exceeded");
		});
	}
	getZxy(e, t, n, r) {
		return MR(this, null, function* () {
			try {
				return yield this.getZxyAttempt(e, t, n, r);
			} catch (i) {
				if (i instanceof ez) return this.cache.invalidate(this.source), yield this.getZxyAttempt(e, t, n, r);
				throw i;
			}
		});
	}
	getMetadataAttempt() {
		return MR(this, null, function* () {
			let e = yield this.cache.getHeader(this.source), t = yield this.source.getBytes(e.jsonMetadataOffset, e.jsonMetadataLength, void 0, e.etag), n = yield this.decompress(t.data, e.internalCompression), r = new TextDecoder("utf-8");
			return JSON.parse(r.decode(n));
		});
	}
	getMetadata() {
		return MR(this, null, function* () {
			try {
				return yield this.getMetadataAttempt();
			} catch (e) {
				if (e instanceof ez) return this.cache.invalidate(this.source), yield this.getMetadataAttempt();
				throw e;
			}
		});
	}
	getTileJson(e) {
		return MR(this, null, function* () {
			let t = yield this.getHeader(), n = yield this.getMetadata();
			return {
				tilejson: "3.0.0",
				scheme: "xyz",
				tiles: [`${e}/{z}/{x}/{y}${GR(t.tileType)}`],
				vector_layers: n.vector_layers,
				attribution: n.attribution,
				description: n.description,
				name: n.name,
				version: n.version,
				bounds: [
					t.minLon,
					t.minLat,
					t.maxLon,
					t.maxLat
				],
				center: [
					t.centerLon,
					t.centerLat,
					t.centerZoom
				],
				minzoom: t.minZoom,
				maxzoom: t.maxZoom
			};
		});
	}
};
jR(az, "PMTiles");
var oz = az, sz = 20037508.342789244, cz = sz * 2, lz = "https://overturemaps-extras-us-west-2.s3.us-west-2.amazonaws.com/tiles/2026-08-19.0", uz = /* @__PURE__ */ new Map();
function dz(e) {
	let t = uz.get(e);
	if (t) return t;
	let n = new oz(`${lz}/${e}.pmtiles`);
	return uz.set(e, n), n;
}
function fz(e) {
	return cz / 2 ** e;
}
function pz(e, t) {
	let [n, r, i, a] = dF(e), o = fz(t), s = Math.max(0, Math.floor((n + sz) / o)), c = Math.min(2 ** t - 1, Math.floor((i + sz) / o)), l = Math.max(0, Math.floor((sz - a) / o)), u = Math.min(2 ** t - 1, Math.floor((sz - r) / o)), d = [];
	for (let e = l; e <= u; e += 1) for (let n = s; n <= c; n += 1) d.push({
		zoom: t,
		x: n,
		y: e
	});
	if (d.length > 64) throw Error("Deze wereldwijde selectie vraagt meer dan 64 kaartdelen.");
	return d;
}
function mz(e, t, n) {
	let r = fz(t.zoom);
	return [-sz + t.x * r + e.x / n * r, sz - t.y * r - e.y / n * r];
}
function hz(e, t, [n, r, i, a]) {
	let o = t[0] - e[0], s = t[1] - e[1], c = 0, l = 1;
	for (let [t, u] of [
		[-o, e[0] - n],
		[o, i - e[0]],
		[-s, e[1] - r],
		[s, a - e[1]]
	]) {
		if (Math.abs(t) < 1e-12) {
			if (u < 0) return;
			continue;
		}
		let e = u / t;
		if (t < 0 ? c = Math.max(c, e) : l = Math.min(l, e), c > l) return;
	}
	return [[e[0] + c * o, e[1] + c * s], [e[0] + l * o, e[1] + l * s]];
}
function gz(e, t) {
	let n = [], r = [], i = (e, t) => Math.hypot(e[0] - t[0], e[1] - t[1]) < .001;
	for (let a = 0; a < e.length - 1; a += 1) {
		let o = hz(e[a], e[a + 1], t);
		o ? r.length === 0 || !i(r[r.length - 1], o[0]) ? (r.length >= 2 && n.push(r), r = [o[0], o[1]]) : i(r[r.length - 1], o[1]) || r.push(o[1]) : (r.length >= 2 && n.push(r), r = []);
	}
	return r.length >= 2 && n.push(r), n;
}
async function _z(e, t, n, r) {
	let i = Array(e.length), a = 0;
	return await Promise.all(Array.from({ length: Math.min(t, e.length) }, async () => {
		for (; a < e.length;) {
			let t = a;
			a += 1, i[t] = await n(e[t]), r?.();
		}
	})), i;
}
function vz(e) {
	let t = Number(e.height), n = Number(e.num_floors);
	if (Number.isFinite(t) && t > 1) return Math.min(240, t);
	if (Number.isFinite(n) && n > 0) return Math.min(240, n * 3.1);
	let r = String(e.subtype ?? e.class ?? "").toLowerCase();
	return r.includes("church") || r.includes("cathedral") ? 24 : 9;
}
function yz(e) {
	let [t, n] = rc([e.centerX, e.centerY]);
	return t >= -5.6 && t <= 10 && n >= 41 && n <= 51.6;
}
function bz(e) {
	return !e || !Array.isArray(e.coordinates) ? [] : e.type === "Polygon" ? [e.coordinates] : e.type === "MultiPolygon" ? e.coordinates : [];
}
async function xz(e, t, n) {
	let r = new URL("/api/geodata/france-buildings", window.__PLEKBEELD_API_ORIGIN__ || window.location.origin);
	r.searchParams.set("bbox", e.join(",")), r.searchParams.set("start", String(t));
	let i = await n(r, { headers: { Accept: "application/json" } });
	if (!i.ok) throw Error(`De Franse gebouwbron gaf status ${i.status}.`);
	return i.json();
}
async function Sz(e, t, n) {
	let [r, i, a, o] = dF(e), [s, c] = rc([r, i]), [l, u] = rc([a, o]), d = [
		s,
		c,
		l,
		u
	], f = await xz(d, 0, t), p = Math.max(f.numberMatched ?? f.totalFeatures ?? f.features?.length ?? 0, 0), m = Math.max(1, Math.ceil(p / 1e3)), h = 1;
	n?.({
		stage: "buildings",
		completed: h,
		total: m,
		message: `Gebouwen laden: ${h} van ${m} delen`
	});
	let g = await _z(Array.from({ length: Math.max(0, m - 1) }, (e, t) => (t + 1) * 1e3), 3, (e) => xz(d, e, t), () => {
		h += 1, n?.({
			stage: "buildings",
			completed: h,
			total: m,
			message: `Gebouwen laden: ${h} van ${m} delen`
		});
	}), _ = Math.max(.18, e.areaMeters / e.modelMillimeters * .035), v = [];
	for (let e of [f, ...g]) for (let [t, n] of (e.features ?? []).entries()) {
		let e = n.properties ?? {};
		for (let [s, c] of bz(n.geometry).entries()) {
			let l = KP(YP(c[0]?.map((e) => nc([Number(e[0]), Number(e[1])])) ?? [], r, i, a, o), _);
			if (l.length < 3 || Math.abs(VP(l)) < 1) continue;
			let u = Number(e.hauteur), d = Number(e.altitude_minimale_sol);
			v.push({
				id: String(e.cleabs ?? n.id ?? `ign-${t}-${s}`),
				footprint: l,
				groundMeters: Number.isFinite(d) ? d : 0,
				heightMeters: Number.isFinite(u) && u > 1 ? Math.min(240, u) : vz(e),
				sourceLod: "LoD0"
			});
		}
	}
	return v;
}
function Cz(e) {
	let t = String(e.class ?? e.subtype ?? "").toLowerCase(), n = `${String(e.road_flags ?? "")} ${String(e.level_rules ?? "")}`.toLowerCase();
	return t.includes("motorway") ? {
		widthMeters: 10,
		priority: 1,
		bridge: n.includes("bridge"),
		tunnel: n.includes("tunnel")
	} : t.includes("primary") || t.includes("trunk") ? {
		widthMeters: 8,
		priority: 2,
		bridge: n.includes("bridge"),
		tunnel: n.includes("tunnel")
	} : t.includes("secondary") ? {
		widthMeters: 6.5,
		priority: 3,
		bridge: n.includes("bridge"),
		tunnel: n.includes("tunnel")
	} : t.includes("tertiary") ? {
		widthMeters: 5.5,
		priority: 4,
		bridge: n.includes("bridge"),
		tunnel: n.includes("tunnel")
	} : {
		widthMeters: t.includes("path") ? 1.8 : 4,
		priority: 5,
		bridge: n.includes("bridge"),
		tunnel: n.includes("tunnel")
	};
}
function wz(e) {
	return String(e.subtype ?? "").toLowerCase() === "road";
}
function Tz(e) {
	let t = `${String(e.class ?? "")} ${String(e.subtype ?? "")}`.toLowerCase();
	return [
		"forest",
		"wood",
		"scrub",
		"shrub",
		"park",
		"grass",
		"nature_reserve",
		"national_park"
	].some((e) => t.includes(e));
}
async function Ez(e, t) {
	let n = await dz(e).getZxy(t.zoom, t.x, t.y);
	if (n) return new iI(new TR(new Uint8Array(n.data)));
}
async function Dz(e, t) {
	let n = dF(e), r = Math.max(.3, e.areaMeters / e.modelMillimeters * .07), i = await _z(t, 4, async (e) => {
		let t = [], i = (await Ez("buildings", e))?.layers.building;
		if (!i) return t;
		for (let a = 0; a < i.length; a += 1) {
			let o = i.feature(a);
			if (o.type === 3) for (let [i, s] of eI(o.loadGeometry()).entries()) {
				let c = KP(YP(s[0]?.map((t) => mz(t, e, o.extent)) ?? [], ...n), r);
				c.length < 3 || Math.abs(VP(c)) < 3 || t.push({
					id: String(o.id ?? o.properties.id ?? `${e.x}-${e.y}-${a}-${i}`),
					footprint: c,
					groundMeters: 0,
					heightMeters: vz(o.properties),
					sourceLod: "LoD0"
				});
			}
		}
		return t;
	}), a = /* @__PURE__ */ new Map();
	for (let e of i.flat()) {
		let t = a.get(e.id);
		(!t || Math.abs(VP(e.footprint)) > Math.abs(VP(t.footprint))) && a.set(e.id, e);
	}
	return [...a.values()];
}
async function Oz(e, t) {
	let n = dF(e), r = Math.max(.4, e.areaMeters / e.modelMillimeters * .09);
	return (await _z(t, 4, async (e) => {
		let t = [], i = (await Ez("transportation", e))?.layers.segment;
		if (!i) return t;
		for (let a = 0; a < i.length; a += 1) {
			let o = i.feature(a);
			if (o.type !== 2 || !wz(o.properties)) continue;
			let s = Cz(o.properties);
			for (let [i, c] of o.loadGeometry().entries()) {
				let l = GP(c.map((t) => mz(t, e, o.extent)), r);
				for (let [r, c] of gz(l, n).entries()) t.push({
					id: `${String(o.id ?? a)}-${e.x}-${e.y}-${i}-${r}`,
					points: c,
					...s
				});
			}
		}
		return t;
	})).flat();
}
async function kz(e, t) {
	let n = dF(e), r = Math.max(.35, e.areaMeters / e.modelMillimeters * .08), i = await _z(t, 4, async (e) => {
		let t = [], i = [], a = [], o = await Ez("base", e);
		if (!o) return {
			water: t,
			greenery: i,
			trees: a
		};
		let s = (t, i, a) => {
			let s = o.layers[t];
			if (s) for (let o = 0; o < s.length; o += 1) {
				let c = s.feature(o);
				if (!(c.type !== 3 || a && !a(c.properties))) for (let [a, s] of eI(c.loadGeometry()).entries()) {
					let l = KP(YP(s[0]?.map((t) => mz(t, e, c.extent)) ?? [], ...n), r);
					if (l.length < 3 || Math.abs(VP(l)) < 3) continue;
					let u = s.slice(1).map((t) => t.map((t) => mz(t, e, c.extent))).map((e) => KP(YP(e, ...n), r)).filter((e) => e.length >= 3 && Math.abs(VP(e)) >= 3 && e.every((e) => _F(e, l)));
					i.push({
						id: `${t}-${String(c.id ?? o)}-${e.x}-${e.y}-${a}`,
						footprint: l,
						holes: u
					});
				}
			}
		};
		s("water", t), s("land_cover", i, Tz), s("land_use", i, Tz), s("land", i, Tz);
		let c = o.layers.land;
		if (c) for (let t = 0; t < c.length; t += 1) {
			let r = c.feature(t), i = `${String(r.properties.class ?? "")} ${String(r.properties.subtype ?? "")}`.toLowerCase();
			if (!(r.type !== 1 || !i.includes("tree"))) for (let [i, o] of r.loadGeometry().entries()) {
				let s = o[0] && mz(o[0], e, r.extent);
				!s || s[0] < n[0] || s[0] > n[2] || s[1] < n[1] || s[1] > n[3] || a.push({
					id: `tree-${String(r.id ?? t)}-${e.x}-${e.y}-${i}`,
					point: s,
					heightMeters: 10,
					crownMeters: 6
				});
			}
		}
		return {
			water: t,
			greenery: i,
			trees: a
		};
	});
	return {
		water: i.flatMap((e) => e.water),
		greenery: i.flatMap((e) => e.greenery),
		trees: i.flatMap((e) => e.trees)
	};
}
function Az(e) {
	return e <= 900 ? 17 : e <= 1800 ? 16 : e <= 4500 ? 15 : 14;
}
async function jz(e) {
	if (typeof createImageBitmap != "function") throw Error("De browser kan de wereldwijde hoogtetegels niet decoderen.");
	let t = await createImageBitmap(await e.blob()), n = document.createElement("canvas");
	n.width = t.width, n.height = t.height;
	let r = n.getContext("2d", { willReadFrequently: !0 });
	if (!r) throw Error("De browser kon de hoogte-afbeelding niet lezen.");
	r.drawImage(t, 0, 0);
	let i = {
		pixels: r.getImageData(0, 0, n.width, n.height).data,
		width: n.width,
		height: n.height
	};
	return t.close(), i;
}
async function Mz(e, t, n) {
	let r = Az(e.areaMeters), i = pz(e, r), a = 0;
	n?.({
		stage: "terrain",
		completed: a,
		total: i.length,
		message: `Hoogtekaart laden: 0 van ${i.length} delen`
	});
	let o = await _z(i, 4, async (e) => {
		let n = new URL("/api/geodata/global-terrain", window.__PLEKBEELD_API_ORIGIN__ || window.location.origin);
		n.searchParams.set("z", String(e.zoom)), n.searchParams.set("x", String(e.x)), n.searchParams.set("y", String(e.y));
		let r = await t(n, { headers: { Accept: "image/webp,image/*" } });
		if (!r.ok) throw Error(`Hoogtekaart gaf status ${r.status}.`);
		return {
			tile: e,
			...await jz(r)
		};
	}, () => {
		a += 1, n?.({
			stage: "terrain",
			completed: a,
			total: i.length,
			message: `Hoogtekaart laden: ${a} van ${i.length} delen`
		});
	}), s = new Map(o.map((e) => [`${e.tile.x}/${e.tile.y}`, e])), [c, l, u, d] = dF(e), f = Math.max(65, Math.min(129, Math.round(e.elevationResolution ?? 97))), p = [];
	for (let e = 0; e < f; e += 1) for (let t = 0; t < f; t += 1) {
		let n = c + t / (f - 1) * (u - c), i = d - e / (f - 1) * (d - l), a = fz(r), o = Math.floor((n + sz) / a), m = Math.floor((sz - i) / a), h = s.get(`${o}/${m}`);
		if (!h) {
			p.push(0);
			continue;
		}
		let g = Math.max(0, Math.min(h.width - 1, Math.floor(((n + sz) / a - o) * h.width))), _ = (Math.max(0, Math.min(h.height - 1, Math.floor(((sz - i) / a - m) * h.height))) * h.width + g) * 4;
		p.push(h.pixels[_] * 256 + h.pixels[_ + 1] + h.pixels[_ + 2] / 256 - 32768);
	}
	return {
		width: f,
		height: f,
		values: p,
		minimumElevation: Math.min(...p),
		maximumElevation: Math.max(...p)
	};
}
async function Nz(e, t = fetch, n) {
	let r = pz(e, 14), i = 0, a = (e) => {
		i += 1, n?.({
			stage: "features",
			completed: i,
			total: 3,
			message: e
		});
	};
	n?.({
		stage: "features",
		completed: 0,
		total: 3,
		message: "Wereldkaart laden: gebouwen"
	});
	let o = e.terrainEnabled ? Mz(e, t, n) : Promise.resolve(void 0), s = yz(e), c = e.buildingsEnabled === !1 ? Promise.resolve([]).then((e) => (a("Wereldkaart laden: gebouwen gereed"), e)) : (s ? Sz(e, t, n) : Dz(e, r)).then((e) => (a(`Wereldkaart: ${e.length.toLocaleString("nl-NL")} gebouwen`), e)), l = e.roadsEnabled ? Oz(e, r).then((e) => (a("Wereldkaart laden: wegen gereed"), e)) : Promise.resolve([]).then((e) => (a("Wereldkaart laden: wegen overgeslagen"), e)), u = kz(e, pz(e, 13)).then((e) => (a(`Wereldkaart: ${e.trees.length.toLocaleString("nl-NL")} boomlocaties geladen`), e)), [d, f, p, m] = await Promise.all([
		c,
		l,
		u,
		o
	]);
	return {
		buildings: d,
		roads: [],
		roadLines: f,
		water: e.waterEnabled ? p.water : [],
		greenery: e.greeneryEnabled === !1 ? [] : p.greenery,
		trees: e.treesEnabled === !1 ? [] : p.trees,
		terrain: m,
		lod: s ? "LoD0 · IGN BD TOPO" : "LoD0 · Overture",
		warnings: [s ? "Frankrijk gebruikt IGN BD TOPO-gebouwen en Mapterhorn-hoogtegegevens." : "Werelddekking gebruikt Overture-objecten en Mapterhorn-hoogtegegevens; beschikbaar detail verschilt per land."],
		attribution: s ? "IGN France BD TOPO (Licence Ouverte 2.0) · Mapterhorn · Overture Maps / OpenStreetMap-bijdragers" : "Overture Maps Foundation / OpenStreetMap-bijdragers · Mapterhorn"
	};
}
//#endregion
//#region lib/map-data.ts
var Pz = "https://api.pdok.nl/lv/bgt/ogc/v1/collections", Fz = "https://service.pdok.nl/rws/ahn/wcs/v1_0", Iz = "https://api.pdok.nl/kadaster/brt-top10nl/ogc/v1/tiles/NetherlandsRDNewQuad", Lz = "http://www.opengis.net/def/crs/EPSG/0/28992", Rz = [-285401.92, 903401.92];
function zz(e) {
	return e && typeof e == "object" ? e : void 0;
}
function Bz(e) {
	return dF(e);
}
function Vz(e, t) {
	return typeof window < "u" ? new URL(e, window.__PLEKBEELD_API_ORIGIN__ || window.location.origin) : new URL(t);
}
async function Hz(e, t, n, r, i = 3) {
	let a, o;
	for (let s = 0; s < i; s += 1) {
		try {
			let a = await e(t, {
				...n,
				signal: AbortSignal.timeout(r)
			});
			if (o = a, a.ok || ![
				429,
				502,
				503,
				504
			].includes(a.status) || s === i - 1) return a;
		} catch (e) {
			if (a = e, e instanceof DOMException && e.name === "AbortError" || s === i - 1) throw e;
		}
		await new Promise((e) => setTimeout(e, 350 * 2 ** s));
	}
	if (o) return o;
	throw a instanceof Error ? a : /* @__PURE__ */ Error("De databron reageerde niet op tijd.");
}
function Uz(e) {
	return Number.isFinite(e) && e > -100 && e < 1e3;
}
function Wz(e, t, n) {
	let r = e.map((e) => Uz(e) ? e : NaN), i = r.map((e) => !Number.isFinite(e)), a = r.filter(Number.isFinite);
	if (a.length === 0) throw Error("AHN bevat geen bruikbare hoogtemetingen.");
	let o = [...a].sort((e, t) => e - t)[Math.floor(a.length / 2)];
	for (let e = 0; e < Math.max(t, n) && r.some(Number.isNaN); e += 1) {
		let e = [...r], i = !1;
		for (let a = 0; a < n; a += 1) for (let o = 0; o < t; o += 1) {
			let s = a * t + o;
			if (Number.isFinite(r[s])) continue;
			let c = 0, l = 0;
			for (let e = -1; e <= 1; e += 1) for (let i = -1; i <= 1; i += 1) {
				if (i === 0 && e === 0) continue;
				let s = o + i, u = a + e;
				if (s < 0 || u < 0 || s >= t || u >= n) continue;
				let d = r[u * t + s];
				Number.isFinite(d) && (c += d, l += 1);
			}
			l > 0 && (e[s] = c / l, i = !0);
		}
		if (r = e, !i) break;
	}
	r = r.map((e) => Number.isFinite(e) ? e : o);
	for (let e = 0; e < 3; e += 1) {
		let e = [...r];
		for (let a = 0; a < n; a += 1) for (let o = 0; o < t; o += 1) {
			let s = a * t + o;
			if (!i[s]) continue;
			let c = 0, l = 0;
			for (let e = -1; e <= 1; e += 1) for (let i = -1; i <= 1; i += 1) {
				let s = o + i, u = a + e;
				if (s < 0 || u < 0 || s >= t || u >= n) continue;
				let d = i === 0 && e === 0 ? 2 : 1;
				c += r[u * t + s] * d, l += d;
			}
			l > 0 && (e[s] = c / l);
		}
		r = e;
	}
	return r;
}
async function Gz(e, t = fetch) {
	let n = await Kz(e, "dtm_05m", Math.max(33, Math.min(81, Math.round(e.elevationResolution ?? 65))), t), r = Wz(n.values, n.width, n.height), i = [...r].sort((e, t) => e - t), a = i[Math.floor(i.length * .01)], o = i[Math.max(0, Math.ceil(i.length * .99) - 1)], s = r.map((e) => Math.max(a, Math.min(o, e)));
	return {
		width: n.width,
		height: n.height,
		values: s,
		minimumElevation: Math.min(...s),
		maximumElevation: Math.max(...s)
	};
}
async function Kz(e, t, n, r) {
	let i = Bz(e), a = Vz("/api/geodata/terrain", Fz);
	typeof window < "u" ? (a.searchParams.set("bbox", i.join(",")), a.searchParams.set("size", String(n)), a.searchParams.set("coverage", t === "dsm_05m" ? "dsm" : "dtm")) : (a.searchParams.set("SERVICE", "WCS"), a.searchParams.set("VERSION", "2.0.1"), a.searchParams.set("REQUEST", "GetCoverage"), a.searchParams.set("COVERAGEID", t), a.searchParams.set("FORMAT", "image/tiff"), a.searchParams.append("SUBSET", `x(${i[0]},${i[2]})`), a.searchParams.append("SUBSET", `y(${i[1]},${i[3]})`), a.searchParams.set("SCALESIZE", `x(${n}),y(${n})`));
	let o = await Hz(r, a, { headers: { Accept: "image/tiff" } }, 3e4, 2);
	if (!o.ok) throw Error(`AHN gaf status ${o.status}.`);
	let s = await (await _R(await o.arrayBuffer())).getImage(), c = await s.readRasters({ interleave: !0 });
	return {
		width: s.getWidth(),
		height: s.getHeight(),
		values: Array.from(c, Number)
	};
}
function qz(e, t) {
	return !t.some((t) => {
		let n = t.footprint.map((e) => e[0]), r = t.footprint.map((e) => e[1]);
		return e.point[0] < Math.min(...n) || e.point[0] > Math.max(...n) || e.point[1] < Math.min(...r) || e.point[1] > Math.max(...r) ? !1 : nF(e.point, t.footprint);
	});
}
function Jz(e, t, n) {
	if (t.width !== n.width || t.height !== n.height) return [];
	let r = t.width, i = t.height;
	if (r < 5 || i < 5) return [];
	let a = Wz(t.values, r, i), o = Wz(n.values, r, i), [s, c, l, u] = Bz(e), d = (l - s) / r, f = (u - c) / i, p = o.map((e, t) => e - a[t]), m = [];
	for (let e = 1; e < i - 1; e += 1) for (let t = 1; t < r - 1; t += 1) {
		let n = p[e * r + t];
		if (!Number.isFinite(n) || n < 3) continue;
		let i = 0, a = !0;
		for (let o = -1; o <= 1; o += 1) for (let s = -1; s <= 1; s += 1) {
			let c = p[(e + o) * r + t + s];
			c >= 2.25 && (i += 1), (s !== 0 || o !== 0) && c > n && (a = !1);
		}
		if (!a || i < 3) continue;
		let o = [s + (t + .5) * d, u - (e + .5) * f];
		m.push({
			id: `ahn-kroon-${e}-${t}`,
			point: o,
			heightMeters: n,
			crownMeters: Math.max(3, Math.min(18, Math.sqrt(i * d * f) * 1.45))
		});
	}
	let h = [];
	for (let e of m.sort((e, t) => (t.heightMeters ?? 0) - (e.heightMeters ?? 0))) {
		let t = Math.max(3.5, Math.min(7, (e.crownMeters ?? 4) * .72));
		h.some((n) => Math.hypot(n.point[0] - e.point[0], n.point[1] - e.point[1]) < t) || h.push(e);
	}
	return h;
}
async function Yz(e, t) {
	let n = Math.max(129, Math.min(401, Math.round(e.areaMeters / 1.6))), [r, i] = await Promise.all([Kz(e, "dtm_05m", n, t), Kz(e, "dsm_05m", n, t)]);
	return Jz(e, r, i);
}
function Xz(e, t, n) {
	let r = [...e];
	for (let e of t) {
		if (!qz(e, n)) continue;
		let t = r.findIndex((t) => Math.hypot(t.point[0] - e.point[0], t.point[1] - e.point[1]) < 4);
		if (t >= 0) {
			r[t] = {
				...r[t],
				heightMeters: e.heightMeters,
				crownMeters: e.crownMeters
			};
			continue;
		}
		r.push(e);
	}
	return r;
}
function Zz(e) {
	let t = zz(e), n = t?.coordinates;
	return Array.isArray(n) ? (t?.type === "Polygon" ? [n] : t?.type === "MultiPolygon" ? n : []).flatMap((e) => {
		if (!Array.isArray(e)) return [];
		let t = e.filter(Array.isArray).map((e) => UP(e.filter(Array.isArray).map((e) => [Number(e[0]), Number(e[1])]).filter((e) => e.every(Number.isFinite)))).filter((e) => e.length >= 3);
		return t.length > 0 ? [{
			footprint: t[0],
			holes: t.slice(1)
		}] : [];
	}) : [];
}
function Qz(e) {
	let t = (Array.isArray(e?.links) ? e.links.map(zz) : []).find((e) => e?.rel === "next" && typeof e.href == "string")?.href;
	if (typeof t == "string") try {
		return new URL(t).searchParams.get("cursor") ?? void 0;
	} catch {
		return;
	}
}
async function $z(e, t, n, r = 8) {
	let i = Bz(t), a = [], o, s = /* @__PURE__ */ new Set();
	for (let t = 0; r === null || t < r; t += 1) {
		let t = Vz("/api/geodata/bgt", `${Pz}/${e}/items`);
		typeof window < "u" ? (t.searchParams.set("collection", e), t.searchParams.set("bbox", i.join(",")), o && t.searchParams.set("cursor", o)) : (t.searchParams.set("bbox", i.join(",")), t.searchParams.set("bbox-crs", Lz), t.searchParams.set("crs", Lz), t.searchParams.set("datetime", (/* @__PURE__ */ new Date()).toISOString()), t.searchParams.set("limit", "1000"), t.searchParams.set("f", "json"), o && t.searchParams.set("cursor", o));
		let r = await Hz(n, t, { headers: { Accept: "application/json" } }, 18e3);
		if (!r.ok) throw Error(`BGT ${e} gaf status ${r.status}.`);
		let c = zz(await r.json());
		if (Array.isArray(c?.features) && a.push(...c.features), o = Qz(c), !o) return {
			features: a,
			truncated: !1
		};
		if (s.has(o)) throw Error(`BGT ${e} stuurde een herhaalde paginacursor.`);
		s.add(o);
	}
	return {
		features: a,
		truncated: !0
	};
}
async function eB(e, t, n, r = 8) {
	let i = Bz(t), a = await $z(e, t, n, r), o = e === "begroeidterreindeel" ? .03 : Math.max(.08, t.areaMeters / t.modelMillimeters * .04), s = [];
	for (let t of a.features) {
		let n = zz(t), r = zz(n?.properties), a = typeof r?.lokaal_id == "string" && r.lokaal_id || typeof n?.id == "string" && n.id || `${e}-${s.length}`;
		for (let [e, t] of Zz(n?.geometry).entries()) {
			let n = KP(YP(t.footprint, ...i), o);
			if (n.length >= 3 && Math.abs(VP(n)) > 1e-4) {
				let r = t.holes.map((e) => KP(YP(e, ...i), o)).filter((e) => e.length >= 3 && Math.abs(VP(e)) > 1e-4);
				s.push({
					id: `${a}-${e}`,
					footprint: n,
					holes: r
				});
			}
		}
	}
	return {
		surfaces: yB(s, vB),
		truncated: a.truncated
	};
}
function tB(e) {
	let t = zz(e);
	if (t?.type !== "Point" || !Array.isArray(t.coordinates)) return;
	let n = [Number(t.coordinates[0]), Number(t.coordinates[1])];
	return n.every(Number.isFinite) ? n : void 0;
}
async function nB(e, t, n) {
	let [r, i, a, o] = Bz(e), s = 2500, c = Math.max(1, Math.ceil((a - r) / s)), l = Math.max(1, Math.ceil((o - i) / s)), u = (a - r) / c, d = (o - i) / l, f = Array.from({ length: l * c }, (t, n) => {
		let a = n % c, o = Math.floor(n / c), s = r + a * u, l = i + o * d, f = r + (a + 1) * u, p = i + (o + 1) * d;
		return {
			...e,
			centerX: (s + f) / 2,
			centerY: (l + p) / 2,
			areaMeters: Math.max(f - s, p - l),
			selectionShape: "rectangle",
			selectionPolygon: [
				[s, l],
				[f, l],
				[f, p],
				[s, p]
			]
		};
	}), p = 0;
	n?.({
		stage: "features",
		completed: 0,
		total: f.length,
		message: `Bomen zoeken: 0 van ${f.length} gebieden`
	});
	let m = await pB(f, 5, (e) => $z("vegetatieobject_punt", e, t, null), () => {
		p += 1, n?.({
			stage: "features",
			completed: p,
			total: f.length,
			message: `Bomen zoeken: ${p} van ${f.length} gebieden`
		});
	}), h = {
		features: m.flatMap((e) => e.features),
		truncated: m.some((e) => e.truncated)
	}, g = /* @__PURE__ */ new Map(), _ = [];
	for (let e of h.features) {
		let t = zz(e), n = zz(t?.properties);
		if (!String(n?.plus_type ?? n?.type ?? "").toLowerCase().includes("boom")) continue;
		let r = tB(t?.geometry);
		if (!r) continue;
		let i = typeof n?.lokaal_id == "string" && n.lokaal_id || typeof t?.id == "string" && t.id || `boom-${_.length}`;
		g.set(i, {
			id: i,
			point: r
		});
	}
	return _.push(...g.values()), n?.({
		stage: "features",
		completed: Math.max(1, _.length),
		total: Math.max(1, _.length),
		message: `${_.length.toLocaleString("nl-NL")} boomlocaties gevonden`
	}), {
		trees: _,
		truncated: h.truncated
	};
}
function rB(e) {
	return e <= 1700 ? 11 : e <= 4600 ? 10 : 9;
}
function iB(e) {
	let t = rB(e.areaMeters), n = 3440.64 / 2 ** t * 256, [r, i, a, o] = Bz(e), s = Math.floor((r - Rz[0]) / n), c = Math.floor((a - Rz[0]) / n), l = Math.floor((Rz[1] - o) / n), u = Math.floor((Rz[1] - i) / n), d = [];
	for (let e = l; e <= u; e += 1) for (let r = s; r <= c; r += 1) d.push({
		zoom: t,
		row: e,
		column: r,
		span: n
	});
	if (d.length > 49) throw Error("Deze selectie vraagt meer dan 49 kaarttegels.");
	return d;
}
function aB(e, t, n) {
	let r = Rz[0] + t.column * t.span, i = Rz[1] - t.row * t.span;
	return [r + e.x / n * t.span, i - e.y / n * t.span];
}
function oB(e, t, [n, r, i, a]) {
	let o = t[0] - e[0], s = t[1] - e[1], c = 0, l = 1;
	for (let [t, u] of [
		[-o, e[0] - n],
		[o, i - e[0]],
		[-s, e[1] - r],
		[s, a - e[1]]
	]) {
		if (Math.abs(t) < 1e-12) {
			if (u < 0) return;
			continue;
		}
		let e = u / t;
		if (t < 0 ? c = Math.max(c, e) : l = Math.min(l, e), c > l) return;
	}
	return [[e[0] + c * o, e[1] + c * s], [e[0] + l * o, e[1] + l * s]];
}
function sB(e, t) {
	let n = [], r = [], i = (e, t) => Math.abs(e[0] - t[0]) < 1e-6 && Math.abs(e[1] - t[1]) < 1e-6;
	for (let a = 0; a < e.length - 1; a += 1) {
		let o = oB(e[a], e[a + 1], t);
		if (!o) {
			r.length >= 2 && n.push(r), r = [];
			continue;
		}
		r.length === 0 || !i(r[r.length - 1], o[0]) ? (r.length >= 2 && n.push(r), r = [o[0], o[1]]) : i(r[r.length - 1], o[1]) || r.push(o[1]);
	}
	return r.length >= 2 && n.push(r), n;
}
function cB(e) {
	let t = String(e.hoogteklasse ?? "").toLowerCase(), n = String(e.typegebouw ?? "").toLowerCase();
	return t.includes("hoogbouw") ? 24 : n.includes("toren") || n.includes("kerk") ? 30 : t.includes("laagbouw") ? 8.5 : 11;
}
function lB(e) {
	return !String(e.typeweg ?? "").toLowerCase().includes("veerverbinding");
}
function uB(e) {
	let t = String(e.typeweg ?? "").toLowerCase();
	return t.includes("autosnelweg") ? 1 : t.includes("hoofdweg") ? 2 : t.includes("regionale") ? 3 : t.includes("lokale") ? 4 : 5;
}
function dB(e) {
	let t = String(e.verhardingsbreedteklasse ?? "");
	return t.includes("> 7") ? 9 : t.includes("4 - 7") ? 5.5 : t.includes("2 - 4") ? 3 : t.includes("< 2") ? 1.5 : uB(e) <= 3 ? 8 : 4;
}
function fB(e) {
	let t = Number(e.hoogteniveau ?? 0), n = String(e.typeinfrastructuur ?? "").toLowerCase(), r = String(e.fysiekvoorkomen ?? "").toLowerCase(), i = String(e.brugnaam ?? "").trim(), a = String(e.tunnelnaam ?? "").trim();
	return {
		level: Number.isFinite(t) ? t : 0,
		bridge: t > 0 || !!i || n.includes("brug") || r.includes("brug"),
		tunnel: t < 0 || !!a || n.includes("tunnel") || n.includes("overkluis") || r.includes("tunnel") || r.includes("overkluis")
	};
}
async function pB(e, t, n, r) {
	let i = Array(e.length), a = 0, o = Array.from({ length: Math.min(t, e.length) }, async () => {
		for (; a < e.length;) {
			let t = a;
			a += 1, i[t] = await n(e[t]), r?.(e[t], i[t]);
		}
	});
	return await Promise.all(o), i;
}
async function mB(e, t, n) {
	let r = Vz("/api/geodata/top10-tile", `${Iz}/${e.zoom}/${e.row}/${e.column}?f=mvt`);
	typeof window < "u" && (r.searchParams.set("z", String(e.zoom)), r.searchParams.set("row", String(e.row)), r.searchParams.set("col", String(e.column)));
	let i = await Hz(n, r, { headers: { Accept: "application/vnd.mapbox-vector-tile" } }, 18e3);
	if (!i.ok) throw Error(`TOP10NL-tegel gaf status ${i.status}.`);
	let a = new iI(new TR(new Uint8Array(await i.arrayBuffer()))), o = Bz(t), s = Math.max(.35, t.areaMeters / t.modelMillimeters * .08), c = [], l = [], u = [], d = [], f = a.layers.gebouw_vlak;
	if (f) for (let t = 0; t < f.length; t += 1) {
		let n = f.feature(t), r = eI(n.loadGeometry());
		for (let [i, a] of r.entries()) {
			let r = KP(YP(a[0]?.map((t) => aB(t, e, n.extent)) ?? [], ...o), s);
			if (r.length < 3 || Math.abs(VP(r)) < 4) continue;
			let l = String(n.properties.lokaalid ?? `tile-${e.zoom}-${e.row}-${e.column}-${t}`);
			c.push({
				id: `${l}-${i}`,
				footprint: r,
				groundMeters: 0,
				heightMeters: cB(n.properties),
				sourceLod: "LoD0"
			});
		}
	}
	let p = a.layers.wegdeel_hartlijn;
	if (p) for (let n = 0; n < p.length; n += 1) {
		let r = p.feature(n);
		if (!lB(r.properties)) continue;
		let i = uB(r.properties), a = dB(r.properties), c = fB(r.properties);
		if (!(t.areaMeters > 4600 && i >= 5 && a < 7)) for (let [t, u] of r.loadGeometry().entries()) {
			let d = GP(u.map((t) => aB(t, e, r.extent)), s);
			for (let [s, u] of sB(d, o).entries()) l.push({
				id: `${String(r.properties.lokaalid ?? n)}-${e.row}-${e.column}-${t}-${s}`,
				points: u,
				widthMeters: a,
				priority: i,
				...c
			});
		}
	}
	let m = a.layers.waterdeel_vlak;
	if (m) for (let t = 0; t < m.length; t += 1) {
		let n = m.feature(t);
		for (let [r, i] of eI(n.loadGeometry()).entries()) {
			let a = KP(YP(i[0]?.map((t) => aB(t, e, n.extent)) ?? [], ...o), s);
			if (a.length >= 3 && Math.abs(VP(a)) >= 3) {
				let c = i.slice(1).map((t) => t.map((t) => aB(t, e, n.extent))).map((e) => KP(YP(e, ...o), s)).filter((e) => e.length >= 3 && Math.abs(VP(e)) >= 3);
				u.push({
					id: `${String(n.properties.lokaalid ?? t)}-${e.row}-${e.column}-${r}`,
					footprint: a,
					holes: c
				});
			}
		}
	}
	let h = a.layers.terrein_vlak;
	if (h) for (let t = 0; t < h.length; t += 1) {
		let n = h.feature(t), r = String(n.properties.typelandgebruik ?? "").toLowerCase(), i = String(n.properties.fysiekvoorkomen ?? "").toLowerCase();
		if ([
			"bos",
			"gras",
			"heide",
			"akker",
			"boomgaard",
			"boomkwekerij",
			"fruitteelt",
			"weide"
		].some((e) => r.includes(e) || i.includes(e))) for (let [r, i] of eI(n.loadGeometry()).entries()) {
			let a = KP(YP(i[0]?.map((t) => aB(t, e, n.extent)) ?? [], ...o), s);
			if (a.length < 3 || Math.abs(VP(a)) < 3) continue;
			let c = i.slice(1).map((t) => t.map((t) => aB(t, e, n.extent))).map((e) => KP(YP(e, ...o), s)).filter((e) => e.length >= 3 && Math.abs(VP(e)) >= 3);
			d.push({
				id: `green-${String(n.properties.lokaalid ?? t)}-${e.row}-${e.column}-${r}`,
				footprint: a,
				holes: c
			});
		}
	}
	return {
		buildings: c,
		roadLines: l,
		water: u,
		greenery: d
	};
}
function hB(e, t) {
	if (e.length <= t) return e;
	let n = e.length / t;
	return Array.from({ length: t }, (t, r) => e[Math.floor(r * n)]);
}
function gB(e) {
	return e.map(([e, t]) => `${Math.round(e * 10)},${Math.round(t * 10)}`);
}
function _B(e) {
	let t = gB(e.points).join(";"), n = gB([...e.points].reverse()).join(";");
	return `${Math.round(e.widthMeters * 10)}|${t < n ? t : n}`;
}
function vB(e) {
	let t = gB(e.footprint);
	if (t.length === 0) return "";
	let n = (e) => {
		let t = [...e].sort()[0];
		return e.flatMap((n, r) => n === t ? [[...e.slice(r), ...e.slice(0, r)].join(";")] : []).sort()[0];
	};
	return `${[n(t), n([...t].reverse())].sort()[0]}#${(e.holes ?? []).map(gB).map((e) => [n(e), n([...e].reverse())].sort()[0]).sort().join("|")}`;
}
function yB(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let r of e) {
		let e = t(r);
		n.has(e) || n.set(e, r);
	}
	return [...n.values()];
}
function bB(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let e = t.get(n.id);
		(!e || Math.abs(VP(n.footprint)) > Math.abs(VP(e.footprint))) && t.set(n.id, n);
	}
	return [...t.values()];
}
async function xB(e, t, n) {
	let r = iB(e), i = 0;
	n?.({
		stage: "features",
		completed: 0,
		total: r.length,
		message: `Kaartlagen laden: 0 van ${r.length} delen`
	});
	let a = await pB(r, 6, (n) => mB(n, e, t), () => {
		i += 1, n?.({
			stage: "features",
			completed: i,
			total: r.length,
			message: `Kaartlagen laden: ${i} van ${r.length} delen`
		});
	}), o = bB(a.flatMap((e) => e.buildings)), s = yB(a.flatMap((e) => e.roadLines), _B).sort((e, t) => e.priority - t.priority), c = yB(a.flatMap((e) => e.water), vB), l = yB(a.flatMap((e) => e.greenery), vB), u = hB(o, 3e4), d = hB(s, 8e3), f = hB(c, 4e3), p = l, m = [];
	return u.length < o.length && m.push("Gebouwen zijn op printresolutie uitgedund."), d.length < s.length && m.push("De fijnste straten zijn op stadsniveau uitgedund."), f.length < c.length && m.push("Kleine waterdelen zijn op stadsniveau uitgedund."), {
		buildings: u,
		roadLines: d,
		water: f,
		greenery: p,
		warnings: m
	};
}
function SB(e, t = "auto", n = "rd") {
	return n === "web-mercator" ? "LoD0 · Overture" : t === "lod0" ? "LoD0 · TOP10NL" : t === "lod22" ? "LoD2.2 · 3DBAG" : t === "lod13" ? "LoD1.3 · 3DBAG" : t === "lod12" ? "LoD1.2 · 3DBAG" : e <= 500 ? "LoD2.2 · 3DBAG" : e <= 800 ? "LoD1.3 · 3DBAG" : "LoD0 · TOP10NL";
}
async function CB(e, t = fetch, n) {
	if (e.coordinateSystem === "web-mercator") return Nz(e, t, n);
	let r = SB(e.areaMeters, e.buildingLod, e.coordinateSystem), i = [], a = e.greeneryEnabled !== !1, o = e.treesEnabled !== !1;
	if (e.roadsEnabled && e.roadSource === "bgt-surfaces" && e.areaMeters > 1200) throw Error("BGT-wegvlakken zijn begrensd tot 1,2 km. Kies voor dit gebied het schone TOP10NL-lijnennet.");
	let s = e.terrainEnabled ? Gz(e, t).then((e) => (n?.({
		stage: "terrain",
		completed: 1,
		total: 1,
		message: "Terrein is geladen en gecontroleerd"
	}), e)).catch((e) => {
		i.push(e instanceof Error ? `Terrein: ${e.message}` : "AHN-terrein ontbreekt.");
	}) : Promise.resolve(void 0);
	if (r !== "LoD0 · TOP10NL") {
		let c = e.buildingsEnabled === !1 ? Promise.resolve({
			buildings: [],
			warnings: [],
			matchedCount: 0
		}) : ZF(e, t, n), l = e.areaMeters <= 1200, u = e.areaMeters <= 2600, d = (e.roadSource ?? "clean-lines") === "clean-lines", f = l && e.roadsEnabled && !d ? Promise.all(["wegdeel", "ondersteunendwegdeel"].map((n) => eB(n, e, t).catch((e) => (i.push(e instanceof Error ? e.message : `BGT ${n} ontbreekt.`), {
			surfaces: [],
			truncated: !1
		})))) : Promise.resolve([]), p = l && e.waterEnabled ? Promise.all(["waterdeel", "ondersteunendwaterdeel"].map((n) => eB(n, e, t).catch((e) => (i.push(e instanceof Error ? e.message : `BGT ${n} ontbreekt.`), {
			surfaces: [],
			truncated: !1
		})))) : Promise.resolve([]), m = u && a ? eB("begroeidterreindeel", e, t, null).catch((e) => (i.push(e instanceof Error ? e.message : "BGT-groen ontbreekt."), {
			surfaces: [],
			truncated: !1
		})) : Promise.resolve({
			surfaces: [],
			truncated: !1
		}), h = o ? nB(e, t, n).catch((e) => (i.push(e instanceof Error ? e.message : "BGT-bomen ontbreken."), {
			trees: [],
			truncated: !1
		})) : Promise.resolve({
			trees: [],
			truncated: !1
		}), g = o && e.areaMeters <= 800 ? Yz(e, t).catch((e) => (i.push(e instanceof Error ? `AHN-boomkronen: ${e.message}` : "AHN-boomkronen ontbreken."), [])) : Promise.resolve([]), _ = !l || e.roadsEnabled && d ? xB(e, t, n) : Promise.resolve(void 0), [v, y, b, x, S, C, w, T] = await Promise.all([
			c,
			s,
			f,
			p,
			m,
			h,
			g,
			_
		]);
		return i.push(...v.warnings), n?.({
			stage: "features",
			completed: 1,
			total: 1,
			message: "Wegen, water en groen zijn geladen"
		}), b.some((e) => e.truncated) && i.push("Niet alle BGT-wegvlakken pasten in één aanvraag."), x.some((e) => e.truncated) && i.push("Niet alle BGT-watervlakken pasten in de paginering."), T && i.push(...T.warnings), {
			buildings: e.buildingsEnabled === !1 ? [] : v.buildings,
			roads: yB(b.flatMap((e) => e.surfaces), vB),
			roadLines: e.roadsEnabled && d ? T?.roadLines ?? [] : [],
			water: e.waterEnabled ? l ? yB(x.flatMap((e) => e.surfaces), vB) : T?.water ?? [] : [],
			greenery: a ? S.surfaces.length > 0 ? S.surfaces : T?.greenery ?? [] : [],
			trees: Xz(C.trees, w, v.buildings),
			terrain: y,
			lod: r,
			warnings: i
		};
	}
	let c = o ? nB(e, t, n).catch((e) => (i.push(e instanceof Error ? e.message : "BGT-bomen ontbreken."), {
		trees: [],
		truncated: !1
	})) : Promise.resolve({
		trees: [],
		truncated: !1
	}), l = o && e.areaMeters <= 800 ? Yz(e, t).catch((e) => (i.push(e instanceof Error ? `AHN-boomkronen: ${e.message}` : "AHN-boomkronen ontbreken."), [])) : Promise.resolve([]), u = e.areaMeters <= 2600 && a ? eB("begroeidterreindeel", e, t, null).catch((e) => (i.push(e instanceof Error ? e.message : "BGT-groen ontbreekt."), {
		surfaces: [],
		truncated: !1
	})) : Promise.resolve({
		surfaces: [],
		truncated: !1
	}), [d, f, p, m, h] = await Promise.all([
		xB(e, t, n),
		s,
		c,
		u,
		l
	]);
	return i.push(...d.warnings), n?.({
		stage: "features",
		completed: 1,
		total: 1,
		message: "Kaartlagen zijn geladen"
	}), {
		buildings: e.buildingsEnabled === !1 ? [] : d.buildings,
		roads: [],
		roadLines: e.roadsEnabled ? d.roadLines : [],
		water: e.waterEnabled ? d.water : [],
		greenery: a ? m.surfaces.length > 0 ? m.surfaces : d.greenery : [],
		trees: Xz(p.trees, h, d.buildings),
		terrain: f,
		lod: r,
		warnings: i
	};
}
//#endregion
//#region lib/model.ts
var wB = /* @__PURE__ */ h((/* @__PURE__ */ p(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self, n.polygonClipping = r());
	})(e, (function() {
		function e(e, t) {
			var n = {
				label: 0,
				sent: function() {
					if (a[0] & 1) throw a[1];
					return a[1];
				},
				trys: [],
				ops: []
			}, r, i, a, o;
			return o = {
				next: s(0),
				throw: s(1),
				return: s(2)
			}, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
				return this;
			}), o;
			function s(e) {
				return function(t) {
					return c([e, t]);
				};
			}
			function c(o) {
				if (r) throw TypeError("Generator is already executing.");
				for (; n;) try {
					if (r = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
					switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
						case 0:
						case 1:
							a = o;
							break;
						case 4: return n.label++, {
							value: o[1],
							done: !1
						};
						case 5:
							n.label++, i = o[1], o = [0];
							continue;
						case 7:
							o = n.ops.pop(), n.trys.pop();
							continue;
						default:
							if ((a = n.trys, !(a = a.length > 0 && a[a.length - 1])) && (o[0] === 6 || o[0] === 2)) {
								n = 0;
								continue;
							}
							if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
								n.label = o[1];
								break;
							}
							if (o[0] === 6 && n.label < a[1]) {
								n.label = a[1], a = o;
								break;
							}
							if (a && n.label < a[2]) {
								n.label = a[2], n.ops.push(o);
								break;
							}
							a[2] && n.ops.pop(), n.trys.pop();
							continue;
					}
					o = t.call(e, n);
				} catch (e) {
					o = [6, e], i = 0;
				} finally {
					r = a = 0;
				}
				if (o[0] & 5) throw o[1];
				return {
					value: o[0] ? o[1] : void 0,
					done: !0
				};
			}
		}
		var t = function() {
			function e(e, t) {
				this.next = null, this.key = e, this.data = t, this.left = null, this.right = null;
			}
			return e;
		}();
		function n(e, t) {
			return e > t ? 1 : e < t ? -1 : 0;
		}
		function r(e, n, r) {
			for (var i = new t(null, null), a = i, o = i;;) {
				var s = r(e, n.key);
				if (s < 0) {
					if (n.left === null) break;
					if (r(e, n.left.key) < 0) {
						var c = n.left;
						if (n.left = c.right, c.right = n, n = c, n.left === null) break;
					}
					o.left = n, o = n, n = n.left;
				} else if (s > 0) {
					if (n.right === null) break;
					if (r(e, n.right.key) > 0) {
						var c = n.right;
						if (n.right = c.left, c.left = n, n = c, n.right === null) break;
					}
					a.right = n, a = n, n = n.right;
				} else break;
			}
			return a.right = n.left, o.left = n.right, n.left = i.right, n.right = i.left, n;
		}
		function i(e, n, i, a) {
			var o = new t(e, n);
			if (i === null) return o.left = o.right = null, o;
			i = r(e, i, a);
			var s = a(e, i.key);
			return s < 0 ? (o.left = i.left, o.right = i, i.left = null) : s >= 0 && (o.right = i.right, o.left = i, i.right = null), o;
		}
		function a(e, t, n) {
			var i = null, a = null;
			if (t) {
				t = r(e, t, n);
				var o = n(t.key, e);
				o === 0 ? (i = t.left, a = t.right) : o < 0 ? (a = t.right, t.right = null, i = t) : (i = t.left, t.left = null, a = t);
			}
			return {
				left: i,
				right: a
			};
		}
		function o(e, t, n) {
			return t === null ? e : e === null ? t : (t = r(e.key, t, n), t.left = e, t);
		}
		function s(e, t, n, r, i) {
			if (e) {
				r("" + t + (n ? "└── " : "├── ") + i(e) + "\n");
				var a = t + (n ? "    " : "│   ");
				e.left && s(e.left, a, !1, r, i), e.right && s(e.right, a, !0, r, i);
			}
		}
		var c = function() {
			function c(e) {
				e === void 0 && (e = n), this._root = null, this._size = 0, this._comparator = e;
			}
			return c.prototype.insert = function(e, t) {
				return this._size++, this._root = i(e, t, this._root, this._comparator);
			}, c.prototype.add = function(e, n) {
				var i = new t(e, n);
				this._root === null && (i.left = i.right = null, this._size++, this._root = i);
				var a = this._comparator, o = r(e, this._root, a), s = a(e, o.key);
				return s === 0 ? this._root = o : (s < 0 ? (i.left = o.left, i.right = o, o.left = null) : s > 0 && (i.right = o.right, i.left = o, o.right = null), this._size++, this._root = i), this._root;
			}, c.prototype.remove = function(e) {
				this._root = this._remove(e, this._root, this._comparator);
			}, c.prototype._remove = function(e, t, n) {
				var i;
				return t === null ? null : (t = r(e, t, n), n(e, t.key) === 0 ? (t.left === null ? i = t.right : (i = r(e, t.left, n), i.right = t.right), this._size--, i) : t);
			}, c.prototype.pop = function() {
				var e = this._root;
				if (e) {
					for (; e.left;) e = e.left;
					return this._root = r(e.key, this._root, this._comparator), this._root = this._remove(e.key, this._root, this._comparator), {
						key: e.key,
						data: e.data
					};
				}
				return null;
			}, c.prototype.findStatic = function(e) {
				for (var t = this._root, n = this._comparator; t;) {
					var r = n(e, t.key);
					if (r === 0) return t;
					t = r < 0 ? t.left : t.right;
				}
				return null;
			}, c.prototype.find = function(e) {
				return this._root && (this._root = r(e, this._root, this._comparator), this._comparator(e, this._root.key) !== 0) ? null : this._root;
			}, c.prototype.contains = function(e) {
				for (var t = this._root, n = this._comparator; t;) {
					var r = n(e, t.key);
					if (r === 0) return !0;
					t = r < 0 ? t.left : t.right;
				}
				return !1;
			}, c.prototype.forEach = function(e, t) {
				for (var n = this._root, r = [], i = !1; !i;) n === null ? r.length === 0 ? i = !0 : (n = r.pop(), e.call(t, n), n = n.right) : (r.push(n), n = n.left);
				return this;
			}, c.prototype.range = function(e, t, n, r) {
				for (var i = [], a = this._comparator, o = this._root, s; i.length !== 0 || o;) if (o) i.push(o), o = o.left;
				else {
					if (o = i.pop(), s = a(o.key, t), s > 0) break;
					if (a(o.key, e) >= 0 && n.call(r, o)) return this;
					o = o.right;
				}
				return this;
			}, c.prototype.keys = function() {
				var e = [];
				return this.forEach(function(t) {
					var n = t.key;
					return e.push(n);
				}), e;
			}, c.prototype.values = function() {
				var e = [];
				return this.forEach(function(t) {
					var n = t.data;
					return e.push(n);
				}), e;
			}, c.prototype.min = function() {
				return this._root ? this.minNode(this._root).key : null;
			}, c.prototype.max = function() {
				return this._root ? this.maxNode(this._root).key : null;
			}, c.prototype.minNode = function(e) {
				if (e === void 0 && (e = this._root), e) for (; e.left;) e = e.left;
				return e;
			}, c.prototype.maxNode = function(e) {
				if (e === void 0 && (e = this._root), e) for (; e.right;) e = e.right;
				return e;
			}, c.prototype.at = function(e) {
				for (var t = this._root, n = !1, r = 0, i = []; !n;) if (t) i.push(t), t = t.left;
				else if (i.length > 0) {
					if (t = i.pop(), r === e) return t;
					r++, t = t.right;
				} else n = !0;
				return null;
			}, c.prototype.next = function(e) {
				var t = this._root, n = null;
				if (e.right) {
					for (n = e.right; n.left;) n = n.left;
					return n;
				}
				for (var r = this._comparator; t;) {
					var i = r(e.key, t.key);
					if (i === 0) break;
					i < 0 ? (n = t, t = t.left) : t = t.right;
				}
				return n;
			}, c.prototype.prev = function(e) {
				var t = this._root, n = null;
				if (e.left !== null) {
					for (n = e.left; n.right;) n = n.right;
					return n;
				}
				for (var r = this._comparator; t;) {
					var i = r(e.key, t.key);
					if (i === 0) break;
					i < 0 ? t = t.left : (n = t, t = t.right);
				}
				return n;
			}, c.prototype.clear = function() {
				return this._root = null, this._size = 0, this;
			}, c.prototype.toList = function() {
				return d(this._root);
			}, c.prototype.load = function(e, t, n) {
				t === void 0 && (t = []), n === void 0 && (n = !1);
				var r = e.length, i = this._comparator;
				if (n && m(e, t, 0, r - 1, i), this._root === null) this._root = l(e, t, 0, r), this._size = r;
				else {
					var a = p(this.toList(), u(e, t), i);
					r = this._size + r, this._root = f({ head: a }, 0, r);
				}
				return this;
			}, c.prototype.isEmpty = function() {
				return this._root === null;
			}, Object.defineProperty(c.prototype, "size", {
				get: function() {
					return this._size;
				},
				enumerable: !0,
				configurable: !0
			}), Object.defineProperty(c.prototype, "root", {
				get: function() {
					return this._root;
				},
				enumerable: !0,
				configurable: !0
			}), c.prototype.toString = function(e) {
				e === void 0 && (e = function(e) {
					return String(e.key);
				});
				var t = [];
				return s(this._root, "", !0, function(e) {
					return t.push(e);
				}, e), t.join("");
			}, c.prototype.update = function(e, t, n) {
				var r = this._comparator, s = a(e, this._root, r), c = s.left, l = s.right;
				r(e, t) < 0 ? l = i(t, n, l, r) : c = i(t, n, c, r), this._root = o(c, l, r);
			}, c.prototype.split = function(e) {
				return a(e, this._root, this._comparator);
			}, c.prototype[Symbol.iterator] = function() {
				var t, n, r;
				return e(this, function(e) {
					switch (e.label) {
						case 0: t = this._root, n = [], r = !1, e.label = 1;
						case 1: return r ? [3, 6] : t === null ? [3, 2] : (n.push(t), t = t.left, [3, 5]);
						case 2: return n.length === 0 ? [3, 4] : (t = n.pop(), [4, t]);
						case 3: return e.sent(), t = t.right, [3, 5];
						case 4: r = !0, e.label = 5;
						case 5: return [3, 1];
						case 6: return [2];
					}
				});
			}, c;
		}();
		function l(e, n, r, i) {
			var a = i - r;
			if (a > 0) {
				var o = r + Math.floor(a / 2), s = e[o], c = n[o], u = new t(s, c);
				return u.left = l(e, n, r, o), u.right = l(e, n, o + 1, i), u;
			}
			return null;
		}
		function u(e, n) {
			for (var r = new t(null, null), i = r, a = 0; a < e.length; a++) i = i.next = new t(e[a], n[a]);
			return i.next = null, r.next;
		}
		function d(e) {
			for (var n = e, r = [], i = !1, a = new t(null, null), o = a; !i;) n ? (r.push(n), n = n.left) : r.length > 0 ? (n = o = o.next = r.pop(), n = n.right) : i = !0;
			return o.next = null, a.next;
		}
		function f(e, t, n) {
			var r = n - t;
			if (r > 0) {
				var i = t + Math.floor(r / 2), a = f(e, t, i), o = e.head;
				return o.left = a, e.head = e.head.next, o.right = f(e, i + 1, n), o;
			}
			return null;
		}
		function p(e, n, r) {
			for (var i = new t(null, null), a = i, o = e, s = n; o !== null && s !== null;) r(o.key, s.key) < 0 ? (a.next = o, o = o.next) : (a.next = s, s = s.next), a = a.next;
			return o === null ? s !== null && (a.next = s) : a.next = o, i.next;
		}
		function m(e, t, n, r, i) {
			if (!(n >= r)) {
				for (var a = e[n + r >> 1], o = n - 1, s = r + 1;;) {
					do
						o++;
					while (i(e[o], a) < 0);
					do
						s--;
					while (i(e[s], a) > 0);
					if (o >= s) break;
					var c = e[o];
					e[o] = e[s], e[s] = c, c = t[o], t[o] = t[s], t[s] = c;
				}
				m(e, t, n, s, i), m(e, t, s + 1, r, i);
			}
		}
		let h = (e, t) => e.ll.x <= t.x && t.x <= e.ur.x && e.ll.y <= t.y && t.y <= e.ur.y, g = (e, t) => {
			if (t.ur.x < e.ll.x || e.ur.x < t.ll.x || t.ur.y < e.ll.y || e.ur.y < t.ll.y) return null;
			let n = e.ll.x < t.ll.x ? t.ll.x : e.ll.x, r = e.ur.x < t.ur.x ? e.ur.x : t.ur.x, i = e.ll.y < t.ll.y ? t.ll.y : e.ll.y, a = e.ur.y < t.ur.y ? e.ur.y : t.ur.y;
			return {
				ll: {
					x: n,
					y: i
				},
				ur: {
					x: r,
					y: a
				}
			};
		}, _ = 2 ** -52;
		_ === void 0 && (_ = 2 ** -52);
		let v = _ * _, y = (e, t) => {
			if (-_ < e && e < _ && -_ < t && t < _) return 0;
			let n = e - t;
			return n * n < v * e * t ? 0 : e < t ? -1 : 1;
		};
		class b {
			constructor() {
				this.reset();
			}
			reset() {
				this.xRounder = new x(), this.yRounder = new x();
			}
			round(e, t) {
				return {
					x: this.xRounder.round(e),
					y: this.yRounder.round(t)
				};
			}
		}
		class x {
			constructor() {
				this.tree = new c(), this.round(0);
			}
			round(e) {
				let t = this.tree.add(e), n = this.tree.prev(t);
				if (n !== null && y(t.key, n.key) === 0) return this.tree.remove(e), n.key;
				let r = this.tree.next(t);
				return r !== null && y(t.key, r.key) === 0 ? (this.tree.remove(e), r.key) : e;
			}
		}
		let S = new b(), C = 11102230246251565e-32, w = 134217729;
		(3 + 8 * C) * C;
		function T(e, t, n, r, i) {
			let a, o, s, c, l = t[0], u = r[0], d = 0, f = 0;
			u > l == u > -l ? (a = l, l = t[++d]) : (a = u, u = r[++f]);
			let p = 0;
			if (d < e && f < n) for (u > l == u > -l ? (o = l + a, s = a - (o - l), l = t[++d]) : (o = u + a, s = a - (o - u), u = r[++f]), a = o, s !== 0 && (i[p++] = s); d < e && f < n;) u > l == u > -l ? (o = a + l, c = o - a, s = a - (o - c) + (l - c), l = t[++d]) : (o = a + u, c = o - a, s = a - (o - c) + (u - c), u = r[++f]), a = o, s !== 0 && (i[p++] = s);
			for (; d < e;) o = a + l, c = o - a, s = a - (o - c) + (l - c), l = t[++d], a = o, s !== 0 && (i[p++] = s);
			for (; f < n;) o = a + u, c = o - a, s = a - (o - c) + (u - c), u = r[++f], a = o, s !== 0 && (i[p++] = s);
			return (a !== 0 || p === 0) && (i[p++] = a), p;
		}
		function E(e, t) {
			let n = t[0];
			for (let r = 1; r < e; r++) n += t[r];
			return n;
		}
		function D(e) {
			return new Float64Array(e);
		}
		(3 + 16 * C) * C, (2 + 12 * C) * C, (9 + 64 * C) * C * C;
		let O = D(4), k = D(8), A = D(12), j = D(16), M = D(4);
		function N(e, t, n, r, i, a, o) {
			let s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, D, N = e - i, P = n - i, F = t - a, I = r - a;
			b = N * I, f = w * N, p = f - (f - N), m = N - p, f = w * I, h = f - (f - I), g = I - h, x = m * g - (b - p * h - m * h - p * g), S = F * P, f = w * F, p = f - (f - F), m = F - p, f = w * P, h = f - (f - P), g = P - h, C = m * g - (S - p * h - m * h - p * g), _ = x - C, d = x - _, O[0] = x - (_ + d) + (d - C), v = b + _, d = v - b, y = b - (v - d) + (_ - d), _ = y - S, d = y - _, O[1] = y - (_ + d) + (d - S), D = v + _, d = D - v, O[2] = v - (D - d) + (_ - d), O[3] = D;
			let R = E(4, O), ee = 22204460492503146e-32 * o;
			if (R >= ee || -R >= ee || (d = e - N, s = e - (N + d) + (d - i), d = n - P, l = n - (P + d) + (d - i), d = t - F, c = t - (F + d) + (d - a), d = r - I, u = r - (I + d) + (d - a), s === 0 && c === 0 && l === 0 && u === 0) || (ee = 11093356479670487e-47 * o + 33306690738754706e-32 * Math.abs(R), R += N * u + I * s - (F * l + P * c), R >= ee || -R >= ee)) return R;
			b = s * I, f = w * s, p = f - (f - s), m = s - p, f = w * I, h = f - (f - I), g = I - h, x = m * g - (b - p * h - m * h - p * g), S = c * P, f = w * c, p = f - (f - c), m = c - p, f = w * P, h = f - (f - P), g = P - h, C = m * g - (S - p * h - m * h - p * g), _ = x - C, d = x - _, M[0] = x - (_ + d) + (d - C), v = b + _, d = v - b, y = b - (v - d) + (_ - d), _ = y - S, d = y - _, M[1] = y - (_ + d) + (d - S), D = v + _, d = D - v, M[2] = v - (D - d) + (_ - d), M[3] = D;
			let te = T(4, O, 4, M, k);
			b = N * u, f = w * N, p = f - (f - N), m = N - p, f = w * u, h = f - (f - u), g = u - h, x = m * g - (b - p * h - m * h - p * g), S = F * l, f = w * F, p = f - (f - F), m = F - p, f = w * l, h = f - (f - l), g = l - h, C = m * g - (S - p * h - m * h - p * g), _ = x - C, d = x - _, M[0] = x - (_ + d) + (d - C), v = b + _, d = v - b, y = b - (v - d) + (_ - d), _ = y - S, d = y - _, M[1] = y - (_ + d) + (d - S), D = v + _, d = D - v, M[2] = v - (D - d) + (_ - d), M[3] = D;
			let ne = T(te, k, 4, M, A);
			return b = s * u, f = w * s, p = f - (f - s), m = s - p, f = w * u, h = f - (f - u), g = u - h, x = m * g - (b - p * h - m * h - p * g), S = c * l, f = w * c, p = f - (f - c), m = c - p, f = w * l, h = f - (f - l), g = l - h, C = m * g - (S - p * h - m * h - p * g), _ = x - C, d = x - _, M[0] = x - (_ + d) + (d - C), v = b + _, d = v - b, y = b - (v - d) + (_ - d), _ = y - S, d = y - _, M[1] = y - (_ + d) + (d - S), D = v + _, d = D - v, M[2] = v - (D - d) + (_ - d), M[3] = D, j[T(ne, A, 4, M, j) - 1];
		}
		function P(e, t, n, r, i, a) {
			let o = (t - a) * (n - i), s = (e - i) * (r - a), c = o - s, l = Math.abs(o + s);
			return Math.abs(c) >= 33306690738754716e-32 * l ? c : -N(e, t, n, r, i, a, l);
		}
		let F = (e, t) => e.x * t.y - e.y * t.x, I = (e, t) => e.x * t.x + e.y * t.y, R = (e, t, n) => {
			let r = P(e.x, e.y, t.x, t.y, n.x, n.y);
			return r > 0 ? -1 : +(r < 0);
		}, ee = (e) => Math.sqrt(I(e, e)), te = (e, t, n) => {
			let r = {
				x: t.x - e.x,
				y: t.y - e.y
			}, i = {
				x: n.x - e.x,
				y: n.y - e.y
			};
			return F(i, r) / ee(i) / ee(r);
		}, ne = (e, t, n) => {
			let r = {
				x: t.x - e.x,
				y: t.y - e.y
			}, i = {
				x: n.x - e.x,
				y: n.y - e.y
			};
			return I(i, r) / ee(i) / ee(r);
		}, z = (e, t, n) => t.y === 0 ? null : {
			x: e.x + t.x / t.y * (n - e.y),
			y: n
		}, B = (e, t, n) => t.x === 0 ? null : {
			x: n,
			y: e.y + t.y / t.x * (n - e.x)
		}, V = (e, t, n, r) => {
			if (t.x === 0) return B(n, r, e.x);
			if (r.x === 0) return B(e, t, n.x);
			if (t.y === 0) return z(n, r, e.y);
			if (r.y === 0) return z(e, t, n.y);
			let i = F(t, r);
			if (i == 0) return null;
			let a = {
				x: n.x - e.x,
				y: n.y - e.y
			}, o = F(a, t) / i, s = F(a, r) / i, c = e.x + s * t.x, l = n.x + o * r.x, u = e.y + s * t.y, d = n.y + o * r.y;
			return {
				x: (c + l) / 2,
				y: (u + d) / 2
			};
		};
		class re {
			static compare(e, t) {
				let n = re.comparePoints(e.point, t.point);
				return n === 0 ? (e.point !== t.point && e.link(t), e.isLeft === t.isLeft ? ae.compare(e.segment, t.segment) : e.isLeft ? 1 : -1) : n;
			}
			static comparePoints(e, t) {
				return e.x < t.x ? -1 : e.x > t.x ? 1 : e.y < t.y ? -1 : +(e.y > t.y);
			}
			constructor(e, t) {
				e.events === void 0 ? e.events = [this] : e.events.push(this), this.point = e, this.isLeft = t;
			}
			link(e) {
				if (e.point === this.point) throw Error("Tried to link already linked events");
				let t = e.point.events;
				for (let e = 0, n = t.length; e < n; e++) {
					let n = t[e];
					this.point.events.push(n), n.point = this.point;
				}
				this.checkForConsuming();
			}
			checkForConsuming() {
				let e = this.point.events.length;
				for (let t = 0; t < e; t++) {
					let n = this.point.events[t];
					if (n.segment.consumedBy === void 0) for (let r = t + 1; r < e; r++) {
						let e = this.point.events[r];
						e.consumedBy === void 0 && n.otherSE.point.events === e.otherSE.point.events && n.segment.consume(e.segment);
					}
				}
			}
			getAvailableLinkedEvents() {
				let e = [];
				for (let t = 0, n = this.point.events.length; t < n; t++) {
					let n = this.point.events[t];
					n !== this && !n.segment.ringOut && n.segment.isInResult() && e.push(n);
				}
				return e;
			}
			getLeftmostComparator(e) {
				let t = /* @__PURE__ */ new Map(), n = (n) => {
					let r = n.otherSE;
					t.set(n, {
						sine: te(this.point, e.point, r.point),
						cosine: ne(this.point, e.point, r.point)
					});
				};
				return (e, r) => {
					t.has(e) || n(e), t.has(r) || n(r);
					let { sine: i, cosine: a } = t.get(e), { sine: o, cosine: s } = t.get(r);
					return i >= 0 && o >= 0 ? a < s ? 1 : a > s ? -1 : 0 : i < 0 && o < 0 ? a < s ? -1 : +(a > s) : o < i ? -1 : +(o > i);
				};
			}
		}
		let ie = 0;
		class ae {
			static compare(e, t) {
				let n = e.leftSE.point.x, r = t.leftSE.point.x, i = e.rightSE.point.x, a = t.rightSE.point.x;
				if (a < n) return 1;
				if (i < r) return -1;
				let o = e.leftSE.point.y, s = t.leftSE.point.y, c = e.rightSE.point.y, l = t.rightSE.point.y;
				if (n < r) {
					if (s < o && s < c) return 1;
					if (s > o && s > c) return -1;
					let n = e.comparePoint(t.leftSE.point);
					if (n < 0) return 1;
					if (n > 0) return -1;
					let r = t.comparePoint(e.rightSE.point);
					return r === 0 ? -1 : r;
				}
				if (n > r) {
					if (o < s && o < l) return -1;
					if (o > s && o > l) return 1;
					let n = t.comparePoint(e.leftSE.point);
					if (n !== 0) return n;
					let r = e.comparePoint(t.rightSE.point);
					return r < 0 ? 1 : r > 0 ? -1 : 1;
				}
				if (o < s) return -1;
				if (o > s) return 1;
				if (i < a) {
					let n = t.comparePoint(e.rightSE.point);
					if (n !== 0) return n;
				}
				if (i > a) {
					let n = e.comparePoint(t.rightSE.point);
					if (n < 0) return 1;
					if (n > 0) return -1;
				}
				if (i !== a) {
					let e = c - o, t = i - n, u = l - s, d = a - r;
					if (e > t && u < d) return 1;
					if (e < t && u > d) return -1;
				}
				return i > a ? 1 : i < a || c < l ? -1 : c > l ? 1 : e.id < t.id ? -1 : +(e.id > t.id);
			}
			constructor(e, t, n, r) {
				this.id = ++ie, this.leftSE = e, e.segment = this, e.otherSE = t, this.rightSE = t, t.segment = this, t.otherSE = e, this.rings = n, this.windings = r;
			}
			static fromRing(e, t, n) {
				let r, i, a, o = re.comparePoints(e, t);
				if (o < 0) r = e, i = t, a = 1;
				else if (o > 0) r = t, i = e, a = -1;
				else throw Error(`Tried to create degenerate segment at [${e.x}, ${e.y}]`);
				return new ae(new re(r, !0), new re(i, !1), [n], [a]);
			}
			replaceRightSE(e) {
				this.rightSE = e, this.rightSE.segment = this, this.rightSE.otherSE = this.leftSE, this.leftSE.otherSE = this.rightSE;
			}
			bbox() {
				let e = this.leftSE.point.y, t = this.rightSE.point.y;
				return {
					ll: {
						x: this.leftSE.point.x,
						y: e < t ? e : t
					},
					ur: {
						x: this.rightSE.point.x,
						y: e > t ? e : t
					}
				};
			}
			vector() {
				return {
					x: this.rightSE.point.x - this.leftSE.point.x,
					y: this.rightSE.point.y - this.leftSE.point.y
				};
			}
			isAnEndpoint(e) {
				return e.x === this.leftSE.point.x && e.y === this.leftSE.point.y || e.x === this.rightSE.point.x && e.y === this.rightSE.point.y;
			}
			comparePoint(e) {
				if (this.isAnEndpoint(e)) return 0;
				let t = this.leftSE.point, n = this.rightSE.point, r = this.vector();
				if (t.x === n.x) return e.x === t.x ? 0 : e.x < t.x ? 1 : -1;
				let i = (e.y - t.y) / r.y, a = t.x + i * r.x;
				if (e.x === a) return 0;
				let o = (e.x - t.x) / r.x, s = t.y + o * r.y;
				return e.y === s ? 0 : e.y < s ? -1 : 1;
			}
			getIntersection(e) {
				let t = this.bbox(), n = e.bbox(), r = g(t, n);
				if (r === null) return null;
				let i = this.leftSE.point, a = this.rightSE.point, o = e.leftSE.point, s = e.rightSE.point, c = h(t, o) && this.comparePoint(o) === 0, l = h(n, i) && e.comparePoint(i) === 0, u = h(t, s) && this.comparePoint(s) === 0, d = h(n, a) && e.comparePoint(a) === 0;
				if (l && c) return d && !u ? a : !d && u ? s : null;
				if (l) return u && i.x === s.x && i.y === s.y ? null : i;
				if (c) return d && a.x === o.x && a.y === o.y ? null : o;
				if (d && u) return null;
				if (d) return a;
				if (u) return s;
				let f = V(i, this.vector(), o, e.vector());
				return f === null || !h(r, f) ? null : S.round(f.x, f.y);
			}
			split(e) {
				let t = [], n = e.events !== void 0, r = new re(e, !0), i = new re(e, !1), a = this.rightSE;
				this.replaceRightSE(i), t.push(i), t.push(r);
				let o = new ae(r, a, this.rings.slice(), this.windings.slice());
				return re.comparePoints(o.leftSE.point, o.rightSE.point) > 0 && o.swapEvents(), re.comparePoints(this.leftSE.point, this.rightSE.point) > 0 && this.swapEvents(), n && (r.checkForConsuming(), i.checkForConsuming()), t;
			}
			swapEvents() {
				let e = this.rightSE;
				this.rightSE = this.leftSE, this.leftSE = e, this.leftSE.isLeft = !0, this.rightSE.isLeft = !1;
				for (let e = 0, t = this.windings.length; e < t; e++) this.windings[e] *= -1;
			}
			consume(e) {
				let t = this, n = e;
				for (; t.consumedBy;) t = t.consumedBy;
				for (; n.consumedBy;) n = n.consumedBy;
				let r = ae.compare(t, n);
				if (r !== 0) {
					if (r > 0) {
						let e = t;
						t = n, n = e;
					}
					if (t.prev === n) {
						let e = t;
						t = n, n = e;
					}
					for (let e = 0, r = n.rings.length; e < r; e++) {
						let r = n.rings[e], i = n.windings[e], a = t.rings.indexOf(r);
						a === -1 ? (t.rings.push(r), t.windings.push(i)) : t.windings[a] += i;
					}
					n.rings = null, n.windings = null, n.consumedBy = t, n.leftSE.consumedBy = t.leftSE, n.rightSE.consumedBy = t.rightSE;
				}
			}
			prevInResult() {
				return this._prevInResult === void 0 && (this.prev ? this.prev.isInResult() ? this._prevInResult = this.prev : this._prevInResult = this.prev.prevInResult() : this._prevInResult = null), this._prevInResult;
			}
			beforeState() {
				if (this._beforeState !== void 0) return this._beforeState;
				if (!this.prev) this._beforeState = {
					rings: [],
					windings: [],
					multiPolys: []
				};
				else {
					let e = this.prev.consumedBy || this.prev;
					this._beforeState = e.afterState();
				}
				return this._beforeState;
			}
			afterState() {
				if (this._afterState !== void 0) return this._afterState;
				let e = this.beforeState();
				this._afterState = {
					rings: e.rings.slice(0),
					windings: e.windings.slice(0),
					multiPolys: []
				};
				let t = this._afterState.rings, n = this._afterState.windings, r = this._afterState.multiPolys;
				for (let e = 0, r = this.rings.length; e < r; e++) {
					let r = this.rings[e], i = this.windings[e], a = t.indexOf(r);
					a === -1 ? (t.push(r), n.push(i)) : n[a] += i;
				}
				let i = [], a = [];
				for (let e = 0, r = t.length; e < r; e++) {
					if (n[e] === 0) continue;
					let r = t[e], o = r.poly;
					if (a.indexOf(o) === -1) if (r.isExterior) i.push(o);
					else {
						a.indexOf(o) === -1 && a.push(o);
						let e = i.indexOf(r.poly);
						e !== -1 && i.splice(e, 1);
					}
				}
				for (let e = 0, t = i.length; e < t; e++) {
					let t = i[e].multiPoly;
					r.indexOf(t) === -1 && r.push(t);
				}
				return this._afterState;
			}
			isInResult() {
				if (this.consumedBy) return !1;
				if (this._isInResult !== void 0) return this._isInResult;
				let e = this.beforeState().multiPolys, t = this.afterState().multiPolys;
				switch (he.type) {
					case "union": {
						let n = e.length === 0, r = t.length === 0;
						this._isInResult = n !== r;
						break;
					}
					case "intersection": {
						let n, r;
						e.length < t.length ? (n = e.length, r = t.length) : (n = t.length, r = e.length), this._isInResult = r === he.numMultiPolys && n < r;
						break;
					}
					case "xor": {
						let n = Math.abs(e.length - t.length);
						this._isInResult = n % 2 == 1;
						break;
					}
					case "difference": {
						let n = (e) => e.length === 1 && e[0].isSubject;
						this._isInResult = n(e) !== n(t);
						break;
					}
					default: throw Error(`Unrecognized operation type found ${he.type}`);
				}
				return this._isInResult;
			}
		}
		class oe {
			constructor(e, t, n) {
				if (!Array.isArray(e) || e.length === 0 || (this.poly = t, this.isExterior = n, this.segments = [], typeof e[0][0] != "number" || typeof e[0][1] != "number")) throw Error("Input geometry is not a valid Polygon or MultiPolygon");
				let r = S.round(e[0][0], e[0][1]);
				this.bbox = {
					ll: {
						x: r.x,
						y: r.y
					},
					ur: {
						x: r.x,
						y: r.y
					}
				};
				let i = r;
				for (let t = 1, n = e.length; t < n; t++) {
					if (typeof e[t][0] != "number" || typeof e[t][1] != "number") throw Error("Input geometry is not a valid Polygon or MultiPolygon");
					let n = S.round(e[t][0], e[t][1]);
					n.x === i.x && n.y === i.y || (this.segments.push(ae.fromRing(i, n, this)), n.x < this.bbox.ll.x && (this.bbox.ll.x = n.x), n.y < this.bbox.ll.y && (this.bbox.ll.y = n.y), n.x > this.bbox.ur.x && (this.bbox.ur.x = n.x), n.y > this.bbox.ur.y && (this.bbox.ur.y = n.y), i = n);
				}
				(r.x !== i.x || r.y !== i.y) && this.segments.push(ae.fromRing(i, r, this));
			}
			getSweepEvents() {
				let e = [];
				for (let t = 0, n = this.segments.length; t < n; t++) {
					let n = this.segments[t];
					e.push(n.leftSE), e.push(n.rightSE);
				}
				return e;
			}
		}
		class se {
			constructor(e, t) {
				if (!Array.isArray(e)) throw Error("Input geometry is not a valid Polygon or MultiPolygon");
				this.exteriorRing = new oe(e[0], this, !0), this.bbox = {
					ll: {
						x: this.exteriorRing.bbox.ll.x,
						y: this.exteriorRing.bbox.ll.y
					},
					ur: {
						x: this.exteriorRing.bbox.ur.x,
						y: this.exteriorRing.bbox.ur.y
					}
				}, this.interiorRings = [];
				for (let t = 1, n = e.length; t < n; t++) {
					let n = new oe(e[t], this, !1);
					n.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = n.bbox.ll.x), n.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = n.bbox.ll.y), n.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = n.bbox.ur.x), n.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = n.bbox.ur.y), this.interiorRings.push(n);
				}
				this.multiPoly = t;
			}
			getSweepEvents() {
				let e = this.exteriorRing.getSweepEvents();
				for (let t = 0, n = this.interiorRings.length; t < n; t++) {
					let n = this.interiorRings[t].getSweepEvents();
					for (let t = 0, r = n.length; t < r; t++) e.push(n[t]);
				}
				return e;
			}
		}
		class ce {
			constructor(e, t) {
				if (!Array.isArray(e)) throw Error("Input geometry is not a valid Polygon or MultiPolygon");
				try {
					typeof e[0][0][0] == "number" && (e = [e]);
				} catch {}
				this.polys = [], this.bbox = {
					ll: {
						x: Infinity,
						y: Infinity
					},
					ur: {
						x: -Infinity,
						y: -Infinity
					}
				};
				for (let t = 0, n = e.length; t < n; t++) {
					let n = new se(e[t], this);
					n.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = n.bbox.ll.x), n.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = n.bbox.ll.y), n.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = n.bbox.ur.x), n.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = n.bbox.ur.y), this.polys.push(n);
				}
				this.isSubject = t;
			}
			getSweepEvents() {
				let e = [];
				for (let t = 0, n = this.polys.length; t < n; t++) {
					let n = this.polys[t].getSweepEvents();
					for (let t = 0, r = n.length; t < r; t++) e.push(n[t]);
				}
				return e;
			}
		}
		class le {
			static factory(e) {
				let t = [];
				for (let n = 0, r = e.length; n < r; n++) {
					let r = e[n];
					if (!r.isInResult() || r.ringOut) continue;
					let i = null, a = r.leftSE, o = r.rightSE, s = [a], c = a.point, l = [];
					for (; i = a, a = o, s.push(a), a.point !== c;) for (;;) {
						let e = a.getAvailableLinkedEvents();
						if (e.length === 0) {
							let e = s[0].point, t = s[s.length - 1].point;
							throw Error(`Unable to complete output ring starting at [${e.x}, ${e.y}]. Last matching segment found ends at [${t.x}, ${t.y}].`);
						}
						if (e.length === 1) {
							o = e[0].otherSE;
							break;
						}
						let n = null;
						for (let e = 0, t = l.length; e < t; e++) if (l[e].point === a.point) {
							n = e;
							break;
						}
						if (n !== null) {
							let e = l.splice(n)[0], r = s.splice(e.index);
							r.unshift(r[0].otherSE), t.push(new le(r.reverse()));
							continue;
						}
						l.push({
							index: s.length,
							point: a.point
						});
						let r = a.getLeftmostComparator(i);
						o = e.sort(r)[0].otherSE;
						break;
					}
					t.push(new le(s));
				}
				return t;
			}
			constructor(e) {
				this.events = e;
				for (let t = 0, n = e.length; t < n; t++) e[t].segment.ringOut = this;
				this.poly = null;
			}
			getGeom() {
				let e = this.events[0].point, t = [e];
				for (let n = 1, r = this.events.length - 1; n < r; n++) {
					let r = this.events[n].point, i = this.events[n + 1].point;
					R(r, e, i) !== 0 && (t.push(r), e = r);
				}
				if (t.length === 1) return null;
				let n = t[0], r = t[1];
				R(n, e, r) === 0 && t.shift(), t.push(t[0]);
				let i = this.isExteriorRing() ? 1 : -1, a = this.isExteriorRing() ? 0 : t.length - 1, o = this.isExteriorRing() ? t.length : -1, s = [];
				for (let e = a; e != o; e += i) s.push([t[e].x, t[e].y]);
				return s;
			}
			isExteriorRing() {
				if (this._isExteriorRing === void 0) {
					let e = this.enclosingRing();
					this._isExteriorRing = e ? !e.isExteriorRing() : !0;
				}
				return this._isExteriorRing;
			}
			enclosingRing() {
				return this._enclosingRing === void 0 && (this._enclosingRing = this._calcEnclosingRing()), this._enclosingRing;
			}
			_calcEnclosingRing() {
				let e = this.events[0];
				for (let t = 1, n = this.events.length; t < n; t++) {
					let n = this.events[t];
					re.compare(e, n) > 0 && (e = n);
				}
				let t = e.segment.prevInResult(), n = t ? t.prevInResult() : null;
				for (;;) {
					if (!t) return null;
					if (!n) return t.ringOut;
					if (n.ringOut !== t.ringOut) return n.ringOut.enclosingRing() === t.ringOut ? t.ringOut.enclosingRing() : t.ringOut;
					t = n.prevInResult(), n = t ? t.prevInResult() : null;
				}
			}
		}
		class ue {
			constructor(e) {
				this.exteriorRing = e, e.poly = this, this.interiorRings = [];
			}
			addInterior(e) {
				this.interiorRings.push(e), e.poly = this;
			}
			getGeom() {
				let e = [this.exteriorRing.getGeom()];
				if (e[0] === null) return null;
				for (let t = 0, n = this.interiorRings.length; t < n; t++) {
					let n = this.interiorRings[t].getGeom();
					n !== null && e.push(n);
				}
				return e;
			}
		}
		class de {
			constructor(e) {
				this.rings = e, this.polys = this._composePolys(e);
			}
			getGeom() {
				let e = [];
				for (let t = 0, n = this.polys.length; t < n; t++) {
					let n = this.polys[t].getGeom();
					n !== null && e.push(n);
				}
				return e;
			}
			_composePolys(e) {
				let t = [];
				for (let n = 0, r = e.length; n < r; n++) {
					let r = e[n];
					if (!r.poly) if (r.isExteriorRing()) t.push(new ue(r));
					else {
						let e = r.enclosingRing();
						e.poly || t.push(new ue(e)), e.poly.addInterior(r);
					}
				}
				return t;
			}
		}
		class fe {
			constructor(e) {
				let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ae.compare;
				this.queue = e, this.tree = new c(t), this.segments = [];
			}
			process(e) {
				let t = e.segment, n = [];
				if (e.consumedBy) return e.isLeft ? this.queue.remove(e.otherSE) : this.tree.remove(t), n;
				let r = e.isLeft ? this.tree.add(t) : this.tree.find(t);
				if (!r) throw Error(`Unable to find segment #${t.id} [${t.leftSE.point.x}, ${t.leftSE.point.y}] -> [${t.rightSE.point.x}, ${t.rightSE.point.y}] in SweepLine tree.`);
				let i = r, a = r, o, s;
				for (; o === void 0;) i = this.tree.prev(i), i === null ? o = null : i.key.consumedBy === void 0 && (o = i.key);
				for (; s === void 0;) a = this.tree.next(a), a === null ? s = null : a.key.consumedBy === void 0 && (s = a.key);
				if (e.isLeft) {
					let r = null;
					if (o) {
						let e = o.getIntersection(t);
						if (e !== null && (t.isAnEndpoint(e) || (r = e), !o.isAnEndpoint(e))) {
							let t = this._splitSafely(o, e);
							for (let e = 0, r = t.length; e < r; e++) n.push(t[e]);
						}
					}
					let i = null;
					if (s) {
						let e = s.getIntersection(t);
						if (e !== null && (t.isAnEndpoint(e) || (i = e), !s.isAnEndpoint(e))) {
							let t = this._splitSafely(s, e);
							for (let e = 0, r = t.length; e < r; e++) n.push(t[e]);
						}
					}
					if (r !== null || i !== null) {
						let e = null;
						e = r === null ? i : i === null || re.comparePoints(r, i) <= 0 ? r : i, this.queue.remove(t.rightSE), n.push(t.rightSE);
						let a = t.split(e);
						for (let e = 0, t = a.length; e < t; e++) n.push(a[e]);
					}
					n.length > 0 ? (this.tree.remove(t), n.push(e)) : (this.segments.push(t), t.prev = o);
				} else {
					if (o && s) {
						let e = o.getIntersection(s);
						if (e !== null) {
							if (!o.isAnEndpoint(e)) {
								let t = this._splitSafely(o, e);
								for (let e = 0, r = t.length; e < r; e++) n.push(t[e]);
							}
							if (!s.isAnEndpoint(e)) {
								let t = this._splitSafely(s, e);
								for (let e = 0, r = t.length; e < r; e++) n.push(t[e]);
							}
						}
					}
					this.tree.remove(t);
				}
				return n;
			}
			_splitSafely(e, t) {
				this.tree.remove(e);
				let n = e.rightSE;
				this.queue.remove(n);
				let r = e.split(t);
				return r.push(n), e.consumedBy === void 0 && this.tree.add(e), r;
			}
		}
		let pe = 1e6;
		class me {
			run(e, t, n) {
				he.type = e, S.reset();
				let r = [new ce(t, !0)];
				for (let e = 0, t = n.length; e < t; e++) r.push(new ce(n[e], !1));
				if (he.numMultiPolys = r.length, he.type === "difference") {
					let e = r[0], t = 1;
					for (; t < r.length;) g(r[t].bbox, e.bbox) === null ? r.splice(t, 1) : t++;
				}
				if (he.type === "intersection") for (let e = 0, t = r.length; e < t; e++) {
					let t = r[e];
					for (let n = e + 1, i = r.length; n < i; n++) if (g(t.bbox, r[n].bbox) === null) return [];
				}
				let i = new c(re.compare);
				for (let e = 0, t = r.length; e < t; e++) {
					let t = r[e].getSweepEvents();
					for (let e = 0, n = t.length; e < n; e++) if (i.insert(t[e]), i.size > pe) throw Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big).");
				}
				let a = new fe(i), o = i.size, s = i.pop();
				for (; s;) {
					let e = s.key;
					if (i.size === o) {
						let t = e.segment;
						throw Error(`Unable to pop() ${e.isLeft ? "left" : "right"} SweepEvent [${e.point.x}, ${e.point.y}] from segment #${t.id} [${t.leftSE.point.x}, ${t.leftSE.point.y}] -> [${t.rightSE.point.x}, ${t.rightSE.point.y}] from queue.`);
					}
					if (i.size > pe) throw Error("Infinite loop when passing sweep line over endpoints (queue size too big).");
					if (a.segments.length > 1e6) throw Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments).");
					let t = a.process(e);
					for (let e = 0, n = t.length; e < n; e++) {
						let n = t[e];
						n.consumedBy === void 0 && i.insert(n);
					}
					o = i.size, s = i.pop();
				}
				return S.reset(), new de(le.factory(a.segments)).getGeom();
			}
		}
		let he = new me();
		return {
			union: function(e) {
				var t = [...arguments].slice(1);
				return he.run("union", e, t);
			},
			intersection: function(e) {
				var t = [...arguments].slice(1);
				return he.run("intersection", e, t);
			},
			xor: function(e) {
				var t = [...arguments].slice(1);
				return he.run("xor", e, t);
			},
			difference: function(e) {
				var t = [...arguments].slice(1);
				return he.run("difference", e, t);
			}
		};
	}));
})))(), 1);
function TB(e, t, n, r) {
	let i = Number(e);
	if (!Number.isFinite(i) || i < t || i > n) throw Error(`${r} moet tussen ${t} en ${n} liggen.`);
	return i;
}
function EB(e, t, n) {
	return typeof e == "string" && t.includes(e) ? e : n;
}
function DB(e, t = !1) {
	if (!Array.isArray(e)) return;
	let n = UP(e.filter(Array.isArray).map((e) => [Number(e[0]), Number(e[1])]).filter((e) => e.every(Number.isFinite)));
	if (n.length < 3) return;
	if (!xF(n)) throw Error("De vrije selectie kruist zichzelf; teken de contour zonder kruisende lijnen.");
	if (Math.abs(VP(n)) < 1) return;
	let r = n.map((e) => e[0]), i = n.map((e) => e[1]), a = Math.max(Math.max(...r) - Math.min(...r), Math.max(...i) - Math.min(...i));
	if ((t ? Math.min(...r) < -20037508.35 || Math.max(...r) > 20037508.35 || Math.min(...i) < -20037508.35 || Math.max(...i) > 20037508.35 : Math.min(...r) < 0 || Math.max(...r) > 3e5 || Math.min(...i) < 28e4 || Math.max(...i) > 65e4) || a > 10200) throw Error(t ? "De getekende selectie valt buiten de ondersteunde wereldkaart of is groter dan 10 km." : "De getekende selectie valt buiten Nederland of is groter dan 10 km.");
	return n;
}
function OB(e, t = !1) {
	if (!Array.isArray(e)) return;
	let n = e.slice(0, 2e4).filter(Array.isArray).map((e) => [Number(e[0]), Number(e[1])]).filter(([e, n]) => Number.isFinite(e) && Number.isFinite(n) && (t ? Math.abs(e) <= 20037508.35 && Math.abs(n) <= 20037508.35 : e >= 0 && e <= 3e5 && n >= 28e4 && n <= 65e4));
	if (n.length < 2) return;
	if (n.length <= 5e3) return n;
	let r = n.length / 5e3;
	return Array.from({ length: 5e3 }, (e, t) => n[Math.floor(t * r)]);
}
function kB(e) {
	let t = e && typeof e == "object" ? e : {}, n = EB(t.coordinateSystem, ["rd", "web-mercator"], "rd"), r = n === "web-mercator", i = EB(t.selectionShape, [
		"square",
		"rectangle",
		"circle",
		"hexagon",
		"polygon"
	], "square"), a = EB(t.buildingLod, [
		"auto",
		"lod12",
		"lod13",
		"lod22",
		"lod0"
	], "auto"), o = EB(t.waterMode, [
		"raised",
		"flush",
		"recessed"
	], "recessed"), s = EB(t.roadMode, ["raised", "flush"], "raised"), c = EB(t.roadSource, ["clean-lines", "bgt-surfaces"], "clean-lines");
	return {
		coordinateSystem: n,
		centerX: TB(t.centerX, r ? -20037508.35 : 1e4, r ? 20037508.35 : 3e5, r ? "Wereld X" : "RD X"),
		centerY: TB(t.centerY, r ? -20037508.35 : 3e5, r ? 20037508.35 : 65e4, r ? "Wereld Y" : "RD Y"),
		areaMeters: TB(t.areaMeters, 80, 1e4, "Gebied"),
		selectionShape: i,
		selectionPolygon: DB(t.selectionPolygon, r),
		modelMillimeters: TB(t.modelMillimeters, 80, 300, "Modelformaat"),
		verticalScale: TB(t.verticalScale, .5, 4, "Gebouwhoogte"),
		minimumBuildingHeightMillimeters: TB(t.minimumBuildingHeightMillimeters ?? 1.2, .5, 6, "Gebouwextrusie"),
		terrainScale: TB(t.terrainScale ?? 1, .25, 4, "Reliëf"),
		heightMode: EB(t.heightMode, ["exaggeration", "target-height"], "exaggeration"),
		targetModelHeightMillimeters: TB(t.targetModelHeightMillimeters ?? 17, 2, 45, "Modelhoogte"),
		elevationResolution: TB(t.elevationResolution ?? 65, 33, 129, "Terreinresolutie"),
		baseMillimeters: TB(t.baseMillimeters ?? 3, 2, 8, "Bodemplaat"),
		baseMode: EB(t.baseMode, ["solid", "hollow"], "solid"),
		wallThicknessMillimeters: TB(t.wallThicknessMillimeters ?? 2.4, .8, 12, "Wanddikte"),
		roofMode: t.roofMode === "print-safe" ? "print-safe" : "detailed",
		buildingLod: a,
		buildingsEnabled: t.buildingsEnabled !== !1,
		terrainEnabled: t.terrainEnabled !== !1,
		roadsEnabled: t.roadsEnabled !== !1,
		waterEnabled: t.waterEnabled !== !1,
		greeneryEnabled: t.greeneryEnabled !== !1,
		treesEnabled: t.treesEnabled !== !1,
		roadWidthScale: TB(t.roadWidthScale ?? 1, .5, 3, "Wegbreedte"),
		roadSource: c,
		roadHeightMillimeters: TB(t.roadHeightMillimeters ?? .5, .12, 2, "Weghoogte"),
		roadMode: s,
		waterHeightMillimeters: TB(t.waterHeightMillimeters ?? .5, .12, 2, "Waterhoogte"),
		waterDepthMillimeters: TB(t.waterDepthMillimeters ?? .65, .2, 2.5, "Waterdiepte"),
		waterMode: o,
		treeDensity: TB(t.treeDensity ?? 1, .05, 1, "Boomdichtheid"),
		treeHeightScale: TB(t.treeHeightScale ?? 1, .5, 2.5, "Boomhoogte"),
		landCoverHeightMillimeters: TB(t.landCoverHeightMillimeters ?? .2, .05, 1.5, "Landbedekkingshoogte"),
		landCoverOffsetMillimeters: TB(t.landCoverOffsetMillimeters ?? .02, 0, 1, "Landbedekkingsoffset"),
		landCoverMode: EB(t.landCoverMode, ["raised", "flush"], "raised"),
		trackPoints: OB(t.trackPoints, r),
		trackWidthMeters: TB(t.trackWidthMeters ?? 3, .5, 30, "Routebreedte"),
		trackHeightMillimeters: TB(t.trackHeightMillimeters ?? .7, .12, 3, "Routehoogte"),
		trackMode: EB(t.trackMode, ["raised", "flush"], "raised")
	};
}
function AB(e) {
	return fF(e);
}
function jB(e) {
	return e.length === 0 ? [0, 0] : [e.reduce((e, t) => e + t[0], 0) / e.length, e.reduce((e, t) => e + t[1], 0) / e.length];
}
function MB(e, t) {
	let n = jB(e);
	return UP(e.map(([e, r]) => [Math.round((n[0] + (e - n[0]) * t) * 1e5) / 1e5, Math.round((n[1] + (r - n[1]) * t) * 1e5) / 1e5]));
}
function NB(e, t, n = .62) {
	let r = uF(t), i = wF(e, r), a = i.length > 1, o = [], s = r.map((e) => mF(e, t));
	for (let e of i) {
		let r = UP(e.map((e) => mF(e, t)));
		if (r.length < 3) continue;
		let i = jB(r), c = r.map((e) => e[0]), l = r.map((e) => e[1]), u = Math.max(...c) - Math.min(...c), d = Math.max(...l) - Math.min(...l);
		if (u < .04 || d < .04 || Math.abs(VP(r)) < .001) continue;
		let f = Math.max(1, n / u, n / d), p = Math.max(...r.map((e) => Math.hypot(e[0] - i[0], e[1] - i[1])), .1), m = a ? Math.max(.94, 1 - .012 / p) : Math.max(.994, 1 - .025 / p), h = MB(r, f * m), g = h.every((e) => _F(e, s)) ? h : MB(r, m);
		g.length >= 3 && o.push({
			source: e,
			model: g
		});
	}
	return o;
}
function PB(e, t) {
	if (!e || !t.terrainEnabled) return {
		grid: void 0,
		reliefMillimeters: 0,
		millimetersPerElevationMeter: 0
	};
	let n = Math.max(0, e.maximumElevation - e.minimumElevation), r = AB(t) * (t.terrainScale ?? 1), i = t.heightMode === "target-height" && n > 0 ? (t.targetModelHeightMillimeters ?? 17) / n : r, a = n > 0 ? i : 0;
	return {
		grid: e,
		reliefMillimeters: n * a,
		millimetersPerElevationMeter: a
	};
}
function FB(e, t, n) {
	let r = n.grid;
	if (!r) return 0;
	let [i, a, o, s] = dF(t), c = Math.max(0, Math.min(1, (e[0] - i) / (o - i))), l = Math.max(0, Math.min(1, (s - e[1]) / (s - a))), u = c * (r.width - 1), d = l * (r.height - 1), f = Math.floor(u), p = Math.floor(d), m = Math.min(r.width - 1, f + 1), h = Math.min(r.height - 1, p + 1), g = u - f, _ = d - p, v = (e, t) => r.values[t * r.width + e], y = v(f, p) * (1 - g) + v(m, p) * g, b = v(f, h) * (1 - g) + v(m, h) * g;
	return y * (1 - _) + b * _;
}
function IB(e, t, n) {
	return n.grid ? t.baseMillimeters + (FB(e, t, n) - n.grid.minimumElevation) * n.millimetersPerElevationMeter : t.baseMillimeters;
}
function LB(e, t, n, r) {
	return [[
		e,
		t,
		n
	], [
		e,
		n,
		r
	]];
}
function RB(e, t, n, r, i, a) {
	let o = [0, 1], s = t[0] - e[0], c = t[1] - e[1];
	if (Math.abs(s) > 1e-9) for (let t = 1; t < i - 1; t += 1) {
		let r = (t / (i - 1) * n - e[0]) / s;
		r > 1e-8 && r < .99999999 && o.push(r);
	}
	if (Math.abs(c) > 1e-9) for (let t = 1; t < a - 1; t += 1) {
		let n = (t / (a - 1) * r - e[1]) / c;
		n > 1e-8 && n < .99999999 && o.push(n);
	}
	return [...new Set(o.map((e) => Math.round(e * 1e10) / 1e10))].sort((e, t) => e - t).map((t) => [e[0] + s * t, e[1] + c * t]);
}
function zB(e, t, n = []) {
	let r = kB(t), i = PB(e, r), a = UP(uF(r).map((e) => mF(e, r))), o = a.map((e) => e[0]), s = a.map((e) => e[1]), c = Math.min(Math.max(...o) - Math.min(...o), Math.max(...s) - Math.min(...s)), l = MB(a, Math.max(.05, 1 - 2 * (r.wallThicknessMillimeters ?? 2.4) / Math.max(1, c))), u = r.baseMode === "hollow" && l.length >= 3 ? tF([a, l], 0, r.baseMillimeters) : eF(a, 0, r.baseMillimeters), d = aF(u).valid ? u : eF(a, 0, r.baseMillimeters);
	if (!i.grid) {
		let e = d;
		return {
			triangles: e,
			surfaceTriangles: [],
			baseTriangles: e,
			reliefMillimeters: 0
		};
	}
	let f = i.grid, [p, m] = pF(r), h = (e) => IB(hF(e, r), r, i), g = r.waterEnabled && r.waterMode === "recessed" ? n.map((e) => [e.footprint, ...e.holes ?? []].map((e) => WB(e.map((e) => mF(e, r))))) : [], _ = d, v = [], y = Math.max(0, r.baseMillimeters - .12);
	if (g.length) {
		let e = wB.default.difference([WB(a)], ...g);
		for (let t of e) {
			let e = UB(t, r, i, () => y, h);
			v.push(...aF(e).valid ? e : HB(t, () => y, h));
		}
		return {
			triangles: [..._, ...v],
			surfaceTriangles: v,
			baseTriangles: _,
			reliefMillimeters: i.reliefMillimeters
		};
	}
	for (let e of ZP(a)) {
		let t = e.map((e) => a[e]), n = t.map((e) => e[0]), r = t.map((e) => e[1]), i = Math.max(0, Math.floor(Math.min(...n) / p * (f.width - 1))), o = Math.min(f.width - 2, Math.floor(Math.max(...n) / p * (f.width - 1))), s = Math.max(0, Math.floor(Math.min(...r) / m * (f.height - 1))), c = Math.min(f.height - 2, Math.floor(Math.max(...r) / m * (f.height - 1)));
		for (let e = s; e <= c; e += 1) {
			let n = e / (f.height - 1) * m, r = (e + 1) / (f.height - 1) * m;
			for (let e = i; e <= o; e += 1) {
				let i = YP(t, e / (f.width - 1) * p, n, (e + 1) / (f.width - 1) * p, r), a = ZP(i);
				if (a.length === 0) continue;
				let o = i.map((e) => [
					e[0],
					e[1],
					h(e)
				]), s = i.map((e) => [
					e[0],
					e[1],
					y
				]);
				for (let [e, t, n] of a) v.push([
					o[e],
					o[t],
					o[n]
				]), v.push([
					s[n],
					s[t],
					s[e]
				]);
			}
		}
	}
	for (let e = 0; e < a.length; e += 1) {
		let t = RB(a[e], a[(e + 1) % a.length], p, m, f.width, f.height);
		for (let e = 0; e < t.length - 1; e += 1) {
			let n = t[e], r = t[e + 1];
			v.push(...LB([
				n[0],
				n[1],
				y
			], [
				r[0],
				r[1],
				y
			], [
				r[0],
				r[1],
				h(r)
			], [
				n[0],
				n[1],
				h(n)
			]));
		}
	}
	return {
		triangles: [..._, ...v],
		surfaceTriangles: v,
		baseTriangles: _,
		reliefMillimeters: i.reliefMillimeters
	};
}
function BB(e, t, n) {
	if (!e.detailedTriangles) return;
	let r = uF(t);
	if (!vF(e.footprint, r)) return;
	let i = e.footprint.map((e) => mF(e, t)), a = jB(i), o = IB(jB(e.footprint), t, n) - .1, s = Math.max(...i.map((e) => Math.hypot(e[0] - a[0], e[1] - a[1])), .1), c = Math.max(.994, 1 - .025 / s), l = AB(t), u = Math.max(.01, e.heightMeters * l * t.verticalScale), d = Math.min(180, Math.max(e.heightMeters + 15, e.heightMeters * 1.8)), f = Math.max(1, (t.minimumBuildingHeightMillimeters ?? 1.2) / u), p = e.detailedTriangles.map((n) => n.map((n) => {
		let r = mF([n[0], n[1]], t);
		return [
			a[0] + (r[0] - a[0]) * c,
			a[1] + (r[1] - a[1]) * c,
			o + Math.min(d, Math.max(0, n[2] - e.groundMeters)) * l * t.verticalScale * f
		];
	})), m = aF(p), h = oF(p), [g, _] = pF(t), v = h.minimum[0] >= -.02 && h.minimum[1] >= -.02 && h.maximum[0] <= g + .02 && h.maximum[1] <= _ + .02;
	return m.valid && v ? p : void 0;
}
function VB(e, t, n) {
	let r = NB(e.footprint, t), i = Math.max(t.minimumBuildingHeightMillimeters ?? 1.2, e.heightMeters * AB(t) * t.verticalScale), a = [];
	for (let e of r) {
		let r = IB(jB(e.source), t, n), o = jB(e.model), s = Math.max(...e.model.map((e) => Math.hypot(e[0] - o[0], e[1] - o[1])), .1), c = Math.max(.992, 1 - .025 / s), l = eF(MB(e.model, c), r - .1, r + i);
		aF(l).valid && a.push(...l);
	}
	return {
		triangles: a,
		footprints: r.map((e) => e.model),
		height: i
	};
}
function HB(e, t, n) {
	let r = e.map(UP).filter((e) => e.length >= 3), { vertices: i, faces: a } = QP(r);
	if (a.length === 0) return [];
	let o = i.map((e) => [
		e[0],
		e[1],
		t(e)
	]), s = i.map((e) => [
		e[0],
		e[1],
		n(e)
	]), c = [];
	for (let [e, t, n] of a) c.push([
		s[e],
		s[t],
		s[n]
	], [
		o[n],
		o[t],
		o[e]
	]);
	let l = 0;
	for (let e of r) {
		for (let t = 0; t < e.length; t += 1) {
			let n = (t + 1) % e.length, r = l + t, i = l + n;
			c.push([
				o[r],
				o[i],
				s[i]
			], [
				o[r],
				s[i],
				s[r]
			]);
		}
		l += e.length;
	}
	return c;
}
function UB(e, t, n, r, i) {
	let a = e.map(UP).filter((e) => e.length >= 3), { vertices: o, faces: s } = QP(a), c = n.grid;
	if (!c) return HB(a, r, i);
	let [l, u] = pF(t), d = [];
	for (let e of s) {
		let t = e.map((e) => o[e]), n = t.map((e) => e[0]), a = t.map((e) => e[1]), s = Math.max(0, Math.floor(Math.min(...n) / l * (c.width - 1))), f = Math.min(c.width - 2, Math.floor(Math.max(...n) / l * (c.width - 1))), p = Math.max(0, Math.floor(Math.min(...a) / u * (c.height - 1))), m = Math.min(c.height - 2, Math.floor(Math.max(...a) / u * (c.height - 1)));
		for (let e = p; e <= m; e += 1) {
			let n = e / (c.height - 1) * u, a = (e + 1) / (c.height - 1) * u;
			for (let e = s; e <= f; e += 1) {
				let o = YP(t, e / (c.width - 1) * l, n, (e + 1) / (c.width - 1) * l, a), s = ZP(o);
				if (s.length === 0) continue;
				let u = o.map((e) => [
					e[0],
					e[1],
					r(e)
				]), f = o.map((e) => [
					e[0],
					e[1],
					i(e)
				]);
				for (let [e, t, n] of s) d.push([
					f[e],
					f[t],
					f[n]
				]), d.push([
					u[n],
					u[t],
					u[e]
				]);
			}
		}
	}
	for (let e of a) for (let t = 0; t < e.length; t += 1) {
		let n = RB(e[t], e[(t + 1) % e.length], l, u, c.width, c.height);
		for (let e = 0; e < n.length - 1; e += 1) {
			let t = n[e], a = n[e + 1];
			d.push(...LB([
				t[0],
				t[1],
				r(t)
			], [
				a[0],
				a[1],
				r(a)
			], [
				a[0],
				a[1],
				i(a)
			], [
				t[0],
				t[1],
				i(t)
			]));
		}
	}
	return d;
}
function WB(e) {
	let t = UP(e).map(([e, t]) => [e, t]);
	return t.length > 0 && t.push([...t[0]]), t;
}
function GB(e, t) {
	if (t === 0) return e;
	let n = jB(e), r = Math.max(...e.map((e) => Math.hypot(e[0] - n[0], e[1] - n[1])), .1);
	return MB(e, Math.max(.01, 1 + t / r));
}
function KB(e) {
	let t = UP(e), n = /* @__PURE__ */ new Map();
	for (let e = 0; e < t.length; e += 1) {
		let r = `${t[e][0].toFixed(6)},${t[e][1].toFixed(6)}`, i = n.get(r);
		if (i !== void 0 && e - i >= 3 && t.length - (e - i) >= 3) {
			let n = UP(t.slice(i, e)), r = UP([...t.slice(e), ...t.slice(0, i)]);
			if (Math.abs(VP(n)) > 1e-8 && Math.abs(VP(r)) > 1e-8) return [...KB(n), ...KB(r)];
		}
		n.set(r, e);
	}
	return t.length >= 3 ? [t] : [];
}
function qB(e, t = !1) {
	if (e.length < 2) return e;
	try {
		let n = t ? .03 : 0, r = e.map((e) => [WB(GB(e.footprint, n)), ...(e.holes ?? []).map((e) => WB(GB(e, -n)))]).filter((e) => e[0].length >= 4);
		return r.length < 2 ? e : wB.default.union(r[0], ...r.slice(1)).flatMap((e, t) => {
			let n = UP(e[0].slice(0, -1).map(([e, t]) => [e, t])), r = e.slice(1).map((e) => UP(e.slice(0, -1).map(([e, t]) => [e, t]))).filter((e) => e.length >= 3);
			return KB(n).map((e, n) => ({
				id: `union-${t}-${n}`,
				footprint: e,
				holes: r.filter((t) => nF(jB(t), e))
			}));
		}).filter((e) => e.footprint.length >= 3);
	} catch {
		return e;
	}
}
function JB(e) {
	if (e.length < 2) return e;
	let t = [...e];
	for (let e = 0; e < 10 && t.length > 700; e += 1) {
		let n = 220 * 2 ** Math.min(e, 3);
		t.sort((e, t) => {
			let r = jB(e.footprint), i = jB(t.footprint);
			return Math.floor(r[0] / n) * 1e6 + Math.floor(r[1] / n) - (Math.floor(i[0] / n) * 1e6 + Math.floor(i[1] / n));
		});
		let r = [];
		for (let n = 0; n < t.length; n += 420) r.push(...qB(t.slice(n, n + 420), e === 0));
		t = r;
	}
	return t.length <= 6e3 ? qB(t, e.length <= 700) : t;
}
function YB(e) {
	let t = e.footprint.map((e) => e[0]), n = e.footprint.map((e) => e[1]);
	return [
		Math.min(...t),
		Math.min(...n),
		Math.max(...t),
		Math.max(...n)
	];
}
function XB(e, t) {
	if (e.length === 0 || t.length === 0) return e;
	let n = /* @__PURE__ */ new Map();
	for (let e of t) {
		let t = YB(e), [r, i, a, o] = t, s = {
			surface: e,
			bounds: t
		};
		for (let e = Math.floor(r / 300); e <= Math.floor(a / 300); e += 1) for (let t = Math.floor(i / 300); t <= Math.floor(o / 300); t += 1) {
			let r = `${e}/${t}`, i = n.get(r) ?? [];
			i.push(s), n.set(r, i);
		}
	}
	return e.flatMap((e, t) => {
		let r = YB(e), i = /* @__PURE__ */ new Set();
		for (let e = Math.floor(r[0] / 300); e <= Math.floor(r[2] / 300); e += 1) for (let t = Math.floor(r[1] / 300); t <= Math.floor(r[3] / 300); t += 1) for (let { surface: a, bounds: o } of n.get(`${e}/${t}`) ?? []) o[0] <= r[2] && o[2] >= r[0] && o[1] <= r[3] && o[3] >= r[1] && i.add(a);
		if (i.size === 0) return [e];
		try {
			let n = [[WB(e.footprint), ...(e.holes ?? []).map(WB)]], r = [...i].map((e) => [WB(e.footprint), ...(e.holes ?? []).map(WB)]);
			for (let e = 0; e < r.length && n.length > 0; e += 120) n = wB.default.difference(n, ...r.slice(e, e + 120));
			return n.map((n, r) => ({
				id: `${e.id}-cut-${t}-${r}`,
				footprint: UP(n[0].slice(0, -1).map(([e, t]) => [e, t])),
				holes: n.slice(1).map((e) => UP(e.slice(0, -1).map(([e, t]) => [e, t]))).filter((e) => e.length >= 3)
			})).filter((e) => e.footprint.length >= 3 && Math.abs(VP(e.footprint)) >= 1);
		} catch {
			return [e];
		}
	});
}
function ZB(e, t, n) {
	try {
		let r = [WB(e.footprint), ...(e.holes ?? []).map(WB)], i = [WB(uF(t))];
		return wB.default.intersection(r, i).flatMap((e) => {
			let r = e.map((e) => UP(e.slice(0, -1).map(([e, n]) => mF([e, n], t)))).filter((e) => e.length >= 3);
			if (r.length === 0) return [];
			let i = r[0].map((e) => e[0]), a = r[0].map((e) => e[1]), o = Math.max(...i) - Math.min(...i), s = Math.max(...a) - Math.min(...a);
			return Math.max(o, s) < Math.min(.08, n * .1) ? [] : [r];
		});
	} catch {
		return NB(e.footprint, t, n).map((e) => [e.model]);
	}
}
function QB(e, t, n, r, i) {
	let a = (e) => {
		let a = [], o = 0;
		for (let s of e) for (let e of ZB(s, t, i)) {
			let i = (e) => IB(hF(e, t), t, n), s, c;
			if (r === "road") {
				let e = t.roadMode === "flush" ? .1 : t.roadHeightMillimeters ?? .5;
				s = (e) => i(e) - .08, c = (t) => i(t) + e;
			} else if (r === "water") {
				let n = t.waterHeightMillimeters ?? .5, r = t.waterDepthMillimeters ?? .65, a = Math.abs(VP(e[0])), o = e[0].map(i).sort((e, t) => e - t), l = o[Math.floor(o.length * .25)] ?? t.baseMillimeters, u = a >= 50;
				if (t.waterMode === "recessed") {
					let e = Math.max(t.baseMillimeters + .06, l - .08);
					s = u ? () => e - Math.max(.35, n) : (e) => i(e) - r - .16, c = u ? () => e : (e) => Math.max(t.baseMillimeters + .06, i(e) - .08);
				} else t.waterMode === "flush" ? (s = u ? () => l - .3 : (e) => i(e) - .2, c = u ? () => l + .04 : (e) => i(e) + .04) : (s = u ? () => l - .18 : (e) => i(e) - .18, c = u ? () => l + n : (e) => i(e) + n);
			} else s = (e) => i(e) - .12, c = t.landCoverMode === "flush" ? (e) => i(e) + .08 : (e) => i(e) + (t.landCoverOffsetMillimeters ?? .02) + (t.landCoverHeightMillimeters ?? .2);
			let l = UB(e, t, n, s, c);
			if (aF(l).valid) a.push(...l);
			else {
				let t = HB(e, s, c);
				aF(t).valid ? a.push(...t) : o += 1;
			}
		}
		return {
			triangles: a,
			invalid: o
		};
	}, o = r === "water" ? e : JB(e), s = a(o);
	return s.invalid > 0 && o !== e && e.length <= 1400 ? a(e).triangles : s.triangles;
}
function $B(e, t) {
	return _F(t, e.footprint) ? !(e.holes ?? []).some((e) => _F(t, e)) : !1;
}
function eV(e, t, n, r = []) {
	let i = AB(t), a = /* @__PURE__ */ new Map(), o = (e) => r.some((t) => $B(t, e));
	for (let n of e) {
		if (n.tunnel) continue;
		let e = Math.max(n.widthMeters * t.roadWidthScale, .38 / Math.max(i, 1e-9));
		for (let t = 0; t < n.points.length - 1; t += 1) {
			let r = n.points[t], s = n.points[t + 1], c = s[0] - r[0], l = s[1] - r[1], u = Math.hypot(c, l);
			if (u * i < .12) continue;
			let d = Array.from({ length: 7 }, (e, t) => {
				let n = t / 6;
				return o([r[0] + c * n, r[1] + l * n]);
			}).some(Boolean) || n.bridge ? Math.max(2, Math.min(32, Math.ceil(u / 5))) : 1, f = Array.from({ length: d }, (e, t) => {
				let n = (t + .5) / d;
				return o([r[0] + c * n, r[1] + l * n]);
			});
			for (let t = 0; t < d; t += 1) {
				let i = t / d, o = (t + 1) / d, s = [r[0] + c * i, r[1] + l * i], u = [r[0] + c * o, r[1] + l * o], p = f[t], m = `${s[0].toFixed(2)},${s[1].toFixed(2)}|${u[0].toFixed(2)},${u[1].toFixed(2)}`, h = `${u[0].toFixed(2)},${u[1].toFixed(2)}|${s[0].toFixed(2)},${s[1].toFixed(2)}`, g = m < h ? m : h, _ = a.get(g);
				(!_ || e > _.widthMeters || p && !_.bridge) && a.set(g, {
					start: s,
					end: u,
					widthMeters: e,
					bridge: p,
					level: p ? Math.max(0, n.level ?? 0) : 0
				});
			}
		}
	}
	let s = [], c = t.roadMode === "flush" ? .1 : t.roadHeightMillimeters ?? .5;
	for (let [e, r] of [...a.values()].entries()) {
		let i = Math.atan2(r.end[1] - r.start[1], r.end[0] - r.start[0]), a = r.widthMeters / 2 * (1 + (e % 7 - 3) * 2e-4), o = [];
		for (let e = 0; e <= 6; e += 1) {
			let t = i + Math.PI / 2 + e / 6 * Math.PI;
			o.push([r.start[0] + Math.cos(t) * a, r.start[1] + Math.sin(t) * a]);
		}
		for (let e = 0; e <= 6; e += 1) {
			let t = i - Math.PI / 2 + e / 6 * Math.PI;
			o.push([r.end[0] + Math.cos(t) * a, r.end[1] + Math.sin(t) * a]);
		}
		let l = t.waterMode === "recessed" ? -(t.waterDepthMillimeters ?? .65) + (t.waterHeightMillimeters ?? .55) : t.waterMode === "flush" ? .1 : t.waterHeightMillimeters ?? .55, u = r.bridge ? Math.max(.12, l + .1 + r.level * .02) : 0, d = e * 11e-6;
		for (let r of ZB({
			id: `road-${e}`,
			footprint: o
		}, t, .38)) {
			let e = (e) => IB(hF(e, t), t, n), i = HB(r, (t) => e(t) + u + d - .1, (t) => e(t) + u + d + c);
			aF(i).valid && s.push(...i);
		}
	}
	return s;
}
function tV(e, t, n, r = 0) {
	return Array.from({ length: n }, (i, a) => {
		let o = r + a / n * Math.PI * 2;
		return [e[0] + Math.cos(o) * t, e[1] + Math.sin(o) * t];
	});
}
function nV(e, t, n, r = 8) {
	let i = Math.max(.75, n * 1.9), a = [
		{
			z: t - .08,
			radius: n * .46
		},
		{
			z: t + i * .24,
			radius: n * .9
		},
		{
			z: t + i * .52,
			radius: n
		},
		{
			z: t + i * .78,
			radius: n * .78
		},
		{
			z: t + i,
			radius: n * .22
		}
	].map((t, n) => tV(e, t.radius, r, Math.PI / 8 + n % 2 * (Math.PI / r)).map(([e, n]) => [
		e,
		n,
		t.z
	])), o = [];
	for (let e = 1; e < r - 1; e += 1) o.push([
		a[0][e + 1],
		a[0][e],
		a[0][0]
	]), o.push([
		a.at(-1)[0],
		a.at(-1)[e],
		a.at(-1)[e + 1]
	]);
	for (let e = 0; e < a.length - 1; e += 1) for (let t = 0; t < r; t += 1) {
		let n = (t + 1) % r;
		o.push([
			a[e][t],
			a[e][n],
			a[e + 1][n]
		]), o.push([
			a[e][t],
			a[e + 1][n],
			a[e + 1][t]
		]);
	}
	return o;
}
function rV(e, t) {
	if (e.length <= t) return e;
	let n = e.length / t;
	return Array.from({ length: t }, (t, r) => e[Math.floor(r * n)]);
}
function iV(e, t, n) {
	let r = t.treeDensity ?? 1, i = r >= .999 ? e : rV(e, Math.max(1, Math.round(e.length * r))), a = uF(t), o = a.map((e) => mF(e, t)), s = [], c = 0;
	for (let e of i) {
		if (!_F(e.point, a)) continue;
		let r = mF(e.point, t), i = AB(t), l = e.crownMeters ?? 7.2, u = t.treeHeightScale ?? 1, d = l * i * u / 2, f = (.3 + l * .016) * u, p = Math.max(.4, Math.min(2.4, Math.max(d, f)));
		if (!tV(r, p, 8).every((e) => _F(e, o))) continue;
		let m = nV(r, IB(e.point, t, n), p, 8);
		aF(m).valid && (s.push(...m), c += 1);
	}
	return {
		triangles: s,
		count: c
	};
}
function aV(e) {
	if (e.attribution) return e.attribution;
	if (e.lod === "LoD0 · IGN BD TOPO") return "IGN France BD TOPO (Licence Ouverte 2.0) · Mapterhorn · Overture Maps / OpenStreetMap-bijdragers";
	if (e.lod === "LoD0 · Overture") return "Overture Maps Foundation / OpenStreetMap-bijdragers · Mapterhorn";
	let t = ["PDOK AHN 4 DTM"];
	return e.lod === "LoD0 · TOP10NL" ? t.push("TOP10NL / Kadaster") : t.push("3DBAG / TU Delft + 3DGI (CC BY 4.0)", "BGT (CC0)"), t.join(" · ");
}
function oV(e, t) {
	let n = kB(t), r = PB(e.terrain, n), i = zB(e.terrain, n, e.water), a = [], o = [], s = 0, c = 0, l = 0;
	for (let t of n.buildingsEnabled === !1 ? [] : e.buildings) {
		if (t.footprint.length < 3 || Math.abs(VP(t.footprint)) < 1) continue;
		let i = VB(t, n, r), u = n.roofMode === "detailed" && !e.lod.startsWith("LoD0") ? BB(t, n, r) : void 0, d = u ?? i.triangles;
		if (d.length === 0) continue;
		a.push(...d), u ? s += 1 : c += 1;
		let f = Math.max(n.minimumBuildingHeightMillimeters ?? 1.2, t.heightMeters * AB(n) * n.verticalScale);
		for (let e of i.footprints) l += Math.abs(VP(e)) * f;
		if (o.length < 6e3) for (let e of i.footprints.slice(0, 4)) o.push({
			id: t.id,
			footprint: e,
			heightMillimeters: f,
			detailed: !!u,
			selected: nF([n.centerX, n.centerY], t.footprint)
		});
	}
	let u = n.roadsEnabled ? [...QB(e.roads, n, r, "road", .58), ...eV(e.roadLines, n, r, e.water)] : [], d = n.waterEnabled ? QB(e.water, n, r, "water", .58) : [], f = XB(e.greenery ?? [], [...e.water, ...e.buildings.map((e) => ({
		id: `building-mask-${e.id}`,
		footprint: e.footprint
	}))]), p = n.greeneryEnabled ? QB(f, n, r, "greenery", .48) : [], m = n.treesEnabled === !1 ? {
		triangles: [],
		count: 0
	} : iV(e.trees ?? [], n, r), h = (n.trackPoints?.length ?? 0) >= 2 ? eV([{
		id: "uploaded-track",
		points: n.trackPoints,
		widthMeters: n.trackWidthMeters ?? 3,
		priority: 0
	}], {
		...n,
		roadWidthScale: 1,
		roadHeightMillimeters: n.trackHeightMillimeters ?? .7,
		roadMode: n.trackMode ?? "raised"
	}, r) : [], g = [
		{
			kind: "base",
			name: "Bodem en zijkanten",
			triangles: i.baseTriangles
		},
		{
			kind: "terrain",
			name: "Terrein",
			triangles: i.surfaceTriangles
		},
		{
			kind: "greenery",
			name: "Land cover",
			triangles: p
		},
		{
			kind: "trees",
			name: "Bomen",
			triangles: m.triangles
		},
		{
			kind: "water",
			name: "Water",
			triangles: d
		},
		{
			kind: "roads",
			name: "Wegen",
			triangles: u
		},
		{
			kind: "track",
			name: "Route",
			triangles: h
		},
		{
			kind: "buildings",
			name: "Gebouwen",
			triangles: a
		}
	], _ = g.flatMap((e) => e.triangles), v = {
		valid: _.length > 0,
		openEdges: 0,
		nonManifoldEdges: 0,
		degenerateTriangles: 0,
		duplicateTriangles: 0,
		disconnectedComponents: +(_.length > 0)
	}, y = oF(_), b = [...e.warnings];
	v.valid || b.push(`De meshcontrole vond ${v.openEdges} open en ${v.nonManifoldEdges} niet-manifold randen.`), n.roofMode === "detailed" && !e.lod.startsWith("LoD0") && s === 0 && e.buildings.length > 0 && b.push("De daken zijn voor deze uitsnede automatisch vereenvoudigd tot gesloten bouwmassa's."), e.lod === "LoD0 · TOP10NL" && b.push("Op stadsschaal gebruikt het model lichte, gegeneraliseerde TOP10NL-bouwmassa's.");
	let [x, S] = pF(n), C = uF(n).map((e) => mF(e, n)), w = Math.abs(VP(C)), T = i.reliefMillimeters * .45, E = w * (n.baseMillimeters + T), D = u.length * .025 + d.length * .02 + (p.length + m.triangles.length) * .018 + h.length * .02, O = (E + l + D) / 1e3, k = Math.round((O * 1.24 * .2 + 4) * 10) / 10;
	return {
		triangles: _,
		layers: g,
		previewBuildings: o,
		warnings: b,
		attribution: aV(e),
		stats: {
			buildingCount: s + c,
			detailedBuildingCount: s,
			fallbackBuildingCount: c,
			triangleCount: _.length,
			widthMillimeters: Math.round(x * 10) / 10,
			depthMillimeters: Math.round(S * 10) / 10,
			heightMillimeters: Number.isFinite(y.maximum[2] - y.minimum[2]) ? Math.round((y.maximum[2] - y.minimum[2]) * 10) / 10 : 0,
			estimatedFilamentGrams: k,
			roadCount: e.roads.length + e.roadLines.length,
			waterCount: e.water.length,
			treeCount: m.count,
			greeneryCount: f.length,
			terrainReliefMillimeters: Math.round(i.reliefMillimeters * 10) / 10,
			dataLod: e.lod,
			diagnostics: v
		}
	};
}
async function sV(e, t = fetch, n) {
	let r = kB(e), i = await CB(r, t, n), a = r.treesEnabled === !1 ? 0 : i.trees.length;
	n?.({
		stage: "mesh",
		completed: 0,
		total: Math.max(1, a),
		message: a > 0 ? `Bomen opbouwen: 0 van ${a}` : "Gesloten printlagen worden opgebouwd"
	}), await new Promise((e) => setTimeout(e, 0));
	let o = oV(i, r);
	return n?.({
		stage: "mesh",
		completed: Math.max(1, a),
		total: Math.max(1, a),
		message: a > 0 ? `Bomen opgebouwd: ${o.stats.treeCount} van ${a}` : "Printlagen zijn opgebouwd"
	}), o;
}
//#endregion
//#region components/model-studio.tsx
var cV = {
	id: "adr-13e27c667505d022db800d52be5da389",
	label: "Markt 1, 2611GP Delft",
	type: "adres",
	x: 84334.1,
	y: 447522.4,
	longitude: 4.35787856,
	latitude: 52.01155949,
	coordinateSystem: "rd"
}, lV = [
	{
		value: 180,
		label: "Straat · 180 m"
	},
	{
		value: 400,
		label: "Buurt · 400 m"
	},
	{
		value: 800,
		label: "Wijk · 800 m"
	},
	{
		value: 1500,
		label: "Stadsdeel · 1,5 km"
	},
	{
		value: 2500,
		label: "Groot stadsdeel · 2,5 km"
	},
	{
		value: 6e3,
		label: "Stad · 6 km"
	},
	{
		value: 1e4,
		label: "Hele stad · 10 km"
	}
], uV = [
	{
		value: "square",
		label: "Vierkant",
		icon: ye
	},
	{
		value: "rectangle",
		label: "Rechthoek",
		icon: he
	},
	{
		value: "circle",
		label: "Cirkel",
		icon: z
	},
	{
		value: "hexagon",
		label: "Zeshoek",
		icon: re
	},
	{
		value: "polygon",
		label: "Vrij tekenen",
		icon: pe
	}
], dV = {
	buildingCount: 0,
	detailedBuildingCount: 0,
	fallbackBuildingCount: 0,
	triangleCount: 0,
	widthMillimeters: 180,
	depthMillimeters: 180,
	heightMillimeters: 0,
	estimatedFilamentGrams: 0,
	roadCount: 0,
	waterCount: 0,
	treeCount: 0,
	greeneryCount: 0,
	terrainReliefMillimeters: 0,
	dataLod: "LoD2.2 · 3DBAG",
	diagnostics: {
		valid: !1,
		openEdges: 0,
		nonManifoldEdges: 0,
		degenerateTriangles: 0,
		duplicateTriangles: 0,
		disconnectedComponents: 0
	}
}, fV = [
	{
		kind: "base",
		label: "Zijkant"
	},
	{
		kind: "terrain",
		label: "Terrein"
	},
	{
		kind: "greenery",
		label: "Groen"
	},
	{
		kind: "trees",
		label: "Bomen"
	},
	{
		kind: "water",
		label: "Water"
	},
	{
		kind: "roads",
		label: "Wegen"
	},
	{
		kind: "track",
		label: "Route"
	},
	{
		kind: "buildings",
		label: "Gebouwen"
	}
], pV = [
	{
		name: "Natuurlijk",
		description: "Aarde, water en echt groen",
		colors: IN
	},
	{
		name: "AMS · 4",
		description: "Vier filamentslots",
		colors: {
			base: "#E7E1D7",
			terrain: "#E7E1D7",
			buildings: "#E7E1D7",
			greenery: "#789B68",
			trees: "#789B68",
			water: "#65AFCB",
			roads: "#666C70",
			track: "#666C70"
		}
	},
	{
		name: "Architectuur",
		description: "Monochroom met rode route",
		colors: {
			base: "#242424",
			terrain: "#F4F1EA",
			greenery: "#D8D8D2",
			trees: "#A7A79E",
			water: "#BEC8CF",
			roads: "#51545A",
			track: "#D92525",
			buildings: "#FFFFFF"
		}
	},
	{
		name: "Pop",
		description: "Paars, cyaan, lime en koraal",
		colors: {
			base: "#241A44",
			terrain: "#FFF0B8",
			greenery: "#B9F227",
			trees: "#38C966",
			water: "#19C7E8",
			roads: "#334155",
			track: "#FF5A5F",
			buildings: "#8B5CF6"
		}
	},
	{
		name: "Pastel",
		description: "Lavendel, mint en zachtroze",
		colors: {
			base: "#C9B9E8",
			terrain: "#FFF4E6",
			greenery: "#BFE7C5",
			trees: "#74C69D",
			water: "#A9D6E5",
			roads: "#8E9AAF",
			track: "#F28482",
			buildings: "#F5CAC3"
		}
	},
	{
		name: "Herfst",
		description: "Oker, roest en donkergroen",
		colors: {
			base: "#4A3428",
			terrain: "#E8D8B5",
			greenery: "#A78B3D",
			trees: "#4F6B3A",
			water: "#2A7F8E",
			roads: "#625750",
			track: "#C4472D",
			buildings: "#D98132"
		}
	}
];
function mV({ icon: e, title: t, source: n, enabled: r, onEnabledChange: i, color: a, onColorChange: o, children: s, defaultOpen: c = !1, toggleDisabled: l = !1 }) {
	let [u, d] = (0, A.useState)(c);
	return /* @__PURE__ */ (0, q.jsxs)("details", {
		className: "feature-panel",
		open: u,
		onToggle: (e) => d(e.currentTarget.open),
		children: [/* @__PURE__ */ (0, q.jsxs)("summary", { children: [/* @__PURE__ */ (0, q.jsxs)("span", {
			className: "feature-identity",
			children: [/* @__PURE__ */ (0, q.jsx)(e, {}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: t }), /* @__PURE__ */ (0, q.jsx)("small", { children: n })] })]
		}), /* @__PURE__ */ (0, q.jsxs)("span", {
			className: "feature-actions",
			children: [
				/* @__PURE__ */ (0, q.jsx)("input", {
					type: "color",
					value: a,
					"aria-label": `Kleur voor ${t}`,
					onClick: (e) => e.stopPropagation(),
					onChange: (e) => o(e.target.value)
				}),
				/* @__PURE__ */ (0, q.jsx)("span", {
					onClick: (e) => e.stopPropagation(),
					children: /* @__PURE__ */ (0, q.jsx)(xM, {
						checked: r,
						onCheckedChange: i,
						disabled: l,
						"aria-label": `${t} tonen`
					})
				}),
				/* @__PURE__ */ (0, q.jsx)(ee, { className: "feature-chevron" })
			]
		})] }), /* @__PURE__ */ (0, q.jsx)("div", {
			className: r ? "feature-settings" : "feature-settings disabled",
			children: r ? s : /* @__PURE__ */ (0, q.jsx)("p", {
				className: "feature-disabled-copy",
				children: "Zet deze laag aan om de instellingen te wijzigen."
			})
		})]
	});
}
function hV(e) {
	return e.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]+/g, "-").replace(/^-+|-+$/g, "").toLowerCase().slice(0, 54) || "nederland";
}
function gV(e, t) {
	if (e.length < 3) return t;
	let n = cF(e);
	return Math.max(n[2] - n[0], n[3] - n[1]);
}
function _V({ onChoose: e, onBack: t } = {}) {
	let [n, r] = (0, A.useState)(cV.label), [i, a] = (0, A.useState)(cV), [o, s] = (0, A.useState)([]), [c, l] = (0, A.useState)(!1), [u, d] = (0, A.useState)("square"), [f, p] = (0, A.useState)([]), [m, h] = (0, A.useState)(0), [g, _] = (0, A.useState)(180), [v, y] = (0, A.useState)(180), [b, x] = (0, A.useState)("auto"), [S, C] = (0, A.useState)(1.35), [w, T] = (0, A.useState)(1.2), [E, D] = (0, A.useState)(1), [O, k] = (0, A.useState)("exaggeration"), [j, M] = (0, A.useState)(17), [N, P] = (0, A.useState)(65), [R, ee] = (0, A.useState)(3), [te, z] = (0, A.useState)("solid"), [B, re] = (0, A.useState)(2.4), [ie, oe] = (0, A.useState)("detailed"), [ue, de] = (0, A.useState)(!0), [pe, he] = (0, A.useState)(!0), [ye, Se] = (0, A.useState)(!0), [Ce, we] = (0, A.useState)(!0), [Te, Ee] = (0, A.useState)(!0), [De, Oe] = (0, A.useState)(!0), [ke, Ae] = (0, A.useState)(1.15), [je, Me] = (0, A.useState)("clean-lines"), [Ne, Pe] = (0, A.useState)(.52), [Fe, Ie] = (0, A.useState)("raised"), [Le, Re] = (0, A.useState)(.55), [ze, Ve] = (0, A.useState)(.65), [He, Ue] = (0, A.useState)("recessed"), [We, Ge] = (0, A.useState)(1), [Ke, qe] = (0, A.useState)(1), [Je, Ye] = (0, A.useState)(.2), [Xe, Ze] = (0, A.useState)(.02), [Qe, $e] = (0, A.useState)("raised"), [et] = (0, A.useState)(1), [tt, nt] = (0, A.useState)(1), [rt, it] = (0, A.useState)(!1), [at, ot] = (0, A.useState)("map"), [G, st] = (0, A.useState)([]), [ct, lt] = (0, A.useState)(!0), [ut, dt] = (0, A.useState)(""), [ft, pt] = (0, A.useState)(3), [mt, ht] = (0, A.useState)(.7), [gt, _t] = (0, A.useState)("raised"), [vt, yt] = (0, A.useState)({ ...IN }), [bt, xt] = (0, A.useState)({
		layers: [],
		stats: dV,
		warnings: [],
		attribution: ""
	}), [St, Ct] = (0, A.useState)(!1), [wt, Tt] = (0, A.useState)(null), [Et, Dt] = (0, A.useState)(0), [Ot, kt] = (0, A.useState)(""), [At, jt] = (0, A.useState)([]), [Mt, Nt] = (0, A.useState)(""), [Pt, Ft] = (0, A.useState)("map"), It = (0, A.useRef)(!1), Lt = (0, A.useRef)(null), Rt = (0, A.useRef)(0), zt = (0, A.useRef)(/* @__PURE__ */ new Map()), Bt = (0, A.useMemo)(() => u === "polygon" ? f : lF(i.x, i.y, g, u, u === "circle" ? 0 : m), [
		g,
		f,
		i.x,
		i.y,
		m,
		u
	]), Vt = Math.max(80, Math.min(1e4, gV(Bt, g))), Ht = (0, A.useMemo)(() => ({
		coordinateSystem: i.coordinateSystem ?? "rd",
		centerX: i.x,
		centerY: i.y,
		areaMeters: Vt,
		selectionShape: u,
		selectionPolygon: Bt,
		modelMillimeters: v,
		verticalScale: S,
		minimumBuildingHeightMillimeters: w,
		terrainScale: E,
		heightMode: O,
		targetModelHeightMillimeters: j,
		elevationResolution: N,
		baseMillimeters: R,
		baseMode: te,
		wallThicknessMillimeters: B,
		roofMode: ie,
		buildingLod: b,
		buildingsEnabled: ue,
		terrainEnabled: pe,
		roadsEnabled: ye,
		waterEnabled: Ce,
		greeneryEnabled: Te,
		treesEnabled: De,
		roadWidthScale: ke,
		roadSource: je,
		roadHeightMillimeters: Ne,
		roadMode: Fe,
		waterHeightMillimeters: Le,
		waterDepthMillimeters: ze,
		waterMode: He,
		treeDensity: We,
		treeHeightScale: Ke,
		landCoverHeightMillimeters: Je,
		landCoverOffsetMillimeters: Xe,
		landCoverMode: Qe,
		trackPoints: ct && G.length >= 2 ? G : void 0,
		trackWidthMeters: ft,
		trackHeightMillimeters: mt,
		trackMode: gt
	}), [
		R,
		te,
		b,
		ue,
		N,
		Te,
		De,
		O,
		Je,
		Qe,
		Xe,
		i.coordinateSystem,
		i.x,
		i.y,
		w,
		v,
		Ne,
		Fe,
		je,
		ke,
		ye,
		ie,
		Vt,
		Bt,
		u,
		j,
		pe,
		E,
		ct,
		mt,
		gt,
		G,
		ft,
		We,
		Ke,
		S,
		B,
		ze,
		Ce,
		Le,
		He
	]), Ut = (0, A.useMemo)(() => JSON.stringify(Ht), [Ht]), [Wt, Gt] = i.coordinateSystem === "web-mercator" ? rc([i.x, i.y]) : $s([i.x, i.y]), Kt = i.coordinateSystem === "web-mercator" && Wt >= -5.6 && Wt <= 10 && Gt >= 41 && Gt <= 51.6, qt = Kt ? "LoD0 · IGN BD TOPO" : SB(Vt, b, i.coordinateSystem), Jt = b === "lod22" && Vt > 500 || b === "lod13" && Vt > 800 || b === "lod12" && Vt > 2500, Yt = (i.coordinateSystem ?? "rd") === "rd" && ye && je === "bgt-surfaces" && Vt > 1200, Xt = (u !== "polygon" || Bt.length >= 3) && !Yt, Zt = u === "polygon" ? `${i.id}-polygon` : `${i.id}-${i.x.toFixed(1)}-${i.y.toFixed(1)}-${g}-${u}-${m}`, Qt = (0, A.useMemo)(() => ({
		water: et,
		greenery: tt
	}), [tt, et]);
	(0, A.useEffect)(() => {
		queueMicrotask(() => {
			let e = new URLSearchParams(window.location.search), t = (t, n, r) => {
				let i = Number(e.get(t));
				return Number.isFinite(i) && i >= n && i <= r ? i : void 0;
			}, n = e.get("region") === "world", i = t("x", n ? -20037508 : 1e4, n ? 20037508 : 3e5), o = t("y", n ? -20037508 : 3e5, n ? 20037508 : 65e4);
			if (i !== void 0 && o !== void 0) {
				let t = e.get("place")?.slice(0, 120) || "Opgeslagen selectie";
				a((e) => ({
					...e,
					id: "url-selection",
					label: t,
					x: i,
					y: o,
					coordinateSystem: n ? "web-mercator" : "rd"
				})), r(t);
			}
			let s = e.get("shape");
			s && uV.some((e) => e.value === s) && d(s);
			let c = e.get("polygon");
			if (c) try {
				let e = JSON.parse(c);
				if (Array.isArray(e)) {
					let t = e.filter(Array.isArray).map((e) => [Number(e[0]), Number(e[1])]).filter((e) => e.every(Number.isFinite));
					t.length >= 3 && xF(t) && p(t);
				}
			} catch {}
			let l = [
				[
					"area",
					80,
					1e4,
					_
				],
				[
					"size",
					80,
					300,
					y
				],
				[
					"rotation",
					-45,
					45,
					h
				],
				[
					"vertical",
					.5,
					4,
					C
				],
				[
					"minBuilding",
					.5,
					6,
					T
				],
				[
					"relief",
					.25,
					4,
					D
				],
				[
					"targetHeight",
					2,
					45,
					M
				],
				[
					"resolution",
					33,
					129,
					P
				],
				[
					"base",
					2,
					8,
					ee
				],
				[
					"roadWidth",
					.5,
					3,
					Ae
				],
				[
					"wall",
					.8,
					12,
					re
				],
				[
					"roadHeight",
					.12,
					2,
					Pe
				],
				[
					"waterHeight",
					.12,
					2,
					Re
				],
				[
					"waterDepth",
					.2,
					2.5,
					Ve
				],
				[
					"treeDensity",
					.05,
					1,
					Ge
				],
				[
					"treeScale",
					.5,
					2.5,
					qe
				],
				[
					"landHeight",
					.05,
					1.5,
					Ye
				],
				[
					"landOffset",
					0,
					1,
					Ze
				],
				[
					"landOpacity",
					.1,
					1,
					nt
				],
				[
					"trackWidth",
					.5,
					30,
					pt
				],
				[
					"trackHeight",
					.12,
					3,
					ht
				]
			];
			for (let [e, n, r, i] of l) {
				let a = t(e, n, r);
				a !== void 0 && i(a);
			}
			let u = e.get("lod");
			u && [
				"auto",
				"lod22",
				"lod13",
				"lod12",
				"lod0"
			].includes(u) && x(u);
			let f = e.get("heightMode");
			f && ["exaggeration", "target-height"].includes(f) && k(f), e.get("baseMode") === "hollow" && z("hollow");
			let m = e.get("roadSource");
			m && ["clean-lines", "bgt-surfaces"].includes(m) && Me(m);
			let g = e.get("roadMode");
			g && ["raised", "flush"].includes(g) && Ie(g);
			let v = e.get("waterMode");
			v && [
				"raised",
				"flush",
				"recessed"
			].includes(v) && Ue(v);
			let b = e.get("trackMode");
			b && ["raised", "flush"].includes(b) && _t(b);
			let S = e.get("landMode");
			S && ["raised", "flush"].includes(S) && $e(S), e.get("ground") === "imagery" && ot("imagery"), e.get("roof") === "print-safe" && oe("print-safe"), he(e.get("terrain") !== "0"), de(e.get("buildings") !== "0"), Se(e.get("roads") !== "0"), we(e.get("water") !== "0"), Ee(e.get("greenery") !== "0"), Oe(e.get("trees") !== "0"), it(e.get("edges") === "1");
			let w = { ...IN };
			for (let { kind: t } of fV) {
				let n = e.get(`color_${t}`);
				n && /^#[0-9a-f]{6}$/i.test(n) && (w[t] = n);
			}
			yt(w), It.current = !0;
		});
	}, []), (0, A.useEffect)(() => {
		if (!It.current) return;
		let e = window.setTimeout(() => {
			let e = new URLSearchParams();
			i.coordinateSystem === "web-mercator" && e.set("region", "world"), e.set("place", i.label), e.set("x", i.x.toFixed(2)), e.set("y", i.y.toFixed(2)), e.set("shape", u), e.set("area", String(Math.round(g))), e.set("size", String(v)), u === "polygon" && f.length >= 3 && e.set("polygon", JSON.stringify(f.map(([e, t]) => [Math.round(e * 10) / 10, Math.round(t * 10) / 10]))), e.set("rotation", String(m)), e.set("lod", b), e.set("roof", ie), e.set("vertical", String(S)), e.set("minBuilding", String(w)), e.set("heightMode", O), e.set("relief", String(E)), e.set("targetHeight", String(j)), e.set("resolution", String(N)), e.set("base", String(R)), e.set("baseMode", te), e.set("wall", String(B)), e.set("roadSource", je), e.set("roadMode", Fe), e.set("roadWidth", String(ke)), e.set("roadHeight", String(Ne)), e.set("waterMode", He), e.set("waterHeight", String(Le)), e.set("waterDepth", String(ze)), e.set("treeDensity", String(We)), e.set("treeScale", String(Ke)), e.set("landHeight", String(Je)), e.set("landOffset", String(Xe)), e.set("landMode", Qe), e.set("waterOpacity", String(et)), e.set("landOpacity", String(tt)), e.set("trackWidth", String(ft)), e.set("trackHeight", String(mt)), e.set("trackMode", gt), e.set("ground", at), pe || e.set("terrain", "0"), ye || e.set("roads", "0"), ue || e.set("buildings", "0"), Ce || e.set("water", "0"), Te || e.set("greenery", "0"), De || e.set("trees", "0"), rt && e.set("edges", "1");
			for (let { kind: t } of fV) e.set(`color_${t}`, vt[t]);
			window.history.replaceState(null, "", `${window.location.pathname}?${e.toString()}`);
		}, 250);
		return () => window.clearTimeout(e);
	}, [
		g,
		R,
		te,
		rt,
		b,
		ue,
		f,
		N,
		Te,
		De,
		at,
		O,
		Je,
		Qe,
		Xe,
		tt,
		vt,
		i.coordinateSystem,
		i.label,
		i.x,
		i.y,
		w,
		v,
		Ne,
		Fe,
		je,
		ke,
		ye,
		ie,
		m,
		u,
		j,
		pe,
		E,
		mt,
		gt,
		ft,
		We,
		Ke,
		S,
		B,
		ze,
		Ce,
		Le,
		He,
		et
	]);
	let $t = (0, A.useCallback)(async (e = Ht) => {
		if ((e.selectionPolygon?.length ?? 0) < 3) {
			Be.info("Teken eerst minimaal drie hoekpunten.");
			return;
		}
		let t = JSON.stringify(e);
		Lt.current?.abort(), Rt.current += 1;
		let n = Rt.current, r = new AbortController();
		Lt.current = r, zt.current.clear(), Ct(!0), Dt(3), kt("Gebied wordt voorbereid…");
		try {
			let i = await sV(e, (e, t = {}) => fetch(e, {
				...t,
				signal: t.signal ? AbortSignal.any([r.signal, t.signal]) : r.signal
			}), (e) => {
				if (r.signal.throwIfAborted(), Rt.current !== n) return;
				zt.current.set(e.stage, e);
				let t = {
					buildings: 38,
					terrain: 20,
					features: 30,
					mesh: 9
				}, i = 3;
				for (let [e, n] of Object.entries(t)) {
					let t = zt.current.get(e);
					t && t.total > 0 && (i += n * Math.min(1, t.completed / t.total));
				}
				Dt(Math.min(97, i)), kt([...zt.current.values()].find((e) => e.completed < e.total)?.message ?? e.message);
			});
			if (Rt.current !== n || r.signal.aborted) return;
			let a = {
				layers: i.layers,
				stats: i.stats,
				warnings: i.warnings,
				attribution: i.attribution
			};
			xt(a), jt(i.triangles), Nt(t), Dt(100), kt("Printmodel is gesloten en gecontroleerd"), Ft("model"), Be.success("Printmodel technisch gecontroleerd", { description: `${a.stats.buildingCount} gebouwen, ${a.stats.waterCount} waterdelen en ${a.stats.treeCount} bomen.` });
		} catch (e) {
			if (r.signal.aborted || Rt.current !== n) return;
			let t = e instanceof Error ? e.message : "Probeer een kleiner gebied.";
			Be.error("Genereren mislukt", { description: t }), xt((e) => ({
				...e,
				warnings: [`Genereren: ${t}`]
			})), Nt(""), Dt(0), kt("");
		} finally {
			Lt.current === r && Rt.current === n && (Lt.current = null, Ct(!1));
		}
	}, [Ht]);
	function en() {
		Lt.current && (Lt.current.abort(), Lt.current = null, Rt.current += 1, zt.current.clear(), Ct(!1), Dt(0), kt(""), Be.info("Laden geannuleerd"));
	}
	async function tn(e) {
		if (e.preventDefault(), !(n.trim().length < 3)) {
			l(!0);
			try {
				let e = i.coordinateSystem === "web-mercator" ? await HF(n.trim()) : await VF(n.trim());
				s(e), e.length === 0 && Be.info("Geen locatie gevonden.");
			} catch (e) {
				Be.error("Adres zoeken mislukt", { description: e instanceof Error ? e.message : void 0 });
			} finally {
				l(!1);
			}
		}
	}
	function nn(e) {
		a(e), r(e.label), s([]), u === "polygon" && p([]), Ft("map");
	}
	function rn(e) {
		if (e === "world") {
			let e = i.coordinateSystem === "web-mercator" ? rc([i.x, i.y]) : $s([i.x, i.y]), [t, n] = nc(e);
			a((r) => ({
				...r,
				id: `world-${r.id}`,
				x: t,
				y: n,
				longitude: e[0],
				latitude: e[1],
				coordinateSystem: "web-mercator"
			})), x("lod0"), Me("clean-lines"), Ue("recessed"), k("exaggeration"), D(1), C(1), P(97), qe(1);
		} else a(cV), r(cV.label), x("auto"), P(65);
		s([]), p([]), Ft("map");
	}
	function an(e) {
		let t = i.coordinateSystem === "web-mercator";
		!t && (e[0] < 1e4 || e[0] > 3e5 || e[1] < 3e5 || e[1] > 65e4) || t && (Math.abs(e[0]) > 20037508 || Math.abs(e[1]) > 20037508) || a((t) => ({
			...t,
			x: e[0],
			y: e[1]
		}));
	}
	function on(e) {
		if (e.length >= 4 && !xF(e)) {
			Be.info("Die lijn zou de contour kruisen. Kies een ander hoekpunt.");
			return;
		}
		if (p(e), e.length >= 3) {
			let t = cF(e), n = Math.max(t[2] - t[0], t[3] - t[1]);
			if (n > 1e4) {
				Be.info("Een vrije selectie mag maximaal 10 km breed zijn."), p(e.slice(0, -1));
				return;
			}
			_(Math.max(80, Math.round(n))), a((e) => ({
				...e,
				x: (t[0] + t[2]) / 2,
				y: (t[1] + t[3]) / 2
			}));
		}
	}
	function sn(e, t) {
		yt((n) => ({
			...n,
			[e]: t
		}));
	}
	function cn(e) {
		yt({ ...e });
	}
	async function ln(e) {
		let t = e.target.files?.[0];
		if (t) try {
			let e = new DOMParser().parseFromString(await t.text(), "application/xml");
			if (e.querySelector("parsererror")) throw Error("Het bestand bevat geen geldige GPX/KML-XML.");
			let n = [...e.querySelectorAll("trkpt, rtept, wpt, coordinates")], r = [];
			for (let e of n) if (e.localName === "coordinates") for (let t of (e.textContent ?? "").trim().split(/\s+/)) {
				let [e, n] = t.split(",").map(Number);
				Number.isFinite(e) && Number.isFinite(n) && r.push(i.coordinateSystem === "web-mercator" ? nc([e, n]) : ec([e, n]));
			}
			else {
				let t = Number(e.getAttribute("lat")), n = Number(e.getAttribute("lon"));
				Number.isFinite(n) && Number.isFinite(t) && r.push(i.coordinateSystem === "web-mercator" ? nc([n, t]) : ec([n, t]));
			}
			if (r.length < 2) throw Error("Er zijn minder dan twee routepunten gevonden.");
			let a = r.length <= 5e3 ? r : Array.from({ length: 5e3 }, (e, t) => r[Math.floor(t * r.length / 5e3)]);
			st(a), dt(t.name), Be.success("Route geladen", { description: `${a.length.toLocaleString("nl-NL")} punten worden als gesloten printlijn opgebouwd.` });
		} catch (e) {
			Be.error("Route laden mislukt", { description: e instanceof Error ? e.message : void 0 });
		} finally {
			e.target.value = "";
		}
	}
	async function un(e) {
		Tt(e);
		try {
			if (Mt !== Ut || At.length === 0) throw Error("Bouw eerst opnieuw het model met deze instellingen.");
			let t = `Plaats in 3D — ${i.label}`, n = e === "stl" ? RN(At, t) : UN(bt.layers, vt, t), r = new Blob([new Uint8Array(n).buffer], { type: e === "stl" ? "model/stl" : "model/3mf" }), a = URL.createObjectURL(r), o = document.createElement("a");
			o.href = a, o.download = `plaats-in-3d-${hV(i.label)}.${e}`, o.click(), URL.revokeObjectURL(a), Be.success(`${e.toUpperCase()} is klaar`, { description: e === "3mf" ? "Terrein, land cover, bomen, water, wegen en gebouwen blijven aparte objecten in Bambu Studio." : "De complete, gecontroleerde geometrie staat in één universele STL." });
		} catch (e) {
			Be.error("Download mislukt", { description: e instanceof Error ? e.message : void 0 });
		} finally {
			Tt(null);
		}
	}
	let K = bt.stats, dn = Mt === Ut ? K.dataLod : qt, fn = bt.warnings.some((e) => /3DBAG.*(?:tegel|pagina|onbereik|ontbre)/i.test(e)), pn = ue && /LoD(?:1|2)/.test(K.dataLod) && K.buildingCount === 0 && fn, mn = K.diagnostics.valid && At.length > 0 && Mt === Ut && !pn, hn = bt.layers.filter((e) => e.triangles.length > 0), gn = new Set(hn.map((e) => vt[e.kind].toLowerCase())).size;
	return /* @__PURE__ */ (0, q.jsxs)("main", {
		className: "min-h-screen",
		children: [
			/* @__PURE__ */ (0, q.jsx)(EM, {
				position: "bottom-right",
				richColors: !0
			}),
			/* @__PURE__ */ (0, q.jsxs)("header", {
				className: "app-header",
				children: [/* @__PURE__ */ (0, q.jsxs)("div", {
					className: "brand-lockup",
					children: [/* @__PURE__ */ (0, q.jsx)("div", {
						className: "brand-mark",
						"aria-hidden": "true",
						children: /* @__PURE__ */ (0, q.jsx)(ae, {})
					}), /* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)("p", {
						className: "brand-name",
						children: "Plaats in 3D"
					}), /* @__PURE__ */ (0, q.jsx)("p", {
						className: "brand-subtitle",
						children: "Wereldwijde open data → H2D-printmodel"
					})] })]
				}), e ? /* @__PURE__ */ (0, q.jsxs)("div", {
					className: "studio-shop-actions",
					children: [/* @__PURE__ */ (0, q.jsx)(eM, {
						variant: "outline",
						onClick: t,
						children: "Terug naar winkel"
					}), /* @__PURE__ */ (0, q.jsx)(eM, {
						disabled: !mn || St,
						onClick: () => e({
							name: i.label,
							layers: bt.layers,
							stats: K,
							config: Ht,
							colors: vt,
							attribution: bt.attribution,
							editorQuery: window.location.search
						}),
						children: "Kies dit ontwerp"
					})]
				}) : /* @__PURE__ */ (0, q.jsxs)("div", {
					className: "header-badge",
					children: [/* @__PURE__ */ (0, q.jsx)("span", {}), " Eén buildplate · max. 300 × 300 mm"]
				})]
			}),
			/* @__PURE__ */ (0, q.jsxs)("div", {
				className: "studio-shell",
				children: [/* @__PURE__ */ (0, q.jsxs)("section", {
					className: "control-panel",
					"aria-labelledby": "controls-title",
					children: [/* @__PURE__ */ (0, q.jsxs)("div", {
						className: "control-scroll",
						children: [
							/* @__PURE__ */ (0, q.jsxs)("div", {
								className: "panel-heading",
								children: [
									/* @__PURE__ */ (0, q.jsx)("p", {
										className: "eyebrow",
										children: "Printkaart-atelier"
									}),
									/* @__PURE__ */ (0, q.jsx)("h1", {
										id: "controls-title",
										children: "Bouw je plaats."
									}),
									/* @__PURE__ */ (0, q.jsx)("p", { children: "Kies eerst de echte uitsnede op de kaart. Stel daarna detail, reliëf en printlagen af." })
								]
							}),
							/* @__PURE__ */ (0, q.jsxs)("div", {
								className: "control-section address-section",
								children: [/* @__PURE__ */ (0, q.jsx)("div", {
									className: "section-number",
									children: "01"
								}), /* @__PURE__ */ (0, q.jsxs)("div", {
									className: "section-content",
									children: [
										/* @__PURE__ */ (0, q.jsx)("label", {
											htmlFor: "data-region",
											children: "Datadekking"
										}),
										/* @__PURE__ */ (0, q.jsxs)(pM, {
											value: i.coordinateSystem === "web-mercator" ? "world" : "nl",
											onValueChange: (e) => rn(e),
											children: [/* @__PURE__ */ (0, q.jsx)(hM, {
												id: "data-region",
												className: "w-full",
												children: /* @__PURE__ */ (0, q.jsx)(mM, {})
											}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [/* @__PURE__ */ (0, q.jsx)(_M, {
												value: "nl",
												children: "Nederland · hoogste detail"
											}), /* @__PURE__ */ (0, q.jsx)(_M, {
												value: "world",
												children: "Wereldwijd · open data"
											})] })]
										}),
										/* @__PURE__ */ (0, q.jsx)("label", {
											htmlFor: "address",
											children: "Adres of woonplaats"
										}),
										/* @__PURE__ */ (0, q.jsxs)("form", {
											onSubmit: tn,
											className: "search-row",
											children: [/* @__PURE__ */ (0, q.jsxs)("div", {
												className: "search-field",
												children: [/* @__PURE__ */ (0, q.jsx)(se, { "aria-hidden": "true" }), /* @__PURE__ */ (0, q.jsx)(dM, {
													id: "address",
													value: n,
													onChange: (e) => r(e.target.value),
													placeholder: i.coordinateSystem === "web-mercator" ? "Bijv. Paris, France" : "Bijv. Utrecht of Markt 1, Delft",
													autoComplete: "street-address"
												})]
											}), /* @__PURE__ */ (0, q.jsxs)(eM, {
												type: "submit",
												variant: "outline",
												disabled: c,
												"aria-label": "Adres zoeken",
												children: [
													/* @__PURE__ */ (0, q.jsx)(_e, {}),
													" ",
													c ? "Zoekt" : "Zoek"
												]
											})]
										}),
										o.length > 0 ? /* @__PURE__ */ (0, q.jsx)("div", {
											className: "suggestion-list",
											role: "listbox",
											"aria-label": "Gevonden locaties",
											children: o.map((e) => /* @__PURE__ */ (0, q.jsxs)("button", {
												type: "button",
												role: "option",
												"aria-selected": e.id === i.id,
												onClick: () => nn(e),
												children: [/* @__PURE__ */ (0, q.jsx)(se, {}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [e.label, /* @__PURE__ */ (0, q.jsx)("small", { children: e.type })] })]
											}, e.id))
										}) : null,
										/* @__PURE__ */ (0, q.jsx)("p", {
											className: "coordinate-line",
											children: i.coordinateSystem === "web-mercator" ? (() => {
												let [e, t] = rc([i.x, i.y]);
												return `${t.toFixed(5)}°, ${e.toFixed(5)}°`;
											})() : `RD ${i.x.toFixed(1)} · ${i.y.toFixed(1)}`
										})
									]
								})]
							}),
							/* @__PURE__ */ (0, q.jsxs)("div", {
								className: "control-section",
								children: [/* @__PURE__ */ (0, q.jsx)("div", {
									className: "section-number",
									children: "02"
								}), /* @__PURE__ */ (0, q.jsxs)("div", {
									className: "section-content",
									children: [
										/* @__PURE__ */ (0, q.jsx)("label", { children: "Vorm van de uitsnede" }),
										/* @__PURE__ */ (0, q.jsx)("div", {
											className: "shape-grid",
											role: "group",
											"aria-label": "Vorm van het printgebied",
											children: uV.map((e) => {
												let t = e.icon;
												return /* @__PURE__ */ (0, q.jsxs)("button", {
													type: "button",
													className: u === e.value ? "active" : "",
													"aria-pressed": u === e.value,
													onClick: () => {
														d(e.value), e.value === "polygon" && p([]), Ft("map");
													},
													children: [/* @__PURE__ */ (0, q.jsx)(t, {}), /* @__PURE__ */ (0, q.jsx)("span", { children: e.label })]
												}, e.value);
											})
										}),
										u === "polygon" ? /* @__PURE__ */ (0, q.jsxs)("div", {
											className: "polygon-actions",
											children: [/* @__PURE__ */ (0, q.jsxs)("span", { children: [f.length, " punten getekend"] }), /* @__PURE__ */ (0, q.jsx)("button", {
												type: "button",
												onClick: () => p([]),
												children: "Opnieuw tekenen"
											})]
										}) : /* @__PURE__ */ (0, q.jsxs)("div", {
											className: "settings-grid compact-settings",
											children: [/* @__PURE__ */ (0, q.jsxs)("div", {
												className: "setting full-width",
												children: [/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "area-size",
														children: "Gebied"
													}), /* @__PURE__ */ (0, q.jsx)("output", {
														className: qt === "LoD2.2 · 3DBAG" ? "lod-output detailed" : "lod-output",
														children: qt
													})]
												}), /* @__PURE__ */ (0, q.jsxs)(pM, {
													value: String(g),
													onValueChange: (e) => {
														_(Number(e)), Ft("map");
													},
													children: [/* @__PURE__ */ (0, q.jsx)(hM, {
														id: "area-size",
														className: "w-full",
														children: /* @__PURE__ */ (0, q.jsx)(mM, {})
													}), /* @__PURE__ */ (0, q.jsx)(gM, { children: lV.map((e) => /* @__PURE__ */ (0, q.jsx)(_M, {
														value: String(e.value),
														children: e.label
													}, e.value)) })]
												})]
											}), u === "circle" ? null : /* @__PURE__ */ (0, q.jsxs)("div", {
												className: "setting full-width",
												children: [/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "rotation",
														children: "Rotatie"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [m, "°"] })]
												}), /* @__PURE__ */ (0, q.jsx)(bM, {
													id: "rotation",
													min: -45,
													max: 45,
													step: 1,
													value: [m],
													onValueChange: (e) => {
														h(e[0]), Ft("map");
													}
												})]
											})]
										}),
										/* @__PURE__ */ (0, q.jsxs)("div", {
											className: "setting print-size-setting",
											children: [/* @__PURE__ */ (0, q.jsx)("label", {
												htmlFor: "model-size",
												children: "Maximale printmaat"
											}), /* @__PURE__ */ (0, q.jsxs)(pM, {
												value: String(v),
												onValueChange: (e) => y(Number(e)),
												children: [/* @__PURE__ */ (0, q.jsx)(hM, {
													id: "model-size",
													className: "w-full",
													children: /* @__PURE__ */ (0, q.jsx)(mM, {})
												}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [
													/* @__PURE__ */ (0, q.jsx)(_M, {
														value: "120",
														children: "120 mm"
													}),
													/* @__PURE__ */ (0, q.jsx)(_M, {
														value: "180",
														children: "180 mm"
													}),
													/* @__PURE__ */ (0, q.jsx)(_M, {
														value: "240",
														children: "240 mm"
													}),
													/* @__PURE__ */ (0, q.jsx)(_M, {
														value: "300",
														children: "300 mm · H2D duo"
													})
												] })]
											})]
										})
									]
								})]
							}),
							/* @__PURE__ */ (0, q.jsxs)("div", {
								className: "feature-stack",
								"aria-label": "Kaartlagen en instellingen",
								children: [
									/* @__PURE__ */ (0, q.jsxs)("div", {
										className: "feature-stack-heading",
										children: [
											/* @__PURE__ */ (0, q.jsx)("span", { children: "03" }),
											/* @__PURE__ */ (0, q.jsx)("strong", { children: "Kaartlagen" }),
											/* @__PURE__ */ (0, q.jsx)("small", { children: "Klik een laag open voor de instellingen" })
										]
									}),
									/* @__PURE__ */ (0, q.jsx)(mV, {
										icon: I,
										title: "Gebouwen",
										source: i.coordinateSystem === "web-mercator" ? Kt ? "IGN France · BD TOPO" : "Overture Maps" : "3DBAG / TOP10NL",
										enabled: ue,
										onEnabledChange: de,
										color: vt.buildings,
										onColorChange: (e) => sn("buildings", e),
										defaultOpen: !0,
										children: /* @__PURE__ */ (0, q.jsxs)("div", {
											className: "settings-grid",
											children: [
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting full-width",
													children: [
														/* @__PURE__ */ (0, q.jsx)("label", {
															htmlFor: "building-lod",
															children: "Gebouwdetail"
														}),
														/* @__PURE__ */ (0, q.jsxs)(pM, {
															value: b,
															onValueChange: (e) => x(e),
															disabled: i.coordinateSystem === "web-mercator",
															children: [/* @__PURE__ */ (0, q.jsx)(hM, {
																id: "building-lod",
																className: "w-full",
																children: /* @__PURE__ */ (0, q.jsx)(mM, {})
															}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [
																/* @__PURE__ */ (0, q.jsx)(_M, {
																	value: "auto",
																	children: "Automatisch · aanbevolen"
																}),
																/* @__PURE__ */ (0, q.jsx)(_M, {
																	value: "lod22",
																	children: "LoD2.2 · echte dakvormen"
																}),
																/* @__PURE__ */ (0, q.jsx)(_M, {
																	value: "lod13",
																	children: "LoD1.3 · dakhoogtes"
																}),
																/* @__PURE__ */ (0, q.jsx)(_M, {
																	value: "lod12",
																	children: "LoD1.2 · bouwblokken"
																}),
																/* @__PURE__ */ (0, q.jsx)(_M, {
																	value: "lod0",
																	children: "LoD0 · lichte stadsdata"
																})
															] })]
														}),
														i.coordinateSystem === "web-mercator" ? /* @__PURE__ */ (0, q.jsx)("p", {
															className: "setting-help",
															children: Kt ? "Frankrijk gebruikt de metrisch nauwkeurige IGN BD TOPO-gebouwvormen en hoogtes." : "Werelddekking gebruikt beschikbare Overture-footprints en gebouwhoogtes."
														}) : Jt ? /* @__PURE__ */ (0, q.jsx)("p", {
															className: "setting-warning",
															children: "Handmatige keuze actief. Het systeem schakelt niet terug; genereren kan hierdoor merkbaar langer duren."
														}) : /* @__PURE__ */ (0, q.jsx)("p", {
															className: "setting-help",
															children: "Auto kiest op schaal. Een handmatige LoD wordt nooit stilletjes vervangen."
														})
													]
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting full-width",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "roof-mode",
														children: "Dakmodus"
													}), /* @__PURE__ */ (0, q.jsxs)(pM, {
														value: ie,
														onValueChange: (e) => oe(e),
														disabled: qt.startsWith("LoD0"),
														children: [/* @__PURE__ */ (0, q.jsx)(hM, {
															id: "roof-mode",
															className: "w-full",
															children: /* @__PURE__ */ (0, q.jsx)(mM, {})
														}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [/* @__PURE__ */ (0, q.jsx)(_M, {
															value: "detailed",
															children: "Brongeometrie"
														}), /* @__PURE__ */ (0, q.jsx)(_M, {
															value: "print-safe",
															children: "Printveilige massa"
														})] })]
													})]
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting full-width",
													children: [/* @__PURE__ */ (0, q.jsxs)("div", {
														className: "setting-label",
														children: [/* @__PURE__ */ (0, q.jsx)("label", {
															htmlFor: "building-height",
															children: "Gebouwhoogte"
														}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [S.toFixed(2), "×"] })]
													}), /* @__PURE__ */ (0, q.jsx)(bM, {
														id: "building-height",
														min: .5,
														max: 3.5,
														step: .05,
														value: [S],
														onValueChange: (e) => C(e[0])
													})]
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting full-width switch-setting",
													children: [/* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "building-edges",
														children: "Dak- en gevelranden"
													}), /* @__PURE__ */ (0, q.jsx)("small", { children: "Alleen in de preview" })] }), /* @__PURE__ */ (0, q.jsx)(xM, {
														id: "building-edges",
														checked: rt,
														onCheckedChange: it
													})]
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting full-width",
													children: [
														/* @__PURE__ */ (0, q.jsxs)("div", {
															className: "setting-label",
															children: [/* @__PURE__ */ (0, q.jsx)("label", {
																htmlFor: "building-extrusion",
																children: "Minimum gebouwextrusie"
															}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [w.toFixed(2), " mm"] })]
														}),
														/* @__PURE__ */ (0, q.jsx)(bM, {
															id: "building-extrusion",
															min: .5,
															max: 6,
															step: .1,
															value: [w],
															onValueChange: (e) => T(e[0])
														}),
														/* @__PURE__ */ (0, q.jsx)("p", {
															className: "setting-help",
															children: "Voor stadsschaal: verhoog dit als kleine bouwmassa's duidelijker moeten worden."
														})
													]
												})
											]
										})
									}),
									/* @__PURE__ */ (0, q.jsx)(mV, {
										icon: le,
										title: "Terrein",
										source: i.coordinateSystem === "web-mercator" ? "Mapterhorn Elevation" : "AHN 4",
										enabled: pe,
										onEnabledChange: he,
										color: vt.terrain,
										onColorChange: (e) => sn("terrain", e),
										children: /* @__PURE__ */ (0, q.jsxs)("div", {
											className: "settings-grid",
											children: [
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting full-width",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "height-mode",
														children: "Terreinhoogte"
													}), /* @__PURE__ */ (0, q.jsxs)(pM, {
														value: O,
														onValueChange: (e) => k(e),
														children: [/* @__PURE__ */ (0, q.jsx)(hM, {
															id: "height-mode",
															className: "w-full",
															children: /* @__PURE__ */ (0, q.jsx)(mM, {})
														}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [/* @__PURE__ */ (0, q.jsx)(_M, {
															value: "exaggeration",
															children: "Natuurlijke schaal / factor"
														}), /* @__PURE__ */ (0, q.jsx)(_M, {
															value: "target-height",
															children: "Gewenste totale reliëfhoogte"
														})] })]
													})]
												}),
												O === "exaggeration" ? /* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting full-width",
													children: [/* @__PURE__ */ (0, q.jsxs)("div", {
														className: "setting-label",
														children: [/* @__PURE__ */ (0, q.jsx)("label", {
															htmlFor: "terrain-relief",
															children: "Terreinreliëf"
														}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [E.toFixed(2), "×"] })]
													}), /* @__PURE__ */ (0, q.jsx)(bM, {
														id: "terrain-relief",
														min: .25,
														max: 3.5,
														step: .05,
														value: [E],
														onValueChange: (e) => D(e[0])
													})]
												}) : /* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting full-width",
													children: [/* @__PURE__ */ (0, q.jsxs)("div", {
														className: "setting-label",
														children: [/* @__PURE__ */ (0, q.jsx)("label", {
															htmlFor: "terrain-target",
															children: "Gewenste reliëfhoogte"
														}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [j.toFixed(1), " mm"] })]
													}), /* @__PURE__ */ (0, q.jsx)(bM, {
														id: "terrain-target",
														min: 2,
														max: 45,
														step: .5,
														value: [j],
														onValueChange: (e) => M(e[0])
													})]
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting full-width",
													children: [/* @__PURE__ */ (0, q.jsxs)("div", {
														className: "setting-label",
														children: [/* @__PURE__ */ (0, q.jsx)("label", {
															htmlFor: "terrain-resolution",
															children: "Verticale resolutie"
														}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [
															N,
															" × ",
															N
														] })]
													}), /* @__PURE__ */ (0, q.jsx)(bM, {
														id: "terrain-resolution",
														min: 33,
														max: 129,
														step: 8,
														value: [N],
														onValueChange: (e) => P(e[0])
													})]
												})
											]
										})
									}),
									/* @__PURE__ */ (0, q.jsx)(mV, {
										icon: ge,
										title: "Wegen",
										source: i.coordinateSystem === "web-mercator" ? "Overture Transportation" : "TOP10NL / BGT",
										enabled: ye,
										onEnabledChange: Se,
										color: vt.roads,
										onColorChange: (e) => sn("roads", e),
										defaultOpen: !0,
										children: /* @__PURE__ */ (0, q.jsxs)("div", {
											className: "layer-options clean-options",
											children: [
												/* @__PURE__ */ (0, q.jsx)("label", {
													className: "mini-label",
													htmlFor: "road-source",
													children: "Databron / geometrie"
												}),
												/* @__PURE__ */ (0, q.jsxs)(pM, {
													value: je,
													onValueChange: (e) => Me(e),
													disabled: i.coordinateSystem === "web-mercator",
													children: [/* @__PURE__ */ (0, q.jsx)(hM, {
														id: "road-source",
														className: "w-full",
														children: /* @__PURE__ */ (0, q.jsx)(mM, {})
													}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [/* @__PURE__ */ (0, q.jsx)(_M, {
														value: "clean-lines",
														children: "TOP10NL-hartlijnen · schoon verbonden"
													}), /* @__PURE__ */ (0, q.jsx)(_M, {
														value: "bgt-surfaces",
														children: "BGT-wegvlakken · maximale lokale nauwkeurigheid"
													})] })]
												}),
												Yt ? /* @__PURE__ */ (0, q.jsx)("p", {
													className: "setting-warning",
													children: "BGT-vlakken kunnen hier maximaal 1,2 km aan. Kies het schone lijnennet voor deze uitsnede."
												}) : null,
												/* @__PURE__ */ (0, q.jsxs)(pM, {
													value: Fe,
													onValueChange: (e) => Ie(e),
													children: [/* @__PURE__ */ (0, q.jsx)(hM, {
														className: "w-full",
														children: /* @__PURE__ */ (0, q.jsx)(mM, {})
													}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [/* @__PURE__ */ (0, q.jsx)(_M, {
														value: "raised",
														children: "Verhoogd"
													}), /* @__PURE__ */ (0, q.jsx)(_M, {
														value: "flush",
														children: "Vlak in terrein"
													})] })]
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "road-width",
														children: "Breedte"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [ke.toFixed(2), "×"] })]
												}),
												/* @__PURE__ */ (0, q.jsx)(bM, {
													id: "road-width",
													min: .5,
													max: 2.5,
													step: .05,
													value: [ke],
													onValueChange: (e) => Ae(e[0])
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "road-height",
														children: "Hoogte"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [Ne.toFixed(2), " mm"] })]
												}),
												/* @__PURE__ */ (0, q.jsx)(bM, {
													id: "road-height",
													min: .12,
													max: 1.5,
													step: .02,
													value: [Ne],
													onValueChange: (e) => Pe(e[0])
												}),
												/* @__PURE__ */ (0, q.jsx)("p", {
													className: "setting-help",
													children: i.coordinateSystem === "web-mercator" ? "Alleen fysieke Overture-wegen worden gebruikt; veer-, vaar- en spoorlijnen worden niet als weg geprint." : "Bruggen volgen het TOP10NL-hoogteniveau; tunnels verdwijnen automatisch onder het model."
												})
											]
										})
									}),
									/* @__PURE__ */ (0, q.jsx)(mV, {
										icon: W,
										title: "Water",
										source: i.coordinateSystem === "web-mercator" ? "Overture Base" : "BGT / TOP10NL",
										enabled: Ce,
										onEnabledChange: we,
										color: vt.water,
										onColorChange: (e) => sn("water", e),
										children: /* @__PURE__ */ (0, q.jsxs)("div", {
											className: "layer-options clean-options",
											children: [
												/* @__PURE__ */ (0, q.jsxs)(pM, {
													value: He,
													onValueChange: (e) => Ue(e),
													children: [/* @__PURE__ */ (0, q.jsx)(hM, {
														className: "w-full",
														children: /* @__PURE__ */ (0, q.jsx)(mM, {})
													}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [
														/* @__PURE__ */ (0, q.jsx)(_M, {
															value: "raised",
															children: "Verhoogd · altijd zichtbaar"
														}),
														/* @__PURE__ */ (0, q.jsx)(_M, {
															value: "flush",
															children: "Vlak"
														}),
														/* @__PURE__ */ (0, q.jsx)(_M, {
															value: "recessed",
															children: "Ingelaten rivierbedding"
														})
													] })]
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "water-height",
														children: "Laaghoogte"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [Le.toFixed(2), " mm"] })]
												}),
												/* @__PURE__ */ (0, q.jsx)(bM, {
													id: "water-height",
													min: .12,
													max: 1.5,
													step: .02,
													value: [Le],
													onValueChange: (e) => Re(e[0])
												}),
												/* @__PURE__ */ (0, q.jsx)("p", {
													className: "setting-help",
													children: "Water wordt volledig dekkend weergegeven in preview en 3MF."
												}),
												He === "recessed" ? /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "water-depth",
														children: "Inlaatdiepte"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [ze.toFixed(2), " mm"] })]
												}), /* @__PURE__ */ (0, q.jsx)(bM, {
													id: "water-depth",
													min: .2,
													max: 2.5,
													step: .05,
													value: [ze],
													onValueChange: (e) => Ve(e[0])
												})] }) : null
											]
										})
									}),
									/* @__PURE__ */ (0, q.jsx)(mV, {
										icon: U,
										title: "Land cover",
										source: i.coordinateSystem === "web-mercator" ? "Overture Base" : "BGT / TOP10NL groen",
										enabled: Te,
										onEnabledChange: Ee,
										color: vt.greenery,
										onColorChange: (e) => sn("greenery", e),
										children: /* @__PURE__ */ (0, q.jsxs)("div", {
											className: "layer-options clean-options",
											children: [
												/* @__PURE__ */ (0, q.jsxs)(pM, {
													value: Qe,
													onValueChange: (e) => $e(e),
													children: [/* @__PURE__ */ (0, q.jsx)(hM, {
														className: "w-full",
														children: /* @__PURE__ */ (0, q.jsx)(mM, {})
													}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [/* @__PURE__ */ (0, q.jsx)(_M, {
														value: "raised",
														children: "Verhoogd"
													}), /* @__PURE__ */ (0, q.jsx)(_M, {
														value: "flush",
														children: "Vlak in terrein"
													})] })]
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "land-height",
														children: "Extrusiehoogte"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [Je.toFixed(2), " mm"] })]
												}),
												/* @__PURE__ */ (0, q.jsx)(bM, {
													id: "land-height",
													min: .05,
													max: 1.5,
													step: .05,
													value: [Je],
													onValueChange: (e) => Ye(e[0])
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "land-offset",
														children: "Offset boven terrein"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [Xe.toFixed(2), " mm"] })]
												}),
												/* @__PURE__ */ (0, q.jsx)(bM, {
													id: "land-offset",
													min: 0,
													max: 1,
													step: .02,
													value: [Xe],
													onValueChange: (e) => Ze(e[0])
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "land-opacity",
														children: "Preview-transparantie"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [Math.round(tt * 100), "%"] })]
												}),
												/* @__PURE__ */ (0, q.jsx)(bM, {
													id: "land-opacity",
													min: .1,
													max: 1,
													step: .05,
													value: [tt],
													onValueChange: (e) => nt(e[0])
												})
											]
										})
									}),
									/* @__PURE__ */ (0, q.jsx)(mV, {
										icon: U,
										title: "Bomen",
										source: i.coordinateSystem === "web-mercator" ? "Overture geregistreerde bomen" : "BGT + AHN boomkronen",
										enabled: De,
										onEnabledChange: Oe,
										color: vt.trees,
										onColorChange: (e) => sn("trees", e),
										children: /* @__PURE__ */ (0, q.jsxs)("div", {
											className: "layer-options clean-options",
											children: [
												/* @__PURE__ */ (0, q.jsx)("label", {
													className: "mini-label",
													children: "Bron"
												}),
												/* @__PURE__ */ (0, q.jsxs)(pM, {
													value: "measured",
													disabled: !0,
													children: [/* @__PURE__ */ (0, q.jsx)(hM, {
														className: "w-full",
														children: /* @__PURE__ */ (0, q.jsx)(mM, {})
													}), /* @__PURE__ */ (0, q.jsx)(gM, { children: /* @__PURE__ */ (0, q.jsx)(_M, {
														value: "measured",
														children: i.coordinateSystem === "web-mercator" ? "Overture boomobjecten" : "BGT-register + AHN hoogteverschil"
													}) })]
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "tree-density",
														children: "Dichtheid"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [Math.round(We * 100), "%"] })]
												}),
												/* @__PURE__ */ (0, q.jsx)(bM, {
													id: "tree-density",
													min: .05,
													max: 1,
													step: .05,
													value: [We],
													onValueChange: (e) => Ge(e[0])
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "tree-height",
														children: "Hoogte"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [Ke.toFixed(2), "×"] })]
												}),
												/* @__PURE__ */ (0, q.jsx)(bM, {
													id: "tree-height",
													min: .5,
													max: 2.5,
													step: .05,
													value: [Ke],
													onValueChange: (e) => qe(e[0])
												}),
												/* @__PURE__ */ (0, q.jsx)("p", {
													className: "setting-help",
													children: i.coordinateSystem === "web-mercator" ? "Alleen geregistreerde boomobjecten worden gebruikt; dekking verschilt per land." : "BGT-boompunten worden aangevuld met echte hoge boomkronen uit het verschil tussen AHN-DSM en AHN-DTM. Gebouwen en vlak weiland worden uitgefilterd."
												})
											]
										})
									}),
									/* @__PURE__ */ (0, q.jsx)(mV, {
										icon: ge,
										title: "Route / track",
										source: "GPX / KML",
										enabled: ct,
										onEnabledChange: lt,
										color: vt.track,
										onColorChange: (e) => sn("track", e),
										children: /* @__PURE__ */ (0, q.jsxs)("div", {
											className: "layer-options clean-options",
											children: [
												/* @__PURE__ */ (0, q.jsxs)("label", {
													className: "track-upload",
													children: [
														/* @__PURE__ */ (0, q.jsx)("input", {
															type: "file",
															accept: ".gpx,.kml,application/gpx+xml,application/vnd.google-earth.kml+xml",
															onChange: (e) => void ln(e)
														}),
														/* @__PURE__ */ (0, q.jsx)(ge, {}),
														" ",
														ut || "GPX of KML kiezen"
													]
												}),
												G.length >= 2 ? /* @__PURE__ */ (0, q.jsx)("button", {
													type: "button",
													className: "text-action",
													onClick: () => {
														st([]), dt("");
													},
													children: "Route verwijderen"
												}) : null,
												/* @__PURE__ */ (0, q.jsxs)(pM, {
													value: gt,
													onValueChange: (e) => _t(e),
													children: [/* @__PURE__ */ (0, q.jsx)(hM, {
														className: "w-full",
														children: /* @__PURE__ */ (0, q.jsx)(mM, {})
													}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [/* @__PURE__ */ (0, q.jsx)(_M, {
														value: "raised",
														children: "Verhoogd"
													}), /* @__PURE__ */ (0, q.jsx)(_M, {
														value: "flush",
														children: "Vlak in terrein"
													})] })]
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "track-width",
														children: "Breedte"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [ft.toFixed(1), " m"] })]
												}),
												/* @__PURE__ */ (0, q.jsx)(bM, {
													id: "track-width",
													min: .5,
													max: 30,
													step: .5,
													value: [ft],
													onValueChange: (e) => pt(e[0])
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "track-height",
														children: "Hoogte"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [mt.toFixed(2), " mm"] })]
												}),
												/* @__PURE__ */ (0, q.jsx)(bM, {
													id: "track-height",
													min: .12,
													max: 3,
													step: .02,
													value: [mt],
													onValueChange: (e) => ht(e[0])
												})
											]
										})
									}),
									/* @__PURE__ */ (0, q.jsx)(mV, {
										icon: F,
										title: "Bodem & zijkanten",
										source: "Printbasis",
										enabled: !0,
										onEnabledChange: () => void 0,
										color: vt.base,
										onColorChange: (e) => sn("base", e),
										toggleDisabled: !0,
										children: /* @__PURE__ */ (0, q.jsxs)("div", {
											className: "layer-options clean-options base-options",
											children: [
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "base-height",
														children: "Bodemplaat"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [R.toFixed(1), " mm"] })]
												}),
												/* @__PURE__ */ (0, q.jsx)(bM, {
													id: "base-height",
													min: 2,
													max: 8,
													step: .25,
													value: [R],
													onValueChange: (e) => ee(e[0])
												}),
												/* @__PURE__ */ (0, q.jsx)("label", {
													className: "mini-label",
													htmlFor: "ground-material",
													children: "2D-ondergrond"
												}),
												/* @__PURE__ */ (0, q.jsxs)(pM, {
													value: at,
													onValueChange: (e) => ot(e),
													children: [/* @__PURE__ */ (0, q.jsx)(hM, {
														id: "ground-material",
														className: "w-full",
														children: /* @__PURE__ */ (0, q.jsx)(mM, {})
													}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [/* @__PURE__ */ (0, q.jsx)(_M, {
														value: "map",
														children: "Topografische kaart"
													}), /* @__PURE__ */ (0, q.jsx)(_M, {
														value: "imagery",
														children: i.coordinateSystem === "web-mercator" ? Kt ? "IGN France orthophoto" : "Sentinel-2 cloudless (EOX)" : "PDOK-luchtfoto actueel"
													})] })]
												}),
												/* @__PURE__ */ (0, q.jsx)("label", {
													className: "mini-label",
													htmlFor: "base-mode",
													children: "Bodemmodus"
												}),
												/* @__PURE__ */ (0, q.jsxs)(pM, {
													value: te,
													onValueChange: (e) => z(e),
													children: [/* @__PURE__ */ (0, q.jsx)(hM, {
														id: "base-mode",
														className: "w-full",
														children: /* @__PURE__ */ (0, q.jsx)(mM, {})
													}), /* @__PURE__ */ (0, q.jsxs)(gM, { children: [/* @__PURE__ */ (0, q.jsx)(_M, {
														value: "solid",
														children: "Massieve bodemplaat"
													}), /* @__PURE__ */ (0, q.jsx)(_M, {
														value: "hollow",
														children: "Hol met gesloten wand"
													})] })]
												}),
												te === "hollow" ? /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "setting-label",
													children: [/* @__PURE__ */ (0, q.jsx)("label", {
														htmlFor: "wall-thickness",
														children: "Wanddikte"
													}), /* @__PURE__ */ (0, q.jsxs)("output", { children: [B.toFixed(1), " mm"] })]
												}), /* @__PURE__ */ (0, q.jsx)(bM, {
													id: "wall-thickness",
													min: .8,
													max: 12,
													step: .2,
													value: [B],
													onValueChange: (e) => re(e[0])
												})] }) : null,
												/* @__PURE__ */ (0, q.jsx)("span", {
													className: "setting-help",
													children: "Terrein en zijkanten zijn afzonderlijke gesloten 3MF-onderdelen; STL combineert ze."
												}),
												/* @__PURE__ */ (0, q.jsxs)("div", {
													className: "inline-colors",
													children: [/* @__PURE__ */ (0, q.jsxs)("label", { children: [/* @__PURE__ */ (0, q.jsx)("input", {
														type: "color",
														value: vt.terrain,
														onChange: (e) => sn("terrain", e.target.value)
													}), " Ondergrond"] }), /* @__PURE__ */ (0, q.jsxs)("label", { children: [/* @__PURE__ */ (0, q.jsx)("input", {
														type: "color",
														value: vt.base,
														onChange: (e) => sn("base", e.target.value)
													}), " Zijkant"] })]
												})
											]
										})
									})
								]
							})
						]
					}), /* @__PURE__ */ (0, q.jsx)("div", {
						className: "build-actions",
						children: St ? /* @__PURE__ */ (0, q.jsxs)("div", {
							className: "sidebar-loading",
							role: "status",
							"aria-live": "polite",
							children: [
								/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)("span", { children: Ot || "Gebied wordt voorbereid…" }), /* @__PURE__ */ (0, q.jsxs)("strong", { children: [Math.round(Et), "%"] })] }),
								/* @__PURE__ */ (0, q.jsx)(fM, { value: Et }),
								/* @__PURE__ */ (0, q.jsxs)(eM, {
									className: "cancel-button",
									variant: "outline",
									onClick: en,
									children: [/* @__PURE__ */ (0, q.jsx)(xe, {}), " Laden annuleren"]
								})
							]
						}) : /* @__PURE__ */ (0, q.jsxs)(eM, {
							className: "build-button",
							size: "lg",
							onClick: () => void $t(),
							disabled: !Xt,
							children: [/* @__PURE__ */ (0, q.jsx)(me, {}), " Maak 3D-preview"]
						})
					})]
				}), /* @__PURE__ */ (0, q.jsxs)("section", {
					className: "preview-panel",
					"aria-labelledby": "preview-title",
					children: [
						Pt === "model" ? /* @__PURE__ */ (0, q.jsxs)("div", {
							className: "workspace-tabs",
							role: "tablist",
							"aria-label": "Kaart en 3D-model",
							children: [/* @__PURE__ */ (0, q.jsxs)("button", {
								type: "button",
								role: "tab",
								"aria-selected": !1,
								onClick: () => Ft("map"),
								children: [/* @__PURE__ */ (0, q.jsx)(ce, {}), " 1 · Gebied kiezen"]
							}), /* @__PURE__ */ (0, q.jsxs)("button", {
								type: "button",
								role: "tab",
								"aria-selected": !0,
								className: "active",
								onClick: () => Ft("model"),
								disabled: bt.layers.length === 0,
								children: [/* @__PURE__ */ (0, q.jsx)(ae, {}), " 2 · 3D & export"]
							})]
						}) : null,
						Pt === "model" ? /* @__PURE__ */ (0, q.jsxs)("div", {
							className: "preview-toolbar",
							children: [/* @__PURE__ */ (0, q.jsxs)("div", { children: [
								/* @__PURE__ */ (0, q.jsx)("p", {
									className: "eyebrow",
									children: "Interactieve modelcontrole"
								}),
								/* @__PURE__ */ (0, q.jsx)("h2", {
									id: "preview-title",
									children: i.label
								}),
								/* @__PURE__ */ (0, q.jsxs)("p", {
									className: "model-source-line",
									children: [
										dn,
										" · ",
										Vt.toLocaleString("nl-NL"),
										" m · ",
										v,
										" mm max"
									]
								})
							] }), /* @__PURE__ */ (0, q.jsxs)("div", {
								className: mn ? "validity-pill valid" : "validity-pill",
								children: [mn ? /* @__PURE__ */ (0, q.jsx)(ve, {}) : /* @__PURE__ */ (0, q.jsx)(be, {}), St ? "Controleren" : mn ? "Mesh geldig" : "Opnieuw bouwen"]
							})]
						}) : null,
						St ? /* @__PURE__ */ (0, q.jsx)("div", {
							className: "global-loading-overlay",
							role: "status",
							"aria-live": "polite",
							children: /* @__PURE__ */ (0, q.jsxs)("div", {
								className: "global-loading-card",
								children: [
									/* @__PURE__ */ (0, q.jsx)("span", { className: "preview-spinner" }),
									/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: "Printmodel wordt opgebouwd" }), /* @__PURE__ */ (0, q.jsx)("p", { children: Ot || "Open geodata wordt voorbereid…" })] }),
									/* @__PURE__ */ (0, q.jsx)(fM, { value: Et }),
									/* @__PURE__ */ (0, q.jsxs)(eM, {
										className: "cancel-button",
										variant: "outline",
										onClick: en,
										autoFocus: !0,
										children: [/* @__PURE__ */ (0, q.jsx)(xe, {}), " Laden annuleren"]
									})
								]
							})
						}) : null,
						Pt === "map" ? /* @__PURE__ */ (0, q.jsx)(dc, {
							center: [i.x, i.y],
							polygon: Bt,
							shape: u,
							coordinateSystem: i.coordinateSystem ?? "rd",
							focusKey: Zt,
							backgroundMode: at,
							onCenterChange: an,
							onPolygonChange: on
						}, i.coordinateSystem ?? "rd") : /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [
							/* @__PURE__ */ (0, q.jsx)(Wv, {
								layers: bt.layers,
								colors: vt,
								modelMillimeters: v,
								loading: !1,
								layerOpacity: Qt,
								buildingEdges: rt,
								progressMessage: Ot
							}),
							/* @__PURE__ */ (0, q.jsxs)("div", {
								className: "stats-grid",
								"aria-label": "Modelstatistieken",
								children: [
									/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)(I, {}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: K.buildingCount.toLocaleString("nl-NL") }), "Gebouwen"] })] }),
									/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)(ge, {}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: K.roadCount.toLocaleString("nl-NL") }), "Wegen"] })] }),
									/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)(W, {}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: K.waterCount.toLocaleString("nl-NL") }), "Waterdelen"] })] }),
									/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)(U, {}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: K.treeCount.toLocaleString("nl-NL") }), "Bomen"] })] }),
									/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)(H, {}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsxs)("strong", { children: [
										K.widthMillimeters,
										" × ",
										K.depthMillimeters,
										" mm"
									] }), "Printvlak"] })] }),
									/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)(F, {}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsxs)("strong", { children: [
										"≈ ",
										K.estimatedFilamentGrams,
										" g"
									] }), "Filamentindicatie"] })] })
								]
							}),
							bt.warnings.length > 0 ? /* @__PURE__ */ (0, q.jsxs)("div", {
								className: "warning-box",
								children: [/* @__PURE__ */ (0, q.jsx)(be, {}), /* @__PURE__ */ (0, q.jsxs)("div", { children: [bt.warnings.map((e, t) => /* @__PURE__ */ (0, q.jsx)("p", { children: e }, `${e}-${t}`)), fn ? /* @__PURE__ */ (0, q.jsxs)("div", {
									className: "warning-actions",
									children: [
										/* @__PURE__ */ (0, q.jsx)(eM, {
											size: "sm",
											variant: "outline",
											onClick: () => void $t(),
											disabled: St,
											children: "Ontbrekende tegels opnieuw proberen"
										}),
										/* @__PURE__ */ (0, q.jsx)(eM, {
											size: "sm",
											variant: "outline",
											onClick: () => {
												x("lod0"), Ft("map");
											},
											children: "LoD0 kiezen"
										}),
										/* @__PURE__ */ (0, q.jsx)(eM, {
											size: "sm",
											variant: "ghost",
											onClick: () => Ft("map"),
											children: "Annuleren"
										})
									]
								}) : null] })]
							}) : mn ? /* @__PURE__ */ (0, q.jsxs)("div", {
								className: "success-box",
								children: [/* @__PURE__ */ (0, q.jsx)(ne, {}), " Geen open, niet-manifold of nuloppervlak-driehoeken gevonden."]
							}) : null,
							/* @__PURE__ */ (0, q.jsxs)("div", {
								className: "download-row",
								children: [/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)("p", { children: "Productiebestanden" }), /* @__PURE__ */ (0, q.jsxs)("span", { children: [
									"3MF bevat benoemde onderdelen en ",
									gn,
									" vooraf toegewezen filamentslots."
								] })] }), /* @__PURE__ */ (0, q.jsxs)("div", {
									className: "download-actions",
									children: [/* @__PURE__ */ (0, q.jsxs)(tM, { children: [/* @__PURE__ */ (0, q.jsx)(nM, {
										asChild: !0,
										children: /* @__PURE__ */ (0, q.jsxs)(eM, {
											variant: "outline",
											disabled: !mn,
											children: [/* @__PURE__ */ (0, q.jsx)(fe, {}), " Printkleuren"]
										})
									}), /* @__PURE__ */ (0, q.jsxs)(oM, {
										className: "print-colors-dialog",
										children: [
											/* @__PURE__ */ (0, q.jsxs)(sM, { children: [/* @__PURE__ */ (0, q.jsx)(lM, { children: "Filamentkleuren instellen" }), /* @__PURE__ */ (0, q.jsx)(uM, { children: "Kies de kleuren hier één keer. De 3MF neemt iedere zichtbare laag mee als benoemd onderdeel met een vooraf toegewezen filamentslot." })] }),
											/* @__PURE__ */ (0, q.jsx)("div", {
												className: "print-palette-actions",
												"aria-label": "Printkleurthema's",
												children: pV.map((e) => /* @__PURE__ */ (0, q.jsxs)(eM, {
													type: "button",
													variant: "outline",
													title: e.description,
													onClick: () => cn(e.colors),
													children: [/* @__PURE__ */ (0, q.jsx)("span", {
														className: "theme-swatches",
														"aria-hidden": "true",
														children: [
															e.colors.buildings,
															e.colors.water,
															e.colors.trees,
															e.colors.roads,
															e.colors.terrain
														].map((e, t) => /* @__PURE__ */ (0, q.jsx)("i", { style: { backgroundColor: e } }, `${e}-${t}`))
													}), e.name]
												}, e.name))
											}),
											/* @__PURE__ */ (0, q.jsx)("div", {
												className: "print-color-list",
												children: hn.map((e) => {
													let t = fV.find((t) => t.kind === e.kind)?.label ?? e.name;
													return /* @__PURE__ */ (0, q.jsxs)("label", {
														className: "print-color-row",
														children: [
															/* @__PURE__ */ (0, q.jsx)("input", {
																type: "color",
																value: vt[e.kind],
																onChange: (t) => sn(e.kind, t.target.value)
															}),
															/* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: t }), /* @__PURE__ */ (0, q.jsx)("small", { children: e.name })] }),
															/* @__PURE__ */ (0, q.jsx)("code", { children: vt[e.kind].toUpperCase() })
														]
													}, e.kind);
												})
											}),
											/* @__PURE__ */ (0, q.jsxs)("p", {
												className: "print-slot-summary",
												children: [
													hn.length,
													" onderdelen · ",
													gn,
													" unieke filamentslots"
												]
											}),
											/* @__PURE__ */ (0, q.jsx)(cM, { children: /* @__PURE__ */ (0, q.jsx)(iM, {
												asChild: !0,
												children: /* @__PURE__ */ (0, q.jsx)(eM, { children: "Gereed" })
											}) })
										]
									})] }), e ? /* @__PURE__ */ (0, q.jsx)(eM, {
										disabled: !mn || St,
										onClick: () => e({
											name: i.label,
											layers: bt.layers,
											stats: K,
											config: Ht,
											colors: vt,
											attribution: bt.attribution,
											editorQuery: window.location.search
										}),
										children: "Lijst, print of download kiezen"
									}) : /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [/* @__PURE__ */ (0, q.jsxs)(eM, {
										variant: "outline",
										onClick: () => void un("stl"),
										disabled: !mn || !!wt,
										children: [
											/* @__PURE__ */ (0, q.jsx)(V, {}),
											" ",
											wt === "stl" ? "Maakt…" : "STL"
										]
									}), /* @__PURE__ */ (0, q.jsxs)(eM, {
										onClick: () => void un("3mf"),
										disabled: !mn || !!wt,
										children: [
											/* @__PURE__ */ (0, q.jsx)(V, {}),
											" ",
											wt === "3mf" ? "Maakt…" : "Download 3MF"
										]
									})] })]
								})]
							})
						] }),
						/* @__PURE__ */ (0, q.jsxs)("div", {
							className: "workflow-strip",
							children: [
								/* @__PURE__ */ (0, q.jsx)("span", { children: "1 · teken contour" }),
								/* @__PURE__ */ (0, q.jsx)("span", { children: "2 · lokale databron" }),
								/* @__PURE__ */ (0, q.jsx)("span", { children: "3 · gesloten printlagen" }),
								/* @__PURE__ */ (0, q.jsx)("span", { children: "4 · STL / kleur-3MF" })
							]
						}),
						/* @__PURE__ */ (0, q.jsxs)("details", {
							className: "workflow-details",
							children: [/* @__PURE__ */ (0, q.jsx)("summary", { children: "Hoe wordt dit printmodel opgebouwd?" }), /* @__PURE__ */ (0, q.jsxs)("ol", { children: [
								/* @__PURE__ */ (0, q.jsx)("li", { children: "De 2D-contour blijft metrisch georiënteerd; noord en oost zijn gelijk in kaart, preview en export." }),
								/* @__PURE__ */ (0, q.jsx)("li", { children: "Nederland gebruikt 3DBAG/PDOK. Frankrijk gebruikt IGN BD TOPO; andere landen gebruiken de beschikbare Overture-gebouwen." }),
								/* @__PURE__ */ (0, q.jsx)("li", { children: "AHN vormt het Nederlandse reliëf en Mapterhorn het wereldwijde reliëf. Groot water wordt vlak en iets onder de oever in het terrein gelegd." }),
								/* @__PURE__ */ (0, q.jsx)("li", { children: "Elke laag wordt gesloten en gecontroleerd. 3MF bewaart kleuren als losse onderdelen; STL combineert alle gesloten solids." })
							] })]
						}),
						/* @__PURE__ */ (0, q.jsx)("p", {
							className: "attribution",
							children: bt.attribution || "3DBAG / TU Delft + 3DGI · PDOK BGT · AHN · TOP10NL"
						})
					]
				})]
			})
		]
	});
}
//#endregion
//#region integrations/shopify/entry.tsx
var vV = document.getElementById("plekbeeld-root"), yV = vV.dataset.api?.trim(), bV = "";
try {
	let e = new URL(yV || "");
	e.protocol === "https:" && e.pathname === "/" && !e.username && !e.password && !e.search && !e.hash && (bV = e.origin);
} catch {}
window.__PLEKBEELD_API_ORIGIN__ = bV;
function xV() {
	let [e, t] = (0, A.useState)(null), [n, r] = (0, A.useState)(""), [i, a] = (0, A.useState)(!1), [o, s] = (0, A.useState)(!1);
	async function c() {
		a(!0), r("Verbinding controleren…");
		try {
			let e = await fetch(bV + "/health", { signal: AbortSignal.timeout(12e3) });
			if (!e.ok) throw Error("De kaartserver antwoordt niet correct.");
			if ((await e.json()).service !== "plekbeeld-geodata") throw Error("Dit is niet de Plekbeeld-kaartserver.");
			s(!0), r("");
		} catch {
			r("De kaartserver is niet bereikbaar vanuit deze winkel. Controleer de server-URL en de toegestane winkel in de serverinstellingen.");
		} finally {
			a(!1);
		}
	}
	async function l() {
		if (e) {
			a(!0), r("Toevoegen…");
			try {
				let t = Number(vV.dataset.variant);
				if (!Number.isSafeInteger(t) || t < 1) throw Error("Selecteer eerst een beschikbaar testproduct in de thema-instellingen.");
				let n = window.Shopify?.routes?.root || "/", r = await fetch(n + "cart/add.js", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ items: [{
						id: t,
						quantity: 1,
						properties: {
							Locatie: e.name,
							Gebruik: "Configuratortest — geen opgeslagen printbestand",
							_plekbeeld_test_id: crypto.randomUUID(),
							_plekbeeld_editor_query: e.editorQuery,
							_plekbeeld_colors: JSON.stringify(e.colors)
						}
					}] })
				}), i = await r.json();
				if (!r.ok) throw Error(typeof i.description == "string" ? i.description : "Toevoegen is mislukt.");
				window.location.assign(n + "cart");
			} catch (e) {
				r(e instanceof Error ? e.message : "Toevoegen is mislukt."), a(!1);
			}
		}
	}
	return bV ? o ? /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [/* @__PURE__ */ (0, q.jsx)("div", {
		className: "pb-testbar",
		children: "Shopify-test · Geen automatische productie of betaalde downloadlevering"
	}), e ? /* @__PURE__ */ (0, q.jsxs)("main", {
		className: "pb-setup",
		children: [
			/* @__PURE__ */ (0, q.jsx)("h1", { children: "Ontwerp gekozen" }),
			/* @__PURE__ */ (0, q.jsx)("p", { children: e.name }),
			/* @__PURE__ */ (0, q.jsxs)("p", { children: [
				"Je voegt het geselecteerde Shopify-testproduct toe voor ",
				vV.dataset.price || "de productprijs",
				". De configuratie bepaalt in deze test nog niet de prijs. De locatie, bewerkingsinstellingen en kleuren gaan mee in de winkelwagen; het printbestand wordt nog niet opgeslagen."
			] }),
			/* @__PURE__ */ (0, q.jsx)("button", {
				onClick: () => {
					t(null), r("");
				},
				children: "Terug naar configurator"
			}),
			" ",
			/* @__PURE__ */ (0, q.jsx)("button", {
				disabled: i,
				onClick: l,
				children: "Voeg testproduct toe"
			}),
			/* @__PURE__ */ (0, q.jsx)("p", {
				role: "status",
				children: n
			})
		]
	}) : /* @__PURE__ */ (0, q.jsx)(_V, { onChoose: t })] }) : /* @__PURE__ */ (0, q.jsxs)("main", {
		className: "pb-setup",
		children: [
			/* @__PURE__ */ (0, q.jsx)("h1", { children: "Plekbeeld configuratortest" }),
			/* @__PURE__ */ (0, q.jsx)("p", { children: "Test de echte kaartselectie en 3D-weergave in je Shopify-winkel." }),
			/* @__PURE__ */ (0, q.jsx)("button", {
				disabled: i,
				onClick: c,
				children: "Start configurator"
			}),
			/* @__PURE__ */ (0, q.jsx)("p", {
				role: "status",
				children: n
			})
		]
	}) : /* @__PURE__ */ (0, q.jsxs)("main", {
		className: "pb-setup",
		children: [
			/* @__PURE__ */ (0, q.jsx)("h1", { children: "Plekbeeld configuratortest" }),
			/* @__PURE__ */ (0, q.jsx)("p", { children: "Vul in de thema-editor bij Plekbeeld configurator de HTTPS-URL van de kaartserver in." }),
			/* @__PURE__ */ (0, q.jsx)("p", { children: "De installatiehandleiding in het testpakket legt uit hoe je de meegeleverde kaartserver online zet. De bestaande privé-URL van ChatGPT is hiervoor niet geschikt." })
		]
	});
}
(0, Se.createRoot)(vV).render(/* @__PURE__ */ (0, q.jsx)(xV, {}));
//#endregion
export { h as n, p as t };
